var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x2) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x2, {
  get: (a2, b2) => (typeof require !== "undefined" ? require : a2)[b2]
}) : x2)(function(x2) {
  if (typeof require !== "undefined")
    return require.apply(this, arguments);
  throw new Error('Dynamic require of "' + x2 + '" is not supported');
});
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key2 of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key2) && key2 !== except)
        __defProp(to, key2, { get: () => from[key2], enumerable: !(desc = __getOwnPropDesc(from, key2)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/tsup/assets/esm_shims.js
var init_esm_shims = __esm({
  "../../node_modules/tsup/assets/esm_shims.js"() {
  }
});

// ../../node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
  "../../node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    "use strict";
    init_esm_shims();
    var b2 = "function" === typeof Symbol && Symbol.for;
    var c2 = b2 ? Symbol.for("react.element") : 60103;
    var d = b2 ? Symbol.for("react.portal") : 60106;
    var e3 = b2 ? Symbol.for("react.fragment") : 60107;
    var f3 = b2 ? Symbol.for("react.strict_mode") : 60108;
    var g2 = b2 ? Symbol.for("react.profiler") : 60114;
    var h = b2 ? Symbol.for("react.provider") : 60109;
    var k2 = b2 ? Symbol.for("react.context") : 60110;
    var l2 = b2 ? Symbol.for("react.async_mode") : 60111;
    var m2 = b2 ? Symbol.for("react.concurrent_mode") : 60111;
    var n3 = b2 ? Symbol.for("react.forward_ref") : 60112;
    var p = b2 ? Symbol.for("react.suspense") : 60113;
    var q2 = b2 ? Symbol.for("react.suspense_list") : 60120;
    var r3 = b2 ? Symbol.for("react.memo") : 60115;
    var t3 = b2 ? Symbol.for("react.lazy") : 60116;
    var v2 = b2 ? Symbol.for("react.block") : 60121;
    var w2 = b2 ? Symbol.for("react.fundamental") : 60117;
    var x2 = b2 ? Symbol.for("react.responder") : 60118;
    var y2 = b2 ? Symbol.for("react.scope") : 60119;
    function z2(a2) {
      if ("object" === typeof a2 && null !== a2) {
        var u2 = a2.$$typeof;
        switch (u2) {
          case c2:
            switch (a2 = a2.type, a2) {
              case l2:
              case m2:
              case e3:
              case g2:
              case f3:
              case p:
                return a2;
              default:
                switch (a2 = a2 && a2.$$typeof, a2) {
                  case k2:
                  case n3:
                  case t3:
                  case r3:
                  case h:
                    return a2;
                  default:
                    return u2;
                }
            }
          case d:
            return u2;
        }
      }
    }
    function A2(a2) {
      return z2(a2) === m2;
    }
    exports.AsyncMode = l2;
    exports.ConcurrentMode = m2;
    exports.ContextConsumer = k2;
    exports.ContextProvider = h;
    exports.Element = c2;
    exports.ForwardRef = n3;
    exports.Fragment = e3;
    exports.Lazy = t3;
    exports.Memo = r3;
    exports.Portal = d;
    exports.Profiler = g2;
    exports.StrictMode = f3;
    exports.Suspense = p;
    exports.isAsyncMode = function(a2) {
      return A2(a2) || z2(a2) === l2;
    };
    exports.isConcurrentMode = A2;
    exports.isContextConsumer = function(a2) {
      return z2(a2) === k2;
    };
    exports.isContextProvider = function(a2) {
      return z2(a2) === h;
    };
    exports.isElement = function(a2) {
      return "object" === typeof a2 && null !== a2 && a2.$$typeof === c2;
    };
    exports.isForwardRef = function(a2) {
      return z2(a2) === n3;
    };
    exports.isFragment = function(a2) {
      return z2(a2) === e3;
    };
    exports.isLazy = function(a2) {
      return z2(a2) === t3;
    };
    exports.isMemo = function(a2) {
      return z2(a2) === r3;
    };
    exports.isPortal = function(a2) {
      return z2(a2) === d;
    };
    exports.isProfiler = function(a2) {
      return z2(a2) === g2;
    };
    exports.isStrictMode = function(a2) {
      return z2(a2) === f3;
    };
    exports.isSuspense = function(a2) {
      return z2(a2) === p;
    };
    exports.isValidElementType = function(a2) {
      return "string" === typeof a2 || "function" === typeof a2 || a2 === e3 || a2 === m2 || a2 === g2 || a2 === f3 || a2 === p || a2 === q2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t3 || a2.$$typeof === r3 || a2.$$typeof === h || a2.$$typeof === k2 || a2.$$typeof === n3 || a2.$$typeof === w2 || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v2);
    };
    exports.typeOf = z2;
  }
});

// ../../node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    init_esm_shims();
    if (process.env.NODE_ENV !== "production") {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type2) {
          return typeof type2 === "string" || typeof type2 === "function" || type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object3) {
          if (typeof object3 === "object" && object3 !== null) {
            var $$typeof = object3.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type2 = object3.type;
                switch (type2) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type2;
                  default:
                    var $$typeofType = type2 && type2.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element3 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment2 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal2 = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object3) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object3) || typeOf(object3) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object3) {
          return typeOf(object3) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object3) {
          return typeOf(object3) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object3) {
          return typeOf(object3) === REACT_PROVIDER_TYPE;
        }
        function isElement(object3) {
          return typeof object3 === "object" && object3 !== null && object3.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object3) {
          return typeOf(object3) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object3) {
          return typeOf(object3) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object3) {
          return typeOf(object3) === REACT_LAZY_TYPE;
        }
        function isMemo(object3) {
          return typeOf(object3) === REACT_MEMO_TYPE;
        }
        function isPortal(object3) {
          return typeOf(object3) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object3) {
          return typeOf(object3) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object3) {
          return typeOf(object3) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object3) {
          return typeOf(object3) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element3;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment2;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal2;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/react-is/index.js"(exports, module) {
    "use strict";
    init_esm_shims();
    if (process.env.NODE_ENV === "production") {
      module.exports = require_react_is_production_min();
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/shallowequal/index.js
var require_shallowequal = __commonJS({
  "../../node_modules/shallowequal/index.js"(exports, module) {
    init_esm_shims();
    module.exports = function shallowEqual2(objA, objB, compare, compareContext) {
      var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
      if (ret !== void 0) {
        return !!ret;
      }
      if (objA === objB) {
        return true;
      }
      if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
        return false;
      }
      var keysA = Object.keys(objA);
      var keysB = Object.keys(objB);
      if (keysA.length !== keysB.length) {
        return false;
      }
      var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
      for (var idx = 0; idx < keysA.length; idx++) {
        var key2 = keysA[idx];
        if (!bHasOwnProperty(key2)) {
          return false;
        }
        var valueA = objA[key2];
        var valueB = objB[key2];
        ret = compare ? compare.call(compareContext, valueA, valueB, key2) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) {
          return false;
        }
      }
      return true;
    };
  }
});

// ../../node_modules/@emotion/memoize/dist/emotion-memoize.cjs.prod.js
var require_emotion_memoize_cjs_prod = __commonJS({
  "../../node_modules/@emotion/memoize/dist/emotion-memoize.cjs.prod.js"(exports) {
    "use strict";
    init_esm_shims();
    Object.defineProperty(exports, "__esModule", { value: true });
    function memoize(fn) {
      var cache = /* @__PURE__ */ Object.create(null);
      return function(arg) {
        if (cache[arg] === void 0)
          cache[arg] = fn(arg);
        return cache[arg];
      };
    }
    exports["default"] = memoize;
  }
});

// ../../node_modules/@emotion/memoize/dist/emotion-memoize.cjs.dev.js
var require_emotion_memoize_cjs_dev = __commonJS({
  "../../node_modules/@emotion/memoize/dist/emotion-memoize.cjs.dev.js"(exports) {
    "use strict";
    init_esm_shims();
    Object.defineProperty(exports, "__esModule", { value: true });
    function memoize(fn) {
      var cache = /* @__PURE__ */ Object.create(null);
      return function(arg) {
        if (cache[arg] === void 0)
          cache[arg] = fn(arg);
        return cache[arg];
      };
    }
    exports["default"] = memoize;
  }
});

// ../../node_modules/@emotion/memoize/dist/emotion-memoize.cjs.js
var require_emotion_memoize_cjs = __commonJS({
  "../../node_modules/@emotion/memoize/dist/emotion-memoize.cjs.js"(exports, module) {
    "use strict";
    init_esm_shims();
    if (process.env.NODE_ENV === "production") {
      module.exports = require_emotion_memoize_cjs_prod();
    } else {
      module.exports = require_emotion_memoize_cjs_dev();
    }
  }
});

// ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.prod.js
var require_emotion_is_prop_valid_cjs_prod = __commonJS({
  "../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.prod.js"(exports) {
    "use strict";
    init_esm_shims();
    Object.defineProperty(exports, "__esModule", { value: true });
    var memoize = require_emotion_memoize_cjs();
    function _interopDefault(e3) {
      return e3 && e3.__esModule ? e3 : { "default": e3 };
    }
    var memoize__default = /* @__PURE__ */ _interopDefault(memoize);
    var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
    var isPropValid = /* @__PURE__ */ memoize__default["default"](
      function(prop) {
        return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
      }
    );
    exports["default"] = isPropValid;
  }
});

// ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.dev.js
var require_emotion_is_prop_valid_cjs_dev = __commonJS({
  "../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.dev.js"(exports) {
    "use strict";
    init_esm_shims();
    Object.defineProperty(exports, "__esModule", { value: true });
    var memoize = require_emotion_memoize_cjs();
    function _interopDefault(e3) {
      return e3 && e3.__esModule ? e3 : { "default": e3 };
    }
    var memoize__default = /* @__PURE__ */ _interopDefault(memoize);
    var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
    var isPropValid = /* @__PURE__ */ memoize__default["default"](
      function(prop) {
        return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
      }
    );
    exports["default"] = isPropValid;
  }
});

// ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.js
var require_emotion_is_prop_valid_cjs = __commonJS({
  "../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.js"(exports, module) {
    "use strict";
    init_esm_shims();
    if (process.env.NODE_ENV === "production") {
      module.exports = require_emotion_is_prop_valid_cjs_prod();
    } else {
      module.exports = require_emotion_is_prop_valid_cjs_dev();
    }
  }
});

// ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.default.js
var require_emotion_is_prop_valid_cjs_default = __commonJS({
  "../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.default.js"(exports) {
    init_esm_shims();
    exports._default = require_emotion_is_prop_valid_cjs().default;
  }
});

// ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var require_hoist_non_react_statics_cjs = __commonJS({
  "../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js"(exports, module) {
    "use strict";
    init_esm_shims();
    var reactIs2 = require_react_is();
    var REACT_STATICS2 = {
      childContextTypes: true,
      contextType: true,
      contextTypes: true,
      defaultProps: true,
      displayName: true,
      getDefaultProps: true,
      getDerivedStateFromError: true,
      getDerivedStateFromProps: true,
      mixins: true,
      propTypes: true,
      type: true
    };
    var KNOWN_STATICS2 = {
      name: true,
      length: true,
      prototype: true,
      caller: true,
      callee: true,
      arguments: true,
      arity: true
    };
    var FORWARD_REF_STATICS2 = {
      "$$typeof": true,
      render: true,
      defaultProps: true,
      displayName: true,
      propTypes: true
    };
    var MEMO_STATICS2 = {
      "$$typeof": true,
      compare: true,
      defaultProps: true,
      displayName: true,
      propTypes: true,
      type: true
    };
    var TYPE_STATICS2 = {};
    TYPE_STATICS2[reactIs2.ForwardRef] = FORWARD_REF_STATICS2;
    TYPE_STATICS2[reactIs2.Memo] = MEMO_STATICS2;
    function getStatics2(component) {
      if (reactIs2.isMemo(component)) {
        return MEMO_STATICS2;
      }
      return TYPE_STATICS2[component["$$typeof"]] || REACT_STATICS2;
    }
    var defineProperty2 = Object.defineProperty;
    var getOwnPropertyNames2 = Object.getOwnPropertyNames;
    var getOwnPropertySymbols2 = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor2 = Object.getOwnPropertyDescriptor;
    var getPrototypeOf2 = Object.getPrototypeOf;
    var objectPrototype2 = Object.prototype;
    function hoistNonReactStatics2(targetComponent, sourceComponent, blacklist) {
      if (typeof sourceComponent !== "string") {
        if (objectPrototype2) {
          var inheritedComponent = getPrototypeOf2(sourceComponent);
          if (inheritedComponent && inheritedComponent !== objectPrototype2) {
            hoistNonReactStatics2(targetComponent, inheritedComponent, blacklist);
          }
        }
        var keys2 = getOwnPropertyNames2(sourceComponent);
        if (getOwnPropertySymbols2) {
          keys2 = keys2.concat(getOwnPropertySymbols2(sourceComponent));
        }
        var targetStatics = getStatics2(targetComponent);
        var sourceStatics = getStatics2(sourceComponent);
        for (var i2 = 0; i2 < keys2.length; ++i2) {
          var key2 = keys2[i2];
          if (!KNOWN_STATICS2[key2] && !(blacklist && blacklist[key2]) && !(sourceStatics && sourceStatics[key2]) && !(targetStatics && targetStatics[key2])) {
            var descriptor = getOwnPropertyDescriptor2(sourceComponent, key2);
            try {
              defineProperty2(targetComponent, key2, descriptor);
            } catch (e3) {
            }
          }
        }
      }
      return targetComponent;
    }
    module.exports = hoistNonReactStatics2;
  }
});

// src/index.tsx
init_esm_shims();

// src/LogInForm.tsx
init_esm_shims();
import React2, { createContext as createContext3, useState as useState3, useContext as useContext3 } from "react";

// ../../node_modules/@livesession/design-system/dist/design-system.es5.js
init_esm_shims();
import * as React from "react";
import React__default, { createContext as createContext2, useLayoutEffect as useLayoutEffect$3, useEffect as useEffect2, useRef as useRef2, Component as Component2, useContext as useContext2, useState as useState2, useMemo as useMemo$1, useCallback as useCallback2, forwardRef as forwardRef2, useImperativeHandle as useImperativeHandle2, isValidElement as isValidElement$1, cloneElement as cloneElement$1 } from "react";

// ../../node_modules/styled-components/dist/styled-components.esm.js
init_esm_shims();
var import_react_is = __toESM(require_react_is());
var import_shallowequal = __toESM(require_shallowequal());
import r, { useState as o, useContext as s, useMemo as i, useEffect as a, useRef as c, createElement as u } from "react";

// ../../node_modules/@emotion/stylis/dist/stylis.esm.js
init_esm_shims();
function stylis_min(W2) {
  function M2(d, c2, e3, h, a2) {
    for (var m2 = 0, b2 = 0, v2 = 0, n3 = 0, q2, g2, x2 = 0, K2 = 0, k2, u2 = k2 = q2 = 0, l2 = 0, r3 = 0, I = 0, t3 = 0, B3 = e3.length, J2 = B3 - 1, y2, f3 = "", p = "", F3 = "", G3 = "", C2; l2 < B3; ) {
      g2 = e3.charCodeAt(l2);
      l2 === J2 && 0 !== b2 + n3 + v2 + m2 && (0 !== b2 && (g2 = 47 === b2 ? 10 : 47), n3 = v2 = m2 = 0, B3++, J2++);
      if (0 === b2 + n3 + v2 + m2) {
        if (l2 === J2 && (0 < r3 && (f3 = f3.replace(N, "")), 0 < f3.trim().length)) {
          switch (g2) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              f3 += e3.charAt(l2);
          }
          g2 = 59;
        }
        switch (g2) {
          case 123:
            f3 = f3.trim();
            q2 = f3.charCodeAt(0);
            k2 = 1;
            for (t3 = ++l2; l2 < B3; ) {
              switch (g2 = e3.charCodeAt(l2)) {
                case 123:
                  k2++;
                  break;
                case 125:
                  k2--;
                  break;
                case 47:
                  switch (g2 = e3.charCodeAt(l2 + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u2 = l2 + 1; u2 < J2; ++u2) {
                          switch (e3.charCodeAt(u2)) {
                            case 47:
                              if (42 === g2 && 42 === e3.charCodeAt(u2 - 1) && l2 + 2 !== u2) {
                                l2 = u2 + 1;
                                break a;
                              }
                              break;
                            case 10:
                              if (47 === g2) {
                                l2 = u2 + 1;
                                break a;
                              }
                          }
                        }
                        l2 = u2;
                      }
                  }
                  break;
                case 91:
                  g2++;
                case 40:
                  g2++;
                case 34:
                case 39:
                  for (; l2++ < J2 && e3.charCodeAt(l2) !== g2; ) {
                  }
              }
              if (0 === k2)
                break;
              l2++;
            }
            k2 = e3.substring(t3, l2);
            0 === q2 && (q2 = (f3 = f3.replace(ca, "").trim()).charCodeAt(0));
            switch (q2) {
              case 64:
                0 < r3 && (f3 = f3.replace(N, ""));
                g2 = f3.charCodeAt(1);
                switch (g2) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r3 = c2;
                    break;
                  default:
                    r3 = O2;
                }
                k2 = M2(c2, r3, k2, g2, a2 + 1);
                t3 = k2.length;
                0 < A2 && (r3 = X2(O2, f3, I), C2 = H2(3, k2, r3, c2, D2, z2, t3, g2, a2, h), f3 = r3.join(""), void 0 !== C2 && 0 === (t3 = (k2 = C2.trim()).length) && (g2 = 0, k2 = ""));
                if (0 < t3)
                  switch (g2) {
                    case 115:
                      f3 = f3.replace(da, ea);
                    case 100:
                    case 109:
                    case 45:
                      k2 = f3 + "{" + k2 + "}";
                      break;
                    case 107:
                      f3 = f3.replace(fa, "$1 $2");
                      k2 = f3 + "{" + k2 + "}";
                      k2 = 1 === w2 || 2 === w2 && L2("@" + k2, 3) ? "@-webkit-" + k2 + "@" + k2 : "@" + k2;
                      break;
                    default:
                      k2 = f3 + k2, 112 === h && (k2 = (p += k2, ""));
                  }
                else
                  k2 = "";
                break;
              default:
                k2 = M2(c2, X2(c2, f3, I), k2, h, a2 + 1);
            }
            F3 += k2;
            k2 = I = r3 = u2 = q2 = 0;
            f3 = "";
            g2 = e3.charCodeAt(++l2);
            break;
          case 125:
          case 59:
            f3 = (0 < r3 ? f3.replace(N, "") : f3).trim();
            if (1 < (t3 = f3.length))
              switch (0 === u2 && (q2 = f3.charCodeAt(0), 45 === q2 || 96 < q2 && 123 > q2) && (t3 = (f3 = f3.replace(" ", ":")).length), 0 < A2 && void 0 !== (C2 = H2(1, f3, c2, d, D2, z2, p.length, h, a2, h)) && 0 === (t3 = (f3 = C2.trim()).length) && (f3 = "\0\0"), q2 = f3.charCodeAt(0), g2 = f3.charCodeAt(1), q2) {
                case 0:
                  break;
                case 64:
                  if (105 === g2 || 99 === g2) {
                    G3 += f3 + e3.charAt(l2);
                    break;
                  }
                default:
                  58 !== f3.charCodeAt(t3 - 1) && (p += P2(f3, q2, g2, f3.charCodeAt(2)));
              }
            I = r3 = u2 = q2 = 0;
            f3 = "";
            g2 = e3.charCodeAt(++l2);
        }
      }
      switch (g2) {
        case 13:
        case 10:
          47 === b2 ? b2 = 0 : 0 === 1 + q2 && 107 !== h && 0 < f3.length && (r3 = 1, f3 += "\0");
          0 < A2 * Y2 && H2(0, f3, c2, d, D2, z2, p.length, h, a2, h);
          z2 = 1;
          D2++;
          break;
        case 59:
        case 125:
          if (0 === b2 + n3 + v2 + m2) {
            z2++;
            break;
          }
        default:
          z2++;
          y2 = e3.charAt(l2);
          switch (g2) {
            case 9:
            case 32:
              if (0 === n3 + m2 + b2)
                switch (x2) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y2 = "";
                    break;
                  default:
                    32 !== g2 && (y2 = " ");
                }
              break;
            case 0:
              y2 = "\\0";
              break;
            case 12:
              y2 = "\\f";
              break;
            case 11:
              y2 = "\\v";
              break;
            case 38:
              0 === n3 + b2 + m2 && (r3 = I = 1, y2 = "\f" + y2);
              break;
            case 108:
              if (0 === n3 + b2 + m2 + E2 && 0 < u2)
                switch (l2 - u2) {
                  case 2:
                    112 === x2 && 58 === e3.charCodeAt(l2 - 3) && (E2 = x2);
                  case 8:
                    111 === K2 && (E2 = K2);
                }
              break;
            case 58:
              0 === n3 + b2 + m2 && (u2 = l2);
              break;
            case 44:
              0 === b2 + v2 + n3 + m2 && (r3 = 1, y2 += "\r");
              break;
            case 34:
            case 39:
              0 === b2 && (n3 = n3 === g2 ? 0 : 0 === n3 ? g2 : n3);
              break;
            case 91:
              0 === n3 + b2 + v2 && m2++;
              break;
            case 93:
              0 === n3 + b2 + v2 && m2--;
              break;
            case 41:
              0 === n3 + b2 + m2 && v2--;
              break;
            case 40:
              if (0 === n3 + b2 + m2) {
                if (0 === q2)
                  switch (2 * x2 + 3 * K2) {
                    case 533:
                      break;
                    default:
                      q2 = 1;
                  }
                v2++;
              }
              break;
            case 64:
              0 === b2 + v2 + n3 + m2 + u2 + k2 && (k2 = 1);
              break;
            case 42:
            case 47:
              if (!(0 < n3 + m2 + v2))
                switch (b2) {
                  case 0:
                    switch (2 * g2 + 3 * e3.charCodeAt(l2 + 1)) {
                      case 235:
                        b2 = 47;
                        break;
                      case 220:
                        t3 = l2, b2 = 42;
                    }
                    break;
                  case 42:
                    47 === g2 && 42 === x2 && t3 + 2 !== l2 && (33 === e3.charCodeAt(t3 + 2) && (p += e3.substring(t3, l2 + 1)), y2 = "", b2 = 0);
                }
          }
          0 === b2 && (f3 += y2);
      }
      K2 = x2;
      x2 = g2;
      l2++;
    }
    t3 = p.length;
    if (0 < t3) {
      r3 = c2;
      if (0 < A2 && (C2 = H2(2, p, r3, d, D2, z2, t3, h, a2, h), void 0 !== C2 && 0 === (p = C2).length))
        return G3 + p + F3;
      p = r3.join(",") + "{" + p + "}";
      if (0 !== w2 * E2) {
        2 !== w2 || L2(p, 2) || (E2 = 0);
        switch (E2) {
          case 111:
            p = p.replace(ha, ":-moz-$1") + p;
            break;
          case 112:
            p = p.replace(Q2, "::-webkit-input-$1") + p.replace(Q2, "::-moz-$1") + p.replace(Q2, ":-ms-input-$1") + p;
        }
        E2 = 0;
      }
    }
    return G3 + p + F3;
  }
  function X2(d, c2, e3) {
    var h = c2.trim().split(ia);
    c2 = h;
    var a2 = h.length, m2 = d.length;
    switch (m2) {
      case 0:
      case 1:
        var b2 = 0;
        for (d = 0 === m2 ? "" : d[0] + " "; b2 < a2; ++b2) {
          c2[b2] = Z2(d, c2[b2], e3).trim();
        }
        break;
      default:
        var v2 = b2 = 0;
        for (c2 = []; b2 < a2; ++b2) {
          for (var n3 = 0; n3 < m2; ++n3) {
            c2[v2++] = Z2(d[n3] + " ", h[b2], e3).trim();
          }
        }
    }
    return c2;
  }
  function Z2(d, c2, e3) {
    var h = c2.charCodeAt(0);
    33 > h && (h = (c2 = c2.trim()).charCodeAt(0));
    switch (h) {
      case 38:
        return c2.replace(F2, "$1" + d.trim());
      case 58:
        return d.trim() + c2.replace(F2, "$1" + d.trim());
      default:
        if (0 < 1 * e3 && 0 < c2.indexOf("\f"))
          return c2.replace(F2, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
    }
    return d + c2;
  }
  function P2(d, c2, e3, h) {
    var a2 = d + ";", m2 = 2 * c2 + 3 * e3 + 4 * h;
    if (944 === m2) {
      d = a2.indexOf(":", 9) + 1;
      var b2 = a2.substring(d, a2.length - 1).trim();
      b2 = a2.substring(0, d).trim() + b2 + ";";
      return 1 === w2 || 2 === w2 && L2(b2, 1) ? "-webkit-" + b2 + b2 : b2;
    }
    if (0 === w2 || 2 === w2 && !L2(a2, 1))
      return a2;
    switch (m2) {
      case 1015:
        return 97 === a2.charCodeAt(10) ? "-webkit-" + a2 + a2 : a2;
      case 951:
        return 116 === a2.charCodeAt(3) ? "-webkit-" + a2 + a2 : a2;
      case 963:
        return 110 === a2.charCodeAt(5) ? "-webkit-" + a2 + a2 : a2;
      case 1009:
        if (100 !== a2.charCodeAt(4))
          break;
      case 969:
      case 942:
        return "-webkit-" + a2 + a2;
      case 978:
        return "-webkit-" + a2 + "-moz-" + a2 + a2;
      case 1019:
      case 983:
        return "-webkit-" + a2 + "-moz-" + a2 + "-ms-" + a2 + a2;
      case 883:
        if (45 === a2.charCodeAt(8))
          return "-webkit-" + a2 + a2;
        if (0 < a2.indexOf("image-set(", 11))
          return a2.replace(ja, "$1-webkit-$2") + a2;
        break;
      case 932:
        if (45 === a2.charCodeAt(4))
          switch (a2.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + a2.replace("-grow", "") + "-webkit-" + a2 + "-ms-" + a2.replace("grow", "positive") + a2;
            case 115:
              return "-webkit-" + a2 + "-ms-" + a2.replace("shrink", "negative") + a2;
            case 98:
              return "-webkit-" + a2 + "-ms-" + a2.replace("basis", "preferred-size") + a2;
          }
        return "-webkit-" + a2 + "-ms-" + a2 + a2;
      case 964:
        return "-webkit-" + a2 + "-ms-flex-" + a2 + a2;
      case 1023:
        if (99 !== a2.charCodeAt(8))
          break;
        b2 = a2.substring(a2.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
        return "-webkit-box-pack" + b2 + "-webkit-" + a2 + "-ms-flex-pack" + b2 + a2;
      case 1005:
        return ka.test(a2) ? a2.replace(aa, ":-webkit-") + a2.replace(aa, ":-moz-") + a2 : a2;
      case 1e3:
        b2 = a2.substring(13).trim();
        c2 = b2.indexOf("-") + 1;
        switch (b2.charCodeAt(0) + b2.charCodeAt(c2)) {
          case 226:
            b2 = a2.replace(G2, "tb");
            break;
          case 232:
            b2 = a2.replace(G2, "tb-rl");
            break;
          case 220:
            b2 = a2.replace(G2, "lr");
            break;
          default:
            return a2;
        }
        return "-webkit-" + a2 + "-ms-" + b2 + a2;
      case 1017:
        if (-1 === a2.indexOf("sticky", 9))
          break;
      case 975:
        c2 = (a2 = d).length - 10;
        b2 = (33 === a2.charCodeAt(c2) ? a2.substring(0, c2) : a2).substring(d.indexOf(":", 7) + 1).trim();
        switch (m2 = b2.charCodeAt(0) + (b2.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b2.charCodeAt(8))
              break;
          case 115:
            a2 = a2.replace(b2, "-webkit-" + b2) + ";" + a2;
            break;
          case 207:
          case 102:
            a2 = a2.replace(b2, "-webkit-" + (102 < m2 ? "inline-" : "") + "box") + ";" + a2.replace(b2, "-webkit-" + b2) + ";" + a2.replace(b2, "-ms-" + b2 + "box") + ";" + a2;
        }
        return a2 + ";";
      case 938:
        if (45 === a2.charCodeAt(5))
          switch (a2.charCodeAt(6)) {
            case 105:
              return b2 = a2.replace("-items", ""), "-webkit-" + a2 + "-webkit-box-" + b2 + "-ms-flex-" + b2 + a2;
            case 115:
              return "-webkit-" + a2 + "-ms-flex-item-" + a2.replace(ba, "") + a2;
            default:
              return "-webkit-" + a2 + "-ms-flex-line-pack" + a2.replace("align-content", "").replace(ba, "") + a2;
          }
        break;
      case 973:
      case 989:
        if (45 !== a2.charCodeAt(3) || 122 === a2.charCodeAt(4))
          break;
      case 931:
      case 953:
        if (true === la.test(d))
          return 115 === (b2 = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P2(d.replace("stretch", "fill-available"), c2, e3, h).replace(":fill-available", ":stretch") : a2.replace(b2, "-webkit-" + b2) + a2.replace(b2, "-moz-" + b2.replace("fill-", "")) + a2;
        break;
      case 962:
        if (a2 = "-webkit-" + a2 + (102 === a2.charCodeAt(5) ? "-ms-" + a2 : "") + a2, 211 === e3 + h && 105 === a2.charCodeAt(13) && 0 < a2.indexOf("transform", 10))
          return a2.substring(0, a2.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a2;
    }
    return a2;
  }
  function L2(d, c2) {
    var e3 = d.indexOf(1 === c2 ? ":" : "{"), h = d.substring(0, 3 !== c2 ? e3 : 10);
    e3 = d.substring(e3 + 1, d.length - 1);
    return R2(2 !== c2 ? h : h.replace(na, "$1"), e3, c2);
  }
  function ea(d, c2) {
    var e3 = P2(c2, c2.charCodeAt(0), c2.charCodeAt(1), c2.charCodeAt(2));
    return e3 !== c2 + ";" ? e3.replace(oa, " or ($1)").substring(4) : "(" + c2 + ")";
  }
  function H2(d, c2, e3, h, a2, m2, b2, v2, n3, q2) {
    for (var g2 = 0, x2 = c2, w3; g2 < A2; ++g2) {
      switch (w3 = S2[g2].call(B2, d, x2, e3, h, a2, m2, b2, v2, n3, q2)) {
        case void 0:
        case false:
        case true:
        case null:
          break;
        default:
          x2 = w3;
      }
    }
    if (x2 !== c2)
      return x2;
  }
  function T2(d) {
    switch (d) {
      case void 0:
      case null:
        A2 = S2.length = 0;
        break;
      default:
        if ("function" === typeof d)
          S2[A2++] = d;
        else if ("object" === typeof d)
          for (var c2 = 0, e3 = d.length; c2 < e3; ++c2) {
            T2(d[c2]);
          }
        else
          Y2 = !!d | 0;
    }
    return T2;
  }
  function U2(d) {
    d = d.prefix;
    void 0 !== d && (R2 = null, d ? "function" !== typeof d ? w2 = 1 : (w2 = 2, R2 = d) : w2 = 0);
    return U2;
  }
  function B2(d, c2) {
    var e3 = d;
    33 > e3.charCodeAt(0) && (e3 = e3.trim());
    V2 = e3;
    e3 = [V2];
    if (0 < A2) {
      var h = H2(-1, c2, e3, e3, D2, z2, 0, 0, 0, 0);
      void 0 !== h && "string" === typeof h && (c2 = h);
    }
    var a2 = M2(O2, e3, c2, 0, 0);
    0 < A2 && (h = H2(-2, a2, e3, e3, D2, z2, a2.length, 0, 0, 0), void 0 !== h && (a2 = h));
    V2 = "";
    E2 = 0;
    z2 = D2 = 1;
    return a2;
  }
  var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F2 = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q2 = /::(place)/g, ha = /:(read-only)/g, G2 = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z2 = 1, D2 = 1, E2 = 0, w2 = 1, O2 = [], S2 = [], A2 = 0, R2 = null, Y2 = 0, V2 = "";
  B2.use = T2;
  B2.set = U2;
  void 0 !== W2 && U2(W2);
  return B2;
}
var stylis_esm_default = stylis_min;

// ../../node_modules/@emotion/unitless/dist/unitless.esm.js
init_esm_shims();
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var unitless_esm_default = unitlessKeys;

// ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.mjs
init_esm_shims();
var import_emotion_is_prop_valid_cjs = __toESM(require_emotion_is_prop_valid_cjs(), 1);
var import_emotion_is_prop_valid_cjs_default = __toESM(require_emotion_is_prop_valid_cjs_default(), 1);

// ../../node_modules/styled-components/dist/styled-components.esm.js
var import_hoist_non_react_statics = __toESM(require_hoist_non_react_statics_cjs());
function m() {
  return (m = Object.assign || function(e3) {
    for (var t3 = 1; t3 < arguments.length; t3++) {
      var n3 = arguments[t3];
      for (var r3 in n3)
        Object.prototype.hasOwnProperty.call(n3, r3) && (e3[r3] = n3[r3]);
    }
    return e3;
  }).apply(this, arguments);
}
var y = function(e3, t3) {
  for (var n3 = [e3[0]], r3 = 0, o2 = t3.length; r3 < o2; r3 += 1)
    n3.push(t3[r3], e3[r3 + 1]);
  return n3;
};
var v = function(t3) {
  return null !== t3 && "object" == typeof t3 && "[object Object]" === (t3.toString ? t3.toString() : Object.prototype.toString.call(t3)) && !(0, import_react_is.typeOf)(t3);
};
var g = Object.freeze([]);
var S = Object.freeze({});
function w(e3) {
  return "function" == typeof e3;
}
function E(e3) {
  return "production" !== process.env.NODE_ENV && "string" == typeof e3 && e3 || e3.displayName || e3.name || "Component";
}
function b(e3) {
  return e3 && "string" == typeof e3.styledComponentId;
}
var _ = "undefined" != typeof process && void 0 !== process.env && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled";
var A = "undefined" != typeof window && "HTMLElement" in window;
var C = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env && (void 0 !== process.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== process.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== process.env.REACT_APP_SC_DISABLE_SPEEDY && process.env.REACT_APP_SC_DISABLE_SPEEDY : void 0 !== process.env.SC_DISABLE_SPEEDY && "" !== process.env.SC_DISABLE_SPEEDY ? "false" !== process.env.SC_DISABLE_SPEEDY && process.env.SC_DISABLE_SPEEDY : "production" !== process.env.NODE_ENV));
var P = "production" !== process.env.NODE_ENV ? { 1: "Cannot create styled-component for component: %s.\n\n", 2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n", 3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n", 4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n", 5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n", 6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n", 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: 'ThemeProvider: Please make your "theme" prop an object.\n\n', 9: "Missing document `<head>`\n\n", 10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n", 11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n", 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n", 14: 'ThemeProvider: "theme" prop is required.\n\n', 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n", 17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n" } : {};
function O() {
  for (var e3 = arguments.length <= 0 ? void 0 : arguments[0], t3 = [], n3 = 1, r3 = arguments.length; n3 < r3; n3 += 1)
    t3.push(n3 < 0 || arguments.length <= n3 ? void 0 : arguments[n3]);
  return t3.forEach(function(t4) {
    e3 = e3.replace(/%[a-z]/, t4);
  }), e3;
}
function R(e3) {
  for (var t3 = arguments.length, n3 = new Array(t3 > 1 ? t3 - 1 : 0), r3 = 1; r3 < t3; r3++)
    n3[r3 - 1] = arguments[r3];
  throw "production" === process.env.NODE_ENV ? new Error("An error occurred. See https://git.io/JUIaE#" + e3 + " for more information." + (n3.length > 0 ? " Args: " + n3.join(", ") : "")) : new Error(O.apply(void 0, [P[e3]].concat(n3)).trim());
}
var D = function() {
  function e3(e4) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e4;
  }
  var t3 = e3.prototype;
  return t3.indexOfGroup = function(e4) {
    for (var t4 = 0, n3 = 0; n3 < e4; n3++)
      t4 += this.groupSizes[n3];
    return t4;
  }, t3.insertRules = function(e4, t4) {
    if (e4 >= this.groupSizes.length) {
      for (var n3 = this.groupSizes, r3 = n3.length, o2 = r3; e4 >= o2; )
        (o2 <<= 1) < 0 && R(16, "" + e4);
      this.groupSizes = new Uint32Array(o2), this.groupSizes.set(n3), this.length = o2;
      for (var s2 = r3; s2 < o2; s2++)
        this.groupSizes[s2] = 0;
    }
    for (var i2 = this.indexOfGroup(e4 + 1), a2 = 0, c2 = t4.length; a2 < c2; a2++)
      this.tag.insertRule(i2, t4[a2]) && (this.groupSizes[e4]++, i2++);
  }, t3.clearGroup = function(e4) {
    if (e4 < this.length) {
      var t4 = this.groupSizes[e4], n3 = this.indexOfGroup(e4), r3 = n3 + t4;
      this.groupSizes[e4] = 0;
      for (var o2 = n3; o2 < r3; o2++)
        this.tag.deleteRule(n3);
    }
  }, t3.getGroup = function(e4) {
    var t4 = "";
    if (e4 >= this.length || 0 === this.groupSizes[e4])
      return t4;
    for (var n3 = this.groupSizes[e4], r3 = this.indexOfGroup(e4), o2 = r3 + n3, s2 = r3; s2 < o2; s2++)
      t4 += this.tag.getRule(s2) + "/*!sc*/\n";
    return t4;
  }, e3;
}();
var j = /* @__PURE__ */ new Map();
var T = /* @__PURE__ */ new Map();
var x = 1;
var k = function(e3) {
  if (j.has(e3))
    return j.get(e3);
  for (; T.has(x); )
    x++;
  var t3 = x++;
  return "production" !== process.env.NODE_ENV && ((0 | t3) < 0 || t3 > 1 << 30) && R(16, "" + t3), j.set(e3, t3), T.set(t3, e3), t3;
};
var V = function(e3) {
  return T.get(e3);
};
var z = function(e3, t3) {
  t3 >= x && (x = t3 + 1), j.set(e3, t3), T.set(t3, e3);
};
var B = "style[" + _ + '][data-styled-version="5.3.11"]';
var M = new RegExp("^" + _ + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)');
var G = function(e3, t3, n3) {
  for (var r3, o2 = n3.split(","), s2 = 0, i2 = o2.length; s2 < i2; s2++)
    (r3 = o2[s2]) && e3.registerName(t3, r3);
};
var L = function(e3, t3) {
  for (var n3 = (t3.textContent || "").split("/*!sc*/\n"), r3 = [], o2 = 0, s2 = n3.length; o2 < s2; o2++) {
    var i2 = n3[o2].trim();
    if (i2) {
      var a2 = i2.match(M);
      if (a2) {
        var c2 = 0 | parseInt(a2[1], 10), u2 = a2[2];
        0 !== c2 && (z(u2, c2), G(e3, u2, a2[3]), e3.getTag().insertRules(c2, r3)), r3.length = 0;
      } else
        r3.push(i2);
    }
  }
};
var F = function() {
  return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
};
var Y = function(e3) {
  var t3 = document.head, n3 = e3 || t3, r3 = document.createElement("style"), o2 = function(e4) {
    for (var t4 = e4.childNodes, n4 = t4.length; n4 >= 0; n4--) {
      var r4 = t4[n4];
      if (r4 && 1 === r4.nodeType && r4.hasAttribute(_))
        return r4;
    }
  }(n3), s2 = void 0 !== o2 ? o2.nextSibling : null;
  r3.setAttribute(_, "active"), r3.setAttribute("data-styled-version", "5.3.11");
  var i2 = F();
  return i2 && r3.setAttribute("nonce", i2), n3.insertBefore(r3, s2), r3;
};
var q = function() {
  function e3(e4) {
    var t4 = this.element = Y(e4);
    t4.appendChild(document.createTextNode("")), this.sheet = function(e5) {
      if (e5.sheet)
        return e5.sheet;
      for (var t5 = document.styleSheets, n3 = 0, r3 = t5.length; n3 < r3; n3++) {
        var o2 = t5[n3];
        if (o2.ownerNode === e5)
          return o2;
      }
      R(17);
    }(t4), this.length = 0;
  }
  var t3 = e3.prototype;
  return t3.insertRule = function(e4, t4) {
    try {
      return this.sheet.insertRule(t4, e4), this.length++, true;
    } catch (e5) {
      return false;
    }
  }, t3.deleteRule = function(e4) {
    this.sheet.deleteRule(e4), this.length--;
  }, t3.getRule = function(e4) {
    var t4 = this.sheet.cssRules[e4];
    return void 0 !== t4 && "string" == typeof t4.cssText ? t4.cssText : "";
  }, e3;
}();
var H = function() {
  function e3(e4) {
    var t4 = this.element = Y(e4);
    this.nodes = t4.childNodes, this.length = 0;
  }
  var t3 = e3.prototype;
  return t3.insertRule = function(e4, t4) {
    if (e4 <= this.length && e4 >= 0) {
      var n3 = document.createTextNode(t4), r3 = this.nodes[e4];
      return this.element.insertBefore(n3, r3 || null), this.length++, true;
    }
    return false;
  }, t3.deleteRule = function(e4) {
    this.element.removeChild(this.nodes[e4]), this.length--;
  }, t3.getRule = function(e4) {
    return e4 < this.length ? this.nodes[e4].textContent : "";
  }, e3;
}();
var $ = function() {
  function e3(e4) {
    this.rules = [], this.length = 0;
  }
  var t3 = e3.prototype;
  return t3.insertRule = function(e4, t4) {
    return e4 <= this.length && (this.rules.splice(e4, 0, t4), this.length++, true);
  }, t3.deleteRule = function(e4) {
    this.rules.splice(e4, 1), this.length--;
  }, t3.getRule = function(e4) {
    return e4 < this.length ? this.rules[e4] : "";
  }, e3;
}();
var W = A;
var U = { isServer: !A, useCSSOMInjection: !C };
var J = function() {
  function e3(e4, t4, n3) {
    void 0 === e4 && (e4 = S), void 0 === t4 && (t4 = {}), this.options = m({}, U, {}, e4), this.gs = t4, this.names = new Map(n3), this.server = !!e4.isServer, !this.server && A && W && (W = false, function(e5) {
      for (var t5 = document.querySelectorAll(B), n4 = 0, r3 = t5.length; n4 < r3; n4++) {
        var o2 = t5[n4];
        o2 && "active" !== o2.getAttribute(_) && (L(e5, o2), o2.parentNode && o2.parentNode.removeChild(o2));
      }
    }(this));
  }
  e3.registerId = function(e4) {
    return k(e4);
  };
  var t3 = e3.prototype;
  return t3.reconstructWithOptions = function(t4, n3) {
    return void 0 === n3 && (n3 = true), new e3(m({}, this.options, {}, t4), this.gs, n3 && this.names || void 0);
  }, t3.allocateGSInstance = function(e4) {
    return this.gs[e4] = (this.gs[e4] || 0) + 1;
  }, t3.getTag = function() {
    return this.tag || (this.tag = (n3 = (t4 = this.options).isServer, r3 = t4.useCSSOMInjection, o2 = t4.target, e4 = n3 ? new $(o2) : r3 ? new q(o2) : new H(o2), new D(e4)));
    var e4, t4, n3, r3, o2;
  }, t3.hasNameForId = function(e4, t4) {
    return this.names.has(e4) && this.names.get(e4).has(t4);
  }, t3.registerName = function(e4, t4) {
    if (k(e4), this.names.has(e4))
      this.names.get(e4).add(t4);
    else {
      var n3 = /* @__PURE__ */ new Set();
      n3.add(t4), this.names.set(e4, n3);
    }
  }, t3.insertRules = function(e4, t4, n3) {
    this.registerName(e4, t4), this.getTag().insertRules(k(e4), n3);
  }, t3.clearNames = function(e4) {
    this.names.has(e4) && this.names.get(e4).clear();
  }, t3.clearRules = function(e4) {
    this.getTag().clearGroup(k(e4)), this.clearNames(e4);
  }, t3.clearTag = function() {
    this.tag = void 0;
  }, t3.toString = function() {
    return function(e4) {
      for (var t4 = e4.getTag(), n3 = t4.length, r3 = "", o2 = 0; o2 < n3; o2++) {
        var s2 = V(o2);
        if (void 0 !== s2) {
          var i2 = e4.names.get(s2), a2 = t4.getGroup(o2);
          if (i2 && a2 && i2.size) {
            var c2 = _ + ".g" + o2 + '[id="' + s2 + '"]', u2 = "";
            void 0 !== i2 && i2.forEach(function(e5) {
              e5.length > 0 && (u2 += e5 + ",");
            }), r3 += "" + a2 + c2 + '{content:"' + u2 + '"}/*!sc*/\n';
          }
        }
      }
      return r3;
    }(this);
  }, e3;
}();
var X = /(a)(d)/gi;
var Z = function(e3) {
  return String.fromCharCode(e3 + (e3 > 25 ? 39 : 97));
};
function K(e3) {
  var t3, n3 = "";
  for (t3 = Math.abs(e3); t3 > 52; t3 = t3 / 52 | 0)
    n3 = Z(t3 % 52) + n3;
  return (Z(t3 % 52) + n3).replace(X, "$1-$2");
}
var Q = function(e3, t3) {
  for (var n3 = t3.length; n3; )
    e3 = 33 * e3 ^ t3.charCodeAt(--n3);
  return e3;
};
var ee = function(e3) {
  return Q(5381, e3);
};
function te(e3) {
  for (var t3 = 0; t3 < e3.length; t3 += 1) {
    var n3 = e3[t3];
    if (w(n3) && !b(n3))
      return false;
  }
  return true;
}
var ne = ee("5.3.11");
var re = function() {
  function e3(e4, t3, n3) {
    this.rules = e4, this.staticRulesId = "", this.isStatic = "production" === process.env.NODE_ENV && (void 0 === n3 || n3.isStatic) && te(e4), this.componentId = t3, this.baseHash = Q(ne, t3), this.baseStyle = n3, J.registerId(t3);
  }
  return e3.prototype.generateAndInjectStyles = function(e4, t3, n3) {
    var r3 = this.componentId, o2 = [];
    if (this.baseStyle && o2.push(this.baseStyle.generateAndInjectStyles(e4, t3, n3)), this.isStatic && !n3.hash)
      if (this.staticRulesId && t3.hasNameForId(r3, this.staticRulesId))
        o2.push(this.staticRulesId);
      else {
        var s2 = be(this.rules, e4, t3, n3).join(""), i2 = K(Q(this.baseHash, s2) >>> 0);
        if (!t3.hasNameForId(r3, i2)) {
          var a2 = n3(s2, "." + i2, void 0, r3);
          t3.insertRules(r3, i2, a2);
        }
        o2.push(i2), this.staticRulesId = i2;
      }
    else {
      for (var c2 = this.rules.length, u2 = Q(this.baseHash, n3.hash), l2 = "", d = 0; d < c2; d++) {
        var h = this.rules[d];
        if ("string" == typeof h)
          l2 += h, "production" !== process.env.NODE_ENV && (u2 = Q(u2, h + d));
        else if (h) {
          var p = be(h, e4, t3, n3), f3 = Array.isArray(p) ? p.join("") : p;
          u2 = Q(u2, f3 + d), l2 += f3;
        }
      }
      if (l2) {
        var m2 = K(u2 >>> 0);
        if (!t3.hasNameForId(r3, m2)) {
          var y2 = n3(l2, "." + m2, void 0, r3);
          t3.insertRules(r3, m2, y2);
        }
        o2.push(m2);
      }
    }
    return o2.join(" ");
  }, e3;
}();
var oe = /^\s*\/\/.*$/gm;
var se = [":", "[", ".", "#"];
function ie(e3) {
  var t3, n3, r3, o2, s2 = void 0 === e3 ? S : e3, i2 = s2.options, a2 = void 0 === i2 ? S : i2, c2 = s2.plugins, u2 = void 0 === c2 ? g : c2, l2 = new stylis_esm_default(a2), h = [], p = function(e4) {
    function t4(t5) {
      if (t5)
        try {
          e4(t5 + "}");
        } catch (e5) {
        }
    }
    return function(n4, r4, o3, s3, i3, a3, c3, u3, l3, d) {
      switch (n4) {
        case 1:
          if (0 === l3 && 64 === r4.charCodeAt(0))
            return e4(r4 + ";"), "";
          break;
        case 2:
          if (0 === u3)
            return r4 + "/*|*/";
          break;
        case 3:
          switch (u3) {
            case 102:
            case 112:
              return e4(o3[0] + r4), "";
            default:
              return r4 + (0 === d ? "/*|*/" : "");
          }
        case -2:
          r4.split("/*|*/}").forEach(t4);
      }
    };
  }(function(e4) {
    h.push(e4);
  }), f3 = function(e4, r4, s3) {
    return 0 === r4 && -1 !== se.indexOf(s3[n3.length]) || s3.match(o2) ? e4 : "." + t3;
  };
  function m2(e4, s3, i3, a3) {
    void 0 === a3 && (a3 = "&");
    var c3 = e4.replace(oe, ""), u3 = s3 && i3 ? i3 + " " + s3 + " { " + c3 + " }" : c3;
    return t3 = a3, n3 = s3, r3 = new RegExp("\\" + n3 + "\\b", "g"), o2 = new RegExp("(\\" + n3 + "\\b){2,}"), l2(i3 || !s3 ? "" : s3, u3);
  }
  return l2.use([].concat(u2, [function(e4, t4, o3) {
    2 === e4 && o3.length && o3[0].lastIndexOf(n3) > 0 && (o3[0] = o3[0].replace(r3, f3));
  }, p, function(e4) {
    if (-2 === e4) {
      var t4 = h;
      return h = [], t4;
    }
  }])), m2.hash = u2.length ? u2.reduce(function(e4, t4) {
    return t4.name || R(15), Q(e4, t4.name);
  }, 5381).toString() : "", m2;
}
var ae = r.createContext();
var ce = ae.Consumer;
var ue = r.createContext();
var le = (ue.Consumer, new J());
var de = ie();
function he() {
  return s(ae) || le;
}
function pe() {
  return s(ue) || de;
}
function fe(e3) {
  var t3 = o(e3.stylisPlugins), n3 = t3[0], s2 = t3[1], c2 = he(), u2 = i(function() {
    var t4 = c2;
    return e3.sheet ? t4 = e3.sheet : e3.target && (t4 = t4.reconstructWithOptions({ target: e3.target }, false)), e3.disableCSSOMInjection && (t4 = t4.reconstructWithOptions({ useCSSOMInjection: false })), t4;
  }, [e3.disableCSSOMInjection, e3.sheet, e3.target]), d = i(function() {
    return ie({ options: { prefix: !e3.disableVendorPrefixes }, plugins: n3 });
  }, [e3.disableVendorPrefixes, n3]);
  return a(function() {
    (0, import_shallowequal.default)(n3, e3.stylisPlugins) || s2(e3.stylisPlugins);
  }, [e3.stylisPlugins]), r.createElement(ae.Provider, { value: u2 }, r.createElement(ue.Provider, { value: d }, "production" !== process.env.NODE_ENV ? r.Children.only(e3.children) : e3.children));
}
var me = function() {
  function e3(e4, t3) {
    var n3 = this;
    this.inject = function(e5, t4) {
      void 0 === t4 && (t4 = de);
      var r3 = n3.name + t4.hash;
      e5.hasNameForId(n3.id, r3) || e5.insertRules(n3.id, r3, t4(n3.rules, r3, "@keyframes"));
    }, this.toString = function() {
      return R(12, String(n3.name));
    }, this.name = e4, this.id = "sc-keyframes-" + e4, this.rules = t3;
  }
  return e3.prototype.getName = function(e4) {
    return void 0 === e4 && (e4 = de), this.name + e4.hash;
  }, e3;
}();
var ye = /([A-Z])/;
var ve = /([A-Z])/g;
var ge = /^ms-/;
var Se = function(e3) {
  return "-" + e3.toLowerCase();
};
function we(e3) {
  return ye.test(e3) ? e3.replace(ve, Se).replace(ge, "-ms-") : e3;
}
var Ee = function(e3) {
  return null == e3 || false === e3 || "" === e3;
};
function be(e3, n3, r3, o2) {
  if (Array.isArray(e3)) {
    for (var s2, i2 = [], a2 = 0, c2 = e3.length; a2 < c2; a2 += 1)
      "" !== (s2 = be(e3[a2], n3, r3, o2)) && (Array.isArray(s2) ? i2.push.apply(i2, s2) : i2.push(s2));
    return i2;
  }
  if (Ee(e3))
    return "";
  if (b(e3))
    return "." + e3.styledComponentId;
  if (w(e3)) {
    if ("function" != typeof (l2 = e3) || l2.prototype && l2.prototype.isReactComponent || !n3)
      return e3;
    var u2 = e3(n3);
    return "production" !== process.env.NODE_ENV && (0, import_react_is.isElement)(u2) && console.warn(E(e3) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), be(u2, n3, r3, o2);
  }
  var l2;
  return e3 instanceof me ? r3 ? (e3.inject(r3, o2), e3.getName(o2)) : e3 : v(e3) ? function e4(t3, n4) {
    var r4, o3, s3 = [];
    for (var i3 in t3)
      t3.hasOwnProperty(i3) && !Ee(t3[i3]) && (Array.isArray(t3[i3]) && t3[i3].isCss || w(t3[i3]) ? s3.push(we(i3) + ":", t3[i3], ";") : v(t3[i3]) ? s3.push.apply(s3, e4(t3[i3], i3)) : s3.push(we(i3) + ": " + (r4 = i3, null == (o3 = t3[i3]) || "boolean" == typeof o3 || "" === o3 ? "" : "number" != typeof o3 || 0 === o3 || r4 in unitless_esm_default || r4.startsWith("--") ? String(o3).trim() : o3 + "px") + ";"));
    return n4 ? [n4 + " {"].concat(s3, ["}"]) : s3;
  }(e3) : e3.toString();
}
var _e = function(e3) {
  return Array.isArray(e3) && (e3.isCss = true), e3;
};
function Ne(e3) {
  for (var t3 = arguments.length, n3 = new Array(t3 > 1 ? t3 - 1 : 0), r3 = 1; r3 < t3; r3++)
    n3[r3 - 1] = arguments[r3];
  return w(e3) || v(e3) ? _e(be(y(g, [e3].concat(n3)))) : 0 === n3.length && 1 === e3.length && "string" == typeof e3[0] ? e3 : _e(be(y(e3, n3)));
}
var Ae = /invalid hook call/i;
var Ce = /* @__PURE__ */ new Set();
var Ie = function(e3, t3) {
  if ("production" !== process.env.NODE_ENV) {
    var n3 = "The component " + e3 + (t3 ? ' with the id of "' + t3 + '"' : "") + " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.", r3 = console.error;
    try {
      var o2 = true;
      console.error = function(e4) {
        if (Ae.test(e4))
          o2 = false, Ce.delete(n3);
        else {
          for (var t4 = arguments.length, s2 = new Array(t4 > 1 ? t4 - 1 : 0), i2 = 1; i2 < t4; i2++)
            s2[i2 - 1] = arguments[i2];
          r3.apply(void 0, [e4].concat(s2));
        }
      }, c(), o2 && !Ce.has(n3) && (console.warn(n3), Ce.add(n3));
    } catch (e4) {
      Ae.test(e4.message) && Ce.delete(n3);
    } finally {
      console.error = r3;
    }
  }
};
var Pe = function(e3, t3, n3) {
  return void 0 === n3 && (n3 = S), e3.theme !== n3.theme && e3.theme || t3 || n3.theme;
};
var Oe = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g;
var Re = /(^-|-$)/g;
function De(e3) {
  return e3.replace(Oe, "-").replace(Re, "");
}
var je = function(e3) {
  return K(ee(e3) >>> 0);
};
function Te(e3) {
  return "string" == typeof e3 && ("production" === process.env.NODE_ENV || e3.charAt(0) === e3.charAt(0).toLowerCase());
}
var xe = function(e3) {
  return "function" == typeof e3 || "object" == typeof e3 && null !== e3 && !Array.isArray(e3);
};
var ke = function(e3) {
  return "__proto__" !== e3 && "constructor" !== e3 && "prototype" !== e3;
};
function Ve(e3, t3, n3) {
  var r3 = e3[n3];
  xe(t3) && xe(r3) ? ze(r3, t3) : e3[n3] = t3;
}
function ze(e3) {
  for (var t3 = arguments.length, n3 = new Array(t3 > 1 ? t3 - 1 : 0), r3 = 1; r3 < t3; r3++)
    n3[r3 - 1] = arguments[r3];
  for (var o2 = 0, s2 = n3; o2 < s2.length; o2++) {
    var i2 = s2[o2];
    if (xe(i2))
      for (var a2 in i2)
        ke(a2) && Ve(e3, i2[a2], a2);
  }
  return e3;
}
var Be = r.createContext();
var Me = Be.Consumer;
var Le = {};
function Fe(e3, t3, n3) {
  var o2 = b(e3), i2 = !Te(e3), a2 = t3.attrs, c2 = void 0 === a2 ? g : a2, l2 = t3.componentId, d = void 0 === l2 ? function(e4, t4) {
    var n4 = "string" != typeof e4 ? "sc" : De(e4);
    Le[n4] = (Le[n4] || 0) + 1;
    var r3 = n4 + "-" + je("5.3.11" + n4 + Le[n4]);
    return t4 ? t4 + "-" + r3 : r3;
  }(t3.displayName, t3.parentComponentId) : l2, h = t3.displayName, y2 = void 0 === h ? function(e4) {
    return Te(e4) ? "styled." + e4 : "Styled(" + E(e4) + ")";
  }(e3) : h, v2 = t3.displayName && t3.componentId ? De(t3.displayName) + "-" + t3.componentId : t3.componentId || d, _2 = o2 && e3.attrs ? Array.prototype.concat(e3.attrs, c2).filter(Boolean) : c2, N = t3.shouldForwardProp;
  o2 && e3.shouldForwardProp && (N = t3.shouldForwardProp ? function(n4, r3, o3) {
    return e3.shouldForwardProp(n4, r3, o3) && t3.shouldForwardProp(n4, r3, o3);
  } : e3.shouldForwardProp);
  var A2, C2 = new re(n3, v2, o2 ? e3.componentStyle : void 0), I = C2.isStatic && 0 === c2.length, P2 = function(e4, t4) {
    return function(e5, t5, n4, r3) {
      var o3 = e5.attrs, i3 = e5.componentStyle, a3 = e5.defaultProps, c3 = e5.foldedComponentIds, l3 = e5.shouldForwardProp, d2 = e5.styledComponentId, h2 = e5.target, f3 = function(e6, t6, n5) {
        void 0 === e6 && (e6 = S);
        var r4 = m({}, t6, { theme: e6 }), o4 = {};
        return n5.forEach(function(e7) {
          var t7, n6, s2, i4 = e7;
          for (t7 in w(i4) && (i4 = i4(r4)), i4)
            r4[t7] = o4[t7] = "className" === t7 ? (n6 = o4[t7], s2 = i4[t7], n6 && s2 ? n6 + " " + s2 : n6 || s2) : i4[t7];
        }), [r4, o4];
      }(Pe(t5, s(Be), a3) || S, t5, o3), y3 = f3[0], v3 = f3[1], g2 = function(e6, t6, n5, r4) {
        var o4 = he(), s2 = pe(), i4 = t6 ? e6.generateAndInjectStyles(S, o4, s2) : e6.generateAndInjectStyles(n5, o4, s2);
        return "production" !== process.env.NODE_ENV && !t6 && r4 && r4(i4), i4;
      }(i3, r3, y3, "production" !== process.env.NODE_ENV ? e5.warnTooManyClasses : void 0), E2 = n4, b2 = v3.$as || t5.$as || v3.as || t5.as || h2, _3 = Te(b2), N2 = v3 !== t5 ? m({}, t5, {}, v3) : t5, A3 = {};
      for (var C3 in N2)
        "$" !== C3[0] && "as" !== C3 && ("forwardedAs" === C3 ? A3.as = N2[C3] : (l3 ? l3(C3, import_emotion_is_prop_valid_cjs_default._default, b2) : !_3 || (0, import_emotion_is_prop_valid_cjs_default._default)(C3)) && (A3[C3] = N2[C3]));
      return t5.style && v3.style !== t5.style && (A3.style = m({}, t5.style, {}, v3.style)), A3.className = Array.prototype.concat(c3, d2, g2 !== d2 ? g2 : null, t5.className, v3.className).filter(Boolean).join(" "), A3.ref = E2, u(b2, A3);
    }(A2, e4, t4, I);
  };
  return P2.displayName = y2, (A2 = r.forwardRef(P2)).attrs = _2, A2.componentStyle = C2, A2.displayName = y2, A2.shouldForwardProp = N, A2.foldedComponentIds = o2 ? Array.prototype.concat(e3.foldedComponentIds, e3.styledComponentId) : g, A2.styledComponentId = v2, A2.target = o2 ? e3.target : e3, A2.withComponent = function(e4) {
    var r3 = t3.componentId, o3 = function(e5, t4) {
      if (null == e5)
        return {};
      var n4, r4, o4 = {}, s3 = Object.keys(e5);
      for (r4 = 0; r4 < s3.length; r4++)
        n4 = s3[r4], t4.indexOf(n4) >= 0 || (o4[n4] = e5[n4]);
      return o4;
    }(t3, ["componentId"]), s2 = r3 && r3 + "-" + (Te(e4) ? e4 : De(E(e4)));
    return Fe(e4, m({}, o3, { attrs: _2, componentId: s2 }), n3);
  }, Object.defineProperty(A2, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(t4) {
    this._foldedDefaultProps = o2 ? ze({}, e3.defaultProps, t4) : t4;
  } }), "production" !== process.env.NODE_ENV && (Ie(y2, v2), A2.warnTooManyClasses = function(e4, t4) {
    var n4 = {}, r3 = false;
    return function(o3) {
      if (!r3 && (n4[o3] = true, Object.keys(n4).length >= 200)) {
        var s2 = t4 ? ' with the id of "' + t4 + '"' : "";
        console.warn("Over 200 classes were generated for component " + e4 + s2 + ".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), r3 = true, n4 = {};
      }
    };
  }(y2, v2)), Object.defineProperty(A2, "toString", { value: function() {
    return "." + A2.styledComponentId;
  } }), i2 && (0, import_hoist_non_react_statics.default)(A2, e3, { attrs: true, componentStyle: true, displayName: true, foldedComponentIds: true, shouldForwardProp: true, styledComponentId: true, target: true, withComponent: true }), A2;
}
var Ye = function(e3) {
  return function e4(t3, r3, o2) {
    if (void 0 === o2 && (o2 = S), !(0, import_react_is.isValidElementType)(r3))
      return R(1, String(r3));
    var s2 = function() {
      return t3(r3, o2, Ne.apply(void 0, arguments));
    };
    return s2.withConfig = function(n3) {
      return e4(t3, r3, m({}, o2, {}, n3));
    }, s2.attrs = function(n3) {
      return e4(t3, r3, m({}, o2, { attrs: Array.prototype.concat(o2.attrs, n3).filter(Boolean) }));
    }, s2;
  }(Fe, e3);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e3) {
  Ye[e3] = Ye(e3);
});
var qe = function() {
  function e3(e4, t4) {
    this.rules = e4, this.componentId = t4, this.isStatic = te(e4), J.registerId(this.componentId + 1);
  }
  var t3 = e3.prototype;
  return t3.createStyles = function(e4, t4, n3, r3) {
    var o2 = r3(be(this.rules, t4, n3, r3).join(""), ""), s2 = this.componentId + e4;
    n3.insertRules(s2, s2, o2);
  }, t3.removeStyles = function(e4, t4) {
    t4.clearRules(this.componentId + e4);
  }, t3.renderStyles = function(e4, t4, n3, r3) {
    e4 > 2 && J.registerId(this.componentId + e4), this.removeStyles(e4, n3), this.createStyles(e4, t4, n3, r3);
  }, e3;
}();
var We = /^\s*<\/[a-z]/i;
var Ue = function() {
  function e3() {
    var e4 = this;
    this._emitSheetCSS = function() {
      var t4 = e4.instance.toString();
      if (!t4)
        return "";
      var n3 = F();
      return "<style " + [n3 && 'nonce="' + n3 + '"', _ + '="true"', 'data-styled-version="5.3.11"'].filter(Boolean).join(" ") + ">" + t4 + "</style>";
    }, this.getStyleTags = function() {
      return e4.sealed ? R(2) : e4._emitSheetCSS();
    }, this.getStyleElement = function() {
      var t4;
      if (e4.sealed)
        return R(2);
      var n3 = ((t4 = {})[_] = "", t4["data-styled-version"] = "5.3.11", t4.dangerouslySetInnerHTML = { __html: e4.instance.toString() }, t4), o2 = F();
      return o2 && (n3.nonce = o2), [r.createElement("style", m({}, n3, { key: "sc-0-0" }))];
    }, this.seal = function() {
      e4.sealed = true;
    }, this.instance = new J({ isServer: true }), this.sealed = false;
  }
  var t3 = e3.prototype;
  return t3.collectStyles = function(e4) {
    return this.sealed ? R(2) : r.createElement(fe, { sheet: this.instance }, e4);
  }, t3.interleaveWithNodeStream = function(e4) {
    if (A)
      return R(3);
    if (this.sealed)
      return R(2);
    this.seal();
    var t4 = __require("stream"), n3 = (t4.Readable, t4.Transform), r3 = e4, o2 = this.instance, s2 = this._emitSheetCSS, i2 = new n3({ transform: function(e5, t5, n4) {
      var r4 = e5.toString(), i3 = s2();
      if (o2.clearTag(), We.test(r4)) {
        var a2 = r4.indexOf(">") + 1, c2 = r4.slice(0, a2), u2 = r4.slice(a2);
        this.push(c2 + i3 + u2);
      } else
        this.push(i3 + r4);
      n4();
    } });
    return r3.on("error", function(e5) {
      i2.emit("error", e5);
    }), r3.pipe(i2);
  }, e3;
}();
"production" !== process.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"), "production" !== process.env.NODE_ENV && "test" !== process.env.NODE_ENV && "undefined" != typeof window && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, 1 === window["__styled-components-init__"] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window["__styled-components-init__"] += 1);
var styled_components_esm_default = Ye;

// ../../node_modules/@livesession/design-system/dist/design-system.es5.js
import * as ReactDOM from "react-dom";
import ReactDOM__default, { findDOMNode as findDOMNode$1, render, unmountComponentAtNode } from "react-dom";
var StyledAlert = styled_components_esm_default.div`
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  word-wrap: break-word;
  border-radius: 2px;

  justify-content: center;
  text-align: center;

  &.error {
    background-color: rgba(230, 82, 90, 0.15) !important;
    min-height: 42px;
    display: flex;
    align-items: center;

    background-color: #fff2f0;
    border: 1px solid #ffccc7;
  }
`;
StyledAlert.displayName = "StyledAlert";
function Alert$1({ color = "default", children }) {
  return React.createElement(StyledAlert, { className: color }, children);
}
var Alert = Object.assign(Alert$1, {});
var dark100 = "#000";
var dark96 = "#2D2D2D";
var dark80 = "#5C5C5C";
var dark64 = "#808080";
var dark48 = "#a7a7a7";
var dark32 = "#d7d7d7";
var dark16 = "#ebebeb";
var dark8 = "#f8f8f8";
var dark4 = "#fafafa";
var white = "#FFF";
var blueDark = "#002F8D";
var blue100 = "#0446CA";
var blue48 = "#4F7DDA";
var blue24 = "#E4EDFF";
var purple100 = "#7051D4";
var purple64 = "#8765F9";
var purple24 = "#EAE3FF";
var green100 = "#0CB970";
var green64 = "#11DA94";
var green8 = "#EDFFF9";
var turquoise100 = "#97FFF2";
var yellowDark = "#EBB600";
var yellow100 = "#F8D047";
var yellow8 = "#FFF8E7";
var redDark = "#C1163F";
var red100 = "#D6204C";
var red48 = "#EE577C";
var red8 = "#FFEBF0";
var colors = {
  dark100,
  dark96,
  dark80,
  dark64,
  dark48,
  dark32,
  dark16,
  dark8,
  dark4,
  white,
  blueDark,
  blue100,
  blue48,
  blue24,
  purple100,
  purple64,
  purple24,
  green100,
  green64,
  green8,
  turquoise100,
  yellowDark,
  yellow100,
  yellow8,
  redDark,
  red100,
  red48,
  red8
};
var colors$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blue100,
  blue24,
  blue48,
  blueDark,
  dark100,
  dark16,
  dark32,
  dark4,
  dark48,
  dark64,
  dark8,
  dark80,
  dark96,
  "default": colors,
  green100,
  green64,
  green8,
  purple100,
  purple24,
  purple64,
  red100,
  red48,
  red8,
  redDark,
  turquoise100,
  white,
  yellow100,
  yellow8,
  yellowDark
});
var themeValues = {
  primaryColor: "#0446ca",
  primaryBorderColor: "#1561d1",
  defaultColor: "#20283b",
  darkColor: "#000",
  outlineDarkColor: "#404040",
  ghostColor: "#576871",
  smokedWhite: "#A7A7A7",
  disabledColor: "#bfbfbf",
  disabledHoverColor: "#dfdfe2",
  primaryContraColor: "#FFE478",
  warningColor: "#D6204C",
  primaryBackgroundColor: "#1f273a",
  defaultBackgroundColor: "#f1f3f5",
  ghostBackgroundColor: "#f8f9fa",
  modalShadeColor: "#122c5d5c",
  borderColor: "#dbe1e2",
  lightBorderColor: "#f0f2f4",
  inputTextColor: "#000",
  inputBorderColor: "#ebebeb",
  inputBackgroundColor: "#fafbfb",
  colors: colors$1,
  fontSize: {
    xsmall: "10.4px",
    small: "12px",
    normal: "13px",
    large: "14px",
    xlarge: "18px",
    xxlarge: "24px",
    xxxlarge: "28.8px"
  },
  inputSize: {
    large: "42px",
    medium: "36px",
    small: "28px"
  },
  iconSize: {
    xlarge: "24px",
    large: "20px",
    medium: "16px",
    small: "14px",
    xsmall: "12px"
  }
};
var mixins = {
  ellipsis: Ne`
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    `,
  rounded: Ne`
        border-radius: 4px;
    `,
  shadow: Ne`
        box-shadow: 0 1px 2px 0 rgba(0,0,0,.3);
    `,
  mainShadow: Ne`
        // box-shadow: 0 0 0 1px rgba(0,0,0,.05), 0 4px 7px 2px rgba(0,0,0,.05);
    `,
  boxShadow: Ne`
        box-shadow: 0 0 15px rgb(0 0 0 / 6%);
    `,
  inputShadow: Ne`
        box-shadow: 0 6px 8px rgba(102,119,136,.03), 0 1px 2px rgba(102,119,136,.3);
    `,
  primaryTextColor: Ne`
        color: ${themeValues.primaryColor};
    `,
  defaultTextColor: Ne`
        color: ${themeValues.defaultColor};
    `,
  ghostTextColor: Ne`
        color: ${themeValues.ghostColor};
    `,
  centerFlex: Ne`
        display: flex;
        align-items: center;
        justify-content: center;
    `,
  disabledInput: Ne`
        opacity: 0.75;
        background-color: #f0f3f6;
    `,
  focusedInput: Ne`
        border-color: #aaa;
        outline: 0;
    `,
  staticWidth: (width) => Ne`
        width: ${width};
        flex-basis: ${width};
        min-width: ${width};
        max-width: ${width};
    `
};
var StyledBadge = styled_components_esm_default.div`
  border: 1px solid ${themeValues.primaryColor};
  border-radius: 50px;
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  height: 18px;
  margin: 3px 4px;
  cursor: initial;

  .primary {
    border-color: ${themeValues.primaryColor};
  }
  
  .badge-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
StyledBadge.displayName = "StyledBadge";
function Badge$1({ color = "primary", children }) {
  return React.createElement(
    StyledBadge,
    { className: color },
    React.createElement("span", { className: "badge-text" }, children)
  );
}
var Badge = Object.assign(Badge$1, {});
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var classnames = { exports: {} };
(function(module) {
  (function() {
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = [];
      for (var i2 = 0; i2 < arguments.length; i2++) {
        var arg = arguments[i2];
        if (!arg)
          continue;
        var argType = typeof arg;
        if (argType === "string" || argType === "number") {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);
            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === "object") {
          if (arg.toString === Object.prototype.toString) {
            for (var key2 in arg) {
              if (hasOwn.call(arg, key2) && arg[key2]) {
                classes.push(key2);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }
      return classes.join(" ");
    }
    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
var cn = classnames.exports;
var IconComponent = styled_components_esm_default.i`
  display: inline-block;

  &.xlarge {
    width: ${themeValues.iconSize.xlarge};
    height: ${themeValues.iconSize.xlarge};
    &::before {
      font-size: ${themeValues.iconSize.xlarge};
    }
  }
  &.large {
    width: ${themeValues.iconSize.large};
    height: ${themeValues.iconSize.large};
    &::before {
      font-size: ${themeValues.iconSize.large};
    }
  }
  &.medium {
    width: ${themeValues.iconSize.medium};
    height: ${themeValues.iconSize.medium};
    &::before {
      font-size: ${themeValues.iconSize.medium};
    }
  }
  &.small {
    width: ${themeValues.iconSize.small};
    height: ${themeValues.iconSize.small};
    &::before {
      font-size: ${themeValues.iconSize.small};
    }
  }
  &.xsmall {
    width: ${themeValues.iconSize.xsmall};
    height: ${themeValues.iconSize.xsmall};
    &::before {
      font-size: ${themeValues.iconSize.xsmall};
    }
  }

  &::before {
    color: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
function Icon$2({ glyph, children, size = "medium", className }) {
  if (Number.isInteger(size)) {
    return React.createElement(IconComponent, { className: cn(glyph, className), style: { fontSize: size } }, children);
  }
  return React.createElement(IconComponent, { className: cn(glyph, size, className) }, children);
}
var StyledButton = styled_components_esm_default.button`
    ${mixins.rounded};
    ${mixins.centerFlex};
    flex-shrink: 0;

    color: white;
    cursor: pointer;
    transition: background-color 0.2s ease;
    font-weight: 500;
    border: 1px solid transparent;
    outline: 0;
    padding: 4px 8px;
    position: relative;

    .loader {
        display: none;
    }

    i {
        &.marginRight {
            margin-right: 8px;
        }
        &.marginLeft {
            margin-left: 8px;
        }
    }

    &:not(.iconOnly) {
        .content {
            &.has-icon {
                width: 100%;
            }

            .children {
                display: flex;
                align-items: center;
                justify-content: space-between;
                white-space: nowrap;
            }
        }
    }

    &.loading {
        .content {
            .children {
                opacity: 0;
            }
            .loader {
                display: flex;
                align-items: center;
                justify-content: center;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
            }
        }
    }

    &.danger {
        &.fill {
            background-color: ${themeValues.colors.red100};
            color: ${themeValues.colors.white};
        }

        &.outline {
            border: 1px solid;
            border-color: ${themeValues.colors.red100};
            background-color: transparent;
            color: ${themeValues.colors.red100};
        }

        &.ghost {
            background-color: transparent;
            color: ${themeValues.colors.red100};
        }
    }

    &.primary-revert {
        background-color: ${themeValues.colors.blue24};
        color: ${themeValues.colors.blue100};
        &.outline {
            border: 1px solid;
            border-color: ${themeValues.colors.blue24};
            background-color: transparent;
            color: ${themeValues.colors.blue100};
        }
        &.ghost {
            background-color: transparent;
            color: ${themeValues.colors.blue100};
        }
    }

    &.primary {
        &.fill {
            background-color: ${themeValues.colors.blue100};
            color: ${themeValues.colors.white};
        }

        &.outline {
            border: 1px solid;
            border-color: ${themeValues.colors.blue100};
            background-color: transparent;
            color: ${themeValues.colors.blue100};
        }

        &.ghost {
            background-color: transparent;
            color: ${themeValues.colors.blue100};
        }
    }

    &.secondary {
        color: ${themeValues.colors.dark100};

        &.fill {
            background-color: ${themeValues.colors.dark16};
        }

        &.outline {
            border: 1px solid;
            border-color: ${themeValues.colors.dark32};
            background-color: transparent;
        }

        &.ghost {
            background-color: transparent;
        }
    }

    &.small {
        height: ${themeValues.inputSize.small};
        min-width: ${themeValues.inputSize.small};
        font-size: ${themeValues.fontSize.normal};
        &.minWidth {
            min-width: 64px;
        }
    }

    &.medium {
        height: ${themeValues.inputSize.medium};
        min-width: ${themeValues.inputSize.medium};
        font-size: ${themeValues.fontSize.large};
        padding: 8px 16px;

        &.minWidth {
            min-width: 96px;
        }
    }

    &.large {
        height: ${themeValues.inputSize.large};
        min-width: ${themeValues.inputSize.large};
        font-size: ${themeValues.fontSize.large};
        padding: 8px 16px;

        &.minWidth {
            min-width: 128px;
        }
    }

    &[disabled] {
        cursor: not-allowed;

        &.primary,
        &.primary-revert {
            color: ${themeValues.colors.dark48};
            &.fill {
                background-color: ${themeValues.colors.dark16};
            }
            &.outline {
                border-color: ${themeValues.colors.dark16};
            }
            &.ghost {
            }
        }
        &.secondary,
        &.danger {
            color: ${themeValues.colors.dark48};
            &.fill {
                background-color: ${themeValues.colors.dark16};
            }
            &.outline {
                border-color: ${themeValues.colors.dark16};
            }
            &.ghost {
            }
        }
    }

    &:not([disabled]) {
        &:hover,
        &.hover {
            &.primary {
                &.fill {
                    background-color: ${themeValues.colors.blue48};
                }
                &.outline,
                &.ghost {
                    background-color: ${themeValues.colors.blue24};
                }
            }
            &.secondary {
                &.fill {
                    background-color: ${themeValues.colors.dark32};
                }
                &.outline,
                &.ghost {
                    background-color: ${themeValues.colors.dark16};
                }
            }
            &.primary-revert {
                &.fill {
                    background-color: white;
                    border-color: ${themeValues.colors.blue24};
                }
                &.outline,
                &.ghost {
                    background-color: ${themeValues.colors.blue24};
                }
            }
            &.danger {
                &.fill {
                    background-color: ${themeValues.colors.red48};
                }
                &.outline,
                &.ghost {
                    background-color: ${themeValues.colors.red48};
                }
            }
        }
        &:active,
        &.active {
            &.primary {
                &.fill {
                    background-color: ${themeValues.colors.blueDark};
                }
                &.outline,
                &.ghost {
                    background-color: ${themeValues.colors.blue24};
                }
            }
            &.secondary {
                &.fill {
                    background-color: ${themeValues.colors.dark48};
                }
                &.outline,
                &.ghost {
                    background-color: ${themeValues.colors.dark32};
                }
            }
            &.primary-revert {
                &.fill {
                    background-color: ${themeValues.colors.blue48};
                }
                &.outline,
                &.ghost {
                    background-color: ${themeValues.colors.blue24};
                }
            }
            &.danger {
                &.fill {
                    background-color: ${themeValues.colors.redDark};
                }
                &.outline,
                &.ghost {
                    background-color: ${themeValues.colors.redDark};
                }
            }
        }
    }

    &.fullwidth {
        width: 100%;
    }

    &.iconOnly {
        padding: 0;
    }
`;
StyledButton.displayName = "StyledButton";
function Button$3({ children, onClick, disabled, loadingLabel, loading, fullWidth, state, icon, iconAlign = "left", size = "medium", kind: btnKind = "primary", theme: btnTheme = "fill", style: style2, className, id: id2, ref }) {
  let kind = btnKind || "primary";
  let theme = btnTheme || "fill";
  let loadingText = loadingLabel || "Loading...";
  if (state == "loading")
    loading = true;
  const iconOnly = !children;
  const hasIcon = !!icon;
  const renderIcon = (align) => {
    if (icon) {
      if (React.isValidElement(icon)) {
        return icon;
      } else {
        return React.createElement(Icon$2, { size: size == "small" ? "xsmall" : "small", glyph: icon, className: cn({
          marginLeft: align == "right" && !!children,
          marginRight: align == "left" && !!children,
          disabled
        }) });
      }
    }
    return null;
  };
  return React.createElement(
    StyledButton,
    { id: id2, ref, onClick, disabled: disabled || loading, style: style2, className: cn(kind, theme, size, state, {
      fullwidth: fullWidth,
      loading,
      iconOnly
    }, className) },
    React.createElement("div", { className: cn("content", loading, { "has-icon": hasIcon }) }, loading ? React.createElement("span", { className: "loader" }, loadingText) : React.createElement(
      "span",
      { className: "children" },
      icon && iconAlign == "left" && renderIcon(iconAlign),
      children,
      icon && iconAlign == "right" && renderIcon(iconAlign)
    ))
  );
}
var Button$2 = Object.assign(Button$3, {});
function __rest$N(s2, e3) {
  var t3 = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
}
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function _defineProperty$4(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$2(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _setPrototypeOf$2(o2, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p2) {
    o3.__proto__ = p2;
    return o3;
  };
  return _setPrototypeOf$2(o2, p);
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf$2(subClass, superClass);
}
function _getPrototypeOf$2(o2) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$2(o2);
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e3) {
    return false;
  }
}
function _typeof$5(obj) {
  "@babel/helpers - typeof";
  return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$5(obj);
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn$1(self2, call2) {
  if (call2 && (_typeof$5(call2) === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self2);
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$2(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$2(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function ownKeys$3(object3, enumerableOnly) {
  var keys2 = Object.keys(object3);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object3);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object3, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread2$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$3(Object(source), true).forEach(function(key2) {
      _defineProperty$4(target, key2, source[key2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key2) {
      Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
    });
  }
  return target;
}
function omit$1(obj, fields) {
  var clone2 = _objectSpread2$1({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach(function(key2) {
      delete clone2[key2];
    });
  }
  return clone2;
}
var reactIs$1 = { exports: {} };
var reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b2 = "function" === typeof Symbol && Symbol.for, c2 = b2 ? Symbol.for("react.element") : 60103, d = b2 ? Symbol.for("react.portal") : 60106, e3 = b2 ? Symbol.for("react.fragment") : 60107, f3 = b2 ? Symbol.for("react.strict_mode") : 60108, g2 = b2 ? Symbol.for("react.profiler") : 60114, h = b2 ? Symbol.for("react.provider") : 60109, k2 = b2 ? Symbol.for("react.context") : 60110, l2 = b2 ? Symbol.for("react.async_mode") : 60111, m2 = b2 ? Symbol.for("react.concurrent_mode") : 60111, n3 = b2 ? Symbol.for("react.forward_ref") : 60112, p = b2 ? Symbol.for("react.suspense") : 60113, q2 = b2 ? Symbol.for("react.suspense_list") : 60120, r3 = b2 ? Symbol.for("react.memo") : 60115, t3 = b2 ? Symbol.for("react.lazy") : 60116, v2 = b2 ? Symbol.for("react.block") : 60121, w2 = b2 ? Symbol.for("react.fundamental") : 60117, x2 = b2 ? Symbol.for("react.responder") : 60118, y2 = b2 ? Symbol.for("react.scope") : 60119;
  function z2(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var u2 = a2.$$typeof;
      switch (u2) {
        case c2:
          switch (a2 = a2.type, a2) {
            case l2:
            case m2:
            case e3:
            case g2:
            case f3:
            case p:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k2:
                case n3:
                case t3:
                case r3:
                case h:
                  return a2;
                default:
                  return u2;
              }
          }
        case d:
          return u2;
      }
    }
  }
  function A2(a2) {
    return z2(a2) === m2;
  }
  reactIs_production_min.AsyncMode = l2;
  reactIs_production_min.ConcurrentMode = m2;
  reactIs_production_min.ContextConsumer = k2;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c2;
  reactIs_production_min.ForwardRef = n3;
  reactIs_production_min.Fragment = e3;
  reactIs_production_min.Lazy = t3;
  reactIs_production_min.Memo = r3;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g2;
  reactIs_production_min.StrictMode = f3;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a2) {
    return A2(a2) || z2(a2) === l2;
  };
  reactIs_production_min.isConcurrentMode = A2;
  reactIs_production_min.isContextConsumer = function(a2) {
    return z2(a2) === k2;
  };
  reactIs_production_min.isContextProvider = function(a2) {
    return z2(a2) === h;
  };
  reactIs_production_min.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === c2;
  };
  reactIs_production_min.isForwardRef = function(a2) {
    return z2(a2) === n3;
  };
  reactIs_production_min.isFragment = function(a2) {
    return z2(a2) === e3;
  };
  reactIs_production_min.isLazy = function(a2) {
    return z2(a2) === t3;
  };
  reactIs_production_min.isMemo = function(a2) {
    return z2(a2) === r3;
  };
  reactIs_production_min.isPortal = function(a2) {
    return z2(a2) === d;
  };
  reactIs_production_min.isProfiler = function(a2) {
    return z2(a2) === g2;
  };
  reactIs_production_min.isStrictMode = function(a2) {
    return z2(a2) === f3;
  };
  reactIs_production_min.isSuspense = function(a2) {
    return z2(a2) === p;
  };
  reactIs_production_min.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === e3 || a2 === m2 || a2 === g2 || a2 === f3 || a2 === p || a2 === q2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t3 || a2.$$typeof === r3 || a2.$$typeof === h || a2.$$typeof === k2 || a2.$$typeof === n3 || a2.$$typeof === w2 || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v2);
  };
  reactIs_production_min.typeOf = z2;
  return reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development)
    return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type2) {
        return typeof type2 === "string" || typeof type2 === "function" || type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object3) {
        if (typeof object3 === "object" && object3 !== null) {
          var $$typeof = object3.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type2 = object3.type;
              switch (type2) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element3 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object3) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object3) || typeOf(object3) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object3) {
        return typeOf(object3) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object3) {
        return typeOf(object3) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object3) {
        return typeOf(object3) === REACT_PROVIDER_TYPE;
      }
      function isElement(object3) {
        return typeof object3 === "object" && object3 !== null && object3.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object3) {
        return typeOf(object3) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object3) {
        return typeOf(object3) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object3) {
        return typeOf(object3) === REACT_LAZY_TYPE;
      }
      function isMemo(object3) {
        return typeOf(object3) === REACT_MEMO_TYPE;
      }
      function isPortal(object3) {
        return typeOf(object3) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object3) {
        return typeOf(object3) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object3) {
        return typeOf(object3) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object3) {
        return typeOf(object3) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element3;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal2;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
(function(module) {
  if (process.env.NODE_ENV === "production") {
    module.exports = requireReactIs_production_min();
  } else {
    module.exports = requireReactIs_development();
  }
})(reactIs$1);
function toArray$8(children) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var ret = [];
  React__default.Children.forEach(children, function(child) {
    if ((child === void 0 || child === null) && !option.keepEmpty) {
      return;
    }
    if (Array.isArray(child)) {
      ret = ret.concat(toArray$8(child));
    } else if (reactIs$1.exports.isFragment(child) && child.props) {
      ret = ret.concat(toArray$8(child.props.children, option));
    } else {
      ret.push(child);
    }
  });
  return ret;
}
var warned = {};
function warning$2(valid, message) {
  if (process.env.NODE_ENV !== "production" && !valid && console !== void 0) {
    console.error("Warning: ".concat(message));
  }
}
function note(valid, message) {
  if (process.env.NODE_ENV !== "production" && !valid && console !== void 0) {
    console.warn("Note: ".concat(message));
  }
}
function call(method3, valid, message) {
  if (!valid && !warned[message]) {
    method3(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning$2, valid, message);
}
function noteOnce(valid, message) {
  call(note, valid, message);
}
function useMemo2(getValue2, condition, shouldUpdate) {
  var cacheRef = React.useRef({});
  if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
    cacheRef.current.value = getValue2();
    cacheRef.current.condition = condition;
  }
  return cacheRef.current.value;
}
function fillRef(ref, node) {
  if (typeof ref === "function") {
    ref(node);
  } else if (_typeof$5(ref) === "object" && ref && "current" in ref) {
    ref.current = node;
  }
}
function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var refList = refs.filter(function(ref) {
    return ref;
  });
  if (refList.length <= 1) {
    return refList[0];
  }
  return function(node) {
    refs.forEach(function(ref) {
      fillRef(ref, node);
    });
  };
}
function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;
  var type2 = reactIs$1.exports.isMemo(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
  if (typeof type2 === "function" && !((_type$prototype = type2.prototype) === null || _type$prototype === void 0 ? void 0 : _type$prototype.render)) {
    return false;
  }
  if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) === null || _nodeOrComponent$prot === void 0 ? void 0 : _nodeOrComponent$prot.render)) {
    return false;
  }
  return true;
}
function findDOMNode2(node) {
  if (node instanceof HTMLElement) {
    return node;
  }
  return ReactDOM__default.findDOMNode(node);
}
var MapShim = function() {
  if (typeof Map !== "undefined") {
    return Map;
  }
  function getIndex(arr, key2) {
    var result = -1;
    arr.some(function(entry, index2) {
      if (entry[0] === key2) {
        result = index2;
        return true;
      }
      return false;
    });
    return result;
  }
  return function() {
    function class_1() {
      this.__entries__ = [];
    }
    Object.defineProperty(class_1.prototype, "size", {
      get: function() {
        return this.__entries__.length;
      },
      enumerable: true,
      configurable: true
    });
    class_1.prototype.get = function(key2) {
      var index2 = getIndex(this.__entries__, key2);
      var entry = this.__entries__[index2];
      return entry && entry[1];
    };
    class_1.prototype.set = function(key2, value) {
      var index2 = getIndex(this.__entries__, key2);
      if (~index2) {
        this.__entries__[index2][1] = value;
      } else {
        this.__entries__.push([key2, value]);
      }
    };
    class_1.prototype.delete = function(key2) {
      var entries = this.__entries__;
      var index2 = getIndex(entries, key2);
      if (~index2) {
        entries.splice(index2, 1);
      }
    };
    class_1.prototype.has = function(key2) {
      return !!~getIndex(this.__entries__, key2);
    };
    class_1.prototype.clear = function() {
      this.__entries__.splice(0);
    };
    class_1.prototype.forEach = function(callback, ctx) {
      if (ctx === void 0) {
        ctx = null;
      }
      for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
        var entry = _a[_i];
        callback.call(ctx, entry[1], entry[0]);
      }
    };
    return class_1;
  }();
}();
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var global$1 = function() {
  if (typeof global !== "undefined" && global.Math === Math) {
    return global;
  }
  if (typeof self !== "undefined" && self.Math === Math) {
    return self;
  }
  if (typeof window !== "undefined" && window.Math === Math) {
    return window;
  }
  return Function("return this")();
}();
var requestAnimationFrame$1 = function() {
  if (typeof requestAnimationFrame === "function") {
    return requestAnimationFrame.bind(global$1);
  }
  return function(callback) {
    return setTimeout(function() {
      return callback(Date.now());
    }, 1e3 / 60);
  };
}();
var trailingTimeout = 2;
function throttle(callback, delay) {
  var leadingCall = false, trailingCall = false, lastCallTime = 0;
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
var mutationObserverSupported = typeof MutationObserver !== "undefined";
var ResizeObserverController = function() {
  function ResizeObserverController2() {
    this.connected_ = false;
    this.mutationEventsAdded_ = false;
    this.mutationsObserver_ = null;
    this.observers_ = [];
    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
  }
  ResizeObserverController2.prototype.addObserver = function(observer) {
    if (!~this.observers_.indexOf(observer)) {
      this.observers_.push(observer);
    }
    if (!this.connected_) {
      this.connect_();
    }
  };
  ResizeObserverController2.prototype.removeObserver = function(observer) {
    var observers2 = this.observers_;
    var index2 = observers2.indexOf(observer);
    if (~index2) {
      observers2.splice(index2, 1);
    }
    if (!observers2.length && this.connected_) {
      this.disconnect_();
    }
  };
  ResizeObserverController2.prototype.refresh = function() {
    var changesDetected = this.updateObservers_();
    if (changesDetected) {
      this.refresh();
    }
  };
  ResizeObserverController2.prototype.updateObservers_ = function() {
    var activeObservers = this.observers_.filter(function(observer) {
      return observer.gatherActive(), observer.hasActive();
    });
    activeObservers.forEach(function(observer) {
      return observer.broadcastActive();
    });
    return activeObservers.length > 0;
  };
  ResizeObserverController2.prototype.connect_ = function() {
    if (!isBrowser || this.connected_) {
      return;
    }
    document.addEventListener("transitionend", this.onTransitionEnd_);
    window.addEventListener("resize", this.refresh);
    if (mutationObserverSupported) {
      this.mutationsObserver_ = new MutationObserver(this.refresh);
      this.mutationsObserver_.observe(document, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    } else {
      document.addEventListener("DOMSubtreeModified", this.refresh);
      this.mutationEventsAdded_ = true;
    }
    this.connected_ = true;
  };
  ResizeObserverController2.prototype.disconnect_ = function() {
    if (!isBrowser || !this.connected_) {
      return;
    }
    document.removeEventListener("transitionend", this.onTransitionEnd_);
    window.removeEventListener("resize", this.refresh);
    if (this.mutationsObserver_) {
      this.mutationsObserver_.disconnect();
    }
    if (this.mutationEventsAdded_) {
      document.removeEventListener("DOMSubtreeModified", this.refresh);
    }
    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
  };
  ResizeObserverController2.prototype.onTransitionEnd_ = function(_a) {
    var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
    var isReflowProperty = transitionKeys.some(function(key2) {
      return !!~propertyName.indexOf(key2);
    });
    if (isReflowProperty) {
      this.refresh();
    }
  };
  ResizeObserverController2.getInstance = function() {
    if (!this.instance_) {
      this.instance_ = new ResizeObserverController2();
    }
    return this.instance_;
  };
  ResizeObserverController2.instance_ = null;
  return ResizeObserverController2;
}();
var defineConfigurable = function(target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key2 = _a[_i];
    Object.defineProperty(target, key2, {
      value: props[key2],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};
var getWindowOf = function(target) {
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  return ownerGlobal || global$1;
};
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value) {
  return parseFloat(value) || 0;
}
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function(size, position) {
    var value = styles["border-" + position + "-width"];
    return size + toFloat(value);
  }, 0);
}
function getPaddings(styles) {
  var positions = ["top", "right", "bottom", "left"];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles["padding-" + position];
    paddings[position] = toFloat(value);
  }
  return paddings;
}
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
  var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  var width = toFloat(styles.width), height = toFloat(styles.height);
  if (styles.boxSizing === "border-box") {
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, "left", "right") + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, "top", "bottom") + vertPad;
    }
  }
  if (!isDocumentElement(target)) {
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
var isSVGGraphicsElement = function() {
  if (typeof SVGGraphicsElement !== "undefined") {
    return function(target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  return function(target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
  };
}();
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a) {
  var x2 = _a.x, y2 = _a.y, width = _a.width, height = _a.height;
  var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  defineConfigurable(rect, {
    x: x2,
    y: y2,
    width,
    height,
    top: y2,
    right: x2 + width,
    bottom: height + y2,
    left: x2
  });
  return rect;
}
function createRectInit(x2, y2, width, height) {
  return { x: x2, y: y2, width, height };
}
var ResizeObservation = function() {
  function ResizeObservation2(target) {
    this.broadcastWidth = 0;
    this.broadcastHeight = 0;
    this.contentRect_ = createRectInit(0, 0, 0, 0);
    this.target = target;
  }
  ResizeObservation2.prototype.isActive = function() {
    var rect = getContentRect(this.target);
    this.contentRect_ = rect;
    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
  };
  ResizeObservation2.prototype.broadcastRect = function() {
    var rect = this.contentRect_;
    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;
    return rect;
  };
  return ResizeObservation2;
}();
var ResizeObserverEntry = function() {
  function ResizeObserverEntry2(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);
    defineConfigurable(this, { target, contentRect });
  }
  return ResizeObserverEntry2;
}();
var ResizeObserverSPI = function() {
  function ResizeObserverSPI2(callback, controller, callbackCtx) {
    this.activeObservations_ = [];
    this.observations_ = new MapShim();
    if (typeof callback !== "function") {
      throw new TypeError("The callback provided as parameter 1 is not a function.");
    }
    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
  }
  ResizeObserverSPI2.prototype.observe = function(target) {
    if (!arguments.length) {
      throw new TypeError("1 argument required, but only 0 present.");
    }
    if (typeof Element === "undefined" || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    if (observations.has(target)) {
      return;
    }
    observations.set(target, new ResizeObservation(target));
    this.controller_.addObserver(this);
    this.controller_.refresh();
  };
  ResizeObserverSPI2.prototype.unobserve = function(target) {
    if (!arguments.length) {
      throw new TypeError("1 argument required, but only 0 present.");
    }
    if (typeof Element === "undefined" || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    if (!observations.has(target)) {
      return;
    }
    observations.delete(target);
    if (!observations.size) {
      this.controller_.removeObserver(this);
    }
  };
  ResizeObserverSPI2.prototype.disconnect = function() {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
  };
  ResizeObserverSPI2.prototype.gatherActive = function() {
    var _this2 = this;
    this.clearActive();
    this.observations_.forEach(function(observation) {
      if (observation.isActive()) {
        _this2.activeObservations_.push(observation);
      }
    });
  };
  ResizeObserverSPI2.prototype.broadcastActive = function() {
    if (!this.hasActive()) {
      return;
    }
    var ctx = this.callbackCtx_;
    var entries = this.activeObservations_.map(function(observation) {
      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });
    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
  };
  ResizeObserverSPI2.prototype.clearActive = function() {
    this.activeObservations_.splice(0);
  };
  ResizeObserverSPI2.prototype.hasActive = function() {
    return this.activeObservations_.length > 0;
  };
  return ResizeObserverSPI2;
}();
var observers = typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim();
var ResizeObserver$1 = function() {
  function ResizeObserver2(callback) {
    if (!(this instanceof ResizeObserver2)) {
      throw new TypeError("Cannot call a class as a function.");
    }
    if (!arguments.length) {
      throw new TypeError("1 argument required, but only 0 present.");
    }
    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);
    observers.set(this, observer);
  }
  return ResizeObserver2;
}();
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(method3) {
  ResizeObserver$1.prototype[method3] = function() {
    var _a;
    return (_a = observers.get(this))[method3].apply(_a, arguments);
  };
});
var index$1 = function() {
  if (typeof global$1.ResizeObserver !== "undefined") {
    return global$1.ResizeObserver;
  }
  return ResizeObserver$1;
}();
var elementListeners = /* @__PURE__ */ new Map();
function onResize(entities) {
  entities.forEach(function(entity) {
    var _elementListeners$get;
    var target = entity.target;
    (_elementListeners$get = elementListeners.get(target)) === null || _elementListeners$get === void 0 ? void 0 : _elementListeners$get.forEach(function(listener) {
      return listener(target);
    });
  });
}
var resizeObserver = new index$1(onResize);
process.env.NODE_ENV !== "production" ? elementListeners : null;
process.env.NODE_ENV !== "production" ? onResize : null;
function observe(element, callback) {
  if (!elementListeners.has(element)) {
    elementListeners.set(element, /* @__PURE__ */ new Set());
    resizeObserver.observe(element);
  }
  elementListeners.get(element).add(callback);
}
function unobserve(element, callback) {
  if (elementListeners.has(element)) {
    elementListeners.get(element).delete(callback);
    if (!elementListeners.get(element).size) {
      resizeObserver.unobserve(element);
      elementListeners.delete(element);
    }
  }
}
var DomWrapper$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(DomWrapper2, _React$Component);
  var _super = _createSuper$1(DomWrapper2);
  function DomWrapper2() {
    _classCallCheck$2(this, DomWrapper2);
    return _super.apply(this, arguments);
  }
  _createClass$2(DomWrapper2, [{
    key: "render",
    value: function render4() {
      return this.props.children;
    }
  }]);
  return DomWrapper2;
}(React.Component);
var CollectionContext = /* @__PURE__ */ React.createContext(null);
function Collection(_ref) {
  var children = _ref.children, onBatchResize = _ref.onBatchResize;
  var resizeIdRef = React.useRef(0);
  var resizeInfosRef = React.useRef([]);
  var onCollectionResize = React.useContext(CollectionContext);
  var onResize2 = React.useCallback(function(size, element, data) {
    resizeIdRef.current += 1;
    var currentId = resizeIdRef.current;
    resizeInfosRef.current.push({
      size,
      element,
      data
    });
    Promise.resolve().then(function() {
      if (currentId === resizeIdRef.current) {
        onBatchResize === null || onBatchResize === void 0 ? void 0 : onBatchResize(resizeInfosRef.current);
        resizeInfosRef.current = [];
      }
    });
    onCollectionResize === null || onCollectionResize === void 0 ? void 0 : onCollectionResize(size, element, data);
  }, [onBatchResize, onCollectionResize]);
  return /* @__PURE__ */ React.createElement(CollectionContext.Provider, {
    value: onResize2
  }, children);
}
function SingleObserver(props) {
  var children = props.children, disabled = props.disabled;
  var elementRef = React.useRef(null);
  var wrapperRef = React.useRef(null);
  var onCollectionResize = React.useContext(CollectionContext);
  var isRenderProps = typeof children === "function";
  var mergedChildren = isRenderProps ? children(elementRef) : children;
  var sizeRef = React.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  });
  var canRef = !isRenderProps && /* @__PURE__ */ React.isValidElement(mergedChildren) && supportRef(mergedChildren);
  var originRef = canRef ? mergedChildren.ref : null;
  var mergedRef = React.useMemo(function() {
    return composeRef(originRef, elementRef);
  }, [originRef, elementRef]);
  var propsRef = React.useRef(props);
  propsRef.current = props;
  var onInternalResize = React.useCallback(function(target) {
    var _propsRef$current = propsRef.current, onResize2 = _propsRef$current.onResize, data = _propsRef$current.data;
    var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
    var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);
    if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
      var size = {
        width: fixedWidth,
        height: fixedHeight,
        offsetWidth,
        offsetHeight
      };
      sizeRef.current = size;
      var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
      var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
      var sizeInfo = _objectSpread2$1(_objectSpread2$1({}, size), {}, {
        offsetWidth: mergedOffsetWidth,
        offsetHeight: mergedOffsetHeight
      });
      onCollectionResize === null || onCollectionResize === void 0 ? void 0 : onCollectionResize(sizeInfo, target, data);
      if (onResize2) {
        Promise.resolve().then(function() {
          onResize2(sizeInfo, target);
        });
      }
    }
  }, []);
  React.useEffect(function() {
    var currentElement = findDOMNode2(elementRef.current) || findDOMNode2(wrapperRef.current);
    if (currentElement && !disabled) {
      observe(currentElement, onInternalResize);
    }
    return function() {
      return unobserve(currentElement, onInternalResize);
    };
  }, [elementRef.current, disabled]);
  return /* @__PURE__ */ React.createElement(DomWrapper$1, {
    ref: wrapperRef
  }, canRef ? /* @__PURE__ */ React.cloneElement(mergedChildren, {
    ref: mergedRef
  }) : mergedChildren);
}
var INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver(props) {
  var children = props.children;
  var childNodes = typeof children === "function" ? [children] : toArray$8(children);
  if (process.env.NODE_ENV !== "production") {
    if (childNodes.length > 1) {
      warning$2(false, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.");
    } else if (childNodes.length === 0) {
      warning$2(false, "`children` of ResizeObserver is empty. Nothing is in observe.");
    }
  }
  return childNodes.map(function(child, index2) {
    var key2 = (child === null || child === void 0 ? void 0 : child.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(index2);
    return /* @__PURE__ */ React.createElement(SingleObserver, _extends$2({}, props, {
      key: key2
    }), child);
  });
}
ResizeObserver.Collection = Collection;
var IconContext = /* @__PURE__ */ createContext2({});
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key2 = sourceKeys[i2];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key2, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key2 = sourceSymbolKeys[i2];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$3(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _unsupportedIterableToArray$3(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$3(o2, minLen);
  var n3 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n3 === "Object" && o2.constructor)
    n3 = o2.constructor.name;
  if (n3 === "Map" || n3 === "Set")
    return Array.from(o2);
  if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3))
    return _arrayLikeToArray$3(o2, minLen);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableSpread();
}
var HOOK_MARK = "RC_FORM_INTERNAL_HOOKS";
var warningFunc = function warningFunc2() {
  warningOnce(false, "Can not find FormContext. Please make sure you wrap Field under Form.");
};
var Context = /* @__PURE__ */ React.createContext({
  getFieldValue: warningFunc,
  getFieldsValue: warningFunc,
  getFieldError: warningFunc,
  getFieldsError: warningFunc,
  isFieldsTouched: warningFunc,
  isFieldTouched: warningFunc,
  isFieldValidating: warningFunc,
  isFieldsValidating: warningFunc,
  resetFields: warningFunc,
  setFields: warningFunc,
  setFieldsValue: warningFunc,
  validateFields: warningFunc,
  submit: warningFunc,
  getInternalHooks: function getInternalHooks() {
    warningFunc();
    return {
      dispatch: warningFunc,
      initEntityValue: warningFunc,
      registerField: warningFunc,
      useSubscribe: warningFunc,
      setInitialValues: warningFunc,
      setCallbacks: warningFunc,
      getFields: warningFunc,
      setValidateMessages: warningFunc,
      setPreserve: warningFunc
    };
  }
});
function toArray$7(value) {
  if (value === void 0 || value === null) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}
var regeneratorRuntime$1 = { exports: {} };
var _typeof$4 = { exports: {} };
(function(module) {
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    return module.exports = _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
      return typeof obj2;
    } : function(obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof2(obj);
  }
  module.exports = _typeof2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(_typeof$4);
(function(module) {
  var _typeof2 = _typeof$4.exports["default"];
  function _regeneratorRuntime2() {
    module.exports = _regeneratorRuntime2 = function _regeneratorRuntime3() {
      return exports;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define2(obj, key2, value) {
      return Object.defineProperty(obj, key2, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      }), obj[key2];
    }
    try {
      define2({}, "");
    } catch (err) {
      define2 = function define3(obj, key2, value) {
        return obj[key2] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator2 = Object.create(protoGenerator.prototype), context2 = new Context2(tryLocsList || []);
      return generator2._invoke = function(innerFn2, self3, context3) {
        var state = "suspendedStart";
        return function(method3, arg) {
          if ("executing" === state)
            throw new Error("Generator is already running");
          if ("completed" === state) {
            if ("throw" === method3)
              throw arg;
            return doneResult();
          }
          for (context3.method = method3, context3.arg = arg; ; ) {
            var delegate = context3.delegate;
            if (delegate) {
              var delegateResult = maybeInvokeDelegate(delegate, context3);
              if (delegateResult) {
                if (delegateResult === ContinueSentinel)
                  continue;
                return delegateResult;
              }
            }
            if ("next" === context3.method)
              context3.sent = context3._sent = context3.arg;
            else if ("throw" === context3.method) {
              if ("suspendedStart" === state)
                throw state = "completed", context3.arg;
              context3.dispatchException(context3.arg);
            } else
              "return" === context3.method && context3.abrupt("return", context3.arg);
            state = "executing";
            var record = tryCatch(innerFn2, self3, context3);
            if ("normal" === record.type) {
              if (state = context3.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel)
                continue;
              return {
                value: record.arg,
                done: context3.done
              };
            }
            "throw" === record.type && (state = "completed", context3.method = "throw", context3.arg = record.arg);
          }
        };
      }(innerFn, self2, context2), generator2;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {
    }
    function GeneratorFunction() {
    }
    function GeneratorFunctionPrototype() {
    }
    var IteratorPrototype = {};
    define2(IteratorPrototype, iteratorSymbol, function() {
      return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function(method3) {
        define2(prototype, method3, function(arg) {
          return this._invoke(method3, arg);
        });
      });
    }
    function AsyncIterator(generator2, PromiseImpl) {
      function invoke(method3, arg, resolve, reject) {
        var record = tryCatch(generator2[method3], generator2, arg);
        if ("throw" !== record.type) {
          var result = record.arg, value = result.value;
          return value && "object" == _typeof2(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value2) {
            invoke("next", value2, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function(unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function(error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      this._invoke = function(method3, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function(resolve, reject) {
            invoke(method3, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      };
    }
    function maybeInvokeDelegate(delegate, context2) {
      var method3 = delegate.iterator[context2.method];
      if (void 0 === method3) {
        if (context2.delegate = null, "throw" === context2.method) {
          if (delegate.iterator["return"] && (context2.method = "return", context2.arg = void 0, maybeInvokeDelegate(delegate, context2), "throw" === context2.method))
            return ContinueSentinel;
          context2.method = "throw", context2.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return ContinueSentinel;
      }
      var record = tryCatch(method3, delegate.iterator, context2.arg);
      if ("throw" === record.type)
        return context2.method = "throw", context2.arg = record.arg, context2.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context2[delegate.resultName] = info.value, context2.next = delegate.nextLoc, "return" !== context2.method && (context2.method = "next", context2.arg = void 0), context2.delegate = null, ContinueSentinel) : info : (context2.method = "throw", context2.arg = new TypeError("iterator result is not an object"), context2.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context2(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod)
          return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next)
          return iterable;
        if (!isNaN(iterable.length)) {
          var i2 = -1, next = function next2() {
            for (; ++i2 < iterable.length; ) {
              if (hasOwn.call(iterable, i2))
                return next2.value = iterable[i2], next2.done = false, next2;
            }
            return next2.value = void 0, next2.done = true, next2;
          };
          return next.next = next;
        }
      }
      return {
        next: doneResult
      };
    }
    function doneResult() {
      return {
        value: void 0,
        done: true
      };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define2(Gp, "constructor", GeneratorFunctionPrototype), define2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define2(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define2(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define2(AsyncIterator.prototype, asyncIteratorSymbol, function() {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define2(Gp, toStringTagSymbol, "Generator"), define2(Gp, iteratorSymbol, function() {
      return this;
    }), define2(Gp, "toString", function() {
      return "[object Generator]";
    }), exports.keys = function(object3) {
      var keys2 = [];
      for (var key2 in object3) {
        keys2.push(key2);
      }
      return keys2.reverse(), function next() {
        for (; keys2.length; ) {
          var key3 = keys2.pop();
          if (key3 in object3)
            return next.value = key3, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, exports.values = values, Context2.prototype = {
      constructor: Context2,
      reset: function reset(skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset)
          for (var name in this) {
            "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
          }
      },
      stop: function stop() {
        this.done = true;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type)
          throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done)
          throw exception;
        var context2 = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context2.next = loc, caught && (context2.method = "next", context2.arg = void 0), !!caught;
        }
        for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
          var entry = this.tryEntries[i2], record = entry.completion;
          if ("root" === entry.tryLoc)
            return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc)
                return handle(entry.catchLoc, true);
              if (this.prev < entry.finallyLoc)
                return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc)
                return handle(entry.catchLoc, true);
            } else {
              if (!hasFinally)
                throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc)
                return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(type2, arg) {
        for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
          var entry = this.tryEntries[i2];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type2 || "continue" === type2) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type2, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if ("throw" === record.type)
          throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
          var entry = this.tryEntries[i2];
          if (entry.finallyLoc === finallyLoc)
            return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
          var entry = this.tryEntries[i2];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName,
          nextLoc
        }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
      }
    }, exports;
  }
  module.exports = _regeneratorRuntime2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(regeneratorRuntime$1);
var runtime = regeneratorRuntime$1.exports();
var regenerator = runtime;
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key2, arg) {
  try {
    var info = gen[key2](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
function _extends$1() {
  _extends$1 = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}
function _getPrototypeOf$1(o2) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$1(o2);
}
function _setPrototypeOf$1(o2, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf2(o3, p2) {
    o3.__proto__ = p2;
    return o3;
  };
  return _setPrototypeOf$1(o2, p);
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e3) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct$1()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a2 = [null];
      a2.push.apply(a2, args2);
      var Constructor = Function.bind.apply(Parent2, a2);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf$1(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper2);
    }
    function Wrapper2() {
      return _construct(Class2, arguments, _getPrototypeOf$1(this).constructor);
    }
    Wrapper2.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper2,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$1(Wrapper2, Class2);
  };
  return _wrapNativeSuper(Class);
}
var formatRegExp = /%[sdj%]/g;
var warning$1 = function warning() {
};
if (typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production" && typeof window !== "undefined" && typeof document !== "undefined") {
  warning$1 = function warning3(type2, errors) {
    if (typeof console !== "undefined" && console.warn) {
      if (errors.every(function(e3) {
        return typeof e3 === "string";
      })) {
        console.warn(type2, errors);
      }
    }
  };
}
function convertFieldsError(errors) {
  if (!errors || !errors.length)
    return null;
  var fields = {};
  errors.forEach(function(error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}
function format$1() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var i2 = 1;
  var f3 = args[0];
  var len = args.length;
  if (typeof f3 === "function") {
    return f3.apply(null, args.slice(1));
  }
  if (typeof f3 === "string") {
    var str = String(f3).replace(formatRegExp, function(x2) {
      if (x2 === "%%") {
        return "%";
      }
      if (i2 >= len) {
        return x2;
      }
      switch (x2) {
        case "%s":
          return String(args[i2++]);
        case "%d":
          return Number(args[i2++]);
        case "%j":
          try {
            return JSON.stringify(args[i2++]);
          } catch (_2) {
            return "[Circular]";
          }
          break;
        default:
          return x2;
      }
    });
    return str;
  }
  return f3;
}
function isNativeStringType(type2) {
  return type2 === "string" || type2 === "url" || type2 === "hex" || type2 === "email" || type2 === "date" || type2 === "pattern";
}
function isEmptyValue(value, type2) {
  if (value === void 0 || value === null) {
    return true;
  }
  if (type2 === "array" && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type2) && typeof value === "string" && !value) {
    return true;
  }
  return false;
}
function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;
  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }
  arr.forEach(function(a2) {
    func(a2, count);
  });
}
function asyncSerialArray(arr, func, callback) {
  var index2 = 0;
  var arrLength = arr.length;
  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index2;
    index2 = index2 + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }
  next([]);
}
function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function(k2) {
    ret.push.apply(ret, objArr[k2]);
  });
  return ret;
}
var AsyncValidationError = /* @__PURE__ */ function(_Error) {
  _inheritsLoose(AsyncValidationError2, _Error);
  function AsyncValidationError2(errors, fields) {
    var _this2;
    _this2 = _Error.call(this, "Async Validation Error") || this;
    _this2.errors = errors;
    _this2.fields = fields;
    return _this2;
  }
  return AsyncValidationError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var _pending = new Promise(function(resolve, reject) {
      var next = function next2(errors) {
        callback(errors);
        return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve();
      };
      var flattenArr = flattenObjArr(objArr);
      asyncSerialArray(flattenArr, func, next);
    });
    _pending["catch"](function(e3) {
      return e3;
    });
    return _pending;
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function(resolve, reject) {
    var next = function next2(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve();
      }
    };
    if (!objArrKeys.length) {
      callback(results);
      resolve();
    }
    objArrKeys.forEach(function(key2) {
      var arr = objArr[key2];
      if (firstFields.indexOf(key2) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending["catch"](function(e3) {
    return e3;
  });
  return pending;
}
function complementError(rule) {
  return function(oe2) {
    if (oe2 && oe2.message) {
      oe2.field = oe2.field || rule.fullField;
      return oe2;
    }
    return {
      message: typeof oe2 === "function" ? oe2() : oe2,
      field: oe2.field || rule.fullField
    };
  };
}
function deepMerge(target, source) {
  if (source) {
    for (var s2 in source) {
      if (source.hasOwnProperty(s2)) {
        var value = source[s2];
        if (typeof value === "object" && typeof target[s2] === "object") {
          target[s2] = _extends$1({}, target[s2], value);
        } else {
          target[s2] = value;
        }
      }
    }
  }
  return target;
}
function required(rule, value, source, errors, options, type2) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value, type2 || rule.type))) {
    errors.push(format$1(options.messages.required, rule.fullField));
  }
}
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === "") {
    errors.push(format$1(options.messages.whitespace, rule.fullField));
  }
}
var pattern = {
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp("^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$", "i"),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  "float": function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e3) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === "function" && typeof value.getMonth === "function" && typeof value.getYear === "function" && !isNaN(value.getTime());
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === "number";
  },
  object: function object(value) {
    return typeof value === "object" && !types.array(value);
  },
  method: function method(value) {
    return typeof value === "function";
  },
  email: function email(value) {
    return typeof value === "string" && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === "string" && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === "string" && !!value.match(pattern.hex);
  }
};
function type(rule, value, source, errors, options) {
  if (rule.required && value === void 0) {
    required(rule, value, source, errors, options);
    return;
  }
  var custom = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(format$1(options.messages.types[ruleType], rule.fullField, rule.type));
    }
  } else if (ruleType && typeof value !== rule.type) {
    errors.push(format$1(options.messages.types[ruleType], rule.fullField, rule.type));
  }
}
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === "number";
  var min = typeof rule.min === "number";
  var max = typeof rule.max === "number";
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key2 = null;
  var num = typeof value === "number";
  var str = typeof value === "string";
  var arr = Array.isArray(value);
  if (num) {
    key2 = "number";
  } else if (str) {
    key2 = "string";
  } else if (arr) {
    key2 = "array";
  }
  if (!key2) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    val = value.replace(spRegexp, "_").length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(format$1(options.messages[key2].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(format$1(options.messages[key2].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(format$1(options.messages[key2].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(format$1(options.messages[key2].range, rule.fullField, rule.min, rule.max));
  }
}
var ENUM = "enum";
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(format$1(options.messages[ENUM], rule.fullField, rule[ENUM].join(", ")));
  }
}
function pattern$1(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(format$1(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === "string") {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(format$1(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}
var rules = {
  required,
  whitespace,
  type,
  range,
  "enum": enumerable,
  pattern: pattern$1
};
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, "string");
    if (!isEmptyValue(value, "string")) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
      rules.pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        rules.whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}
function method2(rule, value, callback, source, options) {
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}
function number2(rule, value, callback, source, options) {
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if (value === "") {
      value = void 0;
    }
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}
function _boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}
function regexp2(rule, value, callback, source, options) {
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value)) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}
function integer2(rule, value, callback, source, options) {
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}
function array2(rule, value, callback, source, options) {
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if ((value === void 0 || value === null) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, "array");
    if (value !== void 0 && value !== null) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}
function object2(rule, value, callback, source, options) {
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}
var ENUM$1 = "enum";
function enumerable$1(rule, value, callback, source, options) {
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules[ENUM$1](rule, value, source, errors, options);
    }
  }
  callback(errors);
}
function pattern$2(rule, value, callback, source, options) {
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "string")) {
      rules.pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}
function date2(rule, value, callback, source, options) {
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if (isEmptyValue(value, "date") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "date")) {
      var dateObject;
      if (value instanceof Date) {
        dateObject = value;
      } else {
        dateObject = new Date(value);
      }
      rules.type(rule, dateObject, source, errors, options);
      if (dateObject) {
        rules.range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}
function required$1(rule, value, callback, source, options) {
  var errors = [];
  var type2 = Array.isArray(value) ? "array" : typeof value;
  rules.required(rule, value, source, errors, options, type2);
  callback(errors);
}
function type$1(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if (isEmptyValue(value, ruleType) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, ruleType);
    if (!isEmptyValue(value, ruleType)) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}
function any(rule, value, callback, source, options) {
  var errors = [];
  var validate3 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate3) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
  }
  callback(errors);
}
var validators = {
  string,
  method: method2,
  number: number2,
  "boolean": _boolean,
  regexp: regexp2,
  integer: integer2,
  "float": floatFn,
  array: array2,
  object: object2,
  "enum": enumerable$1,
  pattern: pattern$2,
  date: date2,
  url: type$1,
  hex: type$1,
  email: type$1,
  required: required$1,
  any
};
function newMessages() {
  return {
    "default": "Validation error on field %s",
    required: "%s is required",
    "enum": "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      "boolean": "%s is not a %s",
      integer: "%s is not an %s",
      "float": "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function clone2() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}
var messages = newMessages();
function Schema(descriptor) {
  this.rules = null;
  this._messages = messages;
  this.define(descriptor);
}
Schema.prototype = {
  messages: function messages2(_messages) {
    if (_messages) {
      this._messages = deepMerge(newMessages(), _messages);
    }
    return this._messages;
  },
  define: function define(rules2) {
    if (!rules2) {
      throw new Error("Cannot configure a schema with no rules");
    }
    if (typeof rules2 !== "object" || Array.isArray(rules2)) {
      throw new Error("Rules must be an object");
    }
    this.rules = {};
    var z2;
    var item;
    for (z2 in rules2) {
      if (rules2.hasOwnProperty(z2)) {
        item = rules2[z2];
        this.rules[z2] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_, o2, oc) {
    var _this2 = this;
    if (o2 === void 0) {
      o2 = {};
    }
    if (oc === void 0) {
      oc = function oc2() {
      };
    }
    var source = source_;
    var options = o2;
    var callback = oc;
    if (typeof options === "function") {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return Promise.resolve();
    }
    function complete(results) {
      var i2;
      var errors = [];
      var fields = {};
      function add(e3) {
        if (Array.isArray(e3)) {
          var _errors;
          errors = (_errors = errors).concat.apply(_errors, e3);
        } else {
          errors.push(e3);
        }
      }
      for (i2 = 0; i2 < results.length; i2++) {
        add(results[i2]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        fields = convertFieldsError(errors);
      }
      callback(errors, fields);
    }
    if (options.messages) {
      var messages$1 = this.messages();
      if (messages$1 === messages) {
        messages$1 = newMessages();
      }
      deepMerge(messages$1, options.messages);
      options.messages = messages$1;
    } else {
      options.messages = this.messages();
    }
    var arr;
    var value;
    var series = {};
    var keys2 = options.keys || Object.keys(this.rules);
    keys2.forEach(function(z2) {
      arr = _this2.rules[z2];
      value = source[z2];
      arr.forEach(function(r3) {
        var rule = r3;
        if (typeof rule.transform === "function") {
          if (source === source_) {
            source = _extends$1({}, source);
          }
          value = source[z2] = rule.transform(value);
        }
        if (typeof rule === "function") {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends$1({}, rule);
        }
        rule.validator = _this2.getValidationMethod(rule);
        rule.field = z2;
        rule.fullField = rule.fullField || z2;
        rule.type = _this2.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z2] = series[z2] || [];
        series[z2].push({
          rule,
          value,
          source,
          field: z2
        });
      });
    });
    var errorFields = {};
    return asyncMap(series, options, function(data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === "object" || rule.type === "array") && (typeof rule.fields === "object" || typeof rule.defaultField === "object");
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;
      function addFullfield(key2, schema) {
        return _extends$1({}, schema, {
          fullField: rule.fullField + "." + key2
        });
      }
      function cb(e3) {
        if (e3 === void 0) {
          e3 = [];
        }
        var errors = e3;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (!options.suppressWarning && errors.length) {
          Schema.warning("async-validator:", errors);
        }
        if (errors.length && rule.message !== void 0) {
          errors = [].concat(rule.message);
        }
        errors = errors.map(complementError(rule));
        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          if (rule.required && !data.value) {
            if (rule.message !== void 0) {
              errors = [].concat(rule.message).map(complementError(rule));
            } else if (options.error) {
              errors = [options.error(rule, format$1(options.messages.required, rule.field))];
            }
            return doIt(errors);
          }
          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k2 in data.value) {
              if (data.value.hasOwnProperty(k2)) {
                fieldsSchema[k2] = rule.defaultField;
              }
            }
          }
          fieldsSchema = _extends$1({}, fieldsSchema, data.rule.fields);
          for (var f3 in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f3)) {
              var fieldSchema = Array.isArray(fieldsSchema[f3]) ? fieldsSchema[f3] : [fieldsSchema[f3]];
              fieldsSchema[f3] = fieldSchema.map(addFullfield.bind(null, f3));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function(errs) {
            var finalErrors = [];
            if (errors && errors.length) {
              finalErrors.push.apply(finalErrors, errors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }
      var res;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        res = rule.validator(rule, data.value, cb, data.source, options);
        if (res === true) {
          cb();
        } else if (res === false) {
          cb(rule.message || rule.field + " fails");
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }
      if (res && res.then) {
        res.then(function() {
          return cb();
        }, function(e3) {
          return cb(e3);
        });
      }
    }, function(results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === void 0 && rule.pattern instanceof RegExp) {
      rule.type = "pattern";
    }
    if (typeof rule.validator !== "function" && rule.type && !validators.hasOwnProperty(rule.type)) {
      throw new Error(format$1("Unknown rule type %s", rule.type));
    }
    return rule.type || "string";
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === "function") {
      return rule.validator;
    }
    var keys2 = Object.keys(rule);
    var messageIndex = keys2.indexOf("message");
    if (messageIndex !== -1) {
      keys2.splice(messageIndex, 1);
    }
    if (keys2.length === 1 && keys2[0] === "required") {
      return validators.required;
    }
    return validators[this.getType(rule)] || false;
  }
};
Schema.register = function register(type2, validator) {
  if (typeof validator !== "function") {
    throw new Error("Cannot register a validator by type, validator is not a function");
  }
  validators[type2] = validator;
};
Schema.warning = warning$1;
Schema.messages = messages;
Schema.validators = validators;
function get(entity, path2) {
  var current = entity;
  for (var i2 = 0; i2 < path2.length; i2 += 1) {
    if (current === null || current === void 0) {
      return void 0;
    }
    current = current[path2[i2]];
  }
  return current;
}
function _arrayWithHoles$3(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _nonIterableRest$3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toArray(arr) {
  return _arrayWithHoles$3(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableRest$3();
}
function internalSet(entity, paths, value, removeIfUndefined) {
  if (!paths.length) {
    return value;
  }
  var _paths = _toArray(paths), path2 = _paths[0], restPath = _paths.slice(1);
  var clone2;
  if (!entity && typeof path2 === "number") {
    clone2 = [];
  } else if (Array.isArray(entity)) {
    clone2 = _toConsumableArray(entity);
  } else {
    clone2 = _objectSpread2$1({}, entity);
  }
  if (removeIfUndefined && value === void 0 && restPath.length === 1) {
    delete clone2[path2][restPath[0]];
  } else {
    clone2[path2] = internalSet(clone2[path2], restPath, value, removeIfUndefined);
  }
  return clone2;
}
function set(entity, paths, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  if (paths.length && removeIfUndefined && value === void 0 && !get(entity, paths.slice(0, -1))) {
    return entity;
  }
  return internalSet(entity, paths, value, removeIfUndefined);
}
function getNamePath(path2) {
  return toArray$7(path2);
}
function getValue$4(store, namePath) {
  var value = get(store, namePath);
  return value;
}
function setValue(store, namePath, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  var newStore = set(store, namePath, value, removeIfUndefined);
  return newStore;
}
function cloneByNamePathList(store, namePathList) {
  var newStore = {};
  namePathList.forEach(function(namePath) {
    var value = getValue$4(store, namePath);
    newStore = setValue(newStore, namePath, value);
  });
  return newStore;
}
function containsNamePath(namePathList, namePath) {
  return namePathList && namePathList.some(function(path2) {
    return matchNamePath(path2, namePath);
  });
}
function isObject$5(obj) {
  return _typeof$5(obj) === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function internalSetValues(store, values) {
  var newStore = Array.isArray(store) ? _toConsumableArray(store) : _objectSpread2$1({}, store);
  if (!values) {
    return newStore;
  }
  Object.keys(values).forEach(function(key2) {
    var prevValue = newStore[key2];
    var value = values[key2];
    var recursive = isObject$5(prevValue) && isObject$5(value);
    newStore[key2] = recursive ? internalSetValues(prevValue, value || {}) : value;
  });
  return newStore;
}
function setValues(store) {
  for (var _len = arguments.length, restValues = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    restValues[_key - 1] = arguments[_key];
  }
  return restValues.reduce(function(current, newStore) {
    return internalSetValues(current, newStore);
  }, store);
}
function matchNamePath(namePath, changedNamePath) {
  if (!namePath || !changedNamePath || namePath.length !== changedNamePath.length) {
    return false;
  }
  return namePath.every(function(nameUnit, i2) {
    return changedNamePath[i2] === nameUnit;
  });
}
function isSimilar(source, target) {
  if (source === target) {
    return true;
  }
  if (!source && target || source && !target) {
    return false;
  }
  if (!source || !target || _typeof$5(source) !== "object" || _typeof$5(target) !== "object") {
    return false;
  }
  var sourceKeys = Object.keys(source);
  var targetKeys = Object.keys(target);
  var keys2 = new Set([].concat(_toConsumableArray(sourceKeys), _toConsumableArray(targetKeys)));
  return _toConsumableArray(keys2).every(function(key2) {
    var sourceValue = source[key2];
    var targetValue = target[key2];
    if (typeof sourceValue === "function" && typeof targetValue === "function") {
      return true;
    }
    return sourceValue === targetValue;
  });
}
function defaultGetValueFromEvent(valuePropName) {
  var event = arguments.length <= 1 ? void 0 : arguments[1];
  if (event && event.target && valuePropName in event.target) {
    return event.target[valuePropName];
  }
  return event;
}
function move(array3, moveIndex, toIndex) {
  var length = array3.length;
  if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) {
    return array3;
  }
  var item = array3[moveIndex];
  var diff = moveIndex - toIndex;
  if (diff > 0) {
    return [].concat(_toConsumableArray(array3.slice(0, toIndex)), [item], _toConsumableArray(array3.slice(toIndex, moveIndex)), _toConsumableArray(array3.slice(moveIndex + 1, length)));
  }
  if (diff < 0) {
    return [].concat(_toConsumableArray(array3.slice(0, moveIndex)), _toConsumableArray(array3.slice(moveIndex + 1, toIndex + 1)), [item], _toConsumableArray(array3.slice(toIndex + 1, length)));
  }
  return array3;
}
var typeTemplate$1 = "'${name}' is not a valid ${type}";
var defaultValidateMessages = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: typeTemplate$1,
    method: typeTemplate$1,
    array: typeTemplate$1,
    object: typeTemplate$1,
    number: typeTemplate$1,
    date: typeTemplate$1,
    boolean: typeTemplate$1,
    integer: typeTemplate$1,
    float: typeTemplate$1,
    regexp: typeTemplate$1,
    email: typeTemplate$1,
    url: typeTemplate$1,
    hex: typeTemplate$1
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
};
var AsyncValidator = Schema;
function replaceMessage(template, kv) {
  return template.replace(/\$\{\w+\}/g, function(str) {
    var key2 = str.slice(2, -1);
    return kv[key2];
  });
}
function convertMessages(messages3, name, rule, messageVariables) {
  var kv = _objectSpread2$1(_objectSpread2$1({}, rule), {}, {
    name,
    enum: (rule.enum || []).join(", ")
  });
  var replaceFunc = function replaceFunc2(template, additionalKV) {
    return function() {
      return replaceMessage(template, _objectSpread2$1(_objectSpread2$1({}, kv), additionalKV));
    };
  };
  function fillTemplate(source) {
    var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Object.keys(source).forEach(function(ruleName) {
      var value = source[ruleName];
      if (typeof value === "string") {
        target[ruleName] = replaceFunc(value, messageVariables);
      } else if (value && _typeof$5(value) === "object") {
        target[ruleName] = {};
        fillTemplate(value, target[ruleName]);
      } else {
        target[ruleName] = value;
      }
    });
    return target;
  }
  return fillTemplate(setValues({}, defaultValidateMessages, messages3));
}
function validateRule(_x, _x2, _x3, _x4, _x5) {
  return _validateRule.apply(this, arguments);
}
function _validateRule() {
  _validateRule = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee2(name, value, rule, options, messageVariables) {
    var cloneRule, subRuleField, validator, messages3, result, subResults;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cloneRule = _objectSpread2$1({}, rule);
            subRuleField = null;
            if (cloneRule && cloneRule.type === "array" && cloneRule.defaultField) {
              subRuleField = cloneRule.defaultField;
              delete cloneRule.defaultField;
            }
            validator = new AsyncValidator(_defineProperty$4({}, name, [cloneRule]));
            messages3 = convertMessages(options.validateMessages, name, cloneRule, messageVariables);
            validator.messages(messages3);
            result = [];
            _context2.prev = 7;
            _context2.next = 10;
            return Promise.resolve(validator.validate(_defineProperty$4({}, name, value), _objectSpread2$1({}, options)));
          case 10:
            _context2.next = 15;
            break;
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](7);
            if (_context2.t0.errors) {
              result = _context2.t0.errors.map(function(_ref2, index2) {
                var message = _ref2.message;
                return /* @__PURE__ */ React.isValidElement(message) ? /* @__PURE__ */ React.cloneElement(message, {
                  key: "error_".concat(index2)
                }) : message;
              });
            } else {
              console.error(_context2.t0);
              result = [messages3.default()];
            }
          case 15:
            if (!(!result.length && subRuleField)) {
              _context2.next = 20;
              break;
            }
            _context2.next = 18;
            return Promise.all(value.map(function(subValue, i2) {
              return validateRule("".concat(name, ".").concat(i2), subValue, subRuleField, options, messageVariables);
            }));
          case 18:
            subResults = _context2.sent;
            return _context2.abrupt("return", subResults.reduce(function(prev, errors) {
              return [].concat(_toConsumableArray(prev), _toConsumableArray(errors));
            }, []));
          case 20:
            return _context2.abrupt("return", result);
          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[7, 12]]);
  }));
  return _validateRule.apply(this, arguments);
}
function validateRules(namePath, value, rules2, options, validateFirst, messageVariables) {
  var name = namePath.join(".");
  var filledRules = rules2.map(function(currentRule) {
    var originValidatorFunc = currentRule.validator;
    if (!originValidatorFunc) {
      return currentRule;
    }
    return _objectSpread2$1(_objectSpread2$1({}, currentRule), {}, {
      validator: function validator(rule, val, callback) {
        var hasPromise = false;
        var wrappedCallback = function wrappedCallback2() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          Promise.resolve().then(function() {
            warningOnce(!hasPromise, "Your validator function has already return a promise. `callback` will be ignored.");
            if (!hasPromise) {
              callback.apply(void 0, args);
            }
          });
        };
        var promise = originValidatorFunc(rule, val, wrappedCallback);
        hasPromise = promise && typeof promise.then === "function" && typeof promise.catch === "function";
        warningOnce(hasPromise, "`callback` is deprecated. Please return a promise instead.");
        if (hasPromise) {
          promise.then(function() {
            callback();
          }).catch(function(err) {
            callback(err || " ");
          });
        }
      }
    });
  });
  var summaryPromise;
  if (validateFirst === true) {
    summaryPromise = new Promise(/* @__PURE__ */ function() {
      var _ref = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee(resolve, reject) {
        var i2, errors;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                i2 = 0;
              case 1:
                if (!(i2 < filledRules.length)) {
                  _context.next = 11;
                  break;
                }
                _context.next = 4;
                return validateRule(name, value, filledRules[i2], options, messageVariables);
              case 4:
                errors = _context.sent;
                if (!errors.length) {
                  _context.next = 8;
                  break;
                }
                reject(errors);
                return _context.abrupt("return");
              case 8:
                i2 += 1;
                _context.next = 1;
                break;
              case 11:
                resolve([]);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function(_x6, _x7) {
        return _ref.apply(this, arguments);
      };
    }());
  } else {
    var rulePromises = filledRules.map(function(rule) {
      return validateRule(name, value, rule, options, messageVariables);
    });
    summaryPromise = (validateFirst ? finishOnFirstFailed(rulePromises) : finishOnAllFailed(rulePromises)).then(function(errors) {
      if (!errors.length) {
        return [];
      }
      return Promise.reject(errors);
    });
  }
  summaryPromise.catch(function(e3) {
    return e3;
  });
  return summaryPromise;
}
function finishOnAllFailed(_x8) {
  return _finishOnAllFailed.apply(this, arguments);
}
function _finishOnAllFailed() {
  _finishOnAllFailed = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee3(rulePromises) {
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
              var _ref3;
              var errors = (_ref3 = []).concat.apply(_ref3, _toConsumableArray(errorsList));
              return errors;
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _finishOnAllFailed.apply(this, arguments);
}
function finishOnFirstFailed(_x9) {
  return _finishOnFirstFailed.apply(this, arguments);
}
function _finishOnFirstFailed() {
  _finishOnFirstFailed = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee4(rulePromises) {
    var count;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            count = 0;
            return _context4.abrupt("return", new Promise(function(resolve) {
              rulePromises.forEach(function(promise) {
                promise.then(function(errors) {
                  if (errors.length) {
                    resolve(errors);
                  }
                  count += 1;
                  if (count === rulePromises.length) {
                    resolve([]);
                  }
                });
              });
            }));
          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _finishOnFirstFailed.apply(this, arguments);
}
function requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
  if (typeof shouldUpdate === "function") {
    return shouldUpdate(prev, next, "source" in info ? {
      source: info.source
    } : {});
  }
  return prevValue !== nextValue;
}
var Field = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Field2, _React$Component);
  var _super = _createSuper$1(Field2);
  function Field2(props) {
    var _this2;
    _classCallCheck$2(this, Field2);
    _this2 = _super.call(this, props);
    _this2.state = {
      resetCount: 0
    };
    _this2.cancelRegisterFunc = null;
    _this2.mounted = false;
    _this2.touched = false;
    _this2.dirty = false;
    _this2.validatePromise = null;
    _this2.errors = [];
    _this2.cancelRegister = function() {
      var _this$props = _this2.props, preserve = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
      if (_this2.cancelRegisterFunc) {
        _this2.cancelRegisterFunc(isListField, preserve, getNamePath(name));
      }
      _this2.cancelRegisterFunc = null;
    };
    _this2.getNamePath = function() {
      var _this$props2 = _this2.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
      var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
      return name !== void 0 ? [].concat(_toConsumableArray(prefixName), _toConsumableArray(name)) : [];
    };
    _this2.getRules = function() {
      var _this$props3 = _this2.props, _this$props3$rules = _this$props3.rules, rules2 = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
      return rules2.map(function(rule) {
        if (typeof rule === "function") {
          return rule(fieldContext);
        }
        return rule;
      });
    };
    _this2.refresh = function() {
      if (!_this2.mounted)
        return;
      _this2.setState(function(_ref) {
        var resetCount = _ref.resetCount;
        return {
          resetCount: resetCount + 1
        };
      });
    };
    _this2.onStoreChange = function(prevStore, namePathList, info) {
      var _this$props4 = _this2.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
      var store = info.store;
      var namePath = _this2.getNamePath();
      var prevValue = _this2.getValue(prevStore);
      var curValue = _this2.getValue(store);
      var namePathMatch = namePathList && containsNamePath(namePathList, namePath);
      if (info.type === "valueUpdate" && info.source === "external" && prevValue !== curValue) {
        _this2.touched = true;
        _this2.dirty = true;
        _this2.validatePromise = null;
        _this2.errors = [];
      }
      switch (info.type) {
        case "reset":
          if (!namePathList || namePathMatch) {
            _this2.touched = false;
            _this2.dirty = false;
            _this2.validatePromise = null;
            _this2.errors = [];
            if (onReset) {
              onReset();
            }
            _this2.refresh();
            return;
          }
          break;
        case "setField": {
          if (namePathMatch) {
            var data = info.data;
            if ("touched" in data) {
              _this2.touched = data.touched;
            }
            if ("validating" in data && !("originRCField" in data)) {
              _this2.validatePromise = data.validating ? Promise.resolve([]) : null;
            }
            if ("errors" in data) {
              _this2.errors = data.errors || [];
            }
            _this2.dirty = true;
            _this2.reRender();
            return;
          }
          if (shouldUpdate && !namePath.length && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
            _this2.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var dependencyList = dependencies.map(getNamePath);
          if (dependencyList.some(function(dependency) {
            return containsNamePath(info.relatedFields, dependency);
          })) {
            _this2.reRender();
            return;
          }
          break;
        }
        default:
          if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
            _this2.reRender();
            return;
          }
          break;
      }
      if (shouldUpdate === true) {
        _this2.reRender();
      }
    };
    _this2.validateRules = function(options) {
      var namePath = _this2.getNamePath();
      var currentValue = _this2.getValue();
      var rootPromise = Promise.resolve().then(function() {
        if (!_this2.mounted) {
          return [];
        }
        var _this$props5 = _this2.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables;
        var _ref2 = options || {}, triggerName = _ref2.triggerName;
        var filteredRules = _this2.getRules();
        if (triggerName) {
          filteredRules = filteredRules.filter(function(rule) {
            var validateTrigger = rule.validateTrigger;
            if (!validateTrigger) {
              return true;
            }
            var triggerList = toArray$7(validateTrigger);
            return triggerList.includes(triggerName);
          });
        }
        var promise = validateRules(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
        promise.catch(function(e3) {
          return e3;
        }).then(function() {
          var errors = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
          if (_this2.validatePromise === rootPromise) {
            _this2.validatePromise = null;
            _this2.errors = errors;
            _this2.reRender();
          }
        });
        return promise;
      });
      _this2.validatePromise = rootPromise;
      _this2.dirty = true;
      _this2.errors = [];
      _this2.reRender();
      return rootPromise;
    };
    _this2.isFieldValidating = function() {
      return !!_this2.validatePromise;
    };
    _this2.isFieldTouched = function() {
      return _this2.touched;
    };
    _this2.isFieldDirty = function() {
      return _this2.dirty;
    };
    _this2.getErrors = function() {
      return _this2.errors;
    };
    _this2.isListField = function() {
      return _this2.props.isListField;
    };
    _this2.isList = function() {
      return _this2.props.isList;
    };
    _this2.isPreserve = function() {
      return _this2.props.preserve;
    };
    _this2.getMeta = function() {
      _this2.prevValidating = _this2.isFieldValidating();
      var meta = {
        touched: _this2.isFieldTouched(),
        validating: _this2.prevValidating,
        errors: _this2.errors,
        name: _this2.getNamePath()
      };
      return meta;
    };
    _this2.getOnlyChild = function(children) {
      if (typeof children === "function") {
        var meta = _this2.getMeta();
        return _objectSpread2$1(_objectSpread2$1({}, _this2.getOnlyChild(children(_this2.getControlled(), meta, _this2.props.fieldContext))), {}, {
          isFunction: true
        });
      }
      var childList = toArray$8(children);
      if (childList.length !== 1 || !/* @__PURE__ */ React.isValidElement(childList[0])) {
        return {
          child: childList,
          isFunction: false
        };
      }
      return {
        child: childList[0],
        isFunction: false
      };
    };
    _this2.getValue = function(store) {
      var getFieldsValue = _this2.props.fieldContext.getFieldsValue;
      var namePath = _this2.getNamePath();
      return getValue$4(store || getFieldsValue(true), namePath);
    };
    _this2.getControlled = function() {
      var childProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var _this$props6 = _this2.props, trigger = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize2 = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
      var mergedValidateTrigger = validateTrigger !== void 0 ? validateTrigger : fieldContext.validateTrigger;
      var namePath = _this2.getNamePath();
      var getInternalHooks3 = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
      var _getInternalHooks = getInternalHooks3(HOOK_MARK), dispatch2 = _getInternalHooks.dispatch;
      var value = _this2.getValue();
      var mergedGetValueProps = getValueProps || function(val) {
        return _defineProperty$4({}, valuePropName, val);
      };
      var originTriggerFunc = childProps[trigger];
      var control = _objectSpread2$1(_objectSpread2$1({}, childProps), mergedGetValueProps(value));
      control[trigger] = function() {
        _this2.touched = true;
        _this2.dirty = true;
        var newValue;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (getValueFromEvent) {
          newValue = getValueFromEvent.apply(void 0, args);
        } else {
          newValue = defaultGetValueFromEvent.apply(void 0, [valuePropName].concat(args));
        }
        if (normalize2) {
          newValue = normalize2(newValue, value, getFieldsValue(true));
        }
        dispatch2({
          type: "updateValue",
          namePath,
          value: newValue
        });
        if (originTriggerFunc) {
          originTriggerFunc.apply(void 0, args);
        }
      };
      var validateTriggerList = toArray$7(mergedValidateTrigger || []);
      validateTriggerList.forEach(function(triggerName) {
        var originTrigger = control[triggerName];
        control[triggerName] = function() {
          if (originTrigger) {
            originTrigger.apply(void 0, arguments);
          }
          var rules2 = _this2.props.rules;
          if (rules2 && rules2.length) {
            dispatch2({
              type: "validateField",
              namePath,
              triggerName
            });
          }
        };
      });
      return control;
    };
    if (props.fieldContext) {
      var getInternalHooks2 = props.fieldContext.getInternalHooks;
      var _getInternalHooks2 = getInternalHooks2(HOOK_MARK), initEntityValue = _getInternalHooks2.initEntityValue;
      initEntityValue(_assertThisInitialized$1(_this2));
    }
    return _this2;
  }
  _createClass$2(Field2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
      this.mounted = true;
      if (fieldContext) {
        var getInternalHooks2 = fieldContext.getInternalHooks;
        var _getInternalHooks3 = getInternalHooks2(HOOK_MARK), registerField = _getInternalHooks3.registerField;
        this.cancelRegisterFunc = registerField(this);
      }
      if (shouldUpdate === true) {
        this.reRender();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelRegister();
      this.mounted = false;
    }
  }, {
    key: "reRender",
    value: function reRender() {
      if (!this.mounted)
        return;
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render4() {
      var resetCount = this.state.resetCount;
      var children = this.props.children;
      var _this$getOnlyChild = this.getOnlyChild(children), child = _this$getOnlyChild.child, isFunction2 = _this$getOnlyChild.isFunction;
      var returnChildNode;
      if (isFunction2) {
        returnChildNode = child;
      } else if (/* @__PURE__ */ React.isValidElement(child)) {
        returnChildNode = /* @__PURE__ */ React.cloneElement(child, this.getControlled(child.props));
      } else {
        warningOnce(!child, "`children` of Field is not validate ReactElement.");
        returnChildNode = child;
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, {
        key: resetCount
      }, returnChildNode);
    }
  }]);
  return Field2;
}(React.Component);
Field.contextType = Context;
Field.defaultProps = {
  trigger: "onChange",
  valuePropName: "value"
};
function WrapperField(_ref4) {
  var name = _ref4.name, restProps = _objectWithoutProperties$1(_ref4, ["name"]);
  var fieldContext = React.useContext(Context);
  var namePath = name !== void 0 ? getNamePath(name) : void 0;
  var key2 = "keep";
  if (!restProps.isListField) {
    key2 = "_".concat((namePath || []).join("_"));
  }
  if (process.env.NODE_ENV !== "production" && restProps.preserve === false && restProps.isListField && namePath.length <= 1) {
    warningOnce(false, "`preserve` should not apply on Form.List fields.");
  }
  return /* @__PURE__ */ React.createElement(Field, _extends$2({
    key: key2,
    name: namePath
  }, restProps, {
    fieldContext
  }));
}
var List$1 = function List(_ref) {
  var name = _ref.name, initialValue = _ref.initialValue, children = _ref.children, rules2 = _ref.rules, validateTrigger = _ref.validateTrigger;
  var context2 = React.useContext(Context);
  var keyRef = React.useRef({
    keys: [],
    id: 0
  });
  var keyManager = keyRef.current;
  if (typeof children !== "function") {
    warningOnce(false, "Form.List only accepts function as children.");
    return null;
  }
  var parentPrefixName = getNamePath(context2.prefixName) || [];
  var prefixName = [].concat(_toConsumableArray(parentPrefixName), _toConsumableArray(getNamePath(name)));
  var shouldUpdate = function shouldUpdate2(prevValue, nextValue, _ref2) {
    var source = _ref2.source;
    if (source === "internal") {
      return false;
    }
    return prevValue !== nextValue;
  };
  return /* @__PURE__ */ React.createElement(Context.Provider, {
    value: _objectSpread2$1(_objectSpread2$1({}, context2), {}, {
      prefixName
    })
  }, /* @__PURE__ */ React.createElement(WrapperField, {
    name: [],
    shouldUpdate,
    rules: rules2,
    validateTrigger,
    initialValue,
    isList: true
  }, function(_ref3, meta) {
    var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange4 = _ref3.onChange;
    var getFieldValue = context2.getFieldValue;
    var getNewValue = function getNewValue2() {
      var values = getFieldValue(prefixName || []);
      return values || [];
    };
    var operations = {
      add: function add(defaultValue, index2) {
        var newValue = getNewValue();
        if (index2 >= 0 && index2 <= newValue.length) {
          keyManager.keys = [].concat(_toConsumableArray(keyManager.keys.slice(0, index2)), [keyManager.id], _toConsumableArray(keyManager.keys.slice(index2)));
          onChange4([].concat(_toConsumableArray(newValue.slice(0, index2)), [defaultValue], _toConsumableArray(newValue.slice(index2))));
        } else {
          if (process.env.NODE_ENV !== "production" && (index2 < 0 || index2 > newValue.length)) {
            warningOnce(false, "The second parameter of the add function should be a valid positive number.");
          }
          keyManager.keys = [].concat(_toConsumableArray(keyManager.keys), [keyManager.id]);
          onChange4([].concat(_toConsumableArray(newValue), [defaultValue]));
        }
        keyManager.id += 1;
      },
      remove: function remove(index2) {
        var newValue = getNewValue();
        var indexSet = new Set(Array.isArray(index2) ? index2 : [index2]);
        if (indexSet.size <= 0) {
          return;
        }
        keyManager.keys = keyManager.keys.filter(function(_2, keysIndex) {
          return !indexSet.has(keysIndex);
        });
        onChange4(newValue.filter(function(_2, valueIndex) {
          return !indexSet.has(valueIndex);
        }));
      },
      move: function move$1(from, to) {
        if (from === to) {
          return;
        }
        var newValue = getNewValue();
        if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) {
          return;
        }
        keyManager.keys = move(keyManager.keys, from, to);
        onChange4(move(newValue, from, to));
      }
    };
    var listValue = value || [];
    if (!Array.isArray(listValue)) {
      listValue = [];
      if (process.env.NODE_ENV !== "production") {
        warningOnce(false, "Current value of '".concat(prefixName.join(" > "), "' is not an array type."));
      }
    }
    return children(listValue.map(function(__, index2) {
      var key2 = keyManager.keys[index2];
      if (key2 === void 0) {
        keyManager.keys[index2] = keyManager.id;
        key2 = keyManager.keys[index2];
        keyManager.id += 1;
      }
      return {
        name: index2,
        key: key2,
        isListField: true
      };
    }), operations, meta);
  }));
};
function _iterableToArrayLimit$3(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _slicedToArray$3(arr, i2) {
  return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i2) || _unsupportedIterableToArray$3(arr, i2) || _nonIterableRest$3();
}
function allPromiseFinish(promiseList) {
  var hasError = false;
  var count = promiseList.length;
  var results = [];
  if (!promiseList.length) {
    return Promise.resolve([]);
  }
  return new Promise(function(resolve, reject) {
    promiseList.forEach(function(promise, index2) {
      promise.catch(function(e3) {
        hasError = true;
        return e3;
      }).then(function(result) {
        count -= 1;
        results[index2] = result;
        if (count > 0) {
          return;
        }
        if (hasError) {
          reject(results);
        }
        resolve(results);
      });
    });
  });
}
var SPLIT = "__@field_split__";
function normalize(namePath) {
  return namePath.map(function(cell) {
    return "".concat(_typeof$5(cell), ":").concat(cell);
  }).join(SPLIT);
}
var NameMap = /* @__PURE__ */ function() {
  function NameMap2() {
    _classCallCheck$2(this, NameMap2);
    this.kvs = /* @__PURE__ */ new Map();
  }
  _createClass$2(NameMap2, [{
    key: "set",
    value: function set2(key2, value) {
      this.kvs.set(normalize(key2), value);
    }
  }, {
    key: "get",
    value: function get2(key2) {
      return this.kvs.get(normalize(key2));
    }
  }, {
    key: "update",
    value: function update(key2, updater) {
      var origin = this.get(key2);
      var next = updater(origin);
      if (!next) {
        this.delete(key2);
      } else {
        this.set(key2, next);
      }
    }
  }, {
    key: "delete",
    value: function _delete(key2) {
      this.kvs.delete(normalize(key2));
    }
  }, {
    key: "map",
    value: function map(callback) {
      return _toConsumableArray(this.kvs.entries()).map(function(_ref) {
        var _ref2 = _slicedToArray$3(_ref, 2), key2 = _ref2[0], value = _ref2[1];
        var cells = key2.split(SPLIT);
        return callback({
          key: cells.map(function(cell) {
            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = _slicedToArray$3(_cell$match, 3), type2 = _cell$match2[1], unit = _cell$match2[2];
            return type2 === "number" ? Number(unit) : unit;
          }),
          value
        });
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = {};
      this.map(function(_ref3) {
        var key2 = _ref3.key, value = _ref3.value;
        json[key2.join(".")] = value;
        return null;
      });
      return json;
    }
  }]);
  return NameMap2;
}();
var FormStore = function FormStore2(forceRootUpdate) {
  var _this2 = this;
  _classCallCheck$2(this, FormStore2);
  this.formHooked = false;
  this.subscribable = true;
  this.store = {};
  this.fieldEntities = [];
  this.initialValues = {};
  this.callbacks = {};
  this.validateMessages = null;
  this.preserve = null;
  this.lastValidatePromise = null;
  this.getForm = function() {
    return {
      getFieldValue: _this2.getFieldValue,
      getFieldsValue: _this2.getFieldsValue,
      getFieldError: _this2.getFieldError,
      getFieldsError: _this2.getFieldsError,
      isFieldsTouched: _this2.isFieldsTouched,
      isFieldTouched: _this2.isFieldTouched,
      isFieldValidating: _this2.isFieldValidating,
      isFieldsValidating: _this2.isFieldsValidating,
      resetFields: _this2.resetFields,
      setFields: _this2.setFields,
      setFieldsValue: _this2.setFieldsValue,
      validateFields: _this2.validateFields,
      submit: _this2.submit,
      getInternalHooks: _this2.getInternalHooks
    };
  };
  this.getInternalHooks = function(key2) {
    if (key2 === HOOK_MARK) {
      _this2.formHooked = true;
      return {
        dispatch: _this2.dispatch,
        initEntityValue: _this2.initEntityValue,
        registerField: _this2.registerField,
        useSubscribe: _this2.useSubscribe,
        setInitialValues: _this2.setInitialValues,
        setCallbacks: _this2.setCallbacks,
        setValidateMessages: _this2.setValidateMessages,
        getFields: _this2.getFields,
        setPreserve: _this2.setPreserve
      };
    }
    warningOnce(false, "`getInternalHooks` is internal usage. Should not call directly.");
    return null;
  };
  this.useSubscribe = function(subscribable) {
    _this2.subscribable = subscribable;
  };
  this.setInitialValues = function(initialValues, init) {
    _this2.initialValues = initialValues || {};
    if (init) {
      _this2.store = setValues({}, initialValues, _this2.store);
    }
  };
  this.getInitialValue = function(namePath) {
    return getValue$4(_this2.initialValues, namePath);
  };
  this.setCallbacks = function(callbacks) {
    _this2.callbacks = callbacks;
  };
  this.setValidateMessages = function(validateMessages) {
    _this2.validateMessages = validateMessages;
  };
  this.setPreserve = function(preserve) {
    _this2.preserve = preserve;
  };
  this.timeoutId = null;
  this.warningUnhooked = function() {
    if (process.env.NODE_ENV !== "production" && !_this2.timeoutId && typeof window !== "undefined") {
      _this2.timeoutId = setTimeout(function() {
        _this2.timeoutId = null;
        if (!_this2.formHooked) {
          warningOnce(false, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
        }
      });
    }
  };
  this.getFieldEntities = function() {
    var pure = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (!pure) {
      return _this2.fieldEntities;
    }
    return _this2.fieldEntities.filter(function(field) {
      return field.getNamePath().length;
    });
  };
  this.getFieldsMap = function() {
    var pure = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var cache = new NameMap();
    _this2.getFieldEntities(pure).forEach(function(field) {
      var namePath = field.getNamePath();
      cache.set(namePath, field);
    });
    return cache;
  };
  this.getFieldEntitiesForNamePathList = function(nameList) {
    if (!nameList) {
      return _this2.getFieldEntities(true);
    }
    var cache = _this2.getFieldsMap(true);
    return nameList.map(function(name) {
      var namePath = getNamePath(name);
      return cache.get(namePath) || {
        INVALIDATE_NAME_PATH: getNamePath(name)
      };
    });
  };
  this.getFieldsValue = function(nameList, filterFunc) {
    _this2.warningUnhooked();
    if (nameList === true && !filterFunc) {
      return _this2.store;
    }
    var fieldEntities = _this2.getFieldEntitiesForNamePathList(Array.isArray(nameList) ? nameList : null);
    var filteredNameList = [];
    fieldEntities.forEach(function(entity) {
      var _entity$isListField;
      var namePath = "INVALIDATE_NAME_PATH" in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
      if (!nameList && ((_entity$isListField = entity.isListField) === null || _entity$isListField === void 0 ? void 0 : _entity$isListField.call(entity))) {
        return;
      }
      if (!filterFunc) {
        filteredNameList.push(namePath);
      } else {
        var meta = "getMeta" in entity ? entity.getMeta() : null;
        if (filterFunc(meta)) {
          filteredNameList.push(namePath);
        }
      }
    });
    return cloneByNamePathList(_this2.store, filteredNameList.map(getNamePath));
  };
  this.getFieldValue = function(name) {
    _this2.warningUnhooked();
    var namePath = getNamePath(name);
    return getValue$4(_this2.store, namePath);
  };
  this.getFieldsError = function(nameList) {
    _this2.warningUnhooked();
    var fieldEntities = _this2.getFieldEntitiesForNamePathList(nameList);
    return fieldEntities.map(function(entity, index2) {
      if (entity && !("INVALIDATE_NAME_PATH" in entity)) {
        return {
          name: entity.getNamePath(),
          errors: entity.getErrors()
        };
      }
      return {
        name: getNamePath(nameList[index2]),
        errors: []
      };
    });
  };
  this.getFieldError = function(name) {
    _this2.warningUnhooked();
    var namePath = getNamePath(name);
    var fieldError = _this2.getFieldsError([namePath])[0];
    return fieldError.errors;
  };
  this.isFieldsTouched = function() {
    _this2.warningUnhooked();
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var arg0 = args[0], arg1 = args[1];
    var namePathList;
    var isAllFieldsTouched = false;
    if (args.length === 0) {
      namePathList = null;
    } else if (args.length === 1) {
      if (Array.isArray(arg0)) {
        namePathList = arg0.map(getNamePath);
        isAllFieldsTouched = false;
      } else {
        namePathList = null;
        isAllFieldsTouched = arg0;
      }
    } else {
      namePathList = arg0.map(getNamePath);
      isAllFieldsTouched = arg1;
    }
    var fieldEntities = _this2.getFieldEntities(true);
    var isFieldTouched = function isFieldTouched2(field) {
      return field.isFieldTouched();
    };
    if (!namePathList) {
      return isAllFieldsTouched ? fieldEntities.every(isFieldTouched) : fieldEntities.some(isFieldTouched);
    }
    var map = new NameMap();
    namePathList.forEach(function(shortNamePath) {
      map.set(shortNamePath, []);
    });
    fieldEntities.forEach(function(field) {
      var fieldNamePath = field.getNamePath();
      namePathList.forEach(function(shortNamePath) {
        if (shortNamePath.every(function(nameUnit, i2) {
          return fieldNamePath[i2] === nameUnit;
        })) {
          map.update(shortNamePath, function(list) {
            return [].concat(_toConsumableArray(list), [field]);
          });
        }
      });
    });
    var isNamePathListTouched = function isNamePathListTouched2(entities) {
      return entities.some(isFieldTouched);
    };
    var namePathListEntities = map.map(function(_ref) {
      var value = _ref.value;
      return value;
    });
    return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
  };
  this.isFieldTouched = function(name) {
    _this2.warningUnhooked();
    return _this2.isFieldsTouched([name]);
  };
  this.isFieldsValidating = function(nameList) {
    _this2.warningUnhooked();
    var fieldEntities = _this2.getFieldEntities();
    if (!nameList) {
      return fieldEntities.some(function(testField) {
        return testField.isFieldValidating();
      });
    }
    var namePathList = nameList.map(getNamePath);
    return fieldEntities.some(function(testField) {
      var fieldNamePath = testField.getNamePath();
      return containsNamePath(namePathList, fieldNamePath) && testField.isFieldValidating();
    });
  };
  this.isFieldValidating = function(name) {
    _this2.warningUnhooked();
    return _this2.isFieldsValidating([name]);
  };
  this.resetWithFieldInitialValue = function() {
    var info = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var cache = new NameMap();
    var fieldEntities = _this2.getFieldEntities(true);
    fieldEntities.forEach(function(field) {
      var initialValue = field.props.initialValue;
      var namePath = field.getNamePath();
      if (initialValue !== void 0) {
        var records = cache.get(namePath) || /* @__PURE__ */ new Set();
        records.add({
          entity: field,
          value: initialValue
        });
        cache.set(namePath, records);
      }
    });
    var resetWithFields = function resetWithFields2(entities) {
      entities.forEach(function(field) {
        var initialValue = field.props.initialValue;
        if (initialValue !== void 0) {
          var namePath = field.getNamePath();
          var formInitialValue = _this2.getInitialValue(namePath);
          if (formInitialValue !== void 0) {
            warningOnce(false, "Form already set 'initialValues' with path '".concat(namePath.join("."), "'. Field can not overwrite it."));
          } else {
            var records = cache.get(namePath);
            if (records && records.size > 1) {
              warningOnce(false, "Multiple Field with path '".concat(namePath.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            } else if (records) {
              var originValue = _this2.getFieldValue(namePath);
              if (!info.skipExist || originValue === void 0) {
                _this2.store = setValue(_this2.store, namePath, _toConsumableArray(records)[0].value);
              }
            }
          }
        }
      });
    };
    var requiredFieldEntities;
    if (info.entities) {
      requiredFieldEntities = info.entities;
    } else if (info.namePathList) {
      requiredFieldEntities = [];
      info.namePathList.forEach(function(namePath) {
        var records = cache.get(namePath);
        if (records) {
          var _requiredFieldEntitie;
          (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, _toConsumableArray(_toConsumableArray(records).map(function(r3) {
            return r3.entity;
          })));
        }
      });
    } else {
      requiredFieldEntities = fieldEntities;
    }
    resetWithFields(requiredFieldEntities);
  };
  this.resetFields = function(nameList) {
    _this2.warningUnhooked();
    var prevStore = _this2.store;
    if (!nameList) {
      _this2.store = setValues({}, _this2.initialValues);
      _this2.resetWithFieldInitialValue();
      _this2.notifyObservers(prevStore, null, {
        type: "reset"
      });
      return;
    }
    var namePathList = nameList.map(getNamePath);
    namePathList.forEach(function(namePath) {
      var initialValue = _this2.getInitialValue(namePath);
      _this2.store = setValue(_this2.store, namePath, initialValue);
    });
    _this2.resetWithFieldInitialValue({
      namePathList
    });
    _this2.notifyObservers(prevStore, namePathList, {
      type: "reset"
    });
  };
  this.setFields = function(fields) {
    _this2.warningUnhooked();
    var prevStore = _this2.store;
    fields.forEach(function(fieldData) {
      var name = fieldData.name;
      fieldData.errors;
      var data = _objectWithoutProperties$1(fieldData, ["name", "errors"]);
      var namePath = getNamePath(name);
      if ("value" in data) {
        _this2.store = setValue(_this2.store, namePath, data.value);
      }
      _this2.notifyObservers(prevStore, [namePath], {
        type: "setField",
        data: fieldData
      });
    });
  };
  this.getFields = function() {
    var entities = _this2.getFieldEntities(true);
    var fields = entities.map(function(field) {
      var namePath = field.getNamePath();
      var meta = field.getMeta();
      var fieldData = _objectSpread2$1(_objectSpread2$1({}, meta), {}, {
        name: namePath,
        value: _this2.getFieldValue(namePath)
      });
      Object.defineProperty(fieldData, "originRCField", {
        value: true
      });
      return fieldData;
    });
    return fields;
  };
  this.initEntityValue = function(entity) {
    var initialValue = entity.props.initialValue;
    if (initialValue !== void 0) {
      var namePath = entity.getNamePath();
      var prevValue = getValue$4(_this2.store, namePath);
      if (prevValue === void 0) {
        _this2.store = setValue(_this2.store, namePath, initialValue);
      }
    }
  };
  this.registerField = function(entity) {
    _this2.fieldEntities.push(entity);
    if (entity.props.initialValue !== void 0) {
      var prevStore = _this2.store;
      _this2.resetWithFieldInitialValue({
        entities: [entity],
        skipExist: true
      });
      _this2.notifyObservers(prevStore, [entity.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(isListField, preserve) {
      var subNamePath = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      _this2.fieldEntities = _this2.fieldEntities.filter(function(item) {
        return item !== entity;
      });
      var mergedPreserve = preserve !== void 0 ? preserve : _this2.preserve;
      if (mergedPreserve === false && (!isListField || subNamePath.length > 1)) {
        var namePath = entity.getNamePath();
        var defaultValue = isListField ? void 0 : getValue$4(_this2.initialValues, namePath);
        if (namePath.length && _this2.getFieldValue(namePath) !== defaultValue && _this2.fieldEntities.every(function(field) {
          return !matchNamePath(field.getNamePath(), namePath);
        })) {
          _this2.store = setValue(_this2.store, namePath, defaultValue, true);
        }
      }
    };
  };
  this.dispatch = function(action) {
    switch (action.type) {
      case "updateValue": {
        var namePath = action.namePath, value = action.value;
        _this2.updateValue(namePath, value);
        break;
      }
      case "validateField": {
        var _namePath = action.namePath, triggerName = action.triggerName;
        _this2.validateFields([_namePath], {
          triggerName
        });
        break;
      }
    }
  };
  this.notifyObservers = function(prevStore, namePathList, info) {
    if (_this2.subscribable) {
      var mergedInfo = _objectSpread2$1(_objectSpread2$1({}, info), {}, {
        store: _this2.getFieldsValue(true)
      });
      _this2.getFieldEntities().forEach(function(_ref2) {
        var onStoreChange = _ref2.onStoreChange;
        onStoreChange(prevStore, namePathList, mergedInfo);
      });
    } else {
      _this2.forceRootUpdate();
    }
  };
  this.updateValue = function(name, value) {
    var namePath = getNamePath(name);
    var prevStore = _this2.store;
    _this2.store = setValue(_this2.store, namePath, value);
    _this2.notifyObservers(prevStore, [namePath], {
      type: "valueUpdate",
      source: "internal"
    });
    var childrenFields = _this2.getDependencyChildrenFields(namePath);
    if (childrenFields.length) {
      _this2.validateFields(childrenFields);
    }
    _this2.notifyObservers(prevStore, childrenFields, {
      type: "dependenciesUpdate",
      relatedFields: [namePath].concat(_toConsumableArray(childrenFields))
    });
    var onValuesChange = _this2.callbacks.onValuesChange;
    if (onValuesChange) {
      var changedValues = cloneByNamePathList(_this2.store, [namePath]);
      onValuesChange(changedValues, _this2.getFieldsValue());
    }
    _this2.triggerOnFieldsChange([namePath].concat(_toConsumableArray(childrenFields)));
  };
  this.setFieldsValue = function(store) {
    _this2.warningUnhooked();
    var prevStore = _this2.store;
    if (store) {
      _this2.store = setValues(_this2.store, store);
    }
    _this2.notifyObservers(prevStore, null, {
      type: "valueUpdate",
      source: "external"
    });
  };
  this.getDependencyChildrenFields = function(rootNamePath) {
    var children = /* @__PURE__ */ new Set();
    var childrenFields = [];
    var dependencies2fields = new NameMap();
    _this2.getFieldEntities().forEach(function(field) {
      var dependencies = field.props.dependencies;
      (dependencies || []).forEach(function(dependency) {
        var dependencyNamePath = getNamePath(dependency);
        dependencies2fields.update(dependencyNamePath, function() {
          var fields = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          fields.add(field);
          return fields;
        });
      });
    });
    var fillChildren = function fillChildren2(namePath) {
      var fields = dependencies2fields.get(namePath) || /* @__PURE__ */ new Set();
      fields.forEach(function(field) {
        if (!children.has(field)) {
          children.add(field);
          var fieldNamePath = field.getNamePath();
          if (field.isFieldDirty() && fieldNamePath.length) {
            childrenFields.push(fieldNamePath);
            fillChildren2(fieldNamePath);
          }
        }
      });
    };
    fillChildren(rootNamePath);
    return childrenFields;
  };
  this.triggerOnFieldsChange = function(namePathList, filedErrors) {
    var onFieldsChange = _this2.callbacks.onFieldsChange;
    if (onFieldsChange) {
      var fields = _this2.getFields();
      if (filedErrors) {
        var cache = new NameMap();
        filedErrors.forEach(function(_ref3) {
          var name = _ref3.name, errors = _ref3.errors;
          cache.set(name, errors);
        });
        fields.forEach(function(field) {
          field.errors = cache.get(field.name) || field.errors;
        });
      }
      var changedFields = fields.filter(function(_ref4) {
        var fieldName = _ref4.name;
        return containsNamePath(namePathList, fieldName);
      });
      onFieldsChange(changedFields, fields);
    }
  };
  this.validateFields = function(nameList, options) {
    _this2.warningUnhooked();
    var provideNameList = !!nameList;
    var namePathList = provideNameList ? nameList.map(getNamePath) : [];
    var promiseList = [];
    _this2.getFieldEntities(true).forEach(function(field) {
      if (!provideNameList) {
        namePathList.push(field.getNamePath());
      }
      if ((options === null || options === void 0 ? void 0 : options.recursive) && provideNameList) {
        var namePath = field.getNamePath();
        if (namePath.every(function(nameUnit, i2) {
          return nameList[i2] === nameUnit || nameList[i2] === void 0;
        })) {
          namePathList.push(namePath);
        }
      }
      if (!field.props.rules || !field.props.rules.length) {
        return;
      }
      var fieldNamePath = field.getNamePath();
      if (!provideNameList || containsNamePath(namePathList, fieldNamePath)) {
        var promise = field.validateRules(_objectSpread2$1({
          validateMessages: _objectSpread2$1(_objectSpread2$1({}, defaultValidateMessages), _this2.validateMessages)
        }, options));
        promiseList.push(promise.then(function() {
          return {
            name: fieldNamePath,
            errors: []
          };
        }).catch(function(errors) {
          return Promise.reject({
            name: fieldNamePath,
            errors
          });
        }));
      }
    });
    var summaryPromise = allPromiseFinish(promiseList);
    _this2.lastValidatePromise = summaryPromise;
    summaryPromise.catch(function(results) {
      return results;
    }).then(function(results) {
      var resultNamePathList = results.map(function(_ref5) {
        var name = _ref5.name;
        return name;
      });
      _this2.notifyObservers(_this2.store, resultNamePathList, {
        type: "validateFinish"
      });
      _this2.triggerOnFieldsChange(resultNamePathList, results);
    });
    var returnPromise = summaryPromise.then(function() {
      if (_this2.lastValidatePromise === summaryPromise) {
        return Promise.resolve(_this2.getFieldsValue(namePathList));
      }
      return Promise.reject([]);
    }).catch(function(results) {
      var errorList = results.filter(function(result) {
        return result && result.errors.length;
      });
      return Promise.reject({
        values: _this2.getFieldsValue(namePathList),
        errorFields: errorList,
        outOfDate: _this2.lastValidatePromise !== summaryPromise
      });
    });
    returnPromise.catch(function(e3) {
      return e3;
    });
    return returnPromise;
  };
  this.submit = function() {
    _this2.warningUnhooked();
    _this2.validateFields().then(function(values) {
      var onFinish = _this2.callbacks.onFinish;
      if (onFinish) {
        try {
          onFinish(values);
        } catch (err) {
          console.error(err);
        }
      }
    }).catch(function(e3) {
      var onFinishFailed = _this2.callbacks.onFinishFailed;
      if (onFinishFailed) {
        onFinishFailed(e3);
      }
    });
  };
  this.forceRootUpdate = forceRootUpdate;
};
function useForm$1(form) {
  var formRef = React.useRef();
  var _React$useState = React.useState({}), _React$useState2 = _slicedToArray$3(_React$useState, 2), forceUpdate = _React$useState2[1];
  if (!formRef.current) {
    if (form) {
      formRef.current = form;
    } else {
      var forceReRender = function forceReRender2() {
        forceUpdate({});
      };
      var formStore = new FormStore(forceReRender);
      formRef.current = formStore.getForm();
    }
  }
  return [formRef.current];
}
var FormContext$1 = /* @__PURE__ */ React.createContext({
  triggerFormChange: function triggerFormChange() {
  },
  triggerFormFinish: function triggerFormFinish() {
  },
  registerForm: function registerForm() {
  },
  unregisterForm: function unregisterForm() {
  }
});
var FormProvider$1 = function FormProvider(_ref) {
  var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children = _ref.children;
  var formContext = React.useContext(FormContext$1);
  var formsRef = React.useRef({});
  return /* @__PURE__ */ React.createElement(FormContext$1.Provider, {
    value: _objectSpread2$1(_objectSpread2$1({}, formContext), {}, {
      validateMessages: _objectSpread2$1(_objectSpread2$1({}, formContext.validateMessages), validateMessages),
      triggerFormChange: function triggerFormChange2(name, changedFields) {
        if (onFormChange) {
          onFormChange(name, {
            changedFields,
            forms: formsRef.current
          });
        }
        formContext.triggerFormChange(name, changedFields);
      },
      triggerFormFinish: function triggerFormFinish2(name, values) {
        if (onFormFinish) {
          onFormFinish(name, {
            values,
            forms: formsRef.current
          });
        }
        formContext.triggerFormFinish(name, values);
      },
      registerForm: function registerForm2(name, form) {
        if (name) {
          formsRef.current = _objectSpread2$1(_objectSpread2$1({}, formsRef.current), {}, _defineProperty$4({}, name, form));
        }
        formContext.registerForm(name, form);
      },
      unregisterForm: function unregisterForm2(name) {
        var newForms = _objectSpread2$1({}, formsRef.current);
        delete newForms[name];
        formsRef.current = newForms;
        formContext.unregisterForm(name);
      }
    })
  }, children);
};
var Form$2 = function Form(_ref, ref) {
  var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve = _ref.preserve, children = _ref.children, _ref$component = _ref.component, Component3 = _ref$component === void 0 ? "form" : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? "onChange" : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, restProps = _objectWithoutProperties$1(_ref, ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed"]);
  var formContext = React.useContext(FormContext$1);
  var _useForm = useForm$1(form), _useForm2 = _slicedToArray$3(_useForm, 1), formInstance = _useForm2[0];
  var _formInstance$getInte = formInstance.getInternalHooks(HOOK_MARK), useSubscribe = _formInstance$getInte.useSubscribe, setInitialValues = _formInstance$getInte.setInitialValues, setCallbacks = _formInstance$getInte.setCallbacks, setValidateMessages = _formInstance$getInte.setValidateMessages, setPreserve = _formInstance$getInte.setPreserve;
  React.useImperativeHandle(ref, function() {
    return formInstance;
  });
  React.useEffect(function() {
    formContext.registerForm(name, formInstance);
    return function() {
      formContext.unregisterForm(name);
    };
  }, [formContext, formInstance, name]);
  setValidateMessages(_objectSpread2$1(_objectSpread2$1({}, formContext.validateMessages), validateMessages));
  setCallbacks({
    onValuesChange,
    onFieldsChange: function onFieldsChange(changedFields) {
      formContext.triggerFormChange(name, changedFields);
      if (_onFieldsChange) {
        for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }
        _onFieldsChange.apply(void 0, [changedFields].concat(rest));
      }
    },
    onFinish: function onFinish(values2) {
      formContext.triggerFormFinish(name, values2);
      if (_onFinish) {
        _onFinish(values2);
      }
    },
    onFinishFailed
  });
  setPreserve(preserve);
  var mountRef = React.useRef(null);
  setInitialValues(initialValues, !mountRef.current);
  if (!mountRef.current) {
    mountRef.current = true;
  }
  var childrenNode = children;
  var childrenRenderProps = typeof children === "function";
  if (childrenRenderProps) {
    var values = formInstance.getFieldsValue(true);
    childrenNode = children(values, formInstance);
  }
  useSubscribe(!childrenRenderProps);
  var prevFieldsRef = React.useRef();
  React.useEffect(function() {
    if (!isSimilar(prevFieldsRef.current || [], fields || [])) {
      formInstance.setFields(fields || []);
    }
    prevFieldsRef.current = fields;
  }, [fields, formInstance]);
  var formContextValue = React.useMemo(function() {
    return _objectSpread2$1(_objectSpread2$1({}, formInstance), {}, {
      validateTrigger
    });
  }, [formInstance, validateTrigger]);
  var wrapperNode = /* @__PURE__ */ React.createElement(Context.Provider, {
    value: formContextValue
  }, childrenNode);
  if (Component3 === false) {
    return wrapperNode;
  }
  return /* @__PURE__ */ React.createElement(Component3, _extends$2({}, restProps, {
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      formInstance.submit();
    },
    onReset: function onReset(event) {
      var _restProps$onReset;
      event.preventDefault();
      formInstance.resetFields();
      (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 ? void 0 : _restProps$onReset.call(restProps, event);
    }
  }), wrapperNode);
};
var InternalForm$1 = /* @__PURE__ */ React.forwardRef(Form$2);
var RefForm = InternalForm$1;
RefForm.FormProvider = FormProvider$1;
RefForm.Field = WrapperField;
RefForm.List = List$1;
RefForm.useForm = useForm$1;
var devWarning = function(valid, component, message) {
  warningOnce(valid, "[antd: ".concat(component, "] ").concat(message));
};
var enUS = {
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
};
var locale$2 = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "Ok",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: true,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
};
var locale$1 = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
};
var locale = {
  lang: _extends$2({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, locale$2),
  timePickerLocale: _extends$2({}, locale$1)
};
var typeTemplate = "${label} is not a valid ${type}";
var localeValues = {
  locale: "en",
  Pagination: enUS,
  DatePicker: locale,
  TimePicker: locale$1,
  Calendar: locale,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No Data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  PageHeader: {
    back: "Back"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      "default": "Field validation error for ${label}",
      required: "Please enter ${label}",
      "enum": "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        "boolean": typeTemplate,
        integer: typeTemplate,
        "float": typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  }
};
_extends$2({}, localeValues.Modal);
var LocaleContext = /* @__PURE__ */ createContext2(void 0);
var LocaleReceiver = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(LocaleReceiver2, _React$Component);
  var _super = _createSuper$1(LocaleReceiver2);
  function LocaleReceiver2() {
    _classCallCheck$2(this, LocaleReceiver2);
    return _super.apply(this, arguments);
  }
  _createClass$2(LocaleReceiver2, [{
    key: "getLocale",
    value: function getLocale() {
      var _this$props = this.props, componentName = _this$props.componentName, defaultLocale = _this$props.defaultLocale;
      var locale2 = defaultLocale || localeValues[componentName || "global"];
      var antLocale = this.context;
      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
      return _extends$2(_extends$2({}, typeof locale2 === "function" ? locale2() : locale2), localeFromContext || {});
    }
  }, {
    key: "getLocaleCode",
    value: function getLocaleCode() {
      var antLocale = this.context;
      var localeCode = antLocale && antLocale.locale;
      if (antLocale && antLocale.exist && !localeCode) {
        return localeValues.locale;
      }
      return localeCode;
    }
  }, {
    key: "render",
    value: function render4() {
      return this.props.children(this.getLocale(), this.getLocaleCode(), this.context);
    }
  }]);
  return LocaleReceiver2;
}(React.Component);
LocaleReceiver.defaultProps = {
  componentName: "global"
};
LocaleReceiver.contextType = LocaleContext;
function useLocaleReceiver(componentName, defaultLocale) {
  var antLocale = React.useContext(LocaleContext);
  var componentLocale = React.useMemo(function() {
    var locale2 = defaultLocale || localeValues[componentName || "global"];
    var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
    return _extends$2(_extends$2({}, typeof locale2 === "function" ? locale2() : locale2), localeFromContext || {});
  }, [componentName, defaultLocale, antLocale]);
  return [componentLocale];
}
var Empty$1 = function Empty() {
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls("empty-img-default");
  return /* @__PURE__ */ React.createElement("svg", {
    className: prefixCls,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ React.createElement("ellipse", {
    className: "".concat(prefixCls, "-ellipse"),
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ React.createElement("path", {
    className: "".concat(prefixCls, "-path-1"),
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
  }), /* @__PURE__ */ React.createElement("path", {
    className: "".concat(prefixCls, "-path-2"),
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ React.createElement("path", {
    className: "".concat(prefixCls, "-path-3"),
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  }), /* @__PURE__ */ React.createElement("path", {
    className: "".concat(prefixCls, "-path-4"),
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
  })), /* @__PURE__ */ React.createElement("path", {
    className: "".concat(prefixCls, "-path-5"),
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
  }), /* @__PURE__ */ React.createElement("g", {
    className: "".concat(prefixCls, "-g"),
    transform: "translate(149.65 15.383)"
  }, /* @__PURE__ */ React.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};
var Simple = function Simple2() {
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls("empty-img-simple");
  return /* @__PURE__ */ React.createElement("svg", {
    className: prefixCls,
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React.createElement("ellipse", {
    className: "".concat(prefixCls, "-ellipse"),
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ React.createElement("g", {
    className: "".concat(prefixCls, "-g"),
    fillRule: "nonzero"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    className: "".concat(prefixCls, "-path")
  }))));
};
var __rest$M = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var defaultEmptyImg = /* @__PURE__ */ React.createElement(Empty$1, null);
var simpleEmptyImg = /* @__PURE__ */ React.createElement(Simple, null);
var Empty2 = function Empty3(_a) {
  var className = _a.className, customizePrefixCls = _a.prefixCls, _a$image = _a.image, image = _a$image === void 0 ? defaultEmptyImg : _a$image, description = _a.description, children = _a.children, imageStyle = _a.imageStyle, restProps = __rest$M(_a, ["className", "prefixCls", "image", "description", "children", "imageStyle"]);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  return /* @__PURE__ */ React.createElement(LocaleReceiver, {
    componentName: "Empty"
  }, function(locale2) {
    var _classNames;
    var prefixCls = getPrefixCls("empty", customizePrefixCls);
    var des = typeof description !== "undefined" ? description : locale2.description;
    var alt = typeof des === "string" ? des : "empty";
    var imageNode = null;
    if (typeof image === "string") {
      imageNode = /* @__PURE__ */ React.createElement("img", {
        alt,
        src: image
      });
    } else {
      imageNode = image;
    }
    return /* @__PURE__ */ React.createElement("div", _extends$2({
      className: cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-normal"), image === simpleEmptyImg), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className)
    }, restProps), /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-image"),
      style: imageStyle
    }, imageNode), des && /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-description")
    }, des), children && /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-footer")
    }, children));
  });
};
Empty2.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty2.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
var renderEmpty = function renderEmpty2(componentName) {
  return /* @__PURE__ */ React.createElement(ConfigConsumer, null, function(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var prefix = getPrefixCls("empty");
    switch (componentName) {
      case "Table":
      case "List":
        return /* @__PURE__ */ React.createElement(Empty2, {
          image: Empty2.PRESENTED_IMAGE_SIMPLE
        });
      case "Select":
      case "TreeSelect":
      case "Cascader":
      case "Transfer":
      case "Mentions":
        return /* @__PURE__ */ React.createElement(Empty2, {
          image: Empty2.PRESENTED_IMAGE_SIMPLE,
          className: "".concat(prefix, "-small")
        });
      default:
        return /* @__PURE__ */ React.createElement(Empty2, null);
    }
  });
};
var defaultGetPrefixCls = function defaultGetPrefixCls2(suffixCls, customizePrefixCls) {
  if (customizePrefixCls)
    return customizePrefixCls;
  return suffixCls ? "ant-".concat(suffixCls) : "ant";
};
var ConfigContext = /* @__PURE__ */ React.createContext({
  getPrefixCls: defaultGetPrefixCls,
  renderEmpty
});
var ConfigConsumer = ConfigContext.Consumer;
function withConfigConsumer(config) {
  return function withConfigConsumerFunc(Component3) {
    var SFC = function SFC2(props) {
      return /* @__PURE__ */ React.createElement(ConfigConsumer, null, function(configProps) {
        var basicPrefixCls = config.prefixCls;
        var getPrefixCls = configProps.getPrefixCls;
        var customizePrefixCls = props.prefixCls;
        var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
        return /* @__PURE__ */ React.createElement(Component3, _extends$2({}, configProps, props, {
          prefixCls
        }));
      });
    };
    var cons = Component3.constructor;
    var name = cons && cons.displayName || Component3.name || "Component";
    SFC.displayName = "withConfigConsumer(".concat(name, ")");
    return SFC;
  };
}
var SizeContext$1 = /* @__PURE__ */ React.createContext(void 0);
var SizeContextProvider$1 = function SizeContextProvider(_ref) {
  var children = _ref.children, size = _ref.size;
  return /* @__PURE__ */ React.createElement(SizeContext$1.Consumer, null, function(originSize) {
    return /* @__PURE__ */ React.createElement(SizeContext$1.Provider, {
      value: size || originSize
    }, children);
  });
};
function canUseDom() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}
function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  };
  if (domSupport) {
    if (!("AnimationEvent" in win)) {
      delete prefixes.animationend.animation;
    }
    if (!("TransitionEvent" in win)) {
      delete prefixes.transitionend.transition;
    }
  }
  return prefixes;
}
var vendorPrefixes = getVendorPrefixes(canUseDom(), typeof window !== "undefined" ? window : {});
var style = {};
if (canUseDom()) {
  _document$createEleme = document.createElement("div");
  style = _document$createEleme.style;
}
var _document$createEleme;
var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }
  var prefixMap = vendorPrefixes[eventName];
  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i2 = 0; i2 < len; i2 += 1) {
      var styleProp = stylePropList[i2];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }
  return "";
}
var internalAnimationEndName = getVendorPrefixedEventName("animationend");
var internalTransitionEndName = getVendorPrefixedEventName("transitionend");
var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
var animationEndName = internalAnimationEndName || "animationend";
var transitionEndName = internalTransitionEndName || "transitionend";
function getTransitionName$2(transitionName2, transitionType) {
  if (!transitionName2)
    return null;
  if (_typeof$5(transitionName2) === "object") {
    var type2 = transitionType.replace(/-\w/g, function(match2) {
      return match2[1].toUpperCase();
    });
    return transitionName2[type2];
  }
  return "".concat(transitionName2, "-").concat(transitionType);
}
var STATUS_NONE = "none";
var STATUS_APPEAR = "appear";
var STATUS_ENTER = "enter";
var STATUS_LEAVE = "leave";
var STEP_NONE = "none";
var STEP_PREPARE = "prepare";
var STEP_START = "start";
var STEP_ACTIVE = "active";
var STEP_ACTIVATED = "end";
function useSafeState(defaultValue) {
  var destroyRef = React.useRef(false);
  var _React$useState = React.useState(defaultValue), _React$useState2 = _slicedToArray$3(_React$useState, 2), value = _React$useState2[0], setValue2 = _React$useState2[1];
  React.useEffect(function() {
    destroyRef.current = false;
    return function() {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue2(updater);
  }
  return [value, safeSetState];
}
var raf = function raf2(callback) {
  return +setTimeout(callback, 16);
};
var caf = function caf2(num) {
  return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
  raf = function raf3(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf3(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = /* @__PURE__ */ new Map();
function cleanup(id2) {
  rafIds.delete(id2);
}
function wrapperRaf$1(callback) {
  var times = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var id2 = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      cleanup(id2);
      callback();
    } else {
      var realId = raf(function() {
        callRef(leftTimes - 1);
      });
      rafIds.set(id2, realId);
    }
  }
  callRef(times);
  return id2;
}
wrapperRaf$1.cancel = function(id2) {
  var realId = rafIds.get(id2);
  cleanup(realId);
  return caf(realId);
};
var useNextFrame = function() {
  var nextFrameRef = React.useRef(null);
  function cancelNextFrame() {
    wrapperRaf$1.cancel(nextFrameRef.current);
  }
  function nextFrame(callback) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    cancelNextFrame();
    var nextFrameId = wrapperRaf$1(function() {
      if (delay <= 1) {
        callback({
          isCanceled: function isCanceled() {
            return nextFrameId !== nextFrameRef.current;
          }
        });
      } else {
        nextFrame(callback, delay - 1);
      }
    });
    nextFrameRef.current = nextFrameId;
  }
  React.useEffect(function() {
    return function() {
      cancelNextFrame();
    };
  }, []);
  return [nextFrame, cancelNextFrame];
};
var useIsomorphicLayoutEffect = canUseDom() ? useLayoutEffect$3 : useEffect2;
var STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
var SkipStep = false;
var DoStep = true;
function isActive(step) {
  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
}
var useStepQueue = function(status, callback) {
  var _useState = useSafeState(STEP_NONE), _useState2 = _slicedToArray$3(_useState, 2), step = _useState2[0], setStep = _useState2[1];
  var _useNextFrame = useNextFrame(), _useNextFrame2 = _slicedToArray$3(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
  function startQueue() {
    setStep(STEP_PREPARE, true);
  }
  useIsomorphicLayoutEffect(function() {
    if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
      var index2 = STEP_QUEUE.indexOf(step);
      var nextStep = STEP_QUEUE[index2 + 1];
      var result = callback(step);
      if (result === SkipStep) {
        setStep(nextStep, true);
      } else {
        nextFrame(function(info) {
          function doNext() {
            if (info.isCanceled())
              return;
            setStep(nextStep, true);
          }
          if (result === true) {
            doNext();
          } else {
            Promise.resolve(result).then(doNext);
          }
        });
      }
    }
  }, [status, step]);
  React.useEffect(function() {
    return function() {
      cancelNextFrame();
    };
  }, []);
  return [startQueue, step];
};
var useDomMotionEvents = function(callback) {
  var cacheElementRef = useRef2();
  var callbackRef = useRef2(callback);
  callbackRef.current = callback;
  var onInternalMotionEnd = React.useCallback(function(event) {
    callbackRef.current(event);
  }, []);
  function removeMotionEvents(element) {
    if (element) {
      element.removeEventListener(transitionEndName, onInternalMotionEnd);
      element.removeEventListener(animationEndName, onInternalMotionEnd);
    }
  }
  function patchMotionEvents(element) {
    if (cacheElementRef.current && cacheElementRef.current !== element) {
      removeMotionEvents(cacheElementRef.current);
    }
    if (element && element !== cacheElementRef.current) {
      element.addEventListener(transitionEndName, onInternalMotionEnd);
      element.addEventListener(animationEndName, onInternalMotionEnd);
      cacheElementRef.current = element;
    }
  }
  React.useEffect(function() {
    return function() {
      removeMotionEvents(cacheElementRef.current);
    };
  }, []);
  return [patchMotionEvents, removeMotionEvents];
};
function useStatus(supportMotion, visible, getElement2, _ref) {
  var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
  var _useState = useSafeState(), _useState2 = _slicedToArray$3(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
  var _useState3 = useSafeState(STATUS_NONE), _useState4 = _slicedToArray$3(_useState3, 2), status = _useState4[0], setStatus = _useState4[1];
  var _useState5 = useSafeState(null), _useState6 = _slicedToArray$3(_useState5, 2), style2 = _useState6[0], setStyle3 = _useState6[1];
  var mountedRef = useRef2(false);
  var deadlineRef = useRef2(null);
  function getDomElement() {
    return getElement2();
  }
  var activeRef = useRef2(false);
  function onInternalMotionEnd(event) {
    var element = getDomElement();
    if (event && !event.deadline && event.target !== element) {
      return;
    }
    var currentActive = activeRef.current;
    var canEnd;
    if (status === STATUS_APPEAR && currentActive) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status === STATUS_ENTER && currentActive) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status === STATUS_LEAVE && currentActive) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    }
    if (status !== STATUS_NONE && currentActive && canEnd !== false) {
      setStatus(STATUS_NONE, true);
      setStyle3(null, true);
    }
  }
  var _useDomMotionEvents = useDomMotionEvents(onInternalMotionEnd), _useDomMotionEvents2 = _slicedToArray$3(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
  var eventHandlers = React.useMemo(function() {
    var _ref2, _ref3, _ref4;
    switch (status) {
      case STATUS_APPEAR:
        return _ref2 = {}, _defineProperty$4(_ref2, STEP_PREPARE, onAppearPrepare), _defineProperty$4(_ref2, STEP_START, onAppearStart), _defineProperty$4(_ref2, STEP_ACTIVE, onAppearActive), _ref2;
      case STATUS_ENTER:
        return _ref3 = {}, _defineProperty$4(_ref3, STEP_PREPARE, onEnterPrepare), _defineProperty$4(_ref3, STEP_START, onEnterStart), _defineProperty$4(_ref3, STEP_ACTIVE, onEnterActive), _ref3;
      case STATUS_LEAVE:
        return _ref4 = {}, _defineProperty$4(_ref4, STEP_PREPARE, onLeavePrepare), _defineProperty$4(_ref4, STEP_START, onLeaveStart), _defineProperty$4(_ref4, STEP_ACTIVE, onLeaveActive), _ref4;
      default:
        return {};
    }
  }, [status]);
  var _useStepQueue = useStepQueue(status, function(newStep) {
    if (newStep === STEP_PREPARE) {
      var onPrepare = eventHandlers[STEP_PREPARE];
      if (!onPrepare) {
        return SkipStep;
      }
      return onPrepare(getDomElement());
    }
    if (step in eventHandlers) {
      var _eventHandlers$step;
      setStyle3(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
    }
    if (step === STEP_ACTIVE) {
      patchMotionEvents(getDomElement());
      if (motionDeadline > 0) {
        clearTimeout(deadlineRef.current);
        deadlineRef.current = setTimeout(function() {
          onInternalMotionEnd({
            deadline: true
          });
        }, motionDeadline);
      }
    }
    return DoStep;
  }), _useStepQueue2 = _slicedToArray$3(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
  var active = isActive(step);
  activeRef.current = active;
  useIsomorphicLayoutEffect(function() {
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;
    if (!supportMotion) {
      return;
    }
    var nextStatus;
    if (!isMounted && visible && motionAppear) {
      nextStatus = STATUS_APPEAR;
    }
    if (isMounted && visible && motionEnter) {
      nextStatus = STATUS_ENTER;
    }
    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = STATUS_LEAVE;
    }
    if (nextStatus) {
      setStatus(nextStatus);
      startStep();
    }
  }, [visible]);
  useEffect2(function() {
    if (status === STATUS_APPEAR && !motionAppear || status === STATUS_ENTER && !motionEnter || status === STATUS_LEAVE && !motionLeave) {
      setStatus(STATUS_NONE);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  useEffect2(function() {
    return function() {
      mountedRef.current = false;
      clearTimeout(deadlineRef.current);
    };
  }, []);
  var firstMountChangeRef = React.useRef(false);
  useEffect2(function() {
    if (asyncVisible) {
      firstMountChangeRef.current = true;
    }
    if (asyncVisible !== void 0 && status === STATUS_NONE) {
      if (firstMountChangeRef.current || asyncVisible) {
        onVisibleChanged === null || onVisibleChanged === void 0 ? void 0 : onVisibleChanged(asyncVisible);
      }
      firstMountChangeRef.current = true;
    }
  }, [asyncVisible, status]);
  var mergedStyle = style2;
  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
    mergedStyle = _objectSpread2$1({
      transition: "none"
    }, mergedStyle);
  }
  return [status, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}
var DomWrapper = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(DomWrapper2, _React$Component);
  var _super = _createSuper$1(DomWrapper2);
  function DomWrapper2() {
    _classCallCheck$2(this, DomWrapper2);
    return _super.apply(this, arguments);
  }
  _createClass$2(DomWrapper2, [{
    key: "render",
    value: function render4() {
      return this.props.children;
    }
  }]);
  return DomWrapper2;
}(React.Component);
function genCSSMotion(config) {
  var transitionSupport = config;
  if (_typeof$5(config) === "object") {
    transitionSupport = config.transitionSupport;
  }
  function isSupportTransition(props) {
    return !!(props.motionName && transitionSupport);
  }
  var CSSMotion2 = /* @__PURE__ */ React.forwardRef(function(props, ref) {
    var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
    var supportMotion = isSupportTransition(props);
    var nodeRef = useRef2();
    var wrapperNodeRef = useRef2();
    function getDomElement() {
      try {
        return nodeRef.current instanceof HTMLElement ? nodeRef.current : findDOMNode2(wrapperNodeRef.current);
      } catch (e3) {
        return null;
      }
    }
    var _useStatus = useStatus(supportMotion, visible, getDomElement, props), _useStatus2 = _slicedToArray$3(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
    var renderedRef = React.useRef(mergedVisible);
    if (mergedVisible) {
      renderedRef.current = true;
    }
    var setNodeRef = React.useCallback(function(node) {
      nodeRef.current = node;
      fillRef(ref, node);
    }, [ref]);
    var motionChildren;
    var mergedProps = _objectSpread2$1(_objectSpread2$1({}, eventProps), {}, {
      visible
    });
    if (!children) {
      motionChildren = null;
    } else if (status === STATUS_NONE || !isSupportTransition(props)) {
      if (mergedVisible) {
        motionChildren = children(_objectSpread2$1({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current) {
        motionChildren = children(_objectSpread2$1(_objectSpread2$1({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender) {
        motionChildren = children(_objectSpread2$1(_objectSpread2$1({}, mergedProps), {}, {
          style: {
            display: "none"
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      var _classNames;
      var statusSuffix;
      if (statusStep === STEP_PREPARE) {
        statusSuffix = "prepare";
      } else if (isActive(statusStep)) {
        statusSuffix = "active";
      } else if (statusStep === STEP_START) {
        statusSuffix = "start";
      }
      motionChildren = children(_objectSpread2$1(_objectSpread2$1({}, mergedProps), {}, {
        className: cn(getTransitionName$2(motionName, status), (_classNames = {}, _defineProperty$4(_classNames, getTransitionName$2(motionName, "".concat(status, "-").concat(statusSuffix)), statusSuffix), _defineProperty$4(_classNames, motionName, typeof motionName === "string"), _classNames)),
        style: statusStyle
      }), setNodeRef);
    }
    if (/* @__PURE__ */ React.isValidElement(motionChildren) && supportRef(motionChildren)) {
      var _motionChildren = motionChildren, originNodeRef = _motionChildren.ref;
      if (!originNodeRef) {
        motionChildren = /* @__PURE__ */ React.cloneElement(motionChildren, {
          ref: setNodeRef
        });
      }
    }
    return /* @__PURE__ */ React.createElement(DomWrapper, {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion2.displayName = "CSSMotion";
  return CSSMotion2;
}
var CSSMotion = genCSSMotion(supportTransition);
var STATUS_ADD = "add";
var STATUS_KEEP = "keep";
var STATUS_REMOVE = "remove";
var STATUS_REMOVED = "removed";
function wrapKeyToObject(key2) {
  var keyObj;
  if (key2 && _typeof$5(key2) === "object" && "key" in key2) {
    keyObj = key2;
  } else {
    keyObj = {
      key: key2
    };
  }
  return _objectSpread2$1(_objectSpread2$1({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return keys2.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var list = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys);
  prevKeyObjects.forEach(function(keyObj) {
    var hit = false;
    for (var i2 = currentIndex; i2 < currentLen; i2 += 1) {
      var currentKeyObj = currentKeyObjects[i2];
      if (currentKeyObj.key === keyObj.key) {
        if (currentIndex < i2) {
          list = list.concat(currentKeyObjects.slice(currentIndex, i2).map(function(obj) {
            return _objectSpread2$1(_objectSpread2$1({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i2;
        }
        list.push(_objectSpread2$1(_objectSpread2$1({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    }
    if (!hit) {
      list.push(_objectSpread2$1(_objectSpread2$1({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  });
  if (currentIndex < currentLen) {
    list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
      return _objectSpread2$1(_objectSpread2$1({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }
  var keys2 = {};
  list.forEach(function(_ref) {
    var key2 = _ref.key;
    keys2[key2] = (keys2[key2] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys2).filter(function(key2) {
    return keys2[key2] > 1;
  });
  duplicatedKeys.forEach(function(matchKey) {
    list = list.filter(function(_ref2) {
      var key2 = _ref2.key, status = _ref2.status;
      return key2 !== matchKey || status !== STATUS_REMOVE;
    });
    list.forEach(function(node) {
      if (node.key === matchKey) {
        node.status = STATUS_KEEP;
      }
    });
  });
  return list;
}
var _excluded$a = ["component", "children", "onVisibleChanged", "onAllRemoved"];
var _excluded2$1 = ["status"];
var MOTION_PROP_NAMES = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function genCSSMotionList(transitionSupport) {
  var CSSMotion$1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CSSMotion;
  var CSSMotionList2 = /* @__PURE__ */ function(_React$Component) {
    _inherits$1(CSSMotionList3, _React$Component);
    var _super = _createSuper$1(CSSMotionList3);
    function CSSMotionList3() {
      var _this2;
      _classCallCheck$2(this, CSSMotionList3);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this2 = _super.call.apply(_super, [this].concat(args));
      _this2.state = {
        keyEntities: []
      };
      _this2.removeKey = function(removeKey) {
        var keyEntities = _this2.state.keyEntities;
        var nextKeyEntities = keyEntities.map(function(entity) {
          if (entity.key !== removeKey)
            return entity;
          return _objectSpread2$1(_objectSpread2$1({}, entity), {}, {
            status: STATUS_REMOVED
          });
        });
        _this2.setState({
          keyEntities: nextKeyEntities
        });
        return nextKeyEntities.filter(function(_ref) {
          var status = _ref.status;
          return status !== STATUS_REMOVED;
        }).length;
      };
      return _this2;
    }
    _createClass$2(CSSMotionList3, [{
      key: "render",
      value: function render4() {
        var _this2 = this;
        var keyEntities = this.state.keyEntities;
        var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = _objectWithoutProperties$1(_this$props, _excluded$a);
        var Component3 = component || React.Fragment;
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function(prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return /* @__PURE__ */ React.createElement(Component3, restProps, keyEntities.map(function(_ref2) {
          var status = _ref2.status, eventProps = _objectWithoutProperties$1(_ref2, _excluded2$1);
          var visible = status === STATUS_ADD || status === STATUS_KEEP;
          return /* @__PURE__ */ React.createElement(CSSMotion$1, _extends$2({}, motionProps, {
            key: eventProps.key,
            visible,
            eventProps,
            onVisibleChanged: function onVisibleChanged(changedVisible) {
              _onVisibleChanged === null || _onVisibleChanged === void 0 ? void 0 : _onVisibleChanged(changedVisible, {
                key: eventProps.key
              });
              if (!changedVisible) {
                var restKeysCount = _this2.removeKey(eventProps.key);
                if (restKeysCount === 0 && onAllRemoved) {
                  onAllRemoved();
                }
              }
            }
          }), children);
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys2 = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = parseKeys(keys2);
        var mixedKeyEntities = diffKeys(keyEntities, parsedKeyObjects);
        return {
          keyEntities: mixedKeyEntities.filter(function(entity) {
            var prevEntity = keyEntities.find(function(_ref5) {
              var key2 = _ref5.key;
              return entity.key === key2;
            });
            if (prevEntity && prevEntity.status === STATUS_REMOVED && entity.status === STATUS_REMOVE) {
              return false;
            }
            return true;
          })
        };
      }
    }]);
    return CSSMotionList3;
  }(React.Component);
  CSSMotionList2.defaultProps = {
    component: "div"
  };
  return CSSMotionList2;
}
var CSSMotionList = genCSSMotionList(supportTransition);
var Notice = /* @__PURE__ */ function(_Component) {
  _inherits$1(Notice2, _Component);
  var _super = _createSuper$1(Notice2);
  function Notice2() {
    var _this2;
    _classCallCheck$2(this, Notice2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super.call.apply(_super, [this].concat(args));
    _this2.closeTimer = null;
    _this2.close = function(e3) {
      if (e3) {
        e3.stopPropagation();
      }
      _this2.clearCloseTimer();
      var _this$props = _this2.props, onClose2 = _this$props.onClose, noticeKey = _this$props.noticeKey;
      if (onClose2) {
        onClose2(noticeKey);
      }
    };
    _this2.startCloseTimer = function() {
      if (_this2.props.duration) {
        _this2.closeTimer = window.setTimeout(function() {
          _this2.close();
        }, _this2.props.duration * 1e3);
      }
    };
    _this2.clearCloseTimer = function() {
      if (_this2.closeTimer) {
        clearTimeout(_this2.closeTimer);
        _this2.closeTimer = null;
      }
    };
    return _this2;
  }
  _createClass$2(Notice2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.duration !== prevProps.duration || this.props.updateMark !== prevProps.updateMark || this.props.visible !== prevProps.visible && this.props.visible) {
        this.restartCloseTimer();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: "restartCloseTimer",
    value: function restartCloseTimer() {
      this.clearCloseTimer();
      this.startCloseTimer();
    }
  }, {
    key: "render",
    value: function render4() {
      var _this2 = this;
      var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, closable = _this$props2.closable, closeIcon2 = _this$props2.closeIcon, style2 = _this$props2.style, onClick = _this$props2.onClick, children = _this$props2.children, holder = _this$props2.holder;
      var componentClass = "".concat(prefixCls, "-notice");
      var dataOrAriaAttributeProps = Object.keys(this.props).reduce(function(acc, key2) {
        if (key2.substr(0, 5) === "data-" || key2.substr(0, 5) === "aria-" || key2 === "role") {
          acc[key2] = _this2.props[key2];
        }
        return acc;
      }, {});
      var node = /* @__PURE__ */ React.createElement("div", _extends$2({
        className: cn(componentClass, className, _defineProperty$4({}, "".concat(componentClass, "-closable"), closable)),
        style: style2,
        onMouseEnter: this.clearCloseTimer,
        onMouseLeave: this.startCloseTimer,
        onClick
      }, dataOrAriaAttributeProps), /* @__PURE__ */ React.createElement("div", {
        className: "".concat(componentClass, "-content")
      }, children), closable ? /* @__PURE__ */ React.createElement("a", {
        tabIndex: 0,
        onClick: this.close,
        className: "".concat(componentClass, "-close")
      }, closeIcon2 || /* @__PURE__ */ React.createElement("span", {
        className: "".concat(componentClass, "-close-x")
      })) : null);
      if (holder) {
        return /* @__PURE__ */ ReactDOM__default.createPortal(node, holder);
      }
      return node;
    }
  }]);
  return Notice2;
}(Component2);
Notice.defaultProps = {
  onClose: function onClose() {
  },
  duration: 1.5
};
function useNotification(notificationInstance) {
  var createdRef = React.useRef({});
  var _React$useState = React.useState([]), _React$useState2 = _slicedToArray$3(_React$useState, 2), elements = _React$useState2[0], setElements = _React$useState2[1];
  function notify(noticeProps) {
    var firstMount = true;
    notificationInstance.add(noticeProps, function(div, props) {
      var key2 = props.key;
      if (div && (!createdRef.current[key2] || firstMount)) {
        var noticeEle = /* @__PURE__ */ React.createElement(Notice, _extends$2({}, props, {
          holder: div
        }));
        createdRef.current[key2] = noticeEle;
        setElements(function(originElements) {
          var index2 = originElements.findIndex(function(ele) {
            return ele.key === props.key;
          });
          if (index2 === -1) {
            return [].concat(_toConsumableArray(originElements), [noticeEle]);
          }
          var cloneList = _toConsumableArray(originElements);
          cloneList[index2] = noticeEle;
          return cloneList;
        });
      }
      firstMount = false;
    });
  }
  return [notify, /* @__PURE__ */ React.createElement(React.Fragment, null, elements)];
}
var seed = 0;
var now$3 = Date.now();
function getUuid() {
  var id2 = seed;
  seed += 1;
  return "rcNotification_".concat(now$3, "_").concat(id2);
}
var Notification = /* @__PURE__ */ function(_Component) {
  _inherits$1(Notification2, _Component);
  var _super = _createSuper$1(Notification2);
  function Notification2() {
    var _this2;
    _classCallCheck$2(this, Notification2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super.call.apply(_super, [this].concat(args));
    _this2.state = {
      notices: []
    };
    _this2.hookRefs = /* @__PURE__ */ new Map();
    _this2.add = function(originNotice, holderCallback) {
      var key2 = originNotice.key || getUuid();
      var notice2 = _objectSpread2$1(_objectSpread2$1({}, originNotice), {}, {
        key: key2
      });
      var maxCount2 = _this2.props.maxCount;
      _this2.setState(function(previousState) {
        var notices = previousState.notices;
        var noticeIndex = notices.map(function(v2) {
          return v2.notice.key;
        }).indexOf(key2);
        var updatedNotices = notices.concat();
        if (noticeIndex !== -1) {
          updatedNotices.splice(noticeIndex, 1, {
            notice: notice2,
            holderCallback
          });
        } else {
          if (maxCount2 && notices.length >= maxCount2) {
            notice2.key = updatedNotices[0].notice.key;
            notice2.updateMark = getUuid();
            notice2.userPassKey = key2;
            updatedNotices.shift();
          }
          updatedNotices.push({
            notice: notice2,
            holderCallback
          });
        }
        return {
          notices: updatedNotices
        };
      });
    };
    _this2.remove = function(removeKey) {
      _this2.setState(function(_ref) {
        var notices = _ref.notices;
        return {
          notices: notices.filter(function(_ref2) {
            var _ref2$notice = _ref2.notice, key2 = _ref2$notice.key, userPassKey = _ref2$notice.userPassKey;
            var mergedKey = userPassKey || key2;
            return mergedKey !== removeKey;
          })
        };
      });
    };
    _this2.noticePropsMap = {};
    return _this2;
  }
  _createClass$2(Notification2, [{
    key: "getTransitionName",
    value: function getTransitionName3() {
      var _this$props = this.props, prefixCls = _this$props.prefixCls, animation = _this$props.animation;
      var transitionName2 = this.props.transitionName;
      if (!transitionName2 && animation) {
        transitionName2 = "".concat(prefixCls, "-").concat(animation);
      }
      return transitionName2;
    }
  }, {
    key: "render",
    value: function render4() {
      var _this2 = this;
      var notices = this.state.notices;
      var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, closeIcon2 = _this$props2.closeIcon, style2 = _this$props2.style;
      var noticeKeys = [];
      notices.forEach(function(_ref3, index2) {
        var notice2 = _ref3.notice, holderCallback = _ref3.holderCallback;
        var updateMark = index2 === notices.length - 1 ? notice2.updateMark : void 0;
        var key2 = notice2.key, userPassKey = notice2.userPassKey;
        var noticeProps = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
          prefixCls,
          closeIcon: closeIcon2
        }, notice2), notice2.props), {}, {
          key: key2,
          noticeKey: userPassKey || key2,
          updateMark,
          onClose: function onClose2(noticeKey) {
            var _notice$onClose;
            _this2.remove(noticeKey);
            (_notice$onClose = notice2.onClose) === null || _notice$onClose === void 0 ? void 0 : _notice$onClose.call(notice2);
          },
          onClick: notice2.onClick,
          children: notice2.content
        });
        noticeKeys.push(key2);
        _this2.noticePropsMap[key2] = {
          props: noticeProps,
          holderCallback
        };
      });
      return /* @__PURE__ */ React.createElement("div", {
        className: cn(prefixCls, className),
        style: style2
      }, /* @__PURE__ */ React.createElement(CSSMotionList, {
        keys: noticeKeys,
        motionName: this.getTransitionName(),
        onVisibleChanged: function onVisibleChanged(changedVisible, _ref4) {
          var key2 = _ref4.key;
          if (!changedVisible) {
            delete _this2.noticePropsMap[key2];
          }
        }
      }, function(_ref5) {
        var key2 = _ref5.key, motionClassName = _ref5.className, motionStyle = _ref5.style, visible = _ref5.visible;
        var _this2$noticePropsMap = _this2.noticePropsMap[key2], noticeProps = _this2$noticePropsMap.props, holderCallback = _this2$noticePropsMap.holderCallback;
        if (holderCallback) {
          return /* @__PURE__ */ React.createElement("div", {
            key: key2,
            className: cn(motionClassName, "".concat(prefixCls, "-hook-holder")),
            style: _objectSpread2$1({}, motionStyle),
            ref: function ref(div) {
              if (typeof key2 === "undefined") {
                return;
              }
              if (div) {
                _this2.hookRefs.set(key2, div);
                holderCallback(div, noticeProps);
              } else {
                _this2.hookRefs.delete(key2);
              }
            }
          });
        }
        return /* @__PURE__ */ React.createElement(Notice, _extends$2({}, noticeProps, {
          className: cn(motionClassName, noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.className),
          style: _objectSpread2$1(_objectSpread2$1({}, motionStyle), noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.style),
          visible
        }));
      }));
    }
  }]);
  return Notification2;
}(Component2);
Notification.newInstance = void 0;
Notification.defaultProps = {
  prefixCls: "rc-notification",
  animation: "fade",
  style: {
    top: 65,
    left: "50%"
  }
};
Notification.newInstance = function newNotificationInstance(properties, callback) {
  var _ref6 = properties || {}, getContainer2 = _ref6.getContainer, props = _objectWithoutProperties$1(_ref6, ["getContainer"]);
  var div = document.createElement("div");
  if (getContainer2) {
    var root2 = getContainer2();
    root2.appendChild(div);
  } else {
    document.body.appendChild(div);
  }
  var called = false;
  function ref(notification) {
    if (called) {
      return;
    }
    called = true;
    callback({
      notice: function notice2(noticeProps) {
        notification.add(noticeProps);
      },
      removeNotice: function removeNotice(key2) {
        notification.remove(key2);
      },
      component: notification,
      destroy: function destroy2() {
        ReactDOM__default.unmountComponentAtNode(div);
        if (div.parentNode) {
          div.parentNode.removeChild(div);
        }
      },
      useNotification: function useNotification$1() {
        return useNotification(notification);
      }
    });
  }
  if (process.env.NODE_ENV === "test" && properties.TEST_RENDER) {
    properties.TEST_RENDER(/* @__PURE__ */ React.createElement(Notification, _extends$2({}, props, {
      ref
    })));
    return;
  }
  ReactDOM__default.render(/* @__PURE__ */ React.createElement(Notification, _extends$2({}, props, {
    ref
  })), div);
};
var LoadingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, "name": "loading", "theme": "outlined" };
function bound01(n3, max) {
  if (isOnePointZero(n3)) {
    n3 = "100%";
  }
  var isPercent = isPercentage(n3);
  n3 = max === 360 ? n3 : Math.min(max, Math.max(0, parseFloat(n3)));
  if (isPercent) {
    n3 = parseInt(String(n3 * max), 10) / 100;
  }
  if (Math.abs(n3 - max) < 1e-6) {
    return 1;
  }
  if (max === 360) {
    n3 = (n3 < 0 ? n3 % max + max : n3 % max) / parseFloat(String(max));
  } else {
    n3 = n3 % max / parseFloat(String(max));
  }
  return n3;
}
function isOnePointZero(n3) {
  return typeof n3 === "string" && n3.indexOf(".") !== -1 && parseFloat(n3) === 1;
}
function isPercentage(n3) {
  return typeof n3 === "string" && n3.indexOf("%") !== -1;
}
function boundAlpha(a2) {
  a2 = parseFloat(a2);
  if (isNaN(a2) || a2 < 0 || a2 > 1) {
    a2 = 1;
  }
  return a2;
}
function convertToPercentage(n3) {
  if (n3 <= 1) {
    return "".concat(Number(n3) * 100, "%");
  }
  return n3;
}
function pad2(c2) {
  return c2.length === 1 ? "0" + c2 : String(c2);
}
function rgbToRgb(r3, g2, b2) {
  return {
    r: bound01(r3, 255) * 255,
    g: bound01(g2, 255) * 255,
    b: bound01(b2, 255) * 255
  };
}
function hue2rgb(p, q2, t3) {
  if (t3 < 0) {
    t3 += 1;
  }
  if (t3 > 1) {
    t3 -= 1;
  }
  if (t3 < 1 / 6) {
    return p + (q2 - p) * (6 * t3);
  }
  if (t3 < 1 / 2) {
    return q2;
  }
  if (t3 < 2 / 3) {
    return p + (q2 - p) * (2 / 3 - t3) * 6;
  }
  return p;
}
function hslToRgb(h, s2, l2) {
  var r3;
  var g2;
  var b2;
  h = bound01(h, 360);
  s2 = bound01(s2, 100);
  l2 = bound01(l2, 100);
  if (s2 === 0) {
    g2 = l2;
    b2 = l2;
    r3 = l2;
  } else {
    var q2 = l2 < 0.5 ? l2 * (1 + s2) : l2 + s2 - l2 * s2;
    var p = 2 * l2 - q2;
    r3 = hue2rgb(p, q2, h + 1 / 3);
    g2 = hue2rgb(p, q2, h);
    b2 = hue2rgb(p, q2, h - 1 / 3);
  }
  return { r: r3 * 255, g: g2 * 255, b: b2 * 255 };
}
function rgbToHsv(r3, g2, b2) {
  r3 = bound01(r3, 255);
  g2 = bound01(g2, 255);
  b2 = bound01(b2, 255);
  var max = Math.max(r3, g2, b2);
  var min = Math.min(r3, g2, b2);
  var h = 0;
  var v2 = max;
  var d = max - min;
  var s2 = max === 0 ? 0 : d / max;
  if (max === min) {
    h = 0;
  } else {
    switch (max) {
      case r3:
        h = (g2 - b2) / d + (g2 < b2 ? 6 : 0);
        break;
      case g2:
        h = (b2 - r3) / d + 2;
        break;
      case b2:
        h = (r3 - g2) / d + 4;
        break;
    }
    h /= 6;
  }
  return { h, s: s2, v: v2 };
}
function hsvToRgb(h, s2, v2) {
  h = bound01(h, 360) * 6;
  s2 = bound01(s2, 100);
  v2 = bound01(v2, 100);
  var i2 = Math.floor(h);
  var f3 = h - i2;
  var p = v2 * (1 - s2);
  var q2 = v2 * (1 - f3 * s2);
  var t3 = v2 * (1 - (1 - f3) * s2);
  var mod = i2 % 6;
  var r3 = [v2, q2, p, p, t3, v2][mod];
  var g2 = [t3, v2, v2, q2, p, p][mod];
  var b2 = [p, p, t3, v2, v2, q2][mod];
  return { r: r3 * 255, g: g2 * 255, b: b2 * 255 };
}
function rgbToHex(r3, g2, b2, allow3Char) {
  var hex2 = [
    pad2(Math.round(r3).toString(16)),
    pad2(Math.round(g2).toString(16)),
    pad2(Math.round(b2).toString(16))
  ];
  if (allow3Char && hex2[0].startsWith(hex2[0].charAt(1)) && hex2[1].startsWith(hex2[1].charAt(1)) && hex2[2].startsWith(hex2[2].charAt(1))) {
    return hex2[0].charAt(0) + hex2[1].charAt(0) + hex2[2].charAt(0);
  }
  return hex2.join("");
}
function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}
function parseIntFromHex(val) {
  return parseInt(val, 16);
}
var names = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function inputToRGB(color) {
  var rgb = { r: 0, g: 0, b: 0 };
  var a2 = 1;
  var s2 = null;
  var v2 = null;
  var l2 = null;
  var ok = false;
  var format3 = false;
  if (typeof color === "string") {
    color = stringInputToObject(color);
  }
  if (typeof color === "object") {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format3 = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s2 = convertToPercentage(color.s);
      v2 = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s2, v2);
      ok = true;
      format3 = "hsv";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s2 = convertToPercentage(color.s);
      l2 = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s2, l2);
      ok = true;
      format3 = "hsl";
    }
    if (Object.prototype.hasOwnProperty.call(color, "a")) {
      a2 = color.a;
    }
  }
  a2 = boundAlpha(a2);
  return {
    ok,
    format: color.format || format3,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a: a2
  };
}
var CSS_INTEGER = "[-\\+]?\\d+%?";
var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
var CSS_UNIT = "(?:".concat(CSS_NUMBER, ")|(?:").concat(CSS_INTEGER, ")");
var PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
var PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
var matchers = {
  CSS_UNIT: new RegExp(CSS_UNIT),
  rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
  rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
  hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
  hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
  hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
  hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function stringInputToObject(color) {
  color = color.trim().toLowerCase();
  if (color.length === 0) {
    return false;
  }
  var named = false;
  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color === "transparent") {
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  }
  var match2 = matchers.rgb.exec(color);
  if (match2) {
    return { r: match2[1], g: match2[2], b: match2[3] };
  }
  match2 = matchers.rgba.exec(color);
  if (match2) {
    return { r: match2[1], g: match2[2], b: match2[3], a: match2[4] };
  }
  match2 = matchers.hsl.exec(color);
  if (match2) {
    return { h: match2[1], s: match2[2], l: match2[3] };
  }
  match2 = matchers.hsla.exec(color);
  if (match2) {
    return { h: match2[1], s: match2[2], l: match2[3], a: match2[4] };
  }
  match2 = matchers.hsv.exec(color);
  if (match2) {
    return { h: match2[1], s: match2[2], v: match2[3] };
  }
  match2 = matchers.hsva.exec(color);
  if (match2) {
    return { h: match2[1], s: match2[2], v: match2[3], a: match2[4] };
  }
  match2 = matchers.hex8.exec(color);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1]),
      g: parseIntFromHex(match2[2]),
      b: parseIntFromHex(match2[3]),
      a: convertHexToDecimal(match2[4]),
      format: named ? "name" : "hex8"
    };
  }
  match2 = matchers.hex6.exec(color);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1]),
      g: parseIntFromHex(match2[2]),
      b: parseIntFromHex(match2[3]),
      format: named ? "name" : "hex"
    };
  }
  match2 = matchers.hex4.exec(color);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1] + match2[1]),
      g: parseIntFromHex(match2[2] + match2[2]),
      b: parseIntFromHex(match2[3] + match2[3]),
      a: convertHexToDecimal(match2[4] + match2[4]),
      format: named ? "name" : "hex8"
    };
  }
  match2 = matchers.hex3.exec(color);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1] + match2[1]),
      g: parseIntFromHex(match2[2] + match2[2]),
      b: parseIntFromHex(match2[3] + match2[3]),
      format: named ? "name" : "hex"
    };
  }
  return false;
}
function isValidCSSUnit(color) {
  return Boolean(matchers.CSS_UNIT.exec(String(color)));
}
var hueStep = 2;
var saturationStep = 0.16;
var saturationStep2 = 0.05;
var brightnessStep1 = 0.05;
var brightnessStep2 = 0.15;
var lightColorCount = 5;
var darkColorCount = 4;
var darkColorMap = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function toHsv(_ref) {
  var r3 = _ref.r, g2 = _ref.g, b2 = _ref.b;
  var hsv = rgbToHsv(r3, g2, b2);
  return {
    h: hsv.h * 360,
    s: hsv.s,
    v: hsv.v
  };
}
function toHex(_ref2) {
  var r3 = _ref2.r, g2 = _ref2.g, b2 = _ref2.b;
  return "#".concat(rgbToHex(r3, g2, b2, false));
}
function mix$1(rgb1, rgb2, amount) {
  var p = amount / 100;
  var rgb = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b
  };
  return rgb;
}
function getHue(hsv, i2, light) {
  var hue;
  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i2 : Math.round(hsv.h) + hueStep * i2;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i2 : Math.round(hsv.h) - hueStep * i2;
  }
  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }
  return hue;
}
function getSaturation(hsv, i2, light) {
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }
  var saturation;
  if (light) {
    saturation = hsv.s - saturationStep * i2;
  } else if (i2 === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i2;
  }
  if (saturation > 1) {
    saturation = 1;
  }
  if (light && i2 === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }
  if (saturation < 0.06) {
    saturation = 0.06;
  }
  return Number(saturation.toFixed(2));
}
function getValue$3(hsv, i2, light) {
  var value;
  if (light) {
    value = hsv.v + brightnessStep1 * i2;
  } else {
    value = hsv.v - brightnessStep2 * i2;
  }
  if (value > 1) {
    value = 1;
  }
  return Number(value.toFixed(2));
}
function generate$1(color) {
  var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var patterns = [];
  var pColor = inputToRGB(color);
  for (var i2 = lightColorCount; i2 > 0; i2 -= 1) {
    var hsv = toHsv(pColor);
    var colorString = toHex(inputToRGB({
      h: getHue(hsv, i2, true),
      s: getSaturation(hsv, i2, true),
      v: getValue$3(hsv, i2, true)
    }));
    patterns.push(colorString);
  }
  patterns.push(toHex(pColor));
  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _hsv = toHsv(pColor);
    var _colorString = toHex(inputToRGB({
      h: getHue(_hsv, _i),
      s: getSaturation(_hsv, _i),
      v: getValue$3(_hsv, _i)
    }));
    patterns.push(_colorString);
  }
  if (opts.theme === "dark") {
    return darkColorMap.map(function(_ref3) {
      var index2 = _ref3.index, opacity = _ref3.opacity;
      var darkColorString = toHex(mix$1(inputToRGB(opts.backgroundColor || "#141414"), inputToRGB(patterns[index2]), opacity * 100));
      return darkColorString;
    });
  }
  return patterns;
}
var presetPrimaryColors = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1890FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
};
var presetPalettes = {};
var presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach(function(key2) {
  presetPalettes[key2] = generate$1(presetPrimaryColors[key2]);
  presetPalettes[key2].primary = presetPalettes[key2][5];
  presetDarkPalettes[key2] = generate$1(presetPrimaryColors[key2], {
    theme: "dark",
    backgroundColor: "#141414"
  });
  presetDarkPalettes[key2].primary = presetDarkPalettes[key2][5];
});
var MARK_KEY = "rc-util-key";
function getMark() {
  var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mark = _ref.mark;
  if (mark) {
    return mark.startsWith("data-") ? mark : "data-".concat(mark);
  }
  return MARK_KEY;
}
function getContainer$1(option) {
  if (option.attachTo) {
    return option.attachTo;
  }
  var head = document.querySelector("head");
  return head || document.body;
}
function injectCSS(css2) {
  var _option$csp;
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!canUseDom()) {
    return null;
  }
  var styleNode = document.createElement("style");
  if ((_option$csp = option.csp) === null || _option$csp === void 0 ? void 0 : _option$csp.nonce) {
    var _option$csp2;
    styleNode.nonce = (_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce;
  }
  styleNode.innerHTML = css2;
  var container = getContainer$1(option);
  var firstChild = container.firstChild;
  if (option.prepend && container.prepend) {
    container.prepend(styleNode);
  } else if (option.prepend && firstChild) {
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }
  return styleNode;
}
var containerCache = /* @__PURE__ */ new Map();
function findExistNode(key2) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var container = getContainer$1(option);
  return Array.from(containerCache.get(container).children).find(function(node) {
    return node.tagName === "STYLE" && node.getAttribute(getMark(option)) === key2;
  });
}
function updateCSS(css2, key2) {
  var option = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var container = getContainer$1(option);
  if (!containerCache.has(container)) {
    var placeholderStyle = injectCSS("", option);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    parentNode.removeChild(placeholderStyle);
  }
  var existNode = findExistNode(key2, option);
  if (existNode) {
    var _option$csp3, _option$csp4;
    if (((_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce) && existNode.nonce !== ((_option$csp4 = option.csp) === null || _option$csp4 === void 0 ? void 0 : _option$csp4.nonce)) {
      var _option$csp5;
      existNode.nonce = (_option$csp5 = option.csp) === null || _option$csp5 === void 0 ? void 0 : _option$csp5.nonce;
    }
    if (existNode.innerHTML !== css2) {
      existNode.innerHTML = css2;
    }
    return existNode;
  }
  var newNode = injectCSS(css2, option);
  newNode.setAttribute(getMark(option), key2);
  return newNode;
}
function warning2(valid, message) {
  warningOnce(valid, "[@ant-design/icons] ".concat(message));
}
function isIconDefinition(target) {
  return _typeof$5(target) === "object" && typeof target.name === "string" && typeof target.theme === "string" && (_typeof$5(target.icon) === "object" || typeof target.icon === "function");
}
function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(attrs).reduce(function(acc, key2) {
    var val = attrs[key2];
    switch (key2) {
      case "class":
        acc.className = val;
        delete acc.class;
        break;
      default:
        acc[key2] = val;
    }
    return acc;
  }, {});
}
function generate(node, key2, rootProps) {
  if (!rootProps) {
    return /* @__PURE__ */ React__default.createElement(node.tag, _objectSpread2$1({
      key: key2
    }, normalizeAttrs(node.attrs)), (node.children || []).map(function(child, index2) {
      return generate(child, "".concat(key2, "-").concat(node.tag, "-").concat(index2));
    }));
  }
  return /* @__PURE__ */ React__default.createElement(node.tag, _objectSpread2$1(_objectSpread2$1({
    key: key2
  }, normalizeAttrs(node.attrs)), rootProps), (node.children || []).map(function(child, index2) {
    return generate(child, "".concat(key2, "-").concat(node.tag, "-").concat(index2));
  }));
}
function getSecondaryColor(primaryColor) {
  return generate$1(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }
  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
}
var iconStyles = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var useInsertStyles = function useInsertStyles2() {
  var styleStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : iconStyles;
  var _useContext = useContext2(IconContext), csp = _useContext.csp;
  useEffect2(function() {
    updateCSS(styleStr, "@ant-design-icons", {
      prepend: true,
      csp
    });
  }, []);
};
var _excluded$9 = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"];
var twoToneColorPalette = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: false
};
function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}
function getTwoToneColors() {
  return _objectSpread2$1({}, twoToneColorPalette);
}
var IconBase = function IconBase2(props) {
  var icon = props.icon, className = props.className, onClick = props.onClick, style2 = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = _objectWithoutProperties$1(props, _excluded$9);
  var colors2 = twoToneColorPalette;
  if (primaryColor) {
    colors2 = {
      primaryColor,
      secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
    };
  }
  useInsertStyles();
  warning2(isIconDefinition(icon), "icon should be icon definiton, but got ".concat(icon));
  if (!isIconDefinition(icon)) {
    return null;
  }
  var target = icon;
  if (target && typeof target.icon === "function") {
    target = _objectSpread2$1(_objectSpread2$1({}, target), {}, {
      icon: target.icon(colors2.primaryColor, colors2.secondaryColor)
    });
  }
  return generate(target.icon, "svg-".concat(target.name), _objectSpread2$1({
    className,
    onClick,
    style: style2,
    "data-icon": target.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, restProps));
};
IconBase.displayName = "IconReact";
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;
function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor), _normalizeTwoToneColo2 = _slicedToArray$3(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
  return IconBase.setTwoToneColors({
    primaryColor,
    secondaryColor
  });
}
function getTwoToneColor() {
  var colors2 = IconBase.getTwoToneColors();
  if (!colors2.calculated) {
    return colors2.primaryColor;
  }
  return [colors2.primaryColor, colors2.secondaryColor];
}
var _excluded$8 = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
setTwoToneColor("#1890ff");
var Icon$1 = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var _classNames;
  var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = _objectWithoutProperties$1(props, _excluded$8);
  var _React$useContext = React.useContext(IconContext), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? "anticon" : _React$useContext$pre;
  var classString = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), _defineProperty$4(_classNames, "".concat(prefixCls, "-spin"), !!spin || icon.name === "loading"), _classNames), className);
  var iconTabIndex = tabIndex;
  if (iconTabIndex === void 0 && onClick) {
    iconTabIndex = -1;
  }
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : void 0;
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor), _normalizeTwoToneColo2 = _slicedToArray$3(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
  return /* @__PURE__ */ React.createElement("span", _objectSpread2$1(_objectSpread2$1({
    role: "img",
    "aria-label": icon.name
  }, restProps), {}, {
    ref,
    tabIndex: iconTabIndex,
    onClick,
    className: classString
  }), /* @__PURE__ */ React.createElement(IconBase, {
    icon,
    primaryColor,
    secondaryColor,
    style: svgStyle
  }));
});
Icon$1.displayName = "AntdIcon";
Icon$1.getTwoToneColor = getTwoToneColor;
Icon$1.setTwoToneColor = setTwoToneColor;
var LoadingOutlined = function LoadingOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: LoadingOutlined$2
  }));
};
LoadingOutlined.displayName = "LoadingOutlined";
var LoadingOutlined$1 = /* @__PURE__ */ React.forwardRef(LoadingOutlined);
var ExclamationCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "exclamation-circle", "theme": "filled" };
var ExclamationCircleFilled = function ExclamationCircleFilled2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: ExclamationCircleFilled$2
  }));
};
ExclamationCircleFilled.displayName = "ExclamationCircleFilled";
var ExclamationCircleFilled$1 = /* @__PURE__ */ React.forwardRef(ExclamationCircleFilled);
var CloseCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" } }] }, "name": "close-circle", "theme": "filled" };
var CloseCircleFilled = function CloseCircleFilled2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: CloseCircleFilled$2
  }));
};
CloseCircleFilled.displayName = "CloseCircleFilled";
var CloseCircleFilled$1 = /* @__PURE__ */ React.forwardRef(CloseCircleFilled);
var CheckCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "check-circle", "theme": "filled" };
var CheckCircleFilled = function CheckCircleFilled2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: CheckCircleFilled$2
  }));
};
CheckCircleFilled.displayName = "CheckCircleFilled";
var CheckCircleFilled$1 = /* @__PURE__ */ React.forwardRef(CheckCircleFilled);
var InfoCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "info-circle", "theme": "filled" };
var InfoCircleFilled = function InfoCircleFilled2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: InfoCircleFilled$2
  }));
};
InfoCircleFilled.displayName = "InfoCircleFilled";
var InfoCircleFilled$1 = /* @__PURE__ */ React.forwardRef(InfoCircleFilled);
function createUseMessage(getRcNotificationInstance, getRCNoticeProps2) {
  var useMessage = function useMessage2() {
    var getPrefixCls;
    var innerInstance = null;
    var proxy = {
      add: function add(noticeProps, holderCallback) {
        innerInstance === null || innerInstance === void 0 ? void 0 : innerInstance.component.add(noticeProps, holderCallback);
      }
    };
    var _useRCNotification = useNotification(proxy), _useRCNotification2 = _slicedToArray$3(_useRCNotification, 2), hookNotify = _useRCNotification2[0], holder = _useRCNotification2[1];
    function notify(args) {
      var customizePrefixCls = args.prefixCls;
      var mergedPrefixCls = getPrefixCls("message", customizePrefixCls);
      var rootPrefixCls = getPrefixCls();
      var target = args.key || getKeyThenIncreaseKey();
      var closePromise = new Promise(function(resolve) {
        var callback = function callback2() {
          if (typeof args.onClose === "function") {
            args.onClose();
          }
          return resolve(true);
        };
        getRcNotificationInstance(_extends$2(_extends$2({}, args), {
          prefixCls: mergedPrefixCls,
          rootPrefixCls
        }), function(_ref) {
          var prefixCls = _ref.prefixCls, instance = _ref.instance;
          innerInstance = instance;
          hookNotify(getRCNoticeProps2(_extends$2(_extends$2({}, args), {
            key: target,
            onClose: callback
          }), prefixCls));
        });
      });
      var result = function result2() {
        if (innerInstance) {
          innerInstance.removeNotice(target);
        }
      };
      result.then = function(filled, rejected) {
        return closePromise.then(filled, rejected);
      };
      result.promise = closePromise;
      return result;
    }
    var hookApiRef = React.useRef({});
    hookApiRef.current.open = notify;
    ["success", "info", "warning", "error", "loading"].forEach(function(type2) {
      return attachTypeApi(hookApiRef.current, type2);
    });
    return [hookApiRef.current, /* @__PURE__ */ React.createElement(ConfigConsumer, {
      key: "holder"
    }, function(context2) {
      getPrefixCls = context2.getPrefixCls;
      return holder;
    })];
  };
  return useMessage;
}
var messageInstance;
var defaultDuration = 3;
var defaultTop;
var key = 1;
var localPrefixCls = "";
var transitionName = "move-up";
var hasTransitionName = false;
var getContainer;
var maxCount;
var rtl = false;
function getKeyThenIncreaseKey() {
  return key++;
}
function setMessageConfig(options) {
  if (options.top !== void 0) {
    defaultTop = options.top;
    messageInstance = null;
  }
  if (options.duration !== void 0) {
    defaultDuration = options.duration;
  }
  if (options.prefixCls !== void 0) {
    localPrefixCls = options.prefixCls;
  }
  if (options.getContainer !== void 0) {
    getContainer = options.getContainer;
  }
  if (options.transitionName !== void 0) {
    transitionName = options.transitionName;
    messageInstance = null;
    hasTransitionName = true;
  }
  if (options.maxCount !== void 0) {
    maxCount = options.maxCount;
    messageInstance = null;
  }
  if (options.rtl !== void 0) {
    rtl = options.rtl;
  }
}
function getRCNotificationInstance(args, callback) {
  var customizePrefixCls = args.prefixCls;
  var _globalConfig = globalConfig(), getPrefixCls = _globalConfig.getPrefixCls, getRootPrefixCls = _globalConfig.getRootPrefixCls;
  var prefixCls = getPrefixCls("message", customizePrefixCls || localPrefixCls);
  var rootPrefixCls = getRootPrefixCls(args.rootPrefixCls, prefixCls);
  if (messageInstance) {
    callback({
      prefixCls,
      rootPrefixCls,
      instance: messageInstance
    });
    return;
  }
  var instanceConfig = {
    prefixCls,
    transitionName: hasTransitionName ? transitionName : "".concat(rootPrefixCls, "-").concat(transitionName),
    style: {
      top: defaultTop
    },
    getContainer,
    maxCount
  };
  Notification.newInstance(instanceConfig, function(instance) {
    if (messageInstance) {
      callback({
        prefixCls,
        rootPrefixCls,
        instance: messageInstance
      });
      return;
    }
    messageInstance = instance;
    if (process.env.NODE_ENV === "test") {
      messageInstance.config = instanceConfig;
    }
    callback({
      prefixCls,
      rootPrefixCls,
      instance
    });
  });
}
var typeToIcon = {
  info: InfoCircleFilled$1,
  success: CheckCircleFilled$1,
  error: CloseCircleFilled$1,
  warning: ExclamationCircleFilled$1,
  loading: LoadingOutlined$1
};
function getRCNoticeProps(args, prefixCls) {
  var _classNames;
  var duration = args.duration !== void 0 ? args.duration : defaultDuration;
  var IconComponent2 = typeToIcon[args.type];
  var messageClass = cn("".concat(prefixCls, "-custom-content"), (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(args.type), args.type), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), rtl === true), _classNames));
  return {
    key: args.key,
    duration,
    style: args.style || {},
    className: args.className,
    content: /* @__PURE__ */ React.createElement("div", {
      className: messageClass
    }, args.icon || IconComponent2 && /* @__PURE__ */ React.createElement(IconComponent2, null), /* @__PURE__ */ React.createElement("span", null, args.content)),
    onClose: args.onClose,
    onClick: args.onClick
  };
}
function notice(args) {
  var target = args.key || key++;
  var closePromise = new Promise(function(resolve) {
    var callback = function callback2() {
      if (typeof args.onClose === "function") {
        args.onClose();
      }
      return resolve(true);
    };
    getRCNotificationInstance(args, function(_ref) {
      var prefixCls = _ref.prefixCls, instance = _ref.instance;
      instance.notice(getRCNoticeProps(_extends$2(_extends$2({}, args), {
        key: target,
        onClose: callback
      }), prefixCls));
    });
  });
  var result = function result2() {
    if (messageInstance) {
      messageInstance.removeNotice(target);
    }
  };
  result.then = function(filled, rejected) {
    return closePromise.then(filled, rejected);
  };
  result.promise = closePromise;
  return result;
}
function isArgsProps(content) {
  return Object.prototype.toString.call(content) === "[object Object]" && !!content.content;
}
var api = {
  open: notice,
  config: setMessageConfig,
  destroy: function destroy(messageKey) {
    if (messageInstance) {
      if (messageKey) {
        var _messageInstance = messageInstance, removeNotice = _messageInstance.removeNotice;
        removeNotice(messageKey);
      } else {
        var _messageInstance2 = messageInstance, destroy2 = _messageInstance2.destroy;
        destroy2();
        messageInstance = null;
      }
    }
  }
};
function attachTypeApi(originalApi, type2) {
  originalApi[type2] = function(content, duration, onClose2) {
    if (isArgsProps(content)) {
      return originalApi.open(_extends$2(_extends$2({}, content), {
        type: type2
      }));
    }
    if (typeof duration === "function") {
      onClose2 = duration;
      duration = void 0;
    }
    return originalApi.open({
      content,
      duration,
      type: type2,
      onClose: onClose2
    });
  };
}
["success", "info", "warning", "error", "loading"].forEach(function(type2) {
  return attachTypeApi(api, type2);
});
api.warn = api.warning;
api.useMessage = createUseMessage(getRCNotificationInstance, getRCNoticeProps);
var CloseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" } }] }, "name": "close", "theme": "outlined" };
var CloseOutlined = function CloseOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: CloseOutlined$2
  }));
};
CloseOutlined.displayName = "CloseOutlined";
var CloseOutlined$1 = /* @__PURE__ */ React.forwardRef(CloseOutlined);
var CheckCircleOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "check-circle", "theme": "outlined" };
var CheckCircleOutlined = function CheckCircleOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: CheckCircleOutlined$1
  }));
};
CheckCircleOutlined.displayName = "CheckCircleOutlined";
var CloseCircleOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z" } }, { "tag": "path", "attrs": { "d": "M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "close-circle", "theme": "outlined" };
var CloseCircleOutlined = function CloseCircleOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: CloseCircleOutlined$1
  }));
};
CloseCircleOutlined.displayName = "CloseCircleOutlined";
var ExclamationCircleOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] }, "name": "exclamation-circle", "theme": "outlined" };
var ExclamationCircleOutlined = function ExclamationCircleOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: ExclamationCircleOutlined$1
  }));
};
ExclamationCircleOutlined.displayName = "ExclamationCircleOutlined";
var InfoCircleOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, "name": "info-circle", "theme": "outlined" };
var InfoCircleOutlined = function InfoCircleOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: InfoCircleOutlined$1
  }));
};
InfoCircleOutlined.displayName = "InfoCircleOutlined";
var configConsumerProps = ["getTargetContainer", "getPopupContainer", "rootPrefixCls", "getPrefixCls", "renderEmpty", "csp", "autoInsertSpaceInButton", "locale", "pageHeader"];
var defaultPrefixCls = "ant";
function getGlobalPrefixCls() {
  return defaultPrefixCls;
}
var globalConfig = function globalConfig2() {
  return {
    getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
      if (customizePrefixCls)
        return customizePrefixCls;
      return suffixCls ? "".concat(getGlobalPrefixCls(), "-").concat(suffixCls) : getGlobalPrefixCls();
    },
    getRootPrefixCls: function getRootPrefixCls(rootPrefixCls, customizePrefixCls) {
      if (rootPrefixCls) {
        return rootPrefixCls;
      }
      if (customizePrefixCls && customizePrefixCls.includes("-")) {
        return customizePrefixCls.replace(/^(.*)-[^-]*$/, "$1");
      }
      return getGlobalPrefixCls();
    }
  };
};
function throttleByAnimationFrame(fn) {
  var requestId;
  var later = function later2(args) {
    return function() {
      requestId = null;
      fn.apply(void 0, _toConsumableArray(args));
    };
  };
  var throttled = function throttled2() {
    if (requestId == null) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      requestId = wrapperRaf$1(later(args));
    }
  };
  throttled.cancel = function() {
    return wrapperRaf$1.cancel(requestId);
  };
  return throttled;
}
function throttleByAnimationFrameDecorator() {
  return function throttle2(target, key2, descriptor) {
    var fn = descriptor.value;
    var definingProperty = false;
    return {
      configurable: true,
      get: function get2() {
        if (definingProperty || this === target.prototype || this.hasOwnProperty(key2)) {
          return fn;
        }
        var boundFn = throttleByAnimationFrame(fn.bind(this));
        definingProperty = true;
        Object.defineProperty(this, key2, {
          value: boundFn,
          configurable: true,
          writable: true
        });
        definingProperty = false;
        return boundFn;
      }
    };
  };
}
function addEventListenerWrap(target, eventType, cb, option) {
  var callback = ReactDOM__default.unstable_batchedUpdates ? function run(e3) {
    ReactDOM__default.unstable_batchedUpdates(cb, e3);
  } : cb;
  if (target.addEventListener) {
    target.addEventListener(eventType, callback, option);
  }
  return {
    remove: function remove() {
      if (target.removeEventListener) {
        target.removeEventListener(eventType, callback, option);
      }
    }
  };
}
function getTargetRect(target) {
  return target !== window ? target.getBoundingClientRect() : {
    top: 0,
    bottom: window.innerHeight
  };
}
function getFixedTop(placeholderReact, targetRect, offsetTop) {
  if (offsetTop !== void 0 && targetRect.top > placeholderReact.top - offsetTop) {
    return offsetTop + targetRect.top;
  }
  return void 0;
}
function getFixedBottom(placeholderReact, targetRect, offsetBottom) {
  if (offsetBottom !== void 0 && targetRect.bottom < placeholderReact.bottom + offsetBottom) {
    var targetBottomOffset = window.innerHeight - targetRect.bottom;
    return offsetBottom + targetBottomOffset;
  }
  return void 0;
}
var TRIGGER_EVENTS = ["resize", "scroll", "touchstart", "touchmove", "touchend", "pageshow", "load"];
var observerEntities = [];
function addObserveTarget(target, affix) {
  if (!target)
    return;
  var entity = observerEntities.find(function(item) {
    return item.target === target;
  });
  if (entity) {
    entity.affixList.push(affix);
  } else {
    entity = {
      target,
      affixList: [affix],
      eventHandlers: {}
    };
    observerEntities.push(entity);
    TRIGGER_EVENTS.forEach(function(eventName) {
      entity.eventHandlers[eventName] = addEventListenerWrap(target, eventName, function() {
        entity.affixList.forEach(function(targetAffix) {
          targetAffix.lazyUpdatePosition();
        });
      });
    });
  }
}
function removeObserveTarget(affix) {
  var observerEntity = observerEntities.find(function(oriObserverEntity) {
    var hasAffix = oriObserverEntity.affixList.some(function(item) {
      return item === affix;
    });
    if (hasAffix) {
      oriObserverEntity.affixList = oriObserverEntity.affixList.filter(function(item) {
        return item !== affix;
      });
    }
    return hasAffix;
  });
  if (observerEntity && observerEntity.affixList.length === 0) {
    observerEntities = observerEntities.filter(function(item) {
      return item !== observerEntity;
    });
    TRIGGER_EVENTS.forEach(function(eventName) {
      var handler = observerEntity.eventHandlers[eventName];
      if (handler && handler.remove) {
        handler.remove();
      }
    });
  }
}
var __decorate = function(decorators, target, key2, desc) {
  var c2 = arguments.length, r3 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key2) : desc, d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof$5(Reflect)) === "object" && typeof Reflect.decorate === "function")
    r3 = Reflect.decorate(decorators, target, key2, desc);
  else
    for (var i2 = decorators.length - 1; i2 >= 0; i2--) {
      if (d = decorators[i2])
        r3 = (c2 < 3 ? d(r3) : c2 > 3 ? d(target, key2, r3) : d(target, key2)) || r3;
    }
  return c2 > 3 && r3 && Object.defineProperty(target, key2, r3), r3;
};
function getDefaultTarget() {
  return typeof window !== "undefined" ? window : null;
}
var AffixStatus;
(function(AffixStatus2) {
  AffixStatus2[AffixStatus2["None"] = 0] = "None";
  AffixStatus2[AffixStatus2["Prepare"] = 1] = "Prepare";
})(AffixStatus || (AffixStatus = {}));
var Affix = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Affix2, _React$Component);
  var _super = _createSuper$1(Affix2);
  function Affix2() {
    var _this2;
    _classCallCheck$2(this, Affix2);
    _this2 = _super.apply(this, arguments);
    _this2.state = {
      status: AffixStatus.None,
      lastAffix: false,
      prevTarget: null
    };
    _this2.getOffsetTop = function() {
      var offsetBottom = _this2.props.offsetBottom;
      var offsetTop = _this2.props.offsetTop;
      if (offsetBottom === void 0 && offsetTop === void 0) {
        offsetTop = 0;
      }
      return offsetTop;
    };
    _this2.getOffsetBottom = function() {
      return _this2.props.offsetBottom;
    };
    _this2.savePlaceholderNode = function(node) {
      _this2.placeholderNode = node;
    };
    _this2.saveFixedNode = function(node) {
      _this2.fixedNode = node;
    };
    _this2.measure = function() {
      var _this$state = _this2.state, status = _this$state.status, lastAffix = _this$state.lastAffix;
      var onChange4 = _this2.props.onChange;
      var targetFunc = _this2.getTargetFunc();
      if (status !== AffixStatus.Prepare || !_this2.fixedNode || !_this2.placeholderNode || !targetFunc) {
        return;
      }
      var offsetTop = _this2.getOffsetTop();
      var offsetBottom = _this2.getOffsetBottom();
      var targetNode = targetFunc();
      if (!targetNode) {
        return;
      }
      var newState = {
        status: AffixStatus.None
      };
      var targetRect = getTargetRect(targetNode);
      var placeholderReact = getTargetRect(_this2.placeholderNode);
      var fixedTop = getFixedTop(placeholderReact, targetRect, offsetTop);
      var fixedBottom = getFixedBottom(placeholderReact, targetRect, offsetBottom);
      if (fixedTop !== void 0) {
        newState.affixStyle = {
          position: "fixed",
          top: fixedTop,
          width: placeholderReact.width,
          height: placeholderReact.height
        };
        newState.placeholderStyle = {
          width: placeholderReact.width,
          height: placeholderReact.height
        };
      } else if (fixedBottom !== void 0) {
        newState.affixStyle = {
          position: "fixed",
          bottom: fixedBottom,
          width: placeholderReact.width,
          height: placeholderReact.height
        };
        newState.placeholderStyle = {
          width: placeholderReact.width,
          height: placeholderReact.height
        };
      }
      newState.lastAffix = !!newState.affixStyle;
      if (onChange4 && lastAffix !== newState.lastAffix) {
        onChange4(newState.lastAffix);
      }
      _this2.setState(newState);
    };
    _this2.prepareMeasure = function() {
      _this2.setState({
        status: AffixStatus.Prepare,
        affixStyle: void 0,
        placeholderStyle: void 0
      });
      if (process.env.NODE_ENV === "test") {
        var onTestUpdatePosition = _this2.props.onTestUpdatePosition;
        onTestUpdatePosition === null || onTestUpdatePosition === void 0 ? void 0 : onTestUpdatePosition();
      }
    };
    _this2.render = function() {
      var getPrefixCls = _this2.context.getPrefixCls;
      var _this$state2 = _this2.state, affixStyle = _this$state2.affixStyle, placeholderStyle = _this$state2.placeholderStyle;
      var _this$props = _this2.props, prefixCls = _this$props.prefixCls, children = _this$props.children;
      var className = cn(_defineProperty$4({}, getPrefixCls("affix", prefixCls), !!affixStyle));
      var props = omit$1(_this2.props, ["prefixCls", "offsetTop", "offsetBottom", "target", "onChange"]);
      if (process.env.NODE_ENV === "test") {
        props = omit$1(props, ["onTestUpdatePosition"]);
      }
      return /* @__PURE__ */ React.createElement(ResizeObserver, {
        onResize: function onResize2() {
          _this2.updatePosition();
        }
      }, /* @__PURE__ */ React.createElement("div", _extends$2({}, props, {
        ref: _this2.savePlaceholderNode
      }), affixStyle && /* @__PURE__ */ React.createElement("div", {
        style: placeholderStyle,
        "aria-hidden": "true"
      }), /* @__PURE__ */ React.createElement("div", {
        className,
        ref: _this2.saveFixedNode,
        style: affixStyle
      }, /* @__PURE__ */ React.createElement(ResizeObserver, {
        onResize: function onResize2() {
          _this2.updatePosition();
        }
      }, children))));
    };
    return _this2;
  }
  _createClass$2(Affix2, [{
    key: "getTargetFunc",
    value: function getTargetFunc() {
      var getTargetContainer = this.context.getTargetContainer;
      var target = this.props.target;
      if (target !== void 0) {
        return target;
      }
      return getTargetContainer || getDefaultTarget;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var targetFunc = this.getTargetFunc();
      if (targetFunc) {
        this.timeout = setTimeout(function() {
          addObserveTarget(targetFunc(), _this2);
          _this2.updatePosition();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevTarget = this.state.prevTarget;
      var targetFunc = this.getTargetFunc();
      var newTarget = null;
      if (targetFunc) {
        newTarget = targetFunc() || null;
      }
      if (prevTarget !== newTarget) {
        removeObserveTarget(this);
        if (newTarget) {
          addObserveTarget(newTarget, this);
          this.updatePosition();
        }
        this.setState({
          prevTarget: newTarget
        });
      }
      if (prevProps.offsetTop !== this.props.offsetTop || prevProps.offsetBottom !== this.props.offsetBottom) {
        this.updatePosition();
      }
      this.measure();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
      removeObserveTarget(this);
      this.updatePosition.cancel();
      this.lazyUpdatePosition.cancel();
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      this.prepareMeasure();
    }
  }, {
    key: "lazyUpdatePosition",
    value: function lazyUpdatePosition() {
      var targetFunc = this.getTargetFunc();
      var affixStyle = this.state.affixStyle;
      if (targetFunc && affixStyle) {
        var offsetTop = this.getOffsetTop();
        var offsetBottom = this.getOffsetBottom();
        var targetNode = targetFunc();
        if (targetNode && this.placeholderNode) {
          var targetRect = getTargetRect(targetNode);
          var placeholderReact = getTargetRect(this.placeholderNode);
          var fixedTop = getFixedTop(placeholderReact, targetRect, offsetTop);
          var fixedBottom = getFixedBottom(placeholderReact, targetRect, offsetBottom);
          if (fixedTop !== void 0 && affixStyle.top === fixedTop || fixedBottom !== void 0 && affixStyle.bottom === fixedBottom) {
            return;
          }
        }
      }
      this.prepareMeasure();
    }
  }]);
  return Affix2;
}(React.Component);
Affix.contextType = ConfigContext;
__decorate([throttleByAnimationFrameDecorator()], Affix.prototype, "updatePosition", null);
__decorate([throttleByAnimationFrameDecorator()], Affix.prototype, "lazyUpdatePosition", null);
function isWindow$1(obj) {
  return obj !== null && obj !== void 0 && obj === obj.window;
}
function getScroll$4(target, top) {
  var _a;
  if (typeof window === "undefined") {
    return 0;
  }
  var method3 = top ? "scrollTop" : "scrollLeft";
  var result = 0;
  if (isWindow$1(target)) {
    result = target[top ? "pageYOffset" : "pageXOffset"];
  } else if (target instanceof Document) {
    result = target.documentElement[method3];
  } else if (target) {
    result = target[method3];
  }
  if (target && !isWindow$1(target) && typeof result !== "number") {
    result = (_a = (target.ownerDocument || target).documentElement) === null || _a === void 0 ? void 0 : _a[method3];
  }
  return result;
}
function easeInOutCubic(t3, b2, c2, d) {
  var cc = c2 - b2;
  t3 /= d / 2;
  if (t3 < 1) {
    return cc / 2 * t3 * t3 * t3 + b2;
  }
  return cc / 2 * ((t3 -= 2) * t3 * t3 + 2) + b2;
}
function scrollTo$1(y2) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _options$getContainer = options.getContainer, getContainer2 = _options$getContainer === void 0 ? function() {
    return window;
  } : _options$getContainer, callback = options.callback, _options$duration = options.duration, duration = _options$duration === void 0 ? 450 : _options$duration;
  var container = getContainer2();
  var scrollTop = getScroll$4(container, true);
  var startTime = Date.now();
  var frameFunc = function frameFunc2() {
    var timestamp = Date.now();
    var time = timestamp - startTime;
    var nextScrollTop = easeInOutCubic(time > duration ? duration : time, scrollTop, y2, duration);
    if (isWindow$1(container)) {
      container.scrollTo(window.pageXOffset, nextScrollTop);
    } else if (container instanceof HTMLDocument || container.constructor.name === "HTMLDocument") {
      container.documentElement.scrollTop = nextScrollTop;
    } else {
      container.scrollTop = nextScrollTop;
    }
    if (time < duration) {
      wrapperRaf$1(frameFunc2);
    } else if (typeof callback === "function") {
      callback();
    }
  };
  wrapperRaf$1(frameFunc);
}
var AnchorContext = /* @__PURE__ */ React.createContext(null);
var AnchorLink = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(AnchorLink2, _React$Component);
  var _super = _createSuper$1(AnchorLink2);
  function AnchorLink2() {
    var _this2;
    _classCallCheck$2(this, AnchorLink2);
    _this2 = _super.apply(this, arguments);
    _this2.handleClick = function(e3) {
      var _this$context = _this2.context, scrollTo2 = _this$context.scrollTo, onClick = _this$context.onClick;
      var _this$props = _this2.props, href = _this$props.href, title = _this$props.title;
      onClick === null || onClick === void 0 ? void 0 : onClick(e3, {
        title,
        href
      });
      scrollTo2(href);
    };
    _this2.renderAnchorLink = function(_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var _this$props2 = _this2.props, customizePrefixCls = _this$props2.prefixCls, href = _this$props2.href, title = _this$props2.title, children = _this$props2.children, className = _this$props2.className, target = _this$props2.target;
      var prefixCls = getPrefixCls("anchor", customizePrefixCls);
      var active = _this2.context.activeLink === href;
      var wrapperClassName = cn("".concat(prefixCls, "-link"), _defineProperty$4({}, "".concat(prefixCls, "-link-active"), active), className);
      var titleClassName = cn("".concat(prefixCls, "-link-title"), _defineProperty$4({}, "".concat(prefixCls, "-link-title-active"), active));
      return /* @__PURE__ */ React.createElement("div", {
        className: wrapperClassName
      }, /* @__PURE__ */ React.createElement("a", {
        className: titleClassName,
        href,
        title: typeof title === "string" ? title : "",
        target,
        onClick: _this2.handleClick
      }, title), children);
    };
    return _this2;
  }
  _createClass$2(AnchorLink2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.context.registerLink(this.props.href);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref2) {
      var prevHref = _ref2.href;
      var href = this.props.href;
      if (prevHref !== href) {
        this.context.unregisterLink(prevHref);
        this.context.registerLink(href);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.context.unregisterLink(this.props.href);
    }
  }, {
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(ConfigConsumer, null, this.renderAnchorLink);
    }
  }]);
  return AnchorLink2;
}(React.Component);
AnchorLink.defaultProps = {
  href: "#"
};
AnchorLink.contextType = AnchorContext;
var KeyCode = {
  MAC_ENTER: 3,
  BACKSPACE: 8,
  TAB: 9,
  NUM_CENTER: 12,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE: 19,
  CAPS_LOCK: 20,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  PRINT_SCREEN: 44,
  INSERT: 45,
  DELETE: 46,
  ZERO: 48,
  ONE: 49,
  TWO: 50,
  THREE: 51,
  FOUR: 52,
  FIVE: 53,
  SIX: 54,
  SEVEN: 55,
  EIGHT: 56,
  NINE: 57,
  QUESTION_MARK: 63,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90,
  META: 91,
  WIN_KEY_RIGHT: 92,
  CONTEXT_MENU: 93,
  NUM_ZERO: 96,
  NUM_ONE: 97,
  NUM_TWO: 98,
  NUM_THREE: 99,
  NUM_FOUR: 100,
  NUM_FIVE: 101,
  NUM_SIX: 102,
  NUM_SEVEN: 103,
  NUM_EIGHT: 104,
  NUM_NINE: 105,
  NUM_MULTIPLY: 106,
  NUM_PLUS: 107,
  NUM_MINUS: 109,
  NUM_PERIOD: 110,
  NUM_DIVISION: 111,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  NUMLOCK: 144,
  SEMICOLON: 186,
  DASH: 189,
  EQUALS: 187,
  COMMA: 188,
  PERIOD: 190,
  SLASH: 191,
  APOSTROPHE: 192,
  SINGLE_QUOTE: 222,
  OPEN_SQUARE_BRACKET: 219,
  BACKSLASH: 220,
  CLOSE_SQUARE_BRACKET: 221,
  WIN_KEY: 224,
  MAC_FF_META: 224,
  WIN_IME: 229,
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e3) {
    var keyCode = e3.keyCode;
    if (e3.altKey && !e3.ctrlKey || e3.metaKey || keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    }
    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;
      default:
        return true;
    }
  },
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }
    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    }
    if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) {
      return true;
    }
    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  }
};
var attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);
var ariaPrefix = "aria-";
var dataPrefix = "data-";
function match$1(key2, prefix) {
  return key2.indexOf(prefix) === 0;
}
function pickAttrs(props) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var mergedConfig;
  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = _objectSpread2$1({}, ariaOnly);
  }
  var attrs = {};
  Object.keys(props).forEach(function(key2) {
    if (mergedConfig.aria && (key2 === "role" || match$1(key2, ariaPrefix)) || mergedConfig.data && match$1(key2, dataPrefix) || mergedConfig.attr && propList.includes(key2)) {
      attrs[key2] = props[key2];
    }
  });
  return attrs;
}
function ownKeys$2(object3, enumerableOnly) {
  var keys2 = Object.keys(object3);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object3);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object3, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$2(Object(source), true).forEach(function(key2) {
      _defineProperty$3(target, key2, source[key2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key2) {
      Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
    });
  }
  return target;
}
function _defineProperty$3(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var Filler = /* @__PURE__ */ React.forwardRef(function(_ref, ref) {
  var height = _ref.height, offset3 = _ref.offset, children = _ref.children, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize;
  var outerStyle = {};
  var innerStyle = {
    display: "flex",
    flexDirection: "column"
  };
  if (offset3 !== void 0) {
    outerStyle = {
      height,
      position: "relative",
      overflow: "hidden"
    };
    innerStyle = _objectSpread$1(_objectSpread$1({}, innerStyle), {}, {
      transform: "translateY(".concat(offset3, "px)"),
      position: "absolute",
      left: 0,
      right: 0,
      top: 0
    });
  }
  return /* @__PURE__ */ React.createElement("div", {
    style: outerStyle
  }, /* @__PURE__ */ React.createElement(ResizeObserver, {
    onResize: function onResize2(_ref2) {
      var offsetHeight = _ref2.offsetHeight;
      if (offsetHeight && onInnerResize) {
        onInnerResize();
      }
    }
  }, /* @__PURE__ */ React.createElement("div", {
    style: innerStyle,
    className: cn(_defineProperty$3({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
    ref
  }, children)));
});
Filler.displayName = "Filler";
function _typeof$3(obj) {
  "@babel/helpers - typeof";
  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$3(obj);
}
function _defineProperty$2(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o2, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o3, p2) {
    o3.__proto__ = p2;
    return o3;
  };
  return _setPrototypeOf(o2, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self2, call2) {
  if (call2 && (_typeof$3(call2) === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e3) {
    return false;
  }
}
function _getPrototypeOf(o2) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf(o2);
}
var MIN_SIZE = 20;
function getPageY(e3) {
  return "touches" in e3 ? e3.touches[0].pageY : e3.pageY;
}
var ScrollBar = /* @__PURE__ */ function(_React$Component) {
  _inherits(ScrollBar2, _React$Component);
  var _super = _createSuper(ScrollBar2);
  function ScrollBar2() {
    var _this2;
    _classCallCheck$1(this, ScrollBar2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super.call.apply(_super, [this].concat(args));
    _this2.moveRaf = null;
    _this2.scrollbarRef = /* @__PURE__ */ React.createRef();
    _this2.thumbRef = /* @__PURE__ */ React.createRef();
    _this2.visibleTimeout = null;
    _this2.state = {
      dragging: false,
      pageY: null,
      startTop: null,
      visible: false
    };
    _this2.delayHidden = function() {
      clearTimeout(_this2.visibleTimeout);
      _this2.setState({
        visible: true
      });
      _this2.visibleTimeout = setTimeout(function() {
        _this2.setState({
          visible: false
        });
      }, 2e3);
    };
    _this2.onScrollbarTouchStart = function(e3) {
      e3.preventDefault();
    };
    _this2.onContainerMouseDown = function(e3) {
      e3.stopPropagation();
      e3.preventDefault();
    };
    _this2.patchEvents = function() {
      window.addEventListener("mousemove", _this2.onMouseMove);
      window.addEventListener("mouseup", _this2.onMouseUp);
      _this2.thumbRef.current.addEventListener("touchmove", _this2.onMouseMove);
      _this2.thumbRef.current.addEventListener("touchend", _this2.onMouseUp);
    };
    _this2.removeEvents = function() {
      var _this$scrollbarRef$cu;
      window.removeEventListener("mousemove", _this2.onMouseMove);
      window.removeEventListener("mouseup", _this2.onMouseUp);
      (_this$scrollbarRef$cu = _this2.scrollbarRef.current) === null || _this$scrollbarRef$cu === void 0 ? void 0 : _this$scrollbarRef$cu.removeEventListener("touchstart", _this2.onScrollbarTouchStart);
      if (_this2.thumbRef.current) {
        _this2.thumbRef.current.removeEventListener("touchstart", _this2.onMouseDown);
        _this2.thumbRef.current.removeEventListener("touchmove", _this2.onMouseMove);
        _this2.thumbRef.current.removeEventListener("touchend", _this2.onMouseUp);
      }
      wrapperRaf$1.cancel(_this2.moveRaf);
    };
    _this2.onMouseDown = function(e3) {
      var onStartMove = _this2.props.onStartMove;
      _this2.setState({
        dragging: true,
        pageY: getPageY(e3),
        startTop: _this2.getTop()
      });
      onStartMove();
      _this2.patchEvents();
      e3.stopPropagation();
      e3.preventDefault();
    };
    _this2.onMouseMove = function(e3) {
      var _this$state = _this2.state, dragging = _this$state.dragging, pageY = _this$state.pageY, startTop = _this$state.startTop;
      var onScroll = _this2.props.onScroll;
      wrapperRaf$1.cancel(_this2.moveRaf);
      if (dragging) {
        var offsetY = getPageY(e3) - pageY;
        var newTop = startTop + offsetY;
        var enableScrollRange = _this2.getEnableScrollRange();
        var enableHeightRange = _this2.getEnableHeightRange();
        var ptg = enableHeightRange ? newTop / enableHeightRange : 0;
        var newScrollTop = Math.ceil(ptg * enableScrollRange);
        _this2.moveRaf = wrapperRaf$1(function() {
          onScroll(newScrollTop);
        });
      }
    };
    _this2.onMouseUp = function() {
      var onStopMove = _this2.props.onStopMove;
      _this2.setState({
        dragging: false
      });
      onStopMove();
      _this2.removeEvents();
    };
    _this2.getSpinHeight = function() {
      var _this$props = _this2.props, height = _this$props.height, count = _this$props.count;
      var baseHeight = height / count * 10;
      baseHeight = Math.max(baseHeight, MIN_SIZE);
      baseHeight = Math.min(baseHeight, height / 2);
      return Math.floor(baseHeight);
    };
    _this2.getEnableScrollRange = function() {
      var _this$props2 = _this2.props, scrollHeight = _this$props2.scrollHeight, height = _this$props2.height;
      return scrollHeight - height || 0;
    };
    _this2.getEnableHeightRange = function() {
      var height = _this2.props.height;
      var spinHeight = _this2.getSpinHeight();
      return height - spinHeight || 0;
    };
    _this2.getTop = function() {
      var scrollTop = _this2.props.scrollTop;
      var enableScrollRange = _this2.getEnableScrollRange();
      var enableHeightRange = _this2.getEnableHeightRange();
      if (scrollTop === 0 || enableScrollRange === 0) {
        return 0;
      }
      var ptg = scrollTop / enableScrollRange;
      return ptg * enableHeightRange;
    };
    _this2.showScroll = function() {
      var _this$props3 = _this2.props, height = _this$props3.height, scrollHeight = _this$props3.scrollHeight;
      return scrollHeight > height;
    };
    return _this2;
  }
  _createClass$1(ScrollBar2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollbarRef.current.addEventListener("touchstart", this.onScrollbarTouchStart);
      this.thumbRef.current.addEventListener("touchstart", this.onMouseDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.scrollTop !== this.props.scrollTop) {
        this.delayHidden();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEvents();
      clearTimeout(this.visibleTimeout);
    }
  }, {
    key: "render",
    value: function render4() {
      var _this$state2 = this.state, dragging = _this$state2.dragging, visible = _this$state2.visible;
      var prefixCls = this.props.prefixCls;
      var spinHeight = this.getSpinHeight();
      var top = this.getTop();
      var canScroll = this.showScroll();
      var mergedVisible = canScroll && visible;
      return /* @__PURE__ */ React.createElement("div", {
        ref: this.scrollbarRef,
        className: cn("".concat(prefixCls, "-scrollbar"), _defineProperty$2({}, "".concat(prefixCls, "-scrollbar-show"), canScroll)),
        style: {
          width: 8,
          top: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: mergedVisible ? null : "none"
        },
        onMouseDown: this.onContainerMouseDown,
        onMouseMove: this.delayHidden
      }, /* @__PURE__ */ React.createElement("div", {
        ref: this.thumbRef,
        className: cn("".concat(prefixCls, "-scrollbar-thumb"), _defineProperty$2({}, "".concat(prefixCls, "-scrollbar-thumb-moving"), dragging)),
        style: {
          width: "100%",
          height: spinHeight,
          top,
          left: 0,
          position: "absolute",
          background: "rgba(0, 0, 0, 0.5)",
          borderRadius: 99,
          cursor: "pointer",
          userSelect: "none"
        },
        onMouseDown: this.onMouseDown
      }));
    }
  }]);
  return ScrollBar2;
}(React.Component);
function Item$2(_ref) {
  var children = _ref.children, setRef = _ref.setRef;
  var refFunc = React.useCallback(function(node) {
    setRef(node);
  }, []);
  return /* @__PURE__ */ React.cloneElement(children, {
    ref: refFunc
  });
}
function useChildren(list, startIndex, endIndex, setNodeRef, renderFunc, _ref) {
  var getKey3 = _ref.getKey;
  return list.slice(startIndex, endIndex + 1).map(function(item, index2) {
    var eleIndex = startIndex + index2;
    var node = renderFunc(item, eleIndex, {});
    var key2 = getKey3(item);
    return /* @__PURE__ */ React.createElement(Item$2, {
      key: key2,
      setRef: function setRef(ele) {
        return setNodeRef(item, ele);
      }
    }, node);
  });
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var CacheMap = /* @__PURE__ */ function() {
  function CacheMap2() {
    _classCallCheck(this, CacheMap2);
    this.maps = void 0;
    this.maps = /* @__PURE__ */ Object.create(null);
  }
  _createClass(CacheMap2, [{
    key: "set",
    value: function set2(key2, value) {
      this.maps[key2] = value;
    }
  }, {
    key: "get",
    value: function get2(key2) {
      return this.maps[key2];
    }
  }]);
  return CacheMap2;
}();
function _slicedToArray$2(arr, i2) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i2) || _unsupportedIterableToArray$2(arr, i2) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$2(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$2(o2, minLen);
  var n3 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n3 === "Object" && o2.constructor)
    n3 = o2.constructor.name;
  if (n3 === "Map" || n3 === "Set")
    return Array.from(o2);
  if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3))
    return _arrayLikeToArray$2(o2, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _iterableToArrayLimit$2(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr))
    return arr;
}
function useHeights(getKey3, onItemAdd, onItemRemove) {
  var _React$useState = React.useState(0), _React$useState2 = _slicedToArray$2(_React$useState, 2), updatedMark = _React$useState2[0], setUpdatedMark = _React$useState2[1];
  var instanceRef = useRef2(/* @__PURE__ */ new Map());
  var heightsRef = useRef2(new CacheMap());
  var collectRafRef = useRef2();
  function cancelRaf() {
    wrapperRaf$1.cancel(collectRafRef.current);
  }
  function collectHeight() {
    cancelRaf();
    collectRafRef.current = wrapperRaf$1(function() {
      instanceRef.current.forEach(function(element, key2) {
        if (element && element.offsetParent) {
          var htmlElement = findDOMNode2(element);
          var offsetHeight = htmlElement.offsetHeight;
          if (heightsRef.current.get(key2) !== offsetHeight) {
            heightsRef.current.set(key2, htmlElement.offsetHeight);
          }
        }
      });
      setUpdatedMark(function(c2) {
        return c2 + 1;
      });
    });
  }
  function setInstanceRef(item, instance) {
    var key2 = getKey3(item);
    var origin = instanceRef.current.get(key2);
    if (instance) {
      instanceRef.current.set(key2, instance);
      collectHeight();
    } else {
      instanceRef.current.delete(key2);
    }
    if (!origin !== !instance) {
      if (instance) {
        onItemAdd === null || onItemAdd === void 0 ? void 0 : onItemAdd(item);
      } else {
        onItemRemove === null || onItemRemove === void 0 ? void 0 : onItemRemove(item);
      }
    }
  }
  useEffect2(function() {
    return cancelRaf;
  }, []);
  return [setInstanceRef, collectHeight, heightsRef.current, updatedMark];
}
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
function useScrollTo(containerRef, data, heights, itemHeight, getKey3, collectHeight, syncScrollTop, triggerFlash) {
  var scrollRef = React.useRef();
  return function(arg) {
    if (arg === null || arg === void 0) {
      triggerFlash();
      return;
    }
    wrapperRaf$1.cancel(scrollRef.current);
    if (typeof arg === "number") {
      syncScrollTop(arg);
    } else if (arg && _typeof$2(arg) === "object") {
      var index2;
      var align = arg.align;
      if ("index" in arg) {
        index2 = arg.index;
      } else {
        index2 = data.findIndex(function(item) {
          return getKey3(item) === arg.key;
        });
      }
      var _arg$offset = arg.offset, offset3 = _arg$offset === void 0 ? 0 : _arg$offset;
      var syncScroll = function syncScroll2(times, targetAlign) {
        if (times < 0 || !containerRef.current)
          return;
        var height = containerRef.current.clientHeight;
        var needCollectHeight = false;
        var newTargetAlign = targetAlign;
        if (height) {
          var mergedAlign = targetAlign || align;
          var stackTop = 0;
          var itemTop = 0;
          var itemBottom = 0;
          var maxLen = Math.min(data.length, index2);
          for (var i2 = 0; i2 <= maxLen; i2 += 1) {
            var key2 = getKey3(data[i2]);
            itemTop = stackTop;
            var cacheHeight = heights.get(key2);
            itemBottom = itemTop + (cacheHeight === void 0 ? itemHeight : cacheHeight);
            stackTop = itemBottom;
            if (i2 === index2 && cacheHeight === void 0) {
              needCollectHeight = true;
            }
          }
          var targetTop = null;
          switch (mergedAlign) {
            case "top":
              targetTop = itemTop - offset3;
              break;
            case "bottom":
              targetTop = itemBottom - height + offset3;
              break;
            default: {
              var scrollTop = containerRef.current.scrollTop;
              var scrollBottom = scrollTop + height;
              if (itemTop < scrollTop) {
                newTargetAlign = "top";
              } else if (itemBottom > scrollBottom) {
                newTargetAlign = "bottom";
              }
            }
          }
          if (targetTop !== null && targetTop !== containerRef.current.scrollTop) {
            syncScrollTop(targetTop);
          }
        }
        scrollRef.current = wrapperRaf$1(function() {
          if (needCollectHeight) {
            collectHeight();
          }
          syncScroll2(times - 1, newTargetAlign);
        });
      };
      syncScroll(3);
    }
  };
}
function findListDiffIndex(originList, targetList, getKey3) {
  var originLen = originList.length;
  var targetLen = targetList.length;
  var shortList;
  var longList;
  if (originLen === 0 && targetLen === 0) {
    return null;
  }
  if (originLen < targetLen) {
    shortList = originList;
    longList = targetList;
  } else {
    shortList = targetList;
    longList = originList;
  }
  var notExistKey = {
    __EMPTY_ITEM__: true
  };
  function getItemKey(item) {
    if (item !== void 0) {
      return getKey3(item);
    }
    return notExistKey;
  }
  var diffIndex = null;
  var multiple = Math.abs(originLen - targetLen) !== 1;
  for (var i2 = 0; i2 < longList.length; i2 += 1) {
    var shortKey = getItemKey(shortList[i2]);
    var longKey = getItemKey(longList[i2]);
    if (shortKey !== longKey) {
      diffIndex = i2;
      multiple = multiple || shortKey !== getItemKey(longList[i2 + 1]);
      break;
    }
  }
  return diffIndex === null ? null : {
    index: diffIndex,
    multiple
  };
}
function _slicedToArray$1(arr, i2) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i2) || _unsupportedIterableToArray$1(arr, i2) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$1(o2, minLen);
  var n3 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n3 === "Object" && o2.constructor)
    n3 = o2.constructor.name;
  if (n3 === "Map" || n3 === "Set")
    return Array.from(o2);
  if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3))
    return _arrayLikeToArray$1(o2, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _iterableToArrayLimit$1(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr))
    return arr;
}
function useDiffItem(data, getKey3, onDiff) {
  var _React$useState = React.useState(data), _React$useState2 = _slicedToArray$1(_React$useState, 2), prevData = _React$useState2[0], setPrevData = _React$useState2[1];
  var _React$useState3 = React.useState(null), _React$useState4 = _slicedToArray$1(_React$useState3, 2), diffItem = _React$useState4[0], setDiffItem = _React$useState4[1];
  React.useEffect(function() {
    var diff = findListDiffIndex(prevData || [], data || [], getKey3);
    if ((diff === null || diff === void 0 ? void 0 : diff.index) !== void 0) {
      onDiff === null || onDiff === void 0 ? void 0 : onDiff(diff.index);
      setDiffItem(data[diff.index]);
    }
    setPrevData(data);
  }, [data]);
  return [diffItem];
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
var isFF = (typeof navigator === "undefined" ? "undefined" : _typeof$1(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
var useOriginScroll = function(isScrollAtTop, isScrollAtBottom) {
  var lockRef = useRef2(false);
  var lockTimeoutRef = useRef2(null);
  function lockScroll() {
    clearTimeout(lockTimeoutRef.current);
    lockRef.current = true;
    lockTimeoutRef.current = setTimeout(function() {
      lockRef.current = false;
    }, 50);
  }
  var scrollPingRef = useRef2({
    top: isScrollAtTop,
    bottom: isScrollAtBottom
  });
  scrollPingRef.current.top = isScrollAtTop;
  scrollPingRef.current.bottom = isScrollAtBottom;
  return function(deltaY) {
    var smoothOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var originScroll = deltaY < 0 && scrollPingRef.current.top || deltaY > 0 && scrollPingRef.current.bottom;
    if (smoothOffset && originScroll) {
      clearTimeout(lockTimeoutRef.current);
      lockRef.current = false;
    } else if (!originScroll || lockRef.current) {
      lockScroll();
    }
    return !lockRef.current && originScroll;
  };
};
function useFrameWheel(inVirtual, isScrollAtTop, isScrollAtBottom, onWheelDelta) {
  var offsetRef = useRef2(0);
  var nextFrameRef = useRef2(null);
  var wheelValueRef = useRef2(null);
  var isMouseScrollRef = useRef2(false);
  var originScroll = useOriginScroll(isScrollAtTop, isScrollAtBottom);
  function onWheel(event) {
    if (!inVirtual)
      return;
    wrapperRaf$1.cancel(nextFrameRef.current);
    var deltaY = event.deltaY;
    offsetRef.current += deltaY;
    wheelValueRef.current = deltaY;
    if (originScroll(deltaY))
      return;
    if (!isFF) {
      event.preventDefault();
    }
    nextFrameRef.current = wrapperRaf$1(function() {
      var patchMultiple = isMouseScrollRef.current ? 10 : 1;
      onWheelDelta(offsetRef.current * patchMultiple);
      offsetRef.current = 0;
    });
  }
  function onFireFoxScroll(event) {
    if (!inVirtual)
      return;
    isMouseScrollRef.current = event.detail === wheelValueRef.current;
  }
  return [onWheel, onFireFoxScroll];
}
var useLayoutEffect$2 = process.env.NODE_ENV !== "test" && canUseDom() ? React.useLayoutEffect : React.useEffect;
var useLayoutUpdateEffect = function useLayoutUpdateEffect2(callback, deps) {
  var firstMountRef = React.useRef(true);
  useLayoutEffect$2(function() {
    if (!firstMountRef.current) {
      return callback();
    }
  }, deps);
  useLayoutEffect$2(function() {
    firstMountRef.current = false;
    return function() {
      firstMountRef.current = true;
    };
  }, []);
};
var SMOOTH_PTG = 14 / 15;
function useMobileTouchMove(inVirtual, listRef, callback) {
  var touchedRef = useRef2(false);
  var touchYRef = useRef2(0);
  var elementRef = useRef2(null);
  var intervalRef = useRef2(null);
  var cleanUpEvents;
  var onTouchMove = function onTouchMove2(e3) {
    if (touchedRef.current) {
      var currentY = Math.ceil(e3.touches[0].pageY);
      var offsetY = touchYRef.current - currentY;
      touchYRef.current = currentY;
      if (callback(offsetY)) {
        e3.preventDefault();
      }
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(function() {
        offsetY *= SMOOTH_PTG;
        if (!callback(offsetY, true) || Math.abs(offsetY) <= 0.1) {
          clearInterval(intervalRef.current);
        }
      }, 16);
    }
  };
  var onTouchEnd = function onTouchEnd2() {
    touchedRef.current = false;
    cleanUpEvents();
  };
  var onTouchStart = function onTouchStart2(e3) {
    cleanUpEvents();
    if (e3.touches.length === 1 && !touchedRef.current) {
      touchedRef.current = true;
      touchYRef.current = Math.ceil(e3.touches[0].pageY);
      elementRef.current = e3.target;
      elementRef.current.addEventListener("touchmove", onTouchMove);
      elementRef.current.addEventListener("touchend", onTouchEnd);
    }
  };
  cleanUpEvents = function cleanUpEvents2() {
    if (elementRef.current) {
      elementRef.current.removeEventListener("touchmove", onTouchMove);
      elementRef.current.removeEventListener("touchend", onTouchEnd);
    }
  };
  useLayoutEffect$2(function() {
    if (inVirtual) {
      listRef.current.addEventListener("touchstart", onTouchStart);
    }
    return function() {
      var _listRef$current;
      (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.removeEventListener("touchstart", onTouchStart);
      cleanUpEvents();
      clearInterval(intervalRef.current);
    };
  }, [inVirtual]);
}
var _excluded$7 = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "component", "onScroll", "onVisibleChange"];
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys$1(object3, enumerableOnly) {
  var keys2 = Object.keys(object3);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object3);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object3, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$1(Object(source), true).forEach(function(key2) {
      _defineProperty$1(target, key2, source[key2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key2) {
      Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
    });
  }
  return target;
}
function _defineProperty$1(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _slicedToArray(arr, i2) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray(arr, i2) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray(o2, minLen);
  var n3 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n3 === "Object" && o2.constructor)
    n3 = o2.constructor.name;
  if (n3 === "Map" || n3 === "Set")
    return Array.from(o2);
  if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3))
    return _arrayLikeToArray(o2, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key2, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key2 = sourceSymbolKeys[i2];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key2 = sourceKeys[i2];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
var EMPTY_DATA = [];
var ScrollStyle = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function RawList(props, ref) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-virtual-list" : _props$prefixCls, className = props.className, height = props.height, itemHeight = props.itemHeight, _props$fullHeight = props.fullHeight, fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight, style2 = props.style, data = props.data, children = props.children, itemKey2 = props.itemKey, virtual = props.virtual, _props$component = props.component, Component3 = _props$component === void 0 ? "div" : _props$component, onScroll = props.onScroll, onVisibleChange = props.onVisibleChange, restProps = _objectWithoutProperties(props, _excluded$7);
  var useVirtual = !!(virtual !== false && height && itemHeight);
  var inVirtual = useVirtual && data && itemHeight * data.length > height;
  var _useState = useState2(0), _useState2 = _slicedToArray(_useState, 2), scrollTop = _useState2[0], setScrollTop = _useState2[1];
  var _useState3 = useState2(false), _useState4 = _slicedToArray(_useState3, 2), scrollMoving = _useState4[0], setScrollMoving = _useState4[1];
  var mergedClassName = cn(prefixCls, className);
  var mergedData = data || EMPTY_DATA;
  var componentRef = useRef2();
  var fillerInnerRef = useRef2();
  var scrollBarRef = useRef2();
  var getKey3 = React.useCallback(function(item) {
    if (typeof itemKey2 === "function") {
      return itemKey2(item);
    }
    return item === null || item === void 0 ? void 0 : item[itemKey2];
  }, [itemKey2]);
  var sharedConfig = {
    getKey: getKey3
  };
  function syncScrollTop(newTop) {
    setScrollTop(function(origin) {
      var value;
      if (typeof newTop === "function") {
        value = newTop(origin);
      } else {
        value = newTop;
      }
      var alignedTop = keepInRange(value);
      componentRef.current.scrollTop = alignedTop;
      return alignedTop;
    });
  }
  var rangeRef = useRef2({
    start: 0,
    end: mergedData.length
  });
  var diffItemRef = useRef2();
  var _useDiffItem = useDiffItem(mergedData, getKey3), _useDiffItem2 = _slicedToArray(_useDiffItem, 1), diffItem = _useDiffItem2[0];
  diffItemRef.current = diffItem;
  var _useHeights = useHeights(getKey3, null, null), _useHeights2 = _slicedToArray(_useHeights, 4), setInstanceRef = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], heightUpdatedMark = _useHeights2[3];
  var _React$useMemo = React.useMemo(function() {
    if (!useVirtual) {
      return {
        scrollHeight: void 0,
        start: 0,
        end: mergedData.length - 1,
        offset: void 0
      };
    }
    if (!inVirtual) {
      var _fillerInnerRef$curre;
      return {
        scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
        start: 0,
        end: mergedData.length - 1,
        offset: void 0
      };
    }
    var itemTop = 0;
    var startIndex;
    var startOffset;
    var endIndex;
    var dataLen = mergedData.length;
    for (var i2 = 0; i2 < dataLen; i2 += 1) {
      var item = mergedData[i2];
      var key2 = getKey3(item);
      var cacheHeight = heights.get(key2);
      var currentItemBottom = itemTop + (cacheHeight === void 0 ? itemHeight : cacheHeight);
      if (currentItemBottom >= scrollTop && startIndex === void 0) {
        startIndex = i2;
        startOffset = itemTop;
      }
      if (currentItemBottom > scrollTop + height && endIndex === void 0) {
        endIndex = i2;
      }
      itemTop = currentItemBottom;
    }
    if (startIndex === void 0) {
      startIndex = 0;
      startOffset = 0;
    }
    if (endIndex === void 0) {
      endIndex = mergedData.length - 1;
    }
    endIndex = Math.min(endIndex + 1, mergedData.length);
    return {
      scrollHeight: itemTop,
      start: startIndex,
      end: endIndex,
      offset: startOffset
    };
  }, [inVirtual, useVirtual, scrollTop, mergedData, heightUpdatedMark, height]), scrollHeight = _React$useMemo.scrollHeight, start = _React$useMemo.start, end = _React$useMemo.end, offset3 = _React$useMemo.offset;
  rangeRef.current.start = start;
  rangeRef.current.end = end;
  var maxScrollHeight = scrollHeight - height;
  var maxScrollHeightRef = useRef2(maxScrollHeight);
  maxScrollHeightRef.current = maxScrollHeight;
  function keepInRange(newScrollTop) {
    var newTop = newScrollTop;
    if (!Number.isNaN(maxScrollHeightRef.current)) {
      newTop = Math.min(newTop, maxScrollHeightRef.current);
    }
    newTop = Math.max(newTop, 0);
    return newTop;
  }
  var isScrollAtTop = scrollTop <= 0;
  var isScrollAtBottom = scrollTop >= maxScrollHeight;
  var originScroll = useOriginScroll(isScrollAtTop, isScrollAtBottom);
  function onScrollBar(newScrollTop) {
    var newTop = newScrollTop;
    syncScrollTop(newTop);
  }
  function onFallbackScroll(e3) {
    var newScrollTop = e3.currentTarget.scrollTop;
    if (newScrollTop !== scrollTop) {
      syncScrollTop(newScrollTop);
    }
    onScroll === null || onScroll === void 0 ? void 0 : onScroll(e3);
  }
  var _useFrameWheel = useFrameWheel(useVirtual, isScrollAtTop, isScrollAtBottom, function(offsetY) {
    syncScrollTop(function(top) {
      var newTop = top + offsetY;
      return newTop;
    });
  }), _useFrameWheel2 = _slicedToArray(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
  useMobileTouchMove(useVirtual, componentRef, function(deltaY, smoothOffset) {
    if (originScroll(deltaY, smoothOffset)) {
      return false;
    }
    onRawWheel({
      preventDefault: function preventDefault() {
      },
      deltaY
    });
    return true;
  });
  useLayoutEffect$2(function() {
    function onMozMousePixelScroll(e3) {
      if (useVirtual) {
        e3.preventDefault();
      }
    }
    componentRef.current.addEventListener("wheel", onRawWheel);
    componentRef.current.addEventListener("DOMMouseScroll", onFireFoxScroll);
    componentRef.current.addEventListener("MozMousePixelScroll", onMozMousePixelScroll);
    return function() {
      if (componentRef.current) {
        componentRef.current.removeEventListener("wheel", onRawWheel);
        componentRef.current.removeEventListener("DOMMouseScroll", onFireFoxScroll);
        componentRef.current.removeEventListener("MozMousePixelScroll", onMozMousePixelScroll);
      }
    };
  }, [useVirtual]);
  var scrollTo2 = useScrollTo(componentRef, mergedData, heights, itemHeight, getKey3, collectHeight, syncScrollTop, function() {
    var _scrollBarRef$current;
    (_scrollBarRef$current = scrollBarRef.current) === null || _scrollBarRef$current === void 0 ? void 0 : _scrollBarRef$current.delayHidden();
  });
  React.useImperativeHandle(ref, function() {
    return {
      scrollTo: scrollTo2
    };
  });
  useLayoutEffect$2(function() {
    if (onVisibleChange) {
      var renderList = mergedData.slice(start, end + 1);
      onVisibleChange(renderList, mergedData);
    }
  }, [start, end, mergedData]);
  var listChildren = useChildren(mergedData, start, end, setInstanceRef, children, sharedConfig);
  var componentStyle = null;
  if (height) {
    componentStyle = _objectSpread(_defineProperty$1({}, fullHeight ? "height" : "maxHeight", height), ScrollStyle);
    if (useVirtual) {
      componentStyle.overflowY = "hidden";
      if (scrollMoving) {
        componentStyle.pointerEvents = "none";
      }
    }
  }
  return /* @__PURE__ */ React.createElement("div", _extends({
    style: _objectSpread(_objectSpread({}, style2), {}, {
      position: "relative"
    }),
    className: mergedClassName
  }, restProps), /* @__PURE__ */ React.createElement(Component3, {
    className: "".concat(prefixCls, "-holder"),
    style: componentStyle,
    ref: componentRef,
    onScroll: onFallbackScroll
  }, /* @__PURE__ */ React.createElement(Filler, {
    prefixCls,
    height: scrollHeight,
    offset: offset3,
    onInnerResize: collectHeight,
    ref: fillerInnerRef
  }, listChildren)), useVirtual && /* @__PURE__ */ React.createElement(ScrollBar, {
    ref: scrollBarRef,
    prefixCls,
    scrollTop,
    height,
    scrollHeight,
    count: mergedData.length,
    onScroll: onScrollBar,
    onStartMove: function onStartMove() {
      setScrollMoving(true);
    },
    onStopMove: function onStopMove() {
      setScrollMoving(false);
    }
  }));
}
var List2 = /* @__PURE__ */ React.forwardRef(RawList);
List2.displayName = "List";
var TransBtn = function TransBtn2(_ref) {
  var className = _ref.className, customizeIcon = _ref.customizeIcon, customizeIconProps = _ref.customizeIconProps, _onMouseDown = _ref.onMouseDown, onClick = _ref.onClick, children = _ref.children;
  var icon;
  if (typeof customizeIcon === "function") {
    icon = customizeIcon(customizeIconProps);
  } else {
    icon = customizeIcon;
  }
  return /* @__PURE__ */ React.createElement("span", {
    className,
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      if (_onMouseDown) {
        _onMouseDown(event);
      }
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick,
    "aria-hidden": true
  }, icon !== void 0 ? icon : /* @__PURE__ */ React.createElement("span", {
    className: cn(className.split(/\s+/).map(function(cls) {
      return "".concat(cls, "-icon");
    }))
  }, children));
};
var OptionList$1 = function OptionList(_ref, ref) {
  var prefixCls = _ref.prefixCls, id2 = _ref.id, flattenOptions2 = _ref.flattenOptions, childrenAsData = _ref.childrenAsData, values = _ref.values, searchValue = _ref.searchValue, multiple = _ref.multiple, defaultActiveFirstOption = _ref.defaultActiveFirstOption, height = _ref.height, itemHeight = _ref.itemHeight, notFoundContent = _ref.notFoundContent, open = _ref.open, menuItemSelectedIcon = _ref.menuItemSelectedIcon, virtual = _ref.virtual, onSelect = _ref.onSelect, onToggleOpen = _ref.onToggleOpen, onActiveValue = _ref.onActiveValue, onScroll = _ref.onScroll, onMouseEnter = _ref.onMouseEnter;
  var itemPrefixCls = "".concat(prefixCls, "-item");
  var memoFlattenOptions = useMemo2(function() {
    return flattenOptions2;
  }, [open, flattenOptions2], function(prev, next) {
    return next[0] && prev[1] !== next[1];
  });
  var listRef = React.useRef(null);
  var onListMouseDown = function onListMouseDown2(event) {
    event.preventDefault();
  };
  var scrollIntoView2 = function scrollIntoView3(index2) {
    if (listRef.current) {
      listRef.current.scrollTo({
        index: index2
      });
    }
  };
  var getEnabledActiveIndex = function getEnabledActiveIndex2(index2) {
    var offset3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var len = memoFlattenOptions.length;
    for (var i2 = 0; i2 < len; i2 += 1) {
      var current = (index2 + i2 * offset3 + len) % len;
      var _memoFlattenOptions$c = memoFlattenOptions[current], group = _memoFlattenOptions$c.group, data = _memoFlattenOptions$c.data;
      if (!group && !data.disabled) {
        return current;
      }
    }
    return -1;
  };
  var _React$useState = React.useState(function() {
    return getEnabledActiveIndex(0);
  }), _React$useState2 = _slicedToArray$3(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
  var setActive = function setActive2(index2) {
    var fromKeyboard = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    setActiveIndex(index2);
    var info = {
      source: fromKeyboard ? "keyboard" : "mouse"
    };
    var flattenItem = memoFlattenOptions[index2];
    if (!flattenItem) {
      onActiveValue(null, -1, info);
      return;
    }
    onActiveValue(flattenItem.data.value, index2, info);
  };
  React.useEffect(function() {
    setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
  }, [memoFlattenOptions.length, searchValue]);
  React.useEffect(function() {
    var timeoutId = setTimeout(function() {
      if (!multiple && open && values.size === 1) {
        var value = Array.from(values)[0];
        var index2 = memoFlattenOptions.findIndex(function(_ref2) {
          var data = _ref2.data;
          return data.value === value;
        });
        setActive(index2);
        scrollIntoView2(index2);
      }
    });
    if (open) {
      var _listRef$current;
      (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(timeoutId);
    };
  }, [open]);
  var onSelectValue = function onSelectValue2(value) {
    if (value !== void 0) {
      onSelect(value, {
        selected: !values.has(value)
      });
    }
    if (!multiple) {
      onToggleOpen(false);
    }
  };
  React.useImperativeHandle(ref, function() {
    return {
      onKeyDown: function onKeyDown2(event) {
        var which = event.which;
        switch (which) {
          case KeyCode.UP:
          case KeyCode.DOWN: {
            var offset3 = 0;
            if (which === KeyCode.UP) {
              offset3 = -1;
            } else if (which === KeyCode.DOWN) {
              offset3 = 1;
            }
            if (offset3 !== 0) {
              var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset3, offset3);
              scrollIntoView2(nextActiveIndex);
              setActive(nextActiveIndex, true);
            }
            break;
          }
          case KeyCode.ENTER: {
            var item = memoFlattenOptions[activeIndex];
            if (item && !item.data.disabled) {
              onSelectValue(item.data.value);
            } else {
              onSelectValue(void 0);
            }
            if (open) {
              event.preventDefault();
            }
            break;
          }
          case KeyCode.ESC: {
            onToggleOpen(false);
            if (open) {
              event.stopPropagation();
            }
          }
        }
      },
      onKeyUp: function onKeyUp2() {
      },
      scrollTo: function scrollTo2(index2) {
        scrollIntoView2(index2);
      }
    };
  });
  if (memoFlattenOptions.length === 0) {
    return /* @__PURE__ */ React.createElement("div", {
      role: "listbox",
      id: "".concat(id2, "_list"),
      className: "".concat(itemPrefixCls, "-empty"),
      onMouseDown: onListMouseDown
    }, notFoundContent);
  }
  function renderItem(index2) {
    var item = memoFlattenOptions[index2];
    if (!item)
      return null;
    var itemData = item.data || {};
    var value = itemData.value, label = itemData.label, children = itemData.children;
    var attrs = pickAttrs(itemData, true);
    var mergedLabel = childrenAsData ? children : label;
    return item ? /* @__PURE__ */ React.createElement("div", _extends$2({
      "aria-label": typeof mergedLabel === "string" ? mergedLabel : null
    }, attrs, {
      key: index2,
      role: "option",
      id: "".concat(id2, "_list_").concat(index2),
      "aria-selected": values.has(value)
    }), value) : null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    role: "listbox",
    id: "".concat(id2, "_list"),
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }, renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /* @__PURE__ */ React.createElement(List2, {
    itemKey: "key",
    ref: listRef,
    data: memoFlattenOptions,
    height,
    itemHeight,
    fullHeight: false,
    onMouseDown: onListMouseDown,
    onScroll,
    virtual,
    onMouseEnter
  }, function(_ref3, itemIndex) {
    var _classNames;
    var group = _ref3.group, groupOption = _ref3.groupOption, data = _ref3.data;
    var label = data.label, key2 = data.key;
    if (group) {
      return /* @__PURE__ */ React.createElement("div", {
        className: cn(itemPrefixCls, "".concat(itemPrefixCls, "-group"))
      }, label !== void 0 ? label : key2);
    }
    var disabled = data.disabled, value = data.value, title = data.title, children = data.children, style2 = data.style, className = data.className, otherProps = _objectWithoutProperties$1(data, ["disabled", "value", "title", "children", "style", "className"]);
    var selected = values.has(value);
    var optionPrefixCls = "".concat(itemPrefixCls, "-option");
    var optionClassName = cn(itemPrefixCls, optionPrefixCls, className, (_classNames = {}, _defineProperty$4(_classNames, "".concat(optionPrefixCls, "-grouped"), groupOption), _defineProperty$4(_classNames, "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !disabled), _defineProperty$4(_classNames, "".concat(optionPrefixCls, "-disabled"), disabled), _defineProperty$4(_classNames, "".concat(optionPrefixCls, "-selected"), selected), _classNames));
    var mergedLabel = childrenAsData ? children : label;
    var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === "function" || selected;
    var content = mergedLabel || value;
    var optionTitle = typeof content === "string" || typeof content === "number" ? content.toString() : void 0;
    if (title !== void 0) {
      optionTitle = title;
    }
    return /* @__PURE__ */ React.createElement("div", _extends$2({}, otherProps, {
      "aria-selected": selected,
      className: optionClassName,
      title: optionTitle,
      onMouseMove: function onMouseMove() {
        if (activeIndex === itemIndex || disabled) {
          return;
        }
        setActive(itemIndex);
      },
      onClick: function onClick() {
        if (!disabled) {
          onSelectValue(value);
        }
      },
      style: style2
    }), /* @__PURE__ */ React.createElement("div", {
      className: "".concat(optionPrefixCls, "-content")
    }, content), /* @__PURE__ */ React.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /* @__PURE__ */ React.createElement(TransBtn, {
      className: "".concat(itemPrefixCls, "-option-state"),
      customizeIcon: menuItemSelectedIcon,
      customizeIconProps: {
        isSelected: selected
      }
    }, selected ? "\u2713" : null));
  }));
};
var RefOptionList$1 = /* @__PURE__ */ React.forwardRef(OptionList$1);
RefOptionList$1.displayName = "OptionList";
var Option$3 = function Option() {
  return null;
};
Option$3.isSelectOption = true;
var OptGroup = function OptGroup2() {
  return null;
};
OptGroup.isSelectOptGroup = true;
function convertNodeToOption(node) {
  var key2 = node.key, _node$props = node.props, children = _node$props.children, value = _node$props.value, restProps = _objectWithoutProperties$1(_node$props, ["children", "value"]);
  return _objectSpread2$1({
    key: key2,
    value: value !== void 0 ? value : key2,
    children
  }, restProps);
}
function convertChildrenToData$1(nodes) {
  var optionOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  return toArray$8(nodes).map(function(node, index2) {
    if (!/* @__PURE__ */ React.isValidElement(node) || !node.type) {
      return null;
    }
    var isSelectOptGroup = node.type.isSelectOptGroup, key2 = node.key, _node$props2 = node.props, children = _node$props2.children, restProps = _objectWithoutProperties$1(_node$props2, ["children"]);
    if (optionOnly || !isSelectOptGroup) {
      return convertNodeToOption(node);
    }
    return _objectSpread2$1(_objectSpread2$1({
      key: "__RC_SELECT_GRP__".concat(key2 === null ? index2 : key2, "__"),
      label: key2
    }, restProps), {}, {
      options: convertChildrenToData$1(children)
    });
  }).filter(function(data) {
    return data;
  });
}
function toArray$6(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return value !== void 0 ? [value] : [];
}
function toInnerValue(value, _ref) {
  var labelInValue = _ref.labelInValue, combobox = _ref.combobox;
  var valueMap = /* @__PURE__ */ new Map();
  if (value === void 0 || value === "" && combobox) {
    return [[], valueMap];
  }
  var values = Array.isArray(value) ? value : [value];
  var rawValues = values;
  if (labelInValue) {
    rawValues = values.filter(function(item) {
      return item !== null;
    }).map(function(itemValue) {
      var key2 = itemValue.key, val = itemValue.value;
      var finalVal = val !== void 0 ? val : key2;
      valueMap.set(finalVal, itemValue);
      return finalVal;
    });
  }
  return [rawValues, valueMap];
}
function toOuterValues(valueList, _ref2) {
  var optionLabelProp = _ref2.optionLabelProp, labelInValue = _ref2.labelInValue, prevValueMap = _ref2.prevValueMap, options = _ref2.options, getLabeledValue3 = _ref2.getLabeledValue;
  var values = valueList;
  if (labelInValue) {
    values = values.map(function(val) {
      return getLabeledValue3(val, {
        options,
        prevValueMap,
        labelInValue,
        optionLabelProp
      });
    });
  }
  return values;
}
function removeLastEnabledValue(measureValues, values) {
  var newValues = _toConsumableArray(values);
  var removeIndex;
  for (removeIndex = measureValues.length - 1; removeIndex >= 0; removeIndex -= 1) {
    if (!measureValues[removeIndex].disabled) {
      break;
    }
  }
  var removedValue = null;
  if (removeIndex !== -1) {
    removedValue = newValues[removeIndex];
    newValues.splice(removeIndex, 1);
  }
  return {
    values: newValues,
    removedValue
  };
}
var isClient = typeof window !== "undefined" && window.document && window.document.documentElement;
var isBrowserClient = process.env.NODE_ENV !== "test" && isClient;
var uuid$2 = 0;
function getUUID() {
  var retId;
  if (isBrowserClient) {
    retId = uuid$2;
    uuid$2 += 1;
  } else {
    retId = "TEST_OR_SSR";
  }
  return retId;
}
function getKey$2(data, index2) {
  var key2 = data.key;
  var value;
  if ("value" in data) {
    value = data.value;
  }
  if (key2 !== null && key2 !== void 0) {
    return key2;
  }
  if (value !== void 0) {
    return value;
  }
  return "rc-index-key-".concat(index2);
}
function flattenOptions$1(options) {
  var flattenList = [];
  function dig(list, isGroupOption) {
    list.forEach(function(data) {
      if (isGroupOption || !("options" in data)) {
        flattenList.push({
          key: getKey$2(data, flattenList.length),
          groupOption: isGroupOption,
          data
        });
      } else {
        flattenList.push({
          key: getKey$2(data, flattenList.length),
          group: true,
          data
        });
        dig(data.options, true);
      }
    });
  }
  dig(options, false);
  return flattenList;
}
function injectPropsWithOption(option) {
  var newOption = _objectSpread2$1({}, option);
  if (!("props" in newOption)) {
    Object.defineProperty(newOption, "props", {
      get: function get2() {
        warningOnce(false, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`.");
        return newOption;
      }
    });
  }
  return newOption;
}
function findValueOption$1(values, options) {
  var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref$prevValueOptions = _ref.prevValueOptions, prevValueOptions = _ref$prevValueOptions === void 0 ? [] : _ref$prevValueOptions;
  var optionMap = /* @__PURE__ */ new Map();
  options.forEach(function(flattenItem) {
    if (!flattenItem.group) {
      var data = flattenItem.data;
      optionMap.set(data.value, data);
    }
  });
  return values.map(function(val) {
    var option = optionMap.get(val);
    if (!option) {
      option = _objectSpread2$1({}, prevValueOptions.find(function(opt) {
        return opt._INTERNAL_OPTION_VALUE_ === val;
      }));
    }
    return injectPropsWithOption(option);
  });
}
var getLabeledValue = function getLabeledValue2(value, _ref2) {
  var options = _ref2.options, prevValueMap = _ref2.prevValueMap, labelInValue = _ref2.labelInValue, optionLabelProp = _ref2.optionLabelProp;
  var item = findValueOption$1([value], options)[0];
  var result = {
    value
  };
  var prevValItem = labelInValue ? prevValueMap.get(value) : void 0;
  if (prevValItem && _typeof$5(prevValItem) === "object" && "label" in prevValItem) {
    result.label = prevValItem.label;
    if (item && typeof prevValItem.label === "string" && typeof item[optionLabelProp] === "string" && prevValItem.label.trim() !== item[optionLabelProp].trim()) {
      warningOnce(false, "`label` of `value` is not same as `label` in Select options.");
    }
  } else if (item && optionLabelProp in item) {
    result.label = item[optionLabelProp];
  } else {
    result.label = value;
    result.isCacheable = true;
  }
  result.key = result.value;
  return result;
};
function toRawString(content) {
  return toArray$6(content).join("");
}
function getFilterFunction(optionFilterProp) {
  return function(searchValue, option) {
    var lowerSearchText = searchValue.toLowerCase();
    if ("options" in option) {
      return toRawString(option.label).toLowerCase().includes(lowerSearchText);
    }
    var rawValue = option[optionFilterProp];
    var value = toRawString(rawValue).toLowerCase();
    return value.includes(lowerSearchText);
  };
}
function filterOptions$1(searchValue, options, _ref3) {
  var optionFilterProp = _ref3.optionFilterProp, filterOption2 = _ref3.filterOption;
  var filteredOptions = [];
  var filterFunc;
  if (filterOption2 === false) {
    return _toConsumableArray(options);
  }
  if (typeof filterOption2 === "function") {
    filterFunc = filterOption2;
  } else {
    filterFunc = getFilterFunction(optionFilterProp);
  }
  options.forEach(function(item) {
    if ("options" in item) {
      var matchGroup = filterFunc(searchValue, item);
      if (matchGroup) {
        filteredOptions.push(item);
      } else {
        var subOptions = item.options.filter(function(subItem) {
          return filterFunc(searchValue, subItem);
        });
        if (subOptions.length) {
          filteredOptions.push(_objectSpread2$1(_objectSpread2$1({}, item), {}, {
            options: subOptions
          }));
        }
      }
      return;
    }
    if (filterFunc(searchValue, injectPropsWithOption(item))) {
      filteredOptions.push(item);
    }
  });
  return filteredOptions;
}
function getSeparatedContent(text, tokens) {
  if (!tokens || !tokens.length) {
    return null;
  }
  var match2 = false;
  function separate(str, _ref4) {
    var _ref5 = _toArray(_ref4), token = _ref5[0], restTokens = _ref5.slice(1);
    if (!token) {
      return [str];
    }
    var list2 = str.split(token);
    match2 = match2 || list2.length > 1;
    return list2.reduce(function(prevList, unitStr) {
      return [].concat(_toConsumableArray(prevList), _toConsumableArray(separate(unitStr, restTokens)));
    }, []).filter(function(unit) {
      return unit;
    });
  }
  var list = separate(text, tokens);
  return match2 ? list : null;
}
function isValueDisabled$1(value, options) {
  var option = findValueOption$1([value], options)[0];
  return option.disabled;
}
function fillOptionsWithMissingValue(options, value, optionLabelProp, labelInValue) {
  var values = toArray$6(value).slice().sort();
  var cloneOptions = _toConsumableArray(options);
  var optionValues = /* @__PURE__ */ new Set();
  options.forEach(function(opt) {
    if (opt.options) {
      opt.options.forEach(function(subOpt) {
        optionValues.add(subOpt.value);
      });
    } else {
      optionValues.add(opt.value);
    }
  });
  values.forEach(function(item) {
    var val = labelInValue ? item.value : item;
    if (!optionValues.has(val)) {
      var _ref6;
      cloneOptions.push(labelInValue ? (_ref6 = {}, _defineProperty$4(_ref6, optionLabelProp, item.label), _defineProperty$4(_ref6, "value", val), _ref6) : {
        value: val
      });
    }
  });
  return cloneOptions;
}
var isMobile$1 = function() {
  if (typeof navigator === "undefined" || typeof window === "undefined") {
    return false;
  }
  var agent = navigator.userAgent || navigator.vendor || window.opera;
  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4))) {
    return true;
  }
  return false;
};
function useEvent(callback) {
  var fnRef = React.useRef();
  fnRef.current = callback;
  var memoFn = React.useCallback(function() {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}
var Source;
(function(Source2) {
  Source2[Source2["INNER"] = 0] = "INNER";
  Source2[Source2["PROP"] = 1] = "PROP";
})(Source || (Source = {}));
function hasValue(value) {
  return value !== void 0;
}
function useMergedState(defaultStateValue, option) {
  var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange4 = _ref.onChange, postState = _ref.postState;
  var _useState = useSafeState(function() {
    var finalValue = void 0;
    var source;
    if (hasValue(value)) {
      finalValue = value;
      source = Source.PROP;
    } else if (hasValue(defaultValue)) {
      finalValue = typeof defaultValue === "function" ? defaultValue() : defaultValue;
      source = Source.PROP;
    } else {
      finalValue = typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
      source = Source.INNER;
    }
    return [finalValue, source, finalValue];
  }), _useState2 = _slicedToArray$3(_useState, 2), mergedValue = _useState2[0], setMergedValue = _useState2[1];
  var chosenValue = hasValue(value) ? value : mergedValue[0];
  var postMergedValue = postState ? postState(chosenValue) : chosenValue;
  useLayoutUpdateEffect(function() {
    setMergedValue(function(_ref2) {
      var _ref3 = _slicedToArray$3(_ref2, 1), prevValue = _ref3[0];
      return [value, Source.PROP, prevValue];
    });
  }, [value]);
  var changeEventPrevRef = React.useRef();
  var triggerChange = useEvent(function(updater, ignoreDestroy) {
    setMergedValue(function(prev) {
      var _prev = _slicedToArray$3(prev, 3), prevValue = _prev[0], prevSource = _prev[1], prevPrevValue = _prev[2];
      var nextValue = typeof updater === "function" ? updater(prevValue) : updater;
      if (nextValue === prevValue) {
        return prev;
      }
      var overridePrevValue = prevSource === Source.INNER && changeEventPrevRef.current !== prevPrevValue ? prevPrevValue : prevValue;
      return [nextValue, Source.INNER, overridePrevValue];
    }, ignoreDestroy);
  });
  var onChangeFn = useEvent(onChange4);
  useLayoutEffect$2(function() {
    var _mergedValue = _slicedToArray$3(mergedValue, 3), current = _mergedValue[0], source = _mergedValue[1], prev = _mergedValue[2];
    if (current !== prev && source === Source.INNER) {
      onChangeFn(current, prev);
      changeEventPrevRef.current = prev;
    }
  }, [mergedValue]);
  return [postMergedValue, triggerChange];
}
var _excluded$6 = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"];
var UNDEFINED = void 0;
function InternalItem(props, ref) {
  var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey2 = props.itemKey, className = props.className, style2 = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component3 = _props$component === void 0 ? "div" : _props$component, restProps = _objectWithoutProperties$1(props, _excluded$6);
  var mergedHidden = responsive && !display;
  function internalRegisterSize(width) {
    registerSize(itemKey2, width);
  }
  React.useEffect(function() {
    return function() {
      internalRegisterSize(null);
    };
  }, []);
  var childNode = renderItem && item !== UNDEFINED ? renderItem(item) : children;
  var overflowStyle;
  if (!invalidate) {
    overflowStyle = {
      opacity: mergedHidden ? 0 : 1,
      height: mergedHidden ? 0 : UNDEFINED,
      overflowY: mergedHidden ? "hidden" : UNDEFINED,
      order: responsive ? order : UNDEFINED,
      pointerEvents: mergedHidden ? "none" : UNDEFINED,
      position: mergedHidden ? "absolute" : UNDEFINED
    };
  }
  var overflowProps = {};
  if (mergedHidden) {
    overflowProps["aria-hidden"] = true;
  }
  var itemNode = /* @__PURE__ */ React.createElement(Component3, _extends$2({
    className: cn(!invalidate && prefixCls, className),
    style: _objectSpread2$1(_objectSpread2$1({}, overflowStyle), style2)
  }, overflowProps, restProps, {
    ref
  }), childNode);
  if (responsive) {
    itemNode = /* @__PURE__ */ React.createElement(ResizeObserver, {
      onResize: function onResize2(_ref) {
        var offsetWidth = _ref.offsetWidth;
        internalRegisterSize(offsetWidth);
      },
      disabled: responsiveDisabled
    }, itemNode);
  }
  return itemNode;
}
var Item$1 = /* @__PURE__ */ React.forwardRef(InternalItem);
Item$1.displayName = "Item";
function useBatchFrameState() {
  var _useState = useSafeState({}), _useState2 = _slicedToArray$3(_useState, 2), forceUpdate = _useState2[1];
  var statesRef = useRef2([]);
  var walkingIndex = 0;
  var beforeFrameId = 0;
  function createState(defaultValue) {
    var myIndex = walkingIndex;
    walkingIndex += 1;
    if (statesRef.current.length < myIndex + 1) {
      statesRef.current[myIndex] = defaultValue;
    }
    var value = statesRef.current[myIndex];
    function setValue2(val) {
      statesRef.current[myIndex] = typeof val === "function" ? val(statesRef.current[myIndex]) : val;
      wrapperRaf$1.cancel(beforeFrameId);
      beforeFrameId = wrapperRaf$1(function() {
        forceUpdate({}, true);
      });
    }
    return [value, setValue2];
  }
  return createState;
}
var _excluded$5 = ["component"];
var _excluded2 = ["className"];
var _excluded3 = ["className"];
var InternalRawItem = function InternalRawItem2(props, ref) {
  var context2 = React.useContext(OverflowContext);
  if (!context2) {
    var _props$component = props.component, Component3 = _props$component === void 0 ? "div" : _props$component, _restProps = _objectWithoutProperties$1(props, _excluded$5);
    return /* @__PURE__ */ React.createElement(Component3, _extends$2({}, _restProps, {
      ref
    }));
  }
  var contextClassName = context2.className, restContext = _objectWithoutProperties$1(context2, _excluded2);
  var className = props.className, restProps = _objectWithoutProperties$1(props, _excluded3);
  return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: null
  }, /* @__PURE__ */ React.createElement(Item$1, _extends$2({
    ref,
    className: cn(contextClassName, className)
  }, restContext, restProps)));
};
var RawItem = /* @__PURE__ */ React.forwardRef(InternalRawItem);
RawItem.displayName = "RawItem";
var _excluded$4 = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"];
var OverflowContext = /* @__PURE__ */ React.createContext(null);
var RESPONSIVE = "responsive";
var INVALIDATE = "invalidate";
function defaultRenderRest(omittedItems) {
  return "+ ".concat(omittedItems.length, " ...");
}
function Overflow(props, ref) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-overflow" : _props$prefixCls, _props$data = props.data, data = _props$data === void 0 ? [] : _props$data, renderItem = props.renderItem, renderRawItem = props.renderRawItem, itemKey2 = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style2 = props.style, className = props.className, maxCount2 = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, suffix = props.suffix, _props$component = props.component, Component3 = _props$component === void 0 ? "div" : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = _objectWithoutProperties$1(props, _excluded$4);
  var createUseState = useBatchFrameState();
  var fullySSR = ssr === "full";
  var _createUseState = createUseState(null), _createUseState2 = _slicedToArray$3(_createUseState, 2), containerWidth = _createUseState2[0], setContainerWidth = _createUseState2[1];
  var mergedContainerWidth = containerWidth || 0;
  var _createUseState3 = createUseState(/* @__PURE__ */ new Map()), _createUseState4 = _slicedToArray$3(_createUseState3, 2), itemWidths = _createUseState4[0], setItemWidths = _createUseState4[1];
  var _createUseState5 = createUseState(0), _createUseState6 = _slicedToArray$3(_createUseState5, 2), prevRestWidth = _createUseState6[0], setPrevRestWidth = _createUseState6[1];
  var _createUseState7 = createUseState(0), _createUseState8 = _slicedToArray$3(_createUseState7, 2), restWidth = _createUseState8[0], setRestWidth = _createUseState8[1];
  var _createUseState9 = createUseState(0), _createUseState10 = _slicedToArray$3(_createUseState9, 2), suffixWidth = _createUseState10[0], setSuffixWidth = _createUseState10[1];
  var _useState = useState2(null), _useState2 = _slicedToArray$3(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
  var _useState3 = useState2(null), _useState4 = _slicedToArray$3(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
  var mergedDisplayCount = React.useMemo(function() {
    if (displayCount === null && fullySSR) {
      return Number.MAX_SAFE_INTEGER;
    }
    return displayCount || 0;
  }, [displayCount, containerWidth]);
  var _useState5 = useState2(false), _useState6 = _slicedToArray$3(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
  var itemPrefixCls = "".concat(prefixCls, "-item");
  var mergedRestWidth = Math.max(prevRestWidth, restWidth);
  var isResponsive = maxCount2 === RESPONSIVE;
  var shouldResponsive = data.length && isResponsive;
  var invalidate = maxCount2 === INVALIDATE;
  var showRest = shouldResponsive || typeof maxCount2 === "number" && data.length > maxCount2;
  var mergedData = useMemo$1(function() {
    var items = data;
    if (shouldResponsive) {
      if (containerWidth === null && fullySSR) {
        items = data;
      } else {
        items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
      }
    } else if (typeof maxCount2 === "number") {
      items = data.slice(0, maxCount2);
    }
    return items;
  }, [data, itemWidth, containerWidth, maxCount2, shouldResponsive]);
  var omittedItems = useMemo$1(function() {
    if (shouldResponsive) {
      return data.slice(mergedDisplayCount + 1);
    }
    return data.slice(mergedData.length);
  }, [data, mergedData, shouldResponsive, mergedDisplayCount]);
  var getKey3 = useCallback2(function(item, index2) {
    var _ref;
    if (typeof itemKey2 === "function") {
      return itemKey2(item);
    }
    return (_ref = itemKey2 && (item === null || item === void 0 ? void 0 : item[itemKey2])) !== null && _ref !== void 0 ? _ref : index2;
  }, [itemKey2]);
  var mergedRenderItem = useCallback2(renderItem || function(item) {
    return item;
  }, [renderItem]);
  function updateDisplayCount(count, notReady) {
    setDisplayCount(count);
    if (!notReady) {
      setRestReady(count < data.length - 1);
      onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(count);
    }
  }
  function onOverflowResize(_2, element) {
    setContainerWidth(element.clientWidth);
  }
  function registerSize(key2, width) {
    setItemWidths(function(origin) {
      var clone2 = new Map(origin);
      if (width === null) {
        clone2.delete(key2);
      } else {
        clone2.set(key2, width);
      }
      return clone2;
    });
  }
  function registerOverflowSize(_2, width) {
    setRestWidth(width);
    setPrevRestWidth(restWidth);
  }
  function registerSuffixSize(_2, width) {
    setSuffixWidth(width);
  }
  function getItemWidth(index2) {
    return itemWidths.get(getKey3(mergedData[index2], index2));
  }
  useLayoutEffect$2(function() {
    if (mergedContainerWidth && mergedRestWidth && mergedData) {
      var totalWidth = suffixWidth;
      var len = mergedData.length;
      var lastIndex = len - 1;
      if (!len) {
        updateDisplayCount(0);
        setSuffixFixedStart(null);
        return;
      }
      for (var i2 = 0; i2 < len; i2 += 1) {
        var currentItemWidth = getItemWidth(i2);
        if (fullySSR) {
          currentItemWidth = currentItemWidth || 0;
        }
        if (currentItemWidth === void 0) {
          updateDisplayCount(i2 - 1, true);
          break;
        }
        totalWidth += currentItemWidth;
        if (lastIndex === 0 && totalWidth <= mergedContainerWidth || i2 === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
          updateDisplayCount(lastIndex);
          setSuffixFixedStart(null);
          break;
        } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
          updateDisplayCount(i2 - 1);
          setSuffixFixedStart(totalWidth - currentItemWidth - suffixWidth + restWidth);
          break;
        }
      }
      if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) {
        setSuffixFixedStart(null);
      }
    }
  }, [mergedContainerWidth, itemWidths, restWidth, suffixWidth, getKey3, mergedData]);
  var displayRest = restReady && !!omittedItems.length;
  var suffixStyle = {};
  if (suffixFixedStart !== null && shouldResponsive) {
    suffixStyle = {
      position: "absolute",
      left: suffixFixedStart,
      top: 0
    };
  }
  var itemSharedProps = {
    prefixCls: itemPrefixCls,
    responsive: shouldResponsive,
    component: itemComponent,
    invalidate
  };
  var internalRenderItemNode = renderRawItem ? function(item, index2) {
    var key2 = getKey3(item, index2);
    return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
      key: key2,
      value: _objectSpread2$1(_objectSpread2$1({}, itemSharedProps), {}, {
        order: index2,
        item,
        itemKey: key2,
        registerSize,
        display: index2 <= mergedDisplayCount
      })
    }, renderRawItem(item, index2));
  } : function(item, index2) {
    var key2 = getKey3(item, index2);
    return /* @__PURE__ */ React.createElement(Item$1, _extends$2({}, itemSharedProps, {
      order: index2,
      key: key2,
      item,
      renderItem: mergedRenderItem,
      itemKey: key2,
      registerSize,
      display: index2 <= mergedDisplayCount
    }));
  };
  var restNode;
  var restContextProps = {
    order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
    className: "".concat(itemPrefixCls, "-rest"),
    registerSize: registerOverflowSize,
    display: displayRest
  };
  if (!renderRawRest) {
    var mergedRenderRest = renderRest || defaultRenderRest;
    restNode = /* @__PURE__ */ React.createElement(Item$1, _extends$2({}, itemSharedProps, restContextProps), typeof mergedRenderRest === "function" ? mergedRenderRest(omittedItems) : mergedRenderRest);
  } else if (renderRawRest) {
    restNode = /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
      value: _objectSpread2$1(_objectSpread2$1({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems));
  }
  var overflowNode = /* @__PURE__ */ React.createElement(Component3, _extends$2({
    className: cn(!invalidate && prefixCls, className),
    style: style2,
    ref
  }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /* @__PURE__ */ React.createElement(Item$1, _extends$2({}, itemSharedProps, {
    responsive: isResponsive,
    responsiveDisabled: !shouldResponsive,
    order: mergedDisplayCount,
    className: "".concat(itemPrefixCls, "-suffix"),
    registerSize: registerSuffixSize,
    display: true,
    style: suffixStyle
  }), suffix));
  if (isResponsive) {
    overflowNode = /* @__PURE__ */ React.createElement(ResizeObserver, {
      onResize: onOverflowResize,
      disabled: !shouldResponsive
    }, overflowNode);
  }
  return overflowNode;
}
var ForwardOverflow = /* @__PURE__ */ React.forwardRef(Overflow);
ForwardOverflow.displayName = "Overflow";
ForwardOverflow.Item = RawItem;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
var Input$2 = function Input(_ref, ref) {
  var _inputNode2, _inputNode2$props;
  var prefixCls = _ref.prefixCls, id2 = _ref.id, inputElement = _ref.inputElement, disabled = _ref.disabled, tabIndex = _ref.tabIndex, autoFocus = _ref.autoFocus, autoComplete = _ref.autoComplete, editable = _ref.editable, accessibilityIndex = _ref.accessibilityIndex, value = _ref.value, maxLength = _ref.maxLength, _onKeyDown = _ref.onKeyDown, _onMouseDown = _ref.onMouseDown, _onChange = _ref.onChange, onPaste = _ref.onPaste, _onCompositionStart = _ref.onCompositionStart, _onCompositionEnd = _ref.onCompositionEnd, open = _ref.open, attrs = _ref.attrs;
  var inputNode = inputElement || /* @__PURE__ */ React.createElement("input", null);
  var _inputNode = inputNode, originRef = _inputNode.ref, _inputNode$props = _inputNode.props, onOriginKeyDown = _inputNode$props.onKeyDown, onOriginChange = _inputNode$props.onChange, onOriginMouseDown = _inputNode$props.onMouseDown, onOriginCompositionStart = _inputNode$props.onCompositionStart, onOriginCompositionEnd = _inputNode$props.onCompositionEnd, style2 = _inputNode$props.style;
  inputNode = /* @__PURE__ */ React.cloneElement(inputNode, _objectSpread2$1(_objectSpread2$1({
    id: id2,
    ref: composeRef(ref, originRef),
    disabled,
    tabIndex,
    autoComplete: autoComplete || "off",
    type: "search",
    autoFocus,
    className: cn("".concat(prefixCls, "-selection-search-input"), (_inputNode2 = inputNode) === null || _inputNode2 === void 0 ? void 0 : (_inputNode2$props = _inputNode2.props) === null || _inputNode2$props === void 0 ? void 0 : _inputNode2$props.className),
    style: _objectSpread2$1(_objectSpread2$1({}, style2), {}, {
      opacity: editable ? null : 0
    }),
    role: "combobox",
    "aria-expanded": open,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(id2, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(id2, "_list"),
    "aria-activedescendant": "".concat(id2, "_list_").concat(accessibilityIndex)
  }, attrs), {}, {
    value: editable ? value : "",
    maxLength,
    readOnly: !editable,
    unselectable: !editable ? "on" : null,
    onKeyDown: function onKeyDown2(event) {
      _onKeyDown(event);
      if (onOriginKeyDown) {
        onOriginKeyDown(event);
      }
    },
    onMouseDown: function onMouseDown(event) {
      _onMouseDown(event);
      if (onOriginMouseDown) {
        onOriginMouseDown(event);
      }
    },
    onChange: function onChange4(event) {
      _onChange(event);
      if (onOriginChange) {
        onOriginChange(event);
      }
    },
    onCompositionStart: function onCompositionStart(event) {
      _onCompositionStart(event);
      if (onOriginCompositionStart) {
        onOriginCompositionStart(event);
      }
    },
    onCompositionEnd: function onCompositionEnd(event) {
      _onCompositionEnd(event);
      if (onOriginCompositionEnd) {
        onOriginCompositionEnd(event);
      }
    },
    onPaste
  }));
  return inputNode;
};
var RefInput = /* @__PURE__ */ React.forwardRef(Input$2);
RefInput.displayName = "Input";
function useLayoutEffect$1(effect, deps) {
  if (isBrowserClient) {
    React.useLayoutEffect(effect, deps);
  } else {
    React.useEffect(effect, deps);
  }
}
var onPreventMouseDown = function onPreventMouseDown2(event) {
  event.preventDefault();
  event.stopPropagation();
};
var SelectSelector = function SelectSelector2(props) {
  var id2 = props.id, prefixCls = props.prefixCls, values = props.values, open = props.open, searchValue = props.searchValue, inputRef = props.inputRef, placeholder = props.placeholder, disabled = props.disabled, mode = props.mode, showSearch = props.showSearch, autoFocus = props.autoFocus, autoComplete = props.autoComplete, accessibilityIndex = props.accessibilityIndex, tabIndex = props.tabIndex, removeIcon = props.removeIcon, maxTagCount = props.maxTagCount, maxTagTextLength = props.maxTagTextLength, _props$maxTagPlacehol = props.maxTagPlaceholder, maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function(omittedValues) {
    return "+ ".concat(omittedValues.length, " ...");
  } : _props$maxTagPlacehol, tagRender = props.tagRender, onToggleOpen = props.onToggleOpen, onSelect = props.onSelect, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd;
  var measureRef = React.useRef(null);
  var _useState = useState2(0), _useState2 = _slicedToArray$3(_useState, 2), inputWidth = _useState2[0], setInputWidth = _useState2[1];
  var _useState3 = useState2(false), _useState4 = _slicedToArray$3(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
  var selectionPrefixCls = "".concat(prefixCls, "-selection");
  var inputValue = open || mode === "tags" ? searchValue : "";
  var inputEditable = mode === "tags" || showSearch && (open || focused);
  useLayoutEffect$1(function() {
    setInputWidth(measureRef.current.scrollWidth);
  }, [inputValue]);
  function defaultRenderSelector(content, itemDisabled, closable, onClose2) {
    return /* @__PURE__ */ React.createElement("span", {
      className: cn("".concat(selectionPrefixCls, "-item"), _defineProperty$4({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled))
    }, /* @__PURE__ */ React.createElement("span", {
      className: "".concat(selectionPrefixCls, "-item-content")
    }, content), closable && /* @__PURE__ */ React.createElement(TransBtn, {
      className: "".concat(selectionPrefixCls, "-item-remove"),
      onMouseDown: onPreventMouseDown,
      onClick: onClose2,
      customizeIcon: removeIcon
    }, "\xD7"));
  }
  function customizeRenderSelector(value, content, itemDisabled, closable, onClose2) {
    var onMouseDown = function onMouseDown2(e3) {
      onPreventMouseDown(e3);
      onToggleOpen(!open);
    };
    return /* @__PURE__ */ React.createElement("span", {
      onMouseDown
    }, tagRender({
      label: content,
      value,
      disabled: itemDisabled,
      closable,
      onClose: onClose2
    }));
  }
  function renderItem(_ref) {
    var itemDisabled = _ref.disabled, label = _ref.label, value = _ref.value;
    var closable = !disabled && !itemDisabled;
    var displayLabel = label;
    if (typeof maxTagTextLength === "number") {
      if (typeof label === "string" || typeof label === "number") {
        var strLabel = String(displayLabel);
        if (strLabel.length > maxTagTextLength) {
          displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
        }
      }
    }
    var onClose2 = function onClose3(event) {
      if (event)
        event.stopPropagation();
      onSelect(value, {
        selected: false
      });
    };
    return typeof tagRender === "function" ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose2) : defaultRenderSelector(displayLabel, itemDisabled, closable, onClose2);
  }
  function renderRest(omittedValues) {
    var content = typeof maxTagPlaceholder === "function" ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
    return defaultRenderSelector(content, false);
  }
  var inputNode = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(selectionPrefixCls, "-search"),
    style: {
      width: inputWidth
    },
    onFocus: function onFocus2() {
      setFocused(true);
    },
    onBlur: function onBlur2() {
      setFocused(false);
    }
  }, /* @__PURE__ */ React.createElement(RefInput, {
    ref: inputRef,
    open,
    prefixCls,
    id: id2,
    inputElement: null,
    disabled,
    autoFocus,
    autoComplete,
    editable: inputEditable,
    accessibilityIndex,
    value: inputValue,
    onKeyDown: onInputKeyDown,
    onMouseDown: onInputMouseDown,
    onChange: onInputChange,
    onPaste: onInputPaste,
    onCompositionStart: onInputCompositionStart,
    onCompositionEnd: onInputCompositionEnd,
    tabIndex,
    attrs: pickAttrs(props, true)
  }), /* @__PURE__ */ React.createElement("span", {
    ref: measureRef,
    className: "".concat(selectionPrefixCls, "-search-mirror"),
    "aria-hidden": true
  }, inputValue, "\xA0"));
  var selectionNode = /* @__PURE__ */ React.createElement(ForwardOverflow, {
    prefixCls: "".concat(selectionPrefixCls, "-overflow"),
    data: values,
    renderItem,
    renderRest,
    suffix: inputNode,
    itemKey: "key",
    maxCount: maxTagCount
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, selectionNode, !values.length && !inputValue && /* @__PURE__ */ React.createElement("span", {
    className: "".concat(selectionPrefixCls, "-placeholder")
  }, placeholder));
};
var SingleSelector = function SingleSelector2(props) {
  var inputElement = props.inputElement, prefixCls = props.prefixCls, id2 = props.id, inputRef = props.inputRef, disabled = props.disabled, autoFocus = props.autoFocus, autoComplete = props.autoComplete, accessibilityIndex = props.accessibilityIndex, mode = props.mode, open = props.open, values = props.values, placeholder = props.placeholder, tabIndex = props.tabIndex, showSearch = props.showSearch, searchValue = props.searchValue, activeValue = props.activeValue, maxLength = props.maxLength, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd;
  var _React$useState = React.useState(false), _React$useState2 = _slicedToArray$3(_React$useState, 2), inputChanged = _React$useState2[0], setInputChanged = _React$useState2[1];
  var combobox = mode === "combobox";
  var inputEditable = combobox || showSearch;
  var item = values[0];
  var inputValue = searchValue || "";
  if (combobox && activeValue && !inputChanged) {
    inputValue = activeValue;
  }
  React.useEffect(function() {
    if (combobox) {
      setInputChanged(false);
    }
  }, [combobox, activeValue]);
  var hasTextInput = mode !== "combobox" && !open ? false : !!inputValue;
  var title = item && (typeof item.label === "string" || typeof item.label === "number") ? item.label.toString() : void 0;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", {
    className: "".concat(prefixCls, "-selection-search")
  }, /* @__PURE__ */ React.createElement(RefInput, {
    ref: inputRef,
    prefixCls,
    id: id2,
    open,
    inputElement,
    disabled,
    autoFocus,
    autoComplete,
    editable: inputEditable,
    accessibilityIndex,
    value: inputValue,
    onKeyDown: onInputKeyDown,
    onMouseDown: onInputMouseDown,
    onChange: function onChange4(e3) {
      setInputChanged(true);
      onInputChange(e3);
    },
    onPaste: onInputPaste,
    onCompositionStart: onInputCompositionStart,
    onCompositionEnd: onInputCompositionEnd,
    tabIndex,
    attrs: pickAttrs(props, true),
    maxLength: combobox ? maxLength : void 0
  })), !combobox && item && !hasTextInput && /* @__PURE__ */ React.createElement("span", {
    className: "".concat(prefixCls, "-selection-item"),
    title
  }, item.label), !item && !hasTextInput && /* @__PURE__ */ React.createElement("span", {
    className: "".concat(prefixCls, "-selection-placeholder")
  }, placeholder));
};
function useLock() {
  var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250;
  var lockRef = React.useRef(null);
  var timeoutRef = React.useRef(null);
  React.useEffect(function() {
    return function() {
      window.clearTimeout(timeoutRef.current);
    };
  }, []);
  function doLock(locked) {
    if (locked || lockRef.current === null) {
      lockRef.current = locked;
    }
    window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(function() {
      lockRef.current = null;
    }, duration);
  }
  return [function() {
    return lockRef.current;
  }, doLock];
}
var Selector = function Selector2(props, ref) {
  var inputRef = useRef2(null);
  var compositionStatusRef = useRef2(false);
  var prefixCls = props.prefixCls, multiple = props.multiple, open = props.open, mode = props.mode, showSearch = props.showSearch, tokenWithEnter = props.tokenWithEnter, onSearch = props.onSearch, onSearchSubmit = props.onSearchSubmit, onToggleOpen = props.onToggleOpen, onInputKeyDown = props.onInputKeyDown, domRef = props.domRef;
  React.useImperativeHandle(ref, function() {
    return {
      focus: function focus() {
        inputRef.current.focus();
      },
      blur: function blur() {
        inputRef.current.blur();
      }
    };
  });
  var _useLock = useLock(0), _useLock2 = _slicedToArray$3(_useLock, 2), getInputMouseDown = _useLock2[0], setInputMouseDown = _useLock2[1];
  var onInternalInputKeyDown = function onInternalInputKeyDown2(event) {
    var which = event.which;
    if (which === KeyCode.UP || which === KeyCode.DOWN) {
      event.preventDefault();
    }
    if (onInputKeyDown) {
      onInputKeyDown(event);
    }
    if (which === KeyCode.ENTER && mode === "tags" && !compositionStatusRef.current && !open) {
      onSearchSubmit(event.target.value);
    }
    if (![KeyCode.SHIFT, KeyCode.TAB, KeyCode.BACKSPACE, KeyCode.ESC].includes(which)) {
      onToggleOpen(true);
    }
  };
  var onInternalInputMouseDown = function onInternalInputMouseDown2() {
    setInputMouseDown(true);
  };
  var pastedTextRef = useRef2(null);
  var triggerOnSearch = function triggerOnSearch2(value) {
    if (onSearch(value, true, compositionStatusRef.current) !== false) {
      onToggleOpen(true);
    }
  };
  var onInputCompositionStart = function onInputCompositionStart2() {
    compositionStatusRef.current = true;
  };
  var onInputCompositionEnd = function onInputCompositionEnd2(e3) {
    compositionStatusRef.current = false;
    if (mode !== "combobox") {
      triggerOnSearch(e3.target.value);
    }
  };
  var onInputChange = function onInputChange2(event) {
    var value = event.target.value;
    if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
      var replacedText = pastedTextRef.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      value = value.replace(replacedText, pastedTextRef.current);
    }
    pastedTextRef.current = null;
    triggerOnSearch(value);
  };
  var onInputPaste = function onInputPaste2(e3) {
    var clipboardData = e3.clipboardData;
    var value = clipboardData.getData("text");
    pastedTextRef.current = value;
  };
  var onClick = function onClick2(_ref) {
    var target = _ref.target;
    if (target !== inputRef.current) {
      var isIE = document.body.style.msTouchAction !== void 0;
      if (isIE) {
        setTimeout(function() {
          inputRef.current.focus();
        });
      } else {
        inputRef.current.focus();
      }
    }
  };
  var onMouseDown = function onMouseDown2(event) {
    var inputMouseDown = getInputMouseDown();
    if (event.target !== inputRef.current && !inputMouseDown) {
      event.preventDefault();
    }
    if (mode !== "combobox" && (!showSearch || !inputMouseDown) || !open) {
      if (open) {
        onSearch("", true, false);
      }
      onToggleOpen();
    }
  };
  var sharedProps = {
    inputRef,
    onInputKeyDown: onInternalInputKeyDown,
    onInputMouseDown: onInternalInputMouseDown,
    onInputChange,
    onInputPaste,
    onInputCompositionStart,
    onInputCompositionEnd
  };
  var selectNode = multiple ? /* @__PURE__ */ React.createElement(SelectSelector, _extends$2({}, props, sharedProps)) : /* @__PURE__ */ React.createElement(SingleSelector, _extends$2({}, props, sharedProps));
  return /* @__PURE__ */ React.createElement("div", {
    ref: domRef,
    className: "".concat(prefixCls, "-selector"),
    onClick,
    onMouseDown
  }, selectNode);
};
var ForwardSelector = /* @__PURE__ */ React.forwardRef(Selector);
ForwardSelector.displayName = "Selector";
function contains(root2, n3) {
  if (!root2) {
    return false;
  }
  return root2.contains(n3);
}
var Portal = /* @__PURE__ */ forwardRef2(function(props, ref) {
  var didUpdate = props.didUpdate, getContainer2 = props.getContainer, children = props.children;
  var parentRef = useRef2();
  var containerRef = useRef2();
  useImperativeHandle2(ref, function() {
    return {};
  });
  var initRef = useRef2(false);
  if (!initRef.current && canUseDom()) {
    containerRef.current = getContainer2();
    parentRef.current = containerRef.current.parentNode;
    initRef.current = true;
  }
  useEffect2(function() {
    didUpdate === null || didUpdate === void 0 ? void 0 : didUpdate(props);
  });
  useEffect2(function() {
    if (containerRef.current.parentNode === null && parentRef.current !== null) {
      parentRef.current.appendChild(containerRef.current);
    }
    return function() {
      var _containerRef$current, _containerRef$current2;
      (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : (_containerRef$current2 = _containerRef$current.parentNode) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.removeChild(containerRef.current);
    };
  }, []);
  return containerRef.current ? /* @__PURE__ */ ReactDOM__default.createPortal(children, containerRef.current) : null;
});
function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}
function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return _objectSpread2$1(_objectSpread2$1({}, baseAlign), align);
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  var placements2 = Object.keys(builtinPlacements);
  for (var i2 = 0; i2 < placements2.length; i2 += 1) {
    var placement = placements2[i2];
    if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
      return "".concat(prefixCls, "-placement-").concat(placement);
    }
  }
  return "";
}
function getMotion$1(_ref) {
  var prefixCls = _ref.prefixCls, motion = _ref.motion, animation = _ref.animation, transitionName2 = _ref.transitionName;
  if (motion) {
    return motion;
  }
  if (animation) {
    return {
      motionName: "".concat(prefixCls, "-").concat(animation)
    };
  }
  if (transitionName2) {
    return {
      motionName: transitionName2
    };
  }
  return null;
}
function Mask(props) {
  var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, mask = props.mask, maskMotion = props.maskMotion, maskAnimation = props.maskAnimation, maskTransitionName = props.maskTransitionName;
  if (!mask) {
    return null;
  }
  var motion = {};
  if (maskMotion || maskTransitionName || maskAnimation) {
    motion = _objectSpread2$1({
      motionAppear: true
    }, getMotion$1({
      motion: maskMotion,
      prefixCls,
      transitionName: maskTransitionName,
      animation: maskAnimation
    }));
  }
  return /* @__PURE__ */ React.createElement(CSSMotion, _extends$2({}, motion, {
    visible,
    removeOnLeave: true
  }), function(_ref) {
    var className = _ref.className;
    return /* @__PURE__ */ React.createElement("div", {
      style: {
        zIndex
      },
      className: cn("".concat(prefixCls, "-mask"), className)
    });
  });
}
var isVisible = function(element) {
  if (!element) {
    return false;
  }
  if (element.offsetParent) {
    return true;
  }
  if (element.getBBox) {
    var box = element.getBBox();
    if (box.width || box.height) {
      return true;
    }
  }
  if (element.getBoundingClientRect) {
    var _box = element.getBoundingClientRect();
    if (_box.width || _box.height) {
      return true;
    }
  }
  return false;
};
function ownKeys(object3, enumerableOnly) {
  var keys2 = Object.keys(object3);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object3);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object3, sym).enumerable;
      });
    }
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys(Object(source), true).forEach(function(key2) {
        _defineProperty(target, key2, source[key2]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key2) {
        Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
      });
    }
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _defineProperty(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var vendorPrefix;
var jsCssMap = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  ms: "-ms-",
  O: "-o-"
};
function getVendorPrefix() {
  if (vendorPrefix !== void 0) {
    return vendorPrefix;
  }
  vendorPrefix = "";
  var style2 = document.createElement("p").style;
  var testProp = "Transform";
  for (var key2 in jsCssMap) {
    if (key2 + testProp in style2) {
      vendorPrefix = key2;
    }
  }
  return vendorPrefix;
}
function getTransitionName$1() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : "transitionProperty";
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : "transform";
}
function setTransitionProperty(node, value) {
  var name = getTransitionName$1();
  if (name) {
    node.style[name] = value;
    if (name !== "transitionProperty") {
      node.style.transitionProperty = value;
    }
  }
}
function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== "transform") {
      node.style.transform = value;
    }
  }
}
function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName$1()];
}
function getTransformXY(node) {
  var style2 = window.getComputedStyle(node, null);
  var transform = style2.getPropertyValue("transform") || style2.getPropertyValue(getTransformName());
  if (transform && transform !== "none") {
    var matrix = transform.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style2 = window.getComputedStyle(node, null);
  var transform = style2.getPropertyValue("transform") || style2.getPropertyValue(getTransformName());
  if (transform && transform !== "none") {
    var arr;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(",").map(function(item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(","), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(",").map(function(item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(","), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}
var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX;
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = "none";
  elem.offsetHeight;
  elem.style.display = originalStyle;
}
function css(el, name, v2) {
  var value = v2;
  if (_typeof(name) === "object") {
    for (var i2 in name) {
      if (name.hasOwnProperty(i2)) {
        css(el, i2, name[i2]);
      }
    }
    return void 0;
  }
  if (typeof value !== "undefined") {
    if (typeof value === "number") {
      value = "".concat(value, "px");
    }
    el.style[name] = value;
    return void 0;
  }
  return getComputedStyleX(el, name);
}
function getClientPosition$1(elem) {
  var box;
  var x2;
  var y2;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  box = elem.getBoundingClientRect();
  x2 = Math.floor(box.left);
  y2 = Math.floor(box.top);
  x2 -= docElem.clientLeft || body.clientLeft || 0;
  y2 -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x2,
    top: y2
  };
}
function getScroll$3(w2, top) {
  var ret = w2["page".concat(top ? "Y" : "X", "Offset")];
  var method3 = "scroll".concat(top ? "Top" : "Left");
  if (typeof ret !== "number") {
    var d = w2.document;
    ret = d.documentElement[method3];
    if (typeof ret !== "number") {
      ret = d.body[method3];
    }
  }
  return ret;
}
function getScrollLeft(w2) {
  return getScroll$3(w2);
}
function getScrollTop(w2) {
  return getScroll$3(w2, true);
}
function getOffset(el) {
  var pos = getClientPosition$1(el);
  var doc = el.ownerDocument;
  var w2 = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w2);
  pos.top += getScrollTop(w2);
  return pos;
}
function isWindow(obj) {
  return obj !== null && obj !== void 0 && obj == obj.window;
}
function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}
function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = "";
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }
  return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), "i");
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = "currentStyle";
var RUNTIME_STYLE = "runtimeStyle";
var LEFT = "left";
var PX = "px";
function _getComputedStyleIE(elem, name) {
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    var style2 = elem.style;
    var left = style2[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
    style2[LEFT] = name === "fontSize" ? "1em" : ret || 0;
    ret = style2.pixelLeft + PX;
    style2[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === "" ? "auto" : ret;
}
if (typeof window !== "undefined") {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function getOffsetDirection(dir, option) {
  if (dir === "left") {
    return option.useCssRight ? "right" : dir;
  }
  return option.useCssBottom ? "bottom" : dir;
}
function oppositeOffsetDirection(dir) {
  if (dir === "left") {
    return "right";
  } else if (dir === "right") {
    return "left";
  } else if (dir === "top") {
    return "bottom";
  } else if (dir === "bottom") {
    return "top";
  }
}
function setLeftTop(elem, offset3, option) {
  if (css(elem, "position") === "static") {
    elem.style.position = "relative";
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection("left", option);
  var verticalProperty = getOffsetDirection("top", option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
  if (horizontalProperty !== "left") {
    presetH = 999;
  }
  if (verticalProperty !== "top") {
    presetV = 999;
  }
  var originalTransition = "";
  var originalOffset = getOffset(elem);
  if ("left" in offset3 || "top" in offset3) {
    originalTransition = getTransitionProperty(elem) || "";
    setTransitionProperty(elem, "none");
  }
  if ("left" in offset3) {
    elem.style[oppositeHorizontalProperty] = "";
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }
  if ("top" in offset3) {
    elem.style[oppositeVerticalProperty] = "";
    elem.style[verticalProperty] = "".concat(presetV, "px");
  }
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key2 in offset3) {
    if (offset3.hasOwnProperty(key2)) {
      var dir = getOffsetDirection(key2, option);
      var preset = key2 === "left" ? presetH : presetV;
      var off = originalOffset[key2] - old[key2];
      if (dir === key2) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  forceRelayout(elem);
  if ("left" in offset3 || "top" in offset3) {
    setTransitionProperty(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset3) {
    if (offset3.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset3[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}
function setTransform$1(elem, offset3) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };
  if ("left" in offset3) {
    resultXY.x = originalXY.x + offset3.left - originalOffset.left;
  }
  if ("top" in offset3) {
    resultXY.y = originalXY.y + offset3.top - originalOffset.top;
  }
  setTransformXY(elem, resultXY);
}
function setOffset(elem, offset3, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset3.left.toFixed(0);
    var tTop = offset3.top.toFixed(0);
    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }
  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset3, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset3);
  } else {
    setLeftTop(elem, offset3, option);
  }
}
function each(arr, fn) {
  for (var i2 = 0; i2 < arr.length; i2++) {
    fn(arr[i2]);
  }
}
function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, "boxSizing") === "border-box";
}
var BOX_MODELS = ["margin", "border", "padding"];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
  var old = {};
  var style2 = elem.style;
  var name;
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style2[name];
      style2[name] = options[name];
    }
  }
  callback.call(elem);
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style2[name] = old[name];
    }
  }
}
function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j2;
  var i2;
  for (j2 = 0; j2 < props.length; j2++) {
    prop = props[j2];
    if (prop) {
      for (i2 = 0; i2 < which.length; i2++) {
        var cssProp = void 0;
        if (prop === "border") {
          cssProp = "".concat(prop).concat(which[i2], "Width");
        } else {
          cssProp = prop + which[i2];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}
var domUtils = {
  getParent: function getParent(element) {
    var parent = element;
    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
    return parent;
  }
};
each(["Width", "Height"], function(name) {
  domUtils["doc".concat(name)] = function(refWin) {
    var d = refWin.document;
    return Math.max(
      d.documentElement["scroll".concat(name)],
      d.body["scroll".concat(name)],
      domUtils["viewport".concat(name)](d)
    );
  };
  domUtils["viewport".concat(name)] = function(win) {
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    return doc.compatMode === "CSS1Compat" && documentElementProp || body && body[prop] || documentElementProp;
  };
});
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === "width" ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === "width" ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  var borderBoxValue = name === "width" ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === void 0 || borderBoxValue <= 0) {
    borderBoxValue = void 0;
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === void 0 || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === void 0) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== void 0 || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ["border", "padding"], which);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ["border"], which) : getPBMWidth(elem, ["margin"], which));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var val;
  var elem = args[0];
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(void 0, args);
  } else {
    swap(elem, cssShow, function() {
      val = getWH.apply(void 0, args);
    });
  }
  return val;
}
each(["width", "height"], function(name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils["outer".concat(first)] = function(el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  domUtils[name] = function(elem, v2) {
    var val = v2;
    if (val !== void 0) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ["padding", "border"], which);
        }
        return css(elem, name, val);
      }
      return void 0;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});
function mix(to, from) {
  for (var i2 in from) {
    if (from.hasOwnProperty(i2)) {
      to[i2] = from[i2];
    }
  }
  return to;
}
var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== "undefined") {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow,
  each,
  css,
  clone: function clone(obj) {
    var i2;
    var ret = {};
    for (i2 in obj) {
      if (obj.hasOwnProperty(i2)) {
        ret[i2] = obj[i2];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i2 in obj) {
        if (obj.hasOwnProperty(i2)) {
          ret.overflow[i2] = obj.overflow[i2];
        }
      }
    }
    return ret;
  },
  mix,
  getWindowScrollLeft: function getWindowScrollLeft(w2) {
    return getScrollLeft(w2);
  },
  getWindowScrollTop: function getWindowScrollTop(w2) {
    return getScrollTop(w2);
  },
  merge: function merge() {
    var ret = {};
    for (var i2 = 0; i2 < arguments.length; i2++) {
      utils.mix(ret, i2 < 0 || arguments.length <= i2 ? void 0 : arguments[i2]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);
var getParent$1 = utils.getParent;
function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, "position");
  var skipStatic = positionStyle === "fixed" || positionStyle === "absolute";
  if (!skipStatic) {
    return element.nodeName.toLowerCase() === "html" ? null : getParent$1(element);
  }
  for (parent = getParent$1(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent$1(parent)) {
    positionStyle = utils.css(parent, "position");
    if (positionStyle !== "static") {
      return parent;
    }
  }
  return null;
}
var getParent$1$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = getParent$1$1(element); parent && parent !== body && parent !== doc; parent = getParent$1$1(parent)) {
    var positionStyle = utils.css(parent, "position");
    if (positionStyle === "fixed") {
      return true;
    }
  }
  return false;
}
function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;
  while (el) {
    if ((navigator.userAgent.indexOf("MSIE") === -1 || el.clientWidth !== 0) && el !== body && el !== documentElement && utils.css(el, "overflow") !== "visible") {
      var pos = utils.offset(el);
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(
        visibleRect.right,
        pos.left + el.clientWidth
      );
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = getOffsetParent(el);
  }
  var originalPosition = null;
  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, "position");
    if (position === "absolute") {
      element.style.position = "fixed";
    }
  }
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;
  var bodyStyle = window.getComputedStyle(body);
  if (bodyStyle.overflowX === "hidden") {
    documentWidth = win.innerWidth;
  }
  if (bodyStyle.overflowY === "hidden") {
    documentHeight = win.innerHeight;
  }
  if (element.style) {
    element.style.position = originalPosition;
  }
  if (alwaysByViewport || isAncestorFixed(element)) {
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }
  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };
  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }
  return utils.mix(pos, size);
}
function getRegion(node) {
  var offset3;
  var w2;
  var h;
  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset3 = utils.offset(node);
    w2 = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset3 = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w2 = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }
  offset3.width = w2;
  offset3.height = h;
  return offset3;
}
function getAlignOffset(region, align) {
  var V2 = align.charAt(0);
  var H2 = align.charAt(1);
  var w2 = region.width;
  var h = region.height;
  var x2 = region.left;
  var y2 = region.top;
  if (V2 === "c") {
    y2 += h / 2;
  } else if (V2 === "b") {
    y2 += h;
  }
  if (H2 === "c") {
    x2 += w2 / 2;
  } else if (H2 === "r") {
    x2 += w2;
  }
  return {
    left: x2,
    top: y2
  };
}
function getElFuturePos(elRegion, refNodeRegion, points, offset3, targetOffset2) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset3[0] - targetOffset2[0]),
    top: Math.round(elRegion.top - diff[1] + offset3[1] - targetOffset2[1])
  };
}
function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function(p) {
    ret.push(p.replace(reg, function(m2) {
      return map[m2];
    }));
  });
  return ret;
}
function flipOffset(offset3, index2) {
  offset3[index2] = -offset3[index2];
  return offset3;
}
function convertOffset(str, offsetLen) {
  var n3;
  if (/%$/.test(str)) {
    n3 = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n3 = parseInt(str, 10);
  }
  return n3 || 0;
}
function normalizeOffset(offset3, el) {
  offset3[0] = convertOffset(offset3[0], el.width);
  offset3[1] = convertOffset(offset3[1], el.height);
}
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset3 = align.offset || [0, 0];
  var targetOffset2 = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset3 = [].concat(offset3);
  targetOffset2 = [].concat(targetOffset2);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
  var elRegion = getRegion(source);
  normalizeOffset(offset3, elRegion);
  normalizeOffset(targetOffset2, tgtRegion);
  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset3, targetOffset2);
  var newElRegion = utils.merge(elRegion, elFuturePos);
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        var newPoints = flip(points, /[lr]/gi, {
          l: "r",
          r: "l"
        });
        var newOffset = flipOffset(offset3, 0);
        var newTargetOffset = flipOffset(targetOffset2, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset3 = newOffset;
          targetOffset2 = newTargetOffset;
        }
      }
    }
    if (overflow.adjustY) {
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        var _newPoints = flip(points, /[tb]/gi, {
          t: "b",
          b: "t"
        });
        var _newOffset = flipOffset(offset3, 1);
        var _newTargetOffset = flipOffset(targetOffset2, 1);
        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset3 = _newOffset;
          targetOffset2 = _newTargetOffset;
        }
      }
    }
    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset3, targetOffset2);
      utils.mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points;
      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: "r",
          r: "l"
        });
      }
      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: "b",
          b: "t"
        });
      }
      points = _newPoints2;
      offset3 = align.offset || [0, 0];
      targetOffset2 = align.targetOffset || [0, 0];
    }
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }
  if (newElRegion.width !== elRegion.width) {
    utils.css(source, "width", utils.width(source) + newElRegion.width - elRegion.width);
  }
  if (newElRegion.height !== elRegion.height) {
    utils.css(source, "height", utils.height(source) + newElRegion.height - elRegion.height);
  }
  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points,
    offset: offset3,
    targetOffset: targetOffset2,
    overflow: newOverflowCfg
  };
}
function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;
function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  if ("pageX" in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }
  if ("pageY" in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }
  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
  var points = [align.points[0], "cc"];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points
  }), pointInView);
}
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$2(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$2;
var eq$1 = eq_1;
function assocIndexOf$4(array3, key2) {
  var length = array3.length;
  while (length--) {
    if (eq$1(array3[length][0], key2)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key2) {
  var data = this.__data__, index2 = assocIndexOf$3(data, key2);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index2, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key2) {
  var data = this.__data__, index2 = assocIndexOf$2(data, key2);
  return index2 < 0 ? void 0 : data[index2][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key2) {
  return assocIndexOf$1(this.__data__, key2) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key2, value) {
  var data = this.__data__, index2 = assocIndexOf(data, key2);
  if (index2 < 0) {
    ++this.size;
    data.push([key2, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear;
var listCacheDelete = _listCacheDelete;
var listCacheGet = _listCacheGet;
var listCacheHas = _listCacheHas;
var listCacheSet = _listCacheSet;
function ListCache$4(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var ListCache$3 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$3();
  this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key2) {
  var data = this.__data__, result = data["delete"](key2);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key2) {
  return this.__data__.get(key2);
}
var _stackGet = stackGet$1;
function stackHas$1(key2) {
  return this.__data__.has(key2);
}
var _stackHas = stackHas$1;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$9 = freeGlobal || freeSelf || Function("return this")();
var _root = root$9;
var root$8 = _root;
var Symbol$5 = root$8.Symbol;
var _Symbol = Symbol$5;
var Symbol$4 = _Symbol;
var objectProto$b = Object.prototype;
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;
var nativeObjectToString$1 = objectProto$b.toString;
var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$8.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e3) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto$a = Object.prototype;
var nativeObjectToString = objectProto$a.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$3 = _Symbol;
var getRawTag = _getRawTag;
var objectToString = _objectToString;
var nullTag = "[object Null]";
var undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : void 0;
function baseGetTag$5(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$5;
function isObject$4(value) {
  var type2 = typeof value;
  return value != null && (type2 == "object" || type2 == "function");
}
var isObject_1 = isObject$4;
var baseGetTag$4 = _baseGetTag;
var isObject$3 = isObject_1;
var asyncTag = "[object AsyncFunction]";
var funcTag$1 = "[object Function]";
var genTag = "[object GeneratorFunction]";
var proxyTag = "[object Proxy]";
function isFunction$2(value) {
  if (!isObject$3(value)) {
    return false;
  }
  var tag = baseGetTag$4(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$2;
var root$7 = _root;
var coreJsData$1 = root$7["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid2 = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid2 ? "Symbol(src)_1." + uid2 : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e3) {
    }
    try {
      return func + "";
    } catch (e3) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$1 = isFunction_1;
var isMasked = _isMasked;
var isObject$2 = isObject_1;
var toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype;
var objectProto$9 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject$2(value) || isMasked(value)) {
    return false;
  }
  var pattern2 = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern2.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$2(object3, key2) {
  return object3 == null ? void 0 : object3[key2];
}
var _getValue = getValue$2;
var baseIsNative = _baseIsNative;
var getValue$1 = _getValue;
function getNative$6(object3, key2) {
  var value = getValue$1(object3, key2);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$6;
var getNative$5 = _getNative;
var root$6 = _root;
var Map$4 = getNative$5(root$6, "Map");
var _Map = Map$4;
var getNative$4 = _getNative;
var nativeCreate$4 = getNative$4(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key2) {
  var result = this.has(key2) && delete this.__data__[key2];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$8 = Object.prototype;
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
function hashGet$1(key2) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key2];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$6.call(data, key2) ? data[key2] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$7 = Object.prototype;
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function hashHas$1(key2) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key2] !== void 0 : hasOwnProperty$5.call(data, key2);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key2, value) {
  var data = this.__data__;
  this.size += this.has(key2) ? 0 : 1;
  data[key2] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear;
var hashDelete = _hashDelete;
var hashGet = _hashGet;
var hashHas = _hashHas;
var hashSet = _hashSet;
function Hash$1(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
var Hash = _Hash;
var ListCache$2 = _ListCache;
var Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache$2)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type2 = typeof value;
  return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map, key2) {
  var data = map.__data__;
  return isKeyable(key2) ? data[typeof key2 == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key2) {
  var result = getMapData$3(this, key2)["delete"](key2);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key2) {
  return getMapData$2(this, key2).get(key2);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key2) {
  return getMapData$1(this, key2).has(key2);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key2, value) {
  var data = getMapData(this, key2), size = data.size;
  data.set(key2, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear;
var mapCacheDelete = _mapCacheDelete;
var mapCacheGet = _mapCacheGet;
var mapCacheHas = _mapCacheHas;
var mapCacheSet = _mapCacheSet;
function MapCache$2(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$2.prototype.clear = mapCacheClear;
MapCache$2.prototype["delete"] = mapCacheDelete;
MapCache$2.prototype.get = mapCacheGet;
MapCache$2.prototype.has = mapCacheHas;
MapCache$2.prototype.set = mapCacheSet;
var _MapCache = MapCache$2;
var ListCache$1 = _ListCache;
var Map$2 = _Map;
var MapCache$1 = _MapCache;
var LARGE_ARRAY_SIZE = 200;
function stackSet$1(key2, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key2, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key2, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache;
var stackClear = _stackClear;
var stackDelete = _stackDelete;
var stackGet = _stackGet;
var stackHas = _stackHas;
var stackSet = _stackSet;
function Stack$1(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack$1.prototype.clear = stackClear;
Stack$1.prototype["delete"] = stackDelete;
Stack$1.prototype.get = stackGet;
Stack$1.prototype.has = stackHas;
Stack$1.prototype.set = stackSet;
var _Stack = Stack$1;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache = _MapCache;
var setCacheAdd = _setCacheAdd;
var setCacheHas = _setCacheHas;
function SetCache$1(values) {
  var index2 = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index2 < length) {
    this.add(values[index2]);
  }
}
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;
function arraySome$1(array3, predicate) {
  var index2 = -1, length = array3 == null ? 0 : array3.length;
  while (++index2 < length) {
    if (predicate(array3[index2], index2, array3)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;
function cacheHas$1(cache, key2) {
  return cache.has(key2);
}
var _cacheHas = cacheHas$1;
var SetCache = _SetCache;
var arraySome = _arraySome;
var cacheHas = _cacheHas;
var COMPARE_PARTIAL_FLAG$3 = 1;
var COMPARE_UNORDERED_FLAG$1 = 2;
function equalArrays$2(array3, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, arrLength = array3.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array3);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array3;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$1 ? new SetCache() : void 0;
  stack.set(array3, other);
  stack.set(other, array3);
  while (++index2 < arrLength) {
    var arrValue = array3[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array3, stack) : customizer(arrValue, othValue, index2, array3, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array3);
  stack["delete"](other);
  return result;
}
var _equalArrays = equalArrays$2;
var root$5 = _root;
var Uint8Array$2 = root$5.Uint8Array;
var _Uint8Array = Uint8Array$2;
function mapToArray$1(map) {
  var index2 = -1, result = Array(map.size);
  map.forEach(function(value, key2) {
    result[++index2] = [key2, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;
function setToArray$1(set2) {
  var index2 = -1, result = Array(set2.size);
  set2.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var _setToArray = setToArray$1;
var Symbol$2 = _Symbol;
var Uint8Array$1 = _Uint8Array;
var eq = eq_1;
var equalArrays$1 = _equalArrays;
var mapToArray = _mapToArray;
var setToArray = _setToArray;
var COMPARE_PARTIAL_FLAG$2 = 1;
var COMPARE_UNORDERED_FLAG = 2;
var boolTag$1 = "[object Boolean]";
var dateTag$1 = "[object Date]";
var errorTag$1 = "[object Error]";
var mapTag$2 = "[object Map]";
var numberTag$1 = "[object Number]";
var regexpTag$1 = "[object RegExp]";
var setTag$2 = "[object Set]";
var stringTag$1 = "[object String]";
var symbolTag$1 = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]";
var dataViewTag$2 = "[object DataView]";
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0;
var symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function equalByTag$1(object3, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if (object3.byteLength != other.byteLength || object3.byteOffset != other.byteOffset) {
        return false;
      }
      object3 = object3.buffer;
      other = other.buffer;
    case arrayBufferTag$1:
      if (object3.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object3), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      return eq(+object3, +other);
    case errorTag$1:
      return object3.name == other.name && object3.message == other.message;
    case regexpTag$1:
    case stringTag$1:
      return object3 == other + "";
    case mapTag$2:
      var convert = mapToArray;
    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
      convert || (convert = setToArray);
      if (object3.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object3);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;
      stack.set(object3, other);
      var result = equalArrays$1(convert(object3), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object3);
      return result;
    case symbolTag$1:
      if (symbolValueOf) {
        return symbolValueOf.call(object3) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;
function arrayPush$1(array3, values) {
  var index2 = -1, length = values.length, offset3 = array3.length;
  while (++index2 < length) {
    array3[offset3 + index2] = values[index2];
  }
  return array3;
}
var _arrayPush = arrayPush$1;
var isArray$4 = Array.isArray;
var isArray_1 = isArray$4;
var arrayPush = _arrayPush;
var isArray$3 = isArray_1;
function baseGetAllKeys$1(object3, keysFunc, symbolsFunc) {
  var result = keysFunc(object3);
  return isArray$3(object3) ? result : arrayPush(result, symbolsFunc(object3));
}
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(array3, predicate) {
  var index2 = -1, length = array3 == null ? 0 : array3.length, resIndex = 0, result = [];
  while (++index2 < length) {
    var value = array3[index2];
    if (predicate(value, index2, array3)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1;
var arrayFilter = _arrayFilter;
var stubArray = stubArray_1;
var objectProto$6 = Object.prototype;
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object3) {
  if (object3 == null) {
    return [];
  }
  object3 = Object(object3);
  return arrayFilter(nativeGetSymbols(object3), function(symbol) {
    return propertyIsEnumerable$1.call(object3, symbol);
  });
};
var _getSymbols = getSymbols$1;
function baseTimes$1(n3, iteratee) {
  var index2 = -1, result = Array(n3);
  while (++index2 < n3) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var _baseTimes = baseTimes$1;
function isObjectLike$5(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$5;
var baseGetTag$3 = _baseGetTag;
var isObjectLike$4 = isObjectLike_1;
var argsTag$2 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$4(value) && baseGetTag$3(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments;
var isObjectLike$3 = isObjectLike_1;
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
var isArguments$1 = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$3(value) && hasOwnProperty$4.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
var isArguments_1 = isArguments$1;
var isBuffer$2 = { exports: {} };
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
(function(module, exports) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer2 = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  module.exports = isBuffer2;
})(isBuffer$2, isBuffer$2.exports);
var MAX_SAFE_INTEGER$2 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$1(value, length) {
  var type2 = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$2 : length;
  return !!length && (type2 == "number" || type2 != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var _isIndex = isIndex$1;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength$2(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}
var isLength_1 = isLength$2;
var baseGetTag$2 = _baseGetTag;
var isLength$1 = isLength_1;
var isObjectLike$2 = isObjectLike_1;
var argsTag$1 = "[object Arguments]";
var arrayTag$1 = "[object Array]";
var boolTag = "[object Boolean]";
var dateTag = "[object Date]";
var errorTag = "[object Error]";
var funcTag = "[object Function]";
var mapTag$1 = "[object Map]";
var numberTag = "[object Number]";
var objectTag$2 = "[object Object]";
var regexpTag = "[object RegExp]";
var setTag$1 = "[object Set]";
var stringTag = "[object String]";
var weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]";
var dataViewTag$1 = "[object DataView]";
var float32Tag = "[object Float32Array]";
var float64Tag = "[object Float64Array]";
var int8Tag = "[object Int8Array]";
var int16Tag = "[object Int16Array]";
var int32Tag = "[object Int32Array]";
var uint8Tag = "[object Uint8Array]";
var uint8ClampedTag = "[object Uint8ClampedArray]";
var uint16Tag = "[object Uint16Array]";
var uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$2(value) && isLength$1(value.length) && !!typedArrayTags[baseGetTag$2(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$1(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$1;
var _nodeUtil = { exports: {} };
(function(module, exports) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types2 = freeModule && freeModule.require && freeModule.require("util").types;
      if (types2) {
        return types2;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e3) {
    }
  }();
  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var baseIsTypedArray = _baseIsTypedArray;
var baseUnary = _baseUnary;
var nodeUtil = _nodeUtil.exports;
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$2;
var baseTimes = _baseTimes;
var isArguments = isArguments_1;
var isArray$2 = isArray_1;
var isBuffer$1 = isBuffer$2.exports;
var isIndex = _isIndex;
var isTypedArray$1 = isTypedArray_1;
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer$1(value), isType = !isArr && !isArg && !isBuff && isTypedArray$1(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key2 in value) {
    if ((inherited || hasOwnProperty$3.call(value, key2)) && !(skipIndexes && (key2 == "length" || isBuff && (key2 == "offset" || key2 == "parent") || isType && (key2 == "buffer" || key2 == "byteLength" || key2 == "byteOffset") || isIndex(key2, length)))) {
      result.push(key2);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$1;
var objectProto$3 = Object.prototype;
function isPrototype$1(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$3;
  return value === proto;
}
var _isPrototype = isPrototype$1;
function overArg$1(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$1;
var overArg = _overArg;
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype = _isPrototype;
var nativeKeys = _nativeKeys;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function baseKeys$1(object3) {
  if (!isPrototype(object3)) {
    return nativeKeys(object3);
  }
  var result = [];
  for (var key2 in Object(object3)) {
    if (hasOwnProperty$2.call(object3, key2) && key2 != "constructor") {
      result.push(key2);
    }
  }
  return result;
}
var _baseKeys = baseKeys$1;
var isFunction = isFunction_1;
var isLength = isLength_1;
function isArrayLike$1(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
var isArrayLike_1 = isArrayLike$1;
var arrayLikeKeys = _arrayLikeKeys;
var baseKeys = _baseKeys;
var isArrayLike = isArrayLike_1;
function keys$1(object3) {
  return isArrayLike(object3) ? arrayLikeKeys(object3) : baseKeys(object3);
}
var keys_1 = keys$1;
var baseGetAllKeys = _baseGetAllKeys;
var getSymbols = _getSymbols;
var keys = keys_1;
function getAllKeys$1(object3) {
  return baseGetAllKeys(object3, keys, getSymbols);
}
var _getAllKeys = getAllKeys$1;
var getAllKeys = _getAllKeys;
var COMPARE_PARTIAL_FLAG$1 = 1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects$1(object3, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1, objProps = getAllKeys(object3), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key2 = objProps[index2];
    if (!(isPartial ? key2 in other : hasOwnProperty$1.call(other, key2))) {
      return false;
    }
  }
  var objStacked = stack.get(object3);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object3;
  }
  var result = true;
  stack.set(object3, other);
  stack.set(other, object3);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key2 = objProps[index2];
    var objValue = object3[key2], othValue = other[key2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key2, other, object3, stack) : customizer(objValue, othValue, key2, object3, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key2 == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object3.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object3 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object3);
  stack["delete"](other);
  return result;
}
var _equalObjects = equalObjects$1;
var getNative$3 = _getNative;
var root$4 = _root;
var DataView$1 = getNative$3(root$4, "DataView");
var _DataView = DataView$1;
var getNative$2 = _getNative;
var root$3 = _root;
var Promise$2 = getNative$2(root$3, "Promise");
var _Promise = Promise$2;
var getNative$1 = _getNative;
var root$2 = _root;
var Set$2 = getNative$1(root$2, "Set");
var _Set = Set$2;
var getNative = _getNative;
var root$1 = _root;
var WeakMap$2 = getNative(root$1, "WeakMap");
var _WeakMap = WeakMap$2;
var DataView = _DataView;
var Map$1 = _Map;
var Promise$1 = _Promise;
var Set$1 = _Set;
var WeakMap$1 = _WeakMap;
var baseGetTag$1 = _baseGetTag;
var toSource = _toSource;
var mapTag = "[object Map]";
var objectTag$1 = "[object Object]";
var promiseTag = "[object Promise]";
var setTag = "[object Set]";
var weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
var dataViewCtorString = toSource(DataView);
var mapCtorString = toSource(Map$1);
var promiseCtorString = toSource(Promise$1);
var setCtorString = toSource(Set$1);
var weakMapCtorString = toSource(WeakMap$1);
var getTag$1 = baseGetTag$1;
if (DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag) {
  getTag$1 = function(value) {
    var result = baseGetTag$1(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var _getTag = getTag$1;
var Stack = _Stack;
var equalArrays = _equalArrays;
var equalByTag = _equalByTag;
var equalObjects = _equalObjects;
var getTag = _getTag;
var isArray$1 = isArray_1;
var isBuffer = isBuffer$2.exports;
var isTypedArray = isTypedArray_1;
var COMPARE_PARTIAL_FLAG = 1;
var argsTag = "[object Arguments]";
var arrayTag = "[object Array]";
var objectTag = "[object Object]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep$1(object3, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$1(object3), othIsArr = isArray$1(other), objTag = objIsArr ? arrayTag : getTag(object3), othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object3)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object3) ? equalArrays(object3, other, bitmask, customizer, equalFunc, stack) : equalByTag(object3, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object3, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object3.value() : object3, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object3, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep;
var isObjectLike$1 = isObjectLike_1;
function baseIsEqual$1(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike$1(value) && !isObjectLike$1(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$1, stack);
}
var _baseIsEqual = baseIsEqual$1;
var baseIsEqual = _baseIsEqual;
function isEqual$1(value, other) {
  return baseIsEqual(value, other);
}
var isEqual_1 = isEqual$1;
function isSamePoint(prev, next) {
  if (prev === next)
    return true;
  if (!prev || !next)
    return false;
  if ("pageX" in next && "pageY" in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }
  if ("clientX" in next && "clientY" in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }
  return false;
}
function restoreFocus(activeElement, container) {
  if (activeElement !== document.activeElement && contains(container, activeElement) && typeof activeElement.focus === "function") {
    activeElement.focus();
  }
}
function monitorResize(element, callback) {
  var prevWidth = null;
  var prevHeight = null;
  function onResize2(_ref) {
    var _ref2 = _slicedToArray$3(_ref, 1), target = _ref2[0].target;
    if (!document.documentElement.contains(target))
      return;
    var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);
    if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) {
      Promise.resolve().then(function() {
        callback({
          width: fixedWidth,
          height: fixedHeight
        });
      });
    }
    prevWidth = fixedWidth;
    prevHeight = fixedHeight;
  }
  var resizeObserver2 = new index$1(onResize2);
  if (element) {
    resizeObserver2.observe(element);
  }
  return function() {
    resizeObserver2.disconnect();
  };
}
var useBuffer = function(callback, buffer) {
  var calledRef = React__default.useRef(false);
  var timeoutRef = React__default.useRef(null);
  function cancelTrigger() {
    window.clearTimeout(timeoutRef.current);
  }
  function trigger(force) {
    cancelTrigger();
    if (!calledRef.current || force === true) {
      if (callback() === false) {
        return;
      }
      calledRef.current = true;
      timeoutRef.current = window.setTimeout(function() {
        calledRef.current = false;
      }, buffer);
    } else {
      timeoutRef.current = window.setTimeout(function() {
        calledRef.current = false;
        trigger();
      }, buffer);
    }
  }
  return [trigger, function() {
    calledRef.current = false;
    cancelTrigger();
  }];
};
function getElement(func) {
  if (typeof func !== "function")
    return null;
  return func();
}
function getPoint(point) {
  if (_typeof$5(point) !== "object" || !point)
    return null;
  return point;
}
var Align = function Align2(_ref, ref) {
  var children = _ref.children, disabled = _ref.disabled, target = _ref.target, align = _ref.align, onAlign = _ref.onAlign, monitorWindowResize = _ref.monitorWindowResize, _ref$monitorBufferTim = _ref.monitorBufferTime, monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
  var cacheRef = React__default.useRef({});
  var nodeRef = React__default.useRef();
  var childNode = React__default.Children.only(children);
  var forceAlignPropsRef = React__default.useRef({});
  forceAlignPropsRef.current.disabled = disabled;
  forceAlignPropsRef.current.target = target;
  forceAlignPropsRef.current.align = align;
  forceAlignPropsRef.current.onAlign = onAlign;
  var _useBuffer = useBuffer(function() {
    var _forceAlignPropsRef$c = forceAlignPropsRef.current, latestDisabled = _forceAlignPropsRef$c.disabled, latestTarget = _forceAlignPropsRef$c.target, latestAlign = _forceAlignPropsRef$c.align, latestOnAlign = _forceAlignPropsRef$c.onAlign;
    if (!latestDisabled && latestTarget) {
      var source = nodeRef.current;
      var result;
      var element = getElement(latestTarget);
      var point = getPoint(latestTarget);
      cacheRef.current.element = element;
      cacheRef.current.point = point;
      cacheRef.current.align = latestAlign;
      var _document = document, activeElement = _document.activeElement;
      if (element && isVisible(element)) {
        result = alignElement(source, element, latestAlign);
      } else if (point) {
        result = alignPoint(source, point, latestAlign);
      }
      restoreFocus(activeElement, source);
      if (latestOnAlign && result) {
        latestOnAlign(source, result);
      }
      return true;
    }
    return false;
  }, monitorBufferTime), _useBuffer2 = _slicedToArray$3(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1];
  var resizeMonitor = React__default.useRef({
    cancel: function cancel2() {
    }
  });
  var sourceResizeMonitor = React__default.useRef({
    cancel: function cancel2() {
    }
  });
  React__default.useEffect(function() {
    var element = getElement(target);
    var point = getPoint(target);
    if (nodeRef.current !== sourceResizeMonitor.current.element) {
      sourceResizeMonitor.current.cancel();
      sourceResizeMonitor.current.element = nodeRef.current;
      sourceResizeMonitor.current.cancel = monitorResize(nodeRef.current, _forceAlign);
    }
    if (cacheRef.current.element !== element || !isSamePoint(cacheRef.current.point, point) || !isEqual_1(cacheRef.current.align, align)) {
      _forceAlign();
      if (resizeMonitor.current.element !== element) {
        resizeMonitor.current.cancel();
        resizeMonitor.current.element = element;
        resizeMonitor.current.cancel = monitorResize(element, _forceAlign);
      }
    }
  });
  React__default.useEffect(function() {
    if (!disabled) {
      _forceAlign();
    } else {
      cancelForceAlign();
    }
  }, [disabled]);
  var winResizeRef = React__default.useRef(null);
  React__default.useEffect(function() {
    if (monitorWindowResize) {
      if (!winResizeRef.current) {
        winResizeRef.current = addEventListenerWrap(window, "resize", _forceAlign);
      }
    } else if (winResizeRef.current) {
      winResizeRef.current.remove();
      winResizeRef.current = null;
    }
  }, [monitorWindowResize]);
  React__default.useEffect(function() {
    return function() {
      resizeMonitor.current.cancel();
      sourceResizeMonitor.current.cancel();
      if (winResizeRef.current)
        winResizeRef.current.remove();
      cancelForceAlign();
    };
  }, []);
  React__default.useImperativeHandle(ref, function() {
    return {
      forceAlign: function forceAlign() {
        return _forceAlign(true);
      }
    };
  });
  if (/* @__PURE__ */ React__default.isValidElement(childNode)) {
    childNode = /* @__PURE__ */ React__default.cloneElement(childNode, {
      ref: composeRef(childNode.ref, nodeRef)
    });
  }
  return childNode;
};
var RcAlign = /* @__PURE__ */ React__default.forwardRef(Align);
RcAlign.displayName = "Align";
function _regeneratorRuntime() {
  _regeneratorRuntime = function _regeneratorRuntime2() {
    return exports;
  };
  var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define2(obj, key2, value) {
    return Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    }), obj[key2];
  }
  try {
    define2({}, "");
  } catch (err) {
    define2 = function define3(obj, key2, value) {
      return obj[key2] = value;
    };
  }
  function wrap(innerFn, outerFn, self2, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator2 = Object.create(protoGenerator.prototype), context2 = new Context2(tryLocsList || []);
    return generator2._invoke = function(innerFn2, self3, context3) {
      var state = "suspendedStart";
      return function(method3, arg) {
        if ("executing" === state)
          throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method3)
            throw arg;
          return doneResult();
        }
        for (context3.method = method3, context3.arg = arg; ; ) {
          var delegate = context3.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context3);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel)
                continue;
              return delegateResult;
            }
          }
          if ("next" === context3.method)
            context3.sent = context3._sent = context3.arg;
          else if ("throw" === context3.method) {
            if ("suspendedStart" === state)
              throw state = "completed", context3.arg;
            context3.dispatchException(context3.arg);
          } else
            "return" === context3.method && context3.abrupt("return", context3.arg);
          state = "executing";
          var record = tryCatch(innerFn2, self3, context3);
          if ("normal" === record.type) {
            if (state = context3.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel)
              continue;
            return {
              value: record.arg,
              done: context3.done
            };
          }
          "throw" === record.type && (state = "completed", context3.method = "throw", context3.arg = record.arg);
        }
      };
    }(innerFn, self2, context2), generator2;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {
  }
  function GeneratorFunction() {
  }
  function GeneratorFunctionPrototype() {
  }
  var IteratorPrototype = {};
  define2(IteratorPrototype, iteratorSymbol, function() {
    return this;
  });
  var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method3) {
      define2(prototype, method3, function(arg) {
        return this._invoke(method3, arg);
      });
    });
  }
  function AsyncIterator(generator2, PromiseImpl) {
    function invoke(method3, arg, resolve, reject) {
      var record = tryCatch(generator2[method3], generator2, arg);
      if ("throw" !== record.type) {
        var result = record.arg, value = result.value;
        return value && "object" == _typeof$5(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value2) {
          invoke("next", value2, resolve, reject);
        }, function(err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function(unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function(error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    this._invoke = function(method3, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method3, arg, resolve, reject);
        });
      }
      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }
  function maybeInvokeDelegate(delegate, context2) {
    var method3 = delegate.iterator[context2.method];
    if (void 0 === method3) {
      if (context2.delegate = null, "throw" === context2.method) {
        if (delegate.iterator["return"] && (context2.method = "return", context2.arg = void 0, maybeInvokeDelegate(delegate, context2), "throw" === context2.method))
          return ContinueSentinel;
        context2.method = "throw", context2.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method3, delegate.iterator, context2.arg);
    if ("throw" === record.type)
      return context2.method = "throw", context2.arg = record.arg, context2.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context2[delegate.resultName] = info.value, context2.next = delegate.nextLoc, "return" !== context2.method && (context2.method = "next", context2.arg = void 0), context2.delegate = null, ContinueSentinel) : info : (context2.method = "throw", context2.arg = new TypeError("iterator result is not an object"), context2.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context2(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod)
        return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next)
        return iterable;
      if (!isNaN(iterable.length)) {
        var i2 = -1, next = function next2() {
          for (; ++i2 < iterable.length; ) {
            if (hasOwn.call(iterable, i2))
              return next2.value = iterable[i2], next2.done = false, next2;
          }
          return next2.value = void 0, next2.done = true, next2;
        };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: void 0,
      done: true
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define2(Gp, "constructor", GeneratorFunctionPrototype), define2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define2(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function(genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define2(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function(arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define2(AsyncIterator.prototype, asyncIteratorSymbol, function() {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define2(Gp, toStringTagSymbol, "Generator"), define2(Gp, iteratorSymbol, function() {
    return this;
  }), define2(Gp, "toString", function() {
    return "[object Generator]";
  }), exports.keys = function(object3) {
    var keys2 = [];
    for (var key2 in object3) {
      keys2.push(key2);
    }
    return keys2.reverse(), function next() {
      for (; keys2.length; ) {
        var key3 = keys2.pop();
        if (key3 in object3)
          return next.value = key3, next.done = false, next;
      }
      return next.done = true, next;
    };
  }, exports.values = values, Context2.prototype = {
    constructor: Context2,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset)
        for (var name in this) {
          "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
        }
    },
    stop: function stop() {
      this.done = true;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type)
        throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done)
        throw exception;
      var context2 = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context2.next = loc, caught && (context2.method = "next", context2.arg = void 0), !!caught;
      }
      for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
        var entry = this.tryEntries[i2], record = entry.completion;
        if ("root" === entry.tryLoc)
          return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc)
              return handle(entry.catchLoc, true);
            if (this.prev < entry.finallyLoc)
              return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc)
              return handle(entry.catchLoc, true);
          } else {
            if (!hasFinally)
              throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc)
              return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type2, arg) {
      for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
        var entry = this.tryEntries[i2];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type2 || "continue" === type2) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type2, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type)
        throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
        var entry = this.tryEntries[i2];
        if (entry.finallyLoc === finallyLoc)
          return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
        var entry = this.tryEntries[i2];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName,
        nextLoc
      }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
    }
  }, exports;
}
var StatusQueue = ["measure", "alignPre", "align", null, "motion"];
var useVisibleStatus = function(visible, doMeasure) {
  var _useState = useSafeState(null), _useState2 = _slicedToArray$3(_useState, 2), status = _useState2[0], setInternalStatus = _useState2[1];
  var rafRef = useRef2();
  function setStatus(nextStatus) {
    setInternalStatus(nextStatus, true);
  }
  function cancelRaf() {
    wrapperRaf$1.cancel(rafRef.current);
  }
  function goNextStatus(callback) {
    cancelRaf();
    rafRef.current = wrapperRaf$1(function() {
      setStatus(function(prev) {
        switch (status) {
          case "align":
            return "motion";
          case "motion":
            return "stable";
        }
        return prev;
      });
      callback === null || callback === void 0 ? void 0 : callback();
    });
  }
  useEffect2(function() {
    setStatus("measure");
  }, [visible]);
  useEffect2(function() {
    switch (status) {
      case "measure":
        doMeasure();
        break;
    }
    if (status) {
      rafRef.current = wrapperRaf$1(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee() {
        var index2, nextStatus;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                index2 = StatusQueue.indexOf(status);
                nextStatus = StatusQueue[index2 + 1];
                if (nextStatus && index2 !== -1) {
                  setStatus(nextStatus);
                }
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }, [status]);
  useEffect2(function() {
    return function() {
      cancelRaf();
    };
  }, []);
  return [status, goNextStatus];
};
var useStretchStyle = function(stretch) {
  var _React$useState = React.useState({
    width: 0,
    height: 0
  }), _React$useState2 = _slicedToArray$3(_React$useState, 2), targetSize = _React$useState2[0], setTargetSize = _React$useState2[1];
  function measureStretch(element) {
    setTargetSize({
      width: element.offsetWidth,
      height: element.offsetHeight
    });
  }
  var style2 = React.useMemo(function() {
    var sizeStyle = {};
    if (stretch) {
      var width = targetSize.width, height = targetSize.height;
      if (stretch.indexOf("height") !== -1 && height) {
        sizeStyle.height = height;
      } else if (stretch.indexOf("minHeight") !== -1 && height) {
        sizeStyle.minHeight = height;
      }
      if (stretch.indexOf("width") !== -1 && width) {
        sizeStyle.width = width;
      } else if (stretch.indexOf("minWidth") !== -1 && width) {
        sizeStyle.minWidth = width;
      }
    }
    return sizeStyle;
  }, [stretch, targetSize]);
  return [style2, measureStretch];
};
var PopupInner = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var visible = props.visible, prefixCls = props.prefixCls, className = props.className, style2 = props.style, children = props.children, zIndex = props.zIndex, stretch = props.stretch, destroyPopupOnHide = props.destroyPopupOnHide, forceRender = props.forceRender, align = props.align, point = props.point, getRootDomNode = props.getRootDomNode, getClassNameFromAlign = props.getClassNameFromAlign, onAlign = props.onAlign, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseDown = props.onMouseDown, onTouchStart = props.onTouchStart, onClick = props.onClick;
  var alignRef = useRef2();
  var elementRef = useRef2();
  var _useState = useState2(), _useState2 = _slicedToArray$3(_useState, 2), alignedClassName = _useState2[0], setAlignedClassName = _useState2[1];
  var _useStretchStyle = useStretchStyle(stretch), _useStretchStyle2 = _slicedToArray$3(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
  function doMeasure() {
    if (stretch) {
      measureStretchStyle(getRootDomNode());
    }
  }
  var _useVisibleStatus = useVisibleStatus(visible, doMeasure), _useVisibleStatus2 = _slicedToArray$3(_useVisibleStatus, 2), status = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1];
  var _useState3 = useState2(0), _useState4 = _slicedToArray$3(_useState3, 2), alignTimes = _useState4[0], setAlignTimes = _useState4[1];
  var prepareResolveRef = useRef2();
  useLayoutEffect$2(function() {
    if (status === "alignPre") {
      setAlignTimes(0);
    }
  }, [status]);
  function getAlignTarget() {
    if (point) {
      return point;
    }
    return getRootDomNode;
  }
  function forceAlign() {
    var _alignRef$current;
    (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 ? void 0 : _alignRef$current.forceAlign();
  }
  function onInternalAlign(popupDomNode, matchAlign) {
    var nextAlignedClassName = getClassNameFromAlign(matchAlign);
    if (alignedClassName !== nextAlignedClassName) {
      setAlignedClassName(nextAlignedClassName);
    }
    setAlignTimes(function(val) {
      return val + 1;
    });
    if (status === "align") {
      onAlign === null || onAlign === void 0 ? void 0 : onAlign(popupDomNode, matchAlign);
    }
  }
  useLayoutEffect$2(function() {
    if (status === "align") {
      if (alignTimes < 2) {
        forceAlign();
      } else {
        goNextStatus(function() {
          var _prepareResolveRef$cu;
          (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 ? void 0 : _prepareResolveRef$cu.call(prepareResolveRef);
        });
      }
    }
  }, [alignTimes]);
  var motion = _objectSpread2$1({}, getMotion$1(props));
  ["onAppearEnd", "onEnterEnd", "onLeaveEnd"].forEach(function(eventName) {
    var originHandler = motion[eventName];
    motion[eventName] = function(element, event) {
      goNextStatus();
      return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
    };
  });
  function onShowPrepare() {
    return new Promise(function(resolve) {
      prepareResolveRef.current = resolve;
    });
  }
  React.useEffect(function() {
    if (!motion.motionName && status === "motion") {
      goNextStatus();
    }
  }, [motion.motionName, status]);
  React.useImperativeHandle(ref, function() {
    return {
      forceAlign,
      getElement: function getElement2() {
        return elementRef.current;
      }
    };
  });
  var mergedStyle = _objectSpread2$1(_objectSpread2$1({}, stretchStyle), {}, {
    zIndex,
    opacity: status === "motion" || status === "stable" || !visible ? void 0 : 0,
    pointerEvents: !visible && status !== "stable" ? "none" : void 0
  }, style2);
  var alignDisabled = true;
  if ((align === null || align === void 0 ? void 0 : align.points) && (status === "align" || status === "stable")) {
    alignDisabled = false;
  }
  var childNode = children;
  if (React.Children.count(children) > 1) {
    childNode = /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, children);
  }
  return /* @__PURE__ */ React.createElement(CSSMotion, _extends$2({
    visible,
    ref: elementRef,
    leavedClassName: "".concat(prefixCls, "-hidden")
  }, motion, {
    onAppearPrepare: onShowPrepare,
    onEnterPrepare: onShowPrepare,
    removeOnLeave: destroyPopupOnHide,
    forceRender
  }), function(_ref, motionRef) {
    var motionClassName = _ref.className, motionStyle = _ref.style;
    var mergedClassName = cn(prefixCls, className, alignedClassName, motionClassName);
    return /* @__PURE__ */ React.createElement(RcAlign, {
      target: getAlignTarget(),
      key: "popup",
      ref: alignRef,
      monitorWindowResize: true,
      disabled: alignDisabled,
      align,
      onAlign: onInternalAlign
    }, /* @__PURE__ */ React.createElement("div", {
      ref: motionRef,
      className: mergedClassName,
      onMouseEnter,
      onMouseLeave,
      onMouseDownCapture: onMouseDown,
      onTouchStartCapture: onTouchStart,
      onClick,
      style: _objectSpread2$1(_objectSpread2$1({}, motionStyle), mergedStyle)
    }, childNode));
  });
});
PopupInner.displayName = "PopupInner";
var MobilePopupInner = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, children = props.children, _props$mobile = props.mobile;
  _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
  var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender, onClick = props.onClick;
  var elementRef = React.useRef();
  React.useImperativeHandle(ref, function() {
    return {
      forceAlign: function forceAlign() {
      },
      getElement: function getElement2() {
        return elementRef.current;
      }
    };
  });
  var mergedStyle = _objectSpread2$1({
    zIndex
  }, popupStyle);
  var childNode = children;
  if (React.Children.count(children) > 1) {
    childNode = /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, children);
  }
  if (popupRender) {
    childNode = popupRender(childNode);
  }
  return /* @__PURE__ */ React.createElement(CSSMotion, _extends$2({
    visible,
    ref: elementRef,
    removeOnLeave: true
  }, popupMotion), function(_ref, motionRef) {
    var motionClassName = _ref.className, motionStyle = _ref.style;
    var mergedClassName = cn(prefixCls, popupClassName, motionClassName);
    return /* @__PURE__ */ React.createElement("div", {
      ref: motionRef,
      className: mergedClassName,
      onClick,
      style: _objectSpread2$1(_objectSpread2$1({}, motionStyle), mergedStyle)
    }, childNode);
  });
});
MobilePopupInner.displayName = "MobilePopupInner";
var _excluded$3 = ["visible", "mobile"];
var Popup = /* @__PURE__ */ React.forwardRef(function(_ref, ref) {
  var visible = _ref.visible, mobile = _ref.mobile, props = _objectWithoutProperties$1(_ref, _excluded$3);
  var _useState = useState2(visible), _useState2 = _slicedToArray$3(_useState, 2), innerVisible = _useState2[0], serInnerVisible = _useState2[1];
  var _useState3 = useState2(false), _useState4 = _slicedToArray$3(_useState3, 2), inMobile = _useState4[0], setInMobile = _useState4[1];
  var cloneProps = _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    visible: innerVisible
  });
  useEffect2(function() {
    serInnerVisible(visible);
    if (visible && mobile) {
      setInMobile(isMobile$1());
    }
  }, [visible, mobile]);
  var popupNode = inMobile ? /* @__PURE__ */ React.createElement(MobilePopupInner, _extends$2({}, cloneProps, {
    mobile,
    ref
  })) : /* @__PURE__ */ React.createElement(PopupInner, _extends$2({}, cloneProps, {
    ref
  }));
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Mask, cloneProps), popupNode);
});
Popup.displayName = "Popup";
var TriggerContext = /* @__PURE__ */ React.createContext(null);
function noop$5() {
}
function returnEmptyString() {
  return "";
}
function returnDocument(element) {
  if (element) {
    return element.ownerDocument;
  }
  return window.document;
}
var ALL_HANDLERS = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "onContextMenu"];
function generateTrigger(PortalComponent) {
  var Trigger2 = /* @__PURE__ */ function(_React$Component) {
    _inherits$1(Trigger3, _React$Component);
    var _super = _createSuper$1(Trigger3);
    function Trigger3(props) {
      var _this2;
      _classCallCheck$2(this, Trigger3);
      _this2 = _super.call(this, props);
      _this2.popupRef = /* @__PURE__ */ React.createRef();
      _this2.triggerRef = /* @__PURE__ */ React.createRef();
      _this2.portalContainer = void 0;
      _this2.attachId = void 0;
      _this2.clickOutsideHandler = void 0;
      _this2.touchOutsideHandler = void 0;
      _this2.contextMenuOutsideHandler1 = void 0;
      _this2.contextMenuOutsideHandler2 = void 0;
      _this2.mouseDownTimeout = void 0;
      _this2.focusTime = void 0;
      _this2.preClickTime = void 0;
      _this2.preTouchTime = void 0;
      _this2.delayTimer = void 0;
      _this2.hasPopupMouseDown = void 0;
      _this2.onMouseEnter = function(e3) {
        var mouseEnterDelay = _this2.props.mouseEnterDelay;
        _this2.fireEvents("onMouseEnter", e3);
        _this2.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e3);
      };
      _this2.onMouseMove = function(e3) {
        _this2.fireEvents("onMouseMove", e3);
        _this2.setPoint(e3);
      };
      _this2.onMouseLeave = function(e3) {
        _this2.fireEvents("onMouseLeave", e3);
        _this2.delaySetPopupVisible(false, _this2.props.mouseLeaveDelay);
      };
      _this2.onPopupMouseEnter = function() {
        _this2.clearDelayTimer();
      };
      _this2.onPopupMouseLeave = function(e3) {
        var _this$popupRef$curren;
        if (e3.relatedTarget && !e3.relatedTarget.setTimeout && contains((_this$popupRef$curren = _this2.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e3.relatedTarget)) {
          return;
        }
        _this2.delaySetPopupVisible(false, _this2.props.mouseLeaveDelay);
      };
      _this2.onFocus = function(e3) {
        _this2.fireEvents("onFocus", e3);
        _this2.clearDelayTimer();
        if (_this2.isFocusToShow()) {
          _this2.focusTime = Date.now();
          _this2.delaySetPopupVisible(true, _this2.props.focusDelay);
        }
      };
      _this2.onMouseDown = function(e3) {
        _this2.fireEvents("onMouseDown", e3);
        _this2.preClickTime = Date.now();
      };
      _this2.onTouchStart = function(e3) {
        _this2.fireEvents("onTouchStart", e3);
        _this2.preTouchTime = Date.now();
      };
      _this2.onBlur = function(e3) {
        _this2.fireEvents("onBlur", e3);
        _this2.clearDelayTimer();
        if (_this2.isBlurToHide()) {
          _this2.delaySetPopupVisible(false, _this2.props.blurDelay);
        }
      };
      _this2.onContextMenu = function(e3) {
        e3.preventDefault();
        _this2.fireEvents("onContextMenu", e3);
        _this2.setPopupVisible(true, e3);
      };
      _this2.onContextMenuClose = function() {
        if (_this2.isContextMenuToShow()) {
          _this2.close();
        }
      };
      _this2.onClick = function(event) {
        _this2.fireEvents("onClick", event);
        if (_this2.focusTime) {
          var preTime;
          if (_this2.preClickTime && _this2.preTouchTime) {
            preTime = Math.min(_this2.preClickTime, _this2.preTouchTime);
          } else if (_this2.preClickTime) {
            preTime = _this2.preClickTime;
          } else if (_this2.preTouchTime) {
            preTime = _this2.preTouchTime;
          }
          if (Math.abs(preTime - _this2.focusTime) < 20) {
            return;
          }
          _this2.focusTime = 0;
        }
        _this2.preClickTime = 0;
        _this2.preTouchTime = 0;
        if (_this2.isClickToShow() && (_this2.isClickToHide() || _this2.isBlurToHide()) && event && event.preventDefault) {
          event.preventDefault();
        }
        var nextVisible = !_this2.state.popupVisible;
        if (_this2.isClickToHide() && !nextVisible || nextVisible && _this2.isClickToShow()) {
          _this2.setPopupVisible(!_this2.state.popupVisible, event);
        }
      };
      _this2.onPopupMouseDown = function() {
        _this2.hasPopupMouseDown = true;
        clearTimeout(_this2.mouseDownTimeout);
        _this2.mouseDownTimeout = window.setTimeout(function() {
          _this2.hasPopupMouseDown = false;
        }, 0);
        if (_this2.context) {
          var _this$context;
          (_this$context = _this2.context).onPopupMouseDown.apply(_this$context, arguments);
        }
      };
      _this2.onDocumentClick = function(event) {
        if (_this2.props.mask && !_this2.props.maskClosable) {
          return;
        }
        var target = event.target;
        var root2 = _this2.getRootDomNode();
        var popupNode = _this2.getPopupDomNode();
        if ((!contains(root2, target) || _this2.isContextMenuOnly()) && !contains(popupNode, target) && !_this2.hasPopupMouseDown) {
          _this2.close();
        }
      };
      _this2.getRootDomNode = function() {
        var getTriggerDOMNode = _this2.props.getTriggerDOMNode;
        if (getTriggerDOMNode) {
          return getTriggerDOMNode(_this2.triggerRef.current);
        }
        try {
          var domNode = findDOMNode2(_this2.triggerRef.current);
          if (domNode) {
            return domNode;
          }
        } catch (err) {
        }
        return ReactDOM__default.findDOMNode(_assertThisInitialized$1(_this2));
      };
      _this2.getPopupClassNameFromAlign = function(align) {
        var className = [];
        var _this$props = _this2.props, popupPlacement = _this$props.popupPlacement, builtinPlacements = _this$props.builtinPlacements, prefixCls = _this$props.prefixCls, alignPoint2 = _this$props.alignPoint, getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;
        if (popupPlacement && builtinPlacements) {
          className.push(getAlignPopupClassName(builtinPlacements, prefixCls, align, alignPoint2));
        }
        if (getPopupClassNameFromAlign) {
          className.push(getPopupClassNameFromAlign(align));
        }
        return className.join(" ");
      };
      _this2.getComponent = function() {
        var _this$props2 = _this2.props, prefixCls = _this$props2.prefixCls, destroyPopupOnHide = _this$props2.destroyPopupOnHide, popupClassName = _this$props2.popupClassName, onPopupAlign = _this$props2.onPopupAlign, popupMotion = _this$props2.popupMotion, popupAnimation = _this$props2.popupAnimation, popupTransitionName = _this$props2.popupTransitionName, popupStyle = _this$props2.popupStyle, mask = _this$props2.mask, maskAnimation = _this$props2.maskAnimation, maskTransitionName = _this$props2.maskTransitionName, maskMotion = _this$props2.maskMotion, zIndex = _this$props2.zIndex, popup = _this$props2.popup, stretch = _this$props2.stretch, alignPoint2 = _this$props2.alignPoint, mobile = _this$props2.mobile, forceRender = _this$props2.forceRender, onPopupClick = _this$props2.onPopupClick;
        var _this$state = _this2.state, popupVisible = _this$state.popupVisible, point = _this$state.point;
        var align = _this2.getPopupAlign();
        var mouseProps = {};
        if (_this2.isMouseEnterToShow()) {
          mouseProps.onMouseEnter = _this2.onPopupMouseEnter;
        }
        if (_this2.isMouseLeaveToHide()) {
          mouseProps.onMouseLeave = _this2.onPopupMouseLeave;
        }
        mouseProps.onMouseDown = _this2.onPopupMouseDown;
        mouseProps.onTouchStart = _this2.onPopupMouseDown;
        return /* @__PURE__ */ React.createElement(Popup, _extends$2({
          prefixCls,
          destroyPopupOnHide,
          visible: popupVisible,
          point: alignPoint2 && point,
          className: popupClassName,
          align,
          onAlign: onPopupAlign,
          animation: popupAnimation,
          getClassNameFromAlign: _this2.getPopupClassNameFromAlign
        }, mouseProps, {
          stretch,
          getRootDomNode: _this2.getRootDomNode,
          style: popupStyle,
          mask,
          zIndex,
          transitionName: popupTransitionName,
          maskAnimation,
          maskTransitionName,
          maskMotion,
          ref: _this2.popupRef,
          motion: popupMotion,
          mobile,
          forceRender,
          onClick: onPopupClick
        }), typeof popup === "function" ? popup() : popup);
      };
      _this2.attachParent = function(popupContainer) {
        wrapperRaf$1.cancel(_this2.attachId);
        var _this$props3 = _this2.props, getPopupContainer = _this$props3.getPopupContainer, getDocument2 = _this$props3.getDocument;
        var domNode = _this2.getRootDomNode();
        var mountNode;
        if (!getPopupContainer) {
          mountNode = getDocument2(_this2.getRootDomNode()).body;
        } else if (domNode || getPopupContainer.length === 0) {
          mountNode = getPopupContainer(domNode);
        }
        if (mountNode) {
          mountNode.appendChild(popupContainer);
        } else {
          _this2.attachId = wrapperRaf$1(function() {
            _this2.attachParent(popupContainer);
          });
        }
      };
      _this2.getContainer = function() {
        if (!_this2.portalContainer) {
          var getDocument2 = _this2.props.getDocument;
          var popupContainer = getDocument2(_this2.getRootDomNode()).createElement("div");
          popupContainer.style.position = "absolute";
          popupContainer.style.top = "0";
          popupContainer.style.left = "0";
          popupContainer.style.width = "100%";
          _this2.portalContainer = popupContainer;
        }
        _this2.attachParent(_this2.portalContainer);
        return _this2.portalContainer;
      };
      _this2.setPoint = function(point) {
        var alignPoint2 = _this2.props.alignPoint;
        if (!alignPoint2 || !point)
          return;
        _this2.setState({
          point: {
            pageX: point.pageX,
            pageY: point.pageY
          }
        });
      };
      _this2.handlePortalUpdate = function() {
        if (_this2.state.prevPopupVisible !== _this2.state.popupVisible) {
          _this2.props.afterPopupVisibleChange(_this2.state.popupVisible);
        }
      };
      _this2.triggerContextValue = {
        onPopupMouseDown: _this2.onPopupMouseDown
      };
      var _popupVisible;
      if ("popupVisible" in props) {
        _popupVisible = !!props.popupVisible;
      } else {
        _popupVisible = !!props.defaultPopupVisible;
      }
      _this2.state = {
        prevPopupVisible: _popupVisible,
        popupVisible: _popupVisible
      };
      ALL_HANDLERS.forEach(function(h) {
        _this2["fire".concat(h)] = function(e3) {
          _this2.fireEvents(h, e3);
        };
      });
      return _this2;
    }
    _createClass$2(Trigger3, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentDidUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var props = this.props;
        var state = this.state;
        if (state.popupVisible) {
          var currentDocument;
          if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
            currentDocument = props.getDocument(this.getRootDomNode());
            this.clickOutsideHandler = addEventListenerWrap(currentDocument, "mousedown", this.onDocumentClick);
          }
          if (!this.touchOutsideHandler) {
            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
            this.touchOutsideHandler = addEventListenerWrap(currentDocument, "touchstart", this.onDocumentClick);
          }
          if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
            this.contextMenuOutsideHandler1 = addEventListenerWrap(currentDocument, "scroll", this.onContextMenuClose);
          }
          if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
            this.contextMenuOutsideHandler2 = addEventListenerWrap(window, "blur", this.onContextMenuClose);
          }
          return;
        }
        this.clearOutsideHandler();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearDelayTimer();
        this.clearOutsideHandler();
        clearTimeout(this.mouseDownTimeout);
        wrapperRaf$1.cancel(this.attachId);
      }
    }, {
      key: "getPopupDomNode",
      value: function getPopupDomNode() {
        var _this$popupRef$curren2;
        return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
      }
    }, {
      key: "getPopupAlign",
      value: function getPopupAlign() {
        var props = this.props;
        var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
        if (popupPlacement && builtinPlacements) {
          return getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
        }
        return popupAlign;
      }
    }, {
      key: "setPopupVisible",
      value: function setPopupVisible(popupVisible, event) {
        var alignPoint2 = this.props.alignPoint;
        var prevPopupVisible = this.state.popupVisible;
        this.clearDelayTimer();
        if (prevPopupVisible !== popupVisible) {
          if (!("popupVisible" in this.props)) {
            this.setState({
              popupVisible,
              prevPopupVisible
            });
          }
          this.props.onPopupVisibleChange(popupVisible);
        }
        if (alignPoint2 && event && popupVisible) {
          this.setPoint(event);
        }
      }
    }, {
      key: "delaySetPopupVisible",
      value: function delaySetPopupVisible(visible, delayS, event) {
        var _this2 = this;
        var delay = delayS * 1e3;
        this.clearDelayTimer();
        if (delay) {
          var point = event ? {
            pageX: event.pageX,
            pageY: event.pageY
          } : null;
          this.delayTimer = window.setTimeout(function() {
            _this2.setPopupVisible(visible, point);
            _this2.clearDelayTimer();
          }, delay);
        } else {
          this.setPopupVisible(visible, event);
        }
      }
    }, {
      key: "clearDelayTimer",
      value: function clearDelayTimer() {
        if (this.delayTimer) {
          clearTimeout(this.delayTimer);
          this.delayTimer = null;
        }
      }
    }, {
      key: "clearOutsideHandler",
      value: function clearOutsideHandler() {
        if (this.clickOutsideHandler) {
          this.clickOutsideHandler.remove();
          this.clickOutsideHandler = null;
        }
        if (this.contextMenuOutsideHandler1) {
          this.contextMenuOutsideHandler1.remove();
          this.contextMenuOutsideHandler1 = null;
        }
        if (this.contextMenuOutsideHandler2) {
          this.contextMenuOutsideHandler2.remove();
          this.contextMenuOutsideHandler2 = null;
        }
        if (this.touchOutsideHandler) {
          this.touchOutsideHandler.remove();
          this.touchOutsideHandler = null;
        }
      }
    }, {
      key: "createTwoChains",
      value: function createTwoChains(event) {
        var childPros = this.props.children.props;
        var props = this.props;
        if (childPros[event] && props[event]) {
          return this["fire".concat(event)];
        }
        return childPros[event] || props[event];
      }
    }, {
      key: "isClickToShow",
      value: function isClickToShow() {
        var _this$props4 = this.props, action = _this$props4.action, showAction = _this$props4.showAction;
        return action.indexOf("click") !== -1 || showAction.indexOf("click") !== -1;
      }
    }, {
      key: "isContextMenuOnly",
      value: function isContextMenuOnly() {
        var action = this.props.action;
        return action === "contextMenu" || action.length === 1 && action[0] === "contextMenu";
      }
    }, {
      key: "isContextMenuToShow",
      value: function isContextMenuToShow() {
        var _this$props5 = this.props, action = _this$props5.action, showAction = _this$props5.showAction;
        return action.indexOf("contextMenu") !== -1 || showAction.indexOf("contextMenu") !== -1;
      }
    }, {
      key: "isClickToHide",
      value: function isClickToHide() {
        var _this$props6 = this.props, action = _this$props6.action, hideAction = _this$props6.hideAction;
        return action.indexOf("click") !== -1 || hideAction.indexOf("click") !== -1;
      }
    }, {
      key: "isMouseEnterToShow",
      value: function isMouseEnterToShow() {
        var _this$props7 = this.props, action = _this$props7.action, showAction = _this$props7.showAction;
        return action.indexOf("hover") !== -1 || showAction.indexOf("mouseEnter") !== -1;
      }
    }, {
      key: "isMouseLeaveToHide",
      value: function isMouseLeaveToHide() {
        var _this$props8 = this.props, action = _this$props8.action, hideAction = _this$props8.hideAction;
        return action.indexOf("hover") !== -1 || hideAction.indexOf("mouseLeave") !== -1;
      }
    }, {
      key: "isFocusToShow",
      value: function isFocusToShow() {
        var _this$props9 = this.props, action = _this$props9.action, showAction = _this$props9.showAction;
        return action.indexOf("focus") !== -1 || showAction.indexOf("focus") !== -1;
      }
    }, {
      key: "isBlurToHide",
      value: function isBlurToHide() {
        var _this$props10 = this.props, action = _this$props10.action, hideAction = _this$props10.hideAction;
        return action.indexOf("focus") !== -1 || hideAction.indexOf("blur") !== -1;
      }
    }, {
      key: "forcePopupAlign",
      value: function forcePopupAlign() {
        if (this.state.popupVisible) {
          var _this$popupRef$curren3;
          (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 ? void 0 : _this$popupRef$curren3.forceAlign();
        }
      }
    }, {
      key: "fireEvents",
      value: function fireEvents(type2, e3) {
        var childCallback = this.props.children.props[type2];
        if (childCallback) {
          childCallback(e3);
        }
        var callback = this.props[type2];
        if (callback) {
          callback(e3);
        }
      }
    }, {
      key: "close",
      value: function close() {
        this.setPopupVisible(false);
      }
    }, {
      key: "render",
      value: function render4() {
        var popupVisible = this.state.popupVisible;
        var _this$props11 = this.props, children = _this$props11.children, forceRender = _this$props11.forceRender, alignPoint2 = _this$props11.alignPoint, className = _this$props11.className, autoDestroy = _this$props11.autoDestroy;
        var child = React.Children.only(children);
        var newChildProps = {
          key: "trigger"
        };
        if (this.isContextMenuToShow()) {
          newChildProps.onContextMenu = this.onContextMenu;
        } else {
          newChildProps.onContextMenu = this.createTwoChains("onContextMenu");
        }
        if (this.isClickToHide() || this.isClickToShow()) {
          newChildProps.onClick = this.onClick;
          newChildProps.onMouseDown = this.onMouseDown;
          newChildProps.onTouchStart = this.onTouchStart;
        } else {
          newChildProps.onClick = this.createTwoChains("onClick");
          newChildProps.onMouseDown = this.createTwoChains("onMouseDown");
          newChildProps.onTouchStart = this.createTwoChains("onTouchStart");
        }
        if (this.isMouseEnterToShow()) {
          newChildProps.onMouseEnter = this.onMouseEnter;
          if (alignPoint2) {
            newChildProps.onMouseMove = this.onMouseMove;
          }
        } else {
          newChildProps.onMouseEnter = this.createTwoChains("onMouseEnter");
        }
        if (this.isMouseLeaveToHide()) {
          newChildProps.onMouseLeave = this.onMouseLeave;
        } else {
          newChildProps.onMouseLeave = this.createTwoChains("onMouseLeave");
        }
        if (this.isFocusToShow() || this.isBlurToHide()) {
          newChildProps.onFocus = this.onFocus;
          newChildProps.onBlur = this.onBlur;
        } else {
          newChildProps.onFocus = this.createTwoChains("onFocus");
          newChildProps.onBlur = this.createTwoChains("onBlur");
        }
        var childrenClassName = cn(child && child.props && child.props.className, className);
        if (childrenClassName) {
          newChildProps.className = childrenClassName;
        }
        var cloneProps = _objectSpread2$1({}, newChildProps);
        if (supportRef(child)) {
          cloneProps.ref = composeRef(this.triggerRef, child.ref);
        }
        var trigger = /* @__PURE__ */ React.cloneElement(child, cloneProps);
        var portal;
        if (popupVisible || this.popupRef.current || forceRender) {
          portal = /* @__PURE__ */ React.createElement(PortalComponent, {
            key: "portal",
            getContainer: this.getContainer,
            didUpdate: this.handlePortalUpdate
          }, this.getComponent());
        }
        if (!popupVisible && autoDestroy) {
          portal = null;
        }
        return /* @__PURE__ */ React.createElement(TriggerContext.Provider, {
          value: this.triggerContextValue
        }, trigger, portal);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref, prevState) {
        var popupVisible = _ref.popupVisible;
        var newState = {};
        if (popupVisible !== void 0 && prevState.popupVisible !== popupVisible) {
          newState.popupVisible = popupVisible;
          newState.prevPopupVisible = prevState.popupVisible;
        }
        return newState;
      }
    }]);
    return Trigger3;
  }(React.Component);
  Trigger2.contextType = TriggerContext;
  Trigger2.defaultProps = {
    prefixCls: "rc-trigger-popup",
    getPopupClassNameFromAlign: returnEmptyString,
    getDocument: returnDocument,
    onPopupVisibleChange: noop$5,
    afterPopupVisibleChange: noop$5,
    onPopupAlign: noop$5,
    popupClassName: "",
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: false,
    popupAlign: {},
    defaultPopupVisible: false,
    mask: false,
    maskClosable: true,
    action: [],
    showAction: [],
    hideAction: [],
    autoDestroy: false
  };
  return Trigger2;
}
var Trigger = generateTrigger(Portal);
var getBuiltInPlacements = function getBuiltInPlacements2(dropdownMatchSelectWidth) {
  var adjustX = typeof dropdownMatchSelectWidth !== "number" ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX,
        adjustY: 1
      }
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX,
        adjustY: 1
      }
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX,
        adjustY: 1
      }
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX,
        adjustY: 1
      }
    }
  };
};
var SelectTrigger = function SelectTrigger2(props, ref) {
  var prefixCls = props.prefixCls;
  props.disabled;
  var visible = props.visible, children = props.children, popupElement = props.popupElement, containerWidth = props.containerWidth, animation = props.animation, transitionName2 = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, _props$direction = props.direction, direction = _props$direction === void 0 ? "ltr" : _props$direction, _props$dropdownMatchS = props.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, empty2 = props.empty, getTriggerDOMNode = props.getTriggerDOMNode, onPopupVisibleChange = props.onPopupVisibleChange, restProps = _objectWithoutProperties$1(props, ["prefixCls", "disabled", "visible", "children", "popupElement", "containerWidth", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange"]);
  var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
  var popupNode = popupElement;
  if (dropdownRender) {
    popupNode = dropdownRender(popupElement);
  }
  var builtInPlacements = React.useMemo(function() {
    return getBuiltInPlacements(dropdownMatchSelectWidth);
  }, [dropdownMatchSelectWidth]);
  var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName2;
  var popupRef = React.useRef(null);
  React.useImperativeHandle(ref, function() {
    return {
      getPopupElement: function getPopupElement() {
        return popupRef.current;
      }
    };
  });
  var popupStyle = _objectSpread2$1({
    minWidth: containerWidth
  }, dropdownStyle);
  if (typeof dropdownMatchSelectWidth === "number") {
    popupStyle.width = dropdownMatchSelectWidth;
  } else if (dropdownMatchSelectWidth) {
    popupStyle.width = containerWidth;
  }
  return /* @__PURE__ */ React.createElement(Trigger, _extends$2({}, restProps, {
    showAction: onPopupVisibleChange ? ["click"] : [],
    hideAction: onPopupVisibleChange ? ["click"] : [],
    popupPlacement: direction === "rtl" ? "bottomRight" : "bottomLeft",
    builtinPlacements: builtInPlacements,
    prefixCls: dropdownPrefixCls,
    popupTransitionName: mergedTransitionName,
    popup: /* @__PURE__ */ React.createElement("div", {
      ref: popupRef
    }, popupNode),
    popupAlign: dropdownAlign,
    popupVisible: visible,
    getPopupContainer,
    popupClassName: cn(dropdownClassName, _defineProperty$4({}, "".concat(dropdownPrefixCls, "-empty"), empty2)),
    popupStyle,
    getTriggerDOMNode,
    onPopupVisibleChange
  }), children);
};
var RefSelectTrigger = /* @__PURE__ */ React.forwardRef(SelectTrigger);
RefSelectTrigger.displayName = "SelectTrigger";
var INTERNAL_PROPS_MARK = "RC_SELECT_INTERNAL_PROPS_MARK";
function useDelayReset() {
  var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
  var _React$useState = React.useState(false), _React$useState2 = _slicedToArray$3(_React$useState, 2), bool = _React$useState2[0], setBool = _React$useState2[1];
  var delayRef = React.useRef(null);
  var cancelLatest = function cancelLatest2() {
    window.clearTimeout(delayRef.current);
  };
  React.useEffect(function() {
    return cancelLatest;
  }, []);
  var delaySetBool = function delaySetBool2(value, callback) {
    cancelLatest();
    delayRef.current = window.setTimeout(function() {
      setBool(value);
      if (callback) {
        callback();
      }
    }, timeout);
  };
  return [bool, delaySetBool, cancelLatest];
}
function useSelectTriggerControl(elements, open, triggerOpen) {
  var propsRef = React.useRef(null);
  propsRef.current = {
    open,
    triggerOpen
  };
  React.useEffect(function() {
    function onGlobalMouseDown(event) {
      var target = event.target;
      if (target.shadowRoot && event.composed) {
        target = event.composedPath()[0] || target;
      }
      if (propsRef.current.open && elements().filter(function(element) {
        return element;
      }).every(function(element) {
        return !element.contains(target) && element !== target;
      })) {
        propsRef.current.triggerOpen(false);
      }
    }
    window.addEventListener("mousedown", onGlobalMouseDown);
    return function() {
      return window.removeEventListener("mousedown", onGlobalMouseDown);
    };
  }, []);
}
function useCacheDisplayValue(values) {
  var prevValuesRef = React.useRef(values);
  var mergedValues = React.useMemo(function() {
    var valueLabels = /* @__PURE__ */ new Map();
    prevValuesRef.current.forEach(function(_ref) {
      var value = _ref.value, label = _ref.label;
      if (value !== label) {
        valueLabels.set(value, label);
      }
    });
    var resultValues = values.map(function(item) {
      var cacheLabel = valueLabels.get(item.value);
      if (item.isCacheable && cacheLabel) {
        return _objectSpread2$1(_objectSpread2$1({}, item), {}, {
          label: cacheLabel
        });
      }
      return item;
    });
    prevValuesRef.current = resultValues;
    return resultValues;
  }, [values]);
  return mergedValues;
}
function useCacheOptions(options) {
  var prevOptionMapRef = React.useRef(null);
  var optionMap = React.useMemo(function() {
    var map = /* @__PURE__ */ new Map();
    options.forEach(function(item) {
      var value = item.data.value;
      map.set(value, item);
    });
    return map;
  }, [options]);
  prevOptionMapRef.current = optionMap;
  var getValueOption = function getValueOption2(vals) {
    return vals.map(function(value) {
      return prevOptionMapRef.current.get(value);
    }).filter(Boolean);
  };
  return getValueOption;
}
var DEFAULT_OMIT_PROPS = ["removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "tabIndex"];
function generateSelector(config) {
  var defaultPrefixCls2 = config.prefixCls, OptionList4 = config.components.optionList, convertChildrenToData3 = config.convertChildrenToData, flattenOptions2 = config.flattenOptions, getLabeledValue3 = config.getLabeledValue, filterOptions2 = config.filterOptions, isValueDisabled2 = config.isValueDisabled, findValueOption2 = config.findValueOption, warningProps2 = config.warningProps, fillOptionsWithMissingValue2 = config.fillOptionsWithMissingValue, omitDOMProps2 = config.omitDOMProps;
  function Select2(props, ref) {
    var _classNames2;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? defaultPrefixCls2 : _props$prefixCls, className = props.className, id2 = props.id, open = props.open, defaultOpen = props.defaultOpen, options = props.options, children = props.children, mode = props.mode, value = props.value, defaultValue = props.defaultValue, labelInValue = props.labelInValue, showSearch = props.showSearch, inputValue = props.inputValue, searchValue = props.searchValue, filterOption2 = props.filterOption, filterSort = props.filterSort, _props$optionFilterPr = props.optionFilterProp, optionFilterProp = _props$optionFilterPr === void 0 ? "value" : _props$optionFilterPr, _props$autoClearSearc = props.autoClearSearchValue, autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc, onSearch = props.onSearch, allowClear = props.allowClear, clearIcon = props.clearIcon, showArrow = props.showArrow, inputIcon = props.inputIcon, menuItemSelectedIcon = props.menuItemSelectedIcon, disabled = props.disabled, loading = props.loading, defaultActiveFirstOption = props.defaultActiveFirstOption, _props$notFoundConten = props.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? "Not Found" : _props$notFoundConten, optionLabelProp = props.optionLabelProp, backfill = props.backfill;
    props.tabIndex;
    var getInputElement = props.getInputElement, getRawInputElement = props.getRawInputElement, getPopupContainer = props.getPopupContainer, _props$listHeight = props.listHeight, listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight, _props$listItemHeight = props.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight, animation = props.animation, transitionName2 = props.transitionName, virtual = props.virtual, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, _props$showAction = props.showAction, showAction = _props$showAction === void 0 ? [] : _props$showAction, direction = props.direction, tokenSeparators = props.tokenSeparators, tagRender = props.tagRender, onPopupScroll = props.onPopupScroll, onDropdownVisibleChange = props.onDropdownVisibleChange, onFocus2 = props.onFocus, onBlur2 = props.onBlur, onKeyUp2 = props.onKeyUp, onKeyDown2 = props.onKeyDown, onMouseDown = props.onMouseDown, onChange4 = props.onChange, onSelect = props.onSelect, onDeselect = props.onDeselect, onClear = props.onClear, _props$internalProps = props.internalProps, internalProps = _props$internalProps === void 0 ? {} : _props$internalProps, restProps = _objectWithoutProperties$1(props, ["prefixCls", "className", "id", "open", "defaultOpen", "options", "children", "mode", "value", "defaultValue", "labelInValue", "showSearch", "inputValue", "searchValue", "filterOption", "filterSort", "optionFilterProp", "autoClearSearchValue", "onSearch", "allowClear", "clearIcon", "showArrow", "inputIcon", "menuItemSelectedIcon", "disabled", "loading", "defaultActiveFirstOption", "notFoundContent", "optionLabelProp", "backfill", "tabIndex", "getInputElement", "getRawInputElement", "getPopupContainer", "listHeight", "listItemHeight", "animation", "transitionName", "virtual", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "showAction", "direction", "tokenSeparators", "tagRender", "onPopupScroll", "onDropdownVisibleChange", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown", "onChange", "onSelect", "onDeselect", "onClear", "internalProps"]);
    var useInternalProps = internalProps.mark === INTERNAL_PROPS_MARK;
    var domProps = omitDOMProps2 ? omitDOMProps2(restProps) : restProps;
    DEFAULT_OMIT_PROPS.forEach(function(prop) {
      delete domProps[prop];
    });
    var containerRef = useRef2(null);
    var triggerRef = useRef2(null);
    var selectorRef = useRef2(null);
    var listRef = useRef2(null);
    var tokenWithEnter = useMemo$1(function() {
      return (tokenSeparators || []).some(function(tokenSeparator) {
        return ["\n", "\r\n"].includes(tokenSeparator);
      });
    }, [tokenSeparators]);
    var _useDelayReset = useDelayReset(), _useDelayReset2 = _slicedToArray$3(_useDelayReset, 3), mockFocused = _useDelayReset2[0], setMockFocused = _useDelayReset2[1], cancelSetMockFocused = _useDelayReset2[2];
    var _useState = useState2(), _useState2 = _slicedToArray$3(_useState, 2), innerId = _useState2[0], setInnerId = _useState2[1];
    useEffect2(function() {
      setInnerId("rc_select_".concat(getUUID()));
    }, []);
    var mergedId = id2 || innerId;
    var mergedOptionLabelProp = optionLabelProp;
    if (mergedOptionLabelProp === void 0) {
      mergedOptionLabelProp = options ? "label" : "children";
    }
    var mergedLabelInValue = mode === "combobox" ? false : labelInValue;
    var isMultiple = mode === "tags" || mode === "multiple";
    var mergedShowSearch = showSearch !== void 0 ? showSearch : isMultiple || mode === "combobox";
    var _useState3 = useState2(false), _useState4 = _slicedToArray$3(_useState3, 2), mobile = _useState4[0], setMobile = _useState4[1];
    useEffect2(function() {
      setMobile(isMobile$1());
    }, []);
    var selectorDomRef = useRef2(null);
    React.useImperativeHandle(ref, function() {
      var _selectorRef$current, _selectorRef$current2, _listRef$current;
      return {
        focus: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.focus,
        blur: (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 ? void 0 : _selectorRef$current2.blur,
        scrollTo: (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo
      };
    });
    var _useMergedState = useMergedState(defaultValue, {
      value
    }), _useMergedState2 = _slicedToArray$3(_useMergedState, 2), mergedValue = _useMergedState2[0], setMergedValue = _useMergedState2[1];
    var _useMemo = useMemo$1(function() {
      return toInnerValue(mergedValue, {
        labelInValue: mergedLabelInValue,
        combobox: mode === "combobox"
      });
    }, [mergedValue, mergedLabelInValue]), _useMemo2 = _slicedToArray$3(_useMemo, 2), mergedRawValue = _useMemo2[0], mergedValueMap = _useMemo2[1];
    var rawValues = useMemo$1(function() {
      return new Set(mergedRawValue);
    }, [mergedRawValue]);
    var _useState5 = useState2(null), _useState6 = _slicedToArray$3(_useState5, 2), activeValue = _useState6[0], setActiveValue = _useState6[1];
    var _useState7 = useState2(""), _useState8 = _slicedToArray$3(_useState7, 2), innerSearchValue = _useState8[0], setInnerSearchValue = _useState8[1];
    var mergedSearchValue = innerSearchValue;
    if (mode === "combobox" && mergedValue !== void 0) {
      mergedSearchValue = mergedValue;
    } else if (searchValue !== void 0) {
      mergedSearchValue = searchValue;
    } else if (inputValue) {
      mergedSearchValue = inputValue;
    }
    var mergedOptions = useMemo$1(function() {
      var newOptions = options;
      if (newOptions === void 0) {
        newOptions = convertChildrenToData3(children);
      }
      if (mode === "tags" && fillOptionsWithMissingValue2) {
        newOptions = fillOptionsWithMissingValue2(newOptions, mergedValue, mergedOptionLabelProp, labelInValue);
      }
      return newOptions || [];
    }, [options, children, mode, mergedValue]);
    var mergedFlattenOptions = useMemo$1(function() {
      return flattenOptions2(mergedOptions, props);
    }, [mergedOptions]);
    var getValueOption = useCacheOptions(mergedFlattenOptions);
    var displayOptions = useMemo$1(function() {
      if (!mergedSearchValue || !mergedShowSearch) {
        return _toConsumableArray(mergedOptions);
      }
      var filteredOptions = filterOptions2(mergedSearchValue, mergedOptions, {
        optionFilterProp,
        filterOption: mode === "combobox" && filterOption2 === void 0 ? function() {
          return true;
        } : filterOption2
      });
      if (mode === "tags" && filteredOptions.every(function(opt) {
        return opt[optionFilterProp] !== mergedSearchValue;
      })) {
        filteredOptions.unshift({
          value: mergedSearchValue,
          label: mergedSearchValue,
          key: "__RC_SELECT_TAG_PLACEHOLDER__"
        });
      }
      if (filterSort && Array.isArray(filteredOptions)) {
        return _toConsumableArray(filteredOptions).sort(filterSort);
      }
      return filteredOptions;
    }, [mergedOptions, mergedSearchValue, mode, mergedShowSearch, filterSort]);
    var displayFlattenOptions = useMemo$1(function() {
      return flattenOptions2(displayOptions, props);
    }, [displayOptions]);
    useEffect2(function() {
      if (listRef.current && listRef.current.scrollTo) {
        listRef.current.scrollTo(0);
      }
    }, [mergedSearchValue]);
    var displayValues = useMemo$1(function() {
      var tmpValues = mergedRawValue.map(function(val) {
        var valueOptions = getValueOption([val]);
        var displayValue = getLabeledValue3(val, {
          options: valueOptions,
          prevValueMap: mergedValueMap,
          labelInValue: mergedLabelInValue,
          optionLabelProp: mergedOptionLabelProp
        });
        return _objectSpread2$1(_objectSpread2$1({}, displayValue), {}, {
          disabled: isValueDisabled2(val, valueOptions)
        });
      });
      if (!mode && tmpValues.length === 1 && tmpValues[0].value === null && tmpValues[0].label === null) {
        return [];
      }
      return tmpValues;
    }, [mergedValue, mergedOptions, mode]);
    displayValues = useCacheDisplayValue(displayValues);
    var triggerSelect = function triggerSelect2(newValue, isSelect, source) {
      var newValueOption = getValueOption([newValue]);
      var outOption = findValueOption2([newValue], newValueOption)[0];
      if (!internalProps.skipTriggerSelect) {
        var selectValue = mergedLabelInValue ? getLabeledValue3(newValue, {
          options: newValueOption,
          prevValueMap: mergedValueMap,
          labelInValue: mergedLabelInValue,
          optionLabelProp: mergedOptionLabelProp
        }) : newValue;
        if (isSelect && onSelect) {
          onSelect(selectValue, outOption);
        } else if (!isSelect && onDeselect) {
          onDeselect(selectValue, outOption);
        }
      }
      if (useInternalProps) {
        if (isSelect && internalProps.onRawSelect) {
          internalProps.onRawSelect(newValue, outOption, source);
        } else if (!isSelect && internalProps.onRawDeselect) {
          internalProps.onRawDeselect(newValue, outOption, source);
        }
      }
    };
    var _useState9 = useState2([]), _useState10 = _slicedToArray$3(_useState9, 2), prevValueOptions = _useState10[0], setPrevValueOptions = _useState10[1];
    var triggerChange = function triggerChange2(newRawValues) {
      if (useInternalProps && internalProps.skipTriggerChange) {
        return;
      }
      var newRawValuesOptions = getValueOption(newRawValues);
      var outValues = toOuterValues(Array.from(newRawValues), {
        labelInValue: mergedLabelInValue,
        options: newRawValuesOptions,
        getLabeledValue: getLabeledValue3,
        prevValueMap: mergedValueMap,
        optionLabelProp: mergedOptionLabelProp
      });
      var outValue = isMultiple ? outValues : outValues[0];
      if (onChange4 && (mergedRawValue.length !== 0 || outValues.length !== 0)) {
        var outOptions = findValueOption2(newRawValues, newRawValuesOptions, {
          prevValueOptions
        });
        setPrevValueOptions(outOptions.map(function(option, index2) {
          var clone2 = _objectSpread2$1({}, option);
          Object.defineProperty(clone2, "_INTERNAL_OPTION_VALUE_", {
            get: function get2() {
              return newRawValues[index2];
            }
          });
          return clone2;
        }));
        onChange4(outValue, isMultiple ? outOptions : outOptions[0]);
      }
      setMergedValue(outValue);
    };
    var onInternalSelect = function onInternalSelect2(newValue, _ref) {
      var selected = _ref.selected, source = _ref.source;
      if (disabled) {
        return;
      }
      var newRawValue;
      if (isMultiple) {
        newRawValue = new Set(mergedRawValue);
        if (selected) {
          newRawValue.add(newValue);
        } else {
          newRawValue.delete(newValue);
        }
      } else {
        newRawValue = /* @__PURE__ */ new Set();
        newRawValue.add(newValue);
      }
      if (isMultiple || !isMultiple && Array.from(mergedRawValue)[0] !== newValue) {
        triggerChange(Array.from(newRawValue));
      }
      triggerSelect(newValue, !isMultiple || selected, source);
      if (mode === "combobox") {
        setInnerSearchValue(String(newValue));
        setActiveValue("");
      } else if (!isMultiple || autoClearSearchValue) {
        setInnerSearchValue("");
        setActiveValue("");
      }
    };
    var onInternalOptionSelect = function onInternalOptionSelect2(newValue, info) {
      onInternalSelect(newValue, _objectSpread2$1(_objectSpread2$1({}, info), {}, {
        source: "option"
      }));
    };
    var onInternalSelectionSelect = function onInternalSelectionSelect2(newValue, info) {
      onInternalSelect(newValue, _objectSpread2$1(_objectSpread2$1({}, info), {}, {
        source: "selection"
      }));
    };
    var customizeInputElement = mode === "combobox" && typeof getInputElement === "function" && getInputElement() || null;
    var customizeRawInputElement = typeof getRawInputElement === "function" && getRawInputElement();
    var _useMergedState3 = useMergedState(void 0, {
      defaultValue: defaultOpen,
      value: open
    }), _useMergedState4 = _slicedToArray$3(_useMergedState3, 2), innerOpen = _useMergedState4[0], setInnerOpen = _useMergedState4[1];
    var mergedOpen = innerOpen;
    var emptyListContent = !notFoundContent && !displayOptions.length;
    if (disabled || emptyListContent && mergedOpen && mode === "combobox") {
      mergedOpen = false;
    }
    var triggerOpen = emptyListContent ? false : mergedOpen;
    var onToggleOpen = function onToggleOpen2(newOpen) {
      var nextOpen = newOpen !== void 0 ? newOpen : !mergedOpen;
      if (innerOpen !== nextOpen && !disabled) {
        setInnerOpen(nextOpen);
        if (onDropdownVisibleChange) {
          onDropdownVisibleChange(nextOpen);
        }
      }
    };
    var onTriggerVisibleChange;
    if (customizeRawInputElement) {
      onTriggerVisibleChange = function onTriggerVisibleChange2(newOpen) {
        onToggleOpen(newOpen);
      };
    }
    useSelectTriggerControl(function() {
      var _triggerRef$current;
      return [containerRef.current, (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getPopupElement()];
    }, triggerOpen, onToggleOpen);
    var triggerSearch = function triggerSearch2(searchText, fromTyping, isCompositing) {
      var ret = true;
      var newSearchText = searchText;
      setActiveValue(null);
      var patchLabels = isCompositing ? null : getSeparatedContent(searchText, tokenSeparators);
      var patchRawValues = patchLabels;
      if (mode === "combobox") {
        if (fromTyping) {
          triggerChange([newSearchText]);
        }
      } else if (patchLabels) {
        newSearchText = "";
        if (mode !== "tags") {
          patchRawValues = patchLabels.map(function(label) {
            var item = mergedFlattenOptions.find(function(_ref2) {
              var data = _ref2.data;
              return data[mergedOptionLabelProp] === label;
            });
            return item ? item.data.value : null;
          }).filter(function(val) {
            return val !== null;
          });
        }
        var newRawValues = Array.from(new Set([].concat(_toConsumableArray(mergedRawValue), _toConsumableArray(patchRawValues))));
        triggerChange(newRawValues);
        newRawValues.forEach(function(newRawValue) {
          triggerSelect(newRawValue, true, "input");
        });
        onToggleOpen(false);
        ret = false;
      }
      setInnerSearchValue(newSearchText);
      if (onSearch && mergedSearchValue !== newSearchText) {
        onSearch(newSearchText);
      }
      return ret;
    };
    var onSearchSubmit = function onSearchSubmit2(searchText) {
      if (!searchText || !searchText.trim()) {
        return;
      }
      var newRawValues = Array.from(new Set([].concat(_toConsumableArray(mergedRawValue), [searchText])));
      triggerChange(newRawValues);
      newRawValues.forEach(function(newRawValue) {
        triggerSelect(newRawValue, true, "input");
      });
      setInnerSearchValue("");
    };
    useEffect2(function() {
      if (innerOpen && !!disabled) {
        setInnerOpen(false);
      }
    }, [disabled]);
    useEffect2(function() {
      if (!mergedOpen && !isMultiple && mode !== "combobox") {
        triggerSearch("", false, false);
      }
    }, [mergedOpen]);
    var _useLock = useLock(), _useLock2 = _slicedToArray$3(_useLock, 2), getClearLock = _useLock2[0], setClearLock = _useLock2[1];
    var onInternalKeyDown = function onInternalKeyDown2(event) {
      var clearLock = getClearLock();
      var which = event.which;
      if (which === KeyCode.ENTER) {
        if (mode !== "combobox") {
          event.preventDefault();
        }
        if (!mergedOpen) {
          onToggleOpen(true);
        }
      }
      setClearLock(!!mergedSearchValue);
      if (which === KeyCode.BACKSPACE && !clearLock && isMultiple && !mergedSearchValue && mergedRawValue.length) {
        var removeInfo = removeLastEnabledValue(displayValues, mergedRawValue);
        if (removeInfo.removedValue !== null) {
          triggerChange(removeInfo.values);
          triggerSelect(removeInfo.removedValue, false, "input");
        }
      }
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      if (mergedOpen && listRef.current) {
        var _listRef$current2;
        (_listRef$current2 = listRef.current).onKeyDown.apply(_listRef$current2, [event].concat(rest));
      }
      if (onKeyDown2) {
        onKeyDown2.apply(void 0, [event].concat(rest));
      }
    };
    var onInternalKeyUp = function onInternalKeyUp2(event) {
      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }
      if (mergedOpen && listRef.current) {
        var _listRef$current3;
        (_listRef$current3 = listRef.current).onKeyUp.apply(_listRef$current3, [event].concat(rest));
      }
      if (onKeyUp2) {
        onKeyUp2.apply(void 0, [event].concat(rest));
      }
    };
    var focusRef = useRef2(false);
    var onContainerFocus = function onContainerFocus2() {
      setMockFocused(true);
      if (!disabled) {
        if (onFocus2 && !focusRef.current) {
          onFocus2.apply(void 0, arguments);
        }
        if (showAction.includes("focus")) {
          onToggleOpen(true);
        }
      }
      focusRef.current = true;
    };
    var onContainerBlur = function onContainerBlur2() {
      setMockFocused(false, function() {
        focusRef.current = false;
        onToggleOpen(false);
      });
      if (disabled) {
        return;
      }
      if (mergedSearchValue) {
        if (mode === "tags") {
          triggerSearch("", false, false);
          triggerChange(Array.from(new Set([].concat(_toConsumableArray(mergedRawValue), [mergedSearchValue]))));
        } else if (mode === "multiple") {
          setInnerSearchValue("");
        }
      }
      if (onBlur2) {
        onBlur2.apply(void 0, arguments);
      }
    };
    var activeTimeoutIds = [];
    useEffect2(function() {
      return function() {
        activeTimeoutIds.forEach(function(timeoutId) {
          return clearTimeout(timeoutId);
        });
        activeTimeoutIds.splice(0, activeTimeoutIds.length);
      };
    }, []);
    var onInternalMouseDown = function onInternalMouseDown2(event) {
      var _triggerRef$current2;
      var target = event.target;
      var popupElement = (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getPopupElement();
      if (popupElement && popupElement.contains(target)) {
        var timeoutId = setTimeout(function() {
          var index2 = activeTimeoutIds.indexOf(timeoutId);
          if (index2 !== -1) {
            activeTimeoutIds.splice(index2, 1);
          }
          cancelSetMockFocused();
          if (!mobile && !popupElement.contains(document.activeElement)) {
            var _selectorRef$current3;
            (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 ? void 0 : _selectorRef$current3.focus();
          }
        });
        activeTimeoutIds.push(timeoutId);
      }
      if (onMouseDown) {
        for (var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          restArgs[_key3 - 1] = arguments[_key3];
        }
        onMouseDown.apply(void 0, [event].concat(restArgs));
      }
    };
    var _useState11 = useState2(0), _useState12 = _slicedToArray$3(_useState11, 2), accessibilityIndex = _useState12[0], setAccessibilityIndex = _useState12[1];
    var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== void 0 ? defaultActiveFirstOption : mode !== "combobox";
    var onActiveValue = function onActiveValue2(active, index2) {
      var _ref3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref3$source = _ref3.source, source = _ref3$source === void 0 ? "keyboard" : _ref3$source;
      setAccessibilityIndex(index2);
      if (backfill && mode === "combobox" && active !== null && source === "keyboard") {
        setActiveValue(String(active));
      }
    };
    var _useState13 = useState2(null), _useState14 = _slicedToArray$3(_useState13, 2), containerWidth = _useState14[0], setContainerWidth = _useState14[1];
    var _useState15 = useState2({}), _useState16 = _slicedToArray$3(_useState15, 2), forceUpdate = _useState16[1];
    function onPopupMouseEnter() {
      forceUpdate({});
    }
    useLayoutEffect$1(function() {
      if (triggerOpen) {
        var _containerRef$current;
        var newWidth = Math.ceil((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth);
        if (containerWidth !== newWidth && !Number.isNaN(newWidth)) {
          setContainerWidth(newWidth);
        }
      }
    }, [triggerOpen]);
    var popupNode = /* @__PURE__ */ React.createElement(OptionList4, {
      ref: listRef,
      prefixCls,
      id: mergedId,
      open: mergedOpen,
      childrenAsData: !options,
      options: displayOptions,
      flattenOptions: displayFlattenOptions,
      multiple: isMultiple,
      values: rawValues,
      height: listHeight,
      itemHeight: listItemHeight,
      onSelect: onInternalOptionSelect,
      onToggleOpen,
      onActiveValue,
      defaultActiveFirstOption: mergedDefaultActiveFirstOption,
      notFoundContent,
      onScroll: onPopupScroll,
      searchValue: mergedSearchValue,
      menuItemSelectedIcon,
      virtual: virtual !== false && dropdownMatchSelectWidth !== false,
      onMouseEnter: onPopupMouseEnter
    });
    var clearNode;
    var onClearMouseDown = function onClearMouseDown2() {
      if (useInternalProps && internalProps.onClear) {
        internalProps.onClear();
      }
      if (onClear) {
        onClear();
      }
      triggerChange([]);
      triggerSearch("", false, false);
    };
    if (!disabled && allowClear && (mergedRawValue.length || mergedSearchValue)) {
      clearNode = /* @__PURE__ */ React.createElement(TransBtn, {
        className: "".concat(prefixCls, "-clear"),
        onMouseDown: onClearMouseDown,
        customizeIcon: clearIcon
      }, "\xD7");
    }
    var mergedShowArrow = showArrow !== void 0 ? showArrow : loading || !isMultiple && mode !== "combobox";
    var arrowNode;
    if (mergedShowArrow) {
      arrowNode = /* @__PURE__ */ React.createElement(TransBtn, {
        className: cn("".concat(prefixCls, "-arrow"), _defineProperty$4({}, "".concat(prefixCls, "-arrow-loading"), loading)),
        customizeIcon: inputIcon,
        customizeIconProps: {
          loading,
          searchValue: mergedSearchValue,
          open: mergedOpen,
          focused: mockFocused,
          showSearch: mergedShowSearch
        }
      });
    }
    if (process.env.NODE_ENV !== "production" && warningProps2) {
      warningProps2(props);
    }
    var mergedClassName = cn(prefixCls, className, (_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-focused"), mockFocused), _defineProperty$4(_classNames2, "".concat(prefixCls, "-multiple"), isMultiple), _defineProperty$4(_classNames2, "".concat(prefixCls, "-single"), !isMultiple), _defineProperty$4(_classNames2, "".concat(prefixCls, "-allow-clear"), allowClear), _defineProperty$4(_classNames2, "".concat(prefixCls, "-show-arrow"), mergedShowArrow), _defineProperty$4(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _defineProperty$4(_classNames2, "".concat(prefixCls, "-loading"), loading), _defineProperty$4(_classNames2, "".concat(prefixCls, "-open"), mergedOpen), _defineProperty$4(_classNames2, "".concat(prefixCls, "-customize-input"), customizeInputElement), _defineProperty$4(_classNames2, "".concat(prefixCls, "-show-search"), mergedShowSearch), _classNames2));
    var selectorNode = /* @__PURE__ */ React.createElement(RefSelectTrigger, {
      ref: triggerRef,
      disabled,
      prefixCls,
      visible: triggerOpen,
      popupElement: popupNode,
      containerWidth,
      animation,
      transitionName: transitionName2,
      dropdownStyle,
      dropdownClassName,
      direction,
      dropdownMatchSelectWidth,
      dropdownRender,
      dropdownAlign,
      getPopupContainer,
      empty: !mergedOptions.length,
      getTriggerDOMNode: function getTriggerDOMNode() {
        return selectorDomRef.current;
      },
      onPopupVisibleChange: onTriggerVisibleChange
    }, customizeRawInputElement ? /* @__PURE__ */ React.cloneElement(customizeRawInputElement, {
      ref: composeRef(selectorDomRef, customizeRawInputElement.props.ref)
    }) : /* @__PURE__ */ React.createElement(ForwardSelector, _extends$2({}, props, {
      domRef: selectorDomRef,
      prefixCls,
      inputElement: customizeInputElement,
      ref: selectorRef,
      id: mergedId,
      showSearch: mergedShowSearch,
      mode,
      accessibilityIndex,
      multiple: isMultiple,
      tagRender,
      values: displayValues,
      open: mergedOpen,
      onToggleOpen,
      searchValue: mergedSearchValue,
      activeValue,
      onSearch: triggerSearch,
      onSearchSubmit,
      onSelect: onInternalSelectionSelect,
      tokenWithEnter
    })));
    if (customizeRawInputElement) {
      return selectorNode;
    }
    return /* @__PURE__ */ React.createElement("div", _extends$2({
      className: mergedClassName
    }, domProps, {
      ref: containerRef,
      onMouseDown: onInternalMouseDown,
      onKeyDown: onInternalKeyDown,
      onKeyUp: onInternalKeyUp,
      onFocus: onContainerFocus,
      onBlur: onContainerBlur
    }), mockFocused && !mergedOpen && /* @__PURE__ */ React.createElement("span", {
      style: {
        width: 0,
        height: 0,
        display: "flex",
        overflow: "hidden",
        opacity: 0
      },
      "aria-live": "polite"
    }, "".concat(mergedRawValue.join(", "))), selectorNode, arrowNode, clearNode);
  }
  var RefSelect2 = /* @__PURE__ */ React.forwardRef(Select2);
  return RefSelect2;
}
function warningProps$1(props) {
  var mode = props.mode, options = props.options, children = props.children, backfill = props.backfill, allowClear = props.allowClear, placeholder = props.placeholder, getInputElement = props.getInputElement, showSearch = props.showSearch, onSearch = props.onSearch, defaultOpen = props.defaultOpen, autoFocus = props.autoFocus, labelInValue = props.labelInValue, value = props.value, inputValue = props.inputValue, optionLabelProp = props.optionLabelProp;
  var multiple = mode === "multiple" || mode === "tags";
  var mergedShowSearch = showSearch !== void 0 ? showSearch : multiple || mode === "combobox";
  var mergedOptions = options || convertChildrenToData$1(children);
  warningOnce(mode !== "tags" || mergedOptions.every(function(opt) {
    return !opt.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag.");
  if (mode === "tags" || mode === "combobox") {
    var hasNumberValue = mergedOptions.some(function(item) {
      if (item.options) {
        return item.options.some(function(opt) {
          return typeof ("value" in opt ? opt.value : opt.key) === "number";
        });
      }
      return typeof ("value" in item ? item.value : item.key) === "number";
    });
    warningOnce(!hasNumberValue, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  warningOnce(mode !== "combobox" || !optionLabelProp, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.");
  warningOnce(mode === "combobox" || !backfill, "`backfill` only works with `combobox` mode.");
  warningOnce(mode === "combobox" || !getInputElement, "`getInputElement` only work with `combobox` mode.");
  noteOnce(mode !== "combobox" || !getInputElement || !allowClear || !placeholder, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.");
  if (onSearch && !mergedShowSearch && mode !== "combobox" && mode !== "tags") {
    warningOnce(false, "`onSearch` should work with `showSearch` instead of use alone.");
  }
  noteOnce(!defaultOpen || autoFocus, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.");
  if (value !== void 0 && value !== null) {
    var values = toArray$6(value);
    warningOnce(!labelInValue || values.every(function(val) {
      return _typeof$5(val) === "object" && ("key" in val || "value" in val);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`");
    warningOnce(!multiple || Array.isArray(value), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (children) {
    var invalidateChildType = null;
    toArray$8(children).some(function(node) {
      if (!/* @__PURE__ */ React.isValidElement(node) || !node.type) {
        return false;
      }
      var type2 = node.type;
      if (type2.isSelectOption) {
        return false;
      }
      if (type2.isSelectOptGroup) {
        var allChildrenValid = toArray$8(node.props.children).every(function(subNode) {
          if (!/* @__PURE__ */ React.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) {
            return true;
          }
          invalidateChildType = subNode.type;
          return false;
        });
        if (allChildrenValid) {
          return false;
        }
        return true;
      }
      invalidateChildType = type2;
      return true;
    });
    if (invalidateChildType) {
      warningOnce(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
    }
    warningOnce(inputValue === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
var RefSelect$1 = generateSelector({
  prefixCls: "rc-select",
  components: {
    optionList: RefOptionList$1
  },
  convertChildrenToData: convertChildrenToData$1,
  flattenOptions: flattenOptions$1,
  getLabeledValue,
  filterOptions: filterOptions$1,
  isValueDisabled: isValueDisabled$1,
  findValueOption: findValueOption$1,
  warningProps: warningProps$1,
  fillOptionsWithMissingValue
});
var Select$3 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Select2, _React$Component);
  var _super = _createSuper$1(Select2);
  function Select2() {
    var _this2;
    _classCallCheck$2(this, Select2);
    _this2 = _super.apply(this, arguments);
    _this2.selectRef = /* @__PURE__ */ React.createRef();
    _this2.focus = function() {
      _this2.selectRef.current.focus();
    };
    _this2.blur = function() {
      _this2.selectRef.current.blur();
    };
    return _this2;
  }
  _createClass$2(Select2, [{
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(RefSelect$1, _extends$2({
        ref: this.selectRef
      }, this.props));
    }
  }]);
  return Select2;
}(React.Component);
Select$3.Option = Option$3;
Select$3.OptGroup = OptGroup;
var DownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, "name": "down", "theme": "outlined" };
var DownOutlined = function DownOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: DownOutlined$2
  }));
};
DownOutlined.displayName = "DownOutlined";
var DownOutlined$1 = /* @__PURE__ */ React.forwardRef(DownOutlined);
var CheckOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, "name": "check", "theme": "outlined" };
var CheckOutlined = function CheckOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: CheckOutlined$2
  }));
};
CheckOutlined.displayName = "CheckOutlined";
var CheckOutlined$1 = /* @__PURE__ */ React.forwardRef(CheckOutlined);
var SearchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, "name": "search", "theme": "outlined" };
var SearchOutlined = function SearchOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: SearchOutlined$2
  }));
};
SearchOutlined.displayName = "SearchOutlined";
var SearchOutlined$1 = /* @__PURE__ */ React.forwardRef(SearchOutlined);
function getIcons(_ref) {
  var suffixIcon = _ref.suffixIcon, clearIcon = _ref.clearIcon, menuItemSelectedIcon = _ref.menuItemSelectedIcon, removeIcon = _ref.removeIcon, loading = _ref.loading, multiple = _ref.multiple, prefixCls = _ref.prefixCls;
  var mergedClearIcon = clearIcon;
  if (!clearIcon) {
    mergedClearIcon = /* @__PURE__ */ React.createElement(CloseCircleFilled$1, null);
  }
  var mergedSuffixIcon = null;
  if (suffixIcon !== void 0) {
    mergedSuffixIcon = suffixIcon;
  } else if (loading) {
    mergedSuffixIcon = /* @__PURE__ */ React.createElement(LoadingOutlined$1, {
      spin: true
    });
  } else {
    var iconCls = "".concat(prefixCls, "-suffix");
    mergedSuffixIcon = function mergedSuffixIcon2(_ref2) {
      var open = _ref2.open, showSearch = _ref2.showSearch;
      if (open && showSearch) {
        return /* @__PURE__ */ React.createElement(SearchOutlined$1, {
          className: iconCls
        });
      }
      return /* @__PURE__ */ React.createElement(DownOutlined$1, {
        className: iconCls
      });
    };
  }
  var mergedItemIcon = null;
  if (menuItemSelectedIcon !== void 0) {
    mergedItemIcon = menuItemSelectedIcon;
  } else if (multiple) {
    mergedItemIcon = /* @__PURE__ */ React.createElement(CheckOutlined$1, null);
  } else {
    mergedItemIcon = null;
  }
  var mergedRemoveIcon = null;
  if (removeIcon !== void 0) {
    mergedRemoveIcon = removeIcon;
  } else {
    mergedRemoveIcon = /* @__PURE__ */ React.createElement(CloseOutlined$1, null);
  }
  return {
    clearIcon: mergedClearIcon,
    suffixIcon: mergedSuffixIcon,
    itemIcon: mergedItemIcon,
    removeIcon: mergedRemoveIcon
  };
}
var getCollapsedHeight = function getCollapsedHeight2() {
  return {
    height: 0,
    opacity: 0
  };
};
var getRealHeight = function getRealHeight2(node) {
  return {
    height: node.scrollHeight,
    opacity: 1
  };
};
var getCurrentHeight = function getCurrentHeight2(node) {
  return {
    height: node.offsetHeight
  };
};
var skipOpacityTransition = function skipOpacityTransition2(_2, event) {
  return event.propertyName === "height";
};
var collapseMotion = {
  motionName: "ant-motion-collapse",
  onAppearStart: getCollapsedHeight,
  onEnterStart: getCollapsedHeight,
  onAppearActive: getRealHeight,
  onEnterActive: getRealHeight,
  onLeaveStart: getCurrentHeight,
  onLeaveActive: getCollapsedHeight,
  onAppearEnd: skipOpacityTransition,
  onEnterEnd: skipOpacityTransition,
  onLeaveEnd: skipOpacityTransition,
  motionDeadline: 500
};
var getTransitionName = function getTransitionName2(rootPrefixCls, motion, transitionName2) {
  if (transitionName2 !== void 0) {
    return transitionName2;
  }
  return "".concat(rootPrefixCls, "-").concat(motion);
};
var __rest$L = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var SECRET_COMBOBOX_MODE_DO_NOT_USE = "SECRET_COMBOBOX_MODE_DO_NOT_USE";
var InternalSelect = function InternalSelect2(_a, ref) {
  var _classNames2;
  var customizePrefixCls = _a.prefixCls, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? true : _a$bordered, className = _a.className, getPopupContainer = _a.getPopupContainer, dropdownClassName = _a.dropdownClassName, _a$listHeight = _a.listHeight, listHeight = _a$listHeight === void 0 ? 256 : _a$listHeight, _a$listItemHeight = _a.listItemHeight, listItemHeight = _a$listItemHeight === void 0 ? 24 : _a$listItemHeight, customizeSize = _a.size, notFoundContent = _a.notFoundContent, props = __rest$L(_a, ["prefixCls", "bordered", "className", "getPopupContainer", "dropdownClassName", "listHeight", "listItemHeight", "size", "notFoundContent"]);
  var _React$useContext = React.useContext(ConfigContext), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, renderEmpty3 = _React$useContext.renderEmpty, direction = _React$useContext.direction, virtual = _React$useContext.virtual, dropdownMatchSelectWidth = _React$useContext.dropdownMatchSelectWidth;
  var size = React.useContext(SizeContext$1);
  var prefixCls = getPrefixCls("select", customizePrefixCls);
  var rootPrefixCls = getPrefixCls();
  var mode = React.useMemo(function() {
    var m2 = props.mode;
    if (m2 === "combobox") {
      return void 0;
    }
    if (m2 === SECRET_COMBOBOX_MODE_DO_NOT_USE) {
      return "combobox";
    }
    return m2;
  }, [props.mode]);
  var isMultiple = mode === "multiple" || mode === "tags";
  var mergedNotFound;
  if (notFoundContent !== void 0) {
    mergedNotFound = notFoundContent;
  } else if (mode === "combobox") {
    mergedNotFound = null;
  } else {
    mergedNotFound = renderEmpty3("Select");
  }
  var _getIcons = getIcons(_extends$2(_extends$2({}, props), {
    multiple: isMultiple,
    prefixCls
  })), suffixIcon = _getIcons.suffixIcon, itemIcon = _getIcons.itemIcon, removeIcon = _getIcons.removeIcon, clearIcon = _getIcons.clearIcon;
  var selectProps = omit$1(props, ["suffixIcon", "itemIcon"]);
  var rcSelectRtlDropDownClassName = cn(dropdownClassName, _defineProperty$4({}, "".concat(prefixCls, "-dropdown-").concat(direction), direction === "rtl"));
  var mergedSize = customizeSize || size;
  var mergedClassName = cn((_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-lg"), mergedSize === "large"), _defineProperty$4(_classNames2, "".concat(prefixCls, "-sm"), mergedSize === "small"), _defineProperty$4(_classNames2, "".concat(prefixCls, "-rtl"), direction === "rtl"), _defineProperty$4(_classNames2, "".concat(prefixCls, "-borderless"), !bordered), _classNames2), className);
  return /* @__PURE__ */ React.createElement(Select$3, _extends$2({
    ref,
    virtual,
    dropdownMatchSelectWidth
  }, selectProps, {
    transitionName: getTransitionName(rootPrefixCls, "slide-up", props.transitionName),
    listHeight,
    listItemHeight,
    mode,
    prefixCls,
    direction,
    inputIcon: suffixIcon,
    menuItemSelectedIcon: itemIcon,
    removeIcon,
    clearIcon,
    notFoundContent: mergedNotFound,
    className: mergedClassName,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    dropdownClassName: rcSelectRtlDropDownClassName
  }));
};
var SelectRef = /* @__PURE__ */ React.forwardRef(InternalSelect);
var Select$2 = SelectRef;
Select$2.SECRET_COMBOBOX_MODE_DO_NOT_USE = SECRET_COMBOBOX_MODE_DO_NOT_USE;
Select$2.Option = Option$3;
Select$2.OptGroup = OptGroup;
var isValidElement2 = React.isValidElement;
function replaceElement(element, replacement, props) {
  if (!isValidElement2(element))
    return replacement;
  return /* @__PURE__ */ React.cloneElement(element, typeof props === "function" ? props(element.props || {}) : props);
}
function cloneElement2(element, props) {
  return replaceElement(element, element, props);
}
var Option$2 = Select$2.Option;
function isSelectOptionOrSelectOptGroup(child) {
  return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
}
var AutoComplete = function AutoComplete2(props, ref) {
  var customizePrefixCls = props.prefixCls, className = props.className, children = props.children, dataSource = props.dataSource;
  var childNodes = toArray$8(children);
  var customizeInput;
  if (childNodes.length === 1 && isValidElement2(childNodes[0]) && !isSelectOptionOrSelectOptGroup(childNodes[0])) {
    var _childNodes = _slicedToArray$3(childNodes, 1);
    customizeInput = _childNodes[0];
  }
  var getInputElement = customizeInput ? function() {
    return customizeInput;
  } : void 0;
  var optionChildren;
  if (childNodes.length && isSelectOptionOrSelectOptGroup(childNodes[0])) {
    optionChildren = children;
  } else {
    optionChildren = dataSource ? dataSource.map(function(item) {
      if (isValidElement2(item)) {
        return item;
      }
      switch (_typeof$5(item)) {
        case "string":
          return /* @__PURE__ */ React.createElement(Option$2, {
            key: item,
            value: item
          }, item);
        case "object": {
          var optionValue = item.value;
          return /* @__PURE__ */ React.createElement(Option$2, {
            key: optionValue,
            value: optionValue
          }, item.text);
        }
        default:
          throw new Error("AutoComplete[dataSource] only supports type `string[] | Object[]`.");
      }
    }) : [];
  }
  React.useEffect(function() {
    devWarning(!("dataSource" in props), "AutoComplete", "`dataSource` is deprecated, please use `options` instead.");
    devWarning(!customizeInput || !("size" in props), "AutoComplete", "You need to control style self instead of setting `size` when using customize input.");
  }, []);
  return /* @__PURE__ */ React.createElement(ConfigConsumer, null, function(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var prefixCls = getPrefixCls("select", customizePrefixCls);
    return /* @__PURE__ */ React.createElement(Select$2, _extends$2({
      ref
    }, omit$1(props, ["dataSource"]), {
      prefixCls,
      className: cn("".concat(prefixCls, "-auto-complete"), className),
      mode: Select$2.SECRET_COMBOBOX_MODE_DO_NOT_USE,
      getInputElement
    }), optionChildren);
  });
};
var RefAutoComplete = /* @__PURE__ */ React.forwardRef(AutoComplete);
RefAutoComplete.Option = Option$2;
var responsiveArray = ["xxl", "xl", "lg", "md", "sm", "xs"];
var responsiveMap = {
  xs: "(max-width: 575px)",
  sm: "(min-width: 576px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 992px)",
  xl: "(min-width: 1200px)",
  xxl: "(min-width: 1600px)"
};
var subscribers = /* @__PURE__ */ new Map();
var subUid = -1;
var screens = {};
var responsiveObserve = {
  matchHandlers: {},
  dispatch: function dispatch(pointMap) {
    screens = pointMap;
    subscribers.forEach(function(func) {
      return func(screens);
    });
    return subscribers.size >= 1;
  },
  subscribe: function subscribe(func) {
    if (!subscribers.size)
      this.register();
    subUid += 1;
    subscribers.set(subUid, func);
    func(screens);
    return subUid;
  },
  unsubscribe: function unsubscribe(token) {
    subscribers["delete"](token);
    if (!subscribers.size)
      this.unregister();
  },
  unregister: function unregister() {
    var _this2 = this;
    Object.keys(responsiveMap).forEach(function(screen) {
      var matchMediaQuery = responsiveMap[screen];
      var handler = _this2.matchHandlers[matchMediaQuery];
      handler === null || handler === void 0 ? void 0 : handler.mql.removeListener(handler === null || handler === void 0 ? void 0 : handler.listener);
    });
    subscribers.clear();
  },
  register: function register2() {
    var _this2 = this;
    Object.keys(responsiveMap).forEach(function(screen) {
      var matchMediaQuery = responsiveMap[screen];
      var listener = function listener2(_ref) {
        var matches = _ref.matches;
        _this2.dispatch(_extends$2(_extends$2({}, screens), _defineProperty$4({}, screen, matches)));
      };
      var mql = window.matchMedia(matchMediaQuery);
      mql.addListener(listener);
      _this2.matchHandlers[matchMediaQuery] = {
        mql,
        listener
      };
      listener(mql);
    });
  }
};
function useBreakpoint() {
  var _useState = useState2({}), _useState2 = _slicedToArray$3(_useState, 2), screens2 = _useState2[0], setScreens = _useState2[1];
  useEffect2(function() {
    var token = responsiveObserve.subscribe(function(supportScreens) {
      setScreens(supportScreens);
    });
    return function() {
      return responsiveObserve.unsubscribe(token);
    };
  }, []);
  return screens2;
}
var SizeContext = /* @__PURE__ */ React.createContext("default");
var SizeContextProvider2 = function SizeContextProvider3(_ref) {
  var children = _ref.children, size = _ref.size;
  return /* @__PURE__ */ React.createElement(SizeContext.Consumer, null, function(originSize) {
    return /* @__PURE__ */ React.createElement(SizeContext.Provider, {
      value: size || originSize
    }, children);
  });
};
var __rest$K = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var InternalAvatar = function InternalAvatar2(props, ref) {
  var _classNames, _classNames2;
  var groupSize = React.useContext(SizeContext);
  var _React$useState = React.useState(1), _React$useState2 = _slicedToArray$3(_React$useState, 2), scale = _React$useState2[0], setScale = _React$useState2[1];
  var _React$useState3 = React.useState(false), _React$useState4 = _slicedToArray$3(_React$useState3, 2), mounted = _React$useState4[0], setMounted = _React$useState4[1];
  var _React$useState5 = React.useState(true), _React$useState6 = _slicedToArray$3(_React$useState5, 2), isImgExist = _React$useState6[0], setIsImgExist = _React$useState6[1];
  var avatarNodeRef = React.useRef();
  var avatarChildrenRef = React.useRef();
  var avatarNodeMergeRef = composeRef(ref, avatarNodeRef);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
  var setScaleParam = function setScaleParam2() {
    if (!avatarChildrenRef.current || !avatarNodeRef.current) {
      return;
    }
    var childrenWidth = avatarChildrenRef.current.offsetWidth;
    var nodeWidth = avatarNodeRef.current.offsetWidth;
    if (childrenWidth !== 0 && nodeWidth !== 0) {
      var _props$gap = props.gap, gap = _props$gap === void 0 ? 4 : _props$gap;
      if (gap * 2 < nodeWidth) {
        setScale(nodeWidth - gap * 2 < childrenWidth ? (nodeWidth - gap * 2) / childrenWidth : 1);
      }
    }
  };
  React.useEffect(function() {
    setMounted(true);
  }, []);
  React.useEffect(function() {
    setIsImgExist(true);
    setScale(1);
  }, [props.src]);
  React.useEffect(function() {
    setScaleParam();
  }, [props.gap]);
  var handleImgLoadError = function handleImgLoadError2() {
    var onError = props.onError;
    var errorFlag = onError ? onError() : void 0;
    if (errorFlag !== false) {
      setIsImgExist(false);
    }
  };
  var customizePrefixCls = props.prefixCls, shape = props.shape, customSize = props.size, src = props.src, srcSet = props.srcSet, icon = props.icon, className = props.className, alt = props.alt, draggable = props.draggable, children = props.children, others = __rest$K(props, ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "alt", "draggable", "children"]);
  var size = customSize === "default" ? groupSize : customSize;
  var screens2 = useBreakpoint();
  var responsiveSizeStyle = React.useMemo(function() {
    if (_typeof$5(size) !== "object") {
      return {};
    }
    var currentBreakpoint = responsiveArray.find(function(screen) {
      return screens2[screen];
    });
    var currentSize = size[currentBreakpoint];
    return currentSize ? {
      width: currentSize,
      height: currentSize,
      lineHeight: "".concat(currentSize, "px"),
      fontSize: icon ? currentSize / 2 : 18
    } : {};
  }, [screens2, size]);
  devWarning(!(typeof icon === "string" && icon.length > 2), "Avatar", "`icon` is using ReactNode instead of string naming in v4. Please check `".concat(icon, "` at https://ant.design/components/icon"));
  var prefixCls = getPrefixCls("avatar", customizePrefixCls);
  var sizeCls = cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-lg"), size === "large"), _defineProperty$4(_classNames, "".concat(prefixCls, "-sm"), size === "small"), _classNames));
  var hasImageElement = /* @__PURE__ */ React.isValidElement(src);
  var classString = cn(prefixCls, sizeCls, (_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-").concat(shape), !!shape), _defineProperty$4(_classNames2, "".concat(prefixCls, "-image"), hasImageElement || src && isImgExist), _defineProperty$4(_classNames2, "".concat(prefixCls, "-icon"), !!icon), _classNames2), className);
  var sizeStyle = typeof size === "number" ? {
    width: size,
    height: size,
    lineHeight: "".concat(size, "px"),
    fontSize: icon ? size / 2 : 18
  } : {};
  var childrenToRender;
  if (typeof src === "string" && isImgExist) {
    childrenToRender = /* @__PURE__ */ React.createElement("img", {
      src,
      draggable,
      srcSet,
      onError: handleImgLoadError,
      alt
    });
  } else if (hasImageElement) {
    childrenToRender = src;
  } else if (icon) {
    childrenToRender = icon;
  } else if (mounted || scale !== 1) {
    var transformString = "scale(".concat(scale, ") translateX(-50%)");
    var childrenStyle = {
      msTransform: transformString,
      WebkitTransform: transformString,
      transform: transformString
    };
    var sizeChildrenStyle = typeof size === "number" ? {
      lineHeight: "".concat(size, "px")
    } : {};
    childrenToRender = /* @__PURE__ */ React.createElement(ResizeObserver, {
      onResize: setScaleParam
    }, /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-string"),
      ref: function ref2(node) {
        avatarChildrenRef.current = node;
      },
      style: _extends$2(_extends$2({}, sizeChildrenStyle), childrenStyle)
    }, children));
  } else {
    childrenToRender = /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-string"),
      style: {
        opacity: 0
      },
      ref: function ref2(node) {
        avatarChildrenRef.current = node;
      }
    }, children);
  }
  delete others.onError;
  delete others.gap;
  return /* @__PURE__ */ React.createElement("span", _extends$2({}, others, {
    style: _extends$2(_extends$2(_extends$2({}, sizeStyle), responsiveSizeStyle), others.style),
    className: classString,
    ref: avatarNodeMergeRef
  }), childrenToRender);
};
var Avatar$1 = /* @__PURE__ */ React.forwardRef(InternalAvatar);
Avatar$1.displayName = "Avatar";
Avatar$1.defaultProps = {
  shape: "circle",
  size: "default"
};
var autoAdjustOverflow$2 = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset$2 = [0, 0];
var placements$2 = {
  left: {
    points: ["cr", "cl"],
    overflow: autoAdjustOverflow$2,
    offset: [-4, 0],
    targetOffset: targetOffset$2
  },
  right: {
    points: ["cl", "cr"],
    overflow: autoAdjustOverflow$2,
    offset: [4, 0],
    targetOffset: targetOffset$2
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflow$2,
    offset: [0, -4],
    targetOffset: targetOffset$2
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflow$2,
    offset: [0, 4],
    targetOffset: targetOffset$2
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow$2,
    offset: [0, -4],
    targetOffset: targetOffset$2
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow$2,
    offset: [-4, 0],
    targetOffset: targetOffset$2
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow$2,
    offset: [0, -4],
    targetOffset: targetOffset$2
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow$2,
    offset: [4, 0],
    targetOffset: targetOffset$2
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow$2,
    offset: [0, 4],
    targetOffset: targetOffset$2
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflow$2,
    offset: [4, 0],
    targetOffset: targetOffset$2
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow$2,
    offset: [0, 4],
    targetOffset: targetOffset$2
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflow$2,
    offset: [-4, 0],
    targetOffset: targetOffset$2
  }
};
var Content$4 = function Content(props) {
  var overlay = props.overlay, prefixCls = props.prefixCls, id2 = props.id, overlayInnerStyle = props.overlayInnerStyle;
  return /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-inner"),
    id: id2,
    role: "tooltip",
    style: overlayInnerStyle
  }, typeof overlay === "function" ? overlay() : overlay);
};
var Tooltip$1 = function Tooltip(props, ref) {
  var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? ["hover"] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tooltip" : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange2 = props.afterVisibleChange, transitionName2 = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? "right" : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, restProps = _objectWithoutProperties$1(props, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle"]);
  var domRef = useRef2(null);
  useImperativeHandle2(ref, function() {
    return domRef.current;
  });
  var extraProps = _objectSpread2$1({}, restProps);
  if ("visible" in props) {
    extraProps.popupVisible = props.visible;
  }
  var getPopupElement = function getPopupElement2() {
    var _props$arrowContent = props.arrowContent, arrowContent = _props$arrowContent === void 0 ? null : _props$arrowContent, overlay = props.overlay, id2 = props.id;
    return [/* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-arrow"),
      key: "arrow"
    }, arrowContent), /* @__PURE__ */ React.createElement(Content$4, {
      key: "content",
      prefixCls,
      id: id2,
      overlay,
      overlayInnerStyle
    })];
  };
  var destroyTooltip = false;
  var autoDestroy = false;
  if (typeof destroyTooltipOnHide === "boolean") {
    destroyTooltip = destroyTooltipOnHide;
  } else if (destroyTooltipOnHide && _typeof$5(destroyTooltipOnHide) === "object") {
    var keepParent = destroyTooltipOnHide.keepParent;
    destroyTooltip = keepParent === true;
    autoDestroy = keepParent === false;
  }
  return /* @__PURE__ */ React.createElement(Trigger, _extends$2({
    popupClassName: overlayClassName,
    prefixCls,
    popup: getPopupElement,
    action: trigger,
    builtinPlacements: placements$2,
    popupPlacement: placement,
    ref: domRef,
    popupAlign: align,
    getPopupContainer: getTooltipContainer,
    onPopupVisibleChange: onVisibleChange,
    afterPopupVisibleChange: afterVisibleChange2,
    popupTransitionName: transitionName2,
    popupAnimation: animation,
    popupMotion: motion,
    defaultPopupVisible: defaultVisible,
    destroyPopupOnHide: destroyTooltip,
    autoDestroy,
    mouseLeaveDelay,
    popupStyle: overlayStyle,
    mouseEnterDelay
  }, extraProps), children);
};
var Tooltip$2 = /* @__PURE__ */ forwardRef2(Tooltip$1);
var autoAdjustOverflowEnabled = {
  adjustX: 1,
  adjustY: 1
};
var autoAdjustOverflowDisabled = {
  adjustX: 0,
  adjustY: 0
};
var targetOffset$1 = [0, 0];
function getOverflowOptions(autoAdjustOverflow2) {
  if (typeof autoAdjustOverflow2 === "boolean") {
    return autoAdjustOverflow2 ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
  }
  return _extends$2(_extends$2({}, autoAdjustOverflowDisabled), autoAdjustOverflow2);
}
function getPlacements(config) {
  var _config$arrowWidth = config.arrowWidth, arrowWidth = _config$arrowWidth === void 0 ? 5 : _config$arrowWidth, _config$horizontalArr = config.horizontalArrowShift, horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr, _config$verticalArrow = config.verticalArrowShift, verticalArrowShift = _config$verticalArrow === void 0 ? 8 : _config$verticalArrow, autoAdjustOverflow2 = config.autoAdjustOverflow;
  var placementMap = {
    left: {
      points: ["cr", "cl"],
      offset: [-4, 0]
    },
    right: {
      points: ["cl", "cr"],
      offset: [4, 0]
    },
    top: {
      points: ["bc", "tc"],
      offset: [0, -4]
    },
    bottom: {
      points: ["tc", "bc"],
      offset: [0, 4]
    },
    topLeft: {
      points: ["bl", "tc"],
      offset: [-(horizontalArrowShift + arrowWidth), -4]
    },
    leftTop: {
      points: ["tr", "cl"],
      offset: [-4, -(verticalArrowShift + arrowWidth)]
    },
    topRight: {
      points: ["br", "tc"],
      offset: [horizontalArrowShift + arrowWidth, -4]
    },
    rightTop: {
      points: ["tl", "cr"],
      offset: [4, -(verticalArrowShift + arrowWidth)]
    },
    bottomRight: {
      points: ["tr", "bc"],
      offset: [horizontalArrowShift + arrowWidth, 4]
    },
    rightBottom: {
      points: ["bl", "cr"],
      offset: [4, verticalArrowShift + arrowWidth]
    },
    bottomLeft: {
      points: ["tl", "bc"],
      offset: [-(horizontalArrowShift + arrowWidth), 4]
    },
    leftBottom: {
      points: ["br", "cl"],
      offset: [-4, verticalArrowShift + arrowWidth]
    }
  };
  Object.keys(placementMap).forEach(function(key2) {
    placementMap[key2] = config.arrowPointAtCenter ? _extends$2(_extends$2({}, placementMap[key2]), {
      overflow: getOverflowOptions(autoAdjustOverflow2),
      targetOffset: targetOffset$1
    }) : _extends$2(_extends$2({}, placements$2[key2]), {
      overflow: getOverflowOptions(autoAdjustOverflow2)
    });
    placementMap[key2].ignoreShake = true;
  });
  return placementMap;
}
var tuple$1 = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args;
};
var tupleNum = function tupleNum2() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return args;
};
var PresetStatusColorTypes = tuple$1("success", "processing", "error", "default", "warning");
var PresetColorTypes = tuple$1("pink", "red", "yellow", "orange", "cyan", "green", "blue", "purple", "geekblue", "magenta", "volcano", "gold", "lime");
var splitObject = function splitObject2(obj, keys2) {
  var picked = {};
  var omitted = _extends$2({}, obj);
  keys2.forEach(function(key2) {
    if (obj && key2 in obj) {
      picked[key2] = obj[key2];
      delete omitted[key2];
    }
  });
  return {
    picked,
    omitted
  };
};
var PresetColorRegex$1 = new RegExp("^(".concat(PresetColorTypes.join("|"), ")(-inverse)?$"));
function getDisabledCompatibleChildren(element, prefixCls) {
  var elementType = element.type;
  if ((elementType.__ANT_BUTTON === true || elementType.__ANT_SWITCH === true || elementType.__ANT_CHECKBOX === true || element.type === "button") && element.props.disabled) {
    var _splitObject = splitObject(element.props.style, ["position", "left", "right", "top", "bottom", "float", "display", "zIndex"]), picked = _splitObject.picked, omitted = _splitObject.omitted;
    var spanStyle = _extends$2(_extends$2({
      display: "inline-block"
    }, picked), {
      cursor: "not-allowed",
      width: element.props.block ? "100%" : null
    });
    var buttonStyle = _extends$2(_extends$2({}, omitted), {
      pointerEvents: "none"
    });
    var child = cloneElement2(element, {
      style: buttonStyle,
      className: null
    });
    return /* @__PURE__ */ React.createElement("span", {
      style: spanStyle,
      className: cn(element.props.className, "".concat(prefixCls, "-disabled-compatible-wrapper"))
    }, child);
  }
  return element;
}
var Tooltip2 = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var _classNames2;
  var _React$useContext = React.useContext(ConfigContext), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var _useMergedState = useMergedState(false, {
    value: props.visible,
    defaultValue: props.defaultVisible
  }), _useMergedState2 = _slicedToArray$3(_useMergedState, 2), visible = _useMergedState2[0], setVisible = _useMergedState2[1];
  var isNoTitle = function isNoTitle2() {
    var title = props.title, overlay = props.overlay;
    return !title && !overlay && title !== 0;
  };
  var onVisibleChange = function onVisibleChange2(vis) {
    var _a;
    setVisible(isNoTitle() ? false : vis);
    if (!isNoTitle()) {
      (_a = props.onVisibleChange) === null || _a === void 0 ? void 0 : _a.call(props, vis);
    }
  };
  var getTooltipPlacements = function getTooltipPlacements2() {
    var builtinPlacements = props.builtinPlacements, arrowPointAtCenter = props.arrowPointAtCenter, autoAdjustOverflow2 = props.autoAdjustOverflow;
    return builtinPlacements || getPlacements({
      arrowPointAtCenter,
      autoAdjustOverflow: autoAdjustOverflow2
    });
  };
  var onPopupAlign = function onPopupAlign2(domNode, align) {
    var placements2 = getTooltipPlacements();
    var placement = Object.keys(placements2).filter(function(key2) {
      return placements2[key2].points[0] === align.points[0] && placements2[key2].points[1] === align.points[1];
    })[0];
    if (!placement) {
      return;
    }
    var rect = domNode.getBoundingClientRect();
    var transformOrigin = {
      top: "50%",
      left: "50%"
    };
    if (placement.indexOf("top") >= 0 || placement.indexOf("Bottom") >= 0) {
      transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
    } else if (placement.indexOf("Top") >= 0 || placement.indexOf("bottom") >= 0) {
      transformOrigin.top = "".concat(-align.offset[1], "px");
    }
    if (placement.indexOf("left") >= 0 || placement.indexOf("Right") >= 0) {
      transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
    } else if (placement.indexOf("right") >= 0 || placement.indexOf("Left") >= 0) {
      transformOrigin.left = "".concat(-align.offset[0], "px");
    }
    domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
  };
  var getOverlay = function getOverlay2() {
    var title = props.title, overlay = props.overlay;
    if (title === 0) {
      return title;
    }
    return overlay || title || "";
  };
  var customizePrefixCls = props.prefixCls, openClassName = props.openClassName, getPopupContainer = props.getPopupContainer, getTooltipContainer = props.getTooltipContainer, overlayClassName = props.overlayClassName, color = props.color, overlayInnerStyle = props.overlayInnerStyle, children = props.children;
  var prefixCls = getPrefixCls("tooltip", customizePrefixCls);
  var rootPrefixCls = getPrefixCls();
  var tempVisible = visible;
  if (!("visible" in props) && isNoTitle()) {
    tempVisible = false;
  }
  var child = getDisabledCompatibleChildren(isValidElement2(children) ? children : /* @__PURE__ */ React.createElement("span", null, children), prefixCls);
  var childProps = child.props;
  var childCls = cn(childProps.className, _defineProperty$4({}, openClassName || "".concat(prefixCls, "-open"), true));
  var customOverlayClassName = cn(overlayClassName, (_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-rtl"), direction === "rtl"), _defineProperty$4(_classNames2, "".concat(prefixCls, "-").concat(color), color && PresetColorRegex$1.test(color)), _classNames2));
  var formattedOverlayInnerStyle = overlayInnerStyle;
  var arrowContentStyle;
  if (color && !PresetColorRegex$1.test(color)) {
    formattedOverlayInnerStyle = _extends$2(_extends$2({}, overlayInnerStyle), {
      background: color
    });
    arrowContentStyle = {
      background: color
    };
  }
  return /* @__PURE__ */ React.createElement(Tooltip$2, _extends$2({}, props, {
    prefixCls,
    overlayClassName: customOverlayClassName,
    getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
    ref,
    builtinPlacements: getTooltipPlacements(),
    overlay: getOverlay(),
    visible: tempVisible,
    onVisibleChange,
    onPopupAlign,
    overlayInnerStyle: formattedOverlayInnerStyle,
    arrowContent: /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-arrow-content"),
      style: arrowContentStyle
    }),
    motion: {
      motionName: getTransitionName(rootPrefixCls, "zoom-big-fast", props.transitionName),
      motionDeadline: 1e3
    }
  }), tempVisible ? cloneElement2(child, {
    className: childCls
  }) : child);
});
Tooltip2.displayName = "Tooltip";
Tooltip2.defaultProps = {
  placement: "top",
  mouseEnterDelay: 0.1,
  mouseLeaveDelay: 0.1,
  arrowPointAtCenter: false,
  autoAdjustOverflow: true
};
var getRenderPropValue = function getRenderPropValue2(propValue) {
  if (!propValue) {
    return null;
  }
  var isRenderFunction = typeof propValue === "function";
  if (isRenderFunction) {
    return propValue();
  }
  return propValue;
};
var __rest$J = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var Popover = /* @__PURE__ */ React.forwardRef(function(_a, ref) {
  var customizePrefixCls = _a.prefixCls, title = _a.title, content = _a.content, otherProps = __rest$J(_a, ["prefixCls", "title", "content"]);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
  var getOverlay = function getOverlay2(prefixCls2) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, title && /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls2, "-title")
    }, getRenderPropValue(title)), /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls2, "-inner-content")
    }, getRenderPropValue(content)));
  };
  var prefixCls = getPrefixCls("popover", customizePrefixCls);
  var rootPrefixCls = getPrefixCls();
  return /* @__PURE__ */ React.createElement(Tooltip2, _extends$2({}, otherProps, {
    prefixCls,
    ref,
    overlay: getOverlay(prefixCls),
    transitionName: getTransitionName(rootPrefixCls, "zoom-big", otherProps.transitionName)
  }));
});
Popover.displayName = "Popover";
Popover.defaultProps = {
  placement: "top",
  trigger: "hover",
  mouseEnterDelay: 0.1,
  mouseLeaveDelay: 0.1,
  overlayStyle: {}
};
var Group$3 = function Group(props) {
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, maxCount2 = props.maxCount, maxStyle = props.maxStyle, size = props.size;
  var prefixCls = getPrefixCls("avatar-group", customizePrefixCls);
  var cls = cn(prefixCls, _defineProperty$4({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), className);
  var children = props.children, _props$maxPopoverPlac = props.maxPopoverPlacement, maxPopoverPlacement = _props$maxPopoverPlac === void 0 ? "top" : _props$maxPopoverPlac;
  var childrenWithProps = toArray$8(children).map(function(child, index2) {
    return cloneElement2(child, {
      key: "avatar-key-".concat(index2)
    });
  });
  var numOfChildren = childrenWithProps.length;
  if (maxCount2 && maxCount2 < numOfChildren) {
    var childrenShow = childrenWithProps.slice(0, maxCount2);
    var childrenHidden = childrenWithProps.slice(maxCount2, numOfChildren);
    childrenShow.push(/* @__PURE__ */ React.createElement(Popover, {
      key: "avatar-popover-key",
      content: childrenHidden,
      trigger: "hover",
      placement: maxPopoverPlacement,
      overlayClassName: "".concat(prefixCls, "-popover")
    }, /* @__PURE__ */ React.createElement(Avatar$1, {
      style: maxStyle
    }, "+".concat(numOfChildren - maxCount2))));
    return /* @__PURE__ */ React.createElement(SizeContextProvider2, {
      size
    }, /* @__PURE__ */ React.createElement("div", {
      className: cls,
      style: props.style
    }, childrenShow));
  }
  return /* @__PURE__ */ React.createElement(SizeContextProvider2, {
    size
  }, /* @__PURE__ */ React.createElement("div", {
    className: cls,
    style: props.style
  }, childrenWithProps));
};
var Avatar = Avatar$1;
Avatar.Group = Group$3;
var VerticalAlignTopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z" } }] }, "name": "vertical-align-top", "theme": "outlined" };
var VerticalAlignTopOutlined = function VerticalAlignTopOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: VerticalAlignTopOutlined$2
  }));
};
VerticalAlignTopOutlined.displayName = "VerticalAlignTopOutlined";
var VerticalAlignTopOutlined$1 = /* @__PURE__ */ React.forwardRef(VerticalAlignTopOutlined);
var BackTop = function BackTop2(props) {
  var _useMergedState = useMergedState(false, {
    value: props.visible
  }), _useMergedState2 = _slicedToArray$3(_useMergedState, 2), visible = _useMergedState2[0], setVisible = _useMergedState2[1];
  var ref = /* @__PURE__ */ React.createRef();
  var scrollEvent = React.useRef();
  var getDefaultTarget2 = function getDefaultTarget3() {
    return ref.current && ref.current.ownerDocument ? ref.current.ownerDocument : window;
  };
  var handleScroll = throttleByAnimationFrame(function(e3) {
    var visibilityHeight = props.visibilityHeight;
    var scrollTop = getScroll$4(e3.target, true);
    setVisible(scrollTop > visibilityHeight);
  });
  var bindScrollEvent = function bindScrollEvent2() {
    var target = props.target;
    var getTarget = target || getDefaultTarget2;
    var container = getTarget();
    scrollEvent.current = addEventListenerWrap(container, "scroll", function(e3) {
      handleScroll(e3);
    });
    handleScroll({
      target: container
    });
  };
  React.useEffect(function() {
    bindScrollEvent();
    return function() {
      if (scrollEvent.current) {
        scrollEvent.current.remove();
      }
      handleScroll.cancel();
    };
  }, [props.target]);
  var scrollToTop = function scrollToTop2(e3) {
    var onClick = props.onClick, target = props.target, _props$duration = props.duration, duration = _props$duration === void 0 ? 450 : _props$duration;
    scrollTo$1(0, {
      getContainer: target || getDefaultTarget2,
      duration
    });
    if (typeof onClick === "function") {
      onClick(e3);
    }
  };
  var renderChildren = function renderChildren2(_ref) {
    var prefixCls2 = _ref.prefixCls, rootPrefixCls2 = _ref.rootPrefixCls;
    var children = props.children;
    var defaultElement = /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls2, "-content")
    }, /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls2, "-icon")
    }, /* @__PURE__ */ React.createElement(VerticalAlignTopOutlined$1, null)));
    return /* @__PURE__ */ React.createElement(CSSMotion, {
      visible,
      motionName: "".concat(rootPrefixCls2, "-fade"),
      removeOnLeave: true
    }, function(_ref2) {
      var motionClassName = _ref2.className;
      var childNode = children || defaultElement;
      return /* @__PURE__ */ React.createElement("div", null, cloneElement2(childNode, function(_ref3) {
        var className2 = _ref3.className;
        return {
          className: cn(motionClassName, className2)
        };
      }));
    });
  };
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className;
  var prefixCls = getPrefixCls("back-top", customizePrefixCls);
  var rootPrefixCls = getPrefixCls();
  var classString = cn(prefixCls, _defineProperty$4({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), className);
  var divProps = omit$1(props, ["prefixCls", "className", "children", "visibilityHeight", "target", "visible"]);
  return /* @__PURE__ */ React.createElement("div", _extends$2({}, divProps, {
    className: classString,
    onClick: scrollToTop,
    ref
  }), renderChildren({
    prefixCls,
    rootPrefixCls
  }));
};
BackTop.defaultProps = {
  visibilityHeight: 400
};
var autoAdjustOverflow$1 = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements$1 = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  topCenter: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  },
  bottomCenter: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  }
};
var _excluded$2 = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger"];
function Dropdown$3(props, ref) {
  var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-dropdown" : _props$prefixCls, transitionName2 = props.transitionName, animation = props.animation, align = props.align, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottomLeft" : _props$placement, _props$placements = props.placements, placements2 = _props$placements === void 0 ? placements$1 : _props$placements, getPopupContainer = props.getPopupContainer, showAction = props.showAction, hideAction = props.hideAction, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, visible = props.visible, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? ["hover"] : _props$trigger, otherProps = _objectWithoutProperties$1(props, _excluded$2);
  var _React$useState = React.useState(), _React$useState2 = _slicedToArray$3(_React$useState, 2), triggerVisible = _React$useState2[0], setTriggerVisible = _React$useState2[1];
  var mergedVisible = "visible" in props ? visible : triggerVisible;
  var triggerRef = React.useRef(null);
  React.useImperativeHandle(ref, function() {
    return triggerRef.current;
  });
  var getOverlayElement = function getOverlayElement2() {
    var overlay = props.overlay;
    var overlayElement;
    if (typeof overlay === "function") {
      overlayElement = overlay();
    } else {
      overlayElement = overlay;
    }
    return overlayElement;
  };
  var onClick = function onClick2(e3) {
    var onOverlayClick = props.onOverlayClick;
    var overlayProps = getOverlayElement().props;
    setTriggerVisible(false);
    if (onOverlayClick) {
      onOverlayClick(e3);
    }
    if (overlayProps.onClick) {
      overlayProps.onClick(e3);
    }
  };
  var onVisibleChange = function onVisibleChange2(newVisible) {
    var onVisibleChangeProp = props.onVisibleChange;
    setTriggerVisible(newVisible);
    if (typeof onVisibleChangeProp === "function") {
      onVisibleChangeProp(newVisible);
    }
  };
  var getMenuElement = function getMenuElement2() {
    var overlayElement = getOverlayElement();
    var extraOverlayProps = {
      prefixCls: "".concat(prefixCls, "-menu"),
      onClick
    };
    if (typeof overlayElement.type === "string") {
      delete extraOverlayProps.prefixCls;
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, arrow && /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-arrow")
    }), /* @__PURE__ */ React.cloneElement(overlayElement, extraOverlayProps));
  };
  var getMenuElementOrLambda = function getMenuElementOrLambda2() {
    var overlay = props.overlay;
    if (typeof overlay === "function") {
      return getMenuElement;
    }
    return getMenuElement();
  };
  var getMinOverlayWidthMatchTrigger = function getMinOverlayWidthMatchTrigger2() {
    var minOverlayWidthMatchTrigger = props.minOverlayWidthMatchTrigger, alignPoint2 = props.alignPoint;
    if ("minOverlayWidthMatchTrigger" in props) {
      return minOverlayWidthMatchTrigger;
    }
    return !alignPoint2;
  };
  var getOpenClassName = function getOpenClassName2() {
    var openClassName = props.openClassName;
    if (openClassName !== void 0) {
      return openClassName;
    }
    return "".concat(prefixCls, "-open");
  };
  var renderChildren = function renderChildren2() {
    var children = props.children;
    var childrenProps = children.props ? children.props : {};
    var childClassName = cn(childrenProps.className, getOpenClassName());
    return mergedVisible && children ? /* @__PURE__ */ React.cloneElement(children, {
      className: childClassName
    }) : children;
  };
  var triggerHideAction = hideAction;
  if (!triggerHideAction && trigger.indexOf("contextMenu") !== -1) {
    triggerHideAction = ["click"];
  }
  return /* @__PURE__ */ React.createElement(Trigger, _objectSpread2$1(_objectSpread2$1({
    builtinPlacements: placements2
  }, otherProps), {}, {
    prefixCls,
    ref: triggerRef,
    popupClassName: cn(overlayClassName, _defineProperty$4({}, "".concat(prefixCls, "-show-arrow"), arrow)),
    popupStyle: overlayStyle,
    action: trigger,
    showAction,
    hideAction: triggerHideAction || [],
    popupPlacement: placement,
    popupAlign: align,
    popupTransitionName: transitionName2,
    popupAnimation: animation,
    popupVisible: mergedVisible,
    stretch: getMinOverlayWidthMatchTrigger() ? "minWidth" : "",
    popup: getMenuElementOrLambda(),
    onPopupVisibleChange: onVisibleChange,
    getPopupContainer
  }), renderChildren());
}
var Dropdown$4 = /* @__PURE__ */ React.forwardRef(Dropdown$3);
var RightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };
var RightOutlined = function RightOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: RightOutlined$2
  }));
};
RightOutlined.displayName = "RightOutlined";
var RightOutlined$1 = /* @__PURE__ */ React.forwardRef(RightOutlined);
var EllipsisOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "ellipsis", "theme": "outlined" };
var EllipsisOutlined = function EllipsisOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: EllipsisOutlined$2
  }));
};
EllipsisOutlined.displayName = "EllipsisOutlined";
var EllipsisOutlined$1 = /* @__PURE__ */ React.forwardRef(EllipsisOutlined);
var UnreachableException = function UnreachableException2(value) {
  _classCallCheck$2(this, UnreachableException2);
  return new Error("unreachable case: ".concat(JSON.stringify(value)));
};
var __rest$I = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var ButtonGroup$1 = function ButtonGroup(props) {
  return /* @__PURE__ */ React.createElement(ConfigConsumer, null, function(_ref) {
    var _classNames;
    var getPrefixCls = _ref.getPrefixCls, direction = _ref.direction;
    var customizePrefixCls = props.prefixCls, size = props.size, className = props.className, others = __rest$I(props, ["prefixCls", "size", "className"]);
    var prefixCls = getPrefixCls("btn-group", customizePrefixCls);
    var sizeCls = "";
    switch (size) {
      case "large":
        sizeCls = "lg";
        break;
      case "small":
        sizeCls = "sm";
        break;
      case "middle":
      case void 0:
        break;
      default:
        console.warn(new UnreachableException(size));
    }
    var classes = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
    return /* @__PURE__ */ React.createElement("div", _extends$2({}, others, {
      className: classes
    }));
  });
};
var id = 0;
var ids = {};
function wrapperRaf(callback) {
  var delayFrames = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  var myId = id++;
  var restFrames = delayFrames;
  function internalCallback() {
    restFrames -= 1;
    if (restFrames <= 0) {
      callback();
      delete ids[myId];
    } else {
      ids[myId] = wrapperRaf$1(internalCallback);
    }
  }
  ids[myId] = wrapperRaf$1(internalCallback);
  return myId;
}
wrapperRaf.cancel = function cancel(pid) {
  if (pid === void 0)
    return;
  wrapperRaf$1.cancel(ids[pid]);
  delete ids[pid];
};
wrapperRaf.ids = ids;
var styleForPseudo;
function isHidden(element) {
  if (process.env.NODE_ENV === "test") {
    return false;
  }
  return !element || element.offsetParent === null || element.hidden;
}
function isNotGrey(color) {
  var match2 = (color || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
  if (match2 && match2[1] && match2[2] && match2[3]) {
    return !(match2[1] === match2[2] && match2[2] === match2[3]);
  }
  return true;
}
var Wave = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Wave2, _React$Component);
  var _super = _createSuper$1(Wave2);
  function Wave2() {
    var _this2;
    _classCallCheck$2(this, Wave2);
    _this2 = _super.apply(this, arguments);
    _this2.containerRef = /* @__PURE__ */ React.createRef();
    _this2.animationStart = false;
    _this2.destroyed = false;
    _this2.onClick = function(node, waveColor) {
      var _a, _b;
      if (!node || isHidden(node) || node.className.indexOf("-leave") >= 0) {
        return;
      }
      var insertExtraNode = _this2.props.insertExtraNode;
      _this2.extraNode = document.createElement("div");
      var _assertThisInitialize = _assertThisInitialized$1(_this2), extraNode = _assertThisInitialize.extraNode;
      var getPrefixCls = _this2.context.getPrefixCls;
      extraNode.className = "".concat(getPrefixCls(""), "-click-animating-node");
      var attributeName = _this2.getAttributeName();
      node.setAttribute(attributeName, "true");
      if (waveColor && waveColor !== "#ffffff" && waveColor !== "rgb(255, 255, 255)" && isNotGrey(waveColor) && !/rgba\((?:\d*, ){3}0\)/.test(waveColor) && waveColor !== "transparent") {
        extraNode.style.borderColor = waveColor;
        var nodeRoot = ((_a = node.getRootNode) === null || _a === void 0 ? void 0 : _a.call(node)) || node.ownerDocument;
        var nodeBody = nodeRoot instanceof Document ? nodeRoot.body : (_b = nodeRoot.firstChild) !== null && _b !== void 0 ? _b : nodeRoot;
        styleForPseudo = updateCSS("\n      [".concat(getPrefixCls(""), "-click-animating-without-extra-node='true']::after, .").concat(getPrefixCls(""), "-click-animating-node {\n        --antd-wave-shadow-color: ").concat(waveColor, ";\n      }"), "antd-wave", {
          csp: _this2.csp,
          attachTo: nodeBody
        });
      }
      if (insertExtraNode) {
        node.appendChild(extraNode);
      }
      ["transition", "animation"].forEach(function(name) {
        node.addEventListener("".concat(name, "start"), _this2.onTransitionStart);
        node.addEventListener("".concat(name, "end"), _this2.onTransitionEnd);
      });
    };
    _this2.onTransitionStart = function(e3) {
      if (_this2.destroyed) {
        return;
      }
      var node = _this2.containerRef.current;
      if (!e3 || e3.target !== node || _this2.animationStart) {
        return;
      }
      _this2.resetEffect(node);
    };
    _this2.onTransitionEnd = function(e3) {
      if (!e3 || e3.animationName !== "fadeEffect") {
        return;
      }
      _this2.resetEffect(e3.target);
    };
    _this2.bindAnimationEvent = function(node) {
      if (!node || !node.getAttribute || node.getAttribute("disabled") || node.className.indexOf("disabled") >= 0) {
        return;
      }
      var onClick = function onClick2(e3) {
        if (e3.target.tagName === "INPUT" || isHidden(e3.target)) {
          return;
        }
        _this2.resetEffect(node);
        var waveColor = getComputedStyle(node).getPropertyValue("border-top-color") || getComputedStyle(node).getPropertyValue("border-color") || getComputedStyle(node).getPropertyValue("background-color");
        _this2.clickWaveTimeoutId = window.setTimeout(function() {
          return _this2.onClick(node, waveColor);
        }, 0);
        wrapperRaf.cancel(_this2.animationStartId);
        _this2.animationStart = true;
        _this2.animationStartId = wrapperRaf(function() {
          _this2.animationStart = false;
        }, 10);
      };
      node.addEventListener("click", onClick, true);
      return {
        cancel: function cancel2() {
          node.removeEventListener("click", onClick, true);
        }
      };
    };
    _this2.renderWave = function(_ref) {
      var csp = _ref.csp;
      var children = _this2.props.children;
      _this2.csp = csp;
      if (!/* @__PURE__ */ React.isValidElement(children))
        return children;
      var ref = _this2.containerRef;
      if (supportRef(children)) {
        ref = composeRef(children.ref, _this2.containerRef);
      }
      return cloneElement2(children, {
        ref
      });
    };
    return _this2;
  }
  _createClass$2(Wave2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = this.containerRef.current;
      if (!node || node.nodeType !== 1) {
        return;
      }
      this.instance = this.bindAnimationEvent(node);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.instance) {
        this.instance.cancel();
      }
      if (this.clickWaveTimeoutId) {
        clearTimeout(this.clickWaveTimeoutId);
      }
      this.destroyed = true;
    }
  }, {
    key: "getAttributeName",
    value: function getAttributeName() {
      var getPrefixCls = this.context.getPrefixCls;
      var insertExtraNode = this.props.insertExtraNode;
      return insertExtraNode ? "".concat(getPrefixCls(""), "-click-animating") : "".concat(getPrefixCls(""), "-click-animating-without-extra-node");
    }
  }, {
    key: "resetEffect",
    value: function resetEffect(node) {
      var _this2 = this;
      if (!node || node === this.extraNode || !(node instanceof Element)) {
        return;
      }
      var insertExtraNode = this.props.insertExtraNode;
      var attributeName = this.getAttributeName();
      node.setAttribute(attributeName, "false");
      if (styleForPseudo) {
        styleForPseudo.innerHTML = "";
      }
      if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
        node.removeChild(this.extraNode);
      }
      ["transition", "animation"].forEach(function(name) {
        node.removeEventListener("".concat(name, "start"), _this2.onTransitionStart);
        node.removeEventListener("".concat(name, "end"), _this2.onTransitionEnd);
      });
    }
  }, {
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(ConfigConsumer, null, this.renderWave);
    }
  }]);
  return Wave2;
}(React.Component);
Wave.contextType = ConfigContext;
var getCollapsedWidth = function getCollapsedWidth2() {
  return {
    width: 0,
    opacity: 0,
    transform: "scale(0)"
  };
};
var getRealWidth = function getRealWidth2(node) {
  return {
    width: node.scrollWidth,
    opacity: 1,
    transform: "scale(1)"
  };
};
var LoadingIcon = function LoadingIcon2(_ref) {
  var prefixCls = _ref.prefixCls, loading = _ref.loading, existIcon = _ref.existIcon;
  var visible = !!loading;
  if (existIcon) {
    return /* @__PURE__ */ React__default.createElement("span", {
      className: "".concat(prefixCls, "-loading-icon")
    }, /* @__PURE__ */ React__default.createElement(LoadingOutlined$1, null));
  }
  return /* @__PURE__ */ React__default.createElement(CSSMotion, {
    visible,
    motionName: "".concat(prefixCls, "-loading-icon-motion"),
    removeOnLeave: true,
    onAppearStart: getCollapsedWidth,
    onAppearActive: getRealWidth,
    onEnterStart: getCollapsedWidth,
    onEnterActive: getRealWidth,
    onLeaveStart: getRealWidth,
    onLeaveActive: getCollapsedWidth
  }, function(_ref2, ref) {
    var className = _ref2.className, style2 = _ref2.style;
    return /* @__PURE__ */ React__default.createElement("span", {
      className: "".concat(prefixCls, "-loading-icon"),
      style: style2,
      ref
    }, /* @__PURE__ */ React__default.createElement(LoadingOutlined$1, {
      className
    }));
  });
};
var __rest$H = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isString$1(str) {
  return typeof str === "string";
}
function isUnborderedButtonType(type2) {
  return type2 === "text" || type2 === "link";
}
function insertSpace(child, needInserted) {
  if (child == null) {
    return;
  }
  var SPACE = needInserted ? " " : "";
  if (typeof child !== "string" && typeof child !== "number" && isString$1(child.type) && isTwoCNChar(child.props.children)) {
    return cloneElement2(child, {
      children: child.props.children.split("").join(SPACE)
    });
  }
  if (typeof child === "string") {
    if (isTwoCNChar(child)) {
      child = child.split("").join(SPACE);
    }
    return /* @__PURE__ */ React.createElement("span", null, child);
  }
  return child;
}
function spaceChildren(children, needInserted) {
  var isPrevChildPure = false;
  var childList = [];
  React.Children.forEach(children, function(child) {
    var type2 = _typeof$5(child);
    var isCurrentChildPure = type2 === "string" || type2 === "number";
    if (isPrevChildPure && isCurrentChildPure) {
      var lastIndex = childList.length - 1;
      var lastChild = childList[lastIndex];
      childList[lastIndex] = "".concat(lastChild).concat(child);
    } else {
      childList.push(child);
    }
    isPrevChildPure = isCurrentChildPure;
  });
  return React.Children.map(childList, function(child) {
    return insertSpace(child, needInserted);
  });
}
tuple$1("default", "primary", "ghost", "dashed", "link", "text");
tuple$1("circle", "round");
tuple$1("submit", "button", "reset");
function convertLegacyProps(type2) {
  if (type2 === "danger") {
    return {
      danger: true
    };
  }
  return {
    type: type2
  };
}
var InternalButton = function InternalButton2(props, ref) {
  var _classNames;
  var _props$loading = props.loading, loading = _props$loading === void 0 ? false : _props$loading, customizePrefixCls = props.prefixCls, type2 = props.type, danger = props.danger, shape = props.shape, customizeSize = props.size, className = props.className, children = props.children, icon = props.icon, _props$ghost = props.ghost, ghost = _props$ghost === void 0 ? false : _props$ghost, _props$block = props.block, block = _props$block === void 0 ? false : _props$block, _props$htmlType = props.htmlType, htmlType = _props$htmlType === void 0 ? "button" : _props$htmlType, rest = __rest$H(props, ["loading", "prefixCls", "type", "danger", "shape", "size", "className", "children", "icon", "ghost", "block", "htmlType"]);
  var size = React.useContext(SizeContext$1);
  var _React$useState = React.useState(!!loading), _React$useState2 = _slicedToArray$3(_React$useState, 2), innerLoading = _React$useState2[0], setLoading = _React$useState2[1];
  var _React$useState3 = React.useState(false), _React$useState4 = _slicedToArray$3(_React$useState3, 2), hasTwoCNChar = _React$useState4[0], setHasTwoCNChar = _React$useState4[1];
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, autoInsertSpaceInButton = _React$useContext.autoInsertSpaceInButton, direction = _React$useContext.direction;
  var buttonRef = ref || /* @__PURE__ */ React.createRef();
  var delayTimeoutRef = React.useRef();
  var isNeedInserted = function isNeedInserted2() {
    return React.Children.count(children) === 1 && !icon && !isUnborderedButtonType(type2);
  };
  var fixTwoCNChar = function fixTwoCNChar2() {
    if (!buttonRef || !buttonRef.current || autoInsertSpaceInButton === false) {
      return;
    }
    var buttonText = buttonRef.current.textContent;
    if (isNeedInserted() && isTwoCNChar(buttonText)) {
      if (!hasTwoCNChar) {
        setHasTwoCNChar(true);
      }
    } else if (hasTwoCNChar) {
      setHasTwoCNChar(false);
    }
  };
  var loadingOrDelay;
  if (_typeof$5(loading) === "object" && loading.delay) {
    loadingOrDelay = loading.delay || true;
  } else {
    loadingOrDelay = !!loading;
  }
  React.useEffect(function() {
    clearTimeout(delayTimeoutRef.current);
    if (typeof loadingOrDelay === "number") {
      delayTimeoutRef.current = window.setTimeout(function() {
        setLoading(loadingOrDelay);
      }, loadingOrDelay);
    } else {
      setLoading(loadingOrDelay);
    }
  }, [loadingOrDelay]);
  React.useEffect(fixTwoCNChar, [buttonRef]);
  var handleClick = function handleClick2(e3) {
    var _a;
    var onClick = props.onClick;
    if (innerLoading) {
      return;
    }
    (_a = onClick) === null || _a === void 0 ? void 0 : _a(e3);
  };
  devWarning(!(typeof icon === "string" && icon.length > 2), "Button", "`icon` is using ReactNode instead of string naming in v4. Please check `".concat(icon, "` at https://ant.design/components/icon"));
  devWarning(!(ghost && isUnborderedButtonType(type2)), "Button", "`link` or `text` button can't be a `ghost` button.");
  var prefixCls = getPrefixCls("btn", customizePrefixCls);
  var autoInsertSpace = autoInsertSpaceInButton !== false;
  var sizeCls = "";
  switch (customizeSize || size) {
    case "large":
      sizeCls = "lg";
      break;
    case "small":
      sizeCls = "sm";
      break;
  }
  var iconType = innerLoading ? "loading" : icon;
  var classes = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(type2), type2), _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty$4(_classNames, "".concat(prefixCls, "-icon-only"), !children && children !== 0 && !!iconType), _defineProperty$4(_classNames, "".concat(prefixCls, "-background-ghost"), ghost && !isUnborderedButtonType(type2)), _defineProperty$4(_classNames, "".concat(prefixCls, "-loading"), innerLoading), _defineProperty$4(_classNames, "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace), _defineProperty$4(_classNames, "".concat(prefixCls, "-block"), block), _defineProperty$4(_classNames, "".concat(prefixCls, "-dangerous"), !!danger), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
  var iconNode = icon && !innerLoading ? icon : /* @__PURE__ */ React.createElement(LoadingIcon, {
    existIcon: !!icon,
    prefixCls,
    loading: !!innerLoading
  });
  var kids = children || children === 0 ? spaceChildren(children, isNeedInserted() && autoInsertSpace) : null;
  var linkButtonRestProps = omit$1(rest, ["navigate"]);
  if (linkButtonRestProps.href !== void 0) {
    return /* @__PURE__ */ React.createElement("a", _extends$2({}, linkButtonRestProps, {
      className: classes,
      onClick: handleClick,
      ref: buttonRef
    }), iconNode, kids);
  }
  var buttonNode = /* @__PURE__ */ React.createElement("button", _extends$2({}, rest, {
    type: htmlType,
    className: classes,
    onClick: handleClick,
    ref: buttonRef
  }), iconNode, kids);
  if (isUnborderedButtonType(type2)) {
    return buttonNode;
  }
  return /* @__PURE__ */ React.createElement(Wave, null, buttonNode);
};
var Button$1 = /* @__PURE__ */ React.forwardRef(InternalButton);
Button$1.displayName = "Button";
Button$1.Group = ButtonGroup$1;
Button$1.__ANT_BUTTON = true;
var __rest$G = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var ButtonGroup2 = Button$1.Group;
var DropdownButton$1 = function DropdownButton(props) {
  var _React$useContext = React.useContext(ConfigContext), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var customizePrefixCls = props.prefixCls, type2 = props.type, disabled = props.disabled, onClick = props.onClick, htmlType = props.htmlType, children = props.children, className = props.className, overlay = props.overlay, trigger = props.trigger, align = props.align, visible = props.visible, onVisibleChange = props.onVisibleChange, placement = props.placement, getPopupContainer = props.getPopupContainer, href = props.href, _props$icon = props.icon, icon = _props$icon === void 0 ? /* @__PURE__ */ React.createElement(EllipsisOutlined$1, null) : _props$icon, title = props.title, buttonsRender2 = props.buttonsRender, restProps = __rest$G(props, ["prefixCls", "type", "disabled", "onClick", "htmlType", "children", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender"]);
  var prefixCls = getPrefixCls("dropdown-button", customizePrefixCls);
  var dropdownProps = {
    align,
    overlay,
    disabled,
    trigger: disabled ? [] : trigger,
    onVisibleChange,
    getPopupContainer: getPopupContainer || getContextPopupContainer
  };
  if ("visible" in props) {
    dropdownProps.visible = visible;
  }
  if ("placement" in props) {
    dropdownProps.placement = placement;
  } else {
    dropdownProps.placement = direction === "rtl" ? "bottomLeft" : "bottomRight";
  }
  var leftButton = /* @__PURE__ */ React.createElement(Button$1, {
    type: type2,
    disabled,
    onClick,
    htmlType,
    href,
    title
  }, children);
  var rightButton = /* @__PURE__ */ React.createElement(Button$1, {
    type: type2,
    icon
  });
  var _buttonsRender = buttonsRender2([leftButton, rightButton]), _buttonsRender2 = _slicedToArray$3(_buttonsRender, 2), leftButtonToRender = _buttonsRender2[0], rightButtonToRender = _buttonsRender2[1];
  return /* @__PURE__ */ React.createElement(ButtonGroup2, _extends$2({}, restProps, {
    className: cn(prefixCls, className)
  }), leftButtonToRender, /* @__PURE__ */ React.createElement(Dropdown$2, dropdownProps, rightButtonToRender));
};
DropdownButton$1.__ANT_BUTTON = true;
DropdownButton$1.defaultProps = {
  type: "default",
  buttonsRender: function buttonsRender(buttons) {
    return buttons;
  }
};
tuple$1("topLeft", "topCenter", "topRight", "bottomLeft", "bottomCenter", "bottomRight");
var Dropdown$2 = function Dropdown(props) {
  var _React$useContext = React.useContext(ConfigContext), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var getTransitionName3 = function getTransitionName4() {
    var rootPrefixCls = getPrefixCls();
    var _props$placement = props.placement, placement = _props$placement === void 0 ? "" : _props$placement, transitionName2 = props.transitionName;
    if (transitionName2 !== void 0) {
      return transitionName2;
    }
    if (placement.indexOf("top") >= 0) {
      return "".concat(rootPrefixCls, "-slide-down");
    }
    return "".concat(rootPrefixCls, "-slide-up");
  };
  var renderOverlay = function renderOverlay2(prefixCls2) {
    var overlay = props.overlay;
    var overlayNode;
    if (typeof overlay === "function") {
      overlayNode = overlay();
    } else {
      overlayNode = overlay;
    }
    overlayNode = React.Children.only(typeof overlayNode === "string" ? /* @__PURE__ */ React.createElement("span", null, overlayNode) : overlayNode);
    var overlayProps = overlayNode.props;
    devWarning(!overlayProps.mode || overlayProps.mode === "vertical", "Dropdown", 'mode="'.concat(overlayProps.mode, `" is not supported for Dropdown's Menu.`));
    var _overlayProps$selecta = overlayProps.selectable, selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta, _overlayProps$focusab = overlayProps.focusable, focusable = _overlayProps$focusab === void 0 ? true : _overlayProps$focusab, expandIcon = overlayProps.expandIcon;
    var overlayNodeExpandIcon = typeof expandIcon !== "undefined" && /* @__PURE__ */ React.isValidElement(expandIcon) ? expandIcon : /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls2, "-menu-submenu-arrow")
    }, /* @__PURE__ */ React.createElement(RightOutlined$1, {
      className: "".concat(prefixCls2, "-menu-submenu-arrow-icon")
    }));
    var fixedModeOverlay = typeof overlayNode.type === "string" ? overlayNode : cloneElement2(overlayNode, {
      mode: "vertical",
      selectable,
      focusable,
      expandIcon: overlayNodeExpandIcon
    });
    return fixedModeOverlay;
  };
  var getPlacement = function getPlacement2() {
    var placement = props.placement;
    if (placement !== void 0) {
      return placement;
    }
    return direction === "rtl" ? "bottomRight" : "bottomLeft";
  };
  var arrow = props.arrow, customizePrefixCls = props.prefixCls, children = props.children, trigger = props.trigger, disabled = props.disabled, getPopupContainer = props.getPopupContainer, overlayClassName = props.overlayClassName;
  var prefixCls = getPrefixCls("dropdown", customizePrefixCls);
  var child = React.Children.only(children);
  var dropdownTrigger = cloneElement2(child, {
    className: cn("".concat(prefixCls, "-trigger"), _defineProperty$4({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), child.props.className),
    disabled
  });
  var overlayClassNameCustomized = cn(overlayClassName, _defineProperty$4({}, "".concat(prefixCls, "-rtl"), direction === "rtl"));
  var triggerActions = disabled ? [] : trigger;
  var alignPoint2;
  if (triggerActions && triggerActions.indexOf("contextMenu") !== -1) {
    alignPoint2 = true;
  }
  return /* @__PURE__ */ React.createElement(Dropdown$4, _extends$2({
    arrow,
    alignPoint: alignPoint2
  }, props, {
    overlayClassName: overlayClassNameCustomized,
    prefixCls,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    transitionName: getTransitionName3(),
    trigger: triggerActions,
    overlay: function overlay() {
      return renderOverlay(prefixCls);
    },
    placement: getPlacement()
  }), dropdownTrigger);
};
Dropdown$2.Button = DropdownButton$1;
Dropdown$2.defaultProps = {
  mouseEnterDelay: 0.15,
  mouseLeaveDelay: 0.1
};
var __rest$F = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var BreadcrumbItem = function BreadcrumbItem2(_a) {
  var customizePrefixCls = _a.prefixCls, _a$separator = _a.separator, separator = _a$separator === void 0 ? "/" : _a$separator, children = _a.children, overlay = _a.overlay, dropdownProps = _a.dropdownProps, restProps = __rest$F(_a, ["prefixCls", "separator", "children", "overlay", "dropdownProps"]);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls("breadcrumb", customizePrefixCls);
  var renderBreadcrumbNode = function renderBreadcrumbNode2(breadcrumbItem) {
    if (overlay) {
      return /* @__PURE__ */ React.createElement(Dropdown$2, _extends$2({
        overlay,
        placement: "bottomCenter"
      }, dropdownProps), /* @__PURE__ */ React.createElement("span", {
        className: "".concat(prefixCls, "-overlay-link")
      }, breadcrumbItem, /* @__PURE__ */ React.createElement(DownOutlined$1, null)));
    }
    return breadcrumbItem;
  };
  var link;
  if ("href" in restProps) {
    link = /* @__PURE__ */ React.createElement("a", _extends$2({
      className: "".concat(prefixCls, "-link")
    }, restProps), children);
  } else {
    link = /* @__PURE__ */ React.createElement("span", _extends$2({
      className: "".concat(prefixCls, "-link")
    }, restProps), children);
  }
  link = renderBreadcrumbNode(link);
  if (children) {
    return /* @__PURE__ */ React.createElement("span", null, link, separator && separator !== "" && /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-separator")
    }, separator));
  }
  return null;
};
BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
var BreadcrumbSeparator = function BreadcrumbSeparator2(_ref) {
  var children = _ref.children;
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls("breadcrumb");
  return /* @__PURE__ */ React.createElement("span", {
    className: "".concat(prefixCls, "-separator")
  }, children || "/");
};
BreadcrumbSeparator.__ANT_BREADCRUMB_SEPARATOR = true;
var __extends$1 = function() {
  var extendStatics = function(d, b2) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
      d2.__proto__ = b3;
    } || function(d2, b3) {
      for (var p in b3)
        if (b3.hasOwnProperty(p))
          d2[p] = b3[p];
    };
    return extendStatics(d, b2);
  };
  return function(d, b2) {
    extendStatics(d, b2);
    function __() {
      this.constructor = d;
    }
    d.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
  };
}();
var MiniStoreContext = React.createContext(null);
var Provider = function(_super) {
  __extends$1(Provider2, _super);
  function Provider2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Provider2.prototype.render = function() {
    return React.createElement(MiniStoreContext.Provider, { value: this.props.store }, this.props.children);
  };
  return Provider2;
}(React.Component);
var shallowequal = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
  if (ret !== void 0) {
    return !!ret;
  }
  if (objA === objB) {
    return true;
  }
  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var idx = 0; idx < keysA.length; idx++) {
    var key2 = keysA[idx];
    if (!bHasOwnProperty(key2)) {
      return false;
    }
    var valueA = objA[key2];
    var valueB = objB[key2];
    ret = compare ? compare.call(compareContext, valueA, valueB, key2) : void 0;
    if (ret === false || ret === void 0 && valueA !== valueB) {
      return false;
    }
  }
  return true;
};
var reactIs = reactIs$1.exports;
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }
  return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== "string") {
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys2 = getOwnPropertyNames(sourceComponent);
    if (getOwnPropertySymbols) {
      keys2 = keys2.concat(getOwnPropertySymbols(sourceComponent));
    }
    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);
    for (var i2 = 0; i2 < keys2.length; ++i2) {
      var key2 = keys2[i2];
      if (!KNOWN_STATICS[key2] && !(blacklist && blacklist[key2]) && !(sourceStatics && sourceStatics[key2]) && !(targetStatics && targetStatics[key2])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key2);
        try {
          defineProperty(targetComponent, key2, descriptor);
        } catch (e3) {
        }
      }
    }
  }
  return targetComponent;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;
var __extends = function() {
  var extendStatics = function(d, b2) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
      d2.__proto__ = b3;
    } || function(d2, b3) {
      for (var p in b3)
        if (b3.hasOwnProperty(p))
          d2[p] = b3[p];
    };
    return extendStatics(d, b2);
  };
  return function(d, b2) {
    extendStatics(d, b2);
    function __() {
      this.constructor = d;
    }
    d.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
  };
}();
var __assign$1 = function() {
  __assign$1 = Object.assign || function(t3) {
    for (var s2, i2 = 1, n3 = arguments.length; i2 < n3; i2++) {
      s2 = arguments[i2];
      for (var p in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p))
          t3[p] = s2[p];
    }
    return t3;
  };
  return __assign$1.apply(this, arguments);
};
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}
var defaultMapStateToProps = function() {
  return {};
};
function connect(mapStateToProps, options) {
  if (options === void 0) {
    options = {};
  }
  var shouldSubscribe = !!mapStateToProps;
  var finalMapStateToProps = mapStateToProps || defaultMapStateToProps;
  return function wrapWithConnect(WrappedComponent) {
    var Connect = function(_super) {
      __extends(Connect2, _super);
      function Connect2(props, context2) {
        var _this2 = _super.call(this, props, context2) || this;
        _this2.unsubscribe = null;
        _this2.handleChange = function() {
          if (!_this2.unsubscribe) {
            return;
          }
          var nextState = finalMapStateToProps(_this2.store.getState(), _this2.props);
          _this2.setState({ subscribed: nextState });
        };
        _this2.store = _this2.context;
        _this2.state = {
          subscribed: finalMapStateToProps(_this2.store.getState(), props),
          store: _this2.store,
          props
        };
        return _this2;
      }
      Connect2.getDerivedStateFromProps = function(props, prevState) {
        if (mapStateToProps && mapStateToProps.length === 2 && props !== prevState.props) {
          return {
            subscribed: finalMapStateToProps(prevState.store.getState(), props),
            props
          };
        }
        return { props };
      };
      Connect2.prototype.componentDidMount = function() {
        this.trySubscribe();
      };
      Connect2.prototype.componentWillUnmount = function() {
        this.tryUnsubscribe();
      };
      Connect2.prototype.shouldComponentUpdate = function(nextProps, nextState) {
        return !shallowequal(this.props, nextProps) || !shallowequal(this.state.subscribed, nextState.subscribed);
      };
      Connect2.prototype.trySubscribe = function() {
        if (shouldSubscribe) {
          this.unsubscribe = this.store.subscribe(this.handleChange);
          this.handleChange();
        }
      };
      Connect2.prototype.tryUnsubscribe = function() {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
      };
      Connect2.prototype.render = function() {
        var props = __assign$1(__assign$1(__assign$1({}, this.props), this.state.subscribed), { store: this.store });
        return React.createElement(WrappedComponent, __assign$1({}, props, { ref: this.props.miniStoreForwardedRef }));
      };
      Connect2.displayName = "Connect(" + getDisplayName(WrappedComponent) + ")";
      Connect2.contextType = MiniStoreContext;
      return Connect2;
    }(React.Component);
    if (options.forwardRef) {
      var forwarded = React.forwardRef(function(props, ref) {
        return React.createElement(Connect, __assign$1({}, props, { miniStoreForwardedRef: ref }));
      });
      return hoistNonReactStatics_cjs(forwarded, WrappedComponent);
    }
    return hoistNonReactStatics_cjs(Connect, WrappedComponent);
  };
}
var __assign = function() {
  __assign = Object.assign || function(t3) {
    for (var s2, i2 = 1, n3 = arguments.length; i2 < n3; i2++) {
      s2 = arguments[i2];
      for (var p in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p))
          t3[p] = s2[p];
    }
    return t3;
  };
  return __assign.apply(this, arguments);
};
function create(initialState2) {
  var state = initialState2;
  var listeners = [];
  function setState(partial) {
    state = __assign(__assign({}, state), partial);
    for (var i2 = 0; i2 < listeners.length; i2++) {
      listeners[i2]();
    }
  }
  function getState() {
    return state;
  }
  function subscribe2(listener) {
    listeners.push(listener);
    return function unsubscribe2() {
      var index2 = listeners.indexOf(listener);
      listeners.splice(index2, 1);
    };
  }
  return {
    setState,
    getState,
    subscribe: subscribe2
  };
}
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);
  if (args.length === 1) {
    return args[0];
  }
  return function chainedFunction() {
    for (var i2 = 0; i2 < args.length; i2++) {
      if (args[i2] && args[i2].apply) {
        args[i2].apply(this, arguments);
      }
    }
  };
}
var applePhone = /iPhone/i;
var appleIpod = /iPod/i;
var appleTablet = /iPad/i;
var androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var androidTablet = /Android/i;
var amazonPhone = /\bAndroid(?:.+)SD4930UR\b/i;
var amazonTablet = /\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i;
var windowsPhone = /Windows Phone/i;
var windowsTablet = /\bWindows(?:.+)ARM\b/i;
var otherBlackberry = /BlackBerry/i;
var otherBlackberry10 = /BB10/i;
var otherOpera = /Opera Mini/i;
var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var otherFirefox = /Mobile(?:.+)Firefox\b/i;
function match(regex, userAgent) {
  return regex.test(userAgent);
}
function isMobile(userAgent) {
  var ua = userAgent || (typeof navigator !== "undefined" ? navigator.userAgent : "");
  var tmp = (ua || "").split("[FBAN");
  if (typeof tmp[1] !== "undefined") {
    var _tmp = tmp;
    var _tmp2 = _slicedToArray$3(_tmp, 1);
    ua = _tmp2[0];
  }
  tmp = ua.split("Twitter");
  if (typeof tmp[1] !== "undefined") {
    var _tmp3 = tmp;
    var _tmp4 = _slicedToArray$3(_tmp3, 1);
    ua = _tmp4[0];
  }
  var result = {
    apple: {
      phone: match(applePhone, ua) && !match(windowsPhone, ua),
      ipod: match(appleIpod, ua),
      tablet: !match(applePhone, ua) && match(appleTablet, ua) && !match(windowsPhone, ua),
      device: (match(applePhone, ua) || match(appleIpod, ua) || match(appleTablet, ua)) && !match(windowsPhone, ua)
    },
    amazon: {
      phone: match(amazonPhone, ua),
      tablet: !match(amazonPhone, ua) && match(amazonTablet, ua),
      device: match(amazonPhone, ua) || match(amazonTablet, ua)
    },
    android: {
      phone: !match(windowsPhone, ua) && match(amazonPhone, ua) || !match(windowsPhone, ua) && match(androidPhone, ua),
      tablet: !match(windowsPhone, ua) && !match(amazonPhone, ua) && !match(androidPhone, ua) && (match(amazonTablet, ua) || match(androidTablet, ua)),
      device: !match(windowsPhone, ua) && (match(amazonPhone, ua) || match(amazonTablet, ua) || match(androidPhone, ua) || match(androidTablet, ua)) || match(/\bokhttp\b/i, ua)
    },
    windows: {
      phone: match(windowsPhone, ua),
      tablet: match(windowsTablet, ua),
      device: match(windowsPhone, ua) || match(windowsTablet, ua)
    },
    other: {
      blackberry: match(otherBlackberry, ua),
      blackberry10: match(otherBlackberry10, ua),
      opera: match(otherOpera, ua),
      firefox: match(otherFirefox, ua),
      chrome: match(otherChrome, ua),
      device: match(otherBlackberry, ua) || match(otherBlackberry10, ua) || match(otherOpera, ua) || match(otherFirefox, ua) || match(otherChrome, ua)
    },
    any: null,
    phone: null,
    tablet: null
  };
  result.any = result.apple.device || result.android.device || result.windows.device || result.other.device;
  result.phone = result.apple.phone || result.android.phone || result.windows.phone;
  result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
  return result;
}
var defaultResult = _objectSpread2$1(_objectSpread2$1({}, isMobile()), {}, {
  isMobile
});
function noop$4() {
}
function getKeyFromChildrenIndex(child, menuEventKey, index2) {
  var prefix = menuEventKey || "";
  return child.key || "".concat(prefix, "item_").concat(index2);
}
function getMenuIdFromSubMenuEventKey(eventKey) {
  return "".concat(eventKey, "-menu-");
}
function loopMenuItem(children, cb) {
  var index2 = -1;
  React.Children.forEach(children, function(c2) {
    index2 += 1;
    if (c2 && c2.type && c2.type.isMenuItemGroup) {
      React.Children.forEach(c2.props.children, function(c22) {
        index2 += 1;
        cb(c22, index2);
      });
    } else {
      cb(c2, index2);
    }
  });
}
function loopMenuItemRecursively(children, keys2, ret) {
  if (!children || ret.find) {
    return;
  }
  React.Children.forEach(children, function(c2) {
    if (c2) {
      var construct = c2.type;
      if (!construct || !(construct.isSubMenu || construct.isMenuItem || construct.isMenuItemGroup)) {
        return;
      }
      if (keys2.indexOf(c2.key) !== -1) {
        ret.find = true;
      } else if (c2.props.children) {
        loopMenuItemRecursively(c2.props.children, keys2, ret);
      }
    }
  });
}
var menuAllProps = [
  "defaultSelectedKeys",
  "selectedKeys",
  "defaultOpenKeys",
  "openKeys",
  "mode",
  "getPopupContainer",
  "onSelect",
  "onDeselect",
  "onDestroy",
  "openTransitionName",
  "openAnimation",
  "subMenuOpenDelay",
  "subMenuCloseDelay",
  "forceSubMenuRender",
  "triggerSubMenuAction",
  "level",
  "selectable",
  "multiple",
  "onOpenChange",
  "visible",
  "focusable",
  "defaultActiveFirst",
  "prefixCls",
  "inlineIndent",
  "parentMenu",
  "title",
  "rootPrefixCls",
  "eventKey",
  "active",
  "onItemHover",
  "onTitleMouseEnter",
  "onTitleMouseLeave",
  "onTitleClick",
  "popupAlign",
  "popupOffset",
  "isOpen",
  "renderMenuItem",
  "manualRef",
  "subMenuKey",
  "disabled",
  "index",
  "isSelected",
  "store",
  "activeKey",
  "builtinPlacements",
  "overflowedIndicator",
  "motion",
  "attribute",
  "value",
  "popupClassName",
  "inlineCollapsed",
  "menu",
  "theme",
  "itemIcon",
  "expandIcon"
];
var getWidth$1 = function getWidth(elem) {
  var includeMargin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var width = elem && typeof elem.getBoundingClientRect === "function" && elem.getBoundingClientRect().width;
  if (width) {
    if (includeMargin) {
      var _getComputedStyle2 = getComputedStyle(elem), marginLeft = _getComputedStyle2.marginLeft, marginRight = _getComputedStyle2.marginRight;
      width += +marginLeft.replace("px", "") + +marginRight.replace("px", "");
    }
    width = +width.toFixed(6);
  }
  return width || 0;
};
var setStyle$1 = function setStyle(elem, styleProperty, value) {
  if (elem && _typeof$5(elem.style) === "object") {
    elem.style[styleProperty] = value;
  }
};
var isMobileDevice = function isMobileDevice2() {
  return defaultResult.any;
};
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var placements = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};
var placementsRtl = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};
var guid = 0;
var popupPlacementMap = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
var updateDefaultActiveFirst = function updateDefaultActiveFirst2(store, eventKey, defaultActiveFirst) {
  var menuId = getMenuIdFromSubMenuEventKey(eventKey);
  var state = store.getState();
  store.setState({
    defaultActiveFirst: _objectSpread2$1(_objectSpread2$1({}, state.defaultActiveFirst), {}, _defineProperty$4({}, menuId, defaultActiveFirst))
  });
};
var SubMenu$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(SubMenu2, _React$Component);
  var _super = _createSuper$1(SubMenu2);
  function SubMenu2(props) {
    var _this2;
    _classCallCheck$2(this, SubMenu2);
    _this2 = _super.call(this, props);
    _this2.onDestroy = function(key2) {
      _this2.props.onDestroy(key2);
    };
    _this2.onKeyDown = function(e3) {
      var keyCode = e3.keyCode;
      var menu = _this2.menuInstance;
      var store2 = _this2.props.store;
      var visible = _this2.getVisible();
      if (keyCode === KeyCode.ENTER) {
        _this2.onTitleClick(e3);
        updateDefaultActiveFirst(store2, _this2.props.eventKey, true);
        return true;
      }
      if (keyCode === KeyCode.RIGHT) {
        if (visible) {
          menu.onKeyDown(e3);
        } else {
          _this2.triggerOpenChange(true);
          updateDefaultActiveFirst(store2, _this2.props.eventKey, true);
        }
        return true;
      }
      if (keyCode === KeyCode.LEFT) {
        var handled;
        if (visible) {
          handled = menu.onKeyDown(e3);
        } else {
          return void 0;
        }
        if (!handled) {
          _this2.triggerOpenChange(false);
          handled = true;
        }
        return handled;
      }
      if (visible && (keyCode === KeyCode.UP || keyCode === KeyCode.DOWN)) {
        return menu.onKeyDown(e3);
      }
      return void 0;
    };
    _this2.onOpenChange = function(e3) {
      _this2.props.onOpenChange(e3);
    };
    _this2.onPopupVisibleChange = function(visible) {
      _this2.triggerOpenChange(visible, visible ? "mouseenter" : "mouseleave");
    };
    _this2.onMouseEnter = function(e3) {
      var _this$props = _this2.props, key2 = _this$props.eventKey, onMouseEnter = _this$props.onMouseEnter, store2 = _this$props.store;
      updateDefaultActiveFirst(store2, _this2.props.eventKey, false);
      onMouseEnter({
        key: key2,
        domEvent: e3
      });
    };
    _this2.onMouseLeave = function(e3) {
      var _this$props2 = _this2.props, parentMenu = _this$props2.parentMenu, eventKey2 = _this$props2.eventKey, onMouseLeave = _this$props2.onMouseLeave;
      parentMenu.subMenuInstance = _assertThisInitialized$1(_this2);
      onMouseLeave({
        key: eventKey2,
        domEvent: e3
      });
    };
    _this2.onTitleMouseEnter = function(domEvent) {
      var _this$props3 = _this2.props, key2 = _this$props3.eventKey, onItemHover = _this$props3.onItemHover, onTitleMouseEnter = _this$props3.onTitleMouseEnter;
      onItemHover({
        key: key2,
        hover: true
      });
      onTitleMouseEnter({
        key: key2,
        domEvent
      });
    };
    _this2.onTitleMouseLeave = function(e3) {
      var _this$props4 = _this2.props, parentMenu = _this$props4.parentMenu, eventKey2 = _this$props4.eventKey, onItemHover = _this$props4.onItemHover, onTitleMouseLeave = _this$props4.onTitleMouseLeave;
      parentMenu.subMenuInstance = _assertThisInitialized$1(_this2);
      onItemHover({
        key: eventKey2,
        hover: false
      });
      onTitleMouseLeave({
        key: eventKey2,
        domEvent: e3
      });
    };
    _this2.onTitleClick = function(e3) {
      var _assertThisInitialize = _assertThisInitialized$1(_this2), props2 = _assertThisInitialize.props;
      props2.onTitleClick({
        key: props2.eventKey,
        domEvent: e3
      });
      if (props2.triggerSubMenuAction === "hover") {
        return;
      }
      _this2.triggerOpenChange(!_this2.getVisible(), "click");
      updateDefaultActiveFirst(props2.store, _this2.props.eventKey, false);
    };
    _this2.onSubMenuClick = function(info) {
      if (typeof _this2.props.onClick === "function") {
        _this2.props.onClick(_this2.addKeyPath(info));
      }
    };
    _this2.onSelect = function(info) {
      _this2.props.onSelect(info);
    };
    _this2.onDeselect = function(info) {
      _this2.props.onDeselect(info);
    };
    _this2.getPrefixCls = function() {
      return "".concat(_this2.props.rootPrefixCls, "-submenu");
    };
    _this2.getActiveClassName = function() {
      return "".concat(_this2.getPrefixCls(), "-active");
    };
    _this2.getDisabledClassName = function() {
      return "".concat(_this2.getPrefixCls(), "-disabled");
    };
    _this2.getSelectedClassName = function() {
      return "".concat(_this2.getPrefixCls(), "-selected");
    };
    _this2.getOpenClassName = function() {
      return "".concat(_this2.props.rootPrefixCls, "-submenu-open");
    };
    _this2.getVisible = function() {
      return _this2.state.isOpen;
    };
    _this2.getMode = function() {
      return _this2.state.mode;
    };
    _this2.saveMenuInstance = function(c2) {
      _this2.menuInstance = c2;
    };
    _this2.addKeyPath = function(info) {
      return _objectSpread2$1(_objectSpread2$1({}, info), {}, {
        keyPath: (info.keyPath || []).concat(_this2.props.eventKey)
      });
    };
    _this2.triggerOpenChange = function(open, type2) {
      var key2 = _this2.props.eventKey;
      var openChange = function openChange2() {
        _this2.onOpenChange({
          key: key2,
          item: _assertThisInitialized$1(_this2),
          trigger: type2,
          open
        });
      };
      if (type2 === "mouseenter") {
        _this2.mouseenterTimeout = setTimeout(function() {
          openChange();
        }, 0);
      } else {
        openChange();
      }
    };
    _this2.isChildrenSelected = function() {
      var ret = {
        find: false
      };
      loopMenuItemRecursively(_this2.props.children, _this2.props.selectedKeys, ret);
      return ret.find;
    };
    _this2.isInlineMode = function() {
      return _this2.getMode() === "inline";
    };
    _this2.adjustWidth = function() {
      if (!_this2.subMenuTitle || !_this2.menuInstance) {
        return;
      }
      var popupMenu = ReactDOM.findDOMNode(_this2.menuInstance);
      if (popupMenu.offsetWidth >= _this2.subMenuTitle.offsetWidth) {
        return;
      }
      popupMenu.style.minWidth = "".concat(_this2.subMenuTitle.offsetWidth, "px");
    };
    _this2.saveSubMenuTitle = function(subMenuTitle) {
      _this2.subMenuTitle = subMenuTitle;
    };
    _this2.getBaseProps = function() {
      var _assertThisInitialize2 = _assertThisInitialized$1(_this2), props2 = _assertThisInitialize2.props;
      var mergedMode = _this2.getMode();
      return {
        mode: mergedMode === "horizontal" ? "vertical" : mergedMode,
        visible: _this2.getVisible(),
        level: props2.level + 1,
        inlineIndent: props2.inlineIndent,
        focusable: false,
        onClick: _this2.onSubMenuClick,
        onSelect: _this2.onSelect,
        onDeselect: _this2.onDeselect,
        onDestroy: _this2.onDestroy,
        selectedKeys: props2.selectedKeys,
        eventKey: "".concat(props2.eventKey, "-menu-"),
        openKeys: props2.openKeys,
        motion: props2.motion,
        onOpenChange: _this2.onOpenChange,
        subMenuOpenDelay: props2.subMenuOpenDelay,
        parentMenu: _assertThisInitialized$1(_this2),
        subMenuCloseDelay: props2.subMenuCloseDelay,
        forceSubMenuRender: props2.forceSubMenuRender,
        triggerSubMenuAction: props2.triggerSubMenuAction,
        builtinPlacements: props2.builtinPlacements,
        defaultActiveFirst: props2.store.getState().defaultActiveFirst[getMenuIdFromSubMenuEventKey(props2.eventKey)],
        multiple: props2.multiple,
        prefixCls: props2.rootPrefixCls,
        id: _this2.internalMenuId,
        manualRef: _this2.saveMenuInstance,
        itemIcon: props2.itemIcon,
        expandIcon: props2.expandIcon,
        direction: props2.direction
      };
    };
    _this2.getMotion = function(mode, visible) {
      var _assertThisInitialize3 = _assertThisInitialized$1(_this2), haveRendered = _assertThisInitialize3.haveRendered;
      var _this$props5 = _this2.props, motion = _this$props5.motion, rootPrefixCls = _this$props5.rootPrefixCls;
      var mergedMotion = _objectSpread2$1(_objectSpread2$1({}, motion), {}, {
        leavedClassName: "".concat(rootPrefixCls, "-hidden"),
        removeOnLeave: false,
        motionAppear: haveRendered || !visible || mode !== "inline"
      });
      return mergedMotion;
    };
    var store = props.store, eventKey = props.eventKey;
    var _store$getState = store.getState(), defaultActiveFirst = _store$getState.defaultActiveFirst;
    _this2.isRootMenu = false;
    var value = false;
    if (defaultActiveFirst) {
      value = defaultActiveFirst[eventKey];
    }
    updateDefaultActiveFirst(store, eventKey, value);
    _this2.state = {
      mode: props.mode,
      isOpen: props.isOpen
    };
    return _this2;
  }
  _createClass$2(SubMenu2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;
      var _this$props6 = this.props, mode = _this$props6.mode, parentMenu = _this$props6.parentMenu, manualRef = _this$props6.manualRef, isOpen = _this$props6.isOpen;
      var updateState = function updateState2() {
        _this2.setState({
          mode,
          isOpen
        });
      };
      var isOpenChanged = isOpen !== this.state.isOpen;
      var isModeChanged = mode !== this.state.mode;
      if (isModeChanged || isOpenChanged) {
        wrapperRaf$1.cancel(this.updateStateRaf);
        if (isModeChanged) {
          this.updateStateRaf = wrapperRaf$1(updateState);
        } else {
          updateState();
        }
      }
      if (manualRef) {
        manualRef(this);
      }
      if (mode !== "horizontal" || !(parentMenu === null || parentMenu === void 0 ? void 0 : parentMenu.isRootMenu) || !isOpen) {
        return;
      }
      this.minWidthTimeout = setTimeout(function() {
        return _this2.adjustWidth();
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props7 = this.props, onDestroy = _this$props7.onDestroy, eventKey = _this$props7.eventKey;
      if (onDestroy) {
        onDestroy(eventKey);
      }
      if (this.minWidthTimeout) {
        clearTimeout(this.minWidthTimeout);
      }
      if (this.mouseenterTimeout) {
        clearTimeout(this.mouseenterTimeout);
      }
      wrapperRaf$1.cancel(this.updateStateRaf);
    }
  }, {
    key: "renderPopupMenu",
    value: function renderPopupMenu(className, style2) {
      var baseProps = this.getBaseProps();
      return /* @__PURE__ */ React.createElement(connected$1, _extends$2({}, baseProps, {
        id: this.internalMenuId,
        className,
        style: style2
      }), this.props.children);
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this3 = this;
      var baseProps = this.getBaseProps();
      var mode = baseProps.mode, visible = baseProps.visible, forceSubMenuRender = baseProps.forceSubMenuRender, direction = baseProps.direction;
      var mergedMotion = this.getMotion(mode, visible);
      this.haveRendered = true;
      this.haveOpened = this.haveOpened || visible || forceSubMenuRender;
      if (!this.haveOpened) {
        return /* @__PURE__ */ React.createElement("div", null);
      }
      var sharedClassName = cn("".concat(baseProps.prefixCls, "-sub"), _defineProperty$4({}, "".concat(baseProps.prefixCls, "-rtl"), direction === "rtl"));
      if (!this.isInlineMode()) {
        return this.renderPopupMenu(sharedClassName);
      }
      return /* @__PURE__ */ React.createElement(CSSMotion, _extends$2({
        visible: baseProps.visible,
        forceRender: forceSubMenuRender
      }, mergedMotion), function(_ref) {
        var className = _ref.className, style2 = _ref.style;
        var mergedClassName = cn(sharedClassName, className);
        return _this3.renderPopupMenu(mergedClassName, style2);
      });
    }
  }, {
    key: "render",
    value: function render4() {
      var _classNames2, _props$parentMenu, _classNames3;
      var props = _objectSpread2$1({}, this.props);
      var visible = this.getVisible();
      var prefixCls = this.getPrefixCls();
      var inline = this.isInlineMode();
      var mergedMode = this.getMode();
      var className = cn(prefixCls, "".concat(prefixCls, "-").concat(mergedMode), (_classNames2 = {}, _defineProperty$4(_classNames2, props.className, !!props.className), _defineProperty$4(_classNames2, this.getOpenClassName(), visible), _defineProperty$4(_classNames2, this.getActiveClassName(), props.active || visible && !inline), _defineProperty$4(_classNames2, this.getDisabledClassName(), props.disabled), _defineProperty$4(_classNames2, this.getSelectedClassName(), this.isChildrenSelected()), _classNames2));
      if (!this.internalMenuId) {
        if (props.eventKey) {
          this.internalMenuId = "".concat(props.eventKey, "$Menu");
        } else {
          guid += 1;
          this.internalMenuId = "$__$".concat(guid, "$Menu");
        }
      }
      var mouseEvents = {};
      var titleClickEvents = {};
      var titleMouseEvents = {};
      if (!props.disabled) {
        mouseEvents = {
          onMouseLeave: this.onMouseLeave,
          onMouseEnter: this.onMouseEnter
        };
        titleClickEvents = {
          onClick: this.onTitleClick
        };
        titleMouseEvents = {
          onMouseEnter: this.onTitleMouseEnter,
          onMouseLeave: this.onTitleMouseLeave
        };
      }
      var style2 = {};
      var direction = props.direction;
      var isRTL = direction === "rtl";
      if (inline) {
        if (isRTL) {
          style2.paddingRight = props.inlineIndent * props.level;
        } else {
          style2.paddingLeft = props.inlineIndent * props.level;
        }
      }
      var ariaOwns = {};
      if (this.getVisible()) {
        ariaOwns = {
          "aria-owns": this.internalMenuId
        };
      }
      var icon = null;
      if (mergedMode !== "horizontal") {
        icon = this.props.expandIcon;
        if (typeof this.props.expandIcon === "function") {
          icon = /* @__PURE__ */ React.createElement(this.props.expandIcon, _objectSpread2$1({}, this.props));
        }
      }
      var title = /* @__PURE__ */ React.createElement("div", _extends$2({
        ref: this.saveSubMenuTitle,
        style: style2,
        className: "".concat(prefixCls, "-title"),
        role: "button"
      }, titleMouseEvents, titleClickEvents, {
        "aria-expanded": visible
      }, ariaOwns, {
        "aria-haspopup": "true",
        title: typeof props.title === "string" ? props.title : void 0
      }), props.title, icon || /* @__PURE__ */ React.createElement("i", {
        className: "".concat(prefixCls, "-arrow")
      }));
      var children = this.renderChildren();
      var getPopupContainer = ((_props$parentMenu = props.parentMenu) === null || _props$parentMenu === void 0 ? void 0 : _props$parentMenu.isRootMenu) ? props.parentMenu.props.getPopupContainer : function(triggerNode) {
        return triggerNode.parentNode;
      };
      var popupPlacement = popupPlacementMap[mergedMode];
      var popupAlign = props.popupOffset ? {
        offset: props.popupOffset
      } : {};
      var popupClassName = cn((_classNames3 = {}, _defineProperty$4(_classNames3, props.popupClassName, props.popupClassName && !inline), _defineProperty$4(_classNames3, "".concat(prefixCls, "-rtl"), isRTL), _classNames3));
      var disabled = props.disabled, triggerSubMenuAction = props.triggerSubMenuAction, subMenuOpenDelay = props.subMenuOpenDelay, forceSubMenuRender = props.forceSubMenuRender, subMenuCloseDelay = props.subMenuCloseDelay, builtinPlacements = props.builtinPlacements;
      menuAllProps.forEach(function(key2) {
        return delete props[key2];
      });
      delete props.onClick;
      var placement = isRTL ? _objectSpread2$1(_objectSpread2$1({}, placementsRtl), builtinPlacements) : _objectSpread2$1(_objectSpread2$1({}, placements), builtinPlacements);
      delete props.direction;
      var baseProps = this.getBaseProps();
      var mergedMotion = inline ? null : this.getMotion(baseProps.mode, baseProps.visible);
      return /* @__PURE__ */ React.createElement("li", _extends$2({}, props, mouseEvents, {
        className,
        role: "menuitem"
      }), /* @__PURE__ */ React.createElement(Trigger, {
        prefixCls,
        popupClassName: cn("".concat(prefixCls, "-popup"), popupClassName),
        getPopupContainer,
        builtinPlacements: placement,
        popupPlacement,
        popupVisible: inline ? false : visible,
        popupAlign,
        popup: inline ? null : children,
        action: disabled || inline ? [] : [triggerSubMenuAction],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: this.onPopupVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion
      }, title), inline ? children : null);
    }
  }]);
  return SubMenu2;
}(React.Component);
SubMenu$1.defaultProps = {
  onMouseEnter: noop$4,
  onMouseLeave: noop$4,
  onTitleMouseEnter: noop$4,
  onTitleMouseLeave: noop$4,
  onTitleClick: noop$4,
  manualRef: noop$4,
  mode: "vertical",
  title: ""
};
var connected$2 = connect(function(_ref2, _ref3) {
  var openKeys = _ref2.openKeys, activeKey = _ref2.activeKey, selectedKeys = _ref2.selectedKeys;
  var eventKey = _ref3.eventKey, subMenuKey = _ref3.subMenuKey;
  return {
    isOpen: openKeys.indexOf(eventKey) > -1,
    active: activeKey[subMenuKey] === eventKey,
    selectedKeys
  };
})(SubMenu$1);
connected$2.isSubMenu = true;
var MENUITEM_OVERFLOWED_CLASSNAME = "menuitem-overflowed";
var FLOAT_PRECISION_ADJUST = 0.5;
var DOMWrap = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(DOMWrap2, _React$Component);
  var _super = _createSuper$1(DOMWrap2);
  function DOMWrap2() {
    var _this2;
    _classCallCheck$2(this, DOMWrap2);
    _this2 = _super.apply(this, arguments);
    _this2.resizeObserver = null;
    _this2.mutationObserver = null;
    _this2.originalTotalWidth = 0;
    _this2.overflowedItems = [];
    _this2.menuItemSizes = [];
    _this2.cancelFrameId = null;
    _this2.state = {
      lastVisibleIndex: void 0
    };
    _this2.childRef = /* @__PURE__ */ React.createRef();
    _this2.getMenuItemNodes = function() {
      var prefixCls = _this2.props.prefixCls;
      var ul = _this2.childRef.current;
      if (!ul) {
        return [];
      }
      return [].slice.call(ul.children).filter(function(node) {
        return node.className.split(" ").indexOf("".concat(prefixCls, "-overflowed-submenu")) < 0;
      });
    };
    _this2.getOverflowedSubMenuItem = function(keyPrefix, overflowedItems, renderPlaceholder) {
      var _this$props = _this2.props, overflowedIndicator = _this$props.overflowedIndicator, level = _this$props.level, mode = _this$props.mode, prefixCls = _this$props.prefixCls, theme = _this$props.theme;
      if (level !== 1 || mode !== "horizontal") {
        return null;
      }
      var copy2 = _this2.props.children[0];
      var _copy$props = copy2.props;
      _copy$props.children;
      _copy$props.title;
      var propStyle = _copy$props.style, rest = _objectWithoutProperties$1(_copy$props, ["children", "title", "style"]);
      var style2 = _objectSpread2$1({}, propStyle);
      var key2 = "".concat(keyPrefix, "-overflowed-indicator");
      var eventKey = "".concat(keyPrefix, "-overflowed-indicator");
      if (overflowedItems.length === 0 && renderPlaceholder !== true) {
        style2 = _objectSpread2$1(_objectSpread2$1({}, style2), {}, {
          display: "none"
        });
      } else if (renderPlaceholder) {
        style2 = _objectSpread2$1(_objectSpread2$1({}, style2), {}, {
          visibility: "hidden",
          position: "absolute"
        });
        key2 = "".concat(key2, "-placeholder");
        eventKey = "".concat(eventKey, "-placeholder");
      }
      var popupClassName = theme ? "".concat(prefixCls, "-").concat(theme) : "";
      var props = {};
      menuAllProps.forEach(function(k2) {
        if (rest[k2] !== void 0) {
          props[k2] = rest[k2];
        }
      });
      return /* @__PURE__ */ React.createElement(connected$2, _extends$2({
        title: overflowedIndicator,
        className: "".concat(prefixCls, "-overflowed-submenu"),
        popupClassName
      }, props, {
        key: key2,
        eventKey,
        disabled: false,
        style: style2
      }), overflowedItems);
    };
    _this2.setChildrenWidthAndResize = function() {
      if (_this2.props.mode !== "horizontal") {
        return;
      }
      var ul = _this2.childRef.current;
      if (!ul) {
        return;
      }
      var ulChildrenNodes = ul.children;
      if (!ulChildrenNodes || ulChildrenNodes.length === 0) {
        return;
      }
      var lastOverflowedIndicatorPlaceholder = ul.children[ulChildrenNodes.length - 1];
      setStyle$1(lastOverflowedIndicatorPlaceholder, "display", "inline-block");
      var menuItemNodes = _this2.getMenuItemNodes();
      var overflowedItems = menuItemNodes.filter(function(c2) {
        return c2.className.split(" ").indexOf(MENUITEM_OVERFLOWED_CLASSNAME) >= 0;
      });
      overflowedItems.forEach(function(c2) {
        setStyle$1(c2, "display", "inline-block");
      });
      _this2.menuItemSizes = menuItemNodes.map(function(c2) {
        return getWidth$1(c2, true);
      });
      overflowedItems.forEach(function(c2) {
        setStyle$1(c2, "display", "none");
      });
      _this2.overflowedIndicatorWidth = getWidth$1(ul.children[ul.children.length - 1], true);
      _this2.originalTotalWidth = _this2.menuItemSizes.reduce(function(acc, cur) {
        return acc + cur;
      }, 0);
      _this2.handleResize();
      setStyle$1(lastOverflowedIndicatorPlaceholder, "display", "none");
    };
    _this2.handleResize = function() {
      if (_this2.props.mode !== "horizontal") {
        return;
      }
      var ul = _this2.childRef.current;
      if (!ul) {
        return;
      }
      var width = getWidth$1(ul);
      _this2.overflowedItems = [];
      var currentSumWidth = 0;
      var lastVisibleIndex;
      if (_this2.originalTotalWidth > width + FLOAT_PRECISION_ADJUST) {
        lastVisibleIndex = -1;
        _this2.menuItemSizes.forEach(function(liWidth) {
          currentSumWidth += liWidth;
          if (currentSumWidth + _this2.overflowedIndicatorWidth <= width) {
            lastVisibleIndex += 1;
          }
        });
      }
      _this2.setState({
        lastVisibleIndex
      });
    };
    return _this2;
  }
  _createClass$2(DOMWrap2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.setChildrenWidthAndResize();
      if (this.props.level === 1 && this.props.mode === "horizontal") {
        var menuUl = this.childRef.current;
        if (!menuUl) {
          return;
        }
        this.resizeObserver = new index$1(function(entries) {
          entries.forEach(function() {
            var cancelFrameId = _this2.cancelFrameId;
            cancelAnimationFrame(cancelFrameId);
            _this2.cancelFrameId = requestAnimationFrame(_this2.setChildrenWidthAndResize);
          });
        });
        [].slice.call(menuUl.children).concat(menuUl).forEach(function(el) {
          _this2.resizeObserver.observe(el);
        });
        if (typeof MutationObserver !== "undefined") {
          this.mutationObserver = new MutationObserver(function() {
            _this2.resizeObserver.disconnect();
            [].slice.call(menuUl.children).concat(menuUl).forEach(function(el) {
              _this2.resizeObserver.observe(el);
            });
            _this2.setChildrenWidthAndResize();
          });
          this.mutationObserver.observe(menuUl, {
            attributes: false,
            childList: true,
            subTree: false
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
      cancelAnimationFrame(this.cancelFrameId);
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      var _this3 = this;
      var lastVisibleIndex = this.state.lastVisibleIndex;
      return (children || []).reduce(function(acc, childNode, index2) {
        var item = childNode;
        if (_this3.props.mode === "horizontal") {
          var overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, []);
          if (lastVisibleIndex !== void 0 && _this3.props.className.indexOf("".concat(_this3.props.prefixCls, "-root")) !== -1) {
            if (index2 > lastVisibleIndex) {
              item = /* @__PURE__ */ React.cloneElement(
                childNode,
                {
                  style: {
                    display: "none"
                  },
                  eventKey: "".concat(childNode.props.eventKey, "-hidden"),
                  className: "".concat(MENUITEM_OVERFLOWED_CLASSNAME)
                }
              );
            }
            if (index2 === lastVisibleIndex + 1) {
              _this3.overflowedItems = children.slice(lastVisibleIndex + 1).map(function(c2) {
                return /* @__PURE__ */ React.cloneElement(
                  c2,
                  {
                    key: c2.props.eventKey,
                    mode: "vertical-left"
                  }
                );
              });
              overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, _this3.overflowedItems);
            }
          }
          var ret = [].concat(_toConsumableArray(acc), [overflowed, item]);
          if (index2 === children.length - 1) {
            ret.push(_this3.getOverflowedSubMenuItem(childNode.props.eventKey, [], true));
          }
          return ret;
        }
        return [].concat(_toConsumableArray(acc), [item]);
      }, []);
    }
  }, {
    key: "render",
    value: function render4() {
      var _this$props2 = this.props;
      _this$props2.visible;
      _this$props2.prefixCls;
      _this$props2.overflowedIndicator;
      _this$props2.mode;
      _this$props2.level;
      var tag = _this$props2.tag, children = _this$props2.children;
      _this$props2.theme;
      var rest = _objectWithoutProperties$1(_this$props2, ["visible", "prefixCls", "overflowedIndicator", "mode", "level", "tag", "children", "theme"]);
      var Tag2 = tag;
      return /* @__PURE__ */ React.createElement(Tag2, _extends$2({
        ref: this.childRef
      }, rest), this.renderChildren(children));
    }
  }]);
  return DOMWrap2;
}(React.Component);
DOMWrap.defaultProps = {
  tag: "div",
  className: ""
};
function allDisabled(arr) {
  if (!arr.length) {
    return true;
  }
  return arr.every(function(c2) {
    return !!c2.props.disabled;
  });
}
function updateActiveKey(store, menuId, activeKey) {
  var state = store.getState();
  store.setState({
    activeKey: _objectSpread2$1(_objectSpread2$1({}, state.activeKey), {}, _defineProperty$4({}, menuId, activeKey))
  });
}
function getEventKey(props) {
  return props.eventKey || "0-menu-";
}
function getActiveKey(props, originalActiveKey) {
  var activeKey = originalActiveKey;
  var children = props.children, eventKey = props.eventKey;
  if (activeKey) {
    var found;
    loopMenuItem(children, function(c2, i2) {
      if (c2 && c2.props && !c2.props.disabled && activeKey === getKeyFromChildrenIndex(c2, eventKey, i2)) {
        found = true;
      }
    });
    if (found) {
      return activeKey;
    }
  }
  activeKey = null;
  if (props.defaultActiveFirst) {
    loopMenuItem(children, function(c2, i2) {
      if (!activeKey && c2 && !c2.props.disabled) {
        activeKey = getKeyFromChildrenIndex(c2, eventKey, i2);
      }
    });
    return activeKey;
  }
  return activeKey;
}
function saveRef(c2) {
  if (!c2) {
    return;
  }
  var index2 = this.instanceArray.indexOf(c2);
  if (index2 !== -1) {
    this.instanceArray[index2] = c2;
  } else {
    this.instanceArray.push(c2);
  }
}
var SubPopupMenu = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(SubPopupMenu2, _React$Component);
  var _super = _createSuper$1(SubPopupMenu2);
  function SubPopupMenu2(props) {
    var _this2;
    _classCallCheck$2(this, SubPopupMenu2);
    _this2 = _super.call(this, props);
    _this2.onKeyDown = function(e3, callback) {
      var keyCode = e3.keyCode;
      var handled;
      _this2.getFlatInstanceArray().forEach(function(obj) {
        if (obj && obj.props.active && obj.onKeyDown) {
          handled = obj.onKeyDown(e3);
        }
      });
      if (handled) {
        return 1;
      }
      var activeItem = null;
      if (keyCode === KeyCode.UP || keyCode === KeyCode.DOWN) {
        activeItem = _this2.step(keyCode === KeyCode.UP ? -1 : 1);
      }
      if (activeItem) {
        e3.preventDefault();
        updateActiveKey(_this2.props.store, getEventKey(_this2.props), activeItem.props.eventKey);
        if (typeof callback === "function") {
          callback(activeItem);
        }
        return 1;
      }
      return void 0;
    };
    _this2.onItemHover = function(e3) {
      var key2 = e3.key, hover = e3.hover;
      updateActiveKey(_this2.props.store, getEventKey(_this2.props), hover ? key2 : null);
    };
    _this2.onDeselect = function(selectInfo) {
      _this2.props.onDeselect(selectInfo);
    };
    _this2.onSelect = function(selectInfo) {
      _this2.props.onSelect(selectInfo);
    };
    _this2.onClick = function(e3) {
      _this2.props.onClick(e3);
    };
    _this2.onOpenChange = function(e3) {
      _this2.props.onOpenChange(e3);
    };
    _this2.onDestroy = function(key2) {
      _this2.props.onDestroy(key2);
    };
    _this2.getFlatInstanceArray = function() {
      return _this2.instanceArray;
    };
    _this2.step = function(direction) {
      var children = _this2.getFlatInstanceArray();
      var activeKey = _this2.props.store.getState().activeKey[getEventKey(_this2.props)];
      var len = children.length;
      if (!len) {
        return null;
      }
      if (direction < 0) {
        children = children.concat().reverse();
      }
      var activeIndex = -1;
      children.every(function(c2, ci) {
        if (c2 && c2.props.eventKey === activeKey) {
          activeIndex = ci;
          return false;
        }
        return true;
      });
      if (!_this2.props.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
        return void 0;
      }
      var start = (activeIndex + 1) % len;
      var i2 = start;
      do {
        var child = children[i2];
        if (!child || child.props.disabled) {
          i2 = (i2 + 1) % len;
        } else {
          return child;
        }
      } while (i2 !== start);
      return null;
    };
    _this2.renderCommonMenuItem = function(child, i2, extraProps) {
      var state = _this2.props.store.getState();
      var _assertThisInitialize = _assertThisInitialized$1(_this2), props2 = _assertThisInitialize.props;
      var key2 = getKeyFromChildrenIndex(child, props2.eventKey, i2);
      var childProps = child.props;
      if (!childProps || typeof child.type === "string") {
        return child;
      }
      var isActive2 = key2 === state.activeKey;
      var newChildProps = _objectSpread2$1(_objectSpread2$1({
        mode: childProps.mode || props2.mode,
        level: props2.level,
        inlineIndent: props2.inlineIndent,
        renderMenuItem: _this2.renderMenuItem,
        rootPrefixCls: props2.prefixCls,
        index: i2,
        parentMenu: props2.parentMenu,
        manualRef: childProps.disabled ? void 0 : createChainedFunction(child.ref, saveRef.bind(_assertThisInitialized$1(_this2))),
        eventKey: key2,
        active: !childProps.disabled && isActive2,
        multiple: props2.multiple,
        onClick: function onClick(e3) {
          (childProps.onClick || noop$4)(e3);
          _this2.onClick(e3);
        },
        onItemHover: _this2.onItemHover,
        motion: props2.motion,
        subMenuOpenDelay: props2.subMenuOpenDelay,
        subMenuCloseDelay: props2.subMenuCloseDelay,
        forceSubMenuRender: props2.forceSubMenuRender,
        onOpenChange: _this2.onOpenChange,
        onDeselect: _this2.onDeselect,
        onSelect: _this2.onSelect,
        builtinPlacements: props2.builtinPlacements,
        itemIcon: childProps.itemIcon || _this2.props.itemIcon,
        expandIcon: childProps.expandIcon || _this2.props.expandIcon
      }, extraProps), {}, {
        direction: props2.direction
      });
      if (props2.mode === "inline" || isMobileDevice()) {
        newChildProps.triggerSubMenuAction = "click";
      }
      return /* @__PURE__ */ React.cloneElement(child, _objectSpread2$1(_objectSpread2$1({}, newChildProps), {}, {
        key: key2 || i2
      }));
    };
    _this2.renderMenuItem = function(c2, i2, subMenuKey) {
      if (!c2) {
        return null;
      }
      var state = _this2.props.store.getState();
      var extraProps = {
        openKeys: state.openKeys,
        selectedKeys: state.selectedKeys,
        triggerSubMenuAction: _this2.props.triggerSubMenuAction,
        subMenuKey
      };
      return _this2.renderCommonMenuItem(c2, i2, extraProps);
    };
    props.store.setState({
      activeKey: _objectSpread2$1(_objectSpread2$1({}, props.store.getState().activeKey), {}, _defineProperty$4({}, props.eventKey, getActiveKey(props, props.activeKey)))
    });
    _this2.instanceArray = [];
    return _this2;
  }
  _createClass$2(SubPopupMenu2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.manualRef) {
        this.props.manualRef(this);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.visible || nextProps.visible || this.props.className !== nextProps.className || !shallowequal(this.props.style, nextProps.style);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var props = this.props;
      var originalActiveKey = "activeKey" in props ? props.activeKey : props.store.getState().activeKey[getEventKey(props)];
      var activeKey = getActiveKey(props, originalActiveKey);
      if (activeKey !== originalActiveKey) {
        updateActiveKey(props.store, getEventKey(props), activeKey);
      } else if ("activeKey" in prevProps) {
        var prevActiveKey = getActiveKey(prevProps, prevProps.activeKey);
        if (activeKey !== prevActiveKey) {
          updateActiveKey(props.store, getEventKey(props), activeKey);
        }
      }
    }
  }, {
    key: "render",
    value: function render4() {
      var _this2 = this;
      var props = _extends$2({}, this.props);
      this.instanceArray = [];
      var className = cn(props.prefixCls, props.className, "".concat(props.prefixCls, "-").concat(props.mode));
      var domProps = {
        className,
        role: props.role || "menu"
      };
      if (props.id) {
        domProps.id = props.id;
      }
      if (props.focusable) {
        domProps.tabIndex = 0;
        domProps.onKeyDown = this.onKeyDown;
      }
      var prefixCls = props.prefixCls, eventKey = props.eventKey, visible = props.visible, level = props.level, mode = props.mode, overflowedIndicator = props.overflowedIndicator, theme = props.theme;
      menuAllProps.forEach(function(key2) {
        return delete props[key2];
      });
      delete props.onClick;
      return /* @__PURE__ */ React.createElement(DOMWrap, _extends$2({}, props, {
        prefixCls,
        mode,
        tag: "ul",
        level,
        theme,
        visible,
        overflowedIndicator
      }, domProps), toArray$8(props.children).map(function(c2, i2) {
        return _this2.renderMenuItem(c2, i2, eventKey || "0-menu-");
      }));
    }
  }]);
  return SubPopupMenu2;
}(React.Component);
SubPopupMenu.defaultProps = {
  prefixCls: "rc-menu",
  className: "",
  mode: "vertical",
  level: 1,
  inlineIndent: 24,
  visible: true,
  focusable: true,
  style: {},
  manualRef: noop$4
};
var connected$1 = connect()(SubPopupMenu);
function getMotion(_ref, _ref2, menuMode) {
  var prefixCls = _ref.prefixCls, motion = _ref.motion, _ref$defaultMotions = _ref.defaultMotions, defaultMotions = _ref$defaultMotions === void 0 ? {} : _ref$defaultMotions, openAnimation = _ref.openAnimation, openTransitionName = _ref.openTransitionName;
  var switchingModeFromInline = _ref2.switchingModeFromInline;
  if (motion) {
    return motion;
  }
  if (_typeof$5(openAnimation) === "object" && openAnimation) {
    warningOnce(false, "Object type of `openAnimation` is removed. Please use `motion` instead.");
  } else if (typeof openAnimation === "string") {
    return {
      motionName: "".concat(prefixCls, "-open-").concat(openAnimation)
    };
  }
  if (openTransitionName) {
    return {
      motionName: openTransitionName
    };
  }
  var defaultMotion = defaultMotions[menuMode];
  if (defaultMotion) {
    return defaultMotion;
  }
  return switchingModeFromInline ? null : defaultMotions.other;
}
var Menu$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Menu2, _React$Component);
  var _super = _createSuper$1(Menu2);
  function Menu2(props) {
    var _this2;
    _classCallCheck$2(this, Menu2);
    _this2 = _super.call(this, props);
    _this2.onSelect = function(selectInfo) {
      var _assertThisInitialize = _assertThisInitialized$1(_this2), props2 = _assertThisInitialize.props;
      if (props2.selectable) {
        var _this$store$getState = _this2.store.getState(), _selectedKeys = _this$store$getState.selectedKeys;
        var selectedKey = selectInfo.key;
        if (props2.multiple) {
          _selectedKeys = _selectedKeys.concat([selectedKey]);
        } else {
          _selectedKeys = [selectedKey];
        }
        if (!("selectedKeys" in props2)) {
          _this2.store.setState({
            selectedKeys: _selectedKeys
          });
        }
        props2.onSelect(_objectSpread2$1(_objectSpread2$1({}, selectInfo), {}, {
          selectedKeys: _selectedKeys
        }));
      }
    };
    _this2.onClick = function(e3) {
      var mode = _this2.getRealMenuMode();
      var _assertThisInitialize2 = _assertThisInitialized$1(_this2), store = _assertThisInitialize2.store, onOpenChange = _assertThisInitialize2.props.onOpenChange;
      if (mode !== "inline" && !("openKeys" in _this2.props)) {
        store.setState({
          openKeys: []
        });
        onOpenChange([]);
      }
      _this2.props.onClick(e3);
    };
    _this2.onKeyDown = function(e3, callback) {
      _this2.innerMenu.getWrappedInstance().onKeyDown(e3, callback);
    };
    _this2.onOpenChange = function(event) {
      var _assertThisInitialize3 = _assertThisInitialized$1(_this2), props2 = _assertThisInitialize3.props;
      var openKeys2 = _this2.store.getState().openKeys.concat();
      var changed = false;
      var processSingle = function processSingle2(e3) {
        var oneChanged = false;
        if (e3.open) {
          oneChanged = openKeys2.indexOf(e3.key) === -1;
          if (oneChanged) {
            openKeys2.push(e3.key);
          }
        } else {
          var index2 = openKeys2.indexOf(e3.key);
          oneChanged = index2 !== -1;
          if (oneChanged) {
            openKeys2.splice(index2, 1);
          }
        }
        changed = changed || oneChanged;
      };
      if (Array.isArray(event)) {
        event.forEach(processSingle);
      } else {
        processSingle(event);
      }
      if (changed) {
        if (!("openKeys" in _this2.props)) {
          _this2.store.setState({
            openKeys: openKeys2
          });
        }
        props2.onOpenChange(openKeys2);
      }
    };
    _this2.onDeselect = function(selectInfo) {
      var _assertThisInitialize4 = _assertThisInitialized$1(_this2), props2 = _assertThisInitialize4.props;
      if (props2.selectable) {
        var _selectedKeys2 = _this2.store.getState().selectedKeys.concat();
        var selectedKey = selectInfo.key;
        var index2 = _selectedKeys2.indexOf(selectedKey);
        if (index2 !== -1) {
          _selectedKeys2.splice(index2, 1);
        }
        if (!("selectedKeys" in props2)) {
          _this2.store.setState({
            selectedKeys: _selectedKeys2
          });
        }
        props2.onDeselect(_objectSpread2$1(_objectSpread2$1({}, selectInfo), {}, {
          selectedKeys: _selectedKeys2
        }));
      }
    };
    _this2.onMouseEnter = function(e3) {
      _this2.restoreModeVerticalFromInline();
      var onMouseEnter = _this2.props.onMouseEnter;
      if (onMouseEnter) {
        onMouseEnter(e3);
      }
    };
    _this2.onTransitionEnd = function(e3) {
      var widthCollapsed = e3.propertyName === "width" && e3.target === e3.currentTarget;
      var className = e3.target.className;
      var classNameValue = Object.prototype.toString.call(className) === "[object SVGAnimatedString]" ? className.animVal : className;
      var iconScaled = e3.propertyName === "font-size" && classNameValue.indexOf("anticon") >= 0;
      if (widthCollapsed || iconScaled) {
        _this2.restoreModeVerticalFromInline();
      }
    };
    _this2.setInnerMenu = function(node) {
      _this2.innerMenu = node;
    };
    _this2.isRootMenu = true;
    var selectedKeys = props.defaultSelectedKeys;
    var openKeys = props.defaultOpenKeys;
    if ("selectedKeys" in props) {
      selectedKeys = props.selectedKeys || [];
    }
    if ("openKeys" in props) {
      openKeys = props.openKeys || [];
    }
    _this2.store = create({
      selectedKeys,
      openKeys,
      activeKey: {
        "0-menu-": getActiveKey(props, props.activeKey)
      }
    });
    _this2.state = {
      switchingModeFromInline: false,
      prevProps: props,
      inlineOpenKeys: [],
      store: _this2.store
    };
    return _this2;
  }
  _createClass$2(Menu2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateMiniStore();
      this.updateMenuDisplay();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props, siderCollapsed = _this$props.siderCollapsed, inlineCollapsed = _this$props.inlineCollapsed, onOpenChange = _this$props.onOpenChange;
      if (!prevProps.inlineCollapsed && inlineCollapsed || !prevProps.siderCollapsed && siderCollapsed) {
        onOpenChange([]);
      }
      this.updateMiniStore();
      this.updateMenuDisplay();
    }
  }, {
    key: "updateMenuDisplay",
    value: function updateMenuDisplay() {
      var collapsedWidth = this.props.collapsedWidth, store = this.store, prevOpenKeys = this.prevOpenKeys;
      var hideMenu = this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === "0" || collapsedWidth === "0px");
      if (hideMenu) {
        this.prevOpenKeys = store.getState().openKeys.concat();
        this.store.setState({
          openKeys: []
        });
      } else if (prevOpenKeys) {
        this.store.setState({
          openKeys: prevOpenKeys
        });
        this.prevOpenKeys = null;
      }
    }
  }, {
    key: "getRealMenuMode",
    value: function getRealMenuMode() {
      var mode = this.props.mode;
      var switchingModeFromInline = this.state.switchingModeFromInline;
      var inlineCollapsed = this.getInlineCollapsed();
      if (switchingModeFromInline && inlineCollapsed) {
        return "inline";
      }
      return inlineCollapsed ? "vertical" : mode;
    }
  }, {
    key: "getInlineCollapsed",
    value: function getInlineCollapsed() {
      var _this$props2 = this.props, inlineCollapsed = _this$props2.inlineCollapsed, siderCollapsed = _this$props2.siderCollapsed;
      if (siderCollapsed !== void 0) {
        return siderCollapsed;
      }
      return inlineCollapsed;
    }
  }, {
    key: "restoreModeVerticalFromInline",
    value: function restoreModeVerticalFromInline() {
      var switchingModeFromInline = this.state.switchingModeFromInline;
      if (switchingModeFromInline) {
        this.setState({
          switchingModeFromInline: false
        });
      }
    }
  }, {
    key: "updateMiniStore",
    value: function updateMiniStore() {
      if ("selectedKeys" in this.props) {
        this.store.setState({
          selectedKeys: this.props.selectedKeys || []
        });
      }
      if ("openKeys" in this.props) {
        this.store.setState({
          openKeys: this.props.openKeys || []
        });
      }
    }
  }, {
    key: "render",
    value: function render4() {
      var props = _objectSpread2$1({}, omit$1(this.props, ["collapsedWidth", "siderCollapsed", "defaultMotions"]));
      var mode = this.getRealMenuMode();
      props.className += " ".concat(props.prefixCls, "-root");
      if (props.direction === "rtl") {
        props.className += " ".concat(props.prefixCls, "-rtl");
      }
      props = _objectSpread2$1(_objectSpread2$1({}, props), {}, {
        mode,
        onClick: this.onClick,
        onOpenChange: this.onOpenChange,
        onDeselect: this.onDeselect,
        onSelect: this.onSelect,
        onMouseEnter: this.onMouseEnter,
        onTransitionEnd: this.onTransitionEnd,
        parentMenu: this,
        motion: getMotion(this.props, this.state, mode)
      });
      delete props.openAnimation;
      delete props.openTransitionName;
      return /* @__PURE__ */ React.createElement(Provider, {
        store: this.store
      }, /* @__PURE__ */ React.createElement(connected$1, _extends$2({}, props, {
        ref: this.setInnerMenu
      }), this.props.children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var prevProps = prevState.prevProps, store = prevState.store;
      var prevStoreState = store.getState();
      var newStoreState = {};
      var newState = {
        prevProps: nextProps
      };
      if (prevProps.mode === "inline" && nextProps.mode !== "inline") {
        newState.switchingModeFromInline = true;
      }
      if ("openKeys" in nextProps) {
        newStoreState.openKeys = nextProps.openKeys || [];
      } else {
        if (nextProps.inlineCollapsed && !prevProps.inlineCollapsed || nextProps.siderCollapsed && !prevProps.siderCollapsed) {
          newState.switchingModeFromInline = true;
          newState.inlineOpenKeys = prevStoreState.openKeys;
          newStoreState.openKeys = [];
        }
        if (!nextProps.inlineCollapsed && prevProps.inlineCollapsed || !nextProps.siderCollapsed && prevProps.siderCollapsed) {
          newStoreState.openKeys = prevState.inlineOpenKeys;
          newState.inlineOpenKeys = [];
        }
      }
      if (Object.keys(newStoreState).length) {
        store.setState(newStoreState);
      }
      return newState;
    }
  }]);
  return Menu2;
}(React.Component);
Menu$1.defaultProps = {
  selectable: true,
  onClick: noop$4,
  onSelect: noop$4,
  onOpenChange: noop$4,
  onDeselect: noop$4,
  defaultSelectedKeys: [],
  defaultOpenKeys: [],
  subMenuOpenDelay: 0.1,
  subMenuCloseDelay: 0.1,
  triggerSubMenuAction: "hover",
  prefixCls: "rc-menu",
  className: "",
  mode: "vertical",
  style: {},
  builtinPlacements: {},
  overflowedIndicator: /* @__PURE__ */ React.createElement("span", null, "\xB7\xB7\xB7")
};
var MenuItem$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(MenuItem2, _React$Component);
  var _super = _createSuper$1(MenuItem2);
  function MenuItem2() {
    var _this2;
    _classCallCheck$2(this, MenuItem2);
    _this2 = _super.apply(this, arguments);
    _this2.onKeyDown = function(e3) {
      var keyCode = e3.keyCode;
      if (keyCode === KeyCode.ENTER) {
        _this2.onClick(e3);
        return true;
      }
      return void 0;
    };
    _this2.onMouseLeave = function(e3) {
      var _this$props = _this2.props, eventKey = _this$props.eventKey, onItemHover = _this$props.onItemHover, onMouseLeave = _this$props.onMouseLeave;
      onItemHover({
        key: eventKey,
        hover: false
      });
      onMouseLeave({
        key: eventKey,
        domEvent: e3
      });
    };
    _this2.onMouseEnter = function(e3) {
      var _this$props2 = _this2.props, eventKey = _this$props2.eventKey, onItemHover = _this$props2.onItemHover, onMouseEnter = _this$props2.onMouseEnter;
      onItemHover({
        key: eventKey,
        hover: true
      });
      onMouseEnter({
        key: eventKey,
        domEvent: e3
      });
    };
    _this2.onClick = function(e3) {
      var _this$props3 = _this2.props, eventKey = _this$props3.eventKey, multiple = _this$props3.multiple, onClick = _this$props3.onClick, onSelect = _this$props3.onSelect, onDeselect = _this$props3.onDeselect, isSelected = _this$props3.isSelected;
      var info = {
        key: eventKey,
        keyPath: [eventKey],
        item: _assertThisInitialized$1(_this2),
        domEvent: e3
      };
      onClick(info);
      if (multiple) {
        if (isSelected) {
          onDeselect(info);
        } else {
          onSelect(info);
        }
      } else if (!isSelected) {
        onSelect(info);
      }
    };
    _this2.saveNode = function(node) {
      _this2.node = node;
    };
    return _this2;
  }
  _createClass$2(MenuItem2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.callRef();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.callRef();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var props = this.props;
      if (props.onDestroy) {
        props.onDestroy(props.eventKey);
      }
    }
  }, {
    key: "getPrefixCls",
    value: function getPrefixCls() {
      return "".concat(this.props.rootPrefixCls, "-item");
    }
  }, {
    key: "getActiveClassName",
    value: function getActiveClassName() {
      return "".concat(this.getPrefixCls(), "-active");
    }
  }, {
    key: "getSelectedClassName",
    value: function getSelectedClassName() {
      return "".concat(this.getPrefixCls(), "-selected");
    }
  }, {
    key: "getDisabledClassName",
    value: function getDisabledClassName() {
      return "".concat(this.getPrefixCls(), "-disabled");
    }
  }, {
    key: "callRef",
    value: function callRef() {
      if (this.props.manualRef) {
        this.props.manualRef(this);
      }
    }
  }, {
    key: "render",
    value: function render4() {
      var _classNames;
      var props = _objectSpread2$1({}, this.props);
      var className = cn(this.getPrefixCls(), props.className, (_classNames = {}, _defineProperty$4(_classNames, this.getActiveClassName(), !props.disabled && props.active), _defineProperty$4(_classNames, this.getSelectedClassName(), props.isSelected), _defineProperty$4(_classNames, this.getDisabledClassName(), props.disabled), _classNames));
      var attrs = _objectSpread2$1(_objectSpread2$1({}, props.attribute), {}, {
        title: typeof props.title === "string" ? props.title : void 0,
        className,
        role: props.role || "menuitem",
        "aria-disabled": props.disabled
      });
      if (props.role === "option") {
        attrs = _objectSpread2$1(_objectSpread2$1({}, attrs), {}, {
          role: "option",
          "aria-selected": props.isSelected
        });
      } else if (props.role === null || props.role === "none") {
        attrs.role = "none";
      }
      var mouseEvent = {
        onClick: props.disabled ? null : this.onClick,
        onMouseLeave: props.disabled ? null : this.onMouseLeave,
        onMouseEnter: props.disabled ? null : this.onMouseEnter
      };
      var style2 = _objectSpread2$1({}, props.style);
      if (props.mode === "inline") {
        if (props.direction === "rtl") {
          style2.paddingRight = props.inlineIndent * props.level;
        } else {
          style2.paddingLeft = props.inlineIndent * props.level;
        }
      }
      menuAllProps.forEach(function(key2) {
        return delete props[key2];
      });
      delete props.direction;
      var icon = this.props.itemIcon;
      if (typeof this.props.itemIcon === "function") {
        icon = /* @__PURE__ */ React.createElement(this.props.itemIcon, this.props);
      }
      return /* @__PURE__ */ React.createElement("li", _extends$2({}, omit$1(props, ["onClick", "onMouseEnter", "onMouseLeave", "onSelect"]), attrs, mouseEvent, {
        style: style2,
        ref: this.saveNode
      }), props.children, icon);
    }
  }]);
  return MenuItem2;
}(React.Component);
MenuItem$1.isMenuItem = true;
MenuItem$1.defaultProps = {
  onSelect: noop$4,
  onMouseEnter: noop$4,
  onMouseLeave: noop$4,
  manualRef: noop$4
};
var connected = connect(function(_ref, _ref2) {
  var activeKey = _ref.activeKey, selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey, subMenuKey = _ref2.subMenuKey;
  return {
    active: activeKey[subMenuKey] === eventKey,
    isSelected: Array.isArray(selectedKeys) ? selectedKeys.indexOf(eventKey) !== -1 : selectedKeys === eventKey
  };
})(MenuItem$1);
var MenuItemGroup = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(MenuItemGroup2, _React$Component);
  var _super = _createSuper$1(MenuItemGroup2);
  function MenuItemGroup2() {
    var _this2;
    _classCallCheck$2(this, MenuItemGroup2);
    _this2 = _super.apply(this, arguments);
    _this2.renderInnerMenuItem = function(item) {
      var _this$props = _this2.props, renderMenuItem = _this$props.renderMenuItem, index2 = _this$props.index;
      return renderMenuItem(item, index2, _this2.props.subMenuKey);
    };
    return _this2;
  }
  _createClass$2(MenuItemGroup2, [{
    key: "render",
    value: function render4() {
      var props = _extends$2({}, this.props);
      var _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, rootPrefixCls = props.rootPrefixCls;
      var titleClassName = "".concat(rootPrefixCls, "-item-group-title");
      var listClassName = "".concat(rootPrefixCls, "-item-group-list");
      var title = props.title, children = props.children;
      menuAllProps.forEach(function(key2) {
        return delete props[key2];
      });
      delete props.direction;
      return /* @__PURE__ */ React.createElement("li", _extends$2({}, props, {
        onClick: function onClick(e3) {
          return e3.stopPropagation();
        },
        className: "".concat(className, " ").concat(rootPrefixCls, "-item-group")
      }), /* @__PURE__ */ React.createElement("div", {
        className: titleClassName,
        title: typeof title === "string" ? title : void 0
      }, title), /* @__PURE__ */ React.createElement("ul", {
        className: listClassName
      }, React.Children.map(children, this.renderInnerMenuItem)));
    }
  }]);
  return MenuItemGroup2;
}(React.Component);
MenuItemGroup.isMenuItemGroup = true;
MenuItemGroup.defaultProps = {
  disabled: true
};
var Divider = function Divider2(_ref) {
  var className = _ref.className, rootPrefixCls = _ref.rootPrefixCls, style2 = _ref.style;
  return /* @__PURE__ */ React.createElement("li", {
    className: "".concat(className, " ").concat(rootPrefixCls, "-item-divider"),
    style: style2
  });
};
Divider.defaultProps = {
  disabled: true,
  className: "",
  style: {}
};
var MenuContext = /* @__PURE__ */ createContext2({
  inlineCollapsed: false
});
var SubMenu = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(SubMenu2, _React$Component);
  var _super = _createSuper$1(SubMenu2);
  function SubMenu2() {
    _classCallCheck$2(this, SubMenu2);
    return _super.apply(this, arguments);
  }
  _createClass$2(SubMenu2, [{
    key: "renderTitle",
    value: function renderTitle(inlineCollapsed) {
      var _this$props = this.props, icon = _this$props.icon, title = _this$props.title, level = _this$props.level, rootPrefixCls = _this$props.rootPrefixCls;
      if (!icon) {
        return inlineCollapsed && level === 1 && title && typeof title === "string" ? /* @__PURE__ */ React.createElement("div", {
          className: "".concat(rootPrefixCls, "-inline-collapsed-noicon")
        }, title.charAt(0)) : title;
      }
      var titleIsSpan = isValidElement2(title) && title.type === "span";
      return /* @__PURE__ */ React.createElement(React.Fragment, null, icon, titleIsSpan ? title : /* @__PURE__ */ React.createElement("span", null, title));
    }
  }, {
    key: "render",
    value: function render4() {
      var _this2 = this;
      var _this$props2 = this.props, rootPrefixCls = _this$props2.rootPrefixCls, popupClassName = _this$props2.popupClassName;
      return /* @__PURE__ */ React.createElement(MenuContext.Consumer, null, function(_ref) {
        var inlineCollapsed = _ref.inlineCollapsed, antdMenuTheme = _ref.antdMenuTheme;
        return /* @__PURE__ */ React.createElement(connected$2, _extends$2({}, omit$1(_this2.props, ["icon"]), {
          title: _this2.renderTitle(inlineCollapsed),
          popupClassName: cn(rootPrefixCls, "".concat(rootPrefixCls, "-").concat(antdMenuTheme), popupClassName)
        }));
      });
    }
  }]);
  return SubMenu2;
}(React.Component);
SubMenu.contextType = MenuContext;
SubMenu.isSubMenu = 1;
var BarsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "bars", "theme": "outlined" };
var BarsOutlined = function BarsOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: BarsOutlined$2
  }));
};
BarsOutlined.displayName = "BarsOutlined";
var BarsOutlined$1 = /* @__PURE__ */ React.forwardRef(BarsOutlined);
var LeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, "name": "left", "theme": "outlined" };
var LeftOutlined = function LeftOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: LeftOutlined$2
  }));
};
LeftOutlined.displayName = "LeftOutlined";
var LeftOutlined$1 = /* @__PURE__ */ React.forwardRef(LeftOutlined);
var __rest$E = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var LayoutContext = /* @__PURE__ */ React.createContext({
  siderHook: {
    addSider: function addSider() {
      return null;
    },
    removeSider: function removeSider() {
      return null;
    }
  }
});
function generator(_ref) {
  var suffixCls = _ref.suffixCls, tagName = _ref.tagName, displayName = _ref.displayName;
  return function(BasicComponent) {
    var Adapter = function Adapter2(props) {
      var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
      var customizePrefixCls = props.prefixCls;
      var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
      return /* @__PURE__ */ React.createElement(BasicComponent, _extends$2({
        prefixCls,
        tagName
      }, props));
    };
    Adapter.displayName = displayName;
    return Adapter;
  };
}
var Basic = function Basic2(props) {
  var prefixCls = props.prefixCls, className = props.className, children = props.children, tagName = props.tagName, others = __rest$E(props, ["prefixCls", "className", "children", "tagName"]);
  var classString = cn(prefixCls, className);
  return /* @__PURE__ */ React.createElement(tagName, _extends$2({
    className: classString
  }, others), children);
};
var BasicLayout = function BasicLayout2(props) {
  var _classNames;
  var _React$useContext2 = React.useContext(ConfigContext), direction = _React$useContext2.direction;
  var _React$useState = React.useState([]), _React$useState2 = _slicedToArray$3(_React$useState, 2), siders = _React$useState2[0], setSiders = _React$useState2[1];
  var prefixCls = props.prefixCls, className = props.className, children = props.children, hasSider = props.hasSider, Tag2 = props.tagName, others = __rest$E(props, ["prefixCls", "className", "children", "hasSider", "tagName"]);
  var classString = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-has-sider"), typeof hasSider === "boolean" ? hasSider : siders.length > 0), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
  return /* @__PURE__ */ React.createElement(LayoutContext.Provider, {
    value: {
      siderHook: {
        addSider: function addSider2(id2) {
          setSiders(function(prev) {
            return [].concat(_toConsumableArray(prev), [id2]);
          });
        },
        removeSider: function removeSider2(id2) {
          setSiders(function(prev) {
            return prev.filter(function(currentId) {
              return currentId !== id2;
            });
          });
        }
      }
    }
  }, /* @__PURE__ */ React.createElement(Tag2, _extends$2({
    className: classString
  }, others), children));
};
var Layout$1 = generator({
  suffixCls: "layout",
  tagName: "section",
  displayName: "Layout"
})(BasicLayout);
var Header$3 = generator({
  suffixCls: "layout-header",
  tagName: "header",
  displayName: "Header"
})(Basic);
var Footer = generator({
  suffixCls: "layout-footer",
  tagName: "footer",
  displayName: "Footer"
})(Basic);
var Content$3 = generator({
  suffixCls: "layout-content",
  tagName: "main",
  displayName: "Content"
})(Basic);
var isNumeric$1 = function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};
var __rest$D = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var dimensionMaxMap = {
  xs: "479.98px",
  sm: "575.98px",
  md: "767.98px",
  lg: "991.98px",
  xl: "1199.98px",
  xxl: "1599.98px"
};
var SiderContext = /* @__PURE__ */ React.createContext({});
var generateId = function() {
  var i2 = 0;
  return function() {
    var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    i2 += 1;
    return "".concat(prefix).concat(i2);
  };
}();
var Sider = /* @__PURE__ */ React.forwardRef(function(_a, ref) {
  var customizePrefixCls = _a.prefixCls, className = _a.className, trigger = _a.trigger, children = _a.children, _a$defaultCollapsed = _a.defaultCollapsed, defaultCollapsed = _a$defaultCollapsed === void 0 ? false : _a$defaultCollapsed, _a$theme = _a.theme, theme = _a$theme === void 0 ? "dark" : _a$theme, _a$style = _a.style, style2 = _a$style === void 0 ? {} : _a$style, _a$collapsible = _a.collapsible, collapsible = _a$collapsible === void 0 ? false : _a$collapsible, _a$reverseArrow = _a.reverseArrow, reverseArrow = _a$reverseArrow === void 0 ? false : _a$reverseArrow, _a$width = _a.width, width = _a$width === void 0 ? 200 : _a$width, _a$collapsedWidth = _a.collapsedWidth, collapsedWidth = _a$collapsedWidth === void 0 ? 80 : _a$collapsedWidth, zeroWidthTriggerStyle = _a.zeroWidthTriggerStyle, breakpoint = _a.breakpoint, onCollapse = _a.onCollapse, onBreakpoint = _a.onBreakpoint, props = __rest$D(_a, ["prefixCls", "className", "trigger", "children", "defaultCollapsed", "theme", "style", "collapsible", "reverseArrow", "width", "collapsedWidth", "zeroWidthTriggerStyle", "breakpoint", "onCollapse", "onBreakpoint"]);
  var _useContext = useContext2(LayoutContext), siderHook = _useContext.siderHook;
  var _useState = useState2("collapsed" in props ? props.collapsed : defaultCollapsed), _useState2 = _slicedToArray$3(_useState, 2), collapsed = _useState2[0], setCollapsed = _useState2[1];
  var _useState3 = useState2(false), _useState4 = _slicedToArray$3(_useState3, 2), below = _useState4[0], setBelow = _useState4[1];
  useEffect2(function() {
    if ("collapsed" in props) {
      setCollapsed(props.collapsed);
    }
  }, [props.collapsed]);
  var handleSetCollapsed = function handleSetCollapsed2(value, type2) {
    if (!("collapsed" in props)) {
      setCollapsed(value);
    }
    onCollapse === null || onCollapse === void 0 ? void 0 : onCollapse(value, type2);
  };
  var responsiveHandlerRef = useRef2();
  responsiveHandlerRef.current = function(mql) {
    setBelow(mql.matches);
    onBreakpoint === null || onBreakpoint === void 0 ? void 0 : onBreakpoint(mql.matches);
    if (collapsed !== mql.matches) {
      handleSetCollapsed(mql.matches, "responsive");
    }
  };
  useEffect2(function() {
    function responsiveHandler(mql2) {
      return responsiveHandlerRef.current(mql2);
    }
    var mql;
    if (typeof window !== "undefined") {
      var _window = window, matchMedia = _window.matchMedia;
      if (matchMedia && breakpoint && breakpoint in dimensionMaxMap) {
        mql = matchMedia("(max-width: ".concat(dimensionMaxMap[breakpoint], ")"));
        try {
          mql.addEventListener("change", responsiveHandler);
        } catch (error) {
          mql.addListener(responsiveHandler);
        }
        responsiveHandler(mql);
      }
    }
    return function() {
      try {
        mql === null || mql === void 0 ? void 0 : mql.removeEventListener("change", responsiveHandler);
      } catch (error) {
        mql === null || mql === void 0 ? void 0 : mql.removeListener(responsiveHandler);
      }
    };
  }, []);
  useEffect2(function() {
    var uniqueId = generateId("ant-sider-");
    siderHook.addSider(uniqueId);
    return function() {
      return siderHook.removeSider(uniqueId);
    };
  }, []);
  var toggle = function toggle2() {
    handleSetCollapsed(!collapsed, "clickTrigger");
  };
  var _useContext2 = useContext2(ConfigContext), getPrefixCls = _useContext2.getPrefixCls;
  var renderSider = function renderSider2() {
    var _classNames;
    var prefixCls = getPrefixCls("layout-sider", customizePrefixCls);
    var divProps = omit$1(props, ["collapsed"]);
    var rawWidth = collapsed ? collapsedWidth : width;
    var siderWidth = isNumeric$1(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth);
    var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /* @__PURE__ */ React.createElement("span", {
      onClick: toggle,
      className: cn("".concat(prefixCls, "-zero-width-trigger"), "".concat(prefixCls, "-zero-width-trigger-").concat(reverseArrow ? "right" : "left")),
      style: zeroWidthTriggerStyle
    }, trigger || /* @__PURE__ */ React.createElement(BarsOutlined$1, null)) : null;
    var iconObj = {
      expanded: reverseArrow ? /* @__PURE__ */ React.createElement(RightOutlined$1, null) : /* @__PURE__ */ React.createElement(LeftOutlined$1, null),
      collapsed: reverseArrow ? /* @__PURE__ */ React.createElement(LeftOutlined$1, null) : /* @__PURE__ */ React.createElement(RightOutlined$1, null)
    };
    var status = collapsed ? "collapsed" : "expanded";
    var defaultTrigger = iconObj[status];
    var triggerDom = trigger !== null ? zeroWidthTrigger || /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-trigger"),
      onClick: toggle,
      style: {
        width: siderWidth
      }
    }, trigger || defaultTrigger) : null;
    var divStyle = _extends$2(_extends$2({}, style2), {
      flex: "0 0 ".concat(siderWidth),
      maxWidth: siderWidth,
      minWidth: siderWidth,
      width: siderWidth
    });
    var siderCls = cn(prefixCls, "".concat(prefixCls, "-").concat(theme), (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-collapsed"), !!collapsed), _defineProperty$4(_classNames, "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), _defineProperty$4(_classNames, "".concat(prefixCls, "-below"), !!below), _defineProperty$4(_classNames, "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), _classNames), className);
    return /* @__PURE__ */ React.createElement("aside", _extends$2({
      className: siderCls
    }, divProps, {
      style: divStyle,
      ref
    }), /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-children")
    }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null);
  };
  return /* @__PURE__ */ React.createElement(SiderContext.Provider, {
    value: {
      siderCollapsed: collapsed,
      collapsedWidth
    }
  }, renderSider());
});
Sider.displayName = "Sider";
var __rest$C = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var MenuItem = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(MenuItem2, _React$Component);
  var _super = _createSuper$1(MenuItem2);
  function MenuItem2() {
    var _this2;
    _classCallCheck$2(this, MenuItem2);
    _this2 = _super.apply(this, arguments);
    _this2.renderItem = function(_ref) {
      var siderCollapsed = _ref.siderCollapsed;
      var _this$props = _this2.props, level = _this$props.level, className = _this$props.className, children = _this$props.children, rootPrefixCls = _this$props.rootPrefixCls;
      var _a = _this2.props, title = _a.title, icon = _a.icon, danger = _a.danger, rest = __rest$C(_a, ["title", "icon", "danger"]);
      return /* @__PURE__ */ React.createElement(MenuContext.Consumer, null, function(_ref2) {
        var _classNames;
        var inlineCollapsed = _ref2.inlineCollapsed, direction = _ref2.direction;
        var _a2;
        var tooltipTitle = title;
        if (typeof title === "undefined") {
          tooltipTitle = level === 1 ? children : "";
        } else if (title === false) {
          tooltipTitle = "";
        }
        var tooltipProps = {
          title: tooltipTitle
        };
        if (!siderCollapsed && !inlineCollapsed) {
          tooltipProps.title = null;
          tooltipProps.visible = false;
        }
        var childrenLength = toArray$8(children).length;
        return /* @__PURE__ */ React.createElement(Tooltip2, _extends$2({}, tooltipProps, {
          placement: direction === "rtl" ? "left" : "right",
          overlayClassName: "".concat(rootPrefixCls, "-inline-collapsed-tooltip")
        }), /* @__PURE__ */ React.createElement(connected, _extends$2({}, rest, {
          className: cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(rootPrefixCls, "-item-danger"), danger), _defineProperty$4(_classNames, "".concat(rootPrefixCls, "-item-only-child"), (icon ? childrenLength + 1 : childrenLength) === 1), _classNames), className),
          title
        }), cloneElement2(icon, {
          className: cn(isValidElement2(icon) ? (_a2 = icon.props) === null || _a2 === void 0 ? void 0 : _a2.className : "", "".concat(rootPrefixCls, "-item-icon"))
        }), _this2.renderItemChildren(inlineCollapsed)));
      });
    };
    return _this2;
  }
  _createClass$2(MenuItem2, [{
    key: "renderItemChildren",
    value: function renderItemChildren(inlineCollapsed) {
      var _this$props2 = this.props, icon = _this$props2.icon, children = _this$props2.children, level = _this$props2.level, rootPrefixCls = _this$props2.rootPrefixCls;
      if (!icon || isValidElement2(children) && children.type === "span") {
        if (children && inlineCollapsed && level === 1 && typeof children === "string") {
          return /* @__PURE__ */ React.createElement("div", {
            className: "".concat(rootPrefixCls, "-inline-collapsed-noicon")
          }, children.charAt(0));
        }
        return children;
      }
      return /* @__PURE__ */ React.createElement("span", null, children);
    }
  }, {
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(SiderContext.Consumer, null, this.renderItem);
    }
  }]);
  return MenuItem2;
}(React.Component);
MenuItem.isMenuItem = true;
var InternalMenu = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(InternalMenu2, _React$Component);
  var _super = _createSuper$1(InternalMenu2);
  function InternalMenu2(props) {
    var _this2;
    _classCallCheck$2(this, InternalMenu2);
    _this2 = _super.call(this, props);
    _this2.renderMenu = function(_ref) {
      var getPopupContainer = _ref.getPopupContainer, getPrefixCls = _ref.getPrefixCls, direction = _ref.direction;
      var rootPrefixCls = getPrefixCls();
      var _this$props = _this2.props, customizePrefixCls = _this$props.prefixCls, className = _this$props.className, theme = _this$props.theme, expandIcon = _this$props.expandIcon;
      var defaultMotions = {
        horizontal: {
          motionName: "".concat(rootPrefixCls, "-slide-up")
        },
        inline: collapseMotion,
        other: {
          motionName: "".concat(rootPrefixCls, "-zoom-big")
        }
      };
      var prefixCls = getPrefixCls("menu", customizePrefixCls);
      var menuClassName = cn("".concat(prefixCls, "-").concat(theme), _defineProperty$4({}, "".concat(prefixCls, "-inline-collapsed"), _this2.getInlineCollapsed()), className);
      return /* @__PURE__ */ React.createElement(MenuContext.Provider, {
        value: {
          inlineCollapsed: _this2.getInlineCollapsed() || false,
          antdMenuTheme: theme,
          direction
        }
      }, /* @__PURE__ */ React.createElement(Menu$1, _extends$2({
        getPopupContainer
      }, _this2.props, {
        className: menuClassName,
        prefixCls,
        direction,
        defaultMotions,
        expandIcon: cloneElement2(expandIcon, {
          className: "".concat(prefixCls, "-submenu-expand-icon")
        })
      })));
    };
    devWarning(!("inlineCollapsed" in props && props.mode !== "inline"), "Menu", "`inlineCollapsed` should only be used when `mode` is inline.");
    devWarning(!(props.siderCollapsed !== void 0 && "inlineCollapsed" in props), "Menu", "`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.");
    return _this2;
  }
  _createClass$2(InternalMenu2, [{
    key: "getInlineCollapsed",
    value: function getInlineCollapsed() {
      var _this$props2 = this.props, inlineCollapsed = _this$props2.inlineCollapsed, siderCollapsed = _this$props2.siderCollapsed;
      if (siderCollapsed !== void 0) {
        return siderCollapsed;
      }
      return inlineCollapsed;
    }
  }, {
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(ConfigConsumer, null, this.renderMenu);
    }
  }]);
  return InternalMenu2;
}(React.Component);
InternalMenu.defaultProps = {
  className: "",
  theme: "light",
  focusable: false
};
var Menu = /* @__PURE__ */ function(_React$Component2) {
  _inherits$1(Menu2, _React$Component2);
  var _super2 = _createSuper$1(Menu2);
  function Menu2() {
    _classCallCheck$2(this, Menu2);
    return _super2.apply(this, arguments);
  }
  _createClass$2(Menu2, [{
    key: "render",
    value: function render4() {
      var _this2 = this;
      return /* @__PURE__ */ React.createElement(SiderContext.Consumer, null, function(context2) {
        return /* @__PURE__ */ React.createElement(InternalMenu, _extends$2({}, _this2.props, context2));
      });
    }
  }]);
  return Menu2;
}(React.Component);
Menu.Divider = Divider;
Menu.Item = MenuItem;
Menu.SubMenu = SubMenu;
Menu.ItemGroup = MenuItemGroup;
function commonjsRequire(path2) {
  throw new Error('Could not dynamically require "' + path2 + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var moment$1 = { exports: {} };
(function(module, exports) {
  (function(global2, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    var hookCallback;
    function hooks() {
      return hookCallback.apply(null, arguments);
    }
    function setHookCallback(callback) {
      hookCallback = callback;
    }
    function isArray2(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject2(input) {
      return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a2, b2) {
      return Object.prototype.hasOwnProperty.call(a2, b2);
    }
    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k2;
        for (k2 in obj) {
          if (hasOwnProp(obj, k2)) {
            return false;
          }
        }
        return true;
      }
    }
    function isUndefined(input) {
      return input === void 0;
    }
    function isNumber(input) {
      return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
      var res = [], i2, arrLen = arr.length;
      for (i2 = 0; i2 < arrLen; ++i2) {
        res.push(fn(arr[i2], i2));
      }
      return res;
    }
    function extend(a2, b2) {
      for (var i2 in b2) {
        if (hasOwnProp(b2, i2)) {
          a2[i2] = b2[i2];
        }
      }
      if (hasOwnProp(b2, "toString")) {
        a2.toString = b2.toString;
      }
      if (hasOwnProp(b2, "valueOf")) {
        a2.valueOf = b2.valueOf;
      }
      return a2;
    }
    function createUTC(input, format4, locale3, strict) {
      return createLocalOrUTC(input, format4, locale3, strict, true).utc();
    }
    function defaultParsingFlags() {
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }
    function getParsingFlags(m2) {
      if (m2._pf == null) {
        m2._pf = defaultParsingFlags();
      }
      return m2._pf;
    }
    var some;
    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function(fun) {
        var t3 = Object(this), len = t3.length >>> 0, i2;
        for (i2 = 0; i2 < len; i2++) {
          if (i2 in t3 && fun.call(this, t3[i2], i2, t3)) {
            return true;
          }
        }
        return false;
      };
    }
    function isValid(m2) {
      if (m2._isValid == null) {
        var flags = getParsingFlags(m2), parsedParts = some.call(flags.parsedDateParts, function(i2) {
          return i2 != null;
        }), isNowValid = !isNaN(m2._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
        if (m2._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === void 0;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m2)) {
          m2._isValid = isNowValid;
        } else {
          return isNowValid;
        }
      }
      return m2._isValid;
    }
    function createInvalid(flags) {
      var m2 = createUTC(NaN);
      if (flags != null) {
        extend(getParsingFlags(m2), flags);
      } else {
        getParsingFlags(m2).userInvalidated = true;
      }
      return m2;
    }
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to2, from2) {
      var i2, prop, val, momentPropertiesLen = momentProperties.length;
      if (!isUndefined(from2._isAMomentObject)) {
        to2._isAMomentObject = from2._isAMomentObject;
      }
      if (!isUndefined(from2._i)) {
        to2._i = from2._i;
      }
      if (!isUndefined(from2._f)) {
        to2._f = from2._f;
      }
      if (!isUndefined(from2._l)) {
        to2._l = from2._l;
      }
      if (!isUndefined(from2._strict)) {
        to2._strict = from2._strict;
      }
      if (!isUndefined(from2._tzm)) {
        to2._tzm = from2._tzm;
      }
      if (!isUndefined(from2._isUTC)) {
        to2._isUTC = from2._isUTC;
      }
      if (!isUndefined(from2._offset)) {
        to2._offset = from2._offset;
      }
      if (!isUndefined(from2._pf)) {
        to2._pf = getParsingFlags(from2);
      }
      if (!isUndefined(from2._locale)) {
        to2._locale = from2._locale;
      }
      if (momentPropertiesLen > 0) {
        for (i2 = 0; i2 < momentPropertiesLen; i2++) {
          prop = momentProperties[i2];
          val = from2[prop];
          if (!isUndefined(val)) {
            to2[prop] = val;
          }
        }
      }
      return to2;
    }
    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);
      if (!this.isValid()) {
        this._d = new Date(NaN);
      }
      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }
    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
        console.warn("Deprecation warning: " + msg);
      }
    }
    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function() {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
          var args = [], arg, i2, key2, argLen = arguments.length;
          for (i2 = 0; i2 < argLen; i2++) {
            arg = "";
            if (typeof arguments[i2] === "object") {
              arg += "\n[" + i2 + "] ";
              for (key2 in arguments[0]) {
                if (hasOwnProp(arguments[0], key2)) {
                  arg += key2 + ": " + arguments[0][key2] + ", ";
                }
              }
              arg = arg.slice(0, -2);
            } else {
              arg = arguments[i2];
            }
            args.push(arg);
          }
          warn(
            msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack
          );
          firstTime = false;
        }
        return fn.apply(this, arguments);
      }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }
      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction2(input) {
      return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set2(config) {
      var prop, i2;
      for (i2 in config) {
        if (hasOwnProp(config, i2)) {
          prop = config[i2];
          if (isFunction2(prop)) {
            this[i2] = prop;
          } else {
            this["_" + i2] = prop;
          }
        }
      }
      this._config = config;
      this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
      );
    }
    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig), prop;
      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject2(parentConfig[prop]) && isObject2(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }
      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject2(parentConfig[prop])) {
          res[prop] = extend({}, res[prop]);
        }
      }
      return res;
    }
    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }
    var keys2;
    if (Object.keys) {
      keys2 = Object.keys;
    } else {
      keys2 = function(obj) {
        var i2, res = [];
        for (i2 in obj) {
          if (hasOwnProp(obj, i2)) {
            res.push(i2);
          }
        }
        return res;
      };
    }
    var defaultCalendar = {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    };
    function calendar(key2, mom, now3) {
      var output = this._calendar[key2] || this._calendar["sameElse"];
      return isFunction2(output) ? output.call(mom, now3) : output;
    }
    function zeroFill(number3, targetLength, forceSign) {
      var absNumber = "" + Math.abs(number3), zerosToFill = targetLength - absNumber.length, sign2 = number3 >= 0;
      return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    function addFormatToken(token2, padded, ordinal2, callback) {
      var func = callback;
      if (typeof callback === "string") {
        func = function() {
          return this[callback]();
        };
      }
      if (token2) {
        formatTokenFunctions[token2] = func;
      }
      if (padded) {
        formatTokenFunctions[padded[0]] = function() {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }
      if (ordinal2) {
        formatTokenFunctions[ordinal2] = function() {
          return this.localeData().ordinal(
            func.apply(this, arguments),
            token2
          );
        };
      }
    }
    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, "");
      }
      return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format4) {
      var array3 = format4.match(formattingTokens), i2, length;
      for (i2 = 0, length = array3.length; i2 < length; i2++) {
        if (formatTokenFunctions[array3[i2]]) {
          array3[i2] = formatTokenFunctions[array3[i2]];
        } else {
          array3[i2] = removeFormattingTokens(array3[i2]);
        }
      }
      return function(mom) {
        var output = "", i3;
        for (i3 = 0; i3 < length; i3++) {
          output += isFunction2(array3[i3]) ? array3[i3].call(mom, format4) : array3[i3];
        }
        return output;
      };
    }
    function formatMoment(m2, format4) {
      if (!m2.isValid()) {
        return m2.localeData().invalidDate();
      }
      format4 = expandFormat(format4, m2.localeData());
      formatFunctions[format4] = formatFunctions[format4] || makeFormatFunction(format4);
      return formatFunctions[format4](m2);
    }
    function expandFormat(format4, locale3) {
      var i2 = 5;
      function replaceLongDateFormatTokens(input) {
        return locale3.longDateFormat(input) || input;
      }
      localFormattingTokens.lastIndex = 0;
      while (i2 >= 0 && localFormattingTokens.test(format4)) {
        format4 = format4.replace(
          localFormattingTokens,
          replaceLongDateFormatTokens
        );
        localFormattingTokens.lastIndex = 0;
        i2 -= 1;
      }
      return format4;
    }
    var defaultLongDateFormat = {
      LTS: "h:mm:ss A",
      LT: "h:mm A",
      L: "MM/DD/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key2) {
      var format4 = this._longDateFormat[key2], formatUpper = this._longDateFormat[key2.toUpperCase()];
      if (format4 || !formatUpper) {
        return format4;
      }
      this._longDateFormat[key2] = formatUpper.match(formattingTokens).map(function(tok) {
        if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
          return tok.slice(1);
        }
        return tok;
      }).join("");
      return this._longDateFormat[key2];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
      return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number3) {
      return this._ordinal.replace("%d", number3);
    }
    var defaultRelativeTime = {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      w: "a week",
      ww: "%d weeks",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    };
    function relativeTime(number3, withoutSuffix, string2, isFuture) {
      var output = this._relativeTime[string2];
      return isFunction2(output) ? output(number3, withoutSuffix, string2, isFuture) : output.replace(/%d/i, number3);
    }
    function pastFuture(diff2, output) {
      var format4 = this._relativeTime[diff2 > 0 ? "future" : "past"];
      return isFunction2(format4) ? format4(output) : format4.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase();
      aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
      return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : void 0;
    }
    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {}, normalizedProp, prop;
      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);
          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }
      return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
      priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
      var units = [], u2;
      for (u2 in unitsObj) {
        if (hasOwnProp(unitsObj, u2)) {
          units.push({ unit: u2, priority: priorities[u2] });
        }
      }
      units.sort(function(a2, b2) {
        return a2.priority - b2.priority;
      });
      return units;
    }
    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number3) {
      if (number3 < 0) {
        return Math.ceil(number3) || 0;
      } else {
        return Math.floor(number3);
      }
    }
    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion, value = 0;
      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }
      return value;
    }
    function makeGetSet(unit, keepTime) {
      return function(value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get2(this, unit);
        }
      };
    }
    function get2(mom, unit) {
      return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
          value = toInt(value);
          mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](
            value,
            mom.month(),
            daysInMonth(value, mom.month())
          );
        } else {
          mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
      }
    }
    function stringGet(units) {
      units = normalizeUnits(units);
      if (isFunction2(this[units])) {
        return this[units]();
      }
      return this;
    }
    function stringSet(units, value) {
      if (typeof units === "object") {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units), i2, prioritizedLen = prioritized.length;
        for (i2 = 0; i2 < prioritizedLen; i2++) {
          this[prioritized[i2].unit](units[prioritized[i2].unit]);
        }
      } else {
        units = normalizeUnits(units);
        if (isFunction2(this[units])) {
          return this[units](value);
        }
      }
      return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token2, regex, strictRegex) {
      regexes[token2] = isFunction2(regex) ? regex : function(isStrict, localeData2) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }
    function getParseRegexForToken(token2, config) {
      if (!hasOwnProp(regexes, token2)) {
        return new RegExp(unescapeFormat(token2));
      }
      return regexes[token2](config._strict, config._locale);
    }
    function unescapeFormat(s2) {
      return regexEscape(
        s2.replace("\\", "").replace(
          /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
          function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
          }
        )
      );
    }
    function regexEscape(s2) {
      return s2.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token2, callback) {
      var i2, func = callback, tokenLen;
      if (typeof token2 === "string") {
        token2 = [token2];
      }
      if (isNumber(callback)) {
        func = function(input, array3) {
          array3[callback] = toInt(input);
        };
      }
      tokenLen = token2.length;
      for (i2 = 0; i2 < tokenLen; i2++) {
        tokens[token2[i2]] = func;
      }
    }
    function addWeekParseToken(token2, callback) {
      addParseToken(token2, function(input, array3, config, token3) {
        config._w = config._w || {};
        callback(input, config._w, config, token3);
      });
    }
    function addTimeToArrayFromToken(token2, input, config) {
      if (input != null && hasOwnProp(tokens, token2)) {
        tokens[token2](input, config._a, config, token2);
      }
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n3, x2) {
      return (n3 % x2 + x2) % x2;
    }
    var indexOf;
    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function(o2) {
        var i2;
        for (i2 = 0; i2 < this.length; ++i2) {
          if (this[i2] === o2) {
            return i2;
          }
        }
        return -1;
      };
    }
    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }
      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    addFormatToken("M", ["MM", 2], "Mo", function() {
      return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format4) {
      return this.localeData().monthsShort(this, format4);
    });
    addFormatToken("MMMM", 0, 0, function(format4) {
      return this.localeData().months(this, format4);
    });
    addUnitAlias("month", "M");
    addUnitPriority("month", 8);
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale3) {
      return locale3.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale3) {
      return locale3.monthsRegex(isStrict);
    });
    addParseToken(["M", "MM"], function(input, array3) {
      array3[MONTH] = toInt(input) - 1;
    });
    addParseToken(["MMM", "MMMM"], function(input, array3, config, token2) {
      var month = config._locale.monthsParse(input, token2, config._strict);
      if (month != null) {
        array3[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    });
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    ), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m2, format4) {
      if (!m2) {
        return isArray2(this._months) ? this._months : this._months["standalone"];
      }
      return isArray2(this._months) ? this._months[m2.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format4) ? "format" : "standalone"][m2.month()];
    }
    function localeMonthsShort(m2, format4) {
      if (!m2) {
        return isArray2(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
      }
      return isArray2(this._monthsShort) ? this._monthsShort[m2.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format4) ? "format" : "standalone"][m2.month()];
    }
    function handleStrictParse(monthName, format4, strict) {
      var i2, ii, mom, llc = monthName.toLocaleLowerCase();
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i2 = 0; i2 < 12; ++i2) {
          mom = createUTC([2e3, i2]);
          this._shortMonthsParse[i2] = this.monthsShort(
            mom,
            ""
          ).toLocaleLowerCase();
          this._longMonthsParse[i2] = this.months(mom, "").toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format4 === "MMM") {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format4 === "MMM") {
          ii = indexOf.call(this._shortMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeMonthsParse(monthName, format4, strict) {
      var i2, mom, regex;
      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format4, strict);
      }
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      }
      for (i2 = 0; i2 < 12; i2++) {
        mom = createUTC([2e3, i2]);
        if (strict && !this._longMonthsParse[i2]) {
          this._longMonthsParse[i2] = new RegExp(
            "^" + this.months(mom, "").replace(".", "") + "$",
            "i"
          );
          this._shortMonthsParse[i2] = new RegExp(
            "^" + this.monthsShort(mom, "").replace(".", "") + "$",
            "i"
          );
        }
        if (!strict && !this._monthsParse[i2]) {
          regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
          this._monthsParse[i2] = new RegExp(regex.replace(".", ""), "i");
        }
        if (strict && format4 === "MMMM" && this._longMonthsParse[i2].test(monthName)) {
          return i2;
        } else if (strict && format4 === "MMM" && this._shortMonthsParse[i2].test(monthName)) {
          return i2;
        } else if (!strict && this._monthsParse[i2].test(monthName)) {
          return i2;
        }
      }
    }
    function setMonth2(mom, value) {
      var dayOfMonth;
      if (!mom.isValid()) {
        return mom;
      }
      if (typeof value === "string") {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value);
          if (!isNumber(value)) {
            return mom;
          }
        }
      }
      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
      mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
      return mom;
    }
    function getSetMonth(value) {
      if (value != null) {
        setMonth2(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get2(this, "Month");
      }
    }
    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, "_monthsRegex")) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, "_monthsShortRegex")) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }
    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, "_monthsRegex")) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, "_monthsRegex")) {
          this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }
    function computeMonthsParse() {
      function cmpLenRev(a2, b2) {
        return b2.length - a2.length;
      }
      var shortPieces = [], longPieces = [], mixedPieces = [], i2, mom;
      for (i2 = 0; i2 < 12; i2++) {
        mom = createUTC([2e3, i2]);
        shortPieces.push(this.monthsShort(mom, ""));
        longPieces.push(this.months(mom, ""));
        mixedPieces.push(this.months(mom, ""));
        mixedPieces.push(this.monthsShort(mom, ""));
      }
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      for (i2 = 0; i2 < 12; i2++) {
        shortPieces[i2] = regexEscape(shortPieces[i2]);
        longPieces[i2] = regexEscape(longPieces[i2]);
      }
      for (i2 = 0; i2 < 24; i2++) {
        mixedPieces[i2] = regexEscape(mixedPieces[i2]);
      }
      this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp(
        "^(" + longPieces.join("|") + ")",
        "i"
      );
      this._monthsShortStrictRegex = new RegExp(
        "^(" + shortPieces.join("|") + ")",
        "i"
      );
    }
    addFormatToken("Y", 0, 0, function() {
      var y2 = this.year();
      return y2 <= 9999 ? zeroFill(y2, 4) : "+" + y2;
    });
    addFormatToken(0, ["YY", 2], 0, function() {
      return this.year() % 100;
    });
    addFormatToken(0, ["YYYY", 4], 0, "year");
    addFormatToken(0, ["YYYYY", 5], 0, "year");
    addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
    addUnitAlias("year", "y");
    addUnitPriority("year", 1);
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken(["YYYYY", "YYYYYY"], YEAR);
    addParseToken("YYYY", function(input, array3) {
      array3[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array3) {
      array3[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array3) {
      array3[YEAR] = parseInt(input, 10);
    });
    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }
    hooks.parseTwoDigitYear = function(input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
    };
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
      return isLeapYear(this.year());
    }
    function createDate(y2, m2, d, h, M2, s2, ms) {
      var date3;
      if (y2 < 100 && y2 >= 0) {
        date3 = new Date(y2 + 400, m2, d, h, M2, s2, ms);
        if (isFinite(date3.getFullYear())) {
          date3.setFullYear(y2);
        }
      } else {
        date3 = new Date(y2, m2, d, h, M2, s2, ms);
      }
      return date3;
    }
    function createUTCDate(y2) {
      var date3, args;
      if (y2 < 100 && y2 >= 0) {
        args = Array.prototype.slice.call(arguments);
        args[0] = y2 + 400;
        date3 = new Date(Date.UTC.apply(null, args));
        if (isFinite(date3.getUTCFullYear())) {
          date3.setUTCFullYear(y2);
        }
      } else {
        date3 = new Date(Date.UTC.apply(null, arguments));
      }
      return date3;
    }
    function firstWeekOffset(year, dow, doy) {
      var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    }
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }
      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }
    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }
      return {
        week: resWeek,
        year: resYear
      };
    }
    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    addFormatToken("w", ["ww", 2], "wo", "week");
    addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken(
      ["w", "ww", "W", "WW"],
      function(input, week, config, token2) {
        week[token2.substr(0, 1)] = toInt(input);
      }
    );
    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
      dow: 0,
      doy: 6
    };
    function localeFirstDayOfWeek() {
      return this._week.dow;
    }
    function localeFirstDayOfYear() {
      return this._week.doy;
    }
    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, "d");
    }
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format4) {
      return this.localeData().weekdaysMin(this, format4);
    });
    addFormatToken("ddd", 0, 0, function(format4) {
      return this.localeData().weekdaysShort(this, format4);
    });
    addFormatToken("dddd", 0, 0, function(format4) {
      return this.localeData().weekdays(this, format4);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale3) {
      return locale3.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale3) {
      return locale3.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale3) {
      return locale3.weekdaysRegex(isStrict);
    });
    addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config, token2) {
      var weekday = config._locale.weekdaysParse(input, token2, config._strict);
      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });
    addWeekParseToken(["d", "e", "E"], function(input, week, config, token2) {
      week[token2] = toInt(input);
    });
    function parseWeekday(input, locale3) {
      if (typeof input !== "string") {
        return input;
      }
      if (!isNaN(input)) {
        return parseInt(input, 10);
      }
      input = locale3.weekdaysParse(input);
      if (typeof input === "number") {
        return input;
      }
      return null;
    }
    function parseIsoWeekday(input, locale3) {
      if (typeof input === "string") {
        return locale3.weekdaysParse(input) % 7 || 7;
      }
      return isNaN(input) ? null : input;
    }
    function shiftWeekdays(ws, n3) {
      return ws.slice(n3, 7).concat(ws.slice(0, n3));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m2, format4) {
      var weekdays = isArray2(this._weekdays) ? this._weekdays : this._weekdays[m2 && m2 !== true && this._weekdays.isFormat.test(format4) ? "format" : "standalone"];
      return m2 === true ? shiftWeekdays(weekdays, this._week.dow) : m2 ? weekdays[m2.day()] : weekdays;
    }
    function localeWeekdaysShort(m2) {
      return m2 === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m2 ? this._weekdaysShort[m2.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m2) {
      return m2 === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m2 ? this._weekdaysMin[m2.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format4, strict) {
      var i2, ii, mom, llc = weekdayName.toLocaleLowerCase();
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];
        for (i2 = 0; i2 < 7; ++i2) {
          mom = createUTC([2e3, 1]).day(i2);
          this._minWeekdaysParse[i2] = this.weekdaysMin(
            mom,
            ""
          ).toLocaleLowerCase();
          this._shortWeekdaysParse[i2] = this.weekdaysShort(
            mom,
            ""
          ).toLocaleLowerCase();
          this._weekdaysParse[i2] = this.weekdays(mom, "").toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format4 === "dddd") {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format4 === "ddd") {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format4 === "dddd") {
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format4 === "ddd") {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeWeekdaysParse(weekdayName, format4, strict) {
      var i2, mom, regex;
      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format4, strict);
      }
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }
      for (i2 = 0; i2 < 7; i2++) {
        mom = createUTC([2e3, 1]).day(i2);
        if (strict && !this._fullWeekdaysParse[i2]) {
          this._fullWeekdaysParse[i2] = new RegExp(
            "^" + this.weekdays(mom, "").replace(".", "\\.?") + "$",
            "i"
          );
          this._shortWeekdaysParse[i2] = new RegExp(
            "^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$",
            "i"
          );
          this._minWeekdaysParse[i2] = new RegExp(
            "^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$",
            "i"
          );
        }
        if (!this._weekdaysParse[i2]) {
          regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
          this._weekdaysParse[i2] = new RegExp(regex.replace(".", ""), "i");
        }
        if (strict && format4 === "dddd" && this._fullWeekdaysParse[i2].test(weekdayName)) {
          return i2;
        } else if (strict && format4 === "ddd" && this._shortWeekdaysParse[i2].test(weekdayName)) {
          return i2;
        } else if (strict && format4 === "dd" && this._minWeekdaysParse[i2].test(weekdayName)) {
          return i2;
        } else if (!strict && this._weekdaysParse[i2].test(weekdayName)) {
          return i2;
        }
      }
    }
    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, "d");
      } else {
        return day;
      }
    }
    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }
    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }
    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, "_weekdaysShortRegex")) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }
    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, "_weekdaysMinRegex")) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }
    function computeWeekdaysParse() {
      function cmpLenRev(a2, b2) {
        return b2.length - a2.length;
      }
      var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i2, mom, minp, shortp, longp;
      for (i2 = 0; i2 < 7; i2++) {
        mom = createUTC([2e3, 1]).day(i2);
        minp = regexEscape(this.weekdaysMin(mom, ""));
        shortp = regexEscape(this.weekdaysShort(mom, ""));
        longp = regexEscape(this.weekdays(mom, ""));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      }
      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp(
        "^(" + longPieces.join("|") + ")",
        "i"
      );
      this._weekdaysShortStrictRegex = new RegExp(
        "^(" + shortPieces.join("|") + ")",
        "i"
      );
      this._weekdaysMinStrictRegex = new RegExp(
        "^(" + minPieces.join("|") + ")",
        "i"
      );
    }
    function hFormat() {
      return this.hours() % 12 || 12;
    }
    function kFormat() {
      return this.hours() || 24;
    }
    addFormatToken("H", ["HH", 2], 0, "hour");
    addFormatToken("h", ["hh", 2], 0, hFormat);
    addFormatToken("k", ["kk", 2], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
      return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
      return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
      return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
      return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token2, lowercase) {
      addFormatToken(token2, 0, 0, function() {
        return this.localeData().meridiem(
          this.hours(),
          this.minutes(),
          lowercase
        );
      });
    }
    meridiem("a", true);
    meridiem("A", false);
    addUnitAlias("hour", "h");
    addUnitPriority("hour", 13);
    function matchMeridiem(isStrict, locale3) {
      return locale3._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken(["H", "HH"], HOUR);
    addParseToken(["k", "kk"], function(input, array3, config) {
      var kInput = toInt(input);
      array3[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(["a", "A"], function(input, array3, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(["h", "hh"], function(input, array3, config) {
      array3[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array3, config) {
      var pos = input.length - 2;
      array3[HOUR] = toInt(input.substr(0, pos));
      array3[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array3, config) {
      var pos1 = input.length - 4, pos2 = input.length - 2;
      array3[HOUR] = toInt(input.substr(0, pos1));
      array3[MINUTE] = toInt(input.substr(pos1, 2));
      array3[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array3, config) {
      var pos = input.length - 2;
      array3[HOUR] = toInt(input.substr(0, pos));
      array3[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array3, config) {
      var pos1 = input.length - 4, pos2 = input.length - 2;
      array3[HOUR] = toInt(input.substr(0, pos1));
      array3[MINUTE] = toInt(input.substr(pos1, 2));
      array3[SECOND] = toInt(input.substr(pos2));
    });
    function localeIsPM(input) {
      return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours2, minutes2, isLower) {
      if (hours2 > 11) {
        return isLower ? "pm" : "PM";
      } else {
        return isLower ? "am" : "AM";
      }
    }
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    };
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
      var i2, minl = Math.min(arr1.length, arr2.length);
      for (i2 = 0; i2 < minl; i2 += 1) {
        if (arr1[i2] !== arr2[i2]) {
          return i2;
        }
      }
      return minl;
    }
    function normalizeLocale(key2) {
      return key2 ? key2.toLowerCase().replace("_", "-") : key2;
    }
    function chooseLocale(names2) {
      var i2 = 0, j2, next, locale3, split;
      while (i2 < names2.length) {
        split = normalizeLocale(names2[i2]).split("-");
        j2 = split.length;
        next = normalizeLocale(names2[i2 + 1]);
        next = next ? next.split("-") : null;
        while (j2 > 0) {
          locale3 = loadLocale(split.slice(0, j2).join("-"));
          if (locale3) {
            return locale3;
          }
          if (next && next.length >= j2 && commonPrefix(split, next) >= j2 - 1) {
            break;
          }
          j2--;
        }
        i2++;
      }
      return globalLocale;
    }
    function isLocaleNameSane(name) {
      return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
      var oldLocale = null, aliasedRequire;
      if (locales[name] === void 0 && true && module && module.exports && isLocaleNameSane(name)) {
        try {
          oldLocale = globalLocale._abbr;
          aliasedRequire = commonjsRequire;
          aliasedRequire("./locale/" + name);
          getSetGlobalLocale(oldLocale);
        } catch (e3) {
          locales[name] = null;
        }
      }
      return locales[name];
    }
    function getSetGlobalLocale(key2, values) {
      var data;
      if (key2) {
        if (isUndefined(values)) {
          data = getLocale(key2);
        } else {
          data = defineLocale(key2, values);
        }
        if (data) {
          globalLocale = data;
        } else {
          if (typeof console !== "undefined" && console.warn) {
            console.warn(
              "Locale " + key2 + " not found. Did you forget to load it?"
            );
          }
        }
      }
      return globalLocale._abbr;
    }
    function defineLocale(name, config) {
      if (config !== null) {
        var locale3, parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
          deprecateSimple(
            "defineLocaleOverride",
            "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
          );
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale3 = loadLocale(config.parentLocale);
            if (locale3 != null) {
              parentConfig = locale3._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }
              localeFamilies[config.parentLocale].push({
                name,
                config
              });
              return null;
            }
          }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));
        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function(x2) {
            defineLocale(x2.name, x2.config);
          });
        }
        getSetGlobalLocale(name);
        return locales[name];
      } else {
        delete locales[name];
        return null;
      }
    }
    function updateLocale(name, config) {
      if (config != null) {
        var locale3, tmpLocale, parentConfig = baseConfig;
        if (locales[name] != null && locales[name].parentLocale != null) {
          locales[name].set(mergeConfigs(locales[name]._config, config));
        } else {
          tmpLocale = loadLocale(name);
          if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
          }
          config = mergeConfigs(parentConfig, config);
          if (tmpLocale == null) {
            config.abbr = name;
          }
          locale3 = new Locale(config);
          locale3.parentLocale = locales[name];
          locales[name] = locale3;
        }
        getSetGlobalLocale(name);
      } else {
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
            if (name === getSetGlobalLocale()) {
              getSetGlobalLocale(name);
            }
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }
      return locales[name];
    }
    function getLocale(key2) {
      var locale3;
      if (key2 && key2._locale && key2._locale._abbr) {
        key2 = key2._locale._abbr;
      }
      if (!key2) {
        return globalLocale;
      }
      if (!isArray2(key2)) {
        locale3 = loadLocale(key2);
        if (locale3) {
          return locale3;
        }
        key2 = [key2];
      }
      return chooseLocale(key2);
    }
    function listLocales() {
      return keys2(locales);
    }
    function checkOverflow(m2) {
      var overflow, a2 = m2._a;
      if (a2 && getParsingFlags(m2).overflow === -2) {
        overflow = a2[MONTH] < 0 || a2[MONTH] > 11 ? MONTH : a2[DATE] < 1 || a2[DATE] > daysInMonth(a2[YEAR], a2[MONTH]) ? DATE : a2[HOUR] < 0 || a2[HOUR] > 24 || a2[HOUR] === 24 && (a2[MINUTE] !== 0 || a2[SECOND] !== 0 || a2[MILLISECOND] !== 0) ? HOUR : a2[MINUTE] < 0 || a2[MINUTE] > 59 ? MINUTE : a2[SECOND] < 0 || a2[SECOND] > 59 ? SECOND : a2[MILLISECOND] < 0 || a2[MILLISECOND] > 999 ? MILLISECOND : -1;
        if (getParsingFlags(m2)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }
        if (getParsingFlags(m2)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }
        if (getParsingFlags(m2)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }
        getParsingFlags(m2).overflow = overflow;
      }
      return m2;
    }
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
      ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
      ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
      ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
      ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
      ["YYYY-DDD", /\d{4}-\d{3}/],
      ["YYYY-MM", /\d{4}-\d\d/, false],
      ["YYYYYYMMDD", /[+-]\d{10}/],
      ["YYYYMMDD", /\d{8}/],
      ["GGGG[W]WWE", /\d{4}W\d{3}/],
      ["GGGG[W]WW", /\d{4}W\d{2}/, false],
      ["YYYYDDD", /\d{7}/],
      ["YYYYMM", /\d{6}/, false],
      ["YYYY", /\d{4}/, false]
    ], isoTimes = [
      ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
      ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
      ["HH:mm:ss", /\d\d:\d\d:\d\d/],
      ["HH:mm", /\d\d:\d\d/],
      ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
      ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
      ["HHmmss", /\d\d\d\d\d\d/],
      ["HHmm", /\d\d\d\d/],
      ["HH", /\d\d/]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
      UT: 0,
      GMT: 0,
      EDT: -4 * 60,
      EST: -5 * 60,
      CDT: -5 * 60,
      CST: -6 * 60,
      MDT: -6 * 60,
      MST: -7 * 60,
      PDT: -7 * 60,
      PST: -8 * 60
    };
    function configFromISO(config) {
      var i2, l2, string2 = config._i, match5 = extendedIsoRegex.exec(string2) || basicIsoRegex.exec(string2), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
      if (match5) {
        getParsingFlags(config).iso = true;
        for (i2 = 0, l2 = isoDatesLen; i2 < l2; i2++) {
          if (isoDates[i2][1].exec(match5[1])) {
            dateFormat = isoDates[i2][0];
            allowTime = isoDates[i2][2] !== false;
            break;
          }
        }
        if (dateFormat == null) {
          config._isValid = false;
          return;
        }
        if (match5[3]) {
          for (i2 = 0, l2 = isoTimesLen; i2 < l2; i2++) {
            if (isoTimes[i2][1].exec(match5[3])) {
              timeFormat = (match5[2] || " ") + isoTimes[i2][0];
              break;
            }
          }
          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }
        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }
        if (match5[4]) {
          if (tzRegex.exec(match5[4])) {
            tzFormat = "Z";
          } else {
            config._isValid = false;
            return;
          }
        }
        config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
      ];
      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }
      return result;
    }
    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);
      if (year <= 49) {
        return 2e3 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }
      return year;
    }
    function preprocessRFC2822(s2) {
      return s2.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(
          parsedInput[0],
          parsedInput[1],
          parsedInput[2]
        ).getDay();
        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }
      return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        return 0;
      } else {
        var hm = parseInt(numOffset, 10), m2 = hm % 100, h = (hm - m2) / 100;
        return h * 60 + m2;
      }
    }
    function configFromRFC2822(config) {
      var match5 = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
      if (match5) {
        parsedArray = extractFromRFC2822Strings(
          match5[4],
          match5[3],
          match5[2],
          match5[5],
          match5[6],
          match5[7]
        );
        if (!checkWeekday(match5[1], parsedArray, config)) {
          return;
        }
        config._a = parsedArray;
        config._tzm = calculateOffset(match5[8], match5[9], match5[10]);
        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    }
    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);
      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }
      configFromISO(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      configFromRFC2822(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      if (config._strict) {
        config._isValid = false;
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    hooks.createFromInputFallback = deprecate(
      "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
      function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
      }
    );
    function defaults(a2, b2, c2) {
      if (a2 != null) {
        return a2;
      }
      if (b2 != null) {
        return b2;
      }
      return c2;
    }
    function currentDateArray(config) {
      var nowValue = new Date(hooks.now());
      if (config._useUTC) {
        return [
          nowValue.getUTCFullYear(),
          nowValue.getUTCMonth(),
          nowValue.getUTCDate()
        ];
      }
      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }
    function configFromArray(config) {
      var i2, date3, input = [], currentDate, expectedWeekday, yearToUse;
      if (config._d) {
        return;
      }
      currentDate = currentDateArray(config);
      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      }
      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }
        date3 = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date3.getUTCMonth();
        config._a[DATE] = date3.getUTCDate();
      }
      for (i2 = 0; i2 < 3 && config._a[i2] == null; ++i2) {
        config._a[i2] = input[i2] = currentDate[i2];
      }
      for (; i2 < 7; i2++) {
        config._a[i2] = input[i2] = config._a[i2] == null ? i2 === 2 ? 1 : 0 : config._a[i2];
      }
      if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }
      config._d = (config._useUTC ? createUTCDate : createDate).apply(
        null,
        input
      );
      expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }
      if (config._nextDay) {
        config._a[HOUR] = 24;
      }
      if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }
    function dayOfYearFromWeekInfo(config) {
      var w2, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
      w2 = config._w;
      if (w2.GG != null || w2.W != null || w2.E != null) {
        dow = 1;
        doy = 4;
        weekYear = defaults(
          w2.GG,
          config._a[YEAR],
          weekOfYear(createLocal(), 1, 4).year
        );
        week = defaults(w2.W, 1);
        weekday = defaults(w2.E, 1);
        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w2.gg, config._a[YEAR], curWeek.year);
        week = defaults(w2.w, curWeek.week);
        if (w2.d != null) {
          weekday = w2.d;
          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w2.e != null) {
          weekday = w2.e + dow;
          if (w2.e < 0 || w2.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          weekday = dow;
        }
      }
      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    }
    hooks.ISO_8601 = function() {
    };
    hooks.RFC_2822 = function() {
    };
    function configFromStringAndFormat(config) {
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }
      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }
      config._a = [];
      getParsingFlags(config).empty = true;
      var string2 = "" + config._i, i2, parsedInput, tokens2, token2, skipped, stringLength = string2.length, totalParsedInputLength = 0, era, tokenLen;
      tokens2 = expandFormat(config._f, config._locale).match(formattingTokens) || [];
      tokenLen = tokens2.length;
      for (i2 = 0; i2 < tokenLen; i2++) {
        token2 = tokens2[i2];
        parsedInput = (string2.match(getParseRegexForToken(token2, config)) || [])[0];
        if (parsedInput) {
          skipped = string2.substr(0, string2.indexOf(parsedInput));
          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }
          string2 = string2.slice(
            string2.indexOf(parsedInput) + parsedInput.length
          );
          totalParsedInputLength += parsedInput.length;
        }
        if (formatTokenFunctions[token2]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token2);
          }
          addTimeToArrayFromToken(token2, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token2);
        }
      }
      getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
      if (string2.length > 0) {
        getParsingFlags(config).unusedInput.push(string2);
      }
      if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = void 0;
      }
      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem;
      config._a[HOUR] = meridiemFixWrap(
        config._locale,
        config._a[HOUR],
        config._meridiem
      );
      era = getParsingFlags(config).era;
      if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
      }
      configFromArray(config);
      checkOverflow(config);
    }
    function meridiemFixWrap(locale3, hour, meridiem2) {
      var isPm;
      if (meridiem2 == null) {
        return hour;
      }
      if (locale3.meridiemHour != null) {
        return locale3.meridiemHour(hour, meridiem2);
      } else if (locale3.isPM != null) {
        isPm = locale3.isPM(meridiem2);
        if (isPm && hour < 12) {
          hour += 12;
        }
        if (!isPm && hour === 12) {
          hour = 0;
        }
        return hour;
      } else {
        return hour;
      }
    }
    function configFromStringAndArray(config) {
      var tempConfig, bestMoment, scoreToBeat, i2, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
      if (configfLen === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }
      for (i2 = 0; i2 < configfLen; i2++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i2];
        configFromStringAndFormat(tempConfig);
        if (isValid(tempConfig)) {
          validFormatFound = true;
        }
        currentScore += getParsingFlags(tempConfig).charsLeftOver;
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;
        if (!bestFormatIsValid) {
          if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
            if (validFormatFound) {
              bestFormatIsValid = true;
            }
          }
        } else {
          if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
          }
        }
      }
      extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
      if (config._d) {
        return;
      }
      var i2 = normalizeObjectUnits(config._i), dayOrDate = i2.day === void 0 ? i2.date : i2.day;
      config._a = map(
        [i2.year, i2.month, dayOrDate, i2.hour, i2.minute, i2.second, i2.millisecond],
        function(obj) {
          return obj && parseInt(obj, 10);
        }
      );
      configFromArray(config);
    }
    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));
      if (res._nextDay) {
        res.add(1, "d");
        res._nextDay = void 0;
      }
      return res;
    }
    function prepareConfig(config) {
      var input = config._i, format4 = config._f;
      config._locale = config._locale || getLocale(config._l);
      if (input === null || format4 === void 0 && input === "") {
        return createInvalid({ nullInput: true });
      }
      if (typeof input === "string") {
        config._i = input = config._locale.preparse(input);
      }
      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray2(format4)) {
        configFromStringAndArray(config);
      } else if (format4) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }
      if (!isValid(config)) {
        config._d = null;
      }
      return config;
    }
    function configFromInput(config) {
      var input = config._i;
      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === "string") {
        configFromString(config);
      } else if (isArray2(input)) {
        config._a = map(input.slice(0), function(obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject2(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    function createLocalOrUTC(input, format4, locale3, strict, isUTC) {
      var c2 = {};
      if (format4 === true || format4 === false) {
        strict = format4;
        format4 = void 0;
      }
      if (locale3 === true || locale3 === false) {
        strict = locale3;
        locale3 = void 0;
      }
      if (isObject2(input) && isObjectEmpty(input) || isArray2(input) && input.length === 0) {
        input = void 0;
      }
      c2._isAMomentObject = true;
      c2._useUTC = c2._isUTC = isUTC;
      c2._l = locale3;
      c2._i = input;
      c2._f = format4;
      c2._strict = strict;
      return createFromConfig(c2);
    }
    function createLocal(input, format4, locale3, strict) {
      return createLocalOrUTC(input, format4, locale3, strict, false);
    }
    var prototypeMin = deprecate(
      "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
      function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other < this ? this : other;
        } else {
          return createInvalid();
        }
      }
    ), prototypeMax = deprecate(
      "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
      function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other > this ? this : other;
        } else {
          return createInvalid();
        }
      }
    );
    function pickBy(fn, moments) {
      var res, i2;
      if (moments.length === 1 && isArray2(moments[0])) {
        moments = moments[0];
      }
      if (!moments.length) {
        return createLocal();
      }
      res = moments[0];
      for (i2 = 1; i2 < moments.length; ++i2) {
        if (!moments[i2].isValid() || moments[i2][fn](res)) {
          res = moments[i2];
        }
      }
      return res;
    }
    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy("isBefore", args);
    }
    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy("isAfter", args);
    }
    var now2 = function() {
      return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
      "year",
      "quarter",
      "month",
      "week",
      "day",
      "hour",
      "minute",
      "second",
      "millisecond"
    ];
    function isDurationValid(m2) {
      var key2, unitHasDecimal = false, i2, orderLen = ordering.length;
      for (key2 in m2) {
        if (hasOwnProp(m2, key2) && !(indexOf.call(ordering, key2) !== -1 && (m2[key2] == null || !isNaN(m2[key2])))) {
          return false;
        }
      }
      for (i2 = 0; i2 < orderLen; ++i2) {
        if (m2[ordering[i2]]) {
          if (unitHasDecimal) {
            return false;
          }
          if (parseFloat(m2[ordering[i2]]) !== toInt(m2[ordering[i2]])) {
            unitHasDecimal = true;
          }
        }
      }
      return true;
    }
    function isValid$1() {
      return this._isValid;
    }
    function createInvalid$1() {
      return createDuration(NaN);
    }
    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput);
      this._milliseconds = +milliseconds2 + seconds2 * 1e3 + minutes2 * 6e4 + hours2 * 1e3 * 60 * 60;
      this._days = +days2 + weeks2 * 7;
      this._months = +months2 + quarters * 3 + years2 * 12;
      this._data = {};
      this._locale = getLocale();
      this._bubble();
    }
    function isDuration(obj) {
      return obj instanceof Duration;
    }
    function absRound(number3) {
      if (number3 < 0) {
        return Math.round(-1 * number3) * -1;
      } else {
        return Math.round(number3);
      }
    }
    function compareArrays(array1, array22, dontConvert) {
      var len = Math.min(array1.length, array22.length), lengthDiff = Math.abs(array1.length - array22.length), diffs = 0, i2;
      for (i2 = 0; i2 < len; i2++) {
        if (dontConvert && array1[i2] !== array22[i2] || !dontConvert && toInt(array1[i2]) !== toInt(array22[i2])) {
          diffs++;
        }
      }
      return diffs + lengthDiff;
    }
    function offset3(token2, separator) {
      addFormatToken(token2, 0, 0, function() {
        var offset4 = this.utcOffset(), sign2 = "+";
        if (offset4 < 0) {
          offset4 = -offset4;
          sign2 = "-";
        }
        return sign2 + zeroFill(~~(offset4 / 60), 2) + separator + zeroFill(~~offset4 % 60, 2);
      });
    }
    offset3("Z", ":");
    offset3("ZZ", "");
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken(["Z", "ZZ"], function(input, array3, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    });
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string2) {
      var matches = (string2 || "").match(matcher), chunk, parts, minutes2;
      if (matches === null) {
        return null;
      }
      chunk = matches[matches.length - 1] || [];
      parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
      minutes2 = +(parts[1] * 60) + toInt(parts[2]);
      return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
    }
    function cloneWithOffset(input, model) {
      var res, diff2;
      if (model._isUTC) {
        res = model.clone();
        diff2 = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        res._d.setTime(res._d.valueOf() + diff2);
        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }
    function getDateOffset(m2) {
      return -Math.round(m2._d.getTimezoneOffset());
    }
    hooks.updateOffset = function() {
    };
    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset4 = this._offset || 0, localAdjust;
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        if (typeof input === "string") {
          input = offsetFromString(matchShortOffset, input);
          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
          this.add(localAdjust, "m");
        }
        if (offset4 !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(
              this,
              createDuration(input - offset4, "m"),
              1,
              false
            );
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }
        return this;
      } else {
        return this._isUTC ? offset4 : getDateOffset(this);
      }
    }
    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== "string") {
          input = -input;
        }
        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }
    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;
        if (keepLocalTime) {
          this.subtract(getDateOffset(this), "m");
        }
      }
      return this;
    }
    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === "string") {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }
      return this;
    }
    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }
      input = input ? createLocal(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }
      var c2 = {}, other;
      copyConfig(c2, this);
      c2 = prepareConfig(c2);
      if (c2._a) {
        other = c2._isUTC ? createUTC(c2._a) : createLocal(c2._a);
        this._isDSTShifted = this.isValid() && compareArrays(c2._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }
      return this._isDSTShifted;
    }
    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key2) {
      var duration = input, match5 = null, sign2, ret, diffRes;
      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input) || !isNaN(+input)) {
        duration = {};
        if (key2) {
          duration[key2] = +input;
        } else {
          duration.milliseconds = +input;
        }
      } else if (match5 = aspNetRegex.exec(input)) {
        sign2 = match5[1] === "-" ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match5[DATE]) * sign2,
          h: toInt(match5[HOUR]) * sign2,
          m: toInt(match5[MINUTE]) * sign2,
          s: toInt(match5[SECOND]) * sign2,
          ms: toInt(absRound(match5[MILLISECOND] * 1e3)) * sign2
        };
      } else if (match5 = isoRegex.exec(input)) {
        sign2 = match5[1] === "-" ? -1 : 1;
        duration = {
          y: parseIso(match5[2], sign2),
          M: parseIso(match5[3], sign2),
          w: parseIso(match5[4], sign2),
          d: parseIso(match5[5], sign2),
          h: parseIso(match5[6], sign2),
          m: parseIso(match5[7], sign2),
          s: parseIso(match5[8], sign2)
        };
      } else if (duration == null) {
        duration = {};
      } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
        diffRes = momentsDifference(
          createLocal(duration.from),
          createLocal(duration.to)
        );
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }
      ret = new Duration(duration);
      if (isDuration(input) && hasOwnProp(input, "_locale")) {
        ret._locale = input._locale;
      }
      if (isDuration(input) && hasOwnProp(input, "_isValid")) {
        ret._isValid = input._isValid;
      }
      return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign2) {
      var res = inp && parseFloat(inp.replace(",", "."));
      return (isNaN(res) ? 0 : res) * sign2;
    }
    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
      if (base.clone().add(res.months, "M").isAfter(other)) {
        --res.months;
      }
      res.milliseconds = +other - +base.clone().add(res.months, "M");
      return res;
    }
    function momentsDifference(base, other) {
      var res;
      if (!(base.isValid() && other.isValid())) {
        return { milliseconds: 0, months: 0 };
      }
      other = cloneWithOffset(other, base);
      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }
      return res;
    }
    function createAdder(direction, name) {
      return function(val, period) {
        var dur, tmp;
        if (period !== null && !isNaN(+period)) {
          deprecateSimple(
            name,
            "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
          );
          tmp = val;
          val = period;
          period = tmp;
        }
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds2 = duration._milliseconds, days2 = absRound(duration._days), months2 = absRound(duration._months);
      if (!mom.isValid()) {
        return;
      }
      updateOffset = updateOffset == null ? true : updateOffset;
      if (months2) {
        setMonth2(mom, get2(mom, "Month") + months2 * isAdding);
      }
      if (days2) {
        set$1(mom, "Date", get2(mom, "Date") + days2 * isAdding);
      }
      if (milliseconds2) {
        mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
      }
      if (updateOffset) {
        hooks.updateOffset(mom, days2 || months2);
      }
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString2(input) {
      return typeof input === "string" || input instanceof String;
    }
    function isMomentInput(input) {
      return isMoment(input) || isDate(input) || isString2(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === void 0;
    }
    function isMomentInputObject(input) {
      var objectTest = isObject2(input) && !isObjectEmpty(input), propertyTest = false, properties = [
        "years",
        "year",
        "y",
        "months",
        "month",
        "M",
        "days",
        "day",
        "d",
        "dates",
        "date",
        "D",
        "hours",
        "hour",
        "h",
        "minutes",
        "minute",
        "m",
        "seconds",
        "second",
        "s",
        "milliseconds",
        "millisecond",
        "ms"
      ], i2, property, propertyLen = properties.length;
      for (i2 = 0; i2 < propertyLen; i2 += 1) {
        property = properties[i2];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
      var arrayTest = isArray2(input), dataTypeTest = false;
      if (arrayTest) {
        dataTypeTest = input.filter(function(item) {
          return !isNumber(item) && isString2(input);
        }).length === 0;
      }
      return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
      var objectTest = isObject2(input) && !isObjectEmpty(input), propertyTest = false, properties = [
        "sameDay",
        "nextDay",
        "lastDay",
        "nextWeek",
        "lastWeek",
        "sameElse"
      ], i2, property;
      for (i2 = 0; i2 < properties.length; i2 += 1) {
        property = properties[i2];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now3) {
      var diff2 = myMoment.diff(now3, "days", true);
      return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
      if (arguments.length === 1) {
        if (!arguments[0]) {
          time = void 0;
          formats = void 0;
        } else if (isMomentInput(arguments[0])) {
          time = arguments[0];
          formats = void 0;
        } else if (isCalendarSpec(arguments[0])) {
          formats = arguments[0];
          time = void 0;
        }
      }
      var now3 = time || createLocal(), sod = cloneWithOffset(now3, this).startOf("day"), format4 = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction2(formats[format4]) ? formats[format4].call(this, now3) : formats[format4]);
      return this.format(
        output || this.localeData().calendar(format4, this, createLocal(now3))
      );
    }
    function clone2() {
      return new Moment(this);
    }
    function isAfter2(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || "millisecond";
      if (units === "millisecond") {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }
    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || "millisecond";
      if (units === "millisecond") {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }
    function isBetween(from2, to2, units, inclusivity) {
      var localFrom = isMoment(from2) ? from2 : createLocal(from2), localTo = isMoment(to2) ? to2 : createLocal(to2);
      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }
      inclusivity = inclusivity || "()";
      return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input), inputMs;
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || "millisecond";
      if (units === "millisecond") {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }
    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
      var that, zoneDelta, output;
      if (!this.isValid()) {
        return NaN;
      }
      that = cloneWithOffset(input, this);
      if (!that.isValid()) {
        return NaN;
      }
      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);
      switch (units) {
        case "year":
          output = monthDiff(this, that) / 12;
          break;
        case "month":
          output = monthDiff(this, that);
          break;
        case "quarter":
          output = monthDiff(this, that) / 3;
          break;
        case "second":
          output = (this - that) / 1e3;
          break;
        case "minute":
          output = (this - that) / 6e4;
          break;
        case "hour":
          output = (this - that) / 36e5;
          break;
        case "day":
          output = (this - that - zoneDelta) / 864e5;
          break;
        case "week":
          output = (this - that - zoneDelta) / 6048e5;
          break;
        default:
          output = this - that;
      }
      return asFloat ? output : absFloor(output);
    }
    function monthDiff(a2, b2) {
      if (a2.date() < b2.date()) {
        return -monthDiff(b2, a2);
      }
      var wholeMonthDiff = (b2.year() - a2.year()) * 12 + (b2.month() - a2.month()), anchor = a2.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
      if (b2 - anchor < 0) {
        anchor2 = a2.clone().add(wholeMonthDiff - 1, "months");
        adjust = (b2 - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a2.clone().add(wholeMonthDiff + 1, "months");
        adjust = (b2 - anchor) / (anchor2 - anchor);
      }
      return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString2() {
      return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }
      var utc = keepOffset !== true, m2 = utc ? this.clone().utc() : this;
      if (m2.year() < 0 || m2.year() > 9999) {
        return formatMoment(
          m2,
          utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
        );
      }
      if (isFunction2(Date.prototype.toISOString)) {
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m2, "Z"));
        }
      }
      return formatMoment(
        m2,
        utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
      );
    }
    function inspect() {
      if (!this.isValid()) {
        return "moment.invalid(/* " + this._i + " */)";
      }
      var func = "moment", zone = "", prefix, year, datetime, suffix;
      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
        zone = "Z";
      }
      prefix = "[" + func + '("]';
      year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
      datetime = "-MM-DD[T]HH:mm:ss.SSS";
      suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }
    function format3(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }
      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    }
    function locale2(key2) {
      var newLocaleData;
      if (key2 === void 0) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key2);
        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }
        return this;
      }
    }
    var lang = deprecate(
      "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
      function(key2) {
        if (key2 === void 0) {
          return this.localeData();
        } else {
          return this.locale(key2);
        }
      }
    );
    function localeData() {
      return this._locale;
    }
    var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y2, m2, d) {
      if (y2 < 100 && y2 >= 0) {
        return new Date(y2 + 400, m2, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y2, m2, d).valueOf();
      }
    }
    function utcStartOfDate(y2, m2, d) {
      if (y2 < 100 && y2 >= 0) {
        return Date.UTC(y2 + 400, m2, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y2, m2, d);
      }
    }
    function startOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === void 0 || units === "millisecond" || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case "year":
          time = startOfDate(this.year(), 0, 1);
          break;
        case "quarter":
          time = startOfDate(
            this.year(),
            this.month() - this.month() % 3,
            1
          );
          break;
        case "month":
          time = startOfDate(this.year(), this.month(), 1);
          break;
        case "week":
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - this.weekday()
          );
          break;
        case "isoWeek":
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - (this.isoWeekday() - 1)
          );
          break;
        case "day":
        case "date":
          time = startOfDate(this.year(), this.month(), this.date());
          break;
        case "hour":
          time = this._d.valueOf();
          time -= mod$1(
            time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
            MS_PER_HOUR
          );
          break;
        case "minute":
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;
        case "second":
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function endOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === void 0 || units === "millisecond" || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case "year":
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;
        case "quarter":
          time = startOfDate(
            this.year(),
            this.month() - this.month() % 3 + 3,
            1
          ) - 1;
          break;
        case "month":
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;
        case "week":
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - this.weekday() + 7
          ) - 1;
          break;
        case "isoWeek":
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - (this.isoWeekday() - 1) + 7
          ) - 1;
          break;
        case "day":
        case "date":
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;
        case "hour":
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(
            time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
            MS_PER_HOUR
          ) - 1;
          break;
        case "minute":
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;
        case "second":
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 6e4;
    }
    function unix() {
      return Math.floor(this.valueOf() / 1e3);
    }
    function toDate() {
      return new Date(this.valueOf());
    }
    function toArray2() {
      var m2 = this;
      return [
        m2.year(),
        m2.month(),
        m2.date(),
        m2.hour(),
        m2.minute(),
        m2.second(),
        m2.millisecond()
      ];
    }
    function toObject() {
      var m2 = this;
      return {
        years: m2.year(),
        months: m2.month(),
        date: m2.date(),
        hours: m2.hours(),
        minutes: m2.minutes(),
        seconds: m2.seconds(),
        milliseconds: m2.milliseconds()
      };
    }
    function toJSON() {
      return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
      return isValid(this);
    }
    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
      return getParsingFlags(this).overflow;
    }
    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", ["y", 1], "yo", "eraYear");
    addFormatToken("y", ["yy", 2], 0, "eraYear");
    addFormatToken("y", ["yyy", 3], 0, "eraYear");
    addFormatToken("y", ["yyyy", 4], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken(
      ["N", "NN", "NNN", "NNNN", "NNNNN"],
      function(input, array3, config, token2) {
        var era = config._locale.erasParse(input, token2, config._strict);
        if (era) {
          getParsingFlags(config).era = era;
        } else {
          getParsingFlags(config).invalidEra = input;
        }
      }
    );
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
    addParseToken(["yo"], function(input, array3, config, token2) {
      var match5;
      if (config._locale._eraYearOrdinalRegex) {
        match5 = input.match(config._locale._eraYearOrdinalRegex);
      }
      if (config._locale.eraYearOrdinalParse) {
        array3[YEAR] = config._locale.eraYearOrdinalParse(input, match5);
      } else {
        array3[YEAR] = parseInt(input, 10);
      }
    });
    function localeEras(m2, format4) {
      var i2, l2, date3, eras = this._eras || getLocale("en")._eras;
      for (i2 = 0, l2 = eras.length; i2 < l2; ++i2) {
        switch (typeof eras[i2].since) {
          case "string":
            date3 = hooks(eras[i2].since).startOf("day");
            eras[i2].since = date3.valueOf();
            break;
        }
        switch (typeof eras[i2].until) {
          case "undefined":
            eras[i2].until = Infinity;
            break;
          case "string":
            date3 = hooks(eras[i2].until).startOf("day").valueOf();
            eras[i2].until = date3.valueOf();
            break;
        }
      }
      return eras;
    }
    function localeErasParse(eraName, format4, strict) {
      var i2, l2, eras = this.eras(), name, abbr, narrow;
      eraName = eraName.toUpperCase();
      for (i2 = 0, l2 = eras.length; i2 < l2; ++i2) {
        name = eras[i2].name.toUpperCase();
        abbr = eras[i2].abbr.toUpperCase();
        narrow = eras[i2].narrow.toUpperCase();
        if (strict) {
          switch (format4) {
            case "N":
            case "NN":
            case "NNN":
              if (abbr === eraName) {
                return eras[i2];
              }
              break;
            case "NNNN":
              if (name === eraName) {
                return eras[i2];
              }
              break;
            case "NNNNN":
              if (narrow === eraName) {
                return eras[i2];
              }
              break;
          }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
          return eras[i2];
        }
      }
    }
    function localeErasConvertYear(era, year) {
      var dir = era.since <= era.until ? 1 : -1;
      if (year === void 0) {
        return hooks(era.since).year();
      } else {
        return hooks(era.since).year() + (year - era.offset) * dir;
      }
    }
    function getEraName() {
      var i2, l2, val, eras = this.localeData().eras();
      for (i2 = 0, l2 = eras.length; i2 < l2; ++i2) {
        val = this.clone().startOf("day").valueOf();
        if (eras[i2].since <= val && val <= eras[i2].until) {
          return eras[i2].name;
        }
        if (eras[i2].until <= val && val <= eras[i2].since) {
          return eras[i2].name;
        }
      }
      return "";
    }
    function getEraNarrow() {
      var i2, l2, val, eras = this.localeData().eras();
      for (i2 = 0, l2 = eras.length; i2 < l2; ++i2) {
        val = this.clone().startOf("day").valueOf();
        if (eras[i2].since <= val && val <= eras[i2].until) {
          return eras[i2].narrow;
        }
        if (eras[i2].until <= val && val <= eras[i2].since) {
          return eras[i2].narrow;
        }
      }
      return "";
    }
    function getEraAbbr() {
      var i2, l2, val, eras = this.localeData().eras();
      for (i2 = 0, l2 = eras.length; i2 < l2; ++i2) {
        val = this.clone().startOf("day").valueOf();
        if (eras[i2].since <= val && val <= eras[i2].until) {
          return eras[i2].abbr;
        }
        if (eras[i2].until <= val && val <= eras[i2].since) {
          return eras[i2].abbr;
        }
      }
      return "";
    }
    function getEraYear() {
      var i2, l2, dir, val, eras = this.localeData().eras();
      for (i2 = 0, l2 = eras.length; i2 < l2; ++i2) {
        dir = eras[i2].since <= eras[i2].until ? 1 : -1;
        val = this.clone().startOf("day").valueOf();
        if (eras[i2].since <= val && val <= eras[i2].until || eras[i2].until <= val && val <= eras[i2].since) {
          return (this.year() - hooks(eras[i2].since).year()) * dir + eras[i2].offset;
        }
      }
      return this.year();
    }
    function erasNameRegex(isStrict) {
      if (!hasOwnProp(this, "_erasNameRegex")) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
      if (!hasOwnProp(this, "_erasAbbrRegex")) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
      if (!hasOwnProp(this, "_erasNarrowRegex")) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale3) {
      return locale3.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale3) {
      return locale3.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale3) {
      return locale3.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale3) {
      return locale3._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
      var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i2, l2, eras = this.eras();
      for (i2 = 0, l2 = eras.length; i2 < l2; ++i2) {
        namePieces.push(regexEscape(eras[i2].name));
        abbrPieces.push(regexEscape(eras[i2].abbr));
        narrowPieces.push(regexEscape(eras[i2].narrow));
        mixedPieces.push(regexEscape(eras[i2].name));
        mixedPieces.push(regexEscape(eras[i2].abbr));
        mixedPieces.push(regexEscape(eras[i2].narrow));
      }
      this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
      this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
      this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
      this._erasNarrowRegex = new RegExp(
        "^(" + narrowPieces.join("|") + ")",
        "i"
      );
    }
    addFormatToken(0, ["gg", 2], 0, function() {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ["GG", 2], 0, function() {
      return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token2, getter) {
      addFormatToken(0, [token2, token2.length], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken(
      ["gggg", "ggggg", "GGGG", "GGGGG"],
      function(input, week, config, token2) {
        week[token2.substr(0, 2)] = toInt(input);
      }
    );
    addWeekParseToken(["gg", "GG"], function(input, week, config, token2) {
      week[token2] = hooks.parseTwoDigitYear(input);
    });
    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(
        this,
        input,
        this.week(),
        this.weekday(),
        this.localeData()._week.dow,
        this.localeData()._week.doy
      );
    }
    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(
        this,
        input,
        this.isoWeek(),
        this.isoWeekday(),
        1,
        4
      );
    }
    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
      return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;
      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
          week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date3 = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date3.getUTCFullYear());
      this.month(date3.getUTCMonth());
      this.date(date3.getUTCDate());
      return this;
    }
    addFormatToken("Q", 0, "Qo", "quarter");
    addUnitAlias("quarter", "Q");
    addUnitPriority("quarter", 7);
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array3) {
      array3[MONTH] = (toInt(input) - 1) * 3;
    });
    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    addFormatToken("D", ["DD", 2], "Do", "date");
    addUnitAlias("date", "D");
    addUnitPriority("date", 9);
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale3) {
      return isStrict ? locale3._dayOfMonthOrdinalParse || locale3._ordinalParse : locale3._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(["D", "DD"], DATE);
    addParseToken("Do", function(input, array3) {
      array3[DATE] = toInt(input.match(match1to2)[0]);
    });
    var getSetDayOfMonth = makeGetSet("Date", true);
    addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
    addUnitAlias("dayOfYear", "DDD");
    addUnitPriority("dayOfYear", 4);
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken(["DDD", "DDDD"], function(input, array3, config) {
      config._dayOfYear = toInt(input);
    });
    function getSetDayOfYear(input) {
      var dayOfYear = Math.round(
        (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
      ) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    addFormatToken("m", ["mm", 2], 0, "minute");
    addUnitAlias("minute", "m");
    addUnitPriority("minute", 14);
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken(["m", "mm"], MINUTE);
    var getSetMinute = makeGetSet("Minutes", false);
    addFormatToken("s", ["ss", 2], 0, "second");
    addUnitAlias("second", "s");
    addUnitPriority("second", 15);
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken(["s", "ss"], SECOND);
    var getSetSecond = makeGetSet("Seconds", false);
    addFormatToken("S", 0, 0, function() {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ["SS", 2], 0, function() {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ["SSS", 3], 0, "millisecond");
    addFormatToken(0, ["SSSS", 4], 0, function() {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ["SSSSS", 5], 0, function() {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ["SSSSSS", 6], 0, function() {
      return this.millisecond() * 1e3;
    });
    addFormatToken(0, ["SSSSSSS", 7], 0, function() {
      return this.millisecond() * 1e4;
    });
    addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
      return this.millisecond() * 1e5;
    });
    addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
      return this.millisecond() * 1e6;
    });
    addUnitAlias("millisecond", "ms");
    addUnitPriority("millisecond", 16);
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for (token = "SSSS"; token.length <= 9; token += "S") {
      addRegexToken(token, matchUnsigned);
    }
    function parseMs(input, array3) {
      array3[MILLISECOND] = toInt(("0." + input) * 1e3);
    }
    for (token = "S"; token.length <= 9; token += "S") {
      addParseToken(token, parseMs);
    }
    getSetMillisecond = makeGetSet("Milliseconds", false);
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    function getZoneAbbr() {
      return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
      return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone2;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format3;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter2;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale2;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray2;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) {
      proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
      };
    }
    proto.toJSON = toJSON;
    proto.toString = toString2;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
      "dates accessor is deprecated. Use date instead.",
      getSetDayOfMonth
    );
    proto.months = deprecate(
      "months accessor is deprecated. Use month instead",
      getSetMonth
    );
    proto.years = deprecate(
      "years accessor is deprecated. Use year instead",
      getSetYear
    );
    proto.zone = deprecate(
      "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
      getSetZone
    );
    proto.isDSTShifted = deprecate(
      "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
      isDaylightSavingTimeShifted
    );
    function createUnix(input) {
      return createLocal(input * 1e3);
    }
    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string2) {
      return string2;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set2;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format4, index2, field, setter) {
      var locale3 = getLocale(), utc = createUTC().set(setter, index2);
      return locale3[field](utc, format4);
    }
    function listMonthsImpl(format4, index2, field) {
      if (isNumber(format4)) {
        index2 = format4;
        format4 = void 0;
      }
      format4 = format4 || "";
      if (index2 != null) {
        return get$1(format4, index2, field, "month");
      }
      var i2, out = [];
      for (i2 = 0; i2 < 12; i2++) {
        out[i2] = get$1(format4, i2, field, "month");
      }
      return out;
    }
    function listWeekdaysImpl(localeSorted, format4, index2, field) {
      if (typeof localeSorted === "boolean") {
        if (isNumber(format4)) {
          index2 = format4;
          format4 = void 0;
        }
        format4 = format4 || "";
      } else {
        format4 = localeSorted;
        index2 = format4;
        localeSorted = false;
        if (isNumber(format4)) {
          index2 = format4;
          format4 = void 0;
        }
        format4 = format4 || "";
      }
      var locale3 = getLocale(), shift = localeSorted ? locale3._week.dow : 0, i2, out = [];
      if (index2 != null) {
        return get$1(format4, (index2 + shift) % 7, field, "day");
      }
      for (i2 = 0; i2 < 7; i2++) {
        out[i2] = get$1(format4, (i2 + shift) % 7, field, "day");
      }
      return out;
    }
    function listMonths(format4, index2) {
      return listMonthsImpl(format4, index2, "months");
    }
    function listMonthsShort(format4, index2) {
      return listMonthsImpl(format4, index2, "monthsShort");
    }
    function listWeekdays(localeSorted, format4, index2) {
      return listWeekdaysImpl(localeSorted, format4, index2, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format4, index2) {
      return listWeekdaysImpl(localeSorted, format4, index2, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format4, index2) {
      return listWeekdaysImpl(localeSorted, format4, index2, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
      eras: [
        {
          since: "0001-01-01",
          until: Infinity,
          offset: 1,
          name: "Anno Domini",
          narrow: "AD",
          abbr: "AD"
        },
        {
          since: "0000-12-31",
          until: -Infinity,
          offset: 1,
          name: "Before Christ",
          narrow: "BC",
          abbr: "BC"
        }
      ],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function(number3) {
        var b2 = number3 % 10, output = toInt(number3 % 100 / 10) === 1 ? "th" : b2 === 1 ? "st" : b2 === 2 ? "nd" : b2 === 3 ? "rd" : "th";
        return number3 + output;
      }
    });
    hooks.lang = deprecate(
      "moment.lang is deprecated. Use moment.locale instead.",
      getSetGlobalLocale
    );
    hooks.langData = deprecate(
      "moment.langData is deprecated. Use moment.localeData instead.",
      getLocale
    );
    var mathAbs = Math.abs;
    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }
    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    }
    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    }
    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number3) {
      if (number3 < 0) {
        return Math.floor(number3);
      } else {
        return Math.ceil(number3);
      }
    }
    function bubble() {
      var milliseconds2 = this._milliseconds, days2 = this._days, months2 = this._months, data = this._data, seconds2, minutes2, hours2, years2, monthsFromDays;
      if (!(milliseconds2 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months2 <= 0)) {
        milliseconds2 += absCeil(monthsToDays(months2) + days2) * 864e5;
        days2 = 0;
        months2 = 0;
      }
      data.milliseconds = milliseconds2 % 1e3;
      seconds2 = absFloor(milliseconds2 / 1e3);
      data.seconds = seconds2 % 60;
      minutes2 = absFloor(seconds2 / 60);
      data.minutes = minutes2 % 60;
      hours2 = absFloor(minutes2 / 60);
      data.hours = hours2 % 24;
      days2 += absFloor(hours2 / 24);
      monthsFromDays = absFloor(daysToMonths(days2));
      months2 += monthsFromDays;
      days2 -= absCeil(monthsToDays(monthsFromDays));
      years2 = absFloor(months2 / 12);
      months2 %= 12;
      data.days = days2;
      data.months = months2;
      data.years = years2;
      return this;
    }
    function daysToMonths(days2) {
      return days2 * 4800 / 146097;
    }
    function monthsToDays(months2) {
      return months2 * 146097 / 4800;
    }
    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }
      var days2, months2, milliseconds2 = this._milliseconds;
      units = normalizeUnits(units);
      if (units === "month" || units === "quarter" || units === "year") {
        days2 = this._days + milliseconds2 / 864e5;
        months2 = this._months + daysToMonths(days2);
        switch (units) {
          case "month":
            return months2;
          case "quarter":
            return months2 / 3;
          case "year":
            return months2 / 12;
        }
      } else {
        days2 = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
          case "week":
            return days2 / 7 + milliseconds2 / 6048e5;
          case "day":
            return days2 + milliseconds2 / 864e5;
          case "hour":
            return days2 * 24 + milliseconds2 / 36e5;
          case "minute":
            return days2 * 1440 + milliseconds2 / 6e4;
          case "second":
            return days2 * 86400 + milliseconds2 / 1e3;
          case "millisecond":
            return Math.floor(days2 * 864e5) + milliseconds2;
          default:
            throw new Error("Unknown unit " + units);
        }
      }
    }
    function valueOf$1() {
      if (!this.isValid()) {
        return NaN;
      }
      return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
      return function() {
        return this.as(alias);
      };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
      return createDuration(this);
    }
    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
      return function() {
        return this.isValid() ? this._data[name] : NaN;
      };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
      return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
      ss: 44,
      s: 45,
      m: 45,
      h: 22,
      d: 26,
      w: null,
      M: 11
    };
    function substituteTimeAgo(string2, number3, withoutSuffix, isFuture, locale3) {
      return locale3.relativeTime(number3 || 1, !!withoutSuffix, string2, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale3) {
      var duration = createDuration(posNegDuration).abs(), seconds2 = round(duration.as("s")), minutes2 = round(duration.as("m")), hours2 = round(duration.as("h")), days2 = round(duration.as("d")), months2 = round(duration.as("M")), weeks2 = round(duration.as("w")), years2 = round(duration.as("y")), a2 = seconds2 <= thresholds2.ss && ["s", seconds2] || seconds2 < thresholds2.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
      if (thresholds2.w != null) {
        a2 = a2 || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
      }
      a2 = a2 || months2 <= 1 && ["M"] || months2 < thresholds2.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
      a2[2] = withoutSuffix;
      a2[3] = +posNegDuration > 0;
      a2[4] = locale3;
      return substituteTimeAgo.apply(null, a2);
    }
    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === void 0) {
        return round;
      }
      if (typeof roundingFunction === "function") {
        round = roundingFunction;
        return true;
      }
      return false;
    }
    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === void 0) {
        return false;
      }
      if (limit === void 0) {
        return thresholds[threshold];
      }
      thresholds[threshold] = limit;
      if (threshold === "s") {
        thresholds.ss = limit - 1;
      }
      return true;
    }
    function humanize(argWithSuffix, argThresholds) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var withSuffix = false, th = thresholds, locale3, output;
      if (typeof argWithSuffix === "object") {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
      }
      if (typeof argWithSuffix === "boolean") {
        withSuffix = argWithSuffix;
      }
      if (typeof argThresholds === "object") {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) {
          th.ss = argThresholds.s - 1;
        }
      }
      locale3 = this.localeData();
      output = relativeTime$1(this, !withSuffix, th, locale3);
      if (withSuffix) {
        output = locale3.pastFuture(+this, output);
      }
      return locale3.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x2) {
      return (x2 > 0) - (x2 < 0) || +x2;
    }
    function toISOString$1() {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var seconds2 = abs$1(this._milliseconds) / 1e3, days2 = abs$1(this._days), months2 = abs$1(this._months), minutes2, hours2, years2, s2, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
      if (!total) {
        return "P0D";
      }
      minutes2 = absFloor(seconds2 / 60);
      hours2 = absFloor(minutes2 / 60);
      seconds2 %= 60;
      minutes2 %= 60;
      years2 = absFloor(months2 / 12);
      months2 %= 12;
      s2 = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
      totalSign = total < 0 ? "-" : "";
      ymSign = sign(this._months) !== sign(total) ? "-" : "";
      daysSign = sign(this._days) !== sign(total) ? "-" : "";
      hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
      return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months2 ? ymSign + months2 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds2 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds2 ? hmsSign + s2 + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale2;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate(
      "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
      toISOString$1
    );
    proto$2.lang = lang;
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array3, config) {
      config._d = new Date(parseFloat(input) * 1e3);
    });
    addParseToken("x", function(input, array3, config) {
      config._d = new Date(toInt(input));
    });
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now2;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    hooks.HTML5_FMT = {
      DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
      DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
      DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
      DATE: "YYYY-MM-DD",
      TIME: "HH:mm",
      TIME_SECONDS: "HH:mm:ss",
      TIME_MS: "HH:mm:ss.SSS",
      WEEK: "GGGG-[W]WW",
      MONTH: "YYYY-MM"
    };
    return hooks;
  });
})(moment$1);
var moment = moment$1.exports;
var generateConfig = {
  getNow: function getNow() {
    return moment();
  },
  getFixedDate: function getFixedDate(string2) {
    return moment(string2, "YYYY-MM-DD");
  },
  getEndDate: function getEndDate(date3) {
    var clone2 = date3.clone();
    return clone2.endOf("month");
  },
  getWeekDay: function getWeekDay(date3) {
    var clone2 = date3.clone().locale("en_US");
    return clone2.weekday() + clone2.localeData().firstDayOfWeek();
  },
  getYear: function getYear(date3) {
    return date3.year();
  },
  getMonth: function getMonth(date3) {
    return date3.month();
  },
  getDate: function getDate(date3) {
    return date3.date();
  },
  getHour: function getHour(date3) {
    return date3.hour();
  },
  getMinute: function getMinute(date3) {
    return date3.minute();
  },
  getSecond: function getSecond(date3) {
    return date3.second();
  },
  addYear: function addYear(date3, diff) {
    var clone2 = date3.clone();
    return clone2.add(diff, "year");
  },
  addMonth: function addMonth(date3, diff) {
    var clone2 = date3.clone();
    return clone2.add(diff, "month");
  },
  addDate: function addDate(date3, diff) {
    var clone2 = date3.clone();
    return clone2.add(diff, "day");
  },
  setYear: function setYear(date3, year) {
    var clone2 = date3.clone();
    return clone2.year(year);
  },
  setMonth: function setMonth(date3, month) {
    var clone2 = date3.clone();
    return clone2.month(month);
  },
  setDate: function setDate(date3, num) {
    var clone2 = date3.clone();
    return clone2.date(num);
  },
  setHour: function setHour(date3, hour) {
    var clone2 = date3.clone();
    return clone2.hour(hour);
  },
  setMinute: function setMinute(date3, minute) {
    var clone2 = date3.clone();
    return clone2.minute(minute);
  },
  setSecond: function setSecond(date3, second) {
    var clone2 = date3.clone();
    return clone2.second(second);
  },
  isAfter: function isAfter(date1, date22) {
    return date1.isAfter(date22);
  },
  isValidate: function isValidate(date3) {
    return date3.isValid();
  },
  locale: {
    getWeekFirstDay: function getWeekFirstDay(locale2) {
      var date3 = moment().locale(locale2);
      return date3.localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function getWeekFirstDate(locale2, date3) {
      var clone2 = date3.clone();
      var result = clone2.locale(locale2);
      return result.weekday(0);
    },
    getWeek: function getWeek(locale2, date3) {
      var clone2 = date3.clone();
      var result = clone2.locale(locale2);
      return result.week();
    },
    getShortWeekDays: function getShortWeekDays(locale2) {
      var date3 = moment().locale(locale2);
      return date3.localeData().weekdaysMin();
    },
    getShortMonths: function getShortMonths(locale2) {
      var date3 = moment().locale(locale2);
      return date3.localeData().monthsShort();
    },
    format: function format(locale2, date3, _format) {
      var clone2 = date3.clone();
      var result = clone2.locale(locale2);
      return result.format(_format);
    },
    parse: function parse(locale2, text, formats) {
      var fallbackFormatList = [];
      for (var i2 = 0; i2 < formats.length; i2 += 1) {
        var format3 = formats[i2];
        var formatText = text;
        if (format3.includes("wo") || format3.includes("Wo")) {
          format3 = format3.replace(/wo/g, "w").replace(/Wo/g, "W");
          var matchFormat = format3.match(/[-YyMmDdHhSsWwGg]+/g);
          var matchText = formatText.match(/[-\d]+/g);
          if (matchFormat && matchText) {
            format3 = matchFormat.join("");
            formatText = matchText.join("");
          } else {
            fallbackFormatList.push(format3.replace(/o/g, ""));
          }
        }
        var date3 = moment(formatText, format3, locale2, true);
        if (date3.isValid()) {
          return date3;
        }
      }
      for (var _i = 0; _i < fallbackFormatList.length; _i += 1) {
        var _date = moment(text, fallbackFormatList[_i], locale2, false);
        if (_date.isValid()) {
          noteOnce(false, "Not match any format strictly and fallback to fuzzy match. Please help to fire a issue about this.");
          return _date;
        }
      }
      return null;
    }
  }
};
var MAX_SAFE_INTEGER = 9007199254740991;
var nativeFloor = Math.floor;
function baseRepeat$1(string2, n3) {
  var result = "";
  if (!string2 || n3 < 1 || n3 > MAX_SAFE_INTEGER) {
    return result;
  }
  do {
    if (n3 % 2) {
      result += string2;
    }
    n3 = nativeFloor(n3 / 2);
    if (n3) {
      string2 += string2;
    }
  } while (n3);
  return result;
}
var _baseRepeat = baseRepeat$1;
function arrayMap$1(array3, iteratee) {
  var index2 = -1, length = array3 == null ? 0 : array3.length, result = Array(length);
  while (++index2 < length) {
    result[index2] = iteratee(array3[index2], index2, array3);
  }
  return result;
}
var _arrayMap = arrayMap$1;
var baseGetTag = _baseGetTag;
var isObjectLike = isObjectLike_1;
var symbolTag = "[object Symbol]";
function isSymbol$2(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
var isSymbol_1 = isSymbol$2;
var Symbol$1 = _Symbol;
var arrayMap = _arrayMap;
var isArray = isArray_1;
var isSymbol$1 = isSymbol_1;
var INFINITY$1 = 1 / 0;
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0;
var symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString$2(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray(value)) {
    return arrayMap(value, baseToString$2) + "";
  }
  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}
var _baseToString = baseToString$2;
function baseSlice$1(array3, start, end) {
  var index2 = -1, length = array3.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index2 < length) {
    result[index2] = array3[index2 + start];
  }
  return result;
}
var _baseSlice = baseSlice$1;
var baseSlice = _baseSlice;
function castSlice$1(array3, start, end) {
  var length = array3.length;
  end = end === void 0 ? length : end;
  return !start && end >= length ? array3 : baseSlice(array3, start, end);
}
var _castSlice = castSlice$1;
var rsAstralRange$2 = "\\ud800-\\udfff";
var rsComboMarksRange$2 = "\\u0300-\\u036f";
var reComboHalfMarksRange$2 = "\\ufe20-\\ufe2f";
var rsComboSymbolsRange$2 = "\\u20d0-\\u20ff";
var rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2;
var rsVarRange$2 = "\\ufe0e\\ufe0f";
var rsZWJ$2 = "\\u200d";
var reHasUnicode = RegExp("[" + rsZWJ$2 + rsAstralRange$2 + rsComboRange$2 + rsVarRange$2 + "]");
function hasUnicode$3(string2) {
  return reHasUnicode.test(string2);
}
var _hasUnicode = hasUnicode$3;
function baseProperty$1(key2) {
  return function(object3) {
    return object3 == null ? void 0 : object3[key2];
  };
}
var _baseProperty = baseProperty$1;
var baseProperty = _baseProperty;
var asciiSize$1 = baseProperty("length");
var _asciiSize = asciiSize$1;
var rsAstralRange$1 = "\\ud800-\\udfff";
var rsComboMarksRange$1 = "\\u0300-\\u036f";
var reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f";
var rsComboSymbolsRange$1 = "\\u20d0-\\u20ff";
var rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
var rsVarRange$1 = "\\ufe0e\\ufe0f";
var rsAstral$1 = "[" + rsAstralRange$1 + "]";
var rsCombo$1 = "[" + rsComboRange$1 + "]";
var rsFitz$1 = "\\ud83c[\\udffb-\\udfff]";
var rsModifier$1 = "(?:" + rsCombo$1 + "|" + rsFitz$1 + ")";
var rsNonAstral$1 = "[^" + rsAstralRange$1 + "]";
var rsRegional$1 = "(?:\\ud83c[\\udde6-\\uddff]){2}";
var rsSurrPair$1 = "[\\ud800-\\udbff][\\udc00-\\udfff]";
var rsZWJ$1 = "\\u200d";
var reOptMod$1 = rsModifier$1 + "?";
var rsOptVar$1 = "[" + rsVarRange$1 + "]?";
var rsOptJoin$1 = "(?:" + rsZWJ$1 + "(?:" + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join("|") + ")" + rsOptVar$1 + reOptMod$1 + ")*";
var rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1;
var rsSymbol$1 = "(?:" + [rsNonAstral$1 + rsCombo$1 + "?", rsCombo$1, rsRegional$1, rsSurrPair$1, rsAstral$1].join("|") + ")";
var reUnicode$1 = RegExp(rsFitz$1 + "(?=" + rsFitz$1 + ")|" + rsSymbol$1 + rsSeq$1, "g");
function unicodeSize$1(string2) {
  var result = reUnicode$1.lastIndex = 0;
  while (reUnicode$1.test(string2)) {
    ++result;
  }
  return result;
}
var _unicodeSize = unicodeSize$1;
var asciiSize = _asciiSize;
var hasUnicode$2 = _hasUnicode;
var unicodeSize = _unicodeSize;
function stringSize$3(string2) {
  return hasUnicode$2(string2) ? unicodeSize(string2) : asciiSize(string2);
}
var _stringSize = stringSize$3;
function asciiToArray$1(string2) {
  return string2.split("");
}
var _asciiToArray = asciiToArray$1;
var rsAstralRange = "\\ud800-\\udfff";
var rsComboMarksRange = "\\u0300-\\u036f";
var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
var rsComboSymbolsRange = "\\u20d0-\\u20ff";
var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
var rsVarRange = "\\ufe0e\\ufe0f";
var rsAstral = "[" + rsAstralRange + "]";
var rsCombo = "[" + rsComboRange + "]";
var rsFitz = "\\ud83c[\\udffb-\\udfff]";
var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
var rsNonAstral = "[^" + rsAstralRange + "]";
var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
var rsZWJ = "\\u200d";
var reOptMod = rsModifier + "?";
var rsOptVar = "[" + rsVarRange + "]?";
var rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
var rsSeq = rsOptVar + reOptMod + rsOptJoin;
var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
function unicodeToArray$1(string2) {
  return string2.match(reUnicode) || [];
}
var _unicodeToArray = unicodeToArray$1;
var asciiToArray = _asciiToArray;
var hasUnicode$1 = _hasUnicode;
var unicodeToArray = _unicodeToArray;
function stringToArray$1(string2) {
  return hasUnicode$1(string2) ? unicodeToArray(string2) : asciiToArray(string2);
}
var _stringToArray = stringToArray$1;
var baseRepeat = _baseRepeat;
var baseToString$1 = _baseToString;
var castSlice = _castSlice;
var hasUnicode = _hasUnicode;
var stringSize$2 = _stringSize;
var stringToArray = _stringToArray;
var nativeCeil = Math.ceil;
function createPadding$2(length, chars) {
  chars = chars === void 0 ? " " : baseToString$1(chars);
  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? baseRepeat(chars, length) : chars;
  }
  var result = baseRepeat(chars, nativeCeil(length / stringSize$2(chars)));
  return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
}
var _createPadding = createPadding$2;
var reWhitespace = /\s/;
function trimmedEndIndex$1(string2) {
  var index2 = string2.length;
  while (index2-- && reWhitespace.test(string2.charAt(index2))) {
  }
  return index2;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string2) {
  return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
}
var _baseTrim = baseTrim$1;
var baseTrim = _baseTrim;
var isObject$1 = isObject_1;
var isSymbol = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$2(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$1(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$2;
var toNumber$1 = toNumber_1;
var INFINITY = 1 / 0;
var MAX_INTEGER = 17976931348623157e292;
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber$1(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
var toFinite_1 = toFinite$1;
var toFinite = toFinite_1;
function toInteger$2(value) {
  var result = toFinite(value), remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}
var toInteger_1 = toInteger$2;
var baseToString = _baseToString;
function toString$2(value) {
  return value == null ? "" : baseToString(value);
}
var toString_1 = toString$2;
var createPadding$1 = _createPadding;
var stringSize$1 = _stringSize;
var toInteger$1 = toInteger_1;
var toString$1 = toString_1;
function padStart(string2, length, chars) {
  string2 = toString$1(string2);
  length = toInteger$1(length);
  var strLength = length ? stringSize$1(string2) : 0;
  return length && strLength < length ? createPadding$1(length - strLength, chars) + string2 : string2;
}
var padStart_1 = padStart;
var PanelContext = /* @__PURE__ */ React.createContext({});
var HIDDEN_STYLE$2 = {
  visibility: "hidden"
};
function Header$2(_ref) {
  var prefixCls = _ref.prefixCls, _ref$prevIcon = _ref.prevIcon, prevIcon = _ref$prevIcon === void 0 ? "\u2039" : _ref$prevIcon, _ref$nextIcon = _ref.nextIcon, nextIcon = _ref$nextIcon === void 0 ? "\u203A" : _ref$nextIcon, _ref$superPrevIcon = _ref.superPrevIcon, superPrevIcon = _ref$superPrevIcon === void 0 ? "\xAB" : _ref$superPrevIcon, _ref$superNextIcon = _ref.superNextIcon, superNextIcon = _ref$superNextIcon === void 0 ? "\xBB" : _ref$superNextIcon, onSuperPrev = _ref.onSuperPrev, onSuperNext = _ref.onSuperNext, onPrev = _ref.onPrev, onNext = _ref.onNext, children = _ref.children;
  var _React$useContext = React.useContext(PanelContext), hideNextBtn = _React$useContext.hideNextBtn, hidePrevBtn = _React$useContext.hidePrevBtn;
  return /* @__PURE__ */ React.createElement("div", {
    className: prefixCls
  }, onSuperPrev && /* @__PURE__ */ React.createElement("button", {
    type: "button",
    onClick: onSuperPrev,
    tabIndex: -1,
    className: "".concat(prefixCls, "-super-prev-btn"),
    style: hidePrevBtn ? HIDDEN_STYLE$2 : {}
  }, superPrevIcon), onPrev && /* @__PURE__ */ React.createElement("button", {
    type: "button",
    onClick: onPrev,
    tabIndex: -1,
    className: "".concat(prefixCls, "-prev-btn"),
    style: hidePrevBtn ? HIDDEN_STYLE$2 : {}
  }, prevIcon), /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-view")
  }, children), onNext && /* @__PURE__ */ React.createElement("button", {
    type: "button",
    onClick: onNext,
    tabIndex: -1,
    className: "".concat(prefixCls, "-next-btn"),
    style: hideNextBtn ? HIDDEN_STYLE$2 : {}
  }, nextIcon), onSuperNext && /* @__PURE__ */ React.createElement("button", {
    type: "button",
    onClick: onSuperNext,
    tabIndex: -1,
    className: "".concat(prefixCls, "-super-next-btn"),
    style: hideNextBtn ? HIDDEN_STYLE$2 : {}
  }, superNextIcon));
}
function DecadeHeader(props) {
  var prefixCls = props.prefixCls, generateConfig2 = props.generateConfig, viewDate = props.viewDate, onPrevDecades = props.onPrevDecades, onNextDecades = props.onNextDecades;
  var _React$useContext = React.useContext(PanelContext), hideHeader = _React$useContext.hideHeader;
  if (hideHeader) {
    return null;
  }
  var headerPrefixCls = "".concat(prefixCls, "-header");
  var yearNumber = generateConfig2.getYear(viewDate);
  var startYear = Math.floor(yearNumber / DECADE_DISTANCE_COUNT) * DECADE_DISTANCE_COUNT;
  var endYear = startYear + DECADE_DISTANCE_COUNT - 1;
  return /* @__PURE__ */ React.createElement(Header$2, _extends$2({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevDecades,
    onSuperNext: onNextDecades
  }), startYear, "-", endYear);
}
function setTime(generateConfig2, date3, hour, minute, second) {
  var nextTime = generateConfig2.setHour(date3, hour);
  nextTime = generateConfig2.setMinute(nextTime, minute);
  nextTime = generateConfig2.setSecond(nextTime, second);
  return nextTime;
}
function setDateTime(generateConfig2, date3, defaultDate) {
  if (!defaultDate) {
    return date3;
  }
  var newDate = date3;
  newDate = generateConfig2.setHour(newDate, generateConfig2.getHour(defaultDate));
  newDate = generateConfig2.setMinute(newDate, generateConfig2.getMinute(defaultDate));
  newDate = generateConfig2.setSecond(newDate, generateConfig2.getSecond(defaultDate));
  return newDate;
}
function getLowerBoundTime(hour, minute, second, hourStep, minuteStep, secondStep) {
  var lowerBoundHour = Math.floor(hour / hourStep) * hourStep;
  if (lowerBoundHour < hour) {
    return [lowerBoundHour, 60 - minuteStep, 60 - secondStep];
  }
  var lowerBoundMinute = Math.floor(minute / minuteStep) * minuteStep;
  if (lowerBoundMinute < minute) {
    return [lowerBoundHour, lowerBoundMinute, 60 - secondStep];
  }
  var lowerBoundSecond = Math.floor(second / secondStep) * secondStep;
  return [lowerBoundHour, lowerBoundMinute, lowerBoundSecond];
}
function getLastDay(generateConfig2, date3) {
  var year = generateConfig2.getYear(date3);
  var month = generateConfig2.getMonth(date3) + 1;
  var endDate = generateConfig2.getEndDate(generateConfig2.getFixedDate("".concat(year, "-").concat(month, "-01")));
  var lastDay = generateConfig2.getDate(endDate);
  var monthShow = month < 10 ? "0".concat(month) : "".concat(month);
  return "".concat(year, "-").concat(monthShow, "-").concat(lastDay);
}
function PanelBody(_ref) {
  var prefixCls = _ref.prefixCls, disabledDate = _ref.disabledDate, onSelect = _ref.onSelect, picker = _ref.picker, rowNum = _ref.rowNum, colNum = _ref.colNum, prefixColumn = _ref.prefixColumn, rowClassName = _ref.rowClassName, baseDate = _ref.baseDate, getCellClassName = _ref.getCellClassName, getCellText = _ref.getCellText, getCellNode = _ref.getCellNode, getCellDate = _ref.getCellDate, generateConfig2 = _ref.generateConfig, titleCell = _ref.titleCell, headerCells = _ref.headerCells;
  var _React$useContext = React.useContext(PanelContext), onDateMouseEnter = _React$useContext.onDateMouseEnter, onDateMouseLeave = _React$useContext.onDateMouseLeave, mode = _React$useContext.mode;
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var rows = [];
  for (var i2 = 0; i2 < rowNum; i2 += 1) {
    var row = [];
    var rowStartDate = void 0;
    var _loop = function _loop2(j3) {
      var _objectSpread22;
      var offset3 = i2 * colNum + j3;
      var currentDate = getCellDate(baseDate, offset3);
      var disabled = getCellDateDisabled({
        cellDate: currentDate,
        mode,
        disabledDate,
        generateConfig: generateConfig2
      });
      if (j3 === 0) {
        rowStartDate = currentDate;
        if (prefixColumn) {
          row.push(prefixColumn(rowStartDate));
        }
      }
      var title = titleCell && titleCell(currentDate);
      row.push(/* @__PURE__ */ React.createElement("td", {
        key: j3,
        title,
        className: cn(cellPrefixCls, _objectSpread2$1((_objectSpread22 = {}, _defineProperty$4(_objectSpread22, "".concat(cellPrefixCls, "-disabled"), disabled), _defineProperty$4(_objectSpread22, "".concat(cellPrefixCls, "-start"), getCellText(currentDate) === 1 || picker === "year" && Number(title) % 10 === 0), _defineProperty$4(_objectSpread22, "".concat(cellPrefixCls, "-end"), title === getLastDay(generateConfig2, currentDate) || picker === "year" && Number(title) % 10 === 9), _objectSpread22), getCellClassName(currentDate))),
        onClick: function onClick() {
          if (!disabled) {
            onSelect(currentDate);
          }
        },
        onMouseEnter: function onMouseEnter() {
          if (!disabled && onDateMouseEnter) {
            onDateMouseEnter(currentDate);
          }
        },
        onMouseLeave: function onMouseLeave() {
          if (!disabled && onDateMouseLeave) {
            onDateMouseLeave(currentDate);
          }
        }
      }, getCellNode ? getCellNode(currentDate) : /* @__PURE__ */ React.createElement("div", {
        className: "".concat(cellPrefixCls, "-inner")
      }, getCellText(currentDate))));
    };
    for (var j2 = 0; j2 < colNum; j2 += 1) {
      _loop(j2);
    }
    rows.push(/* @__PURE__ */ React.createElement("tr", {
      key: i2,
      className: rowClassName && rowClassName(rowStartDate)
    }, row));
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-body")
  }, /* @__PURE__ */ React.createElement("table", {
    className: "".concat(prefixCls, "-content")
  }, headerCells && /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, headerCells)), /* @__PURE__ */ React.createElement("tbody", null, rows)));
}
var DECADE_COL_COUNT = 3;
var DECADE_ROW_COUNT = 4;
function DecadeBody(props) {
  var DECADE_UNIT_DIFF_DES = DECADE_UNIT_DIFF - 1;
  var prefixCls = props.prefixCls, viewDate = props.viewDate, generateConfig2 = props.generateConfig;
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var yearNumber = generateConfig2.getYear(viewDate);
  var decadeYearNumber = Math.floor(yearNumber / DECADE_UNIT_DIFF) * DECADE_UNIT_DIFF;
  var startDecadeYear = Math.floor(yearNumber / DECADE_DISTANCE_COUNT) * DECADE_DISTANCE_COUNT;
  var endDecadeYear = startDecadeYear + DECADE_DISTANCE_COUNT - 1;
  var baseDecadeYear = generateConfig2.setYear(viewDate, startDecadeYear - Math.ceil((DECADE_COL_COUNT * DECADE_ROW_COUNT * DECADE_UNIT_DIFF - DECADE_DISTANCE_COUNT) / 2));
  var getCellClassName = function getCellClassName2(date3) {
    var _ref;
    var startDecadeNumber = generateConfig2.getYear(date3);
    var endDecadeNumber = startDecadeNumber + DECADE_UNIT_DIFF_DES;
    return _ref = {}, _defineProperty$4(_ref, "".concat(cellPrefixCls, "-in-view"), startDecadeYear <= startDecadeNumber && endDecadeNumber <= endDecadeYear), _defineProperty$4(_ref, "".concat(cellPrefixCls, "-selected"), startDecadeNumber === decadeYearNumber), _ref;
  };
  return /* @__PURE__ */ React.createElement(PanelBody, _extends$2({}, props, {
    rowNum: DECADE_ROW_COUNT,
    colNum: DECADE_COL_COUNT,
    baseDate: baseDecadeYear,
    getCellText: function getCellText(date3) {
      var startDecadeNumber = generateConfig2.getYear(date3);
      return "".concat(startDecadeNumber, "-").concat(startDecadeNumber + DECADE_UNIT_DIFF_DES);
    },
    getCellClassName,
    getCellDate: function getCellDate(date3, offset3) {
      return generateConfig2.addYear(date3, offset3 * DECADE_UNIT_DIFF);
    }
  }));
}
var scrollIds = /* @__PURE__ */ new Map();
function waitElementReady(element, callback) {
  var id2;
  function tryOrNextFrame() {
    if (isVisible(element)) {
      callback();
    } else {
      id2 = wrapperRaf$1(function() {
        tryOrNextFrame();
      });
    }
  }
  tryOrNextFrame();
  return function() {
    wrapperRaf$1.cancel(id2);
  };
}
function scrollTo(element, to, duration) {
  if (scrollIds.get(element)) {
    cancelAnimationFrame(scrollIds.get(element));
  }
  if (duration <= 0) {
    scrollIds.set(element, requestAnimationFrame(function() {
      element.scrollTop = to;
    }));
    return;
  }
  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;
  scrollIds.set(element, requestAnimationFrame(function() {
    element.scrollTop += perTick;
    if (element.scrollTop !== to) {
      scrollTo(element, to, duration - 10);
    }
  }));
}
function createKeyDownHandler(event, _ref) {
  var onLeftRight = _ref.onLeftRight, onCtrlLeftRight = _ref.onCtrlLeftRight, onUpDown = _ref.onUpDown, onPageUpDown = _ref.onPageUpDown, onEnter = _ref.onEnter;
  var which = event.which, ctrlKey = event.ctrlKey, metaKey = event.metaKey;
  switch (which) {
    case KeyCode.LEFT:
      if (ctrlKey || metaKey) {
        if (onCtrlLeftRight) {
          onCtrlLeftRight(-1);
          return true;
        }
      } else if (onLeftRight) {
        onLeftRight(-1);
        return true;
      }
      break;
    case KeyCode.RIGHT:
      if (ctrlKey || metaKey) {
        if (onCtrlLeftRight) {
          onCtrlLeftRight(1);
          return true;
        }
      } else if (onLeftRight) {
        onLeftRight(1);
        return true;
      }
      break;
    case KeyCode.UP:
      if (onUpDown) {
        onUpDown(-1);
        return true;
      }
      break;
    case KeyCode.DOWN:
      if (onUpDown) {
        onUpDown(1);
        return true;
      }
      break;
    case KeyCode.PAGE_UP:
      if (onPageUpDown) {
        onPageUpDown(-1);
        return true;
      }
      break;
    case KeyCode.PAGE_DOWN:
      if (onPageUpDown) {
        onPageUpDown(1);
        return true;
      }
      break;
    case KeyCode.ENTER:
      if (onEnter) {
        onEnter();
        return true;
      }
      break;
  }
  return false;
}
function getDefaultFormat(format3, picker, showTime, use12Hours) {
  var mergedFormat = format3;
  if (!mergedFormat) {
    switch (picker) {
      case "time":
        mergedFormat = use12Hours ? "hh:mm:ss a" : "HH:mm:ss";
        break;
      case "week":
        mergedFormat = "gggg-wo";
        break;
      case "month":
        mergedFormat = "YYYY-MM";
        break;
      case "quarter":
        mergedFormat = "YYYY-[Q]Q";
        break;
      case "year":
        mergedFormat = "YYYY";
        break;
      default:
        mergedFormat = showTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
    }
  }
  return mergedFormat;
}
function getInputSize(picker, format3, generateConfig2) {
  var defaultSize = picker === "time" ? 8 : 10;
  var length = typeof format3 === "function" ? format3(generateConfig2.getNow()).length : format3.length;
  return Math.max(defaultSize, length) + 2;
}
var globalClickFunc = null;
var clickCallbacks = /* @__PURE__ */ new Set();
function addGlobalMouseDownEvent(callback) {
  if (!globalClickFunc && typeof window !== "undefined" && window.addEventListener) {
    globalClickFunc = function globalClickFunc2(e3) {
      _toConsumableArray(clickCallbacks).forEach(function(queueFunc) {
        queueFunc(e3);
      });
    };
    window.addEventListener("mousedown", globalClickFunc);
  }
  clickCallbacks.add(callback);
  return function() {
    clickCallbacks.delete(callback);
    if (clickCallbacks.size === 0) {
      window.removeEventListener("mousedown", globalClickFunc);
      globalClickFunc = null;
    }
  };
}
function getTargetFromEvent(e3) {
  var target = e3.target;
  if (e3.composed && target.shadowRoot) {
    var _e$composedPath;
    return ((_e$composedPath = e3.composedPath) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath.call(e3)[0]) || target;
  }
  return target;
}
var getYearNextMode = function getYearNextMode2(next) {
  if (next === "month" || next === "date") {
    return "year";
  }
  return next;
};
var getMonthNextMode = function getMonthNextMode2(next) {
  if (next === "date") {
    return "month";
  }
  return next;
};
var getQuarterNextMode = function getQuarterNextMode2(next) {
  if (next === "month" || next === "date") {
    return "quarter";
  }
  return next;
};
var getWeekNextMode = function getWeekNextMode2(next) {
  if (next === "date") {
    return "week";
  }
  return next;
};
var PickerModeMap = {
  year: getYearNextMode,
  month: getMonthNextMode,
  quarter: getQuarterNextMode,
  week: getWeekNextMode,
  time: null,
  date: null
};
function elementsContains(elements, target) {
  return elements.some(function(ele) {
    return ele && ele.contains(target);
  });
}
var DECADE_UNIT_DIFF = 10;
var DECADE_DISTANCE_COUNT = DECADE_UNIT_DIFF * 10;
function DecadePanel(props) {
  var prefixCls = props.prefixCls, onViewDateChange = props.onViewDateChange, generateConfig2 = props.generateConfig, viewDate = props.viewDate, operationRef = props.operationRef, onSelect = props.onSelect, onPanelChange = props.onPanelChange;
  var panelPrefixCls = "".concat(prefixCls, "-decade-panel");
  operationRef.current = {
    onKeyDown: function onKeyDown2(event) {
      return createKeyDownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          onSelect(generateConfig2.addYear(viewDate, diff * DECADE_UNIT_DIFF), "key");
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          onSelect(generateConfig2.addYear(viewDate, diff * DECADE_DISTANCE_COUNT), "key");
        },
        onUpDown: function onUpDown(diff) {
          onSelect(generateConfig2.addYear(viewDate, diff * DECADE_UNIT_DIFF * DECADE_COL_COUNT), "key");
        },
        onEnter: function onEnter() {
          onPanelChange("year", viewDate);
        }
      });
    }
  };
  var onDecadesChange = function onDecadesChange2(diff) {
    var newDate = generateConfig2.addYear(viewDate, diff * DECADE_DISTANCE_COUNT);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };
  var onInternalSelect = function onInternalSelect2(date3) {
    onSelect(date3, "mouse");
    onPanelChange("year", date3);
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: panelPrefixCls
  }, /* @__PURE__ */ React.createElement(DecadeHeader, _extends$2({}, props, {
    prefixCls,
    onPrevDecades: function onPrevDecades() {
      onDecadesChange(-1);
    },
    onNextDecades: function onNextDecades() {
      onDecadesChange(1);
    }
  })), /* @__PURE__ */ React.createElement(DecadeBody, _extends$2({}, props, {
    prefixCls,
    onSelect: onInternalSelect
  })));
}
var WEEK_DAY_COUNT = 7;
function isNullEqual(value1, value2) {
  if (!value1 && !value2) {
    return true;
  }
  if (!value1 || !value2) {
    return false;
  }
  return void 0;
}
function isSameDecade(generateConfig2, decade1, decade2) {
  var equal = isNullEqual(decade1, decade2);
  if (typeof equal === "boolean") {
    return equal;
  }
  var num1 = Math.floor(generateConfig2.getYear(decade1) / 10);
  var num2 = Math.floor(generateConfig2.getYear(decade2) / 10);
  return num1 === num2;
}
function isSameYear(generateConfig2, year1, year2) {
  var equal = isNullEqual(year1, year2);
  if (typeof equal === "boolean") {
    return equal;
  }
  return generateConfig2.getYear(year1) === generateConfig2.getYear(year2);
}
function getQuarter(generateConfig2, date3) {
  var quota = Math.floor(generateConfig2.getMonth(date3) / 3);
  return quota + 1;
}
function isSameQuarter(generateConfig2, quarter1, quarter2) {
  var equal = isNullEqual(quarter1, quarter2);
  if (typeof equal === "boolean") {
    return equal;
  }
  return isSameYear(generateConfig2, quarter1, quarter2) && getQuarter(generateConfig2, quarter1) === getQuarter(generateConfig2, quarter2);
}
function isSameMonth(generateConfig2, month1, month2) {
  var equal = isNullEqual(month1, month2);
  if (typeof equal === "boolean") {
    return equal;
  }
  return isSameYear(generateConfig2, month1, month2) && generateConfig2.getMonth(month1) === generateConfig2.getMonth(month2);
}
function isSameDate(generateConfig2, date1, date22) {
  var equal = isNullEqual(date1, date22);
  if (typeof equal === "boolean") {
    return equal;
  }
  return generateConfig2.getYear(date1) === generateConfig2.getYear(date22) && generateConfig2.getMonth(date1) === generateConfig2.getMonth(date22) && generateConfig2.getDate(date1) === generateConfig2.getDate(date22);
}
function isSameTime(generateConfig2, time1, time2) {
  var equal = isNullEqual(time1, time2);
  if (typeof equal === "boolean") {
    return equal;
  }
  return generateConfig2.getHour(time1) === generateConfig2.getHour(time2) && generateConfig2.getMinute(time1) === generateConfig2.getMinute(time2) && generateConfig2.getSecond(time1) === generateConfig2.getSecond(time2);
}
function isSameWeek(generateConfig2, locale2, date1, date22) {
  var equal = isNullEqual(date1, date22);
  if (typeof equal === "boolean") {
    return equal;
  }
  return generateConfig2.locale.getWeek(locale2, date1) === generateConfig2.locale.getWeek(locale2, date22);
}
function isEqual(generateConfig2, value1, value2) {
  return isSameDate(generateConfig2, value1, value2) && isSameTime(generateConfig2, value1, value2);
}
function isInRange(generateConfig2, startDate, endDate, current) {
  if (!startDate || !endDate || !current) {
    return false;
  }
  return !isSameDate(generateConfig2, startDate, current) && !isSameDate(generateConfig2, endDate, current) && generateConfig2.isAfter(current, startDate) && generateConfig2.isAfter(endDate, current);
}
function getWeekStartDate(locale2, generateConfig2, value) {
  var weekFirstDay = generateConfig2.locale.getWeekFirstDay(locale2);
  var monthStartDate = generateConfig2.setDate(value, 1);
  var startDateWeekDay = generateConfig2.getWeekDay(monthStartDate);
  var alignStartDate = generateConfig2.addDate(monthStartDate, weekFirstDay - startDateWeekDay);
  if (generateConfig2.getMonth(alignStartDate) === generateConfig2.getMonth(value) && generateConfig2.getDate(alignStartDate) > 1) {
    alignStartDate = generateConfig2.addDate(alignStartDate, -7);
  }
  return alignStartDate;
}
function getClosingViewDate(viewDate, picker, generateConfig2) {
  var offset3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  switch (picker) {
    case "year":
      return generateConfig2.addYear(viewDate, offset3 * 10);
    case "quarter":
    case "month":
      return generateConfig2.addYear(viewDate, offset3);
    default:
      return generateConfig2.addMonth(viewDate, offset3);
  }
}
function formatValue(value, _ref) {
  var generateConfig2 = _ref.generateConfig, locale2 = _ref.locale, format3 = _ref.format;
  return typeof format3 === "function" ? format3(value) : generateConfig2.locale.format(locale2.locale, value, format3);
}
function parseValue(value, _ref2) {
  var generateConfig2 = _ref2.generateConfig, locale2 = _ref2.locale, formatList = _ref2.formatList;
  if (!value || typeof formatList[0] === "function") {
    return null;
  }
  return generateConfig2.locale.parse(locale2.locale, value, formatList);
}
function getCellDateDisabled(_ref3) {
  var cellDate = _ref3.cellDate, mode = _ref3.mode, disabledDate = _ref3.disabledDate, generateConfig2 = _ref3.generateConfig;
  if (!disabledDate)
    return false;
  var getDisabledFromRange = function getDisabledFromRange2(currentMode, start, end) {
    var current = start;
    while (current <= end) {
      var date3 = void 0;
      switch (currentMode) {
        case "date": {
          date3 = generateConfig2.setDate(cellDate, current);
          if (!disabledDate(date3)) {
            return false;
          }
          break;
        }
        case "month": {
          date3 = generateConfig2.setMonth(cellDate, current);
          if (!getCellDateDisabled({
            cellDate: date3,
            mode: "month",
            generateConfig: generateConfig2,
            disabledDate
          })) {
            return false;
          }
          break;
        }
        case "year": {
          date3 = generateConfig2.setYear(cellDate, current);
          if (!getCellDateDisabled({
            cellDate: date3,
            mode: "year",
            generateConfig: generateConfig2,
            disabledDate
          })) {
            return false;
          }
          break;
        }
      }
      current += 1;
    }
    return true;
  };
  switch (mode) {
    case "date":
    case "week": {
      return disabledDate(cellDate);
    }
    case "month": {
      var startDate = 1;
      var endDate = generateConfig2.getDate(generateConfig2.getEndDate(cellDate));
      return getDisabledFromRange("date", startDate, endDate);
    }
    case "quarter": {
      var startMonth = Math.floor(generateConfig2.getMonth(cellDate) / 3) * 3;
      var endMonth = startMonth + 2;
      return getDisabledFromRange("month", startMonth, endMonth);
    }
    case "year": {
      return getDisabledFromRange("month", 0, 11);
    }
    case "decade": {
      var year = generateConfig2.getYear(cellDate);
      var startYear = Math.floor(year / DECADE_UNIT_DIFF) * DECADE_UNIT_DIFF;
      var endYear = startYear + DECADE_UNIT_DIFF - 1;
      return getDisabledFromRange("year", startYear, endYear);
    }
  }
}
function TimeHeader(props) {
  var _React$useContext = React.useContext(PanelContext), hideHeader = _React$useContext.hideHeader;
  if (hideHeader) {
    return null;
  }
  var prefixCls = props.prefixCls, generateConfig2 = props.generateConfig, locale2 = props.locale, value = props.value, format3 = props.format;
  var headerPrefixCls = "".concat(prefixCls, "-header");
  return /* @__PURE__ */ React.createElement(Header$2, {
    prefixCls: headerPrefixCls
  }, value ? formatValue(value, {
    locale: locale2,
    format: format3,
    generateConfig: generateConfig2
  }) : "\xA0");
}
function TimeUnitColumn(props) {
  var prefixCls = props.prefixCls, units = props.units, onSelect = props.onSelect, value = props.value, active = props.active, hideDisabledOptions = props.hideDisabledOptions;
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var _React$useContext = React.useContext(PanelContext), open = _React$useContext.open;
  var ulRef = useRef2(null);
  var liRefs = useRef2(/* @__PURE__ */ new Map());
  var scrollRef = useRef2();
  useLayoutEffect$3(function() {
    var li = liRefs.current.get(value);
    if (li && open !== false) {
      scrollTo(ulRef.current, li.offsetTop, 120);
    }
  }, [value]);
  useLayoutEffect$3(function() {
    if (open) {
      var li = liRefs.current.get(value);
      if (li) {
        scrollRef.current = waitElementReady(li, function() {
          scrollTo(ulRef.current, li.offsetTop, 0);
        });
      }
    }
    return function() {
      var _scrollRef$current;
      (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.call(scrollRef);
    };
  }, [open]);
  return /* @__PURE__ */ React.createElement("ul", {
    className: cn("".concat(prefixCls, "-column"), _defineProperty$4({}, "".concat(prefixCls, "-column-active"), active)),
    ref: ulRef,
    style: {
      position: "relative"
    }
  }, units.map(function(unit) {
    var _classNames2;
    if (hideDisabledOptions && unit.disabled) {
      return null;
    }
    return /* @__PURE__ */ React.createElement("li", {
      key: unit.value,
      ref: function ref(element) {
        liRefs.current.set(unit.value, element);
      },
      className: cn(cellPrefixCls, (_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(cellPrefixCls, "-disabled"), unit.disabled), _defineProperty$4(_classNames2, "".concat(cellPrefixCls, "-selected"), value === unit.value), _classNames2)),
      onClick: function onClick() {
        if (unit.disabled) {
          return;
        }
        onSelect(unit.value);
      }
    }, /* @__PURE__ */ React.createElement("div", {
      className: "".concat(cellPrefixCls, "-inner")
    }, unit.label));
  }));
}
function leftPad(str, length) {
  var fill = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
  var current = String(str);
  while (current.length < length) {
    current = "".concat(fill).concat(str);
  }
  return current;
}
var tuple2 = function tuple3() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args;
};
function toArray$5(val) {
  if (val === null || val === void 0) {
    return [];
  }
  return Array.isArray(val) ? val : [val];
}
function getDataOrAriaProps(props) {
  var retProps = {};
  Object.keys(props).forEach(function(key2) {
    if ((key2.substr(0, 5) === "data-" || key2.substr(0, 5) === "aria-" || key2 === "role" || key2 === "name") && key2.substr(0, 7) !== "data-__") {
      retProps[key2] = props[key2];
    }
  });
  return retProps;
}
function getValue(values, index2) {
  return values ? values[index2] : null;
}
function updateValues(values, value, index2) {
  var newValues = [getValue(values, 0), getValue(values, 1)];
  newValues[index2] = typeof value === "function" ? value(newValues[index2]) : value;
  if (!newValues[0] && !newValues[1]) {
    return null;
  }
  return newValues;
}
function shouldUnitsUpdate(prevUnits, nextUnits) {
  if (prevUnits.length !== nextUnits.length)
    return true;
  for (var i2 = 0; i2 < prevUnits.length; i2 += 1) {
    if (prevUnits[i2].disabled !== nextUnits[i2].disabled)
      return true;
  }
  return false;
}
function generateUnits(start, end, step, disabledUnits) {
  var units = [];
  for (var i2 = start; i2 <= end; i2 += step) {
    units.push({
      label: leftPad(i2, 2),
      value: i2,
      disabled: (disabledUnits || []).includes(i2)
    });
  }
  return units;
}
function TimeBody(props) {
  var generateConfig2 = props.generateConfig, prefixCls = props.prefixCls, operationRef = props.operationRef, activeColumnIndex = props.activeColumnIndex, value = props.value, showHour = props.showHour, showMinute = props.showMinute, showSecond = props.showSecond, use12Hours = props.use12Hours, _props$hourStep = props.hourStep, hourStep = _props$hourStep === void 0 ? 1 : _props$hourStep, _props$minuteStep = props.minuteStep, minuteStep = _props$minuteStep === void 0 ? 1 : _props$minuteStep, _props$secondStep = props.secondStep, secondStep = _props$secondStep === void 0 ? 1 : _props$secondStep, disabledHours = props.disabledHours, disabledMinutes = props.disabledMinutes, disabledSeconds = props.disabledSeconds, hideDisabledOptions = props.hideDisabledOptions, onSelect = props.onSelect;
  var columns = [];
  var contentPrefixCls = "".concat(prefixCls, "-content");
  var columnPrefixCls = "".concat(prefixCls, "-time-panel");
  var isPM;
  var originHour = value ? generateConfig2.getHour(value) : -1;
  var hour = originHour;
  var minute = value ? generateConfig2.getMinute(value) : -1;
  var second = value ? generateConfig2.getSecond(value) : -1;
  var setTime$1 = function setTime$12(isNewPM, newHour, newMinute, newSecond) {
    var newDate = value || generateConfig2.getNow();
    var mergedHour = Math.max(0, newHour);
    var mergedMinute = Math.max(0, newMinute);
    var mergedSecond = Math.max(0, newSecond);
    newDate = setTime(generateConfig2, newDate, !use12Hours || !isNewPM ? mergedHour : mergedHour + 12, mergedMinute, mergedSecond);
    return newDate;
  };
  var rawHours = generateUnits(0, 23, hourStep, disabledHours && disabledHours());
  var memorizedRawHours = useMemo2(function() {
    return rawHours;
  }, rawHours, shouldUnitsUpdate);
  if (use12Hours) {
    isPM = hour >= 12;
    hour %= 12;
  }
  var _React$useMemo = React.useMemo(function() {
    if (!use12Hours) {
      return [false, false];
    }
    var AMPMDisabled = [true, true];
    memorizedRawHours.forEach(function(_ref) {
      var disabled = _ref.disabled, hourValue = _ref.value;
      if (disabled)
        return;
      if (hourValue >= 12) {
        AMPMDisabled[1] = false;
      } else {
        AMPMDisabled[0] = false;
      }
    });
    return AMPMDisabled;
  }, [use12Hours, memorizedRawHours]), _React$useMemo2 = _slicedToArray$3(_React$useMemo, 2), AMDisabled = _React$useMemo2[0], PMDisabled = _React$useMemo2[1];
  var hours = React.useMemo(function() {
    if (!use12Hours)
      return memorizedRawHours;
    return memorizedRawHours.filter(isPM ? function(hourMeta) {
      return hourMeta.value >= 12;
    } : function(hourMeta) {
      return hourMeta.value < 12;
    }).map(function(hourMeta) {
      var hourValue = hourMeta.value % 12;
      var hourLabel = hourValue === 0 ? "12" : leftPad(hourValue, 2);
      return _objectSpread2$1(_objectSpread2$1({}, hourMeta), {}, {
        label: hourLabel,
        value: hourValue
      });
    });
  }, [use12Hours, isPM, memorizedRawHours]);
  var minutes = generateUnits(0, 59, minuteStep, disabledMinutes && disabledMinutes(originHour));
  var seconds = generateUnits(0, 59, secondStep, disabledSeconds && disabledSeconds(originHour, minute));
  operationRef.current = {
    onUpDown: function onUpDown(diff) {
      var column = columns[activeColumnIndex];
      if (column) {
        var valueIndex = column.units.findIndex(function(unit) {
          return unit.value === column.value;
        });
        var unitLen = column.units.length;
        for (var i2 = 1; i2 < unitLen; i2 += 1) {
          var nextUnit = column.units[(valueIndex + diff * i2 + unitLen) % unitLen];
          if (nextUnit.disabled !== true) {
            column.onSelect(nextUnit.value);
            break;
          }
        }
      }
    }
  };
  function addColumnNode(condition, node, columnValue, units, onColumnSelect) {
    if (condition !== false) {
      columns.push({
        node: /* @__PURE__ */ React.cloneElement(node, {
          prefixCls: columnPrefixCls,
          value: columnValue,
          active: activeColumnIndex === columns.length,
          onSelect: onColumnSelect,
          units,
          hideDisabledOptions
        }),
        onSelect: onColumnSelect,
        value: columnValue,
        units
      });
    }
  }
  addColumnNode(showHour, /* @__PURE__ */ React.createElement(TimeUnitColumn, {
    key: "hour"
  }), hour, hours, function(num) {
    onSelect(setTime$1(isPM, num, minute, second), "mouse");
  });
  addColumnNode(showMinute, /* @__PURE__ */ React.createElement(TimeUnitColumn, {
    key: "minute"
  }), minute, minutes, function(num) {
    onSelect(setTime$1(isPM, hour, num, second), "mouse");
  });
  addColumnNode(showSecond, /* @__PURE__ */ React.createElement(TimeUnitColumn, {
    key: "second"
  }), second, seconds, function(num) {
    onSelect(setTime$1(isPM, hour, minute, num), "mouse");
  });
  var PMIndex = -1;
  if (typeof isPM === "boolean") {
    PMIndex = isPM ? 1 : 0;
  }
  addColumnNode(use12Hours === true, /* @__PURE__ */ React.createElement(TimeUnitColumn, {
    key: "12hours"
  }), PMIndex, [{
    label: "AM",
    value: 0,
    disabled: AMDisabled
  }, {
    label: "PM",
    value: 1,
    disabled: PMDisabled
  }], function(num) {
    onSelect(setTime$1(!!num, hour, minute, second), "mouse");
  });
  return /* @__PURE__ */ React.createElement("div", {
    className: contentPrefixCls
  }, columns.map(function(_ref2) {
    var node = _ref2.node;
    return node;
  }));
}
var countBoolean = function countBoolean2(boolList) {
  return boolList.filter(function(bool) {
    return bool !== false;
  }).length;
};
function TimePanel(props) {
  var generateConfig2 = props.generateConfig, _props$format = props.format, format3 = _props$format === void 0 ? "HH:mm:ss" : _props$format, prefixCls = props.prefixCls, active = props.active, operationRef = props.operationRef, showHour = props.showHour, showMinute = props.showMinute, showSecond = props.showSecond, _props$use12Hours = props.use12Hours, use12Hours = _props$use12Hours === void 0 ? false : _props$use12Hours, onSelect = props.onSelect, value = props.value;
  var panelPrefixCls = "".concat(prefixCls, "-time-panel");
  var bodyOperationRef = React.useRef();
  var _React$useState = React.useState(-1), _React$useState2 = _slicedToArray$3(_React$useState, 2), activeColumnIndex = _React$useState2[0], setActiveColumnIndex = _React$useState2[1];
  var columnsCount = countBoolean([showHour, showMinute, showSecond, use12Hours]);
  operationRef.current = {
    onKeyDown: function onKeyDown2(event) {
      return createKeyDownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          setActiveColumnIndex((activeColumnIndex + diff + columnsCount) % columnsCount);
        },
        onUpDown: function onUpDown(diff) {
          if (activeColumnIndex === -1) {
            setActiveColumnIndex(0);
          } else if (bodyOperationRef.current) {
            bodyOperationRef.current.onUpDown(diff);
          }
        },
        onEnter: function onEnter() {
          onSelect(value || generateConfig2.getNow(), "key");
          setActiveColumnIndex(-1);
        }
      });
    },
    onBlur: function onBlur2() {
      setActiveColumnIndex(-1);
    }
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: cn(panelPrefixCls, _defineProperty$4({}, "".concat(panelPrefixCls, "-active"), active))
  }, /* @__PURE__ */ React.createElement(TimeHeader, _extends$2({}, props, {
    format: format3,
    prefixCls
  })), /* @__PURE__ */ React.createElement(TimeBody, _extends$2({}, props, {
    prefixCls,
    activeColumnIndex,
    operationRef: bodyOperationRef
  })));
}
var RangeContext = /* @__PURE__ */ React.createContext({});
function useCellClassName(_ref) {
  var cellPrefixCls = _ref.cellPrefixCls, generateConfig2 = _ref.generateConfig, rangedValue = _ref.rangedValue, hoverRangedValue = _ref.hoverRangedValue, isInView = _ref.isInView, isSameCell = _ref.isSameCell, offsetCell = _ref.offsetCell, today = _ref.today, value = _ref.value;
  function getClassName(currentDate) {
    var _ref2;
    var prevDate = offsetCell(currentDate, -1);
    var nextDate = offsetCell(currentDate, 1);
    var rangeStart = getValue(rangedValue, 0);
    var rangeEnd = getValue(rangedValue, 1);
    var hoverStart = getValue(hoverRangedValue, 0);
    var hoverEnd = getValue(hoverRangedValue, 1);
    var isRangeHovered = isInRange(generateConfig2, hoverStart, hoverEnd, currentDate);
    function isRangeStart(date3) {
      return isSameCell(rangeStart, date3);
    }
    function isRangeEnd(date3) {
      return isSameCell(rangeEnd, date3);
    }
    var isHoverStart = isSameCell(hoverStart, currentDate);
    var isHoverEnd = isSameCell(hoverEnd, currentDate);
    var isHoverEdgeStart = (isRangeHovered || isHoverEnd) && (!isInView(prevDate) || isRangeEnd(prevDate));
    var isHoverEdgeEnd = (isRangeHovered || isHoverStart) && (!isInView(nextDate) || isRangeStart(nextDate));
    return _ref2 = {}, _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-in-view"), isInView(currentDate)), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-in-range"), isInRange(generateConfig2, rangeStart, rangeEnd, currentDate)), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-range-start"), isRangeStart(currentDate)), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-range-end"), isRangeEnd(currentDate)), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-range-start-single"), isRangeStart(currentDate) && !rangeEnd), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-range-end-single"), isRangeEnd(currentDate) && !rangeStart), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-range-start-near-hover"), isRangeStart(currentDate) && (isSameCell(prevDate, hoverStart) || isInRange(generateConfig2, hoverStart, hoverEnd, prevDate))), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-range-end-near-hover"), isRangeEnd(currentDate) && (isSameCell(nextDate, hoverEnd) || isInRange(generateConfig2, hoverStart, hoverEnd, nextDate))), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-range-hover"), isRangeHovered), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-range-hover-start"), isHoverStart), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-range-hover-end"), isHoverEnd), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-start"), isHoverEdgeStart), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-end"), isHoverEdgeEnd), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-start-near-range"), isHoverEdgeStart && isSameCell(prevDate, rangeEnd)), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-end-near-range"), isHoverEdgeEnd && isSameCell(nextDate, rangeStart)), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-today"), isSameCell(today, currentDate)), _defineProperty$4(_ref2, "".concat(cellPrefixCls, "-selected"), isSameCell(value, currentDate)), _ref2;
  }
  return getClassName;
}
function DateBody(props) {
  var prefixCls = props.prefixCls, generateConfig2 = props.generateConfig, prefixColumn = props.prefixColumn, locale2 = props.locale, rowCount = props.rowCount, viewDate = props.viewDate, value = props.value, dateRender = props.dateRender;
  var _React$useContext = React.useContext(RangeContext), rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
  var baseDate = getWeekStartDate(locale2.locale, generateConfig2, viewDate);
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var weekFirstDay = generateConfig2.locale.getWeekFirstDay(locale2.locale);
  var today = generateConfig2.getNow();
  var headerCells = [];
  var weekDaysLocale = locale2.shortWeekDays || (generateConfig2.locale.getShortWeekDays ? generateConfig2.locale.getShortWeekDays(locale2.locale) : []);
  if (prefixColumn) {
    headerCells.push(/* @__PURE__ */ React.createElement("th", {
      key: "empty",
      "aria-label": "empty cell"
    }));
  }
  for (var i2 = 0; i2 < WEEK_DAY_COUNT; i2 += 1) {
    headerCells.push(/* @__PURE__ */ React.createElement("th", {
      key: i2
    }, weekDaysLocale[(i2 + weekFirstDay) % WEEK_DAY_COUNT]));
  }
  var getCellClassName = useCellClassName({
    cellPrefixCls,
    today,
    value,
    generateConfig: generateConfig2,
    rangedValue: prefixColumn ? null : rangedValue,
    hoverRangedValue: prefixColumn ? null : hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return isSameDate(generateConfig2, current, target);
    },
    isInView: function isInView(date3) {
      return isSameMonth(generateConfig2, date3, viewDate);
    },
    offsetCell: function offsetCell(date3, offset3) {
      return generateConfig2.addDate(date3, offset3);
    }
  });
  var getCellNode = dateRender ? function(date3) {
    return dateRender(date3, today);
  } : void 0;
  return /* @__PURE__ */ React.createElement(PanelBody, _extends$2({}, props, {
    rowNum: rowCount,
    colNum: WEEK_DAY_COUNT,
    baseDate,
    getCellNode,
    getCellText: generateConfig2.getDate,
    getCellClassName,
    getCellDate: generateConfig2.addDate,
    titleCell: function titleCell(date3) {
      return formatValue(date3, {
        locale: locale2,
        format: "YYYY-MM-DD",
        generateConfig: generateConfig2
      });
    },
    headerCells
  }));
}
function DateHeader(props) {
  var prefixCls = props.prefixCls, generateConfig2 = props.generateConfig, locale2 = props.locale, viewDate = props.viewDate, onNextMonth = props.onNextMonth, onPrevMonth = props.onPrevMonth, onNextYear = props.onNextYear, onPrevYear = props.onPrevYear, onYearClick = props.onYearClick, onMonthClick = props.onMonthClick;
  var _React$useContext = React.useContext(PanelContext), hideHeader = _React$useContext.hideHeader;
  if (hideHeader) {
    return null;
  }
  var headerPrefixCls = "".concat(prefixCls, "-header");
  var monthsLocale = locale2.shortMonths || (generateConfig2.locale.getShortMonths ? generateConfig2.locale.getShortMonths(locale2.locale) : []);
  var month = generateConfig2.getMonth(viewDate);
  var yearNode = /* @__PURE__ */ React.createElement("button", {
    type: "button",
    key: "year",
    onClick: onYearClick,
    tabIndex: -1,
    className: "".concat(prefixCls, "-year-btn")
  }, formatValue(viewDate, {
    locale: locale2,
    format: locale2.yearFormat,
    generateConfig: generateConfig2
  }));
  var monthNode = /* @__PURE__ */ React.createElement("button", {
    type: "button",
    key: "month",
    onClick: onMonthClick,
    tabIndex: -1,
    className: "".concat(prefixCls, "-month-btn")
  }, locale2.monthFormat ? formatValue(viewDate, {
    locale: locale2,
    format: locale2.monthFormat,
    generateConfig: generateConfig2
  }) : monthsLocale[month]);
  var monthYearNodes = locale2.monthBeforeYear ? [monthNode, yearNode] : [yearNode, monthNode];
  return /* @__PURE__ */ React.createElement(Header$2, _extends$2({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevYear,
    onPrev: onPrevMonth,
    onNext: onNextMonth,
    onSuperNext: onNextYear
  }), monthYearNodes);
}
var DATE_ROW_COUNT = 6;
function DatePanel(props) {
  var prefixCls = props.prefixCls, _props$panelName = props.panelName, panelName = _props$panelName === void 0 ? "date" : _props$panelName, keyboardConfig = props.keyboardConfig, active = props.active, operationRef = props.operationRef, generateConfig2 = props.generateConfig, value = props.value, viewDate = props.viewDate, onViewDateChange = props.onViewDateChange, onPanelChange = props.onPanelChange, _onSelect = props.onSelect;
  var panelPrefixCls = "".concat(prefixCls, "-").concat(panelName, "-panel");
  operationRef.current = {
    onKeyDown: function onKeyDown2(event) {
      return createKeyDownHandler(event, _objectSpread2$1({
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig2.addDate(value || viewDate, diff), "key");
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff), "key");
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig2.addDate(value || viewDate, diff * WEEK_DAY_COUNT), "key");
        },
        onPageUpDown: function onPageUpDown(diff) {
          _onSelect(generateConfig2.addMonth(value || viewDate, diff), "key");
        }
      }, keyboardConfig));
    }
  };
  var onYearChange = function onYearChange2(diff) {
    var newDate = generateConfig2.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };
  var onMonthChange = function onMonthChange2(diff) {
    var newDate = generateConfig2.addMonth(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: cn(panelPrefixCls, _defineProperty$4({}, "".concat(panelPrefixCls, "-active"), active))
  }, /* @__PURE__ */ React.createElement(DateHeader, _extends$2({}, props, {
    prefixCls,
    value,
    viewDate,
    onPrevYear: function onPrevYear() {
      onYearChange(-1);
    },
    onNextYear: function onNextYear() {
      onYearChange(1);
    },
    onPrevMonth: function onPrevMonth() {
      onMonthChange(-1);
    },
    onNextMonth: function onNextMonth() {
      onMonthChange(1);
    },
    onMonthClick: function onMonthClick() {
      onPanelChange("month", viewDate);
    },
    onYearClick: function onYearClick() {
      onPanelChange("year", viewDate);
    }
  })), /* @__PURE__ */ React.createElement(DateBody, _extends$2({}, props, {
    onSelect: function onSelect(date3) {
      return _onSelect(date3, "mouse");
    },
    prefixCls,
    value,
    viewDate,
    rowCount: DATE_ROW_COUNT
  })));
}
var ACTIVE_PANEL = tuple2("date", "time");
function DatetimePanel(props) {
  var prefixCls = props.prefixCls, operationRef = props.operationRef, generateConfig2 = props.generateConfig, value = props.value, defaultValue = props.defaultValue, disabledTime = props.disabledTime, showTime = props.showTime, onSelect = props.onSelect;
  var panelPrefixCls = "".concat(prefixCls, "-datetime-panel");
  var _React$useState = React.useState(null), _React$useState2 = _slicedToArray$3(_React$useState, 2), activePanel = _React$useState2[0], setActivePanel = _React$useState2[1];
  var dateOperationRef = React.useRef({});
  var timeOperationRef = React.useRef({});
  var timeProps = _typeof$5(showTime) === "object" ? _objectSpread2$1({}, showTime) : {};
  function getNextActive(offset3) {
    var activeIndex = ACTIVE_PANEL.indexOf(activePanel) + offset3;
    var nextActivePanel = ACTIVE_PANEL[activeIndex] || null;
    return nextActivePanel;
  }
  var onBlur2 = function onBlur3(e3) {
    if (timeOperationRef.current.onBlur) {
      timeOperationRef.current.onBlur(e3);
    }
    setActivePanel(null);
  };
  operationRef.current = {
    onKeyDown: function onKeyDown2(event) {
      if (event.which === KeyCode.TAB) {
        var nextActivePanel = getNextActive(event.shiftKey ? -1 : 1);
        setActivePanel(nextActivePanel);
        if (nextActivePanel) {
          event.preventDefault();
        }
        return true;
      }
      if (activePanel) {
        var ref = activePanel === "date" ? dateOperationRef : timeOperationRef;
        if (ref.current && ref.current.onKeyDown) {
          ref.current.onKeyDown(event);
        }
        return true;
      }
      if ([KeyCode.LEFT, KeyCode.RIGHT, KeyCode.UP, KeyCode.DOWN].includes(event.which)) {
        setActivePanel("date");
        return true;
      }
      return false;
    },
    onBlur: onBlur2,
    onClose: onBlur2
  };
  var onInternalSelect = function onInternalSelect2(date3, source) {
    var selectedDate = date3;
    if (source === "date" && !value && timeProps.defaultValue) {
      selectedDate = generateConfig2.setHour(selectedDate, generateConfig2.getHour(timeProps.defaultValue));
      selectedDate = generateConfig2.setMinute(selectedDate, generateConfig2.getMinute(timeProps.defaultValue));
      selectedDate = generateConfig2.setSecond(selectedDate, generateConfig2.getSecond(timeProps.defaultValue));
    } else if (source === "time" && !value && defaultValue) {
      selectedDate = generateConfig2.setYear(selectedDate, generateConfig2.getYear(defaultValue));
      selectedDate = generateConfig2.setMonth(selectedDate, generateConfig2.getMonth(defaultValue));
      selectedDate = generateConfig2.setDate(selectedDate, generateConfig2.getDate(defaultValue));
    }
    if (onSelect) {
      onSelect(selectedDate, "mouse");
    }
  };
  var disabledTimes = disabledTime ? disabledTime(value || null) : {};
  return /* @__PURE__ */ React.createElement("div", {
    className: cn(panelPrefixCls, _defineProperty$4({}, "".concat(panelPrefixCls, "-active"), activePanel))
  }, /* @__PURE__ */ React.createElement(DatePanel, _extends$2({}, props, {
    operationRef: dateOperationRef,
    active: activePanel === "date",
    onSelect: function onSelect2(date3) {
      onInternalSelect(setDateTime(generateConfig2, date3, showTime && _typeof$5(showTime) === "object" ? showTime.defaultValue : null), "date");
    }
  })), /* @__PURE__ */ React.createElement(TimePanel, _extends$2({}, props, {
    format: void 0
  }, timeProps, disabledTimes, {
    defaultValue: void 0,
    operationRef: timeOperationRef,
    active: activePanel === "time",
    onSelect: function onSelect2(date3) {
      onInternalSelect(date3, "time");
    }
  })));
}
function WeekPanel(props) {
  var prefixCls = props.prefixCls, generateConfig2 = props.generateConfig, locale2 = props.locale, value = props.value;
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var prefixColumn = function prefixColumn2(date3) {
    return /* @__PURE__ */ React.createElement("td", {
      key: "week",
      className: cn(cellPrefixCls, "".concat(cellPrefixCls, "-week"))
    }, generateConfig2.locale.getWeek(locale2.locale, date3));
  };
  var rowPrefixCls = "".concat(prefixCls, "-week-panel-row");
  var rowClassName = function rowClassName2(date3) {
    return cn(rowPrefixCls, _defineProperty$4({}, "".concat(rowPrefixCls, "-selected"), isSameWeek(generateConfig2, locale2.locale, value, date3)));
  };
  return /* @__PURE__ */ React.createElement(DatePanel, _extends$2({}, props, {
    panelName: "week",
    prefixColumn,
    rowClassName,
    keyboardConfig: {
      onLeftRight: null
    }
  }));
}
function MonthHeader(props) {
  var prefixCls = props.prefixCls, generateConfig2 = props.generateConfig, locale2 = props.locale, viewDate = props.viewDate, onNextYear = props.onNextYear, onPrevYear = props.onPrevYear, onYearClick = props.onYearClick;
  var _React$useContext = React.useContext(PanelContext), hideHeader = _React$useContext.hideHeader;
  if (hideHeader) {
    return null;
  }
  var headerPrefixCls = "".concat(prefixCls, "-header");
  return /* @__PURE__ */ React.createElement(Header$2, _extends$2({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevYear,
    onSuperNext: onNextYear
  }), /* @__PURE__ */ React.createElement("button", {
    type: "button",
    onClick: onYearClick,
    className: "".concat(prefixCls, "-year-btn")
  }, formatValue(viewDate, {
    locale: locale2,
    format: locale2.yearFormat,
    generateConfig: generateConfig2
  })));
}
var MONTH_COL_COUNT = 3;
var MONTH_ROW_COUNT = 4;
function MonthBody(props) {
  var prefixCls = props.prefixCls, locale2 = props.locale, value = props.value, viewDate = props.viewDate, generateConfig2 = props.generateConfig, monthCellRender = props.monthCellRender;
  var _React$useContext = React.useContext(RangeContext), rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var getCellClassName = useCellClassName({
    cellPrefixCls,
    value,
    generateConfig: generateConfig2,
    rangedValue,
    hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return isSameMonth(generateConfig2, current, target);
    },
    isInView: function isInView() {
      return true;
    },
    offsetCell: function offsetCell(date3, offset3) {
      return generateConfig2.addMonth(date3, offset3);
    }
  });
  var monthsLocale = locale2.shortMonths || (generateConfig2.locale.getShortMonths ? generateConfig2.locale.getShortMonths(locale2.locale) : []);
  var baseMonth = generateConfig2.setMonth(viewDate, 0);
  var getCellNode = monthCellRender ? function(date3) {
    return monthCellRender(date3, locale2);
  } : void 0;
  return /* @__PURE__ */ React.createElement(PanelBody, _extends$2({}, props, {
    rowNum: MONTH_ROW_COUNT,
    colNum: MONTH_COL_COUNT,
    baseDate: baseMonth,
    getCellNode,
    getCellText: function getCellText(date3) {
      return locale2.monthFormat ? formatValue(date3, {
        locale: locale2,
        format: locale2.monthFormat,
        generateConfig: generateConfig2
      }) : monthsLocale[generateConfig2.getMonth(date3)];
    },
    getCellClassName,
    getCellDate: generateConfig2.addMonth,
    titleCell: function titleCell(date3) {
      return formatValue(date3, {
        locale: locale2,
        format: "YYYY-MM",
        generateConfig: generateConfig2
      });
    }
  }));
}
function MonthPanel(props) {
  var prefixCls = props.prefixCls, operationRef = props.operationRef, onViewDateChange = props.onViewDateChange, generateConfig2 = props.generateConfig, value = props.value, viewDate = props.viewDate, onPanelChange = props.onPanelChange, _onSelect = props.onSelect;
  var panelPrefixCls = "".concat(prefixCls, "-month-panel");
  operationRef.current = {
    onKeyDown: function onKeyDown2(event) {
      return createKeyDownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig2.addMonth(value || viewDate, diff), "key");
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff), "key");
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig2.addMonth(value || viewDate, diff * MONTH_COL_COUNT), "key");
        },
        onEnter: function onEnter() {
          onPanelChange("date", value || viewDate);
        }
      });
    }
  };
  var onYearChange = function onYearChange2(diff) {
    var newDate = generateConfig2.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: panelPrefixCls
  }, /* @__PURE__ */ React.createElement(MonthHeader, _extends$2({}, props, {
    prefixCls,
    onPrevYear: function onPrevYear() {
      onYearChange(-1);
    },
    onNextYear: function onNextYear() {
      onYearChange(1);
    },
    onYearClick: function onYearClick() {
      onPanelChange("year", viewDate);
    }
  })), /* @__PURE__ */ React.createElement(MonthBody, _extends$2({}, props, {
    prefixCls,
    onSelect: function onSelect(date3) {
      _onSelect(date3, "mouse");
      onPanelChange("date", date3);
    }
  })));
}
function QuarterHeader(props) {
  var prefixCls = props.prefixCls, generateConfig2 = props.generateConfig, locale2 = props.locale, viewDate = props.viewDate, onNextYear = props.onNextYear, onPrevYear = props.onPrevYear, onYearClick = props.onYearClick;
  var _React$useContext = React.useContext(PanelContext), hideHeader = _React$useContext.hideHeader;
  if (hideHeader) {
    return null;
  }
  var headerPrefixCls = "".concat(prefixCls, "-header");
  return /* @__PURE__ */ React.createElement(Header$2, _extends$2({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevYear,
    onSuperNext: onNextYear
  }), /* @__PURE__ */ React.createElement("button", {
    type: "button",
    onClick: onYearClick,
    className: "".concat(prefixCls, "-year-btn")
  }, formatValue(viewDate, {
    locale: locale2,
    format: locale2.yearFormat,
    generateConfig: generateConfig2
  })));
}
var QUARTER_COL_COUNT = 4;
var QUARTER_ROW_COUNT = 1;
function QuarterBody(props) {
  var prefixCls = props.prefixCls, locale2 = props.locale, value = props.value, viewDate = props.viewDate, generateConfig2 = props.generateConfig;
  var _React$useContext = React.useContext(RangeContext), rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var getCellClassName = useCellClassName({
    cellPrefixCls,
    value,
    generateConfig: generateConfig2,
    rangedValue,
    hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return isSameQuarter(generateConfig2, current, target);
    },
    isInView: function isInView() {
      return true;
    },
    offsetCell: function offsetCell(date3, offset3) {
      return generateConfig2.addMonth(date3, offset3 * 3);
    }
  });
  var baseQuarter = generateConfig2.setDate(generateConfig2.setMonth(viewDate, 0), 1);
  return /* @__PURE__ */ React.createElement(PanelBody, _extends$2({}, props, {
    rowNum: QUARTER_ROW_COUNT,
    colNum: QUARTER_COL_COUNT,
    baseDate: baseQuarter,
    getCellText: function getCellText(date3) {
      return formatValue(date3, {
        locale: locale2,
        format: locale2.quarterFormat || "[Q]Q",
        generateConfig: generateConfig2
      });
    },
    getCellClassName,
    getCellDate: function getCellDate(date3, offset3) {
      return generateConfig2.addMonth(date3, offset3 * 3);
    },
    titleCell: function titleCell(date3) {
      return formatValue(date3, {
        locale: locale2,
        format: "YYYY-[Q]Q",
        generateConfig: generateConfig2
      });
    }
  }));
}
function QuarterPanel(props) {
  var prefixCls = props.prefixCls, operationRef = props.operationRef, onViewDateChange = props.onViewDateChange, generateConfig2 = props.generateConfig, value = props.value, viewDate = props.viewDate, onPanelChange = props.onPanelChange, _onSelect = props.onSelect;
  var panelPrefixCls = "".concat(prefixCls, "-quarter-panel");
  operationRef.current = {
    onKeyDown: function onKeyDown2(event) {
      return createKeyDownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig2.addMonth(value || viewDate, diff * 3), "key");
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff), "key");
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff), "key");
        }
      });
    }
  };
  var onYearChange = function onYearChange2(diff) {
    var newDate = generateConfig2.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: panelPrefixCls
  }, /* @__PURE__ */ React.createElement(QuarterHeader, _extends$2({}, props, {
    prefixCls,
    onPrevYear: function onPrevYear() {
      onYearChange(-1);
    },
    onNextYear: function onNextYear() {
      onYearChange(1);
    },
    onYearClick: function onYearClick() {
      onPanelChange("year", viewDate);
    }
  })), /* @__PURE__ */ React.createElement(QuarterBody, _extends$2({}, props, {
    prefixCls,
    onSelect: function onSelect(date3) {
      _onSelect(date3, "mouse");
    }
  })));
}
function YearHeader(props) {
  var prefixCls = props.prefixCls, generateConfig2 = props.generateConfig, viewDate = props.viewDate, onPrevDecade = props.onPrevDecade, onNextDecade = props.onNextDecade, onDecadeClick = props.onDecadeClick;
  var _React$useContext = React.useContext(PanelContext), hideHeader = _React$useContext.hideHeader;
  if (hideHeader) {
    return null;
  }
  var headerPrefixCls = "".concat(prefixCls, "-header");
  var yearNumber = generateConfig2.getYear(viewDate);
  var startYear = Math.floor(yearNumber / YEAR_DECADE_COUNT) * YEAR_DECADE_COUNT;
  var endYear = startYear + YEAR_DECADE_COUNT - 1;
  return /* @__PURE__ */ React.createElement(Header$2, _extends$2({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevDecade,
    onSuperNext: onNextDecade
  }), /* @__PURE__ */ React.createElement("button", {
    type: "button",
    onClick: onDecadeClick,
    className: "".concat(prefixCls, "-decade-btn")
  }, startYear, "-", endYear));
}
var YEAR_COL_COUNT = 3;
var YEAR_ROW_COUNT = 4;
function YearBody(props) {
  var prefixCls = props.prefixCls, value = props.value, viewDate = props.viewDate, locale2 = props.locale, generateConfig2 = props.generateConfig;
  var _React$useContext = React.useContext(RangeContext), rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
  var yearPrefixCls = "".concat(prefixCls, "-cell");
  var yearNumber = generateConfig2.getYear(viewDate);
  var startYear = Math.floor(yearNumber / YEAR_DECADE_COUNT) * YEAR_DECADE_COUNT;
  var endYear = startYear + YEAR_DECADE_COUNT - 1;
  var baseYear = generateConfig2.setYear(viewDate, startYear - Math.ceil((YEAR_COL_COUNT * YEAR_ROW_COUNT - YEAR_DECADE_COUNT) / 2));
  var isInView = function isInView2(date3) {
    var currentYearNumber = generateConfig2.getYear(date3);
    return startYear <= currentYearNumber && currentYearNumber <= endYear;
  };
  var getCellClassName = useCellClassName({
    cellPrefixCls: yearPrefixCls,
    value,
    generateConfig: generateConfig2,
    rangedValue,
    hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return isSameYear(generateConfig2, current, target);
    },
    isInView,
    offsetCell: function offsetCell(date3, offset3) {
      return generateConfig2.addYear(date3, offset3);
    }
  });
  return /* @__PURE__ */ React.createElement(PanelBody, _extends$2({}, props, {
    rowNum: YEAR_ROW_COUNT,
    colNum: YEAR_COL_COUNT,
    baseDate: baseYear,
    getCellText: generateConfig2.getYear,
    getCellClassName,
    getCellDate: generateConfig2.addYear,
    titleCell: function titleCell(date3) {
      return formatValue(date3, {
        locale: locale2,
        format: "YYYY",
        generateConfig: generateConfig2
      });
    }
  }));
}
var YEAR_DECADE_COUNT = 10;
function YearPanel(props) {
  var prefixCls = props.prefixCls, operationRef = props.operationRef, onViewDateChange = props.onViewDateChange, generateConfig2 = props.generateConfig, value = props.value, viewDate = props.viewDate, sourceMode = props.sourceMode, _onSelect = props.onSelect, onPanelChange = props.onPanelChange;
  var panelPrefixCls = "".concat(prefixCls, "-year-panel");
  operationRef.current = {
    onKeyDown: function onKeyDown2(event) {
      return createKeyDownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff), "key");
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff * YEAR_DECADE_COUNT), "key");
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff * YEAR_COL_COUNT), "key");
        },
        onEnter: function onEnter() {
          onPanelChange(sourceMode === "date" ? "date" : "month", value || viewDate);
        }
      });
    }
  };
  var onDecadeChange = function onDecadeChange2(diff) {
    var newDate = generateConfig2.addYear(viewDate, diff * 10);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: panelPrefixCls
  }, /* @__PURE__ */ React.createElement(YearHeader, _extends$2({}, props, {
    prefixCls,
    onPrevDecade: function onPrevDecade() {
      onDecadeChange(-1);
    },
    onNextDecade: function onNextDecade() {
      onDecadeChange(1);
    },
    onDecadeClick: function onDecadeClick() {
      onPanelChange("decade", viewDate);
    }
  })), /* @__PURE__ */ React.createElement(YearBody, _extends$2({}, props, {
    prefixCls,
    onSelect: function onSelect(date3) {
      onPanelChange(sourceMode === "date" ? "date" : "month", date3);
      _onSelect(date3, "mouse");
    }
  })));
}
function getExtraFooter(prefixCls, mode, renderExtraFooter) {
  if (!renderExtraFooter) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-footer-extra")
  }, renderExtraFooter(mode));
}
function getRanges(_ref) {
  var prefixCls = _ref.prefixCls, _ref$rangeList = _ref.rangeList, rangeList = _ref$rangeList === void 0 ? [] : _ref$rangeList, _ref$components = _ref.components, components = _ref$components === void 0 ? {} : _ref$components, needConfirmButton = _ref.needConfirmButton, onNow = _ref.onNow, onOk = _ref.onOk, okDisabled = _ref.okDisabled, showNow = _ref.showNow, locale2 = _ref.locale;
  var presetNode;
  var okNode;
  if (rangeList.length) {
    var Item3 = components.rangeItem || "span";
    presetNode = /* @__PURE__ */ React.createElement(React.Fragment, null, rangeList.map(function(_ref2) {
      var label = _ref2.label, onClick = _ref2.onClick, onMouseEnter = _ref2.onMouseEnter, onMouseLeave = _ref2.onMouseLeave;
      return /* @__PURE__ */ React.createElement("li", {
        key: label,
        className: "".concat(prefixCls, "-preset")
      }, /* @__PURE__ */ React.createElement(Item3, {
        onClick,
        onMouseEnter,
        onMouseLeave
      }, label));
    }));
  }
  if (needConfirmButton) {
    var Button2 = components.button || "button";
    if (onNow && !presetNode && showNow !== false) {
      presetNode = /* @__PURE__ */ React.createElement("li", {
        className: "".concat(prefixCls, "-now")
      }, /* @__PURE__ */ React.createElement("a", {
        className: "".concat(prefixCls, "-now-btn"),
        onClick: onNow
      }, locale2.now));
    }
    okNode = needConfirmButton && /* @__PURE__ */ React.createElement("li", {
      className: "".concat(prefixCls, "-ok")
    }, /* @__PURE__ */ React.createElement(Button2, {
      disabled: okDisabled,
      onClick: onOk
    }, locale2.ok));
  }
  if (!presetNode && !okNode) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("ul", {
    className: "".concat(prefixCls, "-ranges")
  }, presetNode, okNode);
}
function PickerPanel(props) {
  var _classNames;
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-picker" : _props$prefixCls, className = props.className, style2 = props.style, locale2 = props.locale, generateConfig2 = props.generateConfig, value = props.value, defaultValue = props.defaultValue, pickerValue = props.pickerValue, defaultPickerValue = props.defaultPickerValue, disabledDate = props.disabledDate, mode = props.mode, _props$picker = props.picker, picker = _props$picker === void 0 ? "date" : _props$picker, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, showNow = props.showNow, showTime = props.showTime, showToday = props.showToday, renderExtraFooter = props.renderExtraFooter, hideHeader = props.hideHeader, onSelect = props.onSelect, onChange4 = props.onChange, onPanelChange = props.onPanelChange, onMouseDown = props.onMouseDown, onPickerValueChange = props.onPickerValueChange, _onOk = props.onOk, components = props.components, direction = props.direction, _props$hourStep = props.hourStep, hourStep = _props$hourStep === void 0 ? 1 : _props$hourStep, _props$minuteStep = props.minuteStep, minuteStep = _props$minuteStep === void 0 ? 1 : _props$minuteStep, _props$secondStep = props.secondStep, secondStep = _props$secondStep === void 0 ? 1 : _props$secondStep;
  var needConfirmButton = picker === "date" && !!showTime || picker === "time";
  var isHourStepValid = 24 % hourStep === 0;
  var isMinuteStepValid = 60 % minuteStep === 0;
  var isSecondStepValid = 60 % secondStep === 0;
  if (process.env.NODE_ENV !== "production") {
    warningOnce(!value || generateConfig2.isValidate(value), "Invalidate date pass to `value`.");
    warningOnce(!value || generateConfig2.isValidate(value), "Invalidate date pass to `defaultValue`.");
    warningOnce(isHourStepValid, "`hourStep` ".concat(hourStep, " is invalid. It should be a factor of 24."));
    warningOnce(isMinuteStepValid, "`minuteStep` ".concat(minuteStep, " is invalid. It should be a factor of 60."));
    warningOnce(isSecondStepValid, "`secondStep` ".concat(secondStep, " is invalid. It should be a factor of 60."));
  }
  var panelContext = React.useContext(PanelContext);
  var operationRef = panelContext.operationRef, panelDivRef = panelContext.panelRef, onContextSelect = panelContext.onSelect, hideRanges = panelContext.hideRanges, defaultOpenValue = panelContext.defaultOpenValue;
  var _React$useContext = React.useContext(RangeContext), inRange = _React$useContext.inRange, panelPosition = _React$useContext.panelPosition, rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
  var panelRef = React.useRef({});
  var initRef = React.useRef(true);
  var _useMergedState = useMergedState(null, {
    value,
    defaultValue,
    postState: function postState(val) {
      if (!val && defaultOpenValue && picker === "time") {
        return defaultOpenValue;
      }
      return val;
    }
  }), _useMergedState2 = _slicedToArray$3(_useMergedState, 2), mergedValue = _useMergedState2[0], setInnerValue = _useMergedState2[1];
  var _useMergedState3 = useMergedState(null, {
    value: pickerValue,
    defaultValue: defaultPickerValue || mergedValue,
    postState: function postState(date3) {
      var now3 = generateConfig2.getNow();
      if (!date3)
        return now3;
      if (!mergedValue && showTime) {
        if (_typeof$5(showTime) === "object") {
          return setDateTime(generateConfig2, Array.isArray(date3) ? date3[0] : date3, showTime.defaultValue || now3);
        }
        if (defaultValue) {
          return setDateTime(generateConfig2, Array.isArray(date3) ? date3[0] : date3, defaultValue);
        }
        return setDateTime(generateConfig2, Array.isArray(date3) ? date3[0] : date3, now3);
      }
      return date3;
    }
  }), _useMergedState4 = _slicedToArray$3(_useMergedState3, 2), viewDate = _useMergedState4[0], setInnerViewDate = _useMergedState4[1];
  var setViewDate = function setViewDate2(date3) {
    setInnerViewDate(date3);
    if (onPickerValueChange) {
      onPickerValueChange(date3);
    }
  };
  var getInternalNextMode = function getInternalNextMode2(nextMode) {
    var getNextMode = PickerModeMap[picker];
    if (getNextMode) {
      return getNextMode(nextMode);
    }
    return nextMode;
  };
  var _useMergedState5 = useMergedState(function() {
    if (picker === "time") {
      return "time";
    }
    return getInternalNextMode("date");
  }, {
    value: mode
  }), _useMergedState6 = _slicedToArray$3(_useMergedState5, 2), mergedMode = _useMergedState6[0], setInnerMode = _useMergedState6[1];
  React.useEffect(function() {
    setInnerMode(picker);
  }, [picker]);
  var _React$useState = React.useState(function() {
    return mergedMode;
  }), _React$useState2 = _slicedToArray$3(_React$useState, 2), sourceMode = _React$useState2[0], setSourceMode = _React$useState2[1];
  var onInternalPanelChange = function onInternalPanelChange2(newMode, viewValue) {
    var nextMode = getInternalNextMode(newMode || mergedMode);
    setSourceMode(mergedMode);
    setInnerMode(nextMode);
    if (onPanelChange && (mergedMode !== nextMode || isEqual(generateConfig2, viewDate, viewDate))) {
      onPanelChange(viewValue, nextMode);
    }
  };
  var triggerSelect = function triggerSelect2(date3, type2) {
    var forceTriggerSelect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (mergedMode === picker || forceTriggerSelect) {
      setInnerValue(date3);
      if (onSelect) {
        onSelect(date3);
      }
      if (onContextSelect) {
        onContextSelect(date3, type2);
      }
      if (onChange4 && !isEqual(generateConfig2, date3, mergedValue) && !(disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date3))) {
        onChange4(date3);
      }
    }
  };
  var onInternalKeyDown = function onInternalKeyDown2(e3) {
    if (panelRef.current && panelRef.current.onKeyDown) {
      if ([KeyCode.LEFT, KeyCode.RIGHT, KeyCode.UP, KeyCode.DOWN, KeyCode.PAGE_UP, KeyCode.PAGE_DOWN, KeyCode.ENTER].includes(e3.which)) {
        e3.preventDefault();
      }
      return panelRef.current.onKeyDown(e3);
    }
    {
      warningOnce(false, "Panel not correct handle keyDown event. Please help to fire issue about this.");
      return false;
    }
  };
  var onInternalBlur = function onInternalBlur2(e3) {
    if (panelRef.current && panelRef.current.onBlur) {
      panelRef.current.onBlur(e3);
    }
  };
  if (operationRef && panelPosition !== "right") {
    operationRef.current = {
      onKeyDown: onInternalKeyDown,
      onClose: function onClose2() {
        if (panelRef.current && panelRef.current.onClose) {
          panelRef.current.onClose();
        }
      }
    };
  }
  React.useEffect(function() {
    if (value && !initRef.current) {
      setInnerViewDate(value);
    }
  }, [value]);
  React.useEffect(function() {
    initRef.current = false;
  }, []);
  var panelNode;
  var pickerProps = _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    operationRef: panelRef,
    prefixCls,
    viewDate,
    value: mergedValue,
    onViewDateChange: setViewDate,
    sourceMode,
    onPanelChange: onInternalPanelChange,
    disabledDate
  });
  delete pickerProps.onChange;
  delete pickerProps.onSelect;
  switch (mergedMode) {
    case "decade":
      panelNode = /* @__PURE__ */ React.createElement(DecadePanel, _extends$2({}, pickerProps, {
        onSelect: function onSelect2(date3, type2) {
          setViewDate(date3);
          triggerSelect(date3, type2);
        }
      }));
      break;
    case "year":
      panelNode = /* @__PURE__ */ React.createElement(YearPanel, _extends$2({}, pickerProps, {
        onSelect: function onSelect2(date3, type2) {
          setViewDate(date3);
          triggerSelect(date3, type2);
        }
      }));
      break;
    case "month":
      panelNode = /* @__PURE__ */ React.createElement(MonthPanel, _extends$2({}, pickerProps, {
        onSelect: function onSelect2(date3, type2) {
          setViewDate(date3);
          triggerSelect(date3, type2);
        }
      }));
      break;
    case "quarter":
      panelNode = /* @__PURE__ */ React.createElement(QuarterPanel, _extends$2({}, pickerProps, {
        onSelect: function onSelect2(date3, type2) {
          setViewDate(date3);
          triggerSelect(date3, type2);
        }
      }));
      break;
    case "week":
      panelNode = /* @__PURE__ */ React.createElement(WeekPanel, _extends$2({}, pickerProps, {
        onSelect: function onSelect2(date3, type2) {
          setViewDate(date3);
          triggerSelect(date3, type2);
        }
      }));
      break;
    case "time":
      delete pickerProps.showTime;
      panelNode = /* @__PURE__ */ React.createElement(TimePanel, _extends$2({}, pickerProps, _typeof$5(showTime) === "object" ? showTime : null, {
        onSelect: function onSelect2(date3, type2) {
          setViewDate(date3);
          triggerSelect(date3, type2);
        }
      }));
      break;
    default:
      if (showTime) {
        panelNode = /* @__PURE__ */ React.createElement(DatetimePanel, _extends$2({}, pickerProps, {
          onSelect: function onSelect2(date3, type2) {
            setViewDate(date3);
            triggerSelect(date3, type2);
          }
        }));
      } else {
        panelNode = /* @__PURE__ */ React.createElement(DatePanel, _extends$2({}, pickerProps, {
          onSelect: function onSelect2(date3, type2) {
            setViewDate(date3);
            triggerSelect(date3, type2);
          }
        }));
      }
  }
  var extraFooter;
  var rangesNode;
  var onNow = function onNow2() {
    var now3 = generateConfig2.getNow();
    var lowerBoundTime = getLowerBoundTime(generateConfig2.getHour(now3), generateConfig2.getMinute(now3), generateConfig2.getSecond(now3), isHourStepValid ? hourStep : 1, isMinuteStepValid ? minuteStep : 1, isSecondStepValid ? secondStep : 1);
    var adjustedNow = setTime(
      generateConfig2,
      now3,
      lowerBoundTime[0],
      lowerBoundTime[1],
      lowerBoundTime[2]
    );
    triggerSelect(adjustedNow, "submit");
  };
  if (!hideRanges) {
    extraFooter = getExtraFooter(prefixCls, mergedMode, renderExtraFooter);
    rangesNode = getRanges({
      prefixCls,
      components,
      needConfirmButton,
      okDisabled: !mergedValue || disabledDate && disabledDate(mergedValue),
      locale: locale2,
      showNow,
      onNow: needConfirmButton && onNow,
      onOk: function onOk() {
        if (mergedValue) {
          triggerSelect(mergedValue, "submit", true);
          if (_onOk) {
            _onOk(mergedValue);
          }
        }
      }
    });
  }
  var todayNode;
  if (showToday && mergedMode === "date" && picker === "date" && !showTime) {
    var now2 = generateConfig2.getNow();
    var todayCls = "".concat(prefixCls, "-today-btn");
    var disabled = disabledDate && disabledDate(now2);
    todayNode = /* @__PURE__ */ React.createElement("a", {
      className: cn(todayCls, disabled && "".concat(todayCls, "-disabled")),
      "aria-disabled": disabled,
      onClick: function onClick() {
        if (!disabled) {
          triggerSelect(now2, "mouse", true);
        }
      }
    }, locale2.today);
  }
  return /* @__PURE__ */ React.createElement(PanelContext.Provider, {
    value: _objectSpread2$1(_objectSpread2$1({}, panelContext), {}, {
      mode: mergedMode,
      hideHeader: "hideHeader" in props ? hideHeader : panelContext.hideHeader,
      hidePrevBtn: inRange && panelPosition === "right",
      hideNextBtn: inRange && panelPosition === "left"
    })
  }, /* @__PURE__ */ React.createElement("div", {
    tabIndex,
    className: cn("".concat(prefixCls, "-panel"), className, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-panel-has-range"), rangedValue && rangedValue[0] && rangedValue[1]), _defineProperty$4(_classNames, "".concat(prefixCls, "-panel-has-range-hover"), hoverRangedValue && hoverRangedValue[0] && hoverRangedValue[1]), _defineProperty$4(_classNames, "".concat(prefixCls, "-panel-rtl"), direction === "rtl"), _classNames)),
    style: style2,
    onKeyDown: onInternalKeyDown,
    onBlur: onInternalBlur,
    onMouseDown,
    ref: panelDivRef
  }, panelNode, extraFooter || rangesNode || todayNode ? /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-footer")
  }, extraFooter, rangesNode, todayNode) : null));
}
var BUILT_IN_PLACEMENTS$1 = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
function PickerTrigger(_ref) {
  var _classNames;
  var prefixCls = _ref.prefixCls, popupElement = _ref.popupElement, popupStyle = _ref.popupStyle, visible = _ref.visible, dropdownClassName = _ref.dropdownClassName, dropdownAlign = _ref.dropdownAlign, transitionName2 = _ref.transitionName, getPopupContainer = _ref.getPopupContainer, children = _ref.children, range2 = _ref.range, popupPlacement = _ref.popupPlacement, direction = _ref.direction;
  var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
  var getPopupPlacement = function getPopupPlacement2() {
    if (popupPlacement !== void 0) {
      return popupPlacement;
    }
    return direction === "rtl" ? "bottomRight" : "bottomLeft";
  };
  return /* @__PURE__ */ React.createElement(Trigger, {
    showAction: [],
    hideAction: [],
    popupPlacement: getPopupPlacement(),
    builtinPlacements: BUILT_IN_PLACEMENTS$1,
    prefixCls: dropdownPrefixCls,
    popupTransitionName: transitionName2,
    popup: popupElement,
    popupAlign: dropdownAlign,
    popupVisible: visible,
    popupClassName: cn(dropdownClassName, (_classNames = {}, _defineProperty$4(_classNames, "".concat(dropdownPrefixCls, "-range"), range2), _defineProperty$4(_classNames, "".concat(dropdownPrefixCls, "-rtl"), direction === "rtl"), _classNames)),
    popupStyle,
    getPopupContainer
  }, children);
}
function usePickerInput(_ref) {
  var open = _ref.open, value = _ref.value, isClickOutside = _ref.isClickOutside, triggerOpen = _ref.triggerOpen, forwardKeyDown = _ref.forwardKeyDown, _onKeyDown = _ref.onKeyDown, blurToCancel = _ref.blurToCancel, onSubmit = _ref.onSubmit, onCancel = _ref.onCancel, _onFocus = _ref.onFocus, _onBlur = _ref.onBlur;
  var _useState = useState2(false), _useState2 = _slicedToArray$3(_useState, 2), typing = _useState2[0], setTyping = _useState2[1];
  var _useState3 = useState2(false), _useState4 = _slicedToArray$3(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
  var preventBlurRef = useRef2(false);
  var valueChangedRef = useRef2(false);
  var preventDefaultRef = useRef2(false);
  var inputProps = {
    onMouseDown: function onMouseDown() {
      setTyping(true);
      triggerOpen(true);
    },
    onKeyDown: function onKeyDown2(e3) {
      var preventDefault = function preventDefault2() {
        preventDefaultRef.current = true;
      };
      _onKeyDown(e3, preventDefault);
      if (preventDefaultRef.current)
        return;
      switch (e3.which) {
        case KeyCode.ENTER: {
          if (!open) {
            triggerOpen(true);
          } else if (onSubmit() !== false) {
            setTyping(true);
          }
          e3.preventDefault();
          return;
        }
        case KeyCode.TAB: {
          if (typing && open && !e3.shiftKey) {
            setTyping(false);
            e3.preventDefault();
          } else if (!typing && open) {
            if (!forwardKeyDown(e3) && e3.shiftKey) {
              setTyping(true);
              e3.preventDefault();
            }
          }
          return;
        }
        case KeyCode.ESC: {
          setTyping(true);
          onCancel();
          return;
        }
      }
      if (!open && ![KeyCode.SHIFT].includes(e3.which)) {
        triggerOpen(true);
      } else if (!typing) {
        forwardKeyDown(e3);
      }
    },
    onFocus: function onFocus2(e3) {
      setTyping(true);
      setFocused(true);
      if (_onFocus) {
        _onFocus(e3);
      }
    },
    onBlur: function onBlur2(e3) {
      if (preventBlurRef.current || !isClickOutside(document.activeElement)) {
        preventBlurRef.current = false;
        return;
      }
      if (blurToCancel) {
        setTimeout(function() {
          var _document = document, activeElement = _document.activeElement;
          while (activeElement && activeElement.shadowRoot) {
            activeElement = activeElement.shadowRoot.activeElement;
          }
          if (isClickOutside(activeElement)) {
            onCancel();
          }
        }, 0);
      } else if (open) {
        triggerOpen(false);
        if (valueChangedRef.current) {
          onSubmit();
        }
      }
      setFocused(false);
      if (_onBlur) {
        _onBlur(e3);
      }
    }
  };
  useEffect2(function() {
    valueChangedRef.current = false;
  }, [open]);
  useEffect2(function() {
    valueChangedRef.current = true;
  }, [value]);
  useEffect2(function() {
    return addGlobalMouseDownEvent(function(e3) {
      var target = getTargetFromEvent(e3);
      if (open) {
        var clickedOutside = isClickOutside(target);
        if (!clickedOutside) {
          preventBlurRef.current = true;
          requestAnimationFrame(function() {
            preventBlurRef.current = false;
          });
        } else if (!focused || clickedOutside) {
          triggerOpen(false);
        }
      }
    });
  });
  return [inputProps, {
    focused,
    typing
  }];
}
function useTextValueMapping(_ref) {
  var valueTexts = _ref.valueTexts, onTextChange = _ref.onTextChange;
  var _React$useState = React.useState(""), _React$useState2 = _slicedToArray$3(_React$useState, 2), text = _React$useState2[0], setInnerText = _React$useState2[1];
  var valueTextsRef = React.useRef([]);
  valueTextsRef.current = valueTexts;
  function triggerTextChange(value) {
    setInnerText(value);
    onTextChange(value);
  }
  function resetText() {
    setInnerText(valueTextsRef.current[0]);
  }
  React.useEffect(function() {
    if (valueTexts.every(function(valText) {
      return valText !== text;
    })) {
      resetText();
    }
  }, [valueTexts.join("||")]);
  return [text, triggerTextChange, resetText];
}
function useValueTexts(value, _ref) {
  var formatList = _ref.formatList, generateConfig2 = _ref.generateConfig, locale2 = _ref.locale;
  return useMemo2(function() {
    if (!value) {
      return [[""], ""];
    }
    var firstValueText = "";
    var fullValueTexts = [];
    for (var i2 = 0; i2 < formatList.length; i2 += 1) {
      var format3 = formatList[i2];
      var formatStr = formatValue(value, {
        generateConfig: generateConfig2,
        locale: locale2,
        format: format3
      });
      fullValueTexts.push(formatStr);
      if (i2 === 0) {
        firstValueText = formatStr;
      }
    }
    return [fullValueTexts, firstValueText];
  }, [value, formatList], function(prev, next) {
    return prev[0] !== next[0] || !shallowequal(prev[1], next[1]);
  });
}
function useHoverValue(valueText, _ref) {
  var formatList = _ref.formatList, generateConfig2 = _ref.generateConfig, locale2 = _ref.locale;
  var _useState = useState2(null), _useState2 = _slicedToArray$3(_useState, 2), value = _useState2[0], internalSetValue = _useState2[1];
  var raf3 = useRef2(null);
  function setValue2(val) {
    var immediately = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    cancelAnimationFrame(raf3.current);
    if (immediately) {
      internalSetValue(val);
      return;
    }
    raf3.current = requestAnimationFrame(function() {
      internalSetValue(val);
    });
  }
  var _useValueTexts = useValueTexts(value, {
    formatList,
    generateConfig: generateConfig2,
    locale: locale2
  }), _useValueTexts2 = _slicedToArray$3(_useValueTexts, 2), firstText = _useValueTexts2[1];
  function onEnter(date3) {
    setValue2(date3);
  }
  function onLeave() {
    var immediately = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    setValue2(null, immediately);
  }
  useEffect2(function() {
    onLeave(true);
  }, [valueText]);
  useEffect2(function() {
    return function() {
      return cancelAnimationFrame(raf3.current);
    };
  }, []);
  return [firstText, onEnter, onLeave];
}
function InnerPicker(props) {
  var _classNames2;
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-picker" : _props$prefixCls, id2 = props.id, tabIndex = props.tabIndex, style2 = props.style, className = props.className, dropdownClassName = props.dropdownClassName, dropdownAlign = props.dropdownAlign, popupStyle = props.popupStyle, transitionName2 = props.transitionName, generateConfig2 = props.generateConfig, locale2 = props.locale, inputReadOnly = props.inputReadOnly, allowClear = props.allowClear, autoFocus = props.autoFocus, showTime = props.showTime, _props$picker = props.picker, picker = _props$picker === void 0 ? "date" : _props$picker, format3 = props.format, use12Hours = props.use12Hours, value = props.value, defaultValue = props.defaultValue, open = props.open, defaultOpen = props.defaultOpen, defaultOpenValue = props.defaultOpenValue, suffixIcon = props.suffixIcon, clearIcon = props.clearIcon, disabled = props.disabled, disabledDate = props.disabledDate, placeholder = props.placeholder, getPopupContainer = props.getPopupContainer, pickerRef = props.pickerRef, panelRender = props.panelRender, onChange4 = props.onChange, onOpenChange = props.onOpenChange, onFocus2 = props.onFocus, onBlur2 = props.onBlur, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onContextMenu = props.onContextMenu, onClick = props.onClick, _onKeyDown = props.onKeyDown, _onSelect = props.onSelect, direction = props.direction, _props$autoComplete = props.autoComplete, autoComplete = _props$autoComplete === void 0 ? "off" : _props$autoComplete;
  var inputRef = React.useRef(null);
  var needConfirmButton = picker === "date" && !!showTime || picker === "time";
  var formatList = toArray$5(getDefaultFormat(format3, picker, showTime, use12Hours));
  var panelDivRef = React.useRef(null);
  var inputDivRef = React.useRef(null);
  var containerRef = React.useRef(null);
  var _useMergedState = useMergedState(null, {
    value,
    defaultValue
  }), _useMergedState2 = _slicedToArray$3(_useMergedState, 2), mergedValue = _useMergedState2[0], setInnerValue = _useMergedState2[1];
  var _React$useState = React.useState(mergedValue), _React$useState2 = _slicedToArray$3(_React$useState, 2), selectedValue = _React$useState2[0], setSelectedValue = _React$useState2[1];
  var operationRef = React.useRef(null);
  var _useMergedState3 = useMergedState(false, {
    value: open,
    defaultValue: defaultOpen,
    postState: function postState(postOpen) {
      return disabled ? false : postOpen;
    },
    onChange: function onChange5(newOpen) {
      if (onOpenChange) {
        onOpenChange(newOpen);
      }
      if (!newOpen && operationRef.current && operationRef.current.onClose) {
        operationRef.current.onClose();
      }
    }
  }), _useMergedState4 = _slicedToArray$3(_useMergedState3, 2), mergedOpen = _useMergedState4[0], triggerInnerOpen = _useMergedState4[1];
  var _useValueTexts = useValueTexts(selectedValue, {
    formatList,
    generateConfig: generateConfig2,
    locale: locale2
  }), _useValueTexts2 = _slicedToArray$3(_useValueTexts, 2), valueTexts = _useValueTexts2[0], firstValueText = _useValueTexts2[1];
  var _useTextValueMapping = useTextValueMapping({
    valueTexts,
    onTextChange: function onTextChange(newText) {
      var inputDate = parseValue(newText, {
        locale: locale2,
        formatList,
        generateConfig: generateConfig2
      });
      if (inputDate && (!disabledDate || !disabledDate(inputDate))) {
        setSelectedValue(inputDate);
      }
    }
  }), _useTextValueMapping2 = _slicedToArray$3(_useTextValueMapping, 3), text = _useTextValueMapping2[0], triggerTextChange = _useTextValueMapping2[1], resetText = _useTextValueMapping2[2];
  var triggerChange = function triggerChange2(newValue) {
    setSelectedValue(newValue);
    setInnerValue(newValue);
    if (onChange4 && !isEqual(generateConfig2, mergedValue, newValue)) {
      onChange4(newValue, newValue ? formatValue(newValue, {
        generateConfig: generateConfig2,
        locale: locale2,
        format: formatList[0]
      }) : "");
    }
  };
  var triggerOpen = function triggerOpen2(newOpen) {
    if (disabled && newOpen) {
      return;
    }
    triggerInnerOpen(newOpen);
  };
  var forwardKeyDown = function forwardKeyDown2(e3) {
    if (mergedOpen && operationRef.current && operationRef.current.onKeyDown) {
      return operationRef.current.onKeyDown(e3);
    }
    {
      warningOnce(false, "Picker not correct forward KeyDown operation. Please help to fire issue about this.");
      return false;
    }
  };
  var onInternalMouseUp = function onInternalMouseUp2() {
    if (onMouseUp) {
      onMouseUp.apply(void 0, arguments);
    }
    if (inputRef.current) {
      inputRef.current.focus();
      triggerOpen(true);
    }
  };
  var _usePickerInput = usePickerInput({
    blurToCancel: needConfirmButton,
    open: mergedOpen,
    value: text,
    triggerOpen,
    forwardKeyDown,
    isClickOutside: function isClickOutside(target) {
      return !elementsContains([panelDivRef.current, inputDivRef.current, containerRef.current], target);
    },
    onSubmit: function onSubmit() {
      if (!selectedValue || disabledDate && disabledDate(selectedValue)) {
        return false;
      }
      triggerChange(selectedValue);
      triggerOpen(false);
      resetText();
      return true;
    },
    onCancel: function onCancel() {
      triggerOpen(false);
      setSelectedValue(mergedValue);
      resetText();
    },
    onKeyDown: function onKeyDown2(e3, preventDefault) {
      _onKeyDown === null || _onKeyDown === void 0 ? void 0 : _onKeyDown(e3, preventDefault);
    },
    onFocus: onFocus2,
    onBlur: onBlur2
  }), _usePickerInput2 = _slicedToArray$3(_usePickerInput, 2), inputProps = _usePickerInput2[0], _usePickerInput2$ = _usePickerInput2[1], focused = _usePickerInput2$.focused, typing = _usePickerInput2$.typing;
  React.useEffect(function() {
    if (!mergedOpen) {
      setSelectedValue(mergedValue);
      if (!valueTexts.length || valueTexts[0] === "") {
        triggerTextChange("");
      } else if (firstValueText !== text) {
        resetText();
      }
    }
  }, [mergedOpen, valueTexts]);
  React.useEffect(function() {
    if (!mergedOpen) {
      resetText();
    }
  }, [picker]);
  React.useEffect(function() {
    setSelectedValue(mergedValue);
  }, [mergedValue]);
  if (pickerRef) {
    pickerRef.current = {
      focus: function focus() {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      },
      blur: function blur() {
        if (inputRef.current) {
          inputRef.current.blur();
        }
      }
    };
  }
  var _useHoverValue = useHoverValue(text, {
    formatList,
    generateConfig: generateConfig2,
    locale: locale2
  }), _useHoverValue2 = _slicedToArray$3(_useHoverValue, 3), hoverValue = _useHoverValue2[0], onEnter = _useHoverValue2[1], onLeave = _useHoverValue2[2];
  var panelProps = _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    className: void 0,
    style: void 0,
    pickerValue: void 0,
    onPickerValueChange: void 0,
    onChange: null
  });
  var panelNode = /* @__PURE__ */ React.createElement(PickerPanel, _extends$2({}, panelProps, {
    generateConfig: generateConfig2,
    className: cn(_defineProperty$4({}, "".concat(prefixCls, "-panel-focused"), !typing)),
    value: selectedValue,
    locale: locale2,
    tabIndex: -1,
    onSelect: function onSelect(date3) {
      _onSelect === null || _onSelect === void 0 ? void 0 : _onSelect(date3);
      setSelectedValue(date3);
    },
    direction,
    onPanelChange: function onPanelChange(viewDate, mode) {
      var onPanelChange2 = props.onPanelChange;
      onLeave(true);
      onPanelChange2 === null || onPanelChange2 === void 0 ? void 0 : onPanelChange2(viewDate, mode);
    }
  }));
  if (panelRender) {
    panelNode = panelRender(panelNode);
  }
  var panel = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-panel-container"),
    onMouseDown: function onMouseDown2(e3) {
      e3.preventDefault();
    }
  }, panelNode);
  var suffixNode;
  if (suffixIcon) {
    suffixNode = /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-suffix")
    }, suffixIcon);
  }
  var clearNode;
  if (allowClear && mergedValue && !disabled) {
    clearNode = /* @__PURE__ */ React.createElement("span", {
      onMouseDown: function onMouseDown2(e3) {
        e3.preventDefault();
        e3.stopPropagation();
      },
      onMouseUp: function onMouseUp2(e3) {
        e3.preventDefault();
        e3.stopPropagation();
        triggerChange(null);
        triggerOpen(false);
      },
      className: "".concat(prefixCls, "-clear"),
      role: "button"
    }, clearIcon || /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-clear-btn")
    }));
  }
  if (process.env.NODE_ENV !== "production") {
    warningOnce(!defaultOpenValue, "`defaultOpenValue` may confuse user for the current value status. Please use `defaultValue` instead.");
  }
  var onContextSelect = function onContextSelect2(date3, type2) {
    if (type2 === "submit" || type2 !== "key" && !needConfirmButton) {
      triggerChange(date3);
      triggerOpen(false);
    }
  };
  var popupPlacement = direction === "rtl" ? "bottomRight" : "bottomLeft";
  return /* @__PURE__ */ React.createElement(PanelContext.Provider, {
    value: {
      operationRef,
      hideHeader: picker === "time",
      panelRef: panelDivRef,
      onSelect: onContextSelect,
      open: mergedOpen,
      defaultOpenValue,
      onDateMouseEnter: onEnter,
      onDateMouseLeave: onLeave
    }
  }, /* @__PURE__ */ React.createElement(PickerTrigger, {
    visible: mergedOpen,
    popupElement: panel,
    popupStyle,
    prefixCls,
    dropdownClassName,
    dropdownAlign,
    getPopupContainer,
    transitionName: transitionName2,
    popupPlacement,
    direction
  }, /* @__PURE__ */ React.createElement("div", {
    ref: containerRef,
    className: cn(prefixCls, className, (_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _defineProperty$4(_classNames2, "".concat(prefixCls, "-focused"), focused), _defineProperty$4(_classNames2, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames2)),
    style: style2,
    onMouseDown,
    onMouseUp: onInternalMouseUp,
    onMouseEnter,
    onMouseLeave,
    onContextMenu,
    onClick
  }, /* @__PURE__ */ React.createElement("div", {
    className: cn("".concat(prefixCls, "-input"), _defineProperty$4({}, "".concat(prefixCls, "-input-placeholder"), !!hoverValue)),
    ref: inputDivRef
  }, /* @__PURE__ */ React.createElement("input", _extends$2({
    id: id2,
    tabIndex,
    disabled,
    readOnly: inputReadOnly || typeof formatList[0] === "function" || !typing,
    value: hoverValue || text,
    onChange: function onChange5(e3) {
      triggerTextChange(e3.target.value);
    },
    autoFocus,
    placeholder,
    ref: inputRef,
    title: text
  }, inputProps, {
    size: getInputSize(picker, formatList[0], generateConfig2)
  }, getDataOrAriaProps(props), {
    autoComplete
  })), suffixNode, clearNode))));
}
var Picker = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Picker2, _React$Component);
  var _super = _createSuper$1(Picker2);
  function Picker2() {
    var _this2;
    _classCallCheck$2(this, Picker2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super.call.apply(_super, [this].concat(args));
    _this2.pickerRef = /* @__PURE__ */ React.createRef();
    _this2.focus = function() {
      if (_this2.pickerRef.current) {
        _this2.pickerRef.current.focus();
      }
    };
    _this2.blur = function() {
      if (_this2.pickerRef.current) {
        _this2.pickerRef.current.blur();
      }
    };
    return _this2;
  }
  _createClass$2(Picker2, [{
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(InnerPicker, _extends$2({}, this.props, {
        pickerRef: this.pickerRef
      }));
    }
  }]);
  return Picker2;
}(React.Component);
function useRangeDisabled(_ref, disabledStart, disabledEnd) {
  var picker = _ref.picker, locale2 = _ref.locale, selectedValue = _ref.selectedValue, disabledDate = _ref.disabledDate, disabled = _ref.disabled, generateConfig2 = _ref.generateConfig;
  var startDate = getValue(selectedValue, 0);
  var endDate = getValue(selectedValue, 1);
  function weekFirstDate(date3) {
    return generateConfig2.locale.getWeekFirstDate(locale2.locale, date3);
  }
  function monthNumber(date3) {
    var year = generateConfig2.getYear(date3);
    var month = generateConfig2.getMonth(date3);
    return year * 100 + month;
  }
  function quarterNumber(date3) {
    var year = generateConfig2.getYear(date3);
    var quarter = getQuarter(generateConfig2, date3);
    return year * 10 + quarter;
  }
  var disabledStartDate = React.useCallback(function(date3) {
    if (disabledDate && disabledDate(date3)) {
      return true;
    }
    if (disabled[1] && endDate) {
      return !isSameDate(generateConfig2, date3, endDate) && generateConfig2.isAfter(date3, endDate);
    }
    if (disabledStart && endDate) {
      switch (picker) {
        case "quarter":
          return quarterNumber(date3) > quarterNumber(endDate);
        case "month":
          return monthNumber(date3) > monthNumber(endDate);
        case "week":
          return weekFirstDate(date3) > weekFirstDate(endDate);
        default:
          return !isSameDate(generateConfig2, date3, endDate) && generateConfig2.isAfter(date3, endDate);
      }
    }
    return false;
  }, [disabledDate, disabled[1], endDate, disabledStart]);
  var disabledEndDate = React.useCallback(function(date3) {
    if (disabledDate && disabledDate(date3)) {
      return true;
    }
    if (disabled[0] && startDate) {
      return !isSameDate(generateConfig2, date3, endDate) && generateConfig2.isAfter(startDate, date3);
    }
    if (disabledEnd && startDate) {
      switch (picker) {
        case "quarter":
          return quarterNumber(date3) < quarterNumber(startDate);
        case "month":
          return monthNumber(date3) < monthNumber(startDate);
        case "week":
          return weekFirstDate(date3) < weekFirstDate(startDate);
        default:
          return !isSameDate(generateConfig2, date3, startDate) && generateConfig2.isAfter(startDate, date3);
      }
    }
    return false;
  }, [disabledDate, disabled[0], startDate, disabledEnd]);
  return [disabledStartDate, disabledEndDate];
}
function getStartEndDistance(startDate, endDate, picker, generateConfig2) {
  var startNext = getClosingViewDate(startDate, picker, generateConfig2, 1);
  function getDistance(compareFunc) {
    if (compareFunc(startDate, endDate)) {
      return "same";
    }
    if (compareFunc(startNext, endDate)) {
      return "closing";
    }
    return "far";
  }
  switch (picker) {
    case "year":
      return getDistance(function(start, end) {
        return isSameDecade(generateConfig2, start, end);
      });
    case "quarter":
    case "month":
      return getDistance(function(start, end) {
        return isSameYear(generateConfig2, start, end);
      });
    default:
      return getDistance(function(start, end) {
        return isSameMonth(generateConfig2, start, end);
      });
  }
}
function getRangeViewDate(values, index2, picker, generateConfig2) {
  var startDate = getValue(values, 0);
  var endDate = getValue(values, 1);
  if (index2 === 0) {
    return startDate;
  }
  if (startDate && endDate) {
    var distance = getStartEndDistance(startDate, endDate, picker, generateConfig2);
    switch (distance) {
      case "same":
        return startDate;
      case "closing":
        return startDate;
      default:
        return getClosingViewDate(endDate, picker, generateConfig2, -1);
    }
  }
  return startDate;
}
function useRangeViewDates(_ref) {
  var values = _ref.values, picker = _ref.picker, defaultDates = _ref.defaultDates, generateConfig2 = _ref.generateConfig;
  var _React$useState = React.useState(function() {
    return [getValue(defaultDates, 0), getValue(defaultDates, 1)];
  }), _React$useState2 = _slicedToArray$3(_React$useState, 2), defaultViewDates = _React$useState2[0], setDefaultViewDates = _React$useState2[1];
  var _React$useState3 = React.useState(null), _React$useState4 = _slicedToArray$3(_React$useState3, 2), viewDates = _React$useState4[0], setInternalViewDates = _React$useState4[1];
  var startDate = getValue(values, 0);
  var endDate = getValue(values, 1);
  function getViewDate(index2) {
    if (defaultViewDates[index2]) {
      return defaultViewDates[index2];
    }
    return getValue(viewDates, index2) || getRangeViewDate(values, index2, picker, generateConfig2) || startDate || endDate || generateConfig2.getNow();
  }
  function setViewDate(viewDate, index2) {
    if (viewDate) {
      var newViewDates = updateValues(viewDates, viewDate, index2);
      setDefaultViewDates(
        updateValues(defaultViewDates, null, index2) || [null, null]
      );
      var anotherIndex = (index2 + 1) % 2;
      if (!getValue(values, anotherIndex)) {
        newViewDates = updateValues(newViewDates, viewDate, anotherIndex);
      }
      setInternalViewDates(newViewDates);
    } else if (startDate || endDate) {
      setInternalViewDates(null);
    }
  }
  return [getViewDate, setViewDate];
}
function reorderValues(values, generateConfig2) {
  if (values && values[0] && values[1] && generateConfig2.isAfter(values[0], values[1])) {
    return [values[1], values[0]];
  }
  return values;
}
function canValueTrigger(value, index2, disabled, allowEmpty) {
  if (value) {
    return true;
  }
  if (allowEmpty && allowEmpty[index2]) {
    return true;
  }
  if (disabled[(index2 + 1) % 2]) {
    return true;
  }
  return false;
}
function InnerRangePicker(props) {
  var _classNames2, _classNames3, _classNames4;
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-picker" : _props$prefixCls, id2 = props.id, style2 = props.style, className = props.className, popupStyle = props.popupStyle, dropdownClassName = props.dropdownClassName, transitionName2 = props.transitionName, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, generateConfig2 = props.generateConfig, locale2 = props.locale, placeholder = props.placeholder, autoFocus = props.autoFocus, disabled = props.disabled, format3 = props.format, _props$picker = props.picker, picker = _props$picker === void 0 ? "date" : _props$picker, showTime = props.showTime, use12Hours = props.use12Hours, _props$separator = props.separator, separator = _props$separator === void 0 ? "~" : _props$separator, value = props.value, defaultValue = props.defaultValue, defaultPickerValue = props.defaultPickerValue, open = props.open, defaultOpen = props.defaultOpen, disabledDate = props.disabledDate, _disabledTime = props.disabledTime, dateRender = props.dateRender, panelRender = props.panelRender, ranges = props.ranges, allowEmpty = props.allowEmpty, allowClear = props.allowClear, suffixIcon = props.suffixIcon, clearIcon = props.clearIcon, pickerRef = props.pickerRef, inputReadOnly = props.inputReadOnly, mode = props.mode, renderExtraFooter = props.renderExtraFooter, onChange4 = props.onChange, onOpenChange = props.onOpenChange, onPanelChange = props.onPanelChange, onCalendarChange = props.onCalendarChange, _onFocus = props.onFocus, onBlur2 = props.onBlur, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, _onOk = props.onOk, _onKeyDown = props.onKeyDown, components = props.components, order = props.order, direction = props.direction, activePickerIndex = props.activePickerIndex, _props$autoComplete = props.autoComplete, autoComplete = _props$autoComplete === void 0 ? "off" : _props$autoComplete;
  var needConfirmButton = picker === "date" && !!showTime || picker === "time";
  var openRecordsRef = useRef2({});
  var containerRef = useRef2(null);
  var panelDivRef = useRef2(null);
  var startInputDivRef = useRef2(null);
  var endInputDivRef = useRef2(null);
  var separatorRef = useRef2(null);
  var startInputRef = useRef2(null);
  var endInputRef = useRef2(null);
  var formatList = toArray$5(getDefaultFormat(format3, picker, showTime, use12Hours));
  var _useMergedState = useMergedState(0, {
    value: activePickerIndex
  }), _useMergedState2 = _slicedToArray$3(_useMergedState, 2), mergedActivePickerIndex = _useMergedState2[0], setMergedActivePickerIndex = _useMergedState2[1];
  var operationRef = useRef2(null);
  var mergedDisabled = React.useMemo(function() {
    if (Array.isArray(disabled)) {
      return disabled;
    }
    return [disabled || false, disabled || false];
  }, [disabled]);
  var _useMergedState3 = useMergedState(null, {
    value,
    defaultValue,
    postState: function postState(values) {
      return picker === "time" && !order ? values : reorderValues(values, generateConfig2);
    }
  }), _useMergedState4 = _slicedToArray$3(_useMergedState3, 2), mergedValue = _useMergedState4[0], setInnerValue = _useMergedState4[1];
  var _useRangeViewDates = useRangeViewDates({
    values: mergedValue,
    picker,
    defaultDates: defaultPickerValue,
    generateConfig: generateConfig2
  }), _useRangeViewDates2 = _slicedToArray$3(_useRangeViewDates, 2), getViewDate = _useRangeViewDates2[0], setViewDate = _useRangeViewDates2[1];
  var _useMergedState5 = useMergedState(mergedValue, {
    postState: function postState(values) {
      var postValues = values;
      if (mergedDisabled[0] && mergedDisabled[1]) {
        return postValues;
      }
      for (var i2 = 0; i2 < 2; i2 += 1) {
        if (mergedDisabled[i2] && !getValue(postValues, i2) && !getValue(allowEmpty, i2)) {
          postValues = updateValues(postValues, generateConfig2.getNow(), i2);
        }
      }
      return postValues;
    }
  }), _useMergedState6 = _slicedToArray$3(_useMergedState5, 2), selectedValue = _useMergedState6[0], setSelectedValue = _useMergedState6[1];
  var _useMergedState7 = useMergedState([picker, picker], {
    value: mode
  }), _useMergedState8 = _slicedToArray$3(_useMergedState7, 2), mergedModes = _useMergedState8[0], setInnerModes = _useMergedState8[1];
  useEffect2(function() {
    setInnerModes([picker, picker]);
  }, [picker]);
  var triggerModesChange = function triggerModesChange2(modes, values) {
    setInnerModes(modes);
    if (onPanelChange) {
      onPanelChange(values, modes);
    }
  };
  var _useRangeDisabled = useRangeDisabled({
    picker,
    selectedValue,
    locale: locale2,
    disabled: mergedDisabled,
    disabledDate,
    generateConfig: generateConfig2
  }, openRecordsRef.current[1], openRecordsRef.current[0]), _useRangeDisabled2 = _slicedToArray$3(_useRangeDisabled, 2), disabledStartDate = _useRangeDisabled2[0], disabledEndDate = _useRangeDisabled2[1];
  var _useMergedState9 = useMergedState(false, {
    value: open,
    defaultValue: defaultOpen,
    postState: function postState(postOpen) {
      return mergedDisabled[mergedActivePickerIndex] ? false : postOpen;
    },
    onChange: function onChange5(newOpen) {
      if (onOpenChange) {
        onOpenChange(newOpen);
      }
      if (!newOpen && operationRef.current && operationRef.current.onClose) {
        operationRef.current.onClose();
      }
    }
  }), _useMergedState10 = _slicedToArray$3(_useMergedState9, 2), mergedOpen = _useMergedState10[0], triggerInnerOpen = _useMergedState10[1];
  var startOpen = mergedOpen && mergedActivePickerIndex === 0;
  var endOpen = mergedOpen && mergedActivePickerIndex === 1;
  var _useState = useState2(0), _useState2 = _slicedToArray$3(_useState, 2), popupMinWidth = _useState2[0], setPopupMinWidth = _useState2[1];
  useEffect2(function() {
    if (!mergedOpen && containerRef.current) {
      setPopupMinWidth(containerRef.current.offsetWidth);
    }
  }, [mergedOpen]);
  var triggerRef = React.useRef();
  function _triggerOpen(newOpen, index2) {
    if (newOpen) {
      clearTimeout(triggerRef.current);
      openRecordsRef.current[index2] = true;
      setMergedActivePickerIndex(index2);
      triggerInnerOpen(newOpen);
      if (!mergedOpen) {
        setViewDate(null, index2);
      }
    } else if (mergedActivePickerIndex === index2) {
      triggerInnerOpen(newOpen);
      var openRecords = openRecordsRef.current;
      triggerRef.current = setTimeout(function() {
        if (openRecords === openRecordsRef.current) {
          openRecordsRef.current = {};
        }
      });
    }
  }
  function triggerOpenAndFocus(index2) {
    _triggerOpen(true, index2);
    setTimeout(function() {
      var inputRef = [startInputRef, endInputRef][index2];
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 0);
  }
  function triggerChange(newValue, sourceIndex) {
    var values = newValue;
    var startValue = getValue(values, 0);
    var endValue = getValue(values, 1);
    if (startValue && endValue && generateConfig2.isAfter(startValue, endValue)) {
      if (picker === "week" && !isSameWeek(generateConfig2, locale2.locale, startValue, endValue) || picker === "quarter" && !isSameQuarter(generateConfig2, startValue, endValue) || picker !== "week" && picker !== "quarter" && picker !== "time" && !isSameDate(generateConfig2, startValue, endValue)) {
        if (sourceIndex === 0) {
          values = [startValue, null];
          endValue = null;
        } else {
          startValue = null;
          values = [null, endValue];
        }
        openRecordsRef.current = _defineProperty$4({}, sourceIndex, true);
      } else if (picker !== "time" || order !== false) {
        values = reorderValues(values, generateConfig2);
      }
    }
    setSelectedValue(values);
    var startStr2 = values && values[0] ? formatValue(values[0], {
      generateConfig: generateConfig2,
      locale: locale2,
      format: formatList[0]
    }) : "";
    var endStr2 = values && values[1] ? formatValue(values[1], {
      generateConfig: generateConfig2,
      locale: locale2,
      format: formatList[0]
    }) : "";
    if (onCalendarChange) {
      var info = {
        range: sourceIndex === 0 ? "start" : "end"
      };
      onCalendarChange(values, [startStr2, endStr2], info);
    }
    var canStartValueTrigger = canValueTrigger(startValue, 0, mergedDisabled, allowEmpty);
    var canEndValueTrigger = canValueTrigger(endValue, 1, mergedDisabled, allowEmpty);
    var canTrigger = values === null || canStartValueTrigger && canEndValueTrigger;
    if (canTrigger) {
      setInnerValue(values);
      if (onChange4 && (!isEqual(generateConfig2, getValue(mergedValue, 0), startValue) || !isEqual(generateConfig2, getValue(mergedValue, 1), endValue))) {
        onChange4(values, [startStr2, endStr2]);
      }
    }
    var nextOpenIndex = null;
    if (sourceIndex === 0 && !mergedDisabled[1]) {
      nextOpenIndex = 1;
    } else if (sourceIndex === 1 && !mergedDisabled[0]) {
      nextOpenIndex = 0;
    }
    if (nextOpenIndex !== null && nextOpenIndex !== mergedActivePickerIndex && (!openRecordsRef.current[nextOpenIndex] || !getValue(values, nextOpenIndex)) && getValue(values, sourceIndex)) {
      triggerOpenAndFocus(nextOpenIndex);
    } else {
      _triggerOpen(false, sourceIndex);
    }
  }
  var forwardKeyDown = function forwardKeyDown2(e3) {
    if (mergedOpen && operationRef.current && operationRef.current.onKeyDown) {
      return operationRef.current.onKeyDown(e3);
    }
    {
      warningOnce(false, "Picker not correct forward KeyDown operation. Please help to fire issue about this.");
      return false;
    }
  };
  var sharedTextHooksProps = {
    formatList,
    generateConfig: generateConfig2,
    locale: locale2
  };
  var _useValueTexts = useValueTexts(getValue(selectedValue, 0), sharedTextHooksProps), _useValueTexts2 = _slicedToArray$3(_useValueTexts, 2), startValueTexts = _useValueTexts2[0], firstStartValueText = _useValueTexts2[1];
  var _useValueTexts3 = useValueTexts(getValue(selectedValue, 1), sharedTextHooksProps), _useValueTexts4 = _slicedToArray$3(_useValueTexts3, 2), endValueTexts = _useValueTexts4[0], firstEndValueText = _useValueTexts4[1];
  var _onTextChange = function onTextChange(newText, index2) {
    var inputDate = parseValue(newText, {
      locale: locale2,
      formatList,
      generateConfig: generateConfig2
    });
    var disabledFunc = index2 === 0 ? disabledStartDate : disabledEndDate;
    if (inputDate && !disabledFunc(inputDate)) {
      setSelectedValue(updateValues(selectedValue, inputDate, index2));
      setViewDate(inputDate, index2);
    }
  };
  var _useTextValueMapping = useTextValueMapping({
    valueTexts: startValueTexts,
    onTextChange: function onTextChange(newText) {
      return _onTextChange(newText, 0);
    }
  }), _useTextValueMapping2 = _slicedToArray$3(_useTextValueMapping, 3), startText = _useTextValueMapping2[0], triggerStartTextChange = _useTextValueMapping2[1], resetStartText = _useTextValueMapping2[2];
  var _useTextValueMapping3 = useTextValueMapping({
    valueTexts: endValueTexts,
    onTextChange: function onTextChange(newText) {
      return _onTextChange(newText, 1);
    }
  }), _useTextValueMapping4 = _slicedToArray$3(_useTextValueMapping3, 3), endText = _useTextValueMapping4[0], triggerEndTextChange = _useTextValueMapping4[1], resetEndText = _useTextValueMapping4[2];
  var _useState3 = useState2(null), _useState4 = _slicedToArray$3(_useState3, 2), rangeHoverValue = _useState4[0], setRangeHoverValue = _useState4[1];
  var _useState5 = useState2(null), _useState6 = _slicedToArray$3(_useState5, 2), hoverRangedValue = _useState6[0], setHoverRangedValue = _useState6[1];
  var _useHoverValue = useHoverValue(startText, {
    formatList,
    generateConfig: generateConfig2,
    locale: locale2
  }), _useHoverValue2 = _slicedToArray$3(_useHoverValue, 3), startHoverValue = _useHoverValue2[0], onStartEnter = _useHoverValue2[1], onStartLeave = _useHoverValue2[2];
  var _useHoverValue3 = useHoverValue(endText, {
    formatList,
    generateConfig: generateConfig2,
    locale: locale2
  }), _useHoverValue4 = _slicedToArray$3(_useHoverValue3, 3), endHoverValue = _useHoverValue4[0], onEndEnter = _useHoverValue4[1], onEndLeave = _useHoverValue4[2];
  var onDateMouseEnter = function onDateMouseEnter2(date3) {
    setHoverRangedValue(updateValues(selectedValue, date3, mergedActivePickerIndex));
    if (mergedActivePickerIndex === 0) {
      onStartEnter(date3);
    } else {
      onEndEnter(date3);
    }
  };
  var onDateMouseLeave = function onDateMouseLeave2() {
    setHoverRangedValue(updateValues(selectedValue, null, mergedActivePickerIndex));
    if (mergedActivePickerIndex === 0) {
      onStartLeave();
    } else {
      onEndLeave();
    }
  };
  var getSharedInputHookProps = function getSharedInputHookProps2(index2, resetText) {
    return {
      blurToCancel: needConfirmButton,
      forwardKeyDown,
      onBlur: onBlur2,
      isClickOutside: function isClickOutside(target) {
        return !elementsContains([panelDivRef.current, startInputDivRef.current, endInputDivRef.current, containerRef.current], target);
      },
      onFocus: function onFocus2(e3) {
        setMergedActivePickerIndex(index2);
        if (_onFocus) {
          _onFocus(e3);
        }
      },
      triggerOpen: function triggerOpen(newOpen) {
        _triggerOpen(newOpen, index2);
      },
      onSubmit: function onSubmit() {
        triggerChange(selectedValue, index2);
        resetText();
      },
      onCancel: function onCancel() {
        _triggerOpen(false, index2);
        setSelectedValue(mergedValue);
        resetText();
      }
    };
  };
  var _usePickerInput = usePickerInput(_objectSpread2$1(_objectSpread2$1({}, getSharedInputHookProps(0, resetStartText)), {}, {
    open: startOpen,
    value: startText,
    onKeyDown: function onKeyDown2(e3, preventDefault) {
      _onKeyDown === null || _onKeyDown === void 0 ? void 0 : _onKeyDown(e3, preventDefault);
    }
  })), _usePickerInput2 = _slicedToArray$3(_usePickerInput, 2), startInputProps = _usePickerInput2[0], _usePickerInput2$ = _usePickerInput2[1], startFocused = _usePickerInput2$.focused, startTyping = _usePickerInput2$.typing;
  var _usePickerInput3 = usePickerInput(_objectSpread2$1(_objectSpread2$1({}, getSharedInputHookProps(1, resetEndText)), {}, {
    open: endOpen,
    value: endText,
    onKeyDown: function onKeyDown2(e3, preventDefault) {
      _onKeyDown === null || _onKeyDown === void 0 ? void 0 : _onKeyDown(e3, preventDefault);
    }
  })), _usePickerInput4 = _slicedToArray$3(_usePickerInput3, 2), endInputProps = _usePickerInput4[0], _usePickerInput4$ = _usePickerInput4[1], endFocused = _usePickerInput4$.focused, endTyping = _usePickerInput4$.typing;
  var onPickerClick = function onPickerClick2(e3) {
    if (!mergedOpen && !startInputRef.current.contains(e3.target) && !endInputRef.current.contains(e3.target)) {
      if (!mergedDisabled[0]) {
        triggerOpenAndFocus(0);
      } else if (!mergedDisabled[1]) {
        triggerOpenAndFocus(1);
      }
    }
  };
  var onPickerMouseDown = function onPickerMouseDown2(e3) {
    if (mergedOpen && (startFocused || endFocused) && !startInputRef.current.contains(e3.target) && !endInputRef.current.contains(e3.target)) {
      e3.preventDefault();
    }
  };
  var startStr = mergedValue && mergedValue[0] ? formatValue(mergedValue[0], {
    locale: locale2,
    format: "YYYYMMDDHHmmss",
    generateConfig: generateConfig2
  }) : "";
  var endStr = mergedValue && mergedValue[1] ? formatValue(mergedValue[1], {
    locale: locale2,
    format: "YYYYMMDDHHmmss",
    generateConfig: generateConfig2
  }) : "";
  useEffect2(function() {
    if (!mergedOpen) {
      setSelectedValue(mergedValue);
      if (!startValueTexts.length || startValueTexts[0] === "") {
        triggerStartTextChange("");
      } else if (firstStartValueText !== startText) {
        resetStartText();
      }
      if (!endValueTexts.length || endValueTexts[0] === "") {
        triggerEndTextChange("");
      } else if (firstEndValueText !== endText) {
        resetEndText();
      }
    }
  }, [mergedOpen, startValueTexts, endValueTexts]);
  useEffect2(function() {
    setSelectedValue(mergedValue);
  }, [startStr, endStr]);
  if (process.env.NODE_ENV !== "production") {
    if (value && Array.isArray(disabled) && (getValue(disabled, 0) && !getValue(value, 0) || getValue(disabled, 1) && !getValue(value, 1))) {
      warningOnce(false, "`disabled` should not set with empty `value`. You should set `allowEmpty` or `value` instead.");
    }
  }
  if (pickerRef) {
    pickerRef.current = {
      focus: function focus() {
        if (startInputRef.current) {
          startInputRef.current.focus();
        }
      },
      blur: function blur() {
        if (startInputRef.current) {
          startInputRef.current.blur();
        }
        if (endInputRef.current) {
          endInputRef.current.blur();
        }
      }
    };
  }
  var rangeLabels = Object.keys(ranges || {});
  var rangeList = rangeLabels.map(function(label) {
    var range2 = ranges[label];
    var newValues = typeof range2 === "function" ? range2() : range2;
    return {
      label,
      onClick: function onClick() {
        triggerChange(newValues, null);
        _triggerOpen(false, mergedActivePickerIndex);
      },
      onMouseEnter: function onMouseEnter2() {
        setRangeHoverValue(newValues);
      },
      onMouseLeave: function onMouseLeave2() {
        setRangeHoverValue(null);
      }
    };
  });
  function renderPanel() {
    var panelPosition = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var panelProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var panelHoverRangedValue = null;
    if (mergedOpen && hoverRangedValue && hoverRangedValue[0] && hoverRangedValue[1] && generateConfig2.isAfter(hoverRangedValue[1], hoverRangedValue[0])) {
      panelHoverRangedValue = hoverRangedValue;
    }
    var panelShowTime = showTime;
    if (showTime && _typeof$5(showTime) === "object" && showTime.defaultValue) {
      var timeDefaultValues = showTime.defaultValue;
      panelShowTime = _objectSpread2$1(_objectSpread2$1({}, showTime), {}, {
        defaultValue: getValue(timeDefaultValues, mergedActivePickerIndex) || void 0
      });
    }
    var panelDateRender = null;
    if (dateRender) {
      panelDateRender = function panelDateRender2(date3, today) {
        return dateRender(date3, today, {
          range: mergedActivePickerIndex ? "end" : "start"
        });
      };
    }
    return /* @__PURE__ */ React.createElement(RangeContext.Provider, {
      value: {
        inRange: true,
        panelPosition,
        rangedValue: rangeHoverValue || selectedValue,
        hoverRangedValue: panelHoverRangedValue
      }
    }, /* @__PURE__ */ React.createElement(PickerPanel, _extends$2({}, props, panelProps, {
      dateRender: panelDateRender,
      showTime: panelShowTime,
      mode: mergedModes[mergedActivePickerIndex],
      generateConfig: generateConfig2,
      style: void 0,
      direction,
      disabledDate: mergedActivePickerIndex === 0 ? disabledStartDate : disabledEndDate,
      disabledTime: function disabledTime(date3) {
        if (_disabledTime) {
          return _disabledTime(date3, mergedActivePickerIndex === 0 ? "start" : "end");
        }
        return false;
      },
      className: cn(_defineProperty$4({}, "".concat(prefixCls, "-panel-focused"), mergedActivePickerIndex === 0 ? !startTyping : !endTyping)),
      value: getValue(selectedValue, mergedActivePickerIndex),
      locale: locale2,
      tabIndex: -1,
      onPanelChange: function onPanelChange2(date3, newMode) {
        if (mergedActivePickerIndex === 0) {
          onStartLeave(true);
        }
        if (mergedActivePickerIndex === 1) {
          onEndLeave(true);
        }
        triggerModesChange(updateValues(mergedModes, newMode, mergedActivePickerIndex), updateValues(selectedValue, date3, mergedActivePickerIndex));
        var viewDate = date3;
        if (panelPosition === "right" && mergedModes[mergedActivePickerIndex] === newMode) {
          viewDate = getClosingViewDate(viewDate, newMode, generateConfig2, -1);
        }
        setViewDate(viewDate, mergedActivePickerIndex);
      },
      onOk: null,
      onSelect: void 0,
      onChange: void 0,
      defaultValue: mergedActivePickerIndex === 0 ? getValue(selectedValue, 1) : getValue(selectedValue, 0)
    })));
  }
  var arrowLeft = 0;
  var panelLeft = 0;
  if (mergedActivePickerIndex && startInputDivRef.current && separatorRef.current && panelDivRef.current) {
    arrowLeft = startInputDivRef.current.offsetWidth + separatorRef.current.offsetWidth;
    if (panelDivRef.current.offsetWidth && arrowLeft > panelDivRef.current.offsetWidth) {
      panelLeft = arrowLeft;
    }
  }
  var arrowPositionStyle = direction === "rtl" ? {
    right: arrowLeft
  } : {
    left: arrowLeft
  };
  function renderPanels() {
    var panels;
    var extraNode = getExtraFooter(prefixCls, mergedModes[mergedActivePickerIndex], renderExtraFooter);
    var rangesNode = getRanges({
      prefixCls,
      components,
      needConfirmButton,
      okDisabled: !getValue(selectedValue, mergedActivePickerIndex) || disabledDate && disabledDate(selectedValue[mergedActivePickerIndex]),
      locale: locale2,
      rangeList,
      onOk: function onOk() {
        if (getValue(selectedValue, mergedActivePickerIndex)) {
          triggerChange(selectedValue, mergedActivePickerIndex);
          if (_onOk) {
            _onOk(selectedValue);
          }
        }
      }
    });
    if (picker !== "time" && !showTime) {
      var viewDate = getViewDate(mergedActivePickerIndex);
      var nextViewDate = getClosingViewDate(viewDate, picker, generateConfig2);
      var currentMode = mergedModes[mergedActivePickerIndex];
      var showDoublePanel = currentMode === picker;
      var leftPanel = renderPanel(showDoublePanel ? "left" : false, {
        pickerValue: viewDate,
        onPickerValueChange: function onPickerValueChange(newViewDate) {
          setViewDate(newViewDate, mergedActivePickerIndex);
        }
      });
      var rightPanel = renderPanel("right", {
        pickerValue: nextViewDate,
        onPickerValueChange: function onPickerValueChange(newViewDate) {
          setViewDate(getClosingViewDate(newViewDate, picker, generateConfig2, -1), mergedActivePickerIndex);
        }
      });
      if (direction === "rtl") {
        panels = /* @__PURE__ */ React.createElement(React.Fragment, null, rightPanel, showDoublePanel && leftPanel);
      } else {
        panels = /* @__PURE__ */ React.createElement(React.Fragment, null, leftPanel, showDoublePanel && rightPanel);
      }
    } else {
      panels = renderPanel();
    }
    var mergedNodes = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-panels")
    }, panels), (extraNode || rangesNode) && /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-footer")
    }, extraNode, rangesNode));
    if (panelRender) {
      mergedNodes = panelRender(mergedNodes);
    }
    return /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-panel-container"),
      style: {
        marginLeft: panelLeft
      },
      ref: panelDivRef,
      onMouseDown: function onMouseDown(e3) {
        e3.preventDefault();
      }
    }, mergedNodes);
  }
  var rangePanel = /* @__PURE__ */ React.createElement("div", {
    className: cn("".concat(prefixCls, "-range-wrapper"), "".concat(prefixCls, "-").concat(picker, "-range-wrapper")),
    style: {
      minWidth: popupMinWidth
    }
  }, /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-range-arrow"),
    style: arrowPositionStyle
  }), renderPanels());
  var suffixNode;
  if (suffixIcon) {
    suffixNode = /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-suffix")
    }, suffixIcon);
  }
  var clearNode;
  if (allowClear && (getValue(mergedValue, 0) && !mergedDisabled[0] || getValue(mergedValue, 1) && !mergedDisabled[1])) {
    clearNode = /* @__PURE__ */ React.createElement("span", {
      onMouseDown: function onMouseDown(e3) {
        e3.preventDefault();
        e3.stopPropagation();
      },
      onMouseUp: function onMouseUp(e3) {
        e3.preventDefault();
        e3.stopPropagation();
        var values = mergedValue;
        if (!mergedDisabled[0]) {
          values = updateValues(values, null, 0);
        }
        if (!mergedDisabled[1]) {
          values = updateValues(values, null, 1);
        }
        triggerChange(values, null);
        _triggerOpen(false, mergedActivePickerIndex);
      },
      className: "".concat(prefixCls, "-clear")
    }, clearIcon || /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-clear-btn")
    }));
  }
  var inputSharedProps = {
    size: getInputSize(picker, formatList[0], generateConfig2)
  };
  var activeBarLeft = 0;
  var activeBarWidth = 0;
  if (startInputDivRef.current && endInputDivRef.current && separatorRef.current) {
    if (mergedActivePickerIndex === 0) {
      activeBarWidth = startInputDivRef.current.offsetWidth;
    } else {
      activeBarLeft = arrowLeft;
      activeBarWidth = endInputDivRef.current.offsetWidth;
    }
  }
  var activeBarPositionStyle = direction === "rtl" ? {
    right: activeBarLeft
  } : {
    left: activeBarLeft
  };
  var onContextSelect = function onContextSelect2(date3, type2) {
    var values = updateValues(selectedValue, date3, mergedActivePickerIndex);
    if (type2 === "submit" || type2 !== "key" && !needConfirmButton) {
      triggerChange(values, mergedActivePickerIndex);
      if (mergedActivePickerIndex === 0) {
        onStartLeave();
      } else {
        onEndLeave();
      }
    } else {
      setSelectedValue(values);
    }
  };
  return /* @__PURE__ */ React.createElement(PanelContext.Provider, {
    value: {
      operationRef,
      hideHeader: picker === "time",
      onDateMouseEnter,
      onDateMouseLeave,
      hideRanges: true,
      onSelect: onContextSelect,
      open: mergedOpen
    }
  }, /* @__PURE__ */ React.createElement(PickerTrigger, {
    visible: mergedOpen,
    popupElement: rangePanel,
    popupStyle,
    prefixCls,
    dropdownClassName,
    dropdownAlign,
    getPopupContainer,
    transitionName: transitionName2,
    range: true,
    direction
  }, /* @__PURE__ */ React.createElement("div", _extends$2({
    ref: containerRef,
    className: cn(prefixCls, "".concat(prefixCls, "-range"), className, (_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-disabled"), mergedDisabled[0] && mergedDisabled[1]), _defineProperty$4(_classNames2, "".concat(prefixCls, "-focused"), mergedActivePickerIndex === 0 ? startFocused : endFocused), _defineProperty$4(_classNames2, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames2)),
    style: style2,
    onClick: onPickerClick,
    onMouseEnter,
    onMouseLeave,
    onMouseDown: onPickerMouseDown
  }, getDataOrAriaProps(props)), /* @__PURE__ */ React.createElement("div", {
    className: cn("".concat(prefixCls, "-input"), (_classNames3 = {}, _defineProperty$4(_classNames3, "".concat(prefixCls, "-input-active"), mergedActivePickerIndex === 0), _defineProperty$4(_classNames3, "".concat(prefixCls, "-input-placeholder"), !!startHoverValue), _classNames3)),
    ref: startInputDivRef
  }, /* @__PURE__ */ React.createElement("input", _extends$2({
    id: id2,
    disabled: mergedDisabled[0],
    readOnly: inputReadOnly || typeof formatList[0] === "function" || !startTyping,
    value: startHoverValue || startText,
    onChange: function onChange5(e3) {
      triggerStartTextChange(e3.target.value);
    },
    autoFocus,
    placeholder: getValue(placeholder, 0) || "",
    ref: startInputRef
  }, startInputProps, inputSharedProps, {
    autoComplete
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-range-separator"),
    ref: separatorRef
  }, separator), /* @__PURE__ */ React.createElement("div", {
    className: cn("".concat(prefixCls, "-input"), (_classNames4 = {}, _defineProperty$4(_classNames4, "".concat(prefixCls, "-input-active"), mergedActivePickerIndex === 1), _defineProperty$4(_classNames4, "".concat(prefixCls, "-input-placeholder"), !!endHoverValue), _classNames4)),
    ref: endInputDivRef
  }, /* @__PURE__ */ React.createElement("input", _extends$2({
    disabled: mergedDisabled[1],
    readOnly: inputReadOnly || typeof formatList[0] === "function" || !endTyping,
    value: endHoverValue || endText,
    onChange: function onChange5(e3) {
      triggerEndTextChange(e3.target.value);
    },
    placeholder: getValue(placeholder, 1) || "",
    ref: endInputRef
  }, endInputProps, inputSharedProps, {
    autoComplete
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-active-bar"),
    style: _objectSpread2$1(_objectSpread2$1({}, activeBarPositionStyle), {}, {
      width: activeBarWidth,
      position: "absolute"
    })
  }), suffixNode, clearNode)));
}
var RangePicker$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(RangePicker2, _React$Component);
  var _super = _createSuper$1(RangePicker2);
  function RangePicker2() {
    var _this2;
    _classCallCheck$2(this, RangePicker2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super.call.apply(_super, [this].concat(args));
    _this2.pickerRef = /* @__PURE__ */ React.createRef();
    _this2.focus = function() {
      if (_this2.pickerRef.current) {
        _this2.pickerRef.current.focus();
      }
    };
    _this2.blur = function() {
      if (_this2.pickerRef.current) {
        _this2.pickerRef.current.blur();
      }
    };
    return _this2;
  }
  _createClass$2(RangePicker2, [{
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(InnerRangePicker, _extends$2({}, this.props, {
        pickerRef: this.pickerRef
      }));
    }
  }]);
  return RangePicker2;
}(React.Component);
var Checkbox$2 = /* @__PURE__ */ function(_Component) {
  _inherits$1(Checkbox2, _Component);
  var _super = _createSuper$1(Checkbox2);
  function Checkbox2(props) {
    var _this2;
    _classCallCheck$2(this, Checkbox2);
    _this2 = _super.call(this, props);
    _this2.handleChange = function(e3) {
      var _this$props = _this2.props, disabled = _this$props.disabled, onChange4 = _this$props.onChange;
      if (disabled) {
        return;
      }
      if (!("checked" in _this2.props)) {
        _this2.setState({
          checked: e3.target.checked
        });
      }
      if (onChange4) {
        onChange4({
          target: _objectSpread2$1(_objectSpread2$1({}, _this2.props), {}, {
            checked: e3.target.checked
          }),
          stopPropagation: function stopPropagation() {
            e3.stopPropagation();
          },
          preventDefault: function preventDefault() {
            e3.preventDefault();
          },
          nativeEvent: e3.nativeEvent
        });
      }
    };
    _this2.saveInput = function(node) {
      _this2.input = node;
    };
    var checked = "checked" in props ? props.checked : props.defaultChecked;
    _this2.state = {
      checked
    };
    return _this2;
  }
  _createClass$2(Checkbox2, [{
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "render",
    value: function render4() {
      var _classNames;
      var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, style2 = _this$props2.style, name = _this$props2.name, id2 = _this$props2.id, type2 = _this$props2.type, disabled = _this$props2.disabled, readOnly = _this$props2.readOnly, tabIndex = _this$props2.tabIndex, onClick = _this$props2.onClick, onFocus2 = _this$props2.onFocus, onBlur2 = _this$props2.onBlur, onKeyDown2 = _this$props2.onKeyDown, onKeyPress2 = _this$props2.onKeyPress, onKeyUp2 = _this$props2.onKeyUp, autoFocus = _this$props2.autoFocus, value = _this$props2.value, required2 = _this$props2.required, others = _objectWithoutProperties$1(_this$props2, ["prefixCls", "className", "style", "name", "id", "type", "disabled", "readOnly", "tabIndex", "onClick", "onFocus", "onBlur", "onKeyDown", "onKeyPress", "onKeyUp", "autoFocus", "value", "required"]);
      var globalProps = Object.keys(others).reduce(function(prev, key2) {
        if (key2.substr(0, 5) === "aria-" || key2.substr(0, 5) === "data-" || key2 === "role") {
          prev[key2] = others[key2];
        }
        return prev;
      }, {});
      var checked = this.state.checked;
      var classString = cn(prefixCls, className, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-checked"), checked), _defineProperty$4(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
      return /* @__PURE__ */ React__default.createElement("span", {
        className: classString,
        style: style2
      }, /* @__PURE__ */ React__default.createElement("input", _extends$2({
        name,
        id: id2,
        type: type2,
        required: required2,
        readOnly,
        disabled,
        tabIndex,
        className: "".concat(prefixCls, "-input"),
        checked: !!checked,
        onClick,
        onFocus: onFocus2,
        onBlur: onBlur2,
        onKeyUp: onKeyUp2,
        onKeyDown: onKeyDown2,
        onKeyPress: onKeyPress2,
        onChange: this.handleChange,
        autoFocus,
        ref: this.saveInput,
        value
      }, globalProps)), /* @__PURE__ */ React__default.createElement("span", {
        className: "".concat(prefixCls, "-inner")
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if ("checked" in props) {
        return _objectSpread2$1(_objectSpread2$1({}, state), {}, {
          checked: props.checked
        });
      }
      return null;
    }
  }]);
  return Checkbox2;
}(Component2);
Checkbox$2.defaultProps = {
  prefixCls: "rc-checkbox",
  className: "",
  style: {},
  type: "checkbox",
  defaultChecked: false,
  onFocus: function onFocus() {
  },
  onBlur: function onBlur() {
  },
  onChange: function onChange() {
  },
  onKeyDown: function onKeyDown() {
  },
  onKeyPress: function onKeyPress() {
  },
  onKeyUp: function onKeyUp() {
  }
};
var RadioGroupContext$1 = /* @__PURE__ */ React.createContext(null);
var RadioGroupContextProvider = RadioGroupContext$1.Provider;
var __rest$B = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var InternalRadio = function InternalRadio2(props, ref) {
  var _classNames;
  var context2 = React.useContext(RadioGroupContext$1);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var innerRef = React.useRef();
  var mergedRef = composeRef(ref, innerRef);
  React.useEffect(function() {
    devWarning(!("optionType" in props), "Radio", "`optionType` is only support in Radio.Group.");
  }, []);
  var onChange4 = function onChange5(e3) {
    var _a, _b;
    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e3);
    (_b = context2 === null || context2 === void 0 ? void 0 : context2.onChange) === null || _b === void 0 ? void 0 : _b.call(context2, e3);
  };
  var customizePrefixCls = props.prefixCls, className = props.className, children = props.children, style2 = props.style, restProps = __rest$B(props, ["prefixCls", "className", "children", "style"]);
  var prefixCls = getPrefixCls("radio", customizePrefixCls);
  var radioProps = _extends$2({}, restProps);
  if (context2) {
    radioProps.name = context2.name;
    radioProps.onChange = onChange4;
    radioProps.checked = props.value === context2.value;
    radioProps.disabled = props.disabled || context2.disabled;
  }
  var wrapperClassString = cn("".concat(prefixCls, "-wrapper"), (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), _defineProperty$4(_classNames, "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), _defineProperty$4(_classNames, "".concat(prefixCls, "-wrapper-rtl"), direction === "rtl"), _classNames), className);
  return /* @__PURE__ */ React.createElement("label", {
    className: wrapperClassString,
    style: style2,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave
  }, /* @__PURE__ */ React.createElement(Checkbox$2, _extends$2({}, radioProps, {
    prefixCls,
    ref: mergedRef
  })), children !== void 0 ? /* @__PURE__ */ React.createElement("span", null, children) : null);
};
var Radio$2 = /* @__PURE__ */ React.forwardRef(InternalRadio);
Radio$2.displayName = "Radio";
Radio$2.defaultProps = {
  type: "radio"
};
var RadioGroup$1 = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var size = React.useContext(SizeContext$1);
  var _useMergedState = useMergedState(props.defaultValue, {
    value: props.value
  }), _useMergedState2 = _slicedToArray$3(_useMergedState, 2), value = _useMergedState2[0], setValue2 = _useMergedState2[1];
  var onRadioChange = function onRadioChange2(ev) {
    var lastValue = value;
    var val = ev.target.value;
    if (!("value" in props)) {
      setValue2(val);
    }
    var onChange4 = props.onChange;
    if (onChange4 && val !== lastValue) {
      onChange4(ev);
    }
  };
  var renderGroup = function renderGroup2() {
    var _classNames;
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, options = props.options, optionType = props.optionType, _props$buttonStyle = props.buttonStyle, buttonStyle = _props$buttonStyle === void 0 ? "outline" : _props$buttonStyle, disabled = props.disabled, children = props.children, customizeSize = props.size, style2 = props.style, id2 = props.id, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave;
    var prefixCls = getPrefixCls("radio", customizePrefixCls);
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var childrenToRender = children;
    if (options && options.length > 0) {
      var optionsPrefixCls = optionType === "button" ? "".concat(prefixCls, "-button") : prefixCls;
      childrenToRender = options.map(function(option) {
        if (typeof option === "string") {
          return /* @__PURE__ */ React.createElement(Radio$2, {
            key: option,
            prefixCls: optionsPrefixCls,
            disabled,
            value: option,
            checked: value === option
          }, option);
        }
        return /* @__PURE__ */ React.createElement(Radio$2, {
          key: "radio-group-value-options-".concat(option.value),
          prefixCls: optionsPrefixCls,
          disabled: option.disabled || disabled,
          value: option.value,
          checked: value === option.value,
          style: option.style
        }, option.label);
      });
    }
    var mergedSize = customizeSize || size;
    var classString = cn(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), (_classNames = {}, _defineProperty$4(_classNames, "".concat(groupPrefixCls, "-").concat(mergedSize), mergedSize), _defineProperty$4(_classNames, "".concat(groupPrefixCls, "-rtl"), direction === "rtl"), _classNames), className);
    return /* @__PURE__ */ React.createElement("div", {
      className: classString,
      style: style2,
      onMouseEnter,
      onMouseLeave,
      id: id2,
      ref
    }, childrenToRender);
  };
  return /* @__PURE__ */ React.createElement(RadioGroupContextProvider, {
    value: {
      onChange: onRadioChange,
      value,
      disabled: props.disabled,
      name: props.name
    }
  }, renderGroup());
});
var Group$2 = /* @__PURE__ */ React.memo(RadioGroup$1);
var __rest$A = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var RadioButton = function RadioButton2(props, ref) {
  var radioGroupContext = React.useContext(RadioGroupContext$1);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
  var customizePrefixCls = props.prefixCls, radioProps = __rest$A(props, ["prefixCls"]);
  var prefixCls = getPrefixCls("radio-button", customizePrefixCls);
  if (radioGroupContext) {
    radioProps.checked = props.value === radioGroupContext.value;
    radioProps.disabled = props.disabled || radioGroupContext.disabled;
  }
  return /* @__PURE__ */ React.createElement(Radio$2, _extends$2({
    prefixCls
  }, radioProps, {
    type: "radio",
    ref
  }));
};
var Button = /* @__PURE__ */ React.forwardRef(RadioButton);
var Radio$1 = Radio$2;
Radio$1.Button = Button;
Radio$1.Group = Group$2;
function useRaf(callback) {
  var rafRef = useRef2();
  var removedRef = useRef2(false);
  function trigger() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (!removedRef.current) {
      wrapperRaf$1.cancel(rafRef.current);
      rafRef.current = wrapperRaf$1(function() {
        callback.apply(void 0, args);
      });
    }
  }
  useEffect2(function() {
    return function() {
      removedRef.current = true;
      wrapperRaf$1.cancel(rafRef.current);
    };
  }, []);
  return trigger;
}
function useRafState(defaultState) {
  var batchRef = useRef2([]);
  var _useState = useState2({}), _useState2 = _slicedToArray$3(_useState, 2), forceUpdate = _useState2[1];
  var state = useRef2(typeof defaultState === "function" ? defaultState() : defaultState);
  var flushUpdate = useRaf(function() {
    var current = state.current;
    batchRef.current.forEach(function(callback) {
      current = callback(current);
    });
    batchRef.current = [];
    state.current = current;
    forceUpdate({});
  });
  function updater(callback) {
    batchRef.current.push(callback);
    flushUpdate();
  }
  return [state.current, updater];
}
function TabNode(_ref, ref) {
  var _classNames;
  var prefixCls = _ref.prefixCls, id2 = _ref.id, active = _ref.active, rtl2 = _ref.rtl, _ref$tab = _ref.tab, key2 = _ref$tab.key, tab = _ref$tab.tab, disabled = _ref$tab.disabled, closeIcon2 = _ref$tab.closeIcon, tabBarGutter = _ref.tabBarGutter, tabPosition = _ref.tabPosition, closable = _ref.closable, renderWrapper = _ref.renderWrapper, removeAriaLabel = _ref.removeAriaLabel, editable = _ref.editable, onClick = _ref.onClick, onRemove = _ref.onRemove, onFocus2 = _ref.onFocus;
  var tabPrefix = "".concat(prefixCls, "-tab");
  React.useEffect(function() {
    return onRemove;
  }, []);
  var nodeStyle = {};
  if (tabPosition === "top" || tabPosition === "bottom") {
    nodeStyle[rtl2 ? "marginLeft" : "marginRight"] = tabBarGutter;
  } else {
    nodeStyle.marginBottom = tabBarGutter;
  }
  var removable = editable && closable !== false && !disabled;
  function onInternalClick(e3) {
    if (disabled)
      return;
    onClick(e3);
  }
  function onRemoveTab(event) {
    event.preventDefault();
    event.stopPropagation();
    editable.onEdit("remove", {
      key: key2,
      event
    });
  }
  var node = /* @__PURE__ */ React.createElement("div", {
    key: key2,
    ref,
    className: cn(tabPrefix, (_classNames = {}, _defineProperty$4(_classNames, "".concat(tabPrefix, "-with-remove"), removable), _defineProperty$4(_classNames, "".concat(tabPrefix, "-active"), active), _defineProperty$4(_classNames, "".concat(tabPrefix, "-disabled"), disabled), _classNames)),
    style: nodeStyle,
    onClick: onInternalClick
  }, /* @__PURE__ */ React.createElement("div", {
    role: "tab",
    "aria-selected": active,
    id: id2 && "".concat(id2, "-tab-").concat(key2),
    className: "".concat(tabPrefix, "-btn"),
    "aria-controls": id2 && "".concat(id2, "-panel-").concat(key2),
    "aria-disabled": disabled,
    tabIndex: disabled ? null : 0,
    onClick: function onClick2(e3) {
      e3.stopPropagation();
      onInternalClick(e3);
    },
    onKeyDown: function onKeyDown2(e3) {
      if ([KeyCode.SPACE, KeyCode.ENTER].includes(e3.which)) {
        e3.preventDefault();
        onInternalClick(e3);
      }
    },
    onFocus: onFocus2
  }, tab), removable && /* @__PURE__ */ React.createElement("button", {
    type: "button",
    "aria-label": removeAriaLabel || "remove",
    tabIndex: 0,
    className: "".concat(tabPrefix, "-remove"),
    onClick: function onClick2(e3) {
      e3.stopPropagation();
      onRemoveTab(e3);
    }
  }, closeIcon2 || editable.removeIcon || "\xD7"));
  if (renderWrapper) {
    node = renderWrapper(node);
  }
  return node;
}
var TabNode$1 = /* @__PURE__ */ React.forwardRef(TabNode);
var DEFAULT_SIZE$1 = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
function useOffsets(tabs, tabSizes, holderScrollWidth) {
  return useMemo$1(function() {
    var _tabs$;
    var map = /* @__PURE__ */ new Map();
    var lastOffset = tabSizes.get((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key) || DEFAULT_SIZE$1;
    var rightOffset = lastOffset.left + lastOffset.width;
    for (var i2 = 0; i2 < tabs.length; i2 += 1) {
      var key2 = tabs[i2].key;
      var data = tabSizes.get(key2);
      if (!data) {
        var _tabs;
        data = tabSizes.get((_tabs = tabs[i2 - 1]) === null || _tabs === void 0 ? void 0 : _tabs.key) || DEFAULT_SIZE$1;
      }
      var entity = map.get(key2) || _objectSpread2$1({}, data);
      entity.right = rightOffset - entity.left - entity.width;
      map.set(key2, entity);
    }
    return map;
  }, [tabs.map(function(tab) {
    return tab.key;
  }).join("_"), tabSizes, holderScrollWidth]);
}
var DEFAULT_SIZE = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  right: 0
};
function useVisibleRange(tabOffsets, containerSize, tabContentNodeSize, addNodeSize, _ref) {
  var tabs = _ref.tabs, tabPosition = _ref.tabPosition, rtl2 = _ref.rtl;
  var unit;
  var position;
  var transformSize;
  if (["top", "bottom"].includes(tabPosition)) {
    unit = "width";
    position = rtl2 ? "right" : "left";
    transformSize = Math.abs(containerSize.left);
  } else {
    unit = "height";
    position = "top";
    transformSize = -containerSize.top;
  }
  var basicSize = containerSize[unit];
  var tabContentSize = tabContentNodeSize[unit];
  var addSize = addNodeSize[unit];
  var mergedBasicSize = basicSize;
  if (tabContentSize + addSize > basicSize) {
    mergedBasicSize = basicSize - addSize;
  }
  return useMemo$1(function() {
    if (!tabs.length) {
      return [0, 0];
    }
    var len = tabs.length;
    var endIndex = len;
    for (var i2 = 0; i2 < len; i2 += 1) {
      var offset3 = tabOffsets.get(tabs[i2].key) || DEFAULT_SIZE;
      if (offset3[position] + offset3[unit] > transformSize + mergedBasicSize) {
        endIndex = i2 - 1;
        break;
      }
    }
    var startIndex = 0;
    for (var _i = len - 1; _i >= 0; _i -= 1) {
      var _offset = tabOffsets.get(tabs[_i].key) || DEFAULT_SIZE;
      if (_offset[position] < transformSize) {
        startIndex = _i + 1;
        break;
      }
    }
    return [startIndex, endIndex];
  }, [tabOffsets, transformSize, mergedBasicSize, tabPosition, tabs.map(function(tab) {
    return tab.key;
  }).join("_"), rtl2]);
}
function AddButton(_ref, ref) {
  var prefixCls = _ref.prefixCls, editable = _ref.editable, locale2 = _ref.locale, style2 = _ref.style;
  if (!editable || editable.showAdd === false) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("button", {
    ref,
    type: "button",
    className: "".concat(prefixCls, "-nav-add"),
    style: style2,
    "aria-label": (locale2 === null || locale2 === void 0 ? void 0 : locale2.addAriaLabel) || "Add tab",
    onClick: function onClick(event) {
      editable.onEdit("add", {
        event
      });
    }
  }, editable.addIcon || "+");
}
var AddButton$1 = /* @__PURE__ */ React.forwardRef(AddButton);
function OperationNode(_ref, ref) {
  var prefixCls = _ref.prefixCls, id2 = _ref.id, tabs = _ref.tabs, locale2 = _ref.locale, mobile = _ref.mobile, _ref$moreIcon = _ref.moreIcon, moreIcon = _ref$moreIcon === void 0 ? "More" : _ref$moreIcon, moreTransitionName = _ref.moreTransitionName, style2 = _ref.style, className = _ref.className, editable = _ref.editable, tabBarGutter = _ref.tabBarGutter, rtl2 = _ref.rtl, onTabClick = _ref.onTabClick;
  var _useState = useState2(false), _useState2 = _slicedToArray$3(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
  var _useState3 = useState2(null), _useState4 = _slicedToArray$3(_useState3, 2), selectedKey = _useState4[0], setSelectedKey = _useState4[1];
  var popupId = "".concat(id2, "-more-popup");
  var dropdownPrefix = "".concat(prefixCls, "-dropdown");
  var selectedItemId = selectedKey !== null ? "".concat(popupId, "-").concat(selectedKey) : null;
  var dropdownAriaLabel = locale2 === null || locale2 === void 0 ? void 0 : locale2.dropdownAriaLabel;
  var menu = /* @__PURE__ */ React.createElement(Menu$1, {
    onClick: function onClick(_ref2) {
      var key2 = _ref2.key, domEvent = _ref2.domEvent;
      onTabClick(key2, domEvent);
      setOpen(false);
    },
    id: popupId,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": selectedItemId,
    selectedKeys: [selectedKey],
    "aria-label": dropdownAriaLabel !== void 0 ? dropdownAriaLabel : "expanded dropdown"
  }, tabs.map(function(tab) {
    return /* @__PURE__ */ React.createElement(connected, {
      key: tab.key,
      id: "".concat(popupId, "-").concat(tab.key),
      role: "option",
      "aria-controls": id2 && "".concat(id2, "-panel-").concat(tab.key),
      disabled: tab.disabled
    }, tab.tab);
  }));
  function selectOffset(offset3) {
    var enabledTabs = tabs.filter(function(tab2) {
      return !tab2.disabled;
    });
    var selectedIndex = enabledTabs.findIndex(function(tab2) {
      return tab2.key === selectedKey;
    }) || 0;
    var len = enabledTabs.length;
    for (var i2 = 0; i2 < len; i2 += 1) {
      selectedIndex = (selectedIndex + offset3 + len) % len;
      var tab = enabledTabs[selectedIndex];
      if (!tab.disabled) {
        setSelectedKey(tab.key);
        return;
      }
    }
  }
  function onKeyDown2(e3) {
    var which = e3.which;
    if (!open) {
      if ([KeyCode.DOWN, KeyCode.SPACE, KeyCode.ENTER].includes(which)) {
        setOpen(true);
        e3.preventDefault();
      }
      return;
    }
    switch (which) {
      case KeyCode.UP:
        selectOffset(-1);
        e3.preventDefault();
        break;
      case KeyCode.DOWN:
        selectOffset(1);
        e3.preventDefault();
        break;
      case KeyCode.ESC:
        setOpen(false);
        break;
      case KeyCode.SPACE:
      case KeyCode.ENTER:
        if (selectedKey !== null)
          onTabClick(selectedKey, e3);
        break;
    }
  }
  useEffect2(function() {
    var ele = document.getElementById(selectedItemId);
    if (ele && ele.scrollIntoView) {
      ele.scrollIntoView(false);
    }
  }, [selectedKey]);
  useEffect2(function() {
    if (!open) {
      setSelectedKey(null);
    }
  }, [open]);
  var moreStyle = _defineProperty$4({}, rtl2 ? "marginLeft" : "marginRight", tabBarGutter);
  if (!tabs.length) {
    moreStyle.visibility = "hidden";
    moreStyle.order = 1;
  }
  var overlayClassName = cn(_defineProperty$4({}, "".concat(dropdownPrefix, "-rtl"), rtl2));
  var moreNode = mobile ? null : /* @__PURE__ */ React.createElement(Dropdown$4, {
    prefixCls: dropdownPrefix,
    overlay: menu,
    trigger: ["hover"],
    visible: open,
    transitionName: moreTransitionName,
    onVisibleChange: setOpen,
    overlayClassName,
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1
  }, /* @__PURE__ */ React.createElement("button", {
    type: "button",
    className: "".concat(prefixCls, "-nav-more"),
    style: moreStyle,
    tabIndex: -1,
    "aria-hidden": "true",
    "aria-haspopup": "listbox",
    "aria-controls": popupId,
    id: "".concat(id2, "-more"),
    "aria-expanded": open,
    onKeyDown: onKeyDown2
  }, moreIcon));
  return /* @__PURE__ */ React.createElement("div", {
    className: cn("".concat(prefixCls, "-nav-operations"), className),
    style: style2,
    ref
  }, moreNode, /* @__PURE__ */ React.createElement(AddButton$1, {
    prefixCls,
    locale: locale2,
    editable
  }));
}
var OperationNode$1 = /* @__PURE__ */ React.forwardRef(OperationNode);
var TabContext = /* @__PURE__ */ createContext2(null);
var MIN_SWIPE_DISTANCE = 0.1;
var STOP_SWIPE_DISTANCE = 0.01;
var REFRESH_INTERVAL$1 = 20;
var SPEED_OFF_MULTIPLE = Math.pow(0.995, REFRESH_INTERVAL$1);
function useTouchMove(ref, onOffset) {
  var _useState = useState2(), _useState2 = _slicedToArray$3(_useState, 2), touchPosition = _useState2[0], setTouchPosition = _useState2[1];
  var _useState3 = useState2(0), _useState4 = _slicedToArray$3(_useState3, 2), lastTimestamp = _useState4[0], setLastTimestamp = _useState4[1];
  var _useState5 = useState2(0), _useState6 = _slicedToArray$3(_useState5, 2), lastTimeDiff = _useState6[0], setLastTimeDiff = _useState6[1];
  var _useState7 = useState2(), _useState8 = _slicedToArray$3(_useState7, 2), lastOffset = _useState8[0], setLastOffset = _useState8[1];
  var motionRef = useRef2();
  function onTouchStart(e3) {
    var _e$touches$ = e3.touches[0], screenX = _e$touches$.screenX, screenY = _e$touches$.screenY;
    setTouchPosition({
      x: screenX,
      y: screenY
    });
    window.clearInterval(motionRef.current);
  }
  function onTouchMove(e3) {
    if (!touchPosition)
      return;
    e3.preventDefault();
    var _e$touches$2 = e3.touches[0], screenX = _e$touches$2.screenX, screenY = _e$touches$2.screenY;
    setTouchPosition({
      x: screenX,
      y: screenY
    });
    var offsetX = screenX - touchPosition.x;
    var offsetY = screenY - touchPosition.y;
    onOffset(offsetX, offsetY);
    var now2 = Date.now();
    setLastTimestamp(now2);
    setLastTimeDiff(now2 - lastTimestamp);
    setLastOffset({
      x: offsetX,
      y: offsetY
    });
  }
  function onTouchEnd() {
    if (!touchPosition)
      return;
    setTouchPosition(null);
    setLastOffset(null);
    if (lastOffset) {
      var distanceX = lastOffset.x / lastTimeDiff;
      var distanceY = lastOffset.y / lastTimeDiff;
      var absX = Math.abs(distanceX);
      var absY = Math.abs(distanceY);
      if (Math.max(absX, absY) < MIN_SWIPE_DISTANCE)
        return;
      var currentX = distanceX;
      var currentY = distanceY;
      motionRef.current = window.setInterval(function() {
        if (Math.abs(currentX) < STOP_SWIPE_DISTANCE && Math.abs(currentY) < STOP_SWIPE_DISTANCE) {
          window.clearInterval(motionRef.current);
          return;
        }
        currentX *= SPEED_OFF_MULTIPLE;
        currentY *= SPEED_OFF_MULTIPLE;
        onOffset(currentX * REFRESH_INTERVAL$1, currentY * REFRESH_INTERVAL$1);
      }, REFRESH_INTERVAL$1);
    }
  }
  var lastWheelDirectionRef = useRef2();
  function onWheel(e3) {
    var deltaX = e3.deltaX, deltaY = e3.deltaY;
    var mixed = 0;
    var absX = Math.abs(deltaX);
    var absY = Math.abs(deltaY);
    if (absX === absY) {
      mixed = lastWheelDirectionRef.current === "x" ? deltaX : deltaY;
    } else if (absX > absY) {
      mixed = deltaX;
      lastWheelDirectionRef.current = "x";
    } else {
      mixed = deltaY;
      lastWheelDirectionRef.current = "y";
    }
    if (onOffset(-mixed, -mixed)) {
      e3.preventDefault();
    }
  }
  var touchEventsRef = useRef2(null);
  touchEventsRef.current = {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    onWheel
  };
  React.useEffect(function() {
    function onProxyTouchStart(e3) {
      touchEventsRef.current.onTouchStart(e3);
    }
    function onProxyTouchMove(e3) {
      touchEventsRef.current.onTouchMove(e3);
    }
    function onProxyTouchEnd(e3) {
      touchEventsRef.current.onTouchEnd(e3);
    }
    function onProxyWheel(e3) {
      touchEventsRef.current.onWheel(e3);
    }
    document.addEventListener("touchmove", onProxyTouchMove, {
      passive: false
    });
    document.addEventListener("touchend", onProxyTouchEnd, {
      passive: false
    });
    ref.current.addEventListener("touchstart", onProxyTouchStart, {
      passive: false
    });
    ref.current.addEventListener("wheel", onProxyWheel);
    return function() {
      document.removeEventListener("touchmove", onProxyTouchMove);
      document.removeEventListener("touchend", onProxyTouchEnd);
    };
  }, []);
}
function useRefs() {
  var cacheRefs = useRef2(/* @__PURE__ */ new Map());
  function getRef(key2) {
    if (!cacheRefs.current.has(key2)) {
      cacheRefs.current.set(key2, /* @__PURE__ */ React.createRef());
    }
    return cacheRefs.current.get(key2);
  }
  function removeRef(key2) {
    cacheRefs.current.delete(key2);
  }
  return [getRef, removeRef];
}
function useSyncState(defaultState, onChange4) {
  var stateRef = React.useRef(defaultState);
  var _React$useState = React.useState({}), _React$useState2 = _slicedToArray$3(_React$useState, 2), forceUpdate = _React$useState2[1];
  function setState(updater) {
    var newValue = typeof updater === "function" ? updater(stateRef.current) : updater;
    if (newValue !== stateRef.current) {
      onChange4(newValue, stateRef.current);
    }
    stateRef.current = newValue;
    forceUpdate({});
  }
  return [stateRef.current, setState];
}
var ExtraContent = function ExtraContent2(_ref) {
  var position = _ref.position, prefixCls = _ref.prefixCls, extra = _ref.extra;
  if (!extra)
    return null;
  var content;
  var assertExtra = extra;
  if (position === "right") {
    content = assertExtra.right || !assertExtra.left && assertExtra || null;
  }
  if (position === "left") {
    content = assertExtra.left || null;
  }
  return content ? /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-extra-content")
  }, content) : null;
};
function TabNavList(props, ref) {
  var _classNames;
  var _React$useContext = React.useContext(TabContext), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
  var className = props.className, style2 = props.style, id2 = props.id, animated = props.animated, activeKey = props.activeKey, rtl2 = props.rtl, extra = props.extra, editable = props.editable, locale2 = props.locale, tabPosition = props.tabPosition, tabBarGutter = props.tabBarGutter, children = props.children, onTabClick = props.onTabClick, onTabScroll = props.onTabScroll;
  var tabsWrapperRef = useRef2();
  var tabListRef = useRef2();
  var operationsRef = useRef2();
  var innerAddButtonRef = useRef2();
  var _useRefs = useRefs(), _useRefs2 = _slicedToArray$3(_useRefs, 2), getBtnRef = _useRefs2[0], removeBtnRef = _useRefs2[1];
  var tabPositionTopOrBottom = tabPosition === "top" || tabPosition === "bottom";
  var _useSyncState = useSyncState(0, function(next, prev) {
    if (tabPositionTopOrBottom && onTabScroll) {
      onTabScroll({
        direction: next > prev ? "left" : "right"
      });
    }
  }), _useSyncState2 = _slicedToArray$3(_useSyncState, 2), transformLeft = _useSyncState2[0], setTransformLeft = _useSyncState2[1];
  var _useSyncState3 = useSyncState(0, function(next, prev) {
    if (!tabPositionTopOrBottom && onTabScroll) {
      onTabScroll({
        direction: next > prev ? "top" : "bottom"
      });
    }
  }), _useSyncState4 = _slicedToArray$3(_useSyncState3, 2), transformTop = _useSyncState4[0], setTransformTop = _useSyncState4[1];
  var _useState = useState2(0), _useState2 = _slicedToArray$3(_useState, 2), wrapperScrollWidth = _useState2[0], setWrapperScrollWidth = _useState2[1];
  var _useState3 = useState2(0), _useState4 = _slicedToArray$3(_useState3, 2), wrapperScrollHeight = _useState4[0], setWrapperScrollHeight = _useState4[1];
  var _useState5 = useState2(0), _useState6 = _slicedToArray$3(_useState5, 2), wrapperContentWidth = _useState6[0], setWrapperContentWidth = _useState6[1];
  var _useState7 = useState2(0), _useState8 = _slicedToArray$3(_useState7, 2), wrapperContentHeight = _useState8[0], setWrapperContentHeight = _useState8[1];
  var _useState9 = useState2(null), _useState10 = _slicedToArray$3(_useState9, 2), wrapperWidth = _useState10[0], setWrapperWidth = _useState10[1];
  var _useState11 = useState2(null), _useState12 = _slicedToArray$3(_useState11, 2), wrapperHeight = _useState12[0], setWrapperHeight = _useState12[1];
  var _useState13 = useState2(0), _useState14 = _slicedToArray$3(_useState13, 2), addWidth = _useState14[0], setAddWidth = _useState14[1];
  var _useState15 = useState2(0), _useState16 = _slicedToArray$3(_useState15, 2), addHeight = _useState16[0], setAddHeight = _useState16[1];
  var _useRafState = useRafState(/* @__PURE__ */ new Map()), _useRafState2 = _slicedToArray$3(_useRafState, 2), tabSizes = _useRafState2[0], setTabSizes = _useRafState2[1];
  var tabOffsets = useOffsets(tabs, tabSizes, wrapperScrollWidth);
  var operationsHiddenClassName = "".concat(prefixCls, "-nav-operations-hidden");
  var transformMin = 0;
  var transformMax = 0;
  if (!tabPositionTopOrBottom) {
    transformMin = Math.min(0, wrapperHeight - wrapperScrollHeight);
    transformMax = 0;
  } else if (rtl2) {
    transformMin = 0;
    transformMax = Math.max(0, wrapperScrollWidth - wrapperWidth);
  } else {
    transformMin = Math.min(0, wrapperWidth - wrapperScrollWidth);
    transformMax = 0;
  }
  function alignInRange(value) {
    if (value < transformMin) {
      return transformMin;
    }
    if (value > transformMax) {
      return transformMax;
    }
    return value;
  }
  var touchMovingRef = useRef2();
  var _useState17 = useState2(), _useState18 = _slicedToArray$3(_useState17, 2), lockAnimation = _useState18[0], setLockAnimation = _useState18[1];
  function doLockAnimation() {
    setLockAnimation(Date.now());
  }
  function clearTouchMoving() {
    window.clearTimeout(touchMovingRef.current);
  }
  useTouchMove(tabsWrapperRef, function(offsetX, offsetY) {
    function doMove(setState, offset3) {
      setState(function(value) {
        var newValue = alignInRange(value + offset3);
        return newValue;
      });
    }
    if (tabPositionTopOrBottom) {
      if (wrapperWidth >= wrapperScrollWidth) {
        return false;
      }
      doMove(setTransformLeft, offsetX);
    } else {
      if (wrapperHeight >= wrapperScrollHeight) {
        return false;
      }
      doMove(setTransformTop, offsetY);
    }
    clearTouchMoving();
    doLockAnimation();
    return true;
  });
  useEffect2(function() {
    clearTouchMoving();
    if (lockAnimation) {
      touchMovingRef.current = window.setTimeout(function() {
        setLockAnimation(0);
      }, 100);
    }
    return clearTouchMoving;
  }, [lockAnimation]);
  function scrollToTab() {
    var key2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : activeKey;
    var tabOffset = tabOffsets.get(key2) || {
      width: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0
    };
    if (tabPositionTopOrBottom) {
      var newTransform = transformLeft;
      if (rtl2) {
        if (tabOffset.right < transformLeft) {
          newTransform = tabOffset.right;
        } else if (tabOffset.right + tabOffset.width > transformLeft + wrapperWidth) {
          newTransform = tabOffset.right + tabOffset.width - wrapperWidth;
        }
      } else if (tabOffset.left < -transformLeft) {
        newTransform = -tabOffset.left;
      } else if (tabOffset.left + tabOffset.width > -transformLeft + wrapperWidth) {
        newTransform = -(tabOffset.left + tabOffset.width - wrapperWidth);
      }
      setTransformTop(0);
      setTransformLeft(alignInRange(newTransform));
    } else {
      var _newTransform = transformTop;
      if (tabOffset.top < -transformTop) {
        _newTransform = -tabOffset.top;
      } else if (tabOffset.top + tabOffset.height > -transformTop + wrapperHeight) {
        _newTransform = -(tabOffset.top + tabOffset.height - wrapperHeight);
      }
      setTransformLeft(0);
      setTransformTop(alignInRange(_newTransform));
    }
  }
  var _useVisibleRange = useVisibleRange(tabOffsets, {
    width: wrapperWidth,
    height: wrapperHeight,
    left: transformLeft,
    top: transformTop
  }, {
    width: wrapperContentWidth,
    height: wrapperContentHeight
  }, {
    width: addWidth,
    height: addHeight
  }, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    tabs
  })), _useVisibleRange2 = _slicedToArray$3(_useVisibleRange, 2), visibleStart = _useVisibleRange2[0], visibleEnd = _useVisibleRange2[1];
  var tabNodes = tabs.map(function(tab) {
    var key2 = tab.key;
    return /* @__PURE__ */ React.createElement(TabNode$1, {
      id: id2,
      prefixCls,
      key: key2,
      rtl: rtl2,
      tab,
      closable: tab.closable,
      editable,
      active: key2 === activeKey,
      tabPosition,
      tabBarGutter,
      renderWrapper: children,
      removeAriaLabel: locale2 === null || locale2 === void 0 ? void 0 : locale2.removeAriaLabel,
      ref: getBtnRef(key2),
      onClick: function onClick(e3) {
        onTabClick(key2, e3);
      },
      onRemove: function onRemove() {
        removeBtnRef(key2);
      },
      onFocus: function onFocus2() {
        scrollToTab(key2);
        doLockAnimation();
        if (!rtl2) {
          tabsWrapperRef.current.scrollLeft = 0;
        }
        tabsWrapperRef.current.scrollTop = 0;
      }
    });
  });
  var onListHolderResize = useRaf(function() {
    var _tabsWrapperRef$curre, _tabsWrapperRef$curre2, _innerAddButtonRef$cu, _innerAddButtonRef$cu2, _operationsRef$curren, _operationsRef$curren2, _tabListRef$current, _tabListRef$current2, _operationsRef$curren3;
    var offsetWidth = ((_tabsWrapperRef$curre = tabsWrapperRef.current) === null || _tabsWrapperRef$curre === void 0 ? void 0 : _tabsWrapperRef$curre.offsetWidth) || 0;
    var offsetHeight = ((_tabsWrapperRef$curre2 = tabsWrapperRef.current) === null || _tabsWrapperRef$curre2 === void 0 ? void 0 : _tabsWrapperRef$curre2.offsetHeight) || 0;
    var newAddWidth = ((_innerAddButtonRef$cu = innerAddButtonRef.current) === null || _innerAddButtonRef$cu === void 0 ? void 0 : _innerAddButtonRef$cu.offsetWidth) || 0;
    var newAddHeight = ((_innerAddButtonRef$cu2 = innerAddButtonRef.current) === null || _innerAddButtonRef$cu2 === void 0 ? void 0 : _innerAddButtonRef$cu2.offsetHeight) || 0;
    var newOperationWidth = ((_operationsRef$curren = operationsRef.current) === null || _operationsRef$curren === void 0 ? void 0 : _operationsRef$curren.offsetWidth) || 0;
    var newOperationHeight = ((_operationsRef$curren2 = operationsRef.current) === null || _operationsRef$curren2 === void 0 ? void 0 : _operationsRef$curren2.offsetHeight) || 0;
    setWrapperWidth(offsetWidth);
    setWrapperHeight(offsetHeight);
    setAddWidth(newAddWidth);
    setAddHeight(newAddHeight);
    var newWrapperScrollWidth = (((_tabListRef$current = tabListRef.current) === null || _tabListRef$current === void 0 ? void 0 : _tabListRef$current.offsetWidth) || 0) - newAddWidth;
    var newWrapperScrollHeight = (((_tabListRef$current2 = tabListRef.current) === null || _tabListRef$current2 === void 0 ? void 0 : _tabListRef$current2.offsetHeight) || 0) - newAddHeight;
    setWrapperScrollWidth(newWrapperScrollWidth);
    setWrapperScrollHeight(newWrapperScrollHeight);
    var isOperationHidden = (_operationsRef$curren3 = operationsRef.current) === null || _operationsRef$curren3 === void 0 ? void 0 : _operationsRef$curren3.className.includes(operationsHiddenClassName);
    setWrapperContentWidth(newWrapperScrollWidth - (isOperationHidden ? 0 : newOperationWidth));
    setWrapperContentHeight(newWrapperScrollHeight - (isOperationHidden ? 0 : newOperationHeight));
    setTabSizes(function() {
      var newSizes = /* @__PURE__ */ new Map();
      tabs.forEach(function(_ref2) {
        var key2 = _ref2.key;
        var btnNode = getBtnRef(key2).current;
        if (btnNode) {
          newSizes.set(key2, {
            width: btnNode.offsetWidth,
            height: btnNode.offsetHeight,
            left: btnNode.offsetLeft,
            top: btnNode.offsetTop
          });
        }
      });
      return newSizes;
    });
  });
  var startHiddenTabs = tabs.slice(0, visibleStart);
  var endHiddenTabs = tabs.slice(visibleEnd + 1);
  var hiddenTabs = [].concat(_toConsumableArray(startHiddenTabs), _toConsumableArray(endHiddenTabs));
  var _useState19 = useState2(), _useState20 = _slicedToArray$3(_useState19, 2), inkStyle = _useState20[0], setInkStyle = _useState20[1];
  var activeTabOffset = tabOffsets.get(activeKey);
  var inkBarRafRef = useRef2();
  function cleanInkBarRaf() {
    wrapperRaf$1.cancel(inkBarRafRef.current);
  }
  useEffect2(function() {
    var newInkStyle = {};
    if (activeTabOffset) {
      if (tabPositionTopOrBottom) {
        if (rtl2) {
          newInkStyle.right = activeTabOffset.right;
        } else {
          newInkStyle.left = activeTabOffset.left;
        }
        newInkStyle.width = activeTabOffset.width;
      } else {
        newInkStyle.top = activeTabOffset.top;
        newInkStyle.height = activeTabOffset.height;
      }
    }
    cleanInkBarRaf();
    inkBarRafRef.current = wrapperRaf$1(function() {
      setInkStyle(newInkStyle);
    });
    return cleanInkBarRaf;
  }, [activeTabOffset, tabPositionTopOrBottom, rtl2]);
  useEffect2(function() {
    scrollToTab();
  }, [activeKey, activeTabOffset, tabOffsets, tabPositionTopOrBottom]);
  useEffect2(function() {
    onListHolderResize();
  }, [rtl2, tabBarGutter, activeKey, tabs.map(function(tab) {
    return tab.key;
  }).join("_")]);
  var hasDropdown = !!hiddenTabs.length;
  var wrapPrefix = "".concat(prefixCls, "-nav-wrap");
  var pingLeft;
  var pingRight;
  var pingTop;
  var pingBottom;
  if (tabPositionTopOrBottom) {
    if (rtl2) {
      pingRight = transformLeft > 0;
      pingLeft = transformLeft + wrapperWidth < wrapperScrollWidth;
    } else {
      pingLeft = transformLeft < 0;
      pingRight = -transformLeft + wrapperWidth < wrapperScrollWidth;
    }
  } else {
    pingTop = transformTop < 0;
    pingBottom = -transformTop + wrapperHeight < wrapperScrollHeight;
  }
  return /* @__PURE__ */ React.createElement("div", {
    ref,
    role: "tablist",
    className: cn("".concat(prefixCls, "-nav"), className),
    style: style2,
    onKeyDown: function onKeyDown2() {
      doLockAnimation();
    }
  }, /* @__PURE__ */ React.createElement(ExtraContent, {
    position: "left",
    extra,
    prefixCls
  }), /* @__PURE__ */ React.createElement(ResizeObserver, {
    onResize: onListHolderResize
  }, /* @__PURE__ */ React.createElement("div", {
    className: cn(wrapPrefix, (_classNames = {}, _defineProperty$4(_classNames, "".concat(wrapPrefix, "-ping-left"), pingLeft), _defineProperty$4(_classNames, "".concat(wrapPrefix, "-ping-right"), pingRight), _defineProperty$4(_classNames, "".concat(wrapPrefix, "-ping-top"), pingTop), _defineProperty$4(_classNames, "".concat(wrapPrefix, "-ping-bottom"), pingBottom), _classNames)),
    ref: tabsWrapperRef
  }, /* @__PURE__ */ React.createElement(ResizeObserver, {
    onResize: onListHolderResize
  }, /* @__PURE__ */ React.createElement("div", {
    ref: tabListRef,
    className: "".concat(prefixCls, "-nav-list"),
    style: {
      transform: "translate(".concat(transformLeft, "px, ").concat(transformTop, "px)"),
      transition: lockAnimation ? "none" : void 0
    }
  }, tabNodes, /* @__PURE__ */ React.createElement(AddButton$1, {
    ref: innerAddButtonRef,
    prefixCls,
    locale: locale2,
    editable,
    style: {
      visibility: hasDropdown ? "hidden" : null
    }
  }), /* @__PURE__ */ React.createElement("div", {
    className: cn("".concat(prefixCls, "-ink-bar"), _defineProperty$4({}, "".concat(prefixCls, "-ink-bar-animated"), animated.inkBar)),
    style: inkStyle
  }))))), /* @__PURE__ */ React.createElement(OperationNode$1, _extends$2({}, props, {
    ref: operationsRef,
    prefixCls,
    tabs: hiddenTabs,
    className: !hasDropdown && operationsHiddenClassName
  })), /* @__PURE__ */ React.createElement(ExtraContent, {
    position: "right",
    extra,
    prefixCls
  }));
}
var TabNavList$1 = /* @__PURE__ */ React.forwardRef(TabNavList);
function TabPanelList(_ref) {
  var id2 = _ref.id, activeKey = _ref.activeKey, animated = _ref.animated, tabPosition = _ref.tabPosition, rtl2 = _ref.rtl, destroyInactiveTabPane = _ref.destroyInactiveTabPane;
  var _React$useContext = React.useContext(TabContext), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
  var tabPaneAnimated = animated.tabPane;
  var activeIndex = tabs.findIndex(function(tab) {
    return tab.key === activeKey;
  });
  return /* @__PURE__ */ React.createElement("div", {
    className: cn("".concat(prefixCls, "-content-holder"))
  }, /* @__PURE__ */ React.createElement("div", {
    className: cn("".concat(prefixCls, "-content"), "".concat(prefixCls, "-content-").concat(tabPosition), _defineProperty$4({}, "".concat(prefixCls, "-content-animated"), tabPaneAnimated)),
    style: activeIndex && tabPaneAnimated ? _defineProperty$4({}, rtl2 ? "marginRight" : "marginLeft", "-".concat(activeIndex, "00%")) : null
  }, tabs.map(function(tab) {
    return /* @__PURE__ */ React.cloneElement(tab.node, {
      key: tab.key,
      prefixCls,
      tabKey: tab.key,
      id: id2,
      animated: tabPaneAnimated,
      active: tab.key === activeKey,
      destroyInactiveTabPane
    });
  })));
}
function TabPane(_ref) {
  var prefixCls = _ref.prefixCls, forceRender = _ref.forceRender, className = _ref.className, style2 = _ref.style, id2 = _ref.id, active = _ref.active, animated = _ref.animated, destroyInactiveTabPane = _ref.destroyInactiveTabPane, tabKey = _ref.tabKey, children = _ref.children;
  var _React$useState = React.useState(forceRender), _React$useState2 = _slicedToArray$3(_React$useState, 2), visited = _React$useState2[0], setVisited = _React$useState2[1];
  React.useEffect(function() {
    if (active) {
      setVisited(true);
    } else if (destroyInactiveTabPane) {
      setVisited(false);
    }
  }, [active, destroyInactiveTabPane]);
  var mergedStyle = {};
  if (!active) {
    if (animated) {
      mergedStyle.visibility = "hidden";
      mergedStyle.height = 0;
      mergedStyle.overflowY = "hidden";
    } else {
      mergedStyle.display = "none";
    }
  }
  return /* @__PURE__ */ React.createElement("div", {
    id: id2 && "".concat(id2, "-panel-").concat(tabKey),
    role: "tabpanel",
    tabIndex: active ? 0 : -1,
    "aria-labelledby": id2 && "".concat(id2, "-tab-").concat(tabKey),
    "aria-hidden": !active,
    style: _objectSpread2$1(_objectSpread2$1({}, mergedStyle), style2),
    className: cn("".concat(prefixCls, "-tabpane"), active && "".concat(prefixCls, "-tabpane-active"), className)
  }, (active || visited || forceRender) && children);
}
var uuid$1 = 0;
function parseTabList(children) {
  return toArray$8(children).map(function(node) {
    if (/* @__PURE__ */ React.isValidElement(node)) {
      var key2 = node.key !== void 0 ? String(node.key) : void 0;
      return _objectSpread2$1(_objectSpread2$1({
        key: key2
      }, node.props), {}, {
        node
      });
    }
    return null;
  }).filter(function(tab) {
    return tab;
  });
}
function Tabs(_ref, ref) {
  var _classNames;
  var id2 = _ref.id, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-tabs" : _ref$prefixCls, className = _ref.className, children = _ref.children, direction = _ref.direction, activeKey = _ref.activeKey, defaultActiveKey = _ref.defaultActiveKey, editable = _ref.editable, _ref$animated = _ref.animated, animated = _ref$animated === void 0 ? {
    inkBar: true,
    tabPane: false
  } : _ref$animated, _ref$tabPosition = _ref.tabPosition, tabPosition = _ref$tabPosition === void 0 ? "top" : _ref$tabPosition, tabBarGutter = _ref.tabBarGutter, tabBarStyle = _ref.tabBarStyle, tabBarExtraContent = _ref.tabBarExtraContent, locale2 = _ref.locale, moreIcon = _ref.moreIcon, moreTransitionName = _ref.moreTransitionName, destroyInactiveTabPane = _ref.destroyInactiveTabPane, renderTabBar = _ref.renderTabBar, onChange4 = _ref.onChange, onTabClick = _ref.onTabClick, onTabScroll = _ref.onTabScroll, restProps = _objectWithoutProperties$1(_ref, ["id", "prefixCls", "className", "children", "direction", "activeKey", "defaultActiveKey", "editable", "animated", "tabPosition", "tabBarGutter", "tabBarStyle", "tabBarExtraContent", "locale", "moreIcon", "moreTransitionName", "destroyInactiveTabPane", "renderTabBar", "onChange", "onTabClick", "onTabScroll"]);
  var tabs = parseTabList(children);
  var rtl2 = direction === "rtl";
  var mergedAnimated;
  if (animated === false) {
    mergedAnimated = {
      inkBar: false,
      tabPane: false
    };
  } else if (animated === true) {
    mergedAnimated = {
      inkBar: true,
      tabPane: true
    };
  } else {
    mergedAnimated = _objectSpread2$1({
      inkBar: true,
      tabPane: false
    }, _typeof$5(animated) === "object" ? animated : {});
  }
  var _useState = useState2(false), _useState2 = _slicedToArray$3(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
  useEffect2(function() {
    setMobile(isMobile$1());
  }, []);
  var _useMergedState = useMergedState(function() {
    var _tabs$;
    return (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key;
  }, {
    value: activeKey,
    defaultValue: defaultActiveKey
  }), _useMergedState2 = _slicedToArray$3(_useMergedState, 2), mergedActiveKey = _useMergedState2[0], setMergedActiveKey = _useMergedState2[1];
  var _useState3 = useState2(function() {
    return tabs.findIndex(function(tab) {
      return tab.key === mergedActiveKey;
    });
  }), _useState4 = _slicedToArray$3(_useState3, 2), activeIndex = _useState4[0], setActiveIndex = _useState4[1];
  useEffect2(function() {
    var newActiveIndex = tabs.findIndex(function(tab) {
      return tab.key === mergedActiveKey;
    });
    if (newActiveIndex === -1) {
      var _tabs$newActiveIndex;
      newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
      setMergedActiveKey((_tabs$newActiveIndex = tabs[newActiveIndex]) === null || _tabs$newActiveIndex === void 0 ? void 0 : _tabs$newActiveIndex.key);
    }
    setActiveIndex(newActiveIndex);
  }, [tabs.map(function(tab) {
    return tab.key;
  }).join("_"), mergedActiveKey, activeIndex]);
  var _useMergedState3 = useMergedState(null, {
    value: id2
  }), _useMergedState4 = _slicedToArray$3(_useMergedState3, 2), mergedId = _useMergedState4[0], setMergedId = _useMergedState4[1];
  var mergedTabPosition = tabPosition;
  if (mobile && !["left", "right"].includes(tabPosition)) {
    mergedTabPosition = "top";
  }
  useEffect2(function() {
    if (!id2) {
      setMergedId("rc-tabs-".concat(process.env.NODE_ENV === "test" ? "test" : uuid$1));
      uuid$1 += 1;
    }
  }, []);
  function onInternalTabClick(key2, e3) {
    onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(key2, e3);
    setMergedActiveKey(key2);
    onChange4 === null || onChange4 === void 0 ? void 0 : onChange4(key2);
  }
  var sharedProps = {
    id: mergedId,
    activeKey: mergedActiveKey,
    animated: mergedAnimated,
    tabPosition: mergedTabPosition,
    rtl: rtl2,
    mobile
  };
  var tabNavBar;
  var tabNavBarProps = _objectSpread2$1(_objectSpread2$1({}, sharedProps), {}, {
    editable,
    locale: locale2,
    moreIcon,
    moreTransitionName,
    tabBarGutter,
    onTabClick: onInternalTabClick,
    onTabScroll,
    extra: tabBarExtraContent,
    style: tabBarStyle,
    panes: children
  });
  if (renderTabBar) {
    tabNavBar = renderTabBar(tabNavBarProps, TabNavList$1);
  } else {
    tabNavBar = /* @__PURE__ */ React.createElement(TabNavList$1, tabNavBarProps);
  }
  return /* @__PURE__ */ React.createElement(TabContext.Provider, {
    value: {
      tabs,
      prefixCls
    }
  }, /* @__PURE__ */ React.createElement("div", _extends$2({
    ref,
    id: id2,
    className: cn(prefixCls, "".concat(prefixCls, "-").concat(mergedTabPosition), (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-mobile"), mobile), _defineProperty$4(_classNames, "".concat(prefixCls, "-editable"), editable), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), rtl2), _classNames), className)
  }, restProps), tabNavBar, /* @__PURE__ */ React.createElement(TabPanelList, _extends$2({
    destroyInactiveTabPane
  }, sharedProps, {
    animated: mergedAnimated
  }))));
}
var ForwardTabs = /* @__PURE__ */ React.forwardRef(Tabs);
ForwardTabs.TabPane = TabPane;
var PlusOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { "tag": "path", "attrs": { "d": "M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z" } }] }, "name": "plus", "theme": "outlined" };
var PlusOutlined = function PlusOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: PlusOutlined$1
  }));
};
PlusOutlined.displayName = "PlusOutlined";
var RowContext = /* @__PURE__ */ createContext2({});
var canUseDocElement = function canUseDocElement2() {
  return canUseDom() && window.document.documentElement;
};
var isStyleSupport = function isStyleSupport2(styleName) {
  if (canUseDocElement()) {
    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
    var documentElement = window.document.documentElement;
    return styleNameList.some(function(name) {
      return name in documentElement.style;
    });
  }
  return false;
};
var flexGapSupported;
var detectFlexGapSupported = function detectFlexGapSupported2() {
  if (!canUseDocElement()) {
    return false;
  }
  if (flexGapSupported !== void 0) {
    return flexGapSupported;
  }
  var flex = document.createElement("div");
  flex.style.display = "flex";
  flex.style.flexDirection = "column";
  flex.style.rowGap = "1px";
  flex.appendChild(document.createElement("div"));
  flex.appendChild(document.createElement("div"));
  document.body.appendChild(flex);
  flexGapSupported = flex.scrollHeight === 1;
  document.body.removeChild(flex);
  return flexGapSupported;
};
var useFlexGapSupport = function() {
  var _React$useState = React.useState(false), _React$useState2 = _slicedToArray$3(_React$useState, 2), flexible = _React$useState2[0], setFlexible = _React$useState2[1];
  React.useEffect(function() {
    setFlexible(detectFlexGapSupported());
  }, []);
  return flexible;
};
var __rest$z = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
tuple$1("top", "middle", "bottom", "stretch");
tuple$1("start", "end", "center", "space-around", "space-between");
var Row$1 = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var _classNames;
  var customizePrefixCls = props.prefixCls, justify = props.justify, align = props.align, className = props.className, style2 = props.style, children = props.children, _props$gutter = props.gutter, gutter = _props$gutter === void 0 ? 0 : _props$gutter, wrap = props.wrap, others = __rest$z(props, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var _React$useState = React.useState({
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
    xxl: true
  }), _React$useState2 = _slicedToArray$3(_React$useState, 2), screens2 = _React$useState2[0], setScreens = _React$useState2[1];
  var supportFlexGap = useFlexGapSupport();
  var gutterRef = React.useRef(gutter);
  React.useEffect(function() {
    var token = responsiveObserve.subscribe(function(screen) {
      var currentGutter = gutterRef.current || 0;
      if (!Array.isArray(currentGutter) && _typeof$5(currentGutter) === "object" || Array.isArray(currentGutter) && (_typeof$5(currentGutter[0]) === "object" || _typeof$5(currentGutter[1]) === "object")) {
        setScreens(screen);
      }
    });
    return function() {
      return responsiveObserve.unsubscribe(token);
    };
  }, []);
  var getGutter = function getGutter2() {
    var results = [0, 0];
    var normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
    normalizedGutter.forEach(function(g2, index2) {
      if (_typeof$5(g2) === "object") {
        for (var i2 = 0; i2 < responsiveArray.length; i2++) {
          var breakpoint = responsiveArray[i2];
          if (screens2[breakpoint] && g2[breakpoint] !== void 0) {
            results[index2] = g2[breakpoint];
            break;
          }
        }
      } else {
        results[index2] = g2 || 0;
      }
    });
    return results;
  };
  var prefixCls = getPrefixCls("row", customizePrefixCls);
  var gutters = getGutter();
  var classes = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-no-wrap"), wrap === false), _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(justify), justify), _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(align), align), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
  var rowStyle = {};
  var horizontalGutter = gutters[0] > 0 ? gutters[0] / -2 : void 0;
  var verticalGutter = gutters[1] > 0 ? gutters[1] / -2 : void 0;
  if (horizontalGutter) {
    rowStyle.marginLeft = horizontalGutter;
    rowStyle.marginRight = horizontalGutter;
  }
  if (supportFlexGap) {
    var _gutters = _slicedToArray$3(gutters, 2);
    rowStyle.rowGap = _gutters[1];
  } else if (verticalGutter) {
    rowStyle.marginTop = verticalGutter;
    rowStyle.marginBottom = verticalGutter;
  }
  var rowContext = React.useMemo(function() {
    return {
      gutter: gutters,
      wrap,
      supportFlexGap
    };
  }, [gutters, wrap, supportFlexGap]);
  return /* @__PURE__ */ React.createElement(RowContext.Provider, {
    value: rowContext
  }, /* @__PURE__ */ React.createElement("div", _extends$2({}, others, {
    className: classes,
    style: _extends$2(_extends$2({}, rowStyle), style2),
    ref
  }), children));
});
Row$1.displayName = "Row";
var __rest$y = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
function parseFlex(flex) {
  if (typeof flex === "number") {
    return "".concat(flex, " ").concat(flex, " auto");
  }
  if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
    return "0 0 ".concat(flex);
  }
  return flex;
}
var sizes = ["xs", "sm", "md", "lg", "xl", "xxl"];
var Col = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var _classNames;
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var _React$useContext2 = React.useContext(RowContext), gutter = _React$useContext2.gutter, wrap = _React$useContext2.wrap, supportFlexGap = _React$useContext2.supportFlexGap;
  var customizePrefixCls = props.prefixCls, span = props.span, order = props.order, offset3 = props.offset, push = props.push, pull = props.pull, className = props.className, children = props.children, flex = props.flex, style2 = props.style, others = __rest$y(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]);
  var prefixCls = getPrefixCls("col", customizePrefixCls);
  var sizeClassObj = {};
  sizes.forEach(function(size) {
    var _extends2;
    var sizeProps = {};
    var propSize = props[size];
    if (typeof propSize === "number") {
      sizeProps.span = propSize;
    } else if (_typeof$5(propSize) === "object") {
      sizeProps = propSize || {};
    }
    delete others[size];
    sizeClassObj = _extends$2(_extends$2({}, sizeClassObj), (_extends2 = {}, _defineProperty$4(_extends2, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== void 0), _defineProperty$4(_extends2, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), _defineProperty$4(_extends2, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), _defineProperty$4(_extends2, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), _defineProperty$4(_extends2, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), _defineProperty$4(_extends2, "".concat(prefixCls, "-rtl"), direction === "rtl"), _extends2));
  });
  var classes = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(span), span !== void 0), _defineProperty$4(_classNames, "".concat(prefixCls, "-order-").concat(order), order), _defineProperty$4(_classNames, "".concat(prefixCls, "-offset-").concat(offset3), offset3), _defineProperty$4(_classNames, "".concat(prefixCls, "-push-").concat(push), push), _defineProperty$4(_classNames, "".concat(prefixCls, "-pull-").concat(pull), pull), _classNames), className, sizeClassObj);
  var mergedStyle = {};
  if (gutter && gutter[0] > 0) {
    var horizontalGutter = gutter[0] / 2;
    mergedStyle.paddingLeft = horizontalGutter;
    mergedStyle.paddingRight = horizontalGutter;
  }
  if (gutter && gutter[1] > 0 && !supportFlexGap) {
    var verticalGutter = gutter[1] / 2;
    mergedStyle.paddingTop = verticalGutter;
    mergedStyle.paddingBottom = verticalGutter;
  }
  if (flex) {
    mergedStyle.flex = parseFlex(flex);
    if (flex === "auto" && wrap === false && !mergedStyle.minWidth) {
      mergedStyle.minWidth = 0;
    }
  }
  return /* @__PURE__ */ React.createElement("div", _extends$2({}, others, {
    style: _extends$2(_extends$2({}, mergedStyle), style2),
    className: classes,
    ref
  }), children);
});
Col.displayName = "Col";
var PanelContent = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var _classnames;
  var prefixCls = props.prefixCls, forceRender = props.forceRender, className = props.className, style2 = props.style, children = props.children, isActive2 = props.isActive, role = props.role;
  var _React$useState = React.useState(isActive2 || forceRender), _React$useState2 = _slicedToArray$3(_React$useState, 2), rendered = _React$useState2[0], setRendered = _React$useState2[1];
  React.useEffect(function() {
    if (forceRender || isActive2) {
      setRendered(true);
    }
  }, [forceRender, isActive2]);
  if (!rendered) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", {
    ref,
    className: cn("".concat(prefixCls, "-content"), (_classnames = {}, _defineProperty$4(_classnames, "".concat(prefixCls, "-content-active"), isActive2), _defineProperty$4(_classnames, "".concat(prefixCls, "-content-inactive"), !isActive2), _classnames), className),
    style: style2,
    role
  }, /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-content-box")
  }, children));
});
PanelContent.displayName = "PanelContent";
var CollapsePanel$2 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(CollapsePanel2, _React$Component);
  var _super = _createSuper$1(CollapsePanel2);
  function CollapsePanel2() {
    var _this2;
    _classCallCheck$2(this, CollapsePanel2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super.call.apply(_super, [this].concat(args));
    _this2.handleItemClick = function() {
      var _this$props = _this2.props, onItemClick2 = _this$props.onItemClick, panelKey = _this$props.panelKey;
      if (typeof onItemClick2 === "function") {
        onItemClick2(panelKey);
      }
    };
    _this2.handleKeyPress = function(e3) {
      if (e3.key === "Enter" || e3.keyCode === 13 || e3.which === 13) {
        _this2.handleItemClick();
      }
    };
    return _this2;
  }
  _createClass$2(CollapsePanel2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !shallowequal(this.props, nextProps);
    }
  }, {
    key: "render",
    value: function render4() {
      var _classNames, _classNames2, _this2 = this;
      var _this$props2 = this.props, className = _this$props2.className, id2 = _this$props2.id, style2 = _this$props2.style, prefixCls = _this$props2.prefixCls, header = _this$props2.header, headerClass = _this$props2.headerClass, children = _this$props2.children, isActive2 = _this$props2.isActive, showArrow = _this$props2.showArrow, destroyInactivePanel = _this$props2.destroyInactivePanel, accordion = _this$props2.accordion, forceRender = _this$props2.forceRender, openMotion = _this$props2.openMotion, expandIcon = _this$props2.expandIcon, extra = _this$props2.extra, collapsible = _this$props2.collapsible;
      var disabled = collapsible === "disabled";
      var headerCls = cn("".concat(prefixCls, "-header"), (_classNames = {}, _defineProperty$4(_classNames, headerClass, headerClass), _defineProperty$4(_classNames, "".concat(prefixCls, "-header-collapsible-only"), collapsible === "header"), _classNames));
      var itemCls = cn((_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-item"), true), _defineProperty$4(_classNames2, "".concat(prefixCls, "-item-active"), isActive2), _defineProperty$4(_classNames2, "".concat(prefixCls, "-item-disabled"), disabled), _classNames2), className);
      var icon = /* @__PURE__ */ React.createElement("i", {
        className: "arrow"
      });
      if (showArrow && typeof expandIcon === "function") {
        icon = expandIcon(this.props);
      }
      var ifExtraExist = extra !== null && extra !== void 0 && typeof extra !== "boolean";
      return /* @__PURE__ */ React.createElement("div", {
        className: itemCls,
        style: style2,
        id: id2
      }, /* @__PURE__ */ React.createElement("div", {
        className: headerCls,
        onClick: function onClick() {
          return collapsible !== "header" && _this2.handleItemClick();
        },
        role: accordion ? "tab" : "button",
        tabIndex: disabled ? -1 : 0,
        "aria-expanded": isActive2,
        onKeyPress: this.handleKeyPress
      }, showArrow && icon, collapsible === "header" ? /* @__PURE__ */ React.createElement("span", {
        onClick: this.handleItemClick,
        className: "".concat(prefixCls, "-header-text")
      }, header) : header, ifExtraExist && /* @__PURE__ */ React.createElement("div", {
        className: "".concat(prefixCls, "-extra")
      }, extra)), /* @__PURE__ */ React.createElement(CSSMotion, _extends$2({
        visible: isActive2,
        leavedClassName: "".concat(prefixCls, "-content-hidden")
      }, openMotion, {
        forceRender,
        removeOnLeave: destroyInactivePanel
      }), function(_ref, ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /* @__PURE__ */ React.createElement(PanelContent, {
          ref,
          prefixCls,
          className: motionClassName,
          style: motionStyle,
          isActive: isActive2,
          forceRender,
          role: accordion ? "tabpanel" : null
        }, children);
      }));
    }
  }]);
  return CollapsePanel2;
}(React.Component);
CollapsePanel$2.defaultProps = {
  showArrow: true,
  isActive: false,
  onItemClick: function onItemClick() {
  },
  headerClass: "",
  forceRender: false
};
function getActiveKeysArray(activeKey) {
  var currentActiveKey = activeKey;
  if (!Array.isArray(currentActiveKey)) {
    var activeKeyType = _typeof$5(currentActiveKey);
    currentActiveKey = activeKeyType === "number" || activeKeyType === "string" ? [currentActiveKey] : [];
  }
  return currentActiveKey.map(function(key2) {
    return String(key2);
  });
}
var Collapse$2 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Collapse2, _React$Component);
  var _super = _createSuper$1(Collapse2);
  function Collapse2(_props) {
    var _this2;
    _classCallCheck$2(this, Collapse2);
    _this2 = _super.call(this, _props);
    _this2.onClickItem = function(key2) {
      var activeKey = _this2.state.activeKey;
      if (_this2.props.accordion) {
        activeKey = activeKey[0] === key2 ? [] : [key2];
      } else {
        activeKey = _toConsumableArray(activeKey);
        var index2 = activeKey.indexOf(key2);
        var isActive2 = index2 > -1;
        if (isActive2) {
          activeKey.splice(index2, 1);
        } else {
          activeKey.push(key2);
        }
      }
      _this2.setActiveKey(activeKey);
    };
    _this2.getNewChild = function(child, index2) {
      if (!child)
        return null;
      var activeKey = _this2.state.activeKey;
      var _this$props = _this2.props, prefixCls = _this$props.prefixCls, openMotion = _this$props.openMotion, accordion = _this$props.accordion, rootDestroyInactivePanel = _this$props.destroyInactivePanel, expandIcon = _this$props.expandIcon, collapsible = _this$props.collapsible;
      var key2 = child.key || String(index2);
      var _child$props = child.props, header = _child$props.header, headerClass = _child$props.headerClass, destroyInactivePanel = _child$props.destroyInactivePanel, childCollapsible = _child$props.collapsible;
      var isActive2 = false;
      if (accordion) {
        isActive2 = activeKey[0] === key2;
      } else {
        isActive2 = activeKey.indexOf(key2) > -1;
      }
      var mergeCollapsible = childCollapsible !== null && childCollapsible !== void 0 ? childCollapsible : collapsible;
      var props = {
        key: key2,
        panelKey: key2,
        header,
        headerClass,
        isActive: isActive2,
        prefixCls,
        destroyInactivePanel: destroyInactivePanel !== null && destroyInactivePanel !== void 0 ? destroyInactivePanel : rootDestroyInactivePanel,
        openMotion,
        accordion,
        children: child.props.children,
        onItemClick: mergeCollapsible === "disabled" ? null : _this2.onClickItem,
        expandIcon,
        collapsible: mergeCollapsible
      };
      if (typeof child.type === "string") {
        return child;
      }
      return /* @__PURE__ */ React.cloneElement(child, props);
    };
    _this2.getItems = function() {
      var children = _this2.props.children;
      return toArray$8(children).map(_this2.getNewChild);
    };
    _this2.setActiveKey = function(activeKey) {
      if (!("activeKey" in _this2.props)) {
        _this2.setState({
          activeKey
        });
      }
      _this2.props.onChange(_this2.props.accordion ? activeKey[0] : activeKey);
    };
    var _activeKey = _props.activeKey, defaultActiveKey = _props.defaultActiveKey;
    var currentActiveKey = defaultActiveKey;
    if ("activeKey" in _props) {
      currentActiveKey = _activeKey;
    }
    _this2.state = {
      activeKey: getActiveKeysArray(currentActiveKey)
    };
    return _this2;
  }
  _createClass$2(Collapse2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !shallowequal(this.props, nextProps) || !shallowequal(this.state, nextState);
    }
  }, {
    key: "render",
    value: function render4() {
      var _classNames;
      var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, style2 = _this$props2.style, accordion = _this$props2.accordion;
      var collapseClassName = cn((_classNames = {}, _defineProperty$4(_classNames, prefixCls, true), _defineProperty$4(_classNames, className, !!className), _classNames));
      return /* @__PURE__ */ React.createElement("div", {
        className: collapseClassName,
        style: style2,
        role: accordion ? "tablist" : null
      }, this.getItems());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var newState = {};
      if ("activeKey" in nextProps) {
        newState.activeKey = getActiveKeysArray(nextProps.activeKey);
      }
      return newState;
    }
  }]);
  return Collapse2;
}(React.Component);
Collapse$2.defaultProps = {
  prefixCls: "rc-collapse",
  onChange: function onChange2() {
  },
  accordion: false,
  destroyInactivePanel: false
};
Collapse$2.Panel = CollapsePanel$2;
Collapse$2.Panel;
var CollapsePanel$1 = function CollapsePanel(props) {
  devWarning(!("disabled" in props), "Collapse.Panel", '`disabled` is deprecated. Please use `collapsible="disabled"` instead.');
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
  var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow;
  var prefixCls = getPrefixCls("collapse", customizePrefixCls);
  var collapsePanelClassName = cn(_defineProperty$4({}, "".concat(prefixCls, "-no-arrow"), !showArrow), className);
  return /* @__PURE__ */ React.createElement(Collapse$2.Panel, _extends$2({}, props, {
    prefixCls,
    className: collapsePanelClassName
  }));
};
var Collapse$1 = function Collapse(props) {
  var _classNames;
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, ghost = props.ghost;
  var prefixCls = getPrefixCls("collapse", customizePrefixCls);
  var getIconPosition = function getIconPosition2() {
    var expandIconPosition = props.expandIconPosition;
    if (expandIconPosition !== void 0) {
      return expandIconPosition;
    }
    return direction === "rtl" ? "right" : "left";
  };
  var renderExpandIcon = function renderExpandIcon2() {
    var panelProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var expandIcon = props.expandIcon;
    var icon = expandIcon ? expandIcon(panelProps) : /* @__PURE__ */ React.createElement(RightOutlined$1, {
      rotate: panelProps.isActive ? 90 : void 0
    });
    return cloneElement2(icon, function() {
      return {
        className: cn(icon.props.className, "".concat(prefixCls, "-arrow"))
      };
    });
  };
  var iconPosition = getIconPosition();
  var collapseClassName = cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-borderless"), !bordered), _defineProperty$4(_classNames, "".concat(prefixCls, "-icon-position-").concat(iconPosition), true), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _defineProperty$4(_classNames, "".concat(prefixCls, "-ghost"), !!ghost), _classNames), className);
  var openMotion = _extends$2(_extends$2({}, collapseMotion), {
    motionAppear: false,
    leavedClassName: "".concat(prefixCls, "-content-hidden")
  });
  var getItems = function getItems2() {
    var children = props.children;
    return toArray$8(children).map(function(child, index2) {
      var _a;
      if ((_a = child.props) === null || _a === void 0 ? void 0 : _a.disabled) {
        var key2 = child.key || String(index2);
        var _child$props = child.props, disabled = _child$props.disabled, collapsible = _child$props.collapsible;
        var childProps = _extends$2(_extends$2({}, omit$1(child.props, ["disabled"])), {
          key: key2,
          collapsible: collapsible !== null && collapsible !== void 0 ? collapsible : disabled ? "disabled" : void 0
        });
        return cloneElement2(child, childProps);
      }
      return child;
    });
  };
  return /* @__PURE__ */ React.createElement(Collapse$2, _extends$2({
    openMotion
  }, props, {
    bordered,
    expandIcon: renderExpandIcon,
    prefixCls,
    className: collapseClassName
  }), getItems());
};
Collapse$1.Panel = CollapsePanel$1;
var initialState$1 = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
var root = _root;
var now$2 = function() {
  return root.Date.now();
};
var now_1 = now$2;
var isObject = isObject_1;
var now$1 = now_1;
var toNumber = toNumber_1;
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max;
var nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel2() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now$1());
  }
  function debounced() {
    var time = now$1(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel2;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce;
function clamp(number3, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number3, upperBound));
}
var safePreventDefault = function safePreventDefault2(event) {
  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];
  if (!passiveEvents.includes(event._reactName)) {
    event.preventDefault();
  }
};
var getOnDemandLazySlides = function getOnDemandLazySlides2(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};
var lazyStartIndex = function lazyStartIndex2(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = function lazyEndIndex2(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = function lazySlidesOnLeft2(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = function lazySlidesOnRight2(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};
var getWidth2 = function getWidth3(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = function getHeight2(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = function getSwipeDirection2(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var xDist, yDist, r3, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r3 = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r3 * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }
  return "vertical";
};
var canGoNext = function canGoNext2(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};
var extractObject = function extractObject2(spec, keys2) {
  var newObject = {};
  keys2.forEach(function(key2) {
    return newObject[key2] = spec[key2];
  });
  return newObject;
};
var initializedState = function initializedState2(spec) {
  var slideCount = React__default.Children.count(spec.children);
  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth2(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth2(trackNode));
  var slideWidth;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === void 0 ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === void 0) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
    currentSlide,
    lazyLoadedList
  }));
  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount,
    slideWidth,
    listWidth,
    trackWidth,
    currentSlide,
    slideHeight,
    listHeight,
    lazyLoadedList
  };
  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }
  return state;
};
var slideHandler = function slideHandler2(spec) {
  var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index2 = spec.index, slideCount = spec.slideCount, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
  var lazyLoadedList = spec.lazyLoadedList;
  if (waitForAnimate && animating)
    return {};
  var animationSlide = index2, finalSlide, animationLeft, finalLeft;
  var state = {}, nextState = {};
  var targetSlide = infinite ? index2 : clamp(index2, 0, slideCount - 1);
  if (fade) {
    if (!infinite && (index2 < 0 || index2 >= slideCount))
      return {};
    if (index2 < 0) {
      animationSlide = index2 + slideCount;
    } else if (index2 >= slideCount) {
      animationSlide = index2 - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList = lazyLoadedList.concat(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite)
        finalSlide = 0;
      else if (slideCount % slidesToScroll !== 0)
        finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite)
        finalSlide = slideCount - slidesToShow;
      else if (slideCount % slidesToScroll !== 0)
        finalSlide = 0;
    }
    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }
    animationLeft = getTrackLeft(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
      slideIndex: finalSlide
    }));
    if (!infinite) {
      if (animationLeft === finalLeft)
        animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    if (lazyLoad) {
      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
        currentSlide: animationSlide
      })));
    }
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList,
        targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList,
        targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide
      };
    }
  }
  return {
    state,
    nextState
  };
};
var changeSlide = function changeSlide2(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    targetSlide = options.index;
    if (infinite) {
      var direction = siblingDirection(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
        targetSlide
      }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }
  return targetSlide;
};
var keyHandler = function keyHandler2(e3, accessibility, rtl2) {
  if (e3.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility)
    return "";
  if (e3.keyCode === 37)
    return rtl2 ? "next" : "previous";
  if (e3.keyCode === 39)
    return rtl2 ? "previous" : "next";
  return "";
};
var swipeStart = function swipeStart2(e3, swipe, draggable) {
  e3.target.tagName === "IMG" && safePreventDefault(e3);
  if (!swipe || !draggable && e3.type.indexOf("mouse") !== -1)
    return "";
  return {
    dragging: true,
    touchObject: {
      startX: e3.touches ? e3.touches[0].pageX : e3.clientX,
      startY: e3.touches ? e3.touches[0].pageY : e3.clientY,
      curX: e3.touches ? e3.touches[0].pageX : e3.clientX,
      curY: e3.touches ? e3.touches[0].pageY : e3.clientY
    }
  };
};
var swipeMove = function swipeMove2(e3, spec) {
  var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl2 = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
  if (scrolling)
    return;
  if (animating)
    return safePreventDefault(e3);
  if (vertical && swipeToSlide && verticalSwiping)
    safePreventDefault(e3);
  var swipeLeft, state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e3.touches ? e3.touches[0].pageX : e3.clientX;
  touchObject.curY = e3.touches ? e3.touches[0].pageY : e3.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }
  if (verticalSwiping)
    touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl2 ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping)
    positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl2) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _objectSpread2$1(_objectSpread2$1({}, state), {}, {
    touchObject,
    swipeLeft,
    trackStyle: getTrackCSS(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
      left: swipeLeft
    }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    safePreventDefault(e3);
  }
  return state;
};
var swipeEnd = function swipeEnd2(e3, spec) {
  var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
  if (!dragging) {
    if (swipe)
      safePreventDefault(e3);
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    safePreventDefault(e3);
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = activeSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
      left: currentLeft
    }));
  }
  return state;
};
var getNavigableIndexes = function getNavigableIndexes2(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = function checkNavigable2(spec, index2) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index2 > navigables[navigables.length - 1]) {
    index2 = navigables[navigables.length - 1];
  } else {
    for (var n3 in navigables) {
      if (index2 < navigables[n3]) {
        index2 = prevNavigable;
        break;
      }
      prevNavigable = navigables[n3];
    }
  }
  return index2;
};
var getSlideCount = function getSlideCount2(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
    Array.from(slides).every(function(slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth2(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }
      return true;
    });
    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};
var checkSpecKeys = function checkSpecKeys2(spec, keysArray) {
  return keysArray.reduce(function(value, key2) {
    return value && spec.hasOwnProperty(key2);
  }, true) ? null : console.error("Keys Missing:", spec);
};
var getTrackCSS = function getTrackCSS2(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style2 = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style2 = _objectSpread2$1(_objectSpread2$1({}, style2), {}, {
      WebkitTransform,
      transform,
      msTransform
    });
  } else {
    if (spec.vertical) {
      style2["top"] = spec.left;
    } else {
      style2["left"] = spec.left;
    }
  }
  if (spec.fade)
    style2 = {
      opacity: 1
    };
  if (trackWidth)
    style2.width = trackWidth;
  if (trackHeight)
    style2.height = trackHeight;
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style2.marginLeft = spec.left + "px";
    } else {
      style2.marginTop = spec.left + "px";
    }
  }
  return style2;
};
var getTrackAnimateCSS = function getTrackAnimateCSS2(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style2 = getTrackCSS(spec);
  if (spec.useTransform) {
    style2.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style2.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style2.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style2.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style2;
};
var getTrackLeft = function getTrackLeft2(spec) {
  if (spec.unslick) {
    return 0;
  }
  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;
  if (fade || spec.slideCount === 1) {
    return 0;
  }
  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec);
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;
  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }
  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }
  return targetLeft;
};
var getPreClones = function getPreClones2(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var getPostClones = function getPostClones2(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};
var getTotalSlides = function getTotalSlides2(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = function siblingDirection2(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};
var slidesOnRight = function slidesOnRight2(_ref) {
  var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl2 = _ref.rtl, centerPadding = _ref.centerPadding;
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0)
      right += 1;
    if (rtl2 && slidesToShow % 2 === 0)
      right += 1;
    return right;
  }
  if (rtl2) {
    return 0;
  }
  return slidesToShow - 1;
};
var slidesOnLeft = function slidesOnLeft2(_ref2) {
  var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl2 = _ref2.rtl, centerPadding = _ref2.centerPadding;
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0)
      left += 1;
    if (!rtl2 && slidesToShow % 2 === 0)
      left += 1;
    return left;
  }
  if (rtl2) {
    return slidesToShow - 1;
  }
  return 0;
};
var canUseDOM = function canUseDOM2() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
var getSlideClasses = function getSlideClasses2(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index2;
  if (spec.rtl) {
    index2 = spec.slideCount - 1 - spec.index;
  } else {
    index2 = spec.index;
  }
  slickCloned = index2 < 0 || index2 >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index2 - spec.currentSlide) % spec.slideCount === 0;
    if (index2 > spec.currentSlide - centerOffset - 1 && index2 <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index2 && index2 < spec.currentSlide + spec.slidesToShow;
  }
  var focusedSlide;
  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }
  var slickCurrent = index2 === focusedSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent
  };
};
var getSlideStyle = function getSlideStyle2(spec) {
  var style2 = {};
  if (spec.variableWidth === void 0 || spec.variableWidth === false) {
    style2.width = spec.slideWidth;
  }
  if (spec.fade) {
    style2.position = "relative";
    if (spec.vertical) {
      style2.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style2.left = -spec.index * parseInt(spec.slideWidth);
    }
    style2.opacity = spec.currentSlide === spec.index ? 1 : 0;
    if (spec.useCSS) {
      style2.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style2;
};
var getKey$1 = function getKey(child, fallbackKey) {
  return child.key + "-" + fallbackKey;
};
var renderSlides = function renderSlides2(spec) {
  var key2;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = React__default.Children.count(spec.children);
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  React__default.Children.forEach(spec.children, function(elem, index2) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index2,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index2) >= 0) {
      child = elem;
    } else {
      child = /* @__PURE__ */ React__default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
      index: index2
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
      index: index2
    }));
    slides.push(/* @__PURE__ */ React__default.cloneElement(child, {
      key: "original" + getKey$1(child, index2),
      "data-index": index2,
      className: cn(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread2$1(_objectSpread2$1({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e3) {
        child.props && child.props.onClick && child.props.onClick(e3);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index2;
      if (preCloneNo <= getPreClones(spec) && childrenCount !== spec.slidesToShow) {
        key2 = -preCloneNo;
        if (key2 >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
          index: key2
        }));
        preCloneSlides.push(/* @__PURE__ */ React__default.cloneElement(child, {
          key: "precloned" + getKey$1(child, key2),
          "data-index": key2,
          tabIndex: "-1",
          className: cn(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread2$1(_objectSpread2$1({}, child.props.style || {}), childStyle),
          onClick: function onClick(e3) {
            child.props && child.props.onClick && child.props.onClick(e3);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
      if (childrenCount !== spec.slidesToShow) {
        key2 = childrenCount + index2;
        if (key2 < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_objectSpread2$1(_objectSpread2$1({}, spec), {}, {
          index: key2
        }));
        postCloneSlides.push(/* @__PURE__ */ React__default.cloneElement(child, {
          key: "postcloned" + getKey$1(child, key2),
          "data-index": key2,
          tabIndex: "-1",
          className: cn(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread2$1(_objectSpread2$1({}, child.props.style || {}), childStyle),
          onClick: function onClick(e3) {
            child.props && child.props.onClick && child.props.onClick(e3);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });
  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};
var Track$1 = /* @__PURE__ */ function(_React$PureComponent) {
  _inherits$1(Track3, _React$PureComponent);
  var _super = _createSuper$1(Track3);
  function Track3() {
    var _this2;
    _classCallCheck$2(this, Track3);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super.call.apply(_super, [this].concat(args));
    _defineProperty$4(_assertThisInitialized$1(_this2), "node", null);
    _defineProperty$4(_assertThisInitialized$1(_this2), "handleRef", function(ref) {
      _this2.node = ref;
    });
    return _this2;
  }
  _createClass$2(Track3, [{
    key: "render",
    value: function render4() {
      var slides = renderSlides(this.props);
      var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter,
        onMouseOver,
        onMouseLeave
      };
      return /* @__PURE__ */ React__default.createElement("div", _extends$2({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);
  return Track3;
}(React__default.PureComponent);
var getDotCount = function getDotCount2(spec) {
  var dots;
  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }
  return dots;
};
var Dots = /* @__PURE__ */ function(_React$PureComponent) {
  _inherits$1(Dots2, _React$PureComponent);
  var _super = _createSuper$1(Dots2);
  function Dots2() {
    _classCallCheck$2(this, Dots2);
    return _super.apply(this, arguments);
  }
  _createClass$2(Dots2, [{
    key: "clickHandler",
    value: function clickHandler(options, e3) {
      e3.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render4() {
      var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount,
        slidesToScroll,
        slidesToShow,
        infinite
      });
      var mouseEvents = {
        onMouseEnter,
        onMouseOver,
        onMouseLeave
      };
      var dots = [];
      for (var i2 = 0; i2 < dotCount; i2++) {
        var _rightBound = (i2 + 1) * slidesToScroll - 1;
        var rightBound = infinite ? _rightBound : clamp(_rightBound, 0, slideCount - 1);
        var _leftBound = rightBound - (slidesToScroll - 1);
        var leftBound = infinite ? _leftBound : clamp(_leftBound, 0, slideCount - 1);
        var className = cn({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i2,
          slidesToScroll,
          currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat(/* @__PURE__ */ React__default.createElement("li", {
          key: i2,
          className
        }, /* @__PURE__ */ React__default.cloneElement(this.props.customPaging(i2), {
          onClick
        })));
      }
      return /* @__PURE__ */ React__default.cloneElement(this.props.appendDots(dots), _objectSpread2$1({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);
  return Dots2;
}(React__default.PureComponent);
var PrevArrow = /* @__PURE__ */ function(_React$PureComponent) {
  _inherits$1(PrevArrow2, _React$PureComponent);
  var _super = _createSuper$1(PrevArrow2);
  function PrevArrow2() {
    _classCallCheck$2(this, PrevArrow2);
    return _super.apply(this, arguments);
  }
  _createClass$2(PrevArrow2, [{
    key: "clickHandler",
    value: function clickHandler(options, e3) {
      if (e3) {
        e3.preventDefault();
      }
      this.props.clickHandler(options, e3);
    }
  }, {
    key: "render",
    value: function render4() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });
      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }
      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: cn(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;
      if (this.props.prevArrow) {
        prevArrow = /* @__PURE__ */ React__default.cloneElement(this.props.prevArrow, _objectSpread2$1(_objectSpread2$1({}, prevArrowProps), customProps));
      } else {
        prevArrow = /* @__PURE__ */ React__default.createElement("button", _extends$2({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }
      return prevArrow;
    }
  }]);
  return PrevArrow2;
}(React__default.PureComponent);
var NextArrow = /* @__PURE__ */ function(_React$PureComponent2) {
  _inherits$1(NextArrow2, _React$PureComponent2);
  var _super2 = _createSuper$1(NextArrow2);
  function NextArrow2() {
    _classCallCheck$2(this, NextArrow2);
    return _super2.apply(this, arguments);
  }
  _createClass$2(NextArrow2, [{
    key: "clickHandler",
    value: function clickHandler(options, e3) {
      if (e3) {
        e3.preventDefault();
      }
      this.props.clickHandler(options, e3);
    }
  }, {
    key: "render",
    value: function render4() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });
      if (!canGoNext(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }
      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: cn(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;
      if (this.props.nextArrow) {
        nextArrow = /* @__PURE__ */ React__default.cloneElement(this.props.nextArrow, _objectSpread2$1(_objectSpread2$1({}, nextArrowProps), customProps));
      } else {
        nextArrow = /* @__PURE__ */ React__default.createElement("button", _extends$2({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }
      return nextArrow;
    }
  }]);
  return NextArrow2;
}(React__default.PureComponent);
var InnerSlider = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(InnerSlider2, _React$Component);
  var _super = _createSuper$1(InnerSlider2);
  function InnerSlider2(props) {
    var _this2;
    _classCallCheck$2(this, InnerSlider2);
    _this2 = _super.call(this, props);
    _defineProperty$4(_assertThisInitialized$1(_this2), "listRefHandler", function(ref) {
      return _this2.list = ref;
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "trackRefHandler", function(ref) {
      return _this2.track = ref;
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "adaptHeight", function() {
      if (_this2.props.adaptiveHeight && _this2.list) {
        var elem = _this2.list.querySelector('[data-index="'.concat(_this2.state.currentSlide, '"]'));
        _this2.list.style.height = getHeight(elem) + "px";
      }
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "componentDidMount", function() {
      _this2.props.onInit && _this2.props.onInit();
      if (_this2.props.lazyLoad) {
        var slidesToLoad = getOnDemandLazySlides(_objectSpread2$1(_objectSpread2$1({}, _this2.props), _this2.state));
        if (slidesToLoad.length > 0) {
          _this2.setState(function(prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this2.props.onLazyLoad) {
            _this2.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      var spec = _objectSpread2$1({
        listRef: _this2.list,
        trackRef: _this2.track
      }, _this2.props);
      _this2.updateState(spec, true, function() {
        _this2.adaptHeight();
        _this2.props.autoplay && _this2.autoPlay("playing");
      });
      if (_this2.props.lazyLoad === "progressive") {
        _this2.lazyLoadTimer = setInterval(_this2.progressiveLazyLoad, 1e3);
      }
      _this2.ro = new index$1(function() {
        if (_this2.state.animating) {
          _this2.onWindowResized(false);
          _this2.callbackTimers.push(setTimeout(function() {
            return _this2.onWindowResized();
          }, _this2.props.speed));
        } else {
          _this2.onWindowResized();
        }
      });
      _this2.ro.observe(_this2.list);
      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide) {
        slide.onfocus = _this2.props.pauseOnFocus ? _this2.onSlideFocus : null;
        slide.onblur = _this2.props.pauseOnFocus ? _this2.onSlideBlur : null;
      });
      if (window.addEventListener) {
        window.addEventListener("resize", _this2.onWindowResized);
      } else {
        window.attachEvent("onresize", _this2.onWindowResized);
      }
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "componentWillUnmount", function() {
      if (_this2.animationEndCallback) {
        clearTimeout(_this2.animationEndCallback);
      }
      if (_this2.lazyLoadTimer) {
        clearInterval(_this2.lazyLoadTimer);
      }
      if (_this2.callbackTimers.length) {
        _this2.callbackTimers.forEach(function(timer) {
          return clearTimeout(timer);
        });
        _this2.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this2.onWindowResized);
      } else {
        window.detachEvent("onresize", _this2.onWindowResized);
      }
      if (_this2.autoplayTimer) {
        clearInterval(_this2.autoplayTimer);
      }
      _this2.ro.disconnect();
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "componentDidUpdate", function(prevProps) {
      _this2.checkImagesLoad();
      _this2.props.onReInit && _this2.props.onReInit();
      if (_this2.props.lazyLoad) {
        var slidesToLoad = getOnDemandLazySlides(_objectSpread2$1(_objectSpread2$1({}, _this2.props), _this2.state));
        if (slidesToLoad.length > 0) {
          _this2.setState(function(prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this2.props.onLazyLoad) {
            _this2.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      _this2.adaptHeight();
      var spec = _objectSpread2$1(_objectSpread2$1({
        listRef: _this2.list,
        trackRef: _this2.track
      }, _this2.props), _this2.state);
      var setTrackStyle = _this2.didPropsChange(prevProps);
      setTrackStyle && _this2.updateState(spec, setTrackStyle, function() {
        if (_this2.state.currentSlide >= React__default.Children.count(_this2.props.children)) {
          _this2.changeSlide({
            message: "index",
            index: React__default.Children.count(_this2.props.children) - _this2.props.slidesToShow,
            currentSlide: _this2.state.currentSlide
          });
        }
        if (prevProps.autoplay !== _this2.props.autoplay || prevProps.autoplaySpeed !== _this2.props.autoplaySpeed) {
          if (!prevProps.autoplay && _this2.props.autoplay) {
            _this2.autoPlay("playing");
          } else if (_this2.props.autoplay) {
            _this2.autoPlay("update");
          } else {
            _this2.pause("paused");
          }
        }
      });
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "onWindowResized", function(setTrackStyle) {
      if (_this2.debouncedResize)
        _this2.debouncedResize.cancel();
      _this2.debouncedResize = debounce_1(function() {
        return _this2.resizeWindow(setTrackStyle);
      }, 50);
      _this2.debouncedResize();
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "resizeWindow", function() {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
      var isTrackMounted = Boolean(_this2.track && _this2.track.node);
      if (!isTrackMounted)
        return;
      var spec = _objectSpread2$1(_objectSpread2$1({
        listRef: _this2.list,
        trackRef: _this2.track
      }, _this2.props), _this2.state);
      _this2.updateState(spec, setTrackStyle, function() {
        if (_this2.props.autoplay)
          _this2.autoPlay("update");
        else
          _this2.pause("paused");
      });
      _this2.setState({
        animating: false
      });
      clearTimeout(_this2.animationEndCallback);
      delete _this2.animationEndCallback;
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "updateState", function(spec, setTrackStyle, callback) {
      var updatedState = initializedState(spec);
      spec = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = getTrackLeft(spec);
      spec = _objectSpread2$1(_objectSpread2$1({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = getTrackCSS(spec);
      if (setTrackStyle || React__default.Children.count(_this2.props.children) !== React__default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this2.setState(updatedState, callback);
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "ssrInit", function() {
      if (_this2.props.variableWidth) {
        var _trackWidth = 0, _trackLeft = 0;
        var childrenWidths = [];
        var preClones = getPreClones(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, _this2.props), _this2.state), {}, {
          slideCount: _this2.props.children.length
        }));
        var postClones = getPostClones(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, _this2.props), _this2.state), {}, {
          slideCount: _this2.props.children.length
        }));
        _this2.props.children.forEach(function(child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i2 = 0; i2 < preClones; i2++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i2];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i2];
        }
        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }
        for (var _i2 = 0; _i2 < _this2.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this2.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this2.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }
        return {
          trackStyle: _trackStyle
        };
      }
      var childrenCount = React__default.Children.count(_this2.props.children);
      var spec = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, _this2.props), _this2.state), {}, {
        slideCount: childrenCount
      });
      var slideCount = getPreClones(spec) + getPostClones(spec) + childrenCount;
      var trackWidth = 100 / _this2.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * (getPreClones(spec) + _this2.state.currentSlide) * trackWidth / 100;
      if (_this2.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle
      };
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "checkImagesLoad", function() {
      var images = _this2.list && _this2.list.querySelectorAll && _this2.list.querySelectorAll(".slick-slide img") || [];
      var imagesCount = images.length, loadedCount = 0;
      Array.prototype.forEach.call(images, function(image) {
        var handler = function handler2() {
          return ++loadedCount && loadedCount >= imagesCount && _this2.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function() {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function() {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this2.props.lazyLoad) {
            image.onload = function() {
              _this2.adaptHeight();
              _this2.callbackTimers.push(setTimeout(_this2.onWindowResized, _this2.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function() {
              handler();
              _this2.props.onLazyLoadError && _this2.props.onLazyLoadError();
            };
          }
        }
      });
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "progressiveLazyLoad", function() {
      var slidesToLoad = [];
      var spec = _objectSpread2$1(_objectSpread2$1({}, _this2.props), _this2.state);
      for (var index2 = _this2.state.currentSlide; index2 < _this2.state.slideCount + getPostClones(spec); index2++) {
        if (_this2.state.lazyLoadedList.indexOf(index2) < 0) {
          slidesToLoad.push(index2);
          break;
        }
      }
      for (var _index = _this2.state.currentSlide - 1; _index >= -getPreClones(spec); _index--) {
        if (_this2.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this2.setState(function(state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this2.props.onLazyLoad) {
          _this2.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this2.lazyLoadTimer) {
          clearInterval(_this2.lazyLoadTimer);
          delete _this2.lazyLoadTimer;
        }
      }
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "slideHandler", function(index2) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var _this$props = _this2.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange;
      var currentSlide = _this2.state.currentSlide;
      var _slideHandler = slideHandler(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
        index: index2
      }, _this2.props), _this2.state), {}, {
        trackRef: _this2.track,
        useCSS: _this2.props.useCSS && !dontAnimate
      })), state = _slideHandler.state, nextState = _slideHandler.nextState;
      if (!state)
        return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function(value) {
        return _this2.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      if (!_this2.props.waitForAnimate && _this2.animationEndCallback) {
        clearTimeout(_this2.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this2.animationEndCallback;
      }
      _this2.setState(state, function() {
        if (asNavFor && _this2.asNavForIndex !== index2) {
          _this2.asNavForIndex = index2;
          asNavFor.innerSlider.slideHandler(index2);
        }
        if (!nextState)
          return;
        _this2.animationEndCallback = setTimeout(function() {
          var animating = nextState.animating, firstBatch = _objectWithoutProperties$1(nextState, ["animating"]);
          _this2.setState(firstBatch, function() {
            _this2.callbackTimers.push(setTimeout(function() {
              return _this2.setState({
                animating
              });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this2.animationEndCallback;
          });
        }, speed);
      });
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "changeSlide", function(options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var spec = _objectSpread2$1(_objectSpread2$1({}, _this2.props), _this2.state);
      var targetSlide = changeSlide(spec, options);
      if (targetSlide !== 0 && !targetSlide)
        return;
      if (dontAnimate === true) {
        _this2.slideHandler(targetSlide, dontAnimate);
      } else {
        _this2.slideHandler(targetSlide);
      }
      _this2.props.autoplay && _this2.autoPlay("update");
      if (_this2.props.focusOnSelect) {
        var nodes = _this2.list.querySelectorAll(".slick-current");
        nodes[0] && nodes[0].focus();
      }
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "clickHandler", function(e3) {
      if (_this2.clickable === false) {
        e3.stopPropagation();
        e3.preventDefault();
      }
      _this2.clickable = true;
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "keyHandler", function(e3) {
      var dir = keyHandler(e3, _this2.props.accessibility, _this2.props.rtl);
      dir !== "" && _this2.changeSlide({
        message: dir
      });
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "selectHandler", function(options) {
      _this2.changeSlide(options);
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "disableBodyScroll", function() {
      var preventDefault = function preventDefault2(e3) {
        e3 = e3 || window.event;
        if (e3.preventDefault)
          e3.preventDefault();
        e3.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "enableBodyScroll", function() {
      window.ontouchmove = null;
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "swipeStart", function(e3) {
      if (_this2.props.verticalSwiping) {
        _this2.disableBodyScroll();
      }
      var state = swipeStart(e3, _this2.props.swipe, _this2.props.draggable);
      state !== "" && _this2.setState(state);
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "swipeMove", function(e3) {
      var state = swipeMove(e3, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, _this2.props), _this2.state), {}, {
        trackRef: _this2.track,
        listRef: _this2.list,
        slideIndex: _this2.state.currentSlide
      }));
      if (!state)
        return;
      if (state["swiping"]) {
        _this2.clickable = false;
      }
      _this2.setState(state);
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "swipeEnd", function(e3) {
      var state = swipeEnd(e3, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, _this2.props), _this2.state), {}, {
        trackRef: _this2.track,
        listRef: _this2.list,
        slideIndex: _this2.state.currentSlide
      }));
      if (!state)
        return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this2.setState(state);
      if (triggerSlideHandler === void 0)
        return;
      _this2.slideHandler(triggerSlideHandler);
      if (_this2.props.verticalSwiping) {
        _this2.enableBodyScroll();
      }
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "touchEnd", function(e3) {
      _this2.swipeEnd(e3);
      _this2.clickable = true;
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "slickPrev", function() {
      _this2.callbackTimers.push(setTimeout(function() {
        return _this2.changeSlide({
          message: "previous"
        });
      }, 0));
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "slickNext", function() {
      _this2.callbackTimers.push(setTimeout(function() {
        return _this2.changeSlide({
          message: "next"
        });
      }, 0));
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "slickGoTo", function(slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide))
        return "";
      _this2.callbackTimers.push(setTimeout(function() {
        return _this2.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this2.state.currentSlide
        }, dontAnimate);
      }, 0));
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "play", function() {
      var nextIndex;
      if (_this2.props.rtl) {
        nextIndex = _this2.state.currentSlide - _this2.props.slidesToScroll;
      } else {
        if (canGoNext(_objectSpread2$1(_objectSpread2$1({}, _this2.props), _this2.state))) {
          nextIndex = _this2.state.currentSlide + _this2.props.slidesToScroll;
        } else {
          return false;
        }
      }
      _this2.slideHandler(nextIndex);
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "autoPlay", function(playType) {
      if (_this2.autoplayTimer) {
        clearInterval(_this2.autoplayTimer);
      }
      var autoplaying = _this2.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this2.autoplayTimer = setInterval(_this2.play, _this2.props.autoplaySpeed + 50);
      _this2.setState({
        autoplaying: "playing"
      });
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "pause", function(pauseType) {
      if (_this2.autoplayTimer) {
        clearInterval(_this2.autoplayTimer);
        _this2.autoplayTimer = null;
      }
      var autoplaying = _this2.state.autoplaying;
      if (pauseType === "paused") {
        _this2.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this2.setState({
            autoplaying: "focused"
          });
        }
      } else {
        if (autoplaying === "playing") {
          _this2.setState({
            autoplaying: "hovered"
          });
        }
      }
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "onDotsOver", function() {
      return _this2.props.autoplay && _this2.pause("hovered");
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "onDotsLeave", function() {
      return _this2.props.autoplay && _this2.state.autoplaying === "hovered" && _this2.autoPlay("leave");
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "onTrackOver", function() {
      return _this2.props.autoplay && _this2.pause("hovered");
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "onTrackLeave", function() {
      return _this2.props.autoplay && _this2.state.autoplaying === "hovered" && _this2.autoPlay("leave");
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "onSlideFocus", function() {
      return _this2.props.autoplay && _this2.pause("focused");
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "onSlideBlur", function() {
      return _this2.props.autoplay && _this2.state.autoplaying === "focused" && _this2.autoPlay("blur");
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "render", function() {
      var className = cn("slick-slider", _this2.props.className, {
        "slick-vertical": _this2.props.vertical,
        "slick-initialized": true
      });
      var spec = _objectSpread2$1(_objectSpread2$1({}, _this2.props), _this2.state);
      var trackProps = extractObject(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this2.props.pauseOnHover;
      trackProps = _objectSpread2$1(_objectSpread2$1({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this2.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this2.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this2.onTrackOver : null,
        focusOnSelect: _this2.props.focusOnSelect && _this2.clickable ? _this2.selectHandler : null
      });
      var dots;
      if (_this2.props.dots === true && _this2.state.slideCount >= _this2.props.slidesToShow) {
        var dotProps = extractObject(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this2.props.pauseOnDotsHover;
        dotProps = _objectSpread2$1(_objectSpread2$1({}, dotProps), {}, {
          clickHandler: _this2.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this2.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this2.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this2.onDotsLeave : null
        });
        dots = /* @__PURE__ */ React__default.createElement(Dots, dotProps);
      }
      var prevArrow, nextArrow;
      var arrowProps = extractObject(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this2.changeSlide;
      if (_this2.props.arrows) {
        prevArrow = /* @__PURE__ */ React__default.createElement(PrevArrow, arrowProps);
        nextArrow = /* @__PURE__ */ React__default.createElement(NextArrow, arrowProps);
      }
      var verticalHeightStyle = null;
      if (_this2.props.vertical) {
        verticalHeightStyle = {
          height: _this2.state.listHeight
        };
      }
      var centerPaddingStyle = null;
      if (_this2.props.vertical === false) {
        if (_this2.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this2.props.centerPadding
          };
        }
      } else {
        if (_this2.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this2.props.centerPadding + " 0px"
          };
        }
      }
      var listStyle = _objectSpread2$1(_objectSpread2$1({}, verticalHeightStyle), centerPaddingStyle);
      var touchMove = _this2.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this2.clickHandler,
        onMouseDown: touchMove ? _this2.swipeStart : null,
        onMouseMove: _this2.state.dragging && touchMove ? _this2.swipeMove : null,
        onMouseUp: touchMove ? _this2.swipeEnd : null,
        onMouseLeave: _this2.state.dragging && touchMove ? _this2.swipeEnd : null,
        onTouchStart: touchMove ? _this2.swipeStart : null,
        onTouchMove: _this2.state.dragging && touchMove ? _this2.swipeMove : null,
        onTouchEnd: touchMove ? _this2.touchEnd : null,
        onTouchCancel: _this2.state.dragging && touchMove ? _this2.swipeEnd : null,
        onKeyDown: _this2.props.accessibility ? _this2.keyHandler : null
      };
      var innerSliderProps = {
        className,
        dir: "ltr",
        style: _this2.props.style
      };
      if (_this2.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className
        };
      }
      return /* @__PURE__ */ React__default.createElement("div", innerSliderProps, !_this2.props.unslick ? prevArrow : "", /* @__PURE__ */ React__default.createElement("div", _extends$2({
        ref: _this2.listRefHandler
      }, listProps), /* @__PURE__ */ React__default.createElement(Track$1, _extends$2({
        ref: _this2.trackRefHandler
      }, trackProps), _this2.props.children)), !_this2.props.unslick ? nextArrow : "", !_this2.props.unslick ? dots : "");
    });
    _this2.list = null;
    _this2.track = null;
    _this2.state = _objectSpread2$1(_objectSpread2$1({}, initialState$1), {}, {
      currentSlide: _this2.props.initialSlide,
      slideCount: React__default.Children.count(_this2.props.children)
    });
    _this2.callbackTimers = [];
    _this2.clickable = true;
    _this2.debouncedResize = null;
    var ssrState = _this2.ssrInit();
    _this2.state = _objectSpread2$1(_objectSpread2$1({}, _this2.state), ssrState);
    return _this2;
  }
  _createClass$2(InnerSlider2, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;
      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key2 = _Object$keys[_i3];
        if (!prevProps.hasOwnProperty(key2)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof$5(prevProps[key2]) === "object" || typeof prevProps[key2] === "function") {
          continue;
        }
        if (prevProps[key2] !== this.props[key2]) {
          setTrackStyle = true;
          break;
        }
      }
      return setTrackStyle || React__default.Children.count(this.props.children) !== React__default.Children.count(prevProps.children);
    }
  }]);
  return InnerSlider2;
}(React__default.Component);
var camel2hyphen$1 = function(str) {
  return str.replace(/[A-Z]/g, function(match2) {
    return "-" + match2.toLowerCase();
  }).toLowerCase();
};
var camel2hyphen_1 = camel2hyphen$1;
var camel2hyphen = camel2hyphen_1;
var isDimension = function(feature) {
  var re2 = /[height|width]$/;
  return re2.test(feature);
};
var obj2mq = function(obj) {
  var mq = "";
  var features = Object.keys(obj);
  features.forEach(function(feature, index2) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    if (isDimension(feature) && typeof value === "number") {
      value = value + "px";
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += "not " + feature;
    } else {
      mq += "(" + feature + ": " + value + ")";
    }
    if (index2 < features.length - 1) {
      mq += " and ";
    }
  });
  return mq;
};
var json2mq = function(query) {
  var mq = "";
  if (typeof query === "string") {
    return query;
  }
  if (query instanceof Array) {
    query.forEach(function(q2, index2) {
      mq += obj2mq(q2);
      if (index2 < query.length - 1) {
        mq += ", ";
      }
    });
    return mq;
  }
  return obj2mq(query);
};
var json2mq_1 = json2mq;
var defaultProps$1 = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return /* @__PURE__ */ React__default.createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3e3,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i2) {
    return /* @__PURE__ */ React__default.createElement("button", null, i2 + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
/* @__PURE__ */ (function(_React$Component) {
  _inherits$1(Slider2, _React$Component);
  var _super = _createSuper$1(Slider2);
  function Slider2(props) {
    var _this2;
    _classCallCheck$2(this, Slider2);
    _this2 = _super.call(this, props);
    _defineProperty$4(_assertThisInitialized$1(_this2), "innerSliderRefHandler", function(ref) {
      return _this2.innerSlider = ref;
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "slickPrev", function() {
      return _this2.innerSlider.slickPrev();
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "slickNext", function() {
      return _this2.innerSlider.slickNext();
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "slickGoTo", function(slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      return _this2.innerSlider.slickGoTo(slide, dontAnimate);
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "slickPause", function() {
      return _this2.innerSlider.pause("paused");
    });
    _defineProperty$4(_assertThisInitialized$1(_this2), "slickPlay", function() {
      return _this2.innerSlider.autoPlay("play");
    });
    _this2.state = {
      breakpoint: null
    };
    _this2._responsiveMediaHandlers = [];
    return _this2;
  }
  _createClass$2(Slider2, [{
    key: "media",
    value: function media(query, handler) {
      var mql = window.matchMedia(query);
      var listener = function listener2(_ref) {
        var matches = _ref.matches;
        if (matches) {
          handler();
        }
      };
      mql.addListener(listener);
      listener(mql);
      this._responsiveMediaHandlers.push({
        mql,
        query,
        listener
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function(breakpt) {
          return breakpt.breakpoint;
        });
        breakpoints.sort(function(x2, y2) {
          return x2 - y2;
        });
        breakpoints.forEach(function(breakpoint, index2) {
          var bQuery;
          if (index2 === 0) {
            bQuery = json2mq_1({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = json2mq_1({
              minWidth: breakpoints[index2 - 1] + 1,
              maxWidth: breakpoint
            });
          }
          canUseDOM() && _this2.media(bQuery, function() {
            _this2.setState({
              breakpoint
            });
          });
        });
        var query = json2mq_1({
          minWidth: breakpoints.slice(-1)[0]
        });
        canUseDOM() && this.media(query, function() {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function(obj) {
        obj.mql.removeListener(obj.listener);
      });
    }
  }, {
    key: "render",
    value: function render4() {
      var _this3 = this;
      var settings;
      var newProps;
      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function(resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, defaultProps$1), this.props), newProps[0].settings);
      } else {
        settings = _objectSpread2$1(_objectSpread2$1({}, defaultProps$1), this.props);
      }
      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && process.env.NODE_ENV !== "production") {
          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
        }
        settings.slidesToScroll = 1;
      }
      if (settings.fade) {
        if (settings.slidesToShow > 1 && process.env.NODE_ENV !== "production") {
          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
        }
        if (settings.slidesToScroll > 1 && process.env.NODE_ENV !== "production") {
          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
        }
        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      }
      var children = React__default.Children.toArray(this.props.children);
      children = children.filter(function(child) {
        if (typeof child === "string") {
          return !!child.trim();
        }
        return !!child;
      });
      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }
      var newChildren = [];
      var currentWidth = null;
      for (var i2 = 0; i2 < children.length; i2 += settings.rows * settings.slidesPerRow) {
        var newSlide = [];
        for (var j2 = i2; j2 < i2 + settings.rows * settings.slidesPerRow; j2 += settings.slidesPerRow) {
          var row = [];
          for (var k2 = j2; k2 < j2 + settings.slidesPerRow; k2 += 1) {
            if (settings.variableWidth && children[k2].props.style) {
              currentWidth = children[k2].props.style.width;
            }
            if (k2 >= children.length)
              break;
            row.push(/* @__PURE__ */ React__default.cloneElement(children[k2], {
              key: 100 * i2 + 10 * j2 + k2,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }
          newSlide.push(/* @__PURE__ */ React__default.createElement("div", {
            key: 10 * i2 + j2
          }, row));
        }
        if (settings.variableWidth) {
          newChildren.push(/* @__PURE__ */ React__default.createElement("div", {
            key: i2,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push(/* @__PURE__ */ React__default.createElement("div", {
            key: i2
          }, newSlide));
        }
      }
      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return /* @__PURE__ */ React__default.createElement("div", {
          className
        }, children);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }
      return /* @__PURE__ */ React__default.createElement(InnerSlider, _extends$2({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);
  return Slider2;
})(React__default.Component);
process.env.NODE_ENV !== "production";
var lib = { exports: {} };
(function(module, exports) {
  (function(global2, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    function arrayTreeFilter(data, filterFn, options) {
      options = options || {};
      options.childrenKeyName = options.childrenKeyName || "children";
      var children = data || [];
      var result = [];
      var level = 0;
      do {
        var foundItem = children.filter(function(item) {
          return filterFn(item, level);
        })[0];
        if (!foundItem) {
          break;
        }
        result.push(foundItem);
        children = foundItem[options.childrenKeyName] || [];
        level += 1;
      } while (children.length > 0);
      return result;
    }
    return arrayTreeFilter;
  });
})(lib);
var RedoOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 00-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z" } }] }, "name": "redo", "theme": "outlined" };
var RedoOutlined = function RedoOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: RedoOutlined$1
  }));
};
RedoOutlined.displayName = "RedoOutlined";
var ClearableInputType = tuple$1("text", "input");
function hasPrefixSuffix(props) {
  return !!(props.prefix || props.suffix || props.allowClear);
}
function hasAddon(props) {
  return !!(props.addonBefore || props.addonAfter);
}
var ClearableLabeledInput = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(ClearableLabeledInput2, _React$Component);
  var _super = _createSuper$1(ClearableLabeledInput2);
  function ClearableLabeledInput2() {
    var _this2;
    _classCallCheck$2(this, ClearableLabeledInput2);
    _this2 = _super.apply(this, arguments);
    _this2.containerRef = /* @__PURE__ */ React.createRef();
    _this2.onInputMouseUp = function(e3) {
      var _a;
      if ((_a = _this2.containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e3.target)) {
        var triggerFocus2 = _this2.props.triggerFocus;
        triggerFocus2 === null || triggerFocus2 === void 0 ? void 0 : triggerFocus2();
      }
    };
    return _this2;
  }
  _createClass$2(ClearableLabeledInput2, [{
    key: "renderClearIcon",
    value: function renderClearIcon(prefixCls) {
      var _this$props = this.props, allowClear = _this$props.allowClear, value = _this$props.value, disabled = _this$props.disabled, readOnly = _this$props.readOnly, handleReset = _this$props.handleReset;
      if (!allowClear) {
        return null;
      }
      var needClear = !disabled && !readOnly && value;
      var className = "".concat(prefixCls, "-clear-icon");
      return /* @__PURE__ */ React.createElement(CloseCircleFilled$1, {
        onClick: handleReset,
        className: cn(_defineProperty$4({}, "".concat(className, "-hidden"), !needClear), className),
        role: "button"
      });
    }
  }, {
    key: "renderSuffix",
    value: function renderSuffix(prefixCls) {
      var _this$props2 = this.props, suffix = _this$props2.suffix, allowClear = _this$props2.allowClear;
      if (suffix || allowClear) {
        return /* @__PURE__ */ React.createElement("span", {
          className: "".concat(prefixCls, "-suffix")
        }, this.renderClearIcon(prefixCls), suffix);
      }
      return null;
    }
  }, {
    key: "renderLabeledIcon",
    value: function renderLabeledIcon(prefixCls, element) {
      var _classNames2;
      var _this$props3 = this.props, focused = _this$props3.focused, value = _this$props3.value, prefix = _this$props3.prefix, className = _this$props3.className, size = _this$props3.size, suffix = _this$props3.suffix, disabled = _this$props3.disabled, allowClear = _this$props3.allowClear, direction = _this$props3.direction, style2 = _this$props3.style, readOnly = _this$props3.readOnly, bordered = _this$props3.bordered;
      var suffixNode = this.renderSuffix(prefixCls);
      if (!hasPrefixSuffix(this.props)) {
        return cloneElement2(element, {
          value
        });
      }
      var prefixNode = prefix ? /* @__PURE__ */ React.createElement("span", {
        className: "".concat(prefixCls, "-prefix")
      }, prefix) : null;
      var affixWrapperCls = cn("".concat(prefixCls, "-affix-wrapper"), (_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-affix-wrapper-focused"), focused), _defineProperty$4(_classNames2, "".concat(prefixCls, "-affix-wrapper-disabled"), disabled), _defineProperty$4(_classNames2, "".concat(prefixCls, "-affix-wrapper-sm"), size === "small"), _defineProperty$4(_classNames2, "".concat(prefixCls, "-affix-wrapper-lg"), size === "large"), _defineProperty$4(_classNames2, "".concat(prefixCls, "-affix-wrapper-input-with-clear-btn"), suffix && allowClear && value), _defineProperty$4(_classNames2, "".concat(prefixCls, "-affix-wrapper-rtl"), direction === "rtl"), _defineProperty$4(_classNames2, "".concat(prefixCls, "-affix-wrapper-readonly"), readOnly), _defineProperty$4(_classNames2, "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), _defineProperty$4(_classNames2, "".concat(className), !hasAddon(this.props) && className), _classNames2));
      return /* @__PURE__ */ React.createElement("span", {
        ref: this.containerRef,
        className: affixWrapperCls,
        style: style2,
        onMouseUp: this.onInputMouseUp
      }, prefixNode, cloneElement2(element, {
        style: null,
        value,
        className: getInputClassName(prefixCls, bordered, size, disabled)
      }), suffixNode);
    }
  }, {
    key: "renderInputWithLabel",
    value: function renderInputWithLabel(prefixCls, labeledElement) {
      var _classNames4;
      var _this$props4 = this.props, addonBefore = _this$props4.addonBefore, addonAfter = _this$props4.addonAfter, style2 = _this$props4.style, size = _this$props4.size, className = _this$props4.className, direction = _this$props4.direction;
      if (!hasAddon(this.props)) {
        return labeledElement;
      }
      var wrapperClassName = "".concat(prefixCls, "-group");
      var addonClassName = "".concat(wrapperClassName, "-addon");
      var addonBeforeNode = addonBefore ? /* @__PURE__ */ React.createElement("span", {
        className: addonClassName
      }, addonBefore) : null;
      var addonAfterNode = addonAfter ? /* @__PURE__ */ React.createElement("span", {
        className: addonClassName
      }, addonAfter) : null;
      var mergedWrapperClassName = cn("".concat(prefixCls, "-wrapper"), wrapperClassName, _defineProperty$4({}, "".concat(wrapperClassName, "-rtl"), direction === "rtl"));
      var mergedGroupClassName = cn("".concat(prefixCls, "-group-wrapper"), (_classNames4 = {}, _defineProperty$4(_classNames4, "".concat(prefixCls, "-group-wrapper-sm"), size === "small"), _defineProperty$4(_classNames4, "".concat(prefixCls, "-group-wrapper-lg"), size === "large"), _defineProperty$4(_classNames4, "".concat(prefixCls, "-group-wrapper-rtl"), direction === "rtl"), _classNames4), className);
      return /* @__PURE__ */ React.createElement("span", {
        className: mergedGroupClassName,
        style: style2
      }, /* @__PURE__ */ React.createElement("span", {
        className: mergedWrapperClassName
      }, addonBeforeNode, cloneElement2(labeledElement, {
        style: null
      }), addonAfterNode));
    }
  }, {
    key: "renderTextAreaWithClearIcon",
    value: function renderTextAreaWithClearIcon(prefixCls, element) {
      var _classNames5;
      var _this$props5 = this.props, value = _this$props5.value, allowClear = _this$props5.allowClear, className = _this$props5.className, style2 = _this$props5.style, direction = _this$props5.direction, bordered = _this$props5.bordered;
      if (!allowClear) {
        return cloneElement2(element, {
          value
        });
      }
      var affixWrapperCls = cn("".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"), (_classNames5 = {}, _defineProperty$4(_classNames5, "".concat(prefixCls, "-affix-wrapper-rtl"), direction === "rtl"), _defineProperty$4(_classNames5, "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), _defineProperty$4(_classNames5, "".concat(className), !hasAddon(this.props) && className), _classNames5));
      return /* @__PURE__ */ React.createElement("span", {
        className: affixWrapperCls,
        style: style2
      }, cloneElement2(element, {
        style: null,
        value
      }), this.renderClearIcon(prefixCls));
    }
  }, {
    key: "render",
    value: function render4() {
      var _this$props6 = this.props, prefixCls = _this$props6.prefixCls, inputType = _this$props6.inputType, element = _this$props6.element;
      if (inputType === ClearableInputType[0]) {
        return this.renderTextAreaWithClearIcon(prefixCls, element);
      }
      return this.renderInputWithLabel(prefixCls, this.renderLabeledIcon(prefixCls, element));
    }
  }]);
  return ClearableLabeledInput2;
}(React.Component);
function fixControlledValue(value) {
  if (typeof value === "undefined" || value === null) {
    return "";
  }
  return value;
}
function resolveOnChange(target, e3, onChange4, targetValue) {
  if (!onChange4) {
    return;
  }
  var event = e3;
  var originalInputValue = target.value;
  if (e3.type === "click") {
    event = Object.create(e3);
    event.target = target;
    event.currentTarget = target;
    target.value = "";
    onChange4(event);
    target.value = originalInputValue;
    return;
  }
  if (targetValue !== void 0) {
    event = Object.create(e3);
    event.target = target;
    event.currentTarget = target;
    target.value = targetValue;
    onChange4(event);
    return;
  }
  onChange4(event);
}
function getInputClassName(prefixCls, bordered, size, disabled, direction) {
  var _classNames;
  return cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-sm"), size === "small"), _defineProperty$4(_classNames, "".concat(prefixCls, "-lg"), size === "large"), _defineProperty$4(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _defineProperty$4(_classNames, "".concat(prefixCls, "-borderless"), !bordered), _classNames));
}
function triggerFocus(element, option) {
  if (!element)
    return;
  element.focus(option);
  var _ref = option || {}, cursor = _ref.cursor;
  if (cursor) {
    var len = element.value.length;
    switch (cursor) {
      case "start":
        element.setSelectionRange(0, 0);
        break;
      case "end":
        element.setSelectionRange(len, len);
        break;
      default:
        element.setSelectionRange(0, len);
    }
  }
}
var Input$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Input3, _React$Component);
  var _super = _createSuper$1(Input3);
  function Input3(props) {
    var _this2;
    _classCallCheck$2(this, Input3);
    _this2 = _super.call(this, props);
    _this2.direction = "ltr";
    _this2.focus = function(option) {
      triggerFocus(_this2.input, option);
    };
    _this2.saveClearableInput = function(input) {
      _this2.clearableInput = input;
    };
    _this2.saveInput = function(input) {
      _this2.input = input;
    };
    _this2.onFocus = function(e3) {
      var onFocus2 = _this2.props.onFocus;
      _this2.setState({
        focused: true
      }, _this2.clearPasswordValueAttribute);
      onFocus2 === null || onFocus2 === void 0 ? void 0 : onFocus2(e3);
    };
    _this2.onBlur = function(e3) {
      var onBlur2 = _this2.props.onBlur;
      _this2.setState({
        focused: false
      }, _this2.clearPasswordValueAttribute);
      onBlur2 === null || onBlur2 === void 0 ? void 0 : onBlur2(e3);
    };
    _this2.handleReset = function(e3) {
      _this2.setValue("", function() {
        _this2.focus();
      });
      resolveOnChange(_this2.input, e3, _this2.props.onChange);
    };
    _this2.renderInput = function(prefixCls, size, bordered) {
      var input = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      var _this$props = _this2.props, className = _this$props.className, addonBefore = _this$props.addonBefore, addonAfter = _this$props.addonAfter, customizeSize = _this$props.size, disabled = _this$props.disabled;
      var otherProps = omit$1(_this2.props, [
        "prefixCls",
        "onPressEnter",
        "addonBefore",
        "addonAfter",
        "prefix",
        "suffix",
        "allowClear",
        "defaultValue",
        "size",
        "inputType",
        "bordered"
      ]);
      return /* @__PURE__ */ React.createElement("input", _extends$2({
        autoComplete: input.autoComplete
      }, otherProps, {
        onChange: _this2.handleChange,
        onFocus: _this2.onFocus,
        onBlur: _this2.onBlur,
        onKeyDown: _this2.handleKeyDown,
        className: cn(getInputClassName(prefixCls, bordered, customizeSize || size, disabled, _this2.direction), _defineProperty$4({}, className, className && !addonBefore && !addonAfter)),
        ref: _this2.saveInput
      }));
    };
    _this2.clearPasswordValueAttribute = function() {
      _this2.removePasswordTimeout = setTimeout(function() {
        if (_this2.input && _this2.input.getAttribute("type") === "password" && _this2.input.hasAttribute("value")) {
          _this2.input.removeAttribute("value");
        }
      });
    };
    _this2.handleChange = function(e3) {
      _this2.setValue(e3.target.value, _this2.clearPasswordValueAttribute);
      resolveOnChange(_this2.input, e3, _this2.props.onChange);
    };
    _this2.handleKeyDown = function(e3) {
      var _this$props2 = _this2.props, onPressEnter = _this$props2.onPressEnter, onKeyDown2 = _this$props2.onKeyDown;
      if (onPressEnter && e3.keyCode === 13) {
        onPressEnter(e3);
      }
      onKeyDown2 === null || onKeyDown2 === void 0 ? void 0 : onKeyDown2(e3);
    };
    _this2.renderComponent = function(_ref2) {
      var getPrefixCls = _ref2.getPrefixCls, direction = _ref2.direction, input = _ref2.input;
      var _this$state = _this2.state, value2 = _this$state.value, focused = _this$state.focused;
      var _this$props3 = _this2.props, customizePrefixCls = _this$props3.prefixCls, _this$props3$bordered = _this$props3.bordered, bordered = _this$props3$bordered === void 0 ? true : _this$props3$bordered;
      var prefixCls = getPrefixCls("input", customizePrefixCls);
      _this2.direction = direction;
      return /* @__PURE__ */ React.createElement(SizeContext$1.Consumer, null, function(size) {
        return /* @__PURE__ */ React.createElement(ClearableLabeledInput, _extends$2({
          size
        }, _this2.props, {
          prefixCls,
          inputType: "input",
          value: fixControlledValue(value2),
          element: _this2.renderInput(prefixCls, size, bordered, input),
          handleReset: _this2.handleReset,
          ref: _this2.saveClearableInput,
          direction,
          focused,
          triggerFocus: _this2.focus,
          bordered
        }));
      });
    };
    var value = typeof props.value === "undefined" ? props.defaultValue : props.value;
    _this2.state = {
      value,
      focused: false,
      prevValue: props.value
    };
    return _this2;
  }
  _createClass$2(Input3, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.clearPasswordValueAttribute();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      if (hasPrefixSuffix(prevProps) !== hasPrefixSuffix(this.props)) {
        devWarning(this.input !== document.activeElement, "Input", "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ");
      }
      return null;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.removePasswordTimeout) {
        clearTimeout(this.removePasswordTimeout);
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "setSelectionRange",
    value: function setSelectionRange(start, end, direction) {
      this.input.setSelectionRange(start, end, direction);
    }
  }, {
    key: "select",
    value: function select() {
      this.input.select();
    }
  }, {
    key: "setValue",
    value: function setValue2(value, callback) {
      if (this.props.value === void 0) {
        this.setState({
          value
        }, callback);
      } else {
        callback === null || callback === void 0 ? void 0 : callback();
      }
    }
  }, {
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(ConfigConsumer, null, this.renderComponent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, _ref3) {
      var prevValue = _ref3.prevValue;
      var newState = {
        prevValue: nextProps.value
      };
      if (nextProps.value !== void 0 || prevValue !== nextProps.value) {
        newState.value = nextProps.value;
      }
      return newState;
    }
  }]);
  return Input3;
}(React.Component);
Input$1.defaultProps = {
  type: "text"
};
var Group$1 = function Group2(props) {
  return /* @__PURE__ */ React.createElement(ConfigConsumer, null, function(_ref) {
    var _classNames;
    var getPrefixCls = _ref.getPrefixCls, direction = _ref.direction;
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className;
    var prefixCls = getPrefixCls("input-group", customizePrefixCls);
    var cls = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-lg"), props.size === "large"), _defineProperty$4(_classNames, "".concat(prefixCls, "-sm"), props.size === "small"), _defineProperty$4(_classNames, "".concat(prefixCls, "-compact"), props.compact), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
    return /* @__PURE__ */ React.createElement("span", {
      className: cls,
      style: props.style,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      onFocus: props.onFocus,
      onBlur: props.onBlur
    }, props.children);
  });
};
var __rest$x = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var Search$1 = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var _classNames;
  var customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, className = props.className, customizeSize = props.size, suffix = props.suffix, _props$enterButton = props.enterButton, enterButton = _props$enterButton === void 0 ? false : _props$enterButton, addonAfter = props.addonAfter, loading = props.loading, disabled = props.disabled, customOnSearch = props.onSearch, customOnChange = props.onChange, restProps = __rest$x(props, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange"]);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var contextSize = React.useContext(SizeContext$1);
  var size = customizeSize || contextSize;
  var inputRef = React.useRef(null);
  var onChange4 = function onChange5(e3) {
    if (e3 && e3.target && e3.type === "click" && customOnSearch) {
      customOnSearch(e3.target.value, e3);
    }
    if (customOnChange) {
      customOnChange(e3);
    }
  };
  var onMouseDown = function onMouseDown2(e3) {
    var _a;
    if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) {
      e3.preventDefault();
    }
  };
  var onSearch = function onSearch2(e3) {
    var _a;
    if (customOnSearch) {
      customOnSearch((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input.value, e3);
    }
  };
  var prefixCls = getPrefixCls("input-search", customizePrefixCls);
  var inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
  var searchIcon = typeof enterButton === "boolean" || typeof enterButton === "undefined" ? /* @__PURE__ */ React.createElement(SearchOutlined$1, null) : null;
  var btnClassName = "".concat(prefixCls, "-button");
  var button;
  var enterButtonAsElement = enterButton || {};
  var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
  if (isAntdButton || enterButtonAsElement.type === "button") {
    button = cloneElement2(enterButtonAsElement, _extends$2({
      onMouseDown,
      onClick: onSearch,
      key: "enterButton"
    }, isAntdButton ? {
      className: btnClassName,
      size
    } : {}));
  } else {
    button = /* @__PURE__ */ React.createElement(Button$1, {
      className: btnClassName,
      type: enterButton ? "primary" : void 0,
      size,
      disabled,
      key: "enterButton",
      onMouseDown,
      onClick: onSearch,
      loading,
      icon: searchIcon
    }, enterButton);
  }
  if (addonAfter) {
    button = [button, cloneElement2(addonAfter, {
      key: "addonAfter"
    })];
  }
  var cls = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _defineProperty$4(_classNames, "".concat(prefixCls, "-with-button"), !!enterButton), _classNames), className);
  return /* @__PURE__ */ React.createElement(Input$1, _extends$2({
    ref: composeRef(inputRef, ref),
    onPressEnter: onSearch
  }, restProps, {
    size,
    prefixCls: inputPrefixCls,
    addonAfter: button,
    suffix,
    onChange: onChange4,
    className: cls,
    disabled
  }));
});
Search$1.displayName = "Search";
var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
var SIZING_STYLE = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break"];
var computedStyleCache = {};
var hiddenTextarea;
function calculateNodeStyling(node) {
  var useCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var nodeRef = node.getAttribute("id") || node.getAttribute("data-reactid") || node.getAttribute("name");
  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }
  var style2 = window.getComputedStyle(node);
  var boxSizing = style2.getPropertyValue("box-sizing") || style2.getPropertyValue("-moz-box-sizing") || style2.getPropertyValue("-webkit-box-sizing");
  var paddingSize = parseFloat(style2.getPropertyValue("padding-bottom")) + parseFloat(style2.getPropertyValue("padding-top"));
  var borderSize = parseFloat(style2.getPropertyValue("border-bottom-width")) + parseFloat(style2.getPropertyValue("border-top-width"));
  var sizingStyle = SIZING_STYLE.map(function(name) {
    return "".concat(name, ":").concat(style2.getPropertyValue(name));
  }).join(";");
  var nodeInfo = {
    sizingStyle,
    paddingSize,
    borderSize,
    boxSizing
  };
  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }
  return nodeInfo;
}
function calculateNodeHeight(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement("textarea");
    hiddenTextarea.setAttribute("tab-index", "-1");
    hiddenTextarea.setAttribute("aria-hidden", "true");
    document.body.appendChild(hiddenTextarea);
  }
  if (uiTextNode.getAttribute("wrap")) {
    hiddenTextarea.setAttribute("wrap", uiTextNode.getAttribute("wrap"));
  } else {
    hiddenTextarea.removeAttribute("wrap");
  }
  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
  hiddenTextarea.setAttribute("style", "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || "";
  var minHeight = Number.MIN_SAFE_INTEGER;
  var maxHeight = Number.MAX_SAFE_INTEGER;
  var height = hiddenTextarea.scrollHeight;
  var overflowY;
  if (boxSizing === "border-box") {
    height += borderSize;
  } else if (boxSizing === "content-box") {
    height -= paddingSize;
  }
  if (minRows !== null || maxRows !== null) {
    hiddenTextarea.value = " ";
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;
      if (boxSizing === "border-box") {
        minHeight = minHeight + paddingSize + borderSize;
      }
      height = Math.max(minHeight, height);
    }
    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;
      if (boxSizing === "border-box") {
        maxHeight = maxHeight + paddingSize + borderSize;
      }
      overflowY = height > maxHeight ? "" : "hidden";
      height = Math.min(maxHeight, height);
    }
  }
  return {
    height,
    minHeight,
    maxHeight,
    overflowY,
    resize: "none"
  };
}
var RESIZE_STATUS;
(function(RESIZE_STATUS2) {
  RESIZE_STATUS2[RESIZE_STATUS2["NONE"] = 0] = "NONE";
  RESIZE_STATUS2[RESIZE_STATUS2["RESIZING"] = 1] = "RESIZING";
  RESIZE_STATUS2[RESIZE_STATUS2["RESIZED"] = 2] = "RESIZED";
})(RESIZE_STATUS || (RESIZE_STATUS = {}));
var ResizableTextArea = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(ResizableTextArea2, _React$Component);
  var _super = _createSuper$1(ResizableTextArea2);
  function ResizableTextArea2(props) {
    var _this2;
    _classCallCheck$2(this, ResizableTextArea2);
    _this2 = _super.call(this, props);
    _this2.nextFrameActionId = void 0;
    _this2.resizeFrameId = void 0;
    _this2.textArea = void 0;
    _this2.saveTextArea = function(textArea) {
      _this2.textArea = textArea;
    };
    _this2.handleResize = function(size) {
      var resizeStatus = _this2.state.resizeStatus;
      var _this$props = _this2.props, autoSize = _this$props.autoSize, onResize2 = _this$props.onResize;
      if (resizeStatus !== RESIZE_STATUS.NONE) {
        return;
      }
      if (typeof onResize2 === "function") {
        onResize2(size);
      }
      if (autoSize) {
        _this2.resizeOnNextFrame();
      }
    };
    _this2.resizeOnNextFrame = function() {
      cancelAnimationFrame(_this2.nextFrameActionId);
      _this2.nextFrameActionId = requestAnimationFrame(_this2.resizeTextarea);
    };
    _this2.resizeTextarea = function() {
      var autoSize = _this2.props.autoSize;
      if (!autoSize || !_this2.textArea) {
        return;
      }
      var minRows = autoSize.minRows, maxRows = autoSize.maxRows;
      var textareaStyles = calculateNodeHeight(_this2.textArea, false, minRows, maxRows);
      _this2.setState({
        textareaStyles,
        resizeStatus: RESIZE_STATUS.RESIZING
      }, function() {
        cancelAnimationFrame(_this2.resizeFrameId);
        _this2.resizeFrameId = requestAnimationFrame(function() {
          _this2.setState({
            resizeStatus: RESIZE_STATUS.RESIZED
          }, function() {
            _this2.resizeFrameId = requestAnimationFrame(function() {
              _this2.setState({
                resizeStatus: RESIZE_STATUS.NONE
              });
              _this2.fixFirefoxAutoScroll();
            });
          });
        });
      });
    };
    _this2.renderTextArea = function() {
      var _this$props2 = _this2.props, _this$props2$prefixCl = _this$props2.prefixCls, prefixCls = _this$props2$prefixCl === void 0 ? "rc-textarea" : _this$props2$prefixCl, autoSize = _this$props2.autoSize, onResize2 = _this$props2.onResize, className = _this$props2.className, disabled = _this$props2.disabled;
      var _this$state = _this2.state, textareaStyles = _this$state.textareaStyles, resizeStatus = _this$state.resizeStatus;
      var otherProps = omit$1(_this2.props, ["prefixCls", "onPressEnter", "autoSize", "defaultValue", "onResize"]);
      var cls = cn(prefixCls, className, _defineProperty$4({}, "".concat(prefixCls, "-disabled"), disabled));
      if ("value" in otherProps) {
        otherProps.value = otherProps.value || "";
      }
      var style2 = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, _this2.props.style), textareaStyles), resizeStatus === RESIZE_STATUS.RESIZING ? {
        overflowX: "hidden",
        overflowY: "hidden"
      } : null);
      return /* @__PURE__ */ React.createElement(ResizeObserver, {
        onResize: _this2.handleResize,
        disabled: !(autoSize || onResize2)
      }, /* @__PURE__ */ React.createElement("textarea", _extends$2({}, otherProps, {
        className: cls,
        style: style2,
        ref: _this2.saveTextArea
      })));
    };
    _this2.state = {
      textareaStyles: {},
      resizeStatus: RESIZE_STATUS.NONE
    };
    return _this2;
  }
  _createClass$2(ResizableTextArea2, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value || !shallowequal(prevProps.autoSize, this.props.autoSize)) {
        this.resizeTextarea();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cancelAnimationFrame(this.nextFrameActionId);
      cancelAnimationFrame(this.resizeFrameId);
    }
  }, {
    key: "fixFirefoxAutoScroll",
    value: function fixFirefoxAutoScroll() {
      try {
        if (document.activeElement === this.textArea) {
          var currentStart = this.textArea.selectionStart;
          var currentEnd = this.textArea.selectionEnd;
          this.textArea.setSelectionRange(currentStart, currentEnd);
        }
      } catch (e3) {
      }
    }
  }, {
    key: "render",
    value: function render4() {
      return this.renderTextArea();
    }
  }]);
  return ResizableTextArea2;
}(React.Component);
var TextArea$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(TextArea2, _React$Component);
  var _super = _createSuper$1(TextArea2);
  function TextArea2(props) {
    var _this2;
    _classCallCheck$2(this, TextArea2);
    _this2 = _super.call(this, props);
    _this2.resizableTextArea = void 0;
    _this2.focus = function() {
      _this2.resizableTextArea.textArea.focus();
    };
    _this2.saveTextArea = function(resizableTextArea) {
      _this2.resizableTextArea = resizableTextArea;
    };
    _this2.handleChange = function(e3) {
      var onChange4 = _this2.props.onChange;
      _this2.setValue(e3.target.value, function() {
        _this2.resizableTextArea.resizeTextarea();
      });
      if (onChange4) {
        onChange4(e3);
      }
    };
    _this2.handleKeyDown = function(e3) {
      var _this$props = _this2.props, onPressEnter = _this$props.onPressEnter, onKeyDown2 = _this$props.onKeyDown;
      if (e3.keyCode === 13 && onPressEnter) {
        onPressEnter(e3);
      }
      if (onKeyDown2) {
        onKeyDown2(e3);
      }
    };
    var value = typeof props.value === "undefined" || props.value === null ? props.defaultValue : props.value;
    _this2.state = {
      value
    };
    return _this2;
  }
  _createClass$2(TextArea2, [{
    key: "setValue",
    value: function setValue2(value, callback) {
      if (!("value" in this.props)) {
        this.setState({
          value
        }, callback);
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      this.resizableTextArea.textArea.blur();
    }
  }, {
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(ResizableTextArea, _extends$2({}, this.props, {
        value: this.state.value,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        ref: this.saveTextArea
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ("value" in nextProps) {
        return {
          value: nextProps.value
        };
      }
      return null;
    }
  }]);
  return TextArea2;
}(React.Component);
var __rest$w = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
function fixEmojiLength(value, maxLength) {
  return _toConsumableArray(value || "").slice(0, maxLength).join("");
}
var TextArea = /* @__PURE__ */ React.forwardRef(function(_a, ref) {
  var _classNames;
  var customizePrefixCls = _a.prefixCls, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? true : _a$bordered, _a$showCount = _a.showCount, showCount = _a$showCount === void 0 ? false : _a$showCount, maxLength = _a.maxLength, className = _a.className, style2 = _a.style, customizeSize = _a.size, onCompositionStart = _a.onCompositionStart, onCompositionEnd = _a.onCompositionEnd, onChange4 = _a.onChange, props = __rest$w(_a, ["prefixCls", "bordered", "showCount", "maxLength", "className", "style", "size", "onCompositionStart", "onCompositionEnd", "onChange"]);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var size = React.useContext(SizeContext$1);
  var innerRef = React.useRef(null);
  var clearableInputRef = React.useRef(null);
  var _React$useState = React.useState(false), _React$useState2 = _slicedToArray$3(_React$useState, 2), compositing = _React$useState2[0], setCompositing = _React$useState2[1];
  var _useMergedState = useMergedState(props.defaultValue, {
    value: props.value
  }), _useMergedState2 = _slicedToArray$3(_useMergedState, 2), value = _useMergedState2[0], setValue2 = _useMergedState2[1];
  var handleSetValue = function handleSetValue2(val2, callback) {
    if (props.value === void 0) {
      setValue2(val2);
      callback === null || callback === void 0 ? void 0 : callback();
    }
  };
  var hasMaxLength = Number(maxLength) > 0;
  var onInternalCompositionStart = function onInternalCompositionStart2(e3) {
    setCompositing(true);
    onCompositionStart === null || onCompositionStart === void 0 ? void 0 : onCompositionStart(e3);
  };
  var onInternalCompositionEnd = function onInternalCompositionEnd2(e3) {
    setCompositing(false);
    var triggerValue = e3.currentTarget.value;
    if (hasMaxLength) {
      triggerValue = fixEmojiLength(triggerValue, maxLength);
    }
    if (triggerValue !== value) {
      handleSetValue(triggerValue);
      resolveOnChange(innerRef.current, e3, onChange4, triggerValue);
    }
    onCompositionEnd === null || onCompositionEnd === void 0 ? void 0 : onCompositionEnd(e3);
  };
  var handleChange = function handleChange2(e3) {
    var triggerValue = e3.target.value;
    if (!compositing && hasMaxLength) {
      triggerValue = fixEmojiLength(triggerValue, maxLength);
    }
    handleSetValue(triggerValue);
    resolveOnChange(innerRef.current, e3, onChange4, triggerValue);
  };
  var handleReset = function handleReset2(e3) {
    handleSetValue("", function() {
      var _a2;
      (_a2 = innerRef.current) === null || _a2 === void 0 ? void 0 : _a2.focus();
    });
    resolveOnChange(innerRef.current, e3, onChange4);
  };
  var prefixCls = getPrefixCls("input", customizePrefixCls);
  React.useImperativeHandle(ref, function() {
    var _a2;
    return {
      resizableTextArea: (_a2 = innerRef.current) === null || _a2 === void 0 ? void 0 : _a2.resizableTextArea,
      focus: function focus(option) {
        var _a3, _b;
        triggerFocus((_b = (_a3 = innerRef.current) === null || _a3 === void 0 ? void 0 : _a3.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
      },
      blur: function blur() {
        var _a3;
        return (_a3 = innerRef.current) === null || _a3 === void 0 ? void 0 : _a3.blur();
      }
    };
  });
  var textArea = /* @__PURE__ */ React.createElement(TextArea$1, _extends$2({}, omit$1(props, ["allowClear"]), {
    className: cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-borderless"), !bordered), _defineProperty$4(_classNames, className, className && !showCount), _defineProperty$4(_classNames, "".concat(prefixCls, "-sm"), size === "small" || customizeSize === "small"), _defineProperty$4(_classNames, "".concat(prefixCls, "-lg"), size === "large" || customizeSize === "large"), _classNames)),
    style: showCount ? void 0 : style2,
    prefixCls,
    onCompositionStart: onInternalCompositionStart,
    onChange: handleChange,
    onCompositionEnd: onInternalCompositionEnd,
    ref: innerRef
  }));
  var val = fixControlledValue(value);
  if (!compositing && hasMaxLength && (props.value === null || props.value === void 0)) {
    val = fixEmojiLength(val, maxLength);
  }
  var textareaNode = /* @__PURE__ */ React.createElement(ClearableLabeledInput, _extends$2({}, props, {
    prefixCls,
    direction,
    inputType: "text",
    value: val,
    element: textArea,
    handleReset,
    ref: clearableInputRef,
    bordered
  }));
  if (showCount) {
    var valueLength = _toConsumableArray(val).length;
    var dataCount = "";
    if (_typeof$5(showCount) === "object") {
      dataCount = showCount.formatter({
        count: valueLength,
        maxLength
      });
    } else {
      dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(maxLength) : "");
    }
    return /* @__PURE__ */ React.createElement("div", {
      className: cn("".concat(prefixCls, "-textarea"), _defineProperty$4({}, "".concat(prefixCls, "-textarea-rtl"), direction === "rtl"), "".concat(prefixCls, "-textarea-show-count"), className),
      style: style2,
      "data-count": dataCount
    }, textareaNode);
  }
  return textareaNode;
});
var EyeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "eye", "theme": "outlined" };
var EyeOutlined = function EyeOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: EyeOutlined$2
  }));
};
EyeOutlined.displayName = "EyeOutlined";
var EyeOutlined$1 = /* @__PURE__ */ React.forwardRef(EyeOutlined);
var EyeInvisibleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, "name": "eye-invisible", "theme": "outlined" };
var EyeInvisibleOutlined = function EyeInvisibleOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: EyeInvisibleOutlined$2
  }));
};
EyeInvisibleOutlined.displayName = "EyeInvisibleOutlined";
var EyeInvisibleOutlined$1 = /* @__PURE__ */ React.forwardRef(EyeInvisibleOutlined);
var __rest$v = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var ActionMap = {
  click: "onClick",
  hover: "onMouseOver"
};
var Password = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var _useState = useState2(false), _useState2 = _slicedToArray$3(_useState, 2), visible = _useState2[0], setVisible = _useState2[1];
  var onVisibleChange = function onVisibleChange2() {
    var disabled = props.disabled;
    if (disabled) {
      return;
    }
    setVisible(!visible);
  };
  var getIcon2 = function getIcon3(prefixCls) {
    var _iconProps;
    var action = props.action, _props$iconRender = props.iconRender, iconRender2 = _props$iconRender === void 0 ? function() {
      return null;
    } : _props$iconRender;
    var iconTrigger = ActionMap[action] || "";
    var icon = iconRender2(visible);
    var iconProps = (_iconProps = {}, _defineProperty$4(_iconProps, iconTrigger, onVisibleChange), _defineProperty$4(_iconProps, "className", "".concat(prefixCls, "-icon")), _defineProperty$4(_iconProps, "key", "passwordIcon"), _defineProperty$4(_iconProps, "onMouseDown", function onMouseDown(e3) {
      e3.preventDefault();
    }), _defineProperty$4(_iconProps, "onMouseUp", function onMouseUp(e3) {
      e3.preventDefault();
    }), _iconProps);
    return /* @__PURE__ */ React.cloneElement(/* @__PURE__ */ React.isValidElement(icon) ? icon : /* @__PURE__ */ React.createElement("span", null, icon), iconProps);
  };
  var renderPassword = function renderPassword2(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var className = props.className, customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, size = props.size, visibilityToggle = props.visibilityToggle, restProps = __rest$v(props, ["className", "prefixCls", "inputPrefixCls", "size", "visibilityToggle"]);
    var inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
    var prefixCls = getPrefixCls("input-password", customizePrefixCls);
    var suffixIcon = visibilityToggle && getIcon2(prefixCls);
    var inputClassName = cn(prefixCls, className, _defineProperty$4({}, "".concat(prefixCls, "-").concat(size), !!size));
    var omittedProps = _extends$2(_extends$2({}, omit$1(restProps, ["suffix", "iconRender"])), {
      type: visible ? "text" : "password",
      className: inputClassName,
      prefixCls: inputPrefixCls,
      suffix: suffixIcon
    });
    if (size) {
      omittedProps.size = size;
    }
    return /* @__PURE__ */ React.createElement(Input$1, _extends$2({
      ref
    }, omittedProps));
  };
  return /* @__PURE__ */ React.createElement(ConfigConsumer, null, renderPassword);
});
Password.defaultProps = {
  action: "click",
  visibilityToggle: true,
  iconRender: function iconRender(visible) {
    return visible ? /* @__PURE__ */ React.createElement(EyeOutlined$1, null) : /* @__PURE__ */ React.createElement(EyeInvisibleOutlined$1, null);
  }
};
Password.displayName = "Password";
Input$1.Group = Group$1;
Input$1.Search = Search$1;
Input$1.TextArea = TextArea;
Input$1.Password = Password;
var __rest$u = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var GroupContext = /* @__PURE__ */ React.createContext(null);
var InternalCheckboxGroup = function InternalCheckboxGroup2(_a, ref) {
  var defaultValue = _a.defaultValue, children = _a.children, _a$options = _a.options, options = _a$options === void 0 ? [] : _a$options, customizePrefixCls = _a.prefixCls, className = _a.className, style2 = _a.style, onChange4 = _a.onChange, restProps = __rest$u(_a, ["defaultValue", "children", "options", "prefixCls", "className", "style", "onChange"]);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var _React$useState = React.useState(restProps.value || defaultValue || []), _React$useState2 = _slicedToArray$3(_React$useState, 2), value = _React$useState2[0], setValue2 = _React$useState2[1];
  var _React$useState3 = React.useState([]), _React$useState4 = _slicedToArray$3(_React$useState3, 2), registeredValues = _React$useState4[0], setRegisteredValues = _React$useState4[1];
  React.useEffect(function() {
    if ("value" in restProps) {
      setValue2(restProps.value || []);
    }
  }, [restProps.value]);
  var getOptions2 = function getOptions3() {
    return options.map(function(option) {
      if (typeof option === "string") {
        return {
          label: option,
          value: option
        };
      }
      return option;
    });
  };
  var cancelValue = function cancelValue2(val) {
    setRegisteredValues(function(prevValues) {
      return prevValues.filter(function(v2) {
        return v2 !== val;
      });
    });
  };
  var registerValue = function registerValue2(val) {
    setRegisteredValues(function(prevValues) {
      return [].concat(_toConsumableArray(prevValues), [val]);
    });
  };
  var toggleOption = function toggleOption2(option) {
    var optionIndex = value.indexOf(option.value);
    var newValue = _toConsumableArray(value);
    if (optionIndex === -1) {
      newValue.push(option.value);
    } else {
      newValue.splice(optionIndex, 1);
    }
    if (!("value" in restProps)) {
      setValue2(newValue);
    }
    var opts = getOptions2();
    onChange4 === null || onChange4 === void 0 ? void 0 : onChange4(newValue.filter(function(val) {
      return registeredValues.indexOf(val) !== -1;
    }).sort(function(a2, b2) {
      var indexA = opts.findIndex(function(opt) {
        return opt.value === a2;
      });
      var indexB = opts.findIndex(function(opt) {
        return opt.value === b2;
      });
      return indexA - indexB;
    }));
  };
  var prefixCls = getPrefixCls("checkbox", customizePrefixCls);
  var groupPrefixCls = "".concat(prefixCls, "-group");
  var domProps = omit$1(restProps, ["value", "disabled"]);
  if (options && options.length > 0) {
    children = getOptions2().map(function(option) {
      return /* @__PURE__ */ React.createElement(Checkbox$1, {
        prefixCls,
        key: option.value.toString(),
        disabled: "disabled" in option ? option.disabled : restProps.disabled,
        value: option.value,
        checked: value.indexOf(option.value) !== -1,
        onChange: option.onChange,
        className: "".concat(groupPrefixCls, "-item"),
        style: option.style
      }, option.label);
    });
  }
  var context2 = {
    toggleOption,
    value,
    disabled: restProps.disabled,
    name: restProps.name,
    registerValue,
    cancelValue
  };
  var classString = cn(groupPrefixCls, _defineProperty$4({}, "".concat(groupPrefixCls, "-rtl"), direction === "rtl"), className);
  return /* @__PURE__ */ React.createElement("div", _extends$2({
    className: classString,
    style: style2
  }, domProps, {
    ref
  }), /* @__PURE__ */ React.createElement(GroupContext.Provider, {
    value: context2
  }, children));
};
var CheckboxGroup = /* @__PURE__ */ React.forwardRef(InternalCheckboxGroup);
var Group3 = /* @__PURE__ */ React.memo(CheckboxGroup);
var __rest$t = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var InternalCheckbox = function InternalCheckbox2(_a, ref) {
  var _classNames;
  var customizePrefixCls = _a.prefixCls, className = _a.className, children = _a.children, _a$indeterminate = _a.indeterminate, indeterminate = _a$indeterminate === void 0 ? false : _a$indeterminate, style2 = _a.style, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, _a$skipGroup = _a.skipGroup, skipGroup = _a$skipGroup === void 0 ? false : _a$skipGroup, restProps = __rest$t(_a, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup"]);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var checkboxGroup = React.useContext(GroupContext);
  var prevValue = React.useRef(restProps.value);
  React.useEffect(function() {
    checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
    devWarning("checked" in restProps || !!checkboxGroup || !("value" in restProps), "Checkbox", "`value` is not a valid prop, do you mean `checked`?");
  }, []);
  React.useEffect(function() {
    if (skipGroup) {
      return;
    }
    if (restProps.value !== prevValue.current) {
      checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(prevValue.current);
      checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
    }
    return function() {
      return checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
    };
  }, [restProps.value]);
  var prefixCls = getPrefixCls("checkbox", customizePrefixCls);
  var checkboxProps = _extends$2({}, restProps);
  if (checkboxGroup && !skipGroup) {
    checkboxProps.onChange = function() {
      if (restProps.onChange) {
        restProps.onChange.apply(restProps, arguments);
      }
      if (checkboxGroup.toggleOption) {
        checkboxGroup.toggleOption({
          label: children,
          value: restProps.value
        });
      }
    };
    checkboxProps.name = checkboxGroup.name;
    checkboxProps.checked = checkboxGroup.value.indexOf(restProps.value) !== -1;
    checkboxProps.disabled = restProps.disabled || checkboxGroup.disabled;
  }
  var classString = cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _defineProperty$4(_classNames, "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), _defineProperty$4(_classNames, "".concat(prefixCls, "-wrapper-disabled"), checkboxProps.disabled), _classNames), className);
  var checkboxClass = cn(_defineProperty$4({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
  return /* @__PURE__ */ React.createElement("label", {
    className: classString,
    style: style2,
    onMouseEnter,
    onMouseLeave
  }, /* @__PURE__ */ React.createElement(Checkbox$2, _extends$2({}, checkboxProps, {
    prefixCls,
    className: checkboxClass,
    ref
  })), children !== void 0 && /* @__PURE__ */ React.createElement("span", null, children));
};
var Checkbox$1 = /* @__PURE__ */ React.forwardRef(InternalCheckbox);
Checkbox$1.displayName = "Checkbox";
var Checkbox = Checkbox$1;
Checkbox.Group = Group3;
Checkbox.__ANT_CHECKBOX = true;
function PickerButton(props) {
  return /* @__PURE__ */ React.createElement(Button$1, _extends$2({
    size: "small",
    type: "primary"
  }, props));
}
var __rest$s = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var CheckableTag = function CheckableTag2(_a) {
  var _classNames;
  var customizePrefixCls = _a.prefixCls, className = _a.className, checked = _a.checked, onChange4 = _a.onChange, onClick = _a.onClick, restProps = __rest$s(_a, ["prefixCls", "className", "checked", "onChange", "onClick"]);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
  var handleClick = function handleClick2(e3) {
    onChange4 === null || onChange4 === void 0 ? void 0 : onChange4(!checked);
    onClick === null || onClick === void 0 ? void 0 : onClick(e3);
  };
  var prefixCls = getPrefixCls("tag", customizePrefixCls);
  var cls = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-checkable"), true), _defineProperty$4(_classNames, "".concat(prefixCls, "-checkable-checked"), checked), _classNames), className);
  return /* @__PURE__ */ React.createElement("span", _extends$2({}, restProps, {
    className: cls,
    onClick: handleClick
  }));
};
var __rest$r = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var PresetColorRegex = new RegExp("^(".concat(PresetColorTypes.join("|"), ")(-inverse)?$"));
var PresetStatusColorRegex = new RegExp("^(".concat(PresetStatusColorTypes.join("|"), ")$"));
var InternalTag = function InternalTag2(_a, ref) {
  var _classNames;
  var customizePrefixCls = _a.prefixCls, className = _a.className, style2 = _a.style, children = _a.children, icon = _a.icon, color = _a.color, onClose2 = _a.onClose, closeIcon2 = _a.closeIcon, _a$closable = _a.closable, closable = _a$closable === void 0 ? false : _a$closable, props = __rest$r(_a, ["prefixCls", "className", "style", "children", "icon", "color", "onClose", "closeIcon", "closable"]);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var _React$useState = React.useState(true), _React$useState2 = _slicedToArray$3(_React$useState, 2), visible = _React$useState2[0], setVisible = _React$useState2[1];
  React.useEffect(function() {
    if ("visible" in props) {
      setVisible(props.visible);
    }
  }, [props.visible]);
  var isPresetColor = function isPresetColor2() {
    if (!color) {
      return false;
    }
    return PresetColorRegex.test(color) || PresetStatusColorRegex.test(color);
  };
  var tagStyle = _extends$2({
    backgroundColor: color && !isPresetColor() ? color : void 0
  }, style2);
  var presetColor = isPresetColor();
  var prefixCls = getPrefixCls("tag", customizePrefixCls);
  var tagClassName = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(color), presetColor), _defineProperty$4(_classNames, "".concat(prefixCls, "-has-color"), color && !presetColor), _defineProperty$4(_classNames, "".concat(prefixCls, "-hidden"), !visible), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
  var handleCloseClick = function handleCloseClick2(e3) {
    e3.stopPropagation();
    onClose2 === null || onClose2 === void 0 ? void 0 : onClose2(e3);
    if (e3.defaultPrevented) {
      return;
    }
    if (!("visible" in props)) {
      setVisible(false);
    }
  };
  var renderCloseIcon = function renderCloseIcon2() {
    if (closable) {
      return closeIcon2 ? /* @__PURE__ */ React.createElement("span", {
        className: "".concat(prefixCls, "-close-icon"),
        onClick: handleCloseClick
      }, closeIcon2) : /* @__PURE__ */ React.createElement(CloseOutlined$1, {
        className: "".concat(prefixCls, "-close-icon"),
        onClick: handleCloseClick
      });
    }
    return null;
  };
  var isNeedWave = "onClick" in props || children && children.type === "a";
  var tagProps = omit$1(props, ["visible"]);
  var iconNode = icon || null;
  var kids = iconNode ? /* @__PURE__ */ React.createElement(React.Fragment, null, iconNode, /* @__PURE__ */ React.createElement("span", null, children)) : children;
  var tagNode = /* @__PURE__ */ React.createElement("span", _extends$2({}, tagProps, {
    ref,
    className: tagClassName,
    style: tagStyle
  }), kids, renderCloseIcon());
  return isNeedWave ? /* @__PURE__ */ React.createElement(Wave, null, tagNode) : tagNode;
};
var Tag = /* @__PURE__ */ React.forwardRef(InternalTag);
Tag.displayName = "Tag";
Tag.CheckableTag = CheckableTag;
function PickerTag(props) {
  return /* @__PURE__ */ React.createElement(Tag, _extends$2({
    color: "blue"
  }, props));
}
var CalendarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, "name": "calendar", "theme": "outlined" };
var CalendarOutlined = function CalendarOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: CalendarOutlined$2
  }));
};
CalendarOutlined.displayName = "CalendarOutlined";
var CalendarOutlined$1 = /* @__PURE__ */ React.forwardRef(CalendarOutlined);
var ClockCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, "name": "clock-circle", "theme": "outlined" };
var ClockCircleOutlined = function ClockCircleOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: ClockCircleOutlined$2
  }));
};
ClockCircleOutlined.displayName = "ClockCircleOutlined";
var ClockCircleOutlined$1 = /* @__PURE__ */ React.forwardRef(ClockCircleOutlined);
function getPlaceholder(picker, locale2, customizePlaceholder) {
  if (customizePlaceholder !== void 0) {
    return customizePlaceholder;
  }
  if (picker === "year" && locale2.lang.yearPlaceholder) {
    return locale2.lang.yearPlaceholder;
  }
  if (picker === "quarter" && locale2.lang.quarterPlaceholder) {
    return locale2.lang.quarterPlaceholder;
  }
  if (picker === "month" && locale2.lang.monthPlaceholder) {
    return locale2.lang.monthPlaceholder;
  }
  if (picker === "week" && locale2.lang.weekPlaceholder) {
    return locale2.lang.weekPlaceholder;
  }
  if (picker === "time" && locale2.timePickerLocale.placeholder) {
    return locale2.timePickerLocale.placeholder;
  }
  return locale2.lang.placeholder;
}
function getRangePlaceholder(picker, locale2, customizePlaceholder) {
  if (customizePlaceholder !== void 0) {
    return customizePlaceholder;
  }
  if (picker === "year" && locale2.lang.yearPlaceholder) {
    return locale2.lang.rangeYearPlaceholder;
  }
  if (picker === "month" && locale2.lang.monthPlaceholder) {
    return locale2.lang.rangeMonthPlaceholder;
  }
  if (picker === "week" && locale2.lang.weekPlaceholder) {
    return locale2.lang.rangeWeekPlaceholder;
  }
  if (picker === "time" && locale2.timePickerLocale.placeholder) {
    return locale2.timePickerLocale.rangePlaceholder;
  }
  return locale2.lang.rangePlaceholder;
}
var __rest$q = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
function generatePicker$1(generateConfig2) {
  function getPicker(picker, displayName) {
    var Picker$1 = /* @__PURE__ */ function(_React$Component) {
      _inherits$1(Picker$12, _React$Component);
      var _super = _createSuper$1(Picker$12);
      function Picker$12(props) {
        var _this2;
        _classCallCheck$2(this, Picker$12);
        _this2 = _super.call(this, props);
        _this2.pickerRef = /* @__PURE__ */ React.createRef();
        _this2.focus = function() {
          if (_this2.pickerRef.current) {
            _this2.pickerRef.current.focus();
          }
        };
        _this2.blur = function() {
          if (_this2.pickerRef.current) {
            _this2.pickerRef.current.blur();
          }
        };
        _this2.getDefaultLocale = function() {
          var locale$12 = _this2.props.locale;
          var result = _extends$2(_extends$2({}, locale), locale$12);
          result.lang = _extends$2(_extends$2({}, result.lang), (locale$12 || {}).lang);
          return result;
        };
        _this2.renderPicker = function(locale2) {
          var _this$context = _this2.context, getPrefixCls = _this$context.getPrefixCls, direction = _this$context.direction, getPopupContainer = _this$context.getPopupContainer;
          var _a = _this2.props, customizePrefixCls = _a.prefixCls, customizeGetPopupContainer = _a.getPopupContainer, className = _a.className, customizeSize = _a.size, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? true : _a$bordered, placeholder = _a.placeholder, restProps = __rest$q(_a, ["prefixCls", "getPopupContainer", "className", "size", "bordered", "placeholder"]);
          var _this$props = _this2.props, format3 = _this$props.format, showTime = _this$props.showTime;
          var prefixCls = getPrefixCls("picker", customizePrefixCls);
          var additionalProps = {
            showToday: true
          };
          var additionalOverrideProps = {};
          if (picker) {
            additionalOverrideProps.picker = picker;
          }
          var mergedPicker = picker || _this2.props.picker;
          additionalOverrideProps = _extends$2(_extends$2(_extends$2({}, additionalOverrideProps), showTime ? getTimeProps(_extends$2({
            format: format3,
            picker: mergedPicker
          }, showTime)) : {}), mergedPicker === "time" ? getTimeProps(_extends$2(_extends$2({
            format: format3
          }, _this2.props), {
            picker: mergedPicker
          })) : {});
          var rootPrefixCls = getPrefixCls();
          return /* @__PURE__ */ React.createElement(SizeContext$1.Consumer, null, function(size) {
            var _classNames;
            var mergedSize = customizeSize || size;
            return /* @__PURE__ */ React.createElement(Picker, _extends$2({
              ref: _this2.pickerRef,
              placeholder: getPlaceholder(mergedPicker, locale2, placeholder),
              suffixIcon: mergedPicker === "time" ? /* @__PURE__ */ React.createElement(ClockCircleOutlined$1, null) : /* @__PURE__ */ React.createElement(CalendarOutlined$1, null),
              clearIcon: /* @__PURE__ */ React.createElement(CloseCircleFilled$1, null),
              allowClear: true,
              transitionName: "".concat(rootPrefixCls, "-slide-up")
            }, additionalProps, restProps, additionalOverrideProps, {
              locale: locale2.lang,
              className: cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), _defineProperty$4(_classNames, "".concat(prefixCls, "-borderless"), !bordered), _classNames), className),
              prefixCls,
              getPopupContainer: customizeGetPopupContainer || getPopupContainer,
              generateConfig: generateConfig2,
              prevIcon: /* @__PURE__ */ React.createElement("span", {
                className: "".concat(prefixCls, "-prev-icon")
              }),
              nextIcon: /* @__PURE__ */ React.createElement("span", {
                className: "".concat(prefixCls, "-next-icon")
              }),
              superPrevIcon: /* @__PURE__ */ React.createElement("span", {
                className: "".concat(prefixCls, "-super-prev-icon")
              }),
              superNextIcon: /* @__PURE__ */ React.createElement("span", {
                className: "".concat(prefixCls, "-super-next-icon")
              }),
              components: Components,
              direction
            }));
          });
        };
        devWarning(picker !== "quarter", displayName, "DatePicker.".concat(displayName, " is legacy usage. Please use DatePicker[picker='").concat(picker, "'] directly."));
        return _this2;
      }
      _createClass$2(Picker$12, [{
        key: "render",
        value: function render4() {
          return /* @__PURE__ */ React.createElement(LocaleReceiver, {
            componentName: "DatePicker",
            defaultLocale: this.getDefaultLocale
          }, this.renderPicker);
        }
      }]);
      return Picker$12;
    }(React.Component);
    Picker$1.contextType = ConfigContext;
    if (displayName) {
      Picker$1.displayName = displayName;
    }
    return Picker$1;
  }
  var DatePicker2 = getPicker();
  var WeekPicker = getPicker("week", "WeekPicker");
  var MonthPicker = getPicker("month", "MonthPicker");
  var YearPicker = getPicker("year", "YearPicker");
  var TimePicker2 = getPicker("time", "TimePicker");
  var QuarterPicker = getPicker("quarter", "QuarterPicker");
  return {
    DatePicker: DatePicker2,
    WeekPicker,
    MonthPicker,
    YearPicker,
    TimePicker: TimePicker2,
    QuarterPicker
  };
}
var SwapRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, "name": "swap-right", "theme": "outlined" };
var SwapRightOutlined = function SwapRightOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: SwapRightOutlined$2
  }));
};
SwapRightOutlined.displayName = "SwapRightOutlined";
var SwapRightOutlined$1 = /* @__PURE__ */ React.forwardRef(SwapRightOutlined);
var __rest$p = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
function generateRangePicker(generateConfig2) {
  var RangePicker2 = /* @__PURE__ */ function(_React$Component) {
    _inherits$1(RangePicker3, _React$Component);
    var _super = _createSuper$1(RangePicker3);
    function RangePicker3() {
      var _this2;
      _classCallCheck$2(this, RangePicker3);
      _this2 = _super.apply(this, arguments);
      _this2.pickerRef = /* @__PURE__ */ React.createRef();
      _this2.focus = function() {
        if (_this2.pickerRef.current) {
          _this2.pickerRef.current.focus();
        }
      };
      _this2.blur = function() {
        if (_this2.pickerRef.current) {
          _this2.pickerRef.current.blur();
        }
      };
      _this2.getDefaultLocale = function() {
        var locale$12 = _this2.props.locale;
        var result = _extends$2(_extends$2({}, locale), locale$12);
        result.lang = _extends$2(_extends$2({}, result.lang), (locale$12 || {}).lang);
        return result;
      };
      _this2.renderPicker = function(locale2) {
        var _this$context = _this2.context, getPrefixCls = _this$context.getPrefixCls, direction = _this$context.direction, getPopupContainer = _this$context.getPopupContainer;
        var _a = _this2.props, customizePrefixCls = _a.prefixCls, customGetPopupContainer = _a.getPopupContainer, className = _a.className, customizeSize = _a.size, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? true : _a$bordered, placeholder = _a.placeholder, restProps = __rest$p(_a, ["prefixCls", "getPopupContainer", "className", "size", "bordered", "placeholder"]);
        var _this$props = _this2.props, format3 = _this$props.format, showTime = _this$props.showTime, picker = _this$props.picker;
        var prefixCls = getPrefixCls("picker", customizePrefixCls);
        var additionalOverrideProps = {};
        additionalOverrideProps = _extends$2(_extends$2(_extends$2({}, additionalOverrideProps), showTime ? getTimeProps(_extends$2({
          format: format3,
          picker
        }, showTime)) : {}), picker === "time" ? getTimeProps(_extends$2(_extends$2({
          format: format3
        }, _this2.props), {
          picker
        })) : {});
        var rootPrefixCls = getPrefixCls();
        return /* @__PURE__ */ React.createElement(SizeContext$1.Consumer, null, function(size) {
          var _classNames;
          var mergedSize = customizeSize || size;
          return /* @__PURE__ */ React.createElement(RangePicker$1, _extends$2({
            separator: /* @__PURE__ */ React.createElement("span", {
              "aria-label": "to",
              className: "".concat(prefixCls, "-separator")
            }, /* @__PURE__ */ React.createElement(SwapRightOutlined$1, null)),
            ref: _this2.pickerRef,
            placeholder: getRangePlaceholder(picker, locale2, placeholder),
            suffixIcon: picker === "time" ? /* @__PURE__ */ React.createElement(ClockCircleOutlined$1, null) : /* @__PURE__ */ React.createElement(CalendarOutlined$1, null),
            clearIcon: /* @__PURE__ */ React.createElement(CloseCircleFilled$1, null),
            allowClear: true,
            transitionName: "".concat(rootPrefixCls, "-slide-up")
          }, restProps, additionalOverrideProps, {
            className: cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), _defineProperty$4(_classNames, "".concat(prefixCls, "-borderless"), !bordered), _classNames), className),
            locale: locale2.lang,
            prefixCls,
            getPopupContainer: customGetPopupContainer || getPopupContainer,
            generateConfig: generateConfig2,
            prevIcon: /* @__PURE__ */ React.createElement("span", {
              className: "".concat(prefixCls, "-prev-icon")
            }),
            nextIcon: /* @__PURE__ */ React.createElement("span", {
              className: "".concat(prefixCls, "-next-icon")
            }),
            superPrevIcon: /* @__PURE__ */ React.createElement("span", {
              className: "".concat(prefixCls, "-super-prev-icon")
            }),
            superNextIcon: /* @__PURE__ */ React.createElement("span", {
              className: "".concat(prefixCls, "-super-next-icon")
            }),
            components: Components,
            direction
          }));
        });
      };
      return _this2;
    }
    _createClass$2(RangePicker3, [{
      key: "render",
      value: function render4() {
        return /* @__PURE__ */ React.createElement(LocaleReceiver, {
          componentName: "DatePicker",
          defaultLocale: this.getDefaultLocale
        }, this.renderPicker);
      }
    }]);
    return RangePicker3;
  }(React.Component);
  RangePicker2.contextType = ConfigContext;
  return RangePicker2;
}
var Components = {
  button: PickerButton,
  rangeItem: PickerTag
};
function toArray$4(list) {
  if (!list) {
    return [];
  }
  return Array.isArray(list) ? list : [list];
}
function getTimeProps(props) {
  var format3 = props.format, picker = props.picker, showHour = props.showHour, showMinute = props.showMinute, showSecond = props.showSecond, use12Hours = props.use12Hours;
  var firstFormat = toArray$4(format3)[0];
  var showTimeObj = _extends$2({}, props);
  if (firstFormat && typeof firstFormat === "string") {
    if (!firstFormat.includes("s") && showSecond === void 0) {
      showTimeObj.showSecond = false;
    }
    if (!firstFormat.includes("m") && showMinute === void 0) {
      showTimeObj.showMinute = false;
    }
    if (!firstFormat.includes("H") && !firstFormat.includes("h") && showHour === void 0) {
      showTimeObj.showHour = false;
    }
    if ((firstFormat.includes("a") || firstFormat.includes("A")) && use12Hours === void 0) {
      showTimeObj.use12Hours = true;
    }
  }
  if (picker === "time") {
    return showTimeObj;
  }
  if (typeof firstFormat === "function") {
    delete showTimeObj.format;
  }
  return {
    showTime: showTimeObj
  };
}
function generatePicker(generateConfig2) {
  var _generateSinglePicker = generatePicker$1(generateConfig2), DatePicker2 = _generateSinglePicker.DatePicker, WeekPicker = _generateSinglePicker.WeekPicker, MonthPicker = _generateSinglePicker.MonthPicker, YearPicker = _generateSinglePicker.YearPicker, TimePicker2 = _generateSinglePicker.TimePicker, QuarterPicker = _generateSinglePicker.QuarterPicker;
  var RangePicker2 = generateRangePicker(generateConfig2);
  var MergedDatePicker = DatePicker2;
  MergedDatePicker.WeekPicker = WeekPicker;
  MergedDatePicker.MonthPicker = MonthPicker;
  MergedDatePicker.YearPicker = YearPicker;
  MergedDatePicker.RangePicker = RangePicker2;
  MergedDatePicker.TimePicker = TimePicker2;
  MergedDatePicker.QuarterPicker = QuarterPicker;
  return MergedDatePicker;
}
var DatePicker = generatePicker(generateConfig);
var cached;
function getScrollBarSize(fresh) {
  if (typeof document === "undefined") {
    return 0;
  }
  if (fresh || cached === void 0) {
    var inner = document.createElement("div");
    inner.style.width = "100%";
    inner.style.height = "200px";
    var outer = document.createElement("div");
    var outerStyle = outer.style;
    outerStyle.position = "absolute";
    outerStyle.top = "0";
    outerStyle.left = "0";
    outerStyle.pointerEvents = "none";
    outerStyle.visibility = "hidden";
    outerStyle.width = "200px";
    outerStyle.height = "150px";
    outerStyle.overflow = "hidden";
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = "scroll";
    var widthScroll = inner.offsetWidth;
    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }
    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }
  return cached;
}
function setStyle2(style2) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!style2) {
    return {};
  }
  var _options$element = options.element, element = _options$element === void 0 ? document.body : _options$element;
  var oldStyle = {};
  var styleKeys = Object.keys(style2);
  styleKeys.forEach(function(key2) {
    oldStyle[key2] = element.style[key2];
  });
  styleKeys.forEach(function(key2) {
    element.style[key2] = style2[key2];
  });
  return oldStyle;
}
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var cacheStyle$1 = {};
var switchScrollingEffect = function(close) {
  if (!isBodyOverflowing() && !close) {
    return;
  }
  var scrollingEffectClassName2 = "ant-scrolling-effect";
  var scrollingEffectClassNameReg2 = new RegExp("".concat(scrollingEffectClassName2), "g");
  var bodyClassName = document.body.className;
  if (close) {
    if (!scrollingEffectClassNameReg2.test(bodyClassName))
      return;
    setStyle2(cacheStyle$1);
    cacheStyle$1 = {};
    document.body.className = bodyClassName.replace(scrollingEffectClassNameReg2, "").trim();
    return;
  }
  var scrollBarSize = getScrollBarSize();
  if (scrollBarSize) {
    cacheStyle$1 = setStyle2({
      position: "relative",
      width: "calc(100% - ".concat(scrollBarSize, "px)")
    });
    if (!scrollingEffectClassNameReg2.test(bodyClassName)) {
      var addClassName = "".concat(bodyClassName, " ").concat(scrollingEffectClassName2);
      document.body.className = addClassName.trim();
    }
  }
};
var locks = [];
var scrollingEffectClassName = "ant-scrolling-effect";
var scrollingEffectClassNameReg = new RegExp("".concat(scrollingEffectClassName), "g");
var uuid = 0;
var cacheStyle = /* @__PURE__ */ new Map();
var ScrollLocker = /* @__PURE__ */ _createClass$2(function ScrollLocker2(_options) {
  var _this2 = this;
  _classCallCheck$2(this, ScrollLocker2);
  this.lockTarget = void 0;
  this.options = void 0;
  this.getContainer = function() {
    var _this$options;
    return (_this$options = _this2.options) === null || _this$options === void 0 ? void 0 : _this$options.container;
  };
  this.reLock = function(options) {
    var findLock = locks.find(function(_ref) {
      var target = _ref.target;
      return target === _this2.lockTarget;
    });
    if (findLock) {
      _this2.unLock();
    }
    _this2.options = options;
    if (findLock) {
      findLock.options = options;
      _this2.lock();
    }
  };
  this.lock = function() {
    var _this$options3;
    if (locks.some(function(_ref2) {
      var target = _ref2.target;
      return target === _this2.lockTarget;
    })) {
      return;
    }
    if (locks.some(function(_ref3) {
      var _this$options2;
      var options = _ref3.options;
      return (options === null || options === void 0 ? void 0 : options.container) === ((_this$options2 = _this2.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.container);
    })) {
      locks = [].concat(_toConsumableArray(locks), [{
        target: _this2.lockTarget,
        options: _this2.options
      }]);
      return;
    }
    var scrollBarSize = 0;
    var container = ((_this$options3 = _this2.options) === null || _this$options3 === void 0 ? void 0 : _this$options3.container) || document.body;
    if (container === document.body && window.innerWidth - document.documentElement.clientWidth > 0 || container.scrollHeight > container.clientHeight) {
      scrollBarSize = getScrollBarSize();
    }
    var containerClassName = container.className;
    if (locks.filter(function(_ref4) {
      var _this$options4;
      var options = _ref4.options;
      return (options === null || options === void 0 ? void 0 : options.container) === ((_this$options4 = _this2.options) === null || _this$options4 === void 0 ? void 0 : _this$options4.container);
    }).length === 0) {
      cacheStyle.set(container, setStyle2({
        width: scrollBarSize !== 0 ? "calc(100% - ".concat(scrollBarSize, "px)") : void 0,
        overflow: "hidden",
        overflowX: "hidden",
        overflowY: "hidden"
      }, {
        element: container
      }));
    }
    if (!scrollingEffectClassNameReg.test(containerClassName)) {
      var addClassName = "".concat(containerClassName, " ").concat(scrollingEffectClassName);
      container.className = addClassName.trim();
    }
    locks = [].concat(_toConsumableArray(locks), [{
      target: _this2.lockTarget,
      options: _this2.options
    }]);
  };
  this.unLock = function() {
    var _this$options5;
    var findLock = locks.find(function(_ref5) {
      var target = _ref5.target;
      return target === _this2.lockTarget;
    });
    locks = locks.filter(function(_ref6) {
      var target = _ref6.target;
      return target !== _this2.lockTarget;
    });
    if (!findLock || locks.some(function(_ref7) {
      var _findLock$options;
      var options = _ref7.options;
      return (options === null || options === void 0 ? void 0 : options.container) === ((_findLock$options = findLock.options) === null || _findLock$options === void 0 ? void 0 : _findLock$options.container);
    })) {
      return;
    }
    var container = ((_this$options5 = _this2.options) === null || _this$options5 === void 0 ? void 0 : _this$options5.container) || document.body;
    var containerClassName = container.className;
    if (!scrollingEffectClassNameReg.test(containerClassName))
      return;
    setStyle2(cacheStyle.get(container), {
      element: container
    });
    cacheStyle.delete(container);
    container.className = container.className.replace(scrollingEffectClassNameReg, "").trim();
  };
  this.lockTarget = uuid++;
  this.options = _options;
});
var openCount = 0;
var supportDom = canUseDom();
var cacheOverflow = {};
var getParent2 = function getParent3(getContainer2) {
  if (!supportDom) {
    return null;
  }
  if (getContainer2) {
    if (typeof getContainer2 === "string") {
      return document.querySelectorAll(getContainer2)[0];
    }
    if (typeof getContainer2 === "function") {
      return getContainer2();
    }
    if (_typeof$5(getContainer2) === "object" && getContainer2 instanceof window.HTMLElement) {
      return getContainer2;
    }
  }
  return document.body;
};
var PortalWrapper = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(PortalWrapper2, _React$Component);
  var _super = _createSuper$1(PortalWrapper2);
  function PortalWrapper2(props) {
    var _this2;
    _classCallCheck$2(this, PortalWrapper2);
    _this2 = _super.call(this, props);
    _this2.container = void 0;
    _this2.componentRef = /* @__PURE__ */ React.createRef();
    _this2.rafId = void 0;
    _this2.scrollLocker = void 0;
    _this2.renderComponent = void 0;
    _this2.updateScrollLocker = function(prevProps) {
      var _ref = prevProps || {}, prevVisible = _ref.visible;
      var _this$props = _this2.props, getContainer2 = _this$props.getContainer, visible = _this$props.visible;
      if (visible && visible !== prevVisible && supportDom && getParent2(getContainer2) !== _this2.scrollLocker.getContainer()) {
        _this2.scrollLocker.reLock({
          container: getParent2(getContainer2)
        });
      }
    };
    _this2.updateOpenCount = function(prevProps) {
      var _ref2 = prevProps || {}, prevVisible = _ref2.visible, prevGetContainer = _ref2.getContainer;
      var _this$props2 = _this2.props, visible = _this$props2.visible, getContainer2 = _this$props2.getContainer;
      if (visible !== prevVisible && supportDom && getParent2(getContainer2) === document.body) {
        if (visible && !prevVisible) {
          openCount += 1;
        } else if (prevProps) {
          openCount -= 1;
        }
      }
      var getContainerIsFunc = typeof getContainer2 === "function" && typeof prevGetContainer === "function";
      if (getContainerIsFunc ? getContainer2.toString() !== prevGetContainer.toString() : getContainer2 !== prevGetContainer) {
        _this2.removeCurrentContainer();
      }
    };
    _this2.attachToParent = function() {
      var force = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
      if (force || _this2.container && !_this2.container.parentNode) {
        var parent = getParent2(_this2.props.getContainer);
        if (parent) {
          parent.appendChild(_this2.container);
          return true;
        }
        return false;
      }
      return true;
    };
    _this2.getContainer = function() {
      if (!supportDom) {
        return null;
      }
      if (!_this2.container) {
        _this2.container = document.createElement("div");
        _this2.attachToParent(true);
      }
      _this2.setWrapperClassName();
      return _this2.container;
    };
    _this2.setWrapperClassName = function() {
      var wrapperClassName = _this2.props.wrapperClassName;
      if (_this2.container && wrapperClassName && wrapperClassName !== _this2.container.className) {
        _this2.container.className = wrapperClassName;
      }
    };
    _this2.removeCurrentContainer = function() {
      var _this$container, _this$container$paren;
      (_this$container = _this2.container) === null || _this$container === void 0 ? void 0 : (_this$container$paren = _this$container.parentNode) === null || _this$container$paren === void 0 ? void 0 : _this$container$paren.removeChild(_this2.container);
    };
    _this2.switchScrollingEffect = function() {
      if (openCount === 1 && !Object.keys(cacheOverflow).length) {
        switchScrollingEffect();
        cacheOverflow = setStyle2({
          overflow: "hidden",
          overflowX: "hidden",
          overflowY: "hidden"
        });
      } else if (!openCount) {
        setStyle2(cacheOverflow);
        cacheOverflow = {};
        switchScrollingEffect(true);
      }
    };
    _this2.scrollLocker = new ScrollLocker({
      container: getParent2(props.getContainer)
    });
    return _this2;
  }
  _createClass$2(PortalWrapper2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.updateOpenCount();
      if (!this.attachToParent()) {
        this.rafId = wrapperRaf$1(function() {
          _this2.forceUpdate();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.updateOpenCount(prevProps);
      this.updateScrollLocker(prevProps);
      this.setWrapperClassName();
      this.attachToParent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props3 = this.props, visible = _this$props3.visible, getContainer2 = _this$props3.getContainer;
      if (supportDom && getParent2(getContainer2) === document.body) {
        openCount = visible && openCount ? openCount - 1 : openCount;
      }
      this.removeCurrentContainer();
      wrapperRaf$1.cancel(this.rafId);
    }
  }, {
    key: "render",
    value: function render4() {
      var _this$props4 = this.props, children = _this$props4.children, forceRender = _this$props4.forceRender, visible = _this$props4.visible;
      var portal = null;
      var childProps = {
        getOpenCount: function getOpenCount() {
          return openCount;
        },
        getContainer: this.getContainer,
        switchScrollingEffect: this.switchScrollingEffect,
        scrollLocker: this.scrollLocker
      };
      if (forceRender || visible || this.componentRef.current) {
        portal = /* @__PURE__ */ React.createElement(Portal, {
          getContainer: this.getContainer,
          ref: this.componentRef
        }, children(childProps));
      }
      return portal;
    }
  }]);
  return PortalWrapper2;
}(React.Component);
function dataToArray(vars) {
  if (Array.isArray(vars)) {
    return vars;
  }
  return [vars];
}
var transitionEndObject = {
  transition: "transitionend",
  WebkitTransition: "webkitTransitionEnd",
  MozTransition: "transitionend",
  OTransition: "oTransitionEnd otransitionend"
};
var transitionStr = Object.keys(transitionEndObject).filter(function(key2) {
  if (typeof document === "undefined") {
    return false;
  }
  var html = document.getElementsByTagName("html")[0];
  return key2 in (html ? html.style : {});
})[0];
var transitionEnd = transitionEndObject[transitionStr];
function addEventListener(target, eventType, callback, options) {
  if (target.addEventListener) {
    target.addEventListener(eventType, callback, options);
  } else if (target.attachEvent) {
    target.attachEvent("on".concat(eventType), callback);
  }
}
function removeEventListener(target, eventType, callback, options) {
  if (target.removeEventListener) {
    target.removeEventListener(eventType, callback, options);
  } else if (target.attachEvent) {
    target.detachEvent("on".concat(eventType), callback);
  }
}
function transformArguments(arg, cb) {
  var result = typeof arg === "function" ? arg(cb) : arg;
  if (Array.isArray(result)) {
    if (result.length === 2) {
      return result;
    }
    return [result[0], result[1]];
  }
  return [result];
}
var isNumeric2 = function isNumeric3(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};
var windowIsUndefined = !(typeof window !== "undefined" && window.document && window.document.createElement);
var getTouchParentScroll = function getTouchParentScroll2(root2, currentTarget, differX, differY) {
  if (!currentTarget || currentTarget === document || currentTarget instanceof Document) {
    return false;
  }
  if (currentTarget === root2.parentNode) {
    return true;
  }
  var isY = Math.max(Math.abs(differX), Math.abs(differY)) === Math.abs(differY);
  var isX = Math.max(Math.abs(differX), Math.abs(differY)) === Math.abs(differX);
  var scrollY = currentTarget.scrollHeight - currentTarget.clientHeight;
  var scrollX = currentTarget.scrollWidth - currentTarget.clientWidth;
  var style2 = document.defaultView.getComputedStyle(currentTarget);
  var overflowY = style2.overflowY === "auto" || style2.overflowY === "scroll";
  var overflowX = style2.overflowX === "auto" || style2.overflowX === "scroll";
  var y2 = scrollY && overflowY;
  var x2 = scrollX && overflowX;
  if (isY && (!y2 || y2 && (currentTarget.scrollTop >= scrollY && differY < 0 || currentTarget.scrollTop <= 0 && differY > 0)) || isX && (!x2 || x2 && (currentTarget.scrollLeft >= scrollX && differX < 0 || currentTarget.scrollLeft <= 0 && differX > 0))) {
    return getTouchParentScroll2(root2, currentTarget.parentNode, differX, differY);
  }
  return false;
};
var currentDrawer = {};
var DrawerChild = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(DrawerChild2, _React$Component);
  var _super = _createSuper$1(DrawerChild2);
  function DrawerChild2(props) {
    var _this2;
    _classCallCheck$2(this, DrawerChild2);
    _this2 = _super.call(this, props);
    _this2.domFocus = function() {
      if (_this2.dom) {
        _this2.dom.focus();
      }
    };
    _this2.removeStartHandler = function(e3) {
      if (e3.touches.length > 1) {
        return;
      }
      _this2.startPos = {
        x: e3.touches[0].clientX,
        y: e3.touches[0].clientY
      };
    };
    _this2.removeMoveHandler = function(e3) {
      if (e3.changedTouches.length > 1) {
        return;
      }
      var currentTarget = e3.currentTarget;
      var differX = e3.changedTouches[0].clientX - _this2.startPos.x;
      var differY = e3.changedTouches[0].clientY - _this2.startPos.y;
      if ((currentTarget === _this2.maskDom || currentTarget === _this2.handlerDom || currentTarget === _this2.contentDom && getTouchParentScroll(currentTarget, e3.target, differX, differY)) && e3.cancelable) {
        e3.preventDefault();
      }
    };
    _this2.transitionEnd = function(e3) {
      var dom = e3.target;
      removeEventListener(dom, transitionEnd, _this2.transitionEnd);
      dom.style.transition = "";
    };
    _this2.onKeyDown = function(e3) {
      if (e3.keyCode === KeyCode.ESC) {
        var onClose2 = _this2.props.onClose;
        e3.stopPropagation();
        if (onClose2) {
          onClose2(e3);
        }
      }
    };
    _this2.onWrapperTransitionEnd = function(e3) {
      var _this$props = _this2.props, open = _this$props.open, afterVisibleChange2 = _this$props.afterVisibleChange;
      if (e3.target === _this2.contentWrapper && e3.propertyName.match(/transform$/)) {
        _this2.dom.style.transition = "";
        if (!open && _this2.getCurrentDrawerSome()) {
          document.body.style.overflowX = "";
          if (_this2.maskDom) {
            _this2.maskDom.style.left = "";
            _this2.maskDom.style.width = "";
          }
        }
        if (afterVisibleChange2) {
          afterVisibleChange2(!!open);
        }
      }
    };
    _this2.openLevelTransition = function() {
      var _this$props2 = _this2.props, open = _this$props2.open, width = _this$props2.width, height = _this$props2.height;
      var _this$getHorizontalBo = _this2.getHorizontalBoolAndPlacementName(), isHorizontal = _this$getHorizontalBo.isHorizontal, placementName = _this$getHorizontalBo.placementName;
      var contentValue = _this2.contentDom ? _this2.contentDom.getBoundingClientRect()[isHorizontal ? "width" : "height"] : 0;
      var value = (isHorizontal ? width : height) || contentValue;
      _this2.setLevelAndScrolling(open, placementName, value);
    };
    _this2.setLevelTransform = function(open, placementName, value, right) {
      var _this$props3 = _this2.props, placement = _this$props3.placement, levelMove = _this$props3.levelMove, duration = _this$props3.duration, ease = _this$props3.ease, showMask = _this$props3.showMask;
      _this2.levelDom.forEach(function(dom) {
        dom.style.transition = "transform ".concat(duration, " ").concat(ease);
        addEventListener(dom, transitionEnd, _this2.transitionEnd);
        var levelValue = open ? value : 0;
        if (levelMove) {
          var $levelMove = transformArguments(levelMove, {
            target: dom,
            open
          });
          levelValue = open ? $levelMove[0] : $levelMove[1] || 0;
        }
        var $value = typeof levelValue === "number" ? "".concat(levelValue, "px") : levelValue;
        var placementPos = placement === "left" || placement === "top" ? $value : "-".concat($value);
        placementPos = showMask && placement === "right" && right ? "calc(".concat(placementPos, " + ").concat(right, "px)") : placementPos;
        dom.style.transform = levelValue ? "".concat(placementName, "(").concat(placementPos, ")") : "";
      });
    };
    _this2.setLevelAndScrolling = function(open, placementName, value) {
      var onChange4 = _this2.props.onChange;
      if (!windowIsUndefined) {
        var right = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth ? getScrollBarSize(true) : 0;
        _this2.setLevelTransform(open, placementName, value, right);
        _this2.toggleScrollingToDrawerAndBody(right);
      }
      if (onChange4) {
        onChange4(open);
      }
    };
    _this2.toggleScrollingToDrawerAndBody = function(right) {
      var _this$props4 = _this2.props, getContainer2 = _this$props4.getContainer, showMask = _this$props4.showMask, open = _this$props4.open;
      var container = getContainer2 && getContainer2();
      if (container && container.parentNode === document.body && showMask) {
        var eventArray = ["touchstart"];
        var domArray = [document.body, _this2.maskDom, _this2.handlerDom, _this2.contentDom];
        if (open && document.body.style.overflow !== "hidden") {
          if (right) {
            _this2.addScrollingEffect(right);
          }
          document.body.style.touchAction = "none";
          domArray.forEach(function(item, i2) {
            if (!item) {
              return;
            }
            addEventListener(item, eventArray[i2] || "touchmove", i2 ? _this2.removeMoveHandler : _this2.removeStartHandler, _this2.passive);
          });
        } else if (_this2.getCurrentDrawerSome()) {
          document.body.style.touchAction = "";
          if (right) {
            _this2.remScrollingEffect(right);
          }
          domArray.forEach(function(item, i2) {
            if (!item) {
              return;
            }
            removeEventListener(item, eventArray[i2] || "touchmove", i2 ? _this2.removeMoveHandler : _this2.removeStartHandler, _this2.passive);
          });
        }
      }
    };
    _this2.addScrollingEffect = function(right) {
      var _this$props5 = _this2.props, placement = _this$props5.placement, duration = _this$props5.duration, ease = _this$props5.ease;
      var widthTransition = "width ".concat(duration, " ").concat(ease);
      var transformTransition = "transform ".concat(duration, " ").concat(ease);
      _this2.dom.style.transition = "none";
      switch (placement) {
        case "right":
          _this2.dom.style.transform = "translateX(-".concat(right, "px)");
          break;
        case "top":
        case "bottom":
          _this2.dom.style.width = "calc(100% - ".concat(right, "px)");
          _this2.dom.style.transform = "translateZ(0)";
          break;
      }
      clearTimeout(_this2.timeout);
      _this2.timeout = setTimeout(function() {
        if (_this2.dom) {
          _this2.dom.style.transition = "".concat(transformTransition, ",").concat(widthTransition);
          _this2.dom.style.width = "";
          _this2.dom.style.transform = "";
        }
      });
    };
    _this2.remScrollingEffect = function(right) {
      var _this$props6 = _this2.props, placement = _this$props6.placement, duration = _this$props6.duration, ease = _this$props6.ease;
      if (transitionStr) {
        document.body.style.overflowX = "hidden";
      }
      _this2.dom.style.transition = "none";
      var heightTransition;
      var widthTransition = "width ".concat(duration, " ").concat(ease);
      var transformTransition = "transform ".concat(duration, " ").concat(ease);
      switch (placement) {
        case "left": {
          _this2.dom.style.width = "100%";
          widthTransition = "width 0s ".concat(ease, " ").concat(duration);
          break;
        }
        case "right": {
          _this2.dom.style.transform = "translateX(".concat(right, "px)");
          _this2.dom.style.width = "100%";
          widthTransition = "width 0s ".concat(ease, " ").concat(duration);
          if (_this2.maskDom) {
            _this2.maskDom.style.left = "-".concat(right, "px");
            _this2.maskDom.style.width = "calc(100% + ".concat(right, "px)");
          }
          break;
        }
        case "top":
        case "bottom": {
          _this2.dom.style.width = "calc(100% + ".concat(right, "px)");
          _this2.dom.style.height = "100%";
          _this2.dom.style.transform = "translateZ(0)";
          heightTransition = "height 0s ".concat(ease, " ").concat(duration);
          break;
        }
      }
      clearTimeout(_this2.timeout);
      _this2.timeout = setTimeout(function() {
        if (_this2.dom) {
          _this2.dom.style.transition = "".concat(transformTransition, ",").concat(heightTransition ? "".concat(heightTransition, ",") : "").concat(widthTransition);
          _this2.dom.style.transform = "";
          _this2.dom.style.width = "";
          _this2.dom.style.height = "";
        }
      });
    };
    _this2.getCurrentDrawerSome = function() {
      return !Object.keys(currentDrawer).some(function(key2) {
        return currentDrawer[key2];
      });
    };
    _this2.getLevelDom = function(_ref) {
      var level = _ref.level, getContainer2 = _ref.getContainer;
      if (windowIsUndefined) {
        return;
      }
      var container = getContainer2 && getContainer2();
      var parent = container ? container.parentNode : null;
      _this2.levelDom = [];
      if (level === "all") {
        var children = parent ? Array.prototype.slice.call(parent.children) : [];
        children.forEach(function(child) {
          if (child.nodeName !== "SCRIPT" && child.nodeName !== "STYLE" && child.nodeName !== "LINK" && child !== container) {
            _this2.levelDom.push(child);
          }
        });
      } else if (level) {
        dataToArray(level).forEach(function(key2) {
          document.querySelectorAll(key2).forEach(function(item) {
            _this2.levelDom.push(item);
          });
        });
      }
    };
    _this2.getHorizontalBoolAndPlacementName = function() {
      var placement = _this2.props.placement;
      var isHorizontal = placement === "left" || placement === "right";
      var placementName = "translate".concat(isHorizontal ? "X" : "Y");
      return {
        isHorizontal,
        placementName
      };
    };
    _this2.state = {
      _self: _assertThisInitialized$1(_this2)
    };
    return _this2;
  }
  _createClass$2(DrawerChild2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (!windowIsUndefined) {
        var passiveSupported = false;
        try {
          window.addEventListener("test", null, Object.defineProperty({}, "passive", {
            get: function get2() {
              passiveSupported = true;
              return null;
            }
          }));
        } catch (err) {
        }
        this.passive = passiveSupported ? {
          passive: false
        } : false;
      }
      var _this$props7 = this.props, open = _this$props7.open, getContainer2 = _this$props7.getContainer, showMask = _this$props7.showMask;
      var container = getContainer2 && getContainer2();
      this.drawerId = "drawer_id_".concat(Number((Date.now() + Math.random()).toString().replace(".", Math.round(Math.random() * 9).toString())).toString(16));
      this.getLevelDom(this.props);
      if (open) {
        if (container && container.parentNode === document.body) {
          currentDrawer[this.drawerId] = open;
        }
        this.openLevelTransition();
        this.forceUpdate(function() {
          _this2.domFocus();
        });
        if (showMask) {
          var _this$props$scrollLoc;
          (_this$props$scrollLoc = this.props.scrollLocker) === null || _this$props$scrollLoc === void 0 ? void 0 : _this$props$scrollLoc.lock();
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props8 = this.props, open = _this$props8.open, getContainer2 = _this$props8.getContainer, scrollLocker = _this$props8.scrollLocker, showMask = _this$props8.showMask;
      var container = getContainer2 && getContainer2();
      if (open !== prevProps.open) {
        if (container && container.parentNode === document.body) {
          currentDrawer[this.drawerId] = !!open;
        }
        this.openLevelTransition();
        if (open) {
          this.domFocus();
          if (showMask) {
            scrollLocker === null || scrollLocker === void 0 ? void 0 : scrollLocker.lock();
          }
        } else {
          scrollLocker === null || scrollLocker === void 0 ? void 0 : scrollLocker.unLock();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props9 = this.props, open = _this$props9.open, scrollLocker = _this$props9.scrollLocker;
      delete currentDrawer[this.drawerId];
      if (open) {
        this.setLevelTransform(false);
        document.body.style.touchAction = "";
      }
      scrollLocker === null || scrollLocker === void 0 ? void 0 : scrollLocker.unLock();
    }
  }, {
    key: "render",
    value: function render4() {
      var _classnames, _this3 = this;
      var _this$props10 = this.props, className = _this$props10.className, children = _this$props10.children, style2 = _this$props10.style, width = _this$props10.width, height = _this$props10.height;
      _this$props10.defaultOpen;
      var $open = _this$props10.open, prefixCls = _this$props10.prefixCls, placement = _this$props10.placement;
      _this$props10.level;
      _this$props10.levelMove;
      _this$props10.ease;
      _this$props10.duration;
      _this$props10.getContainer;
      var handler = _this$props10.handler;
      _this$props10.onChange;
      _this$props10.afterVisibleChange;
      var showMask = _this$props10.showMask, maskClosable = _this$props10.maskClosable, maskStyle = _this$props10.maskStyle, onClose2 = _this$props10.onClose, onHandleClick = _this$props10.onHandleClick, keyboard = _this$props10.keyboard;
      _this$props10.getOpenCount;
      _this$props10.scrollLocker;
      var contentWrapperStyle = _this$props10.contentWrapperStyle, props = _objectWithoutProperties$1(_this$props10, ["className", "children", "style", "width", "height", "defaultOpen", "open", "prefixCls", "placement", "level", "levelMove", "ease", "duration", "getContainer", "handler", "onChange", "afterVisibleChange", "showMask", "maskClosable", "maskStyle", "onClose", "onHandleClick", "keyboard", "getOpenCount", "scrollLocker", "contentWrapperStyle"]);
      var open = this.dom ? $open : false;
      var wrapperClassName = cn(prefixCls, (_classnames = {}, _defineProperty$4(_classnames, "".concat(prefixCls, "-").concat(placement), true), _defineProperty$4(_classnames, "".concat(prefixCls, "-open"), open), _defineProperty$4(_classnames, className || "", !!className), _defineProperty$4(_classnames, "no-mask", !showMask), _classnames));
      var _this$getHorizontalBo2 = this.getHorizontalBoolAndPlacementName(), placementName = _this$getHorizontalBo2.placementName;
      var placementPos = placement === "left" || placement === "top" ? "-100%" : "100%";
      var transform = open ? "" : "".concat(placementName, "(").concat(placementPos, ")");
      var handlerChildren = handler && /* @__PURE__ */ React.cloneElement(handler, {
        onClick: function onClick(e3) {
          if (handler.props.onClick) {
            handler.props.onClick();
          }
          if (onHandleClick) {
            onHandleClick(e3);
          }
        },
        ref: function ref(c2) {
          _this3.handlerDom = c2;
        }
      });
      return /* @__PURE__ */ React.createElement("div", _extends$2({}, omit$1(props, ["switchScrollingEffect"]), {
        tabIndex: -1,
        className: wrapperClassName,
        style: style2,
        ref: function ref(c2) {
          _this3.dom = c2;
        },
        onKeyDown: open && keyboard ? this.onKeyDown : void 0,
        onTransitionEnd: this.onWrapperTransitionEnd
      }), showMask && /* @__PURE__ */ React.createElement("div", {
        className: "".concat(prefixCls, "-mask"),
        onClick: maskClosable ? onClose2 : void 0,
        style: maskStyle,
        ref: function ref(c2) {
          _this3.maskDom = c2;
        }
      }), /* @__PURE__ */ React.createElement("div", {
        className: "".concat(prefixCls, "-content-wrapper"),
        style: _objectSpread2$1({
          transform,
          msTransform: transform,
          width: isNumeric2(width) ? "".concat(width, "px") : width,
          height: isNumeric2(height) ? "".concat(height, "px") : height
        }, contentWrapperStyle),
        ref: function ref(c2) {
          _this3.contentWrapper = c2;
        }
      }, /* @__PURE__ */ React.createElement("div", {
        className: "".concat(prefixCls, "-content"),
        ref: function ref(c2) {
          _this3.contentDom = c2;
        },
        onTouchStart: open && showMask ? this.removeStartHandler : void 0,
        onTouchMove: open && showMask ? this.removeMoveHandler : void 0
      }, children), handlerChildren));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, _ref2) {
      var prevProps = _ref2.prevProps, _self = _ref2._self;
      var nextState = {
        prevProps: props
      };
      if (prevProps !== void 0) {
        var placement = props.placement, level = props.level;
        if (placement !== prevProps.placement) {
          _self.contentDom = null;
        }
        if (level !== prevProps.level) {
          _self.getLevelDom(props);
        }
      }
      return nextState;
    }
  }]);
  return DrawerChild2;
}(React.Component);
var DrawerWrapper$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(DrawerWrapper2, _React$Component);
  var _super = _createSuper$1(DrawerWrapper2);
  function DrawerWrapper2(props) {
    var _this2;
    _classCallCheck$2(this, DrawerWrapper2);
    _this2 = _super.call(this, props);
    _this2.onHandleClick = function(e3) {
      var _this$props = _this2.props, onHandleClick = _this$props.onHandleClick, $open = _this$props.open;
      if (onHandleClick) {
        onHandleClick(e3);
      }
      if (typeof $open === "undefined") {
        var _open = _this2.state.open;
        _this2.setState({
          open: !_open
        });
      }
    };
    _this2.onClose = function(e3) {
      var _this$props2 = _this2.props, onClose2 = _this$props2.onClose, open2 = _this$props2.open;
      if (onClose2) {
        onClose2(e3);
      }
      if (typeof open2 === "undefined") {
        _this2.setState({
          open: false
        });
      }
    };
    var open = typeof props.open !== "undefined" ? props.open : !!props.defaultOpen;
    _this2.state = {
      open
    };
    if ("onMaskClick" in props) {
      console.warn("`onMaskClick` are removed, please use `onClose` instead.");
    }
    return _this2;
  }
  _createClass$2(DrawerWrapper2, [{
    key: "render",
    value: function render4() {
      var _this2 = this;
      var _this$props3 = this.props;
      _this$props3.defaultOpen;
      var getContainer2 = _this$props3.getContainer, wrapperClassName = _this$props3.wrapperClassName, forceRender = _this$props3.forceRender, handler = _this$props3.handler, props = _objectWithoutProperties$1(_this$props3, ["defaultOpen", "getContainer", "wrapperClassName", "forceRender", "handler"]);
      var open = this.state.open;
      if (!getContainer2) {
        return /* @__PURE__ */ React.createElement("div", {
          className: wrapperClassName,
          ref: function ref(c2) {
            _this2.dom = c2;
          }
        }, /* @__PURE__ */ React.createElement(DrawerChild, _extends$2({}, props, {
          open,
          handler,
          getContainer: function getContainer3() {
            return _this2.dom;
          },
          onClose: this.onClose,
          onHandleClick: this.onHandleClick
        })));
      }
      var $forceRender = !!handler || forceRender;
      return /* @__PURE__ */ React.createElement(PortalWrapper, {
        visible: open,
        forceRender: $forceRender,
        getContainer: getContainer2,
        wrapperClassName
      }, function(_ref) {
        var visible = _ref.visible, afterClose = _ref.afterClose, rest = _objectWithoutProperties$1(_ref, ["visible", "afterClose"]);
        return /* @__PURE__ */ React.createElement(DrawerChild, _extends$2({}, props, rest, {
          open: visible !== void 0 ? visible : open,
          afterVisibleChange: afterClose !== void 0 ? afterClose : props.afterVisibleChange,
          handler,
          onClose: _this2.onClose,
          onHandleClick: _this2.onHandleClick
        }));
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, _ref2) {
      var prevProps = _ref2.prevProps;
      var newState = {
        prevProps: props
      };
      if (typeof prevProps !== "undefined" && props.open !== prevProps.open) {
        newState.open = props.open;
      }
      return newState;
    }
  }]);
  return DrawerWrapper2;
}(React.Component);
DrawerWrapper$1.defaultProps = {
  prefixCls: "drawer",
  placement: "left",
  getContainer: "body",
  defaultOpen: false,
  level: "all",
  duration: ".3s",
  ease: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  onChange: function onChange3() {
  },
  afterVisibleChange: function afterVisibleChange() {
  },
  handler: /* @__PURE__ */ React.createElement("div", {
    className: "drawer-handle"
  }, /* @__PURE__ */ React.createElement("i", {
    className: "drawer-handle-icon"
  })),
  showMask: true,
  maskClosable: true,
  maskStyle: {},
  wrapperClassName: "",
  className: "",
  keyboard: true,
  forceRender: false
};
function useForceUpdate() {
  var _React$useReducer = React.useReducer(function(x2) {
    return x2 + 1;
  }, 0), _React$useReducer2 = _slicedToArray$3(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
  return forceUpdate;
}
var __rest$o = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var DrawerContext = /* @__PURE__ */ React.createContext(null);
tuple$1("top", "right", "bottom", "left");
var defaultPushState = {
  distance: 180
};
var Drawer = /* @__PURE__ */ React.forwardRef(function(_a, ref) {
  var _a$width = _a.width, width = _a$width === void 0 ? 256 : _a$width, _a$height = _a.height, height = _a$height === void 0 ? 256 : _a$height, _a$closable = _a.closable, closable = _a$closable === void 0 ? true : _a$closable, _a$placement = _a.placement, placement = _a$placement === void 0 ? "right" : _a$placement, _a$maskClosable = _a.maskClosable, maskClosable = _a$maskClosable === void 0 ? true : _a$maskClosable, _a$mask = _a.mask, mask = _a$mask === void 0 ? true : _a$mask, _a$level = _a.level, level = _a$level === void 0 ? null : _a$level, _a$keyboard = _a.keyboard, keyboard = _a$keyboard === void 0 ? true : _a$keyboard, _a$push = _a.push, _push = _a$push === void 0 ? defaultPushState : _a$push, _a$closeIcon = _a.closeIcon, closeIcon2 = _a$closeIcon === void 0 ? /* @__PURE__ */ React.createElement(CloseOutlined$1, null) : _a$closeIcon, bodyStyle = _a.bodyStyle, drawerStyle = _a.drawerStyle, prefixCls = _a.prefixCls, className = _a.className, direction = _a.direction, visible = _a.visible, children = _a.children, zIndex = _a.zIndex, destroyOnClose = _a.destroyOnClose, style2 = _a.style, title = _a.title, headerStyle = _a.headerStyle, onClose2 = _a.onClose, footer = _a.footer, footerStyle = _a.footerStyle, rest = __rest$o(_a, ["width", "height", "closable", "placement", "maskClosable", "mask", "level", "keyboard", "push", "closeIcon", "bodyStyle", "drawerStyle", "prefixCls", "className", "direction", "visible", "children", "zIndex", "destroyOnClose", "style", "title", "headerStyle", "onClose", "footer", "footerStyle"]);
  var forceUpdate = useForceUpdate();
  var _React$useState = React.useState(false), _React$useState2 = _slicedToArray$3(_React$useState, 2), internalPush = _React$useState2[0], setPush = _React$useState2[1];
  var parentDrawer = React.useContext(DrawerContext);
  var destroyClose = React.useRef(false);
  React.useEffect(function() {
    if (visible && parentDrawer) {
      parentDrawer.push();
    }
    return function() {
      if (parentDrawer) {
        parentDrawer.pull();
      }
    };
  }, []);
  React.useEffect(function() {
    if (parentDrawer) {
      if (visible) {
        parentDrawer.push();
      } else {
        parentDrawer.pull();
      }
    }
  }, [visible]);
  var operations = React.useMemo(function() {
    return {
      push: function push() {
        if (_push) {
          setPush(true);
        }
      },
      pull: function pull() {
        if (_push) {
          setPush(false);
        }
      }
    };
  }, [_push]);
  React.useImperativeHandle(ref, function() {
    return operations;
  }, [operations]);
  var isDestroyOnClose = destroyOnClose && !visible;
  var onDestroyTransitionEnd = function onDestroyTransitionEnd2() {
    if (!isDestroyOnClose) {
      return;
    }
    if (!visible) {
      destroyClose.current = true;
      forceUpdate();
    }
  };
  var getOffsetStyle = function getOffsetStyle2() {
    if (!visible && !mask) {
      return {};
    }
    var offsetStyle2 = {};
    if (placement === "left" || placement === "right") {
      offsetStyle2.width = width;
    } else {
      offsetStyle2.height = height;
    }
    return offsetStyle2;
  };
  var getRcDrawerStyle = function getRcDrawerStyle2() {
    var getPushTransform = function getPushTransform2(_placement) {
      var distance;
      if (typeof _push === "boolean") {
        distance = _push ? defaultPushState.distance : 0;
      } else {
        distance = _push.distance;
      }
      distance = parseFloat(String(distance || 0));
      if (_placement === "left" || _placement === "right") {
        return "translateX(".concat(_placement === "left" ? distance : -distance, "px)");
      }
      if (_placement === "top" || _placement === "bottom") {
        return "translateY(".concat(_placement === "top" ? distance : -distance, "px)");
      }
    };
    var offsetStyle2 = mask ? {} : getOffsetStyle();
    return _extends$2(_extends$2({
      zIndex,
      transform: internalPush ? getPushTransform(placement) : void 0
    }, offsetStyle2), style2);
  };
  function renderCloseIcon() {
    return closable && /* @__PURE__ */ React.createElement("button", {
      type: "button",
      onClick: onClose2,
      "aria-label": "Close",
      className: "".concat(prefixCls, "-close"),
      style: {
        "--scroll-bar": "".concat(getScrollBarSize(), "px")
      }
    }, closeIcon2);
  }
  function renderHeader() {
    if (!title && !closable) {
      return null;
    }
    var headerClassName = title ? "".concat(prefixCls, "-header") : "".concat(prefixCls, "-header-no-title");
    return /* @__PURE__ */ React.createElement("div", {
      className: headerClassName,
      style: headerStyle
    }, title && /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-title")
    }, title), closable && renderCloseIcon());
  }
  function renderFooter() {
    if (!footer) {
      return null;
    }
    var footerClassName = "".concat(prefixCls, "-footer");
    return /* @__PURE__ */ React.createElement("div", {
      className: footerClassName,
      style: footerStyle
    }, footer);
  }
  var renderBody = function renderBody2() {
    if (destroyClose.current && !visible) {
      return null;
    }
    destroyClose.current = false;
    var containerStyle = {};
    if (isDestroyOnClose) {
      containerStyle.opacity = 0;
      containerStyle.transition = "opacity .3s";
    }
    return /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-wrapper-body"),
      style: _extends$2(_extends$2({}, containerStyle), drawerStyle),
      onTransitionEnd: onDestroyTransitionEnd
    }, renderHeader(), /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-body"),
      style: bodyStyle
    }, children), renderFooter());
  };
  var drawerClassName = cn(_defineProperty$4({
    "no-mask": !mask
  }, "".concat(prefixCls, "-rtl"), direction === "rtl"), className);
  var offsetStyle = mask ? getOffsetStyle() : {};
  return /* @__PURE__ */ React.createElement(DrawerContext.Provider, {
    value: operations
  }, /* @__PURE__ */ React.createElement(DrawerWrapper$1, _extends$2({
    handler: false
  }, _extends$2({
    placement,
    prefixCls,
    maskClosable,
    level,
    keyboard,
    children,
    onClose: onClose2
  }, rest), offsetStyle, {
    open: visible,
    showMask: mask,
    style: getRcDrawerStyle(),
    className: drawerClassName
  }), renderBody()));
});
Drawer.displayName = "Drawer";
var DrawerWrapper = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var customizePrefixCls = props.prefixCls, customizeGetContainer = props.getContainer;
  var _React$useContext = React.useContext(ConfigContext), getPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var prefixCls = getPrefixCls("drawer", customizePrefixCls);
  var getContainer2 = customizeGetContainer === void 0 && getPopupContainer ? function() {
    return getPopupContainer(document.body);
  } : customizeGetContainer;
  return /* @__PURE__ */ React.createElement(Drawer, _extends$2({}, props, {
    ref,
    prefixCls,
    getContainer: getContainer2,
    direction
  }));
});
DrawerWrapper.displayName = "DrawerWrapper";
var FormContext = /* @__PURE__ */ React.createContext({
  labelAlign: "right",
  vertical: false,
  itemRef: function itemRef() {
  }
});
var FormItemContext = /* @__PURE__ */ React.createContext({
  updateItemErrors: function updateItemErrors() {
  }
});
var FormProvider2 = function FormProvider3(props) {
  var providerProps = omit$1(props, ["prefixCls"]);
  return /* @__PURE__ */ React.createElement(FormProvider$1, providerProps);
};
var FormItemPrefixContext = /* @__PURE__ */ React.createContext({
  prefixCls: ""
});
function t2(t3) {
  return "object" == typeof t3 && null != t3 && 1 === t3.nodeType;
}
function e2(t3, e3) {
  return (!e3 || "hidden" !== t3) && "visible" !== t3 && "clip" !== t3;
}
function n2(t3, n3) {
  if (t3.clientHeight < t3.scrollHeight || t3.clientWidth < t3.scrollWidth) {
    var r3 = getComputedStyle(t3, null);
    return e2(r3.overflowY, n3) || e2(r3.overflowX, n3) || function(t4) {
      var e3 = function(t5) {
        if (!t5.ownerDocument || !t5.ownerDocument.defaultView)
          return null;
        try {
          return t5.ownerDocument.defaultView.frameElement;
        } catch (t6) {
          return null;
        }
      }(t4);
      return !!e3 && (e3.clientHeight < t4.scrollHeight || e3.clientWidth < t4.scrollWidth);
    }(t3);
  }
  return false;
}
function r2(t3, e3, n3, r3, i2, o2, l2, d) {
  return o2 < t3 && l2 > e3 || o2 > t3 && l2 < e3 ? 0 : o2 <= t3 && d <= n3 || l2 >= e3 && d >= n3 ? o2 - t3 - r3 : l2 > e3 && d < n3 || o2 < t3 && d > n3 ? l2 - e3 + i2 : 0;
}
function compute(e3, i2) {
  var o2 = window, l2 = i2.scrollMode, d = i2.block, u2 = i2.inline, h = i2.boundary, a2 = i2.skipOverflowHiddenElements, c2 = "function" == typeof h ? h : function(t3) {
    return t3 !== h;
  };
  if (!t2(e3))
    throw new TypeError("Invalid target");
  for (var f3 = document.scrollingElement || document.documentElement, s2 = [], p = e3; t2(p) && c2(p); ) {
    if ((p = p.parentElement) === f3) {
      s2.push(p);
      break;
    }
    null != p && p === document.body && n2(p) && !n2(document.documentElement) || null != p && n2(p, a2) && s2.push(p);
  }
  for (var m2 = o2.visualViewport ? o2.visualViewport.width : innerWidth, g2 = o2.visualViewport ? o2.visualViewport.height : innerHeight, w2 = window.scrollX || pageXOffset, v2 = window.scrollY || pageYOffset, W2 = e3.getBoundingClientRect(), b2 = W2.height, H2 = W2.width, y2 = W2.top, E2 = W2.right, M2 = W2.bottom, V2 = W2.left, x2 = "start" === d || "nearest" === d ? y2 : "end" === d ? M2 : y2 + b2 / 2, I = "center" === u2 ? V2 + H2 / 2 : "end" === u2 ? E2 : V2, C2 = [], T2 = 0; T2 < s2.length; T2++) {
    var k2 = s2[T2], B2 = k2.getBoundingClientRect(), D2 = B2.height, O2 = B2.width, R2 = B2.top, X2 = B2.right, Y2 = B2.bottom, L2 = B2.left;
    if ("if-needed" === l2 && y2 >= 0 && V2 >= 0 && M2 <= g2 && E2 <= m2 && y2 >= R2 && M2 <= Y2 && V2 >= L2 && E2 <= X2)
      return C2;
    var S2 = getComputedStyle(k2), j2 = parseInt(S2.borderLeftWidth, 10), q2 = parseInt(S2.borderTopWidth, 10), z2 = parseInt(S2.borderRightWidth, 10), A2 = parseInt(S2.borderBottomWidth, 10), F2 = 0, G2 = 0, J2 = "offsetWidth" in k2 ? k2.offsetWidth - k2.clientWidth - j2 - z2 : 0, K2 = "offsetHeight" in k2 ? k2.offsetHeight - k2.clientHeight - q2 - A2 : 0;
    if (f3 === k2)
      F2 = "start" === d ? x2 : "end" === d ? x2 - g2 : "nearest" === d ? r2(v2, v2 + g2, g2, q2, A2, v2 + x2, v2 + x2 + b2, b2) : x2 - g2 / 2, G2 = "start" === u2 ? I : "center" === u2 ? I - m2 / 2 : "end" === u2 ? I - m2 : r2(w2, w2 + m2, m2, j2, z2, w2 + I, w2 + I + H2, H2), F2 = Math.max(0, F2 + v2), G2 = Math.max(0, G2 + w2);
    else {
      F2 = "start" === d ? x2 - R2 - q2 : "end" === d ? x2 - Y2 + A2 + K2 : "nearest" === d ? r2(R2, Y2, D2, q2, A2 + K2, x2, x2 + b2, b2) : x2 - (R2 + D2 / 2) + K2 / 2, G2 = "start" === u2 ? I - L2 - j2 : "center" === u2 ? I - (L2 + O2 / 2) + J2 / 2 : "end" === u2 ? I - X2 + z2 + J2 : r2(L2, X2, O2, j2, z2 + J2, I, I + H2, H2);
      var N = k2.scrollLeft, P2 = k2.scrollTop;
      x2 += P2 - (F2 = Math.max(0, Math.min(P2 + F2, k2.scrollHeight - D2 + K2))), I += N - (G2 = Math.max(0, Math.min(N + G2, k2.scrollWidth - O2 + J2)));
    }
    C2.push({ el: k2, top: F2, left: G2 });
  }
  return C2;
}
function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}
function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = "auto";
  }
  var canSmoothScroll = "scrollBehavior" in document.body.style;
  actions.forEach(function(_ref) {
    var el = _ref.el, top = _ref.top, left = _ref.left;
    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top,
        left,
        behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}
function getOptions(options) {
  if (options === false) {
    return {
      block: "end",
      inline: "nearest"
    };
  }
  if (isOptionsObject(options)) {
    return options;
  }
  return {
    block: "start",
    inline: "nearest"
  };
}
function scrollIntoView(target, options) {
  var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
  if (isOptionsObject(options) && typeof options.behavior === "function") {
    return options.behavior(isTargetAttached ? compute(target, options) : []);
  }
  if (!isTargetAttached) {
    return;
  }
  var computeOptions = getOptions(options);
  return defaultBehavior(compute(target, computeOptions), computeOptions.behavior);
}
function toArray$3(candidate) {
  if (candidate === void 0 || candidate === false)
    return [];
  return Array.isArray(candidate) ? candidate : [candidate];
}
function getFieldId(namePath, formName) {
  if (!namePath.length)
    return void 0;
  var mergedId = namePath.join("_");
  return formName ? "".concat(formName, "_").concat(mergedId) : mergedId;
}
function toNamePathStr(name) {
  var namePath = toArray$3(name);
  return namePath.join("_");
}
function useForm(form) {
  var _useRcForm = useForm$1(), _useRcForm2 = _slicedToArray$3(_useRcForm, 1), rcForm = _useRcForm2[0];
  var itemsRef = React.useRef({});
  var wrapForm = React.useMemo(function() {
    return form || _extends$2(_extends$2({}, rcForm), {
      __INTERNAL__: {
        itemRef: function itemRef2(name) {
          return function(node) {
            var namePathStr = toNamePathStr(name);
            if (node) {
              itemsRef.current[namePathStr] = node;
            } else {
              delete itemsRef.current[namePathStr];
            }
          };
        }
      },
      scrollToField: function scrollToField(name) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var namePath = toArray$3(name);
        var fieldId = getFieldId(namePath, wrapForm.__INTERNAL__.name);
        var node = fieldId ? document.getElementById(fieldId) : null;
        if (node) {
          scrollIntoView(node, _extends$2({
            scrollMode: "if-needed",
            block: "nearest"
          }, options));
        }
      },
      getFieldInstance: function getFieldInstance(name) {
        var namePathStr = toNamePathStr(name);
        return itemsRef.current[namePathStr];
      }
    });
  }, [form, rcForm]);
  return [wrapForm];
}
var __rest$n = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var InternalForm = function InternalForm2(props, ref) {
  var _classNames;
  var contextSize = React.useContext(SizeContext$1);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, contextForm = _React$useContext.form;
  var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, _props$size = props.size, size = _props$size === void 0 ? contextSize : _props$size, form = props.form, colon = props.colon, labelAlign = props.labelAlign, labelCol = props.labelCol, wrapperCol = props.wrapperCol, hideRequiredMark = props.hideRequiredMark, _props$layout = props.layout, layout = _props$layout === void 0 ? "horizontal" : _props$layout, scrollToFirstError = props.scrollToFirstError, requiredMark = props.requiredMark, onFinishFailed = props.onFinishFailed, name = props.name, restFormProps = __rest$n(props, ["prefixCls", "className", "size", "form", "colon", "labelAlign", "labelCol", "wrapperCol", "hideRequiredMark", "layout", "scrollToFirstError", "requiredMark", "onFinishFailed", "name"]);
  var mergedRequiredMark = useMemo$1(function() {
    if (requiredMark !== void 0) {
      return requiredMark;
    }
    if (contextForm && contextForm.requiredMark !== void 0) {
      return contextForm.requiredMark;
    }
    if (hideRequiredMark) {
      return false;
    }
    return true;
  }, [hideRequiredMark, requiredMark, contextForm]);
  var prefixCls = getPrefixCls("form", customizePrefixCls);
  var formClassName = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(layout), true), _defineProperty$4(_classNames, "".concat(prefixCls, "-hide-required-mark"), mergedRequiredMark === false), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(size), size), _classNames), className);
  var _useForm = useForm(form), _useForm2 = _slicedToArray$3(_useForm, 1), wrapForm = _useForm2[0];
  var __INTERNAL__ = wrapForm.__INTERNAL__;
  __INTERNAL__.name = name;
  var formContextValue = useMemo$1(function() {
    return {
      name,
      labelAlign,
      labelCol,
      wrapperCol,
      vertical: layout === "vertical",
      colon,
      requiredMark: mergedRequiredMark,
      itemRef: __INTERNAL__.itemRef
    };
  }, [name, labelAlign, labelCol, wrapperCol, layout, colon, mergedRequiredMark]);
  React.useImperativeHandle(ref, function() {
    return wrapForm;
  });
  var onInternalFinishFailed = function onInternalFinishFailed2(errorInfo) {
    onFinishFailed === null || onFinishFailed === void 0 ? void 0 : onFinishFailed(errorInfo);
    var defaultScrollToFirstError = {
      block: "nearest"
    };
    if (scrollToFirstError && errorInfo.errorFields.length) {
      if (_typeof$5(scrollToFirstError) === "object") {
        defaultScrollToFirstError = scrollToFirstError;
      }
      wrapForm.scrollToField(errorInfo.errorFields[0].name, defaultScrollToFirstError);
    }
  };
  return /* @__PURE__ */ React.createElement(SizeContextProvider$1, {
    size
  }, /* @__PURE__ */ React.createElement(FormContext.Provider, {
    value: formContextValue
  }, /* @__PURE__ */ React.createElement(RefForm, _extends$2({
    id: name
  }, restFormProps, {
    name,
    onFinishFailed: onInternalFinishFailed,
    form: wrapForm,
    className: formClassName
  }))));
};
var Form$1 = /* @__PURE__ */ React.forwardRef(InternalForm);
var QuestionCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "question-circle", "theme": "outlined" };
var QuestionCircleOutlined = function QuestionCircleOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: QuestionCircleOutlined$2
  }));
};
QuestionCircleOutlined.displayName = "QuestionCircleOutlined";
var QuestionCircleOutlined$1 = /* @__PURE__ */ React.forwardRef(QuestionCircleOutlined);
var __rest$m = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
function toTooltipProps(tooltip) {
  if (!tooltip) {
    return null;
  }
  if (_typeof$5(tooltip) === "object" && !/* @__PURE__ */ React.isValidElement(tooltip)) {
    return tooltip;
  }
  return {
    title: tooltip
  };
}
var FormItemLabel = function FormItemLabel2(_ref) {
  var prefixCls = _ref.prefixCls, label = _ref.label, htmlFor = _ref.htmlFor, labelCol = _ref.labelCol, labelAlign = _ref.labelAlign, colon = _ref.colon, required2 = _ref.required, requiredMark = _ref.requiredMark, tooltip = _ref.tooltip;
  var _useLocaleReceiver = useLocaleReceiver("Form"), _useLocaleReceiver2 = _slicedToArray$3(_useLocaleReceiver, 1), formLocale = _useLocaleReceiver2[0];
  if (!label)
    return null;
  return /* @__PURE__ */ React.createElement(FormContext.Consumer, {
    key: "label"
  }, function(_ref2) {
    var _classNames;
    var vertical = _ref2.vertical, contextLabelAlign = _ref2.labelAlign, contextLabelCol = _ref2.labelCol, contextColon = _ref2.colon;
    var _a;
    var mergedLabelCol = labelCol || contextLabelCol || {};
    var mergedLabelAlign = labelAlign || contextLabelAlign;
    var labelClsBasic = "".concat(prefixCls, "-item-label");
    var labelColClassName = cn(labelClsBasic, mergedLabelAlign === "left" && "".concat(labelClsBasic, "-left"), mergedLabelCol.className);
    var labelChildren = label;
    var computedColon = colon === true || contextColon !== false && colon !== false;
    var haveColon = computedColon && !vertical;
    if (haveColon && typeof label === "string" && label.trim() !== "") {
      labelChildren = label.replace(/[:|：]\s*$/, "");
    }
    var tooltipProps = toTooltipProps(tooltip);
    if (tooltipProps) {
      var _tooltipProps$icon = tooltipProps.icon, icon = _tooltipProps$icon === void 0 ? /* @__PURE__ */ React.createElement(QuestionCircleOutlined$1, null) : _tooltipProps$icon, restTooltipProps = __rest$m(tooltipProps, ["icon"]);
      var tooltipNode = /* @__PURE__ */ React.createElement(Tooltip2, restTooltipProps, /* @__PURE__ */ React.cloneElement(icon, {
        className: "".concat(prefixCls, "-item-tooltip")
      }));
      labelChildren = /* @__PURE__ */ React.createElement(React.Fragment, null, labelChildren, tooltipNode);
    }
    if (requiredMark === "optional" && !required2) {
      labelChildren = /* @__PURE__ */ React.createElement(React.Fragment, null, labelChildren, /* @__PURE__ */ React.createElement("span", {
        className: "".concat(prefixCls, "-item-optional")
      }, (formLocale === null || formLocale === void 0 ? void 0 : formLocale.optional) || ((_a = localeValues.Form) === null || _a === void 0 ? void 0 : _a.optional)));
    }
    var labelClassName = cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-item-required"), required2), _defineProperty$4(_classNames, "".concat(prefixCls, "-item-required-mark-optional"), requiredMark === "optional"), _defineProperty$4(_classNames, "".concat(prefixCls, "-item-no-colon"), !computedColon), _classNames));
    return /* @__PURE__ */ React.createElement(Col, _extends$2({}, mergedLabelCol, {
      className: labelColClassName
    }), /* @__PURE__ */ React.createElement("label", {
      htmlFor,
      className: labelClassName,
      title: typeof label === "string" ? label : ""
    }, labelChildren));
  });
};
function useCacheErrors(errors, changeTrigger, directly) {
  var cacheRef = React.useRef({
    errors,
    visible: !!errors.length
  });
  var forceUpdate = useForceUpdate();
  var update = function update2() {
    var prevVisible = cacheRef.current.visible;
    var newVisible = !!errors.length;
    var prevErrors = cacheRef.current.errors;
    cacheRef.current.errors = errors;
    cacheRef.current.visible = newVisible;
    if (prevVisible !== newVisible) {
      changeTrigger(newVisible);
    } else if (prevErrors.length !== errors.length || prevErrors.some(function(prevErr, index2) {
      return prevErr !== errors[index2];
    })) {
      forceUpdate();
    }
  };
  React.useEffect(function() {
    if (!directly) {
      var timeout = setTimeout(update, 10);
      return function() {
        return clearTimeout(timeout);
      };
    }
  }, [errors]);
  if (directly) {
    update();
  }
  return [cacheRef.current.visible, cacheRef.current.errors];
}
var EMPTY_LIST = [];
function ErrorList(_ref) {
  var _ref$errors = _ref.errors, errors = _ref$errors === void 0 ? EMPTY_LIST : _ref$errors, help = _ref.help, onDomErrorVisibleChange = _ref.onDomErrorVisibleChange;
  var forceUpdate = useForceUpdate();
  var _React$useContext = React.useContext(FormItemPrefixContext), prefixCls = _React$useContext.prefixCls, status = _React$useContext.status;
  var _React$useContext2 = React.useContext(ConfigContext), getPrefixCls = _React$useContext2.getPrefixCls;
  var _useCacheErrors = useCacheErrors(errors, function(changedVisible) {
    if (changedVisible) {
      Promise.resolve().then(function() {
        onDomErrorVisibleChange === null || onDomErrorVisibleChange === void 0 ? void 0 : onDomErrorVisibleChange(true);
      });
    }
    forceUpdate();
  }, !!help), _useCacheErrors2 = _slicedToArray$3(_useCacheErrors, 2), visible = _useCacheErrors2[0], cacheErrors = _useCacheErrors2[1];
  var memoErrors = useMemo2(function() {
    return cacheErrors;
  }, visible, function(_2, nextVisible) {
    return nextVisible;
  });
  var _React$useState = React.useState(status), _React$useState2 = _slicedToArray$3(_React$useState, 2), innerStatus = _React$useState2[0], setInnerStatus = _React$useState2[1];
  React.useEffect(function() {
    if (visible && status) {
      setInnerStatus(status);
    }
  }, [visible, status]);
  var baseClassName = "".concat(prefixCls, "-item-explain");
  var rootPrefixCls = getPrefixCls();
  return /* @__PURE__ */ React.createElement(CSSMotion, {
    motionDeadline: 500,
    visible,
    motionName: "".concat(rootPrefixCls, "-show-help"),
    onLeaveEnd: function onLeaveEnd() {
      onDomErrorVisibleChange === null || onDomErrorVisibleChange === void 0 ? void 0 : onDomErrorVisibleChange(false);
    },
    motionAppear: true,
    removeOnLeave: true
  }, function(_ref2) {
    var motionClassName = _ref2.className;
    return /* @__PURE__ */ React.createElement("div", {
      className: cn(baseClassName, _defineProperty$4({}, "".concat(baseClassName, "-").concat(innerStatus), innerStatus), motionClassName),
      key: "help"
    }, memoErrors.map(function(error, index2) {
      return /* @__PURE__ */ React.createElement("div", {
        key: index2,
        role: "alert"
      }, error);
    }));
  });
}
var iconMap = {
  success: CheckCircleFilled$1,
  warning: ExclamationCircleFilled$1,
  error: CloseCircleFilled$1,
  validating: LoadingOutlined$1
};
var FormItemInput = function FormItemInput2(props) {
  var prefixCls = props.prefixCls, status = props.status, wrapperCol = props.wrapperCol, children = props.children, help = props.help, errors = props.errors, onDomErrorVisibleChange = props.onDomErrorVisibleChange, hasFeedback = props.hasFeedback, formItemRender = props._internalItemRender, validateStatus = props.validateStatus, extra = props.extra;
  var baseClassName = "".concat(prefixCls, "-item");
  var formContext = React.useContext(FormContext);
  var mergedWrapperCol = wrapperCol || formContext.wrapperCol || {};
  var className = cn("".concat(baseClassName, "-control"), mergedWrapperCol.className);
  React.useEffect(function() {
    return function() {
      onDomErrorVisibleChange(false);
    };
  }, []);
  var IconNode = validateStatus && iconMap[validateStatus];
  var icon = hasFeedback && IconNode ? /* @__PURE__ */ React.createElement("span", {
    className: "".concat(baseClassName, "-children-icon")
  }, /* @__PURE__ */ React.createElement(IconNode, null)) : null;
  var subFormContext = _extends$2({}, formContext);
  delete subFormContext.labelCol;
  delete subFormContext.wrapperCol;
  var inputDom = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(baseClassName, "-control-input")
  }, /* @__PURE__ */ React.createElement("div", {
    className: "".concat(baseClassName, "-control-input-content")
  }, children), icon);
  var errorListDom = /* @__PURE__ */ React.createElement(FormItemPrefixContext.Provider, {
    value: {
      prefixCls,
      status
    }
  }, /* @__PURE__ */ React.createElement(ErrorList, {
    errors,
    help,
    onDomErrorVisibleChange
  }));
  var extraDom = extra ? /* @__PURE__ */ React.createElement("div", {
    className: "".concat(baseClassName, "-extra")
  }, extra) : null;
  var dom = formItemRender && formItemRender.mark === "pro_table_render" && formItemRender.render ? formItemRender.render(props, {
    input: inputDom,
    errorList: errorListDom,
    extra: extraDom
  }) : /* @__PURE__ */ React.createElement(React.Fragment, null, inputDom, errorListDom, extraDom);
  return /* @__PURE__ */ React.createElement(FormContext.Provider, {
    value: subFormContext
  }, /* @__PURE__ */ React.createElement(Col, _extends$2({}, mergedWrapperCol, {
    className
  }), dom));
};
function useFrameState(defaultValue) {
  var _React$useState = React.useState(defaultValue), _React$useState2 = _slicedToArray$3(_React$useState, 2), value = _React$useState2[0], setValue2 = _React$useState2[1];
  var frameRef = useRef2(null);
  var batchRef = useRef2([]);
  var destroyRef = useRef2(false);
  React.useEffect(function() {
    return function() {
      destroyRef.current = true;
      wrapperRaf$1.cancel(frameRef.current);
    };
  }, []);
  function setFrameValue(updater) {
    if (destroyRef.current) {
      return;
    }
    if (frameRef.current === null) {
      batchRef.current = [];
      frameRef.current = wrapperRaf$1(function() {
        frameRef.current = null;
        setValue2(function(prevValue) {
          var current = prevValue;
          batchRef.current.forEach(function(func) {
            current = func(current);
          });
          return current;
        });
      });
    }
    batchRef.current.push(updater);
  }
  return [value, setFrameValue];
}
function useItemRef() {
  var _React$useContext = React.useContext(FormContext), itemRef2 = _React$useContext.itemRef;
  var cacheRef = React.useRef({});
  function getRef(name, children) {
    var childrenRef = children && _typeof$5(children) === "object" && children.ref;
    var nameStr = name.join("_");
    if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
      cacheRef.current.name = nameStr;
      cacheRef.current.originRef = childrenRef;
      cacheRef.current.ref = composeRef(itemRef2(name), childrenRef);
    }
    return cacheRef.current.ref;
  }
  return getRef;
}
var __rest$l = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var NAME_SPLIT = "__SPLIT__";
tuple$1("success", "warning", "error", "validating", "");
var MemoInput = /* @__PURE__ */ React.memo(function(_ref) {
  var children = _ref.children;
  return children;
}, function(prev, next) {
  return prev.value === next.value && prev.update === next.update;
});
function hasValidName(name) {
  if (name === null) {
    devWarning(false, "Form.Item", "`null` is passed as `name` property");
  }
  return !(name === void 0 || name === null);
}
function FormItem(props) {
  var name = props.name, fieldKey = props.fieldKey, noStyle = props.noStyle, dependencies = props.dependencies, customizePrefixCls = props.prefixCls, style2 = props.style, className = props.className, shouldUpdate = props.shouldUpdate, hasFeedback = props.hasFeedback, help = props.help, rules2 = props.rules, validateStatus = props.validateStatus, children = props.children, required2 = props.required, label = props.label, messageVariables = props.messageVariables, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? "onChange" : _props$trigger, validateTrigger = props.validateTrigger, hidden = props.hidden, restProps = __rest$l(props, ["name", "fieldKey", "noStyle", "dependencies", "prefixCls", "style", "className", "shouldUpdate", "hasFeedback", "help", "rules", "validateStatus", "children", "required", "label", "messageVariables", "trigger", "validateTrigger", "hidden"]);
  var destroyRef = useRef2(false);
  var _useContext = useContext2(ConfigContext), getPrefixCls = _useContext.getPrefixCls;
  var _useContext2 = useContext2(FormContext), formName = _useContext2.name, requiredMark = _useContext2.requiredMark;
  var _useContext3 = useContext2(FormItemContext), updateItemErrors2 = _useContext3.updateItemErrors;
  var _React$useState = React.useState(!!help), _React$useState2 = _slicedToArray$3(_React$useState, 2), domErrorVisible = _React$useState2[0], innerSetDomErrorVisible = _React$useState2[1];
  var _useFrameState = useFrameState({}), _useFrameState2 = _slicedToArray$3(_useFrameState, 2), inlineErrors = _useFrameState2[0], setInlineErrors = _useFrameState2[1];
  var _useContext4 = useContext2(Context), contextValidateTrigger = _useContext4.validateTrigger;
  var mergedValidateTrigger = validateTrigger !== void 0 ? validateTrigger : contextValidateTrigger;
  function setDomErrorVisible(visible) {
    if (!destroyRef.current) {
      innerSetDomErrorVisible(visible);
    }
  }
  var hasName = hasValidName(name);
  var nameRef = useRef2([]);
  React.useEffect(function() {
    return function() {
      destroyRef.current = true;
      updateItemErrors2(nameRef.current.join(NAME_SPLIT), []);
    };
  }, []);
  var prefixCls = getPrefixCls("form", customizePrefixCls);
  var updateChildItemErrors = noStyle ? updateItemErrors2 : function(subName, subErrors, originSubName) {
    setInlineErrors(function() {
      var prevInlineErrors = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (originSubName !== subName) {
        delete prevInlineErrors[originSubName];
      }
      if (!isEqual_1(prevInlineErrors[subName], subErrors)) {
        return _extends$2(_extends$2({}, prevInlineErrors), _defineProperty$4({}, subName, subErrors));
      }
      return prevInlineErrors;
    });
  };
  var getItemRef = useItemRef();
  function renderLayout(baseChildren, fieldId, meta, isRequired) {
    var _itemClassName;
    var _a;
    if (noStyle && !hidden) {
      return baseChildren;
    }
    var subErrorList = [];
    Object.keys(inlineErrors).forEach(function(subName) {
      subErrorList = [].concat(_toConsumableArray(subErrorList), _toConsumableArray(inlineErrors[subName] || []));
    });
    var mergedErrors;
    if (help !== void 0 && help !== null) {
      mergedErrors = toArray$3(help);
    } else {
      mergedErrors = meta ? meta.errors : [];
      mergedErrors = [].concat(_toConsumableArray(mergedErrors), _toConsumableArray(subErrorList));
    }
    var mergedValidateStatus = "";
    if (validateStatus !== void 0) {
      mergedValidateStatus = validateStatus;
    } else if (meta === null || meta === void 0 ? void 0 : meta.validating) {
      mergedValidateStatus = "validating";
    } else if (((_a = meta === null || meta === void 0 ? void 0 : meta.errors) === null || _a === void 0 ? void 0 : _a.length) || subErrorList.length) {
      mergedValidateStatus = "error";
    } else if (meta === null || meta === void 0 ? void 0 : meta.touched) {
      mergedValidateStatus = "success";
    }
    var itemClassName = (_itemClassName = {}, _defineProperty$4(_itemClassName, "".concat(prefixCls, "-item"), true), _defineProperty$4(_itemClassName, "".concat(prefixCls, "-item-with-help"), domErrorVisible || !!help), _defineProperty$4(_itemClassName, "".concat(className), !!className), _defineProperty$4(_itemClassName, "".concat(prefixCls, "-item-has-feedback"), mergedValidateStatus && hasFeedback), _defineProperty$4(_itemClassName, "".concat(prefixCls, "-item-has-success"), mergedValidateStatus === "success"), _defineProperty$4(_itemClassName, "".concat(prefixCls, "-item-has-warning"), mergedValidateStatus === "warning"), _defineProperty$4(_itemClassName, "".concat(prefixCls, "-item-has-error"), mergedValidateStatus === "error"), _defineProperty$4(_itemClassName, "".concat(prefixCls, "-item-is-validating"), mergedValidateStatus === "validating"), _defineProperty$4(_itemClassName, "".concat(prefixCls, "-item-hidden"), hidden), _itemClassName);
    return /* @__PURE__ */ React.createElement(Row$1, _extends$2({
      className: cn(itemClassName),
      style: style2,
      key: "row"
    }, omit$1(restProps, ["colon", "extra", "getValueFromEvent", "getValueProps", "htmlFor", "id", "initialValue", "isListField", "labelAlign", "labelCol", "normalize", "preserve", "tooltip", "validateFirst", "valuePropName", "wrapperCol", "_internalItemRender"])), /* @__PURE__ */ React.createElement(FormItemLabel, _extends$2({
      htmlFor: fieldId,
      required: isRequired,
      requiredMark
    }, props, {
      prefixCls
    })), /* @__PURE__ */ React.createElement(FormItemInput, _extends$2({}, props, meta, {
      errors: mergedErrors,
      prefixCls,
      status: mergedValidateStatus,
      onDomErrorVisibleChange: setDomErrorVisible,
      validateStatus: mergedValidateStatus
    }), /* @__PURE__ */ React.createElement(FormItemContext.Provider, {
      value: {
        updateItemErrors: updateChildItemErrors
      }
    }, baseChildren)));
  }
  var isRenderProps = typeof children === "function";
  var updateRef = useRef2(0);
  updateRef.current += 1;
  if (!hasName && !isRenderProps && !dependencies) {
    return renderLayout(children);
  }
  var variables = {};
  if (typeof label === "string") {
    variables.label = label;
  }
  if (messageVariables) {
    variables = _extends$2(_extends$2({}, variables), messageVariables);
  }
  return /* @__PURE__ */ React.createElement(WrapperField, _extends$2({}, props, {
    messageVariables: variables,
    trigger,
    validateTrigger: mergedValidateTrigger,
    onReset: function onReset() {
      setDomErrorVisible(false);
    }
  }), function(control, meta, context2) {
    var errors = meta.errors;
    var mergedName = toArray$3(name).length && meta ? meta.name : [];
    var fieldId = getFieldId(mergedName, formName);
    if (noStyle) {
      var originErrorName = nameRef.current.join(NAME_SPLIT);
      nameRef.current = _toConsumableArray(mergedName);
      if (fieldKey) {
        var fieldKeys = Array.isArray(fieldKey) ? fieldKey : [fieldKey];
        nameRef.current = [].concat(_toConsumableArray(mergedName.slice(0, -1)), _toConsumableArray(fieldKeys));
      }
      updateItemErrors2(nameRef.current.join(NAME_SPLIT), errors, originErrorName);
    }
    var isRequired = required2 !== void 0 ? required2 : !!(rules2 && rules2.some(function(rule) {
      if (rule && _typeof$5(rule) === "object" && rule.required) {
        return true;
      }
      if (typeof rule === "function") {
        var ruleEntity = rule(context2);
        return ruleEntity && ruleEntity.required;
      }
      return false;
    }));
    var mergedControl = _extends$2({}, control);
    var childNode = null;
    devWarning(!(shouldUpdate && dependencies), "Form.Item", "`shouldUpdate` and `dependencies` shouldn't be used together. See https://ant.design/components/form/#dependencies.");
    if (Array.isArray(children) && hasName) {
      devWarning(false, "Form.Item", "`children` is array of render props cannot have `name`.");
      childNode = children;
    } else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) {
      devWarning(!!(shouldUpdate || dependencies), "Form.Item", "`children` of render props only work with `shouldUpdate` or `dependencies`.");
      devWarning(!hasName, "Form.Item", "Do not use `name` with `children` of render props since it's not a field.");
    } else if (dependencies && !isRenderProps && !hasName) {
      devWarning(false, "Form.Item", "Must set `name` or use render props when `dependencies` is set.");
    } else if (isValidElement2(children)) {
      devWarning(children.props.defaultValue === void 0, "Form.Item", "`defaultValue` will not work on controlled Field. You should use `initialValues` of Form instead.");
      var childProps = _extends$2(_extends$2({}, children.props), mergedControl);
      if (!childProps.id) {
        childProps.id = fieldId;
      }
      if (supportRef(children)) {
        childProps.ref = getItemRef(mergedName, children);
      }
      var triggers = new Set([].concat(_toConsumableArray(toArray$3(trigger)), _toConsumableArray(toArray$3(mergedValidateTrigger))));
      triggers.forEach(function(eventName) {
        childProps[eventName] = function() {
          var _a2, _c2;
          var _a, _b, _c;
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          (_a = mergedControl[eventName]) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [mergedControl].concat(args));
          (_c = (_b = children.props)[eventName]) === null || _c === void 0 ? void 0 : (_c2 = _c).call.apply(_c2, [_b].concat(args));
        };
      });
      childNode = /* @__PURE__ */ React.createElement(MemoInput, {
        value: mergedControl[props.valuePropName || "value"],
        update: updateRef.current
      }, cloneElement2(children, childProps));
    } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) {
      childNode = children(context2);
    } else {
      devWarning(!mergedName.length, "Form.Item", "`name` is only used for validate React element. If you are using Form.Item as layout display, please remove `name` instead.");
      childNode = children;
    }
    return renderLayout(childNode, fieldId, meta, isRequired);
  });
}
var __rest$k = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var FormList = function FormList2(_a) {
  var customizePrefixCls = _a.prefixCls, children = _a.children, props = __rest$k(_a, ["prefixCls", "children"]);
  devWarning(!!props.name, "Form.List", "Miss `name` prop.");
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls("form", customizePrefixCls);
  return /* @__PURE__ */ React.createElement(List$1, props, function(fields, operation, meta) {
    return /* @__PURE__ */ React.createElement(FormItemPrefixContext.Provider, {
      value: {
        prefixCls,
        status: "error"
      }
    }, children(fields.map(function(field) {
      return _extends$2(_extends$2({}, field), {
        fieldKey: field.key
      });
    }), operation, {
      errors: meta.errors
    }));
  });
};
var Form2 = Form$1;
Form2.Item = FormItem;
Form2.List = FormList;
Form2.ErrorList = ErrorList;
Form2.useForm = useForm;
Form2.Provider = FormProvider2;
Form2.create = function() {
  devWarning(false, "Form", "antd v4 removed `Form.create`. Please remove or use `@ant-design/compatible` instead.");
};
function getScroll$2(w2, top) {
  var ret = w2["page".concat(top ? "Y" : "X", "Offset")];
  var method3 = "scroll".concat(top ? "Top" : "Left");
  if (typeof ret !== "number") {
    var d = w2.document;
    ret = d.documentElement[method3];
    if (typeof ret !== "number") {
      ret = d.body[method3];
    }
  }
  return ret;
}
function offset$2(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc = el.ownerDocument;
  var w2 = doc.defaultView || doc.parentWindow;
  pos.left += getScroll$2(w2);
  pos.top += getScroll$2(w2, true);
  return pos;
}
var MemoChildren$1 = /* @__PURE__ */ React.memo(function(_ref) {
  var children = _ref.children;
  return children;
}, function(_2, _ref2) {
  var shouldUpdate = _ref2.shouldUpdate;
  return !shouldUpdate;
});
var sentinelStyle$1 = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
};
var Content$2 = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var closable = props.closable, prefixCls = props.prefixCls, width = props.width, height = props.height, footer = props.footer, title = props.title, closeIcon2 = props.closeIcon, style2 = props.style, className = props.className, visible = props.visible, forceRender = props.forceRender, bodyStyle = props.bodyStyle, bodyProps = props.bodyProps, children = props.children, destroyOnClose = props.destroyOnClose, modalRender = props.modalRender, motionName = props.motionName, ariaId = props.ariaId, onClose2 = props.onClose, onVisibleChanged = props.onVisibleChanged, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, mousePosition = props.mousePosition;
  var sentinelStartRef = useRef2();
  var sentinelEndRef = useRef2();
  var dialogRef = useRef2();
  React.useImperativeHandle(ref, function() {
    return {
      focus: function focus() {
        var _sentinelStartRef$cur;
        (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 ? void 0 : _sentinelStartRef$cur.focus();
      },
      changeActive: function changeActive(next) {
        var _document = document, activeElement = _document.activeElement;
        if (next && activeElement === sentinelEndRef.current) {
          sentinelStartRef.current.focus();
        } else if (!next && activeElement === sentinelStartRef.current) {
          sentinelEndRef.current.focus();
        }
      }
    };
  });
  var _React$useState = React.useState(), _React$useState2 = _slicedToArray$3(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
  var contentStyle = {};
  if (width !== void 0) {
    contentStyle.width = width;
  }
  if (height !== void 0) {
    contentStyle.height = height;
  }
  if (transformOrigin) {
    contentStyle.transformOrigin = transformOrigin;
  }
  function onPrepare() {
    var elementOffset = offset$2(dialogRef.current);
    setTransformOrigin(mousePosition ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : "");
  }
  var footerNode;
  if (footer) {
    footerNode = /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-footer")
    }, footer);
  }
  var headerNode;
  if (title) {
    headerNode = /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-header")
    }, /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-title"),
      id: ariaId
    }, title));
  }
  var closer;
  if (closable) {
    closer = /* @__PURE__ */ React.createElement("button", {
      type: "button",
      onClick: onClose2,
      "aria-label": "Close",
      className: "".concat(prefixCls, "-close")
    }, closeIcon2 || /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-close-x")
    }));
  }
  var content = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-content")
  }, closer, headerNode, /* @__PURE__ */ React.createElement("div", _extends$2({
    className: "".concat(prefixCls, "-body"),
    style: bodyStyle
  }, bodyProps), children), footerNode);
  return /* @__PURE__ */ React.createElement(CSSMotion, {
    visible,
    onVisibleChanged,
    onAppearPrepare: onPrepare,
    onEnterPrepare: onPrepare,
    forceRender,
    motionName,
    removeOnLeave: destroyOnClose,
    ref: dialogRef
  }, function(_ref, motionRef) {
    var motionClassName = _ref.className, motionStyle = _ref.style;
    return /* @__PURE__ */ React.createElement("div", {
      key: "dialog-element",
      role: "document",
      ref: motionRef,
      style: _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, motionStyle), style2), contentStyle),
      className: cn(prefixCls, className, motionClassName),
      onMouseDown,
      onMouseUp
    }, /* @__PURE__ */ React.createElement("div", {
      tabIndex: 0,
      ref: sentinelStartRef,
      style: sentinelStyle$1,
      "aria-hidden": "true"
    }), /* @__PURE__ */ React.createElement(MemoChildren$1, {
      shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content), /* @__PURE__ */ React.createElement("div", {
      tabIndex: 0,
      ref: sentinelEndRef,
      style: sentinelStyle$1,
      "aria-hidden": "true"
    }));
  });
});
Content$2.displayName = "Content";
var context = /* @__PURE__ */ React.createContext({
  previewUrls: /* @__PURE__ */ new Map(),
  setPreviewUrls: function setPreviewUrls() {
    return null;
  },
  current: null,
  setCurrent: function setCurrent() {
    return null;
  },
  setShowPreview: function setShowPreview() {
    return null;
  },
  setMousePosition: function setMousePosition() {
    return null;
  },
  registerImage: function registerImage() {
    return function() {
      return null;
    };
  }
});
context.Provider;
var RotateLeftOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" } }, { "tag": "path", "attrs": { "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" } }] }, "name": "rotate-left", "theme": "outlined" };
var RotateLeftOutlined = function RotateLeftOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: RotateLeftOutlined$1
  }));
};
RotateLeftOutlined.displayName = "RotateLeftOutlined";
var RotateRightOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" } }, { "tag": "path", "attrs": { "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" } }] }, "name": "rotate-right", "theme": "outlined" };
var RotateRightOutlined = function RotateRightOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: RotateRightOutlined$1
  }));
};
RotateRightOutlined.displayName = "RotateRightOutlined";
var ZoomInOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-in", "theme": "outlined" };
var ZoomInOutlined = function ZoomInOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: ZoomInOutlined$1
  }));
};
ZoomInOutlined.displayName = "ZoomInOutlined";
var ZoomOutOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-out", "theme": "outlined" };
var ZoomOutOutlined = function ZoomOutOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: ZoomOutOutlined$1
  }));
};
ZoomOutOutlined.displayName = "ZoomOutOutlined";
function supportBigInt() {
  return typeof BigInt === "function";
}
function trimNumber(numStr) {
  var str = numStr.trim();
  var negative = str.startsWith("-");
  if (negative) {
    str = str.slice(1);
  }
  str = str.replace(/(\.\d*[^0])0*$/, "$1").replace(/\.0*$/, "").replace(/^0+/, "");
  if (str.startsWith(".")) {
    str = "0".concat(str);
  }
  var trimStr = str || "0";
  var splitNumber = trimStr.split(".");
  var integerStr = splitNumber[0] || "0";
  var decimalStr = splitNumber[1] || "0";
  if (integerStr === "0" && decimalStr === "0") {
    negative = false;
  }
  var negativeStr = negative ? "-" : "";
  return {
    negative,
    negativeStr,
    trimStr,
    integerStr,
    decimalStr,
    fullStr: "".concat(negativeStr).concat(trimStr)
  };
}
function isE(number3) {
  var str = String(number3);
  return !Number.isNaN(Number(str)) && str.includes("e");
}
function getNumberPrecision(number3) {
  var numStr = String(number3);
  if (isE(number3)) {
    var precision = Number(numStr.slice(numStr.indexOf("e-") + 2));
    var decimalMatch = numStr.match(/\.(\d+)/);
    if (decimalMatch === null || decimalMatch === void 0 ? void 0 : decimalMatch[1]) {
      precision += decimalMatch[1].length;
    }
    return precision;
  }
  return numStr.includes(".") && validateNumber(numStr) ? numStr.length - numStr.indexOf(".") - 1 : 0;
}
function num2str(number3) {
  var numStr = String(number3);
  if (isE(number3)) {
    if (number3 > Number.MAX_SAFE_INTEGER) {
      return String(supportBigInt() ? BigInt(number3).toString() : Number.MAX_SAFE_INTEGER);
    }
    if (number3 < Number.MIN_SAFE_INTEGER) {
      return String(supportBigInt() ? BigInt(number3).toString() : Number.MIN_SAFE_INTEGER);
    }
    numStr = number3.toFixed(getNumberPrecision(numStr));
  }
  return trimNumber(numStr).fullStr;
}
function validateNumber(num) {
  if (typeof num === "number") {
    return !Number.isNaN(num);
  }
  if (!num) {
    return false;
  }
  return /^\s*-?\d+(\.\d+)?\s*$/.test(num) || /^\s*-?\d+\.\s*$/.test(num) || /^\s*-?\.\d+\s*$/.test(num);
}
var NumberDecimal = /* @__PURE__ */ function() {
  function NumberDecimal2(value) {
    _classCallCheck$2(this, NumberDecimal2);
    this.origin = "";
    if (!value && value !== 0 || !String(value).trim()) {
      this.empty = true;
      return;
    }
    this.origin = String(value);
    this.number = Number(value);
  }
  _createClass$2(NumberDecimal2, [{
    key: "negate",
    value: function negate() {
      return new NumberDecimal2(-this.toNumber());
    }
  }, {
    key: "add",
    value: function add(value) {
      if (this.isInvalidate()) {
        return new NumberDecimal2(value);
      }
      var target = Number(value);
      if (Number.isNaN(target)) {
        return this;
      }
      var number3 = this.number + target;
      if (number3 > Number.MAX_SAFE_INTEGER) {
        return new NumberDecimal2(Number.MAX_SAFE_INTEGER);
      }
      if (number3 < Number.MIN_SAFE_INTEGER) {
        return new NumberDecimal2(Number.MIN_SAFE_INTEGER);
      }
      var maxPrecision = Math.max(getNumberPrecision(this.number), getNumberPrecision(target));
      return new NumberDecimal2(number3.toFixed(maxPrecision));
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function isNaN2() {
      return Number.isNaN(this.number);
    }
  }, {
    key: "isInvalidate",
    value: function isInvalidate() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function equals(target) {
      return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
    }
  }, {
    key: "lessEquals",
    value: function lessEquals(target) {
      return this.add(target.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function toNumber2() {
      return this.number;
    }
  }, {
    key: "toString",
    value: function toString2() {
      var safe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
      if (this.isInvalidate()) {
        return safe ? "" : this.origin;
      }
      return num2str(this.number);
    }
  }]);
  return NumberDecimal2;
}();
var BigIntDecimal = /* @__PURE__ */ function() {
  function BigIntDecimal2(value) {
    _classCallCheck$2(this, BigIntDecimal2);
    this.origin = "";
    if (!value && value !== 0 || !String(value).trim()) {
      this.empty = true;
      return;
    }
    this.origin = String(value);
    if (value === "-") {
      this.nan = true;
      return;
    }
    var mergedValue = value;
    if (isE(mergedValue)) {
      mergedValue = Number(mergedValue);
    }
    mergedValue = typeof mergedValue === "string" ? mergedValue : num2str(mergedValue);
    if (validateNumber(mergedValue)) {
      var trimRet = trimNumber(mergedValue);
      this.negative = trimRet.negative;
      var numbers = trimRet.trimStr.split(".");
      this.integer = BigInt(numbers[0]);
      var decimalStr = numbers[1] || "0";
      this.decimal = BigInt(decimalStr);
      this.decimalLen = decimalStr.length;
    } else {
      this.nan = true;
    }
  }
  _createClass$2(BigIntDecimal2, [{
    key: "getMark",
    value: function getMark2() {
      return this.negative ? "-" : "";
    }
  }, {
    key: "getIntegerStr",
    value: function getIntegerStr() {
      return this.integer.toString();
    }
  }, {
    key: "getDecimalStr",
    value: function getDecimalStr() {
      return this.decimal.toString().padStart(this.decimalLen, "0");
    }
  }, {
    key: "alignDecimal",
    value: function alignDecimal(decimalLength) {
      var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, "0"));
      return BigInt(str);
    }
  }, {
    key: "negate",
    value: function negate() {
      var clone2 = new BigIntDecimal2(this.toString());
      clone2.negative = !clone2.negative;
      return clone2;
    }
  }, {
    key: "add",
    value: function add(value) {
      if (this.isInvalidate()) {
        return new BigIntDecimal2(value);
      }
      var offset3 = new BigIntDecimal2(value);
      if (offset3.isInvalidate()) {
        return this;
      }
      var maxDecimalLength = Math.max(this.getDecimalStr().length, offset3.getDecimalStr().length);
      var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
      var offsetAlignedDecimal = offset3.alignDecimal(maxDecimalLength);
      var valueStr = (myAlignedDecimal + offsetAlignedDecimal).toString();
      var _trimNumber = trimNumber(valueStr), negativeStr = _trimNumber.negativeStr, trimStr = _trimNumber.trimStr;
      var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(maxDecimalLength + 1, "0"));
      return new BigIntDecimal2("".concat(hydrateValueStr.slice(0, -maxDecimalLength), ".").concat(hydrateValueStr.slice(-maxDecimalLength)));
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function isNaN2() {
      return this.nan;
    }
  }, {
    key: "isInvalidate",
    value: function isInvalidate() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function equals(target) {
      return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
    }
  }, {
    key: "lessEquals",
    value: function lessEquals(target) {
      return this.add(target.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function toNumber2() {
      if (this.isNaN()) {
        return NaN;
      }
      return Number(this.toString());
    }
  }, {
    key: "toString",
    value: function toString2() {
      var safe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
      if (this.isInvalidate()) {
        return safe ? "" : this.origin;
      }
      return trimNumber("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
    }
  }]);
  return BigIntDecimal2;
}();
function getMiniDecimal(value) {
  if (supportBigInt()) {
    return new BigIntDecimal(value);
  }
  return new NumberDecimal(value);
}
function toFixed(numStr, separatorStr, precision) {
  if (numStr === "") {
    return "";
  }
  var _trimNumber2 = trimNumber(numStr), negativeStr = _trimNumber2.negativeStr, integerStr = _trimNumber2.integerStr, decimalStr = _trimNumber2.decimalStr;
  var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
  var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);
  if (precision >= 0) {
    var advancedNum = Number(decimalStr[precision]);
    if (advancedNum >= 5) {
      var advancedDecimal = getMiniDecimal(numStr).add("0.".concat("0".repeat(precision)).concat(10 - advancedNum));
      return toFixed(advancedDecimal.toString(), separatorStr, precision);
    }
    if (precision === 0) {
      return numberWithoutDecimal;
    }
    return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, "0").slice(0, precision));
  }
  if (precisionDecimalStr === ".0") {
    return numberWithoutDecimal;
  }
  return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}
var STEP_INTERVAL = 200;
var STEP_DELAY = 600;
function StepHandler(_ref) {
  var prefixCls = _ref.prefixCls, upNode = _ref.upNode, downNode = _ref.downNode, upDisabled = _ref.upDisabled, downDisabled = _ref.downDisabled, onStep = _ref.onStep;
  var stepTimeoutRef = React.useRef();
  var onStepRef = React.useRef();
  onStepRef.current = onStep;
  var onStepMouseDown = function onStepMouseDown2(e3, up) {
    e3.preventDefault();
    onStepRef.current(up);
    function loopStep() {
      onStepRef.current(up);
      stepTimeoutRef.current = setTimeout(loopStep, STEP_INTERVAL);
    }
    stepTimeoutRef.current = setTimeout(loopStep, STEP_DELAY);
  };
  var onStopStep = function onStopStep2() {
    clearTimeout(stepTimeoutRef.current);
  };
  React.useEffect(function() {
    return onStopStep;
  }, []);
  if (isMobile$1()) {
    return null;
  }
  var handlerClassName = "".concat(prefixCls, "-handler");
  var upClassName = cn(handlerClassName, "".concat(handlerClassName, "-up"), _defineProperty$4({}, "".concat(handlerClassName, "-up-disabled"), upDisabled));
  var downClassName = cn(handlerClassName, "".concat(handlerClassName, "-down"), _defineProperty$4({}, "".concat(handlerClassName, "-down-disabled"), downDisabled));
  var sharedHandlerProps = {
    unselectable: "on",
    role: "button",
    onMouseUp: onStopStep,
    onMouseLeave: onStopStep
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "".concat(handlerClassName, "-wrap")
  }, /* @__PURE__ */ React.createElement("span", _extends$2({}, sharedHandlerProps, {
    onMouseDown: function onMouseDown(e3) {
      onStepMouseDown(e3, true);
    },
    "aria-label": "Increase Value",
    "aria-disabled": upDisabled,
    className: upClassName
  }), upNode || /* @__PURE__ */ React.createElement("span", {
    unselectable: "on",
    className: "".concat(prefixCls, "-handler-up-inner")
  })), /* @__PURE__ */ React.createElement("span", _extends$2({}, sharedHandlerProps, {
    onMouseDown: function onMouseDown(e3) {
      onStepMouseDown(e3, false);
    },
    "aria-label": "Decrease Value",
    "aria-disabled": downDisabled,
    className: downClassName
  }), downNode || /* @__PURE__ */ React.createElement("span", {
    unselectable: "on",
    className: "".concat(prefixCls, "-handler-down-inner")
  })));
}
function useCursor(input, focused) {
  var selectionRef = useRef2(null);
  function recordCursor() {
    try {
      var start = input.selectionStart, end = input.selectionEnd, value = input.value;
      var beforeTxt = value.substring(0, start);
      var afterTxt = value.substring(end);
      selectionRef.current = {
        start,
        end,
        value,
        beforeTxt,
        afterTxt
      };
    } catch (e3) {
    }
  }
  function restoreCursor() {
    if (input && selectionRef.current && focused) {
      try {
        var value = input.value;
        var _selectionRef$current = selectionRef.current, beforeTxt = _selectionRef$current.beforeTxt, afterTxt = _selectionRef$current.afterTxt, start = _selectionRef$current.start;
        var startPos = value.length;
        if (value.endsWith(afterTxt)) {
          startPos = value.length - selectionRef.current.afterTxt.length;
        } else if (value.startsWith(beforeTxt)) {
          startPos = beforeTxt.length;
        } else {
          var beforeLastChar = beforeTxt[start - 1];
          var newIndex = value.indexOf(beforeLastChar, start - 1);
          if (newIndex !== -1) {
            startPos = newIndex + 1;
          }
        }
        input.setSelectionRange(startPos, startPos);
      } catch (e3) {
        warningOnce(false, "Something warning of cursor restore. Please fire issue about this: ".concat(e3.message));
      }
    }
  }
  return [recordCursor, restoreCursor];
}
var useLayoutEffect2 = canUseDom() ? React.useLayoutEffect : React.useEffect;
function useUpdateEffect(callback, condition) {
  var initRef = React.useRef(false);
  useLayoutEffect2(function() {
    if (!initRef.current) {
      initRef.current = true;
      return void 0;
    }
    return callback();
  }, condition);
}
var getDecimalValue = function getDecimalValue2(stringMode, decimalValue) {
  if (stringMode || decimalValue.isEmpty()) {
    return decimalValue.toString();
  }
  return decimalValue.toNumber();
};
var getDecimalIfValidate = function getDecimalIfValidate2(value) {
  var decimal = getMiniDecimal(value);
  return decimal.isInvalidate() ? null : decimal;
};
var InputNumber = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var _classNames;
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-input-number" : _props$prefixCls, className = props.className, style2 = props.style, min = props.min, max = props.max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, defaultValue = props.defaultValue, value = props.value, disabled = props.disabled, readOnly = props.readOnly, upHandler = props.upHandler, downHandler = props.downHandler, keyboard = props.keyboard, stringMode = props.stringMode, parser = props.parser, formatter = props.formatter, precision = props.precision, decimalSeparator = props.decimalSeparator, onChange4 = props.onChange, onInput = props.onInput, onPressEnter = props.onPressEnter, onStep = props.onStep, inputProps = _objectWithoutProperties$1(props, ["prefixCls", "className", "style", "min", "max", "step", "defaultValue", "value", "disabled", "readOnly", "upHandler", "downHandler", "keyboard", "stringMode", "parser", "formatter", "precision", "decimalSeparator", "onChange", "onInput", "onPressEnter", "onStep"]);
  var inputClassName = "".concat(prefixCls, "-input");
  var inputRef = React.useRef(null);
  var _React$useState = React.useState(false), _React$useState2 = _slicedToArray$3(_React$useState, 2), focus = _React$useState2[0], setFocus = _React$useState2[1];
  var userTypingRef = React.useRef(false);
  var compositionRef = React.useRef(false);
  var _React$useState3 = React.useState(function() {
    return getMiniDecimal(defaultValue !== null && defaultValue !== void 0 ? defaultValue : value);
  }), _React$useState4 = _slicedToArray$3(_React$useState3, 2), decimalValue = _React$useState4[0], setDecimalValue = _React$useState4[1];
  function setUncontrolledDecimalValue(newDecimal) {
    if (value === void 0) {
      setDecimalValue(newDecimal);
    }
  }
  var getPrecision2 = React.useCallback(function(numStr, userTyping) {
    if (precision >= 0) {
      return precision;
    }
    if (userTyping) {
      return void 0;
    }
    return Math.max(getNumberPrecision(numStr), getNumberPrecision(step));
  }, [precision, step]);
  var mergedParser = React.useCallback(function(num) {
    var numStr = String(num);
    if (parser) {
      return parser(numStr);
    }
    var parsedStr = numStr;
    if (decimalSeparator) {
      parsedStr = parsedStr.replace(decimalSeparator, ".");
    }
    return parsedStr.replace(/[^\w.-]+/g, "");
  }, [parser, decimalSeparator]);
  var mergedFormatter = React.useCallback(function(number3, userTyping) {
    if (formatter) {
      return formatter(number3);
    }
    var str = typeof number3 === "number" ? num2str(number3) : number3;
    if (!userTyping) {
      var mergedPrecision = getPrecision2(str, userTyping);
      if (validateNumber(str) && (decimalSeparator || mergedPrecision >= 0)) {
        var separatorStr = decimalSeparator || ".";
        str = toFixed(str, separatorStr, mergedPrecision);
      }
    }
    return str;
  }, [formatter, getPrecision2, decimalSeparator]);
  var _React$useState5 = React.useState(function() {
    var initValue = defaultValue !== null && defaultValue !== void 0 ? defaultValue : value;
    if (decimalValue.isInvalidate() && ["string", "number"].includes(_typeof$5(initValue))) {
      return Number.isNaN(initValue) ? "" : initValue;
    }
    return mergedFormatter(decimalValue.toString(), false);
  }), _React$useState6 = _slicedToArray$3(_React$useState5, 2), inputValue = _React$useState6[0], setInternalInputValue = _React$useState6[1];
  function setInputValue(newValue, userTyping) {
    setInternalInputValue(mergedFormatter(newValue.toString(false), userTyping));
  }
  var maxDecimal = React.useMemo(function() {
    return getDecimalIfValidate(max);
  }, [max]);
  var minDecimal = React.useMemo(function() {
    return getDecimalIfValidate(min);
  }, [min]);
  var upDisabled = React.useMemo(function() {
    if (!maxDecimal || !decimalValue || decimalValue.isInvalidate()) {
      return false;
    }
    return maxDecimal.lessEquals(decimalValue);
  }, [maxDecimal, decimalValue]);
  var downDisabled = React.useMemo(function() {
    if (!minDecimal || !decimalValue || decimalValue.isInvalidate()) {
      return false;
    }
    return decimalValue.lessEquals(minDecimal);
  }, [minDecimal, decimalValue]);
  var _useCursor = useCursor(inputRef.current, focus), _useCursor2 = _slicedToArray$3(_useCursor, 2), recordCursor = _useCursor2[0], restoreCursor = _useCursor2[1];
  var getRangeValue = function getRangeValue2(target) {
    if (maxDecimal && !target.lessEquals(maxDecimal)) {
      return maxDecimal;
    }
    if (minDecimal && !minDecimal.lessEquals(target)) {
      return minDecimal;
    }
    return null;
  };
  var isInRange2 = function isInRange3(target) {
    return !getRangeValue(target);
  };
  var triggerValueUpdate = function triggerValueUpdate2(newValue, userTyping) {
    var updateValue = newValue;
    if (!updateValue.isEmpty()) {
      updateValue = getRangeValue(updateValue) || updateValue;
    }
    if (!readOnly && !disabled) {
      var numStr = updateValue.toString();
      var mergedPrecision = getPrecision2(numStr, userTyping);
      if (mergedPrecision >= 0) {
        updateValue = getMiniDecimal(toFixed(numStr, ".", mergedPrecision));
      }
      if (!updateValue.equals(decimalValue)) {
        setUncontrolledDecimalValue(updateValue);
        onChange4 === null || onChange4 === void 0 ? void 0 : onChange4(updateValue.isEmpty() ? null : getDecimalValue(stringMode, updateValue));
        if (value === void 0) {
          setInputValue(updateValue, userTyping);
        }
      }
      return updateValue;
    }
    return decimalValue;
  };
  var collectInputValue = function collectInputValue2(inputStr) {
    recordCursor();
    setInternalInputValue(inputStr);
    if (!compositionRef.current) {
      var finalValue = mergedParser(inputStr);
      var finalDecimal = getMiniDecimal(finalValue);
      if (!finalDecimal.isInvalidate()) {
        triggerValueUpdate(finalDecimal, true);
      }
    }
  };
  var onCompositionStart = function onCompositionStart2() {
    compositionRef.current = true;
  };
  var onCompositionEnd = function onCompositionEnd2() {
    compositionRef.current = false;
    collectInputValue(inputRef.current.value);
  };
  var onInternalInput = function onInternalInput2(e3) {
    var inputStr = e3.target.value;
    if (!parser) {
      inputStr = inputStr.replace(/。/g, ".");
    }
    collectInputValue(inputStr);
    onInput === null || onInput === void 0 ? void 0 : onInput(inputStr);
  };
  var onInternalStep = function onInternalStep2(up) {
    var _inputRef$current;
    if (up && upDisabled || !up && downDisabled) {
      return;
    }
    userTypingRef.current = false;
    var stepDecimal = getMiniDecimal(step);
    if (!up) {
      stepDecimal = stepDecimal.negate();
    }
    var target = (decimalValue || getMiniDecimal(0)).add(stepDecimal.toString());
    var updatedValue = triggerValueUpdate(target, false);
    onStep === null || onStep === void 0 ? void 0 : onStep(getDecimalValue(stringMode, updatedValue), {
      offset: step,
      type: up ? "up" : "down"
    });
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  };
  var flushInputValue = function flushInputValue2() {
    var parsedValue = getMiniDecimal(mergedParser(inputValue));
    var formatValue2 = parsedValue;
    if (!parsedValue.isNaN()) {
      formatValue2 = triggerValueUpdate(parsedValue, true);
    } else {
      formatValue2 = decimalValue;
    }
    if (value !== void 0) {
      setInputValue(decimalValue, false);
    } else if (!formatValue2.isNaN()) {
      setInputValue(formatValue2, false);
    }
  };
  var onKeyDown2 = function onKeyDown3(event) {
    var which = event.which;
    userTypingRef.current = true;
    if (which === KeyCode.ENTER) {
      if (!compositionRef.current) {
        userTypingRef.current = false;
      }
      flushInputValue();
      onPressEnter === null || onPressEnter === void 0 ? void 0 : onPressEnter(event);
    }
    if (keyboard === false) {
      return;
    }
    if (!compositionRef.current && [KeyCode.UP, KeyCode.DOWN].includes(which)) {
      onInternalStep(KeyCode.UP === which);
      event.preventDefault();
    }
  };
  var onKeyUp2 = function onKeyUp3() {
    userTypingRef.current = false;
  };
  var onBlur2 = function onBlur3() {
    flushInputValue();
    setFocus(false);
  };
  useUpdateEffect(function() {
    if (!decimalValue.isInvalidate()) {
      setInputValue(decimalValue, false);
    }
  }, [precision]);
  useUpdateEffect(function() {
    var newValue = getMiniDecimal(value);
    setDecimalValue(newValue);
    if (newValue.isNaN() || !userTypingRef.current || formatter) {
      setInputValue(newValue, false);
    }
  }, [value]);
  useUpdateEffect(function() {
    if (formatter) {
      restoreCursor();
    }
  }, [inputValue]);
  return /* @__PURE__ */ React.createElement("div", {
    className: cn(prefixCls, className, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-focused"), focus), _defineProperty$4(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty$4(_classNames, "".concat(prefixCls, "-readonly"), readOnly), _defineProperty$4(_classNames, "".concat(prefixCls, "-not-a-number"), decimalValue.isNaN()), _defineProperty$4(_classNames, "".concat(prefixCls, "-out-of-range"), !decimalValue.isInvalidate() && !isInRange2(decimalValue)), _classNames)),
    style: style2,
    onFocus: function onFocus2() {
      setFocus(true);
    },
    onBlur: onBlur2,
    onKeyDown: onKeyDown2,
    onKeyUp: onKeyUp2,
    onCompositionStart,
    onCompositionEnd
  }, /* @__PURE__ */ React.createElement(StepHandler, {
    prefixCls,
    upNode: upHandler,
    downNode: downHandler,
    upDisabled,
    downDisabled,
    onStep: onInternalStep
  }), /* @__PURE__ */ React.createElement("div", {
    className: "".concat(inputClassName, "-wrap")
  }, /* @__PURE__ */ React.createElement("input", _extends$2({
    autoComplete: "off",
    role: "spinbutton",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": decimalValue.isInvalidate() ? null : decimalValue.toString(),
    step
  }, inputProps, {
    ref: composeRef(inputRef, ref),
    className: inputClassName,
    value: inputValue,
    onChange: onInternalInput,
    disabled,
    readOnly
  }))));
});
InputNumber.displayName = "InputNumber";
var UpOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, "name": "up", "theme": "outlined" };
var UpOutlined = function UpOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: UpOutlined$1
  }));
};
UpOutlined.displayName = "UpOutlined";
var Layout = Layout$1;
Layout.Header = Header$3;
Layout.Footer = Footer;
Layout.Content = Content$3;
Layout.Sider = Sider;
var __rest$j = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
tuple$1("small", "default", "large");
var defaultIndicator = null;
function renderIndicator(prefixCls, props) {
  var indicator = props.indicator;
  var dotClassName = "".concat(prefixCls, "-dot");
  if (indicator === null) {
    return null;
  }
  if (isValidElement2(indicator)) {
    return cloneElement2(indicator, {
      className: cn(indicator.props.className, dotClassName)
    });
  }
  if (isValidElement2(defaultIndicator)) {
    return cloneElement2(defaultIndicator, {
      className: cn(defaultIndicator.props.className, dotClassName)
    });
  }
  return /* @__PURE__ */ React.createElement("span", {
    className: cn(dotClassName, "".concat(prefixCls, "-dot-spin"))
  }, /* @__PURE__ */ React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }), /* @__PURE__ */ React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }), /* @__PURE__ */ React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }), /* @__PURE__ */ React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }));
}
function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !isNaN(Number(delay));
}
var Spin = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Spin2, _React$Component);
  var _super = _createSuper$1(Spin2);
  function Spin2(props) {
    var _this2;
    _classCallCheck$2(this, Spin2);
    _this2 = _super.call(this, props);
    _this2.debouncifyUpdateSpinning = function(props2) {
      var _ref = props2 || _this2.props, delay2 = _ref.delay;
      if (delay2) {
        _this2.cancelExistingSpin();
        _this2.updateSpinning = debounce_1(_this2.originalUpdateSpinning, delay2);
      }
    };
    _this2.updateSpinning = function() {
      var spinning2 = _this2.props.spinning;
      var currentSpinning = _this2.state.spinning;
      if (currentSpinning !== spinning2) {
        _this2.setState({
          spinning: spinning2
        });
      }
    };
    _this2.renderSpin = function(_ref2) {
      var _classNames;
      var getPrefixCls = _ref2.getPrefixCls, direction = _ref2.direction;
      var _a = _this2.props, customizePrefixCls = _a.prefixCls, className = _a.className, size = _a.size, tip = _a.tip, wrapperClassName = _a.wrapperClassName, style2 = _a.style, restProps = __rest$j(_a, ["prefixCls", "className", "size", "tip", "wrapperClassName", "style"]);
      var spinning2 = _this2.state.spinning;
      var prefixCls = getPrefixCls("spin", customizePrefixCls);
      var spinClassName = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-sm"), size === "small"), _defineProperty$4(_classNames, "".concat(prefixCls, "-lg"), size === "large"), _defineProperty$4(_classNames, "".concat(prefixCls, "-spinning"), spinning2), _defineProperty$4(_classNames, "".concat(prefixCls, "-show-text"), !!tip), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
      var divProps = omit$1(restProps, ["spinning", "delay", "indicator"]);
      var spinElement = /* @__PURE__ */ React.createElement("div", _extends$2({}, divProps, {
        style: style2,
        className: spinClassName
      }), renderIndicator(prefixCls, _this2.props), tip ? /* @__PURE__ */ React.createElement("div", {
        className: "".concat(prefixCls, "-text")
      }, tip) : null);
      if (_this2.isNestedPattern()) {
        var containerClassName = cn("".concat(prefixCls, "-container"), _defineProperty$4({}, "".concat(prefixCls, "-blur"), spinning2));
        return /* @__PURE__ */ React.createElement("div", _extends$2({}, divProps, {
          className: cn("".concat(prefixCls, "-nested-loading"), wrapperClassName)
        }), spinning2 && /* @__PURE__ */ React.createElement("div", {
          key: "loading"
        }, spinElement), /* @__PURE__ */ React.createElement("div", {
          className: containerClassName,
          key: "container"
        }, _this2.props.children));
      }
      return spinElement;
    };
    var spinning = props.spinning, delay = props.delay;
    var shouldBeDelayed = shouldDelay(spinning, delay);
    _this2.state = {
      spinning: spinning && !shouldBeDelayed
    };
    _this2.originalUpdateSpinning = _this2.updateSpinning;
    _this2.debouncifyUpdateSpinning(props);
    return _this2;
  }
  _createClass$2(Spin2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSpinning();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.debouncifyUpdateSpinning();
      this.updateSpinning();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelExistingSpin();
    }
  }, {
    key: "cancelExistingSpin",
    value: function cancelExistingSpin() {
      var updateSpinning = this.updateSpinning;
      if (updateSpinning && updateSpinning.cancel) {
        updateSpinning.cancel();
      }
    }
  }, {
    key: "isNestedPattern",
    value: function isNestedPattern() {
      return !!(this.props && typeof this.props.children !== "undefined");
    }
  }, {
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(ConfigConsumer, null, this.renderSpin);
    }
  }], [{
    key: "setDefaultIndicator",
    value: function setDefaultIndicator(indicator) {
      defaultIndicator = indicator;
    }
  }]);
  return Spin2;
}(React.Component);
Spin.defaultProps = {
  spinning: true,
  size: "default",
  wrapperClassName: ""
};
var Pager = function Pager2(props) {
  var _classNames;
  var prefixCls = "".concat(props.rootPrefixCls, "-item");
  var cls = cn(prefixCls, "".concat(prefixCls, "-").concat(props.page), (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-active"), props.active), _defineProperty$4(_classNames, "".concat(prefixCls, "-disabled"), !props.page), _defineProperty$4(_classNames, props.className, !!props.className), _classNames));
  var handleClick = function handleClick2() {
    props.onClick(props.page);
  };
  var handleKeyPress = function handleKeyPress2(e3) {
    props.onKeyPress(e3, props.onClick, props.page);
  };
  return /* @__PURE__ */ React__default.createElement("li", {
    title: props.showTitle ? props.page : null,
    className: cls,
    onClick: handleClick,
    onKeyPress: handleKeyPress,
    tabIndex: "0"
  }, props.itemRender(props.page, "page", /* @__PURE__ */ React__default.createElement("a", {
    rel: "nofollow"
  }, props.page)));
};
var KEYCODE = {
  ZERO: 48,
  NINE: 57,
  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,
  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,
  ARROW_UP: 38,
  ARROW_DOWN: 40
};
var Options = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Options2, _React$Component);
  var _super = _createSuper$1(Options2);
  function Options2() {
    var _this2;
    _classCallCheck$2(this, Options2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super.call.apply(_super, [this].concat(args));
    _this2.state = {
      goInputText: ""
    };
    _this2.buildOptionText = function(value) {
      return "".concat(value, " ").concat(_this2.props.locale.items_per_page);
    };
    _this2.changeSize = function(value) {
      _this2.props.changeSize(Number(value));
    };
    _this2.handleChange = function(e3) {
      _this2.setState({
        goInputText: e3.target.value
      });
    };
    _this2.handleBlur = function(e3) {
      var _this$props = _this2.props, goButton = _this$props.goButton, quickGo = _this$props.quickGo, rootPrefixCls = _this$props.rootPrefixCls;
      var goInputText = _this2.state.goInputText;
      if (goButton || goInputText === "") {
        return;
      }
      _this2.setState({
        goInputText: ""
      });
      if (e3.relatedTarget && (e3.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item-link")) >= 0 || e3.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item")) >= 0)) {
        return;
      }
      quickGo(_this2.getValidValue());
    };
    _this2.go = function(e3) {
      var goInputText = _this2.state.goInputText;
      if (goInputText === "") {
        return;
      }
      if (e3.keyCode === KEYCODE.ENTER || e3.type === "click") {
        _this2.setState({
          goInputText: ""
        });
        _this2.props.quickGo(_this2.getValidValue());
      }
    };
    return _this2;
  }
  _createClass$2(Options2, [{
    key: "getValidValue",
    value: function getValidValue() {
      var goInputText = this.state.goInputText;
      return !goInputText || isNaN(goInputText) ? void 0 : Number(goInputText);
    }
  }, {
    key: "getPageSizeOptions",
    value: function getPageSizeOptions() {
      var _this$props2 = this.props, pageSize = _this$props2.pageSize, pageSizeOptions = _this$props2.pageSizeOptions;
      if (pageSizeOptions.some(function(option) {
        return option.toString() === pageSize.toString();
      })) {
        return pageSizeOptions;
      }
      return pageSizeOptions.concat([pageSize.toString()]).sort(function(a2, b2) {
        var numberA = isNaN(Number(a2)) ? 0 : Number(a2);
        var numberB = isNaN(Number(b2)) ? 0 : Number(b2);
        return numberA - numberB;
      });
    }
  }, {
    key: "render",
    value: function render4() {
      var _this2 = this;
      var _this$props3 = this.props, pageSize = _this$props3.pageSize, locale2 = _this$props3.locale, rootPrefixCls = _this$props3.rootPrefixCls, changeSize = _this$props3.changeSize, quickGo = _this$props3.quickGo, goButton = _this$props3.goButton, selectComponentClass = _this$props3.selectComponentClass, buildOptionText = _this$props3.buildOptionText, selectPrefixCls = _this$props3.selectPrefixCls, disabled = _this$props3.disabled;
      var goInputText = this.state.goInputText;
      var prefixCls = "".concat(rootPrefixCls, "-options");
      var Select2 = selectComponentClass;
      var changeSelect = null;
      var goInput = null;
      var gotoButton = null;
      if (!changeSize && !quickGo) {
        return null;
      }
      var pageSizeOptions = this.getPageSizeOptions();
      if (changeSize && Select2) {
        var options = pageSizeOptions.map(function(opt, i2) {
          return /* @__PURE__ */ React__default.createElement(Select2.Option, {
            key: i2,
            value: opt.toString()
          }, (buildOptionText || _this2.buildOptionText)(opt));
        });
        changeSelect = /* @__PURE__ */ React__default.createElement(Select2, {
          disabled,
          prefixCls: selectPrefixCls,
          showSearch: false,
          className: "".concat(prefixCls, "-size-changer"),
          optionLabelProp: "children",
          dropdownMatchSelectWidth: false,
          value: (pageSize || pageSizeOptions[0]).toString(),
          onChange: this.changeSize,
          getPopupContainer: function getPopupContainer(triggerNode) {
            return triggerNode.parentNode;
          },
          "aria-label": locale2.page_size,
          defaultOpen: false
        }, options);
      }
      if (quickGo) {
        if (goButton) {
          gotoButton = typeof goButton === "boolean" ? /* @__PURE__ */ React__default.createElement("button", {
            type: "button",
            onClick: this.go,
            onKeyUp: this.go,
            disabled,
            className: "".concat(prefixCls, "-quick-jumper-button")
          }, locale2.jump_to_confirm) : /* @__PURE__ */ React__default.createElement("span", {
            onClick: this.go,
            onKeyUp: this.go
          }, goButton);
        }
        goInput = /* @__PURE__ */ React__default.createElement("div", {
          className: "".concat(prefixCls, "-quick-jumper")
        }, locale2.jump_to, /* @__PURE__ */ React__default.createElement("input", {
          disabled,
          type: "text",
          value: goInputText,
          onChange: this.handleChange,
          onKeyUp: this.go,
          onBlur: this.handleBlur,
          "aria-label": locale2.page
        }), locale2.page, gotoButton);
      }
      return /* @__PURE__ */ React__default.createElement("li", {
        className: "".concat(prefixCls)
      }, changeSelect, goInput);
    }
  }]);
  return Options2;
}(React__default.Component);
Options.defaultProps = {
  pageSizeOptions: ["10", "20", "50", "100"]
};
var LOCALE = {
  items_per_page: "\u6761/\u9875",
  jump_to: "\u8DF3\u81F3",
  jump_to_confirm: "\u786E\u5B9A",
  page: "\u9875",
  prev_page: "\u4E0A\u4E00\u9875",
  next_page: "\u4E0B\u4E00\u9875",
  prev_5: "\u5411\u524D 5 \u9875",
  next_5: "\u5411\u540E 5 \u9875",
  prev_3: "\u5411\u524D 3 \u9875",
  next_3: "\u5411\u540E 3 \u9875",
  page_size: "\u9875\u7801"
};
function noop$3() {
}
function isInteger(v2) {
  var value = Number(v2);
  return typeof value === "number" && !isNaN(value) && isFinite(value) && Math.floor(value) === value;
}
function defaultItemRender(page, type2, element) {
  return element;
}
function calculatePage(p, state, props) {
  var pageSize = typeof p === "undefined" ? state.pageSize : p;
  return Math.floor((props.total - 1) / pageSize) + 1;
}
var Pagination$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Pagination3, _React$Component);
  var _super = _createSuper$1(Pagination3);
  function Pagination3(props) {
    var _this2;
    _classCallCheck$2(this, Pagination3);
    _this2 = _super.call(this, props);
    _this2.getJumpPrevPage = function() {
      return Math.max(1, _this2.state.current - (_this2.props.showLessItems ? 3 : 5));
    };
    _this2.getJumpNextPage = function() {
      return Math.min(calculatePage(void 0, _this2.state, _this2.props), _this2.state.current + (_this2.props.showLessItems ? 3 : 5));
    };
    _this2.getItemIcon = function(icon, label) {
      var prefixCls = _this2.props.prefixCls;
      var iconNode = icon || /* @__PURE__ */ React__default.createElement("button", {
        type: "button",
        "aria-label": label,
        className: "".concat(prefixCls, "-item-link")
      });
      if (typeof icon === "function") {
        iconNode = /* @__PURE__ */ React__default.createElement(icon, _objectSpread2$1({}, _this2.props));
      }
      return iconNode;
    };
    _this2.savePaginationNode = function(node) {
      _this2.paginationNode = node;
    };
    _this2.isValid = function(page) {
      var total = _this2.props.total;
      return isInteger(page) && page !== _this2.state.current && isInteger(total) && total > 0;
    };
    _this2.shouldDisplayQuickJumper = function() {
      var _this$props = _this2.props, showQuickJumper = _this$props.showQuickJumper, total = _this$props.total;
      var pageSize = _this2.state.pageSize;
      if (total <= pageSize) {
        return false;
      }
      return showQuickJumper;
    };
    _this2.handleKeyDown = function(e3) {
      if (e3.keyCode === KEYCODE.ARROW_UP || e3.keyCode === KEYCODE.ARROW_DOWN) {
        e3.preventDefault();
      }
    };
    _this2.handleKeyUp = function(e3) {
      var value = _this2.getValidValue(e3);
      var currentInputValue = _this2.state.currentInputValue;
      if (value !== currentInputValue) {
        _this2.setState({
          currentInputValue: value
        });
      }
      if (e3.keyCode === KEYCODE.ENTER) {
        _this2.handleChange(value);
      } else if (e3.keyCode === KEYCODE.ARROW_UP) {
        _this2.handleChange(value - 1);
      } else if (e3.keyCode === KEYCODE.ARROW_DOWN) {
        _this2.handleChange(value + 1);
      }
    };
    _this2.handleBlur = function(e3) {
      var value = _this2.getValidValue(e3);
      _this2.handleChange(value);
    };
    _this2.changePageSize = function(size) {
      var current = _this2.state.current;
      var newCurrent = calculatePage(size, _this2.state, _this2.props);
      current = current > newCurrent ? newCurrent : current;
      if (newCurrent === 0) {
        current = _this2.state.current;
      }
      if (typeof size === "number") {
        if (!("pageSize" in _this2.props)) {
          _this2.setState({
            pageSize: size
          });
        }
        if (!("current" in _this2.props)) {
          _this2.setState({
            current,
            currentInputValue: current
          });
        }
      }
      _this2.props.onShowSizeChange(current, size);
      if ("onChange" in _this2.props && _this2.props.onChange) {
        _this2.props.onChange(current, size);
      }
    };
    _this2.handleChange = function(page) {
      var _this$props2 = _this2.props, disabled = _this$props2.disabled, onChange4 = _this$props2.onChange;
      var _this$state = _this2.state, pageSize = _this$state.pageSize, current = _this$state.current, currentInputValue = _this$state.currentInputValue;
      if (_this2.isValid(page) && !disabled) {
        var currentPage = calculatePage(void 0, _this2.state, _this2.props);
        var newPage = page;
        if (page > currentPage) {
          newPage = currentPage;
        } else if (page < 1) {
          newPage = 1;
        }
        if (!("current" in _this2.props)) {
          _this2.setState({
            current: newPage
          });
        }
        if (newPage !== currentInputValue) {
          _this2.setState({
            currentInputValue: newPage
          });
        }
        onChange4(newPage, pageSize);
        return newPage;
      }
      return current;
    };
    _this2.prev = function() {
      if (_this2.hasPrev()) {
        _this2.handleChange(_this2.state.current - 1);
      }
    };
    _this2.next = function() {
      if (_this2.hasNext()) {
        _this2.handleChange(_this2.state.current + 1);
      }
    };
    _this2.jumpPrev = function() {
      _this2.handleChange(_this2.getJumpPrevPage());
    };
    _this2.jumpNext = function() {
      _this2.handleChange(_this2.getJumpNextPage());
    };
    _this2.hasPrev = function() {
      return _this2.state.current > 1;
    };
    _this2.hasNext = function() {
      return _this2.state.current < calculatePage(void 0, _this2.state, _this2.props);
    };
    _this2.runIfEnter = function(event, callback) {
      if (event.key === "Enter" || event.charCode === 13) {
        for (var _len = arguments.length, restParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          restParams[_key - 2] = arguments[_key];
        }
        callback.apply(void 0, restParams);
      }
    };
    _this2.runIfEnterPrev = function(e3) {
      _this2.runIfEnter(e3, _this2.prev);
    };
    _this2.runIfEnterNext = function(e3) {
      _this2.runIfEnter(e3, _this2.next);
    };
    _this2.runIfEnterJumpPrev = function(e3) {
      _this2.runIfEnter(e3, _this2.jumpPrev);
    };
    _this2.runIfEnterJumpNext = function(e3) {
      _this2.runIfEnter(e3, _this2.jumpNext);
    };
    _this2.handleGoTO = function(e3) {
      if (e3.keyCode === KEYCODE.ENTER || e3.type === "click") {
        _this2.handleChange(_this2.state.currentInputValue);
      }
    };
    var hasOnChange = props.onChange !== noop$3;
    var hasCurrent = "current" in props;
    if (hasCurrent && !hasOnChange) {
      console.warn("Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.");
    }
    var _current = props.defaultCurrent;
    if ("current" in props) {
      _current = props.current;
    }
    var _pageSize = props.defaultPageSize;
    if ("pageSize" in props) {
      _pageSize = props.pageSize;
    }
    _current = Math.min(_current, calculatePage(_pageSize, void 0, props));
    _this2.state = {
      current: _current,
      currentInputValue: _current,
      pageSize: _pageSize
    };
    return _this2;
  }
  _createClass$2(Pagination3, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var prefixCls = this.props.prefixCls;
      if (prevState.current !== this.state.current && this.paginationNode) {
        var lastCurrentNode = this.paginationNode.querySelector(".".concat(prefixCls, "-item-").concat(prevState.current));
        if (lastCurrentNode && document.activeElement === lastCurrentNode) {
          lastCurrentNode.blur();
        }
      }
    }
  }, {
    key: "getValidValue",
    value: function getValidValue(e3) {
      var inputValue = e3.target.value;
      var allPages = calculatePage(void 0, this.state, this.props);
      var currentInputValue = this.state.currentInputValue;
      var value;
      if (inputValue === "") {
        value = inputValue;
      } else if (isNaN(Number(inputValue))) {
        value = currentInputValue;
      } else if (inputValue >= allPages) {
        value = allPages;
      } else {
        value = Number(inputValue);
      }
      return value;
    }
  }, {
    key: "getShowSizeChanger",
    value: function getShowSizeChanger() {
      var _this$props3 = this.props, showSizeChanger = _this$props3.showSizeChanger, total = _this$props3.total, totalBoundaryShowSizeChanger = _this$props3.totalBoundaryShowSizeChanger;
      if (typeof showSizeChanger !== "undefined") {
        return showSizeChanger;
      }
      return total > totalBoundaryShowSizeChanger;
    }
  }, {
    key: "renderPrev",
    value: function renderPrev(prevPage) {
      var _this$props4 = this.props, prevIcon = _this$props4.prevIcon, itemRender = _this$props4.itemRender;
      var prevButton = itemRender(prevPage, "prev", this.getItemIcon(prevIcon, "prev page"));
      var disabled = !this.hasPrev();
      return /* @__PURE__ */ isValidElement$1(prevButton) ? /* @__PURE__ */ cloneElement$1(prevButton, {
        disabled
      }) : prevButton;
    }
  }, {
    key: "renderNext",
    value: function renderNext(nextPage) {
      var _this$props5 = this.props, nextIcon = _this$props5.nextIcon, itemRender = _this$props5.itemRender;
      var nextButton = itemRender(nextPage, "next", this.getItemIcon(nextIcon, "next page"));
      var disabled = !this.hasNext();
      return /* @__PURE__ */ isValidElement$1(nextButton) ? /* @__PURE__ */ cloneElement$1(nextButton, {
        disabled
      }) : nextButton;
    }
  }, {
    key: "render",
    value: function render4() {
      var _this2 = this;
      var _this$props6 = this.props, prefixCls = _this$props6.prefixCls, className = _this$props6.className, style2 = _this$props6.style, disabled = _this$props6.disabled, hideOnSinglePage = _this$props6.hideOnSinglePage, total = _this$props6.total, locale2 = _this$props6.locale, showQuickJumper = _this$props6.showQuickJumper, showLessItems = _this$props6.showLessItems, showTitle = _this$props6.showTitle, showTotal = _this$props6.showTotal, simple = _this$props6.simple, itemRender = _this$props6.itemRender, showPrevNextJumpers = _this$props6.showPrevNextJumpers, jumpPrevIcon = _this$props6.jumpPrevIcon, jumpNextIcon = _this$props6.jumpNextIcon, selectComponentClass = _this$props6.selectComponentClass, selectPrefixCls = _this$props6.selectPrefixCls, pageSizeOptions = _this$props6.pageSizeOptions;
      var _this$state2 = this.state, current = _this$state2.current, pageSize = _this$state2.pageSize, currentInputValue = _this$state2.currentInputValue;
      if (hideOnSinglePage === true && total <= pageSize) {
        return null;
      }
      var allPages = calculatePage(void 0, this.state, this.props);
      var pagerList = [];
      var jumpPrev = null;
      var jumpNext = null;
      var firstPager = null;
      var lastPager = null;
      var gotoButton = null;
      var goButton = showQuickJumper && showQuickJumper.goButton;
      var pageBufferSize = showLessItems ? 1 : 2;
      var prevPage = current - 1 > 0 ? current - 1 : 0;
      var nextPage = current + 1 < allPages ? current + 1 : allPages;
      var dataOrAriaAttributeProps = Object.keys(this.props).reduce(function(prev, key2) {
        if (key2.substr(0, 5) === "data-" || key2.substr(0, 5) === "aria-" || key2 === "role") {
          prev[key2] = _this2.props[key2];
        }
        return prev;
      }, {});
      if (simple) {
        if (goButton) {
          if (typeof goButton === "boolean") {
            gotoButton = /* @__PURE__ */ React__default.createElement("button", {
              type: "button",
              onClick: this.handleGoTO,
              onKeyUp: this.handleGoTO
            }, locale2.jump_to_confirm);
          } else {
            gotoButton = /* @__PURE__ */ React__default.createElement("span", {
              onClick: this.handleGoTO,
              onKeyUp: this.handleGoTO
            }, goButton);
          }
          gotoButton = /* @__PURE__ */ React__default.createElement("li", {
            title: showTitle ? "".concat(locale2.jump_to).concat(current, "/").concat(allPages) : null,
            className: "".concat(prefixCls, "-simple-pager")
          }, gotoButton);
        }
        return /* @__PURE__ */ React__default.createElement("ul", _extends$2({
          className: cn(prefixCls, "".concat(prefixCls, "-simple"), _defineProperty$4({}, "".concat(prefixCls, "-disabled"), disabled), className),
          style: style2,
          ref: this.savePaginationNode
        }, dataOrAriaAttributeProps), /* @__PURE__ */ React__default.createElement("li", {
          title: showTitle ? locale2.prev_page : null,
          onClick: this.prev,
          tabIndex: this.hasPrev() ? 0 : null,
          onKeyPress: this.runIfEnterPrev,
          className: cn("".concat(prefixCls, "-prev"), _defineProperty$4({}, "".concat(prefixCls, "-disabled"), !this.hasPrev())),
          "aria-disabled": !this.hasPrev()
        }, this.renderPrev(prevPage)), /* @__PURE__ */ React__default.createElement("li", {
          title: showTitle ? "".concat(current, "/").concat(allPages) : null,
          className: "".concat(prefixCls, "-simple-pager")
        }, /* @__PURE__ */ React__default.createElement("input", {
          type: "text",
          value: currentInputValue,
          disabled,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          onChange: this.handleKeyUp,
          onBlur: this.handleBlur,
          size: "3"
        }), /* @__PURE__ */ React__default.createElement("span", {
          className: "".concat(prefixCls, "-slash")
        }, "/"), allPages), /* @__PURE__ */ React__default.createElement("li", {
          title: showTitle ? locale2.next_page : null,
          onClick: this.next,
          tabIndex: this.hasPrev() ? 0 : null,
          onKeyPress: this.runIfEnterNext,
          className: cn("".concat(prefixCls, "-next"), _defineProperty$4({}, "".concat(prefixCls, "-disabled"), !this.hasNext())),
          "aria-disabled": !this.hasNext()
        }, this.renderNext(nextPage)), gotoButton);
      }
      if (allPages <= 3 + pageBufferSize * 2) {
        var pagerProps = {
          locale: locale2,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          showTitle,
          itemRender
        };
        if (!allPages) {
          pagerList.push(/* @__PURE__ */ React__default.createElement(Pager, _extends$2({}, pagerProps, {
            key: "noPager",
            page: 1,
            className: "".concat(prefixCls, "-item-disabled")
          })));
        }
        for (var i2 = 1; i2 <= allPages; i2 += 1) {
          var active = current === i2;
          pagerList.push(/* @__PURE__ */ React__default.createElement(Pager, _extends$2({}, pagerProps, {
            key: i2,
            page: i2,
            active
          })));
        }
      } else {
        var prevItemTitle = showLessItems ? locale2.prev_3 : locale2.prev_5;
        var nextItemTitle = showLessItems ? locale2.next_3 : locale2.next_5;
        if (showPrevNextJumpers) {
          jumpPrev = /* @__PURE__ */ React__default.createElement("li", {
            title: showTitle ? prevItemTitle : null,
            key: "prev",
            onClick: this.jumpPrev,
            tabIndex: "0",
            onKeyPress: this.runIfEnterJumpPrev,
            className: cn("".concat(prefixCls, "-jump-prev"), _defineProperty$4({}, "".concat(prefixCls, "-jump-prev-custom-icon"), !!jumpPrevIcon))
          }, itemRender(this.getJumpPrevPage(), "jump-prev", this.getItemIcon(jumpPrevIcon, "prev page")));
          jumpNext = /* @__PURE__ */ React__default.createElement("li", {
            title: showTitle ? nextItemTitle : null,
            key: "next",
            tabIndex: "0",
            onClick: this.jumpNext,
            onKeyPress: this.runIfEnterJumpNext,
            className: cn("".concat(prefixCls, "-jump-next"), _defineProperty$4({}, "".concat(prefixCls, "-jump-next-custom-icon"), !!jumpNextIcon))
          }, itemRender(this.getJumpNextPage(), "jump-next", this.getItemIcon(jumpNextIcon, "next page")));
        }
        lastPager = /* @__PURE__ */ React__default.createElement(Pager, {
          locale: locale2,
          last: true,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: allPages,
          page: allPages,
          active: false,
          showTitle,
          itemRender
        });
        firstPager = /* @__PURE__ */ React__default.createElement(Pager, {
          locale: locale2,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: 1,
          page: 1,
          active: false,
          showTitle,
          itemRender
        });
        var left = Math.max(1, current - pageBufferSize);
        var right = Math.min(current + pageBufferSize, allPages);
        if (current - 1 <= pageBufferSize) {
          right = 1 + pageBufferSize * 2;
        }
        if (allPages - current <= pageBufferSize) {
          left = allPages - pageBufferSize * 2;
        }
        for (var _i = left; _i <= right; _i += 1) {
          var _active = current === _i;
          pagerList.push(/* @__PURE__ */ React__default.createElement(Pager, {
            locale: locale2,
            rootPrefixCls: prefixCls,
            onClick: this.handleChange,
            onKeyPress: this.runIfEnter,
            key: _i,
            page: _i,
            active: _active,
            showTitle,
            itemRender
          }));
        }
        if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
          pagerList[0] = /* @__PURE__ */ cloneElement$1(pagerList[0], {
            className: "".concat(prefixCls, "-item-after-jump-prev")
          });
          pagerList.unshift(jumpPrev);
        }
        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
          pagerList[pagerList.length - 1] = /* @__PURE__ */ cloneElement$1(pagerList[pagerList.length - 1], {
            className: "".concat(prefixCls, "-item-before-jump-next")
          });
          pagerList.push(jumpNext);
        }
        if (left !== 1) {
          pagerList.unshift(firstPager);
        }
        if (right !== allPages) {
          pagerList.push(lastPager);
        }
      }
      var totalText = null;
      if (showTotal) {
        totalText = /* @__PURE__ */ React__default.createElement("li", {
          className: "".concat(prefixCls, "-total-text")
        }, showTotal(total, [total === 0 ? 0 : (current - 1) * pageSize + 1, current * pageSize > total ? total : current * pageSize]));
      }
      var prevDisabled = !this.hasPrev() || !allPages;
      var nextDisabled = !this.hasNext() || !allPages;
      return /* @__PURE__ */ React__default.createElement("ul", _extends$2({
        className: cn(prefixCls, className, _defineProperty$4({}, "".concat(prefixCls, "-disabled"), disabled)),
        style: style2,
        unselectable: "unselectable",
        ref: this.savePaginationNode
      }, dataOrAriaAttributeProps), totalText, /* @__PURE__ */ React__default.createElement("li", {
        title: showTitle ? locale2.prev_page : null,
        onClick: this.prev,
        tabIndex: prevDisabled ? null : 0,
        onKeyPress: this.runIfEnterPrev,
        className: cn("".concat(prefixCls, "-prev"), _defineProperty$4({}, "".concat(prefixCls, "-disabled"), prevDisabled)),
        "aria-disabled": prevDisabled
      }, this.renderPrev(prevPage)), pagerList, /* @__PURE__ */ React__default.createElement("li", {
        title: showTitle ? locale2.next_page : null,
        onClick: this.next,
        tabIndex: nextDisabled ? null : 0,
        onKeyPress: this.runIfEnterNext,
        className: cn("".concat(prefixCls, "-next"), _defineProperty$4({}, "".concat(prefixCls, "-disabled"), nextDisabled)),
        "aria-disabled": nextDisabled
      }, this.renderNext(nextPage)), /* @__PURE__ */ React__default.createElement(Options, {
        disabled,
        locale: locale2,
        rootPrefixCls: prefixCls,
        selectComponentClass,
        selectPrefixCls,
        changeSize: this.getShowSizeChanger() ? this.changePageSize : null,
        current,
        pageSize,
        pageSizeOptions,
        quickGo: this.shouldDisplayQuickJumper() ? this.handleChange : null,
        goButton
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, prevState) {
      var newState = {};
      if ("current" in props) {
        newState.current = props.current;
        if (props.current !== prevState.current) {
          newState.currentInputValue = newState.current;
        }
      }
      if ("pageSize" in props && props.pageSize !== prevState.pageSize) {
        var current = prevState.current;
        var newCurrent = calculatePage(props.pageSize, prevState, props);
        current = current > newCurrent ? newCurrent : current;
        if (!("current" in props)) {
          newState.current = current;
          newState.currentInputValue = current;
        }
        newState.pageSize = props.pageSize;
      }
      return newState;
    }
  }]);
  return Pagination3;
}(React__default.Component);
Pagination$1.defaultProps = {
  defaultCurrent: 1,
  total: 0,
  defaultPageSize: 10,
  onChange: noop$3,
  className: "",
  selectPrefixCls: "rc-select",
  prefixCls: "rc-pagination",
  selectComponentClass: null,
  hideOnSinglePage: false,
  showPrevNextJumpers: true,
  showQuickJumper: false,
  showLessItems: false,
  showTitle: true,
  onShowSizeChange: noop$3,
  locale: LOCALE,
  style: {},
  itemRender: defaultItemRender,
  totalBoundaryShowSizeChanger: 50
};
var DoubleLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, "name": "double-left", "theme": "outlined" };
var DoubleLeftOutlined = function DoubleLeftOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: DoubleLeftOutlined$2
  }));
};
DoubleLeftOutlined.displayName = "DoubleLeftOutlined";
var DoubleLeftOutlined$1 = /* @__PURE__ */ React.forwardRef(DoubleLeftOutlined);
var DoubleRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, "name": "double-right", "theme": "outlined" };
var DoubleRightOutlined = function DoubleRightOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: DoubleRightOutlined$2
  }));
};
DoubleRightOutlined.displayName = "DoubleRightOutlined";
var DoubleRightOutlined$1 = /* @__PURE__ */ React.forwardRef(DoubleRightOutlined);
var MiniSelect = function MiniSelect2(props) {
  return /* @__PURE__ */ React.createElement(Select$2, _extends$2({
    size: "small"
  }, props));
};
MiniSelect.Option = Select$2.Option;
var __rest$i = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var Pagination = function Pagination2(_a) {
  var customizePrefixCls = _a.prefixCls, customizeSelectPrefixCls = _a.selectPrefixCls, className = _a.className, size = _a.size, customLocale = _a.locale, restProps = __rest$i(_a, ["prefixCls", "selectPrefixCls", "className", "size", "locale"]);
  var _useBreakpoint = useBreakpoint(), xs = _useBreakpoint.xs;
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var prefixCls = getPrefixCls("pagination", customizePrefixCls);
  var getIconsProps = function getIconsProps2() {
    var ellipsis = /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-item-ellipsis")
    }, "\u2022\u2022\u2022");
    var prevIcon = /* @__PURE__ */ React.createElement("button", {
      className: "".concat(prefixCls, "-item-link"),
      type: "button",
      tabIndex: -1
    }, /* @__PURE__ */ React.createElement(LeftOutlined$1, null));
    var nextIcon = /* @__PURE__ */ React.createElement("button", {
      className: "".concat(prefixCls, "-item-link"),
      type: "button",
      tabIndex: -1
    }, /* @__PURE__ */ React.createElement(RightOutlined$1, null));
    var jumpPrevIcon = /* @__PURE__ */ React.createElement("a", {
      className: "".concat(prefixCls, "-item-link")
    }, /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-item-container")
    }, /* @__PURE__ */ React.createElement(DoubleLeftOutlined$1, {
      className: "".concat(prefixCls, "-item-link-icon")
    }), ellipsis));
    var jumpNextIcon = /* @__PURE__ */ React.createElement("a", {
      className: "".concat(prefixCls, "-item-link")
    }, /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-item-container")
    }, /* @__PURE__ */ React.createElement(DoubleRightOutlined$1, {
      className: "".concat(prefixCls, "-item-link-icon")
    }), ellipsis));
    if (direction === "rtl") {
      var _ref = [nextIcon, prevIcon];
      prevIcon = _ref[0];
      nextIcon = _ref[1];
      var _ref2 = [jumpNextIcon, jumpPrevIcon];
      jumpPrevIcon = _ref2[0];
      jumpNextIcon = _ref2[1];
    }
    return {
      prevIcon,
      nextIcon,
      jumpPrevIcon,
      jumpNextIcon
    };
  };
  var renderPagination = function renderPagination2(contextLocale) {
    var locale2 = _extends$2(_extends$2({}, contextLocale), customLocale);
    var isSmall = size === "small" || !!(xs && !size && restProps.responsive);
    var selectPrefixCls = getPrefixCls("select", customizeSelectPrefixCls);
    var extendedClassName = cn(_defineProperty$4({
      mini: isSmall
    }, "".concat(prefixCls, "-rtl"), direction === "rtl"), className);
    return /* @__PURE__ */ React.createElement(Pagination$1, _extends$2({}, restProps, {
      prefixCls,
      selectPrefixCls
    }, getIconsProps(), {
      className: extendedClassName,
      selectComponentClass: isSmall ? MiniSelect : Select$2,
      locale: locale2
    }));
  };
  return /* @__PURE__ */ React.createElement(LocaleReceiver, {
    componentName: "Pagination",
    defaultLocale: enUS
  }, renderPagination);
};
var __rest$h = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var Meta = function Meta2(_a) {
  var customizePrefixCls = _a.prefixCls, className = _a.className, avatar = _a.avatar, title = _a.title, description = _a.description, others = __rest$h(_a, ["prefixCls", "className", "avatar", "title", "description"]);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls("list", customizePrefixCls);
  var classString = cn("".concat(prefixCls, "-item-meta"), className);
  var content = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-item-meta-content")
  }, title && /* @__PURE__ */ React.createElement("h4", {
    className: "".concat(prefixCls, "-item-meta-title")
  }, title), description && /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-item-meta-description")
  }, description));
  return /* @__PURE__ */ React.createElement("div", _extends$2({}, others, {
    className: classString
  }), avatar && /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-item-meta-avatar")
  }, avatar), (title || description) && content);
};
var Item = function Item2(_a) {
  var customizePrefixCls = _a.prefixCls, children = _a.children, actions = _a.actions, extra = _a.extra, className = _a.className, colStyle = _a.colStyle, others = __rest$h(_a, ["prefixCls", "children", "actions", "extra", "className", "colStyle"]);
  var _React$useContext2 = React.useContext(ListContext), grid = _React$useContext2.grid, itemLayout = _React$useContext2.itemLayout;
  var _React$useContext3 = React.useContext(ConfigContext), getPrefixCls = _React$useContext3.getPrefixCls;
  var isItemContainsTextNodeAndNotSingular = function isItemContainsTextNodeAndNotSingular2() {
    var result;
    React.Children.forEach(children, function(element) {
      if (typeof element === "string") {
        result = true;
      }
    });
    return result && React.Children.count(children) > 1;
  };
  var isFlexMode = function isFlexMode2() {
    if (itemLayout === "vertical") {
      return !!extra;
    }
    return !isItemContainsTextNodeAndNotSingular();
  };
  var prefixCls = getPrefixCls("list", customizePrefixCls);
  var actionsContent = actions && actions.length > 0 && /* @__PURE__ */ React.createElement("ul", {
    className: "".concat(prefixCls, "-item-action"),
    key: "actions"
  }, actions.map(function(action, i2) {
    return /* @__PURE__ */ React.createElement("li", {
      key: "".concat(prefixCls, "-item-action-").concat(i2)
    }, action, i2 !== actions.length - 1 && /* @__PURE__ */ React.createElement("em", {
      className: "".concat(prefixCls, "-item-action-split")
    }));
  }));
  var Element3 = grid ? "div" : "li";
  var itemChildren = /* @__PURE__ */ React.createElement(Element3, _extends$2({}, others, {
    className: cn("".concat(prefixCls, "-item"), _defineProperty$4({}, "".concat(prefixCls, "-item-no-flex"), !isFlexMode()), className)
  }), itemLayout === "vertical" && extra ? [/* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-item-main"),
    key: "content"
  }, children, actionsContent), /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-item-extra"),
    key: "extra"
  }, extra)] : [children, actionsContent, cloneElement2(extra, {
    key: "extra"
  })]);
  return grid ? /* @__PURE__ */ React.createElement(Col, {
    flex: 1,
    style: colStyle
  }, itemChildren) : itemChildren;
};
Item.Meta = Meta;
var ListContext = /* @__PURE__ */ React.createContext({});
ListContext.Consumer;
var MentionsContext = /* @__PURE__ */ React.createContext(null);
var MentionsContextProvider = MentionsContext.Provider;
var MentionsContextConsumer = MentionsContext.Consumer;
var DropdownMenu = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(DropdownMenu2, _React$Component);
  var _super = _createSuper$1(DropdownMenu2);
  function DropdownMenu2() {
    var _this2;
    _classCallCheck$2(this, DropdownMenu2);
    _this2 = _super.apply(this, arguments);
    _this2.renderDropdown = function(_ref) {
      var notFoundContent = _ref.notFoundContent, activeIndex = _ref.activeIndex, setActiveIndex = _ref.setActiveIndex, selectOption = _ref.selectOption, onFocus2 = _ref.onFocus, onBlur2 = _ref.onBlur;
      var _this$props = _this2.props, prefixCls = _this$props.prefixCls, options = _this$props.options;
      var activeOption = options[activeIndex] || {};
      return /* @__PURE__ */ React.createElement(Menu$1, {
        prefixCls: "".concat(prefixCls, "-menu"),
        activeKey: activeOption.key,
        onSelect: function onSelect(_ref2) {
          var key2 = _ref2.key;
          var option = options.find(function(_ref3) {
            var optionKey = _ref3.key;
            return optionKey === key2;
          });
          selectOption(option);
        },
        onFocus: onFocus2,
        onBlur: onBlur2
      }, options.map(function(option, index2) {
        var key2 = option.key, disabled = option.disabled, children = option.children, className = option.className, style2 = option.style;
        return /* @__PURE__ */ React.createElement(connected, {
          key: key2,
          disabled,
          className,
          style: style2,
          onMouseEnter: function onMouseEnter() {
            setActiveIndex(index2);
          }
        }, children);
      }), !options.length && /* @__PURE__ */ React.createElement(connected, {
        disabled: true
      }, notFoundContent));
    };
    return _this2;
  }
  _createClass$2(DropdownMenu2, [{
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(MentionsContextConsumer, null, this.renderDropdown);
    }
  }]);
  return DropdownMenu2;
}(React.Component);
var BUILT_IN_PLACEMENTS = {
  bottomRight: {
    points: ["tl", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  bottomLeft: {
    points: ["tr", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ["bl", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["br", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
var KeywordTrigger = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(KeywordTrigger2, _React$Component);
  var _super = _createSuper$1(KeywordTrigger2);
  function KeywordTrigger2() {
    var _this2;
    _classCallCheck$2(this, KeywordTrigger2);
    _this2 = _super.apply(this, arguments);
    _this2.getDropdownPrefix = function() {
      return "".concat(_this2.props.prefixCls, "-dropdown");
    };
    _this2.getDropdownElement = function() {
      var options = _this2.props.options;
      return /* @__PURE__ */ React.createElement(DropdownMenu, {
        prefixCls: _this2.getDropdownPrefix(),
        options
      });
    };
    _this2.getDropDownPlacement = function() {
      var _this$props = _this2.props, placement = _this$props.placement, direction = _this$props.direction;
      var popupPlacement = "topRight";
      if (direction === "rtl") {
        popupPlacement = placement === "top" ? "topLeft" : "bottomLeft";
      } else {
        popupPlacement = placement === "top" ? "topRight" : "bottomRight";
      }
      return popupPlacement;
    };
    return _this2;
  }
  _createClass$2(KeywordTrigger2, [{
    key: "render",
    value: function render4() {
      var _this$props2 = this.props, children = _this$props2.children, visible = _this$props2.visible, transitionName2 = _this$props2.transitionName, getPopupContainer = _this$props2.getPopupContainer;
      var popupElement = this.getDropdownElement();
      return /* @__PURE__ */ React.createElement(Trigger, {
        prefixCls: this.getDropdownPrefix(),
        popupVisible: visible,
        popup: popupElement,
        popupPlacement: this.getDropDownPlacement(),
        popupTransitionName: transitionName2,
        builtinPlacements: BUILT_IN_PLACEMENTS,
        getPopupContainer
      }, children);
    }
  }]);
  return KeywordTrigger2;
}(React.Component);
var Option$1 = function Option2() {
  return null;
};
var omit = function omit2(obj) {
  var clone2 = _objectSpread2$1({}, obj);
  for (var _len = arguments.length, keys2 = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys2[_key - 1] = arguments[_key];
  }
  keys2.forEach(function(key2) {
    delete clone2[key2];
  });
  return clone2;
};
function getBeforeSelectionText(input) {
  var selectionStart = input.selectionStart;
  return input.value.slice(0, selectionStart);
}
function getLastMeasureIndex(text) {
  var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  var prefixList = Array.isArray(prefix) ? prefix : [prefix];
  return prefixList.reduce(function(lastMatch, prefixStr) {
    var lastIndex = text.lastIndexOf(prefixStr);
    if (lastIndex > lastMatch.location) {
      return {
        location: lastIndex,
        prefix: prefixStr
      };
    }
    return lastMatch;
  }, {
    location: -1,
    prefix: ""
  });
}
function lower(char) {
  return (char || "").toLowerCase();
}
function reduceText(text, targetText, split) {
  var firstChar = text[0];
  if (!firstChar || firstChar === split) {
    return text;
  }
  var restText = text;
  var targetTextLen = targetText.length;
  for (var i2 = 0; i2 < targetTextLen; i2 += 1) {
    if (lower(restText[i2]) !== lower(targetText[i2])) {
      restText = restText.slice(i2);
      break;
    } else if (i2 === targetTextLen - 1) {
      restText = restText.slice(targetTextLen);
    }
  }
  return restText;
}
function replaceWithMeasure(text, measureConfig) {
  var measureLocation = measureConfig.measureLocation, prefix = measureConfig.prefix, targetText = measureConfig.targetText, selectionStart = measureConfig.selectionStart, split = measureConfig.split;
  var beforeMeasureText = text.slice(0, measureLocation);
  if (beforeMeasureText[beforeMeasureText.length - split.length] === split) {
    beforeMeasureText = beforeMeasureText.slice(0, beforeMeasureText.length - split.length);
  }
  if (beforeMeasureText) {
    beforeMeasureText = "".concat(beforeMeasureText).concat(split);
  }
  var restText = reduceText(text.slice(selectionStart), targetText.slice(selectionStart - measureLocation - prefix.length), split);
  if (restText.slice(0, split.length) === split) {
    restText = restText.slice(split.length);
  }
  var connectedStartText = "".concat(beforeMeasureText).concat(prefix).concat(targetText).concat(split);
  return {
    text: "".concat(connectedStartText).concat(restText),
    selectionLocation: connectedStartText.length
  };
}
function setInputSelection(input, location) {
  input.setSelectionRange(location, location);
  input.blur();
  input.focus();
}
function validateSearch(text, props) {
  var split = props.split;
  return !split || text.indexOf(split) === -1;
}
function filterOption(input, _ref) {
  var _ref$value = _ref.value, value = _ref$value === void 0 ? "" : _ref$value;
  var lowerCase = input.toLowerCase();
  return value.toLowerCase().indexOf(lowerCase) !== -1;
}
var Mentions$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Mentions2, _React$Component);
  var _super = _createSuper$1(Mentions2);
  function Mentions2(props) {
    var _this2;
    _classCallCheck$2(this, Mentions2);
    _this2 = _super.call(this, props);
    _this2.focusId = void 0;
    _this2.triggerChange = function(value) {
      var onChange4 = _this2.props.onChange;
      if (!("value" in _this2.props)) {
        _this2.setState({
          value
        });
      }
      if (onChange4) {
        onChange4(value);
      }
    };
    _this2.onChange = function(_ref) {
      var value = _ref.target.value;
      _this2.triggerChange(value);
    };
    _this2.onKeyDown = function(event) {
      var which = event.which;
      var _this$state = _this2.state, activeIndex = _this$state.activeIndex, measuring = _this$state.measuring;
      if (!measuring) {
        return;
      }
      if (which === KeyCode.UP || which === KeyCode.DOWN) {
        var optionLen = _this2.getOptions().length;
        var offset3 = which === KeyCode.UP ? -1 : 1;
        var newActiveIndex = (activeIndex + offset3 + optionLen) % optionLen;
        _this2.setState({
          activeIndex: newActiveIndex
        });
        event.preventDefault();
      } else if (which === KeyCode.ESC) {
        _this2.stopMeasure();
      } else if (which === KeyCode.ENTER) {
        event.preventDefault();
        var options = _this2.getOptions();
        if (!options.length) {
          _this2.stopMeasure();
          return;
        }
        var option = options[activeIndex];
        _this2.selectOption(option);
      }
    };
    _this2.onKeyUp = function(event) {
      var key2 = event.key, which = event.which;
      var _this$state2 = _this2.state, prevMeasureText = _this$state2.measureText, measuring = _this$state2.measuring;
      var _this$props = _this2.props, _this$props$prefix = _this$props.prefix, prefix = _this$props$prefix === void 0 ? "" : _this$props$prefix, onSearch = _this$props.onSearch, validateSearch2 = _this$props.validateSearch;
      var target = event.target;
      var selectionStartText = getBeforeSelectionText(target);
      var _getLastMeasureIndex = getLastMeasureIndex(selectionStartText, prefix), measureIndex = _getLastMeasureIndex.location, measurePrefix = _getLastMeasureIndex.prefix;
      if ([KeyCode.ESC, KeyCode.UP, KeyCode.DOWN, KeyCode.ENTER].indexOf(which) !== -1) {
        return;
      }
      if (measureIndex !== -1) {
        var measureText = selectionStartText.slice(measureIndex + measurePrefix.length);
        var validateMeasure = validateSearch2(measureText, _this2.props);
        var matchOption = !!_this2.getOptions(measureText).length;
        if (validateMeasure) {
          if (key2 === measurePrefix || key2 === "Shift" || measuring || measureText !== prevMeasureText && matchOption) {
            _this2.startMeasure(measureText, measurePrefix, measureIndex);
          }
        } else if (measuring) {
          _this2.stopMeasure();
        }
        if (onSearch && validateMeasure) {
          onSearch(measureText, measurePrefix);
        }
      } else if (measuring) {
        _this2.stopMeasure();
      }
    };
    _this2.onPressEnter = function(event) {
      var measuring = _this2.state.measuring;
      var onPressEnter = _this2.props.onPressEnter;
      if (!measuring && onPressEnter) {
        onPressEnter(event);
      }
    };
    _this2.onInputFocus = function(event) {
      _this2.onFocus(event);
    };
    _this2.onInputBlur = function(event) {
      _this2.onBlur(event);
    };
    _this2.onDropdownFocus = function() {
      _this2.onFocus();
    };
    _this2.onDropdownBlur = function() {
      _this2.onBlur();
    };
    _this2.onFocus = function(event) {
      window.clearTimeout(_this2.focusId);
      var isFocus = _this2.state.isFocus;
      var onFocus2 = _this2.props.onFocus;
      if (!isFocus && event && onFocus2) {
        onFocus2(event);
      }
      _this2.setState({
        isFocus: true
      });
    };
    _this2.onBlur = function(event) {
      _this2.focusId = window.setTimeout(function() {
        var onBlur2 = _this2.props.onBlur;
        _this2.setState({
          isFocus: false
        });
        _this2.stopMeasure();
        if (onBlur2) {
          onBlur2(event);
        }
      }, 0);
    };
    _this2.selectOption = function(option) {
      var _this$state3 = _this2.state, value = _this$state3.value, measureLocation = _this$state3.measureLocation, measurePrefix = _this$state3.measurePrefix;
      var _this$props2 = _this2.props, split = _this$props2.split, onSelect = _this$props2.onSelect;
      var _option$value = option.value, mentionValue = _option$value === void 0 ? "" : _option$value;
      var _replaceWithMeasure = replaceWithMeasure(value, {
        measureLocation,
        targetText: mentionValue,
        prefix: measurePrefix,
        selectionStart: _this2.textarea.selectionStart,
        split
      }), text = _replaceWithMeasure.text, selectionLocation = _replaceWithMeasure.selectionLocation;
      _this2.triggerChange(text);
      _this2.stopMeasure(function() {
        setInputSelection(_this2.textarea, selectionLocation);
      });
      if (onSelect) {
        onSelect(option, measurePrefix);
      }
    };
    _this2.setActiveIndex = function(activeIndex) {
      _this2.setState({
        activeIndex
      });
    };
    _this2.setTextAreaRef = function(element) {
      var _element$resizableTex;
      _this2.textarea = element === null || element === void 0 ? void 0 : (_element$resizableTex = element.resizableTextArea) === null || _element$resizableTex === void 0 ? void 0 : _element$resizableTex.textArea;
    };
    _this2.setMeasureRef = function(element) {
      _this2.measure = element;
    };
    _this2.getOptions = function(measureText) {
      var targetMeasureText = measureText || _this2.state.measureText || "";
      var _this$props3 = _this2.props, children = _this$props3.children, filterOption2 = _this$props3.filterOption;
      var list = toArray$8(children).map(function(_ref2) {
        var props2 = _ref2.props, key2 = _ref2.key;
        return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
          key: key2 || props2.value
        });
      }).filter(function(option) {
        if (filterOption2 === false) {
          return true;
        }
        return filterOption2(targetMeasureText, option);
      });
      return list;
    };
    _this2.state = {
      value: props.defaultValue || props.value || "",
      measuring: false,
      measureLocation: 0,
      measureText: null,
      measurePrefix: "",
      activeIndex: 0,
      isFocus: false
    };
    return _this2;
  }
  _createClass$2(Mentions2, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var measuring = this.state.measuring;
      if (measuring) {
        this.measure.scrollTop = this.textarea.scrollTop;
      }
    }
  }, {
    key: "startMeasure",
    value: function startMeasure(measureText, measurePrefix, measureLocation) {
      this.setState({
        measuring: true,
        measureText,
        measurePrefix,
        measureLocation,
        activeIndex: 0
      });
    }
  }, {
    key: "stopMeasure",
    value: function stopMeasure(callback) {
      this.setState({
        measuring: false,
        measureLocation: 0,
        measureText: null
      }, callback);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.textarea.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.textarea.blur();
    }
  }, {
    key: "render",
    value: function render4() {
      var _this$state4 = this.state, value = _this$state4.value, measureLocation = _this$state4.measureLocation, measurePrefix = _this$state4.measurePrefix, measuring = _this$state4.measuring, activeIndex = _this$state4.activeIndex;
      var _this$props4 = this.props, prefixCls = _this$props4.prefixCls, placement = _this$props4.placement, direction = _this$props4.direction, transitionName2 = _this$props4.transitionName, className = _this$props4.className, style2 = _this$props4.style, autoFocus = _this$props4.autoFocus, notFoundContent = _this$props4.notFoundContent, getPopupContainer = _this$props4.getPopupContainer, restProps = _objectWithoutProperties$1(_this$props4, ["prefixCls", "placement", "direction", "transitionName", "className", "style", "autoFocus", "notFoundContent", "getPopupContainer"]);
      var inputProps = omit(restProps, "value", "defaultValue", "prefix", "split", "children", "validateSearch", "filterOption", "onSelect", "onSearch");
      var options = measuring ? this.getOptions() : [];
      return /* @__PURE__ */ React.createElement("div", {
        className: cn(prefixCls, className),
        style: style2
      }, /* @__PURE__ */ React.createElement(TextArea$1, Object.assign({
        autoFocus,
        ref: this.setTextAreaRef,
        value
      }, inputProps, {
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        onKeyUp: this.onKeyUp,
        onPressEnter: this.onPressEnter,
        onFocus: this.onInputFocus,
        onBlur: this.onInputBlur
      })), measuring && /* @__PURE__ */ React.createElement("div", {
        ref: this.setMeasureRef,
        className: "".concat(prefixCls, "-measure")
      }, value.slice(0, measureLocation), /* @__PURE__ */ React.createElement(MentionsContextProvider, {
        value: {
          notFoundContent,
          activeIndex,
          setActiveIndex: this.setActiveIndex,
          selectOption: this.selectOption,
          onFocus: this.onDropdownFocus,
          onBlur: this.onDropdownBlur
        }
      }, /* @__PURE__ */ React.createElement(KeywordTrigger, {
        prefixCls,
        transitionName: transitionName2,
        placement,
        direction,
        options,
        visible: true,
        getPopupContainer
      }, /* @__PURE__ */ React.createElement("span", null, measurePrefix))), value.slice(measureLocation + measurePrefix.length)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, prevState) {
      var newState = {};
      if ("value" in props && props.value !== prevState.value) {
        newState.value = props.value || "";
      }
      return newState;
    }
  }]);
  return Mentions2;
}(React.Component);
Mentions$1.Option = Option$1;
Mentions$1.defaultProps = {
  prefixCls: "rc-mentions",
  prefix: "@",
  split: " ",
  validateSearch,
  filterOption,
  notFoundContent: "Not Found",
  rows: 1
};
var __rest$g = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var Option3 = Mentions$1.Option;
function loadingFilterOption() {
  return true;
}
var InternalMentions = function InternalMentions2(_a, ref) {
  var _classNames;
  var customizePrefixCls = _a.prefixCls, className = _a.className, disabled = _a.disabled, loading = _a.loading, filterOption2 = _a.filterOption, children = _a.children, notFoundContent = _a.notFoundContent, restProps = __rest$g(_a, ["prefixCls", "className", "disabled", "loading", "filterOption", "children", "notFoundContent"]);
  var _React$useState = React.useState(false), _React$useState2 = _slicedToArray$3(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
  var innerRef = React.useRef();
  var mergedRef = composeRef(ref, innerRef);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, renderEmpty3 = _React$useContext.renderEmpty, direction = _React$useContext.direction;
  var onFocus2 = function onFocus3() {
    if (restProps.onFocus) {
      restProps.onFocus.apply(restProps, arguments);
    }
    setFocused(true);
  };
  var onBlur2 = function onBlur3() {
    if (restProps.onBlur) {
      restProps.onBlur.apply(restProps, arguments);
    }
    setFocused(false);
  };
  var getNotFoundContent = function getNotFoundContent2() {
    if (notFoundContent !== void 0) {
      return notFoundContent;
    }
    return renderEmpty3("Select");
  };
  var getOptions2 = function getOptions3() {
    if (loading) {
      return /* @__PURE__ */ React.createElement(Option3, {
        value: "ANTD_SEARCHING",
        disabled: true
      }, /* @__PURE__ */ React.createElement(Spin, {
        size: "small"
      }));
    }
    return children;
  };
  var getFilterOption = function getFilterOption2() {
    if (loading) {
      return loadingFilterOption;
    }
    return filterOption2;
  };
  var prefixCls = getPrefixCls("mentions", customizePrefixCls);
  var mergedClassName = cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty$4(_classNames, "".concat(prefixCls, "-focused"), focused), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
  return /* @__PURE__ */ React.createElement(Mentions$1, _extends$2({
    prefixCls,
    notFoundContent: getNotFoundContent(),
    className: mergedClassName,
    disabled,
    direction
  }, restProps, {
    filterOption: getFilterOption(),
    onFocus: onFocus2,
    onBlur: onBlur2,
    ref: mergedRef
  }), getOptions2());
};
var Mentions = /* @__PURE__ */ React.forwardRef(InternalMentions);
Mentions.displayName = "Mentions";
Mentions.Option = Option3;
Mentions.getMentions = function() {
  var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var config = arguments.length > 1 ? arguments[1] : void 0;
  var _ref = config || {}, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "@" : _ref$prefix, _ref$split = _ref.split, split = _ref$split === void 0 ? " " : _ref$split;
  var prefixList = Array.isArray(prefix) ? prefix : [prefix];
  return value.split(split).map(function() {
    var str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var hitPrefix = null;
    prefixList.some(function(prefixStr) {
      var startStr = str.slice(0, prefixStr.length);
      if (startStr === prefixStr) {
        hitPrefix = prefixStr;
        return true;
      }
      return false;
    });
    if (hitPrefix !== null) {
      return {
        prefix: hitPrefix,
        value: str.slice(hitPrefix.length)
      };
    }
    return null;
  }).filter(function(entity) {
    return !!entity && !!entity.value;
  });
};
function getScroll$1(w2, top) {
  var ret = w2["page".concat(top ? "Y" : "X", "Offset")];
  var method3 = "scroll".concat(top ? "Top" : "Left");
  if (typeof ret !== "number") {
    var d = w2.document;
    ret = d.documentElement[method3];
    if (typeof ret !== "number") {
      ret = d.body[method3];
    }
  }
  return ret;
}
function offset$1(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc = el.ownerDocument;
  var w2 = doc.defaultView || doc.parentWindow;
  pos.left += getScroll$1(w2);
  pos.top += getScroll$1(w2, true);
  return pos;
}
var MemoChildren = /* @__PURE__ */ React.memo(function(_ref) {
  var children = _ref.children;
  return children;
}, function(_2, _ref2) {
  var shouldUpdate = _ref2.shouldUpdate;
  return !shouldUpdate;
});
var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
};
var Content$1 = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var closable = props.closable, prefixCls = props.prefixCls, width = props.width, height = props.height, footer = props.footer, title = props.title, closeIcon2 = props.closeIcon, style2 = props.style, className = props.className, visible = props.visible, forceRender = props.forceRender, bodyStyle = props.bodyStyle, bodyProps = props.bodyProps, children = props.children, destroyOnClose = props.destroyOnClose, modalRender = props.modalRender, motionName = props.motionName, ariaId = props.ariaId, onClose2 = props.onClose, onVisibleChanged = props.onVisibleChanged, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, mousePosition = props.mousePosition;
  var sentinelStartRef = useRef2();
  var sentinelEndRef = useRef2();
  var dialogRef = useRef2();
  React.useImperativeHandle(ref, function() {
    return {
      focus: function focus() {
        var _sentinelStartRef$cur;
        (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 ? void 0 : _sentinelStartRef$cur.focus();
      },
      changeActive: function changeActive(next) {
        var _document = document, activeElement = _document.activeElement;
        if (next && activeElement === sentinelEndRef.current) {
          sentinelStartRef.current.focus();
        } else if (!next && activeElement === sentinelStartRef.current) {
          sentinelEndRef.current.focus();
        }
      }
    };
  });
  var _React$useState = React.useState(), _React$useState2 = _slicedToArray$3(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
  var contentStyle = {};
  if (width !== void 0) {
    contentStyle.width = width;
  }
  if (height !== void 0) {
    contentStyle.height = height;
  }
  if (transformOrigin) {
    contentStyle.transformOrigin = transformOrigin;
  }
  function onPrepare() {
    var elementOffset = offset$1(dialogRef.current);
    setTransformOrigin(mousePosition ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : "");
  }
  var footerNode;
  if (footer) {
    footerNode = /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-footer")
    }, footer);
  }
  var headerNode;
  if (title) {
    headerNode = /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-header")
    }, /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-title"),
      id: ariaId
    }, title));
  }
  var closer;
  if (closable) {
    closer = /* @__PURE__ */ React.createElement("button", {
      type: "button",
      onClick: onClose2,
      "aria-label": "Close",
      className: "".concat(prefixCls, "-close")
    }, closeIcon2 || /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-close-x")
    }));
  }
  var content = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-content")
  }, closer, headerNode, /* @__PURE__ */ React.createElement("div", _extends$2({
    className: "".concat(prefixCls, "-body"),
    style: bodyStyle
  }, bodyProps), children), footerNode);
  return /* @__PURE__ */ React.createElement(CSSMotion, {
    visible,
    onVisibleChanged,
    onAppearPrepare: onPrepare,
    onEnterPrepare: onPrepare,
    forceRender,
    motionName,
    removeOnLeave: destroyOnClose,
    ref: dialogRef
  }, function(_ref, motionRef) {
    var motionClassName = _ref.className, motionStyle = _ref.style;
    return /* @__PURE__ */ React.createElement("div", {
      key: "dialog-element",
      role: "document",
      ref: motionRef,
      style: _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, motionStyle), style2), contentStyle),
      className: cn(prefixCls, className, motionClassName),
      onMouseDown,
      onMouseUp
    }, /* @__PURE__ */ React.createElement("div", {
      tabIndex: 0,
      ref: sentinelStartRef,
      style: sentinelStyle,
      "aria-hidden": "true"
    }), /* @__PURE__ */ React.createElement(MemoChildren, {
      shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content), /* @__PURE__ */ React.createElement("div", {
      tabIndex: 0,
      ref: sentinelEndRef,
      style: sentinelStyle,
      "aria-hidden": "true"
    }));
  });
});
Content$1.displayName = "Content";
var getClickPosition = function getClickPosition2(e3) {
  ({
    x: e3.pageX,
    y: e3.pageY
  });
  setTimeout(function() {
  }, 100);
};
if (canUseDocElement()) {
  document.documentElement.addEventListener("click", getClickPosition, true);
}
var Title$1 = function Title(_ref) {
  var prefixCls = _ref.prefixCls, className = _ref.className, width = _ref.width, style2 = _ref.style;
  return /* @__PURE__ */ React.createElement("h3", {
    className: cn(prefixCls, className),
    style: _extends$2({
      width
    }, style2)
  });
};
var Paragraph$1 = function Paragraph(props) {
  var getWidth4 = function getWidth5(index2) {
    var width = props.width, _props$rows = props.rows, rows2 = _props$rows === void 0 ? 2 : _props$rows;
    if (Array.isArray(width)) {
      return width[index2];
    }
    if (rows2 - 1 === index2) {
      return width;
    }
    return void 0;
  };
  var prefixCls = props.prefixCls, className = props.className, style2 = props.style, rows = props.rows;
  var rowList = _toConsumableArray(Array(rows)).map(function(_2, index2) {
    return /* @__PURE__ */ React.createElement("li", {
      key: index2,
      style: {
        width: getWidth4(index2)
      }
    });
  });
  return /* @__PURE__ */ React.createElement("ul", {
    className: cn(prefixCls, className),
    style: style2
  }, rowList);
};
var Element$1 = function Element2(props) {
  var _classNames, _classNames2;
  var prefixCls = props.prefixCls, className = props.className, style2 = props.style, size = props.size, shape = props.shape;
  var sizeCls = cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-lg"), size === "large"), _defineProperty$4(_classNames, "".concat(prefixCls, "-sm"), size === "small"), _classNames));
  var shapeCls = cn((_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-circle"), shape === "circle"), _defineProperty$4(_classNames2, "".concat(prefixCls, "-square"), shape === "square"), _defineProperty$4(_classNames2, "".concat(prefixCls, "-round"), shape === "round"), _classNames2));
  var sizeStyle = typeof size === "number" ? {
    width: size,
    height: size,
    lineHeight: "".concat(size, "px")
  } : {};
  return /* @__PURE__ */ React.createElement("span", {
    className: cn(prefixCls, sizeCls, shapeCls, className),
    style: _extends$2(_extends$2({}, sizeStyle), style2)
  });
};
var SkeletonAvatar = function SkeletonAvatar2(props) {
  var renderSkeletonAvatar = function renderSkeletonAvatar2(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls, className = props.className, active = props.active;
    var prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    var otherProps = omit$1(props, ["prefixCls"]);
    var cls = cn(prefixCls, "".concat(prefixCls, "-element"), _defineProperty$4({}, "".concat(prefixCls, "-active"), active), className);
    return /* @__PURE__ */ React.createElement("div", {
      className: cls
    }, /* @__PURE__ */ React.createElement(Element$1, _extends$2({
      prefixCls: "".concat(prefixCls, "-avatar")
    }, otherProps)));
  };
  return /* @__PURE__ */ React.createElement(ConfigConsumer, null, renderSkeletonAvatar);
};
SkeletonAvatar.defaultProps = {
  size: "default",
  shape: "circle"
};
var SkeletonButton = function SkeletonButton2(props) {
  var renderSkeletonButton = function renderSkeletonButton2(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls, className = props.className, active = props.active;
    var prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    var otherProps = omit$1(props, ["prefixCls"]);
    var cls = cn(prefixCls, "".concat(prefixCls, "-element"), _defineProperty$4({}, "".concat(prefixCls, "-active"), active), className);
    return /* @__PURE__ */ React.createElement("div", {
      className: cls
    }, /* @__PURE__ */ React.createElement(Element$1, _extends$2({
      prefixCls: "".concat(prefixCls, "-button")
    }, otherProps)));
  };
  return /* @__PURE__ */ React.createElement(ConfigConsumer, null, renderSkeletonButton);
};
SkeletonButton.defaultProps = {
  size: "default"
};
var SkeletonInput = function SkeletonInput2(props) {
  var renderSkeletonInput = function renderSkeletonInput2(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls, className = props.className, active = props.active;
    var prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    var otherProps = omit$1(props, ["prefixCls"]);
    var cls = cn(prefixCls, "".concat(prefixCls, "-element"), _defineProperty$4({}, "".concat(prefixCls, "-active"), active), className);
    return /* @__PURE__ */ React.createElement("div", {
      className: cls
    }, /* @__PURE__ */ React.createElement(Element$1, _extends$2({
      prefixCls: "".concat(prefixCls, "-input")
    }, otherProps)));
  };
  return /* @__PURE__ */ React.createElement(ConfigConsumer, null, renderSkeletonInput);
};
SkeletonInput.defaultProps = {
  size: "default"
};
var path = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z";
var SkeletonImage = function SkeletonImage2(props) {
  var renderSkeletonImage = function renderSkeletonImage2(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls, className = props.className, style2 = props.style;
    var prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    var cls = cn(prefixCls, "".concat(prefixCls, "-element"), className);
    return /* @__PURE__ */ React.createElement("div", {
      className: cls
    }, /* @__PURE__ */ React.createElement("div", {
      className: cn("".concat(prefixCls, "-image"), className),
      style: style2
    }, /* @__PURE__ */ React.createElement("svg", {
      viewBox: "0 0 1098 1024",
      xmlns: "http://www.w3.org/2000/svg",
      className: "".concat(prefixCls, "-image-svg")
    }, /* @__PURE__ */ React.createElement("path", {
      d: path,
      className: "".concat(prefixCls, "-image-path")
    }))));
  };
  return /* @__PURE__ */ React.createElement(ConfigConsumer, null, renderSkeletonImage);
};
function getComponentProps(prop) {
  if (prop && _typeof$5(prop) === "object") {
    return prop;
  }
  return {};
}
function getAvatarBasicProps(hasTitle, hasParagraph) {
  if (hasTitle && !hasParagraph) {
    return {
      size: "large",
      shape: "square"
    };
  }
  return {
    size: "large",
    shape: "circle"
  };
}
function getTitleBasicProps(hasAvatar, hasParagraph) {
  if (!hasAvatar && hasParagraph) {
    return {
      width: "38%"
    };
  }
  if (hasAvatar && hasParagraph) {
    return {
      width: "50%"
    };
  }
  return {};
}
function getParagraphBasicProps(hasAvatar, hasTitle) {
  var basicProps = {};
  if (!hasAvatar || !hasTitle) {
    basicProps.width = "61%";
  }
  if (!hasAvatar && hasTitle) {
    basicProps.rows = 3;
  } else {
    basicProps.rows = 2;
  }
  return basicProps;
}
var Skeleton = function Skeleton2(props) {
  var renderSkeleton = function renderSkeleton2(_ref) {
    var getPrefixCls = _ref.getPrefixCls, direction = _ref.direction;
    var customizePrefixCls = props.prefixCls, loading = props.loading, className = props.className, children = props.children, avatar = props.avatar, title = props.title, paragraph = props.paragraph, active = props.active, round = props.round;
    var prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    if (loading || !("loading" in props)) {
      var _classNames;
      var hasAvatar = !!avatar;
      var hasTitle = !!title;
      var hasParagraph = !!paragraph;
      var avatarNode;
      if (hasAvatar) {
        var avatarProps = _extends$2(_extends$2({
          prefixCls: "".concat(prefixCls, "-avatar")
        }, getAvatarBasicProps(hasTitle, hasParagraph)), getComponentProps(avatar));
        avatarNode = /* @__PURE__ */ React.createElement("div", {
          className: "".concat(prefixCls, "-header")
        }, /* @__PURE__ */ React.createElement(Element$1, avatarProps));
      }
      var contentNode;
      if (hasTitle || hasParagraph) {
        var $title;
        if (hasTitle) {
          var titleProps = _extends$2(_extends$2({
            prefixCls: "".concat(prefixCls, "-title")
          }, getTitleBasicProps(hasAvatar, hasParagraph)), getComponentProps(title));
          $title = /* @__PURE__ */ React.createElement(Title$1, titleProps);
        }
        var paragraphNode;
        if (hasParagraph) {
          var paragraphProps = _extends$2(_extends$2({
            prefixCls: "".concat(prefixCls, "-paragraph")
          }, getParagraphBasicProps(hasAvatar, hasTitle)), getComponentProps(paragraph));
          paragraphNode = /* @__PURE__ */ React.createElement(Paragraph$1, paragraphProps);
        }
        contentNode = /* @__PURE__ */ React.createElement("div", {
          className: "".concat(prefixCls, "-content")
        }, $title, paragraphNode);
      }
      var cls = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-with-avatar"), hasAvatar), _defineProperty$4(_classNames, "".concat(prefixCls, "-active"), active), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _defineProperty$4(_classNames, "".concat(prefixCls, "-round"), round), _classNames), className);
      return /* @__PURE__ */ React.createElement("div", {
        className: cls
      }, avatarNode, contentNode);
    }
    return children;
  };
  return /* @__PURE__ */ React.createElement(ConfigConsumer, null, renderSkeleton);
};
Skeleton.defaultProps = {
  avatar: false,
  title: true,
  paragraph: true
};
Skeleton.Button = SkeletonButton;
Skeleton.Avatar = SkeletonAvatar;
Skeleton.Input = SkeletonInput;
Skeleton.Image = SkeletonImage;
var createPadding = _createPadding;
var stringSize = _stringSize;
var toInteger = toInteger_1;
var toString = toString_1;
function padEnd(string2, length, chars) {
  string2 = toString(string2);
  length = toInteger(length);
  var strLength = length ? stringSize(string2) : 0;
  return length && strLength < length ? string2 + createPadding(length - strLength, chars) : string2;
}
var padEnd_1 = padEnd;
var StatisticNumber = function StatisticNumber2(props) {
  var value = props.value, formatter = props.formatter, precision = props.precision, decimalSeparator = props.decimalSeparator, _props$groupSeparator = props.groupSeparator, groupSeparator = _props$groupSeparator === void 0 ? "" : _props$groupSeparator, prefixCls = props.prefixCls;
  var valueNode;
  if (typeof formatter === "function") {
    valueNode = formatter(value);
  } else {
    var val = String(value);
    var cells = val.match(/^(-?)(\d*)(\.(\d+))?$/);
    if (!cells || val === "-") {
      valueNode = val;
    } else {
      var negative = cells[1];
      var int = cells[2] || "0";
      var decimal = cells[4] || "";
      int = int.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
      if (typeof precision === "number") {
        decimal = padEnd_1(decimal, precision, "0").slice(0, precision);
      }
      if (decimal) {
        decimal = "".concat(decimalSeparator).concat(decimal);
      }
      valueNode = [/* @__PURE__ */ React.createElement("span", {
        key: "int",
        className: "".concat(prefixCls, "-content-value-int")
      }, negative, int), decimal && /* @__PURE__ */ React.createElement("span", {
        key: "decimal",
        className: "".concat(prefixCls, "-content-value-decimal")
      }, decimal)];
    }
  }
  return /* @__PURE__ */ React.createElement("span", {
    className: "".concat(prefixCls, "-content-value")
  }, valueNode);
};
var Statistic = function Statistic2(props) {
  var prefixCls = props.prefixCls, className = props.className, style2 = props.style, valueStyle = props.valueStyle, _props$value = props.value, value = _props$value === void 0 ? 0 : _props$value, title = props.title, valueRender = props.valueRender, prefix = props.prefix, suffix = props.suffix, loading = props.loading, direction = props.direction, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave;
  var valueNode = /* @__PURE__ */ React.createElement(StatisticNumber, _extends$2({}, props, {
    value
  }));
  var cls = cn(prefixCls, _defineProperty$4({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), className);
  return /* @__PURE__ */ React.createElement("div", {
    className: cls,
    style: style2,
    onMouseEnter,
    onMouseLeave
  }, title && /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-title")
  }, title), /* @__PURE__ */ React.createElement(Skeleton, {
    paragraph: false,
    loading
  }, /* @__PURE__ */ React.createElement("div", {
    style: valueStyle,
    className: "".concat(prefixCls, "-content")
  }, prefix && /* @__PURE__ */ React.createElement("span", {
    className: "".concat(prefixCls, "-content-prefix")
  }, prefix), valueRender ? valueRender(valueNode) : valueNode, suffix && /* @__PURE__ */ React.createElement("span", {
    className: "".concat(prefixCls, "-content-suffix")
  }, suffix))));
};
Statistic.defaultProps = {
  decimalSeparator: ".",
  groupSeparator: ",",
  loading: false
};
var WrapperStatistic = withConfigConsumer({
  prefixCls: "statistic"
})(Statistic);
var timeUnits = [
  ["Y", 1e3 * 60 * 60 * 24 * 365],
  ["M", 1e3 * 60 * 60 * 24 * 30],
  ["D", 1e3 * 60 * 60 * 24],
  ["H", 1e3 * 60 * 60],
  ["m", 1e3 * 60],
  ["s", 1e3],
  ["S", 1]
];
function formatTimeStr(duration, format3) {
  var leftDuration = duration;
  var escapeRegex = /\[[^\]]*]/g;
  var keepList = (format3.match(escapeRegex) || []).map(function(str) {
    return str.slice(1, -1);
  });
  var templateText = format3.replace(escapeRegex, "[]");
  var replacedText = timeUnits.reduce(function(current, _ref) {
    var _ref2 = _slicedToArray$3(_ref, 2), name = _ref2[0], unit = _ref2[1];
    if (current.indexOf(name) !== -1) {
      var value = Math.floor(leftDuration / unit);
      leftDuration -= value * unit;
      return current.replace(new RegExp("".concat(name, "+"), "g"), function(match2) {
        var len = match2.length;
        return padStart_1(value.toString(), len, "0");
      });
    }
    return current;
  }, templateText);
  var index2 = 0;
  return replacedText.replace(escapeRegex, function() {
    var match2 = keepList[index2];
    index2 += 1;
    return match2;
  });
}
function formatCountdown(value, config) {
  var _config$format = config.format, format3 = _config$format === void 0 ? "" : _config$format;
  var target = new Date(value).getTime();
  var current = Date.now();
  var diff = Math.max(target - current, 0);
  return formatTimeStr(diff, format3);
}
var REFRESH_INTERVAL = 1e3 / 30;
function getTime(value) {
  return new Date(value).getTime();
}
var Countdown = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Countdown2, _React$Component);
  var _super = _createSuper$1(Countdown2);
  function Countdown2() {
    var _this2;
    _classCallCheck$2(this, Countdown2);
    _this2 = _super.apply(this, arguments);
    _this2.syncTimer = function() {
      var value = _this2.props.value;
      var timestamp = getTime(value);
      if (timestamp >= Date.now()) {
        _this2.startTimer();
      } else {
        _this2.stopTimer();
      }
    };
    _this2.startTimer = function() {
      if (_this2.countdownId)
        return;
      _this2.countdownId = window.setInterval(function() {
        _this2.forceUpdate();
      }, REFRESH_INTERVAL);
    };
    _this2.stopTimer = function() {
      var _this$props = _this2.props, onFinish = _this$props.onFinish, value = _this$props.value;
      if (_this2.countdownId) {
        clearInterval(_this2.countdownId);
        _this2.countdownId = void 0;
        var timestamp = getTime(value);
        if (onFinish && timestamp < Date.now()) {
          onFinish();
        }
      }
    };
    _this2.formatCountdown = function(value, config) {
      var format3 = _this2.props.format;
      return formatCountdown(value, _extends$2(_extends$2({}, config), {
        format: format3
      }));
    };
    _this2.valueRender = function(node) {
      return cloneElement2(node, {
        title: void 0
      });
    };
    return _this2;
  }
  _createClass$2(Countdown2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncTimer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.syncTimer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopTimer();
    }
  }, {
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(WrapperStatistic, _extends$2({
        valueRender: this.valueRender
      }, this.props, {
        formatter: this.formatCountdown
      }));
    }
  }]);
  return Countdown2;
}(React.Component);
Countdown.defaultProps = {
  format: "HH:mm:ss"
};
WrapperStatistic.Countdown = Countdown;
var ArrowLeftOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "arrow-left", "theme": "outlined" };
var ArrowLeftOutlined = function ArrowLeftOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: ArrowLeftOutlined$1
  }));
};
ArrowLeftOutlined.displayName = "ArrowLeftOutlined";
var ArrowRightOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z" } }] }, "name": "arrow-right", "theme": "outlined" };
var ArrowRightOutlined = function ArrowRightOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: ArrowRightOutlined$1
  }));
};
ArrowRightOutlined.displayName = "ArrowRightOutlined";
var __rest$f = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var inlineStyle = {
  border: 0,
  background: "transparent",
  padding: 0,
  lineHeight: "inherit",
  display: "inline-block"
};
var TransButton = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var onKeyDown2 = function onKeyDown3(event) {
    var keyCode = event.keyCode;
    if (keyCode === KeyCode.ENTER) {
      event.preventDefault();
    }
  };
  var onKeyUp2 = function onKeyUp3(event) {
    var keyCode = event.keyCode;
    var onClick = props.onClick;
    if (keyCode === KeyCode.ENTER && onClick) {
      onClick();
    }
  };
  var style2 = props.style, noStyle = props.noStyle, disabled = props.disabled, restProps = __rest$f(props, ["style", "noStyle", "disabled"]);
  var mergedStyle = {};
  if (!noStyle) {
    mergedStyle = _extends$2({}, inlineStyle);
  }
  if (disabled) {
    mergedStyle.pointerEvents = "none";
  }
  mergedStyle = _extends$2(_extends$2({}, mergedStyle), style2);
  return /* @__PURE__ */ React.createElement("div", _extends$2({
    role: "button",
    tabIndex: 0,
    ref
  }, restProps, {
    onKeyDown: onKeyDown2,
    onKeyUp: onKeyUp2,
    style: mergedStyle
  }));
});
var _this = void 0;
var __rest$e = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var Popconfirm = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var _useMergedState = useMergedState(false, {
    value: props.visible,
    defaultValue: props.defaultVisible
  }), _useMergedState2 = _slicedToArray$3(_useMergedState, 2), visible = _useMergedState2[0], setVisible = _useMergedState2[1];
  var settingVisible = function settingVisible2(value, e3) {
    var _a;
    setVisible(value);
    (_a = props.onVisibleChange) === null || _a === void 0 ? void 0 : _a.call(props, value, e3);
  };
  var onConfirm = function onConfirm2(e3) {
    var _a;
    settingVisible(false, e3);
    (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(_this, e3);
  };
  var onCancel = function onCancel2(e3) {
    var _a;
    settingVisible(false, e3);
    (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(_this, e3);
  };
  var _onKeyDown = function onKeyDown2(e3) {
    if (e3.keyCode === KeyCode.ESC && visible) {
      settingVisible(false, e3);
    }
  };
  var onVisibleChange = function onVisibleChange2(value) {
    var disabled = props.disabled;
    if (disabled) {
      return;
    }
    settingVisible(value);
  };
  var renderOverlay = function renderOverlay2(prefixCls2, popconfirmLocale) {
    var okButtonProps = props.okButtonProps, cancelButtonProps = props.cancelButtonProps, title = props.title, cancelText = props.cancelText, okText = props.okText, okType = props.okType, icon = props.icon;
    return /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls2, "-inner-content")
    }, /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls2, "-message")
    }, icon, /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls2, "-message-title")
    }, getRenderPropValue(title))), /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls2, "-buttons")
    }, /* @__PURE__ */ React.createElement(Button$1, _extends$2({
      onClick: onCancel,
      size: "small"
    }, cancelButtonProps), cancelText || popconfirmLocale.cancelText), /* @__PURE__ */ React.createElement(Button$1, _extends$2({
      onClick: onConfirm
    }, convertLegacyProps(okType), {
      size: "small"
    }, okButtonProps), okText || popconfirmLocale.okText)));
  };
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
  var customizePrefixCls = props.prefixCls, placement = props.placement, children = props.children, overlayClassName = props.overlayClassName, restProps = __rest$e(props, ["prefixCls", "placement", "children", "overlayClassName"]);
  var prefixCls = getPrefixCls("popover", customizePrefixCls);
  var prefixClsConfirm = getPrefixCls("popconfirm", customizePrefixCls);
  var overlayClassNames = cn(prefixClsConfirm, overlayClassName);
  var overlay = /* @__PURE__ */ React.createElement(LocaleReceiver, {
    componentName: "Popconfirm",
    defaultLocale: localeValues.Popconfirm
  }, function(popconfirmLocale) {
    return renderOverlay(prefixCls, popconfirmLocale);
  });
  var rootPrefixCls = getPrefixCls();
  return /* @__PURE__ */ React.createElement(Tooltip2, _extends$2({}, restProps, {
    prefixCls,
    placement,
    onVisibleChange,
    visible,
    overlay,
    overlayClassName: overlayClassNames,
    ref,
    transitionName: getTransitionName(rootPrefixCls, "zoom-big", props.transitionName)
  }), cloneElement2(children, {
    onKeyDown: function onKeyDown2(e3) {
      var _a, _b;
      if (/* @__PURE__ */ React.isValidElement(children)) {
        (_b = children === null || children === void 0 ? void 0 : (_a = children.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, e3);
      }
      _onKeyDown(e3);
    }
  }));
});
Popconfirm.defaultProps = {
  placement: "top",
  trigger: "click",
  okType: "primary",
  icon: /* @__PURE__ */ React.createElement(ExclamationCircleFilled$1, null),
  disabled: false
};
function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }
  if (progress > 100) {
    return 100;
  }
  return progress;
}
function getSuccessPercent(_ref) {
  var success = _ref.success, successPercent = _ref.successPercent;
  var percent = successPercent;
  if (success && "progress" in success) {
    devWarning(false, "Progress", "`success.progress` is deprecated. Please use `success.percent` instead.");
    percent = success.progress;
  }
  if (success && "percent" in success) {
    percent = success.percent;
  }
  return percent;
}
var __rest$d = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var sortGradient = function sortGradient2(gradients) {
  var tempArr = [];
  Object.keys(gradients).forEach(function(key2) {
    var formattedKey = parseFloat(key2.replace(/%/g, ""));
    if (!isNaN(formattedKey)) {
      tempArr.push({
        key: formattedKey,
        value: gradients[key2]
      });
    }
  });
  tempArr = tempArr.sort(function(a2, b2) {
    return a2.key - b2.key;
  });
  return tempArr.map(function(_ref) {
    var key2 = _ref.key, value = _ref.value;
    return "".concat(value, " ").concat(key2, "%");
  }).join(", ");
};
var handleGradient = function handleGradient2(strokeColor, directionConfig) {
  var _strokeColor$from = strokeColor.from, from = _strokeColor$from === void 0 ? presetPrimaryColors.blue : _strokeColor$from, _strokeColor$to = strokeColor.to, to = _strokeColor$to === void 0 ? presetPrimaryColors.blue : _strokeColor$to, _strokeColor$directio = strokeColor.direction, direction = _strokeColor$directio === void 0 ? directionConfig === "rtl" ? "to left" : "to right" : _strokeColor$directio, rest = __rest$d(strokeColor, ["from", "to", "direction"]);
  if (Object.keys(rest).length !== 0) {
    var sortedGradients = sortGradient(rest);
    return {
      backgroundImage: "linear-gradient(".concat(direction, ", ").concat(sortedGradients, ")")
    };
  }
  return {
    backgroundImage: "linear-gradient(".concat(direction, ", ").concat(from, ", ").concat(to, ")")
  };
};
var Line = function Line2(props) {
  var prefixCls = props.prefixCls, directionConfig = props.direction, percent = props.percent, strokeWidth = props.strokeWidth, size = props.size, strokeColor = props.strokeColor, strokeLinecap = props.strokeLinecap, children = props.children, trailColor = props.trailColor, success = props.success;
  var backgroundProps = strokeColor && typeof strokeColor !== "string" ? handleGradient(strokeColor, directionConfig) : {
    background: strokeColor
  };
  var trailStyle = trailColor ? {
    backgroundColor: trailColor
  } : void 0;
  var percentStyle = _extends$2({
    width: "".concat(validProgress(percent), "%"),
    height: strokeWidth || (size === "small" ? 6 : 8),
    borderRadius: strokeLinecap === "square" ? 0 : ""
  }, backgroundProps);
  var successPercent = getSuccessPercent(props);
  var successPercentStyle = {
    width: "".concat(validProgress(successPercent), "%"),
    height: strokeWidth || (size === "small" ? 6 : 8),
    borderRadius: strokeLinecap === "square" ? 0 : "",
    backgroundColor: success === null || success === void 0 ? void 0 : success.strokeColor
  };
  var successSegment = successPercent !== void 0 ? /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-success-bg"),
    style: successPercentStyle
  }) : null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-outer")
  }, /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-inner"),
    style: trailStyle
  }, /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-bg"),
    style: percentStyle
  }), successSegment)), children);
};
var defaultProps = {
  className: "",
  percent: 0,
  prefixCls: "rc-progress",
  strokeColor: "#2db7f5",
  strokeLinecap: "round",
  strokeWidth: 1,
  style: {},
  trailColor: "#D9D9D9",
  trailWidth: 1
};
var useTransitionDuration = function useTransitionDuration2(percentList) {
  var paths = percentList.map(function() {
    return useRef2();
  });
  var prevTimeStamp = useRef2(null);
  useEffect2(function() {
    var now2 = Date.now();
    var updated = false;
    Object.keys(paths).forEach(function(key2) {
      var path2 = paths[key2].current;
      if (!path2) {
        return;
      }
      updated = true;
      var pathStyle = path2.style;
      pathStyle.transitionDuration = ".3s, .3s, .3s, .06s";
      if (prevTimeStamp.current && now2 - prevTimeStamp.current < 100) {
        pathStyle.transitionDuration = "0s, 0s";
      }
    });
    if (updated) {
      prevTimeStamp.current = Date.now();
    }
  });
  return [paths];
};
var gradientSeed = 0;
function stripPercentToNumber(percent) {
  return +percent.replace("%", "");
}
function toArray$2(symArray) {
  return Array.isArray(symArray) ? symArray : [symArray];
}
function getPathStyles(offset3, percent, strokeColor, strokeWidth) {
  var gapDegree = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  var gapPosition = arguments.length > 5 ? arguments[5] : void 0;
  var radius = 50 - strokeWidth / 2;
  var beginPositionX = 0;
  var beginPositionY = -radius;
  var endPositionX = 0;
  var endPositionY = -2 * radius;
  switch (gapPosition) {
    case "left":
      beginPositionX = -radius;
      beginPositionY = 0;
      endPositionX = 2 * radius;
      endPositionY = 0;
      break;
    case "right":
      beginPositionX = radius;
      beginPositionY = 0;
      endPositionX = -2 * radius;
      endPositionY = 0;
      break;
    case "bottom":
      beginPositionY = radius;
      endPositionY = 2 * radius;
      break;
  }
  var pathString = "M 50,50 m ".concat(beginPositionX, ",").concat(beginPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(endPositionX, ",").concat(-endPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(-endPositionX, ",").concat(endPositionY);
  var len = Math.PI * 2 * radius;
  var pathStyle = {
    stroke: typeof strokeColor === "string" ? strokeColor : void 0,
    strokeDasharray: "".concat(percent / 100 * (len - gapDegree), "px ").concat(len, "px"),
    strokeDashoffset: "-".concat(gapDegree / 2 + offset3 / 100 * (len - gapDegree), "px"),
    transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s"
  };
  return {
    pathString,
    pathStyle
  };
}
var Circle$1 = function Circle(_ref) {
  var prefixCls = _ref.prefixCls, strokeWidth = _ref.strokeWidth, trailWidth = _ref.trailWidth, gapDegree = _ref.gapDegree, gapPosition = _ref.gapPosition, trailColor = _ref.trailColor, strokeLinecap = _ref.strokeLinecap, style2 = _ref.style, className = _ref.className, strokeColor = _ref.strokeColor, percent = _ref.percent, restProps = _objectWithoutProperties$1(_ref, ["prefixCls", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor", "percent"]);
  var gradientId = React.useMemo(function() {
    gradientSeed += 1;
    return gradientSeed;
  }, []);
  var _getPathStyles = getPathStyles(0, 100, trailColor, strokeWidth, gapDegree, gapPosition), pathString = _getPathStyles.pathString, pathStyle = _getPathStyles.pathStyle;
  var percentList = toArray$2(percent);
  var strokeColorList = toArray$2(strokeColor);
  var gradient = strokeColorList.find(function(color) {
    return Object.prototype.toString.call(color) === "[object Object]";
  });
  var _useTransitionDuratio = useTransitionDuration(percentList), _useTransitionDuratio2 = _slicedToArray$3(_useTransitionDuratio, 1), paths = _useTransitionDuratio2[0];
  var getStokeList = function getStokeList2() {
    var stackPtg = 0;
    return percentList.map(function(ptg, index2) {
      var color = strokeColorList[index2] || strokeColorList[strokeColorList.length - 1];
      var stroke = Object.prototype.toString.call(color) === "[object Object]" ? "url(#".concat(prefixCls, "-gradient-").concat(gradientId, ")") : "";
      var pathStyles = getPathStyles(stackPtg, ptg, color, strokeWidth, gapDegree, gapPosition);
      stackPtg += ptg;
      return /* @__PURE__ */ React.createElement("path", {
        key: index2,
        className: "".concat(prefixCls, "-circle-path"),
        d: pathStyles.pathString,
        stroke,
        strokeLinecap,
        strokeWidth,
        opacity: ptg === 0 ? 0 : 1,
        fillOpacity: "0",
        style: pathStyles.pathStyle,
        ref: paths[index2]
      });
    });
  };
  return /* @__PURE__ */ React.createElement("svg", _extends$2({
    className: cn("".concat(prefixCls, "-circle"), className),
    viewBox: "0 0 100 100",
    style: style2
  }, restProps), gradient && /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", {
    id: "".concat(prefixCls, "-gradient-").concat(gradientId),
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "0%"
  }, Object.keys(gradient).sort(function(a2, b2) {
    return stripPercentToNumber(a2) - stripPercentToNumber(b2);
  }).map(function(key2, index2) {
    return /* @__PURE__ */ React.createElement("stop", {
      key: index2,
      offset: key2,
      stopColor: gradient[key2]
    });
  }))), /* @__PURE__ */ React.createElement("path", {
    className: "".concat(prefixCls, "-circle-trail"),
    d: pathString,
    stroke: trailColor,
    strokeLinecap,
    strokeWidth: trailWidth || strokeWidth,
    fillOpacity: "0",
    style: pathStyle
  }), getStokeList().reverse());
};
Circle$1.defaultProps = defaultProps;
Circle$1.displayName = "Circle";
function getPercentage(_ref) {
  var percent = _ref.percent, success = _ref.success, successPercent = _ref.successPercent;
  var ptg = validProgress(percent);
  var realSuccessPercent = getSuccessPercent({
    success,
    successPercent
  });
  if (!realSuccessPercent) {
    return ptg;
  }
  return [validProgress(realSuccessPercent), validProgress(ptg - validProgress(realSuccessPercent))];
}
function getStrokeColor(_ref2) {
  var success = _ref2.success, strokeColor = _ref2.strokeColor, successPercent = _ref2.successPercent;
  var color = strokeColor || null;
  var realSuccessPercent = getSuccessPercent({
    success,
    successPercent
  });
  if (!realSuccessPercent) {
    return color;
  }
  return [presetPrimaryColors.green, color];
}
var Circle2 = function Circle3(props) {
  var prefixCls = props.prefixCls, width = props.width, strokeWidth = props.strokeWidth, trailColor = props.trailColor, strokeLinecap = props.strokeLinecap, gapPosition = props.gapPosition, gapDegree = props.gapDegree, type2 = props.type, children = props.children;
  var circleSize = width || 120;
  var circleStyle = {
    width: circleSize,
    height: circleSize,
    fontSize: circleSize * 0.15 + 6
  };
  var circleWidth = strokeWidth || 6;
  var gapPos = gapPosition || type2 === "dashboard" && "bottom" || "top";
  var getGapDegree = function getGapDegree2() {
    if (gapDegree || gapDegree === 0) {
      return gapDegree;
    }
    if (type2 === "dashboard") {
      return 75;
    }
    return void 0;
  };
  var strokeColor = getStrokeColor(props);
  var isGradient = Object.prototype.toString.call(strokeColor) === "[object Object]";
  var wrapperClassName = cn("".concat(prefixCls, "-inner"), _defineProperty$4({}, "".concat(prefixCls, "-circle-gradient"), isGradient));
  return /* @__PURE__ */ React.createElement("div", {
    className: wrapperClassName,
    style: circleStyle
  }, /* @__PURE__ */ React.createElement(Circle$1, {
    percent: getPercentage(props),
    strokeWidth: circleWidth,
    trailWidth: circleWidth,
    strokeColor,
    strokeLinecap,
    trailColor,
    prefixCls,
    gapDegree: getGapDegree(),
    gapPosition: gapPos
  }), children);
};
var Steps$2 = function Steps(props) {
  var size = props.size, steps = props.steps, _props$percent = props.percent, percent = _props$percent === void 0 ? 0 : _props$percent, _props$strokeWidth = props.strokeWidth, strokeWidth = _props$strokeWidth === void 0 ? 8 : _props$strokeWidth, strokeColor = props.strokeColor, trailColor = props.trailColor, prefixCls = props.prefixCls, children = props.children;
  var current = Math.round(steps * (percent / 100));
  var stepWidth = size === "small" ? 2 : 14;
  var styledSteps = [];
  for (var i2 = 0; i2 < steps; i2 += 1) {
    styledSteps.push(/* @__PURE__ */ React.createElement("div", {
      key: i2,
      className: cn("".concat(prefixCls, "-steps-item"), _defineProperty$4({}, "".concat(prefixCls, "-steps-item-active"), i2 <= current - 1)),
      style: {
        backgroundColor: i2 <= current - 1 ? strokeColor : trailColor,
        width: stepWidth,
        height: strokeWidth
      }
    }));
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-steps-outer")
  }, styledSteps, children);
};
var __rest$c = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
tuple$1("line", "circle", "dashboard");
var ProgressStatuses = tuple$1("normal", "exception", "active", "success");
var Progress = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Progress2, _React$Component);
  var _super = _createSuper$1(Progress2);
  function Progress2() {
    var _this2;
    _classCallCheck$2(this, Progress2);
    _this2 = _super.apply(this, arguments);
    _this2.renderProgress = function(_ref) {
      var _classNames;
      var getPrefixCls = _ref.getPrefixCls, direction = _ref.direction;
      var _assertThisInitialize = _assertThisInitialized$1(_this2), props = _assertThisInitialize.props;
      var customizePrefixCls = props.prefixCls, className = props.className, size = props.size, type2 = props.type, steps = props.steps, showInfo = props.showInfo, strokeColor = props.strokeColor, restProps = __rest$c(props, ["prefixCls", "className", "size", "type", "steps", "showInfo", "strokeColor"]);
      var prefixCls = getPrefixCls("progress", customizePrefixCls);
      var progressStatus = _this2.getProgressStatus();
      var progressInfo = _this2.renderProcessInfo(prefixCls, progressStatus);
      devWarning(!("successPercent" in props), "Progress", "`successPercent` is deprecated. Please use `success.percent` instead.");
      var progress;
      if (type2 === "line") {
        progress = steps ? /* @__PURE__ */ React.createElement(Steps$2, _extends$2({}, _this2.props, {
          strokeColor: typeof strokeColor === "string" ? strokeColor : void 0,
          prefixCls,
          steps
        }), progressInfo) : /* @__PURE__ */ React.createElement(Line, _extends$2({}, _this2.props, {
          prefixCls,
          direction
        }), progressInfo);
      } else if (type2 === "circle" || type2 === "dashboard") {
        progress = /* @__PURE__ */ React.createElement(Circle2, _extends$2({}, _this2.props, {
          prefixCls,
          progressStatus
        }), progressInfo);
      }
      var classString = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(type2 === "dashboard" && "circle" || steps && "steps" || type2), true), _defineProperty$4(_classNames, "".concat(prefixCls, "-status-").concat(progressStatus), true), _defineProperty$4(_classNames, "".concat(prefixCls, "-show-info"), showInfo), _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(size), size), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
      return /* @__PURE__ */ React.createElement("div", _extends$2({}, omit$1(restProps, ["status", "format", "trailColor", "strokeWidth", "width", "gapDegree", "gapPosition", "strokeLinecap", "percent", "success", "successPercent"]), {
        className: classString
      }), progress);
    };
    return _this2;
  }
  _createClass$2(Progress2, [{
    key: "getPercentNumber",
    value: function getPercentNumber() {
      var _this$props$percent = this.props.percent, percent = _this$props$percent === void 0 ? 0 : _this$props$percent;
      var successPercent = getSuccessPercent(this.props);
      return parseInt(successPercent !== void 0 ? successPercent.toString() : percent.toString(), 10);
    }
  }, {
    key: "getProgressStatus",
    value: function getProgressStatus() {
      var status = this.props.status;
      if (ProgressStatuses.indexOf(status) < 0 && this.getPercentNumber() >= 100) {
        return "success";
      }
      return status || "normal";
    }
  }, {
    key: "renderProcessInfo",
    value: function renderProcessInfo(prefixCls, progressStatus) {
      var _this$props = this.props, showInfo = _this$props.showInfo, format3 = _this$props.format, type2 = _this$props.type, percent = _this$props.percent;
      var successPercent = getSuccessPercent(this.props);
      if (!showInfo)
        return null;
      var text;
      var textFormatter = format3 || function(percentNumber) {
        return "".concat(percentNumber, "%");
      };
      var isLineType = type2 === "line";
      if (format3 || progressStatus !== "exception" && progressStatus !== "success") {
        text = textFormatter(validProgress(percent), validProgress(successPercent));
      } else if (progressStatus === "exception") {
        text = isLineType ? /* @__PURE__ */ React.createElement(CloseCircleFilled$1, null) : /* @__PURE__ */ React.createElement(CloseOutlined$1, null);
      } else if (progressStatus === "success") {
        text = isLineType ? /* @__PURE__ */ React.createElement(CheckCircleFilled$1, null) : /* @__PURE__ */ React.createElement(CheckOutlined$1, null);
      }
      return /* @__PURE__ */ React.createElement("span", {
        className: "".concat(prefixCls, "-text"),
        title: typeof text === "string" ? text : void 0
      }, text);
    }
  }, {
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(ConfigConsumer, null, this.renderProgress);
    }
  }]);
  return Progress2;
}(React.Component);
Progress.defaultProps = {
  type: "line",
  percent: 0,
  showInfo: true,
  trailColor: null,
  size: "default",
  gapDegree: void 0,
  strokeLinecap: "round"
};
function getScroll(w2) {
  var ret = w2.pageXOffset;
  var method3 = "scrollLeft";
  if (typeof ret !== "number") {
    var d = w2.document;
    ret = d.documentElement[method3];
    if (typeof ret !== "number") {
      ret = d.body[method3];
    }
  }
  return ret;
}
function getClientPosition(elem) {
  var x2;
  var y2;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  var box = elem.getBoundingClientRect();
  x2 = box.left;
  y2 = box.top;
  x2 -= docElem.clientLeft || body.clientLeft || 0;
  y2 -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x2,
    top: y2
  };
}
function getOffsetLeft(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w2 = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w2);
  return pos.left;
}
var Star = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Star2, _React$Component);
  var _super = _createSuper$1(Star2);
  function Star2() {
    var _this2;
    _classCallCheck$2(this, Star2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super.call.apply(_super, [this].concat(args));
    _this2.onHover = function(e3) {
      var _this$props = _this2.props, onHover = _this$props.onHover, index2 = _this$props.index;
      onHover(e3, index2);
    };
    _this2.onClick = function(e3) {
      var _this$props2 = _this2.props, onClick = _this$props2.onClick, index2 = _this$props2.index;
      onClick(e3, index2);
    };
    _this2.onKeyDown = function(e3) {
      var _this$props3 = _this2.props, onClick = _this$props3.onClick, index2 = _this$props3.index;
      if (e3.keyCode === 13) {
        onClick(e3, index2);
      }
    };
    return _this2;
  }
  _createClass$2(Star2, [{
    key: "getClassName",
    value: function getClassName() {
      var _this$props4 = this.props, prefixCls = _this$props4.prefixCls, index2 = _this$props4.index, value = _this$props4.value, allowHalf = _this$props4.allowHalf, focused = _this$props4.focused;
      var starValue = index2 + 1;
      var className = prefixCls;
      if (value === 0 && index2 === 0 && focused) {
        className += " ".concat(prefixCls, "-focused");
      } else if (allowHalf && value + 0.5 >= starValue && value < starValue) {
        className += " ".concat(prefixCls, "-half ").concat(prefixCls, "-active");
        if (focused) {
          className += " ".concat(prefixCls, "-focused");
        }
      } else {
        className += starValue <= value ? " ".concat(prefixCls, "-full") : " ".concat(prefixCls, "-zero");
        if (starValue === value && focused) {
          className += " ".concat(prefixCls, "-focused");
        }
      }
      return className;
    }
  }, {
    key: "render",
    value: function render4() {
      var onHover = this.onHover, onClick = this.onClick, onKeyDown2 = this.onKeyDown;
      var _this$props5 = this.props, disabled = _this$props5.disabled, prefixCls = _this$props5.prefixCls, character = _this$props5.character, characterRender = _this$props5.characterRender, index2 = _this$props5.index, count = _this$props5.count, value = _this$props5.value;
      var characterNode = typeof character === "function" ? character(this.props) : character;
      var start = /* @__PURE__ */ React__default.createElement("li", {
        className: this.getClassName()
      }, /* @__PURE__ */ React__default.createElement("div", {
        onClick: disabled ? null : onClick,
        onKeyDown: disabled ? null : onKeyDown2,
        onMouseMove: disabled ? null : onHover,
        role: "radio",
        "aria-checked": value > index2 ? "true" : "false",
        "aria-posinset": index2 + 1,
        "aria-setsize": count,
        tabIndex: disabled ? -1 : 0
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "".concat(prefixCls, "-first")
      }, characterNode), /* @__PURE__ */ React__default.createElement("div", {
        className: "".concat(prefixCls, "-second")
      }, characterNode)));
      if (characterRender) {
        start = characterRender(start, this.props);
      }
      return start;
    }
  }]);
  return Star2;
}(React__default.Component);
function noop$2() {
}
var Rate$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Rate2, _React$Component);
  var _super = _createSuper$1(Rate2);
  function Rate2(props) {
    var _this2;
    _classCallCheck$2(this, Rate2);
    _this2 = _super.call(this, props);
    _this2.stars = void 0;
    _this2.rate = void 0;
    _this2.onHover = function(event, index2) {
      var onHoverChange = _this2.props.onHoverChange;
      var hoverValue = _this2.getStarValue(index2, event.pageX);
      var cleanedValue = _this2.state.cleanedValue;
      if (hoverValue !== cleanedValue) {
        _this2.setState({
          hoverValue,
          cleanedValue: null
        });
      }
      onHoverChange(hoverValue);
    };
    _this2.onMouseLeave = function() {
      var onHoverChange = _this2.props.onHoverChange;
      _this2.setState({
        hoverValue: void 0,
        cleanedValue: null
      });
      onHoverChange(void 0);
    };
    _this2.onClick = function(event, index2) {
      var allowClear = _this2.props.allowClear;
      var value = _this2.state.value;
      var newValue = _this2.getStarValue(index2, event.pageX);
      var isReset = false;
      if (allowClear) {
        isReset = newValue === value;
      }
      _this2.onMouseLeave();
      _this2.changeValue(isReset ? 0 : newValue);
      _this2.setState({
        cleanedValue: isReset ? newValue : null
      });
    };
    _this2.onFocus = function() {
      var onFocus2 = _this2.props.onFocus;
      _this2.setState({
        focused: true
      });
      if (onFocus2) {
        onFocus2();
      }
    };
    _this2.onBlur = function() {
      var onBlur2 = _this2.props.onBlur;
      _this2.setState({
        focused: false
      });
      if (onBlur2) {
        onBlur2();
      }
    };
    _this2.onKeyDown = function(event) {
      var keyCode = event.keyCode;
      var _this$props = _this2.props, count = _this$props.count, allowHalf = _this$props.allowHalf, onKeyDown2 = _this$props.onKeyDown, direction = _this$props.direction;
      var reverse = direction === "rtl";
      var value = _this2.state.value;
      if (keyCode === KeyCode.RIGHT && value < count && !reverse) {
        if (allowHalf) {
          value += 0.5;
        } else {
          value += 1;
        }
        _this2.changeValue(value);
        event.preventDefault();
      } else if (keyCode === KeyCode.LEFT && value > 0 && !reverse) {
        if (allowHalf) {
          value -= 0.5;
        } else {
          value -= 1;
        }
        _this2.changeValue(value);
        event.preventDefault();
      } else if (keyCode === KeyCode.RIGHT && value > 0 && reverse) {
        if (allowHalf) {
          value -= 0.5;
        } else {
          value -= 1;
        }
        _this2.changeValue(value);
        event.preventDefault();
      } else if (keyCode === KeyCode.LEFT && value < count && reverse) {
        if (allowHalf) {
          value += 0.5;
        } else {
          value += 1;
        }
        _this2.changeValue(value);
        event.preventDefault();
      }
      if (onKeyDown2) {
        onKeyDown2(event);
      }
    };
    _this2.saveRef = function(index2) {
      return function(node) {
        _this2.stars[index2] = node;
      };
    };
    _this2.saveRate = function(node) {
      _this2.rate = node;
    };
    var _value = props.value;
    if (_value === void 0) {
      _value = props.defaultValue;
    }
    _this2.stars = {};
    _this2.state = {
      value: _value,
      focused: false,
      cleanedValue: null
    };
    return _this2;
  }
  _createClass$2(Rate2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props, autoFocus = _this$props2.autoFocus, disabled = _this$props2.disabled;
      if (autoFocus && !disabled) {
        this.focus();
      }
    }
  }, {
    key: "getStarDOM",
    value: function getStarDOM(index2) {
      return findDOMNode2(this.stars[index2]);
    }
  }, {
    key: "getStarValue",
    value: function getStarValue(index2, x2) {
      var _this$props3 = this.props, allowHalf = _this$props3.allowHalf, direction = _this$props3.direction;
      var reverse = direction === "rtl";
      var value = index2 + 1;
      if (allowHalf) {
        var starEle = this.getStarDOM(index2);
        var leftDis = getOffsetLeft(starEle);
        var width = starEle.clientWidth;
        if (reverse && x2 - leftDis > width / 2) {
          value -= 0.5;
        } else if (!reverse && x2 - leftDis < width / 2) {
          value -= 0.5;
        }
      }
      return value;
    }
  }, {
    key: "focus",
    value: function focus() {
      var disabled = this.props.disabled;
      if (!disabled) {
        this.rate.focus();
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      var disabled = this.props.disabled;
      if (!disabled) {
        this.rate.blur();
      }
    }
  }, {
    key: "changeValue",
    value: function changeValue(value) {
      var onChange4 = this.props.onChange;
      if (!("value" in this.props)) {
        this.setState({
          value
        });
      }
      onChange4(value);
    }
  }, {
    key: "render",
    value: function render4() {
      var _this$props4 = this.props, count = _this$props4.count, allowHalf = _this$props4.allowHalf, style2 = _this$props4.style, prefixCls = _this$props4.prefixCls, disabled = _this$props4.disabled, className = _this$props4.className, character = _this$props4.character, characterRender = _this$props4.characterRender, tabIndex = _this$props4.tabIndex, direction = _this$props4.direction;
      var _this$state = this.state, value = _this$state.value, hoverValue = _this$state.hoverValue, focused = _this$state.focused;
      var stars = [];
      var disabledClass = disabled ? "".concat(prefixCls, "-disabled") : "";
      for (var index2 = 0; index2 < count; index2 += 1) {
        stars.push(/* @__PURE__ */ React__default.createElement(Star, {
          ref: this.saveRef(index2),
          index: index2,
          count,
          disabled,
          prefixCls: "".concat(prefixCls, "-star"),
          allowHalf,
          value: hoverValue === void 0 ? value : hoverValue,
          onClick: this.onClick,
          onHover: this.onHover,
          key: index2,
          character,
          characterRender,
          focused
        }));
      }
      var rateClassName = cn(prefixCls, disabledClass, className, _defineProperty$4({}, "".concat(prefixCls, "-rtl"), direction === "rtl"));
      return /* @__PURE__ */ React__default.createElement("ul", {
        className: rateClassName,
        style: style2,
        onMouseLeave: disabled ? null : this.onMouseLeave,
        tabIndex: disabled ? -1 : tabIndex,
        onFocus: disabled ? null : this.onFocus,
        onBlur: disabled ? null : this.onBlur,
        onKeyDown: disabled ? null : this.onKeyDown,
        ref: this.saveRate,
        role: "radiogroup"
      }, stars);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if ("value" in nextProps && nextProps.value !== void 0) {
        return _objectSpread2$1(_objectSpread2$1({}, state), {}, {
          value: nextProps.value
        });
      }
      return state;
    }
  }]);
  return Rate2;
}(React__default.Component);
Rate$1.defaultProps = {
  defaultValue: 0,
  count: 5,
  allowHalf: false,
  allowClear: true,
  style: {},
  prefixCls: "rc-rate",
  onChange: noop$2,
  character: "\u2605",
  onHoverChange: noop$2,
  tabIndex: 0,
  direction: "ltr"
};
var StarFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" } }] }, "name": "star", "theme": "filled" };
var StarFilled = function StarFilled2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: StarFilled$2
  }));
};
StarFilled.displayName = "StarFilled";
var StarFilled$1 = /* @__PURE__ */ React.forwardRef(StarFilled);
var __rest$b = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var Rate = /* @__PURE__ */ React.forwardRef(function(_a, ref) {
  var prefixCls = _a.prefixCls, tooltips = _a.tooltips, props = __rest$b(_a, ["prefixCls", "tooltips"]);
  var characterRender = function characterRender2(node, _ref) {
    var index2 = _ref.index;
    if (!tooltips)
      return node;
    return /* @__PURE__ */ React.createElement(Tooltip2, {
      title: tooltips[index2]
    }, node);
  };
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var ratePrefixCls = getPrefixCls("rate", prefixCls);
  return /* @__PURE__ */ React.createElement(Rate$1, _extends$2({
    ref,
    characterRender
  }, props, {
    prefixCls: ratePrefixCls,
    direction
  }));
});
Rate.displayName = "Rate";
Rate.defaultProps = {
  character: /* @__PURE__ */ React.createElement(StarFilled$1, null)
};
var WarningFilled$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "warning", "theme": "filled" };
var WarningFilled = function WarningFilled2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: WarningFilled$1
  }));
};
WarningFilled.displayName = "WarningFilled";
var NoFound = function NoFound2() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "252",
    height: "294"
  }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("path", {
    d: "M0 .387h251.772v251.772H0z"
  })), /* @__PURE__ */ React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(0 .012)"
  }, /* @__PURE__ */ React.createElement("mask", {
    fill: "#fff"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M0 127.32v-2.095C0 56.279 55.892.387 124.838.387h2.096c68.946 0 124.838 55.892 124.838 124.838v2.096c0 68.946-55.892 124.838-124.838 124.838h-2.096C55.892 252.16 0 196.267 0 127.321",
    fill: "#E4EBF7",
    mask: "url(#b)"
  })), /* @__PURE__ */ React.createElement("path", {
    d: "M39.755 130.84a8.276 8.276 0 1 1-16.468-1.66 8.276 8.276 0 0 1 16.468 1.66",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M36.975 134.297l10.482 5.943M48.373 146.508l-12.648 10.788",
    stroke: "#FFF",
    strokeWidth: "2"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M39.875 159.352a5.667 5.667 0 1 1-11.277-1.136 5.667 5.667 0 0 1 11.277 1.136M57.588 143.247a5.708 5.708 0 1 1-11.358-1.145 5.708 5.708 0 0 1 11.358 1.145M99.018 26.875l29.82-.014a4.587 4.587 0 1 0-.003-9.175l-29.82.013a4.587 4.587 0 1 0 .003 9.176M110.424 45.211l29.82-.013a4.588 4.588 0 0 0-.004-9.175l-29.82.013a4.587 4.587 0 1 0 .004 9.175",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M112.798 26.861v-.002l15.784-.006a4.588 4.588 0 1 0 .003 9.175l-15.783.007v-.002a4.586 4.586 0 0 0-.004-9.172M184.523 135.668c-.553 5.485-5.447 9.483-10.931 8.93-5.485-.553-9.483-5.448-8.93-10.932.552-5.485 5.447-9.483 10.932-8.93 5.485.553 9.483 5.447 8.93 10.932",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M179.26 141.75l12.64 7.167M193.006 156.477l-15.255 13.011",
    stroke: "#FFF",
    strokeWidth: "2"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M184.668 170.057a6.835 6.835 0 1 1-13.6-1.372 6.835 6.835 0 0 1 13.6 1.372M203.34 153.325a6.885 6.885 0 1 1-13.7-1.382 6.885 6.885 0 0 1 13.7 1.382",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M151.931 192.324a2.222 2.222 0 1 1-4.444 0 2.222 2.222 0 0 1 4.444 0zM225.27 116.056a2.222 2.222 0 1 1-4.445 0 2.222 2.222 0 0 1 4.444 0zM216.38 151.08a2.223 2.223 0 1 1-4.446-.001 2.223 2.223 0 0 1 4.446 0zM176.917 107.636a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM195.291 92.165a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM202.058 180.711a2.223 2.223 0 1 1-4.446 0 2.223 2.223 0 0 1 4.446 0z",
    stroke: "#FFF",
    strokeWidth: "2"
  }), /* @__PURE__ */ React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: "2",
    d: "M214.404 153.302l-1.912 20.184-10.928 5.99M173.661 174.792l-6.356 9.814h-11.36l-4.508 6.484M174.941 125.168v-15.804M220.824 117.25l-12.84 7.901-15.31-7.902V94.39"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M166.588 65.936h-3.951a4.756 4.756 0 0 1-4.743-4.742 4.756 4.756 0 0 1 4.743-4.743h3.951a4.756 4.756 0 0 1 4.743 4.743 4.756 4.756 0 0 1-4.743 4.742",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M174.823 30.03c0-16.281 13.198-29.48 29.48-29.48 16.28 0 29.48 13.199 29.48 29.48 0 16.28-13.2 29.48-29.48 29.48-16.282 0-29.48-13.2-29.48-29.48",
    fill: "#1890FF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M205.952 38.387c.5.5.785 1.142.785 1.928s-.286 1.465-.785 1.964c-.572.5-1.214.75-2 .75-.785 0-1.429-.285-1.929-.785-.572-.5-.82-1.143-.82-1.929s.248-1.428.82-1.928c.5-.5 1.144-.75 1.93-.75.785 0 1.462.25 1.999.75m4.285-19.463c1.428 1.249 2.143 2.963 2.143 5.142 0 1.712-.427 3.13-1.219 4.25-.067.096-.137.18-.218.265-.416.429-1.41 1.346-2.956 2.699a5.07 5.07 0 0 0-1.428 1.75 5.207 5.207 0 0 0-.536 2.357v.5h-4.107v-.5c0-1.357.215-2.536.714-3.5.464-.964 1.857-2.464 4.178-4.536l.43-.5c.643-.785.964-1.643.964-2.535 0-1.18-.358-2.108-1-2.785-.678-.68-1.643-1.001-2.858-1.001-1.536 0-2.642.464-3.357 1.43-.37.5-.621 1.135-.76 1.904a1.999 1.999 0 0 1-1.971 1.63h-.004c-1.277 0-2.257-1.183-1.98-2.43.337-1.518 1.02-2.78 2.073-3.784 1.536-1.5 3.607-2.25 6.25-2.25 2.32 0 4.214.607 5.642 1.894",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M52.04 76.131s21.81 5.36 27.307 15.945c5.575 10.74-6.352 9.26-15.73 4.935-10.86-5.008-24.7-11.822-11.577-20.88",
    fill: "#FFB594"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M90.483 67.504l-.449 2.893c-.753.49-4.748-2.663-4.748-2.663l-1.645.748-1.346-5.684s6.815-4.589 8.917-5.018c2.452-.501 9.884.94 10.7 2.278 0 0 1.32.486-2.227.69-3.548.203-5.043.447-6.79 3.132-1.747 2.686-2.412 3.624-2.412 3.624",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M128.055 111.367c-2.627-7.724-6.15-13.18-8.917-15.478-3.5-2.906-9.34-2.225-11.366-4.187-1.27-1.231-3.215-1.197-3.215-1.197s-14.98-3.158-16.828-3.479c-2.37-.41-2.124-.714-6.054-1.405-1.57-1.907-2.917-1.122-2.917-1.122l-7.11-1.383c-.853-1.472-2.423-1.023-2.423-1.023l-2.468-.897c-1.645 9.976-7.74 13.796-7.74 13.796 1.795 1.122 15.703 8.3 15.703 8.3l5.107 37.11s-3.321 5.694 1.346 9.109c0 0 19.883-3.743 34.921-.329 0 0 3.047-2.546.972-8.806.523-3.01 1.394-8.263 1.736-11.622.385.772 2.019 1.918 3.14 3.477 0 0 9.407-7.365 11.052-14.012-.832-.723-1.598-1.585-2.267-2.453-.567-.736-.358-2.056-.765-2.717-.669-1.084-1.804-1.378-1.907-1.682",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M101.09 289.998s4.295 2.041 7.354 1.021c2.821-.94 4.53.668 7.08 1.178 2.55.51 6.874 1.1 11.686-1.26-.103-5.51-6.889-3.98-11.96-6.713-2.563-1.38-3.784-4.722-3.598-8.799h-9.402s-1.392 10.52-1.16 14.573",
    fill: "#CBD1D1"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M101.067 289.826s2.428 1.271 6.759.653c3.058-.437 3.712.481 7.423 1.031 3.712.55 10.724-.069 11.823-.894.413 1.1-.343 2.063-.343 2.063s-1.512.603-4.812.824c-2.03.136-5.8.291-7.607-.503-1.787-1.375-5.247-1.903-5.728-.241-3.918.95-7.355-.286-7.355-.286l-.16-2.647z",
    fill: "#2B0849"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M108.341 276.044h3.094s-.103 6.702 4.536 8.558c-4.64.618-8.558-2.303-7.63-8.558",
    fill: "#A4AABA"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M57.542 272.401s-2.107 7.416-4.485 12.306c-1.798 3.695-4.225 7.492 5.465 7.492 6.648 0 8.953-.48 7.423-6.599-1.53-6.12.266-13.199.266-13.199h-8.669z",
    fill: "#CBD1D1"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M51.476 289.793s2.097 1.169 6.633 1.169c6.083 0 8.249-1.65 8.249-1.65s.602 1.114-.619 2.165c-.993.855-3.597 1.591-7.39 1.546-4.145-.048-5.832-.566-6.736-1.168-.825-.55-.687-1.58-.137-2.062",
    fill: "#2B0849"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M58.419 274.304s.033 1.519-.314 2.93c-.349 1.42-1.078 3.104-1.13 4.139-.058 1.151 4.537 1.58 5.155.034.62-1.547 1.294-6.427 1.913-7.252.619-.825-4.903-2.119-5.624.15",
    fill: "#A4AABA"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M99.66 278.514l13.378.092s1.298-54.52 1.853-64.403c.554-9.882 3.776-43.364 1.002-63.128l-12.547-.644-22.849.78s-.434 3.966-1.195 9.976c-.063.496-.682.843-.749 1.365-.075.585.423 1.354.32 1.966-2.364 14.08-6.377 33.104-8.744 46.677-.116.666-1.234 1.009-1.458 2.691-.04.302.211 1.525.112 1.795-6.873 18.744-10.949 47.842-14.277 61.885l14.607-.014s2.197-8.57 4.03-16.97c2.811-12.886 23.111-85.01 23.111-85.01l3.016-.521 1.043 46.35s-.224 1.234.337 2.02c.56.785-.56 1.123-.392 2.244l.392 1.794s-.449 7.178-.898 11.89c-.448 4.71-.092 39.165-.092 39.165",
    fill: "#7BB2F9"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M76.085 221.626c1.153.094 4.038-2.019 6.955-4.935M106.36 225.142s2.774-1.11 6.103-3.883",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M107.275 222.1s2.773-1.11 6.102-3.884",
    stroke: "#648BD8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M74.74 224.767s2.622-.591 6.505-3.365M86.03 151.634c-.27 3.106.3 8.525-4.336 9.123M103.625 149.88s.11 14.012-1.293 15.065c-2.219 1.664-2.99 1.944-2.99 1.944M99.79 150.438s.035 12.88-1.196 24.377M93.673 175.911s7.212-1.664 9.431-1.664M74.31 205.861a212.013 212.013 0 0 1-.979 4.56s-1.458 1.832-1.009 3.776c.449 1.944-.947 2.045-4.985 15.355-1.696 5.59-4.49 18.591-6.348 27.597l-.231 1.12M75.689 197.807a320.934 320.934 0 0 1-.882 4.754M82.591 152.233L81.395 162.7s-1.097.15-.5 2.244c.113 1.346-2.674 15.775-5.18 30.43M56.12 274.418h13.31",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M116.241 148.22s-17.047-3.104-35.893.2c.158 2.514-.003 4.15-.003 4.15s14.687-2.818 35.67-.312c.252-2.355.226-4.038.226-4.038",
    fill: "#192064"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M106.322 151.165l.003-4.911a.81.81 0 0 0-.778-.815c-2.44-.091-5.066-.108-7.836-.014a.818.818 0 0 0-.789.815l-.003 4.906a.81.81 0 0 0 .831.813c2.385-.06 4.973-.064 7.73.017a.815.815 0 0 0 .842-.81",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M105.207 150.233l.002-3.076a.642.642 0 0 0-.619-.646 94.321 94.321 0 0 0-5.866-.01.65.65 0 0 0-.63.647v3.072a.64.64 0 0 0 .654.644 121.12 121.12 0 0 1 5.794.011c.362.01.665-.28.665-.642",
    fill: "#192064"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M100.263 275.415h12.338M101.436 270.53c.006 3.387.042 5.79.111 6.506M101.451 264.548a915.75 915.75 0 0 0-.015 4.337M100.986 174.965l.898 44.642s.673 1.57-.225 2.692c-.897 1.122 2.468.673.898 2.243-1.57 1.57.897 1.122 0 3.365-.596 1.489-.994 21.1-1.096 35.146",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M46.876 83.427s-.516 6.045 7.223 5.552c11.2-.712 9.218-9.345 31.54-21.655-.786-2.708-2.447-4.744-2.447-4.744s-11.068 3.11-22.584 8.046c-6.766 2.9-13.395 6.352-13.732 12.801M104.46 91.057l.941-5.372-8.884-11.43-5.037 5.372-1.74 7.834a.321.321 0 0 0 .108.32c.965.8 6.5 5.013 14.347 3.544a.332.332 0 0 0 .264-.268",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M93.942 79.387s-4.533-2.853-2.432-6.855c1.623-3.09 4.513 1.133 4.513 1.133s.52-3.642 3.121-3.642c.52-1.04 1.561-4.162 1.561-4.162s11.445 2.601 13.526 3.121c0 5.203-2.304 19.424-7.84 19.861-8.892.703-12.449-9.456-12.449-9.456",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M113.874 73.446c2.601-2.081 3.47-9.722 3.47-9.722s-2.479-.49-6.64-2.05c-4.683-2.081-12.798-4.747-17.48.976-9.668 3.223-2.05 19.823-2.05 19.823l2.713-3.021s-3.935-3.287-2.08-6.243c2.17-3.462 3.92 1.073 3.92 1.073s.637-2.387 3.581-3.342c.355-.71 1.036-2.674 1.432-3.85a1.073 1.073 0 0 1 1.263-.704c2.4.558 8.677 2.019 11.356 2.662.522.125.871.615.82 1.15l-.305 3.248z",
    fill: "#520038"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M104.977 76.064c-.103.61-.582 1.038-1.07.956-.489-.083-.801-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.644.698 1.254M112.132 77.694c-.103.61-.582 1.038-1.07.956-.488-.083-.8-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.643.698 1.254",
    fill: "#552950"
  }), /* @__PURE__ */ React.createElement("path", {
    stroke: "#DB836E",
    strokeWidth: "1.118",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M110.13 74.84l-.896 1.61-.298 4.357h-2.228"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M110.846 74.481s1.79-.716 2.506.537",
    stroke: "#5C2552",
    strokeWidth: "1.118",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M92.386 74.282s.477-1.114 1.113-.716c.637.398 1.274 1.433.558 1.99-.717.556.159 1.67.159 1.67",
    stroke: "#DB836E",
    strokeWidth: "1.118",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M103.287 72.93s1.83 1.113 4.137.954",
    stroke: "#5C2552",
    strokeWidth: "1.118",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M103.685 81.762s2.227 1.193 4.376 1.193M104.64 84.308s.954.398 1.511.318M94.693 81.205s2.308 7.4 10.424 7.639",
    stroke: "#DB836E",
    strokeWidth: "1.118",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M81.45 89.384s.45 5.647-4.935 12.787M69 82.654s-.726 9.282-8.204 14.206",
    stroke: "#E4EBF7",
    strokeWidth: "1.101",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M129.405 122.865s-5.272 7.403-9.422 10.768",
    stroke: "#E4EBF7",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M119.306 107.329s.452 4.366-2.127 32.062",
    stroke: "#E4EBF7",
    strokeWidth: "1.101",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M150.028 151.232h-49.837a1.01 1.01 0 0 1-1.01-1.01v-31.688c0-.557.452-1.01 1.01-1.01h49.837c.558 0 1.01.453 1.01 1.01v31.688a1.01 1.01 0 0 1-1.01 1.01",
    fill: "#F2D7AD"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M150.29 151.232h-19.863v-33.707h20.784v32.786a.92.92 0 0 1-.92.92",
    fill: "#F4D19D"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M123.554 127.896H92.917a.518.518 0 0 1-.425-.816l6.38-9.113c.193-.277.51-.442.85-.442h31.092l-7.26 10.371z",
    fill: "#F2D7AD"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#CC9B6E",
    d: "M123.689 128.447H99.25v-.519h24.169l7.183-10.26.424.298z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M158.298 127.896h-18.669a2.073 2.073 0 0 1-1.659-.83l-7.156-9.541h19.965c.49 0 .95.23 1.244.622l6.69 8.92a.519.519 0 0 1-.415.83",
    fill: "#F4D19D"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#CC9B6E",
    d: "M157.847 128.479h-19.384l-7.857-10.475.415-.31 7.7 10.266h19.126zM130.554 150.685l-.032-8.177.519-.002.032 8.177z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#CC9B6E",
    d: "M130.511 139.783l-.08-21.414.519-.002.08 21.414zM111.876 140.932l-.498-.143 1.479-5.167.498.143zM108.437 141.06l-2.679-2.935 2.665-3.434.41.318-2.397 3.089 2.384 2.612zM116.607 141.06l-.383-.35 2.383-2.612-2.397-3.089.41-.318 2.665 3.434z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M154.316 131.892l-3.114-1.96.038 3.514-1.043.092c-1.682.115-3.634.23-4.789.23-1.902 0-2.693 2.258 2.23 2.648l-2.645-.596s-2.168 1.317.504 2.3c0 0-1.58 1.217.561 2.58-.584 3.504 5.247 4.058 7.122 3.59 1.876-.47 4.233-2.359 4.487-5.16.28-3.085-.89-5.432-3.35-7.238",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M153.686 133.577s-6.522.47-8.36.372c-1.836-.098-1.904 2.19 2.359 2.264 3.739.15 5.451-.044 5.451-.044",
    stroke: "#DB836E",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M145.16 135.877c-1.85 1.346.561 2.355.561 2.355s3.478.898 6.73.617",
    stroke: "#DB836E",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M151.89 141.71s-6.28.111-6.73-2.132c-.223-1.346.45-1.402.45-1.402M146.114 140.868s-1.103 3.16 5.44 3.533M151.202 129.932v3.477M52.838 89.286c3.533-.337 8.423-1.248 13.582-7.754",
    stroke: "#DB836E",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M168.567 248.318a6.647 6.647 0 0 1-6.647-6.647v-66.466a6.647 6.647 0 1 1 13.294 0v66.466a6.647 6.647 0 0 1-6.647 6.647",
    fill: "#5BA02E"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M176.543 247.653a6.647 6.647 0 0 1-6.646-6.647v-33.232a6.647 6.647 0 1 1 13.293 0v33.232a6.647 6.647 0 0 1-6.647 6.647",
    fill: "#92C110"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M186.443 293.613H158.92a3.187 3.187 0 0 1-3.187-3.187v-46.134a3.187 3.187 0 0 1 3.187-3.187h27.524a3.187 3.187 0 0 1 3.187 3.187v46.134a3.187 3.187 0 0 1-3.187 3.187",
    fill: "#F2D7AD"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M88.979 89.48s7.776 5.384 16.6 2.842",
    stroke: "#E4EBF7",
    strokeWidth: "1.101",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ServerError = function ServerError2() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "254",
    height: "294"
  }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("path", {
    d: "M0 .335h253.49v253.49H0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M0 293.665h253.49V.401H0z"
  })), /* @__PURE__ */ React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(0 .067)"
  }, /* @__PURE__ */ React.createElement("mask", {
    fill: "#fff"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M0 128.134v-2.11C0 56.608 56.273.334 125.69.334h2.11c69.416 0 125.69 56.274 125.69 125.69v2.11c0 69.417-56.274 125.69-125.69 125.69h-2.11C56.273 253.824 0 197.551 0 128.134",
    fill: "#E4EBF7",
    mask: "url(#b)"
  })), /* @__PURE__ */ React.createElement("path", {
    d: "M39.989 132.108a8.332 8.332 0 1 1-16.581-1.671 8.332 8.332 0 0 1 16.58 1.671",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M37.19 135.59l10.553 5.983M48.665 147.884l-12.734 10.861",
    stroke: "#FFF",
    strokeWidth: "2"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M40.11 160.816a5.706 5.706 0 1 1-11.354-1.145 5.706 5.706 0 0 1 11.354 1.145M57.943 144.6a5.747 5.747 0 1 1-11.436-1.152 5.747 5.747 0 0 1 11.436 1.153M99.656 27.434l30.024-.013a4.619 4.619 0 1 0-.004-9.238l-30.024.013a4.62 4.62 0 0 0 .004 9.238M111.14 45.896l30.023-.013a4.62 4.62 0 1 0-.004-9.238l-30.024.013a4.619 4.619 0 1 0 .004 9.238",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M113.53 27.421v-.002l15.89-.007a4.619 4.619 0 1 0 .005 9.238l-15.892.007v-.002a4.618 4.618 0 0 0-.004-9.234M150.167 70.091h-3.979a4.789 4.789 0 0 1-4.774-4.775 4.788 4.788 0 0 1 4.774-4.774h3.979a4.789 4.789 0 0 1 4.775 4.774 4.789 4.789 0 0 1-4.775 4.775",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M171.687 30.234c0-16.392 13.289-29.68 29.681-29.68 16.392 0 29.68 13.288 29.68 29.68 0 16.393-13.288 29.681-29.68 29.681s-29.68-13.288-29.68-29.68",
    fill: "#FF603B"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M203.557 19.435l-.676 15.035a1.514 1.514 0 0 1-3.026 0l-.675-15.035a2.19 2.19 0 1 1 4.377 0m-.264 19.378c.513.477.77 1.1.77 1.87s-.257 1.393-.77 1.907c-.55.476-1.21.733-1.943.733a2.545 2.545 0 0 1-1.87-.77c-.55-.514-.806-1.136-.806-1.87 0-.77.256-1.393.806-1.87.513-.513 1.137-.733 1.87-.733.77 0 1.43.22 1.943.733",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M119.3 133.275c4.426-.598 3.612-1.204 4.079-4.778.675-5.18-3.108-16.935-8.262-25.118-1.088-10.72-12.598-11.24-12.598-11.24s4.312 4.895 4.196 16.199c1.398 5.243.804 14.45.804 14.45s5.255 11.369 11.78 10.487",
    fill: "#FFB594"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M100.944 91.61s1.463-.583 3.211.582c8.08 1.398 10.368 6.706 11.3 11.368 1.864 1.282 1.864 2.33 1.864 3.496.365.777 1.515 3.03 1.515 3.03s-7.225 1.748-10.954 6.758c-1.399-6.41-6.936-25.235-6.936-25.235",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M94.008 90.5l1.019-5.815-9.23-11.874-5.233 5.581-2.593 9.863s8.39 5.128 16.037 2.246",
    fill: "#FFB594"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M82.931 78.216s-4.557-2.868-2.445-6.892c1.632-3.107 4.537 1.139 4.537 1.139s.524-3.662 3.139-3.662c.523-1.046 1.569-4.184 1.569-4.184s11.507 2.615 13.6 3.138c-.001 5.23-2.317 19.529-7.884 19.969-8.94.706-12.516-9.508-12.516-9.508",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M102.971 72.243c2.616-2.093 3.489-9.775 3.489-9.775s-2.492-.492-6.676-2.062c-4.708-2.092-12.867-4.771-17.575.982-9.54 4.41-2.062 19.93-2.062 19.93l2.729-3.037s-3.956-3.304-2.092-6.277c2.183-3.48 3.943 1.08 3.943 1.08s.64-2.4 3.6-3.36c.356-.714 1.04-2.69 1.44-3.872a1.08 1.08 0 0 1 1.27-.707c2.41.56 8.723 2.03 11.417 2.676.524.126.876.619.825 1.156l-.308 3.266z",
    fill: "#520038"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M101.22 76.514c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.961.491.083.805.647.702 1.26M94.26 75.074c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.96.491.082.805.646.702 1.26",
    fill: "#552950"
  }), /* @__PURE__ */ React.createElement("path", {
    stroke: "#DB836E",
    strokeWidth: "1.063",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M99.206 73.644l-.9 1.62-.3 4.38h-2.24"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M99.926 73.284s1.8-.72 2.52.54",
    stroke: "#5C2552",
    strokeWidth: "1.117",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M81.367 73.084s.48-1.12 1.12-.72c.64.4 1.28 1.44.56 2s.16 1.68.16 1.68",
    stroke: "#DB836E",
    strokeWidth: "1.117",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M92.326 71.724s1.84 1.12 4.16.96",
    stroke: "#5C2552",
    strokeWidth: "1.117",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M92.726 80.604s2.24 1.2 4.4 1.2M93.686 83.164s.96.4 1.52.32M83.687 80.044s1.786 6.547 9.262 7.954",
    stroke: "#DB836E",
    strokeWidth: "1.063",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M95.548 91.663s-1.068 2.821-8.298 2.105c-7.23-.717-10.29-5.044-10.29-5.044",
    stroke: "#E4EBF7",
    strokeWidth: "1.136",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M78.126 87.478s6.526 4.972 16.47 2.486c0 0 9.577 1.02 11.536 5.322 5.36 11.77.543 36.835 0 39.962 3.496 4.055-.466 8.483-.466 8.483-15.624-3.548-35.81-.6-35.81-.6-4.849-3.546-1.223-9.044-1.223-9.044L62.38 110.32c-2.485-15.227.833-19.803 3.549-20.743 3.03-1.049 8.04-1.282 8.04-1.282.496-.058 1.08-.076 1.37-.233 2.36-1.282 2.787-.583 2.787-.583",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M65.828 89.81s-6.875.465-7.59 8.156c-.466 8.857 3.03 10.954 3.03 10.954s6.075 22.102 16.796 22.957c8.39-2.176 4.758-6.702 4.661-11.42-.233-11.304-7.108-16.897-7.108-16.897s-4.212-13.75-9.789-13.75",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M71.716 124.225s.855 11.264 9.828 6.486c4.765-2.536 7.581-13.828 9.789-22.568 1.456-5.768 2.58-12.197 2.58-12.197l-4.973-1.709s-2.408 5.516-7.769 12.275c-4.335 5.467-9.144 11.11-9.455 17.713",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M108.463 105.191s1.747 2.724-2.331 30.535c2.376 2.216 1.053 6.012-.233 7.51",
    stroke: "#E4EBF7",
    strokeWidth: "1.085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M123.262 131.527s-.427 2.732-11.77 1.981c-15.187-1.006-25.326-3.25-25.326-3.25l.933-5.8s.723.215 9.71-.068c11.887-.373 18.714-6.07 24.964-1.022 4.039 3.263 1.489 8.16 1.489 8.16",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M70.24 90.974s-5.593-4.739-11.054 2.68c-3.318 7.223.517 15.284 2.664 19.578-.31 3.729 2.33 4.311 2.33 4.311s.108.895 1.516 2.68c4.078-7.03 6.72-9.166 13.711-12.546-.328-.656-1.877-3.265-1.825-3.767.175-1.69-1.282-2.623-1.282-2.623s-.286-.156-1.165-2.738c-.788-2.313-2.036-5.177-4.895-7.575",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M90.232 288.027s4.855 2.308 8.313 1.155c3.188-1.063 5.12.755 8.002 1.331 2.881.577 7.769 1.243 13.207-1.424-.117-6.228-7.786-4.499-13.518-7.588-2.895-1.56-4.276-5.336-4.066-9.944H91.544s-1.573 11.89-1.312 16.47",
    fill: "#CBD1D1"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M90.207 287.833s2.745 1.437 7.639.738c3.456-.494 3.223.66 7.418 1.282 4.195.621 13.092-.194 14.334-1.126.466 1.242-.388 2.33-.388 2.33s-1.709.682-5.438.932c-2.295.154-8.098.276-10.14-.621-2.02-1.554-4.894-1.515-6.06-.234-4.427 1.075-7.184-.31-7.184-.31l-.181-2.991z",
    fill: "#2B0849"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M98.429 272.257h3.496s-.117 7.574 5.127 9.671c-5.244.7-9.672-2.602-8.623-9.671",
    fill: "#A4AABA"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M44.425 272.046s-2.208 7.774-4.702 12.899c-1.884 3.874-4.428 7.854 5.729 7.854 6.97 0 9.385-.503 7.782-6.917-1.604-6.415.279-13.836.279-13.836h-9.088z",
    fill: "#CBD1D1"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M38.066 290.277s2.198 1.225 6.954 1.225c6.376 0 8.646-1.73 8.646-1.73s.63 1.168-.649 2.27c-1.04.897-3.77 1.668-7.745 1.621-4.347-.05-6.115-.593-7.062-1.224-.864-.577-.72-1.657-.144-2.162",
    fill: "#2B0849"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M45.344 274.041s.035 1.592-.329 3.07c-.365 1.49-1.13 3.255-1.184 4.34-.061 1.206 4.755 1.657 5.403.036.65-1.622 1.357-6.737 2.006-7.602.648-.865-5.14-2.222-5.896.156",
    fill: "#A4AABA"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M89.476 277.57l13.899.095s1.349-56.643 1.925-66.909c.576-10.267 3.923-45.052 1.042-65.585l-13.037-.669-23.737.81s-.452 4.12-1.243 10.365c-.065.515-.708.874-.777 1.417-.078.608.439 1.407.332 2.044-2.455 14.627-5.797 32.736-8.256 46.837-.121.693-1.282 1.048-1.515 2.796-.042.314.22 1.584.116 1.865-7.14 19.473-12.202 52.601-15.66 67.19l15.176-.015s2.282-10.145 4.185-18.871c2.922-13.389 24.012-88.32 24.012-88.32l3.133-.954-.158 48.568s-.233 1.282.35 2.098c.583.815-.581 1.167-.408 2.331l.408 1.864s-.466 7.458-.932 12.352c-.467 4.895 1.145 40.69 1.145 40.69",
    fill: "#7BB2F9"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M64.57 218.881c1.197.099 4.195-2.097 7.225-5.127M96.024 222.534s2.881-1.152 6.34-4.034",
    stroke: "#648BD8",
    strokeWidth: "1.085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M96.973 219.373s2.882-1.153 6.34-4.034",
    stroke: "#648BD8",
    strokeWidth: "1.032",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M63.172 222.144s2.724-.614 6.759-3.496M74.903 146.166c-.281 3.226.31 8.856-4.506 9.478M93.182 144.344s.115 14.557-1.344 15.65c-2.305 1.73-3.107 2.02-3.107 2.02M89.197 144.923s.269 13.144-1.01 25.088M83.525 170.71s6.81-1.051 9.116-1.051M46.026 270.045l-.892 4.538M46.937 263.289l-.815 4.157M62.725 202.503c-.33 1.618-.102 1.904-.449 3.438 0 0-2.756 1.903-2.29 3.923.466 2.02-.31 3.424-4.505 17.252-1.762 5.807-4.233 18.922-6.165 28.278-.03.144-.521 2.646-1.14 5.8M64.158 194.136c-.295 1.658-.6 3.31-.917 4.938M71.33 146.787l-1.244 10.877s-1.14.155-.519 2.33c.117 1.399-2.778 16.39-5.382 31.615M44.242 273.727H58.07",
    stroke: "#648BD8",
    strokeWidth: "1.085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M106.18 142.117c-3.028-.489-18.825-2.744-36.219.2a.625.625 0 0 0-.518.644c.063 1.307.044 2.343.015 2.995a.617.617 0 0 0 .716.636c3.303-.534 17.037-2.412 35.664-.266.347.04.66-.214.692-.56.124-1.347.16-2.425.17-3.029a.616.616 0 0 0-.52-.62",
    fill: "#192064"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M96.398 145.264l.003-5.102a.843.843 0 0 0-.809-.847 114.104 114.104 0 0 0-8.141-.014.85.85 0 0 0-.82.847l-.003 5.097c0 .476.388.857.864.845 2.478-.064 5.166-.067 8.03.017a.848.848 0 0 0 .876-.843",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M95.239 144.296l.002-3.195a.667.667 0 0 0-.643-.672c-1.9-.061-3.941-.073-6.094-.01a.675.675 0 0 0-.654.672l-.002 3.192c0 .376.305.677.68.669 1.859-.042 3.874-.043 6.02.012.376.01.69-.291.691-.668",
    fill: "#192064"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M90.102 273.522h12.819M91.216 269.761c.006 3.519-.072 5.55 0 6.292M90.923 263.474c-.009 1.599-.016 2.558-.016 4.505M90.44 170.404l.932 46.38s.7 1.631-.233 2.796c-.932 1.166 2.564.7.932 2.33-1.63 1.633.933 1.166 0 3.497-.618 1.546-1.031 21.921-1.138 36.513",
    stroke: "#648BD8",
    strokeWidth: "1.085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M73.736 98.665l2.214 4.312s2.098.816 1.865 2.68l.816 2.214M64.297 116.611c.233-.932 2.176-7.147 12.585-10.488M77.598 90.042s7.691 6.137 16.547 2.72",
    stroke: "#E4EBF7",
    strokeWidth: "1.085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M91.974 86.954s5.476-.816 7.574-4.545c1.297-.345.72 2.212-.33 3.671-.7.971-1.01 1.554-1.01 1.554s.194.31.155.816c-.053.697-.175.653-.272 1.048-.081.335.108.657 0 1.049-.046.17-.198.5-.382.878-.12.249-.072.687-.2.948-.231.469-1.562 1.87-2.622 2.855-3.826 3.554-5.018 1.644-6.001-.408-.894-1.865-.661-5.127-.874-6.875-.35-2.914-2.622-3.03-1.923-4.429.343-.685 2.87.69 3.263 1.748.757 2.04 2.952 1.807 2.622 1.69",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M99.8 82.429c-.465.077-.35.272-.97 1.243-.622.971-4.817 2.932-6.39 3.224-2.589.48-2.278-1.56-4.254-2.855-1.69-1.107-3.562-.638-1.398 1.398.99.932.932 1.107 1.398 3.205.335 1.506-.64 3.67.7 5.593",
    stroke: "#DB836E",
    strokeWidth: ".774",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M79.543 108.673c-2.1 2.926-4.266 6.175-5.557 8.762",
    stroke: "#E59788",
    strokeWidth: ".774",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M87.72 124.768s-2.098-1.942-5.127-2.719c-3.03-.777-3.574-.155-5.516.078-1.942.233-3.885-.932-3.652.7.233 1.63 5.05 1.01 5.206 2.097.155 1.087-6.37 2.796-8.313 2.175-.777.777.466 1.864 2.02 2.175.233 1.554 2.253 1.554 2.253 1.554s.699 1.01 2.641 1.088c2.486 1.32 8.934-.7 10.954-1.554 2.02-.855-.466-5.594-.466-5.594",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M73.425 122.826s.66 1.127 3.167 1.418c2.315.27 2.563.583 2.563.583s-2.545 2.894-9.07 2.272M72.416 129.274s3.826.097 4.933-.718M74.98 130.75s1.961.136 3.36-.505M77.232 131.916s1.748.019 2.914-.505M73.328 122.321s-.595-1.032 1.262-.427c1.671.544 2.833.055 5.128.155 1.389.061 3.067-.297 3.982.15 1.606.784 3.632 2.181 3.632 2.181s10.526 1.204 19.033-1.127M78.864 108.104s-8.39 2.758-13.168 12.12",
    stroke: "#E59788",
    strokeWidth: ".774",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M109.278 112.533s3.38-3.613 7.575-4.662",
    stroke: "#E4EBF7",
    strokeWidth: "1.085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M107.375 123.006s9.697-2.745 11.445-.88",
    stroke: "#E59788",
    strokeWidth: ".774",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M194.605 83.656l3.971-3.886M187.166 90.933l3.736-3.655M191.752 84.207l-4.462-4.56M198.453 91.057l-4.133-4.225M129.256 163.074l3.718-3.718M122.291 170.039l3.498-3.498M126.561 163.626l-4.27-4.27M132.975 170.039l-3.955-3.955",
    stroke: "#BFCDDD",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M190.156 211.779h-1.604a4.023 4.023 0 0 1-4.011-4.011V175.68a4.023 4.023 0 0 1 4.01-4.01h1.605a4.023 4.023 0 0 1 4.011 4.01v32.088a4.023 4.023 0 0 1-4.01 4.01",
    fill: "#A3B4C6"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M237.824 212.977a4.813 4.813 0 0 1-4.813 4.813h-86.636a4.813 4.813 0 0 1 0-9.626h86.636a4.813 4.813 0 0 1 4.813 4.813",
    fill: "#A3B4C6"
  }), /* @__PURE__ */ React.createElement("mask", {
    fill: "#fff"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#A3B4C6",
    mask: "url(#d)",
    d: "M154.098 190.096h70.513v-84.617h-70.513z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M224.928 190.096H153.78a3.219 3.219 0 0 1-3.208-3.209V167.92a3.219 3.219 0 0 1 3.208-3.21h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.219 3.219 0 0 1-3.21 3.209M224.928 130.832H153.78a3.218 3.218 0 0 1-3.208-3.208v-18.968a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.218 3.218 0 0 1-3.21 3.208",
    fill: "#BFCDDD",
    mask: "url(#d)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M159.563 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 120.546h-22.461a.802.802 0 0 1-.802-.802v-3.208c0-.443.359-.803.802-.803h22.46c.444 0 .803.36.803.803v3.208c0 .443-.36.802-.802.802",
    fill: "#FFF",
    mask: "url(#d)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M224.928 160.464H153.78a3.218 3.218 0 0 1-3.208-3.209v-18.967a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.209v18.967a3.218 3.218 0 0 1-3.21 3.209",
    fill: "#BFCDDD",
    mask: "url(#d)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M173.455 130.832h49.301M164.984 130.832h6.089M155.952 130.832h6.75M173.837 160.613h49.3M165.365 160.613h6.089M155.57 160.613h6.751",
    stroke: "#7C90A5",
    strokeWidth: "1.124",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#d)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M159.563 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M166.98 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M174.397 151.038a2.407 2.407 0 1 1 .001-4.814 2.407 2.407 0 0 1 0 4.814M222.539 151.038h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802M159.563 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 179.987h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802",
    fill: "#FFF",
    mask: "url(#d)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M203.04 221.108h-27.372a2.413 2.413 0 0 1-2.406-2.407v-11.448a2.414 2.414 0 0 1 2.406-2.407h27.372a2.414 2.414 0 0 1 2.407 2.407V218.7a2.413 2.413 0 0 1-2.407 2.407",
    fill: "#BFCDDD",
    mask: "url(#d)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M177.259 207.217v11.52M201.05 207.217v11.52",
    stroke: "#A3B4C6",
    strokeWidth: "1.124",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#d)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M162.873 267.894a9.422 9.422 0 0 1-9.422-9.422v-14.82a9.423 9.423 0 0 1 18.845 0v14.82a9.423 9.423 0 0 1-9.423 9.422",
    fill: "#5BA02E",
    mask: "url(#d)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M171.22 267.83a9.422 9.422 0 0 1-9.422-9.423v-3.438a9.423 9.423 0 0 1 18.845 0v3.438a9.423 9.423 0 0 1-9.422 9.423",
    fill: "#92C110",
    mask: "url(#d)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M181.31 293.666h-27.712a3.209 3.209 0 0 1-3.209-3.21V269.79a3.209 3.209 0 0 1 3.209-3.21h27.711a3.209 3.209 0 0 1 3.209 3.21v20.668a3.209 3.209 0 0 1-3.209 3.209",
    fill: "#F2D7AD",
    mask: "url(#d)"
  })));
};
var Unauthorized = function Unauthorized2() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "251",
    height: "294"
  }, /* @__PURE__ */ React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M0 129.023v-2.084C0 58.364 55.591 2.774 124.165 2.774h2.085c68.574 0 124.165 55.59 124.165 124.165v2.084c0 68.575-55.59 124.166-124.165 124.166h-2.085C55.591 253.189 0 197.598 0 129.023",
    fill: "#E4EBF7"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M41.417 132.92a8.231 8.231 0 1 1-16.38-1.65 8.231 8.231 0 0 1 16.38 1.65",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M38.652 136.36l10.425 5.91M49.989 148.505l-12.58 10.73",
    stroke: "#FFF",
    strokeWidth: "2"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M41.536 161.28a5.636 5.636 0 1 1-11.216-1.13 5.636 5.636 0 0 1 11.216 1.13M59.154 145.261a5.677 5.677 0 1 1-11.297-1.138 5.677 5.677 0 0 1 11.297 1.138M100.36 29.516l29.66-.013a4.562 4.562 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 0 0 .005 9.126M111.705 47.754l29.659-.013a4.563 4.563 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 1 0 .005 9.126",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M114.066 29.503V29.5l15.698-.007a4.563 4.563 0 1 0 .004 9.126l-15.698.007v-.002a4.562 4.562 0 0 0-.004-9.122M185.405 137.723c-.55 5.455-5.418 9.432-10.873 8.882-5.456-.55-9.432-5.418-8.882-10.873.55-5.455 5.418-9.432 10.873-8.882 5.455.55 9.432 5.418 8.882 10.873",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M180.17 143.772l12.572 7.129M193.841 158.42L178.67 171.36",
    stroke: "#FFF",
    strokeWidth: "2"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M185.55 171.926a6.798 6.798 0 1 1-13.528-1.363 6.798 6.798 0 0 1 13.527 1.363M204.12 155.285a6.848 6.848 0 1 1-13.627-1.375 6.848 6.848 0 0 1 13.626 1.375",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M152.988 194.074a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0zM225.931 118.217a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM217.09 153.051a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.42 0zM177.84 109.842a2.21 2.21 0 1 1-4.422 0 2.21 2.21 0 0 1 4.421 0zM196.114 94.454a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM202.844 182.523a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0z",
    stroke: "#FFF",
    strokeWidth: "2"
  }), /* @__PURE__ */ React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: "2",
    d: "M215.125 155.262l-1.902 20.075-10.87 5.958M174.601 176.636l-6.322 9.761H156.98l-4.484 6.449M175.874 127.28V111.56M221.51 119.404l-12.77 7.859-15.228-7.86V96.668"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M180.68 29.32C180.68 13.128 193.806 0 210 0c16.193 0 29.32 13.127 29.32 29.32 0 16.194-13.127 29.322-29.32 29.322-16.193 0-29.32-13.128-29.32-29.321",
    fill: "#A26EF4"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M221.45 41.706l-21.563-.125a1.744 1.744 0 0 1-1.734-1.754l.071-12.23a1.744 1.744 0 0 1 1.754-1.734l21.562.125c.964.006 1.74.791 1.735 1.755l-.071 12.229a1.744 1.744 0 0 1-1.754 1.734",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M215.106 29.192c-.015 2.577-2.049 4.654-4.543 4.64-2.494-.014-4.504-2.115-4.489-4.693l.04-6.925c.016-2.577 2.05-4.654 4.543-4.64 2.494.015 4.504 2.116 4.49 4.693l-.04 6.925zm-4.53-14.074a6.877 6.877 0 0 0-6.916 6.837l-.043 7.368a6.877 6.877 0 0 0 13.754.08l.042-7.368a6.878 6.878 0 0 0-6.837-6.917zM167.566 68.367h-3.93a4.73 4.73 0 0 1-4.717-4.717 4.73 4.73 0 0 1 4.717-4.717h3.93a4.73 4.73 0 0 1 4.717 4.717 4.73 4.73 0 0 1-4.717 4.717",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M168.214 248.838a6.611 6.611 0 0 1-6.61-6.611v-66.108a6.611 6.611 0 0 1 13.221 0v66.108a6.611 6.611 0 0 1-6.61 6.61",
    fill: "#5BA02E"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M176.147 248.176a6.611 6.611 0 0 1-6.61-6.61v-33.054a6.611 6.611 0 1 1 13.221 0v33.053a6.611 6.611 0 0 1-6.61 6.611",
    fill: "#92C110"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M185.994 293.89h-27.376a3.17 3.17 0 0 1-3.17-3.17v-45.887a3.17 3.17 0 0 1 3.17-3.17h27.376a3.17 3.17 0 0 1 3.17 3.17v45.886a3.17 3.17 0 0 1-3.17 3.17",
    fill: "#F2D7AD"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M81.972 147.673s6.377-.927 17.566-1.28c11.729-.371 17.57 1.086 17.57 1.086s3.697-3.855.968-8.424c1.278-12.077 5.982-32.827.335-48.273-1.116-1.339-3.743-1.512-7.536-.62-1.337.315-7.147-.149-7.983-.1l-15.311-.347s-3.487-.17-8.035-.508c-1.512-.113-4.227-1.683-5.458-.338-.406.443-2.425 5.669-1.97 16.077l8.635 35.642s-3.141 3.61 1.219 7.085",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M75.768 73.325l-.9-6.397 11.982-6.52s7.302-.118 8.038 1.205c.737 1.324-5.616.993-5.616.993s-1.836 1.388-2.615 2.5c-1.654 2.363-.986 6.471-8.318 5.986-1.708.284-2.57 2.233-2.57 2.233",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M52.44 77.672s14.217 9.406 24.973 14.444c1.061.497-2.094 16.183-11.892 11.811-7.436-3.318-20.162-8.44-21.482-14.496-.71-3.258 2.543-7.643 8.401-11.76M141.862 80.113s-6.693 2.999-13.844 6.876c-3.894 2.11-10.137 4.704-12.33 7.988-6.224 9.314 3.536 11.22 12.947 7.503 6.71-2.651 28.999-12.127 13.227-22.367",
    fill: "#FFB594"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M76.166 66.36l3.06 3.881s-2.783 2.67-6.31 5.747c-7.103 6.195-12.803 14.296-15.995 16.44-3.966 2.662-9.754 3.314-12.177-.118-3.553-5.032.464-14.628 31.422-25.95",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M64.674 85.116s-2.34 8.413-8.912 14.447c.652.548 18.586 10.51 22.144 10.056 5.238-.669 6.417-18.968 1.145-20.531-.702-.208-5.901-1.286-8.853-2.167-.87-.26-1.611-1.71-3.545-.936l-1.98-.869zM128.362 85.826s5.318 1.956 7.325 13.734c-.546.274-17.55 12.35-21.829 7.805-6.534-6.94-.766-17.393 4.275-18.61 4.646-1.121 5.03-1.37 10.23-2.929",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M78.18 94.656s.911 7.41-4.914 13.078",
    stroke: "#E4EBF7",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M87.397 94.68s3.124 2.572 10.263 2.572c7.14 0 9.074-3.437 9.074-3.437",
    stroke: "#E4EBF7",
    strokeWidth: ".932",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M117.184 68.639l-6.781-6.177s-5.355-4.314-9.223-.893c-3.867 3.422 4.463 2.083 5.653 4.165 1.19 2.082.848 1.143-2.083.446-5.603-1.331-2.082.893 2.975 5.355 2.091 1.845 6.992.955 6.992.955l2.467-3.851z",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M105.282 91.315l-.297-10.937-15.918-.027-.53 10.45c-.026.403.17.788.515.999 2.049 1.251 9.387 5.093 15.799.424.287-.21.443-.554.431-.91",
    fill: "#FFB594"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M107.573 74.24c.817-1.147.982-9.118 1.015-11.928a1.046 1.046 0 0 0-.965-1.055l-4.62-.365c-7.71-1.044-17.071.624-18.253 6.346-5.482 5.813-.421 13.244-.421 13.244s1.963 3.566 4.305 6.791c.756 1.041.398-3.731 3.04-5.929 5.524-4.594 15.899-7.103 15.899-7.103",
    fill: "#5C2552"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M88.426 83.206s2.685 6.202 11.602 6.522c7.82.28 8.973-7.008 7.434-17.505l-.909-5.483c-6.118-2.897-15.478.54-15.478.54s-.576 2.044-.19 5.504c-2.276 2.066-1.824 5.618-1.824 5.618s-.905-1.922-1.98-2.321c-.86-.32-1.897.089-2.322 1.98-1.04 4.632 3.667 5.145 3.667 5.145",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    stroke: "#DB836E",
    strokeWidth: "1.145",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M100.843 77.099l1.701-.928-1.015-4.324.674-1.406"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M105.546 74.092c-.022.713-.452 1.279-.96 1.263-.51-.016-.904-.607-.882-1.32.021-.713.452-1.278.96-1.263.51.016.904.607.882 1.32M97.592 74.349c-.022.713-.452 1.278-.961 1.263-.509-.016-.904-.607-.882-1.32.022-.713.452-1.279.961-1.263.51.016.904.606.882 1.32",
    fill: "#552950"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M91.132 86.786s5.269 4.957 12.679 2.327",
    stroke: "#DB836E",
    strokeWidth: "1.145",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M99.776 81.903s-3.592.232-1.44-2.79c1.59-1.496 4.897-.46 4.897-.46s1.156 3.906-3.457 3.25",
    fill: "#DB836E"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M102.88 70.6s2.483.84 3.402.715M93.883 71.975s2.492-1.144 4.778-1.073",
    stroke: "#5C2552",
    strokeWidth: "1.526",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M86.32 77.374s.961.879 1.458 2.106c-.377.48-1.033 1.152-.236 1.809M99.337 83.719s1.911.151 2.509-.254",
    stroke: "#DB836E",
    strokeWidth: "1.145",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M87.782 115.821l15.73-3.012M100.165 115.821l10.04-2.008",
    stroke: "#E4EBF7",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M66.508 86.763s-1.598 8.83-6.697 14.078",
    stroke: "#E4EBF7",
    strokeWidth: "1.114",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M128.31 87.934s3.013 4.121 4.06 11.785",
    stroke: "#E4EBF7",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M64.09 84.816s-6.03 9.912-13.607 9.903",
    stroke: "#DB836E",
    strokeWidth: ".795",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M112.366 65.909l-.142 5.32s5.993 4.472 11.945 9.202c4.482 3.562 8.888 7.455 10.985 8.662 4.804 2.766 8.9 3.355 11.076 1.808 4.071-2.894 4.373-9.878-8.136-15.263-4.271-1.838-16.144-6.36-25.728-9.73",
    fill: "#FFC6A0"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M130.532 85.488s4.588 5.757 11.619 6.214",
    stroke: "#DB836E",
    strokeWidth: ".75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M121.708 105.73s-.393 8.564-1.34 13.612",
    stroke: "#E4EBF7",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M115.784 161.512s-3.57-1.488-2.678-7.14",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M101.52 290.246s4.326 2.057 7.408 1.03c2.842-.948 4.564.673 7.132 1.186 2.57.514 6.925 1.108 11.772-1.269-.104-5.551-6.939-4.01-12.048-6.763-2.582-1.39-3.812-4.757-3.625-8.863h-9.471s-1.402 10.596-1.169 14.68",
    fill: "#CBD1D1"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M101.496 290.073s2.447 1.281 6.809.658c3.081-.44 3.74.485 7.479 1.039 3.739.554 10.802-.07 11.91-.9.415 1.108-.347 2.077-.347 2.077s-1.523.608-4.847.831c-2.045.137-5.843.293-7.663-.507-1.8-1.385-5.286-1.917-5.77-.243-3.947.958-7.41-.288-7.41-.288l-.16-2.667z",
    fill: "#2B0849"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M108.824 276.19h3.116s-.103 6.751 4.57 8.62c-4.673.624-8.62-2.32-7.686-8.62",
    fill: "#A4AABA"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M57.65 272.52s-2.122 7.47-4.518 12.396c-1.811 3.724-4.255 7.548 5.505 7.548 6.698 0 9.02-.483 7.479-6.648-1.541-6.164.268-13.296.268-13.296H57.65z",
    fill: "#CBD1D1"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M51.54 290.04s2.111 1.178 6.682 1.178c6.128 0 8.31-1.662 8.31-1.662s.605 1.122-.624 2.18c-1 .862-3.624 1.603-7.444 1.559-4.177-.049-5.876-.57-6.786-1.177-.831-.554-.692-1.593-.138-2.078",
    fill: "#2B0849"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M58.533 274.438s.034 1.529-.315 2.95c-.352 1.431-1.087 3.127-1.139 4.17-.058 1.16 4.57 1.592 5.194.035.623-1.559 1.303-6.475 1.927-7.306.622-.831-4.94-2.135-5.667.15",
    fill: "#A4AABA"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M100.885 277.015l13.306.092s1.291-54.228 1.843-64.056c.552-9.828 3.756-43.13.997-62.788l-12.48-.64-22.725.776s-.433 3.944-1.19 9.921c-.062.493-.677.838-.744 1.358-.075.582.42 1.347.318 1.956-2.35 14.003-6.343 32.926-8.697 46.425-.116.663-1.227 1.004-1.45 2.677-.04.3.21 1.516.112 1.785-6.836 18.643-10.89 47.584-14.2 61.551l14.528-.014s2.185-8.524 4.008-16.878c2.796-12.817 22.987-84.553 22.987-84.553l3-.517 1.037 46.1s-.223 1.228.334 2.008c.558.782-.556 1.117-.39 2.233l.39 1.784s-.446 7.14-.892 11.826c-.446 4.685-.092 38.954-.092 38.954",
    fill: "#7BB2F9"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M77.438 220.434c1.146.094 4.016-2.008 6.916-4.91M107.55 223.931s2.758-1.103 6.069-3.862",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M108.459 220.905s2.759-1.104 6.07-3.863",
    stroke: "#648BD8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M76.099 223.557s2.608-.587 6.47-3.346M87.33 150.82c-.27 3.088.297 8.478-4.315 9.073M104.829 149.075s.11 13.936-1.286 14.983c-2.207 1.655-2.975 1.934-2.975 1.934M101.014 149.63s.035 12.81-1.19 24.245M94.93 174.965s7.174-1.655 9.38-1.655M75.671 204.754c-.316 1.55-.64 3.067-.973 4.535 0 0-1.45 1.822-1.003 3.756.446 1.934-.943 2.034-4.96 15.273-1.686 5.559-4.464 18.49-6.313 27.447-.078.38-4.018 18.06-4.093 18.423M77.043 196.743a313.269 313.269 0 0 1-.877 4.729M83.908 151.414l-1.19 10.413s-1.091.148-.496 2.23c.111 1.34-2.66 15.692-5.153 30.267M57.58 272.94h13.238",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M117.377 147.423s-16.955-3.087-35.7.199c.157 2.501-.002 4.128-.002 4.128s14.607-2.802 35.476-.31c.251-2.342.226-4.017.226-4.017",
    fill: "#192064"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M107.511 150.353l.004-4.885a.807.807 0 0 0-.774-.81c-2.428-.092-5.04-.108-7.795-.014a.814.814 0 0 0-.784.81l-.003 4.88c0 .456.371.82.827.808a140.76 140.76 0 0 1 7.688.017.81.81 0 0 0 .837-.806",
    fill: "#FFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M106.402 149.426l.002-3.06a.64.64 0 0 0-.616-.643 94.135 94.135 0 0 0-5.834-.009.647.647 0 0 0-.626.643l-.001 3.056c0 .36.291.648.651.64 1.78-.04 3.708-.041 5.762.012.36.009.662-.279.662-.64",
    fill: "#192064"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M101.485 273.933h12.272M102.652 269.075c.006 3.368.04 5.759.11 6.47M102.667 263.125c-.009 1.53-.015 2.98-.016 4.313M102.204 174.024l.893 44.402s.669 1.561-.224 2.677c-.892 1.116 2.455.67.893 2.231-1.562 1.562.893 1.116 0 3.347-.592 1.48-.988 20.987-1.09 34.956",
    stroke: "#648BD8",
    strokeWidth: "1.051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ExceptionMap = {
  "404": NoFound,
  "500": ServerError,
  "403": Unauthorized
};
ExceptionMap["403"];
ExceptionMap["404"];
ExceptionMap["500"];
var Track = function Track2(props) {
  var _ref, _ref2;
  var className = props.className, included = props.included, vertical = props.vertical, style2 = props.style;
  var length = props.length, offset3 = props.offset, reverse = props.reverse;
  if (length < 0) {
    reverse = !reverse;
    length = Math.abs(length);
    offset3 = 100 - offset3;
  }
  var positonStyle = vertical ? (_ref = {}, _defineProperty$4(_ref, reverse ? "top" : "bottom", "".concat(offset3, "%")), _defineProperty$4(_ref, reverse ? "bottom" : "top", "auto"), _defineProperty$4(_ref, "height", "".concat(length, "%")), _ref) : (_ref2 = {}, _defineProperty$4(_ref2, reverse ? "right" : "left", "".concat(offset3, "%")), _defineProperty$4(_ref2, reverse ? "left" : "right", "auto"), _defineProperty$4(_ref2, "width", "".concat(length, "%")), _ref2);
  var elStyle = _objectSpread2$1(_objectSpread2$1({}, style2), positonStyle);
  return included ? /* @__PURE__ */ React__default.createElement("div", {
    className,
    style: elStyle
  }) : null;
};
function _superPropBase(object3, property) {
  while (!Object.prototype.hasOwnProperty.call(object3, property)) {
    object3 = _getPrototypeOf$2(object3);
    if (object3 === null)
      break;
  }
  return object3;
}
function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get2(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get.apply(this, arguments);
}
var calcPoints = function calcPoints2(vertical, marks, dots, step, min, max) {
  warningOnce(dots ? step > 0 : true, "`Slider[step]` should be a positive number in order to make Slider[dots] work.");
  var points = Object.keys(marks).map(parseFloat).sort(function(a2, b2) {
    return a2 - b2;
  });
  if (dots && step) {
    for (var i2 = min; i2 <= max; i2 += step) {
      if (points.indexOf(i2) === -1) {
        points.push(i2);
      }
    }
  }
  return points;
};
var Steps$1 = function Steps2(_ref) {
  var prefixCls = _ref.prefixCls, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, dots = _ref.dots, step = _ref.step, included = _ref.included, lowerBound = _ref.lowerBound, upperBound = _ref.upperBound, max = _ref.max, min = _ref.min, dotStyle = _ref.dotStyle, activeDotStyle = _ref.activeDotStyle;
  var range2 = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function(point) {
    var _classNames;
    var offset3 = "".concat(Math.abs(point - min) / range2 * 100, "%");
    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style2 = vertical ? _objectSpread2$1(_objectSpread2$1({}, dotStyle), {}, _defineProperty$4({}, reverse ? "top" : "bottom", offset3)) : _objectSpread2$1(_objectSpread2$1({}, dotStyle), {}, _defineProperty$4({}, reverse ? "right" : "left", offset3));
    if (isActived) {
      style2 = _objectSpread2$1(_objectSpread2$1({}, style2), activeDotStyle);
    }
    var pointClassName = cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-dot"), true), _defineProperty$4(_classNames, "".concat(prefixCls, "-dot-active"), isActived), _defineProperty$4(_classNames, "".concat(prefixCls, "-dot-reverse"), reverse), _classNames));
    return /* @__PURE__ */ React__default.createElement("span", {
      className: pointClassName,
      style: style2,
      key: point
    });
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(prefixCls, "-step")
  }, elements);
};
var Marks = function Marks2(_ref) {
  var className = _ref.className, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, included = _ref.included, upperBound = _ref.upperBound, lowerBound = _ref.lowerBound, max = _ref.max, min = _ref.min, onClickLabel = _ref.onClickLabel;
  var marksKeys = Object.keys(marks);
  var range2 = max - min;
  var elements = marksKeys.map(parseFloat).sort(function(a2, b2) {
    return a2 - b2;
  }).map(function(point) {
    var _classNames;
    var markPoint = marks[point];
    var markPointIsObject = _typeof$5(markPoint) === "object" && !/* @__PURE__ */ React__default.isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    if (!markLabel && markLabel !== 0) {
      return null;
    }
    var isActive2 = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(className, "-text"), true), _defineProperty$4(_classNames, "".concat(className, "-text-active"), isActive2), _classNames));
    var bottomStyle = _defineProperty$4({
      marginBottom: "-50%"
    }, reverse ? "top" : "bottom", "".concat((point - min) / range2 * 100, "%"));
    var leftStyle = _defineProperty$4({
      transform: "translateX(".concat(reverse ? "50%" : "-50%", ")"),
      msTransform: "translateX(".concat(reverse ? "50%" : "-50%", ")")
    }, reverse ? "right" : "left", "".concat((point - min) / range2 * 100, "%"));
    var style2 = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? _objectSpread2$1(_objectSpread2$1({}, style2), markPoint.style) : style2;
    return /* @__PURE__ */ React__default.createElement("span", {
      className: markClassName,
      style: markStyle,
      key: point,
      onMouseDown: function onMouseDown(e3) {
        return onClickLabel(e3, point);
      },
      onTouchStart: function onTouchStart(e3) {
        return onClickLabel(e3, point);
      }
    }, markLabel);
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    className
  }, elements);
};
var Handle = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Handle2, _React$Component);
  var _super = _createSuper$1(Handle2);
  function Handle2() {
    var _this2;
    _classCallCheck$2(this, Handle2);
    _this2 = _super.apply(this, arguments);
    _this2.state = {
      clickFocused: false
    };
    _this2.setHandleRef = function(node) {
      _this2.handle = node;
    };
    _this2.handleMouseUp = function() {
      if (document.activeElement === _this2.handle) {
        _this2.setClickFocus(true);
      }
    };
    _this2.handleMouseDown = function(e3) {
      e3.preventDefault();
      _this2.focus();
    };
    _this2.handleBlur = function() {
      _this2.setClickFocus(false);
    };
    _this2.handleKeyDown = function() {
      _this2.setClickFocus(false);
    };
    return _this2;
  }
  _createClass$2(Handle2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onMouseUpListener = addEventListenerWrap(document, "mouseup", this.handleMouseUp);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.onMouseUpListener) {
        this.onMouseUpListener.remove();
      }
    }
  }, {
    key: "setClickFocus",
    value: function setClickFocus(focused) {
      this.setState({
        clickFocused: focused
      });
    }
  }, {
    key: "clickFocus",
    value: function clickFocus() {
      this.setClickFocus(true);
      this.focus();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.handle.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.handle.blur();
    }
  }, {
    key: "render",
    value: function render4() {
      var _ref, _ref2;
      var _this$props = this.props, prefixCls = _this$props.prefixCls, vertical = _this$props.vertical, reverse = _this$props.reverse, offset3 = _this$props.offset, style2 = _this$props.style, disabled = _this$props.disabled, min = _this$props.min, max = _this$props.max, value = _this$props.value, tabIndex = _this$props.tabIndex, ariaLabel = _this$props.ariaLabel, ariaLabelledBy = _this$props.ariaLabelledBy, ariaValueTextFormatter = _this$props.ariaValueTextFormatter, restProps = _objectWithoutProperties$1(_this$props, ["prefixCls", "vertical", "reverse", "offset", "style", "disabled", "min", "max", "value", "tabIndex", "ariaLabel", "ariaLabelledBy", "ariaValueTextFormatter"]);
      var className = cn(this.props.className, _defineProperty$4({}, "".concat(prefixCls, "-handle-click-focused"), this.state.clickFocused));
      var positionStyle = vertical ? (_ref = {}, _defineProperty$4(_ref, reverse ? "top" : "bottom", "".concat(offset3, "%")), _defineProperty$4(_ref, reverse ? "bottom" : "top", "auto"), _defineProperty$4(_ref, "transform", reverse ? null : "translateY(+50%)"), _ref) : (_ref2 = {}, _defineProperty$4(_ref2, reverse ? "right" : "left", "".concat(offset3, "%")), _defineProperty$4(_ref2, reverse ? "left" : "right", "auto"), _defineProperty$4(_ref2, "transform", "translateX(".concat(reverse ? "+" : "-", "50%)")), _ref2);
      var elStyle = _objectSpread2$1(_objectSpread2$1({}, style2), positionStyle);
      var mergedTabIndex = tabIndex || 0;
      if (disabled || tabIndex === null) {
        mergedTabIndex = null;
      }
      var ariaValueText;
      if (ariaValueTextFormatter) {
        ariaValueText = ariaValueTextFormatter(value);
      }
      return /* @__PURE__ */ React__default.createElement("div", _extends$2({
        ref: this.setHandleRef,
        tabIndex: mergedTabIndex
      }, restProps, {
        className,
        style: elStyle,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown,
        role: "slider",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        "aria-disabled": !!disabled,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-valuetext": ariaValueText
      }));
    }
  }]);
  return Handle2;
}(React__default.Component);
function isEventFromHandle(e3, handles) {
  try {
    return Object.keys(handles).some(function(key2) {
      return e3.target === findDOMNode$1(handles[key2]);
    });
  } catch (error) {
    return false;
  }
}
function isValueOutOfRange(value, _ref) {
  var min = _ref.min, max = _ref.max;
  return value < min || value > max;
}
function isNotTouchEvent(e3) {
  return e3.touches.length > 1 || e3.type.toLowerCase() === "touchend" && e3.touches.length > 0;
}
function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks, step = _ref2.step, min = _ref2.min, max = _ref2.max;
  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var baseNum = Math.pow(10, getPrecision(step));
    var maxSteps = Math.floor((max * baseNum - min * baseNum) / (step * baseNum));
    var steps = Math.min((val - min) / step, maxSteps);
    var closestStep = Math.round(steps) * step + min;
    points.push(closestStep);
  }
  var diffs = points.map(function(point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, _toConsumableArray(diffs)))];
}
function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf(".") >= 0) {
    precision = stepString.length - stepString.indexOf(".") - 1;
  }
  return precision;
}
function getMousePosition(vertical, e3) {
  return vertical ? e3.clientY : e3.pageX;
}
function getTouchPosition(vertical, e3) {
  return vertical ? e3.touches[0].clientY : e3.touches[0].pageX;
}
function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}
function ensureValueInRange(val, _ref3) {
  var max = _ref3.max, min = _ref3.min;
  if (val <= min) {
    return min;
  }
  if (val >= max) {
    return max;
  }
  return val;
}
function ensureValuePrecision(val, props) {
  var step = props.step;
  var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0;
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}
function pauseEvent(e3) {
  e3.stopPropagation();
  e3.preventDefault();
}
function calculateNextValue(func, value, props) {
  var operations = {
    increase: function increase(a2, b2) {
      return a2 + b2;
    },
    decrease: function decrease(a2, b2) {
      return a2 - b2;
    }
  };
  var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
  var keyToGet = Object.keys(props.marks)[indexToGet];
  if (props.step) {
    return operations[func](value, props.step);
  }
  if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
    return props.marks[keyToGet];
  }
  return value;
}
function getKeyboardValueMutator(e3, vertical, reverse) {
  var increase = "increase";
  var decrease = "decrease";
  var method3 = increase;
  switch (e3.keyCode) {
    case KeyCode.UP:
      method3 = vertical && reverse ? decrease : increase;
      break;
    case KeyCode.RIGHT:
      method3 = !vertical && reverse ? decrease : increase;
      break;
    case KeyCode.DOWN:
      method3 = vertical && reverse ? increase : decrease;
      break;
    case KeyCode.LEFT:
      method3 = !vertical && reverse ? increase : decrease;
      break;
    case KeyCode.END:
      return function(value, props) {
        return props.max;
      };
    case KeyCode.HOME:
      return function(value, props) {
        return props.min;
      };
    case KeyCode.PAGE_UP:
      return function(value, props) {
        return value + props.step * 2;
      };
    case KeyCode.PAGE_DOWN:
      return function(value, props) {
        return value - props.step * 2;
      };
    default:
      return void 0;
  }
  return function(value, props) {
    return calculateNextValue(method3, value, props);
  };
}
function noop$1() {
}
function createSlider(Component3) {
  var _a;
  return _a = /* @__PURE__ */ function(_Component) {
    _inherits$1(ComponentEnhancer, _Component);
    var _super = _createSuper$1(ComponentEnhancer);
    function ComponentEnhancer(props) {
      var _this2;
      _classCallCheck$2(this, ComponentEnhancer);
      _this2 = _super.call(this, props);
      _this2.onDown = function(e3, position) {
        var p = position;
        var _this$props = _this2.props, draggableTrack = _this$props.draggableTrack, isVertical = _this$props.vertical;
        var bounds = _this2.state.bounds;
        var value = draggableTrack && _this2.positionGetValue ? _this2.positionGetValue(p) || [] : [];
        var inPoint = isEventFromHandle(e3, _this2.handlesRefs);
        _this2.dragTrack = draggableTrack && bounds.length >= 2 && !inPoint && !value.map(function(n3, i2) {
          var v2 = !i2 ? n3 >= bounds[i2] : true;
          return i2 === value.length - 1 ? n3 <= bounds[i2] : v2;
        }).some(function(c2) {
          return !c2;
        });
        if (_this2.dragTrack) {
          _this2.dragOffset = p;
          _this2.startBounds = _toConsumableArray(bounds);
        } else {
          if (!inPoint) {
            _this2.dragOffset = 0;
          } else {
            var handlePosition = getHandleCenterPosition(isVertical, e3.target);
            _this2.dragOffset = p - handlePosition;
            p = handlePosition;
          }
          _this2.onStart(p);
        }
      };
      _this2.onMouseDown = function(e3) {
        if (e3.button !== 0) {
          return;
        }
        _this2.removeDocumentEvents();
        var isVertical = _this2.props.vertical;
        var position = getMousePosition(isVertical, e3);
        _this2.onDown(e3, position);
        _this2.addDocumentMouseEvents();
      };
      _this2.onTouchStart = function(e3) {
        if (isNotTouchEvent(e3))
          return;
        var isVertical = _this2.props.vertical;
        var position = getTouchPosition(isVertical, e3);
        _this2.onDown(e3, position);
        _this2.addDocumentTouchEvents();
        pauseEvent(e3);
      };
      _this2.onFocus = function(e3) {
        var _this$props2 = _this2.props, onFocus2 = _this$props2.onFocus, vertical = _this$props2.vertical;
        if (isEventFromHandle(e3, _this2.handlesRefs) && !_this2.dragTrack) {
          var handlePosition = getHandleCenterPosition(vertical, e3.target);
          _this2.dragOffset = 0;
          _this2.onStart(handlePosition);
          pauseEvent(e3);
          if (onFocus2) {
            onFocus2(e3);
          }
        }
      };
      _this2.onBlur = function(e3) {
        var onBlur2 = _this2.props.onBlur;
        if (!_this2.dragTrack) {
          _this2.onEnd();
        }
        if (onBlur2) {
          onBlur2(e3);
        }
      };
      _this2.onMouseUp = function() {
        if (_this2.handlesRefs[_this2.prevMovedHandleIndex]) {
          _this2.handlesRefs[_this2.prevMovedHandleIndex].clickFocus();
        }
      };
      _this2.onMouseMove = function(e3) {
        if (!_this2.sliderRef) {
          _this2.onEnd();
          return;
        }
        var position = getMousePosition(_this2.props.vertical, e3);
        _this2.onMove(e3, position - _this2.dragOffset, _this2.dragTrack, _this2.startBounds);
      };
      _this2.onTouchMove = function(e3) {
        if (isNotTouchEvent(e3) || !_this2.sliderRef) {
          _this2.onEnd();
          return;
        }
        var position = getTouchPosition(_this2.props.vertical, e3);
        _this2.onMove(e3, position - _this2.dragOffset, _this2.dragTrack, _this2.startBounds);
      };
      _this2.onKeyDown = function(e3) {
        if (_this2.sliderRef && isEventFromHandle(e3, _this2.handlesRefs)) {
          _this2.onKeyboard(e3);
        }
      };
      _this2.onClickMarkLabel = function(e3, value) {
        e3.stopPropagation();
        _this2.onChange({
          value
        });
        _this2.setState({
          value
        }, function() {
          return _this2.onEnd(true);
        });
      };
      _this2.saveSlider = function(slider) {
        _this2.sliderRef = slider;
      };
      var step = props.step, max = props.max, min = props.min;
      var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true;
      warningOnce(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (".concat(max - min, ") should be a multiple of Slider[step] (").concat(step, ")"));
      _this2.handlesRefs = {};
      return _this2;
    }
    _createClass$2(ComponentEnhancer, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.document = this.sliderRef && this.sliderRef.ownerDocument;
        var _this$props3 = this.props, autoFocus = _this$props3.autoFocus, disabled = _this$props3.disabled;
        if (autoFocus && !disabled) {
          this.focus();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (_get(_getPrototypeOf$2(ComponentEnhancer.prototype), "componentWillUnmount", this))
          _get(_getPrototypeOf$2(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: "getSliderStart",
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var _this$props4 = this.props, vertical = _this$props4.vertical, reverse = _this$props4.reverse;
        var rect = slider.getBoundingClientRect();
        if (vertical) {
          return reverse ? rect.bottom : rect.top;
        }
        return window.pageXOffset + (reverse ? rect.right : rect.left);
      }
    }, {
      key: "getSliderLength",
      value: function getSliderLength() {
        var slider = this.sliderRef;
        if (!slider) {
          return 0;
        }
        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: "addDocumentTouchEvents",
      value: function addDocumentTouchEvents() {
        this.onTouchMoveListener = addEventListenerWrap(this.document, "touchmove", this.onTouchMove);
        this.onTouchUpListener = addEventListenerWrap(this.document, "touchend", this.onEnd);
      }
    }, {
      key: "addDocumentMouseEvents",
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = addEventListenerWrap(this.document, "mousemove", this.onMouseMove);
        this.onMouseUpListener = addEventListenerWrap(this.document, "mouseup", this.onEnd);
      }
    }, {
      key: "removeDocumentEvents",
      value: function removeDocumentEvents() {
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();
        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
      }
    }, {
      key: "focus",
      value: function focus() {
        var _this$handlesRefs$;
        if (this.props.disabled) {
          return;
        }
        (_this$handlesRefs$ = this.handlesRefs[0]) === null || _this$handlesRefs$ === void 0 ? void 0 : _this$handlesRefs$.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        var _this2 = this;
        if (this.props.disabled) {
          return;
        }
        Object.keys(this.handlesRefs).forEach(function(key2) {
          var _this2$handlesRefs$ke, _this2$handlesRefs$ke2;
          (_this2$handlesRefs$ke = _this2.handlesRefs[key2]) === null || _this2$handlesRefs$ke === void 0 ? void 0 : (_this2$handlesRefs$ke2 = _this2$handlesRefs$ke.blur) === null || _this2$handlesRefs$ke2 === void 0 ? void 0 : _this2$handlesRefs$ke2.call(_this2$handlesRefs$ke);
        });
      }
    }, {
      key: "calcValue",
      value: function calcValue(offset3) {
        var _this$props5 = this.props, vertical = _this$props5.vertical, min = _this$props5.min, max = _this$props5.max;
        var ratio = Math.abs(Math.max(offset3, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: "calcValueByPos",
      value: function calcValueByPos(position) {
        var sign = this.props.reverse ? -1 : 1;
        var pixelOffset = sign * (position - this.getSliderStart());
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: "calcOffset",
      value: function calcOffset(value) {
        var _this$props6 = this.props, min = _this$props6.min, max = _this$props6.max;
        var ratio = (value - min) / (max - min);
        return Math.max(0, ratio * 100);
      }
    }, {
      key: "saveHandle",
      value: function saveHandle(index2, handle) {
        this.handlesRefs[index2] = handle;
      }
    }, {
      key: "render",
      value: function render4() {
        var _classNames;
        var _this$props7 = this.props, prefixCls = _this$props7.prefixCls, className = _this$props7.className, marks = _this$props7.marks, dots = _this$props7.dots, step = _this$props7.step, included = _this$props7.included, disabled = _this$props7.disabled, vertical = _this$props7.vertical, reverse = _this$props7.reverse, min = _this$props7.min, max = _this$props7.max, children = _this$props7.children, maximumTrackStyle = _this$props7.maximumTrackStyle, style2 = _this$props7.style, railStyle = _this$props7.railStyle, dotStyle = _this$props7.dotStyle, activeDotStyle = _this$props7.activeDotStyle;
        var _get$call = _get(_getPrototypeOf$2(ComponentEnhancer.prototype), "render", this).call(this), tracks = _get$call.tracks, handles = _get$call.handles;
        var sliderClassName = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), _defineProperty$4(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty$4(_classNames, "".concat(prefixCls, "-vertical"), vertical), _defineProperty$4(_classNames, className, className), _classNames));
        return /* @__PURE__ */ React__default.createElement("div", {
          ref: this.saveSlider,
          className: sliderClassName,
          onTouchStart: disabled ? noop$1 : this.onTouchStart,
          onMouseDown: disabled ? noop$1 : this.onMouseDown,
          onMouseUp: disabled ? noop$1 : this.onMouseUp,
          onKeyDown: disabled ? noop$1 : this.onKeyDown,
          onFocus: disabled ? noop$1 : this.onFocus,
          onBlur: disabled ? noop$1 : this.onBlur,
          style: style2
        }, /* @__PURE__ */ React__default.createElement("div", {
          className: "".concat(prefixCls, "-rail"),
          style: _objectSpread2$1(_objectSpread2$1({}, maximumTrackStyle), railStyle)
        }), tracks, /* @__PURE__ */ React__default.createElement(Steps$1, {
          prefixCls,
          vertical,
          reverse,
          marks,
          dots,
          step,
          included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max,
          min,
          dotStyle,
          activeDotStyle
        }), handles, /* @__PURE__ */ React__default.createElement(Marks, {
          className: "".concat(prefixCls, "-mark"),
          onClickLabel: disabled ? noop$1 : this.onClickMarkLabel,
          vertical,
          marks,
          included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max,
          min,
          reverse
        }), children);
      }
    }]);
    return ComponentEnhancer;
  }(Component3), _a.displayName = "ComponentEnhancer(".concat(Component3.displayName, ")"), _a.defaultProps = _objectSpread2$1(_objectSpread2$1({}, Component3.defaultProps), {}, {
    prefixCls: "rc-slider",
    className: "",
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(props) {
      var index2 = props.index, restProps = _objectWithoutProperties$1(props, ["index"]);
      delete restProps.dragging;
      if (restProps.value === null) {
        return null;
      }
      return /* @__PURE__ */ React__default.createElement(Handle, _extends$2({}, restProps, {
        key: index2
      }));
    },
    onBeforeChange: noop$1,
    onChange: noop$1,
    onAfterChange: noop$1,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    reverse: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _a;
}
var Slider$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Slider2, _React$Component);
  var _super = _createSuper$1(Slider2);
  function Slider2(props) {
    var _this2;
    _classCallCheck$2(this, Slider2);
    _this2 = _super.call(this, props);
    _this2.positionGetValue = function(position) {
      return [];
    };
    _this2.onEnd = function(force) {
      var dragging = _this2.state.dragging;
      _this2.removeDocumentEvents();
      if (dragging || force) {
        _this2.props.onAfterChange(_this2.getValue());
      }
      _this2.setState({
        dragging: false
      });
    };
    var defaultValue = props.defaultValue !== void 0 ? props.defaultValue : props.min;
    var value = props.value !== void 0 ? props.value : defaultValue;
    _this2.state = {
      value: _this2.trimAlignValue(value),
      dragging: false
    };
    warningOnce(!("minimumTrackStyle" in props), "minimumTrackStyle will be deprecated, please use trackStyle instead.");
    warningOnce(!("maximumTrackStyle" in props), "maximumTrackStyle will be deprecated, please use railStyle instead.");
    return _this2;
  }
  _createClass$2(Slider2, [{
    key: "calcValueByPos",
    value: function calcValueByPos(value) {
      return 0;
    }
  }, {
    key: "calcOffset",
    value: function calcOffset(value) {
      return 0;
    }
  }, {
    key: "saveHandle",
    value: function saveHandle(index2, h) {
    }
  }, {
    key: "removeDocumentEvents",
    value: function removeDocumentEvents() {
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props, min = _this$props.min, max = _this$props.max, value = _this$props.value, onChange4 = _this$props.onChange;
      if (!("min" in this.props || "max" in this.props)) {
        return;
      }
      var theValue = value !== void 0 ? value : prevState.value;
      var nextValue = this.trimAlignValue(theValue, this.props);
      if (nextValue === prevState.value) {
        return;
      }
      this.setState({
        value: nextValue
      });
      if (!(min === prevProps.min && max === prevProps.max) && isValueOutOfRange(theValue, this.props)) {
        onChange4(nextValue);
      }
    }
  }, {
    key: "onChange",
    value: function onChange4(state) {
      var props = this.props;
      var isNotControlled = !("value" in props);
      var nextState = state.value > this.props.max ? _objectSpread2$1(_objectSpread2$1({}, state), {}, {
        value: this.props.max
      }) : state;
      if (isNotControlled) {
        this.setState(nextState);
      }
      var changedValue = nextState.value;
      props.onChange(changedValue);
    }
  }, {
    key: "onStart",
    value: function onStart(position) {
      this.setState({
        dragging: true
      });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);
      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;
      if (value === prevValue)
        return;
      this.prevMovedHandleIndex = 0;
      this.onChange({
        value
      });
    }
  }, {
    key: "onMove",
    value: function onMove(e3, position) {
      pauseEvent(e3);
      var oldValue = this.state.value;
      var value = this.calcValueByPos(position);
      if (value === oldValue)
        return;
      this.onChange({
        value
      });
    }
  }, {
    key: "onKeyboard",
    value: function onKeyboard(e3) {
      var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
      var valueMutator = getKeyboardValueMutator(e3, vertical, reverse);
      if (valueMutator) {
        pauseEvent(e3);
        var state = this.state;
        var oldValue = state.value;
        var mutatedValue = valueMutator(oldValue, this.props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === oldValue)
          return;
        this.onChange({
          value
        });
        this.props.onAfterChange(value);
        this.onEnd();
      }
    }
  }, {
    key: "getValue",
    value: function getValue2() {
      return this.state.value;
    }
  }, {
    key: "getLowerBound",
    value: function getLowerBound() {
      var minPoint = this.props.startPoint || this.props.min;
      return this.state.value > minPoint ? minPoint : this.state.value;
    }
  }, {
    key: "getUpperBound",
    value: function getUpperBound() {
      if (this.state.value < this.props.startPoint) {
        return this.props.startPoint;
      }
      return this.state.value;
    }
  }, {
    key: "trimAlignValue",
    value: function trimAlignValue2(v2) {
      var nextProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (v2 === null) {
        return null;
      }
      var mergedProps = _objectSpread2$1(_objectSpread2$1({}, this.props), nextProps);
      var val = ensureValueInRange(v2, mergedProps);
      return ensureValuePrecision(val, mergedProps);
    }
  }, {
    key: "render",
    value: function render4() {
      var _this2 = this;
      var _this$props3 = this.props, prefixCls = _this$props3.prefixCls, vertical = _this$props3.vertical, included = _this$props3.included, disabled = _this$props3.disabled, minimumTrackStyle = _this$props3.minimumTrackStyle, trackStyle = _this$props3.trackStyle, handleStyle = _this$props3.handleStyle, tabIndex = _this$props3.tabIndex, ariaLabelForHandle = _this$props3.ariaLabelForHandle, ariaLabelledByForHandle = _this$props3.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = _this$props3.ariaValueTextFormatterForHandle, min = _this$props3.min, max = _this$props3.max, startPoint = _this$props3.startPoint, reverse = _this$props3.reverse, handleGenerator = _this$props3.handle;
      var _this$state = this.state, value = _this$state.value, dragging = _this$state.dragging;
      var offset3 = this.calcOffset(value);
      var handle = handleGenerator({
        className: "".concat(prefixCls, "-handle"),
        prefixCls,
        vertical,
        offset: offset3,
        value,
        dragging,
        disabled,
        min,
        max,
        reverse,
        index: 0,
        tabIndex,
        ariaLabel: ariaLabelForHandle,
        ariaLabelledBy: ariaLabelledByForHandle,
        ariaValueTextFormatter: ariaValueTextFormatterForHandle,
        style: handleStyle[0] || handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });
      var trackOffset = startPoint !== void 0 ? this.calcOffset(startPoint) : 0;
      var mergedTrackStyle = trackStyle[0] || trackStyle;
      var track = /* @__PURE__ */ React__default.createElement(Track, {
        className: "".concat(prefixCls, "-track"),
        vertical,
        included,
        offset: trackOffset,
        reverse,
        length: offset3 - trackOffset,
        style: _objectSpread2$1(_objectSpread2$1({}, minimumTrackStyle), mergedTrackStyle)
      });
      return {
        tracks: track,
        handles: handle
      };
    }
  }]);
  return Slider2;
}(React__default.Component);
var Slider$2 = createSlider(Slider$1);
var _trimAlignValue = function trimAlignValue(_ref) {
  var value = _ref.value, handle = _ref.handle, bounds = _ref.bounds, props = _ref.props;
  var allowCross = props.allowCross, pushable = props.pushable;
  var thershold = Number(pushable);
  var valInRange = ensureValueInRange(value, props);
  var valNotConflict = valInRange;
  if (!allowCross && handle != null && bounds !== void 0) {
    if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
      valNotConflict = bounds[handle - 1] + thershold;
    }
    if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
      valNotConflict = bounds[handle + 1] - thershold;
    }
  }
  return ensureValuePrecision(valNotConflict, props);
};
var Range = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Range2, _React$Component);
  var _super = _createSuper$1(Range2);
  function Range2(props) {
    var _this2;
    _classCallCheck$2(this, Range2);
    _this2 = _super.call(this, props);
    _this2.positionGetValue = function(position) {
      var bounds2 = _this2.getValue();
      var value2 = _this2.calcValueByPos(position);
      var closestBound = _this2.getClosestBound(value2);
      var index2 = _this2.getBoundNeedMoving(value2, closestBound);
      var prevValue = bounds2[index2];
      if (value2 === prevValue)
        return null;
      var nextBounds = _toConsumableArray(bounds2);
      nextBounds[index2] = value2;
      return nextBounds;
    };
    _this2.onEnd = function(force) {
      var handle = _this2.state.handle;
      _this2.removeDocumentEvents();
      if (!handle) {
        _this2.dragTrack = false;
      }
      if (handle !== null || force) {
        _this2.props.onAfterChange(_this2.getValue());
      }
      _this2.setState({
        handle: null
      });
    };
    var count = props.count, min = props.min, max = props.max;
    var initialValue = Array.apply(void 0, _toConsumableArray(Array(count + 1))).map(function() {
      return min;
    });
    var defaultValue = "defaultValue" in props ? props.defaultValue : initialValue;
    var value = props.value !== void 0 ? props.value : defaultValue;
    var bounds = value.map(function(v2, i2) {
      return _trimAlignValue({
        value: v2,
        handle: i2,
        props
      });
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;
    _this2.state = {
      handle: null,
      recent,
      bounds
    };
    return _this2;
  }
  _createClass$2(Range2, [{
    key: "calcValueByPos",
    value: function calcValueByPos(value) {
      return 0;
    }
  }, {
    key: "getSliderLength",
    value: function getSliderLength() {
      return 0;
    }
  }, {
    key: "calcOffset",
    value: function calcOffset(value) {
      return 0;
    }
  }, {
    key: "saveHandle",
    value: function saveHandle(index2, h) {
    }
  }, {
    key: "removeDocumentEvents",
    value: function removeDocumentEvents() {
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      var _this$props = this.props, onChange4 = _this$props.onChange, value = _this$props.value, min = _this$props.min, max = _this$props.max;
      if (!("min" in this.props || "max" in this.props)) {
        return;
      }
      if (min === prevProps.min && max === prevProps.max) {
        return;
      }
      var currentValue = value || prevState.bounds;
      if (currentValue.some(function(v2) {
        return isValueOutOfRange(v2, _this2.props);
      })) {
        var newValues = currentValue.map(function(v2) {
          return ensureValueInRange(v2, _this2.props);
        });
        onChange4(newValues);
      }
    }
  }, {
    key: "onChange",
    value: function onChange4(state) {
      var props = this.props;
      var isNotControlled = !("value" in props);
      if (isNotControlled) {
        this.setState(state);
      } else {
        var controlledState = {};
        ["handle", "recent"].forEach(function(item) {
          if (state[item] !== void 0) {
            controlledState[item] = state[item];
          }
        });
        if (Object.keys(controlledState).length) {
          this.setState(controlledState);
        }
      }
      var data = _objectSpread2$1(_objectSpread2$1({}, this.state), state);
      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: "onStart",
    value: function onStart(position) {
      var props = this.props, state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);
      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;
      var closestBound = this.getClosestBound(value);
      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
      this.setState({
        handle: this.prevMovedHandleIndex,
        recent: this.prevMovedHandleIndex
      });
      var prevValue = bounds[this.prevMovedHandleIndex];
      if (value === prevValue)
        return;
      var nextBounds = _toConsumableArray(state.bounds);
      nextBounds[this.prevMovedHandleIndex] = value;
      this.onChange({
        bounds: nextBounds
      });
    }
  }, {
    key: "onMove",
    value: function onMove(e3, position, dragTrack, startBounds) {
      pauseEvent(e3);
      var state = this.state, props = this.props;
      var maxValue = props.max || 100;
      var minValue = props.min || 0;
      if (dragTrack) {
        var pos = props.vertical ? -position : position;
        pos = props.reverse ? -pos : pos;
        var max = maxValue - Math.max.apply(Math, _toConsumableArray(startBounds));
        var min = minValue - Math.min.apply(Math, _toConsumableArray(startBounds));
        var ratio = Math.min(Math.max(pos / (this.getSliderLength() / (maxValue - minValue)), min), max);
        var nextBounds = startBounds.map(function(v2) {
          return Math.floor(Math.max(Math.min(v2 + ratio, maxValue), minValue));
        });
        if (state.bounds.map(function(c2, i2) {
          return c2 === nextBounds[i2];
        }).some(function(c2) {
          return !c2;
        })) {
          this.onChange({
            bounds: nextBounds
          });
        }
        return;
      }
      var value = this.calcValueByPos(position);
      var oldValue = state.bounds[state.handle];
      if (value === oldValue)
        return;
      this.moveTo(value);
    }
  }, {
    key: "onKeyboard",
    value: function onKeyboard(e3) {
      var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
      var valueMutator = getKeyboardValueMutator(e3, vertical, reverse);
      if (valueMutator) {
        pauseEvent(e3);
        var state = this.state, props = this.props;
        var bounds = state.bounds, handle = state.handle;
        var oldValue = bounds[handle === null ? state.recent : handle];
        var mutatedValue = valueMutator(oldValue, props);
        var value = _trimAlignValue({
          value: mutatedValue,
          handle,
          bounds: state.bounds,
          props
        });
        if (value === oldValue)
          return;
        var isFromKeyboardEvent = true;
        this.moveTo(value, isFromKeyboardEvent);
      }
    }
  }, {
    key: "getValue",
    value: function getValue2() {
      return this.state.bounds;
    }
  }, {
    key: "getClosestBound",
    value: function getClosestBound(value) {
      var bounds = this.state.bounds;
      var closestBound = 0;
      for (var i2 = 1; i2 < bounds.length - 1; i2 += 1) {
        if (value >= bounds[i2]) {
          closestBound = i2;
        }
      }
      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound += 1;
      }
      return closestBound;
    }
  }, {
    key: "getBoundNeedMoving",
    value: function getBoundNeedMoving(value, closestBound) {
      var _this$state = this.state, bounds = _this$state.bounds, recent = _this$state.recent;
      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
        boundNeedMoving = recent;
      }
      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }
      return boundNeedMoving;
    }
  }, {
    key: "getLowerBound",
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: "getUpperBound",
    value: function getUpperBound() {
      var bounds = this.state.bounds;
      return bounds[bounds.length - 1];
    }
  }, {
    key: "getPoints",
    value: function getPoints() {
      var _this$props3 = this.props, marks = _this$props3.marks, step = _this$props3.step, min = _this$props3.min, max = _this$props3.max;
      var cache = this.internalPointsCache;
      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = _objectSpread2$1({}, marks);
        if (step !== null) {
          for (var point = min; point <= max; point += step) {
            pointsObject[point] = point;
          }
        }
        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function(a2, b2) {
          return a2 - b2;
        });
        this.internalPointsCache = {
          marks,
          step,
          points
        };
      }
      return this.internalPointsCache.points;
    }
  }, {
    key: "moveTo",
    value: function moveTo(value, isFromKeyboardEvent) {
      var _this3 = this;
      var state = this.state, props = this.props;
      var nextBounds = _toConsumableArray(state.bounds);
      var handle = state.handle === null ? state.recent : state.handle;
      nextBounds[handle] = value;
      var nextHandle = handle;
      if (props.pushable !== false) {
        this.pushSurroundingHandles(nextBounds, nextHandle);
      } else if (props.allowCross) {
        nextBounds.sort(function(a2, b2) {
          return a2 - b2;
        });
        nextHandle = nextBounds.indexOf(value);
      }
      this.onChange({
        recent: nextHandle,
        handle: nextHandle,
        bounds: nextBounds
      });
      if (isFromKeyboardEvent) {
        this.props.onAfterChange(nextBounds);
        this.setState({}, function() {
          _this3.handlesRefs[nextHandle].focus();
        });
        this.onEnd();
      }
    }
  }, {
    key: "pushSurroundingHandles",
    value: function pushSurroundingHandles(bounds, handle) {
      var value = bounds[handle];
      var pushable = this.props.pushable;
      var threshold = Number(pushable);
      var direction = 0;
      if (bounds[handle + 1] - value < threshold) {
        direction = 1;
      }
      if (value - bounds[handle - 1] < threshold) {
        direction = -1;
      }
      if (direction === 0) {
        return;
      }
      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        bounds[handle] = bounds[nextHandle] - direction * threshold;
      }
    }
  }, {
    key: "pushHandle",
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];
      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          bounds[handle] = originalValue;
          return false;
        }
        currentValue = bounds[handle];
      }
      return true;
    }
  }, {
    key: "pushHandleOnePoint",
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;
      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        return false;
      }
      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var pushable = this.props.pushable;
      var threshold = Number(pushable);
      var diffToNext = direction * (bounds[nextHandle] - nextValue);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        return false;
      }
      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: "trimAlignValue",
    value: function trimAlignValue2(value) {
      var _this$state2 = this.state, handle = _this$state2.handle, bounds = _this$state2.bounds;
      return _trimAlignValue({
        value,
        handle,
        bounds,
        props: this.props
      });
    }
  }, {
    key: "render",
    value: function render4() {
      var _this4 = this;
      var _this$state3 = this.state, handle = _this$state3.handle, bounds = _this$state3.bounds;
      var _this$props4 = this.props, prefixCls = _this$props4.prefixCls, vertical = _this$props4.vertical, included = _this$props4.included, disabled = _this$props4.disabled, min = _this$props4.min, max = _this$props4.max, reverse = _this$props4.reverse, handleGenerator = _this$props4.handle, trackStyle = _this$props4.trackStyle, handleStyle = _this$props4.handleStyle, tabIndex = _this$props4.tabIndex, ariaLabelGroupForHandles = _this$props4.ariaLabelGroupForHandles, ariaLabelledByGroupForHandles = _this$props4.ariaLabelledByGroupForHandles, ariaValueTextFormatterGroupForHandles = _this$props4.ariaValueTextFormatterGroupForHandles;
      var offsets = bounds.map(function(v2) {
        return _this4.calcOffset(v2);
      });
      var handleClassName = "".concat(prefixCls, "-handle");
      var handles = bounds.map(function(v2, i2) {
        var _classNames;
        var mergedTabIndex = tabIndex[i2] || 0;
        if (disabled || tabIndex[i2] === null) {
          mergedTabIndex = null;
        }
        var dragging = handle === i2;
        return handleGenerator({
          className: cn((_classNames = {}, _defineProperty$4(_classNames, handleClassName, true), _defineProperty$4(_classNames, "".concat(handleClassName, "-").concat(i2 + 1), true), _defineProperty$4(_classNames, "".concat(handleClassName, "-dragging"), dragging), _classNames)),
          prefixCls,
          vertical,
          dragging,
          offset: offsets[i2],
          value: v2,
          index: i2,
          tabIndex: mergedTabIndex,
          min,
          max,
          reverse,
          disabled,
          style: handleStyle[i2],
          ref: function ref(h) {
            return _this4.saveHandle(i2, h);
          },
          ariaLabel: ariaLabelGroupForHandles[i2],
          ariaLabelledBy: ariaLabelledByGroupForHandles[i2],
          ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i2]
        });
      });
      var tracks = bounds.slice(0, -1).map(function(_2, index2) {
        var _classNames2;
        var i2 = index2 + 1;
        var trackClassName = cn((_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-track"), true), _defineProperty$4(_classNames2, "".concat(prefixCls, "-track-").concat(i2), true), _classNames2));
        return /* @__PURE__ */ React__default.createElement(Track, {
          className: trackClassName,
          vertical,
          reverse,
          included,
          offset: offsets[i2 - 1],
          length: offsets[i2] - offsets[i2 - 1],
          style: trackStyle[index2],
          key: i2
        });
      });
      return {
        tracks,
        handles
      };
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (!("value" in props || "min" in props || "max" in props)) {
        return null;
      }
      var value = props.value || state.bounds;
      var nextBounds = value.map(function(v2, i2) {
        return _trimAlignValue({
          value: v2,
          handle: i2,
          bounds: state.bounds,
          props
        });
      });
      if (state.bounds.length === nextBounds.length) {
        if (nextBounds.every(function(v2, i2) {
          return v2 === state.bounds[i2];
        })) {
          return null;
        }
      } else {
        nextBounds = value.map(function(v2, i2) {
          return _trimAlignValue({
            value: v2,
            handle: i2,
            props
          });
        });
      }
      return _objectSpread2$1(_objectSpread2$1({}, state), {}, {
        bounds: nextBounds
      });
    }
  }]);
  return Range2;
}(React__default.Component);
Range.displayName = "Range";
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  draggableTrack: false,
  tabIndex: [],
  ariaLabelGroupForHandles: [],
  ariaLabelledByGroupForHandles: [],
  ariaValueTextFormatterGroupForHandles: []
};
var RcRange = createSlider(Range);
var SliderTooltip$1 = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var visible = props.visible, overlay = props.overlay;
  var innerRef = React.useRef(null);
  var tooltipRef = composeRef(ref, innerRef);
  var rafRef = React.useRef(null);
  function cancelKeepAlign() {
    wrapperRaf$1.cancel(rafRef.current);
  }
  function keepAlign() {
    rafRef.current = wrapperRaf$1(function() {
      var _innerRef$current;
      (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.forcePopupAlign();
    });
  }
  React.useEffect(function() {
    if (visible) {
      keepAlign();
    } else {
      cancelKeepAlign();
    }
    return cancelKeepAlign;
  }, [visible, overlay]);
  return /* @__PURE__ */ React.createElement(Tooltip$2, _extends$2({
    ref: tooltipRef
  }, props));
});
function createSliderWithTooltip(Component3) {
  var _a;
  return _a = /* @__PURE__ */ function(_React$Component) {
    _inherits$1(ComponentWrapper, _React$Component);
    var _super = _createSuper$1(ComponentWrapper);
    function ComponentWrapper() {
      var _this2;
      _classCallCheck$2(this, ComponentWrapper);
      _this2 = _super.apply(this, arguments);
      _this2.state = {
        visibles: {}
      };
      _this2.handleTooltipVisibleChange = function(index2, visible) {
        _this2.setState(function(prevState) {
          return {
            visibles: _objectSpread2$1(_objectSpread2$1({}, prevState.visibles), {}, _defineProperty$4({}, index2, visible))
          };
        });
      };
      _this2.handleWithTooltip = function(_ref) {
        var value = _ref.value, dragging = _ref.dragging, index2 = _ref.index, disabled = _ref.disabled, restProps = _objectWithoutProperties$1(_ref, ["value", "dragging", "index", "disabled"]);
        var _this$props = _this2.props, tipFormatter2 = _this$props.tipFormatter, tipProps = _this$props.tipProps, handleStyle = _this$props.handleStyle, getTooltipContainer = _this$props.getTooltipContainer;
        var _tipProps$prefixCls = tipProps.prefixCls, prefixCls = _tipProps$prefixCls === void 0 ? "rc-slider-tooltip" : _tipProps$prefixCls, _tipProps$overlay = tipProps.overlay, overlay = _tipProps$overlay === void 0 ? tipFormatter2(value) : _tipProps$overlay, _tipProps$placement = tipProps.placement, placement = _tipProps$placement === void 0 ? "top" : _tipProps$placement, _tipProps$visible = tipProps.visible, visible = _tipProps$visible === void 0 ? false : _tipProps$visible, restTooltipProps = _objectWithoutProperties$1(tipProps, ["prefixCls", "overlay", "placement", "visible"]);
        var handleStyleWithIndex;
        if (Array.isArray(handleStyle)) {
          handleStyleWithIndex = handleStyle[index2] || handleStyle[0];
        } else {
          handleStyleWithIndex = handleStyle;
        }
        return /* @__PURE__ */ React__default.createElement(SliderTooltip$1, _extends$2({}, restTooltipProps, {
          getTooltipContainer,
          prefixCls,
          overlay,
          placement,
          visible: !disabled && (_this2.state.visibles[index2] || dragging) || visible,
          key: index2
        }), /* @__PURE__ */ React__default.createElement(Handle, _extends$2({}, restProps, {
          style: _objectSpread2$1({}, handleStyleWithIndex),
          value,
          onMouseEnter: function onMouseEnter() {
            return _this2.handleTooltipVisibleChange(index2, true);
          },
          onMouseLeave: function onMouseLeave() {
            return _this2.handleTooltipVisibleChange(index2, false);
          }
        })));
      };
      return _this2;
    }
    _createClass$2(ComponentWrapper, [{
      key: "render",
      value: function render4() {
        return /* @__PURE__ */ React__default.createElement(Component3, _extends$2({}, this.props, {
          handle: this.handleWithTooltip
        }));
      }
    }]);
    return ComponentWrapper;
  }(React__default.Component), _a.defaultProps = {
    tipFormatter: function tipFormatter2(value) {
      return value;
    },
    handleStyle: [{}],
    tipProps: {},
    getTooltipContainer: function getTooltipContainer(node) {
      return node.parentNode;
    }
  }, _a;
}
var InternalSlider = Slider$2;
InternalSlider.Range = RcRange;
InternalSlider.Handle = Handle;
InternalSlider.createSliderWithTooltip = createSliderWithTooltip;
var SliderTooltip = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var visible = props.visible;
  var innerRef = useRef2(null);
  var rafRef = useRef2(null);
  function cancelKeepAlign() {
    wrapperRaf$1.cancel(rafRef.current);
    rafRef.current = null;
  }
  function keepAlign() {
    rafRef.current = wrapperRaf$1(function() {
      var _a;
      (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.forcePopupAlign();
      rafRef.current = null;
    });
  }
  React.useEffect(function() {
    if (visible) {
      keepAlign();
    } else {
      cancelKeepAlign();
    }
    return cancelKeepAlign;
  }, [visible, props.title]);
  return /* @__PURE__ */ React.createElement(Tooltip2, _extends$2({
    ref: composeRef(innerRef, ref)
  }, props));
});
var __rest$a = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var Slider = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, getPopupContainer = _React$useContext.getPopupContainer;
  var _React$useState = React.useState({}), _React$useState2 = _slicedToArray$3(_React$useState, 2), visibles = _React$useState2[0], setVisibles = _React$useState2[1];
  var toggleTooltipVisible = function toggleTooltipVisible2(index2, visible) {
    setVisibles(function(prev) {
      return _extends$2(_extends$2({}, prev), _defineProperty$4({}, index2, visible));
    });
  };
  var getTooltipPlacement = function getTooltipPlacement2(tooltipPlacement, vertical) {
    if (tooltipPlacement) {
      return tooltipPlacement;
    }
    if (!vertical) {
      return "top";
    }
    return direction === "rtl" ? "left" : "right";
  };
  var handleWithTooltip = function handleWithTooltip2(_a) {
    var tooltipPrefixCls2 = _a.tooltipPrefixCls, prefixCls2 = _a.prefixCls, _b = _a.info, value = _b.value, dragging = _b.dragging, index2 = _b.index, restProps2 = __rest$a(_b, ["value", "dragging", "index"]);
    var tipFormatter2 = props.tipFormatter, tooltipVisible = props.tooltipVisible, tooltipPlacement = props.tooltipPlacement, getTooltipPopupContainer = props.getTooltipPopupContainer, vertical = props.vertical;
    var isTipFormatter = tipFormatter2 ? visibles[index2] || dragging : false;
    var visible = tooltipVisible || tooltipVisible === void 0 && isTipFormatter;
    var rootPrefixCls = getPrefixCls();
    return /* @__PURE__ */ React.createElement(SliderTooltip, {
      prefixCls: tooltipPrefixCls2,
      title: tipFormatter2 ? tipFormatter2(value) : "",
      visible,
      placement: getTooltipPlacement(tooltipPlacement, vertical),
      transitionName: "".concat(rootPrefixCls, "-zoom-down"),
      key: index2,
      overlayClassName: "".concat(prefixCls2, "-tooltip"),
      getPopupContainer: getTooltipPopupContainer || getPopupContainer
    }, /* @__PURE__ */ React.createElement(Handle, _extends$2({}, restProps2, {
      value,
      onMouseEnter: function onMouseEnter() {
        return toggleTooltipVisible(index2, true);
      },
      onMouseLeave: function onMouseLeave() {
        return toggleTooltipVisible(index2, false);
      }
    })));
  };
  var customizePrefixCls = props.prefixCls, customizeTooltipPrefixCls = props.tooltipPrefixCls, range2 = props.range, className = props.className, restProps = __rest$a(props, ["prefixCls", "tooltipPrefixCls", "range", "className"]);
  var prefixCls = getPrefixCls("slider", customizePrefixCls);
  var tooltipPrefixCls = getPrefixCls("tooltip", customizeTooltipPrefixCls);
  var cls = cn(className, _defineProperty$4({}, "".concat(prefixCls, "-rtl"), direction === "rtl"));
  if (direction === "rtl" && !restProps.vertical) {
    restProps.reverse = !restProps.reverse;
  }
  var draggableTrack;
  if (_typeof$5(range2) === "object") {
    draggableTrack = range2.draggableTrack;
  }
  if (range2) {
    return /* @__PURE__ */ React.createElement(RcRange, _extends$2({}, restProps, {
      step: restProps.step,
      draggableTrack,
      className: cls,
      ref,
      handle: function handle(info) {
        return handleWithTooltip({
          tooltipPrefixCls,
          prefixCls,
          info
        });
      },
      prefixCls
    }));
  }
  return /* @__PURE__ */ React.createElement(InternalSlider, _extends$2({}, restProps, {
    step: restProps.step,
    className: cls,
    ref,
    handle: function handle(info) {
      return handleWithTooltip({
        tooltipPrefixCls,
        prefixCls,
        info
      });
    },
    prefixCls
  }));
});
Slider.displayName = "Slider";
Slider.defaultProps = {
  tipFormatter: function tipFormatter(value) {
    return typeof value === "number" ? value.toString() : "";
  }
};
var _excluded$1 = ["className", "prefixCls", "style", "active", "status", "iconPrefix", "icon", "wrapperStyle", "stepNumber", "disabled", "description", "title", "subTitle", "progressDot", "stepIcon", "tailContent", "icons", "stepIndex", "onStepClick", "onClick"];
function isString(str) {
  return typeof str === "string";
}
var Step = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Step2, _React$Component);
  var _super = _createSuper$1(Step2);
  function Step2() {
    var _this2;
    _classCallCheck$2(this, Step2);
    _this2 = _super.apply(this, arguments);
    _this2.onClick = function() {
      var _this$props = _this2.props, onClick = _this$props.onClick, onStepClick = _this$props.onStepClick, stepIndex = _this$props.stepIndex;
      if (onClick) {
        onClick.apply(void 0, arguments);
      }
      onStepClick(stepIndex);
    };
    return _this2;
  }
  _createClass$2(Step2, [{
    key: "renderIconNode",
    value: function renderIconNode() {
      var _classNames;
      var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, progressDot = _this$props2.progressDot, stepIcon = _this$props2.stepIcon, stepNumber = _this$props2.stepNumber, status = _this$props2.status, title = _this$props2.title, description = _this$props2.description, icon = _this$props2.icon, iconPrefix = _this$props2.iconPrefix, icons = _this$props2.icons;
      var iconNode;
      var iconClassName = cn("".concat(prefixCls, "-icon"), "".concat(iconPrefix, "icon"), (_classNames = {}, _defineProperty$4(_classNames, "".concat(iconPrefix, "icon-").concat(icon), icon && isString(icon)), _defineProperty$4(_classNames, "".concat(iconPrefix, "icon-check"), !icon && status === "finish" && (icons && !icons.finish || !icons)), _defineProperty$4(_classNames, "".concat(iconPrefix, "icon-cross"), !icon && status === "error" && (icons && !icons.error || !icons)), _classNames));
      var iconDot = /* @__PURE__ */ React.createElement("span", {
        className: "".concat(prefixCls, "-icon-dot")
      });
      if (progressDot) {
        if (typeof progressDot === "function") {
          iconNode = /* @__PURE__ */ React.createElement("span", {
            className: "".concat(prefixCls, "-icon")
          }, progressDot(iconDot, {
            index: stepNumber - 1,
            status,
            title,
            description
          }));
        } else {
          iconNode = /* @__PURE__ */ React.createElement("span", {
            className: "".concat(prefixCls, "-icon")
          }, iconDot);
        }
      } else if (icon && !isString(icon)) {
        iconNode = /* @__PURE__ */ React.createElement("span", {
          className: "".concat(prefixCls, "-icon")
        }, icon);
      } else if (icons && icons.finish && status === "finish") {
        iconNode = /* @__PURE__ */ React.createElement("span", {
          className: "".concat(prefixCls, "-icon")
        }, icons.finish);
      } else if (icons && icons.error && status === "error") {
        iconNode = /* @__PURE__ */ React.createElement("span", {
          className: "".concat(prefixCls, "-icon")
        }, icons.error);
      } else if (icon || status === "finish" || status === "error") {
        iconNode = /* @__PURE__ */ React.createElement("span", {
          className: iconClassName
        });
      } else {
        iconNode = /* @__PURE__ */ React.createElement("span", {
          className: "".concat(prefixCls, "-icon")
        }, stepNumber);
      }
      if (stepIcon) {
        iconNode = stepIcon({
          index: stepNumber - 1,
          status,
          title,
          description,
          node: iconNode
        });
      }
      return iconNode;
    }
  }, {
    key: "render",
    value: function render4() {
      var _classNames2;
      var _this$props3 = this.props, className = _this$props3.className, prefixCls = _this$props3.prefixCls, style2 = _this$props3.style, active = _this$props3.active, _this$props3$status = _this$props3.status, status = _this$props3$status === void 0 ? "wait" : _this$props3$status;
      _this$props3.iconPrefix;
      var icon = _this$props3.icon;
      _this$props3.wrapperStyle;
      _this$props3.stepNumber;
      var disabled = _this$props3.disabled, description = _this$props3.description, title = _this$props3.title, subTitle = _this$props3.subTitle;
      _this$props3.progressDot;
      _this$props3.stepIcon;
      var tailContent = _this$props3.tailContent;
      _this$props3.icons;
      _this$props3.stepIndex;
      var onStepClick = _this$props3.onStepClick, onClick = _this$props3.onClick, restProps = _objectWithoutProperties$1(_this$props3, _excluded$1);
      var classString = cn("".concat(prefixCls, "-item"), "".concat(prefixCls, "-item-").concat(status), className, (_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-item-custom"), icon), _defineProperty$4(_classNames2, "".concat(prefixCls, "-item-active"), active), _defineProperty$4(_classNames2, "".concat(prefixCls, "-item-disabled"), disabled === true), _classNames2));
      var stepItemStyle = _objectSpread2$1({}, style2);
      var accessibilityProps = {};
      if (onStepClick && !disabled) {
        accessibilityProps.role = "button";
        accessibilityProps.tabIndex = 0;
        accessibilityProps.onClick = this.onClick;
      }
      return /* @__PURE__ */ React.createElement("div", Object.assign({}, restProps, {
        className: classString,
        style: stepItemStyle
      }), /* @__PURE__ */ React.createElement("div", Object.assign({
        onClick
      }, accessibilityProps, {
        className: "".concat(prefixCls, "-item-container")
      }), /* @__PURE__ */ React.createElement("div", {
        className: "".concat(prefixCls, "-item-tail")
      }, tailContent), /* @__PURE__ */ React.createElement("div", {
        className: "".concat(prefixCls, "-item-icon")
      }, this.renderIconNode()), /* @__PURE__ */ React.createElement("div", {
        className: "".concat(prefixCls, "-item-content")
      }, /* @__PURE__ */ React.createElement("div", {
        className: "".concat(prefixCls, "-item-title")
      }, title, subTitle && /* @__PURE__ */ React.createElement("div", {
        title: typeof subTitle === "string" ? subTitle : void 0,
        className: "".concat(prefixCls, "-item-subtitle")
      }, subTitle)), description && /* @__PURE__ */ React.createElement("div", {
        className: "".concat(prefixCls, "-item-description")
      }, description))));
    }
  }]);
  return Step2;
}(React.Component);
var _excluded = ["prefixCls", "style", "className", "children", "direction", "type", "labelPlacement", "iconPrefix", "status", "size", "current", "progressDot", "stepIcon", "initial", "icons", "onChange"];
var Steps3 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Steps4, _React$Component);
  var _super = _createSuper$1(Steps4);
  function Steps4() {
    var _this2;
    _classCallCheck$2(this, Steps4);
    _this2 = _super.apply(this, arguments);
    _this2.onStepClick = function(next) {
      var _this$props = _this2.props, onChange4 = _this$props.onChange, current = _this$props.current;
      if (onChange4 && current !== next) {
        onChange4(next);
      }
    };
    return _this2;
  }
  _createClass$2(Steps4, [{
    key: "render",
    value: function render4() {
      var _classNames, _this2 = this;
      var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, _this$props2$style = _this$props2.style, style2 = _this$props2$style === void 0 ? {} : _this$props2$style, className = _this$props2.className, children = _this$props2.children, direction = _this$props2.direction, type2 = _this$props2.type, labelPlacement = _this$props2.labelPlacement, iconPrefix = _this$props2.iconPrefix, status = _this$props2.status, size = _this$props2.size, current = _this$props2.current, progressDot = _this$props2.progressDot, stepIcon = _this$props2.stepIcon, initial = _this$props2.initial, icons = _this$props2.icons, onChange4 = _this$props2.onChange, restProps = _objectWithoutProperties$1(_this$props2, _excluded);
      var isNav = type2 === "navigation";
      var adjustedLabelPlacement = progressDot ? "vertical" : labelPlacement;
      var classString = cn(prefixCls, "".concat(prefixCls, "-").concat(direction), className, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(size), size), _defineProperty$4(_classNames, "".concat(prefixCls, "-label-").concat(adjustedLabelPlacement), direction === "horizontal"), _defineProperty$4(_classNames, "".concat(prefixCls, "-dot"), !!progressDot), _defineProperty$4(_classNames, "".concat(prefixCls, "-navigation"), isNav), _classNames));
      return /* @__PURE__ */ React__default.createElement("div", Object.assign({
        className: classString,
        style: style2
      }, restProps), toArray$8(children).map(function(child, index2) {
        var stepNumber = initial + index2;
        var childProps = _objectSpread2$1({
          stepNumber: "".concat(stepNumber + 1),
          stepIndex: stepNumber,
          key: stepNumber,
          prefixCls,
          iconPrefix,
          wrapperStyle: style2,
          progressDot,
          stepIcon,
          icons,
          onStepClick: onChange4 && _this2.onStepClick
        }, child.props);
        if (status === "error" && index2 === current - 1) {
          childProps.className = "".concat(prefixCls, "-next-error");
        }
        if (!child.props.status) {
          if (stepNumber === current) {
            childProps.status = status;
          } else if (stepNumber < current) {
            childProps.status = "finish";
          } else {
            childProps.status = "wait";
          }
        }
        childProps.active = stepNumber === current;
        return /* @__PURE__ */ cloneElement$1(child, childProps);
      }));
    }
  }]);
  return Steps4;
}(React__default.Component);
Steps3.Step = Step;
Steps3.defaultProps = {
  type: "default",
  prefixCls: "rc-steps",
  iconPrefix: "rc",
  direction: "horizontal",
  labelPlacement: "horizontal",
  initial: 0,
  current: 0,
  status: "process",
  size: "",
  progressDot: false
};
Steps3.Step;
var Switch$3 = React.forwardRef(function(_ref, ref) {
  var _classNames;
  var _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-switch" : _ref$prefixCls, className = _ref.className, checked = _ref.checked, defaultChecked = _ref.defaultChecked, disabled = _ref.disabled, loadingIcon = _ref.loadingIcon, checkedChildren = _ref.checkedChildren, unCheckedChildren = _ref.unCheckedChildren, onClick = _ref.onClick, onChange4 = _ref.onChange, onKeyDown2 = _ref.onKeyDown, restProps = _objectWithoutProperties$1(_ref, ["prefixCls", "className", "checked", "defaultChecked", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren", "onClick", "onChange", "onKeyDown"]);
  var _useMergedState = useMergedState(false, {
    value: checked,
    defaultValue: defaultChecked
  }), _useMergedState2 = _slicedToArray$3(_useMergedState, 2), innerChecked = _useMergedState2[0], setInnerChecked = _useMergedState2[1];
  function triggerChange(newChecked, event) {
    var mergedChecked = innerChecked;
    if (!disabled) {
      mergedChecked = newChecked;
      setInnerChecked(mergedChecked);
      onChange4 === null || onChange4 === void 0 ? void 0 : onChange4(mergedChecked, event);
    }
    return mergedChecked;
  }
  function onInternalKeyDown(e3) {
    if (e3.which === KeyCode.LEFT) {
      triggerChange(false, e3);
    } else if (e3.which === KeyCode.RIGHT) {
      triggerChange(true, e3);
    }
    onKeyDown2 === null || onKeyDown2 === void 0 ? void 0 : onKeyDown2(e3);
  }
  function onInternalClick(e3) {
    var ret = triggerChange(!innerChecked, e3);
    onClick === null || onClick === void 0 ? void 0 : onClick(ret, e3);
  }
  var switchClassName = cn(prefixCls, className, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-checked"), innerChecked), _defineProperty$4(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
  return React.createElement("button", Object.assign({}, restProps, {
    type: "button",
    role: "switch",
    "aria-checked": innerChecked,
    disabled,
    className: switchClassName,
    ref,
    onKeyDown: onInternalKeyDown,
    onClick: onInternalClick
  }), loadingIcon, React.createElement("span", {
    className: "".concat(prefixCls, "-inner")
  }, innerChecked ? checkedChildren : unCheckedChildren));
});
Switch$3.displayName = "Switch";
var __rest$9 = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var Switch$2 = /* @__PURE__ */ React.forwardRef(function(_a, ref) {
  var _classNames;
  var customizePrefixCls = _a.prefixCls, customizeSize = _a.size, loading = _a.loading, _a$className = _a.className, className = _a$className === void 0 ? "" : _a$className, disabled = _a.disabled, props = __rest$9(_a, ["prefixCls", "size", "loading", "className", "disabled"]);
  devWarning("checked" in props || !("value" in props), "Switch", "`value` is not a valid prop, do you mean `checked`?");
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var size = React.useContext(SizeContext$1);
  var prefixCls = getPrefixCls("switch", customizePrefixCls);
  var loadingIcon = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-handle")
  }, loading && /* @__PURE__ */ React.createElement(LoadingOutlined$1, {
    className: "".concat(prefixCls, "-loading-icon")
  }));
  var classes = cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-small"), (customizeSize || size) === "small"), _defineProperty$4(_classNames, "".concat(prefixCls, "-loading"), loading), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
  return /* @__PURE__ */ React.createElement(Wave, {
    insertExtraNode: true
  }, /* @__PURE__ */ React.createElement(Switch$3, _extends$2({}, props, {
    prefixCls,
    className: classes,
    disabled: disabled || loading,
    ref,
    loadingIcon
  })));
});
Switch$2.__ANT_SWITCH = true;
Switch$2.displayName = "Switch";
var INTERNAL_KEY_PREFIX = "RC_TABLE_KEY";
function toArray$1(arr) {
  if (arr === void 0 || arr === null) {
    return [];
  }
  return Array.isArray(arr) ? arr : [arr];
}
function getPathValue(record, path2) {
  if (!path2 && typeof path2 !== "number") {
    return record;
  }
  var pathList = toArray$1(path2);
  var current = record;
  for (var i2 = 0; i2 < pathList.length; i2 += 1) {
    if (!current) {
      return null;
    }
    var prop = pathList[i2];
    current = current[prop];
  }
  return current;
}
function getColumnsKey(columns) {
  var columnKeys = [];
  var keys2 = {};
  columns.forEach(function(column) {
    var _ref = column || {}, key2 = _ref.key, dataIndex = _ref.dataIndex;
    var mergedKey = key2 || toArray$1(dataIndex).join("-") || INTERNAL_KEY_PREFIX;
    while (keys2[mergedKey]) {
      mergedKey = "".concat(mergedKey, "_next");
    }
    keys2[mergedKey] = true;
    columnKeys.push(mergedKey);
  });
  return columnKeys;
}
function isRenderCell(data) {
  return data && _typeof$5(data) === "object" && !Array.isArray(data) && !/* @__PURE__ */ React.isValidElement(data);
}
function isRefComponent(component) {
  if (typeof component === "string") {
    return true;
  }
  return supportRef(component);
}
function Cell$1(_ref, ref) {
  var _classNames;
  var prefixCls = _ref.prefixCls, className = _ref.className, record = _ref.record, index2 = _ref.index, dataIndex = _ref.dataIndex, render4 = _ref.render, children = _ref.children, _ref$component = _ref.component, Component3 = _ref$component === void 0 ? "td" : _ref$component, colSpan = _ref.colSpan, rowSpan = _ref.rowSpan, fixLeft = _ref.fixLeft, fixRight = _ref.fixRight, firstFixLeft = _ref.firstFixLeft, lastFixLeft = _ref.lastFixLeft, firstFixRight = _ref.firstFixRight, lastFixRight = _ref.lastFixRight, appendNode = _ref.appendNode, _ref$additionalProps = _ref.additionalProps, additionalProps = _ref$additionalProps === void 0 ? {} : _ref$additionalProps, ellipsis = _ref.ellipsis, align = _ref.align, rowType = _ref.rowType, isSticky = _ref.isSticky;
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var cellProps;
  var childNode;
  if (children) {
    childNode = children;
  } else {
    var value = getPathValue(record, dataIndex);
    childNode = value;
    if (render4) {
      var renderData = render4(value, record, index2);
      if (isRenderCell(renderData)) {
        childNode = renderData.children;
        cellProps = renderData.props;
      } else {
        childNode = renderData;
      }
    }
  }
  if (_typeof$5(childNode) === "object" && !Array.isArray(childNode) && !/* @__PURE__ */ React.isValidElement(childNode)) {
    childNode = null;
  }
  if (ellipsis && (lastFixLeft || firstFixRight)) {
    childNode = /* @__PURE__ */ React.createElement("span", {
      className: "".concat(cellPrefixCls, "-content")
    }, childNode);
  }
  var _ref2 = cellProps || {}, cellColSpan = _ref2.colSpan, cellRowSpan = _ref2.rowSpan, cellStyle = _ref2.style, cellClassName = _ref2.className, restCellProps = _objectWithoutProperties$1(_ref2, ["colSpan", "rowSpan", "style", "className"]);
  var mergedColSpan = cellColSpan !== void 0 ? cellColSpan : colSpan;
  var mergedRowSpan = cellRowSpan !== void 0 ? cellRowSpan : rowSpan;
  if (mergedColSpan === 0 || mergedRowSpan === 0) {
    return null;
  }
  var fixedStyle = {};
  var isFixLeft = typeof fixLeft === "number";
  var isFixRight = typeof fixRight === "number";
  if (isFixLeft) {
    fixedStyle.position = "sticky";
    fixedStyle.left = fixLeft;
  }
  if (isFixRight) {
    fixedStyle.position = "sticky";
    fixedStyle.right = fixRight;
  }
  var alignStyle = {};
  if (align) {
    alignStyle.textAlign = align;
  }
  var title;
  var ellipsisConfig = ellipsis === true ? {
    showTitle: true
  } : ellipsis;
  if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === "header")) {
    if (typeof childNode === "string" || typeof childNode === "number") {
      title = childNode.toString();
    } else if (/* @__PURE__ */ React.isValidElement(childNode) && typeof childNode.props.children === "string") {
      title = childNode.props.children;
    }
  }
  var componentProps = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
    title
  }, restCellProps), additionalProps), {}, {
    colSpan: mergedColSpan && mergedColSpan !== 1 ? mergedColSpan : null,
    rowSpan: mergedRowSpan && mergedRowSpan !== 1 ? mergedRowSpan : null,
    className: cn(cellPrefixCls, className, (_classNames = {}, _defineProperty$4(_classNames, "".concat(cellPrefixCls, "-fix-left"), isFixLeft), _defineProperty$4(_classNames, "".concat(cellPrefixCls, "-fix-left-first"), firstFixLeft), _defineProperty$4(_classNames, "".concat(cellPrefixCls, "-fix-left-last"), lastFixLeft), _defineProperty$4(_classNames, "".concat(cellPrefixCls, "-fix-right"), isFixRight), _defineProperty$4(_classNames, "".concat(cellPrefixCls, "-fix-right-first"), firstFixRight), _defineProperty$4(_classNames, "".concat(cellPrefixCls, "-fix-right-last"), lastFixRight), _defineProperty$4(_classNames, "".concat(cellPrefixCls, "-ellipsis"), ellipsis), _defineProperty$4(_classNames, "".concat(cellPrefixCls, "-with-append"), appendNode), _defineProperty$4(_classNames, "".concat(cellPrefixCls, "-fix-sticky"), (isFixLeft || isFixRight) && isSticky), _classNames), additionalProps.className, cellClassName),
    style: _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, additionalProps.style), alignStyle), fixedStyle), cellStyle),
    ref: isRefComponent(Component3) ? ref : null
  });
  return /* @__PURE__ */ React.createElement(Component3, componentProps, appendNode, childNode);
}
var RefCell = /* @__PURE__ */ React.forwardRef(Cell$1);
RefCell.displayName = "Cell";
var MemoCell = /* @__PURE__ */ React.memo(RefCell, function(prev, next) {
  if (next.shouldCellUpdate) {
    return !next.shouldCellUpdate(next.record, prev.record);
  }
  return false;
});
var TableContext = /* @__PURE__ */ React.createContext(null);
function getCellFixedInfo(colStart, colEnd, columns, stickyOffsets, direction) {
  var startColumn = columns[colStart] || {};
  var endColumn = columns[colEnd] || {};
  var fixLeft;
  var fixRight;
  if (startColumn.fixed === "left") {
    fixLeft = stickyOffsets.left[colStart];
  } else if (endColumn.fixed === "right") {
    fixRight = stickyOffsets.right[colEnd];
  }
  var lastFixLeft = false;
  var firstFixRight = false;
  var lastFixRight = false;
  var firstFixLeft = false;
  var nextColumn = columns[colEnd + 1];
  var prevColumn = columns[colStart - 1];
  if (direction === "rtl") {
    if (fixLeft !== void 0) {
      var prevFixLeft = prevColumn && prevColumn.fixed === "left";
      firstFixLeft = !prevFixLeft;
    } else if (fixRight !== void 0) {
      var nextFixRight = nextColumn && nextColumn.fixed === "right";
      lastFixRight = !nextFixRight;
    }
  } else if (fixLeft !== void 0) {
    var nextFixLeft = nextColumn && nextColumn.fixed === "left";
    lastFixLeft = !nextFixLeft;
  } else if (fixRight !== void 0) {
    var prevFixRight = prevColumn && prevColumn.fixed === "right";
    firstFixRight = !prevFixRight;
  }
  return {
    fixLeft,
    fixRight,
    lastFixLeft,
    firstFixRight,
    lastFixRight,
    firstFixLeft,
    isSticky: stickyOffsets.isSticky
  };
}
function HeaderRow(_ref) {
  var cells = _ref.cells, stickyOffsets = _ref.stickyOffsets, flattenColumns = _ref.flattenColumns, RowComponent = _ref.rowComponent, CellComponent = _ref.cellComponent, onHeaderRow = _ref.onHeaderRow, index2 = _ref.index;
  var _React$useContext = React.useContext(TableContext), prefixCls = _React$useContext.prefixCls, direction = _React$useContext.direction;
  var rowProps;
  if (onHeaderRow) {
    rowProps = onHeaderRow(cells.map(function(cell) {
      return cell.column;
    }), index2);
  }
  var columnsKey = getColumnsKey(cells.map(function(cell) {
    return cell.column;
  }));
  return /* @__PURE__ */ React.createElement(RowComponent, rowProps, cells.map(function(cell, cellIndex) {
    var column = cell.column;
    var fixedInfo = getCellFixedInfo(cell.colStart, cell.colEnd, flattenColumns, stickyOffsets, direction);
    var additionalProps;
    if (column && column.onHeaderCell) {
      additionalProps = cell.column.onHeaderCell(column);
    }
    return /* @__PURE__ */ React.createElement(MemoCell, _extends$2({}, cell, {
      ellipsis: column.ellipsis,
      align: column.align,
      component: CellComponent,
      prefixCls,
      key: columnsKey[cellIndex]
    }, fixedInfo, {
      additionalProps,
      rowType: "header"
    }));
  }));
}
HeaderRow.displayName = "HeaderRow";
function parseHeaderRows(rootColumns) {
  var rows = [];
  function fillRowCells(columns, colIndex) {
    var rowIndex2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    rows[rowIndex2] = rows[rowIndex2] || [];
    var currentColIndex = colIndex;
    var colSpans = columns.filter(Boolean).map(function(column) {
      var cell = {
        key: column.key,
        className: column.className || "",
        children: column.title,
        column,
        colStart: currentColIndex
      };
      var colSpan = 1;
      var subColumns = column.children;
      if (subColumns && subColumns.length > 0) {
        colSpan = fillRowCells(subColumns, currentColIndex, rowIndex2 + 1).reduce(function(total, count) {
          return total + count;
        }, 0);
        cell.hasSubColumns = true;
      }
      if ("colSpan" in column) {
        colSpan = column.colSpan;
      }
      if ("rowSpan" in column) {
        cell.rowSpan = column.rowSpan;
      }
      cell.colSpan = colSpan;
      cell.colEnd = cell.colStart + colSpan - 1;
      rows[rowIndex2].push(cell);
      currentColIndex += colSpan;
      return colSpan;
    });
    return colSpans;
  }
  fillRowCells(rootColumns, 0);
  var rowCount = rows.length;
  var _loop = function _loop2(rowIndex2) {
    rows[rowIndex2].forEach(function(cell) {
      if (!("rowSpan" in cell) && !cell.hasSubColumns) {
        cell.rowSpan = rowCount - rowIndex2;
      }
    });
  };
  for (var rowIndex = 0; rowIndex < rowCount; rowIndex += 1) {
    _loop(rowIndex);
  }
  return rows;
}
function Header$1(_ref) {
  var stickyOffsets = _ref.stickyOffsets, columns = _ref.columns, flattenColumns = _ref.flattenColumns, onHeaderRow = _ref.onHeaderRow;
  var _React$useContext = React.useContext(TableContext), prefixCls = _React$useContext.prefixCls, getComponent = _React$useContext.getComponent;
  var rows = React.useMemo(function() {
    return parseHeaderRows(columns);
  }, [columns]);
  var WrapperComponent = getComponent(["header", "wrapper"], "thead");
  var trComponent = getComponent(["header", "row"], "tr");
  var thComponent = getComponent(["header", "cell"], "th");
  return /* @__PURE__ */ React.createElement(WrapperComponent, {
    className: "".concat(prefixCls, "-thead")
  }, rows.map(function(row, rowIndex) {
    var rowNode = /* @__PURE__ */ React.createElement(HeaderRow, {
      key: rowIndex,
      flattenColumns,
      cells: row,
      stickyOffsets,
      rowComponent: trComponent,
      cellComponent: thComponent,
      onHeaderRow,
      index: rowIndex
    });
    return rowNode;
  }));
}
var INTERNAL_COL_DEFINE = "RC_TABLE_INTERNAL_COL_DEFINE";
function ColGroup(_ref) {
  var colWidths = _ref.colWidths, columns = _ref.columns, columCount = _ref.columCount;
  var cols = [];
  var len = columCount || columns.length;
  var mustInsert = false;
  for (var i2 = len - 1; i2 >= 0; i2 -= 1) {
    var width = colWidths[i2];
    var column = columns && columns[i2];
    var additionalProps = column && column[INTERNAL_COL_DEFINE];
    if (width || additionalProps || mustInsert) {
      cols.unshift(/* @__PURE__ */ React.createElement("col", _extends$2({
        key: i2,
        style: {
          width,
          minWidth: width
        }
      }, additionalProps)));
      mustInsert = true;
    }
  }
  return /* @__PURE__ */ React.createElement("colgroup", null, cols);
}
function useColumnWidth(colWidths, columCount) {
  return useMemo$1(function() {
    var cloneColumns = [];
    for (var i2 = 0; i2 < columCount; i2 += 1) {
      var val = colWidths[i2];
      if (val !== void 0) {
        cloneColumns[i2] = val;
      } else {
        return null;
      }
    }
    return cloneColumns;
  }, [colWidths.join("_"), columCount]);
}
var FixedHeader = /* @__PURE__ */ React.forwardRef(function(_ref, ref) {
  var noData = _ref.noData, columns = _ref.columns, flattenColumns = _ref.flattenColumns, colWidths = _ref.colWidths, columCount = _ref.columCount, stickyOffsets = _ref.stickyOffsets, direction = _ref.direction, fixHeader = _ref.fixHeader, offsetHeader = _ref.offsetHeader, stickyClassName = _ref.stickyClassName, onScroll = _ref.onScroll, maxContentScroll = _ref.maxContentScroll, props = _objectWithoutProperties$1(_ref, ["noData", "columns", "flattenColumns", "colWidths", "columCount", "stickyOffsets", "direction", "fixHeader", "offsetHeader", "stickyClassName", "onScroll", "maxContentScroll"]);
  var _React$useContext = React.useContext(TableContext), prefixCls = _React$useContext.prefixCls, scrollbarSize = _React$useContext.scrollbarSize, isSticky = _React$useContext.isSticky;
  var combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize;
  var scrollRef = React.useRef(null);
  var setScrollRef = React.useCallback(function(element) {
    fillRef(ref, element);
    fillRef(scrollRef, element);
  }, []);
  React.useEffect(function() {
    var _scrollRef$current;
    function onWheel(e3) {
      var currentTarget = e3.currentTarget, deltaX = e3.deltaX;
      if (deltaX) {
        onScroll({
          currentTarget,
          scrollLeft: currentTarget.scrollLeft + deltaX
        });
        e3.preventDefault();
      }
    }
    (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.addEventListener("wheel", onWheel);
    return function() {
      var _scrollRef$current2;
      (_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 ? void 0 : _scrollRef$current2.removeEventListener("wheel", onWheel);
    };
  }, []);
  var allFlattenColumnsWithWidth = React.useMemo(function() {
    return flattenColumns.every(function(column) {
      return column.width >= 0;
    });
  }, [flattenColumns]);
  var lastColumn = flattenColumns[flattenColumns.length - 1];
  var ScrollBarColumn = {
    fixed: lastColumn ? lastColumn.fixed : null,
    onHeaderCell: function onHeaderCell() {
      return {
        className: "".concat(prefixCls, "-cell-scrollbar")
      };
    }
  };
  var columnsWithScrollbar = useMemo$1(function() {
    return combinationScrollBarSize ? [].concat(_toConsumableArray(columns), [ScrollBarColumn]) : columns;
  }, [combinationScrollBarSize, columns]);
  var flattenColumnsWithScrollbar = useMemo$1(function() {
    return combinationScrollBarSize ? [].concat(_toConsumableArray(flattenColumns), [ScrollBarColumn]) : flattenColumns;
  }, [combinationScrollBarSize, flattenColumns]);
  var headerStickyOffsets = useMemo$1(function() {
    var right = stickyOffsets.right, left = stickyOffsets.left;
    return _objectSpread2$1(_objectSpread2$1({}, stickyOffsets), {}, {
      left: direction === "rtl" ? [].concat(_toConsumableArray(left.map(function(width) {
        return width + combinationScrollBarSize;
      })), [0]) : left,
      right: direction === "rtl" ? right : [].concat(_toConsumableArray(right.map(function(width) {
        return width + combinationScrollBarSize;
      })), [0]),
      isSticky
    });
  }, [combinationScrollBarSize, stickyOffsets, isSticky]);
  var mergedColumnWidth = useColumnWidth(colWidths, columCount);
  return /* @__PURE__ */ React.createElement("div", {
    style: _objectSpread2$1({
      overflow: "hidden"
    }, isSticky ? {
      top: offsetHeader
    } : {}),
    ref: setScrollRef,
    className: cn("".concat(prefixCls, "-header"), _defineProperty$4({}, stickyClassName, !!stickyClassName))
  }, /* @__PURE__ */ React.createElement("table", {
    style: {
      tableLayout: "fixed",
      visibility: noData || mergedColumnWidth ? null : "hidden"
    }
  }, (!noData || !maxContentScroll || allFlattenColumnsWithWidth) && /* @__PURE__ */ React.createElement(ColGroup, {
    colWidths: mergedColumnWidth ? [].concat(_toConsumableArray(mergedColumnWidth), [combinationScrollBarSize]) : [],
    columCount: columCount + 1,
    columns: flattenColumnsWithScrollbar
  }), /* @__PURE__ */ React.createElement(Header$1, _extends$2({}, props, {
    stickyOffsets: headerStickyOffsets,
    columns: columnsWithScrollbar,
    flattenColumns: flattenColumnsWithScrollbar
  }))));
});
FixedHeader.displayName = "FixedHeader";
var BodyContext = /* @__PURE__ */ React.createContext(null);
function ExpandedRow(_ref) {
  var prefixCls = _ref.prefixCls, children = _ref.children, Component3 = _ref.component, cellComponent = _ref.cellComponent, fixHeader = _ref.fixHeader, fixColumn = _ref.fixColumn, horizonScroll = _ref.horizonScroll, className = _ref.className, expanded = _ref.expanded, componentWidth = _ref.componentWidth, colSpan = _ref.colSpan;
  var _React$useContext = React.useContext(TableContext), scrollbarSize = _React$useContext.scrollbarSize;
  return React.useMemo(function() {
    var contentNode = children;
    if (fixColumn) {
      contentNode = /* @__PURE__ */ React.createElement("div", {
        style: {
          width: componentWidth - (fixHeader ? scrollbarSize : 0),
          position: "sticky",
          left: 0,
          overflow: "hidden"
        },
        className: "".concat(prefixCls, "-expanded-row-fixed")
      }, contentNode);
    }
    return /* @__PURE__ */ React.createElement(Component3, {
      className,
      style: {
        display: expanded ? null : "none"
      }
    }, /* @__PURE__ */ React.createElement(MemoCell, {
      component: cellComponent,
      prefixCls,
      colSpan
    }, contentNode));
  }, [children, Component3, fixHeader, horizonScroll, className, expanded, componentWidth, colSpan, scrollbarSize]);
}
function BodyRow(props) {
  var className = props.className, style2 = props.style, record = props.record, index2 = props.index, rowKey = props.rowKey, getRowKey = props.getRowKey, rowExpandable = props.rowExpandable, expandedKeys = props.expandedKeys, onRow = props.onRow, _props$indent = props.indent, indent = _props$indent === void 0 ? 0 : _props$indent, RowComponent = props.rowComponent, cellComponent = props.cellComponent, childrenColumnName = props.childrenColumnName;
  var _React$useContext = React.useContext(TableContext), prefixCls = _React$useContext.prefixCls, fixedInfoList = _React$useContext.fixedInfoList;
  var _React$useContext2 = React.useContext(BodyContext), fixHeader = _React$useContext2.fixHeader, fixColumn = _React$useContext2.fixColumn, horizonScroll = _React$useContext2.horizonScroll, componentWidth = _React$useContext2.componentWidth, flattenColumns = _React$useContext2.flattenColumns, expandableType = _React$useContext2.expandableType, expandRowByClick = _React$useContext2.expandRowByClick, onTriggerExpand = _React$useContext2.onTriggerExpand, rowClassName = _React$useContext2.rowClassName, expandedRowClassName = _React$useContext2.expandedRowClassName, indentSize = _React$useContext2.indentSize, expandIcon = _React$useContext2.expandIcon, expandedRowRender = _React$useContext2.expandedRowRender, expandIconColumnIndex = _React$useContext2.expandIconColumnIndex;
  var _React$useState = React.useState(false), _React$useState2 = _slicedToArray$3(_React$useState, 2), expandRended = _React$useState2[0], setExpandRended = _React$useState2[1];
  var expanded = expandedKeys && expandedKeys.has(props.recordKey);
  React.useEffect(function() {
    if (expanded) {
      setExpandRended(true);
    }
  }, [expanded]);
  var rowSupportExpand = expandableType === "row" && (!rowExpandable || rowExpandable(record));
  var nestExpandable = expandableType === "nest";
  var hasNestChildren = childrenColumnName && record && record[childrenColumnName];
  var mergedExpandable = rowSupportExpand || nestExpandable;
  var additionalProps;
  if (onRow) {
    additionalProps = onRow(record, index2);
  }
  var onClick = function onClick2(event) {
    if (expandRowByClick && mergedExpandable) {
      onTriggerExpand(record, event);
    }
    if (additionalProps && additionalProps.onClick) {
      var _additionalProps;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      (_additionalProps = additionalProps).onClick.apply(_additionalProps, [event].concat(args));
    }
  };
  var computeRowClassName;
  if (typeof rowClassName === "string") {
    computeRowClassName = rowClassName;
  } else if (typeof rowClassName === "function") {
    computeRowClassName = rowClassName(record, index2, indent);
  }
  var columnsKey = getColumnsKey(flattenColumns);
  var baseRowNode = /* @__PURE__ */ React.createElement(RowComponent, _extends$2({}, additionalProps, {
    "data-row-key": rowKey,
    className: cn(className, "".concat(prefixCls, "-row"), "".concat(prefixCls, "-row-level-").concat(indent), computeRowClassName, additionalProps && additionalProps.className),
    style: _objectSpread2$1(_objectSpread2$1({}, style2), additionalProps ? additionalProps.style : null),
    onClick
  }), flattenColumns.map(function(column, colIndex) {
    var render4 = column.render, dataIndex = column.dataIndex, columnClassName = column.className;
    var key2 = columnsKey[colIndex];
    var fixedInfo = fixedInfoList[colIndex];
    var appendCellNode;
    if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) {
      appendCellNode = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", {
        style: {
          paddingLeft: "".concat(indentSize * indent, "px")
        },
        className: "".concat(prefixCls, "-row-indent indent-level-").concat(indent)
      }), expandIcon({
        prefixCls,
        expanded,
        expandable: hasNestChildren,
        record,
        onExpand: onTriggerExpand
      }));
    }
    var additionalCellProps;
    if (column.onCell) {
      additionalCellProps = column.onCell(record, index2);
    }
    return /* @__PURE__ */ React.createElement(MemoCell, _extends$2({
      className: columnClassName,
      ellipsis: column.ellipsis,
      align: column.align,
      component: cellComponent,
      prefixCls,
      key: key2,
      record,
      index: index2,
      dataIndex,
      render: render4,
      shouldCellUpdate: column.shouldCellUpdate
    }, fixedInfo, {
      appendNode: appendCellNode,
      additionalProps: additionalCellProps
    }));
  }));
  var expandRowNode;
  if (rowSupportExpand && (expandRended || expanded)) {
    var expandContent = expandedRowRender(record, index2, indent + 1, expanded);
    var computedExpandedRowClassName = expandedRowClassName && expandedRowClassName(record, index2, indent);
    expandRowNode = /* @__PURE__ */ React.createElement(ExpandedRow, {
      expanded,
      className: cn("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), computedExpandedRowClassName),
      prefixCls,
      fixHeader,
      fixColumn,
      horizonScroll,
      component: RowComponent,
      componentWidth,
      cellComponent,
      colSpan: flattenColumns.length
    }, expandContent);
  }
  var nestRowNode;
  if (hasNestChildren && expanded) {
    nestRowNode = (record[childrenColumnName] || []).map(function(subRecord, subIndex) {
      var subKey = getRowKey(subRecord, subIndex);
      return /* @__PURE__ */ React.createElement(BodyRow, _extends$2({}, props, {
        key: subKey,
        rowKey: subKey,
        record: subRecord,
        recordKey: subKey,
        index: subIndex,
        indent: indent + 1
      }));
    });
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, baseRowNode, expandRowNode, nestRowNode);
}
BodyRow.displayName = "BodyRow";
var ResizeContext = /* @__PURE__ */ React.createContext(null);
function MeasureCell(_ref) {
  var columnKey = _ref.columnKey, onColumnResize = _ref.onColumnResize;
  var cellRef = React.useRef();
  React.useEffect(function() {
    if (cellRef.current) {
      onColumnResize(columnKey, cellRef.current.offsetWidth);
    }
  }, []);
  return /* @__PURE__ */ React.createElement(ResizeObserver, {
    onResize: function onResize2(_ref2) {
      var offsetWidth = _ref2.offsetWidth;
      onColumnResize(columnKey, offsetWidth);
    }
  }, /* @__PURE__ */ React.createElement("td", {
    ref: cellRef,
    style: {
      padding: 0,
      border: 0,
      height: 0
    }
  }, /* @__PURE__ */ React.createElement("div", {
    style: {
      height: 0,
      overflow: "hidden"
    }
  }, "\xA0")));
}
function Body(_ref) {
  var data = _ref.data, getRowKey = _ref.getRowKey, measureColumnWidth = _ref.measureColumnWidth, expandedKeys = _ref.expandedKeys, onRow = _ref.onRow, rowExpandable = _ref.rowExpandable, emptyNode = _ref.emptyNode, childrenColumnName = _ref.childrenColumnName;
  var _React$useContext = React.useContext(ResizeContext), onColumnResize = _React$useContext.onColumnResize;
  var _React$useContext2 = React.useContext(TableContext), prefixCls = _React$useContext2.prefixCls, getComponent = _React$useContext2.getComponent;
  var _React$useContext3 = React.useContext(BodyContext), fixHeader = _React$useContext3.fixHeader, horizonScroll = _React$useContext3.horizonScroll, flattenColumns = _React$useContext3.flattenColumns, componentWidth = _React$useContext3.componentWidth;
  return React.useMemo(function() {
    var WrapperComponent = getComponent(["body", "wrapper"], "tbody");
    var trComponent = getComponent(["body", "row"], "tr");
    var tdComponent = getComponent(["body", "cell"], "td");
    var rows;
    if (data.length) {
      rows = data.map(function(record, index2) {
        var key2 = getRowKey(record, index2);
        return /* @__PURE__ */ React.createElement(BodyRow, {
          key: key2,
          rowKey: key2,
          record,
          recordKey: key2,
          index: index2,
          rowComponent: trComponent,
          cellComponent: tdComponent,
          expandedKeys,
          onRow,
          getRowKey,
          rowExpandable,
          childrenColumnName
        });
      });
    } else {
      rows = /* @__PURE__ */ React.createElement(ExpandedRow, {
        expanded: true,
        className: "".concat(prefixCls, "-placeholder"),
        prefixCls,
        fixHeader,
        fixColumn: horizonScroll,
        horizonScroll,
        component: trComponent,
        componentWidth,
        cellComponent: tdComponent,
        colSpan: flattenColumns.length
      }, emptyNode);
    }
    var columnsKey = getColumnsKey(flattenColumns);
    return /* @__PURE__ */ React.createElement(WrapperComponent, {
      className: "".concat(prefixCls, "-tbody")
    }, measureColumnWidth && /* @__PURE__ */ React.createElement("tr", {
      "aria-hidden": "true",
      className: "".concat(prefixCls, "-measure-row"),
      style: {
        height: 0,
        fontSize: 0
      }
    }, columnsKey.map(function(columnKey) {
      return /* @__PURE__ */ React.createElement(MeasureCell, {
        key: columnKey,
        columnKey,
        onColumnResize
      });
    })), rows);
  }, [data, prefixCls, onRow, measureColumnWidth, expandedKeys, getRowKey, getComponent, componentWidth, emptyNode, flattenColumns]);
}
var MemoBody = /* @__PURE__ */ React.memo(Body);
MemoBody.displayName = "Body";
var TreeContext = /* @__PURE__ */ React.createContext(null);
var Indent = function Indent2(_ref) {
  var prefixCls = _ref.prefixCls, level = _ref.level, isStart = _ref.isStart, isEnd = _ref.isEnd;
  var baseClassName = "".concat(prefixCls, "-indent-unit");
  var list = [];
  for (var i2 = 0; i2 < level; i2 += 1) {
    var _classNames;
    list.push(/* @__PURE__ */ React.createElement("span", {
      key: i2,
      className: cn(baseClassName, (_classNames = {}, _defineProperty$4(_classNames, "".concat(baseClassName, "-start"), isStart[i2]), _defineProperty$4(_classNames, "".concat(baseClassName, "-end"), isEnd[i2]), _classNames))
    }));
  }
  return /* @__PURE__ */ React.createElement("span", {
    "aria-hidden": "true",
    className: "".concat(prefixCls, "-indent")
  }, list);
};
var ICON_OPEN = "open";
var ICON_CLOSE = "close";
var defaultTitle = "---";
var InternalTreeNode = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(InternalTreeNode2, _React$Component);
  var _super = _createSuper$1(InternalTreeNode2);
  function InternalTreeNode2() {
    var _this2;
    _classCallCheck$2(this, InternalTreeNode2);
    _this2 = _super.apply(this, arguments);
    _this2.state = {
      dragNodeHighlight: false
    };
    _this2.onSelectorClick = function(e3) {
      var onNodeClick = _this2.props.context.onNodeClick;
      onNodeClick(e3, convertNodePropsToEventData(_this2.props));
      if (_this2.isSelectable()) {
        _this2.onSelect(e3);
      } else {
        _this2.onCheck(e3);
      }
    };
    _this2.onSelectorDoubleClick = function(e3) {
      var onNodeDoubleClick = _this2.props.context.onNodeDoubleClick;
      onNodeDoubleClick(e3, convertNodePropsToEventData(_this2.props));
    };
    _this2.onSelect = function(e3) {
      if (_this2.isDisabled())
        return;
      var onNodeSelect = _this2.props.context.onNodeSelect;
      e3.preventDefault();
      onNodeSelect(e3, convertNodePropsToEventData(_this2.props));
    };
    _this2.onCheck = function(e3) {
      if (_this2.isDisabled())
        return;
      var _this$props = _this2.props, disableCheckbox = _this$props.disableCheckbox, checked = _this$props.checked;
      var onNodeCheck = _this2.props.context.onNodeCheck;
      if (!_this2.isCheckable() || disableCheckbox)
        return;
      e3.preventDefault();
      var targetChecked = !checked;
      onNodeCheck(e3, convertNodePropsToEventData(_this2.props), targetChecked);
    };
    _this2.onMouseEnter = function(e3) {
      var onNodeMouseEnter = _this2.props.context.onNodeMouseEnter;
      onNodeMouseEnter(e3, convertNodePropsToEventData(_this2.props));
    };
    _this2.onMouseLeave = function(e3) {
      var onNodeMouseLeave = _this2.props.context.onNodeMouseLeave;
      onNodeMouseLeave(e3, convertNodePropsToEventData(_this2.props));
    };
    _this2.onContextMenu = function(e3) {
      var onNodeContextMenu = _this2.props.context.onNodeContextMenu;
      onNodeContextMenu(e3, convertNodePropsToEventData(_this2.props));
    };
    _this2.onDragStart = function(e3) {
      var onNodeDragStart = _this2.props.context.onNodeDragStart;
      e3.stopPropagation();
      _this2.setState({
        dragNodeHighlight: true
      });
      onNodeDragStart(e3, _assertThisInitialized$1(_this2));
      try {
        e3.dataTransfer.setData("text/plain", "");
      } catch (error) {
      }
    };
    _this2.onDragEnter = function(e3) {
      var onNodeDragEnter = _this2.props.context.onNodeDragEnter;
      e3.preventDefault();
      e3.stopPropagation();
      onNodeDragEnter(e3, _assertThisInitialized$1(_this2));
    };
    _this2.onDragOver = function(e3) {
      var onNodeDragOver = _this2.props.context.onNodeDragOver;
      e3.preventDefault();
      e3.stopPropagation();
      onNodeDragOver(e3, _assertThisInitialized$1(_this2));
    };
    _this2.onDragLeave = function(e3) {
      var onNodeDragLeave = _this2.props.context.onNodeDragLeave;
      e3.stopPropagation();
      onNodeDragLeave(e3, _assertThisInitialized$1(_this2));
    };
    _this2.onDragEnd = function(e3) {
      var onNodeDragEnd = _this2.props.context.onNodeDragEnd;
      e3.stopPropagation();
      _this2.setState({
        dragNodeHighlight: false
      });
      onNodeDragEnd(e3, _assertThisInitialized$1(_this2));
    };
    _this2.onDrop = function(e3) {
      var onNodeDrop = _this2.props.context.onNodeDrop;
      e3.preventDefault();
      e3.stopPropagation();
      _this2.setState({
        dragNodeHighlight: false
      });
      onNodeDrop(e3, _assertThisInitialized$1(_this2));
    };
    _this2.onExpand = function(e3) {
      var _this$props2 = _this2.props, loading = _this$props2.loading, onNodeExpand = _this$props2.context.onNodeExpand;
      if (loading)
        return;
      onNodeExpand(e3, convertNodePropsToEventData(_this2.props));
    };
    _this2.setSelectHandle = function(node) {
      _this2.selectHandle = node;
    };
    _this2.getNodeState = function() {
      var expanded = _this2.props.expanded;
      if (_this2.isLeaf()) {
        return null;
      }
      return expanded ? ICON_OPEN : ICON_CLOSE;
    };
    _this2.hasChildren = function() {
      var eventKey = _this2.props.eventKey;
      var keyEntities = _this2.props.context.keyEntities;
      var _ref = keyEntities[eventKey] || {}, children = _ref.children;
      return !!(children || []).length;
    };
    _this2.isLeaf = function() {
      var _this$props3 = _this2.props, isLeaf = _this$props3.isLeaf, loaded = _this$props3.loaded;
      var loadData = _this2.props.context.loadData;
      var hasChildren = _this2.hasChildren();
      if (isLeaf === false) {
        return false;
      }
      return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
    };
    _this2.isDisabled = function() {
      var disabled = _this2.props.disabled;
      var treeDisabled = _this2.props.context.disabled;
      return !!(treeDisabled || disabled);
    };
    _this2.isCheckable = function() {
      var checkable = _this2.props.checkable;
      var treeCheckable = _this2.props.context.checkable;
      if (!treeCheckable || checkable === false)
        return false;
      return treeCheckable;
    };
    _this2.syncLoadData = function(props) {
      var expanded = props.expanded, loading = props.loading, loaded = props.loaded;
      var _this$props$context = _this2.props.context, loadData = _this$props$context.loadData, onNodeLoad = _this$props$context.onNodeLoad;
      if (loading)
        return;
      if (loadData && expanded && !_this2.isLeaf()) {
        if (!_this2.hasChildren() && !loaded) {
          onNodeLoad(convertNodePropsToEventData(_this2.props));
        }
      }
    };
    _this2.renderSwitcherIconDom = function(isLeaf) {
      var switcherIconFromProps = _this2.props.switcherIcon;
      var switcherIconFromCtx = _this2.props.context.switcherIcon;
      var switcherIcon = switcherIconFromProps || switcherIconFromCtx;
      if (typeof switcherIcon === "function") {
        return switcherIcon(_objectSpread2$1(_objectSpread2$1({}, _this2.props), {}, {
          isLeaf
        }));
      }
      return switcherIcon;
    };
    _this2.renderSwitcher = function() {
      var expanded = _this2.props.expanded;
      var prefixCls = _this2.props.context.prefixCls;
      if (_this2.isLeaf()) {
        var _switcherIconDom = _this2.renderSwitcherIconDom(true);
        return _switcherIconDom !== false ? /* @__PURE__ */ React.createElement("span", {
          className: cn("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher-noop"))
        }, _switcherIconDom) : null;
      }
      var switcherCls = cn("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher_").concat(expanded ? ICON_OPEN : ICON_CLOSE));
      var switcherIconDom = _this2.renderSwitcherIconDom(false);
      return switcherIconDom !== false ? /* @__PURE__ */ React.createElement("span", {
        onClick: _this2.onExpand,
        className: switcherCls
      }, switcherIconDom) : null;
    };
    _this2.renderCheckbox = function() {
      var _this$props4 = _this2.props, checked = _this$props4.checked, halfChecked = _this$props4.halfChecked, disableCheckbox = _this$props4.disableCheckbox;
      var prefixCls = _this2.props.context.prefixCls;
      var disabled = _this2.isDisabled();
      var checkable = _this2.isCheckable();
      if (!checkable)
        return null;
      var $custom = typeof checkable !== "boolean" ? checkable : null;
      return /* @__PURE__ */ React.createElement("span", {
        className: cn("".concat(prefixCls, "-checkbox"), checked && "".concat(prefixCls, "-checkbox-checked"), !checked && halfChecked && "".concat(prefixCls, "-checkbox-indeterminate"), (disabled || disableCheckbox) && "".concat(prefixCls, "-checkbox-disabled")),
        onClick: _this2.onCheck
      }, $custom);
    };
    _this2.renderIcon = function() {
      var loading = _this2.props.loading;
      var prefixCls = _this2.props.context.prefixCls;
      return /* @__PURE__ */ React.createElement("span", {
        className: cn("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__").concat(_this2.getNodeState() || "docu"), loading && "".concat(prefixCls, "-icon_loading"))
      });
    };
    _this2.renderSelector = function() {
      var dragNodeHighlight = _this2.state.dragNodeHighlight;
      var _this$props5 = _this2.props, title = _this$props5.title, selected = _this$props5.selected, icon = _this$props5.icon, loading = _this$props5.loading, data = _this$props5.data;
      var _this$props$context2 = _this2.props.context, prefixCls = _this$props$context2.prefixCls, showIcon = _this$props$context2.showIcon, treeIcon = _this$props$context2.icon, draggable = _this$props$context2.draggable, loadData = _this$props$context2.loadData, titleRender = _this$props$context2.titleRender;
      var disabled = _this2.isDisabled();
      var mergedDraggable = typeof draggable === "function" ? draggable(data) : draggable;
      var wrapClass = "".concat(prefixCls, "-node-content-wrapper");
      var $icon;
      if (showIcon) {
        var currentIcon = icon || treeIcon;
        $icon = currentIcon ? /* @__PURE__ */ React.createElement("span", {
          className: cn("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__customize"))
        }, typeof currentIcon === "function" ? currentIcon(_this2.props) : currentIcon) : _this2.renderIcon();
      } else if (loadData && loading) {
        $icon = _this2.renderIcon();
      }
      var titleNode;
      if (typeof title === "function") {
        titleNode = title(data);
      } else if (titleRender) {
        titleNode = titleRender(data);
      } else {
        titleNode = title;
      }
      var $title = /* @__PURE__ */ React.createElement("span", {
        className: "".concat(prefixCls, "-title")
      }, titleNode);
      return /* @__PURE__ */ React.createElement("span", {
        ref: _this2.setSelectHandle,
        title: typeof title === "string" ? title : "",
        className: cn("".concat(wrapClass), "".concat(wrapClass, "-").concat(_this2.getNodeState() || "normal"), !disabled && (selected || dragNodeHighlight) && "".concat(prefixCls, "-node-selected"), !disabled && mergedDraggable && "draggable"),
        draggable: !disabled && mergedDraggable || void 0,
        "aria-grabbed": !disabled && mergedDraggable || void 0,
        onMouseEnter: _this2.onMouseEnter,
        onMouseLeave: _this2.onMouseLeave,
        onContextMenu: _this2.onContextMenu,
        onClick: _this2.onSelectorClick,
        onDoubleClick: _this2.onSelectorDoubleClick,
        onDragStart: mergedDraggable ? _this2.onDragStart : void 0
      }, $icon, $title, _this2.renderDropIndicator());
    };
    _this2.renderDropIndicator = function() {
      var _this$props6 = _this2.props, disabled = _this$props6.disabled, eventKey = _this$props6.eventKey;
      var _this$props$context3 = _this2.props.context, draggable = _this$props$context3.draggable, dropLevelOffset = _this$props$context3.dropLevelOffset, dropPosition = _this$props$context3.dropPosition, prefixCls = _this$props$context3.prefixCls, indent = _this$props$context3.indent, dropIndicatorRender2 = _this$props$context3.dropIndicatorRender, dragOverNodeKey = _this$props$context3.dragOverNodeKey, direction = _this$props$context3.direction;
      var mergedDraggable = draggable !== false;
      var showIndicator = !disabled && mergedDraggable && dragOverNodeKey === eventKey;
      return showIndicator ? dropIndicatorRender2({
        dropPosition,
        dropLevelOffset,
        indent,
        prefixCls,
        direction
      }) : null;
    };
    return _this2;
  }
  _createClass$2(InternalTreeNode2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncLoadData(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.syncLoadData(this.props);
    }
  }, {
    key: "isSelectable",
    value: function isSelectable() {
      var selectable = this.props.selectable;
      var treeSelectable = this.props.context.selectable;
      if (typeof selectable === "boolean") {
        return selectable;
      }
      return treeSelectable;
    }
  }, {
    key: "render",
    value: function render4() {
      var _classNames;
      var _this$props7 = this.props, eventKey = _this$props7.eventKey, className = _this$props7.className, style2 = _this$props7.style, dragOver = _this$props7.dragOver, dragOverGapTop = _this$props7.dragOverGapTop, dragOverGapBottom = _this$props7.dragOverGapBottom, isLeaf = _this$props7.isLeaf, isStart = _this$props7.isStart, isEnd = _this$props7.isEnd, expanded = _this$props7.expanded, selected = _this$props7.selected, checked = _this$props7.checked, halfChecked = _this$props7.halfChecked, loading = _this$props7.loading, domRef = _this$props7.domRef, active = _this$props7.active, data = _this$props7.data, onMouseMove = _this$props7.onMouseMove, otherProps = _objectWithoutProperties$1(_this$props7, ["eventKey", "className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "isStart", "isEnd", "expanded", "selected", "checked", "halfChecked", "loading", "domRef", "active", "data", "onMouseMove"]);
      var _this$props$context4 = this.props.context, prefixCls = _this$props$context4.prefixCls, filterTreeNode = _this$props$context4.filterTreeNode, draggable = _this$props$context4.draggable, keyEntities = _this$props$context4.keyEntities, dropContainerKey = _this$props$context4.dropContainerKey, dropTargetKey = _this$props$context4.dropTargetKey;
      var disabled = this.isDisabled();
      var dataOrAriaAttributeProps = getDataAndAria(otherProps);
      var _ref2 = keyEntities[eventKey] || {}, level = _ref2.level;
      var isEndNode = isEnd[isEnd.length - 1];
      var mergedDraggable = typeof draggable === "function" ? draggable(data) : draggable;
      return /* @__PURE__ */ React.createElement("div", _extends$2({
        ref: domRef,
        className: cn(className, "".concat(prefixCls, "-treenode"), (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-treenode-disabled"), disabled), _defineProperty$4(_classNames, "".concat(prefixCls, "-treenode-switcher-").concat(expanded ? "open" : "close"), !isLeaf), _defineProperty$4(_classNames, "".concat(prefixCls, "-treenode-checkbox-checked"), checked), _defineProperty$4(_classNames, "".concat(prefixCls, "-treenode-checkbox-indeterminate"), halfChecked), _defineProperty$4(_classNames, "".concat(prefixCls, "-treenode-selected"), selected), _defineProperty$4(_classNames, "".concat(prefixCls, "-treenode-loading"), loading), _defineProperty$4(_classNames, "".concat(prefixCls, "-treenode-active"), active), _defineProperty$4(_classNames, "".concat(prefixCls, "-treenode-leaf-last"), isEndNode), _defineProperty$4(_classNames, "drop-target", dropTargetKey === eventKey), _defineProperty$4(_classNames, "drop-container", dropContainerKey === eventKey), _defineProperty$4(_classNames, "drag-over", !disabled && dragOver), _defineProperty$4(_classNames, "drag-over-gap-top", !disabled && dragOverGapTop), _defineProperty$4(_classNames, "drag-over-gap-bottom", !disabled && dragOverGapBottom), _defineProperty$4(_classNames, "filter-node", filterTreeNode && filterTreeNode(convertNodePropsToEventData(this.props))), _classNames)),
        style: style2,
        onDragEnter: mergedDraggable ? this.onDragEnter : void 0,
        onDragOver: mergedDraggable ? this.onDragOver : void 0,
        onDragLeave: mergedDraggable ? this.onDragLeave : void 0,
        onDrop: mergedDraggable ? this.onDrop : void 0,
        onDragEnd: mergedDraggable ? this.onDragEnd : void 0,
        onMouseMove
      }, dataOrAriaAttributeProps), /* @__PURE__ */ React.createElement(Indent, {
        prefixCls,
        level,
        isStart,
        isEnd
      }), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector());
    }
  }]);
  return InternalTreeNode2;
}(React.Component);
var ContextTreeNode = function ContextTreeNode2(props) {
  return /* @__PURE__ */ React.createElement(TreeContext.Consumer, null, function(context2) {
    return /* @__PURE__ */ React.createElement(InternalTreeNode, _extends$2({}, props, {
      context: context2
    }));
  });
};
ContextTreeNode.displayName = "TreeNode";
ContextTreeNode.defaultProps = {
  title: defaultTitle
};
ContextTreeNode.isTreeNode = 1;
function arrDel(list, value) {
  var clone2 = list.slice();
  var index2 = clone2.indexOf(value);
  if (index2 >= 0) {
    clone2.splice(index2, 1);
  }
  return clone2;
}
function arrAdd(list, value) {
  var clone2 = list.slice();
  if (clone2.indexOf(value) === -1) {
    clone2.push(value);
  }
  return clone2;
}
function posToArr(pos) {
  return pos.split("-");
}
function getPosition(level, index2) {
  return "".concat(level, "-").concat(index2);
}
function isTreeNode(node) {
  return node && node.type && node.type.isTreeNode;
}
function getDragChildrenKeys(dragNodeKey, keyEntities) {
  var dragChildrenKeys = [];
  var entity = keyEntities[dragNodeKey];
  function dig() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    list.forEach(function(_ref) {
      var key2 = _ref.key, children = _ref.children;
      dragChildrenKeys.push(key2);
      dig(children);
    });
  }
  dig(entity.children);
  return dragChildrenKeys;
}
function isLastChild(treeNodeEntity) {
  if (treeNodeEntity.parent) {
    var posArr = posToArr(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
  }
  return false;
}
function isFirstChild(treeNodeEntity) {
  var posArr = posToArr(treeNodeEntity.pos);
  return Number(posArr[posArr.length - 1]) === 0;
}
function calcDropPosition(event, dragNode, targetNode, indent, startMousePosition, allowDrop2, flattenedNodes, keyEntities, expandKeys, direction) {
  var _abstractDropNodeEnti;
  var clientX = event.clientX, clientY = event.clientY;
  var _event$target$getBoun = event.target.getBoundingClientRect(), top = _event$target$getBoun.top, height = _event$target$getBoun.height;
  var horizontalMouseOffset = (direction === "rtl" ? -1 : 1) * (((startMousePosition === null || startMousePosition === void 0 ? void 0 : startMousePosition.x) || 0) - clientX);
  var rawDropLevelOffset = (horizontalMouseOffset - 12) / indent;
  var abstractDropNodeEntity = keyEntities[targetNode.props.eventKey];
  if (clientY < top + height / 2) {
    var nodeIndex = flattenedNodes.findIndex(function(flattenedNode) {
      return flattenedNode.data.key === abstractDropNodeEntity.key;
    });
    var prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
    var prevNodeKey = flattenedNodes[prevNodeIndex].data.key;
    abstractDropNodeEntity = keyEntities[prevNodeKey];
  }
  var initialAbstractDropNodeKey = abstractDropNodeEntity.key;
  var abstractDragOverEntity = abstractDropNodeEntity;
  var dragOverNodeKey = abstractDropNodeEntity.key;
  var dropPosition = 0;
  var dropLevelOffset = 0;
  if (!expandKeys.includes(initialAbstractDropNodeKey)) {
    for (var i2 = 0; i2 < rawDropLevelOffset; i2 += 1) {
      if (isLastChild(abstractDropNodeEntity)) {
        abstractDropNodeEntity = abstractDropNodeEntity.parent;
        dropLevelOffset += 1;
      } else {
        break;
      }
    }
  }
  var abstractDropDataNode = abstractDropNodeEntity.node;
  var dropAllowed = true;
  if (isFirstChild(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop2({
    dropNode: abstractDropDataNode,
    dropPosition: -1
  }) && abstractDropNodeEntity.key === targetNode.props.eventKey) {
    dropPosition = -1;
  } else if ((abstractDragOverEntity.children || []).length && expandKeys.includes(dragOverNodeKey)) {
    if (allowDrop2({
      dropNode: abstractDropDataNode,
      dropPosition: 0
    })) {
      dropPosition = 0;
    } else {
      dropAllowed = false;
    }
  } else if (dropLevelOffset === 0) {
    if (rawDropLevelOffset > -1.5) {
      if (allowDrop2({
        dropNode: abstractDropDataNode,
        dropPosition: 1
      })) {
        dropPosition = 1;
      } else {
        dropAllowed = false;
      }
    } else {
      if (allowDrop2({
        dropNode: abstractDropDataNode,
        dropPosition: 0
      })) {
        dropPosition = 0;
      } else if (allowDrop2({
        dropNode: abstractDropDataNode,
        dropPosition: 1
      })) {
        dropPosition = 1;
      } else {
        dropAllowed = false;
      }
    }
  } else {
    if (allowDrop2({
      dropNode: abstractDropDataNode,
      dropPosition: 1
    })) {
      dropPosition = 1;
    } else {
      dropAllowed = false;
    }
  }
  return {
    dropPosition,
    dropLevelOffset,
    dropTargetKey: abstractDropNodeEntity.key,
    dropTargetPos: abstractDropNodeEntity.pos,
    dragOverNodeKey,
    dropContainerKey: dropPosition === 0 ? null : ((_abstractDropNodeEnti = abstractDropNodeEntity.parent) === null || _abstractDropNodeEnti === void 0 ? void 0 : _abstractDropNodeEnti.key) || null,
    dropAllowed
  };
}
function calcSelectedKeys(selectedKeys, props) {
  if (!selectedKeys)
    return void 0;
  var multiple = props.multiple;
  if (multiple) {
    return selectedKeys.slice();
  }
  if (selectedKeys.length) {
    return [selectedKeys[0]];
  }
  return selectedKeys;
}
function parseCheckedKeys(keys2) {
  if (!keys2) {
    return null;
  }
  var keyProps;
  if (Array.isArray(keys2)) {
    keyProps = {
      checkedKeys: keys2,
      halfCheckedKeys: void 0
    };
  } else if (_typeof$5(keys2) === "object") {
    keyProps = {
      checkedKeys: keys2.checked || void 0,
      halfCheckedKeys: keys2.halfChecked || void 0
    };
  } else {
    warningOnce(false, "`checkedKeys` is not an array or an object");
    return null;
  }
  return keyProps;
}
function conductExpandParent(keyList, keyEntities) {
  var expandedKeys = /* @__PURE__ */ new Set();
  function conductUp(key2) {
    if (expandedKeys.has(key2))
      return;
    var entity = keyEntities[key2];
    if (!entity)
      return;
    expandedKeys.add(key2);
    var parent = entity.parent, node = entity.node;
    if (node.disabled)
      return;
    if (parent) {
      conductUp(parent.key);
    }
  }
  (keyList || []).forEach(function(key2) {
    conductUp(key2);
  });
  return _toConsumableArray(expandedKeys);
}
function getDataAndAria(props) {
  var omitProps = {};
  Object.keys(props).forEach(function(key2) {
    if (key2.startsWith("data-") || key2.startsWith("aria-")) {
      omitProps[key2] = props[key2];
    }
  });
  return omitProps;
}
function getKey2(key2, pos) {
  if (key2 !== null && key2 !== void 0) {
    return key2;
  }
  return pos;
}
function warningWithoutKey() {
  var treeData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var keys2 = /* @__PURE__ */ new Map();
  function dig(list) {
    var path2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (list || []).forEach(function(treeNode) {
      var key2 = treeNode.key, children = treeNode.children;
      warningOnce(key2 !== null && key2 !== void 0, "Tree node must have a certain key: [".concat(path2).concat(key2, "]"));
      var recordKey = String(key2);
      warningOnce(!keys2.has(recordKey) || key2 === null || key2 === void 0, "Same 'key' exist in the Tree: ".concat(recordKey));
      keys2.set(recordKey, true);
      dig(children, "".concat(path2).concat(recordKey, " > "));
    });
  }
  dig(treeData);
}
function convertTreeToData(rootNodes) {
  function dig(node) {
    var treeNodes = toArray$8(node);
    return treeNodes.map(function(treeNode) {
      if (!isTreeNode(treeNode)) {
        warningOnce(!treeNode, "Tree/TreeNode can only accept TreeNode as children.");
        return null;
      }
      var key2 = treeNode.key;
      var _treeNode$props = treeNode.props, children = _treeNode$props.children, rest = _objectWithoutProperties$1(_treeNode$props, ["children"]);
      var dataNode = _objectSpread2$1({
        key: key2
      }, rest);
      var parsedChildren = dig(children);
      if (parsedChildren.length) {
        dataNode.children = parsedChildren;
      }
      return dataNode;
    }).filter(function(dataNode) {
      return dataNode;
    });
  }
  return dig(rootNodes);
}
function flattenTreeData() {
  var treeNodeList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var expandedKeys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
  var flattenList = [];
  function dig(list) {
    var parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return list.map(function(treeNode, index2) {
      var pos = getPosition(parent ? parent.pos : "0", index2);
      var mergedKey = getKey2(treeNode.key, pos);
      var flattenNode = _objectSpread2$1(_objectSpread2$1({}, treeNode), {}, {
        parent,
        pos,
        children: null,
        data: treeNode,
        isStart: [].concat(_toConsumableArray(parent ? parent.isStart : []), [index2 === 0]),
        isEnd: [].concat(_toConsumableArray(parent ? parent.isEnd : []), [index2 === list.length - 1])
      });
      flattenList.push(flattenNode);
      if (expandedKeys === true || expandedKeySet.has(mergedKey)) {
        flattenNode.children = dig(treeNode.children || [], flattenNode);
      } else {
        flattenNode.children = [];
      }
      return flattenNode;
    });
  }
  dig(treeNodeList);
  return flattenList;
}
function traverseDataNodes(dataNodes, callback, config) {
  var externalGetKey = null;
  var childrenPropName;
  var configType = _typeof$5(config);
  if (configType === "function" || configType === "string") {
    externalGetKey = config;
  } else if (config && configType === "object") {
    childrenPropName = config.childrenPropName;
    externalGetKey = config.externalGetKey;
  }
  childrenPropName = childrenPropName || "children";
  var syntheticGetKey;
  if (externalGetKey) {
    if (typeof externalGetKey === "string") {
      syntheticGetKey = function syntheticGetKey2(node) {
        return node[externalGetKey];
      };
    } else if (typeof externalGetKey === "function") {
      syntheticGetKey = function syntheticGetKey2(node) {
        return externalGetKey(node);
      };
    }
  } else {
    syntheticGetKey = function syntheticGetKey2(node, pos) {
      return getKey2(node.key, pos);
    };
  }
  function processNode(node, index2, parent) {
    var children = node ? node[childrenPropName] : dataNodes;
    var pos = node ? getPosition(parent.pos, index2) : "0";
    if (node) {
      var key2 = syntheticGetKey(node, pos);
      var data = {
        node,
        index: index2,
        pos,
        key: key2,
        parentPos: parent.node ? parent.pos : null,
        level: parent.level + 1
      };
      callback(data);
    }
    if (children) {
      children.forEach(function(subNode, subIndex) {
        processNode(subNode, subIndex, {
          node,
          pos,
          level: parent ? parent.level + 1 : -1
        });
      });
    }
  }
  processNode(null);
}
function convertDataToEntities(dataNodes) {
  var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, initWrapper = _ref.initWrapper, processEntity = _ref.processEntity, onProcessFinished = _ref.onProcessFinished, externalGetKey = _ref.externalGetKey, childrenPropName = _ref.childrenPropName;
  var legacyExternalGetKey = arguments.length > 2 ? arguments[2] : void 0;
  var mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
  var posEntities = {};
  var keyEntities = {};
  var wrapper = {
    posEntities,
    keyEntities
  };
  if (initWrapper) {
    wrapper = initWrapper(wrapper) || wrapper;
  }
  traverseDataNodes(dataNodes, function(item) {
    var node = item.node, index2 = item.index, pos = item.pos, key2 = item.key, parentPos = item.parentPos, level = item.level;
    var entity = {
      node,
      index: index2,
      key: key2,
      pos,
      level
    };
    var mergedKey = getKey2(key2, pos);
    posEntities[pos] = entity;
    keyEntities[mergedKey] = entity;
    entity.parent = posEntities[parentPos];
    if (entity.parent) {
      entity.parent.children = entity.parent.children || [];
      entity.parent.children.push(entity);
    }
    if (processEntity) {
      processEntity(entity, wrapper);
    }
  }, {
    externalGetKey: mergedExternalGetKey,
    childrenPropName
  });
  if (onProcessFinished) {
    onProcessFinished(wrapper);
  }
  return wrapper;
}
function getTreeNodeProps(key2, _ref2) {
  var expandedKeys = _ref2.expandedKeys, selectedKeys = _ref2.selectedKeys, loadedKeys = _ref2.loadedKeys, loadingKeys = _ref2.loadingKeys, checkedKeys = _ref2.checkedKeys, halfCheckedKeys = _ref2.halfCheckedKeys, dragOverNodeKey = _ref2.dragOverNodeKey, dropPosition = _ref2.dropPosition, keyEntities = _ref2.keyEntities;
  var entity = keyEntities[key2];
  var treeNodeProps = {
    eventKey: key2,
    expanded: expandedKeys.indexOf(key2) !== -1,
    selected: selectedKeys.indexOf(key2) !== -1,
    loaded: loadedKeys.indexOf(key2) !== -1,
    loading: loadingKeys.indexOf(key2) !== -1,
    checked: checkedKeys.indexOf(key2) !== -1,
    halfChecked: halfCheckedKeys.indexOf(key2) !== -1,
    pos: String(entity ? entity.pos : ""),
    dragOver: dragOverNodeKey === key2 && dropPosition === 0,
    dragOverGapTop: dragOverNodeKey === key2 && dropPosition === -1,
    dragOverGapBottom: dragOverNodeKey === key2 && dropPosition === 1
  };
  return treeNodeProps;
}
function convertNodePropsToEventData(props) {
  var data = props.data, expanded = props.expanded, selected = props.selected, checked = props.checked, loaded = props.loaded, loading = props.loading, halfChecked = props.halfChecked, dragOver = props.dragOver, dragOverGapTop = props.dragOverGapTop, dragOverGapBottom = props.dragOverGapBottom, pos = props.pos, active = props.active;
  var eventData = _objectSpread2$1(_objectSpread2$1({}, data), {}, {
    expanded,
    selected,
    checked,
    loaded,
    loading,
    halfChecked,
    dragOver,
    dragOverGapTop,
    dragOverGapBottom,
    pos,
    active
  });
  if (!("props" in eventData)) {
    Object.defineProperty(eventData, "props", {
      get: function get2() {
        warningOnce(false, "Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`.");
        return props;
      }
    });
  }
  return eventData;
}
function removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
  var filteredKeys = /* @__PURE__ */ new Set();
  halfCheckedKeys.forEach(function(key2) {
    if (!checkedKeys.has(key2)) {
      filteredKeys.add(key2);
    }
  });
  return filteredKeys;
}
function isCheckDisabled$1(node) {
  var _ref = node || {}, disabled = _ref.disabled, disableCheckbox = _ref.disableCheckbox, checkable = _ref.checkable;
  return !!(disabled || disableCheckbox) || checkable === false;
}
function fillConductCheck(keys2, levelEntities, maxLevel, syntheticGetCheckDisabled) {
  var checkedKeys = new Set(keys2);
  var halfCheckedKeys = /* @__PURE__ */ new Set();
  for (var level = 0; level <= maxLevel; level += 1) {
    var entities = levelEntities.get(level) || /* @__PURE__ */ new Set();
    entities.forEach(function(entity) {
      var key2 = entity.key, node = entity.node, _entity$children = entity.children, children = _entity$children === void 0 ? [] : _entity$children;
      if (checkedKeys.has(key2) && !syntheticGetCheckDisabled(node)) {
        children.filter(function(childEntity) {
          return !syntheticGetCheckDisabled(childEntity.node);
        }).forEach(function(childEntity) {
          checkedKeys.add(childEntity.key);
        });
      }
    });
  }
  var visitedKeys = /* @__PURE__ */ new Set();
  for (var _level = maxLevel; _level >= 0; _level -= 1) {
    var _entities = levelEntities.get(_level) || /* @__PURE__ */ new Set();
    _entities.forEach(function(entity) {
      var parent = entity.parent, node = entity.node;
      if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) {
        return;
      }
      if (syntheticGetCheckDisabled(entity.parent.node)) {
        visitedKeys.add(parent.key);
        return;
      }
      var allChecked = true;
      var partialChecked = false;
      (parent.children || []).filter(function(childEntity) {
        return !syntheticGetCheckDisabled(childEntity.node);
      }).forEach(function(_ref2) {
        var key2 = _ref2.key;
        var checked = checkedKeys.has(key2);
        if (allChecked && !checked) {
          allChecked = false;
        }
        if (!partialChecked && (checked || halfCheckedKeys.has(key2))) {
          partialChecked = true;
        }
      });
      if (allChecked) {
        checkedKeys.add(parent.key);
      }
      if (partialChecked) {
        halfCheckedKeys.add(parent.key);
      }
      visitedKeys.add(parent.key);
    });
  }
  return {
    checkedKeys: Array.from(checkedKeys),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
  };
}
function cleanConductCheck(keys2, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
  var checkedKeys = new Set(keys2);
  var halfCheckedKeys = new Set(halfKeys);
  for (var level = 0; level <= maxLevel; level += 1) {
    var entities = levelEntities.get(level) || /* @__PURE__ */ new Set();
    entities.forEach(function(entity) {
      var key2 = entity.key, node = entity.node, _entity$children2 = entity.children, children = _entity$children2 === void 0 ? [] : _entity$children2;
      if (!checkedKeys.has(key2) && !halfCheckedKeys.has(key2) && !syntheticGetCheckDisabled(node)) {
        children.filter(function(childEntity) {
          return !syntheticGetCheckDisabled(childEntity.node);
        }).forEach(function(childEntity) {
          checkedKeys.delete(childEntity.key);
        });
      }
    });
  }
  halfCheckedKeys = /* @__PURE__ */ new Set();
  var visitedKeys = /* @__PURE__ */ new Set();
  for (var _level2 = maxLevel; _level2 >= 0; _level2 -= 1) {
    var _entities2 = levelEntities.get(_level2) || /* @__PURE__ */ new Set();
    _entities2.forEach(function(entity) {
      var parent = entity.parent, node = entity.node;
      if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) {
        return;
      }
      if (syntheticGetCheckDisabled(entity.parent.node)) {
        visitedKeys.add(parent.key);
        return;
      }
      var allChecked = true;
      var partialChecked = false;
      (parent.children || []).filter(function(childEntity) {
        return !syntheticGetCheckDisabled(childEntity.node);
      }).forEach(function(_ref3) {
        var key2 = _ref3.key;
        var checked = checkedKeys.has(key2);
        if (allChecked && !checked) {
          allChecked = false;
        }
        if (!partialChecked && (checked || halfCheckedKeys.has(key2))) {
          partialChecked = true;
        }
      });
      if (!allChecked) {
        checkedKeys.delete(parent.key);
      }
      if (partialChecked) {
        halfCheckedKeys.add(parent.key);
      }
      visitedKeys.add(parent.key);
    });
  }
  return {
    checkedKeys: Array.from(checkedKeys),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
  };
}
function conductCheck(keyList, checked, keyEntities, getCheckDisabled) {
  var warningMissKeys = [];
  var syntheticGetCheckDisabled;
  if (getCheckDisabled) {
    syntheticGetCheckDisabled = getCheckDisabled;
  } else {
    syntheticGetCheckDisabled = isCheckDisabled$1;
  }
  var keys2 = new Set(keyList.filter(function(key2) {
    var hasEntity = !!keyEntities[key2];
    if (!hasEntity) {
      warningMissKeys.push(key2);
    }
    return hasEntity;
  }));
  var levelEntities = /* @__PURE__ */ new Map();
  var maxLevel = 0;
  Object.keys(keyEntities).forEach(function(key2) {
    var entity = keyEntities[key2];
    var level = entity.level;
    var levelSet = levelEntities.get(level);
    if (!levelSet) {
      levelSet = /* @__PURE__ */ new Set();
      levelEntities.set(level, levelSet);
    }
    levelSet.add(entity);
    maxLevel = Math.max(maxLevel, level);
  });
  warningOnce(!warningMissKeys.length, "Tree missing follow keys: ".concat(warningMissKeys.slice(0, 100).map(function(key2) {
    return "'".concat(key2, "'");
  }).join(", ")));
  var result;
  if (checked === true) {
    result = fillConductCheck(keys2, levelEntities, maxLevel, syntheticGetCheckDisabled);
  } else {
    result = cleanConductCheck(keys2, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
  }
  return result;
}
var CaretDownOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "outlined" };
var CaretDownOutlined = function CaretDownOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: CaretDownOutlined$1
  }));
};
CaretDownOutlined.displayName = "CaretDownOutlined";
var CaretUpOutlined$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, "name": "caret-up", "theme": "outlined" };
var CaretUpOutlined = function CaretUpOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: CaretUpOutlined$1
  }));
};
CaretUpOutlined.displayName = "CaretUpOutlined";
var FilterFilled$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, "name": "filter", "theme": "filled" };
var FilterFilled = function FilterFilled2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: FilterFilled$1
  }));
};
FilterFilled.displayName = "FilterFilled";
Menu.SubMenu;
Menu.Item;
function Search(props) {
  var _props$placeholder = props.placeholder, placeholder = _props$placeholder === void 0 ? "" : _props$placeholder, value = props.value, prefixCls = props.prefixCls, disabled = props.disabled, onChange4 = props.onChange, handleClear = props.handleClear;
  var handleChange = React.useCallback(function(e3) {
    onChange4 === null || onChange4 === void 0 ? void 0 : onChange4(e3);
  }, [onChange4]);
  var handleClearFn = function handleClearFn2(e3) {
    e3.preventDefault();
    if (!disabled && handleClear) {
      handleClear(e3);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Input$1, {
    placeholder,
    className: prefixCls,
    value,
    onChange: handleChange,
    disabled
  }), value && value.length > 0 ? /* @__PURE__ */ React.createElement("a", {
    className: "".concat(prefixCls, "-action"),
    onClick: handleClearFn
  }, /* @__PURE__ */ React.createElement(CloseCircleFilled$1, null)) : /* @__PURE__ */ React.createElement("span", {
    className: "".concat(prefixCls, "-action")
  }, /* @__PURE__ */ React.createElement(SearchOutlined$1, null)));
}
var DeleteOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, "name": "delete", "theme": "outlined" };
var DeleteOutlined = function DeleteOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: DeleteOutlined$2
  }));
};
DeleteOutlined.displayName = "DeleteOutlined";
var DeleteOutlined$1 = /* @__PURE__ */ React.forwardRef(DeleteOutlined);
var ListItem$1 = function ListItem(props) {
  var _classNames;
  var renderedText = props.renderedText, renderedEl = props.renderedEl, item = props.item, checked = props.checked, disabled = props.disabled, prefixCls = props.prefixCls, onClick = props.onClick, onRemove = props.onRemove, showRemove = props.showRemove;
  var className = cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-content-item"), true), _defineProperty$4(_classNames, "".concat(prefixCls, "-content-item-disabled"), disabled || item.disabled), _defineProperty$4(_classNames, "".concat(prefixCls, "-content-item-checked"), checked), _classNames));
  var title;
  if (typeof renderedText === "string" || typeof renderedText === "number") {
    title = String(renderedText);
  }
  return /* @__PURE__ */ React.createElement(LocaleReceiver, {
    componentName: "Transfer",
    defaultLocale: localeValues.Transfer
  }, function(transferLocale) {
    var liProps = {
      className,
      title
    };
    var labelNode = /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-content-item-text")
    }, renderedEl);
    if (showRemove) {
      return /* @__PURE__ */ React.createElement("li", liProps, labelNode, /* @__PURE__ */ React.createElement(TransButton, {
        disabled: disabled || item.disabled,
        className: "".concat(prefixCls, "-content-item-remove"),
        "aria-label": transferLocale.remove,
        onClick: function onClick2() {
          onRemove === null || onRemove === void 0 ? void 0 : onRemove(item);
        }
      }, /* @__PURE__ */ React.createElement(DeleteOutlined$1, null)));
    }
    liProps.onClick = disabled || item.disabled ? void 0 : function() {
      return onClick(item);
    };
    return /* @__PURE__ */ React.createElement("li", liProps, /* @__PURE__ */ React.createElement(Checkbox, {
      className: "".concat(prefixCls, "-checkbox"),
      checked,
      disabled: disabled || item.disabled
    }), labelNode);
  });
};
var ListItem$2 = /* @__PURE__ */ React.memo(ListItem$1);
var OmitProps = tuple$1("handleFilter", "handleClear", "checkedKeys");
function parsePagination(pagination) {
  if (!pagination) {
    return null;
  }
  var defaultPagination = {
    pageSize: 10
  };
  if (_typeof$5(pagination) === "object") {
    return _extends$2(_extends$2({}, defaultPagination), pagination);
  }
  return defaultPagination;
}
var ListBody = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(ListBody2, _React$Component);
  var _super = _createSuper$1(ListBody2);
  function ListBody2() {
    var _this2;
    _classCallCheck$2(this, ListBody2);
    _this2 = _super.apply(this, arguments);
    _this2.state = {
      current: 1
    };
    _this2.onItemSelect = function(item) {
      var _this$props = _this2.props, onItemSelect = _this$props.onItemSelect, selectedKeys = _this$props.selectedKeys;
      var checked = selectedKeys.indexOf(item.key) >= 0;
      onItemSelect(item.key, !checked);
    };
    _this2.onItemRemove = function(item) {
      var onItemRemove = _this2.props.onItemRemove;
      onItemRemove === null || onItemRemove === void 0 ? void 0 : onItemRemove([item.key]);
    };
    _this2.onPageChange = function(current) {
      _this2.setState({
        current
      });
    };
    _this2.getItems = function() {
      var current = _this2.state.current;
      var _this$props2 = _this2.props, pagination = _this$props2.pagination, filteredRenderItems = _this$props2.filteredRenderItems;
      var mergedPagination = parsePagination(pagination);
      var displayItems = filteredRenderItems;
      if (mergedPagination) {
        displayItems = filteredRenderItems.slice((current - 1) * mergedPagination.pageSize, current * mergedPagination.pageSize);
      }
      return displayItems;
    };
    return _this2;
  }
  _createClass$2(ListBody2, [{
    key: "render",
    value: function render4() {
      var _this2 = this;
      var current = this.state.current;
      var _this$props3 = this.props, prefixCls = _this$props3.prefixCls, onScroll = _this$props3.onScroll, filteredRenderItems = _this$props3.filteredRenderItems, selectedKeys = _this$props3.selectedKeys, globalDisabled = _this$props3.disabled, showRemove = _this$props3.showRemove, pagination = _this$props3.pagination;
      var mergedPagination = parsePagination(pagination);
      var paginationNode = null;
      if (mergedPagination) {
        paginationNode = /* @__PURE__ */ React.createElement(Pagination, {
          simple: true,
          size: "small",
          disabled: globalDisabled,
          className: "".concat(prefixCls, "-pagination"),
          total: filteredRenderItems.length,
          pageSize: mergedPagination.pageSize,
          current,
          onChange: this.onPageChange
        });
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("ul", {
        className: cn("".concat(prefixCls, "-content"), _defineProperty$4({}, "".concat(prefixCls, "-content-show-remove"), showRemove)),
        onScroll
      }, this.getItems().map(function(_ref) {
        var renderedEl = _ref.renderedEl, renderedText = _ref.renderedText, item = _ref.item;
        var disabled = item.disabled;
        var checked = selectedKeys.indexOf(item.key) >= 0;
        return /* @__PURE__ */ React.createElement(ListItem$2, {
          disabled: globalDisabled || disabled,
          key: item.key,
          item,
          renderedText,
          renderedEl,
          checked,
          prefixCls,
          onClick: _this2.onItemSelect,
          onRemove: _this2.onItemRemove,
          showRemove
        });
      })), paginationNode);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref2, _ref3) {
      var filteredRenderItems = _ref2.filteredRenderItems, pagination = _ref2.pagination;
      var current = _ref3.current;
      var mergedPagination = parsePagination(pagination);
      if (mergedPagination) {
        var maxPageCount = Math.ceil(filteredRenderItems.length / mergedPagination.pageSize);
        if (current > maxPageCount) {
          return {
            current: maxPageCount
          };
        }
      }
      return null;
    }
  }]);
  return ListBody2;
}(React.Component);
var defaultRender = function defaultRender2() {
  return null;
};
function isRenderResultPlainObject(result) {
  return result && !isValidElement2(result) && Object.prototype.toString.call(result) === "[object Object]";
}
function getEnabledItemKeys(items) {
  return items.filter(function(data) {
    return !data.disabled;
  }).map(function(data) {
    return data.key;
  });
}
var TransferList = /* @__PURE__ */ function(_React$PureComponent) {
  _inherits$1(TransferList2, _React$PureComponent);
  var _super = _createSuper$1(TransferList2);
  function TransferList2(props) {
    var _this2;
    _classCallCheck$2(this, TransferList2);
    _this2 = _super.call(this, props);
    _this2.defaultListBodyRef = /* @__PURE__ */ React.createRef();
    _this2.handleFilter = function(e3) {
      var handleFilter = _this2.props.handleFilter;
      var filterValue = e3.target.value;
      _this2.setState({
        filterValue
      });
      handleFilter(e3);
    };
    _this2.handleClear = function() {
      var handleClear = _this2.props.handleClear;
      _this2.setState({
        filterValue: ""
      });
      handleClear();
    };
    _this2.matchFilter = function(text, item) {
      var filterValue = _this2.state.filterValue;
      var filterOption2 = _this2.props.filterOption;
      if (filterOption2) {
        return filterOption2(filterValue, item);
      }
      return text.indexOf(filterValue) >= 0;
    };
    _this2.getCurrentPageItems = function() {
    };
    _this2.renderListBody = function(renderList, props2) {
      var bodyContent = renderList ? renderList(props2) : null;
      var customize = !!bodyContent;
      if (!customize) {
        bodyContent = /* @__PURE__ */ React.createElement(ListBody, _extends$2({
          ref: _this2.defaultListBodyRef
        }, props2));
      }
      return {
        customize,
        bodyContent
      };
    };
    _this2.renderItem = function(item) {
      var _this$props$render = _this2.props.render, render4 = _this$props$render === void 0 ? defaultRender : _this$props$render;
      var renderResult = render4(item);
      var isRenderResultPlain = isRenderResultPlainObject(renderResult);
      return {
        renderedText: isRenderResultPlain ? renderResult.value : renderResult,
        renderedEl: isRenderResultPlain ? renderResult.label : renderResult,
        item
      };
    };
    _this2.getSelectAllLabel = function(selectedCount, totalCount) {
      var _this$props = _this2.props, itemsUnit = _this$props.itemsUnit, itemUnit = _this$props.itemUnit, selectAllLabel = _this$props.selectAllLabel;
      if (selectAllLabel) {
        return typeof selectAllLabel === "function" ? selectAllLabel({
          selectedCount,
          totalCount
        }) : selectAllLabel;
      }
      var unit = totalCount > 1 ? itemsUnit : itemUnit;
      return /* @__PURE__ */ React.createElement(React.Fragment, null, (selectedCount > 0 ? "".concat(selectedCount, "/") : "") + totalCount, " ", unit);
    };
    _this2.state = {
      filterValue: ""
    };
    return _this2;
  }
  _createClass$2(TransferList2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.triggerScrollTimer);
    }
  }, {
    key: "getCheckStatus",
    value: function getCheckStatus(filteredItems) {
      var checkedKeys = this.props.checkedKeys;
      if (checkedKeys.length === 0) {
        return "none";
      }
      if (filteredItems.every(function(item) {
        return checkedKeys.indexOf(item.key) >= 0 || !!item.disabled;
      })) {
        return "all";
      }
      return "part";
    }
  }, {
    key: "getFilteredItems",
    value: function getFilteredItems(dataSource, filterValue) {
      var _this2 = this;
      var filteredItems = [];
      var filteredRenderItems = [];
      dataSource.forEach(function(item) {
        var renderedItem = _this2.renderItem(item);
        var renderedText = renderedItem.renderedText;
        if (filterValue && !_this2.matchFilter(renderedText, item)) {
          return null;
        }
        filteredItems.push(item);
        filteredRenderItems.push(renderedItem);
      });
      return {
        filteredItems,
        filteredRenderItems
      };
    }
  }, {
    key: "getListBody",
    value: function getListBody(prefixCls, searchPlaceholder, filterValue, filteredItems, notFoundContent, filteredRenderItems, checkedKeys, renderList, showSearch, disabled) {
      var search = showSearch ? /* @__PURE__ */ React.createElement("div", {
        className: "".concat(prefixCls, "-body-search-wrapper")
      }, /* @__PURE__ */ React.createElement(Search, {
        prefixCls: "".concat(prefixCls, "-search"),
        onChange: this.handleFilter,
        handleClear: this.handleClear,
        placeholder: searchPlaceholder,
        value: filterValue,
        disabled
      })) : null;
      var _this$renderListBody = this.renderListBody(renderList, _extends$2(_extends$2({}, omit$1(this.props, OmitProps)), {
        filteredItems,
        filteredRenderItems,
        selectedKeys: checkedKeys
      })), bodyContent = _this$renderListBody.bodyContent, customize = _this$renderListBody.customize;
      var bodyNode;
      if (customize) {
        bodyNode = /* @__PURE__ */ React.createElement("div", {
          className: "".concat(prefixCls, "-body-customize-wrapper")
        }, bodyContent);
      } else {
        bodyNode = filteredItems.length ? bodyContent : /* @__PURE__ */ React.createElement("div", {
          className: "".concat(prefixCls, "-body-not-found")
        }, notFoundContent);
      }
      return /* @__PURE__ */ React.createElement("div", {
        className: cn(showSearch ? "".concat(prefixCls, "-body ").concat(prefixCls, "-body-with-search") : "".concat(prefixCls, "-body"))
      }, search, bodyNode);
    }
  }, {
    key: "getCheckBox",
    value: function getCheckBox(filteredItems, onItemSelectAll, showSelectAll, disabled, prefixCls) {
      var checkStatus = this.getCheckStatus(filteredItems);
      var checkedAll = checkStatus === "all";
      var checkAllCheckbox = showSelectAll !== false && /* @__PURE__ */ React.createElement(Checkbox, {
        disabled,
        checked: checkedAll,
        indeterminate: checkStatus === "part",
        className: "".concat(prefixCls, "-checkbox"),
        onChange: function onChange4() {
          onItemSelectAll(filteredItems.filter(function(item) {
            return !item.disabled;
          }).map(function(_ref) {
            var key2 = _ref.key;
            return key2;
          }), !checkedAll);
        }
      });
      return checkAllCheckbox;
    }
  }, {
    key: "render",
    value: function render4() {
      var _classNames, _this3 = this;
      var filterValue = this.state.filterValue;
      var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, dataSource = _this$props2.dataSource, titleText = _this$props2.titleText, checkedKeys = _this$props2.checkedKeys, disabled = _this$props2.disabled, footer = _this$props2.footer, showSearch = _this$props2.showSearch, style2 = _this$props2.style, searchPlaceholder = _this$props2.searchPlaceholder, notFoundContent = _this$props2.notFoundContent, selectAll = _this$props2.selectAll, selectCurrent = _this$props2.selectCurrent, selectInvert = _this$props2.selectInvert, removeAll = _this$props2.removeAll, removeCurrent = _this$props2.removeCurrent, renderList = _this$props2.renderList, onItemSelectAll = _this$props2.onItemSelectAll, onItemRemove = _this$props2.onItemRemove, showSelectAll = _this$props2.showSelectAll, showRemove = _this$props2.showRemove, pagination = _this$props2.pagination;
      var footerDom = footer && footer(this.props);
      var listCls = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-with-pagination"), !!pagination), _defineProperty$4(_classNames, "".concat(prefixCls, "-with-footer"), !!footerDom), _classNames));
      var _this$getFilteredItem = this.getFilteredItems(dataSource, filterValue), filteredItems = _this$getFilteredItem.filteredItems, filteredRenderItems = _this$getFilteredItem.filteredRenderItems;
      var listBody = this.getListBody(prefixCls, searchPlaceholder, filterValue, filteredItems, notFoundContent, filteredRenderItems, checkedKeys, renderList, showSearch, disabled);
      var listFooter = footerDom ? /* @__PURE__ */ React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, footerDom) : null;
      var checkAllCheckbox = !showRemove && !pagination && this.getCheckBox(filteredItems, onItemSelectAll, showSelectAll, disabled, prefixCls);
      var menu = null;
      if (showRemove) {
        menu = /* @__PURE__ */ React.createElement(Menu, null, pagination && /* @__PURE__ */ React.createElement(Menu.Item, {
          onClick: function onClick() {
            var _a;
            var pageKeys = getEnabledItemKeys((((_a = _this3.defaultListBodyRef.current) === null || _a === void 0 ? void 0 : _a.getItems()) || []).map(function(entity) {
              return entity.item;
            }));
            onItemRemove === null || onItemRemove === void 0 ? void 0 : onItemRemove(pageKeys);
          }
        }, removeCurrent), /* @__PURE__ */ React.createElement(Menu.Item, {
          onClick: function onClick() {
            onItemRemove === null || onItemRemove === void 0 ? void 0 : onItemRemove(getEnabledItemKeys(filteredItems));
          }
        }, removeAll));
      } else {
        menu = /* @__PURE__ */ React.createElement(Menu, null, /* @__PURE__ */ React.createElement(Menu.Item, {
          onClick: function onClick() {
            var keys2 = getEnabledItemKeys(filteredItems);
            onItemSelectAll(keys2, keys2.length !== checkedKeys.length);
          }
        }, selectAll), pagination && /* @__PURE__ */ React.createElement(Menu.Item, {
          onClick: function onClick() {
            var _a;
            var pageItems = ((_a = _this3.defaultListBodyRef.current) === null || _a === void 0 ? void 0 : _a.getItems()) || [];
            onItemSelectAll(getEnabledItemKeys(pageItems.map(function(entity) {
              return entity.item;
            })), true);
          }
        }, selectCurrent), /* @__PURE__ */ React.createElement(Menu.Item, {
          onClick: function onClick() {
            var _a;
            var availableKeys;
            if (pagination) {
              availableKeys = getEnabledItemKeys((((_a = _this3.defaultListBodyRef.current) === null || _a === void 0 ? void 0 : _a.getItems()) || []).map(function(entity) {
                return entity.item;
              }));
            } else {
              availableKeys = getEnabledItemKeys(filteredItems);
            }
            var checkedKeySet = new Set(checkedKeys);
            var newCheckedKeys = [];
            var newUnCheckedKeys = [];
            availableKeys.forEach(function(key2) {
              if (checkedKeySet.has(key2)) {
                newUnCheckedKeys.push(key2);
              } else {
                newCheckedKeys.push(key2);
              }
            });
            onItemSelectAll(newCheckedKeys, true);
            onItemSelectAll(newUnCheckedKeys, false);
          }
        }, selectInvert));
      }
      var dropdown = /* @__PURE__ */ React.createElement(Dropdown$2, {
        className: "".concat(prefixCls, "-header-dropdown"),
        overlay: menu,
        disabled
      }, /* @__PURE__ */ React.createElement(DownOutlined$1, null));
      return /* @__PURE__ */ React.createElement("div", {
        className: listCls,
        style: style2
      }, /* @__PURE__ */ React.createElement("div", {
        className: "".concat(prefixCls, "-header")
      }, checkAllCheckbox, dropdown, /* @__PURE__ */ React.createElement("span", {
        className: "".concat(prefixCls, "-header-selected")
      }, this.getSelectAllLabel(checkedKeys.length, filteredItems.length)), /* @__PURE__ */ React.createElement("span", {
        className: "".concat(prefixCls, "-header-title")
      }, titleText)), listBody, listFooter);
    }
  }]);
  return TransferList2;
}(React.PureComponent);
TransferList.defaultProps = {
  dataSource: [],
  titleText: "",
  showSearch: false
};
var MotionTreeNode = function MotionTreeNode2(_ref, ref) {
  var className = _ref.className, style2 = _ref.style, motion = _ref.motion, motionNodes = _ref.motionNodes, motionType = _ref.motionType, onOriginMotionStart = _ref.onMotionStart, onOriginMotionEnd = _ref.onMotionEnd, active = _ref.active, treeNodeRequiredProps = _ref.treeNodeRequiredProps, props = _objectWithoutProperties$1(_ref, ["className", "style", "motion", "motionNodes", "motionType", "onMotionStart", "onMotionEnd", "active", "treeNodeRequiredProps"]);
  var _React$useState = React.useState(true), _React$useState2 = _slicedToArray$3(_React$useState, 2), visible = _React$useState2[0], setVisible = _React$useState2[1];
  var _React$useContext = React.useContext(TreeContext), prefixCls = _React$useContext.prefixCls;
  var motionedRef = React.useRef(false);
  var onMotionEnd = function onMotionEnd2() {
    if (!motionedRef.current) {
      onOriginMotionEnd();
    }
    motionedRef.current = true;
  };
  useEffect2(function() {
    if (motionNodes && motionType === "hide" && visible) {
      setVisible(false);
    }
  }, [motionNodes]);
  useEffect2(function() {
    if (motionNodes) {
      onOriginMotionStart();
    }
    return function() {
      if (motionNodes) {
        onMotionEnd();
      }
    };
  }, []);
  if (motionNodes) {
    return /* @__PURE__ */ React.createElement(CSSMotion, _extends$2({
      ref,
      visible
    }, motion, {
      motionAppear: motionType === "show",
      onAppearEnd: onMotionEnd,
      onLeaveEnd: onMotionEnd
    }), function(_ref2, motionRef) {
      var motionClassName = _ref2.className, motionStyle = _ref2.style;
      return /* @__PURE__ */ React.createElement("div", {
        ref: motionRef,
        className: cn("".concat(prefixCls, "-treenode-motion"), motionClassName),
        style: motionStyle
      }, motionNodes.map(function(treeNode) {
        var _treeNode$data = treeNode.data, key2 = _treeNode$data.key, restProps = _objectWithoutProperties$1(_treeNode$data, ["key"]), isStart = treeNode.isStart, isEnd = treeNode.isEnd;
        delete restProps.children;
        var treeNodeProps = getTreeNodeProps(key2, treeNodeRequiredProps);
        return /* @__PURE__ */ React.createElement(ContextTreeNode, _extends$2({}, restProps, treeNodeProps, {
          active,
          data: treeNode.data,
          key: key2,
          isStart,
          isEnd
        }));
      }));
    });
  }
  return /* @__PURE__ */ React.createElement(ContextTreeNode, _extends$2({
    domRef: ref,
    className,
    style: style2
  }, props, {
    active
  }));
};
MotionTreeNode.displayName = "MotionTreeNode";
var RefMotionTreeNode = /* @__PURE__ */ React.forwardRef(MotionTreeNode);
function findExpandedKeys() {
  var prev = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var next = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var prevLen = prev.length;
  var nextLen = next.length;
  if (Math.abs(prevLen - nextLen) !== 1) {
    return {
      add: false,
      key: null
    };
  }
  function find(shorter, longer) {
    var cache = /* @__PURE__ */ new Map();
    shorter.forEach(function(key2) {
      cache.set(key2, true);
    });
    var keys2 = longer.filter(function(key2) {
      return !cache.has(key2);
    });
    return keys2.length === 1 ? keys2[0] : null;
  }
  if (prevLen < nextLen) {
    return {
      add: true,
      key: find(prev, next)
    };
  }
  return {
    add: false,
    key: find(next, prev)
  };
}
function getExpandRange(shorter, longer, key2) {
  var shorterStartIndex = shorter.findIndex(function(_ref) {
    var data = _ref.data;
    return data.key === key2;
  });
  var shorterEndNode = shorter[shorterStartIndex + 1];
  var longerStartIndex = longer.findIndex(function(_ref2) {
    var data = _ref2.data;
    return data.key === key2;
  });
  if (shorterEndNode) {
    var longerEndIndex = longer.findIndex(function(_ref3) {
      var data = _ref3.data;
      return data.key === shorterEndNode.data.key;
    });
    return longer.slice(longerStartIndex + 1, longerEndIndex);
  }
  return longer.slice(longerStartIndex + 1);
}
var HIDDEN_STYLE$1 = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
};
var noop = function noop2() {
};
var MOTION_KEY = "RC_TREE_MOTION_".concat(Math.random());
var MotionNode = {
  key: MOTION_KEY
};
var MotionEntity = {
  key: MOTION_KEY,
  level: 0,
  index: 0,
  pos: "0",
  node: MotionNode
};
var MotionFlattenData = {
  parent: null,
  children: [],
  pos: MotionEntity.pos,
  data: MotionNode,
  isStart: [],
  isEnd: []
};
function getMinimumRangeTransitionRange(list, virtual, height, itemHeight) {
  if (virtual === false || !height) {
    return list;
  }
  return list.slice(0, Math.ceil(height / itemHeight) + 1);
}
function itemKey(item) {
  var key2 = item.data.key, pos = item.pos;
  return getKey2(key2, pos);
}
function getAccessibilityPath(item) {
  var path2 = String(item.data.key);
  var current = item;
  while (current.parent) {
    current = current.parent;
    path2 = "".concat(current.data.key, " > ").concat(path2);
  }
  return path2;
}
var RefNodeList = function RefNodeList2(props, ref) {
  var prefixCls = props.prefixCls, data = props.data;
  props.selectable;
  props.checkable;
  var expandedKeys = props.expandedKeys, selectedKeys = props.selectedKeys, checkedKeys = props.checkedKeys, loadedKeys = props.loadedKeys, loadingKeys = props.loadingKeys, halfCheckedKeys = props.halfCheckedKeys, keyEntities = props.keyEntities, disabled = props.disabled, dragging = props.dragging, dragOverNodeKey = props.dragOverNodeKey, dropPosition = props.dropPosition, motion = props.motion, height = props.height, itemHeight = props.itemHeight, virtual = props.virtual, focusable = props.focusable, activeItem = props.activeItem, focused = props.focused, tabIndex = props.tabIndex, onKeyDown2 = props.onKeyDown, onFocus2 = props.onFocus, onBlur2 = props.onBlur, onActiveChange = props.onActiveChange, onListChangeStart = props.onListChangeStart, onListChangeEnd = props.onListChangeEnd, domProps = _objectWithoutProperties$1(props, ["prefixCls", "data", "selectable", "checkable", "expandedKeys", "selectedKeys", "checkedKeys", "loadedKeys", "loadingKeys", "halfCheckedKeys", "keyEntities", "disabled", "dragging", "dragOverNodeKey", "dropPosition", "motion", "height", "itemHeight", "virtual", "focusable", "activeItem", "focused", "tabIndex", "onKeyDown", "onFocus", "onBlur", "onActiveChange", "onListChangeStart", "onListChangeEnd"]);
  var listRef = React.useRef(null);
  var indentMeasurerRef = React.useRef(null);
  React.useImperativeHandle(ref, function() {
    return {
      scrollTo: function scrollTo2(scroll) {
        listRef.current.scrollTo(scroll);
      },
      getIndentWidth: function getIndentWidth() {
        return indentMeasurerRef.current.offsetWidth;
      }
    };
  });
  var _React$useState = React.useState(expandedKeys), _React$useState2 = _slicedToArray$3(_React$useState, 2), prevExpandedKeys = _React$useState2[0], setPrevExpandedKeys = _React$useState2[1];
  var _React$useState3 = React.useState(data), _React$useState4 = _slicedToArray$3(_React$useState3, 2), prevData = _React$useState4[0], setPrevData = _React$useState4[1];
  var _React$useState5 = React.useState(data), _React$useState6 = _slicedToArray$3(_React$useState5, 2), transitionData = _React$useState6[0], setTransitionData = _React$useState6[1];
  var _React$useState7 = React.useState([]), _React$useState8 = _slicedToArray$3(_React$useState7, 2), transitionRange = _React$useState8[0], setTransitionRange = _React$useState8[1];
  var _React$useState9 = React.useState(null), _React$useState10 = _slicedToArray$3(_React$useState9, 2), motionType = _React$useState10[0], setMotionType = _React$useState10[1];
  function onMotionEnd() {
    setPrevData(data);
    setTransitionData(data);
    setTransitionRange([]);
    setMotionType(null);
    onListChangeEnd();
  }
  React.useEffect(function() {
    setPrevExpandedKeys(expandedKeys);
    var diffExpanded = findExpandedKeys(prevExpandedKeys, expandedKeys);
    if (diffExpanded.key !== null) {
      if (diffExpanded.add) {
        var keyIndex = prevData.findIndex(function(_ref) {
          var key2 = _ref.data.key;
          return key2 === diffExpanded.key;
        });
        var rangeNodes = getMinimumRangeTransitionRange(getExpandRange(prevData, data, diffExpanded.key), virtual, height, itemHeight);
        var newTransitionData = prevData.slice();
        newTransitionData.splice(keyIndex + 1, 0, MotionFlattenData);
        setTransitionData(newTransitionData);
        setTransitionRange(rangeNodes);
        setMotionType("show");
      } else {
        var _keyIndex = data.findIndex(function(_ref2) {
          var key2 = _ref2.data.key;
          return key2 === diffExpanded.key;
        });
        var _rangeNodes = getMinimumRangeTransitionRange(getExpandRange(data, prevData, diffExpanded.key), virtual, height, itemHeight);
        var _newTransitionData = data.slice();
        _newTransitionData.splice(_keyIndex + 1, 0, MotionFlattenData);
        setTransitionData(_newTransitionData);
        setTransitionRange(_rangeNodes);
        setMotionType("hide");
      }
    } else if (prevData !== data) {
      setPrevData(data);
      setTransitionData(data);
    }
  }, [expandedKeys, data]);
  React.useEffect(function() {
    if (!dragging) {
      onMotionEnd();
    }
  }, [dragging]);
  var mergedData = motion ? transitionData : data;
  var treeNodeRequiredProps = {
    expandedKeys,
    selectedKeys,
    loadedKeys,
    loadingKeys,
    checkedKeys,
    halfCheckedKeys,
    dragOverNodeKey,
    dropPosition,
    keyEntities
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, focused && activeItem && /* @__PURE__ */ React.createElement("span", {
    style: HIDDEN_STYLE$1,
    "aria-live": "assertive"
  }, getAccessibilityPath(activeItem)), /* @__PURE__ */ React.createElement("div", {
    role: "tree"
  }, /* @__PURE__ */ React.createElement("input", {
    style: HIDDEN_STYLE$1,
    disabled: focusable === false || disabled,
    tabIndex: focusable !== false ? tabIndex : null,
    onKeyDown: onKeyDown2,
    onFocus: onFocus2,
    onBlur: onBlur2,
    value: "",
    onChange: noop
  })), /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-treenode"),
    "aria-hidden": true,
    style: {
      position: "absolute",
      pointerEvents: "none",
      visibility: "hidden",
      height: 0,
      overflow: "hidden"
    }
  }, /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-indent")
  }, /* @__PURE__ */ React.createElement("div", {
    ref: indentMeasurerRef,
    className: "".concat(prefixCls, "-indent-unit")
  }))), /* @__PURE__ */ React.createElement(List2, _extends$2({}, domProps, {
    data: mergedData,
    itemKey,
    height,
    fullHeight: false,
    virtual,
    itemHeight,
    prefixCls: "".concat(prefixCls, "-list"),
    ref: listRef
  }), function(treeNode) {
    var pos = treeNode.pos, _treeNode$data = treeNode.data, key2 = _treeNode$data.key, restProps = _objectWithoutProperties$1(_treeNode$data, ["key"]), isStart = treeNode.isStart, isEnd = treeNode.isEnd;
    var mergedKey = getKey2(key2, pos);
    delete restProps.children;
    var treeNodeProps = getTreeNodeProps(mergedKey, treeNodeRequiredProps);
    return /* @__PURE__ */ React.createElement(RefMotionTreeNode, _extends$2({}, restProps, treeNodeProps, {
      active: !!activeItem && key2 === activeItem.data.key,
      pos,
      data: treeNode.data,
      isStart,
      isEnd,
      motion,
      motionNodes: key2 === MOTION_KEY ? transitionRange : null,
      motionType,
      onMotionStart: onListChangeStart,
      onMotionEnd,
      treeNodeRequiredProps,
      onMouseMove: function onMouseMove() {
        onActiveChange(null);
      }
    }));
  }));
};
var NodeList = /* @__PURE__ */ React.forwardRef(RefNodeList);
NodeList.displayName = "NodeList";
function DropIndicator(_ref) {
  var dropPosition = _ref.dropPosition, dropLevelOffset = _ref.dropLevelOffset, indent = _ref.indent;
  var style2 = {
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    backgroundColor: "red",
    height: 2
  };
  switch (dropPosition) {
    case -1:
      style2.top = 0;
      style2.left = -dropLevelOffset * indent;
      break;
    case 1:
      style2.bottom = 0;
      style2.left = -dropLevelOffset * indent;
      break;
    case 0:
      style2.bottom = 0;
      style2.left = indent;
      break;
  }
  return /* @__PURE__ */ React.createElement("div", {
    style: style2
  });
}
var Tree$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Tree2, _React$Component);
  var _super = _createSuper$1(Tree2);
  function Tree2() {
    var _this2;
    _classCallCheck$2(this, Tree2);
    _this2 = _super.apply(this, arguments);
    _this2.destroyed = false;
    _this2.state = {
      keyEntities: {},
      indent: null,
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],
      expandedKeys: [],
      dragging: false,
      dragChildrenKeys: [],
      dropTargetKey: null,
      dropPosition: null,
      dropContainerKey: null,
      dropLevelOffset: null,
      dropTargetPos: null,
      dropAllowed: true,
      dragOverNodeKey: null,
      treeData: [],
      flattenNodes: [],
      focused: false,
      activeKey: null,
      listChanging: false,
      prevProps: null
    };
    _this2.dragStartMousePosition = null;
    _this2.listRef = /* @__PURE__ */ React.createRef();
    _this2.onNodeDragStart = function(event, node) {
      var _this$state = _this2.state, expandedKeys = _this$state.expandedKeys, keyEntities = _this$state.keyEntities;
      var onDragStart = _this2.props.onDragStart;
      var eventKey = node.props.eventKey;
      _this2.dragNode = node;
      _this2.dragStartMousePosition = {
        x: event.clientX,
        y: event.clientY
      };
      var newExpandedKeys = arrDel(expandedKeys, eventKey);
      _this2.setState({
        dragging: true,
        dragChildrenKeys: getDragChildrenKeys(eventKey, keyEntities),
        indent: _this2.listRef.current.getIndentWidth()
      });
      _this2.setExpandedKeys(newExpandedKeys);
      window.addEventListener("dragend", _this2.onWindowDragEnd);
      if (onDragStart) {
        onDragStart({
          event,
          node: convertNodePropsToEventData(node.props)
        });
      }
    };
    _this2.onNodeDragEnter = function(event, node) {
      var _this$state2 = _this2.state, expandedKeys = _this$state2.expandedKeys, keyEntities = _this$state2.keyEntities, dragChildrenKeys = _this$state2.dragChildrenKeys, flattenNodes = _this$state2.flattenNodes, indent = _this$state2.indent;
      var _this$props = _this2.props, onDragEnter = _this$props.onDragEnter, onExpand = _this$props.onExpand, allowDrop2 = _this$props.allowDrop, direction = _this$props.direction;
      var pos = node.props.pos;
      var _assertThisInitialize = _assertThisInitialized$1(_this2), dragNode = _assertThisInitialize.dragNode;
      var _calcDropPosition = calcDropPosition(event, dragNode, node, indent, _this2.dragStartMousePosition, allowDrop2, flattenNodes, keyEntities, expandedKeys, direction), dropPosition = _calcDropPosition.dropPosition, dropLevelOffset = _calcDropPosition.dropLevelOffset, dropTargetKey = _calcDropPosition.dropTargetKey, dropContainerKey = _calcDropPosition.dropContainerKey, dropTargetPos = _calcDropPosition.dropTargetPos, dropAllowed = _calcDropPosition.dropAllowed, dragOverNodeKey = _calcDropPosition.dragOverNodeKey;
      if (!dragNode || dragChildrenKeys.indexOf(dropTargetKey) !== -1 || !dropAllowed) {
        _this2.setState({
          dragOverNodeKey: null,
          dropPosition: null,
          dropLevelOffset: null,
          dropTargetKey: null,
          dropContainerKey: null,
          dropTargetPos: null,
          dropAllowed: false
        });
        return;
      }
      if (!_this2.delayedDragEnterLogic) {
        _this2.delayedDragEnterLogic = {};
      }
      Object.keys(_this2.delayedDragEnterLogic).forEach(function(key2) {
        clearTimeout(_this2.delayedDragEnterLogic[key2]);
      });
      if (dragNode.props.eventKey !== node.props.eventKey) {
        event.persist();
        _this2.delayedDragEnterLogic[pos] = window.setTimeout(function() {
          if (!_this2.state.dragging)
            return;
          var newExpandedKeys = _toConsumableArray(expandedKeys);
          var entity = keyEntities[node.props.eventKey];
          if (entity && (entity.children || []).length) {
            newExpandedKeys = arrAdd(expandedKeys, node.props.eventKey);
          }
          if (!("expandedKeys" in _this2.props)) {
            _this2.setExpandedKeys(newExpandedKeys);
          }
          if (onExpand) {
            onExpand(newExpandedKeys, {
              node: convertNodePropsToEventData(node.props),
              expanded: true,
              nativeEvent: event.nativeEvent
            });
          }
        }, 800);
      }
      if (dragNode.props.eventKey === dropTargetKey && dropLevelOffset === 0) {
        _this2.setState({
          dragOverNodeKey: null,
          dropPosition: null,
          dropLevelOffset: null,
          dropTargetKey: null,
          dropContainerKey: null,
          dropTargetPos: null,
          dropAllowed: false
        });
        return;
      }
      _this2.setState({
        dragOverNodeKey,
        dropPosition,
        dropLevelOffset,
        dropTargetKey,
        dropContainerKey,
        dropTargetPos,
        dropAllowed
      });
      if (onDragEnter) {
        onDragEnter({
          event,
          node: convertNodePropsToEventData(node.props),
          expandedKeys
        });
      }
    };
    _this2.onNodeDragOver = function(event, node) {
      var _this$state3 = _this2.state, dragChildrenKeys = _this$state3.dragChildrenKeys, flattenNodes = _this$state3.flattenNodes, keyEntities = _this$state3.keyEntities, expandedKeys = _this$state3.expandedKeys, indent = _this$state3.indent;
      var _this$props2 = _this2.props, onDragOver = _this$props2.onDragOver, allowDrop2 = _this$props2.allowDrop, direction = _this$props2.direction;
      var _assertThisInitialize2 = _assertThisInitialized$1(_this2), dragNode = _assertThisInitialize2.dragNode;
      var _calcDropPosition2 = calcDropPosition(event, dragNode, node, indent, _this2.dragStartMousePosition, allowDrop2, flattenNodes, keyEntities, expandedKeys, direction), dropPosition = _calcDropPosition2.dropPosition, dropLevelOffset = _calcDropPosition2.dropLevelOffset, dropTargetKey = _calcDropPosition2.dropTargetKey, dropContainerKey = _calcDropPosition2.dropContainerKey, dropAllowed = _calcDropPosition2.dropAllowed, dropTargetPos = _calcDropPosition2.dropTargetPos, dragOverNodeKey = _calcDropPosition2.dragOverNodeKey;
      if (!dragNode || dragChildrenKeys.indexOf(dropTargetKey) !== -1 || !dropAllowed) {
        return;
      }
      if (dragNode.props.eventKey === dropTargetKey && dropLevelOffset === 0) {
        if (!(_this2.state.dropPosition === null && _this2.state.dropLevelOffset === null && _this2.state.dropTargetKey === null && _this2.state.dropContainerKey === null && _this2.state.dropTargetPos === null && _this2.state.dropAllowed === false && _this2.state.dragOverNodeKey === null)) {
          _this2.setState({
            dropPosition: null,
            dropLevelOffset: null,
            dropTargetKey: null,
            dropContainerKey: null,
            dropTargetPos: null,
            dropAllowed: false,
            dragOverNodeKey: null
          });
        }
      } else if (!(dropPosition === _this2.state.dropPosition && dropLevelOffset === _this2.state.dropLevelOffset && dropTargetKey === _this2.state.dropTargetKey && dropContainerKey === _this2.state.dropContainerKey && dropTargetPos === _this2.state.dropTargetPos && dropAllowed === _this2.state.dropAllowed && dragOverNodeKey === _this2.state.dragOverNodeKey)) {
        _this2.setState({
          dropPosition,
          dropLevelOffset,
          dropTargetKey,
          dropContainerKey,
          dropTargetPos,
          dropAllowed,
          dragOverNodeKey
        });
      }
      if (onDragOver) {
        onDragOver({
          event,
          node: convertNodePropsToEventData(node.props)
        });
      }
    };
    _this2.onNodeDragLeave = function(event, node) {
      var onDragLeave = _this2.props.onDragLeave;
      if (onDragLeave) {
        onDragLeave({
          event,
          node: convertNodePropsToEventData(node.props)
        });
      }
    };
    _this2.onWindowDragEnd = function(event) {
      _this2.onNodeDragEnd(event, null, true);
      window.removeEventListener("dragend", _this2.onWindowDragEnd);
    };
    _this2.onNodeDragEnd = function(event, node) {
      var outsideTree = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      var onDragEnd = _this2.props.onDragEnd;
      _this2.setState({
        dragOverNodeKey: null
      });
      _this2.cleanDragState();
      if (onDragEnd && !outsideTree) {
        onDragEnd({
          event,
          node: convertNodePropsToEventData(node.props)
        });
      }
      _this2.dragNode = null;
    };
    _this2.onNodeDrop = function(event, node) {
      var _this$getActiveItem;
      var outsideTree = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      var _this$state4 = _this2.state, dragChildrenKeys = _this$state4.dragChildrenKeys, dropPosition = _this$state4.dropPosition, dropTargetKey = _this$state4.dropTargetKey, dropTargetPos = _this$state4.dropTargetPos, dropAllowed = _this$state4.dropAllowed;
      if (!dropAllowed)
        return;
      var onDrop = _this2.props.onDrop;
      _this2.setState({
        dragOverNodeKey: null
      });
      _this2.cleanDragState();
      if (dropTargetKey === null)
        return;
      var abstractDropNodeProps = _objectSpread2$1(_objectSpread2$1({}, getTreeNodeProps(dropTargetKey, _this2.getTreeNodeRequiredProps())), {}, {
        active: ((_this$getActiveItem = _this2.getActiveItem()) === null || _this$getActiveItem === void 0 ? void 0 : _this$getActiveItem.data.key) === dropTargetKey,
        data: _this2.state.keyEntities[dropTargetKey].node
      });
      var dropToChild = dragChildrenKeys.indexOf(dropTargetKey) !== -1;
      warningOnce(!dropToChild, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
      var posArr = posToArr(dropTargetPos);
      var dropResult = {
        event,
        node: convertNodePropsToEventData(abstractDropNodeProps),
        dragNode: _this2.dragNode ? convertNodePropsToEventData(_this2.dragNode.props) : null,
        dragNodesKeys: [_this2.dragNode.props.eventKey].concat(dragChildrenKeys),
        dropToGap: dropPosition !== 0,
        dropPosition: dropPosition + Number(posArr[posArr.length - 1])
      };
      if (onDrop && !outsideTree) {
        onDrop(dropResult);
      }
      _this2.dragNode = null;
    };
    _this2.cleanDragState = function() {
      var dragging = _this2.state.dragging;
      if (dragging) {
        _this2.setState({
          dragging: false,
          dropPosition: null,
          dropContainerKey: null,
          dropTargetKey: null,
          dropLevelOffset: null,
          dropAllowed: true,
          dragOverNodeKey: null
        });
      }
      _this2.dragStartMousePosition = null;
    };
    _this2.onNodeClick = function(e3, treeNode) {
      var onClick = _this2.props.onClick;
      if (onClick) {
        onClick(e3, treeNode);
      }
    };
    _this2.onNodeDoubleClick = function(e3, treeNode) {
      var onDoubleClick = _this2.props.onDoubleClick;
      if (onDoubleClick) {
        onDoubleClick(e3, treeNode);
      }
    };
    _this2.onNodeSelect = function(e3, treeNode) {
      var selectedKeys = _this2.state.selectedKeys;
      var keyEntities = _this2.state.keyEntities;
      var _this$props3 = _this2.props, onSelect = _this$props3.onSelect, multiple = _this$props3.multiple;
      var selected = treeNode.selected, key2 = treeNode.key;
      var targetSelected = !selected;
      if (!targetSelected) {
        selectedKeys = arrDel(selectedKeys, key2);
      } else if (!multiple) {
        selectedKeys = [key2];
      } else {
        selectedKeys = arrAdd(selectedKeys, key2);
      }
      var selectedNodes = selectedKeys.map(function(selectedKey) {
        var entity = keyEntities[selectedKey];
        if (!entity)
          return null;
        return entity.node;
      }).filter(function(node) {
        return node;
      });
      _this2.setUncontrolledState({
        selectedKeys
      });
      if (onSelect) {
        onSelect(selectedKeys, {
          event: "select",
          selected: targetSelected,
          node: treeNode,
          selectedNodes,
          nativeEvent: e3.nativeEvent
        });
      }
    };
    _this2.onNodeCheck = function(e3, treeNode, checked) {
      var _this$state5 = _this2.state, keyEntities = _this$state5.keyEntities, oriCheckedKeys = _this$state5.checkedKeys, oriHalfCheckedKeys = _this$state5.halfCheckedKeys;
      var _this$props4 = _this2.props, checkStrictly = _this$props4.checkStrictly, onCheck = _this$props4.onCheck;
      var key2 = treeNode.key;
      var checkedObj;
      var eventObj = {
        event: "check",
        node: treeNode,
        checked,
        nativeEvent: e3.nativeEvent
      };
      if (checkStrictly) {
        var checkedKeys = checked ? arrAdd(oriCheckedKeys, key2) : arrDel(oriCheckedKeys, key2);
        var halfCheckedKeys = arrDel(oriHalfCheckedKeys, key2);
        checkedObj = {
          checked: checkedKeys,
          halfChecked: halfCheckedKeys
        };
        eventObj.checkedNodes = checkedKeys.map(function(checkedKey) {
          return keyEntities[checkedKey];
        }).filter(function(entity) {
          return entity;
        }).map(function(entity) {
          return entity.node;
        });
        _this2.setUncontrolledState({
          checkedKeys
        });
      } else {
        var _conductCheck = conductCheck([].concat(_toConsumableArray(oriCheckedKeys), [key2]), true, keyEntities), _checkedKeys = _conductCheck.checkedKeys, _halfCheckedKeys = _conductCheck.halfCheckedKeys;
        if (!checked) {
          var keySet = new Set(_checkedKeys);
          keySet.delete(key2);
          var _conductCheck2 = conductCheck(Array.from(keySet), {
            checked: false,
            halfCheckedKeys: _halfCheckedKeys
          }, keyEntities);
          _checkedKeys = _conductCheck2.checkedKeys;
          _halfCheckedKeys = _conductCheck2.halfCheckedKeys;
        }
        checkedObj = _checkedKeys;
        eventObj.checkedNodes = [];
        eventObj.checkedNodesPositions = [];
        eventObj.halfCheckedKeys = _halfCheckedKeys;
        _checkedKeys.forEach(function(checkedKey) {
          var entity = keyEntities[checkedKey];
          if (!entity)
            return;
          var node = entity.node, pos = entity.pos;
          eventObj.checkedNodes.push(node);
          eventObj.checkedNodesPositions.push({
            node,
            pos
          });
        });
        _this2.setUncontrolledState({
          checkedKeys: _checkedKeys
        }, false, {
          halfCheckedKeys: _halfCheckedKeys
        });
      }
      if (onCheck) {
        onCheck(checkedObj, eventObj);
      }
    };
    _this2.onNodeLoad = function(treeNode) {
      return new Promise(function(resolve) {
        _this2.setState(function(_ref) {
          var _ref$loadedKeys = _ref.loadedKeys, loadedKeys = _ref$loadedKeys === void 0 ? [] : _ref$loadedKeys, _ref$loadingKeys = _ref.loadingKeys, loadingKeys = _ref$loadingKeys === void 0 ? [] : _ref$loadingKeys;
          var _this$props5 = _this2.props, loadData = _this$props5.loadData, onLoad = _this$props5.onLoad;
          var key2 = treeNode.key;
          if (!loadData || loadedKeys.indexOf(key2) !== -1 || loadingKeys.indexOf(key2) !== -1) {
            return {};
          }
          var promise = loadData(treeNode);
          promise.then(function() {
            var _this$state6 = _this2.state, currentLoadedKeys = _this$state6.loadedKeys, currentLoadingKeys = _this$state6.loadingKeys;
            var newLoadedKeys = arrAdd(currentLoadedKeys, key2);
            var newLoadingKeys = arrDel(currentLoadingKeys, key2);
            if (onLoad) {
              onLoad(newLoadedKeys, {
                event: "load",
                node: treeNode
              });
            }
            _this2.setUncontrolledState({
              loadedKeys: newLoadedKeys
            });
            _this2.setState({
              loadingKeys: newLoadingKeys
            });
            resolve();
          });
          return {
            loadingKeys: arrAdd(loadingKeys, key2)
          };
        });
      });
    };
    _this2.onNodeMouseEnter = function(event, node) {
      var onMouseEnter = _this2.props.onMouseEnter;
      if (onMouseEnter) {
        onMouseEnter({
          event,
          node
        });
      }
    };
    _this2.onNodeMouseLeave = function(event, node) {
      var onMouseLeave = _this2.props.onMouseLeave;
      if (onMouseLeave) {
        onMouseLeave({
          event,
          node
        });
      }
    };
    _this2.onNodeContextMenu = function(event, node) {
      var onRightClick = _this2.props.onRightClick;
      if (onRightClick) {
        event.preventDefault();
        onRightClick({
          event,
          node
        });
      }
    };
    _this2.onFocus = function() {
      var onFocus2 = _this2.props.onFocus;
      _this2.setState({
        focused: true
      });
      if (onFocus2) {
        onFocus2.apply(void 0, arguments);
      }
    };
    _this2.onBlur = function() {
      var onBlur2 = _this2.props.onBlur;
      _this2.setState({
        focused: false
      });
      _this2.onActiveChange(null);
      if (onBlur2) {
        onBlur2.apply(void 0, arguments);
      }
    };
    _this2.getTreeNodeRequiredProps = function() {
      var _this$state7 = _this2.state, expandedKeys = _this$state7.expandedKeys, selectedKeys = _this$state7.selectedKeys, loadedKeys = _this$state7.loadedKeys, loadingKeys = _this$state7.loadingKeys, checkedKeys = _this$state7.checkedKeys, halfCheckedKeys = _this$state7.halfCheckedKeys, dragOverNodeKey = _this$state7.dragOverNodeKey, dropPosition = _this$state7.dropPosition, keyEntities = _this$state7.keyEntities;
      return {
        expandedKeys: expandedKeys || [],
        selectedKeys: selectedKeys || [],
        loadedKeys: loadedKeys || [],
        loadingKeys: loadingKeys || [],
        checkedKeys: checkedKeys || [],
        halfCheckedKeys: halfCheckedKeys || [],
        dragOverNodeKey,
        dropPosition,
        keyEntities
      };
    };
    _this2.setExpandedKeys = function(expandedKeys) {
      var treeData = _this2.state.treeData;
      var flattenNodes = flattenTreeData(treeData, expandedKeys);
      _this2.setUncontrolledState({
        expandedKeys,
        flattenNodes
      }, true);
    };
    _this2.onNodeExpand = function(e3, treeNode) {
      var expandedKeys = _this2.state.expandedKeys;
      var listChanging = _this2.state.listChanging;
      var _this$props6 = _this2.props, onExpand = _this$props6.onExpand, loadData = _this$props6.loadData;
      var key2 = treeNode.key, expanded = treeNode.expanded;
      if (listChanging) {
        return;
      }
      var index2 = expandedKeys.indexOf(key2);
      var targetExpanded = !expanded;
      warningOnce(expanded && index2 !== -1 || !expanded && index2 === -1, "Expand state not sync with index check");
      if (targetExpanded) {
        expandedKeys = arrAdd(expandedKeys, key2);
      } else {
        expandedKeys = arrDel(expandedKeys, key2);
      }
      _this2.setExpandedKeys(expandedKeys);
      if (onExpand) {
        onExpand(expandedKeys, {
          node: treeNode,
          expanded: targetExpanded,
          nativeEvent: e3.nativeEvent
        });
      }
      if (targetExpanded && loadData) {
        var loadPromise = _this2.onNodeLoad(treeNode);
        if (loadPromise) {
          loadPromise.then(function() {
            var newFlattenTreeData = flattenTreeData(_this2.state.treeData, expandedKeys);
            _this2.setUncontrolledState({
              flattenNodes: newFlattenTreeData
            });
          });
        }
      }
    };
    _this2.onListChangeStart = function() {
      _this2.setUncontrolledState({
        listChanging: true
      });
    };
    _this2.onListChangeEnd = function() {
      setTimeout(function() {
        _this2.setUncontrolledState({
          listChanging: false
        });
      });
    };
    _this2.onActiveChange = function(newActiveKey) {
      var activeKey = _this2.state.activeKey;
      var onActiveChange = _this2.props.onActiveChange;
      if (activeKey === newActiveKey) {
        return;
      }
      _this2.setState({
        activeKey: newActiveKey
      });
      if (newActiveKey !== null) {
        _this2.scrollTo({
          key: newActiveKey
        });
      }
      if (onActiveChange) {
        onActiveChange(newActiveKey);
      }
    };
    _this2.getActiveItem = function() {
      var _this$state8 = _this2.state, activeKey = _this$state8.activeKey, flattenNodes = _this$state8.flattenNodes;
      if (activeKey === null) {
        return null;
      }
      return flattenNodes.find(function(_ref2) {
        var key2 = _ref2.data.key;
        return key2 === activeKey;
      }) || null;
    };
    _this2.offsetActiveKey = function(offset3) {
      var _this$state9 = _this2.state, flattenNodes = _this$state9.flattenNodes, activeKey = _this$state9.activeKey;
      var index2 = flattenNodes.findIndex(function(_ref3) {
        var key3 = _ref3.data.key;
        return key3 === activeKey;
      });
      if (index2 === -1 && offset3 < 0) {
        index2 = flattenNodes.length;
      }
      index2 = (index2 + offset3 + flattenNodes.length) % flattenNodes.length;
      var item = flattenNodes[index2];
      if (item) {
        var key2 = item.data.key;
        _this2.onActiveChange(key2);
      } else {
        _this2.onActiveChange(null);
      }
    };
    _this2.onKeyDown = function(event) {
      var _this$state10 = _this2.state, activeKey = _this$state10.activeKey, expandedKeys = _this$state10.expandedKeys, checkedKeys = _this$state10.checkedKeys;
      var _this$props7 = _this2.props, onKeyDown2 = _this$props7.onKeyDown, checkable = _this$props7.checkable, selectable = _this$props7.selectable;
      switch (event.which) {
        case KeyCode.UP: {
          _this2.offsetActiveKey(-1);
          event.preventDefault();
          break;
        }
        case KeyCode.DOWN: {
          _this2.offsetActiveKey(1);
          event.preventDefault();
          break;
        }
      }
      var activeItem = _this2.getActiveItem();
      if (activeItem && activeItem.data) {
        var treeNodeRequiredProps = _this2.getTreeNodeRequiredProps();
        var expandable = activeItem.data.isLeaf === false || !!(activeItem.data.children || []).length;
        var eventNode = convertNodePropsToEventData(_objectSpread2$1(_objectSpread2$1({}, getTreeNodeProps(activeKey, treeNodeRequiredProps)), {}, {
          data: activeItem.data,
          active: true
        }));
        switch (event.which) {
          case KeyCode.LEFT: {
            if (expandable && expandedKeys.includes(activeKey)) {
              _this2.onNodeExpand({}, eventNode);
            } else if (activeItem.parent) {
              _this2.onActiveChange(activeItem.parent.data.key);
            }
            event.preventDefault();
            break;
          }
          case KeyCode.RIGHT: {
            if (expandable && !expandedKeys.includes(activeKey)) {
              _this2.onNodeExpand({}, eventNode);
            } else if (activeItem.children && activeItem.children.length) {
              _this2.onActiveChange(activeItem.children[0].data.key);
            }
            event.preventDefault();
            break;
          }
          case KeyCode.ENTER:
          case KeyCode.SPACE: {
            if (checkable && !eventNode.disabled && eventNode.checkable !== false && !eventNode.disableCheckbox) {
              _this2.onNodeCheck({}, eventNode, !checkedKeys.includes(activeKey));
            } else if (!checkable && selectable && !eventNode.disabled && eventNode.selectable !== false) {
              _this2.onNodeSelect({}, eventNode);
            }
            break;
          }
        }
      }
      if (onKeyDown2) {
        onKeyDown2(event);
      }
    };
    _this2.setUncontrolledState = function(state) {
      var atomic = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var forceState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (_this2.destroyed) {
        return;
      }
      var needSync = false;
      var allPassed = true;
      var newState = {};
      Object.keys(state).forEach(function(name) {
        if (name in _this2.props) {
          allPassed = false;
          return;
        }
        needSync = true;
        newState[name] = state[name];
      });
      if (needSync && (!atomic || allPassed)) {
        _this2.setState(_objectSpread2$1(_objectSpread2$1({}, newState), forceState));
      }
    };
    _this2.scrollTo = function(scroll) {
      _this2.listRef.current.scrollTo(scroll);
    };
    return _this2;
  }
  _createClass$2(Tree2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("dragend", this.onWindowDragEnd);
      this.destroyed = true;
    }
  }, {
    key: "render",
    value: function render4() {
      var _classNames;
      var _this$state11 = this.state, focused = _this$state11.focused, flattenNodes = _this$state11.flattenNodes, keyEntities = _this$state11.keyEntities, dragging = _this$state11.dragging, activeKey = _this$state11.activeKey, dropLevelOffset = _this$state11.dropLevelOffset, dropContainerKey = _this$state11.dropContainerKey, dropTargetKey = _this$state11.dropTargetKey, dropPosition = _this$state11.dropPosition, dragOverNodeKey = _this$state11.dragOverNodeKey, indent = _this$state11.indent;
      var _this$props8 = this.props, prefixCls = _this$props8.prefixCls, className = _this$props8.className, style2 = _this$props8.style, showLine = _this$props8.showLine, focusable = _this$props8.focusable, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, selectable = _this$props8.selectable, showIcon = _this$props8.showIcon, icon = _this$props8.icon, switcherIcon = _this$props8.switcherIcon, draggable = _this$props8.draggable, checkable = _this$props8.checkable, checkStrictly = _this$props8.checkStrictly, disabled = _this$props8.disabled, motion = _this$props8.motion, loadData = _this$props8.loadData, filterTreeNode = _this$props8.filterTreeNode, height = _this$props8.height, itemHeight = _this$props8.itemHeight, virtual = _this$props8.virtual, titleRender = _this$props8.titleRender, dropIndicatorRender2 = _this$props8.dropIndicatorRender, onContextMenu = _this$props8.onContextMenu, direction = _this$props8.direction;
      var domProps = getDataAndAria(this.props);
      return /* @__PURE__ */ React.createElement(TreeContext.Provider, {
        value: {
          prefixCls,
          selectable,
          showIcon,
          icon,
          switcherIcon,
          draggable,
          checkable,
          checkStrictly,
          disabled,
          keyEntities,
          dropLevelOffset,
          dropContainerKey,
          dropTargetKey,
          dropPosition,
          dragOverNodeKey,
          indent,
          direction,
          dropIndicatorRender: dropIndicatorRender2,
          loadData,
          filterTreeNode,
          titleRender,
          onNodeClick: this.onNodeClick,
          onNodeDoubleClick: this.onNodeDoubleClick,
          onNodeExpand: this.onNodeExpand,
          onNodeSelect: this.onNodeSelect,
          onNodeCheck: this.onNodeCheck,
          onNodeLoad: this.onNodeLoad,
          onNodeMouseEnter: this.onNodeMouseEnter,
          onNodeMouseLeave: this.onNodeMouseLeave,
          onNodeContextMenu: this.onNodeContextMenu,
          onNodeDragStart: this.onNodeDragStart,
          onNodeDragEnter: this.onNodeDragEnter,
          onNodeDragOver: this.onNodeDragOver,
          onNodeDragLeave: this.onNodeDragLeave,
          onNodeDragEnd: this.onNodeDragEnd,
          onNodeDrop: this.onNodeDrop
        }
      }, /* @__PURE__ */ React.createElement("div", {
        className: cn(prefixCls, className, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-show-line"), showLine), _defineProperty$4(_classNames, "".concat(prefixCls, "-focused"), focused), _defineProperty$4(_classNames, "".concat(prefixCls, "-active-focused"), activeKey !== null), _classNames))
      }, /* @__PURE__ */ React.createElement(NodeList, _extends$2({
        ref: this.listRef,
        prefixCls,
        style: style2,
        data: flattenNodes,
        disabled,
        selectable,
        checkable: !!checkable,
        motion,
        dragging,
        height,
        itemHeight,
        virtual,
        focusable,
        focused,
        tabIndex,
        activeItem: this.getActiveItem(),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onActiveChange: this.onActiveChange,
        onListChangeStart: this.onListChangeStart,
        onListChangeEnd: this.onListChangeEnd,
        onContextMenu
      }, this.getTreeNodeRequiredProps(), domProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, prevState) {
      var prevProps = prevState.prevProps;
      var newState = {
        prevProps: props
      };
      function needSync(name) {
        return !prevProps && name in props || prevProps && prevProps[name] !== props[name];
      }
      var treeData;
      if (needSync("treeData")) {
        treeData = props.treeData;
      } else if (needSync("children")) {
        warningOnce(false, "`children` of Tree is deprecated. Please use `treeData` instead.");
        treeData = convertTreeToData(props.children);
      }
      if (treeData) {
        newState.treeData = treeData;
        var entitiesMap = convertDataToEntities(treeData);
        newState.keyEntities = _objectSpread2$1(_defineProperty$4({}, MOTION_KEY, MotionEntity), entitiesMap.keyEntities);
        if (process.env.NODE_ENV !== "production") {
          warningWithoutKey(treeData);
        }
      }
      var keyEntities = newState.keyEntities || prevState.keyEntities;
      if (needSync("expandedKeys") || prevProps && needSync("autoExpandParent")) {
        newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? conductExpandParent(props.expandedKeys, keyEntities) : props.expandedKeys;
      } else if (!prevProps && props.defaultExpandAll) {
        var cloneKeyEntities = _objectSpread2$1({}, keyEntities);
        delete cloneKeyEntities[MOTION_KEY];
        newState.expandedKeys = Object.keys(cloneKeyEntities).map(function(key2) {
          return cloneKeyEntities[key2].key;
        });
      } else if (!prevProps && props.defaultExpandedKeys) {
        newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? conductExpandParent(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
      }
      if (!newState.expandedKeys) {
        delete newState.expandedKeys;
      }
      if (treeData || newState.expandedKeys) {
        var flattenNodes = flattenTreeData(treeData || prevState.treeData, newState.expandedKeys || prevState.expandedKeys);
        newState.flattenNodes = flattenNodes;
      }
      if (props.selectable) {
        if (needSync("selectedKeys")) {
          newState.selectedKeys = calcSelectedKeys(props.selectedKeys, props);
        } else if (!prevProps && props.defaultSelectedKeys) {
          newState.selectedKeys = calcSelectedKeys(props.defaultSelectedKeys, props);
        }
      }
      if (props.checkable) {
        var checkedKeyEntity;
        if (needSync("checkedKeys")) {
          checkedKeyEntity = parseCheckedKeys(props.checkedKeys) || {};
        } else if (!prevProps && props.defaultCheckedKeys) {
          checkedKeyEntity = parseCheckedKeys(props.defaultCheckedKeys) || {};
        } else if (treeData) {
          checkedKeyEntity = parseCheckedKeys(props.checkedKeys) || {
            checkedKeys: prevState.checkedKeys,
            halfCheckedKeys: prevState.halfCheckedKeys
          };
        }
        if (checkedKeyEntity) {
          var _checkedKeyEntity = checkedKeyEntity, _checkedKeyEntity$che = _checkedKeyEntity.checkedKeys, checkedKeys = _checkedKeyEntity$che === void 0 ? [] : _checkedKeyEntity$che, _checkedKeyEntity$hal = _checkedKeyEntity.halfCheckedKeys, halfCheckedKeys = _checkedKeyEntity$hal === void 0 ? [] : _checkedKeyEntity$hal;
          if (!props.checkStrictly) {
            var conductKeys = conductCheck(checkedKeys, true, keyEntities);
            checkedKeys = conductKeys.checkedKeys;
            halfCheckedKeys = conductKeys.halfCheckedKeys;
          }
          newState.checkedKeys = checkedKeys;
          newState.halfCheckedKeys = halfCheckedKeys;
        }
      }
      if (needSync("loadedKeys")) {
        newState.loadedKeys = props.loadedKeys;
      }
      return newState;
    }
  }]);
  return Tree2;
}(React.Component);
Tree$1.defaultProps = {
  prefixCls: "rc-tree",
  showLine: false,
  showIcon: true,
  selectable: true,
  multiple: false,
  checkable: false,
  disabled: false,
  checkStrictly: false,
  draggable: false,
  defaultExpandParent: true,
  autoExpandParent: false,
  defaultExpandAll: false,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: [],
  dropIndicatorRender: DropIndicator,
  allowDrop: function allowDrop() {
    return true;
  }
};
Tree$1.TreeNode = ContextTreeNode;
var FileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file", "theme": "outlined" };
var FileOutlined = function FileOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: FileOutlined$2
  }));
};
FileOutlined.displayName = "FileOutlined";
var FileOutlined$1 = /* @__PURE__ */ React.forwardRef(FileOutlined);
var FolderOpenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, "name": "folder-open", "theme": "outlined" };
var FolderOpenOutlined = function FolderOpenOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: FolderOpenOutlined$2
  }));
};
FolderOpenOutlined.displayName = "FolderOpenOutlined";
var FolderOpenOutlined$1 = /* @__PURE__ */ React.forwardRef(FolderOpenOutlined);
var FolderOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, "name": "folder", "theme": "outlined" };
var FolderOutlined = function FolderOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: FolderOutlined$2
  }));
};
FolderOutlined.displayName = "FolderOutlined";
var FolderOutlined$1 = /* @__PURE__ */ React.forwardRef(FolderOutlined);
var Record;
(function(Record2) {
  Record2[Record2["None"] = 0] = "None";
  Record2[Record2["Start"] = 1] = "Start";
  Record2[Record2["End"] = 2] = "End";
})(Record || (Record = {}));
function traverseNodesKey(treeData, callback) {
  function processNode(dataNode) {
    var key2 = dataNode.key, children = dataNode.children;
    if (callback(key2, dataNode) !== false) {
      traverseNodesKey(children || [], callback);
    }
  }
  treeData.forEach(processNode);
}
function calcRangeKeys(_ref) {
  var treeData = _ref.treeData, expandedKeys = _ref.expandedKeys, startKey = _ref.startKey, endKey = _ref.endKey;
  var keys2 = [];
  var record = Record.None;
  if (startKey && startKey === endKey) {
    return [startKey];
  }
  if (!startKey || !endKey) {
    return [];
  }
  function matchKey(key2) {
    return key2 === startKey || key2 === endKey;
  }
  traverseNodesKey(treeData, function(key2) {
    if (record === Record.End) {
      return false;
    }
    if (matchKey(key2)) {
      keys2.push(key2);
      if (record === Record.None) {
        record = Record.Start;
      } else if (record === Record.Start) {
        record = Record.End;
        return false;
      }
    } else if (record === Record.Start) {
      keys2.push(key2);
    }
    if (expandedKeys.indexOf(key2) === -1) {
      return false;
    }
    return true;
  });
  return keys2;
}
function convertDirectoryKeysToNodes(treeData, keys2) {
  var restKeys = _toConsumableArray(keys2);
  var nodes = [];
  traverseNodesKey(treeData, function(key2, node) {
    var index2 = restKeys.indexOf(key2);
    if (index2 !== -1) {
      nodes.push(node);
      restKeys.splice(index2, 1);
    }
    return !!restKeys.length;
  });
  return nodes;
}
var __rest$8 = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
function getIcon(props) {
  var isLeaf = props.isLeaf, expanded = props.expanded;
  if (isLeaf) {
    return /* @__PURE__ */ React.createElement(FileOutlined$1, null);
  }
  return expanded ? /* @__PURE__ */ React.createElement(FolderOpenOutlined$1, null) : /* @__PURE__ */ React.createElement(FolderOutlined$1, null);
}
function getTreeData(_ref) {
  var treeData = _ref.treeData, children = _ref.children;
  return treeData || convertTreeToData(children);
}
var DirectoryTree = function DirectoryTree2(_a, ref) {
  var defaultExpandAll = _a.defaultExpandAll, defaultExpandParent = _a.defaultExpandParent, defaultExpandedKeys = _a.defaultExpandedKeys, props = __rest$8(_a, ["defaultExpandAll", "defaultExpandParent", "defaultExpandedKeys"]);
  var lastSelectedKey = React.useRef();
  var cachedSelectedKeys = React.useRef();
  var treeRef = /* @__PURE__ */ React.createRef();
  React.useImperativeHandle(ref, function() {
    return treeRef.current;
  });
  var getInitExpandedKeys = function getInitExpandedKeys2() {
    var _convertDataToEntitie = convertDataToEntities(getTreeData(props)), keyEntities = _convertDataToEntitie.keyEntities;
    var initExpandedKeys;
    if (defaultExpandAll) {
      initExpandedKeys = Object.keys(keyEntities);
    } else if (defaultExpandParent) {
      initExpandedKeys = conductExpandParent(props.expandedKeys || defaultExpandedKeys, keyEntities);
    } else {
      initExpandedKeys = props.expandedKeys || defaultExpandedKeys;
    }
    return initExpandedKeys;
  };
  var _React$useState = React.useState(props.selectedKeys || props.defaultSelectedKeys || []), _React$useState2 = _slicedToArray$3(_React$useState, 2), selectedKeys = _React$useState2[0], setSelectedKeys = _React$useState2[1];
  var _React$useState3 = React.useState(getInitExpandedKeys()), _React$useState4 = _slicedToArray$3(_React$useState3, 2), expandedKeys = _React$useState4[0], setExpandedKeys = _React$useState4[1];
  React.useEffect(function() {
    if ("selectedKeys" in props) {
      setSelectedKeys(props.selectedKeys);
    }
  }, [props.selectedKeys]);
  React.useEffect(function() {
    if ("expandedKeys" in props) {
      setExpandedKeys(props.expandedKeys);
    }
  }, [props.expandedKeys]);
  var expandFolderNode = function expandFolderNode2(event, node) {
    var isLeaf = node.isLeaf;
    if (isLeaf || event.shiftKey || event.metaKey || event.ctrlKey) {
      return;
    }
    treeRef.current.onNodeExpand(event, node);
  };
  var onDebounceExpand = debounce_1(expandFolderNode, 200, {
    leading: true
  });
  var onExpand = function onExpand2(keys2, info) {
    var _a2;
    if (!("expandedKeys" in props)) {
      setExpandedKeys(keys2);
    }
    return (_a2 = props.onExpand) === null || _a2 === void 0 ? void 0 : _a2.call(props, keys2, info);
  };
  var onClick = function onClick2(event, node) {
    var _a2;
    var expandAction = props.expandAction;
    if (expandAction === "click") {
      onDebounceExpand(event, node);
    }
    (_a2 = props.onClick) === null || _a2 === void 0 ? void 0 : _a2.call(props, event, node);
  };
  var onDoubleClick = function onDoubleClick2(event, node) {
    var _a2;
    var expandAction = props.expandAction;
    if (expandAction === "doubleClick") {
      onDebounceExpand(event, node);
    }
    (_a2 = props.onDoubleClick) === null || _a2 === void 0 ? void 0 : _a2.call(props, event, node);
  };
  var onSelect = function onSelect2(keys2, event) {
    var _a2;
    var multiple = props.multiple;
    var node = event.node, nativeEvent = event.nativeEvent;
    var _node$key = node.key, key2 = _node$key === void 0 ? "" : _node$key;
    var treeData = getTreeData(props);
    var newEvent = _extends$2(_extends$2({}, event), {
      selected: true
    });
    var ctrlPick = nativeEvent.ctrlKey || nativeEvent.metaKey;
    var shiftPick = nativeEvent.shiftKey;
    var newSelectedKeys;
    if (multiple && ctrlPick) {
      newSelectedKeys = keys2;
      lastSelectedKey.current = key2;
      cachedSelectedKeys.current = newSelectedKeys;
      newEvent.selectedNodes = convertDirectoryKeysToNodes(treeData, newSelectedKeys);
    } else if (multiple && shiftPick) {
      newSelectedKeys = Array.from(new Set([].concat(_toConsumableArray(cachedSelectedKeys.current || []), _toConsumableArray(calcRangeKeys({
        treeData,
        expandedKeys,
        startKey: key2,
        endKey: lastSelectedKey.current
      })))));
      newEvent.selectedNodes = convertDirectoryKeysToNodes(treeData, newSelectedKeys);
    } else {
      newSelectedKeys = [key2];
      lastSelectedKey.current = key2;
      cachedSelectedKeys.current = newSelectedKeys;
      newEvent.selectedNodes = convertDirectoryKeysToNodes(treeData, newSelectedKeys);
    }
    (_a2 = props.onSelect) === null || _a2 === void 0 ? void 0 : _a2.call(props, newSelectedKeys, newEvent);
    if (!("selectedKeys" in props)) {
      setSelectedKeys(newSelectedKeys);
    }
  };
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var customizePrefixCls = props.prefixCls, className = props.className, otherProps = __rest$8(props, ["prefixCls", "className"]);
  var prefixCls = getPrefixCls("tree", customizePrefixCls);
  var connectClassName = cn("".concat(prefixCls, "-directory"), _defineProperty$4({}, "".concat(prefixCls, "-directory-rtl"), direction === "rtl"), className);
  return /* @__PURE__ */ React.createElement(Tree, _extends$2({
    icon: getIcon,
    ref: treeRef,
    blockNode: true
  }, otherProps, {
    prefixCls,
    className: connectClassName,
    expandedKeys,
    selectedKeys,
    onSelect,
    onClick,
    onDoubleClick,
    onExpand
  }));
};
var ForwardDirectoryTree = /* @__PURE__ */ React.forwardRef(DirectoryTree);
ForwardDirectoryTree.displayName = "DirectoryTree";
ForwardDirectoryTree.defaultProps = {
  showIcon: true,
  expandAction: "click"
};
var MinusSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "minus-square", "theme": "outlined" };
var MinusSquareOutlined = function MinusSquareOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: MinusSquareOutlined$2
  }));
};
MinusSquareOutlined.displayName = "MinusSquareOutlined";
var MinusSquareOutlined$1 = /* @__PURE__ */ React.forwardRef(MinusSquareOutlined);
var PlusSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "plus-square", "theme": "outlined" };
var PlusSquareOutlined = function PlusSquareOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: PlusSquareOutlined$2
  }));
};
PlusSquareOutlined.displayName = "PlusSquareOutlined";
var PlusSquareOutlined$1 = /* @__PURE__ */ React.forwardRef(PlusSquareOutlined);
var CaretDownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "filled" };
var CaretDownFilled = function CaretDownFilled2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: CaretDownFilled$2
  }));
};
CaretDownFilled.displayName = "CaretDownFilled";
var CaretDownFilled$1 = /* @__PURE__ */ React.forwardRef(CaretDownFilled);
function renderSwitcherIcon(prefixCls, switcherIcon, showLine, _ref) {
  var isLeaf = _ref.isLeaf, expanded = _ref.expanded, loading = _ref.loading;
  if (loading) {
    return /* @__PURE__ */ React.createElement(LoadingOutlined$1, {
      className: "".concat(prefixCls, "-switcher-loading-icon")
    });
  }
  var showLeafIcon;
  if (showLine && _typeof$5(showLine) === "object") {
    showLeafIcon = showLine.showLeafIcon;
  }
  if (isLeaf) {
    if (showLine) {
      if (_typeof$5(showLine) === "object" && !showLeafIcon) {
        return /* @__PURE__ */ React.createElement("span", {
          className: "".concat(prefixCls, "-switcher-leaf-line")
        });
      }
      return /* @__PURE__ */ React.createElement(FileOutlined$1, {
        className: "".concat(prefixCls, "-switcher-line-icon")
      });
    }
    return null;
  }
  var switcherCls = "".concat(prefixCls, "-switcher-icon");
  if (isValidElement2(switcherIcon)) {
    return cloneElement2(switcherIcon, {
      className: cn(switcherIcon.props.className || "", switcherCls)
    });
  }
  if (switcherIcon) {
    return switcherIcon;
  }
  if (showLine) {
    return expanded ? /* @__PURE__ */ React.createElement(MinusSquareOutlined$1, {
      className: "".concat(prefixCls, "-switcher-line-icon")
    }) : /* @__PURE__ */ React.createElement(PlusSquareOutlined$1, {
      className: "".concat(prefixCls, "-switcher-line-icon")
    });
  }
  return /* @__PURE__ */ React.createElement(CaretDownFilled$1, {
    className: switcherCls
  });
}
var offset2 = 4;
function dropIndicatorRender(props) {
  var _style;
  var dropPosition = props.dropPosition, dropLevelOffset = props.dropLevelOffset, prefixCls = props.prefixCls, indent = props.indent, _props$direction = props.direction, direction = _props$direction === void 0 ? "ltr" : _props$direction;
  var startPosition = direction === "ltr" ? "left" : "right";
  var endPosition = direction === "ltr" ? "right" : "left";
  var style2 = (_style = {}, _defineProperty$4(_style, startPosition, -dropLevelOffset * indent + offset2), _defineProperty$4(_style, endPosition, 0), _style);
  switch (dropPosition) {
    case -1:
      style2.top = -3;
      break;
    case 1:
      style2.bottom = -3;
      break;
    default:
      style2.bottom = -3;
      style2[startPosition] = indent + offset2;
      break;
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    style: style2,
    className: "".concat(prefixCls, "-drop-indicator")
  });
}
var Tree = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var _classNames;
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, virtual = _React$useContext.virtual;
  var customizePrefixCls = props.prefixCls, className = props.className, showIcon = props.showIcon, showLine = props.showLine, _switcherIcon = props.switcherIcon, blockNode = props.blockNode, children = props.children, checkable = props.checkable, selectable = props.selectable;
  var prefixCls = getPrefixCls("tree", customizePrefixCls);
  var newProps = _extends$2(_extends$2({}, props), {
    showLine: Boolean(showLine),
    dropIndicatorRender
  });
  return /* @__PURE__ */ React.createElement(Tree$1, _extends$2({
    itemHeight: 20,
    ref,
    virtual
  }, newProps, {
    prefixCls,
    className: cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-icon-hide"), !showIcon), _defineProperty$4(_classNames, "".concat(prefixCls, "-block-node"), blockNode), _defineProperty$4(_classNames, "".concat(prefixCls, "-unselectable"), !selectable), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className),
    direction,
    checkable: checkable ? /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-checkbox-inner")
    }) : checkable,
    selectable,
    switcherIcon: function switcherIcon(nodeProps) {
      return renderSwitcherIcon(prefixCls, _switcherIcon, showLine, nodeProps);
    }
  }), children);
});
Tree.TreeNode = ContextTreeNode;
Tree.DirectoryTree = ForwardDirectoryTree;
Tree.defaultProps = {
  checkable: false,
  selectable: true,
  showIcon: false,
  motion: _extends$2(_extends$2({}, collapseMotion), {
    motionAppear: false
  }),
  blockNode: false
};
var SelectContext = /* @__PURE__ */ React.createContext(null);
function isDisabled(dataNode, skipType) {
  if (!dataNode) {
    return true;
  }
  var _dataNode$data = dataNode.data, disabled = _dataNode$data.disabled, disableCheckbox = _dataNode$data.disableCheckbox;
  switch (skipType) {
    case "select":
      return disabled;
    case "checkbox":
      return disabled || disableCheckbox;
  }
  return false;
}
function useKeyValueMapping(cacheKeyMap, cacheValueMap) {
  var getEntityByKey = React.useCallback(function(key2) {
    var skipType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "select";
    var ignoreDisabledCheck = arguments.length > 2 ? arguments[2] : void 0;
    var dataNode = cacheKeyMap.get(key2);
    if (!ignoreDisabledCheck && isDisabled(dataNode, skipType)) {
      return null;
    }
    return dataNode;
  }, [cacheKeyMap]);
  var getEntityByValue = React.useCallback(function(value) {
    var skipType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "select";
    var ignoreDisabledCheck = arguments.length > 2 ? arguments[2] : void 0;
    var dataNode = cacheValueMap.get(value);
    if (!ignoreDisabledCheck && isDisabled(dataNode, skipType)) {
      return null;
    }
    return dataNode;
  }, [cacheValueMap]);
  return [getEntityByKey, getEntityByValue];
}
function useKeyValueMap(flattenOptions2) {
  return React.useMemo(function() {
    var cacheKeyMap = /* @__PURE__ */ new Map();
    var cacheValueMap = /* @__PURE__ */ new Map();
    flattenOptions2.forEach(function(dataNode) {
      cacheKeyMap.set(dataNode.key, dataNode);
      cacheValueMap.set(dataNode.data.value, dataNode);
    });
    return [cacheKeyMap, cacheValueMap];
  }, [flattenOptions2]);
}
var HIDDEN_STYLE = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
};
var OptionList2 = function OptionList3(props, ref) {
  var prefixCls = props.prefixCls, height = props.height, itemHeight = props.itemHeight, virtual = props.virtual, options = props.options, flattenOptions2 = props.flattenOptions, multiple = props.multiple, searchValue = props.searchValue, onSelect = props.onSelect, onToggleOpen = props.onToggleOpen, open = props.open, notFoundContent = props.notFoundContent, onMouseEnter = props.onMouseEnter;
  var _React$useContext = React.useContext(SelectContext), checkable = _React$useContext.checkable, checkedKeys = _React$useContext.checkedKeys, halfCheckedKeys = _React$useContext.halfCheckedKeys, treeExpandedKeys = _React$useContext.treeExpandedKeys, treeDefaultExpandAll = _React$useContext.treeDefaultExpandAll, treeDefaultExpandedKeys = _React$useContext.treeDefaultExpandedKeys, onTreeExpand = _React$useContext.onTreeExpand, treeIcon = _React$useContext.treeIcon, showTreeIcon = _React$useContext.showTreeIcon, switcherIcon = _React$useContext.switcherIcon, treeLine = _React$useContext.treeLine, treeNodeFilterProp = _React$useContext.treeNodeFilterProp, loadData = _React$useContext.loadData, treeLoadedKeys = _React$useContext.treeLoadedKeys, treeMotion = _React$useContext.treeMotion, onTreeLoad = _React$useContext.onTreeLoad;
  var treeRef = React.useRef();
  var memoOptions = useMemo2(function() {
    return options;
  }, [open, options], function(prev, next) {
    return next[0] && prev[1] !== next[1];
  });
  var _useKeyValueMap = useKeyValueMap(flattenOptions2), _useKeyValueMap2 = _slicedToArray$3(_useKeyValueMap, 2), cacheKeyMap = _useKeyValueMap2[0], cacheValueMap = _useKeyValueMap2[1];
  var _useKeyValueMapping = useKeyValueMapping(cacheKeyMap, cacheValueMap), _useKeyValueMapping2 = _slicedToArray$3(_useKeyValueMapping, 2), getEntityByKey = _useKeyValueMapping2[0], getEntityByValue = _useKeyValueMapping2[1];
  var valueKeys = React.useMemo(function() {
    return checkedKeys.map(function(val) {
      var entity = getEntityByValue(val);
      return entity ? entity.key : null;
    });
  }, [checkedKeys, getEntityByValue]);
  var mergedCheckedKeys = React.useMemo(function() {
    if (!checkable) {
      return null;
    }
    return {
      checked: valueKeys,
      halfChecked: halfCheckedKeys
    };
  }, [valueKeys, halfCheckedKeys, checkable]);
  React.useEffect(function() {
    if (open && !multiple && valueKeys.length) {
      var _treeRef$current;
      (_treeRef$current = treeRef.current) === null || _treeRef$current === void 0 ? void 0 : _treeRef$current.scrollTo({
        key: valueKeys[0]
      });
    }
  }, [open]);
  var lowerSearchValue = String(searchValue).toLowerCase();
  var filterTreeNode = function filterTreeNode2(treeNode) {
    if (!lowerSearchValue) {
      return false;
    }
    return String(treeNode[treeNodeFilterProp]).toLowerCase().includes(lowerSearchValue);
  };
  var _React$useState = React.useState(treeDefaultExpandedKeys), _React$useState2 = _slicedToArray$3(_React$useState, 2), expandedKeys = _React$useState2[0], setExpandedKeys = _React$useState2[1];
  var _React$useState3 = React.useState(null), _React$useState4 = _slicedToArray$3(_React$useState3, 2), searchExpandedKeys = _React$useState4[0], setSearchExpandedKeys = _React$useState4[1];
  var mergedExpandedKeys = React.useMemo(function() {
    if (treeExpandedKeys) {
      return _toConsumableArray(treeExpandedKeys);
    }
    return searchValue ? searchExpandedKeys : expandedKeys;
  }, [expandedKeys, searchExpandedKeys, lowerSearchValue, treeExpandedKeys]);
  React.useEffect(function() {
    if (searchValue) {
      setSearchExpandedKeys(flattenOptions2.map(function(o2) {
        return o2.key;
      }));
    }
  }, [searchValue]);
  var onInternalExpand = function onInternalExpand2(keys2) {
    setExpandedKeys(keys2);
    setSearchExpandedKeys(keys2);
    if (onTreeExpand) {
      onTreeExpand(keys2);
    }
  };
  var onListMouseDown = function onListMouseDown2(event) {
    event.preventDefault();
  };
  var onInternalSelect = function onInternalSelect2(_2, _ref) {
    var key2 = _ref.node.key;
    var entity = getEntityByKey(key2, checkable ? "checkbox" : "select");
    if (entity !== null) {
      onSelect(entity.data.value, {
        selected: !checkedKeys.includes(entity.data.value)
      });
    }
    if (!multiple) {
      onToggleOpen(false);
    }
  };
  var _React$useState5 = React.useState(null), _React$useState6 = _slicedToArray$3(_React$useState5, 2), activeKey = _React$useState6[0], setActiveKey = _React$useState6[1];
  var activeEntity = getEntityByKey(activeKey);
  React.useImperativeHandle(ref, function() {
    var _treeRef$current2;
    return {
      scrollTo: (_treeRef$current2 = treeRef.current) === null || _treeRef$current2 === void 0 ? void 0 : _treeRef$current2.scrollTo,
      onKeyDown: function onKeyDown2(event) {
        var _treeRef$current3;
        var which = event.which;
        switch (which) {
          case KeyCode.UP:
          case KeyCode.DOWN:
          case KeyCode.LEFT:
          case KeyCode.RIGHT:
            (_treeRef$current3 = treeRef.current) === null || _treeRef$current3 === void 0 ? void 0 : _treeRef$current3.onKeyDown(event);
            break;
          case KeyCode.ENTER: {
            var _ref2 = (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.data) || {}, selectable = _ref2.selectable, value = _ref2.value;
            if (selectable !== false) {
              onInternalSelect(null, {
                node: {
                  key: activeKey
                },
                selected: !checkedKeys.includes(value)
              });
            }
            break;
          }
          case KeyCode.ESC: {
            onToggleOpen(false);
          }
        }
      },
      onKeyUp: function onKeyUp2() {
      }
    };
  });
  if (memoOptions.length === 0) {
    return /* @__PURE__ */ React.createElement("div", {
      role: "listbox",
      className: "".concat(prefixCls, "-empty"),
      onMouseDown: onListMouseDown
    }, notFoundContent);
  }
  var treeProps = {};
  if (treeLoadedKeys) {
    treeProps.loadedKeys = treeLoadedKeys;
  }
  if (mergedExpandedKeys) {
    treeProps.expandedKeys = mergedExpandedKeys;
  }
  return /* @__PURE__ */ React.createElement("div", {
    onMouseDown: onListMouseDown,
    onMouseEnter
  }, activeEntity && open && /* @__PURE__ */ React.createElement("span", {
    style: HIDDEN_STYLE,
    "aria-live": "assertive"
  }, activeEntity.data.value), /* @__PURE__ */ React.createElement(Tree$1, _extends$2({
    ref: treeRef,
    focusable: false,
    prefixCls: "".concat(prefixCls, "-tree"),
    treeData: memoOptions,
    height,
    itemHeight,
    virtual,
    multiple,
    icon: treeIcon,
    showIcon: showTreeIcon,
    switcherIcon,
    showLine: treeLine,
    loadData: searchValue ? null : loadData,
    motion: treeMotion,
    checkable,
    checkStrictly: true,
    checkedKeys: mergedCheckedKeys,
    selectedKeys: !checkable ? valueKeys : [],
    defaultExpandAll: treeDefaultExpandAll
  }, treeProps, {
    onActiveChange: setActiveKey,
    onSelect: onInternalSelect,
    onCheck: onInternalSelect,
    onExpand: onInternalExpand,
    onLoad: onTreeLoad,
    filterTreeNode
  })));
};
var RefOptionList = /* @__PURE__ */ React.forwardRef(OptionList2);
RefOptionList.displayName = "OptionList";
var TreeNode = function TreeNode2() {
  return null;
};
function convertChildrenToData(nodes) {
  return toArray$8(nodes).map(function(node) {
    if (!/* @__PURE__ */ React.isValidElement(node) || !node.type) {
      return null;
    }
    var key2 = node.key, _node$props = node.props, children = _node$props.children, value = _node$props.value, restProps = _objectWithoutProperties$1(_node$props, ["children", "value"]);
    var data = _objectSpread2$1({
      key: key2,
      value
    }, restProps);
    var childData = convertChildrenToData(children);
    if (childData.length) {
      data.children = childData;
    }
    return data;
  }).filter(function(data) {
    return data;
  });
}
function fillLegacyProps(dataNode) {
  if (!dataNode) {
    return dataNode;
  }
  var cloneNode = _objectSpread2$1({}, dataNode);
  if (!("props" in cloneNode)) {
    Object.defineProperty(cloneNode, "props", {
      get: function get2() {
        warningOnce(false, "New `rc-tree-select` not support return node instance as argument anymore. Please consider to remove `props` access.");
        return cloneNode;
      }
    });
  }
  return cloneNode;
}
function fillAdditionalInfo(extra, triggerValue, checkedValues, treeData, showPosition) {
  var triggerNode = null;
  var nodeList = null;
  function generateMap() {
    function dig(list) {
      var level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0";
      var parentIncluded = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      return list.map(function(dataNode, index2) {
        var pos = "".concat(level, "-").concat(index2);
        var included = checkedValues.includes(dataNode.value);
        var children = dig(dataNode.children || [], pos, included);
        var node = /* @__PURE__ */ React.createElement(TreeNode, dataNode, children.map(function(child) {
          return child.node;
        }));
        if (triggerValue === dataNode.value) {
          triggerNode = node;
        }
        if (included) {
          var checkedNode = {
            pos,
            node,
            children
          };
          if (!parentIncluded) {
            nodeList.push(checkedNode);
          }
          return checkedNode;
        }
        return null;
      }).filter(function(node) {
        return node;
      });
    }
    if (!nodeList) {
      nodeList = [];
      dig(treeData);
      nodeList.sort(function(_ref, _ref2) {
        var val1 = _ref.node.props.value;
        var val2 = _ref2.node.props.value;
        var index1 = checkedValues.indexOf(val1);
        var index2 = checkedValues.indexOf(val2);
        return index1 - index2;
      });
    }
  }
  Object.defineProperty(extra, "triggerNode", {
    get: function get2() {
      warningOnce(false, "`triggerNode` is deprecated. Please consider decoupling data with node.");
      generateMap();
      return triggerNode;
    }
  });
  Object.defineProperty(extra, "allCheckedNodes", {
    get: function get2() {
      warningOnce(false, "`allCheckedNodes` is deprecated. Please consider decoupling data with node.");
      generateMap();
      if (showPosition) {
        return nodeList;
      }
      return nodeList.map(function(_ref3) {
        var node = _ref3.node;
        return node;
      });
    }
  });
}
function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return value !== void 0 ? [value] : [];
}
function findValueOption(values, options) {
  var optionMap = /* @__PURE__ */ new Map();
  options.forEach(function(flattenItem) {
    var data = flattenItem.data;
    optionMap.set(data.value, data);
  });
  return values.map(function(val) {
    return fillLegacyProps(optionMap.get(val));
  });
}
function isValueDisabled(value, options) {
  var option = findValueOption([value], options)[0];
  if (option) {
    return option.disabled;
  }
  return false;
}
function isCheckDisabled(node) {
  return node.disabled || node.disableCheckbox || node.checkable === false;
}
function getLevel(_ref) {
  var parent = _ref.parent;
  var level = 0;
  var current = parent;
  while (current) {
    current = current.parent;
    level += 1;
  }
  return level;
}
function flattenOptions(options) {
  function fillKey(list) {
    return (list || []).map(function(node) {
      var value = node.value, key2 = node.key, children = node.children;
      var clone2 = _objectSpread2$1(_objectSpread2$1({}, node), {}, {
        key: "key" in node ? key2 : value
      });
      if (children) {
        clone2.children = fillKey(children);
      }
      return clone2;
    });
  }
  var flattenList = flattenTreeData(fillKey(options), true);
  return flattenList.map(function(node) {
    return {
      key: node.data.key,
      data: node.data,
      level: getLevel(node)
    };
  });
}
function getDefaultFilterOption(optionFilterProp) {
  return function(searchValue, dataNode) {
    var value = dataNode[optionFilterProp];
    return String(value).toLowerCase().includes(String(searchValue).toLowerCase());
  };
}
function filterOptions(searchValue, options, _ref2) {
  var optionFilterProp = _ref2.optionFilterProp, filterOption2 = _ref2.filterOption;
  if (filterOption2 === false) {
    return options;
  }
  var filterOptionFunc;
  if (typeof filterOption2 === "function") {
    filterOptionFunc = filterOption2;
  } else {
    filterOptionFunc = getDefaultFilterOption(optionFilterProp);
  }
  function dig(list) {
    var keepAll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return list.map(function(dataNode) {
      var children = dataNode.children;
      var match2 = keepAll || filterOptionFunc(searchValue, fillLegacyProps(dataNode));
      var childList = dig(children || [], match2);
      if (match2 || childList.length) {
        return _objectSpread2$1(_objectSpread2$1({}, dataNode), {}, {
          children: childList
        });
      }
      return null;
    }).filter(function(node) {
      return node;
    });
  }
  return dig(options);
}
function getRawValueLabeled(values, prevValue, getEntityByValue, getLabelProp) {
  var valueMap = /* @__PURE__ */ new Map();
  toArray(prevValue).forEach(function(item) {
    if (item && _typeof$5(item) === "object" && "value" in item) {
      valueMap.set(item.value, item);
    }
  });
  return values.map(function(val) {
    var item = {
      value: val
    };
    var entity = getEntityByValue(val, "select", true);
    var label = entity ? getLabelProp(entity.data) : val;
    if (valueMap.has(val)) {
      var labeledValue = valueMap.get(val);
      item.label = "label" in labeledValue ? labeledValue.label : label;
      if ("halfChecked" in labeledValue) {
        item.halfChecked = labeledValue.halfChecked;
      }
    } else {
      item.label = label;
    }
    return item;
  });
}
function addValue(rawValues, value) {
  var values = new Set(rawValues);
  values.add(value);
  return Array.from(values);
}
function removeValue(rawValues, value) {
  var values = new Set(rawValues);
  values.delete(value);
  return Array.from(values);
}
function warningProps(props) {
  var searchPlaceholder = props.searchPlaceholder, treeCheckStrictly = props.treeCheckStrictly, treeCheckable = props.treeCheckable, labelInValue = props.labelInValue, value = props.value, multiple = props.multiple;
  warningOnce(!searchPlaceholder, "`searchPlaceholder` has been removed.");
  if (treeCheckStrictly && labelInValue === false) {
    warningOnce(false, "`treeCheckStrictly` will force set `labelInValue` to `true`.");
  }
  if (labelInValue || treeCheckStrictly) {
    warningOnce(toArray(value).every(function(val) {
      return val && _typeof$5(val) === "object" && "value" in val;
    }), "Invalid prop `value` supplied to `TreeSelect`. You should use { label: string, value: string | number } or [{ label: string, value: string | number }] instead.");
  }
  if (treeCheckStrictly || multiple || treeCheckable) {
    warningOnce(!value || Array.isArray(value), "`value` should be an array when `TreeSelect` is checkable or multiple.");
  } else {
    warningOnce(!Array.isArray(value), "`value` should not be array when `TreeSelect` is single mode.");
  }
}
var MAX_WARNING_TIMES = 10;
function parseSimpleTreeData(treeData, _ref) {
  var id2 = _ref.id, pId = _ref.pId, rootPId = _ref.rootPId;
  var keyNodes = {};
  var rootNodeList = [];
  var nodeList = treeData.map(function(node) {
    var clone2 = _objectSpread2$1({}, node);
    var key2 = clone2[id2];
    keyNodes[key2] = clone2;
    clone2.key = clone2.key || key2;
    return clone2;
  });
  nodeList.forEach(function(node) {
    var parentKey = node[pId];
    var parent = keyNodes[parentKey];
    if (parent) {
      parent.children = parent.children || [];
      parent.children.push(node);
    }
    if (parentKey === rootPId || !parent && rootPId === null) {
      rootNodeList.push(node);
    }
  });
  return rootNodeList;
}
function formatTreeData(treeData, getLabelProp) {
  var warningTimes = 0;
  var valueSet = /* @__PURE__ */ new Set();
  function dig(dataNodes) {
    return (dataNodes || []).map(function(node) {
      var key2 = node.key, value = node.value, children = node.children, rest = _objectWithoutProperties$1(node, ["key", "value", "children"]);
      var mergedValue = "value" in node ? value : key2;
      var dataNode = _objectSpread2$1(_objectSpread2$1({}, rest), {}, {
        key: key2 !== null && key2 !== void 0 ? key2 : mergedValue,
        value: mergedValue,
        title: getLabelProp(node)
      });
      if (process.env.NODE_ENV !== "production") {
        if (key2 !== null && key2 !== void 0 && value !== void 0 && String(key2) !== String(value) && warningTimes < MAX_WARNING_TIMES) {
          warningTimes += 1;
          warningOnce(false, "`key` or `value` with TreeNode must be the same or you can remove one of them. key: ".concat(key2, ", value: ").concat(value, "."));
        }
        warningOnce(!valueSet.has(value), "Same `value` exist in the tree: ".concat(value));
        valueSet.add(value);
      }
      if ("children" in node) {
        dataNode.children = dig(children);
      }
      return dataNode;
    });
  }
  return dig(treeData);
}
function useTreeData(treeData, children, _ref2) {
  var getLabelProp = _ref2.getLabelProp, simpleMode = _ref2.simpleMode;
  var cacheRef = React.useRef({});
  if (treeData) {
    cacheRef.current.formatTreeData = cacheRef.current.treeData === treeData ? cacheRef.current.formatTreeData : formatTreeData(simpleMode ? parseSimpleTreeData(treeData, _objectSpread2$1({
      id: "id",
      pId: "pId",
      rootPId: null
    }, simpleMode !== true ? simpleMode : {})) : treeData, getLabelProp);
    cacheRef.current.treeData = treeData;
  } else {
    cacheRef.current.formatTreeData = cacheRef.current.children === children ? cacheRef.current.formatTreeData : formatTreeData(convertChildrenToData(children), getLabelProp);
  }
  return cacheRef.current.formatTreeData;
}
var SHOW_ALL = "SHOW_ALL";
var SHOW_PARENT = "SHOW_PARENT";
var SHOW_CHILD = "SHOW_CHILD";
function formatStrategyKeys(keys2, strategy, keyEntities) {
  var keySet = new Set(keys2);
  if (strategy === SHOW_CHILD) {
    return keys2.filter(function(key2) {
      var entity = keyEntities[key2];
      if (entity && entity.children && entity.children.every(function(_ref) {
        var node = _ref.node;
        return isCheckDisabled(node) || keySet.has(node.key);
      })) {
        return false;
      }
      return true;
    });
  }
  if (strategy === SHOW_PARENT) {
    return keys2.filter(function(key2) {
      var entity = keyEntities[key2];
      var parent = entity ? entity.parent : null;
      if (parent && !isCheckDisabled(parent.node) && keySet.has(parent.node.key)) {
        return false;
      }
      return true;
    });
  }
  return keys2;
}
function useSelectValues(rawValues, _ref) {
  var value = _ref.value, getEntityByValue = _ref.getEntityByValue, getEntityByKey = _ref.getEntityByKey, treeConduction = _ref.treeConduction, showCheckedStrategy = _ref.showCheckedStrategy, conductKeyEntities = _ref.conductKeyEntities, getLabelProp = _ref.getLabelProp;
  return React.useMemo(function() {
    var mergedRawValues = rawValues;
    if (treeConduction) {
      var rawKeys = formatStrategyKeys(rawValues.map(function(val) {
        var entity = getEntityByValue(val);
        return entity ? entity.key : val;
      }), showCheckedStrategy, conductKeyEntities);
      mergedRawValues = rawKeys.map(function(key2) {
        var entity = getEntityByKey(key2);
        return entity ? entity.data.value : key2;
      });
    }
    return getRawValueLabeled(mergedRawValues, value, getEntityByValue, getLabelProp);
  }, [rawValues, value, treeConduction, showCheckedStrategy, getEntityByValue]);
}
var OMIT_PROPS = ["expandedKeys", "treeData", "treeCheckable", "showCheckedStrategy", "searchPlaceholder", "treeLine", "treeIcon", "showTreeIcon", "switcherIcon", "treeNodeFilterProp", "filterTreeNode", "dropdownPopupAlign", "treeDefaultExpandAll", "treeCheckStrictly", "treeExpandedKeys", "treeLoadedKeys", "treeMotion", "onTreeExpand", "onTreeLoad", "loadData", "treeDataSimpleMode", "treeNodeLabelProp", "treeDefaultExpandedKeys"];
var RefSelect = generateSelector({
  prefixCls: "rc-tree-select",
  components: {
    optionList: RefOptionList
  },
  convertChildrenToData: function convertChildrenToData2() {
    return null;
  },
  flattenOptions,
  getLabeledValue,
  filterOptions,
  isValueDisabled,
  findValueOption,
  omitDOMProps: function omitDOMProps(props) {
    var cloneProps = _objectSpread2$1({}, props);
    OMIT_PROPS.forEach(function(prop) {
      delete cloneProps[prop];
    });
    return cloneProps;
  }
});
RefSelect.displayName = "Select";
var RefTreeSelect = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var multiple = props.multiple, treeCheckable = props.treeCheckable, treeCheckStrictly = props.treeCheckStrictly, _props$showCheckedStr = props.showCheckedStrategy, showCheckedStrategy = _props$showCheckedStr === void 0 ? "SHOW_CHILD" : _props$showCheckedStr, labelInValue = props.labelInValue, loadData = props.loadData, treeLoadedKeys = props.treeLoadedKeys, _props$treeNodeFilter = props.treeNodeFilterProp, treeNodeFilterProp = _props$treeNodeFilter === void 0 ? "value" : _props$treeNodeFilter, treeNodeLabelProp = props.treeNodeLabelProp, treeDataSimpleMode = props.treeDataSimpleMode, treeData = props.treeData, treeExpandedKeys = props.treeExpandedKeys, treeDefaultExpandedKeys = props.treeDefaultExpandedKeys, treeDefaultExpandAll = props.treeDefaultExpandAll, children = props.children, treeIcon = props.treeIcon, showTreeIcon = props.showTreeIcon, switcherIcon = props.switcherIcon, treeLine = props.treeLine, treeMotion = props.treeMotion, filterTreeNode = props.filterTreeNode, dropdownPopupAlign = props.dropdownPopupAlign, onChange4 = props.onChange, onTreeExpand = props.onTreeExpand, onTreeLoad = props.onTreeLoad, onDropdownVisibleChange = props.onDropdownVisibleChange, onSelect = props.onSelect, onDeselect = props.onDeselect;
  var mergedCheckable = treeCheckable || treeCheckStrictly;
  var mergedMultiple = multiple || mergedCheckable;
  var treeConduction = treeCheckable && !treeCheckStrictly;
  var mergedLabelInValue = treeCheckStrictly || labelInValue;
  var selectRef = React.useRef(null);
  React.useImperativeHandle(ref, function() {
    return {
      scrollTo: selectRef.current.scrollTo,
      focus: selectRef.current.focus,
      blur: selectRef.current.blur
    };
  });
  var getTreeNodeTitle = function getTreeNodeTitle2(node) {
    if (!treeData) {
      return node.title;
    }
    return node.label || node.title;
  };
  var getTreeNodeLabelProp = function getTreeNodeLabelProp2(node) {
    if (treeNodeLabelProp) {
      return node[treeNodeLabelProp];
    }
    return getTreeNodeTitle(node);
  };
  var mergedTreeData = useTreeData(treeData, children, {
    getLabelProp: getTreeNodeTitle,
    simpleMode: treeDataSimpleMode
  });
  var flattedOptions = useMemo$1(function() {
    return flattenOptions(mergedTreeData);
  }, [mergedTreeData]);
  var _useKeyValueMap = useKeyValueMap(flattedOptions), _useKeyValueMap2 = _slicedToArray$3(_useKeyValueMap, 2), cacheKeyMap = _useKeyValueMap2[0], cacheValueMap = _useKeyValueMap2[1];
  var _useKeyValueMapping = useKeyValueMapping(cacheKeyMap, cacheValueMap), _useKeyValueMapping2 = _slicedToArray$3(_useKeyValueMapping, 2), getEntityByKey = _useKeyValueMapping2[0], getEntityByValue = _useKeyValueMapping2[1];
  var _useMemo = useMemo$1(function() {
    if (treeConduction) {
      return convertDataToEntities(mergedTreeData);
    }
    return {
      keyEntities: null
    };
  }, [mergedTreeData, treeCheckable, treeCheckStrictly]), conductKeyEntities = _useMemo.keyEntities;
  var _useMergedState = useMergedState(props.defaultValue, {
    value: props.value
  }), _useMergedState2 = _slicedToArray$3(_useMergedState, 2), value = _useMergedState2[0], setValue2 = _useMergedState2[1];
  var splitRawValues = function splitRawValues2(newRawValues) {
    var missingRawValues = [];
    var existRawValues = [];
    newRawValues.forEach(function(val) {
      if (getEntityByValue(val)) {
        existRawValues.push(val);
      } else {
        missingRawValues.push(val);
      }
    });
    return {
      missingRawValues,
      existRawValues
    };
  };
  var _useMemo2 = useMemo$1(function() {
    var valueHalfCheckedKeys = [];
    var newRawValues = [];
    toArray(value).forEach(function(item) {
      if (item && _typeof$5(item) === "object" && "value" in item) {
        if (item.halfChecked && treeCheckStrictly) {
          var entity = getEntityByValue(item.value);
          valueHalfCheckedKeys.push(entity ? entity.key : item.value);
        } else {
          newRawValues.push(item.value);
        }
      } else {
        newRawValues.push(item);
      }
    });
    if (treeConduction) {
      var _splitRawValues = splitRawValues(newRawValues), missingRawValues = _splitRawValues.missingRawValues, existRawValues = _splitRawValues.existRawValues;
      var keyList = existRawValues.map(function(val) {
        return getEntityByValue(val).key;
      });
      var _conductCheck = conductCheck(keyList, true, conductKeyEntities), checkedKeys = _conductCheck.checkedKeys, halfCheckedKeys = _conductCheck.halfCheckedKeys;
      return [[].concat(_toConsumableArray(missingRawValues), _toConsumableArray(checkedKeys.map(function(key2) {
        return getEntityByKey(key2).data.value;
      }))), halfCheckedKeys];
    }
    return [newRawValues, valueHalfCheckedKeys];
  }, [value, mergedMultiple, mergedLabelInValue, treeCheckable, treeCheckStrictly]), _useMemo3 = _slicedToArray$3(_useMemo2, 2), rawValues = _useMemo3[0], rawHalfCheckedKeys = _useMemo3[1];
  var selectValues = useSelectValues(rawValues, {
    treeConduction,
    value,
    showCheckedStrategy,
    conductKeyEntities,
    getEntityByValue,
    getEntityByKey,
    getLabelProp: getTreeNodeLabelProp
  });
  var triggerChange = function triggerChange2(newRawValues, extra, source) {
    setValue2(mergedMultiple ? newRawValues : newRawValues[0]);
    if (onChange4) {
      var eventValues = newRawValues;
      if (treeConduction && showCheckedStrategy !== "SHOW_ALL") {
        var keyList = newRawValues.map(function(val) {
          var entity = getEntityByValue(val);
          return entity ? entity.key : val;
        });
        var formattedKeyList = formatStrategyKeys(keyList, showCheckedStrategy, conductKeyEntities);
        eventValues = formattedKeyList.map(function(key2) {
          var entity = getEntityByKey(key2);
          return entity ? entity.data.value : key2;
        });
      }
      var _ref = extra || {
        triggerValue: void 0,
        selected: void 0
      }, triggerValue = _ref.triggerValue, selected = _ref.selected;
      var returnValues = mergedLabelInValue ? getRawValueLabeled(eventValues, value, getEntityByValue, getTreeNodeLabelProp) : eventValues;
      if (treeCheckStrictly) {
        var halfValues = rawHalfCheckedKeys.map(function(key2) {
          var entity = getEntityByKey(key2);
          return entity ? entity.data.value : key2;
        }).filter(function(val) {
          return !eventValues.includes(val);
        });
        returnValues = [].concat(_toConsumableArray(returnValues), _toConsumableArray(getRawValueLabeled(halfValues, value, getEntityByValue, getTreeNodeLabelProp)));
      }
      var additionalInfo = {
        preValue: selectValues,
        triggerValue
      };
      var showPosition = true;
      if (treeCheckStrictly || source === "selection" && !selected) {
        showPosition = false;
      }
      fillAdditionalInfo(additionalInfo, triggerValue, newRawValues, mergedTreeData, showPosition);
      if (mergedCheckable) {
        additionalInfo.checked = selected;
      } else {
        additionalInfo.selected = selected;
      }
      onChange4(mergedMultiple ? returnValues : returnValues[0], mergedLabelInValue ? null : eventValues.map(function(val) {
        var entity = getEntityByValue(val);
        return entity ? getTreeNodeLabelProp(entity.data) : null;
      }), additionalInfo);
    }
  };
  var onInternalSelect = function onInternalSelect2(selectValue, option, source) {
    var eventValue = mergedLabelInValue ? selectValue : selectValue;
    if (!mergedMultiple) {
      triggerChange([selectValue], {
        selected: true,
        triggerValue: selectValue
      }, source);
    } else {
      var newRawValues = addValue(rawValues, selectValue);
      if (treeConduction) {
        var _splitRawValues2 = splitRawValues(newRawValues), missingRawValues = _splitRawValues2.missingRawValues, existRawValues = _splitRawValues2.existRawValues;
        var keyList = existRawValues.map(function(val) {
          return getEntityByValue(val).key;
        });
        var _conductCheck2 = conductCheck(keyList, true, conductKeyEntities), checkedKeys = _conductCheck2.checkedKeys;
        newRawValues = [].concat(_toConsumableArray(missingRawValues), _toConsumableArray(checkedKeys.map(function(key2) {
          return getEntityByKey(key2).data.value;
        })));
      }
      triggerChange(newRawValues, {
        selected: true,
        triggerValue: selectValue
      }, source);
    }
    if (onSelect) {
      onSelect(eventValue, option);
    }
  };
  var onInternalDeselect = function onInternalDeselect2(selectValue, option, source) {
    var eventValue = mergedLabelInValue ? selectValue : selectValue;
    var newRawValues = removeValue(rawValues, selectValue);
    if (treeConduction) {
      var _splitRawValues3 = splitRawValues(newRawValues), missingRawValues = _splitRawValues3.missingRawValues, existRawValues = _splitRawValues3.existRawValues;
      var keyList = existRawValues.map(function(val) {
        return getEntityByValue(val).key;
      });
      var _conductCheck3 = conductCheck(keyList, {
        checked: false,
        halfCheckedKeys: rawHalfCheckedKeys
      }, conductKeyEntities), checkedKeys = _conductCheck3.checkedKeys;
      newRawValues = [].concat(_toConsumableArray(missingRawValues), _toConsumableArray(checkedKeys.map(function(key2) {
        return getEntityByKey(key2).data.value;
      })));
    }
    triggerChange(newRawValues, {
      selected: false,
      triggerValue: selectValue
    }, source);
    if (onDeselect) {
      onDeselect(eventValue, option);
    }
  };
  var onInternalClear = function onInternalClear2() {
    triggerChange([], null, "clear");
  };
  var onInternalDropdownVisibleChange = React.useCallback(function(open) {
    if (onDropdownVisibleChange) {
      var legacyParam = {};
      Object.defineProperty(legacyParam, "documentClickClose", {
        get: function get2() {
          warningOnce(false, "Second param of `onDropdownVisibleChange` has been removed.");
          return false;
        }
      });
      onDropdownVisibleChange(open, legacyParam);
    }
  }, [onDropdownVisibleChange]);
  if (process.env.NODE_ENV !== "production") {
    warningProps(props);
  }
  var selectProps = {
    optionLabelProp: null,
    optionFilterProp: treeNodeFilterProp,
    dropdownAlign: dropdownPopupAlign,
    internalProps: {
      mark: INTERNAL_PROPS_MARK,
      onClear: onInternalClear,
      skipTriggerChange: true,
      skipTriggerSelect: true,
      onRawSelect: onInternalSelect,
      onRawDeselect: onInternalDeselect
    }
  };
  if ("filterTreeNode" in props) {
    selectProps.filterOption = filterTreeNode;
  }
  return /* @__PURE__ */ React.createElement(SelectContext.Provider, {
    value: {
      checkable: mergedCheckable,
      loadData,
      treeLoadedKeys,
      onTreeLoad,
      checkedKeys: rawValues,
      halfCheckedKeys: rawHalfCheckedKeys,
      treeDefaultExpandAll,
      treeExpandedKeys,
      treeDefaultExpandedKeys,
      onTreeExpand,
      treeIcon,
      treeMotion,
      showTreeIcon,
      switcherIcon,
      treeLine,
      treeNodeFilterProp
    }
  }, /* @__PURE__ */ React.createElement(RefSelect, _extends$2({
    ref: selectRef,
    mode: mergedMultiple ? "multiple" : null
  }, props, selectProps, {
    value: selectValues,
    labelInValue: true,
    options: mergedTreeData,
    onChange: null,
    onSelect: null,
    onDeselect: null,
    onDropdownVisibleChange: onInternalDropdownVisibleChange
  })));
});
var TreeSelect$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(TreeSelect2, _React$Component);
  var _super = _createSuper$1(TreeSelect2);
  function TreeSelect2() {
    var _this2;
    _classCallCheck$2(this, TreeSelect2);
    _this2 = _super.apply(this, arguments);
    _this2.selectRef = /* @__PURE__ */ React.createRef();
    _this2.focus = function() {
      _this2.selectRef.current.focus();
    };
    _this2.blur = function() {
      _this2.selectRef.current.blur();
    };
    return _this2;
  }
  _createClass$2(TreeSelect2, [{
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React.createElement(RefTreeSelect, _extends$2({
        ref: this.selectRef
      }, this.props));
    }
  }]);
  return TreeSelect2;
}(React.Component);
TreeSelect$1.TreeNode = TreeNode;
TreeSelect$1.SHOW_ALL = SHOW_ALL;
TreeSelect$1.SHOW_PARENT = SHOW_PARENT;
TreeSelect$1.SHOW_CHILD = SHOW_CHILD;
var __rest$7 = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var InternalTreeSelect = function InternalTreeSelect2(_a, ref) {
  var _classNames2;
  var customizePrefixCls = _a.prefixCls, customizeSize = _a.size, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? true : _a$bordered, className = _a.className, treeCheckable = _a.treeCheckable, multiple = _a.multiple, _a$listHeight = _a.listHeight, listHeight = _a$listHeight === void 0 ? 256 : _a$listHeight, _a$listItemHeight = _a.listItemHeight, listItemHeight = _a$listItemHeight === void 0 ? 26 : _a$listItemHeight, notFoundContent = _a.notFoundContent, _switcherIcon = _a.switcherIcon, treeLine = _a.treeLine, getPopupContainer = _a.getPopupContainer, dropdownClassName = _a.dropdownClassName, _a$treeIcon = _a.treeIcon, treeIcon = _a$treeIcon === void 0 ? false : _a$treeIcon, transitionName2 = _a.transitionName, _a$choiceTransitionNa = _a.choiceTransitionName, choiceTransitionName = _a$choiceTransitionNa === void 0 ? "" : _a$choiceTransitionNa, props = __rest$7(_a, ["prefixCls", "size", "bordered", "className", "treeCheckable", "multiple", "listHeight", "listItemHeight", "notFoundContent", "switcherIcon", "treeLine", "getPopupContainer", "dropdownClassName", "treeIcon", "transitionName", "choiceTransitionName"]);
  var _React$useContext = React.useContext(ConfigContext), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, renderEmpty3 = _React$useContext.renderEmpty, direction = _React$useContext.direction, virtual = _React$useContext.virtual, dropdownMatchSelectWidth = _React$useContext.dropdownMatchSelectWidth;
  var size = React.useContext(SizeContext$1);
  devWarning(multiple !== false || !treeCheckable, "TreeSelect", "`multiple` will alway be `true` when `treeCheckable` is true");
  var prefixCls = getPrefixCls("select", customizePrefixCls);
  var treePrefixCls = getPrefixCls("select-tree", customizePrefixCls);
  var treeSelectPrefixCls = getPrefixCls("tree-select", customizePrefixCls);
  var mergedDropdownClassName = cn(dropdownClassName, "".concat(treeSelectPrefixCls, "-dropdown"), _defineProperty$4({}, "".concat(treeSelectPrefixCls, "-dropdown-rtl"), direction === "rtl"));
  var isMultiple = !!(treeCheckable || multiple);
  var _getIcons = getIcons(_extends$2(_extends$2({}, props), {
    multiple: isMultiple,
    prefixCls
  })), suffixIcon = _getIcons.suffixIcon, removeIcon = _getIcons.removeIcon, clearIcon = _getIcons.clearIcon;
  var mergedNotFound;
  if (notFoundContent !== void 0) {
    mergedNotFound = notFoundContent;
  } else {
    mergedNotFound = renderEmpty3("Select");
  }
  var selectProps = omit$1(props, ["suffixIcon", "itemIcon", "removeIcon", "clearIcon", "switcherIcon"]);
  var mergedSize = customizeSize || size;
  var mergedClassName = cn(!customizePrefixCls && treeSelectPrefixCls, (_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-lg"), mergedSize === "large"), _defineProperty$4(_classNames2, "".concat(prefixCls, "-sm"), mergedSize === "small"), _defineProperty$4(_classNames2, "".concat(prefixCls, "-rtl"), direction === "rtl"), _defineProperty$4(_classNames2, "".concat(prefixCls, "-borderless"), !bordered), _classNames2), className);
  var rootPrefixCls = getPrefixCls();
  return /* @__PURE__ */ React.createElement(TreeSelect$1, _extends$2({
    virtual,
    dropdownMatchSelectWidth
  }, selectProps, {
    ref,
    prefixCls,
    className: mergedClassName,
    listHeight,
    listItemHeight,
    treeCheckable: treeCheckable ? /* @__PURE__ */ React.createElement("span", {
      className: "".concat(prefixCls, "-tree-checkbox-inner")
    }) : treeCheckable,
    inputIcon: suffixIcon,
    multiple,
    removeIcon,
    clearIcon,
    switcherIcon: function switcherIcon(nodeProps) {
      return renderSwitcherIcon(treePrefixCls, _switcherIcon, treeLine, nodeProps);
    },
    showTreeIcon: treeIcon,
    notFoundContent: mergedNotFound,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    treeMotion: null,
    dropdownClassName: mergedDropdownClassName,
    choiceTransitionName: getTransitionName(rootPrefixCls, "", choiceTransitionName),
    transitionName: getTransitionName(rootPrefixCls, "slide-up", transitionName2)
  }));
};
var TreeSelectRef = /* @__PURE__ */ React.forwardRef(InternalTreeSelect);
var TreeSelect = TreeSelectRef;
TreeSelect.TreeNode = TreeNode;
TreeSelect.SHOW_ALL = SHOW_ALL;
TreeSelect.SHOW_PARENT = SHOW_PARENT;
TreeSelect.SHOW_CHILD = SHOW_CHILD;
var __rest$6 = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var InternalTimePicker = DatePicker.TimePicker;
var InternalRangePicker = DatePicker.RangePicker;
var RangePicker = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  return /* @__PURE__ */ React.createElement(InternalRangePicker, _extends$2({}, props, {
    dropdownClassName: props.popupClassName,
    picker: "time",
    mode: void 0,
    ref
  }));
});
var TimePicker = /* @__PURE__ */ React.forwardRef(function(_a, ref) {
  var addon = _a.addon, renderExtraFooter = _a.renderExtraFooter, popupClassName = _a.popupClassName, restProps = __rest$6(_a, ["addon", "renderExtraFooter", "popupClassName"]);
  var internalRenderExtraFooter = React.useMemo(function() {
    if (renderExtraFooter) {
      return renderExtraFooter;
    }
    if (addon) {
      devWarning(false, "TimePicker", "`addon` is deprecated. Please use `renderExtraFooter` instead.");
      return addon;
    }
    return void 0;
  }, [addon, renderExtraFooter]);
  return /* @__PURE__ */ React.createElement(InternalTimePicker, _extends$2({}, restProps, {
    dropdownClassName: popupClassName,
    mode: void 0,
    ref,
    renderExtraFooter: internalRenderExtraFooter
  }));
});
TimePicker.displayName = "TimePicker";
TimePicker.RangePicker = RangePicker;
var __rest$5 = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var Typography$1 = function Typography(_a, ref) {
  var customizePrefixCls = _a.prefixCls, _a$component = _a.component, component = _a$component === void 0 ? "article" : _a$component, className = _a.className, ariaLabel = _a["aria-label"], setContentRef = _a.setContentRef, children = _a.children, restProps = __rest$5(_a, ["prefixCls", "component", "className", "aria-label", "setContentRef", "children"]);
  var mergedRef = ref;
  if (setContentRef) {
    devWarning(false, "Typography", "`setContentRef` is deprecated. Please use `ref` instead.");
    mergedRef = composeRef(ref, setContentRef);
  }
  return /* @__PURE__ */ React.createElement(ConfigConsumer, null, function(_ref) {
    var getPrefixCls = _ref.getPrefixCls, direction = _ref.direction;
    var Component3 = component;
    var prefixCls = getPrefixCls("typography", customizePrefixCls);
    var componentClassName = cn(prefixCls, _defineProperty$4({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), className);
    return /* @__PURE__ */ React.createElement(Component3, _extends$2({
      className: componentClassName,
      "aria-label": ariaLabel,
      ref: mergedRef
    }, restProps), children);
  });
};
var RefTypography = /* @__PURE__ */ React.forwardRef(Typography$1);
RefTypography.displayName = "Typography";
var ExportTypography = RefTypography;
var toggleSelection = function() {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function() {
    };
  }
  var active = document.activeElement;
  var ranges = [];
  for (var i2 = 0; i2 < selection.rangeCount; i2++) {
    ranges.push(selection.getRangeAt(i2));
  }
  switch (active.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      active.blur();
      break;
    default:
      active = null;
      break;
  }
  selection.removeAllRanges();
  return function() {
    selection.type === "Caret" && selection.removeAllRanges();
    if (!selection.rangeCount) {
      ranges.forEach(function(range2) {
        selection.addRange(range2);
      });
    }
    active && active.focus();
  };
};
var deselectCurrent = toggleSelection;
var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
};
var defaultMessage = "Copy to clipboard: #{key}, Enter";
function format2(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}
function copy(text, options) {
  var debug, message, reselectPrevious, range2, selection, mark, success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();
    range2 = document.createRange();
    selection = document.getSelection();
    mark = document.createElement("span");
    mark.textContent = text;
    mark.style.all = "unset";
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    mark.style.whiteSpace = "pre";
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e3) {
      e3.stopPropagation();
      if (options.format) {
        e3.preventDefault();
        if (typeof e3.clipboardData === "undefined") {
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format3 = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
          window.clipboardData.setData(format3, text);
        } else {
          e3.clipboardData.clearData();
          e3.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e3.preventDefault();
        options.onCopy(e3.clipboardData);
      }
    });
    document.body.appendChild(mark);
    range2.selectNodeContents(mark);
    selection.addRange(range2);
    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err2) {
      debug && console.error("unable to copy using clipboardData: ", err2);
      debug && console.error("falling back to prompt");
      message = format2("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range2);
      } else {
        selection.removeAllRanges();
      }
    }
    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }
  return success;
}
var copyToClipboard = copy;
var EditOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, "name": "edit", "theme": "outlined" };
var EditOutlined = function EditOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: EditOutlined$2
  }));
};
EditOutlined.displayName = "EditOutlined";
var EditOutlined$1 = /* @__PURE__ */ React.forwardRef(EditOutlined);
var CopyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, "name": "copy", "theme": "outlined" };
var CopyOutlined = function CopyOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: CopyOutlined$2
  }));
};
CopyOutlined.displayName = "CopyOutlined";
var CopyOutlined$1 = /* @__PURE__ */ React.forwardRef(CopyOutlined);
var EnterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, "name": "enter", "theme": "outlined" };
var EnterOutlined = function EnterOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: EnterOutlined$2
  }));
};
EnterOutlined.displayName = "EnterOutlined";
var EnterOutlined$1 = /* @__PURE__ */ React.forwardRef(EnterOutlined);
var Editable = function Editable2(_ref) {
  var prefixCls = _ref.prefixCls, ariaLabel = _ref["aria-label"], className = _ref.className, style2 = _ref.style, direction = _ref.direction, maxLength = _ref.maxLength, _ref$autoSize = _ref.autoSize, autoSize = _ref$autoSize === void 0 ? true : _ref$autoSize, value = _ref.value, onSave = _ref.onSave, onCancel = _ref.onCancel, onEnd = _ref.onEnd;
  var ref = React.useRef();
  var inComposition = React.useRef(false);
  var lastKeyCode = React.useRef();
  var _React$useState = React.useState(value), _React$useState2 = _slicedToArray$3(_React$useState, 2), current = _React$useState2[0], setCurrent2 = _React$useState2[1];
  React.useEffect(function() {
    setCurrent2(value);
  }, [value]);
  React.useEffect(function() {
    if (ref.current && ref.current.resizableTextArea) {
      var textArea = ref.current.resizableTextArea.textArea;
      textArea.focus();
      var length = textArea.value.length;
      textArea.setSelectionRange(length, length);
    }
  }, []);
  var onChange4 = function onChange5(_ref2) {
    var target = _ref2.target;
    setCurrent2(target.value.replace(/[\n\r]/g, ""));
  };
  var onCompositionStart = function onCompositionStart2() {
    inComposition.current = true;
  };
  var onCompositionEnd = function onCompositionEnd2() {
    inComposition.current = false;
  };
  var onKeyDown2 = function onKeyDown3(_ref3) {
    var keyCode = _ref3.keyCode;
    if (inComposition.current)
      return;
    lastKeyCode.current = keyCode;
  };
  var confirmChange = function confirmChange2() {
    onSave(current.trim());
  };
  var onKeyUp2 = function onKeyUp3(_ref4) {
    var keyCode = _ref4.keyCode, ctrlKey = _ref4.ctrlKey, altKey = _ref4.altKey, metaKey = _ref4.metaKey, shiftKey = _ref4.shiftKey;
    if (lastKeyCode.current === keyCode && !inComposition.current && !ctrlKey && !altKey && !metaKey && !shiftKey) {
      if (keyCode === KeyCode.ENTER) {
        confirmChange();
        onEnd === null || onEnd === void 0 ? void 0 : onEnd();
      } else if (keyCode === KeyCode.ESC) {
        onCancel();
      }
    }
  };
  var onBlur2 = function onBlur3() {
    confirmChange();
  };
  var textAreaClassName = cn(prefixCls, "".concat(prefixCls, "-edit-content"), _defineProperty$4({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), className);
  return /* @__PURE__ */ React.createElement("div", {
    className: textAreaClassName,
    style: style2
  }, /* @__PURE__ */ React.createElement(TextArea, {
    ref,
    maxLength,
    value: current,
    onChange: onChange4,
    onKeyDown: onKeyDown2,
    onKeyUp: onKeyUp2,
    onCompositionStart,
    onCompositionEnd,
    onBlur: onBlur2,
    "aria-label": ariaLabel,
    autoSize
  }), /* @__PURE__ */ React.createElement(EnterOutlined$1, {
    className: "".concat(prefixCls, "-edit-content-confirm")
  }));
};
var ELEMENT_NODE = 1;
var TEXT_NODE = 3;
var COMMENT_NODE = 8;
var ellipsisContainer;
var wrapperStyle = {
  padding: 0,
  margin: 0,
  display: "inline",
  lineHeight: "inherit"
};
function pxToNumber(value) {
  if (!value)
    return 0;
  var match2 = value.match(/^\d*(\.\d*)?/);
  return match2 ? Number(match2[0]) : 0;
}
function styleToString(style2) {
  var styleNames = Array.prototype.slice.apply(style2);
  return styleNames.map(function(name) {
    return "".concat(name, ": ").concat(style2.getPropertyValue(name), ";");
  }).join("");
}
function mergeChildren(children) {
  var childList = [];
  children.forEach(function(child) {
    var prevChild = childList[childList.length - 1];
    if (typeof child === "string" && typeof prevChild === "string") {
      childList[childList.length - 1] += child;
    } else {
      childList.push(child);
    }
  });
  return childList;
}
var measure = function(originEle, option, content, fixedContent, ellipsisStr) {
  if (!ellipsisContainer) {
    ellipsisContainer = document.createElement("div");
    ellipsisContainer.setAttribute("aria-hidden", "true");
    document.body.appendChild(ellipsisContainer);
  }
  var rows = option.rows, _option$suffix = option.suffix, suffix = _option$suffix === void 0 ? "" : _option$suffix;
  var originStyle = window.getComputedStyle(originEle);
  var originCSS = styleToString(originStyle);
  var lineHeight = pxToNumber(originStyle.lineHeight);
  var maxHeight = Math.round(lineHeight * (rows + 1) + pxToNumber(originStyle.paddingTop) + pxToNumber(originStyle.paddingBottom));
  ellipsisContainer.setAttribute("style", originCSS);
  ellipsisContainer.style.position = "fixed";
  ellipsisContainer.style.left = "0";
  ellipsisContainer.style.height = "auto";
  ellipsisContainer.style.minHeight = "auto";
  ellipsisContainer.style.maxHeight = "auto";
  ellipsisContainer.style.top = "-999999px";
  ellipsisContainer.style.zIndex = "-1000";
  ellipsisContainer.style.textOverflow = "clip";
  ellipsisContainer.style.whiteSpace = "normal";
  ellipsisContainer.style.webkitLineClamp = "none";
  var contentList = mergeChildren(toArray$8(content));
  render(/* @__PURE__ */ React.createElement("div", {
    style: wrapperStyle
  }, /* @__PURE__ */ React.createElement("span", {
    style: wrapperStyle
  }, contentList, suffix), /* @__PURE__ */ React.createElement("span", {
    style: wrapperStyle
  }, fixedContent)), ellipsisContainer);
  function inRange() {
    return ellipsisContainer.offsetHeight < maxHeight;
  }
  if (inRange()) {
    unmountComponentAtNode(ellipsisContainer);
    return {
      content,
      text: ellipsisContainer.innerHTML,
      ellipsis: false
    };
  }
  var childNodes = Array.prototype.slice.apply(ellipsisContainer.childNodes[0].childNodes[0].cloneNode(true).childNodes).filter(function(_ref) {
    var nodeType = _ref.nodeType;
    return nodeType !== COMMENT_NODE;
  });
  var fixedNodes = Array.prototype.slice.apply(ellipsisContainer.childNodes[0].childNodes[1].cloneNode(true).childNodes);
  unmountComponentAtNode(ellipsisContainer);
  var ellipsisChildren = [];
  ellipsisContainer.innerHTML = "";
  var ellipsisContentHolder = document.createElement("span");
  ellipsisContainer.appendChild(ellipsisContentHolder);
  var ellipsisTextNode = document.createTextNode(ellipsisStr + suffix);
  ellipsisContentHolder.appendChild(ellipsisTextNode);
  fixedNodes.forEach(function(childNode) {
    ellipsisContainer.appendChild(childNode);
  });
  function appendChildNode(node) {
    ellipsisContentHolder.insertBefore(node, ellipsisTextNode);
  }
  function measureText(textNode, fullText) {
    var startLoc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var endLoc = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : fullText.length;
    var lastSuccessLoc = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
    var midLoc = Math.floor((startLoc + endLoc) / 2);
    var currentText = fullText.slice(0, midLoc);
    textNode.textContent = currentText;
    if (startLoc >= endLoc - 1) {
      for (var step = endLoc; step >= startLoc; step -= 1) {
        var currentStepText = fullText.slice(0, step);
        textNode.textContent = currentStepText;
        if (inRange() || !currentStepText) {
          return step === fullText.length ? {
            finished: false,
            reactNode: fullText
          } : {
            finished: true,
            reactNode: currentStepText
          };
        }
      }
    }
    if (inRange()) {
      return measureText(textNode, fullText, midLoc, endLoc, midLoc);
    }
    return measureText(textNode, fullText, startLoc, midLoc, lastSuccessLoc);
  }
  function measureNode(childNode, index2) {
    var type2 = childNode.nodeType;
    if (type2 === ELEMENT_NODE) {
      appendChildNode(childNode);
      if (inRange()) {
        return {
          finished: false,
          reactNode: contentList[index2]
        };
      }
      ellipsisContentHolder.removeChild(childNode);
      return {
        finished: true,
        reactNode: null
      };
    }
    if (type2 === TEXT_NODE) {
      var fullText = childNode.textContent || "";
      var textNode = document.createTextNode(fullText);
      appendChildNode(textNode);
      return measureText(textNode, fullText);
    }
    return {
      finished: false,
      reactNode: null
    };
  }
  childNodes.some(function(childNode, index2) {
    var _measureNode = measureNode(childNode, index2), finished = _measureNode.finished, reactNode = _measureNode.reactNode;
    if (reactNode) {
      ellipsisChildren.push(reactNode);
    }
    return finished;
  });
  return {
    content: ellipsisChildren,
    text: ellipsisContainer.innerHTML,
    ellipsis: true
  };
};
var __rest$4 = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var isLineClampSupport = isStyleSupport("webkitLineClamp");
var isTextOverflowSupport = isStyleSupport("textOverflow");
function wrapperDecorations(_ref, content) {
  var mark = _ref.mark, code = _ref.code, underline = _ref.underline, del = _ref["delete"], strong = _ref.strong, keyboard = _ref.keyboard;
  var currentContent = content;
  function wrap(needed, tag) {
    if (!needed)
      return;
    currentContent = /* @__PURE__ */ React.createElement(tag, {}, currentContent);
  }
  wrap(strong, "strong");
  wrap(underline, "u");
  wrap(del, "del");
  wrap(code, "code");
  wrap(mark, "mark");
  wrap(keyboard, "kbd");
  return currentContent;
}
var ELLIPSIS_STR = "...";
var Base = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Base2, _React$Component);
  var _super = _createSuper$1(Base2);
  function Base2() {
    var _this2;
    _classCallCheck$2(this, Base2);
    _this2 = _super.apply(this, arguments);
    _this2.contentRef = /* @__PURE__ */ React.createRef();
    _this2.state = {
      edit: false,
      copied: false,
      ellipsisText: "",
      ellipsisContent: null,
      isEllipsis: false,
      expanded: false,
      clientRendered: false
    };
    _this2.getPrefixCls = function() {
      var customizePrefixCls = _this2.props.prefixCls;
      var getPrefixCls = _this2.context.getPrefixCls;
      return getPrefixCls("typography", customizePrefixCls);
    };
    _this2.onExpandClick = function(e3) {
      var _a;
      var _this$getEllipsis = _this2.getEllipsis(), onExpand = _this$getEllipsis.onExpand;
      _this2.setState({
        expanded: true
      });
      (_a = onExpand) === null || _a === void 0 ? void 0 : _a(e3);
    };
    _this2.onEditClick = function() {
      _this2.triggerEdit(true);
    };
    _this2.onEditChange = function(value) {
      var _this$getEditable = _this2.getEditable(), onChange4 = _this$getEditable.onChange;
      onChange4 === null || onChange4 === void 0 ? void 0 : onChange4(value);
      _this2.triggerEdit(false);
    };
    _this2.onEditCancel = function() {
      var _a, _b;
      (_b = (_a = _this2.getEditable()).onCancel) === null || _b === void 0 ? void 0 : _b.call(_a);
      _this2.triggerEdit(false);
    };
    _this2.onCopyClick = function(e3) {
      e3.preventDefault();
      var _this$props = _this2.props, children = _this$props.children, copyable = _this$props.copyable;
      var copyConfig = _extends$2({}, _typeof$5(copyable) === "object" ? copyable : null);
      if (copyConfig.text === void 0) {
        copyConfig.text = String(children);
      }
      copyToClipboard(copyConfig.text || "");
      _this2.setState({
        copied: true
      }, function() {
        if (copyConfig.onCopy) {
          copyConfig.onCopy();
        }
        _this2.copyId = window.setTimeout(function() {
          _this2.setState({
            copied: false
          });
        }, 3e3);
      });
    };
    _this2.setEditRef = function(node) {
      _this2.editIcon = node;
    };
    _this2.triggerEdit = function(edit) {
      var _this$getEditable2 = _this2.getEditable(), onStart = _this$getEditable2.onStart;
      if (edit && onStart) {
        onStart();
      }
      _this2.setState({
        edit
      }, function() {
        if (!edit && _this2.editIcon) {
          _this2.editIcon.focus();
        }
      });
    };
    _this2.resizeOnNextFrame = function() {
      wrapperRaf.cancel(_this2.rafId);
      _this2.rafId = wrapperRaf(function() {
        _this2.syncEllipsis();
      });
    };
    return _this2;
  }
  _createClass$2(Base2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        clientRendered: true
      });
      this.resizeOnNextFrame();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var children = this.props.children;
      var ellipsis = this.getEllipsis();
      var prevEllipsis = this.getEllipsis(prevProps);
      if (children !== prevProps.children || ellipsis.rows !== prevEllipsis.rows) {
        this.resizeOnNextFrame();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearTimeout(this.copyId);
      wrapperRaf.cancel(this.rafId);
    }
  }, {
    key: "getEditable",
    value: function getEditable(props) {
      var edit = this.state.edit;
      var _ref2 = props || this.props, editable = _ref2.editable;
      if (!editable)
        return {
          editing: edit
        };
      return _extends$2({
        editing: edit
      }, _typeof$5(editable) === "object" ? editable : null);
    }
  }, {
    key: "getEllipsis",
    value: function getEllipsis(props) {
      var _ref3 = props || this.props, ellipsis = _ref3.ellipsis;
      if (!ellipsis)
        return {};
      return _extends$2({
        rows: 1,
        expandable: false
      }, _typeof$5(ellipsis) === "object" ? ellipsis : null);
    }
  }, {
    key: "canUseCSSEllipsis",
    value: function canUseCSSEllipsis() {
      var clientRendered = this.state.clientRendered;
      var _this$props2 = this.props, editable = _this$props2.editable, copyable = _this$props2.copyable;
      var _this$getEllipsis2 = this.getEllipsis(), rows = _this$getEllipsis2.rows, expandable = _this$getEllipsis2.expandable, suffix = _this$getEllipsis2.suffix, onEllipsis = _this$getEllipsis2.onEllipsis, tooltip = _this$getEllipsis2.tooltip;
      if (suffix || tooltip)
        return false;
      if (editable || copyable || expandable || !clientRendered || onEllipsis) {
        return false;
      }
      if (rows === 1) {
        return isTextOverflowSupport;
      }
      return isLineClampSupport;
    }
  }, {
    key: "syncEllipsis",
    value: function syncEllipsis() {
      var _this$state = this.state, ellipsisText = _this$state.ellipsisText, isEllipsis = _this$state.isEllipsis, expanded = _this$state.expanded;
      var _this$getEllipsis3 = this.getEllipsis(), rows = _this$getEllipsis3.rows, suffix = _this$getEllipsis3.suffix, onEllipsis = _this$getEllipsis3.onEllipsis;
      var children = this.props.children;
      if (!rows || rows < 0 || !this.contentRef.current || expanded)
        return;
      if (this.canUseCSSEllipsis())
        return;
      devWarning(toArray$8(children).every(function(child) {
        return typeof child === "string";
      }), "Typography", "`ellipsis` should use string as children only.");
      var _measure = measure(this.contentRef.current, {
        rows,
        suffix
      }, children, this.renderOperations(true), ELLIPSIS_STR), content = _measure.content, text = _measure.text, ellipsis = _measure.ellipsis;
      if (ellipsisText !== text || isEllipsis !== ellipsis) {
        this.setState({
          ellipsisText: text,
          ellipsisContent: content,
          isEllipsis: ellipsis
        });
        if (isEllipsis !== ellipsis && onEllipsis) {
          onEllipsis(ellipsis);
        }
      }
    }
  }, {
    key: "renderExpand",
    value: function renderExpand(forceRender) {
      var _this$getEllipsis4 = this.getEllipsis(), expandable = _this$getEllipsis4.expandable, symbol = _this$getEllipsis4.symbol;
      var _this$state2 = this.state, expanded = _this$state2.expanded, isEllipsis = _this$state2.isEllipsis;
      if (!expandable)
        return null;
      if (!forceRender && (expanded || !isEllipsis))
        return null;
      var expandContent;
      if (symbol) {
        expandContent = symbol;
      } else {
        expandContent = this.expandStr;
      }
      return /* @__PURE__ */ React.createElement("a", {
        key: "expand",
        className: "".concat(this.getPrefixCls(), "-expand"),
        onClick: this.onExpandClick,
        "aria-label": this.expandStr
      }, expandContent);
    }
  }, {
    key: "renderEdit",
    value: function renderEdit() {
      var editable = this.props.editable;
      if (!editable)
        return;
      var icon = editable.icon, tooltip = editable.tooltip;
      var title = toArray$8(tooltip)[0] || this.editStr;
      var ariaLabel = typeof title === "string" ? title : "";
      return /* @__PURE__ */ React.createElement(Tooltip2, {
        key: "edit",
        title: tooltip === false ? "" : title
      }, /* @__PURE__ */ React.createElement(TransButton, {
        ref: this.setEditRef,
        className: "".concat(this.getPrefixCls(), "-edit"),
        onClick: this.onEditClick,
        "aria-label": ariaLabel
      }, icon || /* @__PURE__ */ React.createElement(EditOutlined$1, {
        role: "button"
      })));
    }
  }, {
    key: "renderCopy",
    value: function renderCopy() {
      var copied = this.state.copied;
      var copyable = this.props.copyable;
      if (!copyable)
        return;
      var prefixCls = this.getPrefixCls();
      var tooltips = copyable.tooltips;
      var tooltipNodes = toArray$8(tooltips);
      if (tooltipNodes.length === 0) {
        tooltipNodes = [this.copyStr, this.copiedStr];
      }
      var title = copied ? tooltipNodes[1] : tooltipNodes[0];
      var ariaLabel = typeof title === "string" ? title : "";
      var icons = toArray$8(copyable.icon);
      return /* @__PURE__ */ React.createElement(Tooltip2, {
        key: "copy",
        title: tooltips === false ? "" : title
      }, /* @__PURE__ */ React.createElement(TransButton, {
        className: cn("".concat(prefixCls, "-copy"), copied && "".concat(prefixCls, "-copy-success")),
        onClick: this.onCopyClick,
        "aria-label": ariaLabel
      }, copied ? icons[1] || /* @__PURE__ */ React.createElement(CheckOutlined$1, null) : icons[0] || /* @__PURE__ */ React.createElement(CopyOutlined$1, null)));
    }
  }, {
    key: "renderEditInput",
    value: function renderEditInput() {
      var _this$props3 = this.props, children = _this$props3.children, className = _this$props3.className, style2 = _this$props3.style;
      var direction = this.context.direction;
      var _this$getEditable3 = this.getEditable(), maxLength = _this$getEditable3.maxLength, autoSize = _this$getEditable3.autoSize, onEnd = _this$getEditable3.onEnd;
      return /* @__PURE__ */ React.createElement(Editable, {
        value: typeof children === "string" ? children : "",
        onSave: this.onEditChange,
        onCancel: this.onEditCancel,
        onEnd,
        prefixCls: this.getPrefixCls(),
        className,
        style: style2,
        direction,
        maxLength,
        autoSize
      });
    }
  }, {
    key: "renderOperations",
    value: function renderOperations(forceRenderExpanded) {
      return [this.renderExpand(forceRenderExpanded), this.renderEdit(), this.renderCopy()].filter(function(node) {
        return node;
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this2 = this;
      var _this$state3 = this.state, ellipsisContent = _this$state3.ellipsisContent, isEllipsis = _this$state3.isEllipsis, expanded = _this$state3.expanded;
      var _a = this.props, component = _a.component, children = _a.children, className = _a.className, type2 = _a.type, disabled = _a.disabled, style2 = _a.style, restProps = __rest$4(_a, ["component", "children", "className", "type", "disabled", "style"]);
      var direction = this.context.direction;
      var _this$getEllipsis5 = this.getEllipsis(), rows = _this$getEllipsis5.rows, suffix = _this$getEllipsis5.suffix, tooltip = _this$getEllipsis5.tooltip;
      var prefixCls = this.getPrefixCls();
      var textProps = omit$1(restProps, ["prefixCls", "editable", "copyable", "ellipsis", "mark", "code", "delete", "underline", "strong", "keyboard"].concat(_toConsumableArray(configConsumerProps)));
      var cssEllipsis = this.canUseCSSEllipsis();
      var cssTextOverflow = rows === 1 && cssEllipsis;
      var cssLineClamp = rows && rows > 1 && cssEllipsis;
      var textNode = children;
      if (rows && isEllipsis && !expanded && !cssEllipsis) {
        var title = restProps.title;
        var restContent = title || "";
        if (!title && (typeof children === "string" || typeof children === "number")) {
          restContent = String(children);
        }
        restContent = restContent === null || restContent === void 0 ? void 0 : restContent.slice(String(ellipsisContent || "").length);
        textNode = /* @__PURE__ */ React.createElement(React.Fragment, null, ellipsisContent, /* @__PURE__ */ React.createElement("span", {
          title: restContent,
          "aria-hidden": "true"
        }, ELLIPSIS_STR), suffix);
        if (tooltip) {
          textNode = /* @__PURE__ */ React.createElement(Tooltip2, {
            title: tooltip === true ? children : tooltip
          }, /* @__PURE__ */ React.createElement("span", null, textNode));
        }
      } else {
        textNode = /* @__PURE__ */ React.createElement(React.Fragment, null, children, suffix);
      }
      textNode = wrapperDecorations(this.props, textNode);
      return /* @__PURE__ */ React.createElement(LocaleReceiver, {
        componentName: "Text"
      }, function(_ref4) {
        var _classNames;
        var edit = _ref4.edit, copyStr = _ref4.copy, copied = _ref4.copied, expand = _ref4.expand;
        _this2.editStr = edit;
        _this2.copyStr = copyStr;
        _this2.copiedStr = copied;
        _this2.expandStr = expand;
        return /* @__PURE__ */ React.createElement(ResizeObserver, {
          onResize: _this2.resizeOnNextFrame,
          disabled: !rows
        }, /* @__PURE__ */ React.createElement(ExportTypography, _extends$2({
          className: cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-").concat(type2), type2), _defineProperty$4(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty$4(_classNames, "".concat(prefixCls, "-ellipsis"), rows), _defineProperty$4(_classNames, "".concat(prefixCls, "-ellipsis-single-line"), cssTextOverflow), _defineProperty$4(_classNames, "".concat(prefixCls, "-ellipsis-multiple-line"), cssLineClamp), _classNames), className),
          style: _extends$2(_extends$2({}, style2), {
            WebkitLineClamp: cssLineClamp ? rows : void 0
          }),
          component,
          ref: _this2.contentRef,
          direction
        }, textProps), textNode, _this2.renderOperations()));
      });
    }
  }, {
    key: "render",
    value: function render4() {
      var _this$getEditable4 = this.getEditable(), editing = _this$getEditable4.editing;
      if (editing) {
        return this.renderEditInput();
      }
      return this.renderContent();
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var children = nextProps.children, editable = nextProps.editable;
      devWarning(!editable || typeof children === "string", "Typography", "When `editable` is enabled, the `children` should use string.");
      return {};
    }
  }]);
  return Base2;
}(React.Component);
Base.contextType = ConfigContext;
Base.defaultProps = {
  children: ""
};
var __rest$3 = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var Text = function Text2(_a) {
  var ellipsis = _a.ellipsis, restProps = __rest$3(_a, ["ellipsis"]);
  var mergedEllipsis = React.useMemo(function() {
    if (ellipsis && _typeof$5(ellipsis) === "object") {
      return omit$1(ellipsis, ["expandable", "rows"]);
    }
    return ellipsis;
  }, [ellipsis]);
  devWarning(_typeof$5(ellipsis) !== "object" || !ellipsis || !("expandable" in ellipsis) && !("rows" in ellipsis), "Typography.Text", "`ellipsis` do not support `expandable` or `rows` props.");
  return /* @__PURE__ */ React.createElement(Base, _extends$2({}, restProps, {
    ellipsis: mergedEllipsis,
    component: "span"
  }));
};
var __rest$2 = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var Link$2 = function Link(_a, ref) {
  var ellipsis = _a.ellipsis, rel = _a.rel, restProps = __rest$2(_a, ["ellipsis", "rel"]);
  devWarning(_typeof$5(ellipsis) !== "object", "Typography.Link", "`ellipsis` only supports boolean value.");
  var baseRef = React.useRef(null);
  React.useImperativeHandle(ref, function() {
    var _a2;
    return (_a2 = baseRef.current) === null || _a2 === void 0 ? void 0 : _a2.contentRef.current;
  });
  var mergedProps = _extends$2(_extends$2({}, restProps), {
    rel: rel === void 0 && restProps.target === "_blank" ? "noopener noreferrer" : rel
  });
  delete mergedProps.navigate;
  return /* @__PURE__ */ React.createElement(Base, _extends$2({}, mergedProps, {
    ref: baseRef,
    ellipsis: !!ellipsis,
    component: "a"
  }));
};
var Link$3 = /* @__PURE__ */ React.forwardRef(Link$2);
var __rest$1 = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var TITLE_ELE_LIST = tupleNum(1, 2, 3, 4, 5);
var Title2 = function Title3(props) {
  var _props$level = props.level, level = _props$level === void 0 ? 1 : _props$level, restProps = __rest$1(props, ["level"]);
  var component;
  if (TITLE_ELE_LIST.indexOf(level) !== -1) {
    component = "h".concat(level);
  } else {
    devWarning(false, "Typography.Title", "Title only accept `1 | 2 | 3 | 4 | 5` as `level` value. And `5` need 4.6.0+ version.");
    component = "h1";
  }
  return /* @__PURE__ */ React.createElement(Base, _extends$2({}, restProps, {
    component
  }));
};
var Paragraph2 = function Paragraph3(props) {
  return /* @__PURE__ */ React.createElement(Base, _extends$2({}, props, {
    component: "div"
  }));
};
var Typography2 = ExportTypography;
Typography2.Text = Text;
Typography2.Link = Link$3;
Typography2.Title = Title2;
Typography2.Paragraph = Paragraph2;
function getError(option, xhr) {
  var msg = "cannot ".concat(option.method, " ").concat(option.action, " ").concat(xhr.status, "'");
  var err = new Error(msg);
  err.status = xhr.status;
  err.method = option.method;
  err.url = option.action;
  return err;
}
function getBody(xhr) {
  var text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }
  try {
    return JSON.parse(text);
  } catch (e3) {
    return text;
  }
}
function upload(option) {
  var xhr = new XMLHttpRequest();
  if (option.onProgress && xhr.upload) {
    xhr.upload.onprogress = function progress(e3) {
      if (e3.total > 0) {
        e3.percent = e3.loaded / e3.total * 100;
      }
      option.onProgress(e3);
    };
  }
  var formData = new FormData();
  if (option.data) {
    Object.keys(option.data).forEach(function(key2) {
      var value = option.data[key2];
      if (Array.isArray(value)) {
        value.forEach(function(item) {
          formData.append("".concat(key2, "[]"), item);
        });
        return;
      }
      formData.append(key2, option.data[key2]);
    });
  }
  if (option.file instanceof Blob) {
    formData.append(option.filename, option.file, option.file.name);
  } else {
    formData.append(option.filename, option.file);
  }
  xhr.onerror = function error(e3) {
    option.onError(e3);
  };
  xhr.onload = function onload() {
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(option, xhr), getBody(xhr));
    }
    return option.onSuccess(getBody(xhr), xhr);
  };
  xhr.open(option.method, option.action, true);
  if (option.withCredentials && "withCredentials" in xhr) {
    xhr.withCredentials = true;
  }
  var headers = option.headers || {};
  if (headers["X-Requested-With"] !== null) {
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  }
  Object.keys(headers).forEach(function(h) {
    if (headers[h] !== null) {
      xhr.setRequestHeader(h, headers[h]);
    }
  });
  xhr.send(formData);
  return {
    abort: function abort() {
      xhr.abort();
    }
  };
}
var now = +new Date();
var index = 0;
function uid() {
  return "rc-upload-".concat(now, "-").concat(++index);
}
var attrAccept = function(file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
    var fileName = file.name || "";
    var mimeType = file.type || "";
    var baseMimeType = mimeType.replace(/\/.*$/, "");
    return acceptedFilesArray.some(function(type2) {
      var validType = type2.trim();
      if (/^\*(\/\*)?$/.test(type2)) {
        return true;
      }
      if (validType.charAt(0) === ".") {
        var lowerFileName = fileName.toLowerCase();
        var lowerType = validType.toLowerCase();
        var affixList = [lowerType];
        if (lowerType === ".jpg" || lowerType === ".jpeg") {
          affixList = [".jpg", "jpeg"];
        }
        return affixList.some(function(affix) {
          return lowerFileName.endsWith(affix);
        });
      }
      if (/\/\*$/.test(validType)) {
        return baseMimeType === validType.replace(/\/.*$/, "");
      }
      return mimeType === validType;
    });
  }
  return true;
};
function loopFiles(item, callback) {
  var dirReader = item.createReader();
  var fileList = [];
  function sequence() {
    dirReader.readEntries(function(entries) {
      var entryList = Array.prototype.slice.apply(entries);
      fileList = fileList.concat(entryList);
      var isFinished = !entryList.length;
      if (isFinished) {
        callback(fileList);
      } else {
        sequence();
      }
    });
  }
  sequence();
}
var traverseFileTree = function traverseFileTree2(files, callback, isAccepted) {
  var _traverseFileTree = function _traverseFileTree2(item, path2) {
    item.path = path2 || "";
    if (item.isFile) {
      item.file(function(file) {
        if (isAccepted(file)) {
          if (item.fullPath && !file.webkitRelativePath) {
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: true
              }
            });
            file.webkitRelativePath = item.fullPath.replace(/^\//, "");
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: false
              }
            });
          }
          callback([file]);
        }
      });
    } else if (item.isDirectory) {
      loopFiles(item, function(entries) {
        entries.forEach(function(entryItem) {
          _traverseFileTree2(entryItem, "".concat(path2).concat(item.name, "/"));
        });
      });
    }
  };
  files.forEach(function(file) {
    _traverseFileTree(file.webkitGetAsEntry());
  });
};
var AjaxUploader = /* @__PURE__ */ function(_Component) {
  _inherits$1(AjaxUploader2, _Component);
  var _super = _createSuper$1(AjaxUploader2);
  function AjaxUploader2() {
    var _this2;
    _classCallCheck$2(this, AjaxUploader2);
    _this2 = _super.apply(this, arguments);
    _this2.state = {
      uid: uid()
    };
    _this2.reqs = {};
    _this2.onChange = function(e3) {
      var files = e3.target.files;
      var acceptedFiles = _toConsumableArray(files).filter(function(file) {
        return attrAccept(file, _this2.props.accept);
      });
      _this2.uploadFiles(acceptedFiles);
      _this2.reset();
    };
    _this2.onClick = function(e3) {
      var el = _this2.fileInput;
      if (!el) {
        return;
      }
      var _this$props = _this2.props, children = _this$props.children, onClick = _this$props.onClick;
      if (children && children.type === "button") {
        var parent = el.parentNode;
        parent.focus();
        parent.querySelector("button").blur();
      }
      el.click();
      if (onClick) {
        onClick(e3);
      }
    };
    _this2.onKeyDown = function(e3) {
      if (e3.key === "Enter") {
        _this2.onClick(e3);
      }
    };
    _this2.onFileDrop = function(e3) {
      var multiple = _this2.props.multiple;
      e3.preventDefault();
      if (e3.type === "dragover") {
        return;
      }
      if (_this2.props.directory) {
        traverseFileTree(Array.prototype.slice.call(e3.dataTransfer.items), _this2.uploadFiles, function(_file) {
          return attrAccept(_file, _this2.props.accept);
        });
      } else {
        var files = _toConsumableArray(e3.dataTransfer.files).filter(function(file) {
          return attrAccept(file, _this2.props.accept);
        });
        if (multiple === false) {
          files = files.slice(0, 1);
        }
        _this2.uploadFiles(files);
      }
    };
    _this2.uploadFiles = function(files) {
      var originFiles = _toConsumableArray(files);
      var postFiles = originFiles.map(function(file) {
        file.uid = uid();
        return _this2.processFile(file, originFiles);
      });
      Promise.all(postFiles).then(function(fileList) {
        var onBatchStart = _this2.props.onBatchStart;
        onBatchStart === null || onBatchStart === void 0 ? void 0 : onBatchStart(fileList.map(function(_ref) {
          var origin = _ref.origin, parsedFile = _ref.parsedFile;
          return {
            file: origin,
            parsedFile
          };
        }));
        fileList.filter(function(file) {
          return file.parsedFile !== null;
        }).forEach(function(file) {
          _this2.post(file);
        });
      });
    };
    _this2.processFile = /* @__PURE__ */ function() {
      var _ref2 = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee(file, fileList) {
        var beforeUpload, transformedFile, action, mergedAction, data, mergedData, parsedData, parsedFile, mergedParsedFile;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                beforeUpload = _this2.props.beforeUpload;
                transformedFile = file;
                if (!beforeUpload) {
                  _context.next = 14;
                  break;
                }
                _context.prev = 3;
                _context.next = 6;
                return beforeUpload(file, fileList);
              case 6:
                transformedFile = _context.sent;
                _context.next = 12;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);
                transformedFile = false;
              case 12:
                if (!(transformedFile === false)) {
                  _context.next = 14;
                  break;
                }
                return _context.abrupt("return", {
                  origin: file,
                  parsedFile: null,
                  action: null,
                  data: null
                });
              case 14:
                action = _this2.props.action;
                if (!(typeof action === "function")) {
                  _context.next = 21;
                  break;
                }
                _context.next = 18;
                return action(file);
              case 18:
                mergedAction = _context.sent;
                _context.next = 22;
                break;
              case 21:
                mergedAction = action;
              case 22:
                data = _this2.props.data;
                if (!(typeof data === "function")) {
                  _context.next = 29;
                  break;
                }
                _context.next = 26;
                return data(file);
              case 26:
                mergedData = _context.sent;
                _context.next = 30;
                break;
              case 29:
                mergedData = data;
              case 30:
                parsedData = (_typeof$5(transformedFile) === "object" || typeof transformedFile === "string") && transformedFile ? transformedFile : file;
                if (parsedData instanceof File) {
                  parsedFile = parsedData;
                } else {
                  parsedFile = new File([parsedData], file.name, {
                    type: file.type
                  });
                }
                mergedParsedFile = parsedFile;
                mergedParsedFile.uid = file.uid;
                return _context.abrupt("return", {
                  origin: file,
                  data: mergedData,
                  parsedFile: mergedParsedFile,
                  action: mergedAction
                });
              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 9]]);
      }));
      return function(_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    _this2.saveFileInput = function(node) {
      _this2.fileInput = node;
    };
    return _this2;
  }
  _createClass$2(AjaxUploader2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.abort();
    }
  }, {
    key: "post",
    value: function post(_ref3) {
      var _this2 = this;
      var data = _ref3.data, origin = _ref3.origin, action = _ref3.action, parsedFile = _ref3.parsedFile;
      if (!this._isMounted) {
        return;
      }
      var _this$props2 = this.props, onStart = _this$props2.onStart, customRequest = _this$props2.customRequest, name = _this$props2.name, headers = _this$props2.headers, withCredentials = _this$props2.withCredentials, method3 = _this$props2.method;
      var uid2 = origin.uid;
      var request = customRequest || upload;
      var requestOption = {
        action,
        filename: name,
        data,
        file: parsedFile,
        headers,
        withCredentials,
        method: method3 || "post",
        onProgress: function onProgress(e3) {
          var onProgress2 = _this2.props.onProgress;
          onProgress2 === null || onProgress2 === void 0 ? void 0 : onProgress2(e3, parsedFile);
        },
        onSuccess: function onSuccess(ret, xhr) {
          var onSuccess2 = _this2.props.onSuccess;
          onSuccess2 === null || onSuccess2 === void 0 ? void 0 : onSuccess2(ret, parsedFile, xhr);
          delete _this2.reqs[uid2];
        },
        onError: function onError(err, ret) {
          var onError2 = _this2.props.onError;
          onError2 === null || onError2 === void 0 ? void 0 : onError2(err, ret, parsedFile);
          delete _this2.reqs[uid2];
        }
      };
      onStart(origin);
      this.reqs[uid2] = request(requestOption);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        uid: uid()
      });
    }
  }, {
    key: "abort",
    value: function abort(file) {
      var reqs = this.reqs;
      if (file) {
        var uid2 = file.uid ? file.uid : file;
        if (reqs[uid2] && reqs[uid2].abort) {
          reqs[uid2].abort();
        }
        delete reqs[uid2];
      } else {
        Object.keys(reqs).forEach(function(uid3) {
          if (reqs[uid3] && reqs[uid3].abort) {
            reqs[uid3].abort();
          }
          delete reqs[uid3];
        });
      }
    }
  }, {
    key: "render",
    value: function render4() {
      var _classNames;
      var _this$props3 = this.props, Tag2 = _this$props3.component, prefixCls = _this$props3.prefixCls, className = _this$props3.className, disabled = _this$props3.disabled, id2 = _this$props3.id, style2 = _this$props3.style, multiple = _this$props3.multiple, accept = _this$props3.accept, children = _this$props3.children, directory = _this$props3.directory, openFileDialogOnClick = _this$props3.openFileDialogOnClick, onMouseEnter = _this$props3.onMouseEnter, onMouseLeave = _this$props3.onMouseLeave, capture = _this$props3.capture, otherProps = _objectWithoutProperties$1(_this$props3, ["component", "prefixCls", "className", "disabled", "id", "style", "multiple", "accept", "children", "directory", "openFileDialogOnClick", "onMouseEnter", "onMouseLeave", "capture"]);
      var cls = cn((_classNames = {}, _defineProperty$4(_classNames, prefixCls, true), _defineProperty$4(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty$4(_classNames, className, className), _classNames));
      var dirProps = directory ? {
        directory: "directory",
        webkitdirectory: "webkitdirectory"
      } : {};
      var events = disabled ? {} : {
        onClick: openFileDialogOnClick ? this.onClick : function() {
        },
        onKeyDown: openFileDialogOnClick ? this.onKeyDown : function() {
        },
        onMouseEnter,
        onMouseLeave,
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDrop,
        tabIndex: "0"
      };
      return /* @__PURE__ */ React__default.createElement(Tag2, _extends$2({}, events, {
        className: cls,
        role: "button",
        style: style2
      }), /* @__PURE__ */ React__default.createElement("input", _extends$2({}, pickAttrs(otherProps, {
        aria: true,
        data: true
      }), {
        id: id2,
        type: "file",
        ref: this.saveFileInput,
        onClick: function onClick(e3) {
          return e3.stopPropagation();
        },
        key: this.state.uid,
        style: {
          display: "none"
        },
        accept
      }, dirProps, {
        multiple,
        onChange: this.onChange
      }, capture != null ? {
        capture
      } : {})), children);
    }
  }]);
  return AjaxUploader2;
}(Component2);
function empty() {
}
var Upload$1 = /* @__PURE__ */ function(_Component) {
  _inherits$1(Upload2, _Component);
  var _super = _createSuper$1(Upload2);
  function Upload2() {
    var _this2;
    _classCallCheck$2(this, Upload2);
    _this2 = _super.apply(this, arguments);
    _this2.saveUploader = function(node) {
      _this2.uploader = node;
    };
    return _this2;
  }
  _createClass$2(Upload2, [{
    key: "abort",
    value: function abort(file) {
      this.uploader.abort(file);
    }
  }, {
    key: "render",
    value: function render4() {
      return /* @__PURE__ */ React__default.createElement(AjaxUploader, _extends$2({}, this.props, {
        ref: this.saveUploader
      }));
    }
  }]);
  return Upload2;
}(Component2);
Upload$1.defaultProps = {
  component: "span",
  prefixCls: "rc-upload",
  data: {},
  headers: {},
  name: "file",
  multipart: false,
  onStart: empty,
  onError: empty,
  onSuccess: empty,
  multiple: false,
  beforeUpload: null,
  customRequest: null,
  withCredentials: false,
  openFileDialogOnClick: true
};
var __rest = function(s2, e3) {
  var t3 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e3.indexOf(p) < 0)
      t3[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
        t3[p[i2]] = s2[p[i2]];
    }
  return t3;
};
var InternalDragger = function InternalDragger2(_a, ref) {
  var style2 = _a.style, height = _a.height, restProps = __rest(_a, ["style", "height"]);
  return /* @__PURE__ */ React.createElement(Upload, _extends$2({
    ref
  }, restProps, {
    type: "drag",
    style: _extends$2(_extends$2({}, style2), {
      height
    })
  }));
};
var Dragger = /* @__PURE__ */ React.forwardRef(InternalDragger);
Dragger.displayName = "Dragger";
var PaperClipOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] }, "name": "paper-clip", "theme": "outlined" };
var PaperClipOutlined = function PaperClipOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: PaperClipOutlined$2
  }));
};
PaperClipOutlined.displayName = "PaperClipOutlined";
var PaperClipOutlined$1 = /* @__PURE__ */ React.forwardRef(PaperClipOutlined);
var PictureTwoTone$2 = { "icon": function render2(primaryColor, secondaryColor) {
  return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", "fill": primaryColor } }] };
}, "name": "picture", "theme": "twotone" };
var PictureTwoTone = function PictureTwoTone2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: PictureTwoTone$2
  }));
};
PictureTwoTone.displayName = "PictureTwoTone";
var PictureTwoTone$1 = /* @__PURE__ */ React.forwardRef(PictureTwoTone);
var FileTwoTone$2 = { "icon": function render3(primaryColor, secondaryColor) {
  return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }] };
}, "name": "file", "theme": "twotone" };
var FileTwoTone = function FileTwoTone2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: FileTwoTone$2
  }));
};
FileTwoTone.displayName = "FileTwoTone";
var FileTwoTone$1 = /* @__PURE__ */ React.forwardRef(FileTwoTone);
function file2Obj(file) {
  return _extends$2(_extends$2({}, file), {
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.name,
    size: file.size,
    type: file.type,
    uid: file.uid,
    percent: 0,
    originFileObj: file
  });
}
function updateFileList(file, fileList) {
  var nextFileList = _toConsumableArray(fileList);
  var fileIndex = nextFileList.findIndex(function(_ref) {
    var uid2 = _ref.uid;
    return uid2 === file.uid;
  });
  if (fileIndex === -1) {
    nextFileList.push(file);
  } else {
    nextFileList[fileIndex] = file;
  }
  return nextFileList;
}
function getFileItem(file, fileList) {
  var matchKey = file.uid !== void 0 ? "uid" : "name";
  return fileList.filter(function(item) {
    return item[matchKey] === file[matchKey];
  })[0];
}
function removeFileItem(file, fileList) {
  var matchKey = file.uid !== void 0 ? "uid" : "name";
  var removed = fileList.filter(function(item) {
    return item[matchKey] !== file[matchKey];
  });
  if (removed.length === fileList.length) {
    return null;
  }
  return removed;
}
var extname = function extname2() {
  var url2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var temp = url2.split("/");
  var filename = temp[temp.length - 1];
  var filenameWithoutSuffix = filename.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [""])[0];
};
var isImageFileType = function isImageFileType2(type2) {
  return type2.indexOf("image/") === 0;
};
var isImageUrl = function isImageUrl2(file) {
  if (file.type && !file.thumbUrl) {
    return isImageFileType(file.type);
  }
  var url2 = file.thumbUrl || file.url;
  var extension = extname(url2);
  if (/^data:image\//.test(url2) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)) {
    return true;
  }
  if (/^data:/.test(url2)) {
    return false;
  }
  if (extension) {
    return false;
  }
  return true;
};
var MEASURE_SIZE = 200;
function previewImage(file) {
  return new Promise(function(resolve) {
    if (!file.type || !isImageFileType(file.type)) {
      resolve("");
      return;
    }
    var canvas = document.createElement("canvas");
    canvas.width = MEASURE_SIZE;
    canvas.height = MEASURE_SIZE;
    canvas.style.cssText = "position: fixed; left: 0; top: 0; width: ".concat(MEASURE_SIZE, "px; height: ").concat(MEASURE_SIZE, "px; z-index: 9999; display: none;");
    document.body.appendChild(canvas);
    var ctx = canvas.getContext("2d");
    var img = new Image();
    img.onload = function() {
      var width = img.width, height = img.height;
      var drawWidth = MEASURE_SIZE;
      var drawHeight = MEASURE_SIZE;
      var offsetX = 0;
      var offsetY = 0;
      if (width > height) {
        drawHeight = height * (MEASURE_SIZE / width);
        offsetY = -(drawHeight - drawWidth) / 2;
      } else {
        drawWidth = width * (MEASURE_SIZE / height);
        offsetX = -(drawWidth - drawHeight) / 2;
      }
      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
      var dataURL = canvas.toDataURL();
      document.body.removeChild(canvas);
      resolve(dataURL);
    };
    img.src = window.URL.createObjectURL(file);
  });
}
var DownloadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, "name": "download", "theme": "outlined" };
var DownloadOutlined = function DownloadOutlined2(props, ref) {
  return /* @__PURE__ */ React.createElement(Icon$1, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref,
    icon: DownloadOutlined$2
  }));
};
DownloadOutlined.displayName = "DownloadOutlined";
var DownloadOutlined$1 = /* @__PURE__ */ React.forwardRef(DownloadOutlined);
var ListItem2 = /* @__PURE__ */ React.forwardRef(function(_ref, ref) {
  var _classNames3;
  var prefixCls = _ref.prefixCls, className = _ref.className, style2 = _ref.style, locale2 = _ref.locale, listType = _ref.listType, file = _ref.file, items = _ref.items, progressProps = _ref.progress, iconRender2 = _ref.iconRender, actionIconRender = _ref.actionIconRender, itemRender = _ref.itemRender, isImgUrl = _ref.isImgUrl, showPreviewIcon = _ref.showPreviewIcon, showRemoveIcon = _ref.showRemoveIcon, showDownloadIcon = _ref.showDownloadIcon, customRemoveIcon = _ref.removeIcon, customDownloadIcon = _ref.downloadIcon, onPreview = _ref.onPreview, onDownload = _ref.onDownload, onClose2 = _ref.onClose;
  var _a, _b;
  var _React$useState = React.useState(false), _React$useState2 = _slicedToArray$3(_React$useState, 2), showProgress = _React$useState2[0], setShowProgress = _React$useState2[1];
  var progressRafRef = React.useRef();
  React.useEffect(function() {
    progressRafRef.current = setTimeout(function() {
      setShowProgress(true);
    }, 300);
    return function() {
      window.clearTimeout(progressRafRef.current);
    };
  }, []);
  var spanClassName = "".concat(prefixCls, "-span");
  var iconNode = iconRender2(file);
  var icon = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-text-icon")
  }, iconNode);
  if (listType === "picture" || listType === "picture-card") {
    if (file.status === "uploading" || !file.thumbUrl && !file.url) {
      var _classNames;
      var uploadingClassName = cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-list-item-thumbnail"), true), _defineProperty$4(_classNames, "".concat(prefixCls, "-list-item-file"), file.status !== "uploading"), _classNames));
      icon = /* @__PURE__ */ React.createElement("div", {
        className: uploadingClassName
      }, iconNode);
    } else {
      var _classNames2;
      var thumbnail = (isImgUrl === null || isImgUrl === void 0 ? void 0 : isImgUrl(file)) ? /* @__PURE__ */ React.createElement("img", {
        src: file.thumbUrl || file.url,
        alt: file.name,
        className: "".concat(prefixCls, "-list-item-image")
      }) : iconNode;
      var aClassName = cn((_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-list-item-thumbnail"), true), _defineProperty$4(_classNames2, "".concat(prefixCls, "-list-item-file"), isImgUrl && !isImgUrl(file)), _classNames2));
      icon = /* @__PURE__ */ React.createElement("a", {
        className: aClassName,
        onClick: function onClick(e3) {
          return onPreview(file, e3);
        },
        href: file.url || file.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, thumbnail);
    }
  }
  var infoUploadingClass = cn((_classNames3 = {}, _defineProperty$4(_classNames3, "".concat(prefixCls, "-list-item"), true), _defineProperty$4(_classNames3, "".concat(prefixCls, "-list-item-").concat(file.status), true), _defineProperty$4(_classNames3, "".concat(prefixCls, "-list-item-list-type-").concat(listType), true), _classNames3));
  var linkProps = typeof file.linkProps === "string" ? JSON.parse(file.linkProps) : file.linkProps;
  var removeIcon = showRemoveIcon ? actionIconRender((typeof customRemoveIcon === "function" ? customRemoveIcon(file) : customRemoveIcon) || /* @__PURE__ */ React.createElement(DeleteOutlined$1, null), function() {
    return onClose2(file);
  }, prefixCls, locale2.removeFile) : null;
  var downloadIcon = showDownloadIcon && file.status === "done" ? actionIconRender((typeof customDownloadIcon === "function" ? customDownloadIcon(file) : customDownloadIcon) || /* @__PURE__ */ React.createElement(DownloadOutlined$1, null), function() {
    return onDownload(file);
  }, prefixCls, locale2.downloadFile) : null;
  var downloadOrDelete = listType !== "picture-card" && /* @__PURE__ */ React.createElement("span", {
    key: "download-delete",
    className: cn("".concat(prefixCls, "-list-item-card-actions"), {
      picture: listType === "picture"
    })
  }, downloadIcon, removeIcon);
  var listItemNameClass = cn("".concat(prefixCls, "-list-item-name"));
  var preview = file.url ? [/* @__PURE__ */ React.createElement("a", _extends$2({
    key: "view",
    target: "_blank",
    rel: "noopener noreferrer",
    className: listItemNameClass,
    title: file.name
  }, linkProps, {
    href: file.url,
    onClick: function onClick(e3) {
      return onPreview(file, e3);
    }
  }), file.name), downloadOrDelete] : [/* @__PURE__ */ React.createElement("span", {
    key: "view",
    className: listItemNameClass,
    onClick: function onClick(e3) {
      return onPreview(file, e3);
    },
    title: file.name
  }, file.name), downloadOrDelete];
  var previewStyle = {
    pointerEvents: "none",
    opacity: 0.5
  };
  var previewIcon = showPreviewIcon ? /* @__PURE__ */ React.createElement("a", {
    href: file.url || file.thumbUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    style: file.url || file.thumbUrl ? void 0 : previewStyle,
    onClick: function onClick(e3) {
      return onPreview(file, e3);
    },
    title: locale2.previewFile
  }, /* @__PURE__ */ React.createElement(EyeOutlined$1, null)) : null;
  var actions = listType === "picture-card" && file.status !== "uploading" && /* @__PURE__ */ React.createElement("span", {
    className: "".concat(prefixCls, "-list-item-actions")
  }, previewIcon, file.status === "done" && downloadIcon, removeIcon);
  var message;
  if (file.response && typeof file.response === "string") {
    message = file.response;
  } else {
    message = ((_a = file.error) === null || _a === void 0 ? void 0 : _a.statusText) || ((_b = file.error) === null || _b === void 0 ? void 0 : _b.message) || locale2.uploadError;
  }
  var iconAndPreview = /* @__PURE__ */ React.createElement("span", {
    className: spanClassName
  }, icon, preview);
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
  var rootPrefixCls = getPrefixCls();
  var dom = /* @__PURE__ */ React.createElement("div", {
    className: infoUploadingClass
  }, /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-list-item-info")
  }, iconAndPreview), actions, showProgress && /* @__PURE__ */ React.createElement(CSSMotion, {
    motionName: "".concat(rootPrefixCls, "-fade"),
    visible: file.status === "uploading",
    motionDeadline: 2e3
  }, function(_ref2) {
    var motionClassName = _ref2.className;
    var loadingProgress = "percent" in file ? /* @__PURE__ */ React.createElement(Progress, _extends$2({}, progressProps, {
      type: "line",
      percent: file.percent
    })) : null;
    return /* @__PURE__ */ React.createElement("div", {
      className: cn("".concat(prefixCls, "-list-item-progress"), motionClassName)
    }, loadingProgress);
  }));
  var listContainerNameClass = cn("".concat(prefixCls, "-list-").concat(listType, "-container"), className);
  var item = file.status === "error" ? /* @__PURE__ */ React.createElement(Tooltip2, {
    title: message,
    getPopupContainer: function getPopupContainer(node) {
      return node.parentNode;
    }
  }, dom) : dom;
  return /* @__PURE__ */ React.createElement("div", {
    className: listContainerNameClass,
    style: style2,
    ref
  }, itemRender ? itemRender(item, file, items) : item);
});
var listItemMotion = _extends$2({}, collapseMotion);
delete listItemMotion.onAppearEnd;
delete listItemMotion.onEnterEnd;
delete listItemMotion.onLeaveEnd;
var InternalUploadList = function InternalUploadList2(_ref, ref) {
  var _classNames;
  var listType = _ref.listType, previewFile = _ref.previewFile, onPreview = _ref.onPreview, onDownload = _ref.onDownload, onRemove = _ref.onRemove, locale2 = _ref.locale, iconRender2 = _ref.iconRender, isImgUrl = _ref.isImageUrl, customizePrefixCls = _ref.prefixCls, _ref$items = _ref.items, items = _ref$items === void 0 ? [] : _ref$items, showPreviewIcon = _ref.showPreviewIcon, showRemoveIcon = _ref.showRemoveIcon, showDownloadIcon = _ref.showDownloadIcon, removeIcon = _ref.removeIcon, downloadIcon = _ref.downloadIcon, progress = _ref.progress, appendAction = _ref.appendAction, itemRender = _ref.itemRender;
  var forceUpdate = useForceUpdate();
  var _React$useState = React.useState(false), _React$useState2 = _slicedToArray$3(_React$useState, 2), motionAppear = _React$useState2[0], setMotionAppear = _React$useState2[1];
  React.useEffect(function() {
    if (listType !== "picture" && listType !== "picture-card") {
      return;
    }
    (items || []).forEach(function(file) {
      if (typeof document === "undefined" || typeof window === "undefined" || !window.FileReader || !window.File || !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== void 0) {
        return;
      }
      file.thumbUrl = "";
      if (previewFile) {
        previewFile(file.originFileObj).then(function(previewDataUrl) {
          file.thumbUrl = previewDataUrl || "";
          forceUpdate();
        });
      }
    });
  }, [listType, items, previewFile]);
  React.useEffect(function() {
    setMotionAppear(true);
  }, []);
  var onInternalPreview = function onInternalPreview2(file, e3) {
    if (!onPreview) {
      return;
    }
    e3.preventDefault();
    return onPreview(file);
  };
  var onInternalDownload = function onInternalDownload2(file) {
    if (typeof onDownload === "function") {
      onDownload(file);
    } else if (file.url) {
      window.open(file.url);
    }
  };
  var onInternalClose = function onInternalClose2(file) {
    onRemove === null || onRemove === void 0 ? void 0 : onRemove(file);
  };
  var internalIconRender = function internalIconRender2(file) {
    if (iconRender2) {
      return iconRender2(file, listType);
    }
    var isLoading = file.status === "uploading";
    var fileIcon = isImgUrl && isImgUrl(file) ? /* @__PURE__ */ React.createElement(PictureTwoTone$1, null) : /* @__PURE__ */ React.createElement(FileTwoTone$1, null);
    var icon = isLoading ? /* @__PURE__ */ React.createElement(LoadingOutlined$1, null) : /* @__PURE__ */ React.createElement(PaperClipOutlined$1, null);
    if (listType === "picture") {
      icon = isLoading ? /* @__PURE__ */ React.createElement(LoadingOutlined$1, null) : fileIcon;
    } else if (listType === "picture-card") {
      icon = isLoading ? locale2.uploading : fileIcon;
    }
    return icon;
  };
  var actionIconRender = function actionIconRender2(customIcon, callback, prefixCls2, title) {
    var btnProps = {
      type: "text",
      size: "small",
      title,
      onClick: function onClick(e3) {
        callback();
        if (isValidElement2(customIcon) && customIcon.props.onClick) {
          customIcon.props.onClick(e3);
        }
      },
      className: "".concat(prefixCls2, "-list-item-card-actions-btn")
    };
    if (isValidElement2(customIcon)) {
      var btnIcon = cloneElement2(customIcon, _extends$2(_extends$2({}, customIcon.props), {
        onClick: function onClick() {
        }
      }));
      return /* @__PURE__ */ React.createElement(Button$1, _extends$2({}, btnProps, {
        icon: btnIcon
      }));
    }
    return /* @__PURE__ */ React.createElement(Button$1, btnProps, /* @__PURE__ */ React.createElement("span", null, customIcon));
  };
  React.useImperativeHandle(ref, function() {
    return {
      handlePreview: onInternalPreview,
      handleDownload: onInternalDownload
    };
  });
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var prefixCls = getPrefixCls("upload", customizePrefixCls);
  var listClassNames = cn((_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-list"), true), _defineProperty$4(_classNames, "".concat(prefixCls, "-list-").concat(listType), true), _defineProperty$4(_classNames, "".concat(prefixCls, "-list-rtl"), direction === "rtl"), _classNames));
  var motionKeyList = _toConsumableArray(items.map(function(file) {
    return {
      key: file.uid,
      file
    };
  }));
  var animationDirection = listType === "picture-card" ? "animate-inline" : "animate";
  var motionConfig = {
    motionDeadline: 2e3,
    motionName: "".concat(prefixCls, "-").concat(animationDirection),
    keys: motionKeyList,
    motionAppear
  };
  if (listType !== "picture-card") {
    motionConfig = _extends$2(_extends$2({}, listItemMotion), motionConfig);
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: listClassNames
  }, /* @__PURE__ */ React.createElement(CSSMotionList, _extends$2({}, motionConfig, {
    component: false
  }), function(_ref2) {
    var key2 = _ref2.key, file = _ref2.file, motionClassName = _ref2.className, motionStyle = _ref2.style;
    return /* @__PURE__ */ React.createElement(ListItem2, {
      key: key2,
      locale: locale2,
      prefixCls,
      className: motionClassName,
      style: motionStyle,
      file,
      items,
      progress,
      listType,
      isImgUrl,
      showPreviewIcon,
      showRemoveIcon,
      showDownloadIcon,
      removeIcon,
      downloadIcon,
      iconRender: internalIconRender,
      actionIconRender,
      itemRender,
      onPreview: onInternalPreview,
      onDownload: onInternalDownload,
      onClose: onInternalClose
    });
  }), appendAction && /* @__PURE__ */ React.createElement(CSSMotion, motionConfig, function(_ref3) {
    var motionClassName = _ref3.className, motionStyle = _ref3.style;
    return cloneElement2(appendAction, function(oriProps) {
      return {
        className: cn(oriProps.className, motionClassName),
        style: _extends$2(_extends$2({}, motionStyle), oriProps.style)
      };
    });
  }));
};
var UploadList = /* @__PURE__ */ React.forwardRef(InternalUploadList);
UploadList.displayName = "UploadList";
UploadList.defaultProps = {
  listType: "text",
  progress: {
    strokeWidth: 2,
    showInfo: false
  },
  showRemoveIcon: true,
  showDownloadIcon: false,
  showPreviewIcon: true,
  previewFile: previewImage,
  isImageUrl
};
var __awaiter = function(thisArg, _arguments, P2, generator2) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator2.next(value));
      } catch (e3) {
        reject(e3);
      }
    }
    function rejected(value) {
      try {
        step(generator2["throw"](value));
      } catch (e3) {
        reject(e3);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator2 = generator2.apply(thisArg, _arguments || [])).next());
  });
};
var LIST_IGNORE = "__LIST_IGNORE_".concat(Date.now(), "__");
var InternalUpload = function InternalUpload2(props, ref) {
  var _classNames2;
  var fileList = props.fileList, defaultFileList = props.defaultFileList, onRemove = props.onRemove, showUploadList = props.showUploadList, listType = props.listType, onPreview = props.onPreview, onDownload = props.onDownload, onChange4 = props.onChange, previewFile = props.previewFile, disabled = props.disabled, propLocale = props.locale, iconRender2 = props.iconRender, isImageUrl3 = props.isImageUrl, progress = props.progress, customizePrefixCls = props.prefixCls, className = props.className, type2 = props.type, children = props.children, style2 = props.style, itemRender = props.itemRender, maxCount2 = props.maxCount;
  var _useMergedState = useMergedState(defaultFileList || [], {
    value: fileList,
    postState: function postState(list) {
      return list !== null && list !== void 0 ? list : [];
    }
  }), _useMergedState2 = _slicedToArray$3(_useMergedState, 2), mergedFileList = _useMergedState2[0], setMergedFileList = _useMergedState2[1];
  var _React$useState = React.useState("drop"), _React$useState2 = _slicedToArray$3(_React$useState, 2), dragState = _React$useState2[0], setDragState = _React$useState2[1];
  var upload2 = React.useRef();
  React.useEffect(function() {
    devWarning("fileList" in props || !("value" in props), "Upload", "`value` is not a valid prop, do you mean `fileList`?");
    devWarning(!("transformFile" in props), "Upload", "`transformFile` is deprecated. Please use `beforeUpload` directly.");
  }, []);
  React.useEffect(function() {
    var timestamp = Date.now();
    (fileList || []).forEach(function(file, index2) {
      if (!file.uid && !Object.isFrozen(file)) {
        file.uid = "__AUTO__".concat(timestamp, "_").concat(index2, "__");
      }
    });
  }, [fileList]);
  var onInternalChange = function onInternalChange2(file, changedFileList, event) {
    var cloneList = _toConsumableArray(changedFileList);
    if (maxCount2 === 1) {
      cloneList = cloneList.slice(-1);
    } else if (maxCount2) {
      cloneList = cloneList.slice(0, maxCount2);
    }
    setMergedFileList(cloneList);
    var changeInfo = {
      file,
      fileList: cloneList
    };
    if (event) {
      changeInfo.event = event;
    }
    onChange4 === null || onChange4 === void 0 ? void 0 : onChange4(changeInfo);
  };
  var mergedBeforeUpload = function mergedBeforeUpload2(file, fileListArgs) {
    return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ regenerator.mark(function _callee() {
      var beforeUpload, transformFile, parsedFile, result;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              beforeUpload = props.beforeUpload, transformFile = props.transformFile;
              parsedFile = file;
              if (!beforeUpload) {
                _context.next = 13;
                break;
              }
              _context.next = 5;
              return beforeUpload(file, fileListArgs);
            case 5:
              result = _context.sent;
              if (!(result === false)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", false);
            case 8:
              delete file[LIST_IGNORE];
              if (!(result === LIST_IGNORE)) {
                _context.next = 12;
                break;
              }
              Object.defineProperty(file, LIST_IGNORE, {
                value: true,
                configurable: true
              });
              return _context.abrupt("return", false);
            case 12:
              if (_typeof$5(result) === "object" && result) {
                parsedFile = result;
              }
            case 13:
              if (!transformFile) {
                _context.next = 17;
                break;
              }
              _context.next = 16;
              return transformFile(parsedFile);
            case 16:
              parsedFile = _context.sent;
            case 17:
              return _context.abrupt("return", parsedFile);
            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
  var onBatchStart = function onBatchStart2(batchFileInfoList) {
    var filteredFileInfoList = batchFileInfoList.filter(function(info) {
      return !info.file[LIST_IGNORE];
    });
    if (!filteredFileInfoList.length) {
      return;
    }
    var objectFileList = filteredFileInfoList.map(function(info) {
      return file2Obj(info.file);
    });
    var newFileList = _toConsumableArray(mergedFileList);
    objectFileList.forEach(function(fileObj) {
      newFileList = updateFileList(fileObj, newFileList);
    });
    objectFileList.forEach(function(fileObj, index2) {
      var triggerFileObj = fileObj;
      if (!filteredFileInfoList[index2].parsedFile) {
        var originFileObj = fileObj.originFileObj;
        var clone2 = new File([originFileObj], originFileObj.name, {
          type: originFileObj.type
        });
        clone2.uid = fileObj.uid;
        triggerFileObj = clone2;
      } else {
        fileObj.status = "uploading";
      }
      onInternalChange(triggerFileObj, newFileList);
    });
  };
  var onSuccess = function onSuccess2(response, file, xhr) {
    try {
      if (typeof response === "string") {
        response = JSON.parse(response);
      }
    } catch (e3) {
    }
    if (!getFileItem(file, mergedFileList)) {
      return;
    }
    var targetItem = file2Obj(file);
    targetItem.status = "done";
    targetItem.percent = 100;
    targetItem.response = response;
    targetItem.xhr = xhr;
    var nextFileList = updateFileList(targetItem, mergedFileList);
    onInternalChange(targetItem, nextFileList);
  };
  var onProgress = function onProgress2(e3, file) {
    if (!getFileItem(file, mergedFileList)) {
      return;
    }
    var targetItem = file2Obj(file);
    targetItem.status = "uploading";
    targetItem.percent = e3.percent;
    var nextFileList = updateFileList(targetItem, mergedFileList);
    onInternalChange(targetItem, nextFileList, e3);
  };
  var onError = function onError2(error, response, file) {
    if (!getFileItem(file, mergedFileList)) {
      return;
    }
    var targetItem = file2Obj(file);
    targetItem.error = error;
    targetItem.response = response;
    targetItem.status = "error";
    var nextFileList = updateFileList(targetItem, mergedFileList);
    onInternalChange(targetItem, nextFileList);
  };
  var handleRemove = function handleRemove2(file) {
    var currentFile;
    Promise.resolve(typeof onRemove === "function" ? onRemove(file) : onRemove).then(function(ret) {
      var _a;
      if (ret === false) {
        return;
      }
      var removedFileList = removeFileItem(file, mergedFileList);
      if (removedFileList) {
        currentFile = _extends$2(_extends$2({}, file), {
          status: "removed"
        });
        mergedFileList === null || mergedFileList === void 0 ? void 0 : mergedFileList.forEach(function(item) {
          var matchKey = currentFile.uid !== void 0 ? "uid" : "name";
          if (item[matchKey] === currentFile[matchKey] && !Object.isFrozen(item)) {
            item.status = "removed";
          }
        });
        (_a = upload2.current) === null || _a === void 0 ? void 0 : _a.abort(currentFile);
        onInternalChange(currentFile, removedFileList);
      }
    });
  };
  var onFileDrop = function onFileDrop2(e3) {
    e3.stopPropagation();
    setDragState(e3.type);
  };
  React.useImperativeHandle(ref, function() {
    return {
      onBatchStart,
      onSuccess,
      onProgress,
      onError,
      fileList: mergedFileList,
      upload: upload2.current
    };
  });
  var _React$useContext = React.useContext(ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
  var prefixCls = getPrefixCls("upload", customizePrefixCls);
  var rcUploadProps = _extends$2(_extends$2({
    onBatchStart,
    onError,
    onProgress,
    onSuccess
  }, props), {
    prefixCls,
    beforeUpload: mergedBeforeUpload,
    onChange: void 0
  });
  delete rcUploadProps.className;
  delete rcUploadProps.style;
  if (!children || disabled) {
    delete rcUploadProps.id;
  }
  var renderUploadList = function renderUploadList2(button) {
    return showUploadList ? /* @__PURE__ */ React.createElement(LocaleReceiver, {
      componentName: "Upload",
      defaultLocale: localeValues.Upload
    }, function(locale2) {
      var _ref = typeof showUploadList === "boolean" ? {} : showUploadList, showRemoveIcon = _ref.showRemoveIcon, showPreviewIcon = _ref.showPreviewIcon, showDownloadIcon = _ref.showDownloadIcon, removeIcon = _ref.removeIcon, downloadIcon = _ref.downloadIcon;
      return /* @__PURE__ */ React.createElement(UploadList, {
        listType,
        items: mergedFileList,
        previewFile,
        onPreview,
        onDownload,
        onRemove: handleRemove,
        showRemoveIcon: !disabled && showRemoveIcon,
        showPreviewIcon,
        showDownloadIcon,
        removeIcon,
        downloadIcon,
        iconRender: iconRender2,
        locale: _extends$2(_extends$2({}, locale2), propLocale),
        isImageUrl: isImageUrl3,
        progress,
        appendAction: button,
        itemRender
      });
    }) : button;
  };
  if (type2 === "drag") {
    var _classNames;
    var dragCls = cn(prefixCls, (_classNames = {}, _defineProperty$4(_classNames, "".concat(prefixCls, "-drag"), true), _defineProperty$4(_classNames, "".concat(prefixCls, "-drag-uploading"), mergedFileList.some(function(file) {
      return file.status === "uploading";
    })), _defineProperty$4(_classNames, "".concat(prefixCls, "-drag-hover"), dragState === "dragover"), _defineProperty$4(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty$4(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("div", {
      className: dragCls,
      onDrop: onFileDrop,
      onDragOver: onFileDrop,
      onDragLeave: onFileDrop,
      style: style2
    }, /* @__PURE__ */ React.createElement(Upload$1, _extends$2({}, rcUploadProps, {
      ref: upload2,
      className: "".concat(prefixCls, "-btn")
    }), /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-drag-container")
    }, children))), renderUploadList());
  }
  var uploadButtonCls = cn(prefixCls, (_classNames2 = {}, _defineProperty$4(_classNames2, "".concat(prefixCls, "-select"), true), _defineProperty$4(_classNames2, "".concat(prefixCls, "-select-").concat(listType), true), _defineProperty$4(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _defineProperty$4(_classNames2, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames2));
  var uploadButton = /* @__PURE__ */ React.createElement("div", {
    className: uploadButtonCls,
    style: children ? void 0 : {
      display: "none"
    }
  }, /* @__PURE__ */ React.createElement(Upload$1, _extends$2({}, rcUploadProps, {
    ref: upload2
  })));
  if (listType === "picture-card") {
    return /* @__PURE__ */ React.createElement("span", {
      className: cn("".concat(prefixCls, "-picture-card-wrapper"), className)
    }, renderUploadList(uploadButton));
  }
  return /* @__PURE__ */ React.createElement("span", {
    className
  }, uploadButton, renderUploadList());
};
var Upload = /* @__PURE__ */ React.forwardRef(InternalUpload);
Upload.Dragger = Dragger;
Upload.LIST_IGNORE = LIST_IGNORE;
Upload.displayName = "Upload";
Upload.defaultProps = {
  type: "select",
  multiple: false,
  action: "",
  data: {},
  accept: "",
  showUploadList: true,
  listType: "text",
  className: "",
  disabled: false,
  supportServerRender: true
};
Upload.Dragger = Dragger;
var { Panel: Panel$1 } = Collapse$1;
var StyledCollapse = styled_components_esm_default((props) => React__default.createElement(Collapse$1, Object.assign({}, props)))`
  &.ant-collapse {
    border: none;
    background-color: transparent;
    width: 607px;

    & .ant-collapse-content {
      border-top: none;
      color: initial;

      .ant-collapse-content-box {
        padding: 18px 32px 32px;
      }
    }

    & .ant-collapse-item {
      margin-top: 16px;
      border: none;
      border: 2px solid #e4e5e8;
      border-radius: 4px;
      transition: 0.2s ease;

      &:hover {
        border-color: #0446ca;
      }

      & .ant-collapse-header {
        padding: 16px 32px;
      }
    }

    & .ant-collapse-item.ant-collapse-item-active {
      border-color: #1749c2;

      .collapse-icon {
        transform: rotate(180deg);

        & path {
          fill: #1749c2;
        }
      }

      & svg.code-icon path {
        stroke: #1749c2;
      }

      & svg.send-icon path {
        fill: #1749c2;
      }
    }
  }
`;
var StyledPanel = styled_components_esm_default(Panel$1)``;
var HeaderWrapper = styled_components_esm_default.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & div.header-content {
    display: flex;
    align-items: center;
    width: 100%;

    & svg,
    & img,
    & div {
      margin-right: 15px;
    }

    & div {
      & h3.onboarding-title {
        font-size: 16px;
        line-height: 19px;
        font-weight: 700;
      }

      & p.onboarding-subtitle {
        font-size: 14px;
        line-height: 16px;
        color: #a7a7a7;
        margin-top: 8px;
        font-weight: 400;
        text-align: left;
      }
    }
  }

  .collapse-icon {
    transition: all 0.2s ease;
    transform-origin: 50% 50%;
  }
`;
var StyledSpace = styled_components_esm_default.div`
  display: flex;
  align-items: center;
  &.small {
    gap: 8px;
  }
  &.medium {
    gap: 16px;
  }
  &.large {
    gap: 24px;
  }
  `;
StyledSpace.displayName = "StyledSpace";
function Space$1({ style: style2, children, gap = "small" }) {
  return React.createElement(StyledSpace, { className: gap, style: style2 }, children);
}
var Space = Object.assign(Space$1, {});
function useDropdownBtn() {
  const dropdown = useContext2(DropdownContext);
  function toggle() {
    dropdown.setOpen(!dropdown.open);
  }
  return {
    toggle
  };
}
var StyledDropdownItem = styled_components_esm_default.div`
  border: none;
  background-color: transparent;
  font-size: ${themeValues.fontSize.normal};

  padding: 8px 16px;
  cursor: pointer;
  min-width: 150px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  width: 100%;

  & p {
    font-weight: 400;
  }

  &.separator {
    cursor: initial;
  }

  &.with-indicator {
    padding: 8px 16px 8px 40px;
  }

  &:hover {
    background-color: #f5f5f5;
    color: #000;

    &.hover-bold {
      font-weight: 700;
    }

    &.separator {
      background-color: transparent;
    }
  }

  &.controls {
    min-width: 107px;
    font-weight: 400;
    text-align: center;
    color: #000 !important;

    font-size: ${themeValues.fontSize.normal};
    padding: 8px 0;
    margin: 0 auto;
    display: block;
    align-items: center;
  }

  .ant-switch-small.ant-switch-checked .ant-switch-handle {
    left: 50%;
  }

  &.button-with-feature {
    padding: 0;

    & .with-feature {
      display: flex;
      padding: 8px 16px;
      width: 100%;
    }
  }
`;
StyledDropdownItem.displayName = "StyledDropdownItem";
var StyledDropdownContent = styled_components_esm_default.div`
  padding: 8px 0 8px 0;
  max-height: 50vh;
  overflow: auto;
  overflow-x: hidden;
`;
StyledDropdownContent.displayName = "StyledDropdownContent";
function Dropdown$1({ open: openProp, children = [] }) {
  const [open, setOpen] = useState2(openProp || false);
  const childHead = children[0];
  const [, ...childTail] = children.length > 1 ? children : [null, null];
  function close() {
    setOpen(false);
  }
  const content = React.createElement(StyledDropdownContent, null, childTail);
  return React.createElement(
    DropdownContext.Provider,
    { value: {
      open,
      setOpen
    } },
    React.createElement(Popover, {
      placement: "bottomLeft",
      content,
      trigger: "click",
      onVisibleChange: close,
      visible: open,
      overlayClassName: "dropdown-hide-arrow"
    }, childHead)
  );
}
var StyledDropdownButton = styled_components_esm_default.span`

`;
StyledDropdownButton.displayName = "StyledDropdownButton";
function DropdownButton2() {
  return React.createElement(React.Fragment, null);
}
function DropdownIconToggler({ color = "primary", icon = "icon-more-options" }) {
  const { toggle } = useDropdownBtn();
  return React.createElement(
    StyledDropdownButton,
    null,
    React.createElement(Button$2, { theme: "outline", kind: color, icon, onClick: toggle })
  );
}
function DropdownItem({ children, onClick: onClickProp }) {
  const { setOpen } = useContext2(DropdownContext);
  function onClick() {
    setOpen(false);
    if (!onClickProp) {
      return;
    }
    onClickProp();
  }
  return React.createElement(StyledDropdownItem, { onClick }, children);
}
var DropdownContext = createContext2({
  open: false,
  setOpen: (open) => {
  }
});
var Dropdown2 = Object.assign(Dropdown$1, {
  Button: DropdownButton2,
  IconToggler: DropdownIconToggler,
  Item: DropdownItem
});
var EmptyStateShade = styled_components_esm_default.div`
  opacity: 0.3; // TODO: opacity level, dark/light mode
  pointer-events: none;
  user-select: none;
  outline: 0;
`;
EmptyStateShade.displayName = "EmptyStateShade";
function EmptyState$1() {
  return React.createElement(React.Fragment, null);
}
var EmptyState = Object.assign(EmptyState$1, {
  Shade: EmptyStateShade
});
var reactDropdownTreeSelect = { exports: {} };
(function(module, exports) {
  !function(e3, t3) {
    module.exports = t3(React__default);
  }(commonjsGlobal, function(e3) {
    return function(e4) {
      var t3 = {};
      function n3(r3) {
        if (t3[r3])
          return t3[r3].exports;
        var o2 = t3[r3] = { i: r3, l: false, exports: {} };
        return e4[r3].call(o2.exports, o2, o2.exports, n3), o2.l = true, o2.exports;
      }
      return n3.m = e4, n3.c = t3, n3.d = function(e5, t4, r3) {
        n3.o(e5, t4) || Object.defineProperty(e5, t4, { enumerable: true, get: r3 });
      }, n3.r = function(e5) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e5, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e5, "__esModule", { value: true });
      }, n3.t = function(e5, t4) {
        if (1 & t4 && (e5 = n3(e5)), 8 & t4)
          return e5;
        if (4 & t4 && "object" == typeof e5 && e5 && e5.__esModule)
          return e5;
        var r3 = /* @__PURE__ */ Object.create(null);
        if (n3.r(r3), Object.defineProperty(r3, "default", { enumerable: true, value: e5 }), 2 & t4 && "string" != typeof e5)
          for (var o2 in e5)
            n3.d(r3, o2, function(t5) {
              return e5[t5];
            }.bind(null, o2));
        return r3;
      }, n3.n = function(e5) {
        var t4 = e5 && e5.__esModule ? function() {
          return e5.default;
        } : function() {
          return e5;
        };
        return n3.d(t4, "a", t4), t4;
      }, n3.o = function(e5, t4) {
        return Object.prototype.hasOwnProperty.call(e5, t4);
      }, n3.p = "", n3(n3.s = 10);
    }([function(e4, t3, n3) {
      e4.exports = n3(4)();
    }, function(t3, n3) {
      t3.exports = e3;
    }, function(e4, t3, n3) {
      var r3;
      r3 = function(e5) {
        return function(e6) {
          var t4 = {};
          function n4(r4) {
            if (t4[r4])
              return t4[r4].exports;
            var o2 = t4[r4] = { exports: {}, id: r4, loaded: false };
            return e6[r4].call(o2.exports, o2, o2.exports, n4), o2.loaded = true, o2.exports;
          }
          return n4.m = e6, n4.c = t4, n4.p = "", n4(0);
        }([function(e6, t4, n4) {
          Object.defineProperty(t4, "__esModule", { value: true });
          var r4 = Object.assign || function(e7) {
            for (var t5 = 1; t5 < arguments.length; t5++) {
              var n5 = arguments[t5];
              for (var r5 in n5)
                Object.prototype.hasOwnProperty.call(n5, r5) && (e7[r5] = n5[r5]);
            }
            return e7;
          }, o2 = function() {
            function e7(e8, t5) {
              for (var n5 = 0; n5 < t5.length; n5++) {
                var r5 = t5[n5];
                r5.enumerable = r5.enumerable || false, r5.configurable = true, "value" in r5 && (r5.writable = true), Object.defineProperty(e8, r5.key, r5);
              }
            }
            return function(t5, n5, r5) {
              return n5 && e7(t5.prototype, n5), r5 && e7(t5, r5), t5;
            };
          }(), a2 = function(e7, t5, n5) {
            for (var r5 = true; r5; ) {
              var o3 = e7, a3 = t5, i3 = n5;
              r5 = false, null === o3 && (o3 = Function.prototype);
              var l3 = Object.getOwnPropertyDescriptor(o3, a3);
              if (void 0 !== l3) {
                if ("value" in l3)
                  return l3.value;
                var s3 = l3.get;
                if (void 0 === s3)
                  return;
                return s3.call(i3);
              }
              var c3 = Object.getPrototypeOf(o3);
              if (null === c3)
                return;
              e7 = c3, t5 = a3, n5 = i3, r5 = true, l3 = c3 = void 0;
            }
          };
          function i2(e7) {
            return e7 && e7.__esModule ? e7 : { default: e7 };
          }
          var l2 = n4(8), s2 = i2(l2), c2 = i2(n4(6)), u2 = i2(n4(2)), d = n4(1), h = function(e7) {
            function t5(e8) {
              !function(e9, t6) {
                if (!(e9 instanceof t6))
                  throw new TypeError("Cannot call a class as a function");
              }(this, t5), a2(Object.getPrototypeOf(t5.prototype), "constructor", this).call(this), this.state = { showLoader: false, lastScrollTop: 0, actionTriggered: false, pullToRefreshThresholdBreached: false }, this.startY = 0, this.currentY = 0, this.dragging = false, this.maxPullDownDistance = 0, this.onScrollListener = this.onScrollListener.bind(this), this.throttledOnScrollListener = (0, u2.default)(this.onScrollListener, 150).bind(this), this.onStart = this.onStart.bind(this), this.onMove = this.onMove.bind(this), this.onEnd = this.onEnd.bind(this), this.getScrollableTarget = this.getScrollableTarget.bind(this);
            }
            return function(e8, t6) {
              if ("function" != typeof t6 && null !== t6)
                throw new TypeError("Super expression must either be null or a function, not " + typeof t6);
              e8.prototype = Object.create(t6 && t6.prototype, { constructor: { value: e8, enumerable: false, writable: true, configurable: true } }), t6 && (Object.setPrototypeOf ? Object.setPrototypeOf(e8, t6) : e8.__proto__ = t6);
            }(t5, l2.Component), o2(t5, [{ key: "componentDidMount", value: function() {
              if (this._scrollableNode = this.getScrollableTarget(), this.el = this.props.height ? this._infScroll : this._scrollableNode || window, this.el.addEventListener("scroll", this.throttledOnScrollListener), "number" == typeof this.props.initialScrollY && this.el.scrollHeight > this.props.initialScrollY && this.el.scrollTo(0, this.props.initialScrollY), this.props.pullDownToRefresh && (this.el.addEventListener("touchstart", this.onStart), this.el.addEventListener("touchmove", this.onMove), this.el.addEventListener("touchend", this.onEnd), this.el.addEventListener("mousedown", this.onStart), this.el.addEventListener("mousemove", this.onMove), this.el.addEventListener("mouseup", this.onEnd), this.maxPullDownDistance = this._pullDown.firstChild.getBoundingClientRect().height, this.forceUpdate(), "function" != typeof this.props.refreshFunction))
                throw new Error(`Mandatory prop "refreshFunction" missing.
          Pull Down To Refresh functionality will not work
          as expected. Check README.md for usage'`);
            } }, { key: "componentWillUnmount", value: function() {
              this.el.removeEventListener("scroll", this.throttledOnScrollListener), this.props.pullDownToRefresh && (this.el.removeEventListener("touchstart", this.onStart), this.el.removeEventListener("touchmove", this.onMove), this.el.removeEventListener("touchend", this.onEnd), this.el.removeEventListener("mousedown", this.onStart), this.el.removeEventListener("mousemove", this.onMove), this.el.removeEventListener("mouseup", this.onEnd));
            } }, { key: "componentWillReceiveProps", value: function(e8) {
              this.props.key === e8.key && this.props.dataLength === e8.dataLength || this.setState({ showLoader: false, actionTriggered: false, pullToRefreshThresholdBreached: false });
            } }, { key: "getScrollableTarget", value: function() {
              return this.props.scrollableTarget instanceof HTMLElement ? this.props.scrollableTarget : "string" == typeof this.props.scrollableTarget ? document.getElementById(this.props.scrollableTarget) : (null === this.props.scrollableTarget && console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      "), null);
            } }, { key: "onStart", value: function(e8) {
              this.state.lastScrollTop || (this.dragging = true, this.startY = e8.pageY || e8.touches[0].pageY, this.currentY = this.startY, this._infScroll.style.willChange = "transform", this._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)");
            } }, { key: "onMove", value: function(e8) {
              this.dragging && (this.currentY = e8.pageY || e8.touches[0].pageY, this.currentY < this.startY || (this.currentY - this.startY >= this.props.pullDownToRefreshThreshold && this.setState({ pullToRefreshThresholdBreached: true }), this.currentY - this.startY > 1.5 * this.maxPullDownDistance || (this._infScroll.style.overflow = "visible", this._infScroll.style.transform = "translate3d(0px, " + (this.currentY - this.startY) + "px, 0px)")));
            } }, { key: "onEnd", value: function(e8) {
              var t6 = this;
              this.startY = 0, this.currentY = 0, this.dragging = false, this.state.pullToRefreshThresholdBreached && this.props.refreshFunction && this.props.refreshFunction(), requestAnimationFrame(function() {
                t6._infScroll && (t6._infScroll.style.overflow = "auto", t6._infScroll.style.transform = "none", t6._infScroll.style.willChange = "none");
              });
            } }, { key: "isElementAtBottom", value: function(e8) {
              var t6 = arguments.length <= 1 || void 0 === arguments[1] ? 0.8 : arguments[1], n5 = e8 === document.body || e8 === document.documentElement ? window.screen.availHeight : e8.clientHeight, r5 = (0, d.parseThreshold)(t6);
              return r5.unit === d.ThresholdUnits.Pixel ? e8.scrollTop + n5 >= e8.scrollHeight - r5.value : e8.scrollTop + n5 >= r5.value / 100 * e8.scrollHeight;
            } }, { key: "onScrollListener", value: function(e8) {
              var t6 = this;
              "function" == typeof this.props.onScroll && setTimeout(function() {
                return t6.props.onScroll(e8);
              }, 0);
              var n5 = this.props.height || this._scrollableNode ? e8.target : document.documentElement.scrollTop ? document.documentElement : document.body;
              this.state.actionTriggered || (this.isElementAtBottom(n5, this.props.scrollThreshold) && this.props.hasMore && (this.setState({ actionTriggered: true, showLoader: true }), this.props.next()), this.setState({ lastScrollTop: n5.scrollTop }));
            } }, { key: "render", value: function() {
              var e8 = this, t6 = r4({ height: this.props.height || "auto", overflow: "auto", WebkitOverflowScrolling: "touch" }, this.props.style), n5 = this.props.hasChildren || !(!this.props.children || !this.props.children.length), o3 = this.props.pullDownToRefresh && this.props.height ? { overflow: "auto" } : {};
              return s2.default.createElement("div", { style: o3 }, s2.default.createElement("div", { className: "infinite-scroll-component " + (this.props.className || ""), ref: function(t7) {
                return e8._infScroll = t7;
              }, style: t6 }, this.props.pullDownToRefresh && s2.default.createElement("div", { style: { position: "relative" }, ref: function(t7) {
                return e8._pullDown = t7;
              } }, s2.default.createElement("div", { style: { position: "absolute", left: 0, right: 0, top: -1 * this.maxPullDownDistance } }, !this.state.pullToRefreshThresholdBreached && this.props.pullDownToRefreshContent, this.state.pullToRefreshThresholdBreached && this.props.releaseToRefreshContent)), this.props.children, !this.state.showLoader && !n5 && this.props.hasMore && this.props.loader, this.state.showLoader && this.props.hasMore && this.props.loader, !this.props.hasMore && this.props.endMessage));
            } }]), t5;
          }();
          t4.default = h, h.defaultProps = { pullDownToRefreshContent: s2.default.createElement("h3", null, "Pull down to refresh"), releaseToRefreshContent: s2.default.createElement("h3", null, "Release to refresh"), pullDownToRefreshThreshold: 100, disableBrowserPullToRefresh: true }, h.propTypes = { next: c2.default.func, hasMore: c2.default.bool, children: c2.default.node, loader: c2.default.node.isRequired, scrollThreshold: c2.default.oneOfType([c2.default.number, c2.default.string]), endMessage: c2.default.node, style: c2.default.object, height: c2.default.number, scrollableTarget: c2.default.node, hasChildren: c2.default.bool, pullDownToRefresh: c2.default.bool, pullDownToRefreshContent: c2.default.node, releaseToRefreshContent: c2.default.node, pullDownToRefreshThreshold: c2.default.number, refreshFunction: c2.default.func, onScroll: c2.default.func, dataLength: c2.default.number.isRequired, key: c2.default.string }, e6.exports = t4.default;
        }, function(e6, t4) {
          Object.defineProperty(t4, "__esModule", { value: true }), t4.parseThreshold = function(e7) {
            if ("number" == typeof e7)
              return { unit: n4.Percent, value: 100 * e7 };
            if ("string" == typeof e7)
              return e7.match(/^(\d*(\.\d+)?)px$/) ? { unit: n4.Pixel, value: parseFloat(e7) } : e7.match(/^(\d*(\.\d+)?)%$/) ? { unit: n4.Percent, value: parseFloat(e7) } : (console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...'), r4);
            return console.warn("scrollThreshold should be string or number"), r4;
          };
          var n4 = { Pixel: "Pixel", Percent: "Percent" };
          t4.ThresholdUnits = n4;
          var r4 = { unit: n4.Percent, value: 0.8 };
        }, function(e6, t4) {
          Object.defineProperty(t4, "__esModule", { value: true }), t4.default = function(e7, t5, n4) {
            var r4, o2;
            return t5 || (t5 = 250), function() {
              var a2 = n4 || this, i2 = +new Date(), l2 = arguments;
              r4 && i2 < r4 + t5 ? (clearTimeout(o2), o2 = setTimeout(function() {
                r4 = i2, e7.apply(a2, l2);
              }, t5)) : (r4 = i2, e7.apply(a2, l2));
            };
          }, e6.exports = t4.default;
        }, function(e6, t4) {
          function n4(e7) {
            return function() {
              return e7;
            };
          }
          var r4 = function() {
          };
          r4.thatReturns = n4, r4.thatReturnsFalse = n4(false), r4.thatReturnsTrue = n4(true), r4.thatReturnsNull = n4(null), r4.thatReturnsThis = function() {
            return this;
          }, r4.thatReturnsArgument = function(e7) {
            return e7;
          }, e6.exports = r4;
        }, function(e6, t4, n4) {
          e6.exports = function(e7, t5, n5, o2, a2, i2, l2, s2) {
            if (!e7) {
              var c2;
              if (void 0 === t5)
                c2 = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
              else {
                var u2 = [n5, o2, a2, i2, l2, s2], d = 0;
                (c2 = new Error(t5.replace(/%s/g, function() {
                  return u2[d++];
                }))).name = "Invariant Violation";
              }
              throw c2.framesToPop = 1, c2;
            }
          };
        }, function(e6, t4, n4) {
          var r4 = n4(3), o2 = n4(4), a2 = n4(7);
          e6.exports = function() {
            function e7(e8, t6, n6, r5, i2, l2) {
              l2 !== a2 && o2(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            }
            function t5() {
              return e7;
            }
            e7.isRequired = e7;
            var n5 = { array: e7, bool: e7, func: e7, number: e7, object: e7, string: e7, symbol: e7, any: e7, arrayOf: t5, element: e7, instanceOf: t5, node: e7, objectOf: t5, oneOf: t5, oneOfType: t5, shape: t5 };
            return n5.checkPropTypes = r4, n5.PropTypes = n5, n5;
          };
        }, function(e6, t4, n4) {
          e6.exports = n4(5)();
        }, function(e6, t4) {
          e6.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        }, function(t4, n4) {
          t4.exports = e5;
        }]);
      }, e4.exports = r3(n3(1));
    }, function(e4, t3, n3) {
      e4.exports = function(e5, t4) {
        var n4 = e5.filter(t4);
        return 0 !== n4.length && n4.length !== e5.length;
      };
    }, function(e4, t3, n3) {
      var r3 = n3(5);
      function o2() {
      }
      function a2() {
      }
      a2.resetWarningCache = o2, e4.exports = function() {
        function e5(e6, t5, n5, o3, a3, i2) {
          if (i2 !== r3) {
            var l2 = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw l2.name = "Invariant Violation", l2;
          }
        }
        function t4() {
          return e5;
        }
        e5.isRequired = e5;
        var n4 = { array: e5, bool: e5, func: e5, number: e5, object: e5, string: e5, symbol: e5, any: e5, arrayOf: t4, element: e5, elementType: e5, instanceOf: t4, node: e5, objectOf: t4, oneOf: t4, oneOfType: t4, shape: t4, exact: t4, checkPropTypes: a2, resetWarningCache: o2 };
        return n4.PropTypes = n4, n4;
      };
    }, function(e4, t3, n3) {
      e4.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, function(e4, t3, n3) {
    }, function(e4, t3, n3) {
    }, function(e4, t3, n3) {
    }, function(e4, t3, n3) {
    }, function(e4, t3, n3) {
      n3.r(t3);
      var r3, o2, a2, i2 = n3(0), l2 = n3.n(i2), s2 = n3(1), c2 = n3.n(s2), u2 = function() {
        var e5 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return Object.keys(e5).reduce(function(t4, n4) {
          var r4;
          return t4["data-" + (r4 = n4, r4.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase())] = e5[n4], t4;
        }, {});
      }, d = function(e5) {
        return !e5 || Array.isArray(e5) && !e5.length;
      }, h = function(e5, t4) {
        return e5 instanceof Event && !function(e6) {
          if (e6.path)
            return e6.path;
          for (var t5 = e6.target, n4 = [t5]; t5.parentElement; )
            t5 = t5.parentElement, n4.unshift(t5);
          return n4;
        }(e5).some(function(e6) {
          return e6 === t4;
        });
      }, p = function(e5, t4) {
        var n4 = void 0;
        return function() {
          for (var r4 = arguments.length, o3 = Array(r4), a3 = 0; a3 < r4; a3++)
            o3[a3] = arguments[a3];
          var i3 = !n4;
          clearTimeout(n4), n4 = setTimeout(function() {
            n4 = null, e5.apply(void 0, o3);
          }, t4), i3 && e5.apply(void 0, o3);
        };
      }, f3 = (r3 = "rdts", o2 = 1, a2 = /* @__PURE__ */ new WeakMap(), { get: function(e5) {
        return a2.has(e5) || a2.set(e5, o2++), "" + r3 + a2.get(e5);
      }, reset: function() {
        a2 = /* @__PURE__ */ new WeakMap(), o2 = 1;
      } });
      var y2 = function(e5, t4, n4) {
        if (Array.prototype.findIndex)
          return e5.findIndex(t4, n4);
        if (!e5)
          throw new TypeError("findIndex called on null or undefined");
        if ("function" != typeof t4)
          throw new TypeError("findIndex predicate must be a function");
        for (var r4 = 0; r4 < e5.length; r4++) {
          var o3 = e5[r4];
          if (t4.call(n4, o3, r4, e5))
            return r4;
        }
        return -1;
      };
      function g2(e5, t4) {
        var n4 = function(e6) {
          if (!e6)
            return {};
          if ("#" === e6[0])
            return { "aria-labelledby": e6.substring(1).replace(/ #/g, " ") };
          return { "aria-label": e6 };
        }(e5);
        return t4 && (n4["aria-labelledby"] = ((n4["aria-labelledby"] || "") + " " + t4).trim()), n4;
      }
      var b2 = Object.assign || function(e5) {
        for (var t4 = 1; t4 < arguments.length; t4++) {
          var n4 = arguments[t4];
          for (var r4 in n4)
            Object.prototype.hasOwnProperty.call(n4, r4) && (e5[r4] = n4[r4]);
        }
        return e5;
      }, v2 = function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }();
      var m2 = function(e5) {
        function t4(e6) {
          !function(e7, t5) {
            if (!(e7 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, t4);
          var n4 = function(e7, t5) {
            if (!e7)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t5 || "object" != typeof t5 && "function" != typeof t5 ? e7 : t5;
          }(this, (t4.__proto__ || Object.getPrototypeOf(t4)).call(this, e6));
          return n4.handleInputChange = function(e7) {
            e7.persist(), n4.delayedCallback(e7);
          }, n4.delayedCallback = p(function(e7) {
            return n4.props.onInputChange(e7.target.value);
          }, 300), n4;
        }
        return function(e6, t5) {
          if ("function" != typeof t5 && null !== t5)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t5);
          e6.prototype = Object.create(t5 && t5.prototype, { constructor: { value: e6, enumerable: false, writable: true, configurable: true } }), t5 && (Object.setPrototypeOf ? Object.setPrototypeOf(e6, t5) : e6.__proto__ = t5);
        }(t4, s2["PureComponent"]), v2(t4, [{ key: "render", value: function() {
          var e6 = this.props, t5 = e6.inputRef, n4 = e6.texts, r4 = void 0 === n4 ? {} : n4, o3 = e6.onFocus, a3 = e6.onBlur, i3 = e6.disabled, l3 = e6.readOnly, s3 = e6.onKeyDown, u3 = e6.activeDescendant, d2 = e6.inlineSearchInput;
          return c2.a.createElement("input", b2({ type: "text", disabled: i3, ref: t5, className: "search", placeholder: d2 ? r4.inlineSearchPlaceholder || "Search..." : r4.placeholder || "Choose...", onKeyDown: s3, onChange: this.handleInputChange, onFocus: o3, onBlur: a3, readOnly: l3, "aria-activedescendant": u3, "aria-autocomplete": s3 ? "list" : void 0 }, g2(r4.label)));
        } }]), t4;
      }();
      m2.propTypes = { tags: l2.a.array, texts: l2.a.object, onInputChange: l2.a.func, onFocus: l2.a.func, onBlur: l2.a.func, onTagRemove: l2.a.func, onKeyDown: l2.a.func, inputRef: l2.a.func, disabled: l2.a.bool, readOnly: l2.a.bool, activeDescendant: l2.a.string, inlineSearchInput: l2.a.bool };
      var w2 = m2, O2 = (n3(6), function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }());
      function k2(e5, t4) {
        if (!e5)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t4 || "object" != typeof t4 && "function" != typeof t4 ? e5 : t4;
      }
      var _2 = function(e5) {
        return e5 + "_tag";
      }, T2 = function(e5) {
        function t4() {
          var e6, n4, r4;
          !function(e7, t5) {
            if (!(e7 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, t4);
          for (var o3 = arguments.length, a3 = Array(o3), i3 = 0; i3 < o3; i3++)
            a3[i3] = arguments[i3];
          return n4 = r4 = k2(this, (e6 = t4.__proto__ || Object.getPrototypeOf(t4)).call.apply(e6, [this].concat(a3))), r4.handleClick = function(e7) {
            var t5 = r4.props, n5 = t5.id, o4 = t5.onDelete;
            e7.stopPropagation(), e7.nativeEvent.stopImmediatePropagation(), o4(n5, void 0 !== (e7.key || e7.keyCode));
          }, r4.onKeyDown = function(e7) {
            "Backspace" === e7.key && (r4.handleClick(e7), e7.preventDefault());
          }, r4.onKeyUp = function(e7) {
            (32 === e7.keyCode || ["Delete", "Enter"].indexOf(e7.key) > -1) && (r4.handleClick(e7), e7.preventDefault());
          }, k2(r4, n4);
        }
        return function(e6, t5) {
          if ("function" != typeof t5 && null !== t5)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t5);
          e6.prototype = Object.create(t5 && t5.prototype, { constructor: { value: e6, enumerable: false, writable: true, configurable: true } }), t5 && (Object.setPrototypeOf ? Object.setPrototypeOf(e6, t5) : e6.__proto__ = t5);
        }(t4, s2["PureComponent"]), O2(t4, [{ key: "render", value: function() {
          var e6 = this.props, t5 = e6.id, n4 = e6.label, r4 = e6.labelRemove, o3 = void 0 === r4 ? "Remove" : r4, a3 = e6.readOnly, i3 = e6.disabled, l3 = _2(t5), s3 = t5 + "_button", u3 = ["tag-remove", a3 && "readOnly", i3 && "disabled"].filter(Boolean).join(" "), d2 = a3 || i3;
          return c2.a.createElement("span", { className: "tag", id: l3, "aria-label": n4 }, n4, c2.a.createElement("button", { id: s3, onClick: d2 ? void 0 : this.handleClick, onKeyDown: d2 ? void 0 : this.onKeyDown, onKeyUp: d2 ? void 0 : this.onKeyUp, className: u3, type: "button", "aria-label": o3, "aria-labelledby": s3 + " " + l3, "aria-disabled": d2 }, "x"));
        } }]), t4;
      }();
      T2.propTypes = { id: l2.a.string.isRequired, label: l2.a.string.isRequired, onDelete: l2.a.func, readOnly: l2.a.bool, disabled: l2.a.bool, labelRemove: l2.a.string };
      var P2 = T2, S2 = (n3(7), function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }()), C2 = Object.assign || function(e5) {
        for (var t4 = 1; t4 < arguments.length; t4++) {
          var n4 = arguments[t4];
          for (var r4 in n4)
            Object.prototype.hasOwnProperty.call(n4, r4) && (e5[r4] = n4[r4]);
        }
        return e5;
      };
      var x2 = function(e5) {
        function t4() {
          return function(e6, t5) {
            if (!(e6 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, t4), function(e6, t5) {
            if (!e6)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t5 || "object" != typeof t5 && "function" != typeof t5 ? e6 : t5;
          }(this, (t4.__proto__ || Object.getPrototypeOf(t4)).apply(this, arguments));
        }
        return function(e6, t5) {
          if ("function" != typeof t5 && null !== t5)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t5);
          e6.prototype = Object.create(t5 && t5.prototype, { constructor: { value: e6, enumerable: false, writable: true, configurable: true } }), t5 && (Object.setPrototypeOf ? Object.setPrototypeOf(e6, t5) : e6.__proto__ = t5);
        }(t4, s2["PureComponent"]), S2(t4, [{ key: "render", value: function() {
          var e6 = this.props, t5 = e6.tags, n4 = e6.onTagRemove, r4 = e6.texts, o3 = void 0 === r4 ? {} : r4, a3 = e6.disabled, i3 = e6.readOnly, l3 = e6.children || c2.a.createElement("span", { className: "placeholder" }, o3.placeholder || "Choose...");
          return c2.a.createElement("ul", { className: "tag-list" }, function() {
            var e7 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t6 = arguments[1], n5 = arguments[2], r5 = arguments[3], o4 = arguments[4];
            return e7.map(function(e8) {
              var a4 = e8._id, i4 = e8.label, l4 = e8.tagClassName, s3 = e8.dataset, d2 = e8.tagLabel;
              return c2.a.createElement("li", C2({ className: ["tag-item", l4].filter(Boolean).join(" "), key: "tag-item-" + a4 }, u2(s3)), c2.a.createElement(P2, { label: d2 || i4, id: a4, onDelete: t6, readOnly: n5, disabled: r5 || e8.disabled, labelRemove: o4 }));
            });
          }(t5, n4, i3, a3, o3.labelRemove), c2.a.createElement("li", { className: "tag-item" }, l3));
        } }]), t4;
      }();
      x2.propTypes = { tags: l2.a.array, onTagRemove: l2.a.func, readOnly: l2.a.bool, disabled: l2.a.bool, texts: l2.a.object, children: l2.a.node };
      var E2 = x2, j2 = Object.assign || function(e5) {
        for (var t4 = 1; t4 < arguments.length; t4++) {
          var n4 = arguments[t4];
          for (var r4 in n4)
            Object.prototype.hasOwnProperty.call(n4, r4) && (e5[r4] = n4[r4]);
        }
        return e5;
      }, N = function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }();
      function I(e5, t4) {
        if (!e5)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t4 || "object" != typeof t4 && "function" != typeof t4 ? e5 : t4;
      }
      var D2 = function(e5) {
        function t4() {
          var e6, n4, r4;
          !function(e7, t5) {
            if (!(e7 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, t4);
          for (var o3 = arguments.length, a3 = Array(o3), i3 = 0; i3 < o3; i3++)
            a3[i3] = arguments[i3];
          return n4 = r4 = I(this, (e6 = t4.__proto__ || Object.getPrototypeOf(t4)).call.apply(e6, [this].concat(a3))), r4.getAriaAttributes = function() {
            var e7 = r4.props, t5 = e7.mode, n5 = e7.texts, o4 = void 0 === n5 ? {} : n5, a4 = e7.showDropdown, i4 = e7.clientId, l3 = e7.tags, s3 = i4 + "_trigger", c3 = [], u3 = g2(o4.label);
            return l3 && l3.length && (u3["aria-label"] && c3.push(s3), l3.forEach(function(e8) {
              c3.push(_2(e8._id));
            }), u3 = g2(o4.label, c3.join(" "))), j2({ id: s3, role: "button", tabIndex: r4.props.tabIndex, "aria-haspopup": "simpleSelect" === t5 ? "listbox" : "tree", "aria-expanded": a4 ? "true" : "false" }, u3);
          }, r4.handleTrigger = function(e7) {
            e7.key && 13 !== e7.keyCode && 32 !== e7.keyCode && 40 !== e7.keyCode || e7.key && r4.triggerNode && r4.triggerNode !== document.activeElement || (r4.props.showDropdown || 32 !== e7.keyCode || e7.preventDefault(), r4.props.onTrigger(e7));
          }, I(r4, n4);
        }
        return function(e6, t5) {
          if ("function" != typeof t5 && null !== t5)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t5);
          e6.prototype = Object.create(t5 && t5.prototype, { constructor: { value: e6, enumerable: false, writable: true, configurable: true } }), t5 && (Object.setPrototypeOf ? Object.setPrototypeOf(e6, t5) : e6.__proto__ = t5);
        }(t4, s2["PureComponent"]), N(t4, [{ key: "render", value: function() {
          var e6 = this, t5 = this.props, n4 = t5.disabled, r4 = t5.readOnly, o3 = t5.showDropdown, a3 = ["dropdown-trigger", "arrow", n4 && "disabled", r4 && "readOnly", o3 && "top", !o3 && "bottom"].filter(Boolean).join(" ");
          return c2.a.createElement("a", j2({ ref: function(t6) {
            e6.triggerNode = t6;
          }, className: a3, onClick: n4 ? void 0 : this.handleTrigger, onKeyDown: n4 ? void 0 : this.handleTrigger }, this.getAriaAttributes()), this.props.children);
        } }]), t4;
      }();
      D2.propTypes = { onTrigger: l2.a.func, disabled: l2.a.bool, readOnly: l2.a.bool, showDropdown: l2.a.bool, mode: l2.a.oneOf(["multiSelect", "simpleSelect", "radioSelect", "hierarchical"]), texts: l2.a.object, clientId: l2.a.string, tags: l2.a.array, tabIndex: l2.a.number };
      var R2 = D2, M2 = n3(2), F2 = n3.n(M2), A2 = function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }();
      function B2(e5, t4) {
        if (!e5)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t4 || "object" != typeof t4 && "function" != typeof t4 ? e5 : t4;
      }
      var L2 = function(e5) {
        function t4() {
          var e6, n4, r4;
          !function(e7, t5) {
            if (!(e7 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, t4);
          for (var o3 = arguments.length, a3 = Array(o3), i3 = 0; i3 < o3; i3++)
            a3[i3] = arguments[i3];
          return n4 = r4 = B2(this, (e6 = t4.__proto__ || Object.getPrototypeOf(t4)).call.apply(e6, [this].concat(a3))), r4.handleClick = function() {
            var e7 = r4.props, t5 = e7.onAction, n5 = e7.actionData;
            t5 && t5(n5.nodeId, n5.action);
          }, B2(r4, n4);
        }
        return function(e6, t5) {
          if ("function" != typeof t5 && null !== t5)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t5);
          e6.prototype = Object.create(t5 && t5.prototype, { constructor: { value: e6, enumerable: false, writable: true, configurable: true } }), t5 && (Object.setPrototypeOf ? Object.setPrototypeOf(e6, t5) : e6.__proto__ = t5);
        }(t4, s2["PureComponent"]), A2(t4, [{ key: "render", value: function() {
          var e6 = this.props, t5 = e6.title, n4 = e6.className, r4 = e6.text, o3 = e6.readOnly;
          return c2.a.createElement("i", { title: t5, className: n4, onClick: o3 ? void 0 : this.handleClick }, r4);
        } }]), t4;
      }();
      L2.propTypes = { title: l2.a.string, text: l2.a.string, className: l2.a.string, actionData: l2.a.object, onAction: l2.a.func, readOnly: l2.a.bool }, L2.defaultProps = { onAction: function() {
      } };
      var V2 = L2, Y2 = Object.assign || function(e5) {
        for (var t4 = 1; t4 < arguments.length; t4++) {
          var n4 = arguments[t4];
          for (var r4 in n4)
            Object.prototype.hasOwnProperty.call(n4, r4) && (e5[r4] = n4[r4]);
        }
        return e5;
      }, K2 = function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }();
      var q2 = function(e5) {
        function t4() {
          return function(e6, t5) {
            if (!(e6 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, t4), function(e6, t5) {
            if (!e6)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t5 || "object" != typeof t5 && "function" != typeof t5 ? e6 : t5;
          }(this, (t4.__proto__ || Object.getPrototypeOf(t4)).apply(this, arguments));
        }
        return function(e6, t5) {
          if ("function" != typeof t5 && null !== t5)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t5);
          e6.prototype = Object.create(t5 && t5.prototype, { constructor: { value: e6, enumerable: false, writable: true, configurable: true } }), t5 && (Object.setPrototypeOf ? Object.setPrototypeOf(e6, t5) : e6.__proto__ = t5);
        }(t4, s2["PureComponent"]), K2(t4, [{ key: "render", value: function() {
          var e6 = this.props, t5 = e6.actions, n4 = e6.id, r4 = function(e7, t6) {
            var n5 = {};
            for (var r5 in e7)
              t6.indexOf(r5) >= 0 || Object.prototype.hasOwnProperty.call(e7, r5) && (n5[r5] = e7[r5]);
            return n5;
          }(e6, ["actions", "id"]);
          return d(t5) ? null : t5.map(function(e7, t6) {
            var o3 = e7.id || "action-" + t6;
            return c2.a.createElement(V2, Y2({ key: o3 }, r4, e7, { actionData: { action: Y2({}, e7, { id: o3 }), nodeId: n4 } }));
          });
        } }]), t4;
      }();
      q2.propTypes = { id: l2.a.string.isRequired, actions: l2.a.array };
      var H2 = q2, U2 = Object.assign || function(e5) {
        for (var t4 = 1; t4 < arguments.length; t4++) {
          var n4 = arguments[t4];
          for (var r4 in n4)
            Object.prototype.hasOwnProperty.call(n4, r4) && (e5[r4] = n4[r4]);
        }
        return e5;
      }, W2 = function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }();
      var z2 = function(e5) {
        var t4 = e5.checked, n4 = e5.indeterminate;
        return function(e6) {
          e6 && (e6.checked = t4, e6.indeterminate = n4);
        };
      }, $2 = function(e5) {
        function t4() {
          return function(e6, t5) {
            if (!(e6 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, t4), function(e6, t5) {
            if (!e6)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t5 || "object" != typeof t5 && "function" != typeof t5 ? e6 : t5;
          }(this, (t4.__proto__ || Object.getPrototypeOf(t4)).apply(this, arguments));
        }
        return function(e6, t5) {
          if ("function" != typeof t5 && null !== t5)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t5);
          e6.prototype = Object.create(t5 && t5.prototype, { constructor: { value: e6, enumerable: false, writable: true, configurable: true } }), t5 && (Object.setPrototypeOf ? Object.setPrototypeOf(e6, t5) : e6.__proto__ = t5);
        }(t4, s2["PureComponent"]), W2(t4, [{ key: "render", value: function() {
          var e6 = this.props, t5 = e6.checked, n4 = e6.indeterminate, r4 = void 0 !== n4 && n4, o3 = e6.onChange, a3 = e6.disabled, i3 = e6.readOnly, l3 = function(e7, t6) {
            var n5 = {};
            for (var r5 in e7)
              t6.indexOf(r5) >= 0 || Object.prototype.hasOwnProperty.call(e7, r5) && (n5[r5] = e7[r5]);
            return n5;
          }(e6, ["checked", "indeterminate", "onChange", "disabled", "readOnly"]), s3 = a3 || i3;
          return c2.a.createElement("input", U2({ type: "checkbox", ref: z2({ checked: t5, indeterminate: r4 }), onChange: o3, disabled: s3 }, l3));
        } }]), t4;
      }();
      $2.propTypes = { checked: l2.a.bool, indeterminate: l2.a.bool, onChange: l2.a.func, disabled: l2.a.bool, readOnly: l2.a.bool };
      var J2 = $2, Z2 = Object.assign || function(e5) {
        for (var t4 = 1; t4 < arguments.length; t4++) {
          var n4 = arguments[t4];
          for (var r4 in n4)
            Object.prototype.hasOwnProperty.call(n4, r4) && (e5[r4] = n4[r4]);
        }
        return e5;
      }, G2 = function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }();
      var Q2 = function(e5) {
        var t4 = e5.checked;
        return function(e6) {
          e6 && (e6.checked = t4);
        };
      }, X2 = function(e5) {
        function t4() {
          return function(e6, t5) {
            if (!(e6 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, t4), function(e6, t5) {
            if (!e6)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t5 || "object" != typeof t5 && "function" != typeof t5 ? e6 : t5;
          }(this, (t4.__proto__ || Object.getPrototypeOf(t4)).apply(this, arguments));
        }
        return function(e6, t5) {
          if ("function" != typeof t5 && null !== t5)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t5);
          e6.prototype = Object.create(t5 && t5.prototype, { constructor: { value: e6, enumerable: false, writable: true, configurable: true } }), t5 && (Object.setPrototypeOf ? Object.setPrototypeOf(e6, t5) : e6.__proto__ = t5);
        }(t4, s2["PureComponent"]), G2(t4, [{ key: "render", value: function() {
          var e6 = this.props, t5 = e6.name, n4 = e6.checked, r4 = e6.onChange, o3 = e6.disabled, a3 = e6.readOnly, i3 = function(e7, t6) {
            var n5 = {};
            for (var r5 in e7)
              t6.indexOf(r5) >= 0 || Object.prototype.hasOwnProperty.call(e7, r5) && (n5[r5] = e7[r5]);
            return n5;
          }(e6, ["name", "checked", "onChange", "disabled", "readOnly"]), l3 = o3 || a3;
          return c2.a.createElement("input", Z2({ type: "radio", name: t5, ref: Q2({ checked: n4 }), onChange: r4, disabled: l3 }, i3));
        } }]), t4;
      }();
      X2.propTypes = { name: l2.a.string.isRequired, checked: l2.a.bool, onChange: l2.a.func, disabled: l2.a.bool, readOnly: l2.a.bool };
      var ee2 = X2, te2 = Object.assign || function(e5) {
        for (var t4 = 1; t4 < arguments.length; t4++) {
          var n4 = arguments[t4];
          for (var r4 in n4)
            Object.prototype.hasOwnProperty.call(n4, r4) && (e5[r4] = n4[r4]);
        }
        return e5;
      }, ne2 = function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }();
      function re2(e5, t4) {
        if (!e5)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t4 || "object" != typeof t4 && "function" != typeof t4 ? e5 : t4;
      }
      var oe2 = function(e5) {
        function t4() {
          var e6, n4, r4;
          !function(e7, t5) {
            if (!(e7 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, t4);
          for (var o3 = arguments.length, a3 = Array(o3), i3 = 0; i3 < o3; i3++)
            a3[i3] = arguments[i3];
          return n4 = r4 = re2(this, (e6 = t4.__proto__ || Object.getPrototypeOf(t4)).call.apply(e6, [this].concat(a3))), r4.handleCheckboxChange = function(e7) {
            var t5 = r4.props, n5 = t5.mode, o4 = t5.id, a4 = t5.onCheckboxChange;
            "simpleSelect" === n5 || "radioSelect" === n5 ? a4(o4, true) : a4(o4, e7.target.checked);
            e7.stopPropagation(), e7.nativeEvent.stopImmediatePropagation();
          }, re2(r4, n4);
        }
        return function(e6, t5) {
          if ("function" != typeof t5 && null !== t5)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t5);
          e6.prototype = Object.create(t5 && t5.prototype, { constructor: { value: e6, enumerable: false, writable: true, configurable: true } }), t5 && (Object.setPrototypeOf ? Object.setPrototypeOf(e6, t5) : e6.__proto__ = t5);
        }(t4, s2["PureComponent"]), ne2(t4, [{ key: "render", value: function() {
          var e6 = this.props, t5 = e6.mode, n4 = e6.title, r4 = e6.label, o3 = e6.id, a3 = e6.partial, i3 = e6.checked, l3 = this.props, s3 = l3.value, u3 = l3.disabled, d2 = l3.showPartiallySelected, h2 = l3.readOnly, p2 = l3.clientId, f4 = { className: "node-label" };
          "simpleSelect" === t5 && !h2 && !u3 && (f4.onClick = this.handleCheckboxChange);
          var y3 = { id: o3, value: s3, checked: i3, disabled: u3, readOnly: h2, tabIndex: -1 }, g3 = ["checkbox-item", "simpleSelect" === t5 && "simple-select"].filter(Boolean).join(" ");
          return c2.a.createElement("label", { title: n4 || r4, htmlFor: o3 }, "radioSelect" === t5 ? c2.a.createElement(ee2, te2({ name: p2, className: "radio-item", onChange: this.handleCheckboxChange }, y3)) : c2.a.createElement(J2, te2({ name: o3, className: g3, indeterminate: d2 && a3, onChange: this.handleCheckboxChange }, y3)), c2.a.createElement("span", f4, r4));
        } }]), t4;
      }();
      oe2.propTypes = { id: l2.a.string.isRequired, actions: l2.a.array, title: l2.a.string, label: l2.a.string.isRequired, value: l2.a.string.isRequired, checked: l2.a.bool, partial: l2.a.bool, disabled: l2.a.bool, dataset: l2.a.object, mode: l2.a.oneOf(["multiSelect", "simpleSelect", "radioSelect", "hierarchical"]), showPartiallySelected: l2.a.bool, onCheckboxChange: l2.a.func, readOnly: l2.a.bool, clientId: l2.a.string };
      var ae2 = oe2, ie2 = function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }();
      function le2(e5, t4) {
        if (!e5)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t4 || "object" != typeof t4 && "function" != typeof t4 ? e5 : t4;
      }
      var se2 = function(e5) {
        function t4() {
          var e6, n4, r4;
          !function(e7, t5) {
            if (!(e7 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, t4);
          for (var o3 = arguments.length, a3 = Array(o3), i3 = 0; i3 < o3; i3++)
            a3[i3] = arguments[i3];
          return n4 = r4 = le2(this, (e6 = t4.__proto__ || Object.getPrototypeOf(t4)).call.apply(e6, [this].concat(a3))), r4.onToggle = function(e7) {
            e7.stopPropagation(), e7.nativeEvent.stopImmediatePropagation(), r4.props.onNodeToggle(r4.props.id);
          }, r4.onKeyDown = function(e7) {
            "Enter" !== e7.key && 32 !== e7.keyCode || (r4.props.onNodeToggle(r4.props.id), e7.preventDefault());
          }, le2(r4, n4);
        }
        return function(e6, t5) {
          if ("function" != typeof t5 && null !== t5)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t5);
          e6.prototype = Object.create(t5 && t5.prototype, { constructor: { value: e6, enumerable: false, writable: true, configurable: true } }), t5 && (Object.setPrototypeOf ? Object.setPrototypeOf(e6, t5) : e6.__proto__ = t5);
        }(t4, s2["PureComponent"]), ie2(t4, [{ key: "render", value: function() {
          var e6 = this.props, t5 = e6.expanded, n4 = e6.isLeaf, r4 = ["toggle", t5 && "expanded", !t5 && "collapsed"].filter(Boolean).join(" ");
          return n4 ? c2.a.createElement("i", { role: "button", tabIndex: -1, className: r4, style: { visibility: "hidden" }, "aria-hidden": true }) : c2.a.createElement("i", { role: "button", tabIndex: -1, className: r4, onClick: this.onToggle, onKeyDown: this.onKeyDown, "aria-hidden": true });
        } }]), t4;
      }();
      se2.propTypes = { expanded: l2.a.bool, isLeaf: l2.a.bool, onNodeToggle: l2.a.func, id: l2.a.string };
      var ce2 = se2, ue2 = (n3(8), Object.assign || function(e5) {
        for (var t4 = 1; t4 < arguments.length; t4++) {
          var n4 = arguments[t4];
          for (var r4 in n4)
            Object.prototype.hasOwnProperty.call(n4, r4) && (e5[r4] = n4[r4]);
        }
        return e5;
      }), de2 = function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }();
      function he2(e5, t4) {
        if (!e5)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t4 || "object" != typeof t4 && "function" != typeof t4 ? e5 : t4;
      }
      var pe2 = function(e5) {
        return d(e5);
      }, fe2 = function(e5) {
        function t4() {
          var e6, n4, r4;
          !function(e7, t5) {
            if (!(e7 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, t4);
          for (var o3 = arguments.length, a3 = Array(o3), i3 = 0; i3 < o3; i3++)
            a3[i3] = arguments[i3];
          return n4 = r4 = he2(this, (e6 = t4.__proto__ || Object.getPrototypeOf(t4)).call.apply(e6, [this].concat(a3))), r4.getAriaAttributes = function() {
            var e7 = r4.props, t5 = e7._children, n5 = e7._depth, o4 = e7.checked, a4 = e7.disabled, i4 = e7.expanded, l3 = e7.readOnly, s3 = e7.mode, c3 = e7.partial, u3 = {};
            return u3.role = "simpleSelect" === s3 ? "option" : "treeitem", u3["aria-disabled"] = a4 || l3, u3["aria-selected"] = o4, "simpleSelect" !== s3 && (u3["aria-checked"] = c3 ? "mixed" : o4, u3["aria-level"] = (n5 || 0) + 1, u3["aria-expanded"] = t5 && (i4 ? "true" : "false")), u3;
          }, he2(r4, n4);
        }
        return function(e6, t5) {
          if ("function" != typeof t5 && null !== t5)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t5);
          e6.prototype = Object.create(t5 && t5.prototype, { constructor: { value: e6, enumerable: false, writable: true, configurable: true } }), t5 && (Object.setPrototypeOf ? Object.setPrototypeOf(e6, t5) : e6.__proto__ = t5);
        }(t4, s2["PureComponent"]), de2(t4, [{ key: "render", value: function() {
          var e6 = this.props, t5 = e6.mode, n4 = e6.keepTreeOnSearch, r4 = e6._id, o3 = e6._children, a3 = e6.dataset, i3 = e6._depth, l3 = e6.expanded, s3 = e6.title, d2 = e6.label, h2 = e6.partial, p2 = e6.checked, f4 = e6.value, y3 = e6.disabled, g3 = e6.actions, b3 = e6.onAction, v3 = e6.searchModeOn, m3 = e6.onNodeToggle, w3 = e6.onCheckboxChange, O3 = e6.showPartiallySelected, k3 = e6.readOnly, _3 = e6.clientId, T3 = function(e7) {
            var t6 = e7.keepTreeOnSearch, n5 = e7.keepChildrenOnSearch, r5 = e7._children, o4 = e7.matchInChildren, a4 = e7.matchInParent, i4 = e7.disabled, l4 = e7.partial, s4 = e7.hide, c3 = e7.className, u3 = e7.showPartiallySelected, d3 = e7.readOnly, h3 = e7.checked, p3 = e7._focused;
            return ["node", pe2(r5) && "leaf", !pe2(r5) && "tree", i4 && "disabled", s4 && "hide", t6 && o4 && "match-in-children", t6 && n5 && a4 && "match-in-parent", u3 && l4 && "partial", d3 && "readOnly", h3 && "checked", p3 && "focused", c3].filter(Boolean).join(" ");
          }(this.props), P3 = n4 || !v3 ? { paddingLeft: 20 * (i3 || 0) + "px" } : {}, S3 = r4 + "_li";
          return c2.a.createElement("li", ue2({ className: T3, style: P3, id: S3 }, u2(a3), this.getAriaAttributes()), c2.a.createElement(ce2, { isLeaf: pe2(o3), expanded: l3, id: r4, onNodeToggle: m3 }), c2.a.createElement(ae2, { title: s3, label: d2, id: r4, partial: h2, checked: p2, value: f4, disabled: y3, mode: t5, onCheckboxChange: w3, showPartiallySelected: O3, readOnly: k3, clientId: _3 }), c2.a.createElement(H2, { actions: g3, onAction: b3, id: r4, readOnly: k3 }));
        } }]), t4;
      }();
      fe2.propTypes = { _id: l2.a.string.isRequired, _depth: l2.a.number, _children: l2.a.array, actions: l2.a.array, className: l2.a.string, title: l2.a.string, label: l2.a.string.isRequired, value: l2.a.string.isRequired, checked: l2.a.bool, expanded: l2.a.bool, disabled: l2.a.bool, partial: l2.a.bool, dataset: l2.a.object, keepTreeOnSearch: l2.a.bool, keepChildrenOnSearch: l2.a.bool, searchModeOn: l2.a.bool, onNodeToggle: l2.a.func, onAction: l2.a.func, onCheckboxChange: l2.a.func, mode: l2.a.oneOf(["multiSelect", "simpleSelect", "radioSelect", "hierarchical"]), showPartiallySelected: l2.a.bool, readOnly: l2.a.bool, clientId: l2.a.string };
      var ye2 = fe2, ge2 = Object.assign || function(e5) {
        for (var t4 = 1; t4 < arguments.length; t4++) {
          var n4 = arguments[t4];
          for (var r4 in n4)
            Object.prototype.hasOwnProperty.call(n4, r4) && (e5[r4] = n4[r4]);
        }
        return e5;
      }, be2 = function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }();
      var ve2 = function(e5) {
        function t4(e6) {
          !function(e7, t5) {
            if (!(e7 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, t4);
          var n4 = function(e7, t5) {
            if (!e7)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t5 || "object" != typeof t5 && "function" != typeof t5 ? e7 : t5;
          }(this, (t4.__proto__ || Object.getPrototypeOf(t4)).call(this, e6));
          return me2.call(n4), n4.currentPage = 1, n4.computeInstanceProps(e6, true), n4.state = { items: n4.allVisibleNodes.slice(0, n4.props.pageSize) }, n4;
        }
        return function(e6, t5) {
          if ("function" != typeof t5 && null !== t5)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t5);
          e6.prototype = Object.create(t5 && t5.prototype, { constructor: { value: e6, enumerable: false, writable: true, configurable: true } }), t5 && (Object.setPrototypeOf ? Object.setPrototypeOf(e6, t5) : e6.__proto__ = t5);
        }(t4, s2["Component"]), be2(t4, [{ key: "render", value: function() {
          var e6 = this.props.searchModeOn;
          return c2.a.createElement("ul", ge2({ className: "root " + (e6 ? "searchModeOn" : ""), ref: this.setNodeRef }, this.getAriaAttributes()), this.state.scrollableTarget && c2.a.createElement(F2.a, { dataLength: this.state.items.length, next: this.loadMore, hasMore: this.hasMore(), loader: c2.a.createElement("span", { className: "searchLoader" }, "Loading..."), scrollableTarget: this.state.scrollableTarget }, this.state.items));
        } }]), t4;
      }();
      ve2.propTypes = { data: l2.a.object, keepTreeOnSearch: l2.a.bool, keepChildrenOnSearch: l2.a.bool, searchModeOn: l2.a.bool, onChange: l2.a.func, onNodeToggle: l2.a.func, onAction: l2.a.func, onCheckboxChange: l2.a.func, mode: l2.a.oneOf(["multiSelect", "simpleSelect", "radioSelect", "hierarchical"]), showPartiallySelected: l2.a.bool, pageSize: l2.a.number, readOnly: l2.a.bool, clientId: l2.a.string, activeDescendant: l2.a.string }, ve2.defaultProps = { pageSize: 100 };
      var me2 = function() {
        var e5 = this;
        this.componentWillReceiveProps = function(t4) {
          var n4 = t4.activeDescendant === e5.props.activeDescendant;
          e5.computeInstanceProps(t4, !n4), e5.setState({ items: e5.allVisibleNodes.slice(0, e5.currentPage * e5.props.pageSize) });
        }, this.componentDidMount = function() {
          e5.setState({ scrollableTarget: e5.node.parentNode });
        }, this.computeInstanceProps = function(t4, n4) {
          if (e5.allVisibleNodes = e5.getNodes(t4), e5.totalPages = Math.ceil(e5.allVisibleNodes.length / e5.props.pageSize), n4 && t4.activeDescendant) {
            var r4 = t4.activeDescendant.replace(/_li$/, ""), o3 = y2(e5.allVisibleNodes, function(e6) {
              return e6.key === r4;
            }) + 1;
            e5.currentPage = o3 > 0 ? Math.ceil(o3 / e5.props.pageSize) : 1;
          }
        }, this.shouldRenderNode = function(e6, t4) {
          var n4 = t4.data, r4 = t4.searchModeOn, o3 = e6.expanded, a3 = e6._parent;
          if (r4 || o3)
            return true;
          var i3 = a3 && n4.get(a3);
          return !i3 || i3.expanded;
        }, this.getNodes = function(t4) {
          var n4 = t4.data, r4 = t4.keepTreeOnSearch, o3 = t4.keepChildrenOnSearch, a3 = t4.searchModeOn, i3 = t4.mode, l3 = t4.showPartiallySelected, s3 = t4.readOnly, u3 = t4.onAction, d2 = t4.onChange, h2 = t4.onCheckboxChange, p2 = t4.onNodeToggle, f4 = t4.activeDescendant, y3 = t4.clientId, g3 = [];
          return n4.forEach(function(n5) {
            e5.shouldRenderNode(n5, t4) && g3.push(c2.a.createElement(ye2, ge2({ keepTreeOnSearch: r4, keepChildrenOnSearch: o3, key: n5._id }, n5, { searchModeOn: a3, onChange: d2, onCheckboxChange: h2, onNodeToggle: p2, onAction: u3, mode: i3, showPartiallySelected: l3, readOnly: s3, clientId: y3, activeDescendant: f4 })));
          }), g3;
        }, this.hasMore = function() {
          return e5.currentPage < e5.totalPages;
        }, this.loadMore = function() {
          e5.currentPage = e5.currentPage + 1;
          var t4 = e5.allVisibleNodes.slice(0, e5.currentPage * e5.props.pageSize);
          e5.setState({ items: t4 });
        }, this.setNodeRef = function(t4) {
          e5.node = t4;
        }, this.getAriaAttributes = function() {
          var t4 = e5.props.mode;
          return { role: "simpleSelect" === t4 ? "listbox" : "tree", "aria-multiselectable": /multiSelect|hierarchical/.test(t4) };
        };
      }, we2 = ve2, Oe2 = n3(3), ke2 = n3.n(Oe2), _e2 = function(e5) {
        return e5;
      }, Te2 = function(e5) {
        var t4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "children", n4 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : _e2;
        return ke2()(e5[t4], function(e6) {
          return n4(e6).checked;
        }) || e5[t4].some(function(e6) {
          return n4(e6).partial;
        });
      };
      var Pe2 = function(e5) {
        var t4 = e5.tree, n4 = e5.simple, r4 = e5.radio, o3 = e5.showPartialState, a3 = e5.hierarchical, i3 = e5.rootPrefixId;
        return function e6(t5) {
          var n5 = t5.nodes, r5 = t5.parent, o4 = t5.depth, a4 = void 0 === o4 ? 0 : o4, i4 = t5.simple, l3 = t5.radio, s3 = t5.showPartialState, c3 = t5.hierarchical, u3 = t5.rootPrefixId, h2 = t5._rv, p2 = void 0 === h2 ? { list: /* @__PURE__ */ new Map(), defaultValues: [], singleSelectedNode: null } : h2, f4 = i4 || l3;
          return n5.forEach(function(t6, n6) {
            t6._depth = a4, r5 ? (t6._id = t6.id || r5._id + "-" + n6, t6._parent = r5._id, r5._children.push(t6._id)) : t6._id = t6.id || "" + (u3 ? u3 + "-" + n6 : n6), f4 && t6.checked && (p2.singleSelectedNode ? t6.checked = false : p2.singleSelectedNode = t6), f4 && t6.isDefaultValue && p2.singleSelectedNode && !p2.singleSelectedNode.isDefaultValue && (p2.singleSelectedNode.checked = false, p2.singleSelectedNode = null), !t6.isDefaultValue || f4 && 0 !== p2.defaultValues.length || (p2.defaultValues.push(t6._id), t6.checked = true, f4 && (p2.singleSelectedNode = t6)), c3 && !l3 || function(e7) {
              for (var t7 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n7 = arguments.length > 2 && void 0 !== arguments[2] && !arguments[2] ? ["disabled"] : ["checked", "disabled"], r6 = 0; r6 < n7.length; r6++) {
                var o5 = n7[r6];
                void 0 === e7[o5] && void 0 !== t7[o5] && (e7[o5] = t7[o5]);
              }
            }(t6, r5, !l3), p2.list.set(t6._id, t6), !i4 && t6.children && (t6._children = [], e6({ nodes: t6.children, parent: t6, depth: a4 + 1, radio: l3, showPartialState: s3, hierarchical: c3, _rv: p2 }), s3 && !t6.checked && (t6.partial = Te2(t6), f4 || d(t6.children) || !t6.children.every(function(e7) {
              return e7.checked;
            }) || (t6.checked = true)), t6.children = void 0);
          }), p2;
        }({ nodes: Array.isArray(t4) ? t4 : [t4], simple: n4, radio: r4, showPartialState: o3, hierarchical: a3, rootPrefixId: i3 });
      }, Se2 = function e5(t4, n4, r4) {
        n4[t4._id] = true, d(t4._children) || t4._children.forEach(function(t5) {
          return e5(r4(t5), n4, r4);
        });
      }, Ce2 = function(e5, t4) {
        var n4 = [], r4 = {};
        return e5.forEach(function(e6, o3) {
          r4[o3] || (t4(e6, o3, r4) && n4.push(e6), r4[o3] = true);
        }), n4;
      }, xe2 = { getNodesMatching: Ce2, getVisibleNodes: function(e5, t4, n4) {
        return Ce2(e5, function(e6, r4, o3) {
          return n4 && e6._children && e6._children.length && true !== e6.expanded && Se2(e6, o3, t4), !e6.hide;
        });
      }, markSubTreeVisited: Se2 }, Ee2 = function() {
        return function(e5, t4) {
          if (Array.isArray(e5))
            return e5;
          if (Symbol.iterator in Object(e5))
            return function(e6, t5) {
              var n4 = [], r4 = true, o3 = false, a3 = void 0;
              try {
                for (var i3, l3 = e6[Symbol.iterator](); !(r4 = (i3 = l3.next()).done) && (n4.push(i3.value), !t5 || n4.length !== t5); r4 = true)
                  ;
              } catch (e7) {
                o3 = true, a3 = e7;
              } finally {
                try {
                  !r4 && l3.return && l3.return();
                } finally {
                  if (o3)
                    throw a3;
                }
              }
              return n4;
            }(e5, t4);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }(), je2 = "ArrowUp", Ne2 = "ArrowDown", Ie2 = "ArrowLeft", De2 = "ArrowRight", Re2 = "Enter", Me2 = "Home", Fe2 = "PageUp", Ae2 = "End", Be2 = "PageDown", Le2 = { None: "None", FocusPrevious: "FocusPrevious", FocusNext: "FocusNext", FocusParent: "FocusParent", FocusFirst: "FocusFirst", FocusLast: "FocusLast", ToggleExpanded: "ToggleExpanded", ToggleChecked: "ToggleChecked" }, Ve2 = /* @__PURE__ */ new Set([Le2.FocusPrevious, Le2.FocusNext, Le2.FocusParent, Le2.FocusFirst, Le2.FocusLast]), Ye2 = [je2, Ne2, Me2, Fe2, Ae2, Be2], Ke = Ye2.concat([Ie2, De2, Re2]), qe2 = function(e5, t4, n4, r4) {
        return t4.indexOf(e5) > -1 || !n4 && e5 === r4;
      }, He = function(e5, t4, n4) {
        if (!e5 || 0 === e5.length)
          return t4;
        var r4 = t4;
        (function(e6) {
          return qe2(e6, [Le2.FocusFirst, Le2.FocusLast], true);
        })(n4) ? r4 = Ee2(e5, 1)[0] : [Le2.FocusPrevious, Le2.FocusNext].indexOf(n4) > -1 && (r4 = function(e6, t5) {
          var n5 = e6.indexOf(t5) + 1;
          return n5 % e6.length == 0 ? e6[0] : e6[n5];
        }(e5, t4));
        return r4;
      }, Ue2 = { isValidKey: function(e5, t4) {
        return (t4 ? Ke : Ye2).indexOf(e5) > -1;
      }, getAction: function(e5, t4) {
        return t4 === Ie2 ? function(e6, t5) {
          return e6 && t5 === Ie2 ? true === e6.expanded ? Le2.ToggleExpanded : e6._parent ? Le2.FocusParent : Le2.None : Le2.None;
        }(e5, t4) : t4 === De2 ? function(e6, t5) {
          return e6 && e6._children && t5 === De2 ? true !== e6.expanded ? Le2.ToggleExpanded : Le2.FocusNext : Le2.None;
        }(e5, t4) : function(e6, t5) {
          return qe2(e6, [Me2, Fe2], t5, Ne2);
        }(t4, e5) ? Le2.FocusFirst : function(e6, t5) {
          return qe2(e6, [Ae2, Be2], t5, je2);
        }(t4, e5) ? Le2.FocusLast : function(e6, t5) {
          if (!e6)
            return Le2.None;
          switch (t5) {
            case je2:
              return Le2.FocusPrevious;
            case Ne2:
              return Le2.FocusNext;
            case Re2:
              return Le2.ToggleChecked;
            default:
              return Le2.None;
          }
        }(e5, t4);
      }, getNextFocus: function(e5, t4, n4, r4, o3) {
        if (n4 === Le2.FocusParent)
          return function(e6, t5) {
            return e6 && e6._parent ? t5(e6._parent) : e6;
          }(t4, r4);
        if (!Ve2.has(n4))
          return t4;
        var a3 = xe2.getVisibleNodes(e5, r4, o3);
        return function(e6) {
          return qe2(e6, [Le2.FocusPrevious, Le2.FocusLast], true);
        }(n4) && (a3 = a3.reverse()), He(a3, t4, n4);
      }, getNextFocusAfterTagDelete: function(e5, t4, n4, r4) {
        var o3 = t4 ? y2(t4, function(t5) {
          return t5._id === e5;
        }) : -1;
        if (o3 < 0 || !n4.length)
          return r4;
        var a3 = n4[o3 = n4.length > o3 ? o3 : n4.length - 1]._id, i3 = document.getElementById(_2(a3));
        return i3 && i3.firstElementChild || r4;
      }, handleFocusNavigationkey: function(e5, t4, n4, r4, o3) {
        var a3 = Ue2.getNextFocus(e5, n4, t4, r4, o3);
        return Ue2.adjustFocusedProps(n4, a3), a3 ? a3._id : n4 && n4._id;
      }, handleToggleNavigationkey: function(e5, t4, n4, r4, o3) {
        return e5 !== Le2.ToggleChecked || n4 || t4.readOnly || t4.disabled ? e5 === Le2.ToggleExpanded && o3(t4._id) : r4(t4._id, true !== t4.checked), t4 && t4._id;
      }, adjustFocusedProps: function(e5, t4) {
        e5 && t4 && e5._id !== t4._id && (e5._focused = false), t4 && (t4._focused = true);
      } }, We2 = Ue2, ze2 = function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }();
      var $e = function() {
        function e5(t4) {
          var n4 = t4.data, r4 = t4.mode, o3 = t4.showPartiallySelected, a3 = t4.rootPrefixId, i3 = t4.searchPredicate;
          !function(e6, t5) {
            if (!(e6 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, e5), this._src = n4, this.simpleSelect = "simpleSelect" === r4, this.radioSelect = "radioSelect" === r4, this.hierarchical = "hierarchical" === r4, this.searchPredicate = i3;
          var l3 = Pe2({ tree: JSON.parse(JSON.stringify(n4)), simple: this.simpleSelect, radio: this.radioSelect, showPartialState: o3, hierarchical: this.hierarchical, rootPrefixId: a3 }), s3 = l3.list, c3 = l3.defaultValues, u3 = l3.singleSelectedNode;
          this.tree = s3, this.defaultValues = c3, this.showPartialState = !this.hierarchical && o3, this.searchMaps = /* @__PURE__ */ new Map(), (this.simpleSelect || this.radioSelect) && u3 && (this.currentChecked = u3._id);
        }
        return ze2(e5, [{ key: "getNodeById", value: function(e6) {
          return this.tree.get(e6);
        } }, { key: "getMatches", value: function(e6) {
          var t4 = this;
          if (this.searchMaps.has(e6))
            return this.searchMaps.get(e6);
          var n4 = -1, r4 = e6;
          this.searchMaps.forEach(function(t5, o4) {
            e6.startsWith(o4) && o4.length > n4 && (n4 = o4.length, r4 = o4);
          });
          var o3 = [], a3 = this._getAddOnMatch(o3, e6);
          r4 !== e6 ? this.searchMaps.get(r4).forEach(function(e7) {
            return a3(t4.getNodeById(e7));
          }) : this.tree.forEach(a3);
          return this.searchMaps.set(e6, o3), o3;
        } }, { key: "addParentsToTree", value: function(e6, t4) {
          if (void 0 !== e6) {
            var n4 = this.getNodeById(e6);
            this.addParentsToTree(n4._parent, t4), n4.hide = !n4._isMatch || n4.hide, n4.matchInChildren = true, t4.set(e6, n4);
          }
        } }, { key: "addChildrenToTree", value: function(e6, t4, n4) {
          var r4 = this;
          void 0 !== e6 && e6.forEach(function(e7) {
            if (!n4 || !n4.includes(e7)) {
              var o3 = r4.getNodeById(e7);
              o3.matchInParent = true, t4.set(e7, o3), r4.addChildrenToTree(o3._children, t4);
            }
          });
        } }, { key: "filterTree", value: function(e6, t4, n4) {
          var r4 = this, o3 = this.getMatches(e6.toLowerCase()), a3 = /* @__PURE__ */ new Map();
          o3.forEach(function(e7) {
            var i4 = r4.getNodeById(e7);
            i4.hide = false, i4._isMatch = true, t4 && r4.addParentsToTree(i4._parent, a3), a3.set(e7, i4), t4 && n4 && r4.addChildrenToTree(i4._children, a3, o3);
          });
          var i3 = 0 === o3.length;
          return this.matchTree = a3, { allNodesHidden: i3, tree: a3 };
        } }, { key: "restoreNodes", value: function() {
          return this.tree.forEach(function(e6) {
            e6.hide = false;
          }), this.tree;
        } }, { key: "restoreDefaultValues", value: function() {
          var e6 = this;
          return this.defaultValues.forEach(function(t4) {
            e6.setNodeCheckedState(t4, true);
          }), this.tree;
        } }, { key: "togglePreviousChecked", value: function(e6, t4) {
          var n4 = this.currentChecked;
          if (n4 && n4 !== e6) {
            var r4 = this.getNodeById(n4);
            r4.checked = false, this.radioSelect && this.showPartialState && this.partialCheckParents(r4);
          }
          this.currentChecked = t4 ? e6 : null;
        } }, { key: "setNodeCheckedState", value: function(e6, t4) {
          this.radioSelect && this.togglePreviousChecked(e6, t4);
          var n4 = this.getNodeById(e6);
          n4.checked = t4, this.showPartialState && (n4.partial = false), this.simpleSelect ? this.togglePreviousChecked(e6, t4) : this.radioSelect ? (this.showPartialState && this.partialCheckParents(n4), t4 || this.unCheckParents(n4)) : (this.hierarchical || this.toggleChildren(e6, t4), this.showPartialState && this.partialCheckParents(n4), this.hierarchical || t4 || this.unCheckParents(n4));
        } }, { key: "unCheckParents", value: function(e6) {
          for (var t4 = e6._parent; t4; ) {
            var n4 = this.getNodeById(t4);
            n4.checked = false, n4.partial = Te2(n4, "_children", this.getNodeById.bind(this)), t4 = n4._parent;
          }
        } }, { key: "partialCheckParents", value: function(e6) {
          for (var t4 = this, n4 = e6._parent; n4; ) {
            var r4 = this.getNodeById(n4);
            r4.checked = r4._children.every(function(e7) {
              return t4.getNodeById(e7).checked;
            }), r4.partial = Te2(r4, "_children", this.getNodeById.bind(this)), n4 = r4._parent;
          }
        } }, { key: "toggleChildren", value: function(e6, t4) {
          var n4 = this, r4 = this.getNodeById(e6);
          r4.checked = t4, this.showPartialState && (r4.partial = false), d(r4._children) || r4._children.forEach(function(e7) {
            return n4.toggleChildren(e7, t4);
          });
        } }, { key: "toggleNodeExpandState", value: function(e6) {
          var t4 = this.getNodeById(e6);
          return t4.expanded = !t4.expanded, t4.expanded || this.collapseChildren(t4), this.tree;
        } }, { key: "collapseChildren", value: function(e6) {
          var t4 = this;
          e6.expanded = false, d(e6._children) || e6._children.forEach(function(e7) {
            return t4.collapseChildren(t4.getNodeById(e7));
          });
        } }, { key: "getTreeAndTags", value: function() {
          return { tree: this.tree, tags: this.tags };
        } }, { key: "handleNavigationKey", value: function(e6, t4, n4, r4, o3, a3, i3) {
          var l3 = this, s3 = e6 && this.getNodeById(e6), c3 = We2.getAction(s3, n4);
          return Ve2.has(c3) ? We2.handleFocusNavigationkey(t4, c3, s3, function(e7) {
            return l3.getNodeById(e7);
          }, o3) : s3 && t4.has(s3._id) ? We2.handleToggleNavigationkey(c3, s3, r4, a3, i3) : e6;
        } }, { key: "_getAddOnMatch", value: function(e6, t4) {
          var n4 = function(e7, t5) {
            return e7.label.toLowerCase().indexOf(t5) >= 0;
          };
          return "function" == typeof this.searchPredicate && (n4 = this.searchPredicate), function(r4) {
            n4(r4, t4) && e6.push(r4._id);
          };
        } }, { key: "tags", get: function() {
          var e6 = this;
          return this.radioSelect || this.simpleSelect ? this.currentChecked ? [this.getNodeById(this.currentChecked)] : [] : xe2.getNodesMatching(this.tree, function(t4, n4, r4) {
            return t4.checked && !e6.hierarchical && xe2.markSubTreeVisited(t4, r4, function(t5) {
              return e6.getNodeById(t5);
            }), t4.checked;
          });
        } }]), e5;
      }(), Je = (n3(9), Object.assign || function(e5) {
        for (var t4 = 1; t4 < arguments.length; t4++) {
          var n4 = arguments[t4];
          for (var r4 in n4)
            Object.prototype.hasOwnProperty.call(n4, r4) && (e5[r4] = n4[r4]);
        }
        return e5;
      }), Ze = function() {
        function e5(e6, t4) {
          for (var n4 = 0; n4 < t4.length; n4++) {
            var r4 = t4[n4];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e6, r4.key, r4);
          }
        }
        return function(t4, n4, r4) {
          return n4 && e5(t4.prototype, n4), r4 && e5(t4, r4), t4;
        };
      }();
      var Ge = function(e5) {
        function t4(e6) {
          !function(e7, t5) {
            if (!(e7 instanceof t5))
              throw new TypeError("Cannot call a class as a function");
          }(this, t4);
          var n4 = function(e7, t5) {
            if (!e7)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t5 || "object" != typeof t5 && "function" != typeof t5 ? e7 : t5;
          }(this, (t4.__proto__ || Object.getPrototypeOf(t4)).call(this, e6));
          return n4.initNewProps = function(e7) {
            var t5 = e7.data, r4 = e7.mode, o3 = e7.showDropdown, a3 = e7.showPartiallySelected, i3 = e7.searchPredicate;
            n4.treeManager = new $e({ data: t5, mode: r4, showPartiallySelected: a3, rootPrefixId: n4.clientId, searchPredicate: i3 }), n4.setState(function(e8) {
              var t6 = e8.currentFocus && n4.treeManager.getNodeById(e8.currentFocus);
              return t6 && (t6._focused = true), Je({ showDropdown: /initial|always/.test(o3) || true === e8.showDropdown }, n4.treeManager.getTreeAndTags());
            });
          }, n4.resetSearchState = function() {
            return n4.searchInput && (n4.searchInput.value = ""), { tree: n4.treeManager.restoreNodes(), searchModeOn: false, allNodesHidden: false };
          }, n4.handleClick = function(e7, t5) {
            n4.setState(function(e8) {
              var t6 = "always" === n4.props.showDropdown || n4.keepDropdownActive || !e8.showDropdown;
              return t6 !== e8.showDropdown && (t6 ? document.addEventListener("click", n4.handleOutsideClick, false) : document.removeEventListener("click", n4.handleOutsideClick, false)), t6 ? n4.props.onFocus() : n4.props.onBlur(), t6 ? { showDropdown: t6 } : Je({ showDropdown: t6 }, n4.resetSearchState());
            }, t5);
          }, n4.handleOutsideClick = function(e7) {
            "always" !== n4.props.showDropdown && h(e7, n4.node) && n4.handleClick();
          }, n4.onInputChange = function(e7) {
            var t5 = n4.treeManager.filterTree(e7, n4.props.keepTreeOnSearch, n4.props.keepChildrenOnSearch), r4 = t5.allNodesHidden, o3 = t5.tree, a3 = e7.length > 0;
            n4.setState({ tree: o3, searchModeOn: a3, allNodesHidden: r4 });
          }, n4.onTagRemove = function(e7, t5) {
            var r4 = n4.state.tags;
            n4.onCheckboxChange(e7, false, function(o3) {
              t5 && We2.getNextFocusAfterTagDelete(e7, r4, o3, n4.searchInput).focus();
            });
          }, n4.onNodeToggle = function(e7) {
            n4.treeManager.toggleNodeExpandState(e7);
            var t5 = n4.state.searchModeOn ? n4.treeManager.matchTree : n4.treeManager.tree;
            n4.setState({ tree: t5 }), "function" == typeof n4.props.onNodeToggle && n4.props.onNodeToggle(n4.treeManager.getNodeById(e7));
          }, n4.onCheckboxChange = function(e7, t5, r4) {
            var o3 = n4.props, a3 = o3.mode, i3 = o3.keepOpenOnSelect, l3 = o3.clearSearchOnChange, s3 = n4.state, c3 = s3.currentFocus, u3 = s3.searchModeOn;
            n4.treeManager.setNodeCheckedState(e7, t5);
            var d2 = n4.treeManager.tags, h2 = ["simpleSelect", "radioSelect"].indexOf(a3) > -1, p2 = !(h2 && !i3) && n4.state.showDropdown, f4 = c3 && n4.treeManager.getNodeById(c3), y3 = n4.treeManager.getNodeById(e7);
            d2.length || (n4.treeManager.restoreDefaultValues(), d2 = n4.treeManager.tags);
            var g3 = { tree: u3 ? n4.treeManager.matchTree : n4.treeManager.tree, tags: d2, showDropdown: p2, currentFocus: e7 };
            (h2 && !p2 || l3) && Object.assign(g3, n4.resetSearchState()), h2 && !p2 && document.removeEventListener("click", n4.handleOutsideClick, false), We2.adjustFocusedProps(f4, y3), n4.setState(g3, function() {
              r4 && r4(d2);
            }), n4.props.onChange(y3, d2);
          }, n4.onAction = function(e7, t5) {
            n4.props.onAction(n4.treeManager.getNodeById(e7), t5);
          }, n4.onInputFocus = function() {
            n4.keepDropdownActive = true;
          }, n4.onInputBlur = function() {
            n4.keepDropdownActive = false;
          }, n4.onTrigger = function(e7) {
            n4.handleClick(e7, function() {
              n4.state.showDropdown && n4.searchInput.focus();
            });
          }, n4.onKeyboardKeyDown = function(e7) {
            var t5 = n4.props, r4 = t5.readOnly, o3 = t5.mode, a3 = t5.disablePoppingOnBackspace, i3 = n4.state, l3 = i3.showDropdown, s3 = i3.tags, c3 = i3.searchModeOn, u3 = i3.currentFocus, d2 = n4.treeManager, h2 = c3 ? d2.matchTree : d2.tree;
            if (l3 || !We2.isValidKey(e7.key, false) && !/^\w$/i.test(e7.key))
              if (l3 && We2.isValidKey(e7.key, true)) {
                var p2 = d2.handleNavigationKey(u3, h2, e7.key, r4, !c3, n4.onCheckboxChange, n4.onNodeToggle);
                p2 !== u3 && n4.setState({ currentFocus: p2 }, function() {
                  var e8 = document && document.getElementById(p2 + "_li");
                  e8 && e8.scrollIntoView();
                });
              } else {
                if (l3 && ["Escape", "Tab"].indexOf(e7.key) > -1)
                  return void ("simpleSelect" === o3 && h2.has(u3) ? n4.onCheckboxChange(u3, true) : (n4.keepDropdownActive = false, n4.handleClick()));
                if (a3 || "Backspace" !== e7.key || !s3.length || 0 !== n4.searchInput.value.length)
                  return;
                var f4 = s3.pop();
                n4.onCheckboxChange(f4._id, false);
              }
            else if (e7.persist(), n4.handleClick(null, function() {
              return n4.onKeyboardKeyDown(e7);
            }), /\w/i.test(e7.key))
              return;
            e7.preventDefault();
          }, n4.getAriaAttributes = function() {
            var e7 = n4.props, t5 = e7.mode, r4 = e7.texts;
            return "radioSelect" !== t5 ? {} : Je({ role: "radiogroup" }, g2(r4.label));
          }, n4.state = { searchModeOn: false, currentFocus: void 0 }, n4.clientId = e6.id || f3.get(n4), n4;
        }
        return function(e6, t5) {
          if ("function" != typeof t5 && null !== t5)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t5);
          e6.prototype = Object.create(t5 && t5.prototype, { constructor: { value: e6, enumerable: false, writable: true, configurable: true } }), t5 && (Object.setPrototypeOf ? Object.setPrototypeOf(e6, t5) : e6.__proto__ = t5);
        }(t4, s2["Component"]), Ze(t4, [{ key: "componentWillMount", value: function() {
          this.initNewProps(this.props);
        } }, { key: "componentWillUnmount", value: function() {
          document.removeEventListener("click", this.handleOutsideClick, false);
        } }, { key: "componentWillReceiveProps", value: function(e6) {
          this.initNewProps(e6);
        } }, { key: "render", value: function() {
          var e6 = this, t5 = this.props, n4 = t5.disabled, r4 = t5.readOnly, o3 = t5.mode, a3 = t5.texts, i3 = t5.inlineSearchInput, l3 = t5.tabIndex, s3 = this.state, u3 = s3.showDropdown, d2 = s3.currentFocus, h2 = s3.tags, p2 = { disabled: n4, readOnly: r4, activeDescendant: d2 ? d2 + "_li" : void 0, texts: a3, mode: o3, clientId: this.clientId }, f4 = c2.a.createElement(w2, Je({ inputRef: function(t6) {
            e6.searchInput = t6;
          }, onInputChange: this.onInputChange, onFocus: this.onInputFocus, onBlur: this.onInputBlur, onKeyDown: this.onKeyboardKeyDown }, p2, { inlineSearchInput: i3 }));
          return c2.a.createElement("div", { id: this.clientId, className: [this.props.className && this.props.className, "react-dropdown-tree-select"].filter(Boolean).join(" "), ref: function(t6) {
            e6.node = t6;
          } }, c2.a.createElement("div", { className: ["dropdown", "simpleSelect" === o3 && "simple-select", "radioSelect" === o3 && "radio-select"].filter(Boolean).join(" ") }, c2.a.createElement(R2, Je({ onTrigger: this.onTrigger, showDropdown: u3 }, p2, { tags: h2, tabIndex: l3 }), c2.a.createElement(E2, Je({ tags: h2, onTagRemove: this.onTagRemove }, p2), !i3 && f4)), u3 && c2.a.createElement("div", Je({ className: "dropdown-content" }, this.getAriaAttributes()), i3 && f4, this.state.allNodesHidden ? c2.a.createElement("span", { className: "no-matches" }, a3.noMatches || "No matches found") : c2.a.createElement(we2, Je({ data: this.state.tree, keepTreeOnSearch: this.props.keepTreeOnSearch, keepChildrenOnSearch: this.props.keepChildrenOnSearch, searchModeOn: this.state.searchModeOn, onAction: this.onAction, onCheckboxChange: this.onCheckboxChange, onNodeToggle: this.onNodeToggle, mode: o3, showPartiallySelected: this.props.showPartiallySelected }, p2)))));
        } }]), t4;
      }();
      Ge.propTypes = { data: l2.a.oneOfType([l2.a.object, l2.a.array]).isRequired, clearSearchOnChange: l2.a.bool, keepTreeOnSearch: l2.a.bool, keepChildrenOnSearch: l2.a.bool, keepOpenOnSelect: l2.a.bool, texts: l2.a.shape({ placeholder: l2.a.string, inlineSearchPlaceholder: l2.a.string, noMatches: l2.a.string, label: l2.a.string, labelRemove: l2.a.string }), showDropdown: l2.a.oneOf(["default", "initial", "always"]), className: l2.a.string, onChange: l2.a.func, onAction: l2.a.func, onNodeToggle: l2.a.func, onFocus: l2.a.func, onBlur: l2.a.func, mode: l2.a.oneOf(["multiSelect", "simpleSelect", "radioSelect", "hierarchical"]), showPartiallySelected: l2.a.bool, disabled: l2.a.bool, readOnly: l2.a.bool, id: l2.a.string, searchPredicate: l2.a.func, inlineSearchInput: l2.a.bool, tabIndex: l2.a.number, disablePoppingOnBackspace: l2.a.bool }, Ge.defaultProps = { onAction: function() {
      }, onFocus: function() {
      }, onBlur: function() {
      }, onChange: function() {
      }, texts: {}, showDropdown: "default", inlineSearchInput: false, tabIndex: 0, disablePoppingOnBackspace: false };
      t3.default = Ge;
    }]);
  });
})(reactDropdownTreeSelect);
var DropdownTreeSelect = /* @__PURE__ */ getDefaultExportFromCjs(reactDropdownTreeSelect.exports);
var StyledSpanOuter = styled_components_esm_default.span`
  align-self: flex-start;
  margin-left: 4px;

  color: #343741;

  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  padding: 0 8px;
  display: inline-block;
  text-decoration: none;
  border-radius: 3px;
  border: solid 1px #D3DAE6;
  background-color: #fff;
  white-space: nowrap;
  vertical-align: middle;
  cursor: default;
  max-width: 100%;
  text-align: left;
`;
StyledSpanOuter.displayName = "StyledDefaultEmptyStateStyledSpanOuter";
var StyledSpanInner = styled_components_esm_default.span`
  min-height: 18px;
  display: flex;
  align-items: center;
  overflow: hidden;
  flex-direction: row-reverse;
`;
StyledSpanInner.displayName = "StyledDefaultEmptyStateStyledSpanInner";
var StyledIcon = styled_components_esm_default(() => React.createElement(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", focusable: "false", role: "img", "aria-hidden": "true" },
  React.createElement("path", { d: "M11.994 4c1.059 0 1.924.818 2 1.856l.006.15v1.988a2.005 2.005 0 01-1.856 2L12 10H3.484l1.91 1.82a.52.52 0 010 .77.616.616 0 01-.829 0l-2.05-1.95a1.551 1.551 0 010-2.31l2.05-1.95a.617.617 0 01.83 0 .52.52 0 010 .77L3.45 9H12c.514-.003.935-.39.993-.888L13 7.994V6.006c0-.516-.388-.941-.888-1L11.994 5H9.5a.5.5 0 01-.09-.992L9.5 4h2.494z" })
))`
  width: 16px;
  height: 16px;

  display: inline-block;
  vertical-align: middle;
  fill: currentColor;
  transform: translate(0, 0);

  color: inherit;

  flex: 0 0 auto;
`;
StyledIcon.displayName = "StyledDefaultEmptyStateStyledIcon";
var StyledDefaultEmptyState = styled_components_esm_default.div`
  display: flex;
  margin: 0 20px;
  justify-content: space-between;
`;
StyledDefaultEmptyState.displayName = "StyledDefaultEmptyState";
function DefaultEmptyState({ close, value }) {
  return React.createElement(
    StyledDefaultEmptyState,
    null,
    React.createElement(
      "p",
      null,
      "Add ",
      React.createElement("strong", null, value),
      " as a custom option"
    ),
    React.createElement(
      StyledSpanOuter,
      null,
      React.createElement(
        StyledSpanInner,
        null,
        React.createElement(StyledIcon, null)
      )
    )
  );
}
function useEmptyState(selector, onClose2) {
  const input = useRef2(null);
  const inputValue = useRef2("");
  const [currentValue, setCurrentValue] = useState2("");
  function outsideClick() {
    if (!(input === null || input === void 0 ? void 0 : input.current)) {
      return;
    }
    input.current.blur();
    document.body.click();
  }
  function close() {
    outsideClick();
  }
  function onKeyDown2(e3) {
    if ((e3 === null || e3 === void 0 ? void 0 : e3.keyCode) === 13) {
      outsideClick();
    }
  }
  function onValueChanged() {
    if (!input.current) {
      return;
    }
    inputValue.current = input.current.value;
    setCurrentValue(input.current.value);
  }
  useEffect2(() => {
    input.current = document.querySelector(selector);
    if (!input.current) {
      return;
    }
    inputValue.current = input.current.value;
    setCurrentValue(input.current.value);
    input.current.addEventListener("input", onValueChanged);
    input.current.addEventListener("keydown", onKeyDown2);
    return () => {
      if (!input.current) {
        return;
      }
      onClose2(inputValue.current);
      input.current.removeEventListener("input", onValueChanged);
      input.current.removeEventListener("keydown", onKeyDown2);
    };
  }, []);
  return {
    value: currentValue,
    close
  };
}
function EmptyStateHOC(Component3) {
  return function EmptyStateHocInner({ selector, onCloseProp }) {
    const { value, close } = useEmptyState(selector, onCloseProp);
    function onClose2() {
      onCloseProp(value);
      close();
    }
    return React.createElement(Component3, { value, close: onClose2 });
  };
}
var closeIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xIDFMOSA5IiBzdHJva2U9IiMwNDQ2Q0EiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgIDxwYXRoIGQ9Ik05IDFMMSA5IiBzdHJva2U9IiMwNDQ2Q0EiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
var StyledTreeSelect = styled_components_esm_default(DropdownTreeSelect)`
  .tag {
    background-color: #f4f4f4;
    border: 1px solid #e9e9e9;
    padding: 2px 0 2px 2px;
    border-radius: 2px;
    display: inline-block
  }

  .tag:focus-within {
    background-color: #e9e9e9;
    border-color: #a0a0a0
  }

  .tag-remove {
    color: #a0a0a0;
    font-size: 75%;
    line-height: 100%;
    cursor: pointer;
    background-color: transparent;
    border: none;
    outline: none
  }

  .tag-remove.disabled, .tag-remove.readOnly {
    cursor: not-allowed
  }

  .tag-remove:focus {
    color: #3c3c3c
  }

  .node > label {
    cursor: pointer;
    margin-left: 2px
  }

  .tag-list {
    display: inline;
    padding: 0;
    margin: 0
  }

  .tag-item {
    display: inline-block;
    margin: 4px
  }

  .tag-item .search {
    border: none;
    border-bottom: 1px solid #ccc;
    outline: none
  }

  .tag-item:last-child {
    margin-right: 4px
  }

  .node {
    list-style: none;
    white-space: nowrap;
    padding: 4px
  }

  .node.leaf.collapsed {
    display: none
  }

  .node.disabled > * {
    color: gray;
    cursor: not-allowed
  }

  .node.match-in-children.hide .node-label {
    opacity: .5
  }

  .node.focused {
    background-color: #f4f4f4
  }

  .toggle {
    white-space: pre;
    margin-right: 4px;
    cursor: pointer
  }

  .toggle:after {
    content: " "
  }

  .toggle.collapsed:after {
    content: "+"
  }

  .toggle.expanded:after {
    content: "-"
  }

  .searchModeOn .toggle {
    display: none
  }

  .checkbox-item, .radio-item {
    vertical-align: middle;
    margin: 0 4px 0 0
  }

  .checkbox-item.simple-select, .radio-item.simple-select {
    display: none
  }

  .hide:not(.match-in-children) {
    display: none
  }

  .react-dropdown-tree-select .dropdown {
    position: relative;
    display: table
  }

  .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow {
    cursor: pointer
  }

  .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.bottom:after {
    content: "\\25BC";
    vertical-align: middle;
    color: #3c3c3c;
    margin-right: 2px
  }

  .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.top:after {
    content: "\\25B2";
    vertical-align: middle;
    color: #3c3c3c;
    margin-right: 2px
  }

  .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.disabled {
    cursor: not-allowed
  }

  .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.disabled.bottom:after {
    color: #b9b9b9
  }

  .react-dropdown-tree-select .dropdown .dropdown-content {
    position: absolute;
    padding: 4px;
    z-index: 1;
    background: #fff;
    border-top: 1px solid rgba(0, 0, 0, .05);
    -webkit-box-shadow: 0 5px 8px rgba(0, 0, 0, .15);
    box-shadow: 0 5px 8px rgba(0, 0, 0, .15)
  }

  .react-dropdown-tree-select .dropdown .dropdown-content .search {
    width: 100%;
    border: none;
    border-bottom: 1px solid #ccc;
    outline: none
  }

  .react-dropdown-tree-select .dropdown .dropdown-content ul {
    margin: 0;
    padding: 0
  }

  /*# sourceMappingURL=styles.css.map*/
  /* */
  &.disabled {
    .dropdown, .search {
      opacity: 0.75;
      background-color: #f0f3f6;
    }
  }
  
  &.react-dropdown-tree-select {
    .dropdown {
      width: 100%;
      position: initial;
    }

    & .dropdown-content {
      position: relative !important;
      max-height: 200px;
      overflow-y: auto;
      margin-top: 4px;
      width: 100%;
      padding: 8px 0 !important;
      box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
      border: 1px solid #e4e5e8;
      border-radius: 4px;

      & .no-matches {
        text-align: center;
        font-size: 14px;
        line-height: 16px;
        display: block;
        padding: 8px 0;
      }

      & .node.leaf {
        padding: 0;

        & i {
          display: none;
        }

        & label {
          width: 100%;
          display: flex;
          align-items: center;
          padding: 8px 16px;
          margin: 0;

          & .node-label {
            color: #000;
            font-size: 14px;
            line-height: normal;
          }

          & input {
            cursor: pointer;
            margin-right: 16px;
          }
        }

        &:hover {
          background-color: #f8f8f8;
        }
      }
    }

    & .dropdown .dropdown-trigger {
      padding: 4px;
      line-height: 20px;
      max-height: 200px;
      display: inline-block;
      overflow: auto;
      border: 1px solid #b9b9b9;
      
      padding: 6px 16px;
      border: 1px solid #e4e5e8;
      border-radius: 4px;
      overflow: initial;
      width: 100%;
      transition: 0.2s ease;

      &:hover,
      &:focus-within {
        border-color: #aaa;
      }

      &.arrow.top::after,
      &.arrow.bottom::after {
        display: none;
      }

      & .tag-list {
        & .tag-item:first-child {
          margin-left: 0;
        }

        & .tag-item {
          & .search {
            border: none;
            font-size: 14px;
            line-height: 16px;
            color: #000;

            &::placeholder {
              color: #929da3;
            }
          }

          & .tag {
            border: 1px solid ${themeValues.primaryColor};
            border-radius: 50px;
            display: flex;
            align-items: center;
            padding: 0 0 0 8px;
            height: 18px;
            cursor: initial;
            background-color: #fff !important;
            color: #000;
            font-weight: 500;
            font-size: ${themeValues.fontSize.normal};
            line-height: 14px;

            & button.tag-remove {
              background-image: url(${closeIcon});
              background-size: 8px;
              background-position: center;
              background-repeat: no-repeat;
              width: 8px;
              height: 100%;
              background-color: transparent;
              border: none;
              cursor: pointer;
              outline: 0;
              padding: 3px 12px 3px 8px;
              transition: transform 0.2s ease;
              color: transparent;

              &:hover {
                transform: rotate(90deg);
              }
            }
          }
        }
      }
    }
  }
`;
StyledTreeSelect.displayName = "StyledTreeSelect";
function ComboBox$1({ id: id2, texts, data: dataProp, onChange: onChangeProp, emptyStateResolver, loading }) {
  const comboBoxInputSelector = `#${id2}_trigger input`;
  function onEmptyStateClose(value) {
    if (!value) {
      return;
    }
    const customAdded = {
      label: value,
      value,
      checked: true
    };
    onChangeProp(true, customAdded, [
      ...dataProp.filter((d) => d.checked),
      customAdded
    ]);
  }
  function onChange4(current, selectedNodes) {
    onChangeProp(false, current, selectedNodes);
  }
  let noMatchesComponent;
  if (emptyStateResolver) {
    if (typeof emptyStateResolver == "boolean") {
      noMatchesComponent = DefaultEmptyState;
    } else {
      noMatchesComponent = emptyStateResolver;
    }
  }
  let noMatches;
  if (noMatchesComponent && emptyStateResolver) {
    const EmptyState2 = EmptyStateHOC(noMatchesComponent);
    noMatches = React.createElement(EmptyState2, { selector: comboBoxInputSelector, onCloseProp: onEmptyStateClose });
  } else {
    noMatches = texts.noMatches;
  }
  return React.createElement(StyledTreeSelect, {
    id: id2,
    data: dataProp,
    texts: {
      placeholder: texts.placeholder,
      noMatches
    },
    onChange: onChange4,
    clearSearchOnChange: true,
    disabled: loading
  });
}
var ComboBox = Object.assign(ComboBox$1, {});
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate2(uuid2) {
  return typeof uuid2 === "string" && REGEX.test(uuid2);
}
var byteToHex = [];
for (i2 = 0; i2 < 256; ++i2) {
  byteToHex.push((i2 + 256).toString(16).substr(1));
}
var i2;
function stringify(arr) {
  var offset3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var uuid2 = (byteToHex[arr[offset3 + 0]] + byteToHex[arr[offset3 + 1]] + byteToHex[arr[offset3 + 2]] + byteToHex[arr[offset3 + 3]] + "-" + byteToHex[arr[offset3 + 4]] + byteToHex[arr[offset3 + 5]] + "-" + byteToHex[arr[offset3 + 6]] + byteToHex[arr[offset3 + 7]] + "-" + byteToHex[arr[offset3 + 8]] + byteToHex[arr[offset3 + 9]] + "-" + byteToHex[arr[offset3 + 10]] + byteToHex[arr[offset3 + 11]] + byteToHex[arr[offset3 + 12]] + byteToHex[arr[offset3 + 13]] + byteToHex[arr[offset3 + 14]] + byteToHex[arr[offset3 + 15]]).toLowerCase();
  if (!validate2(uuid2)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid2;
}
var _nodeId;
var _clockseq;
var _lastMSecs = 0;
var _lastNSecs = 0;
function v1(options, buf, offset3) {
  var i2 = buf && offset3 || 0;
  var b2 = buf || new Array(16);
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq;
  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || rng)();
    if (node == null) {
      node = _nodeId = [seedBytes[0] | 1, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }
    if (clockseq == null) {
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
    }
  }
  var msecs = options.msecs !== void 0 ? options.msecs : Date.now();
  var nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
  if (dt < 0 && options.clockseq === void 0) {
    clockseq = clockseq + 1 & 16383;
  }
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
    nsecs = 0;
  }
  if (nsecs >= 1e4) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;
  msecs += 122192928e5;
  var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
  b2[i2++] = tl >>> 24 & 255;
  b2[i2++] = tl >>> 16 & 255;
  b2[i2++] = tl >>> 8 & 255;
  b2[i2++] = tl & 255;
  var tmh = msecs / 4294967296 * 1e4 & 268435455;
  b2[i2++] = tmh >>> 8 & 255;
  b2[i2++] = tmh & 255;
  b2[i2++] = tmh >>> 24 & 15 | 16;
  b2[i2++] = tmh >>> 16 & 255;
  b2[i2++] = clockseq >>> 8 | 128;
  b2[i2++] = clockseq & 255;
  for (var n3 = 0; n3 < 6; ++n3) {
    b2[i2 + n3] = node[n3];
  }
  return buf || stringify(b2);
}
function parse2(uuid2) {
  if (!validate2(uuid2)) {
    throw TypeError("Invalid UUID");
  }
  var v2;
  var arr = new Uint8Array(16);
  arr[0] = (v2 = parseInt(uuid2.slice(0, 8), 16)) >>> 24;
  arr[1] = v2 >>> 16 & 255;
  arr[2] = v2 >>> 8 & 255;
  arr[3] = v2 & 255;
  arr[4] = (v2 = parseInt(uuid2.slice(9, 13), 16)) >>> 8;
  arr[5] = v2 & 255;
  arr[6] = (v2 = parseInt(uuid2.slice(14, 18), 16)) >>> 8;
  arr[7] = v2 & 255;
  arr[8] = (v2 = parseInt(uuid2.slice(19, 23), 16)) >>> 8;
  arr[9] = v2 & 255;
  arr[10] = (v2 = parseInt(uuid2.slice(24, 36), 16)) / 1099511627776 & 255;
  arr[11] = v2 / 4294967296 & 255;
  arr[12] = v2 >>> 24 & 255;
  arr[13] = v2 >>> 16 & 255;
  arr[14] = v2 >>> 8 & 255;
  arr[15] = v2 & 255;
  return arr;
}
function stringToBytes(str) {
  str = unescape(encodeURIComponent(str));
  var bytes = [];
  for (var i2 = 0; i2 < str.length; ++i2) {
    bytes.push(str.charCodeAt(i2));
  }
  return bytes;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
var URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset3) {
    if (typeof value === "string") {
      value = stringToBytes(value);
    }
    if (typeof namespace === "string") {
      namespace = parse2(namespace);
    }
    if (namespace.length !== 16) {
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    }
    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 15 | version;
    bytes[8] = bytes[8] & 63 | 128;
    if (buf) {
      offset3 = offset3 || 0;
      for (var i2 = 0; i2 < 16; ++i2) {
        buf[offset3 + i2] = bytes[i2];
      }
      return buf;
    }
    return stringify(bytes);
  }
  try {
    generateUUID.name = name;
  } catch (err) {
  }
  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}
function md5(bytes) {
  if (typeof bytes === "string") {
    var msg = unescape(encodeURIComponent(bytes));
    bytes = new Uint8Array(msg.length);
    for (var i2 = 0; i2 < msg.length; ++i2) {
      bytes[i2] = msg.charCodeAt(i2);
    }
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = "0123456789abcdef";
  for (var i2 = 0; i2 < length32; i2 += 8) {
    var x2 = input[i2 >> 5] >>> i2 % 32 & 255;
    var hex2 = parseInt(hexTab.charAt(x2 >>> 4 & 15) + hexTab.charAt(x2 & 15), 16);
    output.push(hex2);
  }
  return output;
}
function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(x2, len) {
  x2[len >> 5] |= 128 << len % 32;
  x2[getOutputLength(len) - 1] = len;
  var a2 = 1732584193;
  var b2 = -271733879;
  var c2 = -1732584194;
  var d = 271733878;
  for (var i2 = 0; i2 < x2.length; i2 += 16) {
    var olda = a2;
    var oldb = b2;
    var oldc = c2;
    var oldd = d;
    a2 = md5ff(a2, b2, c2, d, x2[i2], 7, -680876936);
    d = md5ff(d, a2, b2, c2, x2[i2 + 1], 12, -389564586);
    c2 = md5ff(c2, d, a2, b2, x2[i2 + 2], 17, 606105819);
    b2 = md5ff(b2, c2, d, a2, x2[i2 + 3], 22, -1044525330);
    a2 = md5ff(a2, b2, c2, d, x2[i2 + 4], 7, -176418897);
    d = md5ff(d, a2, b2, c2, x2[i2 + 5], 12, 1200080426);
    c2 = md5ff(c2, d, a2, b2, x2[i2 + 6], 17, -1473231341);
    b2 = md5ff(b2, c2, d, a2, x2[i2 + 7], 22, -45705983);
    a2 = md5ff(a2, b2, c2, d, x2[i2 + 8], 7, 1770035416);
    d = md5ff(d, a2, b2, c2, x2[i2 + 9], 12, -1958414417);
    c2 = md5ff(c2, d, a2, b2, x2[i2 + 10], 17, -42063);
    b2 = md5ff(b2, c2, d, a2, x2[i2 + 11], 22, -1990404162);
    a2 = md5ff(a2, b2, c2, d, x2[i2 + 12], 7, 1804603682);
    d = md5ff(d, a2, b2, c2, x2[i2 + 13], 12, -40341101);
    c2 = md5ff(c2, d, a2, b2, x2[i2 + 14], 17, -1502002290);
    b2 = md5ff(b2, c2, d, a2, x2[i2 + 15], 22, 1236535329);
    a2 = md5gg(a2, b2, c2, d, x2[i2 + 1], 5, -165796510);
    d = md5gg(d, a2, b2, c2, x2[i2 + 6], 9, -1069501632);
    c2 = md5gg(c2, d, a2, b2, x2[i2 + 11], 14, 643717713);
    b2 = md5gg(b2, c2, d, a2, x2[i2], 20, -373897302);
    a2 = md5gg(a2, b2, c2, d, x2[i2 + 5], 5, -701558691);
    d = md5gg(d, a2, b2, c2, x2[i2 + 10], 9, 38016083);
    c2 = md5gg(c2, d, a2, b2, x2[i2 + 15], 14, -660478335);
    b2 = md5gg(b2, c2, d, a2, x2[i2 + 4], 20, -405537848);
    a2 = md5gg(a2, b2, c2, d, x2[i2 + 9], 5, 568446438);
    d = md5gg(d, a2, b2, c2, x2[i2 + 14], 9, -1019803690);
    c2 = md5gg(c2, d, a2, b2, x2[i2 + 3], 14, -187363961);
    b2 = md5gg(b2, c2, d, a2, x2[i2 + 8], 20, 1163531501);
    a2 = md5gg(a2, b2, c2, d, x2[i2 + 13], 5, -1444681467);
    d = md5gg(d, a2, b2, c2, x2[i2 + 2], 9, -51403784);
    c2 = md5gg(c2, d, a2, b2, x2[i2 + 7], 14, 1735328473);
    b2 = md5gg(b2, c2, d, a2, x2[i2 + 12], 20, -1926607734);
    a2 = md5hh(a2, b2, c2, d, x2[i2 + 5], 4, -378558);
    d = md5hh(d, a2, b2, c2, x2[i2 + 8], 11, -2022574463);
    c2 = md5hh(c2, d, a2, b2, x2[i2 + 11], 16, 1839030562);
    b2 = md5hh(b2, c2, d, a2, x2[i2 + 14], 23, -35309556);
    a2 = md5hh(a2, b2, c2, d, x2[i2 + 1], 4, -1530992060);
    d = md5hh(d, a2, b2, c2, x2[i2 + 4], 11, 1272893353);
    c2 = md5hh(c2, d, a2, b2, x2[i2 + 7], 16, -155497632);
    b2 = md5hh(b2, c2, d, a2, x2[i2 + 10], 23, -1094730640);
    a2 = md5hh(a2, b2, c2, d, x2[i2 + 13], 4, 681279174);
    d = md5hh(d, a2, b2, c2, x2[i2], 11, -358537222);
    c2 = md5hh(c2, d, a2, b2, x2[i2 + 3], 16, -722521979);
    b2 = md5hh(b2, c2, d, a2, x2[i2 + 6], 23, 76029189);
    a2 = md5hh(a2, b2, c2, d, x2[i2 + 9], 4, -640364487);
    d = md5hh(d, a2, b2, c2, x2[i2 + 12], 11, -421815835);
    c2 = md5hh(c2, d, a2, b2, x2[i2 + 15], 16, 530742520);
    b2 = md5hh(b2, c2, d, a2, x2[i2 + 2], 23, -995338651);
    a2 = md5ii(a2, b2, c2, d, x2[i2], 6, -198630844);
    d = md5ii(d, a2, b2, c2, x2[i2 + 7], 10, 1126891415);
    c2 = md5ii(c2, d, a2, b2, x2[i2 + 14], 15, -1416354905);
    b2 = md5ii(b2, c2, d, a2, x2[i2 + 5], 21, -57434055);
    a2 = md5ii(a2, b2, c2, d, x2[i2 + 12], 6, 1700485571);
    d = md5ii(d, a2, b2, c2, x2[i2 + 3], 10, -1894986606);
    c2 = md5ii(c2, d, a2, b2, x2[i2 + 10], 15, -1051523);
    b2 = md5ii(b2, c2, d, a2, x2[i2 + 1], 21, -2054922799);
    a2 = md5ii(a2, b2, c2, d, x2[i2 + 8], 6, 1873313359);
    d = md5ii(d, a2, b2, c2, x2[i2 + 15], 10, -30611744);
    c2 = md5ii(c2, d, a2, b2, x2[i2 + 6], 15, -1560198380);
    b2 = md5ii(b2, c2, d, a2, x2[i2 + 13], 21, 1309151649);
    a2 = md5ii(a2, b2, c2, d, x2[i2 + 4], 6, -145523070);
    d = md5ii(d, a2, b2, c2, x2[i2 + 11], 10, -1120210379);
    c2 = md5ii(c2, d, a2, b2, x2[i2 + 2], 15, 718787259);
    b2 = md5ii(b2, c2, d, a2, x2[i2 + 9], 21, -343485551);
    a2 = safeAdd(a2, olda);
    b2 = safeAdd(b2, oldb);
    c2 = safeAdd(c2, oldc);
    d = safeAdd(d, oldd);
  }
  return [a2, b2, c2, d];
}
function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }
  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));
  for (var i2 = 0; i2 < length8; i2 += 8) {
    output[i2 >> 5] |= (input[i2 / 8] & 255) << i2 % 32;
  }
  return output;
}
function safeAdd(x2, y2) {
  var lsw = (x2 & 65535) + (y2 & 65535);
  var msw = (x2 >> 16) + (y2 >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 65535;
}
function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
function md5cmn(q2, a2, b2, x2, s2, t3) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a2, q2), safeAdd(x2, t3)), s2), b2);
}
function md5ff(a2, b2, c2, d, x2, s2, t3) {
  return md5cmn(b2 & c2 | ~b2 & d, a2, b2, x2, s2, t3);
}
function md5gg(a2, b2, c2, d, x2, s2, t3) {
  return md5cmn(b2 & d | c2 & ~d, a2, b2, x2, s2, t3);
}
function md5hh(a2, b2, c2, d, x2, s2, t3) {
  return md5cmn(b2 ^ c2 ^ d, a2, b2, x2, s2, t3);
}
function md5ii(a2, b2, c2, d, x2, s2, t3) {
  return md5cmn(c2 ^ (b2 | ~d), a2, b2, x2, s2, t3);
}
v35("v3", 48, md5);
function f2(s2, x2, y2, z2) {
  switch (s2) {
    case 0:
      return x2 & y2 ^ ~x2 & z2;
    case 1:
      return x2 ^ y2 ^ z2;
    case 2:
      return x2 & y2 ^ x2 & z2 ^ y2 & z2;
    case 3:
      return x2 ^ y2 ^ z2;
  }
}
function ROTL(x2, n3) {
  return x2 << n3 | x2 >>> 32 - n3;
}
function sha1(bytes) {
  var K2 = [1518500249, 1859775393, 2400959708, 3395469782];
  var H2 = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof bytes === "string") {
    var msg = unescape(encodeURIComponent(bytes));
    bytes = [];
    for (var i2 = 0; i2 < msg.length; ++i2) {
      bytes.push(msg.charCodeAt(i2));
    }
  } else if (!Array.isArray(bytes)) {
    bytes = Array.prototype.slice.call(bytes);
  }
  bytes.push(128);
  var l2 = bytes.length / 4 + 2;
  var N = Math.ceil(l2 / 16);
  var M2 = new Array(N);
  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);
    for (var j2 = 0; j2 < 16; ++j2) {
      arr[j2] = bytes[_i * 64 + j2 * 4] << 24 | bytes[_i * 64 + j2 * 4 + 1] << 16 | bytes[_i * 64 + j2 * 4 + 2] << 8 | bytes[_i * 64 + j2 * 4 + 3];
    }
    M2[_i] = arr;
  }
  M2[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M2[N - 1][14] = Math.floor(M2[N - 1][14]);
  M2[N - 1][15] = (bytes.length - 1) * 8 & 4294967295;
  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W2 = new Uint32Array(80);
    for (var t3 = 0; t3 < 16; ++t3) {
      W2[t3] = M2[_i2][t3];
    }
    for (var _t = 16; _t < 80; ++_t) {
      W2[_t] = ROTL(W2[_t - 3] ^ W2[_t - 8] ^ W2[_t - 14] ^ W2[_t - 16], 1);
    }
    var a2 = H2[0];
    var b2 = H2[1];
    var c2 = H2[2];
    var d = H2[3];
    var e3 = H2[4];
    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s2 = Math.floor(_t2 / 20);
      var T2 = ROTL(a2, 5) + f2(s2, b2, c2, d) + e3 + K2[s2] + W2[_t2] >>> 0;
      e3 = d;
      d = c2;
      c2 = ROTL(b2, 30) >>> 0;
      b2 = a2;
      a2 = T2;
    }
    H2[0] = H2[0] + a2 >>> 0;
    H2[1] = H2[1] + b2 >>> 0;
    H2[2] = H2[2] + c2 >>> 0;
    H2[3] = H2[3] + d >>> 0;
    H2[4] = H2[4] + e3 >>> 0;
  }
  return [H2[0] >> 24 & 255, H2[0] >> 16 & 255, H2[0] >> 8 & 255, H2[0] & 255, H2[1] >> 24 & 255, H2[1] >> 16 & 255, H2[1] >> 8 & 255, H2[1] & 255, H2[2] >> 24 & 255, H2[2] >> 16 & 255, H2[2] >> 8 & 255, H2[2] & 255, H2[3] >> 24 & 255, H2[3] >> 16 & 255, H2[3] >> 8 & 255, H2[3] & 255, H2[4] >> 24 & 255, H2[4] >> 16 & 255, H2[4] >> 8 & 255, H2[4] & 255];
}
v35("v5", 80, sha1);
function safeID(idPrefix) {
  const staticUuid = v1();
  return (idSuffix) => {
    const prefix = `${idPrefix}${idPrefix !== "" ? "_" : "i"}`;
    const suffix = idSuffix ? `_${idSuffix}` : "";
    return `${prefix}${suffix ? staticUuid : v1()}${suffix}`;
  };
}
var FormControlContext = createContext2({
  id: "",
  disabled: false
});
function FormControl$1({ id: idProp, full, children, disabled }) {
  const id2 = idProp || safeID("form_control")("");
  return React.createElement(
    FormControlContext.Provider,
    { value: { id: id2, disabled } },
    React.createElement(StyledFormControl, { className: cn({
      "fullwidth": full,
      "disabled": disabled
    }) }, children)
  );
}
var StyledFormControlLabel = styled_components_esm_default.label`
  cursor: pointer;
  display: flex;
  align-self: flex-start;
  color: #000;
  margin-bottom: 8px;

  &.spacing-default {
    gap: 5px;
  }

  &.spacing-small {
    gap: 2px;
  }

  &.spacing-medium {
    gap: 10px;
  }

  &.spacing-large {
    gap: 15px;
  }

  &.append {
    width: 100%;
    align-items: center;
  }
`;
StyledFormControlLabel.displayName = "StyledFormControlLabel";
var StyledFormControl = styled_components_esm_default.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
  max-width: 400px;

  &.fullwidth {
    max-width: 100%;
  }

  &.disabled {
    ${StyledFormControlLabel} {
      color: ${themeValues.disabledColor}
    }
    
    pointer-events: none;
  }
`;
StyledFormControl.displayName = "StyledFormControl";
var StyledAppendLabelWrapper = styled_components_esm_default.div`
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${StyledFormControlLabel} {
    margin-bottom: 0;
  }
`;
StyledAppendLabelWrapper.displayName = "StyledAppendLabelWrapper";
function FormControlLabel({ for: forProp, text, children, spacing: spacingProp, append }) {
  const formControl = useContext2(FormControlContext);
  const htmlFor = forProp || (formControl === null || formControl === void 0 ? void 0 : formControl.id);
  let spacing = "";
  if (spacingProp) {
    spacing = typeof spacingProp === "boolean" ? "default" : spacingProp;
  }
  const label = React.createElement(StyledFormControlLabel, { htmlFor, className: cn({
    [`spacing-${spacing}`]: spacing,
    "append": append
  }) }, text || children);
  if (!append) {
    return label;
  }
  return React.createElement(
    StyledAppendLabelWrapper,
    null,
    React.createElement("div", null, label),
    React.createElement("div", null, append)
  );
}
var StyledFormControlGroup = styled_components_esm_default.div`
  &.inline {
    display: flex;

    ${StyledFormControl} {
      margin-bottom: 0;
    }

    &.inline-default {
      gap: 20px;
    }

    &.inline-small {
      gap: 16px;
    }

    &.inline-medium {
      gap: 25px;
    }

    &.inline-large {
      gap: 35px;
    }
  }

  ${StyledFormControl} {
    flex-direction: initial;
    align-items: center;
  }

  ${StyledFormControlLabel} {
    align-items: center;
  }
`;
StyledFormControlGroup.displayName = "StyledFormControlGroup";
function FormControlGroup({ inline: inlineProp, children }) {
  let inline = "";
  if (inlineProp) {
    inline = typeof inlineProp === "boolean" ? "default" : inlineProp;
  }
  return React.createElement(StyledFormControlGroup, { className: cn({
    "inline": inline,
    [`inline-${inline}`]: inline
  }) }, children);
}
var RadioGroupContext = createContext2(null);
var StyledRadioGroup = styled_components_esm_default(StyledFormControlGroup)`
  ${StyledFormControlLabel} {
    margin-bottom: 0;
  }

  ${StyledFormControl} {
    margin-bottom: 10px;
  }

  &.inline {
    display: flex;

    &.inline-default {
      gap: 8px;
    }

    &.inline-small {
      gap: 5px;
    }

    &.inline-medium {
      gap: 10px;
    }

    &.inline-large {
      gap: 15px;
    }
  }
`;
StyledRadioGroup.displayName = "StyledRadioGroup";
var StyledRadio = styled_components_esm_default.input`
  cursor: pointer;
  font-size: ${themeValues.fontSize.normal};
  margin-right: 5px;
`;
StyledRadio.displayName = "StyledRadio";
var SelectWrapper = styled_components_esm_default.div`
  position: relative;
  display: inline-block;

  &.fullWidth {
    width: 100%;
  }
`;
var Wrapper$2 = styled_components_esm_default.div`
  position: relative;
  width: 100%;
  
  .input-label {
    font-size: ${themeValues.fontSize.normal};
    color: ${themeValues.colors.dark100};    
    line-height: 18px;
    margin-bottom: 4px;
    display: block;
  }
  .input-error, .input-description {
    font-size: ${themeValues.fontSize.small};
    line-height: 18px;
    display: block;
    margin-top: 4px;
  }
  .input-description {
    color: ${themeValues.colors.dark64};
  }
  .input-error {
    color: ${themeValues.colors.red100};
  }
  &.disabled {
    .input-label, .input-description {
      color: ${themeValues.colors.dark48};
    }
    i {
        color: ${themeValues.colors.dark48};
      }
  }

  .input-wrapper {
      i {
        position: absolute;
      }
    }

  &.large {
    .input-wrapper {
      i {
        top: 13px;
        left: 14px;
      }
      .chevron {
        left: auto;
        right: 12px;
        top: 17px;
      }
    }
  }
  &.medium {
    .input-wrapper {
      i {
        top: 11px;
        left: 11px;
      }
      .chevron {
        left: auto;
        right: 12px;
        top: 15px;
      }
    }
  }
  &.small {
    .input-wrapper {
      i {
        top: 8px;
        left: 11px;
      }
      .chevron {
        left: auto;
        right: 12px;
        top: 11px;
      }
    }
  }
`;
Wrapper$2.displayName = "SelectWrapper";
var SelectComponent = styled_components_esm_default.select`
  height: 40px;
  line-height: normal;
  padding: 4px 48px 4px 8px;
  transition: 0.2s;

  border: 1px solid ${themeValues.colors.dark16};
  font-size: ${themeValues.fontSize.normal};
  color: ${themeValues.colors.dark100};
  appearance:none;


  ${mixins.rounded};

  &.error {
    border-color: ${themeValues.colors.red100};
  }

  &::placeholder {
    color:  ${themeValues.colors.dark64};
  }

  &.small {
    height: ${themeValues.inputSize.small};
    line-height: normal;

    &::placeholder {
      font-size: ${themeValues.fontSize.small};
    }
  }

  &.medium, &.large {
    font-size: ${themeValues.fontSize.large};
    &::placeholder {
      font-size: ${themeValues.fontSize.large};
    }
  }

  &.small {
    &.icon {
      padding-left: 32px;
    }
  }

  &.medium {
    height: ${themeValues.inputSize.medium};

    &.icon {
      padding-left: 32px;
    }
  }
  
  &.large {
    height: ${themeValues.inputSize.large};

    &.icon {
      padding-left: 42px;
    }
  }

  &.fullWidth {
    width: 100%;
  }

  &[disabled] {
    background-color: ${themeValues.colors.dark8};
    color: ${themeValues.colors.dark48};
    &::placeholder {
      color: ${themeValues.colors.dark48};
    }
  }

  &:not([disabled]) {
    &:hover,
    &:focus,
    &:active,
    &.hover {
      &:not(.error) {
        border-color: ${themeValues.colors.blue100};
      }
      outline: none;
    }
  }
`;
SelectComponent.displayName = "Select";
function Select$1({ value, type: type2 = "text", label, error, id: id2, name, description, placeholder, onChange: onChange4, required: required2, disabled, fullWidth, size = "medium", autoFocus, inputClassName, icon, items }) {
  const iconSize = size == "small" ? "xsmall" : size == "medium" ? "small" : "medium";
  const chevronSize = size == "small" ? 6 : size == "medium" ? 7 : 8;
  return React.createElement(
    Wrapper$2,
    { className: cn(size, { "disabled": disabled }) },
    label && React.createElement("label", { className: "input-label", htmlFor: id2 || name }, label),
    React.createElement(
      SelectWrapper,
      { className: cn("input-wrapper", { fullWidth }) },
      React.createElement(Icon$2, { size: iconSize, glyph: icon }),
      React.createElement(SelectComponent, {
        id: id2,
        name,
        value,
        type: type2,
        onChange: onChange4,
        required: required2,
        placeholder,
        disabled,
        autoFocus,
        className: cn(size, inputClassName, {
          "fullWidth": fullWidth,
          "error": !!error,
          "icon": !!icon
        })
      }, items && items.map(({ value: value2, name: name2 }) => React.createElement("option", { value: value2 }, name2))),
      React.createElement(Icon$2, { className: "chevron", size: chevronSize, glyph: "icon-chevron-down" })
    ),
    error && React.createElement("span", { className: "input-error" }, error),
    description && React.createElement("span", { className: "input-description" }, description)
  );
}
var Select = Object.assign(Select$1, {});
var Handler = styled_components_esm_default.div`
  background-color: ${themeValues.colors.white};
  border-radius: 100%;
  transition: all 0.2s ease-in-out;
`;
var SwitchComponent = styled_components_esm_default.button`
  border-radius: 50px;
  cursor: pointer;
  width: 100%;
  background-color: ${themeValues.colors.dark32};
  border: 0;
  transition: 0.2s;
  padding: 2px 2px;
  display: flex;

  &.small {
    height: 16px;
    width: 29px;

    ${Handler} {
      width: 12px;
      height: 12px;
    }
  }

  &.medium {
    height: 20px;
    width: 39px;

    ${Handler} {
      width: 16px;
      height: 16px;
    }
  }

  &[disabled] {
    cursor: not-allowed;
  }

  &.checked {
    &:not([disabled]) {
      background-color: ${themeValues.colors.blue100};
    }
    ${Handler} {
        margin-left: auto;
      }
  }

`;
function Switch$1({ id: id2, disabled, defaultChecked, checked, onChange: onChange4, size = "medium" }) {
  return React.createElement(
    SwitchComponent,
    {
      className: cn(size, disabled, { "checked": checked }),
      id: id2,
      defaultChecked,
      onChange: onChange4,
      disabled
    },
    React.createElement(Handler, null)
  );
}
var Switch = Object.assign(Switch$1, {});
var InputWrapper = styled_components_esm_default.div`
  position: relative;

  &.large {
      i {
        position: absolute;
        top: 13px;
        left: 11px;
      }
    }
`;
var Wrapper$1 = styled_components_esm_default.div`
  position: relative;
  width: 100%;
  
  .input-label {
    font-size: ${themeValues.fontSize.normal};
    color: ${themeValues.colors.dark100};    
    line-height: 18px;
    margin-bottom: 4px;
    display: block;

    .input-optional {
      font-size: ${themeValues.fontSize.small};
      color: ${themeValues.colors.dark64};
      display: inline-block;
      margin-left: 8px;
      line-height: normal;
    }
  }
  .input-error, .input-description {
    font-size: ${themeValues.fontSize.small};
    line-height: 18px;
    display: block;
    margin-top: 4px;
  }
  .input-description {
    color: ${themeValues.colors.dark64};
  }
  .input-error {
    color: ${themeValues.colors.red100};
  }
  &.disabled {
    .input-label, .input-description {
      color: ${themeValues.colors.dark48};
    }
  }

  .input-wrapper {
      i {
        position: absolute;
      }
    }
  &.large {
    .input-wrapper {
      i {
        top: 13px;
        left: 14px;
      }
    }
  }
  &.medium {
    .input-wrapper {
      i {
        top: 11px;
        left: 11px;
      }
    }
  }
  &.small {
    .input-wrapper {
      i {
        top: 8px;
        left: 11px;
      }
    }
  }
`;
Wrapper$1.displayName = "InputWrapper";
var Input2 = styled_components_esm_default.input`
  height: 40px;
  line-height: normal;
  padding: 4px 0.75rem;
  transition: 0.2s;

  border: 1px solid ${themeValues.colors.dark16};
  font-size: ${themeValues.fontSize.normal};
  color: ${themeValues.colors.dark100};


  ${mixins.rounded};

  &.error {
    border-color: ${themeValues.colors.red100};
  }

  &::placeholder {
    color:  ${themeValues.colors.dark64};
  }

  &.small {
    height: ${themeValues.inputSize.small};
    line-height: normal;

    &::placeholder {
      font-size: ${themeValues.fontSize.small};
    }
  }

  &.medium, &.large {
    font-size: ${themeValues.fontSize.large};
    &::placeholder {
      font-size: ${themeValues.fontSize.large};
    }
  }

  &.small {
    &.icon {
      padding-left: 32px;
    }
  }

  &.medium {
    height: ${themeValues.inputSize.medium};

    &.icon {
      padding-left: 32px;
    }
  }
  
  &.large {
    height: ${themeValues.inputSize.large};

    &.icon {
      padding-left: 42px;
    }
  }

  &.fullwidth {
    width: 100%;
  }

  &[disabled] {
    background-color: ${themeValues.colors.dark8};
    color: ${themeValues.colors.dark48};
    &::placeholder {
      color: ${themeValues.colors.dark48};
    }
  }

  &:not([disabled]) {
    &:hover,
    &:focus,
    &:active,
    &.hover {
      &:not(.error) {
        border-color: ${themeValues.colors.blue100};
      }
      outline: none;
    }
  }
`;
Input2.displayName = "Input";
function TextInput$1({ value, type: type2 = "text", label, error, id: id2, name, description, placeholder, onChange: onChange4, required: required2, disabled, fullWidth, size = "medium", autoFocus, inputClassName, icon, iconAlign, optional }) {
  const iconSize = size == "small" ? "xsmall" : size == "medium" ? "small" : "medium";
  return React.createElement(
    Wrapper$1,
    { className: cn(size, { "disabled": disabled }) },
    label && React.createElement(
      "label",
      { className: "input-label", htmlFor: id2 || name },
      label,
      optional && React.createElement("span", { className: "input-optional" }, "Optional")
    ),
    React.createElement(
      InputWrapper,
      { className: "input-wrapper" },
      React.createElement(Icon$2, { size: iconSize, glyph: icon }),
      React.createElement(Input2, { id: id2, name, value, type: type2, onChange: onChange4, required: required2, placeholder, disabled, autoFocus, className: cn(size, inputClassName, {
        "fullwidth": fullWidth,
        "error": !!error,
        "icon": !!icon
      }) })
    ),
    error && React.createElement("span", { className: "input-error" }, error),
    description && React.createElement("span", { className: "input-description" }, description)
  );
}
var TextInput = Object.assign(TextInput$1, {});
var FormControl = Object.assign(FormControl$1, {
  Label: FormControlLabel,
  Group: FormControlGroup
});
var Icon = Object.assign(Icon$2, {});
var StyledLearnMore = styled_components_esm_default.a`
  color: ${themeValues.primaryColor};
  font-weight: 500;
  align-items: center;
  display: flex;
  font-size: ${themeValues.fontSize.small};
  line-height: 13px;

  &.disabled {
    color: ${themeValues.ghostColor};

    & svg path {
      stroke: ${themeValues.ghostColor};
    }
  }

  &:hover {
    text-decoration: underline;
    color: ${themeValues.primaryColor};

    .disabled {
      color: ${themeValues.ghostColor};
    }
  }

  & svg {
    margin-right: 6px;
  }
`;
StyledLearnMore.displayName = "StyledLearnMore";
function LearnMore$1({ href, title, disabled }) {
  return React.createElement(
    StyledLearnMore,
    { href, target: "_blank", rel: "noopener noreferrer", className: cn({
      "disabled": disabled
    }) },
    React.createElement(Icon, { glyph: "learnMore" }),
    title || "Learn more"
  );
}
var LearnMore = Object.assign(LearnMore$1, {});
var Page$1 = styled_components_esm_default.div``;
Page$1.displayName = "Page";
function PageBody() {
}
var PageHeader = styled_components_esm_default.div`
  border-bottom: 1px solid ${themeValues.borderColor};
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  font-size: 20px; // TODO: use themValues
  line-height: 32px;
  min-height: 52px;
  font-weight: 500;
  margin-bottom: 32px;

  .sub {
    color: ${themeValues.ghostColor};
    margin-left: 16px;
    font-weight: 500;
  }

  i {
    margin-right: 16px;
    color: ${themeValues.ghostColor};
  }
`;
PageHeader.displayName = "PageHeader";
function PageHeaderSection({ icon, title, children }) {
  return React.createElement(
    React.Fragment,
    null,
    icon ? React.createElement("i", { className: icon }) : null,
    " ",
    children || title
  );
}
var PageContent = styled_components_esm_default.div`
  font-size: ${themeValues.fontSize.large};
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  display: flex;

  h3 {
    font-weight: 500;
    margin: 1rem 0;
  }
`;
PageContent.displayName = "PageContent";
var StyledCTA = styled_components_esm_default.div`
  margin-left: auto;
`;
StyledCTA.displayName = "StyledCTA";
var StyledPageContentHeader = styled_components_esm_default.div`
  &.flex {
    display: flex;
    align-items: center;
    width: 100%;
  }

  ${StyledLearnMore} {
    margin-left: 10px;
  }
`;
StyledPageContentHeader.displayName = "StyledPageContentHeader";
function PageContentHeader({ children, title, learnMore, cta }) {
  const flex = !!(learnMore || cta);
  return React.createElement(
    StyledPageContentHeader,
    { className: cn({
      "flex": flex
    }) },
    React.createElement("span", null, children || title),
    learnMore ? React.createElement(LearnMore, { href: learnMore }) : null,
    cta ? React.createElement(StyledCTA, null, cta) : null
  );
}
var Page = Object.assign(Page$1, {
  Body: PageBody,
  Header: PageHeader,
  HeaderSection: PageHeaderSection,
  Content: PageContent,
  ContentHeader: PageContentHeader
});
function Link$1({ href, target: targetProp, external, onClick, children }) {
  let target = targetProp;
  let rel = "";
  if (external) {
    target = "_blank";
  }
  if (target == "_blank") {
    rel = "noreferrer";
  }
  return React.createElement("a", { onClick, href, target, rel }, children);
}
var Link2 = Object.assign(Link$1, {});
var lsLogo = "data:image/svg+xml;base64,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";
var Logo = styled_components_esm_default.img`
  max-width: 60px;
  margin-bottom: 32px;
  border-radius: 4px;
`;
var Container = styled_components_esm_default.div`
  display: flex;
  align-items: center;
  padding-top: 25vh;
  height: 85vh;
  transition: 0.4s;
  flex-direction: column;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 123456789;
  background-color: #fff;
`;
var Loading = styled_components_esm_default.div`
  height: 4px;
  width: 182px;
  background-color: #dbe1e2;
  overflow: hidden;
  position: relative;

  @keyframes initial-loading {
    0% {
      transform: translate(-24px);
    }

    50% {
      transform: translate(158px);
    }

    to {
      transform: translate(-24px);
    }
  }

  div {
    height: 100%;
    width: 48px;
    position: absolute;
    transform: translate(-x);
    background-color: #0446ca;
    border-radius: 2px;
    animation: initial-loading 1.5s ease infinite;
  }
`;
function Loader$1() {
  return null;
}
function SplashLoader() {
  return React__default.createElement(
    Container,
    null,
    React__default.createElement(Logo, { src: lsLogo }),
    React__default.createElement(
      Loading,
      null,
      React__default.createElement("div", null)
    )
  );
}
SplashLoader.displayName = "SplashLoader";
var Loader = Object.assign(Loader$1, {
  Splash: SplashLoader
});
var StyledModalShade = styled_components_esm_default.div`
  position: fixed;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  min-width: 100%;
  height: 100vh;
  background-color: ${themeValues.modalShadeColor};
  transition: 0.2s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  overflow-y: auto;
`;
StyledModalShade.displayName = "StyledModalShade";
var StyledModalFrame = styled_components_esm_default.div`
  ${mixins.rounded};
  ${mixins.boxShadow};

  background-color: white;
  font-size: 13px;
  overflow: hidden;
  width: 100%;

  &.width-small {
    max-width: 455px;
  }

  &.width-medium {
    max-width: 600px;
  }

  &.width-large {
    max-width: 850px;
  }

  &.width-xlarge {
    max-width: 1000px;
  }

  &.font-size-default {
    font-size: 13px;
  }

  &.font-size-upper {
    font-size: 14px;
  }

  margin-top: 5vh;
  animation: 0.3s ease-in-out 0s 1 slideInScale;
  margin-bottom: 24px;

  &.with-border {
    position: relative;

    &::after {
      position: absolute;
      content: "";
      bottom: 0;
      left: 0;
      width: 100%;
      height: 24px;
      background-color: #fff;
      z-index: 5;
    }
  }
`;
StyledModalFrame.displayName = "StyledModalFrame";
var StyledModalBody = styled_components_esm_default.div`
  max-height: 80vh;
  padding: 1.5rem 1.5rem 0;
  overflow-y: auto;
`;
StyledModalBody.displayName = "StyledModalBody";
var StyledModalHeader = styled_components_esm_default.div`
  position: relative;
`;
StyledModalHeader.displayName = "StyledModalHeader";
var StyledModalClose = styled_components_esm_default.i`
  margin-left: auto;
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
`;
StyledModalClose.displayName = "StyledModalClose";
var StyledModalTitle = styled_components_esm_default.div`
  font-size: 16px; // TODO: use from mixins
  font-weight: 500;
  display: flex;
  align-items: center;
  color: ${themeValues.darkColor};
  background-color: white;
  padding: 1rem 1.5rem;
`;
StyledModalTitle.displayName = "StyledModalTitle";
var StyledModalFooter = styled_components_esm_default.div`
  padding: 24px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: end;
  justify-content: flex-end;
  
  & button:first-child {
    margin-right: 8px;
  }
`;
StyledModalFooter.displayName = "StyledModalFooter";
var StyledModalInfo = styled_components_esm_default.div`
  &.success {
    background-color: #78ffca;
    color: #222;
  }

  &.warn {
    background-color: #ffe478;
    color: #222;
  }

  padding: 0.75rem 1.5rem;
  position: relative;
  top: -1px;
  font-size: 0.85rem;
`;
StyledModalInfo.displayName = "StyledModalInfo";
var ModalContext = createContext2({
  onClose: () => null
});
function ModalClose() {
  const useModal = useContext2(ModalContext);
  return React.createElement(StyledModalClose, { className: "ion-close", onClick: useModal.onClose });
}
function Modal$1({ title, visible, onClose: onClose2, children, size = "large", fontSize = "default" }) {
  const escFunction = (event) => {
    if (event.keyCode === 27) {
      onClose2();
    }
  };
  useEffect2(() => {
    document.addEventListener("keydown", escFunction);
    return function cleanup2() {
      document.removeEventListener("keydown", escFunction);
    };
  }, []);
  return React.createElement(React.Fragment, null, visible ? React.createElement(
    ModalContext.Provider,
    { value: { onClose: onClose2 } },
    React.createElement(
      StyledModalShade,
      null,
      React.createElement(
        StyledModalFrame,
        { className: cn({
          [`width-${size}`]: size,
          [`font-size-${fontSize}`]: fontSize
        }) },
        title ? React.createElement(
          StyledModalHeader,
          null,
          React.createElement(
            StyledModalTitle,
            null,
            title,
            React.createElement(ModalClose, null)
          )
        ) : null,
        children
      )
    )
  ) : null);
}
function ModalHeader({ children }) {
  return React.createElement(
    React.Fragment,
    null,
    React.createElement(
      StyledModalHeader,
      null,
      React.createElement(
        StyledModalTitle,
        null,
        children,
        React.createElement(ModalClose, null)
      )
    )
  );
}
function ModalBody({ children }) {
  return React.createElement(
    React.Fragment,
    null,
    React.createElement(
      StyledModalBody,
      null,
      React.createElement("div", null, children)
    )
  );
}
function ModalFooter({ children }) {
  return React.createElement(
    React.Fragment,
    null,
    React.createElement(StyledModalFooter, null, children)
  );
}
var Modal = Object.assign(Modal$1, {
  Header: ModalHeader,
  Body: ModalBody,
  Footer: ModalFooter
});
function Cancel({ onClick, title }) {
  return React.createElement(Button$2, { size: "small", theme: "ghost", kind: "secondary", onClick }, title);
}
function ModalConfirmFooter({ onConfirm, onCancel, confirmButtonText, cancelButtonText, inverseOrder, buttonColor, buttonDisabled, leftBtn, rightBtn }) {
  const LeftBtnComponent = leftBtn || Cancel;
  const RightBtnComponent = rightBtn || Button$2;
  const LeftBtn = (_a) => {
    var props = __rest$N(_a, []);
    return React.createElement(LeftBtnComponent, Object.assign({}, props, { title: cancelButtonText, onClick: onCancel, theme: "outline" }));
  };
  const RightBtn = (_a) => {
    var props = __rest$N(_a, []);
    return React.createElement(RightBtnComponent, Object.assign({}, props, { size: "small", kind: buttonColor, onClick: onConfirm, disabled: buttonDisabled }), confirmButtonText);
  };
  let left;
  let right;
  if (inverseOrder) {
    const copiedLeft = React.createElement(LeftBtn, null);
    left = React.createElement(RightBtn, null);
    right = copiedLeft;
  } else {
    left = React.createElement(LeftBtn, null);
    right = React.createElement(RightBtn, null);
  }
  return React.createElement(
    Modal.Footer,
    null,
    left,
    right
  );
}
function ModalConfirm$1({ children, title, visible, cancelButtonText, confirmButtonText, buttonColor, buttonDisabled, size = "small", fontSize, onConfirm, onCancel, rightBtn, leftBtn }) {
  return React.createElement(
    React.Fragment,
    null,
    React.createElement(
      Modal,
      { title, visible, onClose: onCancel, size, fontSize },
      React.createElement(Modal.Body, null, children),
      React.createElement(ModalConfirmFooter, { cancelButtonText, confirmButtonText, buttonColor, buttonDisabled, onConfirm, onCancel, rightBtn, leftBtn })
    )
  );
}
var ModalConfirm = Object.assign(ModalConfirm$1, {
  Footer: ModalConfirmFooter
});
var Wrapper = styled_components_esm_default.div`
    width: 100%;
    box-sizing: border-box;
    padding: ${(props) => props.padding}px;

    align-items: center;
    display: flex;

    @-webkit-keyframes placeload {
        0% {
            background-position: -468px 0;
        }
        100% {
            background-position: 468px 0;
        }
    }

    @keyframes placeload {
        0% {
            background-position: -468px 0;
        }
        100% {
            background-position: 468px 0;
        }
    }
`;
Wrapper.displayName = "PlaceholderWrapper";
var Content2 = styled_components_esm_default.div`
    ${mixins.rounded};
    background-color: ${(props) => props.color};
    height: ${(props) => props.height}px;
    width: 100%;
    min-width: ${({ minWidth }) => minWidth}px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeload;
    animation-timing-function: linear;
    ${(props) => props.theme.style === "dark" && props.useDarkMode ? "background: -webkit-linear-gradient(left, #111 8%, #222 18%, #111 33%);" : "background: -webkit-linear-gradient(left, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);"};
    -webkit-background-size: 800px 104px;
    background-size: 1200px 104px;
    position: relative;
`;
Content2.displayName = "PlaceholderContent";
var Placeholder$1 = ({ height = 12, padding = 3, color = "rgba(0,0,0, 0.05)", minWidth = 100, style: style2, contentStyle, useDarkMode = false }) => React.createElement(
  Wrapper,
  { padding, style: style2 },
  React.createElement(Content2, { style: contentStyle, color, height, minWidth, useDarkMode: useDarkMode || false })
);
var Placeholder = Object.assign(Placeholder$1, {});
var Cell = styled_components_esm_default.div`
    display: flex;
    flex: 1;
`;
Cell.displayName = "StyledCell";
var Row = styled_components_esm_default.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1rem 0;
    width: 100%;

    &.border {
        border-bottom: 1px solid ${themeValues.lightBorderColor};

        &:last-child {
            border-bottom: none;
        }
    }
`;
Row.displayName = "StyledRow";
var StyledTable = styled_components_esm_default.div`
  margin-top: 48px;
`;
StyledTable.displayName = "StyledTable";
var StyledTh = styled_components_esm_default(Cell)`
  font-size: ${themeValues.fontSize.small};
  font-weight: 500;
  padding: 16px 8px;
  color: #808080;
  flex: ${(p) => p.flex || void 0};
`;
StyledTh.displayName = "StyledTh";
var StyledTr = styled_components_esm_default(Row)`
  border-bottom: 1px solid #f0f2f4;
  padding: 0;
  
  .loading {
    opacity: 0.5
  }
`;
StyledTr.displayName = "StyledTr";
var StyledTd = styled_components_esm_default(Cell)`
  flex-flow: wrap;
  padding: 16px 8px;
  color: #000;
  font-weight: 500;
  font-size: ${themeValues.fontSize.normal};
  flex: ${(p) => p.flex || void 0};

  &.ellipsis {
    min-width: 0;
  }

  &.active {
    color: #0446ca;
    font-weight: bold;
  }
`;
StyledTd.displayName = "StyledTd";
var StyledEllipsis = styled_components_esm_default.span`
  margin-right: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;
StyledEllipsis.displayName = "StyledEllipsis";
var TableStyledButton = styled_components_esm_default.button`
  padding: 8px 14px;
  background-color: transparent;
  border: 1px solid #e4e5e8;
  border-radius: 4px;
  transition: all 0.2s ease;
  text-transform: uppercase;
  color: #e4e5e8;
  font-size: 10px;
  font-weight: 500;
  display: block;
  margin: 0 auto;
  outline: 0;

  &:not(:disabled) {
    color: #000;
    cursor: pointer;
  }

  &:hover:not(:disabled) {
    border-color: #000;
  }
`;
TableStyledButton.displayName = "TableStyledButton";
function Table$1({ children, emptyFallback, placeholder, header }) {
  function renderRows() {
    if (children) {
      return React.createElement("div", null, children);
    }
    return null;
  }
  const headers = header.map((head) => {
    const { flex = 0, label } = typeof head == "string" ? { label: head } : head || {};
    return React.createElement(StyledTh, { flex, key: label }, label);
  });
  const placeholders = header.map((head) => {
    const { flex = 0, label } = typeof head == "string" ? { label: head } : head || {};
    return React.createElement(
      StyledTh,
      { flex, key: label },
      React.createElement(Placeholder, null, label)
    );
  });
  let placeholderRows = null;
  if (placeholder) {
    const placeholderRow = React.createElement(Tr, null, placeholders);
    if (typeof placeholder == "number") {
      const rows = [];
      for (let i2 = 0; i2 < placeholder; i2++) {
        rows.push(placeholderRow);
      }
      placeholderRows = React.createElement(React.Fragment, null, rows);
    } else {
      placeholderRows = placeholderRow;
    }
  }
  return React.createElement(
    StyledTable,
    null,
    !emptyFallback ? React.createElement(Tr, null, headers) : null,
    placeholderRows ? placeholderRows : emptyFallback || renderRows()
  );
}
function Tr({ children }) {
  return React.createElement(StyledTr, null, children);
}
function Td({ children, ellipsis, flex = 0, active }) {
  return React.createElement(StyledTd, { flex, className: cn({
    "ellipsis": ellipsis,
    "active": active
  }) }, ellipsis ? React.createElement(StyledEllipsis, null, children) : children);
}
var Table = Object.assign(Table$1, {
  Button: TableStyledButton,
  Td,
  Tr
});
function useWindowOpen() {
  const currentWindow = useRef2(null);
  return {
    opened: currentWindow,
    open(url2) {
      const newWindow = window.open(url2);
      if (!newWindow) {
        return null;
      }
      newWindow.opener = null;
      currentWindow.current = newWindow;
      return newWindow;
    }
  };
}
var supportBroadcastAPI = typeof window !== "undefined" && "BroadcastChannel" in window;
var initialState = {
  current: ""
};
function useWindowCommunication(name) {
  const [state, setState] = useState2(initialState);
  const broadCastChannel = useRef2();
  if (supportBroadcastAPI) {
    broadCastChannel.current = new BroadcastChannel(name);
  }
  function updateStateMsg(msg) {
    setState({ current: msg });
  }
  function sendMessage(msg) {
    if (supportBroadcastAPI && (broadCastChannel === null || broadCastChannel === void 0 ? void 0 : broadCastChannel.current)) {
      broadCastChannel.current.postMessage(msg);
      return;
    }
    window.localStorage.setItem(name, msg);
  }
  function updateFromBroadcast(e3) {
    updateStateMsg(e3.data);
  }
  function updateFromLocalStorage(e3) {
    if (e3.newValue) {
      updateStateMsg(e3.newValue);
    }
  }
  function onDestroy() {
    if (broadCastChannel === null || broadCastChannel === void 0 ? void 0 : broadCastChannel.current) {
      broadCastChannel.current.close();
      broadCastChannel.current = null;
      return;
    }
    window.localStorage.removeItem(name);
    window.removeEventListener("storage", updateFromLocalStorage);
  }
  useEffect2(() => {
    if (supportBroadcastAPI && (broadCastChannel === null || broadCastChannel === void 0 ? void 0 : broadCastChannel.current)) {
      broadCastChannel.current.onmessage = updateFromBroadcast;
    } else {
      window.addEventListener("storage", updateFromLocalStorage);
    }
    return onDestroy;
  }, [name]);
  return [state, sendMessage];
}
var ClosedMessage = "closed";
function useWindowCommunicationProvider(url2, name) {
  const [closed, setClosed] = useState2(false);
  const windowOpen = useWindowOpen();
  const [communication] = useWindowCommunication(name);
  useEffect2(() => {
    var _a;
    const closed2 = communication.current === ClosedMessage;
    if (!closed2 || !windowOpen.opened) {
      return;
    }
    (_a = windowOpen.opened.current) === null || _a === void 0 ? void 0 : _a.close();
    setClosed(true);
  }, [communication]);
  return {
    closed,
    open() {
      windowOpen.open(url2);
    }
  };
}
function WindowCommunication$1() {
  return React.createElement(React.Fragment, null);
}
function WindowCommunicationLink({ children, url: url2, onClose: onClose2, name: nameProp }) {
  const name = nameProp || url2;
  const { closed, open } = useWindowCommunicationProvider(url2, name);
  useEffect2(() => {
    if (closed) {
      onClose2();
    }
  }, [closed]);
  return React.createElement(Link2, { onClick: open }, children);
}
var WindowCommunication = Object.assign(WindowCommunication$1, {
  Link: WindowCommunicationLink
});

// src/LogInForm.tsx
import { useAuth } from "livesession-auth-sdk";
var FormContext2 = createContext3({
  loginInput: "",
  setLogin: () => {
  },
  passwordInput: "",
  setPassword: () => {
  }
});
function Form3({ children }) {
  const {
    login
  } = useAuth();
  const [loginInput, setLogin] = useState3("");
  const [passwordInput, setPassword] = useState3("");
  function submit(e3) {
    e3.preventDefault();
    login(loginInput, passwordInput);
  }
  return /* @__PURE__ */ React2.createElement(FormContext2.Provider, {
    value: { loginInput, setLogin, passwordInput, setPassword }
  }, /* @__PURE__ */ React2.createElement("form", {
    onSubmit: submit
  }, children));
}
function Email() {
  const {
    isLoading
  } = useAuth();
  const { loginInput, setLogin } = useContext3(FormContext2);
  return /* @__PURE__ */ React2.createElement(TextInput, {
    type: "email",
    name: "login",
    label: "Email",
    size: "large",
    onChange: (e3) => {
      setLogin(e3.target.value);
    },
    value: loginInput,
    disabled: isLoading,
    placeholder: "john@example.com",
    required: true,
    fullWidth: true,
    autoFocus: true
  });
}
function Password2() {
  const {
    isLoading
  } = useAuth();
  const { passwordInput, setPassword } = useContext3(FormContext2);
  return /* @__PURE__ */ React2.createElement(TextInput, {
    type: "password",
    name: "password",
    label: "Password",
    size: "large",
    onChange: (e3) => {
      setPassword(e3.target.value);
    },
    value: passwordInput,
    disabled: isLoading,
    placeholder: "password",
    required: true,
    fullWidth: true
  });
}
var LogInForm = Object.assign(Form3, {
  Email,
  Password: Password2
});

// src/GoogleLogin.tsx
init_esm_shims();
import React3 from "react";
import { ThirdParty } from "livesession-auth-elements";
function GoogleLogin() {
  const params = new URLSearchParams(window.location.search);
  const clientId = params.get("client_id");
  const redirectUri = params.get("redirect_uri");
  const responseType = params.get("response_type");
  const scope = params.get("scope");
  const state = params.get("state");
  const json = {
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: responseType,
    scope,
    state,
    accounts: true
  };
  return /* @__PURE__ */ React3.createElement("form", {
    method: "GET",
    action: `${process.env.REACT_APP_API_URL || "http://localhost:3001"}/agents/auth/google`
  }, /* @__PURE__ */ React3.createElement("input", {
    type: "hidden",
    name: "state",
    value: JSON.stringify(json)
  }), /* @__PURE__ */ React3.createElement(ThirdParty.Button, {
    type: "submit"
  }, /* @__PURE__ */ React3.createElement("img", {
    alt: "logo",
    src: process.env.PUBLIC_URL + "/img/google_logo.svg",
    style: { maxWidth: 20, marginRight: "16px" }
  }), "Log in with ", /* @__PURE__ */ React3.createElement("strong", null, "Google")));
}

// src/SignUpForm.tsx
init_esm_shims();
import React4, { createContext as createContext4, useState as useState4, useContext as useContext4 } from "react";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useAuth as useAuth2 } from "livesession-auth-sdk";
var FormContext3 = createContext4({
  loginInput: "",
  setLogin: () => {
  },
  passwordInput: "",
  setPassword: () => {
  }
});
function RecaptchaForm({ recaptchaKey, children, force }) {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [loginInput, setLogin] = useState4("");
  const [passwordInput, setPassword] = useState4("");
  return /* @__PURE__ */ React4.createElement(GoogleReCaptchaProvider, {
    reCaptchaKey: recaptchaKey
  }, /* @__PURE__ */ React4.createElement(FormContext3.Provider, {
    value: { loginInput, setLogin, passwordInput, setPassword }
  }, /* @__PURE__ */ React4.createElement(Form4, {
    force
  }, children)));
}
function Form4({ children, force }) {
  const form = useSignUpForm();
  const onSubmit = async (e3) => {
    e3.preventDefault();
    form.submit(force);
  };
  return /* @__PURE__ */ React4.createElement("form", {
    onSubmit
  }, children);
}
function Email2() {
  const {
    isLoading
  } = useAuth2();
  const { loginInput, setLogin } = useContext4(FormContext3);
  return /* @__PURE__ */ React4.createElement(TextInput, {
    type: "email",
    name: "login",
    label: "Business email",
    size: "large",
    onChange: (e3) => {
      setLogin(e3.target.value);
    },
    value: loginInput,
    disabled: isLoading,
    placeholder: "john@example.com",
    required: true,
    fullWidth: true,
    autoFocus: true
  });
}
function Password3() {
  const {
    isLoading
  } = useAuth2();
  const { passwordInput, setPassword } = useContext4(FormContext3);
  return /* @__PURE__ */ React4.createElement(TextInput, {
    type: "password",
    name: "password",
    label: "Password",
    size: "large",
    onChange: (e3) => {
      setPassword(e3.target.value);
    },
    value: passwordInput,
    disabled: isLoading,
    placeholder: "password",
    required: true,
    fullWidth: true
  });
}
var SignUpForm = Object.assign(RecaptchaForm, {
  Email: Email2,
  Password: Password3
});
function useSignUpForm() {
  const form = useContext4(FormContext3);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const {
    signup
  } = useAuth2();
  return {
    login: form.loginInput,
    async submit(force) {
      if (!executeRecaptcha) {
        console.error("sign up form need recaptcha");
        return;
      }
      const token = await executeRecaptcha("signup");
      const stateB64 = new URLSearchParams(window.location.search).get("state");
      const state = JSON.parse(atob(stateB64 || "") || "{}");
      signup(
        form.loginInput,
        form.passwordInput,
        token,
        "USD",
        force || false,
        void 0,
        "shopify",
        state.shopify_shop,
        state.shopify_token
      );
    }
  };
}

// src/Error.tsx
init_esm_shims();
import React5 from "react";
import { useAuth as useAuth3 } from "livesession-auth-sdk";
function loginErrorMessage(error) {
  const { param, code, data, type: type2, message } = error;
  let msg = null;
  switch (code) {
    case "INVALID_STATUS":
      if (data && data.status === "inactive") {
        msg = "Account is inactive.";
      }
      if (data && data.status === "blocked") {
        msg = "Account has been blocked.";
      }
      if (data && data.status === "not_active") {
        const resendActivation = null;
        msg = /* @__PURE__ */ React5.createElement("div", null, "Account is not active", resendActivation ? ". " : null, resendActivation);
      } else {
        msg = "Account is not active.";
      }
      break;
    case "INVALID_CREDENTIALS":
      msg = "Invalid username or password.";
      break;
    case "auth-login/per-minute/ip":
      msg = "Too many requests. Try again later.";
      break;
    default:
      msg = "Ups... Internal error. Please try again.";
      if (type2 === "validation") {
        msg = message;
      }
  }
  return msg;
}
var thirdParyLoginError = () => {
  const { error } = { error: null };
  let msg = null;
  if (error) {
    switch (error) {
      case "session_expired":
        msg = "Your session has expired. Please log in.";
        break;
      default:
        msg = "Unknown error, please try to log in again.";
        break;
    }
  }
  return msg;
};
function LogInError() {
  const { error } = useAuth3();
  if (error) {
    const msg = loginErrorMessage(error) || thirdParyLoginError();
    if (msg) {
      return /* @__PURE__ */ React5.createElement(Alert, {
        color: "error"
      }, msg);
    }
  }
  return null;
}
function signUpErrorMessage(error) {
  if (error == null ? void 0 : error.type) {
    switch (error == null ? void 0 : error.type) {
      case "account_exists":
        return "Account with this email already exists.";
      case "validation":
        if (error == null ? void 0 : error.message) {
          return error == null ? void 0 : error.message;
        }
        return "This is not a correct email. Please check it and try again.";
      case "data_format":
        return "Please check your email and password, then try again.";
      case "unauthorized":
        const stateB64 = new URLSearchParams(window.location.search).get(
          "state"
        );
        const state = JSON.parse(atob(stateB64 || "") || "{}");
        if (state.appUrl) {
          return /* @__PURE__ */ React5.createElement(React5.Fragment, null, "Unauthorized. Please try again", " ", /* @__PURE__ */ React5.createElement("a", {
            style: { marginLeft: 3 },
            href: state.appUrl
          }, " ", "here"), ".");
        }
        return "Unauthorized. Please try again.";
      default:
        return "Something went wrong. Please check your email and password, then try again.";
    }
  } else {
    return "Something went wrong. Please check your email and password, then try again.";
  }
}
function SignUpError() {
  const { error } = useAuth3();
  if (error) {
    const msg = signUpErrorMessage(error);
    if (msg) {
      return /* @__PURE__ */ React5.createElement(Alert, {
        color: "error"
      }, msg);
    }
  }
  return null;
}
function useDomainExists() {
  const { error } = useAuth3();
  return (error == null ? void 0 : error.code) === "domain_exists";
}
export {
  GoogleLogin,
  LogInError,
  LogInForm,
  SignUpError,
  SignUpForm,
  useDomainExists,
  useSignUpForm
};
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/*!
 * React Dropdown Tree Select
 * A lightweight, fast and highly customizable tree select component.
 * Hrusikesh Panda <hrusikesh.panda@dowjones.com>
 * Copyright (c) 2017 Dow Jones, Inc. <support@dowjones.com> (http://dowjones.com)
 * license MIT
 * see https://github.com/dowjones/react-dropdown-tree-select
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
//! moment.js
